// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$resolve(url) {  url = importMap[url] || url;  return new URL(distDir + url, import.meta.url).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"20yW5":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "anDi6": "routes.25881442.json",
    "3123e": "stops.3d.13cc4320.json",
    "aU3FH": "singapore.eaa26174.pmtiles"
});

},{}],"jIMFG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _maplibreGl = require("maplibre-gl");
var _maplibreGlDefault = parcelHelpers.interopDefault(_maplibreGl);
var _mapboxLayer = require("@deck.gl/mapbox/dist/mapbox-layer");
var _mapboxLayerDefault = parcelHelpers.interopDefault(_mapboxLayer);
var _solidPolygonLayer = require("@deck.gl/layers/dist/solid-polygon-layer/solid-polygon-layer");
var _solidPolygonLayerDefault = parcelHelpers.interopDefault(_solidPolygonLayer);
var _pathLayer = require("@deck.gl/layers/dist/path-layer/path-layer");
var _pathLayerDefault = parcelHelpers.interopDefault(_pathLayer);
var _pmtiles = require("pmtiles");
var _basemaps = require("@protomaps/basemaps");
var _bus = require("../assets/utils/bus");
var _fetchCache = require("../assets/utils/fetchCache");
var _fetchCacheDefault = parcelHelpers.interopDefault(_fetchCache);
var _routesJson = require("./data/routes.json");
var _routesJsonDefault = parcelHelpers.interopDefault(_routesJson);
var _stops3DJson = require("./data/stops.3d.json");
var _stops3DJsonDefault = parcelHelpers.interopDefault(_stops3DJson);
const CACHE_TIME = 10080; // 1 week
const stopsFetch = (0, _fetchCacheDefault.default)((0, _stops3DJsonDefault.default), CACHE_TIME);
const routesFetch = (0, _fetchCacheDefault.default)((0, _routesJsonDefault.default), CACHE_TIME);
const lowerLat = 1.1, upperLat = 1.58, lowerLong = 103.49, upperLong = 104.15;
// Set up PMTiles protocol
let protocol = new (0, _pmtiles.Protocol)();
(0, _maplibreGlDefault.default).addProtocol('pmtiles', protocol.tile);
// Create map style using protomaps black flavor
const sgTilesPath = new URL(require("c242acc13020a885"));
const GLYPHS_URL = 'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf';
const SPRITE_URL = 'https://protomaps.github.io/basemaps-assets/sprites/v4/dark';
// Customize Protomaps black theme
const currentFlavor = (0, _basemaps.namedFlavor)('black');
// Go thru all values in currentFlavor and set all to #ffffff00
function transparentify(obj) {
    for(const key in obj){
        if (typeof obj[key] === 'object') transparentify(obj[key]);
        else if (typeof obj[key] === 'string') obj[key] = '#ffffff00';
    }
}
transparentify(currentFlavor);
const roadColor = '#112230';
const flavor = {
    ...currentFlavor,
    background: '#112230',
    water: '#112230',
    earth: '#08101d',
    buildings: '#141c2a',
    minor_service: roadColor,
    minor_a: roadColor,
    minor_b: roadColor,
    link: roadColor,
    major: roadColor,
    highway: roadColor,
    bridges_minor: roadColor,
    bridges_link: roadColor,
    bridges_major: roadColor,
    bridges_highway: roadColor
};
const mapLayers = (0, _basemaps.layers)('protomaps', flavor, {
    lang: 'en'
});
const mapStyle = {
    version: 8,
    glyphs: GLYPHS_URL,
    sprite: SPRITE_URL,
    sources: {
        protomaps: {
            type: 'vector',
            url: `pmtiles://${sgTilesPath}`,
            attribution: '<a href="https://protomaps.com" target="_blank">Protomaps</a> \xa9 <a href="https://openstreetmap.org" target="_blank">OpenStreetMap</a>'
        }
    },
    layers: mapLayers
};
const map = new (0, _maplibreGlDefault.default).Map({
    container: 'map',
    style: mapStyle,
    boxZoom: false,
    minZoom: 8,
    renderWorldCopies: false,
    bounds: [
        lowerLong,
        lowerLat,
        upperLong,
        upperLat
    ],
    attributionControl: false
});
map.addControl(new (0, _maplibreGlDefault.default).NavigationControl(), 'bottom-right');
map.addControl(new (0, _maplibreGlDefault.default).AttributionControl({
    compact: true
}), 'bottom-left');
// https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
// https://gist.github.com/rosszurowski/67f04465c424a9bc0dae
function lerpColor(a, b, amount) {
    var ah = parseInt(a.replace(/#/g, ''), 16), ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff, bh = parseInt(b.replace(/#/g, ''), 16), br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff, rr = ar + amount * (br - ar), rg = ag + amount * (bg - ag), rb = ab + amount * (bb - ab);
    return [
        rr,
        rg,
        rb
    ];
}
const mapCanvas = map.getCanvas();
map.on('load', async ()=>{
    const stopsData = (await stopsFetch).sort((a, b)=>a.number - b.number);
    const routesData = (await routesFetch).sort((a, b)=>(0, _bus.sortServices)(a.number, b.number));
    const serviceStops = {};
    stopsData.forEach((stop)=>{
        stop.services.forEach((service)=>{
            if (!serviceStops[service]) serviceStops[service] = new Set();
            serviceStops[service].add(stop.number);
        });
    });
    const stopLayerHover = debounce((info, e)=>{
        const object = info.object;
        let number = object ? object.number : null;
        const services = object ? object.services : null;
        if (number) showStop(number, services);
        else {
            const [_, type, number] = location.hash.match(/#([^\/]+)\/([^\/]+)/i) || [
                ,
                , 
            ];
            if (type === 'stops') showStop(number);
            else if (type === 'services') showService(number);
            else showStop(null);
        }
        focusListStop(number);
    }, 100);
    const stopsLayer = new (0, _mapboxLayerDefault.default)({
        id: 'stops',
        type: (0, _solidPolygonLayerDefault.default),
        data: stopsData,
        getPolygon: (d)=>d.contour,
        extruded: true,
        getElevation: (d)=>d.faded ? 30 : d.level * 100,
        getFillColor: (d)=>d.highlighted ? [
                229,
                238,
                193
            ] : d.faded ? [
                55,
                83,
                95,
                255
            ] : [
                55,
                83,
                95,
                128
            ],
        pickable: true,
        autoHighlight: true,
        highlightColor: [
            229,
            238,
            193
        ],
        onHover: stopLayerHover,
        onClick: (info, e)=>{
            if (!info.object) return;
            const { number } = info.object;
            location.hash = `#stops/${number}`;
        },
        parameters: {
            depthTest: false,
            blend: true
        }
    });
    map.addLayer(stopsLayer);
    const $tooltip = document.getElementById('tooltip');
    const highestLevel = routesData.reduce((level, d)=>d.level > level ? d.level : level, 1);
    const routesLayer = new (0, _mapboxLayerDefault.default)({
        id: 'routes',
        type: (0, _pathLayerDefault.default),
        data: routesData,
        getPath: (d)=>d.path,
        opacity: 1,
        widthMinPixels: 1,
        getWidth: 10,
        getColor: (d)=>d.faded ? [
                0,
                0,
                0,
                0
            ] : lerpColor('#73BC84', '#E5EEC1', d.level / highestLevel),
        pickable: true,
        autoHighlight: true,
        highlightColor: [
            255,
            255,
            255
        ],
        onHover: (info, e)=>{
            if (info.object) {
                const { number } = info.object;
                const { x, y } = e.offsetCenter;
                $tooltip.innerHTML = `Service ${number}`;
                const { offsetWidth: w } = $tooltip;
                const tx = Math.min(x, mapCanvas.offsetWidth - w - 5);
                const ty = y + 16; // Under the cursor
                $tooltip.style.transform = `translate3d(${tx}px, ${ty}px, 0)`;
                $tooltip.hidden = false;
            } else $tooltip.hidden = true;
        },
        parameters: {
            depthTest: false,
            blend: true
        }
    });
    map.addLayer(routesLayer);
    map.once('data', ()=>{
        requestAnimationFrame(()=>{
            map.once('idle', ()=>{
                document.body.classList.add('ready');
            });
            const center = map.unproject([
                mapCanvas.offsetWidth / 2,
                mapCanvas.offsetHeight / 3
            ]);
            map.easeTo({
                pitch: 45,
                bearing: -10,
                center,
                duration: 2000,
                zoom: map.getZoom() + 0.1
            });
        });
    });
    const showStop = (number, services)=>{
        stopsLayer.setProps({
            data: stopsData.map((d)=>{
                d.faded = number && d.number !== number;
                d.highlighted = number && d.number === number;
                return d;
            })
        });
        if (number) {
            if (!services) services = stopsData.find((d)=>d.number === number).services;
            routesLayer.setProps({
                data: routesData.map((d)=>{
                    const highlighted = services.includes(d.number);
                    d.highlighted = highlighted;
                    d.faded = !highlighted;
                    return d;
                })
            });
        } else routesLayer.setProps({
            data: routesData.map((d)=>{
                d.highlighted = d.faded = false;
                return d;
            })
        });
    };
    const showService = (number)=>{
        if (number) {
            const stops = serviceStops[number];
            stopsLayer.setProps({
                data: stopsData.map((d)=>{
                    d.faded = !stops.has(d.number);
                    d.highlighted = false;
                    return d;
                })
            });
        } else stopsLayer.setProps({
            data: stopsData.map((d)=>{
                d.faded = false;
                d.highlighted = false;
                return d;
            })
        });
        routesLayer.setProps({
            data: routesData.map((d)=>{
                d.faded = number && d.number !== number;
                d.highlighted = false;
                return d;
            })
        });
    };
    const $panel = document.getElementById('panel');
    const routesList = routesData.map((r)=>r.number).filter((el, pos, arr)=>arr.indexOf(el) === pos);
    $panel.innerHTML = `
    <button type="button" id="toggle">\u{25BC}</button>
    <div id="services">
      <h2 title="${routesList.length} services">Services</h2>
      <ul>
        ${routesList.map((number)=>`<li><a href="#services/${number}" class="number">${number}</a></li>`).join('')}
      </ul>
    </div>
    <div id="stops">
      <h2>${stopsData.length} Stops</h2>
      <ul>
        ${stopsData.map((s)=>`<li><a href="#stops/${s.number}"><span class="number">${s.number}</span>&nbsp;&nbsp;${s.name}</a></li>`).join('')}
      </ul>
    </div>
  `;
    $panel.querySelector('#toggle').addEventListener('click', ()=>{
        document.body.classList.toggle('map-expand');
        setTimeout(()=>{
            map.resize();
        }, 350);
    });
    const $stops = $panel.querySelector('#stops');
    const focusListStop = (number)=>{
        const el = $stops.querySelector(`a[href*="/${number}"]`);
        if (el) el.focus();
    };
    let mouseoutRAF;
    $panel.addEventListener('mouseover', (e)=>{
        if (e.target.tagName.toLowerCase() === 'a') {
            cancelAnimationFrame(mouseoutRAF);
            const [_, type, number] = e.target.href.match(/#([^\/]+)\/([^\/]+)/i);
            if (type === 'stops') showStop(number);
            else if (type === 'services') showService(number);
        }
    });
    $panel.addEventListener('mouseout', (e)=>{
        if (e.target.tagName.toLowerCase() === 'a') mouseoutRAF = requestAnimationFrame(()=>{
            const [_, type, number] = location.hash.match(/#([^\/]+)\/([^\/]+)/i) || [
                ,
                , 
            ];
            if (type) {
                if (type === 'stops') showStop(number);
                else if (type === 'services') showService(number);
            } else {
                const [_, type, number] = e.target.href.match(/#([^\/]+)\/([^\/]+)/i);
                if (type === 'stops') showStop(null);
                else if (type === 'services') showService(null);
            }
        });
    });
    const $status = document.getElementById('status');
    const closeHTML = '<a href="#" class="close">\xd7</a>';
    window.onhashchange = ()=>{
        const [_, type, number] = location.hash.match(/#([^\/]+)\/([^\/]+)/i) || [
            ,
            , 
        ];
        if (type === 'stops') {
            showStop(number);
            const { name } = stopsData.find((s)=>s.number === number);
            $status.hidden = false;
            $status.innerHTML = `<span>Bus stop ${number}: ${name}</span> ${closeHTML}`;
        } else if (type === 'services') {
            showService(number);
            $status.hidden = false;
            $status.innerHTML = `<span>Bus service ${number}</span> ${closeHTML}`;
        } else {
            showStop(null);
            $status.hidden = true;
        }
    };
    window.onhashchange();
});

},{"maplibre-gl":"lyGpb","@deck.gl/mapbox/dist/mapbox-layer":"jrHbk","@deck.gl/layers/dist/solid-polygon-layer/solid-polygon-layer":"5WG87","@deck.gl/layers/dist/path-layer/path-layer":"ePgCZ","pmtiles":"cbZxG","@protomaps/basemaps":"4cB20","../assets/utils/bus":"4E495","../assets/utils/fetchCache":"kNdlE","./data/routes.json":"4wBi3","./data/stops.3d.json":"0ghot","c242acc13020a885":"3k5gl","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jrHbk":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deckUtilsJs = require("./deck-utils.js");
class MapboxLayer {
    /* eslint-disable no-this-before-super */ constructor(props){
        if (!props.id) throw new Error('Layer must have an unique id');
        this.id = props.id;
        this.type = 'custom';
        this.renderingMode = props.renderingMode || '3d';
        this.slot = props.slot;
        this.map = null;
        this.deck = null;
        this.props = props;
    }
    /* Mapbox custom layer methods */ onAdd(map, gl) {
        this.map = map;
        this.deck = (0, _deckUtilsJs.getDeckInstance)({
            map,
            gl,
            deck: this.props.deck
        });
        (0, _deckUtilsJs.addLayer)(this.deck, this);
    }
    onRemove() {
        if (this.deck) (0, _deckUtilsJs.removeLayer)(this.deck, this);
    }
    setProps(props) {
        // id cannot be changed
        Object.assign(this.props, props, {
            id: this.id
        });
        // safe guard in case setProps is called before onAdd
        if (this.deck) (0, _deckUtilsJs.updateLayer)(this.deck, this);
    }
    render(gl, renderParameters) {
        (0, _deckUtilsJs.drawLayer)(this.deck, this.map, this, renderParameters);
    }
}
exports.default = MapboxLayer;

},{"./deck-utils.js":"elU4i","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"elU4i":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Create an interleaved deck instance.
parcelHelpers.export(exports, "getDeckInstance", ()=>getDeckInstance);
parcelHelpers.export(exports, "removeDeckInstance", ()=>removeDeckInstance);
parcelHelpers.export(exports, "getDefaultParameters", ()=>getDefaultParameters);
parcelHelpers.export(exports, "addLayer", ()=>addLayer);
parcelHelpers.export(exports, "removeLayer", ()=>removeLayer);
parcelHelpers.export(exports, "updateLayer", ()=>updateLayer);
parcelHelpers.export(exports, "drawLayer", ()=>drawLayer);
parcelHelpers.export(exports, "getDefaultView", ()=>getDefaultView);
parcelHelpers.export(exports, "getViewState", ()=>getViewState);
var _core = require("@deck.gl/core");
var _webMercator = require("@math.gl/web-mercator");
// Mercator constants
const TILE_SIZE = 512;
const DEGREES_TO_RADIANS = Math.PI / 180;
function getDeckInstance({ map, gl, deck }) {
    // Only create one deck instance per context
    if (map.__deck) return map.__deck;
    // Only initialize certain props once per context
    const customRender = deck?.props._customRender;
    const onLoad = deck?.props.onLoad;
    const deckProps = {
        ...deck?.props,
        _customRender: ()=>{
            map.triggerRepaint();
            // customRender may be subscribed by DeckGL React component to update child props
            // make sure it is still called
            // Hack - do not pass a redraw reason here to prevent the React component from clearing the context
            // Rerender will be triggered by MapboxLayer's render()
            customRender?.('');
        }
    };
    deckProps.parameters = {
        ...getDefaultParameters(map, true),
        ...deckProps.parameters
    };
    deckProps.views || (deckProps.views = getDefaultView(map));
    let deckInstance;
    if (!deck || deck.props.gl === gl) {
        // If deck isn't defined (Internal MapboxLayer use case),
        // or if deck is defined and is using the WebGLContext created by mapbox (MapboxOverlay and External MapboxLayer use case),
        // block deck from setting the canvas size, and use the map's viewState to drive deck.
        // Otherwise, we use deck's viewState to drive the map.
        Object.assign(deckProps, {
            gl,
            width: null,
            height: null,
            touchAction: 'unset',
            viewState: getViewState(map)
        });
        if (deck?.isInitialized) watchMapMove(deck, map);
        else deckProps.onLoad = ()=>{
            onLoad?.();
            watchMapMove(deckInstance, map);
        };
    }
    if (deck) {
        deckInstance = deck;
        deck.setProps(deckProps);
        deck.userData.isExternal = true;
    } else {
        deckInstance = new (0, _core.Deck)(deckProps);
        map.on('remove', ()=>{
            removeDeckInstance(map);
        });
    }
    deckInstance.userData.mapboxLayers = new Set();
    // (deckInstance.userData as UserData).mapboxVersion = getMapboxVersion(map);
    map.__deck = deckInstance;
    map.on('render', ()=>{
        if (deckInstance.isInitialized) afterRender(deckInstance, map);
    });
    return deckInstance;
}
function watchMapMove(deck, map) {
    const _handleMapMove = ()=>{
        if (deck.isInitialized) // call view state methods
        onMapMove(deck, map);
        else // deregister itself when deck is finalized
        map.off('move', _handleMapMove);
    };
    map.on('move', _handleMapMove);
}
function removeDeckInstance(map) {
    map.__deck?.finalize();
    map.__deck = null;
}
function getDefaultParameters(map, interleaved) {
    const result = interleaved ? {
        depthWriteEnabled: true,
        depthCompare: 'less-equal',
        depthBias: 0,
        blend: true,
        blendColorSrcFactor: 'src-alpha',
        blendColorDstFactor: 'one-minus-src-alpha',
        blendAlphaSrcFactor: 'one',
        blendAlphaDstFactor: 'one-minus-src-alpha',
        blendColorOperation: 'add',
        blendAlphaOperation: 'add'
    } : {};
    if (getProjection(map) === 'globe') result.cullMode = 'back';
    return result;
}
function addLayer(deck, layer) {
    deck.userData.mapboxLayers.add(layer);
    updateLayers(deck);
}
function removeLayer(deck, layer) {
    deck.userData.mapboxLayers.delete(layer);
    updateLayers(deck);
}
function updateLayer(deck, layer) {
    updateLayers(deck);
}
function drawLayer(deck, map, layer, renderParameters) {
    let { currentViewport } = deck.userData;
    let clearStack = false;
    if (!currentViewport) {
        // This is the first layer drawn in this render cycle.
        // Generate viewport from the current map state.
        currentViewport = getViewport(deck, map, renderParameters);
        deck.userData.currentViewport = currentViewport;
        clearStack = true;
    }
    if (!deck.isInitialized) return;
    deck._drawLayers('mapbox-repaint', {
        viewports: [
            currentViewport
        ],
        layerFilter: ({ layer: deckLayer })=>layer.id === deckLayer.id || deckLayer.props.operation.includes('terrain'),
        clearStack,
        clearCanvas: false
    });
}
function getProjection(map) {
    const projection = map.getProjection?.();
    const type = // maplibre projection spec
    projection?.type || // mapbox projection spec
    projection?.name;
    if (type === 'globe') return 'globe';
    if (type && type !== 'mercator') throw new Error('Unsupported projection');
    return 'mercator';
}
function getDefaultView(map) {
    if (getProjection(map) === 'globe') return new (0, _core._GlobeView)({
        id: 'mapbox'
    });
    return new (0, _core.MapView)({
        id: 'mapbox'
    });
}
function getViewState(map) {
    const { lng, lat } = map.getCenter();
    const viewState = {
        // Longitude returned by getCenter can be outside of [-180, 180] when zooming near the anti meridian
        // https://github.com/visgl/deck.gl/issues/6894
        longitude: (lng + 540) % 360 - 180,
        latitude: lat,
        zoom: map.getZoom(),
        bearing: map.getBearing(),
        pitch: map.getPitch(),
        padding: map.getPadding(),
        repeat: map.getRenderWorldCopies()
    };
    if (map.getTerrain?.()) // When the base map has terrain, we need to target the camera at the terrain surface
    centerCameraOnTerrain(map, viewState);
    return viewState;
}
function centerCameraOnTerrain(map, viewState) {
    if (map.getFreeCameraOptions) {
        // mapbox-gl v2
        const { position } = map.getFreeCameraOptions();
        if (!position || position.z === undefined) return;
        // @ts-ignore transform is not typed
        const height = map.transform.height;
        const { longitude, latitude, pitch } = viewState;
        // Convert mapbox mercator coordinate to deck common space
        const cameraX = position.x * TILE_SIZE;
        const cameraY = (1 - position.y) * TILE_SIZE;
        const cameraZ = position.z * TILE_SIZE;
        // Mapbox manipulates zoom in terrain mode, see discussion here: https://github.com/mapbox/mapbox-gl-js/issues/12040
        const center = (0, _webMercator.lngLatToWorld)([
            longitude,
            latitude
        ]);
        const dx = cameraX - center[0];
        const dy = cameraY - center[1];
        const cameraToCenterDistanceGround = Math.sqrt(dx * dx + dy * dy);
        const pitchRadians = pitch * DEGREES_TO_RADIANS;
        const altitudePixels = 1.5 * height;
        const scale = pitchRadians < 0.001 ? altitudePixels * Math.cos(pitchRadians) / cameraZ : altitudePixels * Math.sin(pitchRadians) / cameraToCenterDistanceGround;
        viewState.zoom = Math.log2(scale);
        const cameraZFromSurface = altitudePixels * Math.cos(pitchRadians) / scale;
        const surfaceElevation = cameraZ - cameraZFromSurface;
        viewState.position = [
            0,
            0,
            surfaceElevation / (0, _webMercator.unitsPerMeter)(latitude)
        ];
    } else if (typeof map.transform.elevation === 'number') // maplibre-gl
    // @ts-ignore transform is not typed
    viewState.position = [
        0,
        0,
        map.transform.elevation
    ];
}
function getViewport(deck, map, renderParameters) {
    const viewState = getViewState(map);
    const view = getDefaultView(map);
    if (renderParameters) // Called from MapboxLayer.render
    // Magic number, matches mapbox-gl@>=1.3.0's projection matrix
    view.props.nearZMultiplier = 0.2;
    // Get the base map near/far plane
    // renderParameters is maplibre API but not mapbox
    // Transform is not an official API, properties could be undefined for older versions
    const nearZ = renderParameters?.nearZ ?? map.transform._nearZ;
    const farZ = renderParameters?.farZ ?? map.transform._farZ;
    if (Number.isFinite(nearZ)) {
        viewState.nearZ = nearZ / map.transform.height;
        viewState.farZ = farZ / map.transform.height;
    }
    // Otherwise fallback to default calculation using nearZMultiplier/farZMultiplier
    return view.makeViewport({
        width: deck.width,
        height: deck.height,
        viewState
    });
}
function afterRender(deck, map) {
    const { mapboxLayers, isExternal } = deck.userData;
    if (isExternal) {
        // Draw non-Mapbox layers
        const mapboxLayerIds = Array.from(mapboxLayers, (layer)=>layer.id);
        const deckLayers = (0, _core._flatten)(deck.props.layers, Boolean);
        const hasNonMapboxLayers = deckLayers.some((layer)=>layer && !mapboxLayerIds.includes(layer.id));
        let viewports = deck.getViewports();
        const mapboxViewportIdx = viewports.findIndex((vp)=>vp.id === 'mapbox');
        const hasNonMapboxViews = viewports.length > 1 || mapboxViewportIdx < 0;
        if (hasNonMapboxLayers || hasNonMapboxViews) {
            if (mapboxViewportIdx >= 0) {
                viewports = viewports.slice();
                viewports[mapboxViewportIdx] = getViewport(deck, map);
            }
            deck._drawLayers('mapbox-repaint', {
                viewports,
                layerFilter: (params)=>(!deck.props.layerFilter || deck.props.layerFilter(params)) && (params.viewport.id !== 'mapbox' || !mapboxLayerIds.includes(params.layer.id)),
                clearCanvas: false
            });
        }
    }
    // End of render cycle, clear generated viewport
    deck.userData.currentViewport = null;
}
function onMapMove(deck, map) {
    deck.setProps({
        viewState: getViewState(map)
    });
    // Camera changed, will trigger a map repaint right after this
    // Clear any change flag triggered by setting viewState so that deck does not request
    // a second repaint
    deck.needsRedraw({
        clearRedrawFlags: true
    });
}
function updateLayers(deck) {
    if (deck.userData.isExternal) return;
    const layers = [];
    deck.userData.mapboxLayers.forEach((deckLayer)=>{
        const LayerType = deckLayer.props.type;
        const layer = new LayerType(deckLayer.props);
        layers.push(layer);
    });
    deck.setProps({
        layers
    });
}

},{"@deck.gl/core":"grwzR","@math.gl/web-mercator":"3nSdG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"grwzR":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable max-len */ // Intialize globals, extract version
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>(0, _initJs.VERSION));
// Import shaderlib to make sure shader modules are initialized
parcelHelpers.export(exports, "getShaderAssembler", ()=>(0, _indexJs.getShaderAssembler));
// Core Library
parcelHelpers.export(exports, "COORDINATE_SYSTEM", ()=>(0, _constantsJs.COORDINATE_SYSTEM));
parcelHelpers.export(exports, "OPERATION", ()=>(0, _constantsJs.OPERATION));
parcelHelpers.export(exports, "UNIT", ()=>(0, _constantsJs.UNIT));
// Effects
parcelHelpers.export(exports, "LightingEffect", ()=>(0, _lightingEffectJsDefault.default));
parcelHelpers.export(exports, "AmbientLight", ()=>(0, _ambientLightJs.AmbientLight));
parcelHelpers.export(exports, "DirectionalLight", ()=>(0, _directionalLightJs.DirectionalLight));
parcelHelpers.export(exports, "PointLight", ()=>(0, _pointLightJs.PointLight));
parcelHelpers.export(exports, "_CameraLight", ()=>(0, _cameraLightJsDefault.default));
parcelHelpers.export(exports, "_SunLight", ()=>(0, _sunLightJsDefault.default));
parcelHelpers.export(exports, "PostProcessEffect", ()=>(0, _postProcessEffectJsDefault.default));
// Passes
parcelHelpers.export(exports, "_LayersPass", ()=>(0, _layersPassJsDefault.default));
parcelHelpers.export(exports, "_PickLayersPass", ()=>(0, _pickLayersPassJsDefault.default));
// Experimental Pure JS (non-React) bindings
parcelHelpers.export(exports, "Deck", ()=>(0, _deckJsDefault.default));
parcelHelpers.export(exports, "LayerManager", ()=>(0, _layerManagerJsDefault.default));
parcelHelpers.export(exports, "Attribute", ()=>(0, _attributeJsDefault.default));
parcelHelpers.export(exports, "AttributeManager", ()=>(0, _attributeManagerJsDefault.default));
parcelHelpers.export(exports, "Layer", ()=>(0, _layerJsDefault.default));
parcelHelpers.export(exports, "CompositeLayer", ()=>(0, _compositeLayerJsDefault.default));
parcelHelpers.export(exports, "DeckRenderer", ()=>(0, _deckRendererJsDefault.default));
// Viewports
parcelHelpers.export(exports, "Viewport", ()=>(0, _viewportJsDefault.default));
parcelHelpers.export(exports, "WebMercatorViewport", ()=>(0, _webMercatorViewportJsDefault.default));
parcelHelpers.export(exports, "_GlobeViewport", ()=>(0, _globeViewportJsDefault.default));
parcelHelpers.export(exports, "OrbitViewport", ()=>(0, _orbitViewportJsDefault.default));
parcelHelpers.export(exports, "OrthographicViewport", ()=>(0, _orthographicViewportJsDefault.default));
parcelHelpers.export(exports, "FirstPersonViewport", ()=>(0, _firstPersonViewportJsDefault.default));
// Shader modules
parcelHelpers.export(exports, "picking", ()=>(0, _indexJs.picking));
parcelHelpers.export(exports, "project", ()=>(0, _indexJs.project));
parcelHelpers.export(exports, "project32", ()=>(0, _indexJs.project32));
parcelHelpers.export(exports, "gouraudLighting", ()=>(0, _indexJs.gouraudLighting));
parcelHelpers.export(exports, "phongLighting", ()=>(0, _indexJs.phongLighting));
parcelHelpers.export(exports, "shadow", ()=>(0, _indexJs.shadow));
parcelHelpers.export(exports, "View", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "MapView", ()=>(0, _mapViewJsDefault.default));
parcelHelpers.export(exports, "FirstPersonView", ()=>(0, _firstPersonViewJsDefault.default));
parcelHelpers.export(exports, "OrbitView", ()=>(0, _orbitViewJsDefault.default));
parcelHelpers.export(exports, "OrthographicView", ()=>(0, _orthographicViewJsDefault.default));
parcelHelpers.export(exports, "_GlobeView", ()=>(0, _globeViewJsDefault.default));
// Controllers
parcelHelpers.export(exports, "Controller", ()=>(0, _controllerJsDefault.default));
parcelHelpers.export(exports, "MapController", ()=>(0, _mapControllerJsDefault.default));
parcelHelpers.export(exports, "_GlobeController", ()=>(0, _globeControllerJsDefault.default));
parcelHelpers.export(exports, "FirstPersonController", ()=>(0, _firstPersonControllerJsDefault.default));
parcelHelpers.export(exports, "OrbitController", ()=>(0, _orbitControllerJsDefault.default));
parcelHelpers.export(exports, "OrthographicController", ()=>(0, _orthographicControllerJsDefault.default));
// Extensions interface
parcelHelpers.export(exports, "LayerExtension", ()=>(0, _layerExtensionJsDefault.default));
// Transitions
parcelHelpers.export(exports, "TRANSITION_EVENTS", ()=>(0, _transitionManagerJs.TRANSITION_EVENTS));
parcelHelpers.export(exports, "TransitionInterpolator", ()=>(0, _transitionInterpolatorJsDefault.default));
parcelHelpers.export(exports, "LinearInterpolator", ()=>(0, _linearInterpolatorJsDefault.default));
parcelHelpers.export(exports, "FlyToInterpolator", ()=>(0, _flyToInterpolatorJsDefault.default));
// Layer utilities
parcelHelpers.export(exports, "log", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "assert", ()=>(0, _assertJsDefault.default));
parcelHelpers.export(exports, "createIterable", ()=>(0, _iterableUtilsJs.createIterable));
parcelHelpers.export(exports, "fp64LowPart", ()=>(0, _mathUtilsJs.fp64LowPart));
parcelHelpers.export(exports, "Tesselator", ()=>(0, _tesselatorJsDefault.default)) // Export? move to luma.gl or math.gl?
;
// Experimental utilities
parcelHelpers.export(exports, "_fillArray", ()=>(0, _flattenJs.fillArray)) // Export? move to luma.gl or math.gl?
;
parcelHelpers.export(exports, "_flatten", ()=>(0, _flattenJs.flatten));
parcelHelpers.export(exports, "_count", ()=>(0, _countJs.count));
parcelHelpers.export(exports, "_deepEqual", ()=>(0, _deepEqualJs.deepEqual));
parcelHelpers.export(exports, "_memoize", ()=>(0, _memoizeJsDefault.default));
parcelHelpers.export(exports, "_mergeShaders", ()=>(0, _shaderJs.mergeShaders));
parcelHelpers.export(exports, "_compareProps", ()=>(0, _propsJs.compareProps));
parcelHelpers.export(exports, "_applyStyles", ()=>(0, _applyStylesJs.applyStyles));
parcelHelpers.export(exports, "_removeStyles", ()=>(0, _applyStylesJs.removeStyles));
// INTERNAL, DO NOT USE
// @deprecated internal do not use
parcelHelpers.export(exports, "_Component", ()=>(0, _componentJsDefault.default));
// @deprecated internal do not use
parcelHelpers.export(exports, "_ComponentState", ()=>(0, _componentStateJsDefault.default));
var _initJs = require("./lib/init.js");
var _indexJs = require("./shaderlib/index.js");
var _constantsJs = require("./lib/constants.js");
var _lightingEffectJs = require("./effects/lighting/lighting-effect.js");
var _lightingEffectJsDefault = parcelHelpers.interopDefault(_lightingEffectJs);
var _ambientLightJs = require("./effects/lighting/ambient-light.js");
var _directionalLightJs = require("./effects/lighting/directional-light.js");
var _pointLightJs = require("./effects/lighting/point-light.js");
var _cameraLightJs = require("./effects/lighting/camera-light.js");
var _cameraLightJsDefault = parcelHelpers.interopDefault(_cameraLightJs);
var _sunLightJs = require("./effects/lighting/sun-light.js");
var _sunLightJsDefault = parcelHelpers.interopDefault(_sunLightJs);
var _postProcessEffectJs = require("./effects/post-process-effect.js");
var _postProcessEffectJsDefault = parcelHelpers.interopDefault(_postProcessEffectJs);
var _layersPassJs = require("./passes/layers-pass.js");
var _layersPassJsDefault = parcelHelpers.interopDefault(_layersPassJs);
var _pickLayersPassJs = require("./passes/pick-layers-pass.js");
var _pickLayersPassJsDefault = parcelHelpers.interopDefault(_pickLayersPassJs);
var _deckJs = require("./lib/deck.js");
var _deckJsDefault = parcelHelpers.interopDefault(_deckJs);
var _layerManagerJs = require("./lib/layer-manager.js");
var _layerManagerJsDefault = parcelHelpers.interopDefault(_layerManagerJs);
var _attributeJs = require("./lib/attribute/attribute.js");
var _attributeJsDefault = parcelHelpers.interopDefault(_attributeJs);
var _attributeManagerJs = require("./lib/attribute/attribute-manager.js");
var _attributeManagerJsDefault = parcelHelpers.interopDefault(_attributeManagerJs);
var _layerJs = require("./lib/layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
var _compositeLayerJs = require("./lib/composite-layer.js");
var _compositeLayerJsDefault = parcelHelpers.interopDefault(_compositeLayerJs);
var _deckRendererJs = require("./lib/deck-renderer.js");
var _deckRendererJsDefault = parcelHelpers.interopDefault(_deckRendererJs);
var _viewportJs = require("./viewports/viewport.js");
var _viewportJsDefault = parcelHelpers.interopDefault(_viewportJs);
var _webMercatorViewportJs = require("./viewports/web-mercator-viewport.js");
var _webMercatorViewportJsDefault = parcelHelpers.interopDefault(_webMercatorViewportJs);
var _globeViewportJs = require("./viewports/globe-viewport.js");
var _globeViewportJsDefault = parcelHelpers.interopDefault(_globeViewportJs);
var _orbitViewportJs = require("./viewports/orbit-viewport.js");
var _orbitViewportJsDefault = parcelHelpers.interopDefault(_orbitViewportJs);
var _orthographicViewportJs = require("./viewports/orthographic-viewport.js");
var _orthographicViewportJsDefault = parcelHelpers.interopDefault(_orthographicViewportJs);
var _firstPersonViewportJs = require("./viewports/first-person-viewport.js");
var _firstPersonViewportJsDefault = parcelHelpers.interopDefault(_firstPersonViewportJs);
var _viewJs = require("./views/view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _mapViewJs = require("./views/map-view.js");
var _mapViewJsDefault = parcelHelpers.interopDefault(_mapViewJs);
var _firstPersonViewJs = require("./views/first-person-view.js");
var _firstPersonViewJsDefault = parcelHelpers.interopDefault(_firstPersonViewJs);
var _orbitViewJs = require("./views/orbit-view.js");
var _orbitViewJsDefault = parcelHelpers.interopDefault(_orbitViewJs);
var _orthographicViewJs = require("./views/orthographic-view.js");
var _orthographicViewJsDefault = parcelHelpers.interopDefault(_orthographicViewJs);
var _globeViewJs = require("./views/globe-view.js");
var _globeViewJsDefault = parcelHelpers.interopDefault(_globeViewJs);
var _controllerJs = require("./controllers/controller.js");
var _controllerJsDefault = parcelHelpers.interopDefault(_controllerJs);
var _mapControllerJs = require("./controllers/map-controller.js");
var _mapControllerJsDefault = parcelHelpers.interopDefault(_mapControllerJs);
var _globeControllerJs = require("./controllers/globe-controller.js");
var _globeControllerJsDefault = parcelHelpers.interopDefault(_globeControllerJs);
var _firstPersonControllerJs = require("./controllers/first-person-controller.js");
var _firstPersonControllerJsDefault = parcelHelpers.interopDefault(_firstPersonControllerJs);
var _orbitControllerJs = require("./controllers/orbit-controller.js");
var _orbitControllerJsDefault = parcelHelpers.interopDefault(_orbitControllerJs);
var _orthographicControllerJs = require("./controllers/orthographic-controller.js");
var _orthographicControllerJsDefault = parcelHelpers.interopDefault(_orthographicControllerJs);
var _layerExtensionJs = require("./lib/layer-extension.js");
var _layerExtensionJsDefault = parcelHelpers.interopDefault(_layerExtensionJs);
var _transitionManagerJs = require("./controllers/transition-manager.js");
var _transitionInterpolatorJs = require("./transitions/transition-interpolator.js");
var _transitionInterpolatorJsDefault = parcelHelpers.interopDefault(_transitionInterpolatorJs);
var _linearInterpolatorJs = require("./transitions/linear-interpolator.js");
var _linearInterpolatorJsDefault = parcelHelpers.interopDefault(_linearInterpolatorJs);
var _flyToInterpolatorJs = require("./transitions/fly-to-interpolator.js");
var _flyToInterpolatorJsDefault = parcelHelpers.interopDefault(_flyToInterpolatorJs);
var _logJs = require("./utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _assertJs = require("./utils/assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
var _iterableUtilsJs = require("./utils/iterable-utils.js");
var _mathUtilsJs = require("./utils/math-utils.js");
var _tesselatorJs = require("./utils/tesselator.js");
var _tesselatorJsDefault = parcelHelpers.interopDefault(_tesselatorJs);
var _flattenJs = require("./utils/flatten.js");
var _countJs = require("./utils/count.js");
var _deepEqualJs = require("./utils/deep-equal.js");
var _memoizeJs = require("./utils/memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
var _shaderJs = require("./utils/shader.js");
var _propsJs = require("./lifecycle/props.js");
var _applyStylesJs = require("./utils/apply-styles.js");
var _componentJs = require("./lifecycle/component.js");
var _componentJsDefault = parcelHelpers.interopDefault(_componentJs);
var _componentStateJs = require("./lifecycle/component-state.js");
var _componentStateJsDefault = parcelHelpers.interopDefault(_componentStateJs);

},{"./lib/init.js":false,"./shaderlib/index.js":"1z7oa","./lib/constants.js":"k6l9N","./effects/lighting/lighting-effect.js":false,"./effects/lighting/ambient-light.js":false,"./effects/lighting/directional-light.js":false,"./effects/lighting/point-light.js":false,"./effects/lighting/camera-light.js":false,"./effects/lighting/sun-light.js":false,"./effects/post-process-effect.js":false,"./passes/layers-pass.js":false,"./passes/pick-layers-pass.js":false,"./lib/deck.js":"94R9P","./lib/layer-manager.js":false,"./lib/attribute/attribute.js":false,"./lib/attribute/attribute-manager.js":false,"./lib/layer.js":"gOEmJ","./lib/composite-layer.js":false,"./lib/deck-renderer.js":false,"./viewports/viewport.js":false,"./viewports/web-mercator-viewport.js":false,"./viewports/globe-viewport.js":false,"./viewports/orbit-viewport.js":false,"./viewports/orthographic-viewport.js":false,"./viewports/first-person-viewport.js":false,"./views/view.js":false,"./views/map-view.js":"eBM7P","./views/first-person-view.js":false,"./views/orbit-view.js":false,"./views/orthographic-view.js":false,"./views/globe-view.js":"cbqTt","./controllers/controller.js":false,"./controllers/map-controller.js":false,"./controllers/globe-controller.js":false,"./controllers/first-person-controller.js":false,"./controllers/orbit-controller.js":false,"./controllers/orthographic-controller.js":false,"./lib/layer-extension.js":false,"./controllers/transition-manager.js":false,"./transitions/transition-interpolator.js":false,"./transitions/linear-interpolator.js":false,"./transitions/fly-to-interpolator.js":false,"./utils/log.js":false,"./utils/assert.js":false,"./utils/iterable-utils.js":false,"./utils/math-utils.js":false,"./utils/tesselator.js":"2WEkC","./utils/flatten.js":"8GYLR","./utils/count.js":false,"./utils/deep-equal.js":false,"./utils/memoize.js":false,"./utils/shader.js":false,"./lifecycle/props.js":false,"./utils/apply-styles.js":false,"./lifecycle/component.js":false,"./lifecycle/component-state.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"i151I":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var _core = require("@loaders.gl/core");
var _images = require("@loaders.gl/images");
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _indexJs = require("../debug/index.js");
var _jsonLoaderJs = require("../utils/json-loader.js");
var _jsonLoaderJsDefault = parcelHelpers.interopDefault(_jsonLoaderJs);
function checkVersion() {
    // Version detection using typescript plugin.
    // Fallback for tests and SSR since global variable is defined by esbuild.
    const version = "9.1.12";
    // Note: a `deck` object not created by deck.gl may exist in the global scope
    const existingVersion = globalThis.deck && globalThis.deck.VERSION;
    if (existingVersion && existingVersion !== version) throw new Error(`deck.gl - multiple versions detected: ${existingVersion} vs ${version}`);
    if (!existingVersion) {
        (0, _logJsDefault.default).log(1, `deck.gl ${version}`)();
        globalThis.deck = {
            ...globalThis.deck,
            VERSION: version,
            version,
            log: (0, _logJsDefault.default),
            // experimental
            _registerLoggers: (0, _indexJs.register)
        };
        (0, _core.registerLoaders)([
            (0, _jsonLoaderJsDefault.default),
            // @ts-expect-error non-standard Loader format
            [
                (0, _images.ImageLoader),
                {
                    imagebitmap: {
                        premultiplyAlpha: 'none'
                    }
                }
            ]
        ]);
    }
    return version;
}
const VERSION = checkVersion();

},{"@loaders.gl/core":"30VLs","@loaders.gl/images":"8Otgz","../utils/log.js":"9S0lD","../debug/index.js":"7gIzA","../utils/json-loader.js":"ilrl6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"30VLs":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// FILE READING AND WRITING
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchFile", ()=>(0, _fetchFileJs.fetchFile));
parcelHelpers.export(exports, "FetchError", ()=>(0, _fetchErrorJs.FetchError));
parcelHelpers.export(exports, "readArrayBuffer", ()=>(0, _readArrayBufferJs.readArrayBuffer));
// export {readFileSync} from './lib/fetch/read-file';
// export {writeFile, writeFileSync} from './lib/fetch/write-file';
// CONFIGURATION
parcelHelpers.export(exports, "setLoaderOptions", ()=>(0, _loaderOptionsJs.setLoaderOptions));
parcelHelpers.export(exports, "getLoaderOptions", ()=>(0, _loaderOptionsJs.getLoaderOptions));
parcelHelpers.export(exports, "registerLoaders", ()=>(0, _registerLoadersJs.registerLoaders));
parcelHelpers.export(exports, "selectLoader", ()=>(0, _selectLoaderJs.selectLoader));
parcelHelpers.export(exports, "selectLoaderSync", ()=>(0, _selectLoaderJs.selectLoaderSync));
// LOADING (READING + PARSING)
parcelHelpers.export(exports, "parse", ()=>(0, _parseJs.parse));
parcelHelpers.export(exports, "parseSync", ()=>(0, _parseSyncJs.parseSync));
parcelHelpers.export(exports, "parseInBatches", ()=>(0, _parseInBatchesJs.parseInBatches));
parcelHelpers.export(exports, "load", ()=>(0, _loadJs.load));
parcelHelpers.export(exports, "loadInBatches", ()=>(0, _loadInBatchesJs.loadInBatches));
// ENCODING (ENCODING AND WRITING)
parcelHelpers.export(exports, "encodeTable", ()=>(0, _encodeTableJs.encodeTable));
parcelHelpers.export(exports, "encodeTableAsText", ()=>(0, _encodeTableJs.encodeTableAsText));
parcelHelpers.export(exports, "encodeTableInBatches", ()=>(0, _encodeTableJs.encodeTableInBatches));
parcelHelpers.export(exports, "encode", ()=>(0, _encodeJs.encode));
parcelHelpers.export(exports, "encodeSync", ()=>(0, _encodeJs.encodeSync));
parcelHelpers.export(exports, "encodeInBatches", ()=>(0, _encodeJs.encodeInBatches));
parcelHelpers.export(exports, "encodeURLtoURL", ()=>(0, _encodeJs.encodeURLtoURL));
parcelHelpers.export(exports, "encodeText", ()=>(0, _encodeJs.encodeText));
parcelHelpers.export(exports, "encodeTextSync", ()=>(0, _encodeJs.encodeTextSync));
// SERVICES AND SOURCES
parcelHelpers.export(exports, "createDataSource", ()=>(0, _createDataSourceJs.createDataSource));
parcelHelpers.export(exports, "_selectSource", ()=>(0, _selectSourceJs.selectSource));
// CORE UTILS SHARED WITH LOADERS (RE-EXPORTED FROM LOADER-UTILS)
parcelHelpers.export(exports, "setPathPrefix", ()=>(0, _loaderUtils.setPathPrefix));
parcelHelpers.export(exports, "getPathPrefix", ()=>(0, _loaderUtils.getPathPrefix));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _loaderUtils.resolvePath));
parcelHelpers.export(exports, "RequestScheduler", ()=>(0, _loaderUtils.RequestScheduler));
// ITERATOR UTILS
parcelHelpers.export(exports, "makeIterator", ()=>(0, _makeIteratorJs.makeIterator));
parcelHelpers.export(exports, "makeStream", ()=>(0, _makeStreamJs.makeStream));
// CORE LOADERS
parcelHelpers.export(exports, "NullWorkerLoader", ()=>(0, _nullLoaderJs.NullWorkerLoader));
parcelHelpers.export(exports, "NullLoader", ()=>(0, _nullLoaderJs.NullLoader));
parcelHelpers.export(exports, "JSONLoader", ()=>(0, _loaderUtils.JSONLoader));
// EXPERIMENTAL
parcelHelpers.export(exports, "_fetchProgress", ()=>(0, _fetchProgressJs.fetchProgress));
parcelHelpers.export(exports, "_BrowserFileSystem", ()=>(0, _browserFilesystemJs.BrowserFileSystem));
// FOR TESTING
parcelHelpers.export(exports, "_unregisterLoaders", ()=>(0, _registerLoadersJs._unregisterLoaders));
//
// TODO - MOVE TO LOADER-UTILS AND DEPRECATE IN CORE?
//
parcelHelpers.export(exports, "isBrowser", ()=>(0, _loaderUtils.isBrowser));
parcelHelpers.export(exports, "isWorker", ()=>(0, _loaderUtils.isWorker));
parcelHelpers.export(exports, "self", ()=>(0, _loaderUtils.self));
parcelHelpers.export(exports, "window", ()=>(0, _loaderUtils.window));
parcelHelpers.export(exports, "global", ()=>(0, _loaderUtils.global));
parcelHelpers.export(exports, "document", ()=>(0, _loaderUtils.document));
parcelHelpers.export(exports, "assert", ()=>(0, _loaderUtils.assert));
parcelHelpers.export(exports, "forEach", ()=>(0, _loaderUtils.forEach));
parcelHelpers.export(exports, "concatenateArrayBuffersAsync", ()=>(0, _loaderUtils.concatenateArrayBuffersAsync));
parcelHelpers.export(exports, "makeTextDecoderIterator", ()=>(0, _loaderUtils.makeTextDecoderIterator));
parcelHelpers.export(exports, "makeTextEncoderIterator", ()=>(0, _loaderUtils.makeTextEncoderIterator));
parcelHelpers.export(exports, "makeLineIterator", ()=>(0, _loaderUtils.makeLineIterator));
parcelHelpers.export(exports, "makeNumberedLineIterator", ()=>(0, _loaderUtils.makeNumberedLineIterator));
// "JAVASCRIPT" UTILS - move to loader-utils?
parcelHelpers.export(exports, "isPureObject", ()=>(0, _isTypeJs.isPureObject));
parcelHelpers.export(exports, "isPromise", ()=>(0, _isTypeJs.isPromise));
parcelHelpers.export(exports, "isIterable", ()=>(0, _isTypeJs.isIterable));
parcelHelpers.export(exports, "isAsyncIterable", ()=>(0, _isTypeJs.isAsyncIterable));
parcelHelpers.export(exports, "isIterator", ()=>(0, _isTypeJs.isIterator));
parcelHelpers.export(exports, "isResponse", ()=>(0, _isTypeJs.isResponse));
parcelHelpers.export(exports, "isReadableStream", ()=>(0, _isTypeJs.isReadableStream));
parcelHelpers.export(exports, "isWritableStream", ()=>(0, _isTypeJs.isWritableStream));
var _fetchFileJs = require("./lib/fetch/fetch-file.js");
var _fetchErrorJs = require("./lib/fetch/fetch-error.js");
var _readArrayBufferJs = require("./lib/fetch/read-array-buffer.js");
var _loaderOptionsJs = require("./lib/api/loader-options.js");
var _registerLoadersJs = require("./lib/api/register-loaders.js");
var _selectLoaderJs = require("./lib/api/select-loader.js");
var _parseJs = require("./lib/api/parse.js");
var _parseSyncJs = require("./lib/api/parse-sync.js");
var _parseInBatchesJs = require("./lib/api/parse-in-batches.js");
var _loadJs = require("./lib/api/load.js");
var _loadInBatchesJs = require("./lib/api/load-in-batches.js");
var _encodeTableJs = require("./lib/api/encode-table.js");
var _encodeJs = require("./lib/api/encode.js");
var _createDataSourceJs = require("./lib/api/create-data-source.js");
var _selectSourceJs = require("./lib/api/select-source.js");
var _loaderUtils = require("@loaders.gl/loader-utils");
var _makeIteratorJs = require("./iterators/make-iterator/make-iterator.js");
var _makeStreamJs = require("./iterators/make-stream/make-stream.js");
var _nullLoaderJs = require("./null-loader.js");
var _fetchProgressJs = require("./lib/progress/fetch-progress.js");
var _browserFilesystemJs = require("./lib/filesystems/browser-filesystem.js");
var _isTypeJs = require("./javascript-utils/is-type.js");

},{"./lib/fetch/fetch-file.js":false,"./lib/fetch/fetch-error.js":false,"./lib/fetch/read-array-buffer.js":false,"./lib/api/loader-options.js":false,"./lib/api/register-loaders.js":"iUBbO","./lib/api/select-loader.js":false,"./lib/api/parse.js":false,"./lib/api/parse-sync.js":false,"./lib/api/parse-in-batches.js":false,"./lib/api/load.js":"2W714","./lib/api/load-in-batches.js":false,"./lib/api/encode-table.js":false,"./lib/api/encode.js":false,"./lib/api/create-data-source.js":false,"./lib/api/select-source.js":false,"@loaders.gl/loader-utils":false,"./iterators/make-iterator/make-iterator.js":false,"./iterators/make-stream/make-stream.js":false,"./null-loader.js":false,"./lib/progress/fetch-progress.js":false,"./lib/filesystems/browser-filesystem.js":false,"./javascript-utils/is-type.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dJvPG":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// import {FetchError} from './fetch-error';
parcelHelpers.export(exports, "isNodePath", ()=>isNodePath);
parcelHelpers.export(exports, "isRequestURL", ()=>isRequestURL);
parcelHelpers.export(exports, "isDataURL", ()=>isDataURL);
/**
 * fetch API compatible function
 * - Supports fetching from Node.js local file system paths
 * - Respects pathPrefix and file aliases
 */ parcelHelpers.export(exports, "fetchFile", ()=>fetchFile);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _responseUtilsJs = require("../utils/response-utils.js");
function isNodePath(url) {
    return !isRequestURL(url) && !isDataURL(url);
}
function isRequestURL(url) {
    return url.startsWith('http:') || url.startsWith('https:');
}
function isDataURL(url) {
    return url.startsWith('data:');
}
async function fetchFile(urlOrData, fetchOptions) {
    if (typeof urlOrData === 'string') {
        const url = (0, _loaderUtils.resolvePath)(urlOrData);
        // Support fetching from local file system
        if (isNodePath(url)) {
            if (globalThis.loaders?.fetchNode) return globalThis.loaders?.fetchNode(url, fetchOptions);
        // throw new Error(
        //   'fetchFile: globalThis.loaders.fetchNode not defined. Install @loaders.gl/polyfills'
        // );
        }
        // Call global fetch
        return await fetch(url, fetchOptions);
    }
    // TODO - should we still call fetch on non-URL inputs?
    return await (0, _responseUtilsJs.makeResponse)(urlOrData);
}

},{"@loaders.gl/loader-utils":"5BWS4","../utils/response-utils.js":"1lJGj","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5BWS4":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseFromContext", ()=>(0, _loaderTypesJs.parseFromContext));
parcelHelpers.export(exports, "parseSyncFromContext", ()=>(0, _loaderTypesJs.parseSyncFromContext));
parcelHelpers.export(exports, "parseInBatchesFromContext", ()=>(0, _loaderTypesJs.parseInBatchesFromContext));
// GENERAL UTILS
parcelHelpers.export(exports, "assert", ()=>(0, _assertJs.assert));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _globalsJs.isBrowser));
parcelHelpers.export(exports, "isWorker", ()=>(0, _globalsJs.isWorker));
parcelHelpers.export(exports, "nodeVersion", ()=>(0, _globalsJs.nodeVersion));
parcelHelpers.export(exports, "self", ()=>(0, _globalsJs.self));
parcelHelpers.export(exports, "window", ()=>(0, _globalsJs.window));
parcelHelpers.export(exports, "global", ()=>(0, _globalsJs.global));
parcelHelpers.export(exports, "document", ()=>(0, _globalsJs.document));
parcelHelpers.export(exports, "log", ()=>(0, _logJs.log));
// Options and modules
parcelHelpers.export(exports, "mergeLoaderOptions", ()=>(0, _mergeLoaderOptionsJs.mergeLoaderOptions));
parcelHelpers.export(exports, "registerJSModules", ()=>(0, _jsModuleUtilsJs.registerJSModules));
parcelHelpers.export(exports, "checkJSModule", ()=>(0, _jsModuleUtilsJs.checkJSModule));
parcelHelpers.export(exports, "getJSModule", ()=>(0, _jsModuleUtilsJs.getJSModule));
parcelHelpers.export(exports, "getJSModuleOrNull", ()=>(0, _jsModuleUtilsJs.getJSModuleOrNull));
// LOADERS.GL-SPECIFIC WORKER UTILS
parcelHelpers.export(exports, "createLoaderWorker", ()=>(0, _createLoaderWorkerJs.createLoaderWorker));
parcelHelpers.export(exports, "parseWithWorker", ()=>(0, _parseWithWorkerJs.parseWithWorker));
parcelHelpers.export(exports, "canParseWithWorker", ()=>(0, _parseWithWorkerJs.canParseWithWorker));
parcelHelpers.export(exports, "canEncodeWithWorker", ()=>(0, _encodeWithWorkerJs.canEncodeWithWorker));
// PARSER UTILS
parcelHelpers.export(exports, "parseJSON", ()=>(0, _parseJsonJs.parseJSON));
// MEMORY COPY UTILS
parcelHelpers.export(exports, "sliceArrayBuffer", ()=>(0, _arrayBufferUtilsJs.sliceArrayBuffer));
parcelHelpers.export(exports, "concatenateArrayBuffers", ()=>(0, _arrayBufferUtilsJs.concatenateArrayBuffers));
parcelHelpers.export(exports, "concatenateArrayBuffersFromArray", ()=>(0, _arrayBufferUtilsJs.concatenateArrayBuffersFromArray));
parcelHelpers.export(exports, "concatenateTypedArrays", ()=>(0, _arrayBufferUtilsJs.concatenateTypedArrays));
parcelHelpers.export(exports, "compareArrayBuffers", ()=>(0, _arrayBufferUtilsJs.compareArrayBuffers));
parcelHelpers.export(exports, "padToNBytes", ()=>(0, _memoryCopyUtilsJs.padToNBytes));
parcelHelpers.export(exports, "copyToArray", ()=>(0, _memoryCopyUtilsJs.copyToArray));
parcelHelpers.export(exports, "copyArrayBuffer", ()=>(0, _memoryCopyUtilsJs.copyArrayBuffer));
parcelHelpers.export(exports, "padStringToByteAlignment", ()=>(0, _dataviewCopyUtilsJs.padStringToByteAlignment));
parcelHelpers.export(exports, "copyStringToDataView", ()=>(0, _dataviewCopyUtilsJs.copyStringToDataView));
parcelHelpers.export(exports, "copyBinaryToDataView", ()=>(0, _dataviewCopyUtilsJs.copyBinaryToDataView));
parcelHelpers.export(exports, "copyPaddedArrayBufferToDataView", ()=>(0, _dataviewCopyUtilsJs.copyPaddedArrayBufferToDataView));
parcelHelpers.export(exports, "copyPaddedStringToDataView", ()=>(0, _dataviewCopyUtilsJs.copyPaddedStringToDataView));
parcelHelpers.export(exports, "getFirstCharacters", ()=>(0, _getFirstCharactersJs.getFirstCharacters));
parcelHelpers.export(exports, "getMagicString", ()=>(0, _getFirstCharactersJs.getMagicString));
// ITERATOR UTILS
parcelHelpers.export(exports, "makeTextEncoderIterator", ()=>(0, _textIteratorsJs.makeTextEncoderIterator));
parcelHelpers.export(exports, "makeTextDecoderIterator", ()=>(0, _textIteratorsJs.makeTextDecoderIterator));
parcelHelpers.export(exports, "makeLineIterator", ()=>(0, _textIteratorsJs.makeLineIterator));
parcelHelpers.export(exports, "makeNumberedLineIterator", ()=>(0, _textIteratorsJs.makeNumberedLineIterator));
parcelHelpers.export(exports, "forEach", ()=>(0, _asyncIterationJs.forEach));
parcelHelpers.export(exports, "concatenateArrayBuffersAsync", ()=>(0, _asyncIterationJs.concatenateArrayBuffersAsync));
// REQUEST UTILS
parcelHelpers.export(exports, "RequestScheduler", ()=>(0, _requestSchedulerJsDefault.default));
// PATH HELPERS
parcelHelpers.export(exports, "setPathPrefix", ()=>(0, _fileAliasesJs.setPathPrefix));
parcelHelpers.export(exports, "getPathPrefix", ()=>(0, _fileAliasesJs.getPathPrefix));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _fileAliasesJs.resolvePath));
parcelHelpers.export(exports, "_addAliases", ()=>(0, _fileAliasesJs.addAliases));
// MICRO LOADERS
parcelHelpers.export(exports, "JSONLoader", ()=>(0, _jsonLoaderJs.JSONLoader));
// NODE support
// Node.js emulation (can be used in browser)
// Avoid direct use of `Buffer` which pulls in 50KB polyfill
parcelHelpers.export(exports, "isBuffer", ()=>(0, _memoryConversionUtilsJs.isBuffer));
parcelHelpers.export(exports, "toBuffer", ()=>(0, _memoryConversionUtilsJs.toBuffer));
parcelHelpers.export(exports, "toArrayBuffer", ()=>(0, _memoryConversionUtilsJs.toArrayBuffer));
// Note.js wrappers (can be safely imported, but not used in browser)
// Use instead of importing 'util' to avoid node dependencies
parcelHelpers.export(exports, "promisify1", ()=>(0, _promisifyJs.promisify1));
parcelHelpers.export(exports, "promisify2", ()=>(0, _promisifyJs.promisify2));
parcelHelpers.export(exports, "BlobFile", ()=>(0, _blobFileJs.BlobFile));
parcelHelpers.export(exports, "HttpFile", ()=>(0, _httpFileJs.HttpFile));
parcelHelpers.export(exports, "NodeFile", ()=>(0, _nodeFileFacadeJs.NodeFileFacade));
parcelHelpers.export(exports, "NodeFilesystem", ()=>(0, _nodeFilesystemFacadeJs.NodeFileSystemFacade));
parcelHelpers.export(exports, "isFileProvider", ()=>(0, _fileProviderInterfaceJs.isFileProvider));
parcelHelpers.export(exports, "FileProvider", ()=>(0, _fileProviderJs.FileProvider));
parcelHelpers.export(exports, "FileHandleFile", ()=>(0, _fileHandleFileJs.FileHandleFile));
parcelHelpers.export(exports, "DataViewFile", ()=>(0, _dataViewFileJs.DataViewFile));
parcelHelpers.export(exports, "DataSource", ()=>(0, _dataSourceJs.DataSource));
parcelHelpers.export(exports, "ImageSource", ()=>(0, _imageSourceJs.ImageSource));
parcelHelpers.export(exports, "VectorSource", ()=>(0, _vectorSourceJs.VectorSource));
parcelHelpers.export(exports, "path", ()=>_pathJs);
parcelHelpers.export(exports, "stream", ()=>_streamJs);
var _loaderTypesJs = require("./loader-types.js");
var _assertJs = require("./lib/env-utils/assert.js");
var _globalsJs = require("./lib/env-utils/globals.js");
var _logJs = require("./lib/log-utils/log.js");
var _mergeLoaderOptionsJs = require("./lib/option-utils/merge-loader-options.js");
var _jsModuleUtilsJs = require("./lib/module-utils/js-module-utils.js");
var _createLoaderWorkerJs = require("./lib/worker-loader-utils/create-loader-worker.js");
var _parseWithWorkerJs = require("./lib/worker-loader-utils/parse-with-worker.js");
var _encodeWithWorkerJs = require("./lib/worker-loader-utils/encode-with-worker.js");
var _parseJsonJs = require("./lib/parser-utils/parse-json.js");
var _arrayBufferUtilsJs = require("./lib/binary-utils/array-buffer-utils.js");
var _memoryCopyUtilsJs = require("./lib/binary-utils/memory-copy-utils.js");
var _dataviewCopyUtilsJs = require("./lib/binary-utils/dataview-copy-utils.js");
var _getFirstCharactersJs = require("./lib/binary-utils/get-first-characters.js");
var _textIteratorsJs = require("./lib/iterators/text-iterators.js");
var _asyncIterationJs = require("./lib/iterators/async-iteration.js");
var _requestSchedulerJs = require("./lib/request-utils/request-scheduler.js");
var _requestSchedulerJsDefault = parcelHelpers.interopDefault(_requestSchedulerJs);
var _fileAliasesJs = require("./lib/path-utils/file-aliases.js");
var _jsonLoaderJs = require("./json-loader.js");
var _memoryConversionUtilsJs = require("./lib/binary-utils/memory-conversion-utils.js");
var _promisifyJs = require("./lib/node/promisify.js");
// `path` replacement (avoids bundling big path polyfill)
var _pathJs = require("./lib/path-utils/path.js");
// Use instead of importing 'stream' to avoid node dependencies`
var _streamJs = require("./lib/node/stream.js");
var _blobFileJs = require("./lib/files/blob-file.js");
var _httpFileJs = require("./lib/files/http-file.js");
var _nodeFileFacadeJs = require("./lib/files/node-file-facade.js");
var _nodeFilesystemFacadeJs = require("./lib/filesystems/node-filesystem-facade.js");
var _fileProviderInterfaceJs = require("./lib/file-provider/file-provider-interface.js");
var _fileProviderJs = require("./lib/file-provider/file-provider.js");
var _fileHandleFileJs = require("./lib/file-provider/file-handle-file.js");
var _dataViewFileJs = require("./lib/file-provider/data-view-file.js");
var _dataSourceJs = require("./lib/sources/data-source.js");
var _imageSourceJs = require("./lib/sources/image-source.js");
var _vectorSourceJs = require("./lib/sources/vector-source.js");

},{"./loader-types.js":false,"./lib/env-utils/assert.js":"ldEft","./lib/env-utils/globals.js":"eQfjJ","./lib/log-utils/log.js":"bFP9w","./lib/option-utils/merge-loader-options.js":"fM5ry","./lib/module-utils/js-module-utils.js":"hLJZ8","./lib/worker-loader-utils/create-loader-worker.js":false,"./lib/worker-loader-utils/parse-with-worker.js":"jdJu4","./lib/worker-loader-utils/encode-with-worker.js":false,"./lib/parser-utils/parse-json.js":false,"./lib/binary-utils/array-buffer-utils.js":"6Xs03","./lib/binary-utils/memory-copy-utils.js":false,"./lib/binary-utils/dataview-copy-utils.js":false,"./lib/binary-utils/get-first-characters.js":false,"./lib/iterators/text-iterators.js":false,"./lib/iterators/async-iteration.js":"036iC","./lib/request-utils/request-scheduler.js":false,"./lib/path-utils/file-aliases.js":"dVB55","./json-loader.js":false,"./lib/binary-utils/memory-conversion-utils.js":"jRpLl","./lib/node/promisify.js":false,"./lib/path-utils/path.js":"bcLKE","./lib/node/stream.js":false,"./lib/files/blob-file.js":false,"./lib/files/http-file.js":false,"./lib/files/node-file-facade.js":false,"./lib/filesystems/node-filesystem-facade.js":false,"./lib/file-provider/file-provider-interface.js":false,"./lib/file-provider/file-provider.js":false,"./lib/file-provider/file-handle-file.js":false,"./lib/file-provider/data-view-file.js":false,"./lib/sources/data-source.js":false,"./lib/sources/image-source.js":false,"./lib/sources/vector-source.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ldEft":[function(require,module,exports,__globalThis) {
/**
 * Throws an `Error` with the optional `message` if `condition` is falsy
 * @note Replacement for the external assert method to reduce bundle size
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(message || 'loader assertion failed.');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ftQX7":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"eQfjJ":[function(require,module,exports,__globalThis) {
// Purpose: include this in your module to avoid
// dependencies on micro modules like 'global' and 'is-browser';
/* eslint-disable no-restricted-globals */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "self", ()=>self_);
parcelHelpers.export(exports, "window", ()=>window_);
parcelHelpers.export(exports, "global", ()=>global_);
parcelHelpers.export(exports, "document", ()=>document_);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "isWorker", ()=>isWorker);
parcelHelpers.export(exports, "nodeVersion", ()=>nodeVersion);
var global = arguments[3];
const globals = {
    self: typeof self !== 'undefined' && self,
    window: typeof window !== 'undefined' && window,
    global: typeof global !== 'undefined' && global,
    document: typeof document !== 'undefined' && document
};
const self_ = globals.self || globals.window || globals.global || {};
const window_ = globals.window || globals.self || globals.global || {};
const global_ = globals.global || globals.self || globals.window || {};
const document_ = globals.document || {};
const isBrowser = // @ts-ignore process does not exist on browser
Boolean(true);
const isWorker = typeof importScripts === 'function';
// Extract node major version
const matches = false;
const nodeVersion = matches && parseFloat(matches[1]) || 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bFP9w":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "log", ()=>log);
var _log = require("@probe.gl/log");
const VERSION = "4.3.3";
const version = VERSION[0] >= '0' && VERSION[0] <= '9' ? `v${VERSION}` : '';
// Make sure we set the global variable
function createLog() {
    const log = new (0, _log.Log)({
        id: 'loaders.gl'
    });
    globalThis.loaders = globalThis.loaders || {};
    globalThis.loaders.log = log;
    globalThis.loaders.version = version;
    globalThis.probe = globalThis.probe || {};
    globalThis.probe.loaders = log;
    return log;
}
const log = createLog();

},{"@probe.gl/log":"fwng6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fwng6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// LOGGING
parcelHelpers.export(exports, "Log", ()=>(0, _logJs.Log));
parcelHelpers.export(exports, "COLOR", ()=>(0, _colorJs.COLOR));
// UTILITIES
parcelHelpers.export(exports, "addColor", ()=>(0, _colorJs.addColor));
parcelHelpers.export(exports, "leftPad", ()=>(0, _formattersJs.leftPad));
parcelHelpers.export(exports, "rightPad", ()=>(0, _formattersJs.rightPad));
parcelHelpers.export(exports, "autobind", ()=>(0, _autobindJs.autobind));
parcelHelpers.export(exports, "LocalStorage", ()=>(0, _localStorageJs.LocalStorage));
parcelHelpers.export(exports, "getHiResTimestamp", ()=>(0, _hiResTimestampJs.getHiResTimestamp));
var _logJs = require("./log.js");
var _colorJs = require("./utils/color.js");
var _formattersJs = require("./utils/formatters.js");
var _autobindJs = require("./utils/autobind.js");
var _localStorageJs = require("./utils/local-storage.js");
var _hiResTimestampJs = require("./utils/hi-res-timestamp.js");
var _initJs = require("./init.js");
// DEFAULT EXPORT IS A LOG INSTANCE
exports.default = new (0, _logJs.Log)({
    id: '@probe.gl/log'
});

},{"./log.js":"7HUdh","./utils/color.js":false,"./utils/formatters.js":false,"./utils/autobind.js":false,"./utils/local-storage.js":false,"./utils/hi-res-timestamp.js":false,"./init.js":"3yMhI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7HUdh":[function(require,module,exports,__globalThis) {
// probe.gl, MIT license
/* eslint-disable no-console,prefer-rest-params */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** A console wrapper */ parcelHelpers.export(exports, "Log", ()=>Log);
/**
 * "Normalizes" the various argument patterns into an object with known types
 * - log(logLevel, message, args) => {logLevel, message, args}
 * - log(message, args) => {logLevel: 0, message, args}
 * - log({logLevel, ...}, message, args) => {logLevel, message, args}
 * - log({logLevel, message, args}) => {logLevel, message, args}
 */ parcelHelpers.export(exports, "normalizeArguments", ()=>normalizeArguments);
var _env = require("@probe.gl/env");
var _localStorageJs = require("./utils/local-storage.js");
var _formattersJs = require("./utils/formatters.js");
var _colorJs = require("./utils/color.js");
var _autobindJs = require("./utils/autobind.js");
var _assertJs = require("./utils/assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
var _hiResTimestampJs = require("./utils/hi-res-timestamp.js");
// Instrumentation in other packages may override console methods, so preserve them here
const originalConsole = {
    debug: (0, _env.isBrowser)() ? console.debug || console.log : console.log,
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error
};
const DEFAULT_LOG_CONFIGURATION = {
    enabled: true,
    level: 0
};
function noop() {} // eslint-disable-line @typescript-eslint/no-empty-function
const cache = {};
const ONCE = {
    once: true
};
class Log {
    constructor({ id } = {
        id: ''
    }){
        this.VERSION = (0, _env.VERSION);
        this._startTs = (0, _hiResTimestampJs.getHiResTimestamp)();
        this._deltaTs = (0, _hiResTimestampJs.getHiResTimestamp)();
        this.userData = {};
        // TODO - fix support from throttling groups
        this.LOG_THROTTLE_TIMEOUT = 0; // Time before throttled messages are logged again
        this.id = id;
        this.userData = {};
        this._storage = new (0, _localStorageJs.LocalStorage)(`__probe-${this.id}__`, DEFAULT_LOG_CONFIGURATION);
        this.timeStamp(`${this.id} started`);
        (0, _autobindJs.autobind)(this);
        Object.seal(this);
    }
    set level(newLevel) {
        this.setLevel(newLevel);
    }
    get level() {
        return this.getLevel();
    }
    isEnabled() {
        return this._storage.config.enabled;
    }
    getLevel() {
        return this._storage.config.level;
    }
    /** @return milliseconds, with fractions */ getTotal() {
        return Number(((0, _hiResTimestampJs.getHiResTimestamp)() - this._startTs).toPrecision(10));
    }
    /** @return milliseconds, with fractions */ getDelta() {
        return Number(((0, _hiResTimestampJs.getHiResTimestamp)() - this._deltaTs).toPrecision(10));
    }
    /** @deprecated use logLevel */ set priority(newPriority) {
        this.level = newPriority;
    }
    /** @deprecated use logLevel */ get priority() {
        return this.level;
    }
    /** @deprecated use logLevel */ getPriority() {
        return this.level;
    }
    // Configure
    enable(enabled = true) {
        this._storage.setConfiguration({
            enabled
        });
        return this;
    }
    setLevel(level) {
        this._storage.setConfiguration({
            level
        });
        return this;
    }
    /** return the current status of the setting */ get(setting) {
        return this._storage.config[setting];
    }
    // update the status of the setting
    set(setting, value) {
        this._storage.setConfiguration({
            [setting]: value
        });
    }
    /** Logs the current settings as a table */ settings() {
        if (console.table) console.table(this._storage.config);
        else console.log(this._storage.config);
    }
    // Unconditional logging
    assert(condition, message) {
        if (!condition) throw new Error(message || 'Assertion failed');
    }
    warn(message) {
        return this._getLogFunction(0, message, originalConsole.warn, arguments, ONCE);
    }
    error(message) {
        return this._getLogFunction(0, message, originalConsole.error, arguments);
    }
    /** Print a deprecation warning */ deprecated(oldUsage, newUsage) {
        return this.warn(`\`${oldUsage}\` is deprecated and will be removed \
in a later version. Use \`${newUsage}\` instead`);
    }
    /** Print a removal warning */ removed(oldUsage, newUsage) {
        return this.error(`\`${oldUsage}\` has been removed. Use \`${newUsage}\` instead`);
    }
    probe(logLevel, message) {
        return this._getLogFunction(logLevel, message, originalConsole.log, arguments, {
            time: true,
            once: true
        });
    }
    log(logLevel, message) {
        return this._getLogFunction(logLevel, message, originalConsole.debug, arguments);
    }
    info(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.info, arguments);
    }
    once(logLevel, message) {
        return this._getLogFunction(logLevel, message, originalConsole.debug || originalConsole.info, arguments, ONCE);
    }
    /** Logs an object as a table */ table(logLevel, table, columns) {
        if (table) return this._getLogFunction(logLevel, table, console.table || noop, columns && [
            columns
        ], {
            tag: getTableHeader(table)
        });
        return noop;
    }
    time(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.time ? console.time : console.info);
    }
    timeEnd(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeEnd ? console.timeEnd : console.info);
    }
    timeStamp(logLevel, message) {
        return this._getLogFunction(logLevel, message, console.timeStamp || noop);
    }
    group(logLevel, message, opts = {
        collapsed: false
    }) {
        const options = normalizeArguments({
            logLevel,
            message,
            opts
        });
        const { collapsed } = opts;
        // @ts-expect-error
        options.method = (collapsed ? console.groupCollapsed : console.group) || console.info;
        return this._getLogFunction(options);
    }
    groupCollapsed(logLevel, message, opts = {}) {
        return this.group(logLevel, message, Object.assign({}, opts, {
            collapsed: true
        }));
    }
    groupEnd(logLevel) {
        return this._getLogFunction(logLevel, '', console.groupEnd || noop);
    }
    // EXPERIMENTAL
    withGroup(logLevel, message, func) {
        this.group(logLevel, message)();
        try {
            func();
        } finally{
            this.groupEnd(logLevel)();
        }
    }
    trace() {
        if (console.trace) console.trace();
    }
    // PRIVATE METHODS
    /** Deduces log level from a variety of arguments */ _shouldLog(logLevel) {
        return this.isEnabled() && this.getLevel() >= normalizeLogLevel(logLevel);
    }
    _getLogFunction(logLevel, message, method, args, opts) {
        if (this._shouldLog(logLevel)) {
            // normalized opts + timings
            opts = normalizeArguments({
                logLevel,
                message,
                args,
                opts
            });
            method = method || opts.method;
            (0, _assertJsDefault.default)(method);
            opts.total = this.getTotal();
            opts.delta = this.getDelta();
            // reset delta timer
            this._deltaTs = (0, _hiResTimestampJs.getHiResTimestamp)();
            const tag = opts.tag || opts.message;
            if (opts.once && tag) {
                if (!cache[tag]) cache[tag] = (0, _hiResTimestampJs.getHiResTimestamp)();
                else return noop;
            }
            // TODO - Make throttling work with groups
            // if (opts.nothrottle || !throttle(tag, this.LOG_THROTTLE_TIMEOUT)) {
            //   return noop;
            // }
            message = decorateMessage(this.id, opts.message, opts);
            // Bind console function so that it can be called after being returned
            return method.bind(console, message, ...opts.args);
        }
        return noop;
    }
}
Log.VERSION = (0, _env.VERSION);
/**
 * Get logLevel from first argument:
 * - log(logLevel, message, args) => logLevel
 * - log(message, args) => 0
 * - log({logLevel, ...}, message, args) => logLevel
 * - log({logLevel, message, args}) => logLevel
 */ function normalizeLogLevel(logLevel) {
    if (!logLevel) return 0;
    let resolvedLevel;
    switch(typeof logLevel){
        case 'number':
            resolvedLevel = logLevel;
            break;
        case 'object':
            // Backward compatibility
            // TODO - deprecate `priority`
            // @ts-expect-error
            resolvedLevel = logLevel.logLevel || logLevel.priority || 0;
            break;
        default:
            return 0;
    }
    // 'log level must be a number'
    (0, _assertJsDefault.default)(Number.isFinite(resolvedLevel) && resolvedLevel >= 0);
    return resolvedLevel;
}
function normalizeArguments(opts) {
    const { logLevel, message } = opts;
    opts.logLevel = normalizeLogLevel(logLevel);
    // We use `arguments` instead of rest parameters (...args) because IE
    // does not support the syntax. Rest parameters is transpiled to code with
    // perf impact. Doing it here instead avoids constructing args when logging is
    // disabled.
    // TODO - remove when/if IE support is dropped
    const args = opts.args ? Array.from(opts.args) : [];
    // args should only contain arguments that appear after `message`
    // eslint-disable-next-line no-empty
    while(args.length && args.shift() !== message);
    switch(typeof logLevel){
        case 'string':
        case 'function':
            if (message !== undefined) args.unshift(message);
            opts.message = logLevel;
            break;
        case 'object':
            Object.assign(opts, logLevel);
            break;
        default:
    }
    // Resolve functions into strings by calling them
    if (typeof opts.message === 'function') opts.message = opts.message();
    const messageType = typeof opts.message;
    // 'log message must be a string' or object
    (0, _assertJsDefault.default)(messageType === 'string' || messageType === 'object');
    // original opts + normalized opts + opts arg + fixed up message
    return Object.assign(opts, {
        args
    }, opts.opts);
}
function decorateMessage(id, message, opts) {
    if (typeof message === 'string') {
        const time = opts.time ? (0, _formattersJs.leftPad)((0, _formattersJs.formatTime)(opts.total)) : '';
        message = opts.time ? `${id}: ${time}  ${message}` : `${id}: ${message}`;
        message = (0, _colorJs.addColor)(message, opts.color, opts.background);
    }
    return message;
}
function getTableHeader(table) {
    for(const key in table){
        for(const title in table[key])return title || 'untitled';
    }
    return 'empty';
}

},{"@probe.gl/env":"hQL54","./utils/local-storage.js":"eKOiI","./utils/formatters.js":"aoLen","./utils/color.js":"7BESu","./utils/autobind.js":"5teEW","./utils/assert.js":"cYBSu","./utils/hi-res-timestamp.js":"23HUi","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hQL54":[function(require,module,exports,__globalThis) {
// Extract injected version from package.json (injected by babel plugin)
// @ts-expect-error
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ENVIRONMENT
parcelHelpers.export(exports, "self", ()=>(0, _globalsJs.self));
parcelHelpers.export(exports, "window", ()=>(0, _globalsJs.window));
parcelHelpers.export(exports, "global", ()=>(0, _globalsJs.global));
parcelHelpers.export(exports, "document", ()=>(0, _globalsJs.document));
parcelHelpers.export(exports, "process", ()=>(0, _globalsJs.process));
parcelHelpers.export(exports, "console", ()=>(0, _globalsJs.console));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _isBrowserJs.isBrowser));
parcelHelpers.export(exports, "getBrowser", ()=>(0, _getBrowserJs.getBrowser));
parcelHelpers.export(exports, "isMobile", ()=>(0, _getBrowserJs.isMobile));
parcelHelpers.export(exports, "isElectron", ()=>(0, _isElectronJs.isElectron));
// ENVIRONMENT'S ASSERT IS 5-15KB, SO WE PROVIDE OUR OWN
parcelHelpers.export(exports, "assert", ()=>(0, _assertJs.assert)) // TODO - wish we could just export a constant
 // export const isBrowser = checkIfBrowser();
;
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var _globalsJs = require("./lib/globals.js");
var _isBrowserJs = require("./lib/is-browser.js");
var _getBrowserJs = require("./lib/get-browser.js");
var _isElectronJs = require("./lib/is-electron.js");
var _assertJs = require("./utils/assert.js");
const VERSION = "4.1.0";

},{"./lib/globals.js":"dyM3I","./lib/is-browser.js":"8wUbH","./lib/get-browser.js":"4LtUy","./lib/is-electron.js":false,"./utils/assert.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dyM3I":[function(require,module,exports,__globalThis) {
// Do not name these variables the same as the global objects - will break bundling
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "global", ()=>global_);
parcelHelpers.export(exports, "self", ()=>global_);
parcelHelpers.export(exports, "window", ()=>window_);
parcelHelpers.export(exports, "document", ()=>document_);
parcelHelpers.export(exports, "process", ()=>process_);
parcelHelpers.export(exports, "console", ()=>console_);
parcelHelpers.export(exports, "navigator", ()=>navigator_);
const global_ = globalThis;
const window_ = globalThis;
const document_ = globalThis.document || {};
const process_ = globalThis.process || {};
const console_ = globalThis.console;
const navigator_ = globalThis.navigator || {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8wUbH":[function(require,module,exports,__globalThis) {
// This function is needed in initialization stages,
// make sure it can be imported in isolation
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Check if in browser by duck-typing Node context */ parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
var _isElectronJs = require("./is-electron.js");
function isBrowser() {
    const isNode = // @ts-expect-error
    false;
    return !isNode || (0, _isElectronJs.isElectron)();
}

},{"./is-electron.js":"3hCsi","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3hCsi":[function(require,module,exports,__globalThis) {
// based on https://github.com/cheton/is-electron
// https://github.com/electron/electron/issues/2288
/* eslint-disable complexity */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElectron", ()=>isElectron);
function isElectron(mockUserAgent) {
    // Renderer process
    // @ts-expect-error
    if (typeof window !== 'undefined' && window.process?.type === 'renderer') return true;
    // Detect the user agent when the `nodeIntegration` option is set to true
    const realUserAgent = typeof navigator !== 'undefined' && navigator.userAgent;
    const userAgent = mockUserAgent || realUserAgent;
    return Boolean(userAgent && userAgent.indexOf('Electron') >= 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4LtUy":[function(require,module,exports,__globalThis) {
// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
// This function is needed in initialization stages,
// make sure it can be imported in isolation
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMobile", ()=>isMobile);
// Simple browser detection
// `mockUserAgent` parameter allows user agent to be overridden for testing
/* eslint-disable complexity */ parcelHelpers.export(exports, "getBrowser", ()=>getBrowser);
var _isBrowserJs = require("./is-browser.js");
var _isElectronJs = require("./is-electron.js");
var _globalsJs = require("./globals.js");
function isMobile() {
    return typeof globalThis.orientation !== 'undefined';
}
function getBrowser(mockUserAgent) {
    if (!mockUserAgent && !(0, _isBrowserJs.isBrowser)()) return 'Node';
    if ((0, _isElectronJs.isElectron)(mockUserAgent)) return 'Electron';
    const userAgent = mockUserAgent || (0, _globalsJs.navigator).userAgent || '';
    // NOTE: Order of tests matter, as many agents list Chrome etc.
    if (userAgent.indexOf('Edge') > -1) return 'Edge';
    if (globalThis.chrome) return 'Chrome';
    if (globalThis.safari) return 'Safari';
    if (globalThis.mozInnerScreenX) return 'Firefox';
    return 'Unknown';
}

},{"./is-browser.js":"8wUbH","./is-electron.js":"3hCsi","./globals.js":"dyM3I","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eKOiI":[function(require,module,exports,__globalThis) {
// probe.gl, MIT license
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Store keys in local storage via simple interface
parcelHelpers.export(exports, "LocalStorage", ()=>LocalStorage);
function getStorage(type) {
    try {
        const storage = window[type];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return storage;
    } catch (e) {
        return null;
    }
}
class LocalStorage {
    constructor(id, defaultConfig, type = 'sessionStorage'){
        this.storage = getStorage(type);
        this.id = id;
        this.config = defaultConfig;
        this._loadConfiguration();
    }
    getConfiguration() {
        return this.config;
    }
    setConfiguration(configuration) {
        Object.assign(this.config, configuration);
        if (this.storage) {
            const serialized = JSON.stringify(this.config);
            this.storage.setItem(this.id, serialized);
        }
    }
    // Get config from persistent store, if available
    _loadConfiguration() {
        let configuration = {};
        if (this.storage) {
            const serializedConfiguration = this.storage.getItem(this.id);
            configuration = serializedConfiguration ? JSON.parse(serializedConfiguration) : {};
        }
        Object.assign(this.config, configuration);
        return this;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aoLen":[function(require,module,exports,__globalThis) {
// probe.gl, MIT license
/**
 * Format time
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "leftPad", ()=>leftPad);
parcelHelpers.export(exports, "rightPad", ()=>rightPad);
parcelHelpers.export(exports, "formatValue", ()=>formatValue);
function formatTime(ms) {
    let formatted;
    if (ms < 10) formatted = `${ms.toFixed(2)}ms`;
    else if (ms < 100) formatted = `${ms.toFixed(1)}ms`;
    else if (ms < 1000) formatted = `${ms.toFixed(0)}ms`;
    else formatted = `${(ms / 1000).toFixed(2)}s`;
    return formatted;
}
function leftPad(string, length = 8) {
    const padLength = Math.max(length - string.length, 0);
    return `${' '.repeat(padLength)}${string}`;
}
function rightPad(string, length = 8) {
    const padLength = Math.max(length - string.length, 0);
    return `${string}${' '.repeat(padLength)}`;
}
function formatValue(v, options = {}) {
    const EPSILON = 1e-16;
    const { isInteger = false } = options;
    if (Array.isArray(v) || ArrayBuffer.isView(v)) return formatArrayValue(v, options);
    if (!Number.isFinite(v)) return String(v);
    // @ts-expect-error
    if (Math.abs(v) < EPSILON) return isInteger ? '0' : '0.';
    if (isInteger) // @ts-expect-error
    return v.toFixed(0);
    // @ts-expect-error
    if (Math.abs(v) > 100 && Math.abs(v) < 10000) // @ts-expect-error
    return v.toFixed(0);
    // @ts-expect-error
    const string = v.toPrecision(2);
    const decimal = string.indexOf('.0');
    return decimal === string.length - 2 ? string.slice(0, -1) : string;
}
/** Helper to formatValue */ function formatArrayValue(v, options) {
    const { maxElts = 16, size = 1 } = options;
    let string = '[';
    for(let i = 0; i < v.length && i < maxElts; ++i){
        if (i > 0) string += `,${i % size === 0 ? ' ' : ''}`;
        string += formatValue(v[i], options);
    }
    const terminator = v.length > maxElts ? '...' : ']';
    return `${string}${terminator}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7BESu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLOR", ()=>COLOR);
parcelHelpers.export(exports, "addColor", ()=>addColor);
var _env = require("@probe.gl/env");
var COLOR;
(function(COLOR) {
    COLOR[COLOR["BLACK"] = 30] = "BLACK";
    COLOR[COLOR["RED"] = 31] = "RED";
    COLOR[COLOR["GREEN"] = 32] = "GREEN";
    COLOR[COLOR["YELLOW"] = 33] = "YELLOW";
    COLOR[COLOR["BLUE"] = 34] = "BLUE";
    COLOR[COLOR["MAGENTA"] = 35] = "MAGENTA";
    COLOR[COLOR["CYAN"] = 36] = "CYAN";
    COLOR[COLOR["WHITE"] = 37] = "WHITE";
    COLOR[COLOR["BRIGHT_BLACK"] = 90] = "BRIGHT_BLACK";
    COLOR[COLOR["BRIGHT_RED"] = 91] = "BRIGHT_RED";
    COLOR[COLOR["BRIGHT_GREEN"] = 92] = "BRIGHT_GREEN";
    COLOR[COLOR["BRIGHT_YELLOW"] = 93] = "BRIGHT_YELLOW";
    COLOR[COLOR["BRIGHT_BLUE"] = 94] = "BRIGHT_BLUE";
    COLOR[COLOR["BRIGHT_MAGENTA"] = 95] = "BRIGHT_MAGENTA";
    COLOR[COLOR["BRIGHT_CYAN"] = 96] = "BRIGHT_CYAN";
    COLOR[COLOR["BRIGHT_WHITE"] = 97] = "BRIGHT_WHITE";
})(COLOR || (COLOR = {}));
const BACKGROUND_INCREMENT = 10;
function getColor(color) {
    if (typeof color !== 'string') return color;
    color = color.toUpperCase();
    return COLOR[color] || COLOR.WHITE;
}
function addColor(string, color, background) {
    if (!(0, _env.isBrowser) && typeof string === 'string') {
        if (color) {
            const colorCode = getColor(color);
            string = `\u001b[${colorCode}m${string}\u001b[39m`;
        }
        if (background) {
            // background colors values are +10
            const colorCode = getColor(background);
            string = `\u001b[${colorCode + BACKGROUND_INCREMENT}m${string}\u001b[49m`;
        }
    }
    return string;
}

},{"@probe.gl/env":"hQL54","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5teEW":[function(require,module,exports,__globalThis) {
// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/**
 * Binds the "this" argument of all functions on a class instance to the instance
 * @param obj - class instance (typically a react component)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autobind", ()=>autobind);
function autobind(obj, predefined = [
    'constructor'
]) {
    const proto = Object.getPrototypeOf(obj);
    const propNames = Object.getOwnPropertyNames(proto);
    const object = obj;
    for (const key of propNames){
        const value = object[key];
        if (typeof value === 'function') {
            if (!predefined.find((name)=>key === name)) object[key] = value.bind(obj);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cYBSu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(message || 'Assertion failed');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"23HUi":[function(require,module,exports,__globalThis) {
// probe.gl, MIT license
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Get best timer available. */ parcelHelpers.export(exports, "getHiResTimestamp", ()=>getHiResTimestamp);
var _env = require("@probe.gl/env");
function getHiResTimestamp() {
    let timestamp;
    if ((0, _env.isBrowser)() && (0, _env.window).performance) timestamp = (0, _env.window)?.performance?.now?.();
    else if ('hrtime' in (0, _env.process)) {
        // @ts-ignore
        const timeParts = (0, _env.process)?.hrtime?.();
        timestamp = timeParts[0] * 1000 + timeParts[1] / 1e6;
    } else timestamp = Date.now();
    return timestamp;
}

},{"@probe.gl/env":"hQL54","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3yMhI":[function(require,module,exports,__globalThis) {
// @ts-nocheck
/* eslint-disable */ globalThis.probe = {};

},{}],"fM5ry":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 *
 * @param baseOptions Can be undefined, in which case a fresh options object will be minted
 * @param newOptions
 * @returns
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeLoaderOptions", ()=>mergeLoaderOptions);
function mergeLoaderOptions(baseOptions, newOptions) {
    return mergeOptionsRecursively(baseOptions || {}, newOptions);
}
function mergeOptionsRecursively(baseOptions, newOptions, level = 0) {
    // Sanity check (jest test runner overwrites the console object which can lead to infinite recursion)
    if (level > 3) return newOptions;
    const options = {
        ...baseOptions
    };
    for (const [key, newValue] of Object.entries(newOptions))if (newValue && typeof newValue === 'object' && !Array.isArray(newValue)) options[key] = mergeOptionsRecursively(options[key] || {}, newOptions[key], level + 1);
    else options[key] = newOptions[key];
    return options;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hLJZ8":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Register application-imported modules
 * These modules are typically to big to bundle, or may have issues on some bundlers/environments
 */ parcelHelpers.export(exports, "registerJSModules", ()=>registerJSModules);
/**
 * Get a pre-registered application-imported module, warn if not present
 */ parcelHelpers.export(exports, "checkJSModule", ()=>checkJSModule);
/**
 * Get a pre-registered application-imported module, throw if not present
 */ parcelHelpers.export(exports, "getJSModule", ()=>getJSModule);
/**
 * Get a pre-registered application-imported module, return null if not present
 */ parcelHelpers.export(exports, "getJSModuleOrNull", ()=>getJSModuleOrNull);
var _logJs = require("../log-utils/log.js");
function registerJSModules(modules) {
    globalThis.loaders ||= {};
    globalThis.loaders.modules ||= {};
    Object.assign(globalThis.loaders.modules, modules);
}
function checkJSModule(name, caller) {
    const module = globalThis.loaders?.modules?.[name];
    if (!module) (0, _logJs.log).warn(`${caller}: ${name} library not installed`)();
}
function getJSModule(name, caller) {
    const module = globalThis.loaders?.modules?.[name];
    if (!module) throw new Error(`${caller}: ${name} library not installed`);
    return module;
}
function getJSModuleOrNull(name) {
    const module = globalThis.loaders?.modules?.[name];
    return module || null;
}

},{"../log-utils/log.js":"bFP9w","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jdJu4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines if a loader can parse with worker
 * @param loader
 * @param options
 */ parcelHelpers.export(exports, "canParseWithWorker", ()=>canParseWithWorker);
/**
 * this function expects that the worker function sends certain messages,
 * this can be automated if the worker is wrapper by a call to createLoaderWorker in @loaders.gl/loader-utils.
 */ parcelHelpers.export(exports, "parseWithWorker", ()=>parseWithWorker);
var _workerUtils = require("@loaders.gl/worker-utils");
function canParseWithWorker(loader, options) {
    if (!(0, _workerUtils.WorkerFarm).isSupported()) return false;
    // Node workers are still experimental
    if (!(0, _workerUtils.isBrowser) && !options?._nodeWorkers) return false;
    return loader.worker && options?.worker;
}
async function parseWithWorker(loader, data, options, context, parseOnMainThread) {
    const name = loader.id; // TODO
    const url = (0, _workerUtils.getWorkerURL)(loader, options);
    const workerFarm = (0, _workerUtils.WorkerFarm).getWorkerFarm(options);
    const workerPool = workerFarm.getWorkerPool({
        name,
        url
    });
    // options.log object contains functions which cannot be transferred
    // context.fetch & context.parse functions cannot be transferred
    // TODO - decide how to handle logging on workers
    options = JSON.parse(JSON.stringify(options));
    context = JSON.parse(JSON.stringify(context || {}));
    const job = await workerPool.startJob('process-on-worker', // @ts-expect-error
    onMessage.bind(null, parseOnMainThread) // eslint-disable-line @typescript-eslint/no-misused-promises
    );
    job.postMessage('process', {
        // @ts-ignore
        input: data,
        options,
        context
    });
    const result = await job.result;
    // TODO - what is going on here?
    return await result.result;
}
/**
 * Handle worker's responses to the main thread
 * @param job
 * @param type
 * @param payload
 */ async function onMessage(parseOnMainThread, job, type, payload) {
    switch(type){
        case 'done':
            job.done(payload);
            break;
        case 'error':
            job.error(new Error(payload.error));
            break;
        case 'process':
            // Worker is asking for main thread to parseO
            const { id, input, options } = payload;
            try {
                const result = await parseOnMainThread(input, options);
                job.postMessage('done', {
                    id,
                    result
                });
            } catch (error) {
                const message = error instanceof Error ? error.message : 'unknown error';
                job.postMessage('error', {
                    id,
                    error: message
                });
            }
            break;
        default:
            // eslint-disable-next-line
            console.warn(`parse-with-worker unknown message ${type}`);
    }
}

},{"@loaders.gl/worker-utils":"jmn0B","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jmn0B":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERAL UTILS
parcelHelpers.export(exports, "assert", ()=>(0, _assertJs.assert));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _globalsJs.isBrowser));
parcelHelpers.export(exports, "isWorker", ()=>(0, _globalsJs.isWorker));
// WORKER UTILS - TYPES
parcelHelpers.export(exports, "WorkerJob", ()=>(0, _workerJobJsDefault.default));
parcelHelpers.export(exports, "WorkerThread", ()=>(0, _workerThreadJsDefault.default));
// WORKER FARMS
parcelHelpers.export(exports, "WorkerFarm", ()=>(0, _workerFarmJsDefault.default));
parcelHelpers.export(exports, "WorkerPool", ()=>(0, _workerPoolJsDefault.default));
parcelHelpers.export(exports, "WorkerBody", ()=>(0, _workerBodyJsDefault.default));
parcelHelpers.export(exports, "processOnWorker", ()=>(0, _processOnWorkerJs.processOnWorker));
parcelHelpers.export(exports, "canProcessOnWorker", ()=>(0, _processOnWorkerJs.canProcessOnWorker));
parcelHelpers.export(exports, "createWorker", ()=>(0, _createWorkerJs.createWorker));
// WORKER UTILS - EXPORTS
parcelHelpers.export(exports, "getWorkerURL", ()=>(0, _getWorkerUrlJs.getWorkerURL));
parcelHelpers.export(exports, "validateWorkerVersion", ()=>(0, _validateWorkerVersionJs.validateWorkerVersion));
parcelHelpers.export(exports, "getTransferList", ()=>(0, _getTransferListJs.getTransferList));
parcelHelpers.export(exports, "getTransferListForWriter", ()=>(0, _getTransferListJs.getTransferListForWriter));
// LIBRARY UTILS
parcelHelpers.export(exports, "getLibraryUrl", ()=>(0, _libraryUtilsJs.getLibraryUrl));
parcelHelpers.export(exports, "loadLibrary", ()=>(0, _libraryUtilsJs.loadLibrary));
// PARSER UTILS
parcelHelpers.export(exports, "AsyncQueue", ()=>(0, _asyncQueueJsDefault.default));
// PROCESS UTILS
parcelHelpers.export(exports, "ChildProcessProxy", ()=>(0, _childProcessProxyJsDefault.default));
parcelHelpers.export(exports, "NullWorker", ()=>NullWorker);
var _versionJs = require("./lib/env-utils/version.js");
var _assertJs = require("./lib/env-utils/assert.js");
var _globalsJs = require("./lib/env-utils/globals.js");
var _workerJobJs = require("./lib/worker-farm/worker-job.js");
var _workerJobJsDefault = parcelHelpers.interopDefault(_workerJobJs);
var _workerThreadJs = require("./lib/worker-farm/worker-thread.js");
var _workerThreadJsDefault = parcelHelpers.interopDefault(_workerThreadJs);
var _workerFarmJs = require("./lib/worker-farm/worker-farm.js");
var _workerFarmJsDefault = parcelHelpers.interopDefault(_workerFarmJs);
var _workerPoolJs = require("./lib/worker-farm/worker-pool.js");
var _workerPoolJsDefault = parcelHelpers.interopDefault(_workerPoolJs);
var _workerBodyJs = require("./lib/worker-farm/worker-body.js");
var _workerBodyJsDefault = parcelHelpers.interopDefault(_workerBodyJs);
var _processOnWorkerJs = require("./lib/worker-api/process-on-worker.js");
var _createWorkerJs = require("./lib/worker-api/create-worker.js");
var _getWorkerUrlJs = require("./lib/worker-api/get-worker-url.js");
var _validateWorkerVersionJs = require("./lib/worker-api/validate-worker-version.js");
var _getTransferListJs = require("./lib/worker-utils/get-transfer-list.js");
var _libraryUtilsJs = require("./lib/library-utils/library-utils.js");
var _asyncQueueJs = require("./lib/async-queue/async-queue.js");
var _asyncQueueJsDefault = parcelHelpers.interopDefault(_asyncQueueJs);
var _childProcessProxyJs = require("./lib/process-utils/child-process-proxy.js");
var _childProcessProxyJsDefault = parcelHelpers.interopDefault(_childProcessProxyJs);
const NullWorker = {
    id: 'null',
    name: 'null',
    module: 'worker-utils',
    version: (0, _versionJs.VERSION),
    options: {
        null: {}
    }
};

},{"./lib/env-utils/version.js":"8ob32","./lib/env-utils/assert.js":"8dZa5","./lib/env-utils/globals.js":"6J3TE","./lib/worker-farm/worker-job.js":false,"./lib/worker-farm/worker-thread.js":false,"./lib/worker-farm/worker-farm.js":"8zkOj","./lib/worker-farm/worker-pool.js":false,"./lib/worker-farm/worker-body.js":false,"./lib/worker-api/process-on-worker.js":false,"./lib/worker-api/create-worker.js":false,"./lib/worker-api/get-worker-url.js":"fnVxb","./lib/worker-api/validate-worker-version.js":"d7qkn","./lib/worker-utils/get-transfer-list.js":false,"./lib/library-utils/library-utils.js":false,"./lib/async-queue/async-queue.js":false,"./lib/process-utils/child-process-proxy.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8ob32":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Version constant cannot be imported, it needs to correspond to the build version of **this** module.
/**
 * TODO - unpkg.com doesn't seem to have a `latest` specifier for alpha releases...
 * 'beta' on beta branch, 'latest' on prod branch
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NPM_TAG", ()=>NPM_TAG);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const NPM_TAG = 'latest';
function getVersion() {
    if (!globalThis._loadersgl_?.version) {
        globalThis._loadersgl_ = globalThis._loadersgl_ || {};
        globalThis._loadersgl_.version = "4.3.3";
    }
    return globalThis._loadersgl_.version;
}
const VERSION = getVersion();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8dZa5":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Replacement for the external assert method to reduce bundle size
// Note: We don't use the second "message" argument in calling code,
// so no need to support it here
/** Throws an `Error` with the optional `message` if `condition` is falsy */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(message || 'loaders.gl assertion failed.');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6J3TE":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Purpose: include this in your module to avoids adding dependencies on
// micro modules like 'global' and 'is-browser';
/* eslint-disable no-restricted-globals */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "self", ()=>self_);
parcelHelpers.export(exports, "window", ()=>window_);
parcelHelpers.export(exports, "global", ()=>global_);
parcelHelpers.export(exports, "document", ()=>document_);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "isWorker", ()=>isWorker);
parcelHelpers.export(exports, "isMobile", ()=>isMobile);
parcelHelpers.export(exports, "nodeVersion", ()=>nodeVersion);
var global = arguments[3];
const globals = {
    self: typeof self !== 'undefined' && self,
    window: typeof window !== 'undefined' && window,
    global: typeof global !== 'undefined' && global,
    document: typeof document !== 'undefined' && document
};
const self_ = globals.self || globals.window || globals.global || {};
const window_ = globals.window || globals.self || globals.global || {};
const global_ = globals.global || globals.self || globals.window || {};
const document_ = globals.document || {};
const isBrowser = // @ts-ignore process.browser
true;
const isWorker = typeof importScripts === 'function';
const isMobile = typeof window !== 'undefined' && typeof window.orientation !== 'undefined';
// Extract node major version
const matches = false;
const nodeVersion = matches && parseFloat(matches[1]) || 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"93IHG":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assertJs = require("../env-utils/assert.js");
class WorkerJob {
    name;
    workerThread;
    isRunning = true;
    /** Promise that resolves when Job is done */ result;
    _resolve = ()=>{};
    _reject = ()=>{};
    constructor(jobName, workerThread){
        this.name = jobName;
        this.workerThread = workerThread;
        this.result = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    /**
     * Send a message to the job's worker thread
     * @param data any data structure, ideally consisting mostly of transferrable objects
     */ postMessage(type, payload) {
        this.workerThread.postMessage({
            source: 'loaders.gl',
            type,
            payload
        });
    }
    /**
     * Call to resolve the `result` Promise with the supplied value
     */ done(value) {
        (0, _assertJs.assert)(this.isRunning);
        this.isRunning = false;
        this._resolve(value);
    }
    /**
     * Call to reject the `result` Promise with the supplied error
     */ error(error) {
        (0, _assertJs.assert)(this.isRunning);
        this.isRunning = false;
        this._reject(error);
    }
}
exports.default = WorkerJob;

},{"../env-utils/assert.js":"8dZa5","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"crLkY":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _workerThreadsJs = require("../node/worker_threads.js");
var _globalsJs = require("../env-utils/globals.js");
var _assertJs = require("../env-utils/assert.js");
var _getLoadableWorkerUrlJs = require("../worker-utils/get-loadable-worker-url.js");
var _getTransferListJs = require("../worker-utils/get-transfer-list.js");
const NOOP = ()=>{};
class WorkerThread {
    name;
    source;
    url;
    terminated = false;
    worker;
    onMessage;
    onError;
    _loadableURL = '';
    /** Checks if workers are supported on this platform */ static isSupported() {
        return typeof Worker !== 'undefined' && (0, _globalsJs.isBrowser) || typeof (0, _workerThreadsJs.NodeWorker) !== 'undefined' && !(0, _globalsJs.isBrowser);
    }
    constructor(props){
        const { name, source, url } = props;
        (0, _assertJs.assert)(source || url); // Either source or url must be defined
        this.name = name;
        this.source = source;
        this.url = url;
        this.onMessage = NOOP;
        this.onError = (error)=>console.log(error); // eslint-disable-line
        this.worker = (0, _globalsJs.isBrowser) ? this._createBrowserWorker() : this._createNodeWorker();
    }
    /**
     * Terminate this worker thread
     * @note Can free up significant memory
     */ destroy() {
        this.onMessage = NOOP;
        this.onError = NOOP;
        this.worker.terminate(); // eslint-disable-line @typescript-eslint/no-floating-promises
        this.terminated = true;
    }
    get isRunning() {
        return Boolean(this.onMessage);
    }
    /**
     * Send a message to this worker thread
     * @param data any data structure, ideally consisting mostly of transferrable objects
     * @param transferList If not supplied, calculated automatically by traversing data
     */ postMessage(data, transferList) {
        transferList = transferList || (0, _getTransferListJs.getTransferList)(data);
        // @ts-ignore
        this.worker.postMessage(data, transferList);
    }
    // PRIVATE
    /**
     * Generate a standard Error from an ErrorEvent
     * @param event
     */ _getErrorFromErrorEvent(event) {
        // Note Error object does not have the expected fields if loading failed completely
        // https://developer.mozilla.org/en-US/docs/Web/API/Worker#Event_handlers
        // https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
        let message = 'Failed to load ';
        message += `worker ${this.name} from ${this.url}. `;
        if (event.message) message += `${event.message} in `;
        // const hasFilename = event.filename && !event.filename.startsWith('blob:');
        // message += hasFilename ? event.filename : this.source.slice(0, 100);
        if (event.lineno) message += `:${event.lineno}:${event.colno}`;
        return new Error(message);
    }
    /**
     * Creates a worker thread on the browser
     */ _createBrowserWorker() {
        this._loadableURL = (0, _getLoadableWorkerUrlJs.getLoadableWorkerURL)({
            source: this.source,
            url: this.url
        });
        const worker = new Worker(this._loadableURL, {
            name: this.name
        });
        worker.onmessage = (event)=>{
            if (!event.data) this.onError(new Error('No data received'));
            else this.onMessage(event.data);
        };
        // This callback represents an uncaught exception in the worker thread
        worker.onerror = (error)=>{
            this.onError(this._getErrorFromErrorEvent(error));
            this.terminated = true;
        };
        // TODO - not clear when this would be called, for now just log in case it happens
        worker.onmessageerror = (event)=>console.error(event); // eslint-disable-line
        return worker;
    }
    /**
     * Creates a worker thread in node.js
     * @todo https://nodejs.org/api/async_hooks.html#async-resource-worker-pool
     */ _createNodeWorker() {
        let worker;
        if (this.url) {
            // Make sure relative URLs start with './'
            const absolute = this.url.includes(':/') || this.url.startsWith('/');
            const url = absolute ? this.url : `./${this.url}`;
            // console.log('Starting work from', url);
            worker = new (0, _workerThreadsJs.NodeWorker)(url, {
                eval: false
            });
        } else if (this.source) worker = new (0, _workerThreadsJs.NodeWorker)(this.source, {
            eval: true
        });
        else throw new Error('no worker');
        worker.on('message', (data)=>{
            // console.error('message', data);
            this.onMessage(data);
        });
        worker.on('error', (error)=>{
            // console.error('error', error);
            this.onError(error);
        });
        worker.on('exit', (code)=>{
        // console.error('exit', code);
        });
        return worker;
    }
}
exports.default = WorkerThread;

},{"../node/worker_threads.js":"5L4l0","../env-utils/globals.js":"6J3TE","../env-utils/assert.js":"8dZa5","../worker-utils/get-loadable-worker-url.js":"bGitn","../worker-utils/get-transfer-list.js":"lpgei","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5L4l0":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Browser polyfill for Node.js built-in `worker_threads` module.
 * These fills are non-functional, and just intended to ensure that
 * `import 'worker_threads` doesn't break browser builds.
 * The replacement is done in package.json browser field
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeWorker", ()=>NodeWorker);
parcelHelpers.export(exports, "parentPort", ()=>parentPort);
class NodeWorker {
    terminate() {}
}
const parentPort = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bGitn":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a loadable URL from worker source or URL
 * that can be used to create `Worker` instances.
 * Due to CORS issues it may be necessary to wrap a URL in a small importScripts
 * @param props
 * @param props.source Worker source
 * @param props.url Worker URL
 * @returns loadable url
 */ parcelHelpers.export(exports, "getLoadableWorkerURL", ()=>getLoadableWorkerURL);
var _assertJs = require("../env-utils/assert.js");
const workerURLCache = new Map();
function getLoadableWorkerURL(props) {
    (0, _assertJs.assert)(props.source && !props.url || !props.source && props.url); // Either source or url must be defined
    let workerURL = workerURLCache.get(props.source || props.url);
    if (!workerURL) {
        // Differentiate worker urls from worker source code
        if (props.url) {
            workerURL = getLoadableWorkerURLFromURL(props.url);
            workerURLCache.set(props.url, workerURL);
        }
        if (props.source) {
            workerURL = getLoadableWorkerURLFromSource(props.source);
            workerURLCache.set(props.source, workerURL);
        }
    }
    (0, _assertJs.assert)(workerURL);
    return workerURL;
}
/**
 * Build a loadable worker URL from worker URL
 * @param url
 * @returns loadable URL
 */ function getLoadableWorkerURLFromURL(url) {
    // A local script url, we can use it to initialize a Worker directly
    if (!url.startsWith('http')) return url;
    // A remote script, we need to use `importScripts` to load from different origin
    const workerSource = buildScriptSource(url);
    return getLoadableWorkerURLFromSource(workerSource);
}
/**
 * Build a loadable worker URL from worker source
 * @param workerSource
 * @returns loadable url
 */ function getLoadableWorkerURLFromSource(workerSource) {
    const blob = new Blob([
        workerSource
    ], {
        type: 'application/javascript'
    });
    return URL.createObjectURL(blob);
}
/**
 * Per spec, worker cannot be initialized with a script from a different origin
 * However a local worker script can still import scripts from other origins,
 * so we simply build a wrapper script.
 *
 * @param workerUrl
 * @returns source
 */ function buildScriptSource(workerUrl) {
    return `\
try {
  importScripts('${workerUrl}');
} catch (error) {
  console.error(error);
  throw error;
}`;
}

},{"../env-utils/assert.js":"8dZa5","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lpgei":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// NOTE - there is a copy of this function is both in core and loader-utils
// core does not need all the utils in loader-utils, just this one.
/**
 * Returns an array of Transferrable objects that can be used with postMessage
 * https://developer.mozilla.org/en-US/docs/Web/API/Worker/postMessage
 * @param object data to be sent via postMessage
 * @param recursive - not for application use
 * @param transfers - not for application use
 * @returns a transfer list that can be passed to postMessage
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTransferList", ()=>getTransferList);
/**
 * Recursively drop non serializable values like functions and regexps.
 * @param object
 */ parcelHelpers.export(exports, "getTransferListForWriter", ()=>getTransferListForWriter);
function getTransferList(object, recursive = true, transfers) {
    // Make sure that items in the transfer list is unique
    const transfersSet = transfers || new Set();
    if (!object) ;
    else if (isTransferable(object)) transfersSet.add(object);
    else if (isTransferable(object.buffer)) // Typed array
    transfersSet.add(object.buffer);
    else if (ArrayBuffer.isView(object)) ;
    else if (recursive && typeof object === 'object') for(const key in object)// Avoid perf hit - only go one level deep
    getTransferList(object[key], recursive, transfersSet);
    // If transfers is defined, is internal recursive call
    // Otherwise it's called by the user
    return transfers === undefined ? Array.from(transfersSet) : [];
}
// https://developer.mozilla.org/en-US/docs/Web/API/Transferable
function isTransferable(object) {
    if (!object) return false;
    if (object instanceof ArrayBuffer) return true;
    if (typeof MessagePort !== 'undefined' && object instanceof MessagePort) return true;
    if (typeof ImageBitmap !== 'undefined' && object instanceof ImageBitmap) return true;
    // @ts-ignore
    if (typeof OffscreenCanvas !== 'undefined' && object instanceof OffscreenCanvas) return true;
    return false;
}
function getTransferListForWriter(object) {
    if (object === null) return {};
    const clone = Object.assign({}, object);
    Object.keys(clone).forEach((key)=>{
        // Typed Arrays and Arrays are passed with no change
        if (typeof object[key] === 'object' && !ArrayBuffer.isView(object[key]) && !(object[key] instanceof Array)) clone[key] = getTransferListForWriter(object[key]);
        else if (typeof clone[key] === 'function' || clone[key] instanceof RegExp) clone[key] = {};
        else clone[key] = object[key];
    });
    return clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8zkOj":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _workerPoolJs = require("./worker-pool.js");
var _workerPoolJsDefault = parcelHelpers.interopDefault(_workerPoolJs);
var _workerThreadJs = require("./worker-thread.js");
var _workerThreadJsDefault = parcelHelpers.interopDefault(_workerThreadJs);
const DEFAULT_PROPS = {
    maxConcurrency: 3,
    maxMobileConcurrency: 1,
    reuseWorkers: true,
    onDebug: ()=>{}
};
class WorkerFarm {
    props;
    workerPools = new Map();
    // singleton
    static _workerFarm;
    /** Checks if workers are supported on this platform */ static isSupported() {
        return (0, _workerThreadJsDefault.default).isSupported();
    }
    /** Get the singleton instance of the global worker farm */ static getWorkerFarm(props = {}) {
        WorkerFarm._workerFarm = WorkerFarm._workerFarm || new WorkerFarm({});
        WorkerFarm._workerFarm.setProps(props);
        return WorkerFarm._workerFarm;
    }
    /** get global instance with WorkerFarm.getWorkerFarm() */ constructor(props){
        this.props = {
            ...DEFAULT_PROPS
        };
        this.setProps(props);
        /** @type Map<string, WorkerPool>} */ this.workerPools = new Map();
    }
    /**
     * Terminate all workers in the farm
     * @note Can free up significant memory
     */ destroy() {
        for (const workerPool of this.workerPools.values())workerPool.destroy();
        this.workerPools = new Map();
    }
    /**
     * Set props used when initializing worker pools
     * @param props
     */ setProps(props) {
        this.props = {
            ...this.props,
            ...props
        };
        // Update worker pool props
        for (const workerPool of this.workerPools.values())workerPool.setProps(this._getWorkerPoolProps());
    }
    /**
     * Returns a worker pool for the specified worker
     * @param options - only used first time for a specific worker name
     * @param options.name - the name of the worker - used to identify worker pool
     * @param options.url -
     * @param options.source -
     * @example
     *   const job = WorkerFarm.getWorkerFarm().getWorkerPool({name, url}).startJob(...);
     */ getWorkerPool(options) {
        const { name, source, url } = options;
        let workerPool = this.workerPools.get(name);
        if (!workerPool) {
            workerPool = new (0, _workerPoolJsDefault.default)({
                name,
                source,
                url
            });
            workerPool.setProps(this._getWorkerPoolProps());
            this.workerPools.set(name, workerPool);
        }
        return workerPool;
    }
    _getWorkerPoolProps() {
        return {
            maxConcurrency: this.props.maxConcurrency,
            maxMobileConcurrency: this.props.maxMobileConcurrency,
            reuseWorkers: this.props.reuseWorkers,
            onDebug: this.props.onDebug
        };
    }
}
exports.default = WorkerFarm;

},{"./worker-pool.js":"72PDi","./worker-thread.js":"crLkY","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"72PDi":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _globalsJs = require("../env-utils/globals.js");
var _workerThreadJs = require("./worker-thread.js");
var _workerThreadJsDefault = parcelHelpers.interopDefault(_workerThreadJs);
var _workerJobJs = require("./worker-job.js");
var _workerJobJsDefault = parcelHelpers.interopDefault(_workerJobJs);
class WorkerPool {
    name = 'unnamed';
    source;
    url;
    maxConcurrency = 1;
    maxMobileConcurrency = 1;
    onDebug = ()=>{};
    reuseWorkers = true;
    props = {};
    jobQueue = [];
    idleQueue = [];
    count = 0;
    isDestroyed = false;
    /** Checks if workers are supported on this platform */ static isSupported() {
        return (0, _workerThreadJsDefault.default).isSupported();
    }
    /**
     * @param processor - worker function
     * @param maxConcurrency - max count of workers
     */ constructor(props){
        this.source = props.source;
        this.url = props.url;
        this.setProps(props);
    }
    /**
     * Terminates all workers in the pool
     * @note Can free up significant memory
     */ destroy() {
        // Destroy idle workers, active Workers will be destroyed on completion
        this.idleQueue.forEach((worker)=>worker.destroy());
        this.isDestroyed = true;
    }
    setProps(props) {
        this.props = {
            ...this.props,
            ...props
        };
        if (props.name !== undefined) this.name = props.name;
        if (props.maxConcurrency !== undefined) this.maxConcurrency = props.maxConcurrency;
        if (props.maxMobileConcurrency !== undefined) this.maxMobileConcurrency = props.maxMobileConcurrency;
        if (props.reuseWorkers !== undefined) this.reuseWorkers = props.reuseWorkers;
        if (props.onDebug !== undefined) this.onDebug = props.onDebug;
    }
    async startJob(name, onMessage = (job, type, data)=>job.done(data), onError = (job, error)=>job.error(error)) {
        // Promise resolves when thread starts working on this job
        const startPromise = new Promise((onStart)=>{
            // Promise resolves when thread completes or fails working on this job
            this.jobQueue.push({
                name,
                onMessage,
                onError,
                onStart
            });
            return this;
        });
        this._startQueuedJob(); // eslint-disable-line @typescript-eslint/no-floating-promises
        return await startPromise;
    }
    // PRIVATE
    /**
     * Starts first queued job if worker is available or can be created
     * Called when job is started and whenever a worker returns to the idleQueue
     */ async _startQueuedJob() {
        if (!this.jobQueue.length) return;
        const workerThread = this._getAvailableWorker();
        if (!workerThread) return;
        // We have a worker, dequeue and start the job
        const queuedJob = this.jobQueue.shift();
        if (queuedJob) {
            // Emit a debug event
            // @ts-ignore
            this.onDebug({
                message: 'Starting job',
                name: queuedJob.name,
                workerThread,
                backlog: this.jobQueue.length
            });
            // Create a worker job to let the app access thread and manage job completion
            const job = new (0, _workerJobJsDefault.default)(queuedJob.name, workerThread);
            // Set the worker thread's message handlers
            workerThread.onMessage = (data)=>queuedJob.onMessage(job, data.type, data.payload);
            workerThread.onError = (error)=>queuedJob.onError(job, error);
            // Resolve the start promise so that the app can start sending messages to worker
            queuedJob.onStart(job);
            // Wait for the app to signal that the job is complete, then return worker to queue
            try {
                await job.result;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Worker exception: ${error}`);
            } finally{
                this.returnWorkerToQueue(workerThread);
            }
        }
    }
    /**
     * Returns a worker to the idle queue
     * Destroys the worker if
     *  - pool is destroyed
     *  - if this pool doesn't reuse workers
     *  - if maxConcurrency has been lowered
     * @param worker
     */ returnWorkerToQueue(worker) {
        const shouldDestroyWorker = // Workers on Node.js prevent the process from exiting.
        // Until we figure out how to close them before exit, we always destroy them
        !(0, _globalsJs.isBrowser) || // If the pool is destroyed, there is no reason to keep the worker around
        this.isDestroyed || // If the app has disabled worker reuse, any completed workers should be destroyed
        !this.reuseWorkers || // If concurrency has been lowered, this worker might be surplus to requirements
        this.count > this._getMaxConcurrency();
        if (shouldDestroyWorker) {
            worker.destroy();
            this.count--;
        } else this.idleQueue.push(worker);
        if (!this.isDestroyed) this._startQueuedJob(); // eslint-disable-line @typescript-eslint/no-floating-promises
    }
    /**
     * Returns idle worker or creates new worker if maxConcurrency has not been reached
     */ _getAvailableWorker() {
        // If a worker has completed and returned to the queue, it can be used
        if (this.idleQueue.length > 0) return this.idleQueue.shift() || null;
        // Create fresh worker if we haven't yet created the max amount of worker threads for this worker source
        if (this.count < this._getMaxConcurrency()) {
            this.count++;
            const name = `${this.name.toLowerCase()} (#${this.count} of ${this.maxConcurrency})`;
            return new (0, _workerThreadJsDefault.default)({
                name,
                source: this.source,
                url: this.url
            });
        }
        // No worker available, have to wait
        return null;
    }
    _getMaxConcurrency() {
        return (0, _globalsJs.isMobile) ? this.maxMobileConcurrency : this.maxConcurrency;
    }
}
exports.default = WorkerPool;

},{"../env-utils/globals.js":"6J3TE","./worker-thread.js":"crLkY","./worker-job.js":"93IHG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fnVxb":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets worker object's name (for debugging in Chrome thread inspector window)
 */ parcelHelpers.export(exports, "getWorkerName", ()=>getWorkerName);
/**
 * Generate a worker URL based on worker object and options
 * @returns A URL to one of the following:
 * - a published worker on unpkg CDN
 * - a local test worker
 * - a URL provided by the user in options
 */ parcelHelpers.export(exports, "getWorkerURL", ()=>getWorkerURL);
var _assertJs = require("../env-utils/assert.js");
var _globalsJs = require("../env-utils/globals.js");
var _versionJs = require("../env-utils/version.js");
function getWorkerName(worker) {
    const warning = worker.version !== (0, _versionJs.VERSION) ? ` (worker-utils@${0, _versionJs.VERSION})` : '';
    return `${worker.name}@${worker.version}${warning}`;
}
function getWorkerURL(worker, options = {}) {
    const workerOptions = options[worker.id] || {};
    const workerFile = (0, _globalsJs.isBrowser) ? `${worker.id}-worker.js` : `${worker.id}-worker-node.js`;
    let url = workerOptions.workerUrl;
    // HACK: Allow for non-nested workerUrl for the CompressionWorker.
    // For the compression worker, workerOptions is currently not nested correctly. For most loaders,
    // you'd have options within an object, i.e. `{mvt: {coordinates: ...}}` but the CompressionWorker
    // puts options at the top level, not within a `compression` key (its `id`). For this reason, the
    // above `workerOptions` will always be a string (i.e. `'gzip'`) for the CompressionWorker. To not
    // break backwards compatibility, we allow the CompressionWorker to have options at the top level.
    if (!url && worker.id === 'compression') url = options.workerUrl;
    // If URL is test, generate local loaders.gl url
    // @ts-ignore _workerType
    if (options._workerType === 'test') {
        if (0, _globalsJs.isBrowser) url = `modules/${worker.module}/dist/${workerFile}`;
        else // In the test environment the ts-node loader requires TypeScript code
        url = `modules/${worker.module}/src/workers/${worker.id}-worker-node.ts`;
    }
    // If url override is not provided, generate a URL to published version on npm CDN unpkg.com
    if (!url) {
        // GENERATE
        let version = worker.version;
        // On master we need to load npm alpha releases published with the `beta` tag
        if (version === 'latest') // throw new Error('latest worker version specified');
        version = (0, _versionJs.NPM_TAG);
        const versionTag = version ? `@${version}` : '';
        url = `https://unpkg.com/@loaders.gl/${worker.module}${versionTag}/dist/${workerFile}`;
    }
    (0, _assertJs.assert)(url);
    // Allow user to override location
    return url;
}

},{"../env-utils/assert.js":"8dZa5","../env-utils/globals.js":"6J3TE","../env-utils/version.js":"8ob32","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"d7qkn":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Check if worker is compatible with this library version
 * @param worker
 * @param libVersion
 * @returns `true` if the two versions are compatible
 */ parcelHelpers.export(exports, "validateWorkerVersion", ()=>validateWorkerVersion);
var _assertJs = require("../env-utils/assert.js");
var _versionJs = require("../env-utils/version.js");
function validateWorkerVersion(worker, coreVersion = (0, _versionJs.VERSION)) {
    (0, _assertJs.assert)(worker, 'no worker provided');
    const workerVersion = worker.version;
    if (!coreVersion || !workerVersion) return false;
    // TODO enable when fix the __version__ injection
    // const coreVersions = parseVersion(coreVersion);
    // const workerVersions = parseVersion(workerVersion);
    // assert(
    //   coreVersion.major === workerVersion.major && coreVersion.minor <= workerVersion.minor,
    //   `worker: ${worker.name} is not compatible. ${coreVersion.major}.${
    //     coreVersion.minor
    //   }+ is required.`
    // );
    return true;
}
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function parseVersion(version) {
    const parts = version.split('.').map(Number);
    return {
        major: parts[0],
        minor: parts[1]
    };
}

},{"../env-utils/assert.js":"8dZa5","../env-utils/version.js":"8ob32","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6Xs03":[function(require,module,exports,__globalThis) {
/**
 * compare two binary arrays for equality
 * @param a
 * @param b
 * @param byteLength
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareArrayBuffers", ()=>compareArrayBuffers);
/**
 * Concatenate a sequence of ArrayBuffers from arguments
 * @return A concatenated ArrayBuffer
 */ parcelHelpers.export(exports, "concatenateArrayBuffers", ()=>concatenateArrayBuffers);
/**
 * Concatenate a sequence of ArrayBuffers from array
 * @return A concatenated ArrayBuffer
 */ parcelHelpers.export(exports, "concatenateArrayBuffersFromArray", ()=>concatenateArrayBuffersFromArray);
/**
 * Concatenate arbitrary count of typed arrays
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Typed_arrays
 * @param - list of arrays. All arrays should be the same type
 * @return A concatenated TypedArray
 */ parcelHelpers.export(exports, "concatenateTypedArrays", ()=>concatenateTypedArrays);
/**
 * Copy a view of an ArrayBuffer into new ArrayBuffer with byteOffset = 0
 * @param arrayBuffer
 * @param byteOffset
 * @param byteLength
 */ parcelHelpers.export(exports, "sliceArrayBuffer", ()=>sliceArrayBuffer);
function compareArrayBuffers(arrayBuffer1, arrayBuffer2, byteLength) {
    byteLength = byteLength || arrayBuffer1.byteLength;
    if (arrayBuffer1.byteLength < byteLength || arrayBuffer2.byteLength < byteLength) return false;
    const array1 = new Uint8Array(arrayBuffer1);
    const array2 = new Uint8Array(arrayBuffer2);
    for(let i = 0; i < array1.length; ++i){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
function concatenateArrayBuffers(...sources) {
    return concatenateArrayBuffersFromArray(sources);
}
function concatenateArrayBuffersFromArray(sources) {
    // Make sure all inputs are wrapped in typed arrays
    const sourceArrays = sources.map((source2)=>source2 instanceof ArrayBuffer ? new Uint8Array(source2) : source2);
    // Get length of all inputs
    const byteLength = sourceArrays.reduce((length, typedArray)=>length + typedArray.byteLength, 0);
    // Allocate array with space for all inputs
    const result = new Uint8Array(byteLength);
    // Copy the subarrays
    let offset = 0;
    for (const sourceArray of sourceArrays){
        result.set(sourceArray, offset);
        offset += sourceArray.byteLength;
    }
    // We work with ArrayBuffers, discard the typed array wrapper
    return result.buffer;
}
function concatenateTypedArrays(...typedArrays) {
    // @ts-ignore
    const arrays = typedArrays;
    // @ts-ignore
    const TypedArrayConstructor = arrays && arrays.length > 1 && arrays[0].constructor || null;
    if (!TypedArrayConstructor) throw new Error('"concatenateTypedArrays" - incorrect quantity of arguments or arguments have incompatible data types');
    const sumLength = arrays.reduce((acc, value)=>acc + value.length, 0);
    // @ts-ignore typescript does not like dynamic constructors
    const result = new TypedArrayConstructor(sumLength);
    let offset = 0;
    for (const array of arrays){
        result.set(array, offset);
        offset += array.length;
    }
    return result;
}
function sliceArrayBuffer(arrayBuffer, byteOffset, byteLength) {
    const subArray = byteLength !== undefined ? new Uint8Array(arrayBuffer).subarray(byteOffset, byteOffset + byteLength) : new Uint8Array(arrayBuffer).subarray(byteOffset);
    const arrayCopy = new Uint8Array(subArray);
    return arrayCopy.buffer;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"036iC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERAL UTILITIES
/**
 * Iterate over async iterator, without resetting iterator if end is not reached
 * - forEach intentionally does not reset iterator if exiting loop prematurely
 *   so that iteration can continue in a second loop
 * - It is recommended to use a standard for-await as last loop to ensure
 *   iterator gets properly reset
 *
 * TODO - optimize using sync iteration if argument is an Iterable?
 *
 * @param iterator
 * @param visitor
 */ parcelHelpers.export(exports, "forEach", ()=>forEach);
// Breaking big data into iterable chunks, concatenating iterable chunks into big data objects
/**
 * Concatenates all data chunks yielded by an (async) iterator
 * This function can e.g. be used to enable atomic parsers to work on (async) iterator inputs
 */ parcelHelpers.export(exports, "concatenateArrayBuffersAsync", ()=>concatenateArrayBuffersAsync);
parcelHelpers.export(exports, "concatenateStringsAsync", ()=>concatenateStringsAsync);
var _arrayBufferUtilsJs = require("../binary-utils/array-buffer-utils.js");
async function forEach(iterator, visitor) {
    // eslint-disable-next-line
    while(true){
        const { done, value } = await iterator.next();
        if (done) {
            iterator.return();
            return;
        }
        const cancel = visitor(value);
        if (cancel) return;
    }
}
async function concatenateArrayBuffersAsync(asyncIterator) {
    const arrayBuffers = [];
    for await (const chunk of asyncIterator)arrayBuffers.push(chunk);
    return (0, _arrayBufferUtilsJs.concatenateArrayBuffers)(...arrayBuffers);
}
async function concatenateStringsAsync(asyncIterator) {
    const strings = [];
    for await (const chunk of asyncIterator)strings.push(chunk);
    return strings.join('');
}

},{"../binary-utils/array-buffer-utils.js":"6Xs03","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dVB55":[function(require,module,exports,__globalThis) {
// Simple file alias mechanisms for tests.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Set a relative path prefix
 */ parcelHelpers.export(exports, "setPathPrefix", ()=>setPathPrefix);
/*
 * Get the relative path prefix
 */ parcelHelpers.export(exports, "getPathPrefix", ()=>getPathPrefix);
/**
 *
 * @param aliases
 *
 * Note: addAliases are an experimental export, they are only for testing of loaders.gl loaders
 * not intended as a generic aliasing mechanism
 */ parcelHelpers.export(exports, "addAliases", ()=>addAliases);
/**
 * Resolves aliases and adds path-prefix to paths
 */ parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
let pathPrefix = '';
const fileAliases = {};
function setPathPrefix(prefix) {
    pathPrefix = prefix;
}
function getPathPrefix() {
    return pathPrefix;
}
function addAliases(aliases) {
    Object.assign(fileAliases, aliases);
}
function resolvePath(filename) {
    for(const alias in fileAliases)if (filename.startsWith(alias)) {
        const replacement = fileAliases[alias];
        filename = filename.replace(alias, replacement);
    }
    if (!filename.startsWith('http://') && !filename.startsWith('https://')) filename = `${pathPrefix}${filename}`;
    return filename;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jRpLl":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Check for Node.js `Buffer` (without triggering bundler to include Buffer polyfill on browser)
 */ parcelHelpers.export(exports, "isBuffer", ()=>isBuffer);
/**
 * Converts to Node.js `Buffer` (without triggering bundler to include Buffer polyfill on browser)
 * @todo better data type
 */ parcelHelpers.export(exports, "toBuffer", ()=>toBuffer);
/**
 * Convert an object to an array buffer
 */ parcelHelpers.export(exports, "toArrayBuffer", ()=>toArrayBuffer);
var _bufferJs = require("../node/buffer.js");
function isBuffer(value) {
    return value && typeof value === 'object' && value.isBuffer;
}
function toBuffer(data) {
    return _bufferJs.toBuffer ? _bufferJs.toBuffer(data) : data;
}
function toArrayBuffer(data) {
    // Note: Should be called first, Buffers can trigger other detections below
    if (isBuffer(data)) return _bufferJs.toArrayBuffer(data);
    if (data instanceof ArrayBuffer) return data;
    // Careful - Node Buffers look like Uint8Arrays (keep after isBuffer)
    if (ArrayBuffer.isView(data)) {
        if (data.byteOffset === 0 && data.byteLength === data.buffer.byteLength) return data.buffer;
        return data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength);
    }
    if (typeof data === 'string') {
        const text = data;
        const uint8Array = new TextEncoder().encode(text);
        return uint8Array.buffer;
    }
    // HACK to support Blob polyfill
    if (data && typeof data === 'object' && data._toArrayBuffer) return data._toArrayBuffer();
    throw new Error('toArrayBuffer');
}

},{"../node/buffer.js":"lwgiE","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lwgiE":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Isolates Buffer references to ensure they are only bundled under Node.js (avoids big webpack polyfill)
// this file is selected by the package.json "browser" field).
/**
 * Convert Buffer to ArrayBuffer
 * Converts Node.js `Buffer` to `ArrayBuffer` (without triggering bundler to include Buffer polyfill on browser)
 * @todo better data type
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArrayBuffer", ()=>toArrayBuffer);
/**
 * Convert (copy) ArrayBuffer to Buffer
 */ parcelHelpers.export(exports, "toBuffer", ()=>toBuffer);
function toArrayBuffer(buffer) {
    return buffer;
}
function toBuffer(binaryData) {
    throw new Error('Buffer not supported in browser');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bcLKE":[function(require,module,exports,__globalThis) {
// Beginning of a minimal implementation of the Node.js path API, that doesn't pull in big polyfills.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Replacement for Node.js path.filename
 * @param url
 */ parcelHelpers.export(exports, "filename", ()=>filename);
/**
 * Replacement for Node.js path.dirname
 * @param url
 */ parcelHelpers.export(exports, "dirname", ()=>dirname);
/**
 * Replacement for Node.js path.join
 * @param parts
 */ parcelHelpers.export(exports, "join", ()=>join);
/* eslint-disable no-continue */ /**
 * https://nodejs.org/api/path.html#path_path_resolve_paths
 * @param paths A sequence of paths or path segments.
 * @return resolved path
 * Forked from BTOdell/path-resolve under MIT license
 * @see https://github.com/BTOdell/path-resolve/blob/master/LICENSE
 */ parcelHelpers.export(exports, "resolve", ()=>resolve);
var _getCwdJs = require("./get-cwd.js");
function filename(url) {
    const slashIndex = url ? url.lastIndexOf('/') : -1;
    return slashIndex >= 0 ? url.substr(slashIndex + 1) : '';
}
function dirname(url) {
    const slashIndex = url ? url.lastIndexOf('/') : -1;
    return slashIndex >= 0 ? url.substr(0, slashIndex) : '';
}
function join(...parts) {
    const separator = '/';
    parts = parts.map((part, index)=>{
        if (index) part = part.replace(new RegExp(`^${separator}`), '');
        if (index !== parts.length - 1) part = part.replace(new RegExp(`${separator}$`), '');
        return part;
    });
    return parts.join(separator);
}
function resolve(...components) {
    const paths = [];
    for(let _i = 0; _i < components.length; _i++)paths[_i] = components[_i];
    let resolvedPath = '';
    let resolvedAbsolute = false;
    let cwd;
    for(let i = paths.length - 1; i >= -1 && !resolvedAbsolute; i--){
        let path;
        if (i >= 0) path = paths[i];
        else {
            if (cwd === undefined) cwd = (0, _getCwdJs.getCWD)();
            path = cwd;
        }
        // Skip empty entries
        if (path.length === 0) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charCodeAt(0) === SLASH;
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path (removes leading slash)
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
    if (resolvedAbsolute) return `/${resolvedPath}`;
    else if (resolvedPath.length > 0) return resolvedPath;
    return '.';
}
const SLASH = 47;
const DOT = 46;
/**
 * Resolves . and .. elements in a path with directory names
 * Forked from BTOdell/path-resolve under MIT license
 * @see https://github.com/BTOdell/path-resolve/blob/master/LICENSE
 */ /* eslint-disable max-depth */ // eslint-disable-next-line complexity, max-statements
function normalizeStringPosix(path, allowAboveRoot) {
    let res = '';
    let lastSlash = -1;
    let dots = 0;
    let code;
    let isAboveRoot = false;
    for(let i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === SLASH) break;
        else code = SLASH;
        if (code === SLASH) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || !isAboveRoot || res.charCodeAt(res.length - 1) !== DOT || res.charCodeAt(res.length - 2) !== DOT) {
                    if (res.length > 2) {
                        const start = res.length - 1;
                        let j = start;
                        for(; j >= 0; --j){
                            if (res.charCodeAt(j) === SLASH) break;
                        }
                        if (j !== start) {
                            res = j === -1 ? '' : res.slice(0, j);
                            lastSlash = i;
                            dots = 0;
                            isAboveRoot = false;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSlash = i;
                        dots = 0;
                        isAboveRoot = false;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    isAboveRoot = true;
                }
            } else {
                const slice = path.slice(lastSlash + 1, i);
                if (res.length > 0) res += `/${slice}`;
                else res = slice;
                isAboveRoot = false;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === DOT && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}

},{"./get-cwd.js":"h3rr3","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"h3rr3":[function(require,module,exports,__globalThis) {
// loaders.gl MIT license
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCWD", ()=>getCWD);
function getCWD() {
    const pathname = window.location?.pathname;
    return pathname?.slice(0, pathname.lastIndexOf('/') + 1) || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1lJGj":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a Response object
 * Adds content-length header when possible
 *
 * @param resource
 */ parcelHelpers.export(exports, "makeResponse", ()=>makeResponse);
/**
 * Checks response status (async) and throws a helpful error message if status is not OK.
 * @param response
 */ parcelHelpers.export(exports, "checkResponse", ()=>checkResponse);
/**
 * Checks response status (sync) and throws a helpful error message if status is not OK.
 * @param response
 */ parcelHelpers.export(exports, "checkResponseSync", ()=>checkResponseSync);
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _fetchErrorJs = require("../fetch/fetch-error.js");
var _resourceUtilsJs = require("./resource-utils.js");
var _urlUtilsJs = require("./url-utils.js");
async function makeResponse(resource) {
    if ((0, _isTypeJs.isResponse)(resource)) return resource;
    // Add content-length header if possible
    const headers = {};
    const contentLength = (0, _resourceUtilsJs.getResourceContentLength)(resource);
    if (contentLength >= 0) headers['content-length'] = String(contentLength);
    // `new Response(File)` does not preserve content-type and URL
    // so we add them here
    const url = (0, _resourceUtilsJs.getResourceUrl)(resource);
    const type = (0, _resourceUtilsJs.getResourceMIMEType)(resource);
    if (type) headers['content-type'] = type;
    // Add a custom header with initial bytes if available
    const initialDataUrl = await getInitialDataUrl(resource);
    if (initialDataUrl) headers['x-first-bytes'] = initialDataUrl;
    // TODO - is this the best way of handling strings?
    // Maybe package as data URL instead?
    if (typeof resource === 'string') // Convert to ArrayBuffer to avoid Response treating it as a URL
    resource = new TextEncoder().encode(resource);
    // Attempt to create a Response from the resource, adding headers and setting url
    const response = new Response(resource, {
        headers
    });
    // We can't control `Response.url` via constructor, use a property override to record URL.
    Object.defineProperty(response, 'url', {
        value: url
    });
    return response;
}
async function checkResponse(response) {
    if (!response.ok) {
        const error = await getResponseError(response);
        throw error;
    }
}
function checkResponseSync(response) {
    if (!response.ok) {
        let message = `${response.status} ${response.statusText}`;
        message = message.length > 60 ? `${message.slice(0, 60)}...` : message;
        throw new Error(message);
    }
}
// HELPERS
async function getResponseError(response) {
    const shortUrl = (0, _urlUtilsJs.shortenUrlForDisplay)(response.url);
    let message = `Failed to fetch resource (${response.status}) ${response.statusText}: ${shortUrl}`;
    message = message.length > 100 ? `${message.slice(0, 100)}...` : message;
    const info = {
        reason: response.statusText,
        url: response.url,
        response
    };
    // See if we got an error message in the body
    try {
        const contentType = response.headers.get('Content-Type');
        info.reason = !response.bodyUsed && contentType?.includes('application/json') ? await response.json() : await response.text();
    } catch (error) {
    // eslint forbids return in a finally statement, so we just catch here
    }
    return new (0, _fetchErrorJs.FetchError)(message, info);
}
async function getInitialDataUrl(resource) {
    const INITIAL_DATA_LENGTH = 5;
    if (typeof resource === 'string') return `data:,${resource.slice(0, INITIAL_DATA_LENGTH)}`;
    if (resource instanceof Blob) {
        const blobSlice = resource.slice(0, 5);
        return await new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onload = (event)=>resolve(event?.target?.result);
            reader.readAsDataURL(blobSlice);
        });
    }
    if (resource instanceof ArrayBuffer) {
        const slice = resource.slice(0, INITIAL_DATA_LENGTH);
        const base64 = arrayBufferToBase64(slice);
        return `data:base64,${base64}`;
    }
    return null;
}
// https://stackoverflow.com/questions/9267899/arraybuffer-to-base64-encoded-string
function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for(let i = 0; i < bytes.byteLength; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
}

},{"../../javascript-utils/is-type.js":"f69p0","../fetch/fetch-error.js":"dDIly","./resource-utils.js":"bS5F0","./url-utils.js":"7TG35","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"f69p0":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isPureObject", ()=>isPureObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
parcelHelpers.export(exports, "isAsyncIterable", ()=>isAsyncIterable);
parcelHelpers.export(exports, "isIterator", ()=>isIterator);
parcelHelpers.export(exports, "isResponse", ()=>isResponse);
parcelHelpers.export(exports, "isFile", ()=>isFile);
parcelHelpers.export(exports, "isBlob", ()=>isBlob);
parcelHelpers.export(exports, "isBuffer", ()=>isBuffer);
parcelHelpers.export(exports, "isWritableDOMStream", ()=>isWritableDOMStream);
parcelHelpers.export(exports, "isReadableDOMStream", ()=>isReadableDOMStream);
parcelHelpers.export(exports, "isWritableNodeStream", ()=>isWritableNodeStream);
parcelHelpers.export(exports, "isReadableNodeStream", ()=>isReadableNodeStream);
parcelHelpers.export(exports, "isReadableStream", ()=>isReadableStream);
parcelHelpers.export(exports, "isWritableStream", ()=>isWritableStream);
const isBoolean = (x)=>typeof x === 'boolean';
const isFunction = (x)=>typeof x === 'function';
const isObject = (x)=>x !== null && typeof x === 'object';
const isPureObject = (x)=>isObject(x) && x.constructor === ({}).constructor;
const isPromise = (x)=>isObject(x) && isFunction(x.then);
const isIterable = (x)=>Boolean(x) && typeof x[Symbol.iterator] === 'function';
const isAsyncIterable = (x)=>x && typeof x[Symbol.asyncIterator] === 'function';
const isIterator = (x)=>x && isFunction(x.next);
const isResponse = (x)=>typeof Response !== 'undefined' && x instanceof Response || x && x.arrayBuffer && x.text && x.json;
const isFile = (x)=>typeof File !== 'undefined' && x instanceof File;
const isBlob = (x)=>typeof Blob !== 'undefined' && x instanceof Blob;
const isBuffer = (x)=>x && typeof x === 'object' && x.isBuffer;
const isWritableDOMStream = (x)=>isObject(x) && isFunction(x.abort) && isFunction(x.getWriter);
const isReadableDOMStream = (x)=>typeof ReadableStream !== 'undefined' && x instanceof ReadableStream || isObject(x) && isFunction(x.tee) && isFunction(x.cancel) && isFunction(x.getReader);
const isWritableNodeStream = (x)=>isObject(x) && isFunction(x.end) && isFunction(x.write) && isBoolean(x.writable);
const isReadableNodeStream = (x)=>isObject(x) && isFunction(x.read) && isFunction(x.pipe) && isBoolean(x.readable);
const isReadableStream = (x)=>isReadableDOMStream(x) || isReadableNodeStream(x);
const isWritableStream = (x)=>isWritableDOMStream(x) || isWritableNodeStream(x);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dDIly":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchError", ()=>FetchError);
class FetchError extends Error {
    constructor(message, info){
        super(message);
        this.reason = info.reason;
        this.url = info.url;
        this.response = info.response;
    }
    /** A best effort reason for why the fetch failed */ reason;
    /** The URL that failed to load. Empty string if not available. */ url;
    /** The Response object, if any. */ response;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bS5F0":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the URL associated with this resource.
 * The returned value may include a query string and need further processing.
 * If it cannot determine url, the corresponding value will be an empty string
 *
 * @todo string parameters are assumed to be URLs
 */ parcelHelpers.export(exports, "getResourceUrl", ()=>getResourceUrl);
/**
 * Returns the URL associated with this resource.
 * The returned value may include a query string and need further processing.
 * If it cannot determine url, the corresponding value will be an empty string
 *
 * @todo string parameters are assumed to be URLs
 */ parcelHelpers.export(exports, "getResourceMIMEType", ()=>getResourceMIMEType);
/**
  * Returns (approximate) content length for a resource if it can be determined.
  * Returns -1 if content length cannot be determined.
  * @param resource

  * @note string parameters are NOT assumed to be URLs
  */ parcelHelpers.export(exports, "getResourceContentLength", ()=>getResourceContentLength);
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _mimeTypeUtilsJs = require("./mime-type-utils.js");
var _urlUtilsJs = require("./url-utils.js");
function getResourceUrl(resource) {
    // If resource is a `Response`, it contains the information directly as a field
    if ((0, _isTypeJs.isResponse)(resource)) {
        const response = resource;
        return response.url;
    }
    // If the resource is a Blob or a File (subclass of Blob)
    if ((0, _isTypeJs.isBlob)(resource)) {
        const blob = resource;
        // File objects have a "name" property. Blob objects don't have any
        // url (name) information
        return blob.name || '';
    }
    if (typeof resource === 'string') return resource;
    // Unknown
    return '';
}
function getResourceMIMEType(resource) {
    // If resource is a response, it contains the information directly
    if ((0, _isTypeJs.isResponse)(resource)) {
        const response = resource;
        const contentTypeHeader = response.headers.get('content-type') || '';
        const noQueryUrl = (0, _urlUtilsJs.stripQueryString)(response.url);
        return (0, _mimeTypeUtilsJs.parseMIMEType)(contentTypeHeader) || (0, _mimeTypeUtilsJs.parseMIMETypeFromURL)(noQueryUrl);
    }
    // If the resource is a Blob or a File (subclass of Blob)
    if ((0, _isTypeJs.isBlob)(resource)) {
        const blob = resource;
        return blob.type || '';
    }
    if (typeof resource === 'string') return (0, _mimeTypeUtilsJs.parseMIMETypeFromURL)(resource);
    // Unknown
    return '';
}
function getResourceContentLength(resource) {
    if ((0, _isTypeJs.isResponse)(resource)) {
        const response = resource;
        return response.headers['content-length'] || -1;
    }
    if ((0, _isTypeJs.isBlob)(resource)) {
        const blob = resource;
        return blob.size;
    }
    if (typeof resource === 'string') // TODO - handle data URL?
    return resource.length;
    if (resource instanceof ArrayBuffer) return resource.byteLength;
    if (ArrayBuffer.isView(resource)) return resource.byteLength;
    return -1;
}

},{"../../javascript-utils/is-type.js":"f69p0","./mime-type-utils.js":"bqJn2","./url-utils.js":"7TG35","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bqJn2":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// TODO - build/integrate proper MIME type parsing
// https://mimesniff.spec.whatwg.org/
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Compare two MIME types, case insensitively etc.
 * @param mimeType1
 * @param mimeType2
 * @returns true if the MIME types are equivalent
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#structure_of_a_mime_type
 */ parcelHelpers.export(exports, "compareMIMETypes", ()=>compareMIMETypes);
/**
 * Remove extra data like `charset` from MIME types
 * @param mimeString
 * @returns A clean MIME type, or an empty string
 *
 * @todo - handle more advanced MIMETYpes, multiple types
 * @todo - extract charset etc
 */ parcelHelpers.export(exports, "parseMIMEType", ()=>parseMIMEType);
/**
 * Extract MIME type from data URL
 *
 * @param mimeString
 * @returns A clean MIME type, or an empty string
 *
 * @todo - handle more advanced MIMETYpes, multiple types
 * @todo - extract charset etc
 */ parcelHelpers.export(exports, "parseMIMETypeFromURL", ()=>parseMIMETypeFromURL);
const DATA_URL_PATTERN = /^data:([-\w.]+\/[-\w.+]+)(;|,)/;
const MIME_TYPE_PATTERN = /^([-\w.]+\/[-\w.+]+)/;
function compareMIMETypes(mimeType1, mimeType2) {
    if (mimeType1.toLowerCase() === mimeType2.toLowerCase()) return true;
    return false;
}
function parseMIMEType(mimeString) {
    // If resource is a data url, extract any embedded mime type
    const matches = MIME_TYPE_PATTERN.exec(mimeString);
    if (matches) return matches[1];
    return mimeString;
}
function parseMIMETypeFromURL(url) {
    // If resource is a data URL, extract any embedded mime type
    const matches = DATA_URL_PATTERN.exec(url);
    if (matches) return matches[1];
    return '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7TG35":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractQueryString", ()=>extractQueryString);
parcelHelpers.export(exports, "stripQueryString", ()=>stripQueryString);
parcelHelpers.export(exports, "shortenUrlForDisplay", ()=>shortenUrlForDisplay);
const QUERY_STRING_PATTERN = /\?.*/;
function extractQueryString(url) {
    const matches = url.match(QUERY_STRING_PATTERN);
    return matches && matches[0];
}
function stripQueryString(url) {
    return url.replace(QUERY_STRING_PATTERN, '');
}
function shortenUrlForDisplay(url) {
    if (url.length < 50) return url;
    const urlEnd = url.slice(url.length - 15);
    const urlStart = url.substr(0, 32);
    return `${urlStart}...${urlEnd}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iUBbO":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Register a list of global loaders
 * @note Registration erases loader type information.
 * @deprecated It is recommended that applications manage loader registration. This function will likely be remove in loaders.gl v5
 */ parcelHelpers.export(exports, "registerLoaders", ()=>registerLoaders);
/**
 * @deprecated It is recommended that applications manage loader registration. This function will likely be remove in loaders.gl v5
 */ parcelHelpers.export(exports, "getRegisteredLoaders", ()=>getRegisteredLoaders);
/** @deprecated For testing only  */ parcelHelpers.export(exports, "_unregisterLoaders", ()=>_unregisterLoaders);
var _normalizeLoaderJs = require("../loader-utils/normalize-loader.js");
var _optionUtilsJs = require("../loader-utils/option-utils.js");
/**
 * Store global registered loaders on the global object to increase chances of cross loaders-version interoperability
 * This use case is not reliable but can help when testing new versions of loaders.gl with existing frameworks
 */ const getGlobalLoaderRegistry = ()=>{
    const state = (0, _optionUtilsJs.getGlobalLoaderState)();
    state.loaderRegistry = state.loaderRegistry || [];
    return state.loaderRegistry;
};
function registerLoaders(loaders) {
    const loaderRegistry = getGlobalLoaderRegistry();
    loaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    for (const loader of loaders){
        const normalizedLoader = (0, _normalizeLoaderJs.normalizeLoader)(loader);
        if (!loaderRegistry.find((registeredLoader)=>normalizedLoader === registeredLoader)) // add to the beginning of the loaderRegistry, so the last registeredLoader get picked
        loaderRegistry.unshift(normalizedLoader);
    }
}
function getRegisteredLoaders() {
    return getGlobalLoaderRegistry();
}
function _unregisterLoaders() {
    const state = (0, _optionUtilsJs.getGlobalLoaderState)();
    state.loaderRegistry = [];
}

},{"../loader-utils/normalize-loader.js":"dpeMM","../loader-utils/option-utils.js":"jlnKJ","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dpeMM":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLoaderObject", ()=>isLoaderObject);
parcelHelpers.export(exports, "normalizeLoader", ()=>normalizeLoader);
var _loaderUtils = require("@loaders.gl/loader-utils");
function isLoaderObject(loader) {
    if (!loader) return false;
    if (Array.isArray(loader)) loader = loader[0];
    const hasExtensions = Array.isArray(loader?.extensions);
    /* Now handled by types and worker loaders do not have these
    let hasParser =
      loader.parseTextSync ||
      loader.parseSync ||
      loader.parse ||
      loader.parseStream || // TODO Remove, Replace with parseInBatches
      loader.parseInBatches;
    */ return hasExtensions;
}
function normalizeLoader(loader) {
    // This error is fairly easy to trigger by mixing up import statements etc
    // So we make an exception and add a developer error message for this case
    // To help new users from getting stuck here
    (0, _loaderUtils.assert)(loader, 'null loader');
    (0, _loaderUtils.assert)(isLoaderObject(loader), 'invalid loader');
    // NORMALIZE [LOADER, OPTIONS] => LOADER
    // If [loader, options], create a new loaders object with options merged in
    let options;
    if (Array.isArray(loader)) {
        options = loader[1];
        loader = loader[0];
        loader = {
            ...loader,
            options: {
                ...loader.options,
                ...options
            }
        };
    }
    // NORMALIZE text and binary flags
    // Ensure at least one of text/binary flags are properly set
    // @ts-expect-error
    if (loader?.parseTextSync || loader?.parseText) loader.text = true;
    if (!loader.text) loader.binary = true;
    return loader;
}

},{"@loaders.gl/loader-utils":"5BWS4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jlnKJ":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Helper for safely accessing global loaders.gl variables
 * Wraps initialization of global variable in function to defeat overly aggressive tree-shakers
 */ parcelHelpers.export(exports, "getGlobalLoaderState", ()=>getGlobalLoaderState);
/**
 * Store global loader options on the global object to increase chances of cross loaders-version interoperability
 * NOTE: This use case is not reliable but can help when testing new versions of loaders.gl with existing frameworks
 * @returns global loader options merged with default loader options
 */ parcelHelpers.export(exports, "getGlobalLoaderOptions", ()=>getGlobalLoaderOptions);
/**
 * Set global loader options
 * @param options
 */ parcelHelpers.export(exports, "setGlobalOptions", ()=>setGlobalOptions);
/**
 * Merges options with global opts and loader defaults, also injects baseUri
 * @param options
 * @param loader
 * @param loaders
 * @param url
 */ parcelHelpers.export(exports, "normalizeOptions", ()=>normalizeOptions);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _loggersJs = require("./loggers.js");
var _optionDefaultsJs = require("./option-defaults.js");
function getGlobalLoaderState() {
    // @ts-ignore
    globalThis.loaders = globalThis.loaders || {};
    // @ts-ignore
    const { loaders } = globalThis;
    // Add _state object to keep separate from modules added to globalThis.loaders
    if (!loaders._state) loaders._state = {};
    return loaders._state;
}
function getGlobalLoaderOptions() {
    const state = getGlobalLoaderState();
    // Ensure all default loader options from this library are mentioned
    state.globalOptions = state.globalOptions || {
        ...(0, _optionDefaultsJs.DEFAULT_LOADER_OPTIONS)
    };
    return state.globalOptions;
}
function setGlobalOptions(options) {
    const state = getGlobalLoaderState();
    const globalOptions = getGlobalLoaderOptions();
    // @ts-expect-error First param looks incorrect
    state.globalOptions = normalizeOptionsInternal(globalOptions, options);
    // Make sure any new modules are registered
    (0, _loaderUtils.registerJSModules)(options.modules);
}
function normalizeOptions(options, loader, loaders, url) {
    loaders = loaders || [];
    loaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    validateOptions(options, loaders);
    return normalizeOptionsInternal(loader, options, url);
}
// VALIDATE OPTIONS
/**
 * Warn for unsupported options
 * @param options
 * @param loaders
 */ function validateOptions(options, loaders) {
    // Check top level options
    validateOptionsObject(options, null, (0, _optionDefaultsJs.DEFAULT_LOADER_OPTIONS), (0, _optionDefaultsJs.REMOVED_LOADER_OPTIONS), loaders);
    for (const loader of loaders){
        // Get the scoped, loader specific options from the user supplied options
        const idOptions = options && options[loader.id] || {};
        // Get scoped, loader specific default and deprecated options from the selected loader
        const loaderOptions = loader.options && loader.options[loader.id] || {};
        const deprecatedOptions = loader.deprecatedOptions && loader.deprecatedOptions[loader.id] || {};
        // Validate loader specific options
        // @ts-ignore
        validateOptionsObject(idOptions, loader.id, loaderOptions, deprecatedOptions, loaders);
    }
}
// eslint-disable-next-line max-params, complexity
function validateOptionsObject(options, id, defaultOptions, deprecatedOptions, loaders) {
    const loaderName = id || 'Top level';
    const prefix = id ? `${id}.` : '';
    for(const key in options){
        // If top level option value is an object it could options for a loader, so ignore
        const isSubOptions = !id && (0, _isTypeJs.isObject)(options[key]);
        const isBaseUriOption = key === 'baseUri' && !id;
        const isWorkerUrlOption = key === 'workerUrl' && id;
        // <loader>.workerUrl requires special handling as it is now auto-generated and no longer specified as a default option.
        if (!(key in defaultOptions) && !isBaseUriOption && !isWorkerUrlOption) {
            // Issue deprecation warnings
            if (key in deprecatedOptions) (0, _loggersJs.probeLog).warn(`${loaderName} loader option \'${prefix}${key}\' no longer supported, use \'${deprecatedOptions[key]}\'`)();
            else if (!isSubOptions) {
                const suggestion = findSimilarOption(key, loaders);
                (0, _loggersJs.probeLog).warn(`${loaderName} loader option \'${prefix}${key}\' not recognized. ${suggestion}`)();
            }
        }
    }
}
function findSimilarOption(optionKey, loaders) {
    const lowerCaseOptionKey = optionKey.toLowerCase();
    let bestSuggestion = '';
    for (const loader of loaders)for(const key in loader.options){
        if (optionKey === key) return `Did you mean \'${loader.id}.${key}\'?`;
        const lowerCaseKey = key.toLowerCase();
        const isPartialMatch = lowerCaseOptionKey.startsWith(lowerCaseKey) || lowerCaseKey.startsWith(lowerCaseOptionKey);
        if (isPartialMatch) bestSuggestion = bestSuggestion || `Did you mean \'${loader.id}.${key}\'?`;
    }
    return bestSuggestion;
}
function normalizeOptionsInternal(loader, options, url) {
    const loaderDefaultOptions = loader.options || {};
    const mergedOptions = {
        ...loaderDefaultOptions
    };
    addUrlOptions(mergedOptions, url);
    // LOGGING: options.log can be set to `null` to defeat logging
    if (mergedOptions.log === null) mergedOptions.log = new (0, _loggersJs.NullLog)();
    mergeNestedFields(mergedOptions, getGlobalLoaderOptions());
    mergeNestedFields(mergedOptions, options);
    return mergedOptions;
}
// Merge nested options objects
function mergeNestedFields(mergedOptions, options) {
    for(const key in options)// Check for nested options
    // object in options => either no key in defaultOptions or object in defaultOptions
    if (key in options) {
        const value = options[key];
        if ((0, _isTypeJs.isPureObject)(value) && (0, _isTypeJs.isPureObject)(mergedOptions[key])) mergedOptions[key] = {
            ...mergedOptions[key],
            ...options[key]
        };
        else mergedOptions[key] = options[key];
    }
}
/**
 * Harvest information from the url
 * @deprecated This is mainly there to support a hack in the GLTFLoader
 * TODO - baseUri should be a directory, i.e. remove file component from baseUri
 * TODO - extract extension?
 * TODO - extract query parameters?
 * TODO - should these be injected on context instead of options?
 */ function addUrlOptions(options, url) {
    if (url && !('baseUri' in options)) options.baseUri = url;
}

},{"@loaders.gl/loader-utils":"5BWS4","../../javascript-utils/is-type.js":"f69p0","./loggers.js":"fi2pB","./option-defaults.js":"j4uvy","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fi2pB":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// probe.gl Log compatible loggers
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "probeLog", ()=>probeLog);
// Logs nothing
parcelHelpers.export(exports, "NullLog", ()=>NullLog);
// Logs to console
parcelHelpers.export(exports, "ConsoleLog", ()=>ConsoleLog);
var _log = require("@probe.gl/log");
const probeLog = new (0, _log.Log)({
    id: 'loaders.gl'
});
class NullLog {
    log() {
        return ()=>{};
    }
    info() {
        return ()=>{};
    }
    warn() {
        return ()=>{};
    }
    error() {
        return ()=>{};
    }
}
class ConsoleLog {
    console;
    constructor(){
        this.console = console; // eslint-disable-line
    }
    log(...args) {
        return this.console.log.bind(this.console, ...args);
    }
    info(...args) {
        return this.console.info.bind(this.console, ...args);
    }
    warn(...args) {
        return this.console.warn.bind(this.console, ...args);
    }
    error(...args) {
        return this.console.error.bind(this.console, ...args);
    }
}

},{"@probe.gl/log":"fwng6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"j4uvy":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOADER_OPTIONS", ()=>DEFAULT_LOADER_OPTIONS);
parcelHelpers.export(exports, "REMOVED_LOADER_OPTIONS", ()=>REMOVED_LOADER_OPTIONS);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _loggersJs = require("./loggers.js");
const DEFAULT_LOADER_OPTIONS = {
    // baseUri
    fetch: null,
    mimeType: undefined,
    nothrow: false,
    log: new (0, _loggersJs.ConsoleLog)(),
    useLocalLibraries: false,
    CDN: 'https://unpkg.com/@loaders.gl',
    worker: true,
    maxConcurrency: 3,
    maxMobileConcurrency: 1,
    reuseWorkers: (0, _loaderUtils.isBrowser),
    _nodeWorkers: false,
    _workerType: '',
    limit: 0,
    _limitMB: 0,
    batchSize: 'auto',
    batchDebounceMs: 0,
    metadata: false,
    transforms: []
};
const REMOVED_LOADER_OPTIONS = {
    throws: 'nothrow',
    dataType: '(no longer used)',
    uri: 'baseUri',
    // Warn if fetch options are used on top-level
    method: 'fetch.method',
    headers: 'fetch.headers',
    body: 'fetch.body',
    mode: 'fetch.mode',
    credentials: 'fetch.credentials',
    cache: 'fetch.cache',
    redirect: 'fetch.redirect',
    referrer: 'fetch.referrer',
    referrerPolicy: 'fetch.referrerPolicy',
    integrity: 'fetch.integrity',
    keepalive: 'fetch.keepalive',
    signal: 'fetch.signal'
};

},{"@loaders.gl/loader-utils":"5BWS4","./loggers.js":"fi2pB","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aRJ2H":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO - Need a variant that peeks at streams for parseInBatches
// TODO - Detect multiple matching loaders? Use heuristics to grade matches?
// TODO - Allow apps to pass context to disambiguate between multiple matches (e.g. multiple .json formats)?
/**
 * Find a loader that matches file extension and/or initial file content
 * Search the loaders array argument for a loader that matches url extension or initial data
 * Returns: a normalized loader
 * @param data data to assist
 * @param loaders
 * @param options
 * @param context used internally, applications should not provide this parameter
 */ parcelHelpers.export(exports, "selectLoader", ()=>selectLoader);
/**
 * Find a loader that matches file extension and/or initial file content
 * Search the loaders array argument for a loader that matches url extension or initial data
 * Returns: a normalized loader
 * @param data data to assist
 * @param loaders
 * @param options
 * @param context used internally, applications should not provide this parameter
 */ parcelHelpers.export(exports, "selectLoaderSync", ()=>selectLoaderSync);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _normalizeLoaderJs = require("../loader-utils/normalize-loader.js");
var _resourceUtilsJs = require("../utils/resource-utils.js");
var _mimeTypeUtilsJs = require("../utils/mime-type-utils.js");
var _registerLoadersJs = require("./register-loaders.js");
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _urlUtilsJs = require("../utils/url-utils.js");
const EXT_PATTERN = /\.([^.]+)$/;
async function selectLoader(data, loaders = [], options, context) {
    if (!validHTTPResponse(data)) return null;
    // First make a sync attempt, disabling exceptions
    let loader = selectLoaderSync(data, loaders, {
        ...options,
        nothrow: true
    }, context);
    if (loader) return loader;
    // For Blobs and Files, try to asynchronously read a small initial slice and test again with that
    // to see if we can detect by initial content
    if ((0, _isTypeJs.isBlob)(data)) {
        data = await data.slice(0, 10).arrayBuffer();
        loader = selectLoaderSync(data, loaders, options, context);
    }
    // no loader available
    if (!loader && !options?.nothrow) throw new Error(getNoValidLoaderMessage(data));
    return loader;
}
function selectLoaderSync(data, loaders = [], options, context) {
    if (!validHTTPResponse(data)) return null;
    // eslint-disable-next-line complexity
    // if only a single loader was provided (not as array), force its use
    // TODO - Should this behavior be kept and documented?
    if (loaders && !Array.isArray(loaders)) // TODO - remove support for legacy loaders
    return (0, _normalizeLoaderJs.normalizeLoader)(loaders);
    // Build list of candidate loaders that will be searched in order for a match
    let candidateLoaders = [];
    // First search supplied loaders
    if (loaders) candidateLoaders = candidateLoaders.concat(loaders);
    // Then fall back to registered loaders
    if (!options?.ignoreRegisteredLoaders) candidateLoaders.push(...(0, _registerLoadersJs.getRegisteredLoaders)());
    // TODO - remove support for legacy loaders
    normalizeLoaders(candidateLoaders);
    const loader = selectLoaderInternal(data, candidateLoaders, options, context);
    // no loader available
    if (!loader && !options?.nothrow) throw new Error(getNoValidLoaderMessage(data));
    return loader;
}
/** Implements loaders selection logic */ // eslint-disable-next-line complexity
function selectLoaderInternal(data, loaders, options, context) {
    const url = (0, _resourceUtilsJs.getResourceUrl)(data);
    const type = (0, _resourceUtilsJs.getResourceMIMEType)(data);
    const testUrl = (0, _urlUtilsJs.stripQueryString)(url) || context?.url;
    let loader = null;
    let reason = '';
    // if options.mimeType is supplied, it takes precedence
    if (options?.mimeType) {
        loader = findLoaderByMIMEType(loaders, options?.mimeType);
        reason = `match forced by supplied MIME type ${options?.mimeType}`;
    }
    // Look up loader by url
    loader = loader || findLoaderByUrl(loaders, testUrl);
    reason = reason || (loader ? `matched url ${testUrl}` : '');
    // Look up loader by mime type
    loader = loader || findLoaderByMIMEType(loaders, type);
    reason = reason || (loader ? `matched MIME type ${type}` : '');
    // Look for loader via initial bytes (Note: not always accessible (e.g. Response, stream, async iterator)
    // @ts-ignore Blob | Response
    loader = loader || findLoaderByInitialBytes(loaders, data);
    // @ts-ignore Blob | Response
    reason = reason || (loader ? `matched initial data ${getFirstCharacters(data)}` : '');
    // Look up loader by fallback mime type
    if (options?.fallbackMimeType) {
        loader = loader || findLoaderByMIMEType(loaders, options?.fallbackMimeType);
        reason = reason || (loader ? `matched fallback MIME type ${type}` : '');
    }
    if (reason) (0, _loaderUtils.log).log(1, `selectLoader selected ${loader?.name}: ${reason}.`);
    return loader;
}
/** Check HTTP Response */ function validHTTPResponse(data) {
    // HANDLE HTTP status
    if (data instanceof Response) {
        // 204 - NO CONTENT. This handles cases where e.g. a tile server responds with 204 for a missing tile
        if (data.status === 204) return false;
    }
    return true;
}
/** Generate a helpful message to help explain why loader selection failed. */ function getNoValidLoaderMessage(data) {
    const url = (0, _resourceUtilsJs.getResourceUrl)(data);
    const type = (0, _resourceUtilsJs.getResourceMIMEType)(data);
    let message = 'No valid loader found (';
    message += url ? `${(0, _loaderUtils.path).filename(url)}, ` : 'no url provided, ';
    message += `MIME type: ${type ? `"${type}"` : 'not provided'}, `;
    // First characters are only accessible when called on data (string or arrayBuffer).
    // @ts-ignore Blob | Response
    const firstCharacters = data ? getFirstCharacters(data) : '';
    message += firstCharacters ? ` first bytes: "${firstCharacters}"` : 'first bytes: not available';
    message += ')';
    return message;
}
function normalizeLoaders(loaders) {
    for (const loader of loaders)(0, _normalizeLoaderJs.normalizeLoader)(loader);
}
// TODO - Would be nice to support http://example.com/file.glb?parameter=1
// E.g: x = new URL('http://example.com/file.glb?load=1'; x.pathname
function findLoaderByUrl(loaders, url) {
    // Get extension
    const match = url && EXT_PATTERN.exec(url);
    const extension = match && match[1];
    return extension ? findLoaderByExtension(loaders, extension) : null;
}
function findLoaderByExtension(loaders, extension) {
    extension = extension.toLowerCase();
    for (const loader of loaders)for (const loaderExtension of loader.extensions){
        if (loaderExtension.toLowerCase() === extension) return loader;
    }
    return null;
}
function findLoaderByMIMEType(loaders, mimeType) {
    for (const loader of loaders){
        if (loader.mimeTypes?.some((mimeType1)=>(0, _mimeTypeUtilsJs.compareMIMETypes)(mimeType, mimeType1))) return loader;
        // Support referring to loaders using the "unregistered tree"
        // https://en.wikipedia.org/wiki/Media_type#Unregistered_tree
        if ((0, _mimeTypeUtilsJs.compareMIMETypes)(mimeType, `application/x.${loader.id}`)) return loader;
    }
    return null;
}
function findLoaderByInitialBytes(loaders, data) {
    if (!data) return null;
    for (const loader of loaders){
        if (typeof data === 'string') {
            if (testDataAgainstText(data, loader)) return loader;
        } else if (ArrayBuffer.isView(data)) {
            // Typed Arrays can have offsets into underlying buffer
            if (testDataAgainstBinary(data.buffer, data.byteOffset, loader)) return loader;
        } else if (data instanceof ArrayBuffer) {
            const byteOffset = 0;
            if (testDataAgainstBinary(data, byteOffset, loader)) return loader;
        }
    // TODO Handle streaming case (requires creating a new AsyncIterator)
    }
    return null;
}
function testDataAgainstText(data, loader) {
    if (loader.testText) return loader.testText(data);
    const tests = Array.isArray(loader.tests) ? loader.tests : [
        loader.tests
    ];
    return tests.some((test)=>data.startsWith(test));
}
function testDataAgainstBinary(data, byteOffset, loader) {
    const tests = Array.isArray(loader.tests) ? loader.tests : [
        loader.tests
    ];
    return tests.some((test)=>testBinary(data, byteOffset, loader, test));
}
function testBinary(data, byteOffset, loader, test) {
    if (test instanceof ArrayBuffer) return (0, _loaderUtils.compareArrayBuffers)(test, data, test.byteLength);
    switch(typeof test){
        case 'function':
            return test(data);
        case 'string':
            // Magic bytes check: If `test` is a string, check if binary data starts with that strings
            const magic = getMagicString(data, byteOffset, test.length);
            return test === magic;
        default:
            return false;
    }
}
function getFirstCharacters(data, length = 5) {
    if (typeof data === 'string') return data.slice(0, length);
    else if (ArrayBuffer.isView(data)) // Typed Arrays can have offsets into underlying buffer
    return getMagicString(data.buffer, data.byteOffset, length);
    else if (data instanceof ArrayBuffer) {
        const byteOffset = 0;
        return getMagicString(data, byteOffset, length);
    }
    return '';
}
function getMagicString(arrayBuffer, byteOffset, length) {
    if (arrayBuffer.byteLength < byteOffset + length) return '';
    const dataView = new DataView(arrayBuffer);
    let magic = '';
    for(let i = 0; i < length; i++)magic += String.fromCharCode(dataView.getUint8(byteOffset + i));
    return magic;
}

},{"@loaders.gl/loader-utils":"5BWS4","../loader-utils/normalize-loader.js":"dpeMM","../utils/resource-utils.js":"bS5F0","../utils/mime-type-utils.js":"bqJn2","./register-loaders.js":"iUBbO","../../javascript-utils/is-type.js":"f69p0","../utils/url-utils.js":"7TG35","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"g68RD":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parses `data` using a specified loader
 * @param data
 * @param loaders
 * @param options
 * @param context
 */ // implementation signature
parcelHelpers.export(exports, "parse", ()=>parse);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _workerUtils = require("@loaders.gl/worker-utils");
var _normalizeLoaderJs = require("../loader-utils/normalize-loader.js");
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _optionUtilsJs = require("../loader-utils/option-utils.js");
var _getDataJs = require("../loader-utils/get-data.js");
var _loaderContextJs = require("../loader-utils/loader-context.js");
var _resourceUtilsJs = require("../utils/resource-utils.js");
var _selectLoaderJs = require("./select-loader.js");
async function parse(data, loaders, options, context) {
    // Signature: parse(data, options, context | url)
    // Uses registered loaders
    if (loaders && !Array.isArray(loaders) && !(0, _normalizeLoaderJs.isLoaderObject)(loaders)) {
        context = undefined; // context not supported in short signature
        options = loaders;
        loaders = undefined;
    }
    data = await data; // Resolve any promise
    options = options || {}; // Could be invalid...
    // Extract a url for auto detection
    const url = (0, _resourceUtilsJs.getResourceUrl)(data);
    // Chooses a loader (and normalizes it)
    // Also use any loaders in the context, new loaders take priority
    const typedLoaders = loaders;
    const candidateLoaders = (0, _loaderContextJs.getLoadersFromContext)(typedLoaders, context);
    // todo hacky type cast
    const loader = await (0, _selectLoaderJs.selectLoader)(data, candidateLoaders, options);
    // Note: if no loader was found, if so just return null
    if (!loader) return null;
    // Normalize options
    // @ts-expect-error
    options = (0, _optionUtilsJs.normalizeOptions)(options, loader, candidateLoaders, url); // Could be invalid...
    // Get a context (if already present, will be unchanged)
    context = (0, _loaderContextJs.getLoaderContext)(// @ts-expect-error
    {
        url,
        _parse: parse,
        loaders: candidateLoaders
    }, options, context || null);
    return await parseWithLoader(loader, data, options, context);
}
// TODO: support progress and abort
// TODO - should accept loader.parseAsyncIterator and concatenate.
async function parseWithLoader(loader, data, options, context) {
    (0, _workerUtils.validateWorkerVersion)(loader);
    options = (0, _loaderUtils.mergeLoaderOptions)(loader.options, options);
    if ((0, _isTypeJs.isResponse)(data)) {
        // Serialize to support passing the response to web worker
        const response = data;
        const { ok, redirected, status, statusText, type, url } = response;
        const headers = Object.fromEntries(response.headers.entries());
        // @ts-expect-error TODO - fix this
        context.response = {
            headers,
            ok,
            redirected,
            status,
            statusText,
            type,
            url
        };
    }
    data = await (0, _getDataJs.getArrayBufferOrStringFromData)(data, loader, options);
    const loaderWithParser = loader;
    // First check for synchronous text parser, wrap results in promises
    if (loaderWithParser.parseTextSync && typeof data === 'string') return loaderWithParser.parseTextSync(data, options, context);
    // If we have a workerUrl and the loader can parse the given options efficiently in a worker
    if ((0, _loaderUtils.canParseWithWorker)(loader, options)) return await (0, _loaderUtils.parseWithWorker)(loader, data, options, context, parse);
    // Check for asynchronous parser
    if (loaderWithParser.parseText && typeof data === 'string') return await loaderWithParser.parseText(data, options, context);
    if (loaderWithParser.parse) return await loaderWithParser.parse(data, options, context);
    // This should not happen, all sync loaders should also offer `parse` function
    (0, _workerUtils.assert)(!loaderWithParser.parseSync);
    // TBD - If asynchronous parser not available, return null
    throw new Error(`${loader.id} loader - no parser found and worker is disabled`);
}

},{"@loaders.gl/loader-utils":"5BWS4","@loaders.gl/worker-utils":"jmn0B","../loader-utils/normalize-loader.js":"dpeMM","../../javascript-utils/is-type.js":"f69p0","../loader-utils/option-utils.js":"jlnKJ","../loader-utils/get-data.js":"gaVVd","../loader-utils/loader-context.js":"kpMQq","../utils/resource-utils.js":"bS5F0","./select-loader.js":"aRJ2H","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gaVVd":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line complexity
parcelHelpers.export(exports, "getArrayBufferOrStringFromDataSync", ()=>getArrayBufferOrStringFromDataSync);
// Convert async iterator to a promise
parcelHelpers.export(exports, "getArrayBufferOrStringFromData", ()=>getArrayBufferOrStringFromData);
parcelHelpers.export(exports, "getAsyncIterableFromData", ()=>getAsyncIterableFromData);
parcelHelpers.export(exports, "getReadableStream", ()=>getReadableStream);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _makeIteratorJs = require("../../iterators/make-iterator/make-iterator.js");
var _responseUtilsJs = require("../utils/response-utils.js");
const ERR_DATA = 'Cannot convert supplied data type';
function getArrayBufferOrStringFromDataSync(data, loader, options) {
    if (loader.text && typeof data === 'string') return data;
    if ((0, _isTypeJs.isBuffer)(data)) // @ts-ignore
    data = data.buffer;
    if (data instanceof ArrayBuffer) {
        const arrayBuffer = data;
        if (loader.text && !loader.binary) {
            const textDecoder = new TextDecoder('utf8');
            return textDecoder.decode(arrayBuffer);
        }
        return arrayBuffer;
    }
    // We may need to handle offsets
    if (ArrayBuffer.isView(data)) {
        // TextDecoder is invoked on typed arrays and will handle offsets
        if (loader.text && !loader.binary) {
            const textDecoder = new TextDecoder('utf8');
            return textDecoder.decode(data);
        }
        let arrayBuffer = data.buffer;
        // Since we are returning the underlying arrayBuffer, we must create a new copy
        // if this typed array / Buffer is a partial view into the ArryayBuffer
        // TODO - this is a potentially unnecessary copy
        const byteLength = data.byteLength || data.length;
        if (data.byteOffset !== 0 || byteLength !== arrayBuffer.byteLength) // console.warn(`loaders.gl copying arraybuffer of length ${byteLength}`);
        arrayBuffer = arrayBuffer.slice(data.byteOffset, data.byteOffset + byteLength);
        return arrayBuffer;
    }
    throw new Error(ERR_DATA);
}
async function getArrayBufferOrStringFromData(data, loader, options) {
    const isArrayBuffer = data instanceof ArrayBuffer || ArrayBuffer.isView(data);
    if (typeof data === 'string' || isArrayBuffer) return getArrayBufferOrStringFromDataSync(data, loader, options);
    // Blobs and files are FileReader compatible
    if ((0, _isTypeJs.isBlob)(data)) data = await (0, _responseUtilsJs.makeResponse)(data);
    if ((0, _isTypeJs.isResponse)(data)) {
        const response = data;
        await (0, _responseUtilsJs.checkResponse)(response);
        return loader.binary ? await response.arrayBuffer() : await response.text();
    }
    if ((0, _isTypeJs.isReadableStream)(data)) // @ts-expect-error TS2559 options type
    data = (0, _makeIteratorJs.makeIterator)(data, options);
    if ((0, _isTypeJs.isIterable)(data) || (0, _isTypeJs.isAsyncIterable)(data)) // Assume arrayBuffer iterator - attempt to concatenate
    return (0, _loaderUtils.concatenateArrayBuffersAsync)(data);
    throw new Error(ERR_DATA);
}
async function getAsyncIterableFromData(data, options) {
    if ((0, _isTypeJs.isIterator)(data)) return data;
    if ((0, _isTypeJs.isResponse)(data)) {
        const response = data;
        // Note Since this function is not async, we currently can't load error message, just status
        await (0, _responseUtilsJs.checkResponse)(response);
        // TODO - bug in polyfill, body can be a Promise under Node.js
        // eslint-disable-next-line @typescript-eslint/await-thenable
        const body = await response.body;
        // TODO - body can be null?
        return (0, _makeIteratorJs.makeIterator)(body, options);
    }
    if ((0, _isTypeJs.isBlob)(data) || (0, _isTypeJs.isReadableStream)(data)) return (0, _makeIteratorJs.makeIterator)(data, options);
    if ((0, _isTypeJs.isAsyncIterable)(data)) return data;
    return getIterableFromData(data);
}
async function getReadableStream(data) {
    if ((0, _isTypeJs.isReadableStream)(data)) return data;
    if ((0, _isTypeJs.isResponse)(data)) // @ts-ignore
    return data.body;
    const response = await (0, _responseUtilsJs.makeResponse)(data);
    // @ts-ignore
    return response.body;
}
// HELPERS
function getIterableFromData(data) {
    // generate an iterator that emits a single chunk
    if (ArrayBuffer.isView(data)) return function* oneChunk() {
        yield data.buffer;
    }();
    if (data instanceof ArrayBuffer) return function* oneChunk() {
        yield data;
    }();
    if ((0, _isTypeJs.isIterator)(data)) return data;
    if ((0, _isTypeJs.isIterable)(data)) return data[Symbol.iterator]();
    throw new Error(ERR_DATA);
}

},{"@loaders.gl/loader-utils":"5BWS4","../../javascript-utils/is-type.js":"f69p0","../../iterators/make-iterator/make-iterator.js":"4dLI5","../utils/response-utils.js":"1lJGj","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4dLI5":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an iterator that breaks its input into chunks and yields them one-by-one.
 * @param data
 * @param options
 * @returns
 * This function can e.g. be used to enable data sources that can only be read atomically
 * (such as `Blob` and `File` via `FileReader`) to still be parsed in batches.
 */ parcelHelpers.export(exports, "makeIterator", ()=>makeIterator);
var _makeStringIteratorJs = require("./make-string-iterator.js");
var _makeArrayBufferIteratorJs = require("./make-array-buffer-iterator.js");
var _makeBlobIteratorJs = require("./make-blob-iterator.js");
var _makeStreamIteratorJs = require("./make-stream-iterator.js");
var _isTypeJs = require("../../javascript-utils/is-type.js");
function makeIterator(data, options) {
    if (typeof data === 'string') // Note: Converts string chunks to binary
    return (0, _makeStringIteratorJs.makeStringIterator)(data, options);
    if (data instanceof ArrayBuffer) return (0, _makeArrayBufferIteratorJs.makeArrayBufferIterator)(data, options);
    if ((0, _isTypeJs.isBlob)(data)) return (0, _makeBlobIteratorJs.makeBlobIterator)(data, options);
    if ((0, _isTypeJs.isReadableStream)(data)) return (0, _makeStreamIteratorJs.makeStreamIterator)(data, options);
    if ((0, _isTypeJs.isResponse)(data)) {
        const response = data;
        return (0, _makeStreamIteratorJs.makeStreamIterator)(response.body, options);
    }
    throw new Error('makeIterator');
}

},{"./make-string-iterator.js":"d3zYG","./make-array-buffer-iterator.js":"tN2nL","./make-blob-iterator.js":"2wFd3","./make-stream-iterator.js":"8h8K4","../../javascript-utils/is-type.js":"f69p0","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"d3zYG":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an iterator that breaks a big string into chunks and yields them one-by-one as ArrayBuffers
 * @param blob string to iterate over
 * @param options
 * @param options.chunkSize
 */ parcelHelpers.export(exports, "makeStringIterator", ()=>makeStringIterator);
const DEFAULT_CHUNK_SIZE = 262144;
function* makeStringIterator(string, options) {
    const chunkSize = options?.chunkSize || DEFAULT_CHUNK_SIZE;
    let offset = 0;
    const textEncoder = new TextEncoder();
    while(offset < string.length){
        // Create a chunk of the right size
        const chunkLength = Math.min(string.length - offset, chunkSize);
        const chunk = string.slice(offset, offset + chunkLength);
        offset += chunkLength;
        // yield an ArrayBuffer chunk
        yield textEncoder.encode(chunk);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"tN2nL":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an iterator that breaks a big ArrayBuffer into chunks and yields them one-by-one
 * @param blob ArrayBuffer to iterate over
 * @param options
 * @param options.chunkSize
 */ parcelHelpers.export(exports, "makeArrayBufferIterator", ()=>makeArrayBufferIterator);
const DEFAULT_CHUNK_SIZE = 262144;
function* makeArrayBufferIterator(arrayBuffer, options = {}) {
    const { chunkSize = DEFAULT_CHUNK_SIZE } = options;
    let byteOffset = 0;
    while(byteOffset < arrayBuffer.byteLength){
        // Create a chunk of the right size
        const chunkByteLength = Math.min(arrayBuffer.byteLength - byteOffset, chunkSize);
        const chunk = new ArrayBuffer(chunkByteLength);
        // Copy data from the big chunk
        const sourceArray = new Uint8Array(arrayBuffer, byteOffset, chunkByteLength);
        const chunkArray = new Uint8Array(chunk);
        chunkArray.set(sourceArray);
        // yield the chunk
        byteOffset += chunkByteLength;
        yield chunk;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2wFd3":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an iterator that breaks a big Blob into chunks and yields them one-by-one
 * @param blob Blob or File object
 * @param options
 * @param options.chunkSize
 */ parcelHelpers.export(exports, "makeBlobIterator", ()=>makeBlobIterator);
const DEFAULT_CHUNK_SIZE = 1048576; // 1MB — biggest value that keeps UI responsive
async function* makeBlobIterator(blob, options) {
    const chunkSize = options?.chunkSize || DEFAULT_CHUNK_SIZE;
    let offset = 0;
    while(offset < blob.size){
        const end = offset + chunkSize;
        const chunk = await blob.slice(offset, end).arrayBuffer();
        offset = end;
        yield chunk;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8h8K4":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an async iterable that reads from a stream (works in both Node.js and browsers)
 * @param stream stream to iterator over
 */ parcelHelpers.export(exports, "makeStreamIterator", ()=>makeStreamIterator);
var _loaderUtils = require("@loaders.gl/loader-utils");
function makeStreamIterator(stream, options) {
    return (0, _loaderUtils.isBrowser) ? makeBrowserStreamIterator(stream, options) : makeNodeStreamIterator(stream, options);
}
/**
 * Returns an async iterable that reads from a DOM (browser) stream
 * @param stream stream to iterate from
 * @see https://jakearchibald.com/2017/async-iterators-and-generators/#making-streams-iterate
 */ async function* makeBrowserStreamIterator(stream, options) {
    // WhatWG: stream is supposed to have a `getIterator` method
    // if (typeof stream.getIterator === 'function') {
    //   return stream.getIterator();
    // }
    // if (typeof stream[Symbol.asyncIterator] === 'function') {
    //   return makeToArrayBufferIterator(stream);
    // }
    // In the browser, we first need to get a lock on the stream
    const reader = stream.getReader();
    let nextBatchPromise;
    try {
        // eslint-disable-next-line no-constant-condition
        while(true){
            const currentBatchPromise = nextBatchPromise || reader.read();
            // Issue a read for an additional batch, while we await the next batch
            // Idea is to make fetching happen in parallel with processing / parsing
            if (options?._streamReadAhead) nextBatchPromise = reader.read();
            // Read from the stream
            // value is a Uint8Array
            const { done, value } = await currentBatchPromise;
            // Exit if we're done
            if (done) return;
            // Else yield the chunk
            yield (0, _loaderUtils.toArrayBuffer)(value);
        }
    } catch (error) {
        // TODO - examples makes it look like this should always be called,
        // but that generates exceptions so only call it if we do not reach the end
        reader.releaseLock();
    }
}
/**
 * Returns an async iterable that reads from a DOM (browser) stream
 * @param stream stream to iterate from
 * @note Requires Node.js >= 10
 */ async function* makeNodeStreamIterator(stream, options) {
    // Hacky test for node version to ensure we don't call bad polyfills
    // NODE 10+: stream is an asyncIterator
    for await (const chunk of stream)yield (0, _loaderUtils.toArrayBuffer)(chunk); // Coerce each chunk to ArrayBuffer
} /* TODO - remove NODE < 10
 * @see https://github.com/bustle/streaming-iterables, MIT license
 *
  if (typeof stream[Symbol.asyncIterator] === 'function') {
    return;
  }

  // TODO - check if is this ever used in Node 10+?
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const data = stream.read();
    if (data !== null) {
      yield toArrayBuffer(data);
      // eslint-disable-next-line no-continue
      continue;
    }
    if (stream._readableState?.ended) {
      return;
    }
    await onceReadable(stream);
  }

async function onceReadable(stream: Readable): Promise<any> {
  return new Promise((resolve) => {
    stream.once('readable', resolve);
  });
}
  */ 

},{"@loaders.gl/loader-utils":"5BWS4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kpMQq":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * "sub" loaders invoked by other loaders get a "context" injected on `this`
 * The context will inject core methods like `parse` and contain information
 * about loaders and options passed in to the top-level `parse` call.
 *
 * @param context
 * @param options
 * @param previousContext
 */ parcelHelpers.export(exports, "getLoaderContext", ()=>getLoaderContext);
// eslint-disable-next-line complexity
parcelHelpers.export(exports, "getLoadersFromContext", ()=>getLoadersFromContext);
var _getFetchFunctionJs = require("./get-fetch-function.js");
var _urlUtilsJs = require("../utils/url-utils.js");
var _loaderUtils = require("@loaders.gl/loader-utils");
function getLoaderContext(context, options, parentContext) {
    // For recursive calls, we already have a context
    // TODO - add any additional loaders to context?
    if (parentContext) return parentContext;
    const newContext = {
        fetch: (0, _getFetchFunctionJs.getFetchFunction)(options, context),
        ...context
    };
    // Parse URLs so that subloaders can easily generate correct strings
    if (newContext.url) {
        const baseUrl = (0, _urlUtilsJs.stripQueryString)(newContext.url);
        newContext.baseUrl = baseUrl;
        newContext.queryString = (0, _urlUtilsJs.extractQueryString)(newContext.url);
        newContext.filename = (0, _loaderUtils.path).filename(baseUrl);
        newContext.baseUrl = (0, _loaderUtils.path).dirname(baseUrl);
    }
    // Recursive loading does not use single loader
    if (!Array.isArray(newContext.loaders)) newContext.loaders = null;
    return newContext;
}
function getLoadersFromContext(loaders, context) {
    // A single loader (non-array) indicates no selection desired. Force select.
    if (loaders && !Array.isArray(loaders)) return loaders;
    // Create a merged list
    let candidateLoaders;
    if (loaders) candidateLoaders = Array.isArray(loaders) ? loaders : [
        loaders
    ];
    if (context && context.loaders) {
        const contextLoaders = Array.isArray(context.loaders) ? context.loaders : [
            context.loaders
        ];
        candidateLoaders = candidateLoaders ? [
            ...candidateLoaders,
            ...contextLoaders
        ] : contextLoaders;
    }
    // If no loaders, return null to look in globally registered loaders
    return candidateLoaders && candidateLoaders.length ? candidateLoaders : undefined;
}

},{"./get-fetch-function.js":"324Xa","../utils/url-utils.js":"7TG35","@loaders.gl/loader-utils":"5BWS4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"324Xa":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the current fetch function from options and context
 * @param options
 * @param context
 */ parcelHelpers.export(exports, "getFetchFunction", ()=>getFetchFunction);
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _fetchFileJs = require("../fetch/fetch-file.js");
var _optionUtilsJs = require("./option-utils.js");
function getFetchFunction(options, context) {
    const globalOptions = (0, _optionUtilsJs.getGlobalLoaderOptions)();
    const loaderOptions = options || globalOptions;
    // options.fetch can be a function
    if (typeof loaderOptions.fetch === 'function') return loaderOptions.fetch;
    // options.fetch can be an options object
    if ((0, _isTypeJs.isObject)(loaderOptions.fetch)) return (url)=>(0, _fetchFileJs.fetchFile)(url, loaderOptions.fetch);
    // else refer to context (from parent loader) if available
    if (context?.fetch) return context?.fetch;
    // else return the default fetch function
    return 0, _fetchFileJs.fetchFile;
}

},{"../../javascript-utils/is-type.js":"f69p0","../fetch/fetch-file.js":"dJvPG","./option-utils.js":"jlnKJ","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2W714":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// export async function load(url: string | DataType, loaders: LoaderOptions): Promise<any>;
// implementation signature
parcelHelpers.export(exports, "load", ()=>load);
var _isTypeJs = require("../../javascript-utils/is-type.js");
var _normalizeLoaderJs = require("../loader-utils/normalize-loader.js");
var _getFetchFunctionJs = require("../loader-utils/get-fetch-function.js");
var _parseJs = require("./parse.js");
async function load(url, loaders, options, context) {
    let resolvedLoaders;
    let resolvedOptions;
    // Signature: load(url, options)
    if (!Array.isArray(loaders) && !(0, _normalizeLoaderJs.isLoaderObject)(loaders)) {
        resolvedLoaders = [];
        resolvedOptions = loaders;
        context = undefined; // context not supported in short signature
    } else {
        resolvedLoaders = loaders;
        resolvedOptions = options;
    }
    // Select fetch function
    const fetch = (0, _getFetchFunctionJs.getFetchFunction)(resolvedOptions);
    // at this point, `url` could be already loaded binary data
    let data = url;
    // url is a string, fetch the url
    if (typeof url === 'string') data = await fetch(url);
    if ((0, _isTypeJs.isBlob)(url)) // The fetch response object will contain blob.name
    // @ts-expect-error TODO - This may not work for overridden fetch functions
    data = await fetch(url);
    // Data is loaded (at least we have a `Response` object) so time to hand over to `parse`
    // return await parse(data, loaders as Loader[], options);
    return Array.isArray(resolvedLoaders) ? await (0, _parseJs.parse)(data, resolvedLoaders, resolvedOptions) // loader array overload
     : await (0, _parseJs.parse)(data, resolvedLoaders, resolvedOptions); // single loader overload
}

},{"../../javascript-utils/is-type.js":"f69p0","../loader-utils/normalize-loader.js":"dpeMM","../loader-utils/get-fetch-function.js":"324Xa","./parse.js":"g68RD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8Otgz":[function(require,module,exports,__globalThis) {
// LOADERS AND WRITERS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageLoader", ()=>(0, _imageLoaderJs.ImageLoader));
parcelHelpers.export(exports, "ImageWriter", ()=>(0, _imageWriterJs.ImageWriter));
// IMAGE CATEGORY API
// Binary Image API
parcelHelpers.export(exports, "getBinaryImageMetadata", ()=>(0, _binaryImageApiJs.getBinaryImageMetadata));
// Parsed Image API
parcelHelpers.export(exports, "isImageTypeSupported", ()=>(0, _imageTypeJs.isImageTypeSupported));
parcelHelpers.export(exports, "getDefaultImageType", ()=>(0, _imageTypeJs.getDefaultImageType));
parcelHelpers.export(exports, "isImage", ()=>(0, _parsedImageApiJs.isImage));
parcelHelpers.export(exports, "getImageType", ()=>(0, _parsedImageApiJs.getImageType));
parcelHelpers.export(exports, "getImageSize", ()=>(0, _parsedImageApiJs.getImageSize));
parcelHelpers.export(exports, "getImageData", ()=>(0, _parsedImageApiJs.getImageData));
// EXPERIMENTAL
parcelHelpers.export(exports, "getSupportedImageFormats", ()=>(0, _imageFormatJs.getSupportedImageFormats));
parcelHelpers.export(exports, "isImageFormatSupported", ()=>(0, _imageFormatJs.isImageFormatSupported));
// REMOVED
/** @deprecated Temporary placeholder to prevent builds from breaking */ parcelHelpers.export(exports, "loadImage", ()=>loadImage);
var _imageLoaderJs = require("./image-loader.js");
var _imageWriterJs = require("./image-writer.js");
var _binaryImageApiJs = require("./lib/category-api/binary-image-api.js");
var _imageTypeJs = require("./lib/category-api/image-type.js");
var _parsedImageApiJs = require("./lib/category-api/parsed-image-api.js");
var _imageFormatJs = require("./lib/category-api/image-format.js");
function loadImage() {
    throw new Error('loadImage has moved to @loaders.gl/textures');
}

},{"./image-loader.js":"79CMR","./image-writer.js":false,"./lib/category-api/binary-image-api.js":false,"./lib/category-api/image-type.js":false,"./lib/category-api/parsed-image-api.js":false,"./lib/category-api/image-format.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"79CMR":[function(require,module,exports,__globalThis) {
// import type { ImageType } from '@loaders.gl/schema';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageLoader", ()=>ImageLoader);
var _versionJs = require("./lib/utils/version.js");
var _parseImageJs = require("./lib/parsers/parse-image.js");
var _binaryImageApiJs = require("./lib/category-api/binary-image-api.js");
const EXTENSIONS = [
    'png',
    'jpg',
    'jpeg',
    'gif',
    'webp',
    'bmp',
    'ico',
    'svg',
    'avif'
];
const MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
    'image/avif',
    'image/bmp',
    'image/vnd.microsoft.icon',
    'image/svg+xml'
];
const DEFAULT_IMAGE_LOADER_OPTIONS = {
    image: {
        type: 'auto',
        decode: true // if format is HTML
    }
};
const ImageLoader = {
    dataType: null,
    batchType: null,
    id: 'image',
    module: 'images',
    name: 'Images',
    version: (0, _versionJs.VERSION),
    mimeTypes: MIME_TYPES,
    extensions: EXTENSIONS,
    parse: (0, _parseImageJs.parseImage),
    // TODO: byteOffset, byteLength;
    tests: [
        (arrayBuffer)=>Boolean((0, _binaryImageApiJs.getBinaryImageMetadata)(new DataView(arrayBuffer)))
    ],
    options: DEFAULT_IMAGE_LOADER_OPTIONS
};

},{"./lib/utils/version.js":"lsq6g","./lib/parsers/parse-image.js":"ifWiw","./lib/category-api/binary-image-api.js":"5svD4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lsq6g":[function(require,module,exports,__globalThis) {
// Version constant cannot be imported, it needs to correspond to the build version of **this** module.
// __VERSION__ is injected by babel-plugin-version-inline
// @ts-ignore TS2304: Cannot find name '__VERSION__'.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "4.3.3";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ifWiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Parse to platform defined image type (data on node, ImageBitmap or HTMLImage on browser)
// eslint-disable-next-line complexity
parcelHelpers.export(exports, "parseImage", ()=>parseImage);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _imageTypeJs = require("../category-api/image-type.js");
var _parsedImageApiJs = require("../category-api/parsed-image-api.js");
var _parseToImageJs = require("./parse-to-image.js");
var _parseToImageBitmapJs = require("./parse-to-image-bitmap.js");
var _parseToNodeImageJs = require("./parse-to-node-image.js");
async function parseImage(arrayBuffer, options, context) {
    options = options || {};
    const imageOptions = options.image || {};
    // The user can request a specific output format via `options.image.type`
    const imageType = imageOptions.type || 'auto';
    const { url } = context || {};
    // Note: For options.image.type === `data`, we may still need to load as `image` or `imagebitmap`
    const loadType = getLoadableImageType(imageType);
    let image;
    switch(loadType){
        case 'imagebitmap':
            image = await (0, _parseToImageBitmapJs.parseToImageBitmap)(arrayBuffer, options, url);
            break;
        case 'image':
            image = await (0, _parseToImageJs.parseToImage)(arrayBuffer, options, url);
            break;
        case 'data':
            // Node.js loads imagedata directly
            image = await (0, _parseToNodeImageJs.parseToNodeImage)(arrayBuffer, options);
            break;
        default:
            (0, _loaderUtils.assert)(false);
    }
    // Browser: if options.image.type === 'data', we can now extract data from the loaded image
    if (imageType === 'data') image = (0, _parsedImageApiJs.getImageData)(image);
    return image;
}
// Get a loadable image type from image type
function getLoadableImageType(type) {
    switch(type){
        case 'auto':
        case 'data':
            // Browser: For image data we need still need to load using an image format
            // Node: the default image type is `data`.
            return (0, _imageTypeJs.getDefaultImageType)();
        default:
            // Throw an error if not supported
            (0, _imageTypeJs.isImageTypeSupported)(type);
            return type;
    }
}

},{"@loaders.gl/loader-utils":"5BWS4","../category-api/image-type.js":"e3JUt","../category-api/parsed-image-api.js":"4SpOP","./parse-to-image.js":"bL8Mg","./parse-to-image-bitmap.js":"7pWbK","./parse-to-node-image.js":"gOld5","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"e3JUt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if a loaders.gl image type is supported
 * @param type image type string
 */ parcelHelpers.export(exports, "isImageTypeSupported", ()=>isImageTypeSupported);
/**
 * Returns the "most performant" supported image type on this platform
 * @returns image type string
 */ parcelHelpers.export(exports, "getDefaultImageType", ()=>getDefaultImageType);
var _loaderUtils = require("@loaders.gl/loader-utils");
// @ts-ignore TS2339: Property does not exist on type
const parseImageNode = globalThis.loaders?.parseImageNode;
const IMAGE_SUPPORTED = typeof Image !== 'undefined'; // NOTE: "false" positives if jsdom is installed
const IMAGE_BITMAP_SUPPORTED = typeof ImageBitmap !== 'undefined';
const NODE_IMAGE_SUPPORTED = Boolean(parseImageNode);
const DATA_SUPPORTED = (0, _loaderUtils.isBrowser) ? true : NODE_IMAGE_SUPPORTED;
function isImageTypeSupported(type) {
    switch(type){
        case 'auto':
            // Should only ever be false in Node.js, if polyfills have not been installed...
            return IMAGE_BITMAP_SUPPORTED || IMAGE_SUPPORTED || DATA_SUPPORTED;
        case 'imagebitmap':
            return IMAGE_BITMAP_SUPPORTED;
        case 'image':
            return IMAGE_SUPPORTED;
        case 'data':
            return DATA_SUPPORTED;
        default:
            throw new Error(`@loaders.gl/images: image ${type} not supported in this environment`);
    }
}
function getDefaultImageType() {
    if (IMAGE_BITMAP_SUPPORTED) return 'imagebitmap';
    if (IMAGE_SUPPORTED) return 'image';
    if (DATA_SUPPORTED) return 'data';
    // This should only happen in Node.js
    throw new Error('Install \'@loaders.gl/polyfills\' to parse images under Node.js');
}

},{"@loaders.gl/loader-utils":"5BWS4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4SpOP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isImage", ()=>isImage);
parcelHelpers.export(exports, "deleteImage", ()=>deleteImage);
parcelHelpers.export(exports, "getImageType", ()=>getImageType);
parcelHelpers.export(exports, "getImageSize", ()=>getImageSize);
parcelHelpers.export(exports, "getImageData", ()=>getImageData);
function isImage(image) {
    return Boolean(getImageTypeOrNull(image));
}
function deleteImage(image) {
    switch(getImageType(image)){
        case 'imagebitmap':
            image.close();
            break;
        default:
    }
}
function getImageType(image) {
    const format = getImageTypeOrNull(image);
    if (!format) throw new Error('Not an image');
    return format;
}
function getImageSize(image) {
    return getImageData(image);
}
function getImageData(image) {
    switch(getImageType(image)){
        case 'data':
            return image;
        case 'image':
        case 'imagebitmap':
            // Extract the image data from the image via a canvas
            const canvas = document.createElement('canvas');
            // TODO - reuse the canvas?
            const context = canvas.getContext('2d');
            if (!context) throw new Error('getImageData');
            // @ts-ignore
            canvas.width = image.width;
            // @ts-ignore
            canvas.height = image.height;
            // @ts-ignore
            context.drawImage(image, 0, 0);
            // @ts-ignore
            return context.getImageData(0, 0, image.width, image.height);
        default:
            throw new Error('getImageData');
    }
}
// PRIVATE
// eslint-disable-next-line complexity
function getImageTypeOrNull(image) {
    if (typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) return 'imagebitmap';
    if (typeof Image !== 'undefined' && image instanceof Image) return 'image';
    if (image && typeof image === 'object' && image.data && image.width && image.height) return 'data';
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bL8Mg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Parses html image from array buffer
parcelHelpers.export(exports, "parseToImage", ()=>parseToImage);
parcelHelpers.export(exports, "loadToImage", ()=>loadToImage);
var _svgUtilsJs = require("./svg-utils.js");
async function parseToImage(arrayBuffer, options, url) {
    // Note: image parsing requires conversion to Blob (for createObjectURL).
    // Potentially inefficient for not using `response.blob()` (and for File / Blob inputs)...
    // But presumably not worth adding 'blob' flag to loader objects?
    const blobOrDataUrl = (0, _svgUtilsJs.getBlobOrSVGDataUrl)(arrayBuffer, url);
    const URL = self.URL || self.webkitURL;
    const objectUrl = typeof blobOrDataUrl !== 'string' && URL.createObjectURL(blobOrDataUrl);
    try {
        return await loadToImage(objectUrl || blobOrDataUrl, options);
    } finally{
        if (objectUrl) URL.revokeObjectURL(objectUrl);
    }
}
async function loadToImage(url, options) {
    const image = new Image();
    image.src = url;
    // The `image.onload()` callback does not guarantee that the image has been decoded
    // so a main thread "freeze" can be incurred when using the image for the first time.
    // `Image.decode()` returns a promise that completes when image is decoded.
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/decode
    // Note: When calling `img.decode()`, we do not need to wait for `img.onload()`
    // Note: `HTMLImageElement.decode()` is not available in Edge and IE11
    if (options.image && options.image.decode && image.decode) {
        await image.decode();
        return image;
    }
    // Create a promise that tracks onload/onerror callbacks
    return await new Promise((resolve, reject)=>{
        try {
            image.onload = ()=>resolve(image);
            image.onerror = (error)=>{
                const message = error instanceof Error ? error.message : 'error';
                reject(new Error(message));
            };
        } catch (error) {
            reject(error);
        }
    });
}

},{"./svg-utils.js":"3tPCD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3tPCD":[function(require,module,exports,__globalThis) {
// SVG parsing has limitations, e.g:
// https://bugs.chromium.org/p/chromium/issues/detail?id=606319
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVG", ()=>isSVG);
parcelHelpers.export(exports, "getBlobOrSVGDataUrl", ()=>getBlobOrSVGDataUrl);
parcelHelpers.export(exports, "getBlob", ()=>getBlob);
const SVG_DATA_URL_PATTERN = /^data:image\/svg\+xml/;
const SVG_URL_PATTERN = /\.svg((\?|#).*)?$/;
function isSVG(url) {
    return url && (SVG_DATA_URL_PATTERN.test(url) || SVG_URL_PATTERN.test(url));
}
function getBlobOrSVGDataUrl(arrayBuffer, url) {
    if (isSVG(url)) {
        // Prepare a properly tagged data URL, and load using normal mechanism
        const textDecoder = new TextDecoder();
        let xmlText = textDecoder.decode(arrayBuffer);
        // TODO Escape in browser to support e.g. Chinese characters
        try {
            if (typeof unescape === 'function' && typeof encodeURIComponent === 'function') xmlText = unescape(encodeURIComponent(xmlText));
        } catch (error) {
            throw new Error(error.message);
        }
        // base64 encoding is safer. utf-8 fails in some browsers
        const src = `data:image/svg+xml;base64,${btoa(xmlText)}`;
        return src;
    }
    return getBlob(arrayBuffer, url);
}
function getBlob(arrayBuffer, url) {
    if (isSVG(url)) // https://bugs.chromium.org/p/chromium/issues/detail?id=606319
    // return new Blob([new Uint8Array(arrayBuffer)], {type: 'image/svg+xml'});
    throw new Error('SVG cannot be parsed directly to imagebitmap');
    // TODO - how to determine mime type? Param? Sniff here?
    return new Blob([
        new Uint8Array(arrayBuffer)
    ]); // MIME type not needed?
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7pWbK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Asynchronously parses an array buffer into an ImageBitmap - this contains the decoded data
 * ImageBitmaps are supported on worker threads, but not supported on Edge, IE11 and Safari
 * https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap#Browser_compatibility
 *
 * TODO - createImageBitmap supports source rect (5 param overload), pass through?
 */ parcelHelpers.export(exports, "parseToImageBitmap", ()=>parseToImageBitmap);
var _svgUtilsJs = require("./svg-utils.js");
var _parseToImageJs = require("./parse-to-image.js");
const EMPTY_OBJECT = {};
let imagebitmapOptionsSupported = true;
async function parseToImageBitmap(arrayBuffer, options, url) {
    let blob;
    // Cannot parse SVG directly to ImageBitmap, parse to Image first
    if ((0, _svgUtilsJs.isSVG)(url)) {
        // Note: this only works on main thread
        const image = await (0, _parseToImageJs.parseToImage)(arrayBuffer, options, url);
        blob = image;
    } else // Create blob from the array buffer
    blob = (0, _svgUtilsJs.getBlob)(arrayBuffer, url);
    const imagebitmapOptions = options && options.imagebitmap;
    return await safeCreateImageBitmap(blob, imagebitmapOptions);
}
/**
 * Safely creates an imageBitmap with options
 * *
 * Firefox crashes if imagebitmapOptions is supplied
 * Avoid supplying if not provided or supported, remember if not supported
 */ async function safeCreateImageBitmap(blob, imagebitmapOptions = null) {
    if (isEmptyObject(imagebitmapOptions) || !imagebitmapOptionsSupported) imagebitmapOptions = null;
    if (imagebitmapOptions) try {
        // @ts-ignore Options
        return await createImageBitmap(blob, imagebitmapOptions);
    } catch (error) {
        console.warn(error); // eslint-disable-line
        imagebitmapOptionsSupported = false;
    }
    return await createImageBitmap(blob);
}
function isEmptyObject(object) {
    // @ts-ignore
    for(const key in object || EMPTY_OBJECT)return false;
    return true;
}

},{"./svg-utils.js":"3tPCD","./parse-to-image.js":"bL8Mg","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gOld5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Use polyfills if installed to parsed image using get-pixels
parcelHelpers.export(exports, "parseToNodeImage", ()=>parseToNodeImage);
var _loaderUtils = require("@loaders.gl/loader-utils");
var _binaryImageApiJs = require("../category-api/binary-image-api.js");
async function parseToNodeImage(arrayBuffer, options) {
    const { mimeType } = (0, _binaryImageApiJs.getBinaryImageMetadata)(arrayBuffer) || {};
    // @ts-ignore
    const parseImageNode = globalThis.loaders?.parseImageNode;
    (0, _loaderUtils.assert)(parseImageNode); // '@loaders.gl/polyfills not installed'
    // @ts-expect-error TODO should we throw error in this case?
    return await parseImageNode(arrayBuffer, mimeType);
}

},{"@loaders.gl/loader-utils":"5BWS4","../category-api/binary-image-api.js":"5svD4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5svD4":[function(require,module,exports,__globalThis) {
// Attributions
// * Based on binary-gltf-utils under MIT license: Copyright (c) 2016-17 Karl Cheng
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Extracts `{mimeType, width and height}` from a memory buffer containing a known image format
 * Currently supports `image/png`, `image/jpeg`, `image/bmp` and `image/gif`.
 * @param binaryData: DataView | ArrayBuffer image file memory to parse
 * @returns metadata or null if memory is not a valid image file format layout.
 */ parcelHelpers.export(exports, "getBinaryImageMetadata", ()=>getBinaryImageMetadata);
// BMP
// TODO: BMP is not this simple
parcelHelpers.export(exports, "getBmpMetadata", ()=>getBmpMetadata);
var _parseIsobmffBinaryJs = require("./parse-isobmff-binary.js");
const BIG_ENDIAN = false;
const LITTLE_ENDIAN = true;
function getBinaryImageMetadata(binaryData) {
    const dataView = toDataView(binaryData);
    return getPngMetadata(dataView) || getJpegMetadata(dataView) || getGifMetadata(dataView) || getBmpMetadata(dataView) || getISOBMFFMetadata(dataView);
}
// ISOBMFF
function getISOBMFFMetadata(binaryData) {
    const buffer = new Uint8Array(binaryData instanceof DataView ? binaryData.buffer : binaryData);
    const mediaType = (0, _parseIsobmffBinaryJs.getISOBMFFMediaType)(buffer);
    if (!mediaType) return null;
    return {
        mimeType: mediaType.mimeType,
        // TODO - decode width and height
        width: 0,
        height: 0
    };
}
// PNG
function getPngMetadata(binaryData) {
    const dataView = toDataView(binaryData);
    // Check file contains the first 4 bytes of the PNG signature.
    const isPng = dataView.byteLength >= 24 && dataView.getUint32(0, BIG_ENDIAN) === 0x89504e47;
    if (!isPng) return null;
    // Extract size from a binary PNG file
    return {
        mimeType: 'image/png',
        width: dataView.getUint32(16, BIG_ENDIAN),
        height: dataView.getUint32(20, BIG_ENDIAN)
    };
}
// GIF
// Extract size from a binary GIF file
// TODO: GIF is not this simple
function getGifMetadata(binaryData) {
    const dataView = toDataView(binaryData);
    // Check first 4 bytes of the GIF signature ("GIF8").
    const isGif = dataView.byteLength >= 10 && dataView.getUint32(0, BIG_ENDIAN) === 0x47494638;
    if (!isGif) return null;
    // GIF is little endian.
    return {
        mimeType: 'image/gif',
        width: dataView.getUint16(6, LITTLE_ENDIAN),
        height: dataView.getUint16(8, LITTLE_ENDIAN)
    };
}
function getBmpMetadata(binaryData) {
    const dataView = toDataView(binaryData);
    // Check magic number is valid (first 2 characters should be "BM").
    // The mandatory bitmap file header is 14 bytes long.
    const isBmp = dataView.byteLength >= 14 && dataView.getUint16(0, BIG_ENDIAN) === 0x424d && dataView.getUint32(2, LITTLE_ENDIAN) === dataView.byteLength;
    if (!isBmp) return null;
    // BMP is little endian.
    return {
        mimeType: 'image/bmp',
        width: dataView.getUint32(18, LITTLE_ENDIAN),
        height: dataView.getUint32(22, LITTLE_ENDIAN)
    };
}
// JPEG
// Extract width and height from a binary JPEG file
function getJpegMetadata(binaryData) {
    const dataView = toDataView(binaryData);
    // Check file contains the JPEG "start of image" (SOI) marker
    // followed by another marker.
    const isJpeg = dataView.byteLength >= 3 && dataView.getUint16(0, BIG_ENDIAN) === 0xffd8 && dataView.getUint8(2) === 0xff;
    if (!isJpeg) return null;
    const { tableMarkers, sofMarkers } = getJpegMarkers();
    // Exclude the two byte SOI marker.
    let i = 2;
    while(i + 9 < dataView.byteLength){
        const marker = dataView.getUint16(i, BIG_ENDIAN);
        // The frame that contains the width and height of the JPEG image.
        if (sofMarkers.has(marker)) return {
            mimeType: 'image/jpeg',
            height: dataView.getUint16(i + 5, BIG_ENDIAN),
            width: dataView.getUint16(i + 7, BIG_ENDIAN) // Number of pixels per line
        };
        // Miscellaneous tables/data preceding the frame header.
        if (!tableMarkers.has(marker)) return null;
        // Length includes size of length parameter but not the two byte header.
        i += 2;
        i += dataView.getUint16(i, BIG_ENDIAN);
    }
    return null;
}
function getJpegMarkers() {
    // Tables/misc header markers.
    // DQT, DHT, DAC, DRI, COM, APP_n
    const tableMarkers = new Set([
        0xffdb,
        0xffc4,
        0xffcc,
        0xffdd,
        0xfffe
    ]);
    for(let i = 0xffe0; i < 0xfff0; ++i)tableMarkers.add(i);
    // SOF markers and DHP marker.
    // These markers are after tables/misc data.
    const sofMarkers = new Set([
        0xffc0,
        0xffc1,
        0xffc2,
        0xffc3,
        0xffc5,
        0xffc6,
        0xffc7,
        0xffc9,
        0xffca,
        0xffcb,
        0xffcd,
        0xffce,
        0xffcf,
        0xffde
    ]);
    return {
        tableMarkers,
        sofMarkers
    };
}
// TODO - move into image module?
function toDataView(data) {
    if (data instanceof DataView) return data;
    if (ArrayBuffer.isView(data)) return new DataView(data.buffer);
    // TODO: make these functions work for Node.js buffers?
    // if (bufferToArrayBuffer) {
    //   data = bufferToArrayBuffer(data);
    // }
    // Careful - Node Buffers will look like ArrayBuffers (keep after isBuffer)
    if (data instanceof ArrayBuffer) return new DataView(data);
    throw new Error('toDataView');
}

},{"./parse-isobmff-binary.js":"lpb9H","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lpb9H":[function(require,module,exports,__globalThis) {
// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// code adapted from https://github.com/sindresorhus/file-type under MIT license
/**
 * Tests if a buffer is in ISO base media file format (ISOBMFF) @see https://en.wikipedia.org/wiki/ISO_base_media_file_format
 * (ISOBMFF is a media container standard based on the Apple QuickTime container format)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getISOBMFFMediaType", ()=>getISOBMFFMediaType);
/**
 * brands explained @see https://github.com/strukturag/libheif/issues/83
 * code adapted from @see https://github.com/sindresorhus/file-type/blob/main/core.js#L489-L492
 */ parcelHelpers.export(exports, "decodeMajorBrand", ()=>decodeMajorBrand);
function getISOBMFFMediaType(buffer) {
    // Almost all ISO base media files start with `ftyp` box. (It's not required to be first, but it's recommended to be.)
    if (!checkString(buffer, 'ftyp', 4)) return null;
    // Extra check: test for 8859-1 printable characters (for simplicity, it's a mask which also catches one non-printable character).
    if ((buffer[8] & 0x60) === 0x00) return null;
    // `ftyp` box must contain a brand major identifier, which must consist of ISO 8859-1 printable characters.
    return decodeMajorBrand(buffer);
}
function decodeMajorBrand(buffer) {
    const brandMajor = getUTF8String(buffer, 8, 12).replace('\0', ' ').trim();
    switch(brandMajor){
        case 'avif':
        case 'avis':
            return {
                extension: 'avif',
                mimeType: 'image/avif'
            };
        default:
            return null;
    }
// We don't need these now, but they are easy to add
// case 'mif1':
//   return {extension: 'heic', mimeType: 'image/heif'};
// case 'msf1':
//   return {extension: 'heic', mimeType: 'image/heif-sequence'};
// case 'heic':
// case 'heix':
//   return {extension: 'heic', mimeType: 'image/heic'};
// case 'hevc':
// case 'hevx':
//   return {extension: 'heic', mimeType: 'image/heic-sequence'};
// case 'qt':
//   return {ext: 'mov', mime: 'video/quicktime'};
// case 'M4V':
// case 'M4VH':
// case 'M4VP':
//   return {ext: 'm4v', mime: 'video/x-m4v'};
// case 'M4P':
//   return {ext: 'm4p', mime: 'video/mp4'};
// case 'M4B':
//   return {ext: 'm4b', mime: 'audio/mp4'};
// case 'M4A':
//   return {ext: 'm4a', mime: 'audio/x-m4a'};
// case 'F4V':
//   return {ext: 'f4v', mime: 'video/mp4'};
// case 'F4P':
//   return {ext: 'f4p', mime: 'video/mp4'};
// case 'F4A':
//   return {ext: 'f4a', mime: 'audio/mp4'};
// case 'F4B':
//   return {ext: 'f4b', mime: 'audio/mp4'};
// case 'crx':
//   return {ext: 'cr3', mime: 'image/x-canon-cr3'};
// default:
// if (brandMajor.startsWith('3g')) {
//   if (brandMajor.startsWith('3g2')) {
//     return {ext: '3g2', mime: 'video/3gpp2'};
//   }
//   return {ext: '3gp', mime: 'video/3gpp'};
// }
// return {ext: 'mp4', mime: 'video/mp4'};
}
/** Interpret a chunk of bytes as a UTF8 string */ function getUTF8String(array, start, end) {
    return String.fromCharCode(...array.slice(start, end));
}
function stringToBytes(string) {
    return [
        ...string
    ].map((character)=>character.charCodeAt(0));
}
function checkString(buffer, header, offset = 0) {
    const headerBytes = stringToBytes(header);
    for(let i = 0; i < headerBytes.length; ++i){
        if (headerBytes[i] !== buffer[i + offset]) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9S0lD":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _log = require("@probe.gl/log");
const defaultLogger = new (0, _log.Log)({
    id: 'deck'
});
exports.default = defaultLogger;

},{"@probe.gl/log":"fwng6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7gIzA":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", ()=>register);
parcelHelpers.export(exports, "default", ()=>debug);
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _loggersJs = require("./loggers.js");
/* debug utility */ let loggers = {};
function register(handlers) {
    loggers = handlers;
}
function debug(eventType, arg1, arg2, arg3) {
    if ((0, _logJsDefault.default).level > 0 && loggers[eventType]) // Not using rest parameters to defeat perf hit from array construction
    loggers[eventType].call(null, arg1, arg2, arg3);
}

},{"../utils/log.js":"9S0lD","./loggers.js":"bIXCs","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bIXCs":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLoggers", ()=>getLoggers);
const logState = {
    attributeUpdateStart: -1,
    attributeManagerUpdateStart: -1,
    attributeUpdateMessages: []
};
const LOG_LEVEL_MAJOR_UPDATE = 1; // Events with direct perf impact
const LOG_LEVEL_MINOR_UPDATE = 2; // Events that may affect perf
const LOG_LEVEL_UPDATE_DETAIL = 3;
const LOG_LEVEL_INFO = 4;
const LOG_LEVEL_DRAW = 2;
const getLoggers = (log)=>({
        /* Layer events */ 'layer.changeFlag': (layer, key, flags)=>{
            log.log(LOG_LEVEL_UPDATE_DETAIL, `${layer.id} ${key}: `, flags[key])();
        },
        'layer.initialize': (layer)=>{
            log.log(LOG_LEVEL_MAJOR_UPDATE, `Initializing ${layer}`)();
        },
        'layer.update': (layer, needsUpdate)=>{
            if (needsUpdate) {
                const flags = layer.getChangeFlags();
                log.log(LOG_LEVEL_MINOR_UPDATE, `Updating ${layer} because: ${Object.keys(flags).filter((key)=>flags[key]).join(', ')}`)();
            } else log.log(LOG_LEVEL_INFO, `${layer} does not need update`)();
        },
        'layer.matched': (layer, changed)=>{
            if (changed) log.log(LOG_LEVEL_INFO, `Matched ${layer}, state transfered`)();
        },
        'layer.finalize': (layer)=>{
            log.log(LOG_LEVEL_MAJOR_UPDATE, `Finalizing ${layer}`)();
        },
        /* CompositeLayer events */ 'compositeLayer.renderLayers': (layer, updated, subLayers)=>{
            if (updated) log.log(LOG_LEVEL_MINOR_UPDATE, `Composite layer rendered new subLayers ${layer}`, subLayers)();
            else log.log(LOG_LEVEL_INFO, `Composite layer reused subLayers ${layer}`, subLayers)();
        },
        /* LayerManager events */ 'layerManager.setLayers': (layerManager, updated, layers)=>{
            if (updated) log.log(LOG_LEVEL_MINOR_UPDATE, `Updating ${layers.length} deck layers`)();
        },
        'layerManager.activateViewport': (layerManager, viewport)=>{
            log.log(LOG_LEVEL_UPDATE_DETAIL, 'Viewport changed', viewport)();
        },
        /* AttributeManager events */ 'attributeManager.invalidate': (attributeManager, trigger, attributeNames)=>{
            log.log(LOG_LEVEL_MAJOR_UPDATE, attributeNames ? `invalidated attributes ${attributeNames} (${trigger}) for ${attributeManager.id}` : `invalidated all attributes for ${attributeManager.id}`)();
        },
        'attributeManager.updateStart': (attributeManager)=>{
            logState.attributeUpdateMessages.length = 0;
            logState.attributeManagerUpdateStart = Date.now();
        },
        'attributeManager.updateEnd': (attributeManager, numInstances)=>{
            const timeMs = Math.round(Date.now() - logState.attributeManagerUpdateStart);
            log.groupCollapsed(LOG_LEVEL_MINOR_UPDATE, `Updated attributes for ${numInstances} instances in ${attributeManager.id} in ${timeMs}ms`)();
            for (const updateMessage of logState.attributeUpdateMessages)log.log(LOG_LEVEL_UPDATE_DETAIL, updateMessage)();
            log.groupEnd(LOG_LEVEL_MINOR_UPDATE)();
        },
        /* Attribute events */ 'attribute.updateStart': (attribute)=>{
            logState.attributeUpdateStart = Date.now();
        },
        'attribute.allocate': (attribute, numInstances)=>{
            const message = `${attribute.id} allocated ${numInstances}`;
            logState.attributeUpdateMessages.push(message);
        },
        'attribute.updateEnd': (attribute, numInstances)=>{
            const timeMs = Math.round(Date.now() - logState.attributeUpdateStart);
            const message = `${attribute.id} updated ${numInstances} in ${timeMs}ms`;
            logState.attributeUpdateMessages.push(message);
        },
        /* Render events */ 'deckRenderer.renderLayers': (deckRenderer, renderStats, opts)=>{
            const { pass, redrawReason, stats } = opts;
            for (const status of renderStats){
                const { totalCount, visibleCount, compositeCount, pickableCount } = status;
                const primitiveCount = totalCount - compositeCount;
                const hiddenCount = primitiveCount - visibleCount;
                log.log(LOG_LEVEL_DRAW, `RENDER #${deckRenderer.renderCount} \
  ${visibleCount} (of ${totalCount} layers) to ${pass} because ${redrawReason} \
  (${hiddenCount} hidden, ${compositeCount} composite ${pickableCount} pickable)`)();
                if (stats) stats.get('Redraw Layers').add(visibleCount);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ilrl6":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isJSON(text) {
    const firstChar = text[0];
    const lastChar = text[text.length - 1];
    return firstChar === '{' && lastChar === '}' || firstChar === '[' && lastChar === ']';
}
// A light weight version instead of @loaders.gl/json (stream processing etc.)
exports.default = {
    dataType: null,
    batchType: null,
    id: 'JSON',
    name: 'JSON',
    module: '',
    version: '',
    options: {},
    extensions: [
        'json',
        'geojson'
    ],
    mimeTypes: [
        'application/json',
        'application/geo+json'
    ],
    testText: isJSON,
    parseTextSync: JSON.parse
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1z7oa":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getShaderAssembler", ()=>getShaderAssembler);
parcelHelpers.export(exports, "layerUniforms", ()=>(0, _layerUniformsJs.layerUniforms));
parcelHelpers.export(exports, "picking", ()=>(0, _pickingJsDefault.default));
parcelHelpers.export(exports, "project", ()=>(0, _projectJsDefault.default));
parcelHelpers.export(exports, "project32", ()=>(0, _project32JsDefault.default));
parcelHelpers.export(exports, "gouraudLighting", ()=>(0, _shadertools.gouraudLighting));
parcelHelpers.export(exports, "phongLighting", ()=>(0, _shadertools.phongLighting));
parcelHelpers.export(exports, "shadow", ()=>(0, _shadowJsDefault.default));
var _shadertools = require("@luma.gl/shadertools");
var _layerUniformsJs = require("./misc/layer-uniforms.js");
var _geometryJs = require("./misc/geometry.js");
var _geometryJsDefault = parcelHelpers.interopDefault(_geometryJs);
var _projectJs = require("./project/project.js");
var _projectJsDefault = parcelHelpers.interopDefault(_projectJs);
var _project32Js = require("./project32/project32.js");
var _project32JsDefault = parcelHelpers.interopDefault(_project32Js);
var _shadowJs = require("./shadow/shadow.js");
var _shadowJsDefault = parcelHelpers.interopDefault(_shadowJs);
var _pickingJs = require("./picking/picking.js");
var _pickingJsDefault = parcelHelpers.interopDefault(_pickingJs);
const DEFAULT_MODULES = [
    (0, _geometryJsDefault.default)
];
const SHADER_HOOKS_GLSL = [
    'vs:DECKGL_FILTER_SIZE(inout vec3 size, VertexGeometry geometry)',
    'vs:DECKGL_FILTER_GL_POSITION(inout vec4 position, VertexGeometry geometry)',
    'vs:DECKGL_FILTER_COLOR(inout vec4 color, VertexGeometry geometry)',
    'fs:DECKGL_FILTER_COLOR(inout vec4 color, FragmentGeometry geometry)'
];
const SHADER_HOOKS_WGSL = [];
function getShaderAssembler(language) {
    const shaderAssembler = (0, _shadertools.ShaderAssembler).getDefaultShaderAssembler();
    for (const shaderModule of DEFAULT_MODULES)shaderAssembler.addDefaultModule(shaderModule);
    // Add shader hooks based on language
    // TODO(ibgreen) - should the luma shader assembler support both sets of hooks?
    const shaderHooks = language === 'glsl' ? SHADER_HOOKS_GLSL : SHADER_HOOKS_WGSL;
    for (const shaderHook of shaderHooks)shaderAssembler.addShaderHook(shaderHook);
    return shaderAssembler;
}

},{"@luma.gl/shadertools":"iH5G2","./misc/layer-uniforms.js":"lcE29","./misc/geometry.js":"1yy3M","./project/project.js":false,"./project32/project32.js":"gO5dh","./shadow/shadow.js":false,"./picking/picking.js":"9SQCI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iH5G2":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeShaderModule", ()=>(0, _shaderModuleJs.initializeShaderModule));
parcelHelpers.export(exports, "initializeShaderModules", ()=>(0, _shaderModuleJs.initializeShaderModules));
parcelHelpers.export(exports, "getShaderModuleUniforms", ()=>(0, _shaderModuleJs.getShaderModuleUniforms));
parcelHelpers.export(exports, "getShaderModuleDependencies", ()=>(0, _shaderModuleDependenciesJs.getShaderModuleDependencies));
parcelHelpers.export(exports, "checkShaderModuleDeprecations", ()=>(0, _shaderModuleJs.checkShaderModuleDeprecations));
parcelHelpers.export(exports, "getShaderModuleSource", ()=>(0, _assembleShadersJs.getShaderModuleSource));
parcelHelpers.export(exports, "_resolveModules", ()=>(0, _shaderModuleDependenciesJs.resolveModules));
parcelHelpers.export(exports, "_getDependencyGraph", ()=>(0, _shaderModuleDependenciesJs.getDependencyGraph));
// ShaderAssembler
parcelHelpers.export(exports, "ShaderAssembler", ()=>(0, _shaderAssemblerJs.ShaderAssembler));
// SHADER HELPERS
// Shader source introspection
parcelHelpers.export(exports, "getShaderInfo", ()=>(0, _getShaderInfoJs.getShaderInfo));
parcelHelpers.export(exports, "getQualifierDetails", ()=>(0, _shaderUtilsJs.getQualifierDetails));
parcelHelpers.export(exports, "getPassthroughFS", ()=>(0, _shaderUtilsJs.getPassthroughFS));
parcelHelpers.export(exports, "typeToChannelSuffix", ()=>(0, _shaderUtilsJs.typeToChannelSuffix));
parcelHelpers.export(exports, "typeToChannelCount", ()=>(0, _shaderUtilsJs.typeToChannelCount));
parcelHelpers.export(exports, "convertToVec4", ()=>(0, _shaderUtilsJs.convertToVec4));
parcelHelpers.export(exports, "generateShaderForModule", ()=>(0, _generateShaderJs.generateShaderForModule));
parcelHelpers.export(exports, "capitalize", ()=>(0, _capitalizeJs.capitalize));
// TEST EXPORTS - Do not use in production applications
parcelHelpers.export(exports, "preprocess", ()=>(0, _preprocessorJs.preprocess));
parcelHelpers.export(exports, "assembleGLSLShaderPair", ()=>(0, _assembleShadersJs.assembleGLSLShaderPair));
parcelHelpers.export(exports, "combineInjects", ()=>(0, _shaderInjectionsJs.combineInjects));
// EXPERIMENTAL WGSL
parcelHelpers.export(exports, "getShaderLayoutFromWGSL", ()=>(0, _getShaderLayoutWgslJs.getShaderLayoutFromWGSL));
// data utils
parcelHelpers.export(exports, "toHalfFloat", ()=>(0, _fp16UtilsJs.toHalfFloat));
parcelHelpers.export(exports, "fromHalfFloat", ()=>(0, _fp16UtilsJs.fromHalfFloat));
parcelHelpers.export(exports, "fp64ify", ()=>(0, _fp64UtilsJs.fp64ify));
parcelHelpers.export(exports, "fp64LowPart", ()=>(0, _fp64UtilsJs.fp64LowPart));
parcelHelpers.export(exports, "fp64ifyMatrix4", ()=>(0, _fp64UtilsJs.fp64ifyMatrix4));
// math libraries
parcelHelpers.export(exports, "random", ()=>(0, _randomJs.random));
parcelHelpers.export(exports, "fp32", ()=>(0, _fp32Js.fp32));
parcelHelpers.export(exports, "fp64", ()=>(0, _fp64Js.fp64));
parcelHelpers.export(exports, "fp64arithmetic", ()=>(0, _fp64Js.fp64arithmetic));
parcelHelpers.export(exports, "picking", ()=>(0, _pickingJs.picking));
parcelHelpers.export(exports, "lighting", ()=>(0, _lightingJs.lighting));
parcelHelpers.export(exports, "dirlight", ()=>(0, _dirlightJs.dirlight));
parcelHelpers.export(exports, "gouraudMaterial", ()=>(0, _gouraudMaterialJs.gouraudMaterial));
parcelHelpers.export(exports, "phongMaterial", ()=>(0, _phongMaterialJs.phongMaterial));
parcelHelpers.export(exports, "pbrMaterial", ()=>(0, _pbrMaterialJs.pbrMaterial));
// DEPRECATED - v8 legacy shader modules (non-uniform buffer)
// math libraries
// export {fp64, fp64arithmetic} from './modules-webgl1/math/fp64/fp64';
// projection and lighting
parcelHelpers.export(exports, "geometry1", ()=>(0, _geometryJs.geometry));
parcelHelpers.export(exports, "project1", ()=>(0, _projectJs.project));
parcelHelpers.export(exports, "lights1", ()=>(0, _lightsJs.lights));
parcelHelpers.export(exports, "dirlight1", ()=>(0, _dirlightJs1.dirlight));
parcelHelpers.export(exports, "gouraudLighting", ()=>(0, _phongLightingJs.gouraudLighting));
parcelHelpers.export(exports, "phongLighting", ()=>(0, _phongLightingJs.phongLighting));
parcelHelpers.export(exports, "pbr", ()=>(0, _pbrJs.pbr));
var _shaderModuleJs = require("./lib/shader-module/shader-module.js");
var _shaderModuleDependenciesJs = require("./lib/shader-module/shader-module-dependencies.js");
var _assembleShadersJs = require("./lib/shader-assembly/assemble-shaders.js");
var _shaderAssemblerJs = require("./lib/shader-assembler.js");
var _getShaderInfoJs = require("./lib/glsl-utils/get-shader-info.js");
var _shaderUtilsJs = require("./lib/glsl-utils/shader-utils.js");
var _generateShaderJs = require("./lib/shader-generator/generate-shader.js");
var _capitalizeJs = require("./lib/shader-generator/utils/capitalize.js");
var _preprocessorJs = require("./lib/preprocessor/preprocessor.js");
var _shaderInjectionsJs = require("./lib/shader-assembly/shader-injections.js");
var _getShaderLayoutWgslJs = require("./lib/wgsl/get-shader-layout-wgsl.js");
var _fp16UtilsJs = require("./modules/math/fp16/fp16-utils.js");
var _fp64UtilsJs = require("./modules/math/fp64/fp64-utils.js");
var _randomJs = require("./modules/math/random/random.js");
var _fp32Js = require("./modules/math/fp32/fp32.js");
var _fp64Js = require("./modules/math/fp64/fp64.js");
var _pickingJs = require("./modules/engine/picking/picking.js");
var _lightingJs = require("./modules/lighting/lights/lighting.js");
var _dirlightJs = require("./modules/lighting/no-material/dirlight.js");
var _gouraudMaterialJs = require("./modules/lighting/gouraud-material/gouraud-material.js");
var _phongMaterialJs = require("./modules/lighting/phong-material/phong-material.js");
var _pbrMaterialJs = require("./modules/lighting/pbr-material/pbr-material.js");
var _geometryJs = require("./modules-webgl1/geometry/geometry.js");
var _projectJs = require("./modules-webgl1/project/project.js");
var _lightsJs = require("./modules-webgl1/lighting/lights/lights.js");
var _dirlightJs1 = require("./modules-webgl1/lighting/dirlight/dirlight.js");
var _phongLightingJs = require("./modules-webgl1/lighting/phong-lighting/phong-lighting.js");
var _pbrJs = require("./modules-webgl1/lighting/pbr/pbr.js");

},{"./lib/shader-module/shader-module.js":false,"./lib/shader-module/shader-module-dependencies.js":"2p3Mz","./lib/shader-assembly/assemble-shaders.js":false,"./lib/shader-assembler.js":"bsU1C","./lib/glsl-utils/get-shader-info.js":false,"./lib/glsl-utils/shader-utils.js":"ebLBN","./lib/shader-generator/generate-shader.js":false,"./lib/shader-generator/utils/capitalize.js":false,"./lib/preprocessor/preprocessor.js":false,"./lib/shader-assembly/shader-injections.js":false,"./lib/wgsl/get-shader-layout-wgsl.js":"cM8Ra","./modules/math/fp16/fp16-utils.js":false,"./modules/math/fp64/fp64-utils.js":false,"./modules/math/random/random.js":false,"./modules/math/fp32/fp32.js":"7IenJ","./modules/math/fp64/fp64.js":"g1i3d","./modules/engine/picking/picking.js":"j6JaV","./modules/lighting/lights/lighting.js":false,"./modules/lighting/no-material/dirlight.js":false,"./modules/lighting/gouraud-material/gouraud-material.js":"3997R","./modules/lighting/phong-material/phong-material.js":false,"./modules/lighting/pbr-material/pbr-material.js":false,"./modules-webgl1/geometry/geometry.js":false,"./modules-webgl1/project/project.js":false,"./modules-webgl1/lighting/lights/lights.js":false,"./modules-webgl1/lighting/dirlight/dirlight.js":false,"./modules-webgl1/lighting/phong-lighting/phong-lighting.js":false,"./modules-webgl1/lighting/pbr/pbr.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"azfVk":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// SHNDER MODULE API
parcelHelpers.export(exports, "initializeShaderModules", ()=>initializeShaderModules);
parcelHelpers.export(exports, "initializeShaderModule", ()=>initializeShaderModule);
/** Convert module props to uniforms */ parcelHelpers.export(exports, "getShaderModuleUniforms", ()=>getShaderModuleUniforms);
/* TODO this looks like it was unused code
  _defaultGetUniforms(opts: Record<string, any> = {}): Record<string, any> {
    const uniforms: Record<string, any> = {};
    const propTypes = this.uniforms;

    for (const key in propTypes) {
      const propDef = propTypes[key];
      if (key in opts && !propDef.private) {
        if (propDef.validate) {
          assert(propDef.validate(opts[key], propDef), `${this.name}: invalid ${key}`);
        }
        uniforms[key] = opts[key];
      } else {
        uniforms[key] = propDef.value;
      }
    }

    return uniforms;
  }
}
*/ // Warn about deprecated uniforms or functions
parcelHelpers.export(exports, "checkShaderModuleDeprecations", ()=>checkShaderModuleDeprecations);
var _propTypesJs = require("../filters/prop-types.js");
var _shaderInjectionsJs = require("../shader-assembly/shader-injections.js");
function initializeShaderModules(modules) {
    modules.map((module)=>initializeShaderModule(module));
}
function initializeShaderModule(module) {
    if (module.instance) return;
    initializeShaderModules(module.dependencies || []);
    const { propTypes = {}, deprecations = [], // defines = {},
    inject = {} } = module;
    const instance = {
        normalizedInjections: (0, _shaderInjectionsJs.normalizeInjections)(inject),
        parsedDeprecations: parseDeprecationDefinitions(deprecations)
    };
    if (propTypes) instance.propValidators = (0, _propTypesJs.makePropValidators)(propTypes);
    module.instance = instance;
    // TODO(ib) - we need to apply the original prop types to the default uniforms
    let defaultProps = {};
    if (propTypes) defaultProps = Object.entries(propTypes).reduce((obj, [key, propType])=>{
        // @ts-expect-error
        const value = propType?.value;
        if (value) // @ts-expect-error
        obj[key] = value;
        return obj;
    }, {});
    module.defaultUniforms = {
        ...module.defaultUniforms,
        ...defaultProps
    };
}
function getShaderModuleUniforms(module, props, oldUniforms) {
    initializeShaderModule(module);
    const uniforms = oldUniforms || {
        ...module.defaultUniforms
    };
    // If module has a getUniforms function, use it
    if (props && module.getUniforms) return module.getUniforms(props, uniforms);
    // Build uniforms from the uniforms array
    // @ts-expect-error
    return (0, _propTypesJs.getValidatedProperties)(props, module.instance?.propValidators, module.name);
}
function checkShaderModuleDeprecations(shaderModule, shaderSource, log) {
    shaderModule.deprecations?.forEach((def)=>{
        if (def.regex?.test(shaderSource)) {
            if (def.deprecated) log.deprecated(def.old, def.new)();
            else log.removed(def.old, def.new)();
        }
    });
}
// HELPERS
function parseDeprecationDefinitions(deprecations) {
    deprecations.forEach((def)=>{
        switch(def.type){
            case 'function':
                def.regex = new RegExp(`\\b${def.old}\\(`);
                break;
            default:
                def.regex = new RegExp(`${def.type} ${def.old};`);
        }
    });
    return deprecations;
}

},{"../filters/prop-types.js":"8uWS8","../shader-assembly/shader-injections.js":"iYwCC","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8uWS8":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse a list of property types into property definitions that can be used to validate
 * values passed in by applications.
 * @param propTypes
 * @returns
 */ parcelHelpers.export(exports, "makePropValidators", ()=>makePropValidators);
/**
 * Validate a map of user supplied properties against a map of validators
 * Inject default values when user doesn't supply a property
 * @param properties
 * @param propValidators
 * @returns
 */ parcelHelpers.export(exports, "getValidatedProperties", ()=>getValidatedProperties);
var _assertJs = require("../utils/assert.js");
/** Minimal validators for number and array types */ const DEFAULT_PROP_VALIDATORS = {
    number: {
        type: 'number',
        validate (value, propType) {
            return Number.isFinite(value) && typeof propType === 'object' && (propType.max === undefined || value <= propType.max) && (propType.min === undefined || value >= propType.min);
        }
    },
    array: {
        type: 'array',
        validate (value, propType) {
            return Array.isArray(value) || ArrayBuffer.isView(value);
        }
    }
};
function makePropValidators(propTypes) {
    const propValidators = {};
    for (const [name, propType] of Object.entries(propTypes))propValidators[name] = makePropValidator(propType);
    return propValidators;
}
function getValidatedProperties(properties, propValidators, errorMessage) {
    const validated = {};
    for (const [key, propsValidator] of Object.entries(propValidators))if (properties && key in properties && !propsValidator.private) {
        if (propsValidator.validate) (0, _assertJs.assert)(propsValidator.validate(properties[key], propsValidator), `${errorMessage}: invalid ${key}`);
        validated[key] = properties[key];
    } else // property not supplied - use default value
    validated[key] = propsValidator.value;
    // TODO - warn for unused properties that don't match a validator?
    return validated;
}
/**
 * Creates a property validator for a prop type. Either contains:
 * - a valid prop type object ({type, ...})
 * - or just a default value, in which case type and name inference is used
 */ function makePropValidator(propType) {
    let type = getTypeOf(propType);
    if (type !== 'object') return {
        value: propType,
        ...DEFAULT_PROP_VALIDATORS[type],
        type
    };
    // Special handling for objects
    if (typeof propType === 'object') {
        if (!propType) return {
            type: 'object',
            value: null
        };
        if (propType.type !== undefined) return {
            ...propType,
            ...DEFAULT_PROP_VALIDATORS[propType.type],
            type: propType.type
        };
        // If no type and value this object is likely the value
        if (propType.value === undefined) return {
            type: 'object',
            value: propType
        };
        type = getTypeOf(propType.value);
        return {
            ...propType,
            ...DEFAULT_PROP_VALIDATORS[type],
            type
        };
    }
    throw new Error('props');
}
/**
 * "improved" version of javascript typeof that can distinguish arrays and null values
 */ function getTypeOf(value) {
    if (Array.isArray(value) || ArrayBuffer.isView(value)) return 'array';
    return typeof value;
}

},{"../utils/assert.js":"cePKD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cePKD":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Recommendation is to ignore message but current test suite checks agains the
// message so keep it for now.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(message || 'shadertools: assertion failed.');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iYwCC":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DECLARATION_INJECT_MARKER", ()=>DECLARATION_INJECT_MARKER);
/**
 *
 */ parcelHelpers.export(exports, "normalizeInjections", ()=>normalizeInjections);
/**
// A minimal shader injection/templating system.
// RFC: https://github.com/visgl/luma.gl/blob/7.0-release/dev-docs/RFCs/v6.0/shader-injection-rfc.md
 * @param source
 * @param type
 * @param inject
 * @param injectStandardStubs
 * @returns
 */ // eslint-disable-next-line complexity
parcelHelpers.export(exports, "injectShader", ()=>injectShader);
// Takes an array of inject objects and combines them into one
parcelHelpers.export(exports, "combineInjects", ()=>combineInjects);
var _moduleInjectorsJs = require("../../module-injectors.js");
var _assertJs = require("../utils/assert.js");
// TODO - experimental
const MODULE_INJECTORS = {
    vertex: (0, _moduleInjectorsJs.MODULE_INJECTORS_VS),
    fragment: (0, _moduleInjectorsJs.MODULE_INJECTORS_FS)
};
const REGEX_START_OF_MAIN = /void\s+main\s*\([^)]*\)\s*\{\n?/; // Beginning of main
const REGEX_END_OF_MAIN = /}\n?[^{}]*$/; // End of main, assumes main is last function
const fragments = [];
const DECLARATION_INJECT_MARKER = '__LUMA_INJECT_DECLARATIONS__';
function normalizeInjections(injections) {
    const result = {
        vertex: {},
        fragment: {}
    };
    for(const hook in injections){
        let injection = injections[hook];
        const stage = getHookStage(hook);
        if (typeof injection === 'string') injection = {
            order: 0,
            injection
        };
        result[stage][hook] = injection;
    }
    return result;
}
function getHookStage(hook) {
    const type = hook.slice(0, 2);
    switch(type){
        case 'vs':
            return 'vertex';
        case 'fs':
            return 'fragment';
        default:
            throw new Error(type);
    }
}
function injectShader(source, stage, inject, injectStandardStubs = false) {
    const isVertex = stage === 'vertex';
    for(const key in inject){
        const fragmentData = inject[key];
        fragmentData.sort((a, b)=>a.order - b.order);
        fragments.length = fragmentData.length;
        for(let i = 0, len = fragmentData.length; i < len; ++i)fragments[i] = fragmentData[i].injection;
        const fragmentString = `${fragments.join('\n')}\n`;
        switch(key){
            // declarations are injected before the main function
            case 'vs:#decl':
                if (isVertex) source = source.replace(DECLARATION_INJECT_MARKER, fragmentString);
                break;
            // inject code at the beginning of the main function
            case 'vs:#main-start':
                if (isVertex) source = source.replace(REGEX_START_OF_MAIN, (match)=>match + fragmentString);
                break;
            // inject code at the end of main function
            case 'vs:#main-end':
                if (isVertex) source = source.replace(REGEX_END_OF_MAIN, (match)=>fragmentString + match);
                break;
            // declarations are injected before the main function
            case 'fs:#decl':
                if (!isVertex) source = source.replace(DECLARATION_INJECT_MARKER, fragmentString);
                break;
            // inject code at the beginning of the main function
            case 'fs:#main-start':
                if (!isVertex) source = source.replace(REGEX_START_OF_MAIN, (match)=>match + fragmentString);
                break;
            // inject code at the end of main function
            case 'fs:#main-end':
                if (!isVertex) source = source.replace(REGEX_END_OF_MAIN, (match)=>fragmentString + match);
                break;
            default:
                // TODO(Tarek): I think this usage should be deprecated.
                // inject code after key, leaving key in place
                source = source.replace(key, (match)=>match + fragmentString);
        }
    }
    // Remove if it hasn't already been replaced
    source = source.replace(DECLARATION_INJECT_MARKER, '');
    // Finally, if requested, insert an automatic module injector chunk
    if (injectStandardStubs) source = source.replace(/\}\s*$/, (match)=>match + MODULE_INJECTORS[stage]);
    return source;
}
function combineInjects(injects) {
    const result = {};
    (0, _assertJs.assert)(Array.isArray(injects) && injects.length > 1);
    injects.forEach((inject)=>{
        for(const key in inject)result[key] = result[key] ? `${result[key]}\n${inject[key]}` : inject[key];
    });
    return result;
}

},{"../../module-injectors.js":"90YFK","../utils/assert.js":"cePKD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"90YFK":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MODULE_INJECTORS_VS", ()=>MODULE_INJECTORS_VS);
parcelHelpers.export(exports, "MODULE_INJECTORS_FS", ()=>MODULE_INJECTORS_FS);
const MODULE_INJECTORS_VS = /* glsl */ `\
#ifdef MODULE_LOGDEPTH
  logdepth_adjustPosition(gl_Position);
#endif
`;
const MODULE_INJECTORS_FS = /* glsl */ `\
#ifdef MODULE_MATERIAL
  fragColor = material_filterColor(fragColor);
#endif

#ifdef MODULE_LIGHTING
  fragColor = lighting_filterColor(fragColor);
#endif

#ifdef MODULE_FOG
  fragColor = fog_filterColor(fragColor);
#endif

#ifdef MODULE_PICKING
  fragColor = picking_filterHighlightColor(fragColor);
  fragColor = picking_filterPickingColor(fragColor);
#endif

#ifdef MODULE_LOGDEPTH
  logdepth_setFragDepth();
#endif
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2p3Mz":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Takes a list of shader module names and returns a new list of
 * shader module names that includes all dependencies, sorted so
 * that modules that are dependencies of other modules come first.
 *
 * If the shader glsl code from the returned modules is concatenated
 * in the reverse order, it is guaranteed that all functions be resolved and
 * that all function and variable definitions come before use.
 *
 * @param modules - Array of modules (inline modules or module names)
 * @return - Array of modules
 */ parcelHelpers.export(exports, "getShaderModuleDependencies", ()=>getShaderModuleDependencies);
/**
 * Recursively checks module dependencies to calculate dependency level of each module.
 *
 * @param options.modules - Array of modules
 * @param options.level - Current level
 * @param options.moduleMap -
 * @param options.moduleDepth - Current level
 * @return - Map of module name to its level
 */ // Adds another level of dependencies to the result map
parcelHelpers.export(exports, "getDependencyGraph", ()=>getDependencyGraph);
/**
 * Takes a list of shader module names and returns a new list of
 * shader module names that includes all dependencies, sorted so
 * that modules that are dependencies of other modules come first.
 *
 * If the shader glsl code from the returned modules is concatenated
 * in the reverse order, it is guaranteed that all functions be resolved and
 * that all function and variable definitions come before use.
 *
 * @param modules - Array of modules (inline modules or module names)
 * @return - Array of modules
 */ parcelHelpers.export(exports, "getShaderDependencies", ()=>getShaderDependencies);
// DEPRECATED
/**
 * Instantiate shader modules and resolve any dependencies
 * @deprecated Use getShaderDpendencies
 */ parcelHelpers.export(exports, "resolveModules", ()=>resolveModules);
var _shaderModuleJs = require("./shader-module.js");
function getShaderModuleDependencies(modules) {
    (0, _shaderModuleJs.initializeShaderModules)(modules);
    const moduleMap = {};
    const moduleDepth = {};
    getDependencyGraph({
        modules,
        level: 0,
        moduleMap,
        moduleDepth
    });
    // Return a reverse sort so that dependencies come before the modules that use them
    const dependencies = Object.keys(moduleDepth).sort((a, b)=>moduleDepth[b] - moduleDepth[a]).map((name)=>moduleMap[name]);
    (0, _shaderModuleJs.initializeShaderModules)(dependencies);
    return dependencies;
}
function getDependencyGraph(options) {
    const { modules, level, moduleMap, moduleDepth } = options;
    if (level >= 5) throw new Error('Possible loop in shader dependency graph');
    // Update level on all current modules
    for (const module of modules){
        moduleMap[module.name] = module;
        if (moduleDepth[module.name] === undefined || moduleDepth[module.name] < level) moduleDepth[module.name] = level;
    }
    // Recurse
    for (const module of modules)if (module.dependencies) getDependencyGraph({
        modules: module.dependencies,
        level: level + 1,
        moduleMap,
        moduleDepth
    });
}
function getShaderDependencies(modules) {
    (0, _shaderModuleJs.initializeShaderModules)(modules);
    const moduleMap = {};
    const moduleDepth = {};
    getDependencyGraph({
        modules,
        level: 0,
        moduleMap,
        moduleDepth
    });
    // Return a reverse sort so that dependencies come before the modules that use them
    modules = Object.keys(moduleDepth).sort((a, b)=>moduleDepth[b] - moduleDepth[a]).map((name)=>moduleMap[name]);
    (0, _shaderModuleJs.initializeShaderModules)(modules);
    return modules;
}
function resolveModules(modules) {
    return getShaderDependencies(modules);
}

},{"./shader-module.js":"azfVk","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6fcAZ":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Inject a list of shader modules into a single shader source for WGSL
 */ parcelHelpers.export(exports, "assembleWGSLShader", ()=>assembleWGSLShader);
/**
 * Injects dependent shader module sources into pair of main vertex/fragment shader sources for GLSL
 */ parcelHelpers.export(exports, "assembleGLSLShaderPair", ()=>assembleGLSLShaderPair);
/**
 * Pulls together complete source code for either a vertex or a fragment shader
 * adding prologues, requested module chunks, and any final injections.
 * @param gl
 * @param options
 * @returns
 */ parcelHelpers.export(exports, "assembleShaderWGSL", ()=>assembleShaderWGSL);
/**
 * Returns a combined `getUniforms` covering the options for all the modules,
 * the created function will pass on options to the inidividual `getUniforms`
 * function of each shader module and combine the results into one object that
 * can be passed to setUniforms.
 * @param modules
 * @returns
 */ parcelHelpers.export(exports, "assembleGetUniforms", ()=>assembleGetUniforms);
/** Extracts the source code chunk for the specified shader type from the named shader module */ parcelHelpers.export(exports, "getShaderModuleSource", ()=>getShaderModuleSource) /*
function getHookFunctions(
  hookFunctions: Record<string, HookFunction>,
  hookInjections: Record<string, Injection[]>
): string {
  let result = '';
  for (const hookName in hookFunctions) {
    const hookFunction = hookFunctions[hookName];
    result += `void ${hookFunction.signature} {\n`;
    if (hookFunction.header) {
      result += `  ${hookFunction.header}`;
    }
    if (hookInjections[hookName]) {
      const injections = hookInjections[hookName];
      injections.sort((a: {order: number}, b: {order: number}): number => a.order - b.order);
      for (const injection of injections) {
        result += `  ${injection.injection}\n`;
      }
    }
    if (hookFunction.footer) {
      result += `  ${hookFunction.footer}`;
    }
    result += '}\n';
  }

  return result;
}

function normalizeHookFunctions(hookFunctions: (string | HookFunction)[]): {
  vs: Record<string, HookFunction>;
  fs: Record<string, HookFunction>;
} {
  const result: {vs: Record<string, any>; fs: Record<string, any>} = {
    vs: {},
    fs: {}
  };

  hookFunctions.forEach((hookFunction: string | HookFunction) => {
    let opts: HookFunction;
    let hook: string;
    if (typeof hookFunction !== 'string') {
      opts = hookFunction;
      hook = opts.hook;
    } else {
      opts = {} as HookFunction;
      hook = hookFunction;
    }
    hook = hook.trim();
    const [stage, signature] = hook.split(':');
    const name = hook.replace(/\(.+/, '');
    if (stage !== 'vs' && stage !== 'fs') {
      throw new Error(stage);
    }
    result[stage][name] = Object.assign(opts, {signature});
  });

  return result;
}
*/ ;
var _shaderModuleDependenciesJs = require("../shader-module/shader-module-dependencies.js");
var _platformDefinesJs = require("./platform-defines.js");
var _shaderInjectionsJs = require("./shader-injections.js");
var _transpileGlslShaderJs = require("../shader-transpiler/transpile-glsl-shader.js");
var _shaderModuleJs = require("../shader-module/shader-module.js");
var _shaderHooksJs = require("./shader-hooks.js");
var _assertJs = require("../utils/assert.js");
var _getShaderInfoJs = require("../glsl-utils/get-shader-info.js");
const INJECT_SHADER_DECLARATIONS = `\n\n${(0, _shaderInjectionsJs.DECLARATION_INJECT_MARKER)}\n`;
/**
 * Precision prologue to inject before functions are injected in shader
 * TODO - extract any existing prologue in the fragment source and move it up...
 */ const FRAGMENT_SHADER_PROLOGUE = /* glsl */ `\
precision highp float;
`;
function assembleWGSLShader(options) {
    const modules = (0, _shaderModuleDependenciesJs.getShaderModuleDependencies)(options.modules || []);
    return {
        source: assembleShaderWGSL(options.platformInfo, {
            ...options,
            source: options.source,
            stage: 'vertex',
            modules
        }),
        getUniforms: assembleGetUniforms(modules)
    };
}
function assembleGLSLShaderPair(options) {
    const { vs, fs } = options;
    const modules = (0, _shaderModuleDependenciesJs.getShaderModuleDependencies)(options.modules || []);
    return {
        vs: assembleShaderGLSL(options.platformInfo, {
            ...options,
            source: vs,
            stage: 'vertex',
            modules
        }),
        fs: assembleShaderGLSL(options.platformInfo, {
            ...options,
            // @ts-expect-error
            source: fs,
            stage: 'fragment',
            modules
        }),
        getUniforms: assembleGetUniforms(modules)
    };
}
function assembleShaderWGSL(platformInfo, options) {
    const { // id,
    source, stage, modules, // defines = {},
    hookFunctions = [], inject = {}, log } = options;
    (0, _assertJs.assert)(typeof source === 'string', 'shader source must be a string');
    // const isVertex = type === 'vs';
    // const sourceLines = source.split('\n');
    const coreSource = source;
    // Combine Module and Application Defines
    // const allDefines = {};
    // modules.forEach(module => {
    //   Object.assign(allDefines, module.getDefines());
    // });
    // Object.assign(allDefines, defines);
    // Add platform defines (use these to work around platform-specific bugs and limitations)
    // Add common defines (GLSL version compatibility, feature detection)
    // Add precision declaration for fragment shaders
    let assembledSource = '';
    //   prologue
    //     ? `\
    // ${getShaderNameDefine({id, source, type})}
    // ${getShaderType(type)}
    // ${getPlatformShaderDefines(platformInfo)}
    // ${getApplicationDefines(allDefines)}
    // ${isVertex ? '' : FRAGMENT_SHADER_PROLOGUE}
    // `
    // `;
    const hookFunctionMap = (0, _shaderHooksJs.normalizeShaderHooks)(hookFunctions);
    // Add source of dependent modules in resolved order
    const hookInjections = {};
    const declInjections = {};
    const mainInjections = {};
    for(const key in inject){
        const injection = typeof inject[key] === 'string' ? {
            injection: inject[key],
            order: 0
        } : inject[key];
        const match = /^(v|f)s:(#)?([\w-]+)$/.exec(key);
        if (match) {
            const hash = match[2];
            const name = match[3];
            if (hash) {
                if (name === 'decl') declInjections[key] = [
                    injection
                ];
                else mainInjections[key] = [
                    injection
                ];
            } else hookInjections[key] = [
                injection
            ];
        } else // Regex injection
        mainInjections[key] = [
            injection
        ];
    }
    // TODO - hack until shadertool modules support WebGPU
    const modulesToInject = modules;
    for (const module of modulesToInject){
        if (log) (0, _shaderModuleJs.checkShaderModuleDeprecations)(module, coreSource, log);
        const moduleSource = getShaderModuleSource(module, 'wgsl');
        // Add the module source, and a #define that declares it presence
        assembledSource += moduleSource;
        const injections = module.injections?.[stage] || {};
        for(const key in injections){
            const match = /^(v|f)s:#([\w-]+)$/.exec(key);
            if (match) {
                const name = match[2];
                const injectionType = name === 'decl' ? declInjections : mainInjections;
                injectionType[key] = injectionType[key] || [];
                injectionType[key].push(injections[key]);
            } else {
                hookInjections[key] = hookInjections[key] || [];
                hookInjections[key].push(injections[key]);
            }
        }
    }
    // For injectShader
    assembledSource += INJECT_SHADER_DECLARATIONS;
    assembledSource = (0, _shaderInjectionsJs.injectShader)(assembledSource, stage, declInjections);
    assembledSource += (0, _shaderHooksJs.getShaderHooks)(hookFunctionMap[stage], hookInjections);
    // Add the version directive and actual source of this shader
    assembledSource += coreSource;
    // Apply any requested shader injections
    assembledSource = (0, _shaderInjectionsJs.injectShader)(assembledSource, stage, mainInjections);
    return assembledSource;
}
/**
 * Pulls together complete source code for either a vertex or a fragment shader
 * adding prologues, requested module chunks, and any final injections.
 * @param gl
 * @param options
 * @returns
 */ function assembleShaderGLSL(platformInfo, options) {
    const { id, source, stage, language = 'glsl', modules, defines = {}, hookFunctions = [], inject = {}, prologue = true, log } = options;
    (0, _assertJs.assert)(typeof source === 'string', 'shader source must be a string');
    const sourceVersion = language === 'glsl' ? (0, _getShaderInfoJs.getShaderInfo)(source).version : -1;
    const targetVersion = platformInfo.shaderLanguageVersion;
    const sourceVersionDirective = sourceVersion === 100 ? '#version 100' : '#version 300 es';
    const sourceLines = source.split('\n');
    // TODO : keep all pre-processor statements at the beginning of the shader.
    const coreSource = sourceLines.slice(1).join('\n');
    // Combine Module and Application Defines
    const allDefines = {};
    modules.forEach((module)=>{
        Object.assign(allDefines, module.defines);
    });
    Object.assign(allDefines, defines);
    // Add platform defines (use these to work around platform-specific bugs and limitations)
    // Add common defines (GLSL version compatibility, feature detection)
    // Add precision declaration for fragment shaders
    let assembledSource = '';
    switch(language){
        case 'wgsl':
            break;
        case 'glsl':
            assembledSource = prologue ? `\
${sourceVersionDirective}

// ----- PROLOGUE -------------------------
${getShaderNameDefine({
                id,
                source,
                stage
            })}
${`#define SHADER_TYPE_${stage.toUpperCase()}`}

${(0, _platformDefinesJs.getPlatformShaderDefines)(platformInfo)}
${stage === 'fragment' ? FRAGMENT_SHADER_PROLOGUE : ''}

// ----- APPLICATION DEFINES -------------------------

${getApplicationDefines(allDefines)}

` : `${sourceVersionDirective}
`;
            break;
    }
    const hookFunctionMap = (0, _shaderHooksJs.normalizeShaderHooks)(hookFunctions);
    // Add source of dependent modules in resolved order
    const hookInjections = {};
    const declInjections = {};
    const mainInjections = {};
    for(const key in inject){
        const injection = typeof inject[key] === 'string' ? {
            injection: inject[key],
            order: 0
        } : inject[key];
        const match = /^(v|f)s:(#)?([\w-]+)$/.exec(key);
        if (match) {
            const hash = match[2];
            const name = match[3];
            if (hash) {
                if (name === 'decl') declInjections[key] = [
                    injection
                ];
                else mainInjections[key] = [
                    injection
                ];
            } else hookInjections[key] = [
                injection
            ];
        } else // Regex injection
        mainInjections[key] = [
            injection
        ];
    }
    for (const module of modules){
        if (log) (0, _shaderModuleJs.checkShaderModuleDeprecations)(module, coreSource, log);
        const moduleSource = getShaderModuleSource(module, stage);
        // Add the module source, and a #define that declares it presence
        assembledSource += moduleSource;
        const injections = module.instance?.normalizedInjections[stage] || {};
        for(const key in injections){
            const match = /^(v|f)s:#([\w-]+)$/.exec(key);
            if (match) {
                const name = match[2];
                const injectionType = name === 'decl' ? declInjections : mainInjections;
                injectionType[key] = injectionType[key] || [];
                injectionType[key].push(injections[key]);
            } else {
                hookInjections[key] = hookInjections[key] || [];
                hookInjections[key].push(injections[key]);
            }
        }
    }
    assembledSource += '// ----- MAIN SHADER SOURCE -------------------------';
    // For injectShader
    assembledSource += INJECT_SHADER_DECLARATIONS;
    assembledSource = (0, _shaderInjectionsJs.injectShader)(assembledSource, stage, declInjections);
    assembledSource += (0, _shaderHooksJs.getShaderHooks)(hookFunctionMap[stage], hookInjections);
    // Add the version directive and actual source of this shader
    assembledSource += coreSource;
    // Apply any requested shader injections
    assembledSource = (0, _shaderInjectionsJs.injectShader)(assembledSource, stage, mainInjections);
    if (language === 'glsl' && sourceVersion !== targetVersion) assembledSource = (0, _transpileGlslShaderJs.transpileGLSLShader)(assembledSource, stage);
    return assembledSource.trim();
}
function assembleGetUniforms(modules) {
    return function getUniforms(opts) {
        const uniforms = {};
        for (const module of modules){
            // `modules` is already sorted by dependency level. This guarantees that
            // modules have access to the uniforms that are generated by their dependencies.
            const moduleUniforms = module.getUniforms?.(opts, uniforms);
            Object.assign(uniforms, moduleUniforms);
        }
        return uniforms;
    };
}
/**
 * Generate "glslify-compatible" SHADER_NAME defines
 * These are understood by the GLSL error parsing function
 * If id is provided and no SHADER_NAME constant is present in source, create one
 */ function getShaderNameDefine(options) {
    const { id, source, stage } = options;
    const injectShaderName = id && source.indexOf('SHADER_NAME') === -1;
    return injectShaderName ? `
#define SHADER_NAME ${id}_${stage}` : '';
}
/** Generates application defines from an object of key value pairs */ function getApplicationDefines(defines = {}) {
    let sourceText = '';
    for(const define in defines){
        const value = defines[define];
        if (value || Number.isFinite(value)) sourceText += `#define ${define.toUpperCase()} ${defines[define]}\n`;
    }
    return sourceText;
}
function getShaderModuleSource(module, stage) {
    let moduleSource;
    switch(stage){
        case 'vertex':
            moduleSource = module.vs || '';
            break;
        case 'fragment':
            moduleSource = module.fs || '';
            break;
        case 'wgsl':
            moduleSource = module.source || '';
            break;
        default:
            (0, _assertJs.assert)(false);
    }
    if (!module.name) throw new Error('Shader module must have a name');
    const moduleName = module.name.toUpperCase().replace(/[^0-9a-z]/gi, '_');
    let source = `\
// ----- MODULE ${module.name} ---------------

`;
    if (stage !== 'wgsl') source += `#define MODULE_${moduleName}\n`;
    source += `${moduleSource}\n`;
    return source;
}

},{"../shader-module/shader-module-dependencies.js":"2p3Mz","./platform-defines.js":"dy5qa","./shader-injections.js":"iYwCC","../shader-transpiler/transpile-glsl-shader.js":"fvjci","../shader-module/shader-module.js":"azfVk","./shader-hooks.js":"kCzdO","../utils/assert.js":"cePKD","../glsl-utils/get-shader-info.js":"4Ld8H","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dy5qa":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Adds defines to help identify GPU architecture / platform */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlatformShaderDefines", ()=>getPlatformShaderDefines);
function getPlatformShaderDefines(platformInfo) {
    switch(platformInfo?.gpu.toLowerCase()){
        case 'apple':
            return /* glsl */ `\
#define APPLE_GPU
// Apple optimizes away the calculation necessary for emulated fp64
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
// Intel GPU doesn't have full 32 bits precision in same cases, causes overflow
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
        case 'nvidia':
            return /* glsl */ `\
#define NVIDIA_GPU
// Nvidia optimizes away the calculation necessary for emulated fp64
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
`;
        case 'intel':
            return /* glsl */ `\
#define INTEL_GPU
// Intel optimizes away the calculation necessary for emulated fp64
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
// Intel's built-in 'tan' function doesn't have acceptable precision
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
// Intel GPU doesn't have full 32 bits precision in same cases, causes overflow
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
        case 'amd':
            // AMD Does not eliminate fp64 code
            return /* glsl */ `\
#define AMD_GPU
`;
        default:
            // We don't know what GPU it is, could be that the GPU driver or
            // browser is not implementing UNMASKED_RENDERER constant and not
            // reporting a correct name
            return /* glsl */ `\
#define DEFAULT_GPU
// Prevent driver from optimizing away the calculation necessary for emulated fp64
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
// Headless Chrome's software shader 'tan' function doesn't have acceptable precision
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
// If the GPU doesn't have full 32 bits precision, will causes overflow
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fvjci":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// TRANSPILATION TABLES
/**
 * Transpiles GLSL 3.00 shader source code to target GLSL version (3.00 or 1.00)
 *
 * @note We always run transpiler even if same version e.g. 3.00 => 3.00
 * @note For texture sampling transpilation, apps need to use non-standard texture* calls in GLSL 3.00 source
 * RFC: https://github.com/visgl/luma.gl/blob/7.0-release/dev-docs/RFCs/v6.0/portable-glsl-300-rfc.md
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transpileGLSLShader", ()=>transpileGLSLShader);
function transpileGLSLShader(source, stage) {
    const sourceGLSLVersion = Number(source.match(/^#version[ \t]+(\d+)/m)?.[1] || 100);
    if (sourceGLSLVersion !== 300) // TODO - we splurge on a longer error message to help deck.gl custom layer developers
    throw new Error('luma.gl v9 only supports GLSL 3.00 shader sources');
    switch(stage){
        case 'vertex':
            source = convertShader(source, ES300_VERTEX_REPLACEMENTS);
            return source;
        case 'fragment':
            source = convertShader(source, ES300_FRAGMENT_REPLACEMENTS);
            return source;
        default:
            // Unknown shader stage
            throw new Error(stage);
    }
}
/** Simple regex replacements for GLSL ES 1.00 syntax that has changed in GLSL ES 3.00 */ const ES300_REPLACEMENTS = [
    // Fix poorly formatted version directive
    [
        /^(#version[ \t]+(100|300[ \t]+es))?[ \t]*\n/,
        '#version 300 es\n'
    ],
    // The individual `texture...()` functions were replaced with `texture()` overloads
    [
        /\btexture(2D|2DProj|Cube)Lod(EXT)?\(/g,
        'textureLod('
    ],
    [
        /\btexture(2D|2DProj|Cube)(EXT)?\(/g,
        'texture('
    ]
];
const ES300_VERTEX_REPLACEMENTS = [
    ...ES300_REPLACEMENTS,
    // `attribute` keyword replaced with `in`
    [
        makeVariableTextRegExp('attribute'),
        'in $1'
    ],
    // `varying` keyword replaced with `out`
    [
        makeVariableTextRegExp('varying'),
        'out $1'
    ]
];
/** Simple regex replacements for GLSL ES 1.00 syntax that has changed in GLSL ES 3.00 */ const ES300_FRAGMENT_REPLACEMENTS = [
    ...ES300_REPLACEMENTS,
    // `varying` keyword replaced with `in`
    [
        makeVariableTextRegExp('varying'),
        'in $1'
    ]
];
function convertShader(source, replacements) {
    for (const [pattern, replacement] of replacements)source = source.replace(pattern, replacement);
    return source;
}
/**
 * Creates a regexp that tests for a specific variable type
 * @example
 *   should match:
 *     in float weight;
 *     out vec4 positions[2];
 *   should not match:
 *     void f(out float a, in float b) {}
 */ function makeVariableTextRegExp(qualifier) {
    return new RegExp(`\\b${qualifier}[ \\t]+(\\w+[ \\t]+\\w+(\\[\\w+\\])?;)`, 'g');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kCzdO":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Generate hook source code */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getShaderHooks", ()=>getShaderHooks);
/**
 * Parse string based hook functions
 * And split per shader
 */ parcelHelpers.export(exports, "normalizeShaderHooks", ()=>normalizeShaderHooks);
function getShaderHooks(hookFunctions, hookInjections) {
    let result = '';
    for(const hookName in hookFunctions){
        const hookFunction = hookFunctions[hookName];
        result += `void ${hookFunction.signature} {\n`;
        if (hookFunction.header) result += `  ${hookFunction.header}`;
        if (hookInjections[hookName]) {
            const injections = hookInjections[hookName];
            injections.sort((a, b)=>a.order - b.order);
            for (const injection of injections)result += `  ${injection.injection}\n`;
        }
        if (hookFunction.footer) result += `  ${hookFunction.footer}`;
        result += '}\n';
    }
    return result;
}
function normalizeShaderHooks(hookFunctions) {
    const result = {
        vertex: {},
        fragment: {}
    };
    for (const hookFunction of hookFunctions){
        let opts;
        let hook;
        if (typeof hookFunction !== 'string') {
            opts = hookFunction;
            hook = opts.hook;
        } else {
            opts = {};
            hook = hookFunction;
        }
        hook = hook.trim();
        const [shaderStage, signature] = hook.split(':');
        const name = hook.replace(/\(.+/, '');
        const normalizedHook = Object.assign(opts, {
            signature
        });
        switch(shaderStage){
            case 'vs':
                result.vertex[name] = normalizedHook;
                break;
            case 'fs':
                result.fragment[name] = normalizedHook;
                break;
            default:
                throw new Error(shaderStage);
        }
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4Ld8H":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Extracts information from shader source code */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getShaderInfo", ()=>getShaderInfo);
function getShaderInfo(source, defaultName) {
    return {
        name: getShaderName(source, defaultName),
        language: 'glsl',
        version: getShaderVersion(source)
    };
}
/** Extracts GLSLIFY style naming of shaders: `#define SHADER_NAME ...` */ function getShaderName(shader, defaultName = 'unnamed') {
    const SHADER_NAME_REGEXP = /#define[^\S\r\n]*SHADER_NAME[^\S\r\n]*([A-Za-z0-9_-]+)\s*/;
    const match = SHADER_NAME_REGEXP.exec(shader);
    return match ? match[1] : defaultName;
}
/** returns GLSL shader version of given shader string */ function getShaderVersion(source) {
    let version = 100;
    const words = source.match(/[^\s]+/g);
    if (words && words.length >= 2 && words[0] === '#version') {
        const parsedVersion = parseInt(words[1], 10);
        if (Number.isFinite(parsedVersion)) version = parsedVersion;
    }
    if (version !== 100 && version !== 300) throw new Error(`Invalid GLSL version ${version}`);
    return version;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bsU1C":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A stateful version of `assembleShaders` that can be used to assemble shaders.
 * Supports setting of default modules and hooks.
 */ parcelHelpers.export(exports, "ShaderAssembler", ()=>ShaderAssembler);
var _shaderModuleJs = require("./shader-module/shader-module.js");
var _assembleShadersJs = require("./shader-assembly/assemble-shaders.js");
var _preprocessorJs = require("./preprocessor/preprocessor.js");
class ShaderAssembler {
    /** Default ShaderAssembler instance */ static defaultShaderAssembler;
    /** Hook functions */ _hookFunctions = [];
    /** Shader modules */ _defaultModules = [];
    /**
     * A default shader assembler instance - the natural place to register default modules and hooks
     * @returns
     */ static getDefaultShaderAssembler() {
        ShaderAssembler.defaultShaderAssembler = ShaderAssembler.defaultShaderAssembler || new ShaderAssembler();
        return ShaderAssembler.defaultShaderAssembler;
    }
    /**
     * Add a default module that does not have to be provided with every call to assembleShaders()
     */ addDefaultModule(module) {
        if (!this._defaultModules.find((m)=>m.name === (typeof module === 'string' ? module : module.name))) this._defaultModules.push(module);
    }
    /**
     * Remove a default module
     */ removeDefaultModule(module) {
        const moduleName = typeof module === 'string' ? module : module.name;
        this._defaultModules = this._defaultModules.filter((m)=>m.name !== moduleName);
    }
    /**
     * Register a shader hook
     * @param hook
     * @param opts
     */ addShaderHook(hook, opts) {
        if (opts) hook = Object.assign(opts, {
            hook
        });
        this._hookFunctions.push(hook);
    }
    /**
     * Assemble a WGSL unified shader
     * @param platformInfo
     * @param props
     * @returns
     */ assembleWGSLShader(props) {
        const modules = this._getModuleList(props.modules); // Combine with default modules
        const hookFunctions = this._hookFunctions; // TODO - combine with default hook functions
        const { source, getUniforms } = (0, _assembleShadersJs.assembleWGSLShader)({
            ...props,
            // @ts-expect-error
            source: props.source,
            modules,
            hookFunctions
        });
        // WGSL does not have built-in preprocessing support (just compile time constants)
        const preprocessedSource = props.platformInfo.shaderLanguage === 'wgsl' ? (0, _preprocessorJs.preprocess)(source) : source;
        return {
            source: preprocessedSource,
            getUniforms,
            modules
        };
    }
    /**
     * Assemble a pair of shaders into a single shader program
     * @param platformInfo
     * @param props
     * @returns
     */ assembleGLSLShaderPair(props) {
        const modules = this._getModuleList(props.modules); // Combine with default modules
        const hookFunctions = this._hookFunctions; // TODO - combine with default hook functions
        const assembled = (0, _assembleShadersJs.assembleGLSLShaderPair)({
            ...props,
            // @ts-expect-error
            vs: props.vs,
            // @ts-expect-error
            fs: props.fs,
            modules,
            hookFunctions
        });
        return {
            ...assembled,
            modules
        };
    }
    /**
     * Dedupe and combine with default modules
     */ _getModuleList(appModules = []) {
        const modules = new Array(this._defaultModules.length + appModules.length);
        const seen = {};
        let count = 0;
        for(let i = 0, len = this._defaultModules.length; i < len; ++i){
            const module = this._defaultModules[i];
            const name = module.name;
            modules[count++] = module;
            seen[name] = true;
        }
        for(let i = 0, len = appModules.length; i < len; ++i){
            const module = appModules[i];
            const name = module.name;
            if (!seen[name]) {
                modules[count++] = module;
                seen[name] = true;
            }
        }
        modules.length = count;
        (0, _shaderModuleJs.initializeShaderModules)(modules);
        return modules;
    }
}

},{"./shader-module/shader-module.js":"azfVk","./shader-assembly/assemble-shaders.js":"6fcAZ","./preprocessor/preprocessor.js":"3s7AG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3s7AG":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preprocess", ()=>preprocess);
const IFDEF_REGEXP = /^\s*\#\s*ifdef\s*([a-zA-Z_]+)\s*$/;
const ENDIF_REGEXP = /^\s*\#\s*endif\s*$/;
function preprocess(source, options) {
    const lines = source.split('\n');
    const output = [];
    let conditional = true;
    let currentDefine = null;
    for (const line of lines){
        const matchIf = line.match(IFDEF_REGEXP);
        const matchEnd = line.match(ENDIF_REGEXP);
        if (matchIf) {
            currentDefine = matchIf[1];
            conditional = Boolean(options?.defines?.[currentDefine]);
        } else if (matchEnd) conditional = true;
        else if (conditional) output.push(line);
    }
    return output.join('\n');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ebLBN":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Prase given glsl line and return qualifier details or null
parcelHelpers.export(exports, "getQualifierDetails", ()=>getQualifierDetails);
/**
 * Given the shader input and output variable names,
 * builds and return a pass through fragment shader.
 */ parcelHelpers.export(exports, "getPassthroughFS", ()=>getPassthroughFS);
/** convert glsl type to suffix */ parcelHelpers.export(exports, "typeToChannelSuffix", ()=>typeToChannelSuffix);
/** convert glsl type to channel count */ parcelHelpers.export(exports, "typeToChannelCount", ()=>typeToChannelCount);
/** Returns glsl instruction for converting to vec4 */ parcelHelpers.export(exports, "convertToVec4", ()=>convertToVec4);
const FS_GLES = /* glsl */ `\
out vec4 transform_output;
void main() {
  transform_output = vec4(0);
}`;
const FS300 = `#version 300 es\n${FS_GLES}`;
function getQualifierDetails(line, qualifiers) {
    qualifiers = Array.isArray(qualifiers) ? qualifiers : [
        qualifiers
    ];
    const words = line.replace(/^\s+/, '').split(/\s+/);
    // TODO add support for precession qualifiers (highp, mediump and lowp)
    const [qualifier, type, definition] = words;
    if (!qualifiers.includes(qualifier) || !type || !definition) return null;
    const name = definition.split(';')[0];
    return {
        qualifier,
        type,
        name
    };
}
function getPassthroughFS(options) {
    const { input, inputChannels, output } = options || {};
    if (!input) // Default shader
    return FS300;
    if (!inputChannels) throw new Error('inputChannels');
    const inputType = channelCountToType(inputChannels);
    const outputValue = convertToVec4(input, inputChannels);
    return `\
#version 300 es
in ${inputType} ${input};
out vec4 ${output};
void main() {
  ${output} = ${outputValue};
}`;
}
function typeToChannelSuffix(type) {
    // prettier-ignore
    switch(type){
        case 'float':
            return 'x';
        case 'vec2':
            return 'xy';
        case 'vec3':
            return 'xyz';
        case 'vec4':
            return 'xyzw';
        default:
            throw new Error(type);
    }
}
function typeToChannelCount(type) {
    // prettier-ignore
    switch(type){
        case 'float':
            return 1;
        case 'vec2':
            return 2;
        case 'vec3':
            return 3;
        case 'vec4':
            return 4;
        default:
            throw new Error(type);
    }
}
function channelCountToType(channels) {
    // prettier-ignore
    switch(channels){
        case 1:
            return 'float';
        case 2:
            return 'vec2';
        case 3:
            return 'vec3';
        case 4:
            return 'vec4';
        default:
            throw new Error(`invalid channels: ${channels}`);
    }
}
function convertToVec4(variable, channels) {
    // prettier-ignore
    switch(channels){
        case 1:
            return `vec4(${variable}, 0.0, 0.0, 1.0)`;
        case 2:
            return `vec4(${variable}, 0.0, 1.0)`;
        case 3:
            return `vec4(${variable}, 1.0)`;
        case 4:
            return variable;
        default:
            throw new Error(`invalid channels: ${channels}`);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cM8Ra":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse a ShaderLayout from WGSL shader source code.
 * @param source WGSL source code (can contain both @vertex and @fragment entry points)
 * @returns
 */ parcelHelpers.export(exports, "getShaderLayoutFromWGSL", ()=>getShaderLayoutFromWGSL);
var _core = require("@luma.gl/core");
var _wgslReflect = require("wgsl_reflect");
function getShaderLayoutFromWGSL(source) {
    const shaderLayout = {
        attributes: [],
        bindings: []
    };
    let parsedWGSL;
    try {
        parsedWGSL = parseWGSL(source);
    } catch (error) {
        (0, _core.log).error(error.message)();
        return shaderLayout;
    }
    for (const uniform of parsedWGSL.uniforms){
        const members = [];
        for (const attribute of uniform.type?.members || [])members.push({
            name: attribute.name,
            type: getType(attribute.type)
        });
        shaderLayout.bindings.push({
            type: 'uniform',
            name: uniform.name,
            group: uniform.group,
            location: uniform.binding,
            // @ts-expect-error TODO - unused for now but needs fixing
            members
        });
    }
    for (const texture of parsedWGSL.textures)shaderLayout.bindings.push({
        type: 'texture',
        name: texture.name,
        group: texture.group,
        location: texture.binding
    });
    for (const sampler of parsedWGSL.samplers)shaderLayout.bindings.push({
        type: 'sampler',
        name: sampler.name,
        group: sampler.group,
        location: sampler.binding
    });
    const vertex = parsedWGSL.entry.vertex[0]; // "main"
    // Vertex shader inputs
    const attributeCount = vertex?.inputs.length || 0; // inputs to "main"
    for(let i = 0; i < attributeCount; i++){
        const wgslAttribute = vertex.inputs[i];
        // locationType can be "builtin"
        if (wgslAttribute.locationType === 'location') {
            const type = getType(wgslAttribute.type);
            shaderLayout.attributes.push({
                name: wgslAttribute.name,
                location: Number(wgslAttribute.location),
                type
            });
        }
    }
    return shaderLayout;
}
/** Get a valid shader attribute type string from a wgsl-reflect type */ function getType(type) {
    return type.format ? `${type.name}<${type.format.name}>` : type.name;
}
function parseWGSL(source) {
    try {
        return new (0, _wgslReflect.WgslReflect)(source);
    } catch (error) {
        if (error instanceof Error) throw error;
        let message = 'WGSL parse error';
        if (typeof error === 'object' && error?.message) message += `: ${error.message} `;
        if (typeof error === 'object' && error?.token) message += error.token.line || '';
        throw new Error(message, {
            cause: error
        });
    }
}

},{"@luma.gl/core":"7TxCR","wgsl_reflect":"iuhA1","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7TxCR":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "luma", ()=>(0, _lumaJs.luma));
// ADAPTER (DEVICE AND GPU RESOURCE INTERFACES)
parcelHelpers.export(exports, "Adapter", ()=>(0, _adapterJs.Adapter));
parcelHelpers.export(exports, "Device", ()=>(0, _deviceJs.Device));
parcelHelpers.export(exports, "DeviceFeatures", ()=>(0, _deviceJs.DeviceFeatures));
parcelHelpers.export(exports, "DeviceLimits", ()=>(0, _deviceJs.DeviceLimits));
parcelHelpers.export(exports, "CanvasContext", ()=>(0, _canvasContextJs.CanvasContext));
parcelHelpers.export(exports, "Resource", ()=>(0, _resourceJs.Resource));
parcelHelpers.export(exports, "Buffer", ()=>(0, _bufferJs.Buffer));
parcelHelpers.export(exports, "Texture", ()=>(0, _textureJs.Texture));
parcelHelpers.export(exports, "TextureView", ()=>(0, _textureViewJs.TextureView));
parcelHelpers.export(exports, "ExternalTexture", ()=>(0, _externalTextureJs.ExternalTexture));
parcelHelpers.export(exports, "Shader", ()=>(0, _shaderJs.Shader));
parcelHelpers.export(exports, "Sampler", ()=>(0, _samplerJs.Sampler));
parcelHelpers.export(exports, "Framebuffer", ()=>(0, _framebufferJs.Framebuffer));
parcelHelpers.export(exports, "RenderPipeline", ()=>(0, _renderPipelineJs.RenderPipeline));
parcelHelpers.export(exports, "RenderPass", ()=>(0, _renderPassJs.RenderPass));
parcelHelpers.export(exports, "ComputePipeline", ()=>(0, _computePipelineJs.ComputePipeline));
parcelHelpers.export(exports, "ComputePass", ()=>(0, _computePassJs.ComputePass));
parcelHelpers.export(exports, "CommandEncoder", ()=>(0, _commandEncoderJs.CommandEncoder));
parcelHelpers.export(exports, "CommandBuffer", ()=>(0, _commandBufferJs.CommandBuffer));
parcelHelpers.export(exports, "VertexArray", ()=>(0, _vertexArrayJs.VertexArray));
parcelHelpers.export(exports, "TransformFeedback", ()=>(0, _transformFeedbackJs.TransformFeedback));
parcelHelpers.export(exports, "QuerySet", ()=>(0, _querySetJs.QuerySet));
parcelHelpers.export(exports, "PipelineLayout", ()=>(0, _pipelineLayoutJs.PipelineLayout));
// PORTABLE API - UNIFORM BUFFERS
parcelHelpers.export(exports, "UniformBufferLayout", ()=>(0, _uniformBufferLayoutJs.UniformBufferLayout));
parcelHelpers.export(exports, "UniformBlock", ()=>(0, _uniformBlockJs.UniformBlock));
parcelHelpers.export(exports, "UniformStore", ()=>(0, _uniformStoreJs.UniformStore));
// GPU TYPE UTILS - GPU MEMORY LAYOUT HELPERS - CAN BE USED BY APPS BUT MOSTLY USED INTERNALLY
parcelHelpers.export(exports, "decodeVertexFormat", ()=>(0, _decodeVertexFormatJs.decodeVertexFormat));
parcelHelpers.export(exports, "decodeShaderUniformType", ()=>(0, _decodeShaderTypesJs.decodeShaderUniformType));
parcelHelpers.export(exports, "decodeShaderAttributeType", ()=>(0, _decodeAttributeTypeJs.decodeShaderAttributeType));
parcelHelpers.export(exports, "getDataTypeFromTypedArray", ()=>(0, _vertexFormatFromAttributeJs.getDataTypeFromTypedArray));
parcelHelpers.export(exports, "getTypedArrayFromDataType", ()=>(0, _vertexFormatFromAttributeJs.getTypedArrayFromDataType));
parcelHelpers.export(exports, "getVertexFormatFromAttribute", ()=>(0, _vertexFormatFromAttributeJs.getVertexFormatFromAttribute));
parcelHelpers.export(exports, "decodeTextureFormat", ()=>(0, _decodeTextureFormatJs.decodeTextureFormat));
parcelHelpers.export(exports, "getTextureFormatCapabilities", ()=>(0, _textureFormatCapabilitiesJs.getTextureFormatCapabilities));
// INTERNAL UTILS - for use in other luma.gl modules only
parcelHelpers.export(exports, "log", ()=>(0, _logJs.log));
parcelHelpers.export(exports, "getScratchArray", ()=>(0, _arrayUtilsFlatJs.getScratchArray));
parcelHelpers.export(exports, "_BufferLayoutHelper", ()=>(0, _bufferLayoutHelperJs.BufferLayoutHelper));
parcelHelpers.export(exports, "getAttributeInfosFromLayouts", ()=>(0, _getAttributeFromLayoutsJs.getAttributeInfosFromLayouts));
parcelHelpers.export(exports, "sortedBufferLayoutByShaderSourceLocations", ()=>(0, _bufferLayoutOrderJs.sortedBufferLayoutByShaderSourceLocations));
// TEST EXPORTS
parcelHelpers.export(exports, "_getTextureFormatDefinition", ()=>(0, _textureFormatTableJs.getTextureFormatDefinition));
parcelHelpers.export(exports, "_getTextureFormatTable", ()=>(0, _textureFormatTableJs.getTextureFormatTable));
var _lumaJs = require("./adapter/luma.js");
var _adapterJs = require("./adapter/adapter.js");
var _deviceJs = require("./adapter/device.js");
var _canvasContextJs = require("./adapter/canvas-context.js");
var _resourceJs = require("./adapter/resources/resource.js");
var _bufferJs = require("./adapter/resources/buffer.js");
var _textureJs = require("./adapter/resources/texture.js");
var _textureViewJs = require("./adapter/resources/texture-view.js");
var _externalTextureJs = require("./adapter/resources/external-texture.js");
var _shaderJs = require("./adapter/resources/shader.js");
var _samplerJs = require("./adapter/resources/sampler.js");
var _framebufferJs = require("./adapter/resources/framebuffer.js");
var _renderPipelineJs = require("./adapter/resources/render-pipeline.js");
var _renderPassJs = require("./adapter/resources/render-pass.js");
var _computePipelineJs = require("./adapter/resources/compute-pipeline.js");
var _computePassJs = require("./adapter/resources/compute-pass.js");
var _commandEncoderJs = require("./adapter/resources/command-encoder.js");
var _commandBufferJs = require("./adapter/resources/command-buffer.js");
var _vertexArrayJs = require("./adapter/resources/vertex-array.js");
var _transformFeedbackJs = require("./adapter/resources/transform-feedback.js");
var _querySetJs = require("./adapter/resources/query-set.js");
var _pipelineLayoutJs = require("./adapter/resources/pipeline-layout.js");
var _uniformBufferLayoutJs = require("./portable/uniform-buffer-layout.js");
var _uniformBlockJs = require("./portable/uniform-block.js");
var _uniformStoreJs = require("./portable/uniform-store.js");
var _decodeVertexFormatJs = require("./gpu-type-utils/decode-vertex-format.js");
var _decodeShaderTypesJs = require("./gpu-type-utils/decode-shader-types.js");
var _decodeAttributeTypeJs = require("./gpu-type-utils/decode-attribute-type.js");
var _vertexFormatFromAttributeJs = require("./gpu-type-utils/vertex-format-from-attribute.js");
var _decodeTextureFormatJs = require("./gpu-type-utils/decode-texture-format.js");
var _textureFormatCapabilitiesJs = require("./gpu-type-utils/texture-format-capabilities.js");
var _logJs = require("./utils/log.js");
var _arrayUtilsFlatJs = require("./utils/array-utils-flat.js");
var _bufferLayoutHelperJs = require("./adapter-utils/buffer-layout-helper.js");
var _getAttributeFromLayoutsJs = require("./adapter-utils/get-attribute-from-layouts.js");
var _bufferLayoutOrderJs = require("./adapter-utils/buffer-layout-order.js");
var _textureFormatTableJs = require("./gpu-type-utils/texture-format-table.js");

},{"./adapter/luma.js":"caRq9","./adapter/adapter.js":"jZOWz","./adapter/device.js":"64dAV","./adapter/canvas-context.js":"30mlx","./adapter/resources/resource.js":false,"./adapter/resources/buffer.js":"hGOAm","./adapter/resources/texture.js":"gUJuc","./adapter/resources/texture-view.js":"4w1oD","./adapter/resources/external-texture.js":false,"./adapter/resources/shader.js":"a5SbE","./adapter/resources/sampler.js":"eOSB4","./adapter/resources/framebuffer.js":"2JTLp","./adapter/resources/render-pipeline.js":"isCOh","./adapter/resources/render-pass.js":"5lDGH","./adapter/resources/compute-pipeline.js":"4tPYA","./adapter/resources/compute-pass.js":false,"./adapter/resources/command-encoder.js":"6yvMS","./adapter/resources/command-buffer.js":"1NpBB","./adapter/resources/vertex-array.js":"8zNVo","./adapter/resources/transform-feedback.js":"8dFaM","./adapter/resources/query-set.js":"e3Bzu","./adapter/resources/pipeline-layout.js":false,"./portable/uniform-buffer-layout.js":false,"./portable/uniform-block.js":false,"./portable/uniform-store.js":"3UJv9","./gpu-type-utils/decode-vertex-format.js":false,"./gpu-type-utils/decode-shader-types.js":false,"./gpu-type-utils/decode-attribute-type.js":false,"./gpu-type-utils/vertex-format-from-attribute.js":"1o6YL","./gpu-type-utils/decode-texture-format.js":"7OUol","./gpu-type-utils/texture-format-capabilities.js":false,"./utils/log.js":"3Uksv","./utils/array-utils-flat.js":"hMRlV","./adapter-utils/buffer-layout-helper.js":"gtPdY","./adapter-utils/get-attribute-from-layouts.js":"54Scv","./adapter-utils/buffer-layout-order.js":"jnFyu","./gpu-type-utils/texture-format-table.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"caRq9":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Entry point to the luma.gl GPU abstraction
 * Register WebGPU and/or WebGL adapters (controls application bundle size)
 * Run-time selection of the first available Device
 */ parcelHelpers.export(exports, "Luma", ()=>Luma);
parcelHelpers.export(exports, "luma", ()=>luma);
var _env = require("@probe.gl/env");
var _deviceJs = require("./device.js");
var _statsManagerJs = require("../utils/stats-manager.js");
var _logJs = require("../utils/log.js");
const isPage = (0, _env.isBrowser)() && typeof document !== 'undefined';
const isPageLoaded = ()=>isPage && document.readyState === 'complete';
const STARTUP_MESSAGE = 'set luma.log.level=1 (or higher) to trace rendering';
const ERROR_MESSAGE = 'No matching device found. Ensure `@luma.gl/webgl` and/or `@luma.gl/webgpu` modules are imported.';
class Luma {
    static defaultProps = {
        ...(0, _deviceJs.Device).defaultProps,
        type: 'best-available',
        adapters: undefined,
        waitForPageLoad: true
    };
    /**
     * Page load promise
     * Get a 'lazy' promise that resolves when the DOM is loaded.
     * @note Since there may be limitations on number of `load` event listeners,
     * it is recommended avoid calling this function until actually needed.
     * I.e. don't call it until you know that you will be looking up a string in the DOM.
     */ static pageLoaded = getPageLoadPromise().then(()=>{
        (0, _logJs.log).probe(2, 'DOM is loaded')();
    });
    /** Global stats for all devices */ stats = (0, _statsManagerJs.lumaStats);
    /**
     * Global log
     *
     * Assign luma.log.level in console to control logging: \
     * 0: none, 1: minimal, 2: verbose, 3: attribute/uniforms, 4: gl logs
     * luma.log.break[], set to gl funcs, luma.log.profile[] set to model names`;
     */ log = (0, _logJs.log);
    /** Version of luma.gl */ VERSION = "9.1.9";
    spector;
    preregisteredAdapters = new Map();
    constructor(){
        if (globalThis.luma) {
            if (globalThis.luma.VERSION !== this.VERSION) {
                (0, _logJs.log).error(`Found luma.gl ${globalThis.luma.VERSION} while initialzing ${this.VERSION}`)();
                (0, _logJs.log).error(`'yarn why @luma.gl/core' can help identify the source of the conflict`)();
                throw new Error(`luma.gl - multiple versions detected: see console log`);
            }
            (0, _logJs.log).error('This version of luma.gl has already been initialized')();
        }
        (0, _logJs.log).log(1, `${this.VERSION} - ${STARTUP_MESSAGE}`)();
        globalThis.luma = this;
    }
    registerAdapters(adapters) {
        for (const deviceClass of adapters)this.preregisteredAdapters.set(deviceClass.type, deviceClass);
    }
    /** Get type strings for supported Devices */ getSupportedAdapters(adapters = []) {
        const adapterMap = this.getAdapterMap(adapters);
        return Array.from(adapterMap).map(([, adapter])=>adapter).filter((adapter)=>adapter.isSupported?.()).map((adapter)=>adapter.type);
    }
    /** Get type strings for best available Device */ getBestAvailableAdapter(adapters = []) {
        const adapterMap = this.getAdapterMap(adapters);
        if (adapterMap.get('webgpu')?.isSupported?.()) return 'webgpu';
        if (adapterMap.get('webgl')?.isSupported?.()) return 'webgl';
        return null;
    }
    setDefaultDeviceProps(props) {
        Object.assign(Luma.defaultProps, props);
    }
    /** Creates a device. Asynchronously. */ async createDevice(props = {}) {
        props = {
            ...Luma.defaultProps,
            ...props
        };
        if (props.waitForPageLoad) // || props.createCanvasContext) {
        await Luma.pageLoaded;
        const adapterMap = this.getAdapterMap(props.adapters);
        let type = props.type || '';
        if (type === 'best-available') type = this.getBestAvailableAdapter(props.adapters) || type;
        const adapters = this.getAdapterMap(props.adapters) || adapterMap;
        const adapter = adapters.get(type);
        const device = await adapter?.create?.(props);
        if (device) return device;
        throw new Error(ERROR_MESSAGE);
    }
    /** Attach to an existing GPU API handle (WebGL2RenderingContext or GPUDevice). */ async attachDevice(props) {
        const adapters = this.getAdapterMap(props.adapters);
        // WebGL
        let type = '';
        if (props.handle instanceof WebGL2RenderingContext) type = 'webgl';
        if (props.createCanvasContext) await Luma.pageLoaded;
        // TODO - WebGPU does not yet have a stable API
        // if (props.handle instanceof GPUDevice) {
        //   const WebGPUDevice = adapters.get('webgpu') as any;
        //   if (WebGPUDevice) {
        //     return (await WebGPUDevice.attach(props.handle)) as Device;
        //   }
        // }
        // null
        if (props.handle === null) type = 'unknown';
        const adapter = adapters.get(type);
        const device = await adapter?.attach?.(null);
        if (device) return device;
        throw new Error(ERROR_MESSAGE);
    }
    /**
     * Override `HTMLCanvasContext.getCanvas()` to always create WebGL2 contexts with additional WebGL1 compatibility.
     * Useful when attaching luma to a context from an external library does not support creating WebGL2 contexts.
     */ enforceWebGL2(enforce = true, adapters = []) {
        const adapterMap = this.getAdapterMap(adapters);
        const webgl2Adapter = adapterMap.get('webgl');
        if (!webgl2Adapter) (0, _logJs.log).warn('enforceWebGL2: webgl adapter not found')();
        webgl2Adapter?.enforceWebGL2?.(enforce);
    }
    /** Convert a list of adapters to a map */ getAdapterMap(adapters = []) {
        const map = new Map(this.preregisteredAdapters);
        for (const adapter of adapters)map.set(adapter.type, adapter);
        return map;
    }
    // DEPRECATED
    /** @deprecated Use registerAdapters */ registerDevices(deviceClasses) {
        (0, _logJs.log).warn('luma.registerDevices() is deprecated, use luma.registerAdapters() instead');
        for (const deviceClass of deviceClasses){
            const adapter = deviceClass.adapter;
            if (adapter) this.preregisteredAdapters.set(adapter.type, adapter);
        }
    }
}
const luma = new Luma();
// HELPER FUNCTIONS
/** Returns a promise that resolves when the page is loaded */ function getPageLoadPromise() {
    if (isPageLoaded() || typeof window === 'undefined') return Promise.resolve();
    return new Promise((resolve)=>{
        window.addEventListener('load', ()=>resolve());
    });
}

},{"@probe.gl/env":"hQL54","./device.js":"64dAV","../utils/stats-manager.js":"gKaAd","../utils/log.js":"3Uksv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"64dAV":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Limits for a device (max supported sizes of resources, max number of bindings etc) */ parcelHelpers.export(exports, "DeviceLimits", ()=>DeviceLimits);
/** Set-like class for features (lets apps check for WebGL / WebGPU extensions) */ parcelHelpers.export(exports, "DeviceFeatures", ()=>DeviceFeatures);
/**
 * WebGPU Device/WebGL context abstraction
 */ parcelHelpers.export(exports, "Device", ()=>Device);
var _statsManagerJs = require("../utils/stats-manager.js");
var _logJs = require("../utils/log.js");
var _uidJs = require("../utils/uid.js");
var _bufferJs = require("./resources/buffer.js");
var _decodeTextureFormatJs = require("../gpu-type-utils/decode-texture-format.js");
var _textureFormatCapabilitiesJs = require("../gpu-type-utils/texture-format-capabilities.js");
class DeviceLimits {
}
class DeviceFeatures {
    features;
    disabledFeatures;
    constructor(features = [], disabledFeatures){
        this.features = new Set(features);
        this.disabledFeatures = disabledFeatures || {};
    }
    *[Symbol.iterator]() {
        yield* this.features;
    }
    has(feature) {
        return !this.disabledFeatures?.[feature] && this.features.has(feature);
    }
}
class Device {
    static defaultProps = {
        id: null,
        powerPreference: 'high-performance',
        failIfMajorPerformanceCaveat: false,
        createCanvasContext: undefined,
        // Callbacks
        onError: (error)=>(0, _logJs.log).error(error.message)(),
        // Experimental
        _reuseDevices: false,
        _requestMaxLimits: true,
        _factoryDestroyPolicy: 'unused',
        // TODO - Change these after confirming things work as expected
        _initializeFeatures: true,
        _disabledFeatures: {
            'compilation-status-async-webgl': true
        },
        _resourceDefaults: {},
        // WebGL specific
        webgl: {},
        debug: (0, _logJs.log).get('debug') || undefined,
        debugShaders: (0, _logJs.log).get('debug-shaders') || undefined,
        debugFramebuffers: Boolean((0, _logJs.log).get('debug-framebuffers')),
        debugWebGL: Boolean((0, _logJs.log).get('debug-webgl')),
        debugSpectorJS: undefined,
        debugSpectorJSUrl: undefined,
        // INTERNAL
        _handle: undefined
    };
    get [Symbol.toStringTag]() {
        return 'Device';
    }
    constructor(props){
        this.props = {
            ...Device.defaultProps,
            ...props
        };
        this.id = this.props.id || (0, _uidJs.uid)(this[Symbol.toStringTag].toLowerCase());
    }
    /** id of this device, primarily for debugging */ id;
    /** A copy of the device props  */ props;
    /** Available for the application to store data on the device */ userData = {};
    /** stats */ statsManager = (0, _statsManagerJs.lumaStats);
    /** An abstract timestamp used for change tracking */ timestamp = 0;
    /** True if this device has been reused during device creation (app has multiple references) */ _reused = false;
    /** Used by other luma.gl modules to store data on the device */ _lumaData = {};
    /** Determines what operations are supported on a texture format, checking against supported device features */ getTextureFormatCapabilities(format) {
        const genericCapabilities = (0, _textureFormatCapabilitiesJs.getTextureFormatCapabilities)(format);
        // Check standard features
        const checkFeature = (featureOrBoolean)=>(typeof featureOrBoolean === 'string' ? this.features.has(featureOrBoolean) : featureOrBoolean) ?? true;
        const supported = checkFeature(genericCapabilities.create);
        const deviceCapabilities = {
            format,
            create: supported,
            render: supported && checkFeature(genericCapabilities.render),
            filter: supported && checkFeature(genericCapabilities.filter),
            blend: supported && checkFeature(genericCapabilities.blend),
            store: supported && checkFeature(genericCapabilities.store)
        };
        return this._getDeviceSpecificTextureFormatCapabilities(deviceCapabilities);
    }
    /** Check if device supports a specific texture format (creation and `nearest` sampling) */ isTextureFormatSupported(format, capabilities) {
        return this.getTextureFormatCapabilities(format).create;
    }
    /** Check if linear filtering (sampler interpolation) is supported for a specific texture format */ isTextureFormatFilterable(format) {
        return this.getTextureFormatCapabilities(format).filter;
    }
    /** Check if device supports rendering to a framebuffer color attachment of a specific texture format */ isTextureFormatRenderable(format) {
        return this.getTextureFormatCapabilities(format).render;
    }
    /** Check if a specific texture format is GPU compressed */ isTextureFormatCompressed(format) {
        return (0, _decodeTextureFormatJs.isTextureFormatCompressed)(format);
    }
    /**
     * Trigger device loss.
     * @returns `true` if context loss could actually be triggered.
     * @note primarily intended for testing how application reacts to device loss
     */ loseDevice() {
        return false;
    }
    /** Report error (normally called for unhandled device errors) */ reportError(error) {
        this.props.onError(error);
    }
    /** Returns the default / primary canvas context. Throws an error if no canvas context is available (a WebGPU compute device) */ getDefaultCanvasContext() {
        if (!this.canvasContext) throw new Error('Device has no default CanvasContext. See props.createCanvasContext');
        return this.canvasContext;
    }
    createCommandEncoder(props = {}) {
        throw new Error('not implemented');
    }
    /** A monotonic counter for tracking buffer and texture updates */ incrementTimestamp() {
        return this.timestamp++;
    }
    // Error Handling
    /** Report unhandled device errors */ onError(error) {
        this.props.onError(error);
    }
    // DEPRECATED METHODS
    /** @deprecated Use getDefaultCanvasContext() */ getCanvasContext() {
        return this.getDefaultCanvasContext();
    }
    // WebGL specific HACKS - enables app to remove webgl import
    // Use until we have a better way to handle these
    /** @deprecated - will be removed - should use command encoder */ readPixelsToArrayWebGL(source, options) {
        throw new Error('not implemented');
    }
    /** @deprecated - will be removed - should use command encoder */ readPixelsToBufferWebGL(source, options) {
        throw new Error('not implemented');
    }
    /** @deprecated - will be removed - should use WebGPU parameters (pipeline) */ setParametersWebGL(parameters) {
        throw new Error('not implemented');
    }
    /** @deprecated - will be removed - should use WebGPU parameters (pipeline) */ getParametersWebGL(parameters) {
        throw new Error('not implemented');
    }
    /** @deprecated - will be removed - should use WebGPU parameters (pipeline) */ withParametersWebGL(parameters, func) {
        throw new Error('not implemented');
    }
    /** @deprecated - will be removed - should use clear arguments in RenderPass */ clearWebGL(options) {
        throw new Error('not implemented');
    }
    /** @deprecated - will be removed - should use for debugging only */ resetWebGL() {
        throw new Error('not implemented');
    }
    // IMPLEMENTATION
    /** Helper to get the canvas context props */ static _getCanvasContextProps(props) {
        return props.createCanvasContext === true ? {} : props.createCanvasContext;
    }
    /** Subclasses use this to support .createBuffer() overloads */ _normalizeBufferProps(props) {
        if (props instanceof ArrayBuffer || ArrayBuffer.isView(props)) props = {
            data: props
        };
        // TODO - fragile, as this is done before we merge with default options
        // inside the Buffer constructor
        const newProps = {
            ...props
        };
        // Deduce indexType
        if ((props.usage || 0) & (0, _bufferJs.Buffer).INDEX && !props.indexType) {
            if (props.data instanceof Uint32Array) newProps.indexType = 'uint32';
            else if (props.data instanceof Uint16Array) newProps.indexType = 'uint16';
            else (0, _logJs.log).warn('indices buffer content must be of integer type')();
        }
        return newProps;
    }
}

},{"../utils/stats-manager.js":"gKaAd","../utils/log.js":"3Uksv","../utils/uid.js":"3tU6J","./resources/buffer.js":"hGOAm","../gpu-type-utils/decode-texture-format.js":"7OUol","../gpu-type-utils/texture-format-capabilities.js":"bfqP2","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gKaAd":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Helper class managing a collection of probe.gl stats objects
 */ parcelHelpers.export(exports, "StatsManager", ()=>StatsManager);
parcelHelpers.export(exports, "lumaStats", ()=>lumaStats);
var _stats = require("@probe.gl/stats");
class StatsManager {
    stats = new Map();
    getStats(name) {
        return this.get(name);
    }
    get(name) {
        if (!this.stats.has(name)) this.stats.set(name, new (0, _stats.Stats)({
            id: name
        }));
        return this.stats.get(name);
    }
}
const lumaStats = new StatsManager();

},{"@probe.gl/stats":"GKYog","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"GKYog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Stats", ()=>(0, _statsJsDefault.default));
parcelHelpers.export(exports, "Stat", ()=>(0, _statJsDefault.default));
// UTILITIES
parcelHelpers.export(exports, "_getHiResTimestamp", ()=>(0, _hiResTimestampJsDefault.default));
var _statsJs = require("./lib/stats.js");
var _statsJsDefault = parcelHelpers.interopDefault(_statsJs);
var _statJs = require("./lib/stat.js");
var _statJsDefault = parcelHelpers.interopDefault(_statJs);
var _hiResTimestampJs = require("./utils/hi-res-timestamp.js");
var _hiResTimestampJsDefault = parcelHelpers.interopDefault(_hiResTimestampJs);

},{"./lib/stats.js":"1Bbyk","./lib/stat.js":"3Oj4I","./utils/hi-res-timestamp.js":"4QCIG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1Bbyk":[function(require,module,exports,__globalThis) {
// probe.gl, MIT license
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _statJs = require("./stat.js");
var _statJsDefault = parcelHelpers.interopDefault(_statJs);
class Stats {
    constructor(options){
        this.stats = {};
        this.id = options.id;
        this.stats = {};
        this._initializeStats(options.stats);
        Object.seal(this);
    }
    /** Acquire a stat. Create if it doesn't exist. */ get(name, type = 'count') {
        return this._getOrCreate({
            name,
            type
        });
    }
    get size() {
        return Object.keys(this.stats).length;
    }
    /** Reset all stats */ reset() {
        for (const stat of Object.values(this.stats))stat.reset();
        return this;
    }
    forEach(fn) {
        for (const stat of Object.values(this.stats))fn(stat);
    }
    getTable() {
        const table = {};
        this.forEach((stat)=>{
            table[stat.name] = {
                time: stat.time || 0,
                count: stat.count || 0,
                average: stat.getAverageTime() || 0,
                hz: stat.getHz() || 0
            };
        });
        return table;
    }
    _initializeStats(stats = []) {
        stats.forEach((stat)=>this._getOrCreate(stat));
    }
    _getOrCreate(stat) {
        const { name, type } = stat;
        let result = this.stats[name];
        if (!result) {
            if (stat instanceof (0, _statJsDefault.default)) result = stat;
            else result = new (0, _statJsDefault.default)(name, type);
            this.stats[name] = result;
        }
        return result;
    }
}
exports.default = Stats;

},{"./stat.js":"3Oj4I","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3Oj4I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hiResTimestampJs = require("../utils/hi-res-timestamp.js");
var _hiResTimestampJsDefault = parcelHelpers.interopDefault(_hiResTimestampJs);
class Stat {
    constructor(name, type){
        this.sampleSize = 1;
        this.time = 0;
        this.count = 0;
        this.samples = 0;
        this.lastTiming = 0;
        this.lastSampleTime = 0;
        this.lastSampleCount = 0;
        this._count = 0;
        this._time = 0;
        this._samples = 0;
        this._startTime = 0;
        this._timerPending = false;
        this.name = name;
        this.type = type;
        this.reset();
    }
    reset() {
        this.time = 0;
        this.count = 0;
        this.samples = 0;
        this.lastTiming = 0;
        this.lastSampleTime = 0;
        this.lastSampleCount = 0;
        this._count = 0;
        this._time = 0;
        this._samples = 0;
        this._startTime = 0;
        this._timerPending = false;
        return this;
    }
    setSampleSize(samples) {
        this.sampleSize = samples;
        return this;
    }
    /** Call to increment count (+1) */ incrementCount() {
        this.addCount(1);
        return this;
    }
    /** Call to decrement count (-1) */ decrementCount() {
        this.subtractCount(1);
        return this;
    }
    /** Increase count */ addCount(value) {
        this._count += value;
        this._samples++;
        this._checkSampling();
        return this;
    }
    /** Decrease count */ subtractCount(value) {
        this._count -= value;
        this._samples++;
        this._checkSampling();
        return this;
    }
    /** Add an arbitrary timing and bump the count */ addTime(time) {
        this._time += time;
        this.lastTiming = time;
        this._samples++;
        this._checkSampling();
        return this;
    }
    /** Start a timer */ timeStart() {
        this._startTime = (0, _hiResTimestampJsDefault.default)();
        this._timerPending = true;
        return this;
    }
    /** End a timer. Adds to time and bumps the timing count. */ timeEnd() {
        if (!this._timerPending) return this;
        this.addTime((0, _hiResTimestampJsDefault.default)() - this._startTime);
        this._timerPending = false;
        this._checkSampling();
        return this;
    }
    getSampleAverageCount() {
        return this.sampleSize > 0 ? this.lastSampleCount / this.sampleSize : 0;
    }
    /** Calculate average time / count for the previous window */ getSampleAverageTime() {
        return this.sampleSize > 0 ? this.lastSampleTime / this.sampleSize : 0;
    }
    /** Calculate counts per second for the previous window */ getSampleHz() {
        return this.lastSampleTime > 0 ? this.sampleSize / (this.lastSampleTime / 1000) : 0;
    }
    getAverageCount() {
        return this.samples > 0 ? this.count / this.samples : 0;
    }
    /** Calculate average time / count */ getAverageTime() {
        return this.samples > 0 ? this.time / this.samples : 0;
    }
    /** Calculate counts per second */ getHz() {
        return this.time > 0 ? this.samples / (this.time / 1000) : 0;
    }
    _checkSampling() {
        if (this._samples === this.sampleSize) {
            this.lastSampleTime = this._time;
            this.lastSampleCount = this._count;
            this.count += this._count;
            this.time += this._time;
            this.samples += this._samples;
            this._time = 0;
            this._count = 0;
            this._samples = 0;
        }
    }
}
exports.default = Stat;

},{"../utils/hi-res-timestamp.js":"4QCIG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4QCIG":[function(require,module,exports,__globalThis) {
// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHiResTimestamp);
function getHiResTimestamp() {
    let timestamp;
    // Get best timer available.
    if (typeof window !== 'undefined' && window.performance) timestamp = window.performance.now();
    else timestamp = Date.now();
    return timestamp;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3Uksv":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "log", ()=>log);
var _log = require("@probe.gl/log");
const log = new (0, _log.Log)({
    id: 'luma.gl'
});

},{"@probe.gl/log":"fwng6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3tU6J":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a UID.
 * @param id= - Identifier base name
 * @return uid
 **/ parcelHelpers.export(exports, "uid", ()=>uid);
const uidCounters = {};
function uid(id = 'id') {
    uidCounters[id] = uidCounters[id] || 1;
    const count = uidCounters[id]++;
    return `${id}-${count}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hGOAm":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Abstract GPU buffer */ parcelHelpers.export(exports, "Buffer", ()=>Buffer);
var _resourceJs = require("./resource.js");
class Buffer extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        usage: 0,
        byteLength: 0,
        byteOffset: 0,
        data: null,
        indexType: 'uint16',
        mappedAtCreation: false
    };
    // Usage Flags
    static MAP_READ = 0x01;
    static MAP_WRITE = 0x02;
    static COPY_SRC = 0x0004;
    static COPY_DST = 0x0008;
    /** Index buffer */ static INDEX = 0x0010;
    /** Vertex buffer */ static VERTEX = 0x0020;
    /** Uniform buffer */ static UNIFORM = 0x0040;
    /** Storage buffer */ static STORAGE = 0x0080;
    static INDIRECT = 0x0100;
    static QUERY_RESOLVE = 0x0200;
    get [Symbol.toStringTag]() {
        return 'Buffer';
    }
    /** The usage with which this buffer was created */ usage;
    /** For index buffers, whether indices are 16 or 32 bit */ indexType;
    /** "Time" of last update, can be used to check if redraw is needed */ updateTimestamp;
    constructor(device, props){
        const deducedProps = {
            ...props
        };
        // Deduce indexType
        if ((props.usage || 0) & Buffer.INDEX && !props.indexType) {
            if (props.data instanceof Uint32Array) deducedProps.indexType = 'uint32';
            else if (props.data instanceof Uint16Array) deducedProps.indexType = 'uint16';
        }
        // Remove data from props before storing, we don't want to hold on to a big chunk of memory
        delete deducedProps.data;
        super(device, deducedProps, Buffer.defaultProps);
        this.usage = deducedProps.usage || 0;
        this.indexType = deducedProps.indexType;
        // TODO - perhaps this should be set on async write completion?
        this.updateTimestamp = device.incrementTimestamp();
    }
    /**
     * Create a copy of this Buffer with new byteLength, with same props but of the specified size.
     * @note Does not copy contents of the cloned Buffer.
     */ clone(props) {
        return this.device.createBuffer({
            ...this.props,
            ...props
        });
    }
    /** Read data synchronously. @note WebGL2 only */ readSyncWebGL(byteOffset, byteLength) {
        throw new Error('not implemented');
    }
    // PROTECTED METHODS (INTENDED FOR USE BY OTHER FRAMEWORK CODE ONLY)
    /** Max amount of debug data saved. Two vec4's */ static DEBUG_DATA_MAX_LENGTH = 32;
    /** A partial CPU-side copy of the data in this buffer, for debugging purposes */ debugData = new ArrayBuffer(0);
    /** This doesn't handle partial non-zero offset updates correctly */ _setDebugData(data, byteOffset, byteLength) {
        const arrayBuffer = ArrayBuffer.isView(data) ? data.buffer : data;
        const debugDataLength = Math.min(data ? data.byteLength : byteLength, Buffer.DEBUG_DATA_MAX_LENGTH);
        if (arrayBuffer === null) this.debugData = new ArrayBuffer(debugDataLength);
        else if (byteOffset === 0 && byteLength === arrayBuffer.byteLength) this.debugData = arrayBuffer.slice(0, debugDataLength);
        else this.debugData = arrayBuffer.slice(byteOffset, byteOffset + debugDataLength);
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"e1oiI":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Base class for GPU (WebGPU/WebGL) Resources
 */ parcelHelpers.export(exports, "Resource", ()=>Resource);
var _uidJs = require("../../utils/uid.js");
class Resource {
    /** Default properties for resource */ static defaultProps = {
        id: 'undefined',
        handle: undefined,
        userData: undefined
    };
    toString() {
        return `${this[Symbol.toStringTag] || this.constructor.name}:"${this.id}"`;
    }
    /** props.id, for debugging. */ id;
    props;
    userData = {};
    _device;
    /** Whether this resource has been destroyed */ destroyed = false;
    /** For resources that allocate GPU memory */ allocatedBytes = 0;
    /** Attached resources will be destroyed when this resource is destroyed. Tracks auto-created "sub" resources. */ _attachedResources = new Set();
    /**
     * Create a new Resource. Called from Subclass
     */ constructor(device, props, defaultProps){
        if (!device) throw new Error('no device');
        this._device = device;
        this.props = selectivelyMerge(props, defaultProps);
        const id = this.props.id !== 'undefined' ? this.props.id : (0, _uidJs.uid)(this[Symbol.toStringTag]);
        this.props.id = id;
        this.id = id;
        this.userData = this.props.userData || {};
        this.addStats();
    }
    /**
     * destroy can be called on any resource to release it before it is garbage collected.
     */ destroy() {
        this.destroyResource();
    }
    /** @deprecated Use destroy() */ delete() {
        this.destroy();
        return this;
    }
    /**
     * Combines a map of user props and default props, only including props from defaultProps
     * @returns returns a map of overridden default props
     */ getProps() {
        return this.props;
    }
    // ATTACHED RESOURCES
    /**
     * Attaches a resource. Attached resources are auto destroyed when this resource is destroyed
     * Called automatically when sub resources are auto created but can be called by application
     */ attachResource(resource) {
        this._attachedResources.add(resource);
    }
    /**
     * Detach an attached resource. The resource will no longer be auto-destroyed when this resource is destroyed.
     */ detachResource(resource) {
        this._attachedResources.delete(resource);
    }
    /**
     * Destroys a resource (only if owned), and removes from the owned (auto-destroy) list for this resource.
     */ destroyAttachedResource(resource) {
        if (this._attachedResources.delete(resource)) resource.destroy();
    }
    /** Destroy all owned resources. Make sure the resources are no longer needed before calling. */ destroyAttachedResources() {
        for (const resource of Object.values(this._attachedResources))resource.destroy();
        // don't remove while we are iterating
        this._attachedResources = new Set();
    }
    // PROTECTED METHODS
    /** Perform all destroy steps. Can be called by derived resources when overriding destroy() */ destroyResource() {
        this.destroyAttachedResources();
        this.removeStats();
        this.destroyed = true;
    }
    /** Called by .destroy() to track object destruction. Subclass must call if overriding destroy() */ removeStats() {
        const stats = this._device.statsManager.getStats('Resource Counts');
        const name = this[Symbol.toStringTag];
        stats.get(`${name}s Active`).decrementCount();
    }
    /** Called by subclass to track memory allocations */ trackAllocatedMemory(bytes, name = this[Symbol.toStringTag]) {
        const stats = this._device.statsManager.getStats('Resource Counts');
        stats.get('GPU Memory').addCount(bytes);
        stats.get(`${name} Memory`).addCount(bytes);
        this.allocatedBytes = bytes;
    }
    /** Called by subclass to track memory deallocations */ trackDeallocatedMemory(name = this[Symbol.toStringTag]) {
        const stats = this._device.statsManager.getStats('Resource Counts');
        stats.get('GPU Memory').subtractCount(this.allocatedBytes);
        stats.get(`${name} Memory`).subtractCount(this.allocatedBytes);
        this.allocatedBytes = 0;
    }
    /** Called by resource constructor to track object creation */ addStats() {
        const stats = this._device.statsManager.getStats('Resource Counts');
        const name = this[Symbol.toStringTag];
        stats.get('Resources Created').incrementCount();
        stats.get(`${name}s Created`).incrementCount();
        stats.get(`${name}s Active`).incrementCount();
    }
}
/**
 * Combines a map of user props and default props, only including props from defaultProps
 * @param props
 * @param defaultProps
 * @returns returns a map of overridden default props
 */ function selectivelyMerge(props, defaultProps) {
    const mergedProps = {
        ...defaultProps
    };
    for(const key in props)if (props[key] !== undefined) mergedProps[key] = props[key];
    return mergedProps;
}

},{"../../utils/uid.js":"3tU6J","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7OUol":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns true if a texture format is GPU compressed
 */ parcelHelpers.export(exports, "isTextureFormatCompressed", ()=>isTextureFormatCompressed);
/**
 * Decodes a texture format, returning e.g. attatchment type, components, byte length and flags (integer, signed, normalized)
 */ parcelHelpers.export(exports, "decodeTextureFormat", ()=>decodeTextureFormat);
var _decodeDataTypeJs = require("./decode-data-type.js");
var _textureFormatTableJs = require("./texture-format-table.js");
// prettier-ignore
const COMPRESSED_TEXTURE_FORMAT_PREFIXES = [
    'bc1',
    'bc2',
    'bc3',
    'bc4',
    'bc5',
    'bc6',
    'bc7',
    'etc1',
    'etc2',
    'eac',
    'atc',
    'astc',
    'pvrtc'
];
const RGB_FORMAT_REGEX = /^(r|rg|rgb|rgba|bgra)([0-9]*)([a-z]*)(-srgb)?(-webgl)?$/;
function isTextureFormatCompressed(format) {
    return COMPRESSED_TEXTURE_FORMAT_PREFIXES.some((prefix)=>format.startsWith(prefix));
}
function decodeTextureFormat(format) {
    let formatInfo = decodeTextureFormatUsingTable(format);
    if (isTextureFormatCompressed(format)) {
        formatInfo.channels = 'rgb';
        formatInfo.components = 3;
        formatInfo.bytesPerPixel = 1;
        formatInfo.srgb = false;
        formatInfo.compressed = true;
        const blockSize = getCompressedTextureBlockSize(format);
        if (blockSize) {
            formatInfo.blockWidth = blockSize.blockWidth;
            formatInfo.blockHeight = blockSize.blockHeight;
        }
    }
    // Fill in missing information that can be derived from the format string
    const matches = RGB_FORMAT_REGEX.exec(format);
    if (matches) {
        const [, channels, length, type, srgb, suffix] = matches;
        const dataType = `${type}${length}`;
        const decodedType = (0, _decodeDataTypeJs.decodeVertexType)(dataType);
        const bits = decodedType.byteLength * 8;
        const components = channels.length;
        const bitsPerChannel = [
            bits,
            components >= 2 ? bits : 0,
            components >= 3 ? bits : 0,
            components >= 4 ? bits : 0
        ];
        formatInfo = {
            format,
            attachment: formatInfo.attachment,
            dataType: decodedType.dataType,
            components,
            channels: channels,
            integer: decodedType.integer,
            signed: decodedType.signed,
            normalized: decodedType.normalized,
            bitsPerChannel,
            bytesPerPixel: decodedType.byteLength * channels.length,
            packed: formatInfo.packed,
            srgb: formatInfo.srgb
        };
        if (suffix === '-webgl') formatInfo.webgl = true;
        // dataType - overwritten by decodedType
        if (srgb === '-srgb') formatInfo.srgb = true;
    }
    if (format.endsWith('-webgl')) formatInfo.webgl = true;
    if (format.endsWith('-srgb')) formatInfo.srgb = true;
    return formatInfo;
}
/** Decode texture format info from the table */ function decodeTextureFormatUsingTable(format) {
    const info = (0, _textureFormatTableJs.getTextureFormatDefinition)(format);
    const bytesPerPixel = info.bytesPerPixel || 1;
    const bitsPerChannel = info.bitsPerChannel || [
        8,
        8,
        8,
        8
    ];
    delete info.bitsPerChannel;
    delete info.bytesPerPixel;
    delete info.f;
    delete info.render;
    delete info.filter;
    delete info.blend;
    delete info.store;
    const formatInfo = {
        ...info,
        format,
        attachment: info.attachment || 'color',
        channels: info.channels || 'r',
        components: info.components || info.channels?.length || 1,
        bytesPerPixel,
        bitsPerChannel,
        dataType: info.dataType || 'uint8',
        srgb: info.srgb ?? false,
        packed: info.packed ?? false,
        webgl: info.webgl ?? false,
        integer: info.integer ?? false,
        signed: info.signed ?? false,
        normalized: info.normalized ?? false,
        compressed: info.compressed ?? false
    };
    return formatInfo;
}
/** Parses ASTC block widths from format string */ function getCompressedTextureBlockSize(format) {
    const REGEX = /.*-(\d+)x(\d+)-.*/;
    const matches = REGEX.exec(format);
    if (matches) {
        const [, blockWidth, blockHeight] = matches;
        return {
            blockWidth: Number(blockWidth),
            blockHeight: Number(blockHeight)
        };
    }
    return null;
} /*
'r8unorm':	{s: "float"}, // 	✓	✓	✓	},
'r8snorm':	{s: "float"}, // 		✓		},
'r8uint':	{s: "uint"}, // 	✓	✓		},
'r8sint':	{s: "sint"}, // 	✓	✓		},
'rg8unorm':	{s: "float"}, // 	✓	✓	✓	},
'rg8snorm':	{s: "float"}, // 		✓		},
'rg8uint':	{s: "uint"}, // 	✓	✓		},
'rg8sint':	{s: "sint"}, // 	✓	✓		},
'rgba8unorm':	{s: "float"}, // 	✓	✓	✓	✓},
'rgba8unorm-srgb': {s: "float"}, // 	✓	✓	✓	},
'rgba8snorm':	{s: "float"}, // 		✓		✓},
'rgba8uint':	{s: "uint"}, // 	✓	✓		✓},
'rgba8sint':	{s: "sint"}, // 	✓	✓		✓},
'bgra8unorm':	{s: "float"}, // 	✓	✓	✓	},
'bgra8unorm-srgb': {s: "float"}, // 	✓	✓	✓	},
// 16-bit per component
'r16uint': {s: "uint"}, // 	✓	✓		},
'r16sint': {s: "sint"}, // 	✓	✓		},
'r16float': {s: "float"}, // 	✓	✓	✓	},
'rg16uint': {s: "uint"}, // 	✓	✓		},
'rg16sint': {s: "sint"}, // 	✓	✓		},
'rg16float': {s: "float"}, // 	✓	✓	✓	},
'rgba16uint': {s: "uint"}, // 	✓	✓		✓},
'rgba16sint': {s: "sint"}, // 	✓	✓		✓},
'rgba16float': {s: "float"}, // 	✓	✓	✓	✓},
// 32-bit per component
'r32uint': {s: "uint"}, // 	✓			✓},
'r32sint': {s: "sint"}, // 	✓			✓},
'r32float': {"unfilterable-float"	✓	✓		✓},
'rg32uint': {s: "uint"}, // 	✓			✓},
'rg32sint': {s: "sint"}, // 	✓			✓},
'rg32float': {"unfilterable-float"	✓			✓},
'rgba32uint': {s: "uint"}, // 	✓			✓},
'rgba32sint': {s: "sint"}, // 	✓			✓},
'rgba32float': {"unfilterable-float"	✓			✓},
// mixed component width
'rgb10a2unorm': {s: "float"}, // 	✓	✓	✓	}
'rg11b10ufloat': {s: "float"}, // 		✓		}
// Format	Bytes per texel	Aspect	GPUTextureSampleType	Valid image copy source	Valid image copy destination
'stencil8': {1 − 4	stencil	"uint"	✓}
'depth16unorm': {2	depth	"depth"	✓}
'depth24plus': {4	depth	"depth"	✗}
'depth24plus': {stencil8	4 − 8	depth	"depth"	✗}
'stencil': {s: "uint"}, // 	✓}
'depth32float': {4	depth	"depth"	✓	✗}
'depth24unorm': {stencil8	4	depth	"depth"	✗}
'stencil': {s: "uint"}, // 	✓}
'depth32float': {stencil8}

// Format	Bytes per block	GPUTextureSampleType	Block Size	Feature
'rgb9e5ufloat': {c: 4, s: "float",	bpp: 4/(1*1)},

'bc1-rgba-unorm': {c: 4. s: "float", bpp: 8/(4 * 4) f: 'texture-compression-bc'},
'bc1-rgba-unorm-srgb': {c: 4. s: "float", bpp: 8/(4 * 4) f: 'texture-compression-bc'},
'bc2-rgba-unorm': {c: 4. s: "float", bpp: 16/(4 * 4) f: 'texture-compression-bc'},
'bc2-rgba-unorm-srgb': {c: 4. s: "float", bpp: 16/(4 * 4) f: 'texture-compression-bc'},
'bc3-rgba-unorm': {c: 4. s: "float", bpp: 16/(4 * 4) f: 'texture-compression-bc'},
'bc3-rgba-unorm-srgb': {c: 4. s: "float", bpp: 16/(4 * 4) f: 'texture-compression-bc'},
'bc4-r-unorm': {c: 1. s: "float", bpp: 8/(4 * 4) f: 'texture-compression-bc'},
'bc4-r-snorm': {c: 1. s: "float", bpp: 8/(4 * 4) f: 'texture-compression-bc'},
'bc5-rg-unorm': {c: 2. s: "float", bpp: 16/(4 * 4) f: 'texture-compression-bc'},
'bc5-rg-snorm': { },
'bc6h-rgb-ufloat': {	16 },
'bc6h-rgb-float': { },
'bc7-rgba-unorm': {	16 },
'bc7-rgba-unorm-srgb': { },

'etc2-rgb8unorm': {	8	"float"	4 × 4	texture-compression-etc2 },
'etc2-rgb8unorm-srgb': { },
'etc2-rgb8a1unorm': {	8 },
'etc2-rgb8a1unorm-srgb': { },
'etc2-rgba8unorm': {	16 },
'etc2-rgba8unorm-srgb': { },

'eac-r11unorm': {	8 },
'eac-r11snorm': { },
'eac-rg11unorm': {	16 },
'eac-rg11snorm': { },

'astc-4x4-unorm': {	16	"float"	4 × 4	texture-compression-astc },
'astc-4x4-unorm-srgb': { },
'astc-5x4-unorm': {	16	5 × 4 },
'astc-5x4-unorm-srgb': { },
'astc-5x5-unorm': {	16	5 × 5 },
'astc-5x5-unorm-srgb': { },
'astc-6x5-unorm': {	16	6 × 5 },
'astc-6x5-unorm-srgb': { },
'astc-6x6-unorm': {	16	6 × 6 },
'astc-6x6-unorm-srgb': { },
'astc-8x5-unorm': {	16	8 × 5 },
'astc-8x5-unorm-srgb': { },
'astc-8x6-unorm': {	16	8 × 6 },
'astc-8x6-unorm-srgb': { },
'astc-8x8-unorm': {	16	8 × 8 },
'astc-8x8-unorm-srgb': { },
'astc-10x5-unorm': {	16	10 × 5 },
'astc-10x5-unorm-srgb': { },
'astc-10x6-unorm': {	16	10 × 6 },
'astc-10x6-unorm-srgb': { },
'astc-10x8-unorm': {	16	10 × 8 },
'astc-10x8-unorm-srgb': { },
'astc-10x10-unorm': {	16	10 × 10 },
'astc-10x10-unorm-srgb': { },
'astc-12x10-unorm': {	16	12 × 10 },
'astc-12x10-unorm-srgb': { },
'astc-12x12-unorm': {	16 },
*/ 

},{"./decode-data-type.js":"c4uI5","./texture-format-table.js":"9REHK","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"c4uI5":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Decodes a vertex type, returning byte length and flags (integer, signed, normalized) */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeVertexType", ()=>decodeVertexType);
function decodeVertexType(type) {
    const dataType = TYPE_MAP[type];
    const bytes = getDataTypeBytes(dataType);
    const normalized = type.includes('norm');
    const integer = !normalized && !type.startsWith('float');
    const signed = type.startsWith('s');
    return {
        dataType: TYPE_MAP[type],
        byteLength: bytes,
        integer,
        signed,
        normalized
    };
}
function getDataTypeBytes(type) {
    const bytes = TYPE_SIZES[type];
    // assert(bytes);
    return bytes;
}
const TYPE_MAP = {
    uint8: 'uint8',
    sint8: 'sint8',
    unorm8: 'uint8',
    snorm8: 'sint8',
    uint16: 'uint16',
    sint16: 'sint16',
    unorm16: 'uint16',
    snorm16: 'sint16',
    float16: 'float16',
    float32: 'float32',
    uint32: 'uint32',
    sint32: 'sint32'
};
const TYPE_SIZES = {
    uint8: 1,
    sint8: 1,
    uint16: 2,
    sint16: 2,
    float16: 2,
    float32: 4,
    uint32: 4,
    sint32: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9REHK":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable camelcase */ // Define local device feature strings to optimize minification
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTextureFormatDefinition", ()=>getTextureFormatDefinition);
parcelHelpers.export(exports, "getTextureFormatTable", ()=>getTextureFormatTable);
const texture_compression_bc = 'texture-compression-bc';
const texture_compression_astc = 'texture-compression-astc';
const texture_compression_etc2 = 'texture-compression-etc2';
const texture_compression_etc1_webgl = 'texture-compression-etc1-webgl';
const texture_compression_pvrtc_webgl = 'texture-compression-pvrtc-webgl';
const texture_compression_atc_webgl = 'texture-compression-atc-webgl';
const float32_renderable = 'float32-renderable-webgl';
const float16_renderable = 'float16-renderable-webgl';
const rgb9e5ufloat_renderable = 'rgb9e5ufloat-renderable-webgl';
const snorm8_renderable = 'snorm8-renderable-webgl';
const norm16_renderable = 'norm16-renderable-webgl';
const snorm16_renderable = 'snorm16-renderable-webgl';
const float32_filterable = 'float32-filterable';
const float16_filterable = 'float16-filterable-webgl';
function getTextureFormatDefinition(format) {
    const info = TEXTURE_FORMAT_TABLE[format];
    if (!info) throw new Error(`Unsupported texture format ${format}`);
    return info;
}
function getTextureFormatTable() {
    return TEXTURE_FORMAT_TABLE;
}
// prettier-ignore
const TEXTURE_FORMAT_TABLE = {
    // 8-bit formats
    'r8unorm': {},
    'r8snorm': {
        render: snorm8_renderable
    },
    'r8uint': {},
    'r8sint': {},
    // 16-bit formats
    'rg8unorm': {},
    'rg8snorm': {
        render: snorm8_renderable
    },
    'rg8uint': {},
    'rg8sint': {},
    'r16uint': {},
    'r16sint': {},
    'r16float': {
        render: float16_renderable,
        filter: 'float16-filterable-webgl'
    },
    'r16unorm-webgl': {
        f: norm16_renderable
    },
    'r16snorm-webgl': {
        f: snorm16_renderable
    },
    // Packed 16-bit formats
    'rgba4unorm-webgl': {
        channels: 'rgba',
        bitsPerChannel: [
            4,
            4,
            4,
            4
        ],
        packed: true
    },
    'rgb565unorm-webgl': {
        channels: 'rgb',
        bitsPerChannel: [
            5,
            6,
            5,
            0
        ],
        packed: true
    },
    'rgb5a1unorm-webgl': {
        channels: 'rgba',
        bitsPerChannel: [
            5,
            5,
            5,
            1
        ],
        packed: true
    },
    // 24-bit formats
    'rgb8unorm-webgl': {},
    'rgb8snorm-webgl': {},
    // 32-bit formats  
    'rgba8unorm': {},
    'rgba8unorm-srgb': {},
    'rgba8snorm': {
        render: snorm8_renderable
    },
    'rgba8uint': {},
    'rgba8sint': {},
    // 32-bit, reverse colors, webgpu only
    'bgra8unorm': {},
    'bgra8unorm-srgb': {},
    'rg16uint': {},
    'rg16sint': {},
    'rg16float': {
        render: float16_renderable,
        filter: float16_filterable
    },
    'rg16unorm-webgl': {
        render: norm16_renderable
    },
    'rg16snorm-webgl': {
        render: snorm16_renderable
    },
    'r32uint': {},
    'r32sint': {},
    'r32float': {
        render: float32_renderable,
        filter: float32_filterable
    },
    // Packed 32 bit formats
    'rgb9e5ufloat': {
        channels: 'rgb',
        packed: true,
        render: rgb9e5ufloat_renderable
    },
    'rg11b10ufloat': {
        channels: 'rgb',
        bitsPerChannel: [
            11,
            11,
            10,
            0
        ],
        packed: true,
        p: 1,
        render: float32_renderable
    },
    'rgb10a2unorm': {
        channels: 'rgba',
        bitsPerChannel: [
            10,
            10,
            10,
            2
        ],
        packed: true,
        p: 1
    },
    'rgb10a2uint-webgl': {
        channels: 'rgba',
        bitsPerChannel: [
            10,
            10,
            10,
            2
        ],
        packed: true,
        p: 1,
        wgpu: false
    },
    // 48-bit formats
    'rgb16unorm-webgl': {
        f: norm16_renderable
    },
    'rgb16snorm-webgl': {
        f: norm16_renderable
    },
    // 64-bit formats
    'rg32uint': {},
    'rg32sint': {},
    'rg32float': {
        render: false,
        filter: float32_filterable
    },
    'rgba16uint': {},
    'rgba16sint': {},
    'rgba16float': {
        render: float16_renderable,
        filter: float16_filterable
    },
    'rgba16unorm-webgl': {
        render: norm16_renderable
    },
    'rgba16snorm-webgl': {
        render: snorm16_renderable
    },
    // 96-bit formats (deprecated!)
    'rgb32float-webgl': {
        render: float32_renderable,
        filter: float32_filterable
    },
    // 128-bit formats
    'rgba32uint': {},
    'rgba32sint': {},
    'rgba32float': {
        render: float32_renderable,
        filter: float32_filterable
    },
    // Depth/stencil
    // Depth and stencil formats
    stencil8: {
        attachment: 'stencil',
        bitsPerChannel: [
            8,
            0,
            0,
            0
        ],
        dataType: 'uint8'
    },
    'depth16unorm': {
        attachment: 'depth',
        bitsPerChannel: [
            16,
            0,
            0,
            0
        ],
        dataType: 'uint16'
    },
    'depth24plus': {
        attachment: 'depth',
        bitsPerChannel: [
            24,
            0,
            0,
            0
        ],
        dataType: 'uint32'
    },
    'depth32float': {
        attachment: 'depth',
        bitsPerChannel: [
            32,
            0,
            0,
            0
        ],
        dataType: 'float32'
    },
    // The depth component of the "depth24plus" and "depth24plus-stencil8" formats may be implemented as either a 24-bit depth value or a "depth32float" value.
    'depth24plus-stencil8': {
        attachment: 'depth-stencil',
        bitsPerChannel: [
            24,
            8,
            0,
            0
        ],
        packed: true
    },
    // "depth32float-stencil8" feature
    'depth32float-stencil8': {
        attachment: 'depth-stencil',
        bitsPerChannel: [
            32,
            8,
            0,
            0
        ],
        packed: true
    },
    // BC compressed formats: check device.features.has("texture-compression-bc");
    'bc1-rgb-unorm-webgl': {
        f: texture_compression_bc
    },
    'bc1-rgb-unorm-srgb-webgl': {
        f: texture_compression_bc
    },
    'bc1-rgba-unorm': {
        f: texture_compression_bc
    },
    'bc1-rgba-unorm-srgb': {
        f: texture_compression_bc
    },
    'bc2-rgba-unorm': {
        f: texture_compression_bc
    },
    'bc2-rgba-unorm-srgb': {
        f: texture_compression_bc
    },
    'bc3-rgba-unorm': {
        f: texture_compression_bc
    },
    'bc3-rgba-unorm-srgb': {
        f: texture_compression_bc
    },
    'bc4-r-unorm': {
        f: texture_compression_bc
    },
    'bc4-r-snorm': {
        f: texture_compression_bc
    },
    'bc5-rg-unorm': {
        f: texture_compression_bc
    },
    'bc5-rg-snorm': {
        f: texture_compression_bc
    },
    'bc6h-rgb-ufloat': {
        f: texture_compression_bc
    },
    'bc6h-rgb-float': {
        f: texture_compression_bc
    },
    'bc7-rgba-unorm': {
        f: texture_compression_bc
    },
    'bc7-rgba-unorm-srgb': {
        f: texture_compression_bc
    },
    // WEBGL_compressed_texture_etc: device.features.has("texture-compression-etc2")
    // Note: Supposedly guaranteed availability compressed formats in WebGL2, but through CPU decompression
    'etc2-rgb8unorm': {
        f: texture_compression_etc2
    },
    'etc2-rgb8unorm-srgb': {
        f: texture_compression_etc2
    },
    'etc2-rgb8a1unorm': {
        f: texture_compression_etc2
    },
    'etc2-rgb8a1unorm-srgb': {
        f: texture_compression_etc2
    },
    'etc2-rgba8unorm': {
        f: texture_compression_etc2
    },
    'etc2-rgba8unorm-srgb': {
        f: texture_compression_etc2
    },
    'eac-r11unorm': {
        f: texture_compression_etc2
    },
    'eac-r11snorm': {
        f: texture_compression_etc2
    },
    'eac-rg11unorm': {
        f: texture_compression_etc2
    },
    'eac-rg11snorm': {
        f: texture_compression_etc2
    },
    // X_ASTC compressed formats: device.features.has("texture-compression-astc")
    'astc-4x4-unorm': {
        f: texture_compression_astc
    },
    'astc-4x4-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-5x4-unorm': {
        f: texture_compression_astc
    },
    'astc-5x4-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-5x5-unorm': {
        f: texture_compression_astc
    },
    'astc-5x5-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-6x5-unorm': {
        f: texture_compression_astc
    },
    'astc-6x5-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-6x6-unorm': {
        f: texture_compression_astc
    },
    'astc-6x6-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-8x5-unorm': {
        f: texture_compression_astc
    },
    'astc-8x5-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-8x6-unorm': {
        f: texture_compression_astc
    },
    'astc-8x6-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-8x8-unorm': {
        f: texture_compression_astc
    },
    'astc-8x8-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-10x5-unorm': {
        f: texture_compression_astc
    },
    'astc-10x5-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-10x6-unorm': {
        f: texture_compression_astc
    },
    'astc-10x6-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-10x8-unorm': {
        f: texture_compression_astc
    },
    'astc-10x8-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-10x10-unorm': {
        f: texture_compression_astc
    },
    'astc-10x10-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-12x10-unorm': {
        f: texture_compression_astc
    },
    'astc-12x10-unorm-srgb': {
        f: texture_compression_astc
    },
    'astc-12x12-unorm': {
        f: texture_compression_astc
    },
    'astc-12x12-unorm-srgb': {
        f: texture_compression_astc
    },
    // WEBGL_compressed_texture_pvrtc
    'pvrtc-rgb4unorm-webgl': {
        f: texture_compression_pvrtc_webgl
    },
    'pvrtc-rgba4unorm-webgl': {
        f: texture_compression_pvrtc_webgl
    },
    'pvrtc-rbg2unorm-webgl': {
        f: texture_compression_pvrtc_webgl
    },
    'pvrtc-rgba2unorm-webgl': {
        f: texture_compression_pvrtc_webgl
    },
    // WEBGL_compressed_texture_etc1
    'etc1-rbg-unorm-webgl': {
        f: texture_compression_etc1_webgl
    },
    // WEBGL_compressed_texture_atc
    'atc-rgb-unorm-webgl': {
        f: texture_compression_atc_webgl
    },
    'atc-rgba-unorm-webgl': {
        f: texture_compression_atc_webgl
    },
    'atc-rgbai-unorm-webgl': {
        f: texture_compression_atc_webgl
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bfqP2":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTextureFormatCapabilities", ()=>getTextureFormatCapabilities);
var _decodeTextureFormatJs = require("./decode-texture-format.js");
var _textureFormatTableJs = require("./texture-format-table.js");
function getTextureFormatCapabilities(format) {
    const info = (0, _textureFormatTableJs.getTextureFormatDefinition)(format);
    const formatCapabilities = {
        format,
        create: info.f ?? true,
        render: info.render ?? true,
        filter: info.filter ?? true,
        blend: info.blend ?? true,
        store: info.store ?? true
    };
    const formatInfo = (0, _decodeTextureFormatJs.decodeTextureFormat)(format);
    const isDepthStencil = format.startsWith('depth') || format.startsWith('stencil');
    const isSigned = formatInfo?.signed;
    const isInteger = formatInfo?.integer;
    const isWebGLSpecific = formatInfo?.webgl;
    // signed formats are not renderable
    formatCapabilities.render &&= !isSigned;
    // signed and integer formats are not filterable
    formatCapabilities.filter &&= !isDepthStencil && !isSigned && !isInteger && !isWebGLSpecific;
    return formatCapabilities;
}

},{"./decode-texture-format.js":"7OUol","./texture-format-table.js":"9REHK","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jZOWz":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Create and attach devices for a specific backend.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adapter", ()=>Adapter);
class Adapter {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"30mlx":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages a canvas. Supports both HTML or offscreen canvas
 * - Creates a new canvas or looks up a canvas from the DOM
 * - Provides check for DOM loaded
 * @todo commit(): https://github.com/w3ctag/design-reviews/issues/288
 * @todo transferControlToOffscreen: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/transferControlToOffscreen
 */ parcelHelpers.export(exports, "CanvasContext", ()=>CanvasContext);
var _env = require("@probe.gl/env");
var _logJs = require("../utils/log.js");
var _uidJs = require("../utils/uid.js");
class CanvasContext {
    static defaultProps = {
        canvas: null,
        width: 800,
        height: 600,
        useDevicePixels: true,
        autoResize: true,
        container: null,
        visible: true,
        alphaMode: 'opaque',
        colorSpace: 'srgb'
    };
    id;
    props;
    canvas;
    htmlCanvas;
    offscreenCanvas;
    type;
    width = 1;
    height = 1;
    resizeObserver;
    /** State used by luma.gl classes: TODO - move to canvasContext*/ _canvasSizeInfo = {
        clientWidth: 0,
        clientHeight: 0,
        devicePixelRatio: 1
    };
    toString() {
        return `${this[Symbol.toStringTag]}(${this.id})`;
    }
    constructor(props){
        this.props = {
            ...CanvasContext.defaultProps,
            ...props
        };
        props = this.props;
        if (!(0, _env.isBrowser)()) {
            this.id = 'node-canvas-context';
            this.type = 'node';
            this.width = this.props.width;
            this.height = this.props.height;
            // TODO - does this prevent app from using jsdom style polyfills?
            this.canvas = null;
            return;
        }
        if (!props.canvas) {
            const canvas = createCanvas(props);
            const container = getContainer(props?.container || null);
            container.insertBefore(canvas, container.firstChild);
            this.canvas = canvas;
            if (!props?.visible) this.canvas.style.visibility = 'hidden';
        } else if (typeof props.canvas === 'string') this.canvas = getCanvasFromDOM(props.canvas);
        else this.canvas = props.canvas;
        if (this.canvas instanceof HTMLCanvasElement) {
            this.id = this.canvas.id;
            this.type = 'html-canvas';
            this.htmlCanvas = this.canvas;
        } else {
            this.id = 'offscreen-canvas';
            this.type = 'offscreen-canvas';
            this.offscreenCanvas = this.canvas;
        }
        // React to size changes
        if (this.canvas instanceof HTMLCanvasElement && props.autoResize) {
            this.resizeObserver = new ResizeObserver((entries)=>{
                for (const entry of entries)if (entry.target === this.canvas) this.update();
            });
            this.resizeObserver.observe(this.canvas);
        }
    }
    /**
     * Returns the current DPR, if props.useDevicePixels is true
     * Device refers to physical
     */ getDevicePixelRatio(useDevicePixels) {
        if (typeof OffscreenCanvas !== 'undefined' && this.canvas instanceof OffscreenCanvas) return 1;
        useDevicePixels = useDevicePixels === undefined ? this.props.useDevicePixels : useDevicePixels;
        if (!useDevicePixels || useDevicePixels <= 0) return 1;
        // The param was mainly provide to support the test cases, could be removed
        if (useDevicePixels === true) {
            const dpr = typeof window !== 'undefined' && window.devicePixelRatio;
            return dpr || 1;
        }
        return useDevicePixels;
    }
    /**
     * Returns the size of drawing buffer in device pixels.
     * @note This can be different from the 'CSS' size of a canvas, and also from the
     * canvas' internal drawing buffer size (.width, .height).
     * This is the size required to cover the canvas, adjusted for DPR
     */ getPixelSize() {
        switch(this.type){
            case 'node':
                return [
                    this.width,
                    this.height
                ];
            case 'offscreen-canvas':
                return [
                    this.canvas.width,
                    this.canvas.height
                ];
            case 'html-canvas':
                const dpr = this.getDevicePixelRatio();
                const canvas = this.canvas;
                // If not attached to DOM client size can be 0
                return canvas.parentElement ? [
                    canvas.clientWidth * dpr,
                    canvas.clientHeight * dpr
                ] : [
                    this.canvas.width,
                    this.canvas.height
                ];
            default:
                throw new Error(this.type);
        }
    }
    getAspect() {
        const [width, height] = this.getPixelSize();
        return width / height;
    }
    /**
     * Returns multiplier need to convert CSS size to Device size
     */ cssToDeviceRatio() {
        try {
            // For headless gl we might have used custom width and height
            // hence use cached clientWidth
            const [drawingBufferWidth] = this.getDrawingBufferSize();
            // _canvasSizeInfo may not be populated if `setDevicePixelRatio` is never called
            const clientWidth = this._canvasSizeInfo.clientWidth || this.htmlCanvas?.clientWidth;
            return clientWidth ? drawingBufferWidth / clientWidth : 1;
        } catch  {
            return 1;
        }
    }
    /**
     * Maps CSS pixel position to device pixel position
     */ cssToDevicePixels(cssPixel, yInvert = true) {
        const ratio = this.cssToDeviceRatio();
        const [width, height] = this.getDrawingBufferSize();
        return scalePixels(cssPixel, ratio, width, height, yInvert);
    }
    /**
     * Use devicePixelRatio to set canvas width and height
     * @note this is a raw port of luma.gl v8 code. Might be worth a review
     */ setDevicePixelRatio(devicePixelRatio, options = {}) {
        if (!this.htmlCanvas) return;
        // NOTE: if options.width and options.height not used remove in v8
        let clientWidth = 'width' in options ? options.width : this.htmlCanvas.clientWidth;
        let clientHeight = 'height' in options ? options.height : this.htmlCanvas.clientHeight;
        if (!clientWidth || !clientHeight) {
            (0, _logJs.log).log(1, 'Canvas clientWidth/clientHeight is 0')();
            // by forcing devicePixel ratio to 1, we do not scale canvas.width and height in each frame.
            devicePixelRatio = 1;
            clientWidth = this.htmlCanvas.width || 1;
            clientHeight = this.htmlCanvas.height || 1;
        }
        const cachedSize = this._canvasSizeInfo;
        // Check if canvas needs to be resized
        if (cachedSize.clientWidth !== clientWidth || cachedSize.clientHeight !== clientHeight || cachedSize.devicePixelRatio !== devicePixelRatio) {
            let clampedPixelRatio = devicePixelRatio;
            const canvasWidth = Math.floor(clientWidth * clampedPixelRatio);
            const canvasHeight = Math.floor(clientHeight * clampedPixelRatio);
            this.htmlCanvas.width = canvasWidth;
            this.htmlCanvas.height = canvasHeight;
            // @ts-expect-error This only works for WebGL
            const gl = this.device.gl;
            if (gl) {
                // Note: when devicePixelRatio is too high, it is possible we might hit system limit for
                // drawing buffer width and hight, in those cases they get clamped and resulting aspect ration may not be maintained
                // for those cases, reduce devicePixelRatio.
                const [drawingBufferWidth, drawingBufferHeight] = this.getDrawingBufferSize();
                if (drawingBufferWidth !== canvasWidth || drawingBufferHeight !== canvasHeight) {
                    clampedPixelRatio = Math.min(drawingBufferWidth / clientWidth, drawingBufferHeight / clientHeight);
                    this.htmlCanvas.width = Math.floor(clientWidth * clampedPixelRatio);
                    this.htmlCanvas.height = Math.floor(clientHeight * clampedPixelRatio);
                    (0, _logJs.log).warn('Device pixel ratio clamped')();
                }
                this._canvasSizeInfo.clientWidth = clientWidth;
                this._canvasSizeInfo.clientHeight = clientHeight;
                this._canvasSizeInfo.devicePixelRatio = devicePixelRatio;
            }
        }
    }
    // PRIVATE
    /** @todo Major hack done to port the CSS methods above, base canvas context should not depend on WebGL */ getDrawingBufferSize() {
        // @ts-expect-error This only works for WebGL
        const gl = this.device.gl;
        if (!gl) // use default device pixel ratio
        return this.getPixelSize();
        return [
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ];
    }
    /**
     * Allows subclass constructor to override the canvas id for auto created canvases.
     * This can really help when debugging DOM in apps that create multiple devices
     */ _setAutoCreatedCanvasId(id) {
        if (this.htmlCanvas?.id === 'lumagl-auto-created-canvas') this.htmlCanvas.id = id;
    }
}
// HELPER FUNCTIONS
function getContainer(container) {
    if (typeof container === 'string') {
        const element = document.getElementById(container);
        if (!element) throw new Error(`${container} is not an HTML element`);
        return element;
    } else if (container) return container;
    return document.body;
}
/** Get a Canvas element from DOM id */ function getCanvasFromDOM(canvasId) {
    const canvas = document.getElementById(canvasId);
    if (!(canvas instanceof HTMLCanvasElement)) throw new Error('Object is not a canvas element');
    return canvas;
}
/** Create a new canvas */ function createCanvas(props) {
    const { width, height } = props;
    const targetCanvas = document.createElement('canvas');
    targetCanvas.id = (0, _uidJs.uid)('lumagl-auto-created-canvas');
    targetCanvas.width = width || 1;
    targetCanvas.height = height || 1;
    targetCanvas.style.width = Number.isFinite(width) ? `${width}px` : '100%';
    targetCanvas.style.height = Number.isFinite(height) ? `${height}px` : '100%';
    return targetCanvas;
}
/**
 *
 * @param pixel
 * @param ratio
 * @param width
 * @param height
 * @param yInvert
 * @returns
 */ function scalePixels(pixel, ratio, width, height, yInvert) {
    const point = pixel;
    const x = scaleX(point[0], ratio, width);
    let y = scaleY(point[1], ratio, height, yInvert);
    // Find boundaries of next pixel to provide valid range of device pixel locations
    let t = scaleX(point[0] + 1, ratio, width);
    // If next pixel's position is clamped to boundary, use it as is, otherwise subtract 1 for current pixel boundary
    const xHigh = t === width - 1 ? t : t - 1;
    t = scaleY(point[1] + 1, ratio, height, yInvert);
    let yHigh;
    if (yInvert) {
        // If next pixel's position is clamped to boundary, use it as is, otherwise clamp it to valid range
        t = t === 0 ? t : t + 1;
        // swap y and yHigh
        yHigh = y;
        y = t;
    } else // If next pixel's position is clamped to boundary, use it as is, otherwise clamp it to valid range
    yHigh = t === height - 1 ? t : t - 1;
    return {
        x,
        y,
        // when ratio < 1, current css pixel and next css pixel may point to same device pixel, set width/height to 1 in those cases.
        width: Math.max(xHigh - x + 1, 1),
        height: Math.max(yHigh - y + 1, 1)
    };
}
function scaleX(x, ratio, width) {
    // since we are rounding to nearest, when ratio > 1, edge pixels may point to out of bounds value, clamp to the limit
    const r = Math.min(Math.round(x * ratio), width - 1);
    return r;
}
function scaleY(y, ratio, height, yInvert) {
    // since we are rounding to nearest, when ratio > 1, edge pixels may point to out of bounds value, clamp to the limit
    return yInvert ? Math.max(0, height - 1 - Math.round(y * ratio)) : Math.min(Math.round(y * ratio), height - 1);
}

},{"@probe.gl/env":"hQL54","../utils/log.js":"3Uksv","../utils/uid.js":"3tU6J","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gUJuc":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract Texture interface
 * Texture Object
 * https://gpuweb.github.io/gpuweb/#gputexture
 */ parcelHelpers.export(exports, "Texture", ()=>Texture);
var _resourceJs = require("./resource.js");
class Texture extends (0, _resourceJs.Resource) {
    static COPY_SRC = 0x01;
    static COPY_DST = 0x02;
    static TEXTURE = 0x04;
    static STORAGE = 0x08;
    static RENDER_ATTACHMENT = 0x10;
    static CubeFaces = [
        '+X',
        '-X',
        '+Y',
        '-Y',
        '+Z',
        '-Z'
    ];
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        data: null,
        dimension: '2d',
        format: 'rgba8unorm',
        width: undefined,
        height: undefined,
        depth: 1,
        mipmaps: false,
        compressed: false,
        usage: 0,
        mipLevels: undefined,
        samples: undefined,
        sampler: {},
        view: undefined,
        flipY: undefined
    };
    get [Symbol.toStringTag]() {
        return 'Texture';
    }
    toString() {
        return `Texture(${this.id},${this.format},${this.width}x${this.height})`;
    }
    /** dimension of this texture */ dimension;
    /** format of this texture */ format;
    /** width in pixels of this texture */ width;
    /** height in pixels of this texture */ height;
    /** depth of this texture */ depth;
    /** mip levels in this texture */ mipLevels;
    /** "Time" of last update. Monotonically increasing timestamp. TODO move to AsyncTexture? */ updateTimestamp;
    /** Do not use directly. Create with device.createTexture() */ constructor(device, props){
        props = Texture.normalizeProps(device, props);
        super(device, props, Texture.defaultProps);
        this.dimension = this.props.dimension;
        this.format = this.props.format;
        // Size
        this.width = this.props.width;
        this.height = this.props.height;
        this.depth = this.props.depth;
        // Calculate size, if not provided
        if (this.props.width === undefined || this.props.height === undefined) {
            // @ts-ignore
            const size = Texture.getTextureDataSize(this.props.data);
            this.width = size?.width || 1;
            this.height = size?.height || 1;
        }
        // mipLevels
        // If mipmap generation is requested and mipLevels is not provided, initialize a full pyramid
        if (this.props.mipmaps && this.props.mipLevels === undefined) this.props.mipLevels = 'pyramid';
        // Auto-calculate the number of mip levels as a convenience
        // TODO - Should we clamp to 1-getMipLevelCount?
        this.mipLevels = this.props.mipLevels === 'pyramid' ? Texture.getMipLevelCount(this.width, this.height) : this.props.mipLevels || 1;
        // TODO - perhaps this should be set on async write completion?
        this.updateTimestamp = device.incrementTimestamp();
    }
    /**
     * Create a new texture with the same parameters and optionally, a different size
     * @note Textures are immutable and cannot be resized after creation, but we can create a similar texture with the same parameters but a new size.
     * @note Does not copy contents of the texture
     */ clone(size) {
        return this.device.createTexture({
            ...this.props,
            ...size
        });
    }
    /** Check if data is an external image */ static isExternalImage(data) {
        return typeof ImageData !== 'undefined' && data instanceof ImageData || typeof ImageBitmap !== 'undefined' && data instanceof ImageBitmap || typeof HTMLImageElement !== 'undefined' && data instanceof HTMLImageElement || typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement || typeof VideoFrame !== 'undefined' && data instanceof VideoFrame || typeof HTMLCanvasElement !== 'undefined' && data instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && data instanceof OffscreenCanvas;
    }
    /** Determine size (width and height) of provided image data */ static getExternalImageSize(data) {
        if (typeof ImageData !== 'undefined' && data instanceof ImageData || typeof ImageBitmap !== 'undefined' && data instanceof ImageBitmap || typeof HTMLCanvasElement !== 'undefined' && data instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && data instanceof OffscreenCanvas) return {
            width: data.width,
            height: data.height
        };
        if (typeof HTMLImageElement !== 'undefined' && data instanceof HTMLImageElement) return {
            width: data.naturalWidth,
            height: data.naturalHeight
        };
        if (typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement) return {
            width: data.videoWidth,
            height: data.videoHeight
        };
        if (typeof VideoFrame !== 'undefined' && data instanceof VideoFrame) // TODO: is this the right choice for width and height?
        return {
            width: data.displayWidth,
            height: data.displayHeight
        };
        throw new Error('Unknown image type');
    }
    /** Check if texture data is a typed array */ static isTextureLevelData(data) {
        const typedArray = data?.data;
        return ArrayBuffer.isView(typedArray);
    }
    /** Get the size of the texture described by the provided TextureData */ static getTextureDataSize(data) {
        if (!data) return null;
        if (ArrayBuffer.isView(data)) return null;
        // Recurse into arrays (array of miplevels)
        if (Array.isArray(data)) return Texture.getTextureDataSize(data[0]);
        if (Texture.isExternalImage(data)) return Texture.getExternalImageSize(data);
        if (data && typeof data === 'object' && data.constructor === Object) {
            const textureDataArray = Object.values(data);
            const untypedData = textureDataArray[0];
            return {
                width: untypedData.width,
                height: untypedData.height
            };
        }
        throw new Error('texture size deduction failed');
    }
    /**
     * Normalize TextureData to an array of TextureLevelData / ExternalImages
     * @param data
     * @param options
     * @returns array of TextureLevelData / ExternalImages
     */ static normalizeTextureData(data, options) {
        let lodArray;
        if (ArrayBuffer.isView(data)) lodArray = [
            {
                // ts-expect-error does data really need to be Uint8ClampedArray?
                data,
                width: options.width,
                height: options.height
            }
        ];
        else if (!Array.isArray(data)) lodArray = [
            data
        ];
        else lodArray = data;
        return lodArray;
    }
    /** Calculate the number of mip levels for a texture of width and height */ static getMipLevelCount(width, height) {
        return Math.floor(Math.log2(Math.max(width, height))) + 1;
    }
    /** Convert luma.gl cubemap face constants to depth index */ static getCubeFaceDepth(face) {
        // prettier-ignore
        switch(face){
            case '+X':
                return 0;
            case '-X':
                return 1;
            case '+Y':
                return 2;
            case '-Y':
                return 3;
            case '+Z':
                return 4;
            case '-Z':
                return 5;
            default:
                throw new Error(face);
        }
    }
    /** Default options */ static defaultCopyExternalImageOptions = {
        image: undefined,
        sourceX: 0,
        sourceY: 0,
        width: undefined,
        height: undefined,
        depth: 1,
        mipLevel: 0,
        x: 0,
        y: 0,
        z: 0,
        aspect: 'all',
        colorSpace: 'srgb',
        premultipliedAlpha: false,
        flipY: false
    };
    /** Ensure we have integer coordinates */ static normalizeProps(device, props) {
        const newProps = {
            ...props
        };
        // Allow device to override props (e.g. props.mipmaps)
        const overriddenDefaultProps = device?.props?._resourceDefaults?.texture || {};
        // TODO - Type issue with props.data circumvented with Object.assign
        Object.assign(newProps, overriddenDefaultProps);
        // Ensure we have integer coordinates
        const { width, height } = newProps;
        if (typeof width === 'number') newProps.width = Math.max(1, Math.ceil(width));
        if (typeof height === 'number') newProps.height = Math.max(1, Math.ceil(height));
        return newProps;
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4w1oD":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Immutable TextureView object */ parcelHelpers.export(exports, "TextureView", ()=>TextureView);
var _resourceJs = require("./resource.js");
class TextureView extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        format: undefined,
        dimension: undefined,
        aspect: 'all',
        baseMipLevel: 0,
        mipLevelCount: undefined,
        baseArrayLayer: 0,
        arrayLayerCount: undefined
    };
    get [Symbol.toStringTag]() {
        return 'TextureView';
    }
    /** Should not be constructed directly. Use `texture.createView(props)` */ constructor(device, props){
        super(device, props, TextureView.defaultProps);
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"a5SbE":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Immutable Shader object
 * In WebGPU the handle can be copied between threads
 */ parcelHelpers.export(exports, "Shader", ()=>Shader);
var _resourceJs = require("./resource.js");
// import { log } from '../../utils/log';
var _uidJs = require("../../utils/uid.js");
var _formatCompilerLogJs = require("../../adapter-utils/format-compiler-log.js");
class Shader extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        language: 'auto',
        stage: undefined,
        source: '',
        sourceMap: null,
        entryPoint: 'main',
        debugShaders: undefined
    };
    get [Symbol.toStringTag]() {
        return 'Shader';
    }
    /** The stage of this shader */ stage;
    /** The source code of this shader */ source;
    /** The compilation status of the shader. 'pending' if compilation is asynchronous, and on production */ compilationStatus = 'pending';
    /** Create a new Shader instance */ constructor(device, props){
        props = {
            ...props,
            debugShaders: props.debugShaders || device.props.debugShaders || 'errors'
        };
        super(device, {
            id: getShaderIdFromProps(props),
            ...props
        }, Shader.defaultProps);
        this.stage = this.props.stage;
        this.source = this.props.source;
    }
    /** Get compiler log synchronously (WebGL only) */ getCompilationInfoSync() {
        return null;
    }
    /** Get translated shader source in host platform's native language (HLSL, GLSL, and even GLSL ES), if available */ getTranslatedSource() {
        return null;
    }
    // PORTABLE HELPERS
    /** In browser logging of errors */ async debugShader() {
        const trigger = this.props.debugShaders;
        switch(trigger){
            case 'never':
                return;
            case 'errors':
                // On WebGL - Don't extract the log unless errors
                if (this.compilationStatus === 'success') return;
                break;
            case 'warnings':
            case 'always':
                break;
        }
        const messages = await this.getCompilationInfo();
        if (trigger === 'warnings' && messages?.length === 0) return;
        this._displayShaderLog(messages);
    }
    // PRIVATE
    /**
     * In-browser UI logging of errors
     * TODO - this HTML formatting code should not be in Device, should be pluggable
     */ _displayShaderLog(messages) {
        // Return if under Node.js / incomplete `document` polyfills
        if (typeof document === 'undefined' || !document?.createElement) return;
        const shaderName = getShaderName(this.source);
        const shaderTitle = `${this.stage} ${shaderName}`;
        let htmlLog = (0, _formatCompilerLogJs.formatCompilerLog)(messages, this.source, {
            showSourceCode: 'all',
            html: true
        });
        // Show translated source if available
        const translatedSource = this.getTranslatedSource();
        if (translatedSource) htmlLog += `<br /><br /><h1>Translated Source</h1><br /><br /><code style="user-select:text;"><pre>${translatedSource}</pre></code>`;
        // Make it clickable so we can copy to clipboard
        const button = document.createElement('Button');
        button.innerHTML = `
<h1>Shader Compilation Error in ${shaderTitle}</h1><br /><br />
<code style="user-select:text;"><pre>
${htmlLog}
</pre></code>`;
        button.style.top = '10px';
        button.style.left = '10px';
        button.style.position = 'absolute';
        button.style.zIndex = '9999';
        button.style.width = '100%';
        button.style.textAlign = 'left';
        document.body.appendChild(button);
        const errors = document.getElementsByClassName('luma-compiler-log-error');
        errors[0]?.scrollIntoView();
        // TODO - add a small embedded copy button (instead of main button)
        button.onclick = ()=>{
            // const source = this.source.replaceAll('\n', '<br />');
            const dataURI = `data:text/plain,${encodeURIComponent(this.source)}`;
            navigator.clipboard.writeText(dataURI);
        };
    // TODO - add a small embedded close button
    }
}
// HELPERS
/** Deduce an id, from shader source, or supplied id, or shader type */ function getShaderIdFromProps(props) {
    return getShaderName(props.source) || props.id || (0, _uidJs.uid)(`unnamed ${props.stage}-shader`);
}
/** Extracts GLSLIFY style naming of shaders: `#define SHADER_NAME ...` */ function getShaderName(shader, defaultName = 'unnamed') {
    const SHADER_NAME_REGEXP = /#define[\s*]SHADER_NAME[\s*]([A-Za-z0-9_-]+)[\s*]/;
    const match = SHADER_NAME_REGEXP.exec(shader);
    return match ? match[1] : defaultName;
}

},{"./resource.js":"e1oiI","../../utils/uid.js":"3tU6J","../../adapter-utils/format-compiler-log.js":"5Tnyx","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5Tnyx":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** @returns annotated errors or warnings */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatCompilerLog", ()=>formatCompilerLog);
function formatCompilerLog(shaderLog, source, options) {
    let formattedLog = '';
    const lines = source.split(/\r?\n/);
    const log = shaderLog.slice().sort((a, b)=>a.lineNum - b.lineNum);
    switch(options?.showSourceCode || 'no'){
        case 'all':
            // Parse the error - note: browser and driver dependent
            let currentMessage = 0;
            for(let lineNum = 1; lineNum <= lines.length; lineNum++){
                formattedLog += getNumberedLine(lines[lineNum - 1], lineNum, options);
                while(log.length > currentMessage && log[currentMessage].lineNum === lineNum){
                    const message = log[currentMessage++];
                    formattedLog += formatCompilerMessage(message, lines, message.lineNum, {
                        ...options,
                        inlineSource: false
                    });
                }
            }
            return formattedLog;
        case 'issues':
        case 'no':
            // Parse the error - note: browser and driver dependent
            for (const message of shaderLog)formattedLog += formatCompilerMessage(message, lines, message.lineNum, {
                inlineSource: options?.showSourceCode !== 'no'
            });
            return formattedLog;
    }
}
// Helpers
/** Format one message */ function formatCompilerMessage(message, lines, lineNum, options) {
    if (options?.inlineSource) {
        const numberedLines = getNumberedLines(lines, lineNum);
        // If we got error position on line add a `^^^` indicator on next line
        const positionIndicator = message.linePos > 0 ? `${' '.repeat(message.linePos + 5)}^^^\n` : '';
        return `
${numberedLines}${positionIndicator}${message.type.toUpperCase()}: ${message.message}

`;
    }
    const color = message.type === 'error' ? 'red' : '#8B4000'; // dark orange
    return options?.html ? `<div class='luma-compiler-log-error' style="color:${color};"><b> ${message.type.toUpperCase()}: ${message.message}</b></div>` : `${message.type.toUpperCase()}: ${message.message}`;
}
function getNumberedLines(lines, lineNum, options) {
    let numberedLines = '';
    for(let lineIndex = lineNum - 2; lineIndex <= lineNum; lineIndex++){
        const sourceLine = lines[lineIndex - 1];
        if (sourceLine !== undefined) numberedLines += getNumberedLine(sourceLine, lineNum, options);
    }
    return numberedLines;
}
function getNumberedLine(line, lineNum, options) {
    const escapedLine = options?.html ? escapeHTML(line) : line;
    return `${padLeft(String(lineNum), 4)}: ${escapedLine}${options?.html ? '<br/>' : '\n'}`;
}
/**
 * Pads a string with a number of spaces (space characters) to the left
 * @param {String} string - string to pad
 * @param {Number} digits - number of spaces to add
 * @return {String} string - The padded string
 */ function padLeft(string, paddedLength) {
    let result = '';
    for(let i = string.length; i < paddedLength; ++i)result += ' ';
    return result + string;
}
function escapeHTML(unsafe) {
    return unsafe.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eOSB4":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Immutable Sampler object */ parcelHelpers.export(exports, "Sampler", ()=>Sampler);
var _resourceJs = require("./resource.js");
class Sampler extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        type: 'color-sampler',
        addressModeU: 'clamp-to-edge',
        addressModeV: 'clamp-to-edge',
        addressModeW: 'clamp-to-edge',
        magFilter: 'nearest',
        minFilter: 'nearest',
        mipmapFilter: 'none',
        lodMinClamp: 0,
        lodMaxClamp: 32,
        compare: 'less-equal',
        maxAnisotropy: 1
    };
    get [Symbol.toStringTag]() {
        return 'Sampler';
    }
    constructor(device, props){
        props = Sampler.normalizeProps(device, props);
        super(device, props, Sampler.defaultProps);
    }
    static normalizeProps(device, props) {
        const overriddenDefaultProps = device?.props?._resourceDefaults?.sampler || {};
        const newProps = {
            ...props,
            ...overriddenDefaultProps
        };
        return newProps;
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2JTLp":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create new textures with correct size for all attachments.
 * @note resize() destroys existing textures (if size has changed).
 */ parcelHelpers.export(exports, "Framebuffer", ()=>Framebuffer);
var _resourceJs = require("./resource.js");
var _textureJs = require("./texture.js");
var _logJs = require("../../utils/log.js");
class Framebuffer extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        width: 1,
        height: 1,
        colorAttachments: [],
        depthStencilAttachment: null // 'depth24plus-stencil8'
    };
    get [Symbol.toStringTag]() {
        return 'Framebuffer';
    }
    /** Width of all attachments in this framebuffer */ width;
    /** Height of all attachments in this framebuffer */ height;
    constructor(device, props = {}){
        super(device, props, Framebuffer.defaultProps);
        this.width = this.props.width;
        this.height = this.props.height;
    }
    /**
     * Create a copy of this framebuffer with new attached textures, with same props but of the specified size.
     * @note Does not copy contents of the attached textures.
     */ clone(size) {
        const colorAttachments = this.colorAttachments.map((colorAttachment)=>colorAttachment.texture.clone(size));
        const depthStencilAttachment = this.depthStencilAttachment && this.depthStencilAttachment.texture.clone(size);
        return this.device.createFramebuffer({
            ...this.props,
            colorAttachments,
            depthStencilAttachment
        });
    }
    resize(size) {
        let updateSize = !size;
        if (size) {
            const [width, height] = Array.isArray(size) ? size : [
                size.width,
                size.height
            ];
            updateSize = updateSize || height !== this.height || width !== this.width;
            this.width = width;
            this.height = height;
        }
        if (updateSize) {
            (0, _logJs.log).log(2, `Resizing framebuffer ${this.id} to ${this.width}x${this.height}`)();
            this.resizeAttachments(this.width, this.height);
        }
    }
    /** Auto creates any textures */ autoCreateAttachmentTextures() {
        if (this.props.colorAttachments.length === 0 && !this.props.depthStencilAttachment) throw new Error('Framebuffer has noattachments');
        this.colorAttachments = this.props.colorAttachments.map((attachment, index)=>{
            if (typeof attachment === 'string') {
                const texture = this.createColorTexture(attachment, index);
                this.attachResource(texture);
                return texture.view;
            }
            if (attachment instanceof (0, _textureJs.Texture)) return attachment.view;
            return attachment;
        });
        const attachment = this.props.depthStencilAttachment;
        if (attachment) {
            if (typeof attachment === 'string') {
                const texture = this.createDepthStencilTexture(attachment);
                this.attachResource(texture);
                this.depthStencilAttachment = texture.view;
            } else if (attachment instanceof (0, _textureJs.Texture)) this.depthStencilAttachment = attachment.view;
            else this.depthStencilAttachment = attachment;
        }
    }
    /** Create a color texture */ createColorTexture(format, index) {
        return this.device.createTexture({
            id: `${this.id}-color-attachment-${index}`,
            usage: (0, _textureJs.Texture).RENDER_ATTACHMENT,
            format,
            width: this.width,
            height: this.height,
            // TODO deprecated? - luma.gl v8 compatibility
            sampler: {
                magFilter: 'linear',
                minFilter: 'linear'
            }
        });
    }
    /** Create depth stencil texture */ createDepthStencilTexture(format) {
        return this.device.createTexture({
            id: `${this.id}-depth-stencil-attachment`,
            usage: (0, _textureJs.Texture).RENDER_ATTACHMENT,
            format,
            width: this.width,
            height: this.height,
            mipmaps: false
        });
    }
    /**
     * Default implementation of resize
     * Creates new textures with correct size for all attachments.
     * and destroys existing textures if owned
     */ resizeAttachments(width, height) {
        for(let i = 0; i < this.colorAttachments.length; ++i)if (this.colorAttachments[i]) {
            const resizedTexture = this.colorAttachments[i].texture.clone({
                width,
                height
            });
            this.destroyAttachedResource(this.colorAttachments[i]);
            this.colorAttachments[i] = resizedTexture.view;
            this.attachResource(resizedTexture.view);
        }
        if (this.depthStencilAttachment) {
            const resizedTexture = this.depthStencilAttachment.texture.clone({
                width,
                height
            });
            this.destroyAttachedResource(this.depthStencilAttachment);
            this.depthStencilAttachment = resizedTexture.view;
            this.attachResource(resizedTexture);
        }
        this.updateAttachments();
    }
}

},{"./resource.js":"e1oiI","./texture.js":"gUJuc","../../utils/log.js":"3Uksv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"isCOh":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// import {normalizeAttributeMap} from '../helpers/attribute-bindings';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A compiled and linked shader program
 */ parcelHelpers.export(exports, "RenderPipeline", ()=>RenderPipeline);
var _resourceJs = require("./resource.js");
class RenderPipeline extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        vs: null,
        vertexEntryPoint: 'vertexMain',
        vsConstants: {},
        fs: null,
        fragmentEntryPoint: 'fragmentMain',
        fsConstants: {},
        shaderLayout: null,
        bufferLayout: [],
        topology: 'triangle-list',
        parameters: {},
        // isInstanced: false,
        // instanceCount: 0,
        // vertexCount: 0,
        bindings: {},
        uniforms: {}
    };
    get [Symbol.toStringTag]() {
        return 'RenderPipeline';
    }
    /** The merged layout */ shaderLayout;
    /** Buffer map describing buffer interleaving etc */ bufferLayout;
    /** The linking status of the pipeline. 'pending' if linking is asynchronous, and on production */ linkStatus = 'pending';
    /** The hash of the pipeline */ hash = '';
    constructor(device, props){
        super(device, props, RenderPipeline.defaultProps);
        this.shaderLayout = this.props.shaderLayout;
        this.bufferLayout = this.props.bufferLayout || [];
    }
    // DEPRECATED METHODS
    /**
     * Uniforms
     * @deprecated Use uniforms buffers
     * @note textures, samplers and uniform buffers should be set via `setBindings()`, these are not considered uniforms.
     * @note In WebGL uniforms have a performance penalty, they are reset before each call to enable pipeline sharing.
     */ setUniformsWebGL(uniforms) {
        throw new Error('Use uniform blocks');
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5lDGH":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// import {Binding} from '../types/shader-layout';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A RenderPass instance is a required parameter to all draw calls.
 *
 * It holds a combination of
 * - render targets (specified via a framebuffer)
 * - clear colors, read/write, discard information for the framebuffer attachments
 * - a couple of mutable parameters ()
 */ parcelHelpers.export(exports, "RenderPass", ()=>RenderPass) // TODO - Can we align WebGL implementation with WebGPU API?
 // In WebGPU the following methods are on the renderpass instead of the renderpipeline
 // luma.gl keeps them on the pipeline for now, but that has some issues.
 // abstract setPipeline(pipeline: RenderPipeline): void {}
 // abstract setIndexBuffer()
 // abstract setVertexBuffer(slot: number, buffer: Buffer, offset: number): void;
 // abstract setBindings(bindings: Record<string, Binding>): void;
 // abstract setParameters(parameters: RenderPassParameters);
 // abstract draw(options: {
 // abstract drawIndirect(indirectBuffer: GPUBuffer, indirectOffset: number): void;
 // abstract drawIndexedIndirect(indirectBuffer: GPUBuffer, indirectOffset: number): void;
;
var _resourceJs = require("./resource.js");
class RenderPass extends (0, _resourceJs.Resource) {
    /** TODO - should be [0, 0, 0, 0], update once deck.gl tests run clean */ static defaultClearColor = [
        0,
        0,
        0,
        1
    ];
    /** Depth 1.0 represents the far plance */ static defaultClearDepth = 1;
    /** Clears all stencil bits */ static defaultClearStencil = 0;
    /** Default properties for RenderPass */ static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        framebuffer: null,
        parameters: undefined,
        clearColor: RenderPass.defaultClearColor,
        clearColors: undefined,
        clearDepth: RenderPass.defaultClearDepth,
        clearStencil: RenderPass.defaultClearStencil,
        depthReadOnly: false,
        stencilReadOnly: false,
        discard: false,
        occlusionQuerySet: undefined,
        timestampQuerySet: undefined,
        beginTimestampIndex: undefined,
        endTimestampIndex: undefined
    };
    get [Symbol.toStringTag]() {
        return 'RenderPass';
    }
    constructor(device, props){
        props = RenderPass.normalizeProps(device, props);
        super(device, props, RenderPass.defaultProps);
    }
    static normalizeProps(device, props) {
        // Intended to override e.g. set default clear values to true
        const overriddenDefaultProps = device.props._resourceDefaults?.renderPass;
        const newProps = {
            ...overriddenDefaultProps,
            ...props
        };
        return newProps;
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4tPYA":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A compiled and linked shader program for compute
 */ parcelHelpers.export(exports, "ComputePipeline", ()=>ComputePipeline);
var _resourceJs = require("./resource.js");
class ComputePipeline extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        shader: undefined,
        entryPoint: undefined,
        constants: {},
        shaderLayout: undefined
    };
    get [Symbol.toStringTag]() {
        return 'ComputePipeline';
    }
    hash = '';
    /** The merged shader layout */ shaderLayout;
    constructor(device, props){
        super(device, props, ComputePipeline.defaultProps);
        this.shaderLayout = props.shaderLayout;
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6yvMS":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Encodes commands to queue that can be executed later
 */ parcelHelpers.export(exports, "CommandEncoder", ()=>CommandEncoder);
var _resourceJs = require("./resource.js");
class CommandEncoder extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        measureExecutionTime: undefined
    };
    get [Symbol.toStringTag]() {
        return 'CommandEncoder';
    }
    constructor(device, props){
        super(device, props, CommandEncoder.defaultProps);
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1NpBB":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Encodes commands to queue that can be executed later
 */ parcelHelpers.export(exports, "CommandBuffer", ()=>CommandBuffer);
var _resourceJs = require("./resource.js");
class CommandBuffer extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps
    };
    get [Symbol.toStringTag]() {
        return 'CommandBuffer';
    }
    constructor(device, props){
        super(device, props, CommandBuffer.defaultProps);
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8zNVo":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stores attribute bindings.
 * Makes it easy to share a render pipeline and use separate vertex arrays.
 * @note On WebGL, VertexArray allows non-constant bindings to be performed in advance
 * reducing the number of WebGL calls per draw call.
 * @note On WebGPU this is just a convenience class that collects the bindings.
 */ parcelHelpers.export(exports, "VertexArray", ()=>VertexArray);
var _getAttributeFromLayoutsJs = require("../../adapter-utils/get-attribute-from-layouts.js");
var _resourceJs = require("./resource.js");
class VertexArray extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        renderPipeline: null
    };
    get [Symbol.toStringTag]() {
        return 'VertexArray';
    }
    /** Max number of vertex attributes */ maxVertexAttributes;
    /** Attribute infos indexed by location - TODO only needed by webgl module? */ attributeInfos;
    /** Index buffer */ indexBuffer = null;
    /** Attributes indexed by buffer slot */ attributes;
    constructor(device, props){
        super(device, props, VertexArray.defaultProps);
        this.maxVertexAttributes = device.limits.maxVertexAttributes;
        this.attributes = new Array(this.maxVertexAttributes).fill(null);
        const { shaderLayout, bufferLayout } = props.renderPipeline || {};
        if (!shaderLayout || !bufferLayout) throw new Error('VertexArray');
        this.attributeInfos = (0, _getAttributeFromLayoutsJs.getAttributeInfosByLocation)(shaderLayout, bufferLayout, this.maxVertexAttributes);
    }
    // DEPRECATED METHODS
    /** @deprecated Set constant attributes (WebGL only) */ setConstantWebGL(location, value) {
        this.device.reportError(new Error('constant attributes not supported'));
    }
}

},{"../../adapter-utils/get-attribute-from-layouts.js":"54Scv","./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"54Scv":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Map from "attribute names" to "resolved attribute infos"
 * containing information about both buffer layouts and shader attribute declarations
 */ parcelHelpers.export(exports, "getAttributeInfosFromLayouts", ()=>getAttributeInfosFromLayouts);
/**
 * Array indexed by "location" holding "resolved attribute infos"
 */ parcelHelpers.export(exports, "getAttributeInfosByLocation", ()=>getAttributeInfosByLocation);
var _logJs = require("../utils/log.js");
var _decodeAttributeTypeJs = require("../gpu-type-utils/decode-attribute-type.js");
var _decodeVertexFormatJs = require("../gpu-type-utils/decode-vertex-format.js");
function getAttributeInfosFromLayouts(shaderLayout, bufferLayout) {
    const attributeInfos = {};
    for (const attribute of shaderLayout.attributes){
        const attributeInfo = getAttributeInfoFromLayouts(shaderLayout, bufferLayout, attribute.name);
        if (attributeInfo) attributeInfos[attribute.name] = attributeInfo;
    }
    return attributeInfos;
}
function getAttributeInfosByLocation(shaderLayout, bufferLayout, maxVertexAttributes = 16) {
    const attributeInfos = getAttributeInfosFromLayouts(shaderLayout, bufferLayout);
    const locationInfos = new Array(maxVertexAttributes).fill(null);
    for (const attributeInfo of Object.values(attributeInfos))locationInfos[attributeInfo.location] = attributeInfo;
    return locationInfos;
}
/**
 * Get the combined information from a shader layout and a buffer layout for a specific attribute
 */ function getAttributeInfoFromLayouts(shaderLayout, bufferLayout, name1) {
    const shaderDeclaration = getAttributeFromShaderLayout(shaderLayout, name1);
    const bufferMapping = getAttributeFromBufferLayout(bufferLayout, name1);
    // TODO should no longer happen
    if (!shaderDeclaration) //  || !bufferMapping
    return null;
    const attributeTypeInfo = (0, _decodeAttributeTypeJs.decodeShaderAttributeType)(shaderDeclaration.type);
    const vertexFormat = bufferMapping?.vertexFormat || attributeTypeInfo.defaultVertexFormat;
    const vertexFormatInfo = (0, _decodeVertexFormatJs.decodeVertexFormat)(vertexFormat);
    return {
        attributeName: bufferMapping?.attributeName || shaderDeclaration.name,
        bufferName: bufferMapping?.bufferName || shaderDeclaration.name,
        location: shaderDeclaration.location,
        shaderType: shaderDeclaration.type,
        shaderDataType: attributeTypeInfo.dataType,
        shaderComponents: attributeTypeInfo.components,
        vertexFormat,
        bufferDataType: vertexFormatInfo.type,
        bufferComponents: vertexFormatInfo.components,
        // normalized is a property of the buffer's vertex format
        normalized: vertexFormatInfo.normalized,
        // integer is a property of the shader declaration
        integer: attributeTypeInfo.integer,
        stepMode: bufferMapping?.stepMode || shaderDeclaration.stepMode || 'vertex',
        byteOffset: bufferMapping?.byteOffset || 0,
        byteStride: bufferMapping?.byteStride || 0
    };
}
function getAttributeFromShaderLayout(shaderLayout, name1) {
    const attribute = shaderLayout.attributes.find((attr)=>attr.name === name1);
    if (!attribute) (0, _logJs.log).warn(`shader layout attribute "${name1}" not present in shader`);
    return attribute || null;
}
function getAttributeFromBufferLayout(bufferLayouts, name1) {
    // Check that bufferLayouts are valid (each either has format or attribute)
    checkBufferLayouts(bufferLayouts);
    let bufferLayoutInfo = getAttributeFromShortHand(bufferLayouts, name1);
    if (bufferLayoutInfo) return bufferLayoutInfo;
    bufferLayoutInfo = getAttributeFromAttributesList(bufferLayouts, name1);
    if (bufferLayoutInfo) return bufferLayoutInfo;
    // Didn't find...
    (0, _logJs.log).warn(`layout for attribute "${name1}" not present in buffer layout`);
    return null;
}
/** Check that bufferLayouts are valid (each either has format or attribute) */ function checkBufferLayouts(bufferLayouts) {
    for (const bufferLayout of bufferLayouts)if (bufferLayout.attributes && bufferLayout.format || !bufferLayout.attributes && !bufferLayout.format) (0, _logJs.log).warn(`BufferLayout ${name} must have either 'attributes' or 'format' field`);
}
/** Get attribute from format shorthand if specified */ function getAttributeFromShortHand(bufferLayouts, name1) {
    for (const bufferLayout of bufferLayouts){
        if (bufferLayout.format && bufferLayout.name === name1) return {
            attributeName: bufferLayout.name,
            bufferName: name1,
            stepMode: bufferLayout.stepMode,
            vertexFormat: bufferLayout.format,
            // If offset is needed, use `attributes` field.
            byteOffset: 0,
            byteStride: bufferLayout.byteStride || 0
        };
    }
    return null;
}
/**
 * Search attribute mappings (e.g. interleaved attributes) for buffer mapping.
 * Not the name of the buffer might be the same as one of the interleaved attributes.
 */ function getAttributeFromAttributesList(bufferLayouts, name1) {
    for (const bufferLayout of bufferLayouts){
        let byteStride = bufferLayout.byteStride;
        // Calculate a default byte stride if not provided
        if (typeof bufferLayout.byteStride !== 'number') for (const attributeMapping of bufferLayout.attributes || []){
            const info = (0, _decodeVertexFormatJs.decodeVertexFormat)(attributeMapping.format);
            // @ts-ignore
            byteStride += info.byteLength;
        }
        const attributeMapping = bufferLayout.attributes?.find((mapping)=>mapping.attribute === name1);
        if (attributeMapping) return {
            attributeName: attributeMapping.attribute,
            bufferName: bufferLayout.name,
            stepMode: bufferLayout.stepMode,
            vertexFormat: attributeMapping.format,
            byteOffset: attributeMapping.byteOffset,
            // @ts-ignore
            byteStride
        };
    }
    return null;
}

},{"../utils/log.js":"3Uksv","../gpu-type-utils/decode-attribute-type.js":"2xyUe","../gpu-type-utils/decode-vertex-format.js":"1LOvq","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2xyUe":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Decodes a vertex type, returning byte length and flags (integer, signed, normalized) */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeShaderAttributeType", ()=>decodeShaderAttributeType);
function decodeShaderAttributeType(attributeType) {
    const [dataType, components] = TYPE_INFO[attributeType];
    const integer = dataType === 'i32' || dataType === 'u32';
    const signed = dataType !== 'u32';
    const byteLength = TYPE_SIZES[dataType] * components;
    const defaultVertexFormat = getCompatibleVertexFormat(dataType, components);
    return {
        dataType,
        components,
        defaultVertexFormat,
        byteLength,
        integer,
        signed
    };
}
/** Get the "default" vertex format for a certain shader data type */ function getCompatibleVertexFormat(dataType, components) {
    let vertexType;
    switch(dataType){
        case 'f32':
            vertexType = 'float32';
            break;
        case 'i32':
            vertexType = 'sint32';
            break;
        case 'u32':
            vertexType = 'uint32';
            break;
        case 'f16':
            return components <= 2 ? 'float16x2' : 'float16x4';
    }
    // TODO logic does not work for float16
    if (components === 1) return vertexType;
    return `${vertexType}x${components}`;
}
/** All valid shader attribute types. A table guarantees exhaustive list and fast execution */ const TYPE_INFO = {
    f32: [
        'f32',
        1
    ],
    'vec2<f32>': [
        'f32',
        2
    ],
    'vec3<f32>': [
        'f32',
        3
    ],
    'vec4<f32>': [
        'f32',
        4
    ],
    f16: [
        'f16',
        1
    ],
    'vec2<f16>': [
        'f16',
        2
    ],
    'vec3<f16>': [
        'f16',
        3
    ],
    'vec4<f16>': [
        'f16',
        4
    ],
    i32: [
        'i32',
        1
    ],
    'vec2<i32>': [
        'i32',
        2
    ],
    'vec3<i32>': [
        'i32',
        3
    ],
    'vec4<i32>': [
        'i32',
        4
    ],
    u32: [
        'u32',
        1
    ],
    'vec2<u32>': [
        'u32',
        2
    ],
    'vec3<u32>': [
        'u32',
        3
    ],
    'vec4<u32>': [
        'u32',
        4
    ]
};
const TYPE_SIZES = {
    f32: 4,
    f16: 2,
    i32: 4,
    u32: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1LOvq":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Decodes a vertex format, returning type, components, byte  length and flags (integer, signed, normalized)
 */ parcelHelpers.export(exports, "decodeVertexFormat", ()=>decodeVertexFormat);
var _decodeDataTypeJs = require("./decode-data-type.js");
function decodeVertexFormat(format) {
    // Strip the -webgl ending if present
    let webglOnly;
    if (format.endsWith('-webgl')) {
        format.replace('-webgl', '');
        webglOnly = true;
    }
    // split components from type
    const [type_, count] = format.split('x');
    const type = type_;
    const components = count ? parseInt(count) : 1;
    // decode the type
    const decodedType = (0, _decodeDataTypeJs.decodeVertexType)(type);
    const result = {
        type,
        components,
        byteLength: decodedType.byteLength * components,
        integer: decodedType.integer,
        signed: decodedType.signed,
        normalized: decodedType.normalized
    };
    if (webglOnly) result.webglOnly = true;
    return result;
}

},{"./decode-data-type.js":"c4uI5","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8dFaM":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Holds a set of output buffers for pipeline (WebGL only) */ parcelHelpers.export(exports, "TransformFeedback", ()=>TransformFeedback);
var _resourceJs = require("./resource.js");
class TransformFeedback extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        layout: undefined,
        buffers: {}
    };
    get [Symbol.toStringTag]() {
        return 'TransformFeedback';
    }
    constructor(device, props){
        super(device, props, TransformFeedback.defaultProps);
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"e3Bzu":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Immutable QuerySet object */ parcelHelpers.export(exports, "QuerySet", ()=>QuerySet);
var _resourceJs = require("./resource.js");
class QuerySet extends (0, _resourceJs.Resource) {
    static defaultProps = {
        ...(0, _resourceJs.Resource).defaultProps,
        type: undefined,
        count: undefined
    };
    get [Symbol.toStringTag]() {
        return 'QuerySet';
    }
    constructor(device, props){
        super(device, props, QuerySet.defaultProps);
    }
}

},{"./resource.js":"e1oiI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"b61Pn":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Std140 layout for uniform buffers
 * Supports manual listing of uniforms
 */ parcelHelpers.export(exports, "UniformBufferLayout", ()=>UniformBufferLayout);
var _decodeShaderTypesJs = require("../gpu-type-utils/decode-shader-types.js");
var _arrayUtilsFlatJs = require("../utils/array-utils-flat.js");
var _isArrayJs = require("../utils/is-array.js");
var _logJs = require("../utils/log.js");
/**
 * Smallest buffer size that can be used for uniform buffers.
 * TODO - does this depend on device?
 */ const minBufferSize = 1024;
class UniformBufferLayout {
    layout = {};
    /** number of bytes needed for buffer allocation */ byteLength;
    /** Create a new UniformBufferLayout given a map of attributes. */ constructor(uniformTypes){
        /** number of 4 byte slots taken */ let size = 0;
        // Add layout (type, size and offset) definitions for each uniform in the layout
        for (const [key, uniformType] of Object.entries(uniformTypes)){
            const typeAndComponents = (0, _decodeShaderTypesJs.decodeShaderUniformType)(uniformType);
            const { type, components: count } = typeAndComponents;
            // First, align (bump) current offset to an even multiple of current object (1, 2, 4)
            size = (0, _decodeShaderTypesJs.alignTo)(size, count);
            // Use the aligned size as the offset of the current uniform.
            const offset = size;
            // Then, add our object's padded size ((1, 2, multiple of 4) to the current offset
            size += count;
            this.layout[key] = {
                type,
                size: count,
                offset
            };
        }
        size += (4 - size % 4) % 4;
        const actualByteLength = size * 4;
        this.byteLength = Math.max(actualByteLength, minBufferSize);
    }
    /** Get the data for the complete buffer */ getData(uniformValues) {
        const bufferSize = Math.max(this.byteLength, minBufferSize);
        // Allocate three typed arrays pointing at same memory
        const arrayBuffer = (0, _arrayUtilsFlatJs.getScratchArrayBuffer)(bufferSize);
        const typedArrays = {
            i32: new Int32Array(arrayBuffer),
            u32: new Uint32Array(arrayBuffer),
            f32: new Float32Array(arrayBuffer),
            // TODO not implemented
            f16: new Uint16Array(arrayBuffer)
        };
        // TODO is this needed?
        // typedArrays.i32.fill(0);
        for (const [name, value] of Object.entries(uniformValues)){
            const uniformLayout = this.layout[name];
            if (!uniformLayout) {
                (0, _logJs.log).warn(`Supplied uniform value ${name} not present in uniform block layout`)();
                continue;
            }
            const { type, size, offset } = uniformLayout;
            const typedArray = typedArrays[type];
            if (size === 1) {
                if (typeof value !== 'number' && typeof value !== 'boolean') {
                    (0, _logJs.log).warn(`Supplied value for single component uniform ${name} is not a number: ${value}`)();
                    continue;
                }
                // single value -> just set it
                typedArray[offset] = Number(value);
            } else {
                if (!(0, _isArrayJs.isNumberArray)(value)) {
                    (0, _logJs.log).warn(`Supplied value for multi component / array uniform ${name} is not a numeric array: ${value}`)();
                    continue;
                }
                // vector/matrix -> copy the supplied (typed) array, starting from offset
                // TODO: we should limit or check size in case the supplied data overflows
                typedArray.set(value, offset);
            }
        }
        return new Uint8Array(arrayBuffer);
    }
    /** Does this layout have a field with specified name */ has(name) {
        return Boolean(this.layout[name]);
    }
    /** Get offset and size for a field with specified name */ get(name) {
        const layout = this.layout[name];
        return layout;
    }
}

},{"../gpu-type-utils/decode-shader-types.js":"fikq1","../utils/array-utils-flat.js":"hMRlV","../utils/is-array.js":"8t7dD","../utils/log.js":"3Uksv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fikq1":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Split a uniform type string into type and components */ parcelHelpers.export(exports, "decodeShaderUniformType", ()=>decodeShaderUniformType);
/** Align offset to 1, 2 or 4 elements (4, 8 or 16 bytes) */ parcelHelpers.export(exports, "alignTo", ()=>alignTo);
const UNIFORM_FORMATS = {
    f32: {
        type: 'f32',
        components: 1
    },
    i32: {
        type: 'i32',
        components: 1
    },
    u32: {
        type: 'u32',
        components: 1
    },
    // 'bool-webgl': {type: 'bool-webgl', components: 1},
    'vec2<f32>': {
        type: 'f32',
        components: 2
    },
    'vec3<f32>': {
        type: 'f32',
        components: 3
    },
    'vec4<f32>': {
        type: 'f32',
        components: 4
    },
    'vec2<i32>': {
        type: 'i32',
        components: 2
    },
    'vec3<i32>': {
        type: 'i32',
        components: 3
    },
    'vec4<i32>': {
        type: 'i32',
        components: 4
    },
    'vec2<u32>': {
        type: 'u32',
        components: 2
    },
    'vec3<u32>': {
        type: 'u32',
        components: 3
    },
    'vec4<u32>': {
        type: 'u32',
        components: 4
    },
    'mat2x2<f32>': {
        type: 'f32',
        components: 4
    },
    'mat2x3<f32>': {
        type: 'f32',
        components: 6
    },
    'mat2x4<f32>': {
        type: 'f32',
        components: 8
    },
    'mat3x2<f32>': {
        type: 'f32',
        components: 6
    },
    'mat3x3<f32>': {
        type: 'f32',
        components: 9
    },
    'mat3x4<f32>': {
        type: 'f32',
        components: 12
    },
    'mat4x2<f32>': {
        type: 'f32',
        components: 8
    },
    'mat4x3<f32>': {
        type: 'f32',
        components: 12
    },
    'mat4x4<f32>': {
        type: 'f32',
        components: 16
    }
};
function decodeShaderUniformType(format) {
    const decoded = UNIFORM_FORMATS[format];
    return decoded;
}
function alignTo(size, count) {
    // prettier-ignore
    switch(count){
        case 1:
            return size; // Pad upwards to even multiple of 2
        case 2:
            return size + size % 2; // Pad upwards to even multiple of 2
        default:
            return size + (4 - size % 4) % 4; // Pad upwards to even multiple of 4
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hMRlV":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScratchArrayBuffer", ()=>getScratchArrayBuffer);
parcelHelpers.export(exports, "getScratchArray", ()=>getScratchArray);
let arrayBuffer;
function getScratchArrayBuffer(byteLength) {
    if (!arrayBuffer || arrayBuffer.byteLength < byteLength) arrayBuffer = new ArrayBuffer(byteLength);
    return arrayBuffer;
}
function getScratchArray(Type, length) {
    const scratchArrayBuffer = getScratchArrayBuffer(Type.BYTES_PER_ELEMENT * length);
    return new Type(scratchArrayBuffer, 0, length); // arrayBuffer, byteOffset, length (in elements)
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8t7dD":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Check is an array is a typed array
 * @param value value to be tested
 * @returns input as TypedArray, or null
 * @todo this should be provided by @math.gl/types
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
/**
 * Check is an array is a numeric array (typed array or array of numbers)
 * @param value value to be tested
 * @returns input as NumberArray, or null
 * @todo this should be provided by @math.gl/types
 */ parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isTypedArray(value) {
    return ArrayBuffer.isView(value) && !(value instanceof DataView);
}
function isNumberArray(value) {
    if (Array.isArray(value)) return value.length === 0 || typeof value[0] === 'number';
    return isTypedArray(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eVkh2":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A uniform block holds values of the of uniform values for one uniform block / buffer.
 * It also does some book keeping on what has changed, to minimize unnecessary writes to uniform buffers.
 */ parcelHelpers.export(exports, "UniformBlock", ()=>UniformBlock);
var _arrayEqualJs = require("../utils/array-equal.js");
class UniformBlock {
    name;
    uniforms = {};
    modifiedUniforms = {};
    modified = true;
    bindingLayout = {};
    needsRedraw = 'initialized';
    constructor(props){
        this.name = props?.name || 'unnamed';
        // TODO - Extract uniform layout from the shaderLayout object
        if (props?.name && props?.shaderLayout) {
            const binding = props?.shaderLayout.bindings?.find((binding_)=>binding_.type === 'uniform' && binding_.name === props?.name);
            if (!binding) throw new Error(props?.name);
            const uniformBlock = binding;
            for (const uniform of uniformBlock.uniforms || [])this.bindingLayout[uniform.name] = uniform;
        }
    }
    /** Set a map of uniforms */ setUniforms(uniforms) {
        for (const [key, value] of Object.entries(uniforms)){
            this._setUniform(key, value);
            if (!this.needsRedraw) this.setNeedsRedraw(`${this.name}.${key}=${value}`);
        }
    }
    setNeedsRedraw(reason) {
        this.needsRedraw = this.needsRedraw || reason;
    }
    /** Returns all uniforms */ getAllUniforms() {
        // @ts-expect-error
        this.modifiedUniforms = {};
        this.needsRedraw = false;
        return this.uniforms || {};
    }
    /** Set a single uniform */ _setUniform(key, value) {
        if ((0, _arrayEqualJs.arrayEqual)(this.uniforms[key], value)) return;
        this.uniforms[key] = (0, _arrayEqualJs.arrayCopy)(value);
        this.modifiedUniforms[key] = true;
        this.modified = true;
    }
}

},{"../utils/array-equal.js":"lrBbv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lrBbv":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Test if two arrays are deep equal, with a length limit that defaults to 16 */ parcelHelpers.export(exports, "arrayEqual", ()=>arrayEqual);
/** Copy a value */ parcelHelpers.export(exports, "arrayCopy", ()=>arrayCopy);
var _isArrayJs = require("./is-array.js");
function arrayEqual(a, b, limit = 16) {
    if (a !== b) return false;
    const arrayA = a;
    const arrayB = b;
    if (!(0, _isArrayJs.isNumberArray)(arrayA)) return false;
    if ((0, _isArrayJs.isNumberArray)(arrayB) && arrayA.length === arrayB.length) for(let i = 0; i < arrayA.length; ++i){
        if (arrayB[i] !== arrayA[i]) return false;
    }
    return true;
}
function arrayCopy(a) {
    if ((0, _isArrayJs.isNumberArray)(a)) return a.slice();
    return a;
}

},{"./is-array.js":"8t7dD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3UJv9":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A uniform store holds a uniform values for one or more uniform blocks,
 * - It can generate binary data for any uniform buffer
 * - It can manage a uniform buffer for each block
 * - It can update managed uniform buffers with a single call
 * - It performs some book keeping on what has changed to minimize unnecessary writes to uniform buffers.
 */ parcelHelpers.export(exports, "UniformStore", ()=>UniformStore);
var _bufferJs = require("../adapter/resources/buffer.js");
var _logJs = require("../utils/log.js");
var _uniformBlockJs = require("./uniform-block.js");
var _uniformBufferLayoutJs = require("./uniform-buffer-layout.js");
class UniformStore {
    /** Stores the uniform values for each uniform block */ uniformBlocks = new Map();
    /** Can generate data for a uniform buffer for each block from data */ uniformBufferLayouts = new Map();
    /** Actual buffer for the blocks */ uniformBuffers = new Map();
    /**
     * Create a new UniformStore instance
     * @param blocks
     */ constructor(blocks){
        for (const [bufferName, block] of Object.entries(blocks)){
            const uniformBufferName = bufferName;
            // Create a layout object to help us generate correctly formatted binary uniform buffers
            const uniformBufferLayout = new (0, _uniformBufferLayoutJs.UniformBufferLayout)(block.uniformTypes || {});
            this.uniformBufferLayouts.set(uniformBufferName, uniformBufferLayout);
            // Create a Uniform block to store the uniforms for each buffer.
            const uniformBlock = new (0, _uniformBlockJs.UniformBlock)({
                name: bufferName
            });
            uniformBlock.setUniforms(block.defaultUniforms || {});
            this.uniformBlocks.set(uniformBufferName, uniformBlock);
        }
    }
    /** Destroy any managed uniform buffers */ destroy() {
        for (const uniformBuffer of this.uniformBuffers.values())uniformBuffer.destroy();
    }
    /**
     * Set uniforms
     * Makes all properties partial
     */ setUniforms(uniforms) {
        for (const [blockName, uniformValues] of Object.entries(uniforms))this.uniformBlocks.get(blockName)?.setUniforms(uniformValues);
        this.updateUniformBuffers();
    }
    /** Get the required minimum length of the uniform buffer */ getUniformBufferByteLength(uniformBufferName) {
        return this.uniformBufferLayouts.get(uniformBufferName)?.byteLength || 0;
    }
    /** Get formatted binary memory that can be uploaded to a buffer */ getUniformBufferData(uniformBufferName) {
        const uniformValues = this.uniformBlocks.get(uniformBufferName)?.getAllUniforms() || {};
        // @ts-ignore
        return this.uniformBufferLayouts.get(uniformBufferName)?.getData(uniformValues);
    }
    /**
     * Creates an unmanaged uniform buffer (umnanaged means that application is responsible for destroying it)
     * The new buffer is initialized with current / supplied values
     */ createUniformBuffer(device, uniformBufferName, uniforms) {
        if (uniforms) this.setUniforms(uniforms);
        const byteLength = this.getUniformBufferByteLength(uniformBufferName);
        const uniformBuffer = device.createBuffer({
            usage: (0, _bufferJs.Buffer).UNIFORM | (0, _bufferJs.Buffer).COPY_DST,
            byteLength
        });
        // Note that this clears the needs redraw flag
        const uniformBufferData = this.getUniformBufferData(uniformBufferName);
        uniformBuffer.write(uniformBufferData);
        return uniformBuffer;
    }
    /** Get the managed uniform buffer. "managed" resources are destroyed when the uniformStore is destroyed. */ getManagedUniformBuffer(device, uniformBufferName) {
        if (!this.uniformBuffers.get(uniformBufferName)) {
            const byteLength = this.getUniformBufferByteLength(uniformBufferName);
            const uniformBuffer = device.createBuffer({
                usage: (0, _bufferJs.Buffer).UNIFORM | (0, _bufferJs.Buffer).COPY_DST,
                byteLength
            });
            this.uniformBuffers.set(uniformBufferName, uniformBuffer);
        }
        // this.updateUniformBuffers();
        // @ts-ignore
        return this.uniformBuffers.get(uniformBufferName);
    }
    /** Updates all uniform buffers where values have changed */ updateUniformBuffers() {
        let reason = false;
        for (const uniformBufferName of this.uniformBlocks.keys()){
            const bufferReason = this.updateUniformBuffer(uniformBufferName);
            reason ||= bufferReason;
        }
        if (reason) (0, _logJs.log).log(3, `UniformStore.updateUniformBuffers(): ${reason}`)();
        return reason;
    }
    /** Update one uniform buffer. Only updates if values have changed */ updateUniformBuffer(uniformBufferName) {
        const uniformBlock = this.uniformBlocks.get(uniformBufferName);
        let uniformBuffer = this.uniformBuffers.get(uniformBufferName);
        let reason = false;
        if (uniformBuffer && uniformBlock?.needsRedraw) {
            reason ||= uniformBlock.needsRedraw;
            // This clears the needs redraw flag
            const uniformBufferData = this.getUniformBufferData(uniformBufferName);
            uniformBuffer = this.uniformBuffers.get(uniformBufferName);
            uniformBuffer?.write(uniformBufferData);
            // logging - TODO - don't query the values unnecessarily
            const uniformValues = this.uniformBlocks.get(uniformBufferName)?.getAllUniforms();
            (0, _logJs.log).log(4, `Writing to uniform buffer ${String(uniformBufferName)}`, uniformBufferData, uniformValues)();
        }
        return reason;
    }
}

},{"../adapter/resources/buffer.js":"hGOAm","../utils/log.js":"3Uksv","./uniform-block.js":"eVkh2","./uniform-buffer-layout.js":"b61Pn","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1o6YL":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDataTypeFromTypedArray", ()=>getDataTypeFromTypedArray);
parcelHelpers.export(exports, "getTypedArrayFromDataType", ()=>getTypedArrayFromDataType);
/** Get the vertex format for an attribute with TypedArray and size */ parcelHelpers.export(exports, "getVertexFormatFromAttribute", ()=>getVertexFormatFromAttribute);
function getDataTypeFromTypedArray(arrayOrType) {
    const type = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
    switch(type){
        case Float32Array:
            return 'float32';
        case Uint16Array:
            return 'uint16';
        case Uint32Array:
            return 'uint32';
        case Uint8Array:
        case Uint8ClampedArray:
            return 'uint8';
        case Int8Array:
            return 'sint8';
        case Int16Array:
            return 'sint16';
        case Int32Array:
            return 'sint32';
        default:
            // Failed to deduce data type from typed array
            throw new Error(type.constructor.name);
    }
}
function getTypedArrayFromDataType(dataType) {
    switch(dataType){
        case 'float32':
            return Float32Array;
        case 'uint32':
            return Uint32Array;
        case 'sint32':
            return Int32Array;
        case 'uint16':
        case 'unorm16':
            return Uint16Array;
        case 'sint16':
        case 'snorm16':
            return Int16Array;
        case 'uint8':
        case 'unorm8':
            return Uint8Array;
        case 'sint8':
        case 'snorm8':
            return Int8Array;
        default:
            // Failed to deduce typed array from data type
            throw new Error(dataType);
    }
}
function getVertexFormatFromAttribute(typedArray, size, normalized) {
    if (!size || size > 4) throw new Error(`size ${size}`);
    const components = size;
    let dataType = getDataTypeFromTypedArray(typedArray);
    // TODO - Special cases for WebGL (not supported on WebGPU), overrides the check below
    if (dataType === 'uint8' && normalized && components === 1) return 'unorm8-webgl';
    if (dataType === 'uint8' && normalized && components === 3) return 'unorm8x3-webgl';
    if (dataType === 'uint8' || dataType === 'sint8') {
        if (components === 1 || components === 3) // WebGPU 8 bit formats must be aligned to 16 bit boundaries');
        throw new Error(`size: ${size}`);
        if (normalized) dataType = dataType.replace('int', 'norm');
        return `${dataType}x${components}`;
    }
    if (dataType === 'uint16' || dataType === 'sint16') {
        if (components === 1 || components === 3) // WebGPU 16 bit formats must be aligned to 32 bit boundaries
        throw new Error(`size: ${size}`);
        if (normalized) dataType = dataType.replace('int', 'norm');
        return `${dataType}x${components}`;
    }
    if (components === 1) return dataType;
    return `${dataType}x${components}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gtPdY":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** BufferLayoutHelper is a helper class that should not be used directly by applications */ parcelHelpers.export(exports, "BufferLayoutHelper", ()=>BufferLayoutHelper);
var _logJs = require("../utils/log.js");
class BufferLayoutHelper {
    bufferLayouts;
    constructor(bufferLayouts){
        this.bufferLayouts = bufferLayouts;
    }
    getBufferLayout(name) {
        return this.bufferLayouts.find((layout)=>layout.name === name) || null;
    }
    /** Get attribute names from a BufferLayout */ getAttributeNamesForBuffer(bufferLayout) {
        return bufferLayout.attributes ? bufferLayout.attributes?.map((layout)=>layout.attribute) : [
            bufferLayout.name
        ];
    }
    mergeBufferLayouts(bufferLayouts1, bufferLayouts2) {
        const mergedLayouts = [
            ...bufferLayouts1
        ];
        for (const attribute of bufferLayouts2){
            const index = mergedLayouts.findIndex((attribute2)=>attribute2.name === attribute.name);
            if (index < 0) mergedLayouts.push(attribute);
            else mergedLayouts[index] = attribute;
        }
        return mergedLayouts;
    }
    getBufferIndex(bufferName) {
        const bufferIndex = this.bufferLayouts.findIndex((layout)=>layout.name === bufferName);
        if (bufferIndex === -1) (0, _logJs.log).warn(`BufferLayout: Missing buffer for "${bufferName}".`)();
        return bufferIndex;
    }
}

},{"../utils/log.js":"3Uksv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jnFyu":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortedBufferLayoutByShaderSourceLocations", ()=>sortedBufferLayoutByShaderSourceLocations);
function sortedBufferLayoutByShaderSourceLocations(shaderLayout, bufferLayout) {
    const shaderLayoutMap = Object.fromEntries(shaderLayout.attributes.map((attr)=>[
            attr.name,
            attr.location
        ]));
    const sortedLayout = bufferLayout.slice();
    sortedLayout.sort((a, b)=>{
        const attributeNamesA = a.attributes ? a.attributes.map((attr)=>attr.attribute) : [
            a.name
        ];
        const attributeNamesB = b.attributes ? b.attributes.map((attr)=>attr.attribute) : [
            b.name
        ];
        const minLocationA = Math.min(...attributeNamesA.map((name)=>shaderLayoutMap[name]));
        const minLocationB = Math.min(...attributeNamesB.map((name)=>shaderLayoutMap[name]));
        return minLocationA - minLocationB;
    });
    return sortedLayout;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iuhA1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alias", ()=>ee);
parcelHelpers.export(exports, "AliasInfo", ()=>l);
parcelHelpers.export(exports, "Argument", ()=>Ee);
parcelHelpers.export(exports, "ArgumentInfo", ()=>f);
parcelHelpers.export(exports, "ArrayIndex", ()=>be);
parcelHelpers.export(exports, "ArrayInfo", ()=>s);
parcelHelpers.export(exports, "ArrayType", ()=>ce);
parcelHelpers.export(exports, "Assign", ()=>R);
parcelHelpers.export(exports, "AssignOperator", ()=>W);
parcelHelpers.export(exports, "Attribute", ()=>Ce);
parcelHelpers.export(exports, "BinaryOperator", ()=>ke);
parcelHelpers.export(exports, "BitcastExpr", ()=>xe);
parcelHelpers.export(exports, "Break", ()=>ne);
parcelHelpers.export(exports, "Call", ()=>G);
parcelHelpers.export(exports, "CallExpr", ()=>de);
parcelHelpers.export(exports, "Case", ()=>Se);
parcelHelpers.export(exports, "Const", ()=>U);
parcelHelpers.export(exports, "ConstExpr", ()=>_e);
parcelHelpers.export(exports, "Continue", ()=>se);
parcelHelpers.export(exports, "Continuing", ()=>V);
parcelHelpers.export(exports, "CreateExpr", ()=>pe);
parcelHelpers.export(exports, "Data", ()=>De);
parcelHelpers.export(exports, "Default", ()=>Ae);
parcelHelpers.export(exports, "DefaultSelector", ()=>Te);
parcelHelpers.export(exports, "Diagnostic", ()=>J);
parcelHelpers.export(exports, "Discard", ()=>te);
parcelHelpers.export(exports, "ElseIf", ()=>$e);
parcelHelpers.export(exports, "Enable", ()=>Y);
parcelHelpers.export(exports, "EntryFunctions", ()=>d);
parcelHelpers.export(exports, "Expression", ()=>he);
parcelHelpers.export(exports, "For", ()=>O);
parcelHelpers.export(exports, "ForwardType", ()=>ae);
parcelHelpers.export(exports, "Function", ()=>C);
parcelHelpers.export(exports, "FunctionInfo", ()=>p);
parcelHelpers.export(exports, "If", ()=>Z);
parcelHelpers.export(exports, "Increment", ()=>z);
parcelHelpers.export(exports, "IncrementOperator", ()=>P);
parcelHelpers.export(exports, "InputInfo", ()=>c);
parcelHelpers.export(exports, "Let", ()=>M);
parcelHelpers.export(exports, "LiteralExpr", ()=>ge);
parcelHelpers.export(exports, "Loop", ()=>X);
parcelHelpers.export(exports, "MatrixData", ()=>Me);
parcelHelpers.export(exports, "Member", ()=>Le);
parcelHelpers.export(exports, "MemberInfo", ()=>t);
parcelHelpers.export(exports, "Node", ()=>S);
parcelHelpers.export(exports, "Operator", ()=>ve);
parcelHelpers.export(exports, "OutputInfo", ()=>u);
parcelHelpers.export(exports, "Override", ()=>F);
parcelHelpers.export(exports, "OverrideInfo", ()=>h);
parcelHelpers.export(exports, "PointerData", ()=>Ve);
parcelHelpers.export(exports, "PointerInfo", ()=>r);
parcelHelpers.export(exports, "PointerType", ()=>le);
parcelHelpers.export(exports, "Requires", ()=>K);
parcelHelpers.export(exports, "ResourceType", ()=>i);
parcelHelpers.export(exports, "Return", ()=>Q);
parcelHelpers.export(exports, "SamplerType", ()=>ue);
parcelHelpers.export(exports, "ScalarData", ()=>Oe);
parcelHelpers.export(exports, "Statement", ()=>L);
parcelHelpers.export(exports, "StaticAssert", ()=>D);
parcelHelpers.export(exports, "StringExpr", ()=>fe);
parcelHelpers.export(exports, "Struct", ()=>ie);
parcelHelpers.export(exports, "StructInfo", ()=>n);
parcelHelpers.export(exports, "Switch", ()=>j);
parcelHelpers.export(exports, "SwitchCase", ()=>Ie);
parcelHelpers.export(exports, "TemplateInfo", ()=>a);
parcelHelpers.export(exports, "TemplateType", ()=>oe);
parcelHelpers.export(exports, "TextureData", ()=>Pe);
parcelHelpers.export(exports, "Token", ()=>He);
parcelHelpers.export(exports, "TokenClass", ()=>H);
parcelHelpers.export(exports, "TokenType", ()=>We);
parcelHelpers.export(exports, "TokenTypes", ()=>qe);
parcelHelpers.export(exports, "Type", ()=>re);
parcelHelpers.export(exports, "TypeInfo", ()=>e);
parcelHelpers.export(exports, "TypecastExpr", ()=>ye);
parcelHelpers.export(exports, "TypedData", ()=>Ue);
parcelHelpers.export(exports, "UnaryOperator", ()=>we);
parcelHelpers.export(exports, "Var", ()=>B);
parcelHelpers.export(exports, "VariableExpr", ()=>me);
parcelHelpers.export(exports, "VariableInfo", ()=>o);
parcelHelpers.export(exports, "VectorData", ()=>Fe);
parcelHelpers.export(exports, "VoidData", ()=>Ne);
parcelHelpers.export(exports, "WgslDebug", ()=>Et);
parcelHelpers.export(exports, "WgslExec", ()=>pt);
parcelHelpers.export(exports, "WgslParser", ()=>mt);
parcelHelpers.export(exports, "WgslReflect", ()=>_t);
parcelHelpers.export(exports, "WgslScanner", ()=>ze);
parcelHelpers.export(exports, "While", ()=>N);
parcelHelpers.export(exports, "_BlockEnd", ()=>E);
parcelHelpers.export(exports, "_BlockStart", ()=>A);
class e {
    constructor(e, t){
        this.name = e, this.attributes = t, this.size = 0;
    }
    get isArray() {
        return !1;
    }
    get isStruct() {
        return !1;
    }
    get isTemplate() {
        return !1;
    }
    get isPointer() {
        return !1;
    }
    getTypeName() {
        return this.name;
    }
}
class t {
    constructor(e, t, n){
        this.name = e, this.type = t, this.attributes = n, this.offset = 0, this.size = 0;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray || this.type.isTemplate ? this.type.format : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}
class n extends e {
    constructor(e, t){
        super(e, t), this.members = [], this.align = 0, this.startLine = -1, this.endLine = -1, this.inUse = !1;
    }
    get isStruct() {
        return !0;
    }
}
class s extends e {
    constructor(e, t){
        super(e, t), this.count = 0, this.stride = 0;
    }
    get isArray() {
        return !0;
    }
    getTypeName() {
        return `array<${this.format.getTypeName()}, ${this.count}>`;
    }
}
class r extends e {
    constructor(e, t, n){
        super(e, n), this.format = t;
    }
    get isPointer() {
        return !0;
    }
    getTypeName() {
        return `&${this.format.getTypeName()}`;
    }
}
class a extends e {
    constructor(e, t, n, s){
        super(e, n), this.format = t, this.access = s;
    }
    get isTemplate() {
        return !0;
    }
    getTypeName() {
        let e = this.name;
        if (null !== this.format) {
            if ('vec2' === e || 'vec3' === e || 'vec4' === e || 'mat2x2' === e || 'mat2x3' === e || 'mat2x4' === e || 'mat3x2' === e || 'mat3x3' === e || 'mat3x4' === e || 'mat4x2' === e || 'mat4x3' === e || 'mat4x4' === e) {
                if ('f32' === this.format.name) return e += 'f', e;
                if ('i32' === this.format.name) return e += 'i', e;
                if ('u32' === this.format.name) return e += 'u', e;
                if ('bool' === this.format.name) return e += 'b', e;
                if ('f16' === this.format.name) return e += 'h', e;
            }
            e += `<${this.format.name}>`;
        } else if ('vec2' === e || 'vec3' === e || 'vec4' === e) return e;
        return e;
    }
}
var i;
((e)=>{
    e[e.Uniform = 0] = 'Uniform', e[e.Storage = 1] = 'Storage', e[e.Texture = 2] = 'Texture', e[e.Sampler = 3] = 'Sampler', e[e.StorageTexture = 4] = 'StorageTexture';
})(i || (i = {}));
class o {
    constructor(e, t, n, s, r, a, i){
        this.name = e, this.type = t, this.group = n, this.binding = s, this.attributes = r, this.resourceType = a, this.access = i;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get size() {
        return this.type.size;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray || this.type.isTemplate ? this.type.format : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}
class l {
    constructor(e, t){
        this.name = e, this.type = t;
    }
}
class c {
    constructor(e, t, n, s){
        this.name = e, this.type = t, this.locationType = n, this.location = s, this.interpolation = null;
    }
}
class u {
    constructor(e, t, n, s){
        this.name = e, this.type = t, this.locationType = n, this.location = s;
    }
}
class h {
    constructor(e, t, n, s){
        this.name = e, this.type = t, this.attributes = n, this.id = s;
    }
}
class f {
    constructor(e, t, n){
        this.name = e, this.type = t, this.attributes = n;
    }
}
class p {
    constructor(e, t = null, n){
        this.stage = null, this.inputs = [], this.outputs = [], this.arguments = [], this.returnType = null, this.resources = [], this.overrides = [], this.startLine = -1, this.endLine = -1, this.inUse = !1, this.calls = new Set, this.name = e, this.stage = t, this.attributes = n;
    }
}
class d {
    constructor(){
        this.vertex = [], this.fragment = [], this.compute = [];
    }
}
const m = new Float32Array(1), _ = new Int32Array(m.buffer), g = new Uint16Array(1);
function x(e) {
    m[0] = e;
    const t = _[0], n = t >> 31 & 1;
    let s = t >> 23 & 255, r = 8388607 & t;
    if (255 === s) return g[0] = n << 15 | 31744 | (0 !== r ? 512 : 0), g[0];
    if (0 === s) {
        if (0 === r) return g[0] = n << 15, g[0];
        r |= 8388608;
        let e = 113;
        for(; !(8388608 & r);)r <<= 1, e--;
        return s = 127 - e, r &= 8388607, s > 0 ? (r = (r >> 126 - s) + (r >> 127 - s & 1), g[0] = n << 15 | s << 10 | r >> 13, g[0]) : (g[0] = n << 15, g[0]);
    }
    return s = s - 127 + 15, s >= 31 ? (g[0] = n << 15 | 31744, g[0]) : s <= 0 ? s < -10 ? (g[0] = n << 15, g[0]) : (r = (8388608 | r) >> 1 - s, g[0] = n << 15 | r >> 13, g[0]) : (r >>= 13, g[0] = n << 15 | s << 10 | r, g[0]);
}
const y = new Uint32Array(1), b = new Float32Array(y.buffer, 0, 1);
function v(e) {
    const t = 112 + (e >> 6 & 31) << 23 | (63 & e) << 17;
    return y[0] = t, b[0];
}
function w(e, t, n, s, r, a, i, o, l) {
    const c = s * (i >>= r) * (a >>= r) + n * i + t * o;
    switch(l){
        case 'r8unorm':
            return [
                k(e, c, '8unorm', 1)[0]
            ];
        case 'r8snorm':
            return [
                k(e, c, '8snorm', 1)[0]
            ];
        case 'r8uint':
            return [
                k(e, c, '8uint', 1)[0]
            ];
        case 'r8sint':
            return [
                k(e, c, '8sint', 1)[0]
            ];
        case 'rg8unorm':
            {
                const t = k(e, c, '8unorm', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rg8snorm':
            {
                const t = k(e, c, '8snorm', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rg8uint':
            {
                const t = k(e, c, '8uint', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rg8sint':
            {
                const t = k(e, c, '8sint', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rgba8unorm-srgb':
        case 'rgba8unorm':
            {
                const t = k(e, c, '8unorm', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rgba8snorm':
            {
                const t = k(e, c, '8snorm', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rgba8uint':
            {
                const t = k(e, c, '8uint', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rgba8sint':
            {
                const t = k(e, c, '8sint', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'bgra8unorm-srgb':
        case 'bgra8unorm':
            {
                const t = k(e, c, '8unorm', 4);
                return [
                    t[2],
                    t[1],
                    t[0],
                    t[3]
                ];
            }
        case 'r16uint':
            return [
                k(e, c, '16uint', 1)[0]
            ];
        case 'r16sint':
            return [
                k(e, c, '16sint', 1)[0]
            ];
        case 'r16float':
            return [
                k(e, c, '16float', 1)[0]
            ];
        case 'rg16uint':
            {
                const t = k(e, c, '16uint', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rg16sint':
            {
                const t = k(e, c, '16sint', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rg16float':
            {
                const t = k(e, c, '16float', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rgba16uint':
            {
                const t = k(e, c, '16uint', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rgba16sint':
            {
                const t = k(e, c, '16sint', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rgba16float':
            {
                const t = k(e, c, '16float', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'r32uint':
            return [
                k(e, c, '32uint', 1)[0]
            ];
        case 'r32sint':
            return [
                k(e, c, '32sint', 1)[0]
            ];
        case 'depth16unorm':
        case 'depth24plus':
        case 'depth24plus-stencil8':
        case 'depth32float':
        case 'depth32float-stencil8':
        case 'r32float':
            return [
                k(e, c, '32float', 1)[0]
            ];
        case 'rg32uint':
            {
                const t = k(e, c, '32uint', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rg32sint':
            {
                const t = k(e, c, '32sint', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rg32float':
            {
                const t = k(e, c, '32float', 2);
                return [
                    t[0],
                    t[1]
                ];
            }
        case 'rgba32uint':
            {
                const t = k(e, c, '32uint', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rgba32sint':
            {
                const t = k(e, c, '32sint', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rgba32float':
            {
                const t = k(e, c, '32float', 4);
                return [
                    t[0],
                    t[1],
                    t[2],
                    t[3]
                ];
            }
        case 'rg11b10ufloat':
            {
                const t = new Uint32Array(e.buffer, c, 1)[0], n = (4192256 & t) >> 11, s = (4290772992 & t) >> 22;
                return [
                    v(2047 & t),
                    v(n),
                    function(e) {
                        const t = 112 + (e >> 5 & 31) << 23 | (31 & e) << 18;
                        return y[0] = t, b[0];
                    }(s),
                    1
                ];
            }
    }
    return null;
}
function k(e, t, n, s) {
    const r = [
        0,
        0,
        0,
        0
    ];
    for(let c = 0; c < s; ++c)switch(n){
        case '8unorm':
            r[c] = e[t] / 255, t++;
            break;
        case '8snorm':
            r[c] = e[t] / 255 * 2 - 1, t++;
            break;
        case '8uint':
            r[c] = e[t], t++;
            break;
        case '8sint':
            r[c] = e[t] - 127, t++;
            break;
        case '16uint':
            r[c] = e[t] | e[t + 1] << 8, t += 2;
            break;
        case '16sint':
            r[c] = (e[t] | e[t + 1] << 8) - 32768, t += 2;
            break;
        case '16float':
            r[c] = (a = e[t] | e[t + 1] << 8, i = void 0, o = void 0, l = void 0, i = (32768 & a) >> 15, l = 1023 & a, 0 == (o = (31744 & a) >> 10) ? (i ? -1 : 1) * Math.pow(2, -14) * (l / Math.pow(2, 10)) : 31 == o ? l ? NaN : 1 / 0 * (i ? -1 : 1) : (i ? -1 : 1) * Math.pow(2, o - 15) * (1 + l / Math.pow(2, 10))), t += 2;
            break;
        case '32uint':
        case '32sint':
            r[c] = e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24, t += 4;
            break;
        case '32float':
            r[c] = new Float32Array(e.buffer, t, 1)[0], t += 4;
    }
    var a, i, o, l;
    return r;
}
function I(e, t, n, s, r) {
    for(let a = 0; a < s; ++a)switch(n){
        case '8unorm':
            e[t] = 255 * r[a], t++;
            break;
        case '8snorm':
            e[t] = .5 * (r[a] + 1) * 255, t++;
            break;
        case '8uint':
            e[t] = r[a], t++;
            break;
        case '8sint':
            e[t] = r[a] + 127, t++;
            break;
        case '16uint':
            new Uint16Array(e.buffer, t, 1)[0] = r[a], t += 2;
            break;
        case '16sint':
            new Int16Array(e.buffer, t, 1)[0] = r[a], t += 2;
            break;
        case '16float':
            {
                const n = x(r[a]);
                new Uint16Array(e.buffer, t, 1)[0] = n, t += 2;
                break;
            }
        case '32uint':
            new Uint32Array(e.buffer, t, 1)[0] = r[a], t += 4;
            break;
        case '32sint':
            new Int32Array(e.buffer, t, 1)[0] = r[a], t += 4;
            break;
        case '32float':
            new Float32Array(e.buffer, t, 1)[0] = r[a], t += 4;
    }
    return r;
}
const T = {
    r8unorm: {
        bytesPerBlock: 1,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    r8snorm: {
        bytesPerBlock: 1,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    r8uint: {
        bytesPerBlock: 1,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    r8sint: {
        bytesPerBlock: 1,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    rg8unorm: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rg8snorm: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rg8uint: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rg8sint: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rgba8unorm: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    'rgba8unorm-srgb': {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgba8snorm: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgba8uint: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgba8sint: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    bgra8unorm: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    'bgra8unorm-srgb': {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    r16uint: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    r16sint: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    r16float: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    rg16uint: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rg16sint: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rg16float: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rgba16uint: {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgba16sint: {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgba16float: {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    r32uint: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    r32sint: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    r32float: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 1
    },
    rg32uint: {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rg32sint: {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rg32float: {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 2
    },
    rgba32uint: {
        bytesPerBlock: 16,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgba32sint: {
        bytesPerBlock: 16,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgba32float: {
        bytesPerBlock: 16,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgb10a2uint: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rgb10a2unorm: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    rg11b10ufloat: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    stencil8: {
        bytesPerBlock: 1,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        isDepthStencil: !0,
        hasDepth: !1,
        hasStencil: !0,
        channels: 1
    },
    depth16unorm: {
        bytesPerBlock: 2,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        isDepthStencil: !0,
        hasDepth: !0,
        hasStencil: !1,
        channels: 1
    },
    depth24plus: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        isDepthStencil: !0,
        hasDepth: !0,
        hasStencil: !1,
        depthOnlyFormat: 'depth32float',
        channels: 1
    },
    'depth24plus-stencil8': {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        isDepthStencil: !0,
        hasDepth: !0,
        hasStencil: !0,
        depthOnlyFormat: 'depth32float',
        channels: 1
    },
    depth32float: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        isDepthStencil: !0,
        hasDepth: !0,
        hasStencil: !1,
        channels: 1
    },
    'depth32float-stencil8': {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        isDepthStencil: !0,
        hasDepth: !0,
        hasStencil: !0,
        stencilOnlyFormat: 'depth32float',
        channels: 1
    },
    rgb9e5ufloat: {
        bytesPerBlock: 4,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !1,
        channels: 4
    },
    'bc1-rgba-unorm': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc1-rgba-unorm-srgb': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc2-rgba-unorm': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc2-rgba-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc3-rgba-unorm': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc3-rgba-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc4-r-unorm': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 1
    },
    'bc4-r-snorm': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 1
    },
    'bc5-rg-unorm': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 2
    },
    'bc5-rg-snorm': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 2
    },
    'bc6h-rgb-ufloat': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc6h-rgb-float': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc7-rgba-unorm': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'bc7-rgba-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'etc2-rgb8unorm': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'etc2-rgb8unorm-srgb': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'etc2-rgb8a1unorm': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'etc2-rgb8a1unorm-srgb': {
        bytesPerBlock: 8,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'etc2-rgba8unorm': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'etc2-rgba8unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'eac-r11unorm': {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !0,
        channels: 1
    },
    'eac-r11snorm': {
        bytesPerBlock: 8,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !0,
        channels: 1
    },
    'eac-rg11unorm': {
        bytesPerBlock: 16,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !0,
        channels: 2
    },
    'eac-rg11snorm': {
        bytesPerBlock: 16,
        blockWidth: 1,
        blockHeight: 1,
        isCompressed: !0,
        channels: 2
    },
    'astc-4x4-unorm': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'astc-4x4-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 4,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'astc-5x4-unorm': {
        bytesPerBlock: 16,
        blockWidth: 5,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'astc-5x4-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 5,
        blockHeight: 4,
        isCompressed: !0,
        channels: 4
    },
    'astc-5x5-unorm': {
        bytesPerBlock: 16,
        blockWidth: 5,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-5x5-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 5,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-6x5-unorm': {
        bytesPerBlock: 16,
        blockWidth: 6,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-6x5-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 6,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-6x6-unorm': {
        bytesPerBlock: 16,
        blockWidth: 6,
        blockHeight: 6,
        isCompressed: !0,
        channels: 4
    },
    'astc-6x6-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 6,
        blockHeight: 6,
        isCompressed: !0,
        channels: 4
    },
    'astc-8x5-unorm': {
        bytesPerBlock: 16,
        blockWidth: 8,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-8x5-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 8,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-8x6-unorm': {
        bytesPerBlock: 16,
        blockWidth: 8,
        blockHeight: 6,
        isCompressed: !0,
        channels: 4
    },
    'astc-8x6-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 8,
        blockHeight: 6,
        isCompressed: !0,
        channels: 4
    },
    'astc-8x8-unorm': {
        bytesPerBlock: 16,
        blockWidth: 8,
        blockHeight: 8,
        isCompressed: !0,
        channels: 4
    },
    'astc-8x8-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 8,
        blockHeight: 8,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x5-unorm': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x5-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 5,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x6-unorm': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 6,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x6-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 6,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x8-unorm': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 8,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x8-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 8,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x10-unorm': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 10,
        isCompressed: !0,
        channels: 4
    },
    'astc-10x10-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 10,
        blockHeight: 10,
        isCompressed: !0,
        channels: 4
    },
    'astc-12x10-unorm': {
        bytesPerBlock: 16,
        blockWidth: 12,
        blockHeight: 10,
        isCompressed: !0,
        channels: 4
    },
    'astc-12x10-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 12,
        blockHeight: 10,
        isCompressed: !0,
        channels: 4
    },
    'astc-12x12-unorm': {
        bytesPerBlock: 16,
        blockWidth: 12,
        blockHeight: 12,
        isCompressed: !0,
        channels: 4
    },
    'astc-12x12-unorm-srgb': {
        bytesPerBlock: 16,
        blockWidth: 12,
        blockHeight: 12,
        isCompressed: !0,
        channels: 4
    }
};
class S {
    constructor(){
        this.id = S._id++, this.line = 0;
    }
    get isAstNode() {
        return !0;
    }
    get astNodeType() {
        return '';
    }
    search(e) {
        e(this);
    }
    searchBlock(e, t) {
        if (e) {
            t(A.instance);
            for (const n of e)n instanceof Array ? this.searchBlock(n, t) : n.search(t);
            t(E.instance);
        }
    }
    constEvaluate(e, t) {
        throw new Error('Cannot evaluate node');
    }
    constEvaluateString(e) {
        return this.constEvaluate(e).toString();
    }
}
S._id = 0;
class A extends S {
}
A.instance = new A;
class E extends S {
}
E.instance = new E;
const $ = new Set([
    'all',
    'all',
    'any',
    'select',
    'arrayLength',
    'abs',
    'acos',
    'acosh',
    'asin',
    'asinh',
    'atan',
    'atanh',
    'atan2',
    'ceil',
    'clamp',
    'cos',
    'cosh',
    'countLeadingZeros',
    'countOneBits',
    'countTrailingZeros',
    'cross',
    'degrees',
    'determinant',
    'distance',
    'dot',
    'dot4U8Packed',
    'dot4I8Packed',
    'exp',
    'exp2',
    'extractBits',
    'faceForward',
    'firstLeadingBit',
    'firstTrailingBit',
    'floor',
    'fma',
    'fract',
    'frexp',
    'insertBits',
    'inverseSqrt',
    'ldexp',
    'length',
    'log',
    'log2',
    'max',
    'min',
    'mix',
    'modf',
    'normalize',
    'pow',
    'quantizeToF16',
    'radians',
    'reflect',
    'refract',
    'reverseBits',
    'round',
    'saturate',
    'sign',
    'sin',
    'sinh',
    'smoothStep',
    'sqrt',
    'step',
    'tan',
    'tanh',
    'transpose',
    'trunc',
    'dpdx',
    'dpdxCoarse',
    'dpdxFine',
    'dpdy',
    'dpdyCoarse',
    'dpdyFine',
    'fwidth',
    'fwidthCoarse',
    'fwidthFine',
    'textureDimensions',
    'textureGather',
    'textureGatherCompare',
    'textureLoad',
    'textureNumLayers',
    'textureNumLevels',
    'textureNumSamples',
    'textureSample',
    'textureSampleBias',
    'textureSampleCompare',
    'textureSampleCompareLevel',
    'textureSampleGrad',
    'textureSampleLevel',
    'textureSampleBaseClampToEdge',
    'textureStore',
    'atomicLoad',
    'atomicStore',
    'atomicAdd',
    'atomicSub',
    'atomicMax',
    'atomicMin',
    'atomicAnd',
    'atomicOr',
    'atomicXor',
    'atomicExchange',
    'atomicCompareExchangeWeak',
    'pack4x8snorm',
    'pack4x8unorm',
    'pack4xI8',
    'pack4xU8',
    'pack4x8Clamp',
    'pack4xU8Clamp',
    'pack2x16snorm',
    'pack2x16unorm',
    'pack2x16float',
    'unpack4x8snorm',
    'unpack4x8unorm',
    'unpack4xI8',
    'unpack4xU8',
    'unpack2x16snorm',
    'unpack2x16unorm',
    'unpack2x16float',
    'storageBarrier',
    'textureBarrier',
    'workgroupBarrier',
    'workgroupUniformLoad',
    'subgroupAdd',
    'subgroupExclusiveAdd',
    'subgroupInclusiveAdd',
    'subgroupAll',
    'subgroupAnd',
    'subgroupAny',
    'subgroupBallot',
    'subgroupBroadcast',
    'subgroupBroadcastFirst',
    'subgroupElect',
    'subgroupMax',
    'subgroupMin',
    'subgroupMul',
    'subgroupExclusiveMul',
    'subgroupInclusiveMul',
    'subgroupOr',
    'subgroupShuffle',
    'subgroupShuffleDown',
    'subgroupShuffleUp',
    'subgroupShuffleXor',
    'subgroupXor',
    'quadBroadcast',
    'quadSwapDiagonal',
    'quadSwapX',
    'quadSwapY'
]);
class L extends S {
    constructor(){
        super();
    }
}
class C extends L {
    constructor(e, t, n, s, r, a){
        super(), this.calls = new Set, this.name = e, this.args = t, this.returnType = n, this.body = s, this.startLine = r, this.endLine = a;
    }
    get astNodeType() {
        return 'function';
    }
    search(e) {
        if (this.attributes) for (const t of this.attributes)e(t);
        e(this);
        for (const t of this.args)e(t);
        this.searchBlock(this.body, e);
    }
}
class D extends L {
    constructor(e){
        super(), this.expression = e;
    }
    get astNodeType() {
        return 'staticAssert';
    }
    search(e) {
        this.expression.search(e);
    }
}
class N extends L {
    constructor(e, t){
        super(), this.condition = e, this.body = t;
    }
    get astNodeType() {
        return 'while';
    }
    search(e) {
        this.condition.search(e), this.searchBlock(this.body, e);
    }
}
class V extends L {
    constructor(e, t){
        super(), this.body = e, this.loopId = t;
    }
    get astNodeType() {
        return 'continuing';
    }
    search(e) {
        this.searchBlock(this.body, e);
    }
}
class O extends L {
    constructor(e, t, n, s){
        super(), this.init = e, this.condition = t, this.increment = n, this.body = s;
    }
    get astNodeType() {
        return 'for';
    }
    search(e) {
        var t, n, s;
        null === (t = this.init) || void 0 === t || t.search(e), null === (n = this.condition) || void 0 === n || n.search(e), null === (s = this.increment) || void 0 === s || s.search(e), this.searchBlock(this.body, e);
    }
}
class B extends L {
    constructor(e, t, n, s, r){
        super(), this.attributes = null, this.name = e, this.type = t, this.storage = n, this.access = s, this.value = r;
    }
    get astNodeType() {
        return 'var';
    }
    search(e) {
        var t;
        e(this), null === (t = this.value) || void 0 === t || t.search(e);
    }
}
class F extends L {
    constructor(e, t, n){
        super(), this.attributes = null, this.name = e, this.type = t, this.value = n;
    }
    get astNodeType() {
        return 'override';
    }
    search(e) {
        var t;
        null === (t = this.value) || void 0 === t || t.search(e);
    }
}
class M extends L {
    constructor(e, t, n, s, r){
        super(), this.attributes = null, this.name = e, this.type = t, this.storage = n, this.access = s, this.value = r;
    }
    get astNodeType() {
        return 'let';
    }
    search(e) {
        var t;
        e(this), null === (t = this.value) || void 0 === t || t.search(e);
    }
}
class U extends L {
    constructor(e, t, n, s, r){
        super(), this.attributes = null, this.name = e, this.type = t, this.storage = n, this.access = s, this.value = r;
    }
    get astNodeType() {
        return 'const';
    }
    constEvaluate(e, t) {
        return this.value.constEvaluate(e, t);
    }
    search(e) {
        var t;
        e(this), null === (t = this.value) || void 0 === t || t.search(e);
    }
}
var P, W, q, H;
((e)=>{
    e.increment = '++', e.decrement = '--';
})(P || (P = {})), ((e)=>{
    e.parse = function(t) {
        const n = t;
        if ('parse' == n) throw new Error('Invalid value for IncrementOperator');
        return e[n];
    };
})(P || (P = {}));
class z extends L {
    constructor(e, t){
        super(), this.operator = e, this.variable = t;
    }
    get astNodeType() {
        return 'increment';
    }
    search(e) {
        this.variable.search(e);
    }
}
((e)=>{
    e.assign = '=', e.addAssign = '+=', e.subtractAssin = '-=', e.multiplyAssign = '*=', e.divideAssign = '/=', e.moduloAssign = '%=', e.andAssign = '&=', e.orAssign = '|=', e.xorAssign = '^=', e.shiftLeftAssign = '<<=', e.shiftRightAssign = '>>=';
})(W || (W = {})), ((e)=>{
    e.parse = function(e) {
        const t = e;
        if ('parse' == t) throw new Error('Invalid value for AssignOperator');
        return t;
    };
})(W || (W = {}));
class R extends L {
    constructor(e, t, n){
        super(), this.operator = e, this.variable = t, this.value = n;
    }
    get astNodeType() {
        return 'assign';
    }
    search(e) {
        this.variable.search(e), this.value.search(e);
    }
}
class G extends L {
    constructor(e, t){
        super(), this.name = e, this.args = t;
    }
    get astNodeType() {
        return 'call';
    }
    isBuiltin() {
        return $.has(this.name);
    }
    search(e) {
        for (const t of this.args)t.search(e);
        e(this);
    }
}
class X extends L {
    constructor(e, t){
        super(), this.body = e, this.continuing = t;
    }
    get astNodeType() {
        return 'loop';
    }
}
class j extends L {
    constructor(e, t){
        super(), this.condition = e, this.cases = t;
    }
    get astNodeType() {
        return 'switch';
    }
    search(e) {
        e(this);
        for (const t of this.cases)t.search(e);
    }
}
class Z extends L {
    constructor(e, t, n, s){
        super(), this.condition = e, this.body = t, this.elseif = n, this.else = s;
    }
    get astNodeType() {
        return 'if';
    }
    search(e) {
        this.condition.search(e), this.searchBlock(this.body, e), this.searchBlock(this.elseif, e), this.searchBlock(this.else, e);
    }
}
class Q extends L {
    constructor(e){
        super(), this.value = e;
    }
    get astNodeType() {
        return 'return';
    }
    search(e) {
        var t;
        null === (t = this.value) || void 0 === t || t.search(e);
    }
}
class Y extends L {
    constructor(e){
        super(), this.name = e;
    }
    get astNodeType() {
        return 'enable';
    }
}
class K extends L {
    constructor(e){
        super(), this.extensions = e;
    }
    get astNodeType() {
        return 'requires';
    }
}
class J extends L {
    constructor(e, t){
        super(), this.severity = e, this.rule = t;
    }
    get astNodeType() {
        return 'diagnostic';
    }
}
class ee extends L {
    constructor(e, t){
        super(), this.name = e, this.type = t;
    }
    get astNodeType() {
        return 'alias';
    }
}
class te extends L {
    constructor(){
        super();
    }
    get astNodeType() {
        return 'discard';
    }
}
class ne extends L {
    constructor(){
        super(), this.condition = null, this.loopId = -1;
    }
    get astNodeType() {
        return 'break';
    }
}
class se extends L {
    constructor(){
        super(), this.loopId = -1;
    }
    get astNodeType() {
        return 'continue';
    }
}
class re extends L {
    constructor(e){
        super(), this.attributes = null, this.name = e;
    }
    get astNodeType() {
        return 'type';
    }
    get isStruct() {
        return !1;
    }
    get isArray() {
        return !1;
    }
    static maxFormatType(e) {
        let t = e[0];
        if ('f32' === t.name) return t;
        for(let n = 1; n < e.length; ++n){
            const s = re._priority.get(t.name);
            re._priority.get(e[n].name) < s && (t = e[n]);
        }
        return 'x32' === t.name ? re.i32 : t;
    }
    getTypeName() {
        return this.name;
    }
}
re.x32 = new re('x32'), re.f32 = new re('f32'), re.i32 = new re('i32'), re.u32 = new re('u32'), re.f16 = new re('f16'), re.bool = new re('bool'), re.void = new re('void'), re._priority = new Map([
    [
        'f32',
        0
    ],
    [
        'f16',
        1
    ],
    [
        'u32',
        2
    ],
    [
        'i32',
        3
    ],
    [
        'x32',
        3
    ]
]);
class ae extends re {
    constructor(e){
        super(e);
    }
}
class ie extends re {
    constructor(e, t, n, s){
        super(e), this.members = t, this.startLine = n, this.endLine = s;
    }
    get astNodeType() {
        return 'struct';
    }
    get isStruct() {
        return !0;
    }
    getMemberIndex(e) {
        for(let t = 0; t < this.members.length; t++)if (this.members[t].name == e) return t;
        return -1;
    }
    search(e) {
        for (const t of this.members)e(t);
    }
}
class oe extends re {
    constructor(e, t, n){
        super(e), this.format = t, this.access = n;
    }
    get astNodeType() {
        return 'template';
    }
    getTypeName() {
        let e = this.name;
        if (null !== this.format) {
            if ('vec2' === e || 'vec3' === e || 'vec4' === e || 'mat2x2' === e || 'mat2x3' === e || 'mat2x4' === e || 'mat3x2' === e || 'mat3x3' === e || 'mat3x4' === e || 'mat4x2' === e || 'mat4x3' === e || 'mat4x4' === e) {
                if ('f32' === this.format.name) return e += 'f', e;
                if ('i32' === this.format.name) return e += 'i', e;
                if ('u32' === this.format.name) return e += 'u', e;
                if ('bool' === this.format.name) return e += 'b', e;
                if ('f16' === this.format.name) return e += 'h', e;
            }
            e += `<${this.format.name}>`;
        } else if ('vec2' === e || 'vec3' === e || 'vec4' === e) return e;
        return e;
    }
}
oe.vec2f = new oe('vec2', re.f32, null), oe.vec3f = new oe('vec3', re.f32, null), oe.vec4f = new oe('vec4', re.f32, null), oe.vec2i = new oe('vec2', re.i32, null), oe.vec3i = new oe('vec3', re.i32, null), oe.vec4i = new oe('vec4', re.i32, null), oe.vec2u = new oe('vec2', re.u32, null), oe.vec3u = new oe('vec3', re.u32, null), oe.vec4u = new oe('vec4', re.u32, null), oe.vec2h = new oe('vec2', re.f16, null), oe.vec3h = new oe('vec3', re.f16, null), oe.vec4h = new oe('vec4', re.f16, null), oe.vec2b = new oe('vec2', re.bool, null), oe.vec3b = new oe('vec3', re.bool, null), oe.vec4b = new oe('vec4', re.bool, null), oe.mat2x2f = new oe('mat2x2', re.f32, null), oe.mat2x3f = new oe('mat2x3', re.f32, null), oe.mat2x4f = new oe('mat2x4', re.f32, null), oe.mat3x2f = new oe('mat3x2', re.f32, null), oe.mat3x3f = new oe('mat3x3', re.f32, null), oe.mat3x4f = new oe('mat3x4', re.f32, null), oe.mat4x2f = new oe('mat4x2', re.f32, null), oe.mat4x3f = new oe('mat4x3', re.f32, null), oe.mat4x4f = new oe('mat4x4', re.f32, null), oe.mat2x2h = new oe('mat2x2', re.f16, null), oe.mat2x3h = new oe('mat2x3', re.f16, null), oe.mat2x4h = new oe('mat2x4', re.f16, null), oe.mat3x2h = new oe('mat3x2', re.f16, null), oe.mat3x3h = new oe('mat3x3', re.f16, null), oe.mat3x4h = new oe('mat3x4', re.f16, null), oe.mat4x2h = new oe('mat4x2', re.f16, null), oe.mat4x3h = new oe('mat4x3', re.f16, null), oe.mat4x4h = new oe('mat4x4', re.f16, null), oe.mat2x2i = new oe('mat2x2', re.i32, null), oe.mat2x3i = new oe('mat2x3', re.i32, null), oe.mat2x4i = new oe('mat2x4', re.i32, null), oe.mat3x2i = new oe('mat3x2', re.i32, null), oe.mat3x3i = new oe('mat3x3', re.i32, null), oe.mat3x4i = new oe('mat3x4', re.i32, null), oe.mat4x2i = new oe('mat4x2', re.i32, null), oe.mat4x3i = new oe('mat4x3', re.i32, null), oe.mat4x4i = new oe('mat4x4', re.i32, null), oe.mat2x2u = new oe('mat2x2', re.u32, null), oe.mat2x3u = new oe('mat2x3', re.u32, null), oe.mat2x4u = new oe('mat2x4', re.u32, null), oe.mat3x2u = new oe('mat3x2', re.u32, null), oe.mat3x3u = new oe('mat3x3', re.u32, null), oe.mat3x4u = new oe('mat3x4', re.u32, null), oe.mat4x2u = new oe('mat4x2', re.u32, null), oe.mat4x3u = new oe('mat4x3', re.u32, null), oe.mat4x4u = new oe('mat4x4', re.u32, null);
class le extends re {
    constructor(e, t, n, s){
        super(e), this.storage = t, this.type = n, this.access = s;
    }
    get astNodeType() {
        return 'pointer';
    }
}
class ce extends re {
    constructor(e, t, n, s){
        super(e), this.attributes = t, this.format = n, this.count = s;
    }
    get astNodeType() {
        return 'array';
    }
    get isArray() {
        return !0;
    }
}
class ue extends re {
    constructor(e, t, n){
        super(e), this.format = t, this.access = n;
    }
    get astNodeType() {
        return 'sampler';
    }
}
class he extends S {
    constructor(){
        super(), this.postfix = null;
    }
}
class fe extends he {
    constructor(e){
        super(), this.value = e;
    }
    get astNodeType() {
        return 'stringExpr';
    }
    toString() {
        return this.value;
    }
    constEvaluateString() {
        return this.value;
    }
}
class pe extends he {
    constructor(e, t){
        super(), this.type = e, this.args = t;
    }
    get astNodeType() {
        return 'createExpr';
    }
    search(e) {
        if (e(this), this.args) for (const t of this.args)t.search(e);
    }
    constEvaluate(e, t) {
        return t && (t[0] = this.type), e.evalExpression(this, e.context);
    }
}
class de extends he {
    constructor(e, t){
        super(), this.cachedReturnValue = null, this.name = e, this.args = t;
    }
    get astNodeType() {
        return 'callExpr';
    }
    setCachedReturnValue(e) {
        this.cachedReturnValue = e;
    }
    get isBuiltin() {
        return $.has(this.name);
    }
    constEvaluate(e, t) {
        return e.evalExpression(this, e.context);
    }
    search(e) {
        for (const t of this.args)t.search(e);
        e(this);
    }
}
class me extends he {
    constructor(e){
        super(), this.name = e;
    }
    get astNodeType() {
        return 'varExpr';
    }
    search(e) {
        e(this), this.postfix && this.postfix.search(e);
    }
    constEvaluate(e, t) {
        return e.evalExpression(this, e.context);
    }
}
class _e extends he {
    constructor(e, t){
        super(), this.name = e, this.initializer = t;
    }
    get astNodeType() {
        return 'constExpr';
    }
    constEvaluate(e, t) {
        if (this.initializer) {
            const t = e.evalExpression(this.initializer, e.context);
            return null !== t && this.postfix ? t.getSubData(e, this.postfix, e.context) : t;
        }
        return null;
    }
    search(e) {
        this.initializer.search(e);
    }
}
class ge extends he {
    constructor(e, t){
        super(), this.value = e, this.type = t;
    }
    get astNodeType() {
        return 'literalExpr';
    }
    constEvaluate(e, t) {
        return void 0 !== t && (t[0] = this.type), this.value;
    }
    get isScalar() {
        return this.value instanceof Oe;
    }
    get isVector() {
        return this.value instanceof Fe || this.value instanceof Me;
    }
    get scalarValue() {
        return this.value instanceof Oe ? this.value.value : (console.error('Value is not scalar.'), 0);
    }
    get vectorValue() {
        return this.value instanceof Fe || this.value instanceof Me ? this.value.data : (console.error('Value is not a vector or matrix.'), new Float32Array(0));
    }
}
class xe extends he {
    constructor(e, t){
        super(), this.type = e, this.value = t;
    }
    get astNodeType() {
        return 'bitcastExpr';
    }
    search(e) {
        this.value.search(e);
    }
}
class ye extends he {
    constructor(e, t){
        super(), this.type = e, this.args = t;
    }
    get astNodeType() {
        return 'typecastExpr';
    }
    constEvaluate(e, t) {
        return e.evalExpression(this, e.context);
    }
    search(e) {
        this.searchBlock(this.args, e);
    }
}
class be extends he {
    constructor(e){
        super(), this.index = e;
    }
    search(e) {
        this.index.search(e);
    }
}
class ve extends he {
    constructor(){
        super();
    }
}
class we extends ve {
    constructor(e, t){
        super(), this.operator = e, this.right = t;
    }
    get astNodeType() {
        return 'unaryOp';
    }
    constEvaluate(e, t) {
        return e.evalExpression(this, e.context);
    }
    search(e) {
        this.right.search(e);
    }
}
class ke extends ve {
    constructor(e, t, n){
        super(), this.operator = e, this.left = t, this.right = n;
    }
    get astNodeType() {
        return 'binaryOp';
    }
    _getPromotedType(e, t) {
        return e.name === t.name ? e : 'f32' === e.name || 'f32' === t.name ? re.f32 : 'u32' === e.name || 'u32' === t.name ? re.u32 : re.i32;
    }
    constEvaluate(e, t) {
        return e.evalExpression(this, e.context);
    }
    search(e) {
        this.left.search(e), this.right.search(e);
    }
}
class Ie extends S {
    constructor(e){
        super(), this.body = e;
    }
    search(e) {
        e(this), this.searchBlock(this.body, e);
    }
}
class Te extends he {
    constructor(){
        super();
    }
    get astNodeType() {
        return 'default';
    }
}
class Se extends Ie {
    constructor(e, t){
        super(t), this.selectors = e;
    }
    get astNodeType() {
        return 'case';
    }
    search(e) {
        this.searchBlock(this.body, e);
    }
}
class Ae extends Ie {
    constructor(e){
        super(e);
    }
    get astNodeType() {
        return 'default';
    }
    search(e) {
        this.searchBlock(this.body, e);
    }
}
class Ee extends S {
    constructor(e, t, n){
        super(), this.name = e, this.type = t, this.attributes = n;
    }
    get astNodeType() {
        return 'argument';
    }
}
class $e extends S {
    constructor(e, t){
        super(), this.condition = e, this.body = t;
    }
    get astNodeType() {
        return 'elseif';
    }
    search(e) {
        this.condition.search(e), this.searchBlock(this.body, e);
    }
}
class Le extends S {
    constructor(e, t, n){
        super(), this.name = e, this.type = t, this.attributes = n;
    }
    get astNodeType() {
        return 'member';
    }
}
class Ce extends S {
    constructor(e, t){
        super(), this.name = e, this.value = t;
    }
    get astNodeType() {
        return 'attribute';
    }
}
class De {
    constructor(e, t){
        this.parent = null, this.typeInfo = e, this.parent = t, this.id = De._id++;
    }
    clone() {
        throw `Clone: Not implemented for ${this.constructor.name}`;
    }
    setDataValue(e, t, n, s) {
        console.error(`SetDataValue: Not implemented for ${this.constructor.name}`);
    }
    getSubData(e, t, n) {
        return console.error(`GetDataValue: Not implemented for ${this.constructor.name}`), null;
    }
    toString() {
        return `<${this.typeInfo.getTypeName()}>`;
    }
}
De._id = 0;
class Ne extends De {
    constructor(){
        super(new e('void', null), null);
    }
    toString() {
        return 'void';
    }
}
Ne.void = new Ne;
class Ve extends De {
    constructor(e){
        super(new r('pointer', e.typeInfo, null), null), this.reference = e;
    }
    clone() {
        return this;
    }
    setDataValue(e, t, n, s) {
        this.reference.setDataValue(e, t, n, s);
    }
    getSubData(e, t, n) {
        return t ? this.reference.getSubData(e, t, n) : this;
    }
    toString() {
        return `&${this.reference.toString()}`;
    }
}
class Oe extends De {
    constructor(e, t, n = null){
        super(t, n), e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array ? this.data = e : 'x32' === this.typeInfo.name ? e - Math.floor(e) != 0 ? this.data = new Float32Array([
            e
        ]) : this.data = e >= 0 ? new Uint32Array([
            e
        ]) : new Int32Array([
            e
        ]) : 'i32' === this.typeInfo.name || 'bool' === this.typeInfo.name ? this.data = new Int32Array([
            e
        ]) : 'u32' === this.typeInfo.name ? this.data = new Uint32Array([
            e
        ]) : 'f32' === this.typeInfo.name || 'f16' === this.typeInfo.name ? this.data = new Float32Array([
            e
        ]) : console.error('ScalarData2: Invalid type', t);
    }
    clone() {
        if (this.data instanceof Float32Array) return new Oe(new Float32Array(this.data), this.typeInfo, null);
        if (this.data instanceof Int32Array) return new Oe(new Int32Array(this.data), this.typeInfo, null);
        if (this.data instanceof Uint32Array) return new Oe(new Uint32Array(this.data), this.typeInfo, null);
        throw 'ScalarData: Invalid data type';
    }
    get value() {
        return this.data[0];
    }
    set value(e) {
        this.data[0] = e;
    }
    setDataValue(e, t, n, s) {
        if (n) return void console.error('SetDataValue: Scalar data does not support postfix', n);
        if (!(t instanceof Oe)) return void console.error('SetDataValue: Invalid value', t);
        let r = t.data[0];
        'i32' === this.typeInfo.name || 'u32' === this.typeInfo.name ? r = Math.floor(r) : 'bool' === this.typeInfo.name && (r = r ? 1 : 0), this.data[0] = r;
    }
    getSubData(e, t, n) {
        return t ? (console.error('getSubData: Scalar data does not support postfix', t), null) : this;
    }
    toString() {
        return `${this.value}`;
    }
}
function Be(e, t, n) {
    const s = t.length;
    return 2 === s ? 'f32' === n ? new Fe(new Float32Array(t), e.getTypeInfo('vec2f')) : 'i32' === n || 'bool' === n ? new Fe(new Int32Array(t), e.getTypeInfo('vec2i')) : 'u32' === n ? new Fe(new Uint32Array(t), e.getTypeInfo('vec2u')) : 'f16' === n ? new Fe(new Float32Array(t), e.getTypeInfo('vec2h')) : (console.error(`getSubData: Unknown format ${n}`), null) : 3 === s ? 'f32' === n ? new Fe(new Float32Array(t), e.getTypeInfo('vec3f')) : 'i32' === n || 'bool' === n ? new Fe(new Int32Array(t), e.getTypeInfo('vec3i')) : 'u32' === n ? new Fe(new Uint32Array(t), e.getTypeInfo('vec3u')) : 'f16' === n ? new Fe(new Float32Array(t), e.getTypeInfo('vec3h')) : (console.error(`getSubData: Unknown format ${n}`), null) : 4 === s ? 'f32' === n ? new Fe(new Float32Array(t), e.getTypeInfo('vec4f')) : 'i32' === n || 'bool' === n ? new Fe(new Int32Array(t), e.getTypeInfo('vec4i')) : 'u32' === n ? new Fe(new Uint32Array(t), e.getTypeInfo('vec4u')) : 'f16' === n ? new Fe(new Float32Array(t), e.getTypeInfo('vec4h')) : (console.error(`getSubData: Unknown format ${n}`), null) : (console.error(`getSubData: Invalid vector size ${t.length}`), null);
}
class Fe extends De {
    constructor(e, t, n = null){
        if (super(t, n), e instanceof Float32Array || e instanceof Uint32Array || e instanceof Int32Array) this.data = e;
        else {
            const t = this.typeInfo.name;
            'vec2f' === t || 'vec3f' === t || 'vec4f' === t ? this.data = new Float32Array(e) : 'vec2i' === t || 'vec3i' === t || 'vec4i' === t ? this.data = new Int32Array(e) : 'vec2u' === t || 'vec3u' === t || 'vec4u' === t ? this.data = new Uint32Array(e) : 'vec2h' === t || 'vec3h' === t || 'vec4h' === t ? this.data = new Float32Array(e) : 'vec2b' === t || 'vec3b' === t || 'vec4b' === t ? this.data = new Int32Array(e) : 'vec2' === t || 'vec3' === t || 'vec4' === t ? this.data = new Float32Array(e) : console.error(`VectorData: Invalid type ${t}`);
        }
    }
    clone() {
        if (this.data instanceof Float32Array) return new Fe(new Float32Array(this.data), this.typeInfo, null);
        if (this.data instanceof Int32Array) return new Fe(new Int32Array(this.data), this.typeInfo, null);
        if (this.data instanceof Uint32Array) return new Fe(new Uint32Array(this.data), this.typeInfo, null);
        throw 'VectorData: Invalid data type';
    }
    setDataValue(e, t, n, s) {
        n instanceof fe ? console.error('TODO: Set vector postfix') : t instanceof Fe ? this.data = t.data : console.error('SetDataValue: Invalid value', t);
    }
    getSubData(e, t, n) {
        if (null === t) return this;
        let s = e.getTypeInfo('f32');
        if (this.typeInfo instanceof a) s = this.typeInfo.format || s;
        else {
            const t = this.typeInfo.name;
            'vec2f' === t || 'vec3f' === t || 'vec4f' === t ? s = e.getTypeInfo('f32') : 'vec2i' === t || 'vec3i' === t || 'vec4i' === t ? s = e.getTypeInfo('i32') : 'vec2b' === t || 'vec3b' === t || 'vec4b' === t ? s = e.getTypeInfo('bool') : 'vec2u' === t || 'vec3u' === t || 'vec4u' === t ? s = e.getTypeInfo('u32') : 'vec2h' === t || 'vec3h' === t || 'vec4h' === t ? s = e.getTypeInfo('f16') : console.error(`GetSubData: Unknown type ${t}`);
        }
        let r = this;
        for(; null !== t && null !== r;){
            if (t instanceof be) {
                const a = t.index;
                let i = -1;
                if (a instanceof ge) {
                    if (!(a.value instanceof Oe)) return console.error(`GetSubData: Invalid array index ${a.value}`), null;
                    i = a.value.value;
                } else {
                    const t = e.evalExpression(a, n);
                    if (!(t instanceof Oe)) return console.error('GetSubData: Unknown index type', a), null;
                    i = t.value;
                }
                if (i < 0 || i >= r.data.length) return console.error('GetSubData: Index out of range', i), null;
                if (r.data instanceof Float32Array) {
                    const e = new Float32Array(r.data.buffer, r.data.byteOffset + 4 * i, 1);
                    return new Oe(e, s);
                }
                if (r.data instanceof Int32Array) {
                    const e = new Int32Array(r.data.buffer, r.data.byteOffset + 4 * i, 1);
                    return new Oe(e, s);
                }
                if (r.data instanceof Uint32Array) {
                    const e = new Uint32Array(r.data.buffer, r.data.byteOffset + 4 * i, 1);
                    return new Oe(e, s);
                }
                throw 'GetSubData: Invalid data type';
            }
            if (!(t instanceof fe)) return console.error('GetSubData: Unknown postfix', t), null;
            {
                const n = t.value.toLowerCase();
                if (1 === n.length) {
                    let e = 0;
                    if ('x' === n || 'r' === n) e = 0;
                    else if ('y' === n || 'g' === n) e = 1;
                    else if ('z' === n || 'b' === n) e = 2;
                    else {
                        if ('w' !== n && 'a' !== n) return console.error(`GetSubData: Unknown member ${n}`), null;
                        e = 3;
                    }
                    if (this.data instanceof Float32Array) {
                        let t = new Float32Array(this.data.buffer, this.data.byteOffset + 4 * e, 1);
                        return new Oe(t, s, this);
                    }
                    if (this.data instanceof Int32Array) {
                        let t = new Int32Array(this.data.buffer, this.data.byteOffset + 4 * e, 1);
                        return new Oe(t, s, this);
                    }
                    if (this.data instanceof Uint32Array) {
                        let t = new Uint32Array(this.data.buffer, this.data.byteOffset + 4 * e, 1);
                        return new Oe(t, s, this);
                    }
                }
                const a = [];
                for (const e of n)'x' === e || 'r' === e ? a.push(this.data[0]) : 'y' === e || 'g' === e ? a.push(this.data[1]) : 'z' === e || 'b' === e ? a.push(this.data[2]) : 'w' === e || 'a' === e ? a.push(this.data[3]) : console.error(`GetDataValue: Unknown member ${e}`);
                r = Be(e, a, s.name);
            }
            t = t.postfix;
        }
        return r;
    }
    toString() {
        let e = `${this.data[0]}`;
        for(let t = 1; t < this.data.length; ++t)e += `, ${this.data[t]}`;
        return e;
    }
}
class Me extends De {
    constructor(e, t, n = null){
        super(t, n), e instanceof Float32Array ? this.data = e : this.data = new Float32Array(e);
    }
    clone() {
        return new Me(new Float32Array(this.data), this.typeInfo, null);
    }
    setDataValue(e, t, n, s) {
        n instanceof fe ? console.error('TODO: Set matrix postfix') : t instanceof Me ? this.data = t.data : console.error('SetDataValue: Invalid value', t);
    }
    getSubData(e, t, n) {
        if (null === t) return this;
        const s = this.typeInfo.name;
        if (e.getTypeInfo('f32'), this.typeInfo instanceof a) this.typeInfo.format;
        else if (s.endsWith('f')) e.getTypeInfo('f32');
        else if (s.endsWith('i')) e.getTypeInfo('i32');
        else if (s.endsWith('u')) e.getTypeInfo('u32');
        else {
            if (!s.endsWith('h')) return console.error(`GetDataValue: Unknown type ${s}`), null;
            e.getTypeInfo('f16');
        }
        if (t instanceof be) {
            const r = t.index;
            let a = -1;
            if (r instanceof ge) {
                if (!(r.value instanceof Oe)) return console.error(`GetDataValue: Invalid array index ${r.value}`), null;
                a = r.value.value;
            } else {
                const t = e.evalExpression(r, n);
                if (!(t instanceof Oe)) return console.error('GetDataValue: Unknown index type', r), null;
                a = t.value;
            }
            if (a < 0 || a >= this.data.length) return console.error('GetDataValue: Index out of range', a), null;
            const i = s.endsWith('h') ? 'h' : 'f';
            let o;
            if ('mat2x2' === s || 'mat2x2f' === s || 'mat2x2h' === s || 'mat3x2' === s || 'mat3x2f' === s || 'mat3x2h' === s || 'mat4x2' === s || 'mat4x2f' === s || 'mat4x2h' === s) o = new Fe(new Float32Array(this.data.buffer, this.data.byteOffset + 2 * a * 4, 2), e.getTypeInfo(`vec2${i}`));
            else if ('mat2x3' === s || 'mat2x3f' === s || 'mat2x3h' === s || 'mat3x3' === s || 'mat3x3f' === s || 'mat3x3h' === s || 'mat4x3' === s || 'mat4x3f' === s || 'mat4x3h' === s) o = new Fe(new Float32Array(this.data.buffer, this.data.byteOffset + 3 * a * 4, 3), e.getTypeInfo(`vec3${i}`));
            else {
                if ('mat2x4' !== s && 'mat2x4f' !== s && 'mat2x4h' !== s && 'mat3x4' !== s && 'mat3x4f' !== s && 'mat3x4h' !== s && 'mat4x4' !== s && 'mat4x4f' !== s && 'mat4x4h' !== s) return console.error(`GetDataValue: Unknown type ${s}`), null;
                o = new Fe(new Float32Array(this.data.buffer, this.data.byteOffset + 4 * a * 4, 4), e.getTypeInfo(`vec4${i}`));
            }
            return t.postfix ? o.getSubData(e, t.postfix, n) : o;
        }
        return console.error('GetDataValue: Invalid postfix', t), null;
    }
    toString() {
        let e = `${this.data[0]}`;
        for(let t = 1; t < this.data.length; ++t)e += `, ${this.data[t]}`;
        return e;
    }
}
class Ue extends De {
    constructor(e, t, n = 0, s = null){
        super(t, s), this.buffer = e instanceof ArrayBuffer ? e : e.buffer, this.offset = n;
    }
    clone() {
        const e = new Uint8Array(new Uint8Array(this.buffer, this.offset, this.typeInfo.size));
        return new Ue(e.buffer, this.typeInfo, 0, null);
    }
    setDataValue(t, r, a, i) {
        if (null === r) return void console.log('setDataValue: NULL data.');
        let o = this.offset, l = this.typeInfo;
        for(; a;){
            if (a instanceof be) {
                if (l instanceof s) {
                    const e = a.index;
                    if (e instanceof ge) {
                        if (!(e.value instanceof Oe)) return void console.error(`SetDataValue: Invalid index type ${e.value}`);
                        o += e.value.value * l.stride;
                    } else {
                        const n = t.evalExpression(e, i);
                        if (!(n instanceof Oe)) return void console.error('SetDataValue: Unknown index type', e);
                        o += n.value * l.stride;
                    }
                    l = l.format;
                } else console.error(`SetDataValue: Type ${l.getTypeName()} is not an array`);
            } else {
                if (!(a instanceof fe)) return void console.error('SetDataValue: Unknown postfix type', a);
                {
                    const t = a.value;
                    if (l instanceof n) {
                        let e = !1;
                        for (const n of l.members)if (n.name === t) {
                            o += n.offset, l = n.type, e = !0;
                            break;
                        }
                        if (!e) return void console.error(`SetDataValue: Member ${t} not found`);
                    } else if (l instanceof e) {
                        const e = l.getTypeName();
                        let n = 0;
                        if ('x' === t || 'r' === t) n = 0;
                        else if ('y' === t || 'g' === t) n = 1;
                        else if ('z' === t || 'b' === t) n = 2;
                        else {
                            if ('w' !== t && 'a' !== t) return void console.error(`SetDataValue: Unknown member ${t}`);
                            n = 3;
                        }
                        if (!(r instanceof Oe)) return void console.error('SetDataValue: Invalid value', r);
                        const s = r.value;
                        return 'vec2f' === e ? void (new Float32Array(this.buffer, o, 2)[n] = s) : 'vec3f' === e ? void (new Float32Array(this.buffer, o, 3)[n] = s) : 'vec4f' === e ? void (new Float32Array(this.buffer, o, 4)[n] = s) : 'vec2i' === e ? void (new Int32Array(this.buffer, o, 2)[n] = s) : 'vec3i' === e ? void (new Int32Array(this.buffer, o, 3)[n] = s) : 'vec4i' === e ? void (new Int32Array(this.buffer, o, 4)[n] = s) : 'vec2u' === e ? void (new Uint32Array(this.buffer, o, 2)[n] = s) : 'vec3u' === e ? void (new Uint32Array(this.buffer, o, 3)[n] = s) : 'vec4u' === e ? void (new Uint32Array(this.buffer, o, 4)[n] = s) : void console.error(`SetDataValue: Type ${e} is not a struct`);
                    }
                }
            }
            a = a.postfix;
        }
        this.setData(t, r, l, o, i);
    }
    setData(e, t, n, s, r) {
        const a = n.getTypeName();
        if ('f32' !== a && 'f16' !== a) {
            if ('i32' !== a && 'atomic<i32>' !== a && 'x32' !== a) {
                if ('u32' !== a && 'atomic<u32>' !== a) {
                    if ('bool' !== a) {
                        if ('vec2f' !== a && 'vec2h' !== a) {
                            if ('vec3f' !== a && 'vec3h' !== a) {
                                if ('vec4f' !== a && 'vec4h' !== a) {
                                    if ('vec2i' !== a) {
                                        if ('vec3i' !== a) {
                                            if ('vec4i' !== a) {
                                                if ('vec2u' !== a) {
                                                    if ('vec3u' !== a) {
                                                        if ('vec4u' !== a) {
                                                            if ('vec2b' !== a) {
                                                                if ('vec3b' !== a) {
                                                                    if ('vec4b' !== a) {
                                                                        if ('mat2x2f' !== a && 'mat2x2h' !== a) {
                                                                            if ('mat2x3f' !== a && 'mat2x3h' !== a) {
                                                                                if ('mat2x4f' !== a && 'mat2x4h' !== a) {
                                                                                    if ('mat3x2f' !== a && 'mat3x2h' !== a) {
                                                                                        if ('mat3x3f' !== a && 'mat3x3h' !== a) {
                                                                                            if ('mat3x4f' !== a && 'mat3x4h' !== a) {
                                                                                                if ('mat4x2f' !== a && 'mat4x2h' !== a) {
                                                                                                    if ('mat4x3f' !== a && 'mat4x3h' !== a) {
                                                                                                        if ('mat4x4f' !== a && 'mat4x4h' !== a) {
                                                                                                            if (t instanceof Ue) {
                                                                                                                if (n === t.typeInfo) return void new Uint8Array(this.buffer, s, t.buffer.byteLength).set(new Uint8Array(t.buffer));
                                                                                                                console.error('SetDataValue: Type mismatch', a, t.typeInfo.getTypeName());
                                                                                                            } else console.error(`SetData: Unknown type ${a}`);
                                                                                                        } else {
                                                                                                            const e = new Float32Array(this.buffer, s, 16);
                                                                                                            t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5], e[6] = t.data[6], e[7] = t.data[7], e[8] = t.data[8], e[9] = t.data[9], e[10] = t.data[10], e[11] = t.data[11], e[12] = t.data[12], e[13] = t.data[13], e[14] = t.data[14], e[15] = t.data[15]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]);
                                                                                                        }
                                                                                                    } else {
                                                                                                        const e = new Float32Array(this.buffer, s, 12);
                                                                                                        t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5], e[6] = t.data[6], e[7] = t.data[7], e[8] = t.data[8], e[9] = t.data[9], e[10] = t.data[10], e[11] = t.data[11]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11]);
                                                                                                    }
                                                                                                } else {
                                                                                                    const e = new Float32Array(this.buffer, s, 8);
                                                                                                    t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5], e[6] = t.data[6], e[7] = t.data[7]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7]);
                                                                                                }
                                                                                            } else {
                                                                                                const e = new Float32Array(this.buffer, s, 12);
                                                                                                t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5], e[6] = t.data[6], e[7] = t.data[7], e[8] = t.data[8], e[9] = t.data[9], e[10] = t.data[10], e[11] = t.data[11]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11]);
                                                                                            }
                                                                                        } else {
                                                                                            const e = new Float32Array(this.buffer, s, 9);
                                                                                            t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5], e[6] = t.data[6], e[7] = t.data[7], e[8] = t.data[8]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8]);
                                                                                        }
                                                                                    } else {
                                                                                        const e = new Float32Array(this.buffer, s, 6);
                                                                                        t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5]);
                                                                                    }
                                                                                } else {
                                                                                    const e = new Float32Array(this.buffer, s, 8);
                                                                                    t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5], e[6] = t.data[6], e[7] = t.data[7]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7]);
                                                                                }
                                                                            } else {
                                                                                const e = new Float32Array(this.buffer, s, 6);
                                                                                t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3], e[4] = t.data[4], e[5] = t.data[5]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5]);
                                                                            }
                                                                        } else {
                                                                            const e = new Float32Array(this.buffer, s, 4);
                                                                            t instanceof Me ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3]);
                                                                        }
                                                                    } else {
                                                                        const e = new Uint32Array(this.buffer, s, 4);
                                                                        t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3]);
                                                                    }
                                                                } else {
                                                                    const e = new Uint32Array(this.buffer, s, 3);
                                                                    t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2]);
                                                                }
                                                            } else {
                                                                const e = new Uint32Array(this.buffer, s, 2);
                                                                t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1]) : (e[0] = t[0], e[1] = t[1]);
                                                            }
                                                        } else {
                                                            const e = new Uint32Array(this.buffer, s, 4);
                                                            t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3]);
                                                        }
                                                    } else {
                                                        const e = new Uint32Array(this.buffer, s, 3);
                                                        t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2]);
                                                    }
                                                } else {
                                                    const e = new Uint32Array(this.buffer, s, 2);
                                                    t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1]) : (e[0] = t[0], e[1] = t[1]);
                                                }
                                            } else {
                                                const e = new Int32Array(this.buffer, s, 4);
                                                t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3]);
                                            }
                                        } else {
                                            const e = new Int32Array(this.buffer, s, 3);
                                            t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2]);
                                        }
                                    } else {
                                        const e = new Int32Array(this.buffer, s, 2);
                                        t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1]) : (e[0] = t[0], e[1] = t[1]);
                                    }
                                } else {
                                    const e = new Float32Array(this.buffer, s, 4);
                                    t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2], e[3] = t.data[3]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3]);
                                }
                            } else {
                                const e = new Float32Array(this.buffer, s, 3);
                                t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1], e[2] = t.data[2]) : (e[0] = t[0], e[1] = t[1], e[2] = t[2]);
                            }
                        } else {
                            const e = new Float32Array(this.buffer, s, 2);
                            t instanceof Fe ? (e[0] = t.data[0], e[1] = t.data[1]) : (e[0] = t[0], e[1] = t[1]);
                        }
                    } else t instanceof Oe && (new Int32Array(this.buffer, s, 1)[0] = t.value);
                } else t instanceof Oe && (new Uint32Array(this.buffer, s, 1)[0] = t.value);
            } else t instanceof Oe && (new Int32Array(this.buffer, s, 1)[0] = t.value);
        } else t instanceof Oe && (new Float32Array(this.buffer, s, 1)[0] = t.value);
    }
    getSubData(t, r, i) {
        var o, l, c;
        if (null === r) return this;
        let u = this.offset, h = this.typeInfo;
        for(; r;){
            if (r instanceof be) {
                const e = r.index, n = e instanceof he ? t.evalExpression(e, i) : e;
                let a = 0;
                if (n instanceof Oe ? a = n.value : 'number' == typeof n ? a = n : console.error('GetDataValue: Invalid index type', e), h instanceof s) u += a * h.stride, h = h.format;
                else {
                    const e = h.getTypeName();
                    'mat4x4' === e || 'mat4x4f' === e || 'mat4x4h' === e ? (u += 16 * a, h = t.getTypeInfo('vec4f')) : console.error(`getDataValue: Type ${h.getTypeName()} is not an array`);
                }
            } else {
                if (!(r instanceof fe)) return console.error('GetDataValue: Unknown postfix type', r), null;
                {
                    const s = r.value;
                    if (h instanceof n) {
                        let e = !1;
                        for (const t of h.members)if (t.name === s) {
                            u += t.offset, h = t.type, e = !0;
                            break;
                        }
                        if (!e) return console.error(`GetDataValue: Member ${s} not found`), null;
                    } else if (h instanceof e) {
                        const e = h.getTypeName();
                        if ('vec2f' === e || 'vec3f' === e || 'vec4f' === e || 'vec2i' === e || 'vec3i' === e || 'vec4i' === e || 'vec2u' === e || 'vec3u' === e || 'vec4u' === e || 'vec2b' === e || 'vec3b' === e || 'vec4b' === e || 'vec2h' === e || 'vec3h' === e || 'vec4h' === e || 'vec2' === e || 'vec3' === e || 'vec4' === e) {
                            if (s.length > 0 && s.length < 5) {
                                let n = 'f';
                                const r = [];
                                for(let a = 0; a < s.length; ++a){
                                    const i = s[a].toLowerCase();
                                    let o = 0;
                                    if ('x' === i || 'r' === i) o = 0;
                                    else if ('y' === i || 'g' === i) o = 1;
                                    else if ('z' === i || 'b' === i) o = 2;
                                    else {
                                        if ('w' !== i && 'a' !== i) return console.error(`Unknown member ${s}`), null;
                                        o = 3;
                                    }
                                    if (1 === s.length) {
                                        if (e.endsWith('f')) return this.buffer.byteLength < u + 4 * o + 4 ? (console.log('Insufficient buffer data'), null) : new Oe(new Float32Array(this.buffer, u + 4 * o, 1), t.getTypeInfo('f32'), this);
                                        if (e.endsWith('h')) return new Oe(new Float32Array(this.buffer, u + 4 * o, 1), t.getTypeInfo('f16'), this);
                                        if (e.endsWith('i')) return new Oe(new Int32Array(this.buffer, u + 4 * o, 1), t.getTypeInfo('i32'), this);
                                        if (e.endsWith('b')) return new Oe(new Int32Array(this.buffer, u + 4 * o, 1), t.getTypeInfo('bool'), this);
                                        if (e.endsWith('u')) return new Oe(new Uint32Array(this.buffer, u + 4 * o, 1), t.getTypeInfo('i32'), this);
                                    }
                                    if ('vec2f' === e) r.push(new Float32Array(this.buffer, u, 2)[o]);
                                    else if ('vec3f' === e) {
                                        if (u + 12 >= this.buffer.byteLength) return console.log('Insufficient buffer data'), null;
                                        const e = new Float32Array(this.buffer, u, 3);
                                        r.push(e[o]);
                                    } else if ('vec4f' === e) r.push(new Float32Array(this.buffer, u, 4)[o]);
                                    else if ('vec2i' === e) n = 'i', r.push(new Int32Array(this.buffer, u, 2)[o]);
                                    else if ('vec3i' === e) n = 'i', r.push(new Int32Array(this.buffer, u, 3)[o]);
                                    else if ('vec4i' === e) n = 'i', r.push(new Int32Array(this.buffer, u, 4)[o]);
                                    else if ('vec2u' === e) {
                                        n = 'u';
                                        const e = new Uint32Array(this.buffer, u, 2);
                                        r.push(e[o]);
                                    } else 'vec3u' === e ? (n = 'u', r.push(new Uint32Array(this.buffer, u, 3)[o])) : 'vec4u' === e && (n = 'u', r.push(new Uint32Array(this.buffer, u, 4)[o]));
                                }
                                return 2 === r.length ? h = t.getTypeInfo(`vec2${n}`) : 3 === r.length ? h = t.getTypeInfo(`vec3${n}`) : 4 === r.length ? h = t.getTypeInfo(`vec4${n}`) : console.error(`GetDataValue: Invalid vector length ${r.length}`), new Fe(r, h, null);
                            }
                            return console.error(`GetDataValue: Unknown member ${s}`), null;
                        }
                        return console.error(`GetDataValue: Type ${e} is not a struct`), null;
                    }
                }
            }
            r = r.postfix;
        }
        const f = h.getTypeName();
        return 'f32' === f ? new Oe(new Float32Array(this.buffer, u, 1), h, this) : 'i32' === f ? new Oe(new Int32Array(this.buffer, u, 1), h, this) : 'u32' === f ? new Oe(new Uint32Array(this.buffer, u, 1), h, this) : 'vec2f' === f ? new Fe(new Float32Array(this.buffer, u, 2), h, this) : 'vec3f' === f ? new Fe(new Float32Array(this.buffer, u, 3), h, this) : 'vec4f' === f ? new Fe(new Float32Array(this.buffer, u, 4), h, this) : 'vec2i' === f ? new Fe(new Int32Array(this.buffer, u, 2), h, this) : 'vec3i' === f ? new Fe(new Int32Array(this.buffer, u, 3), h, this) : 'vec4i' === f ? new Fe(new Int32Array(this.buffer, u, 4), h, this) : 'vec2u' === f ? new Fe(new Uint32Array(this.buffer, u, 2), h, this) : 'vec3u' === f ? new Fe(new Uint32Array(this.buffer, u, 3), h, this) : 'vec4u' === f ? new Fe(new Uint32Array(this.buffer, u, 4), h, this) : h instanceof a && 'atomic' === h.name ? 'u32' === (null === (o = h.format) || void 0 === o ? void 0 : o.name) ? new Oe(new Uint32Array(this.buffer, u, 1)[0], h.format, this) : 'i32' === (null === (l = h.format) || void 0 === l ? void 0 : l.name) ? new Oe(new Int32Array(this.buffer, u, 1)[0], h.format, this) : (console.error(`GetDataValue: Invalid atomic format ${null === (c = h.format) || void 0 === c ? void 0 : c.name}`), null) : new Ue(this.buffer, h, u, this);
    }
    toString() {
        let e = '';
        if (this.typeInfo instanceof s) {
            if ('f32' === this.typeInfo.format.name) {
                const t = new Float32Array(this.buffer, this.offset);
                e = `[${t[0]}`;
                for(let n = 1; n < t.length; ++n)e += `, ${t[n]}`;
            } else if ('i32' === this.typeInfo.format.name) {
                const t = new Int32Array(this.buffer, this.offset);
                e = `[${t[0]}`;
                for(let n = 1; n < t.length; ++n)e += `, ${t[n]}`;
            } else if ('u32' === this.typeInfo.format.name) {
                const t = new Uint32Array(this.buffer, this.offset);
                e = `[${t[0]}`;
                for(let n = 1; n < t.length; ++n)e += `, ${t[n]}`;
            } else if ('vec2f' === this.typeInfo.format.name) {
                const t = new Float32Array(this.buffer, this.offset);
                e = `[${t[0]}, ${t[1]}]`;
                for(let n = 1; n < t.length / 2; ++n)e += `, [${t[2 * n]}, ${t[2 * n + 1]}]`;
            } else if ('vec3f' === this.typeInfo.format.name) {
                const t = new Float32Array(this.buffer, this.offset);
                e = `[${t[0]}, ${t[1]}, ${t[2]}]`;
                for(let n = 4; n < t.length; n += 4)e += `, [${t[n]}, ${t[n + 1]}, ${t[n + 2]}]`;
            } else if ('vec4f' === this.typeInfo.format.name) {
                const t = new Float32Array(this.buffer, this.offset);
                e = `[${t[0]}, ${t[1]}, ${t[2]}, ${t[3]}]`;
                for(let n = 4; n < t.length; n += 4)e += `, [${t[n]}, ${t[n + 1]}, ${t[n + 2]}, ${t[n + 3]}]`;
            } else e = '[...]';
        } else this.typeInfo instanceof n ? e += '{...}' : e = '[...]';
        return e;
    }
}
class Pe extends De {
    constructor(e, t, n, s){
        super(t, null), this.data = e, this.descriptor = n, this.view = s;
    }
    clone() {
        return new Pe(this.data, this.typeInfo, this.descriptor, this.view);
    }
    get width() {
        var e, t;
        const n = this.descriptor.size;
        return n instanceof Array && n.length > 0 ? null !== (e = n[0]) && void 0 !== e ? e : 0 : n instanceof Object && null !== (t = n.width) && void 0 !== t ? t : 0;
    }
    get height() {
        var e, t;
        const n = this.descriptor.size;
        return n instanceof Array && n.length > 1 ? null !== (e = n[1]) && void 0 !== e ? e : 0 : n instanceof Object && null !== (t = n.height) && void 0 !== t ? t : 0;
    }
    get depthOrArrayLayers() {
        var e, t;
        const n = this.descriptor.size;
        return n instanceof Array && n.length > 2 ? null !== (e = n[2]) && void 0 !== e ? e : 0 : n instanceof Object && null !== (t = n.depthOrArrayLayers) && void 0 !== t ? t : 0;
    }
    get format() {
        var e;
        return this.descriptor && null !== (e = this.descriptor.format) && void 0 !== e ? e : 'rgba8unorm';
    }
    get sampleCount() {
        var e;
        return this.descriptor && null !== (e = this.descriptor.sampleCount) && void 0 !== e ? e : 1;
    }
    get mipLevelCount() {
        var e;
        return this.descriptor && null !== (e = this.descriptor.mipLevelCount) && void 0 !== e ? e : 1;
    }
    get dimension() {
        var e;
        return this.descriptor && null !== (e = this.descriptor.dimension) && void 0 !== e ? e : '2d';
    }
    getMipLevelSize(e) {
        if (e >= this.mipLevelCount) return [
            0,
            0,
            0
        ];
        const t = [
            this.width,
            this.height,
            this.depthOrArrayLayers
        ];
        for(let n = 0; n < t.length; ++n)t[n] = Math.max(1, t[n] >> e);
        return t;
    }
    get texelByteSize() {
        const e = this.format, t = T[e];
        return t ? t.isDepthStencil ? 4 : t.bytesPerBlock : 0;
    }
    get bytesPerRow() {
        return this.width * this.texelByteSize;
    }
    get isDepthStencil() {
        const e = this.format, t = T[e];
        return !!t && t.isDepthStencil;
    }
    getGpuSize() {
        const e = this.format, t = T[e], n = this.width;
        if (!e || n <= 0 || !t) return -1;
        const s = this.height, r = this.depthOrArrayLayers, a = this.dimension;
        return n / t.blockWidth * ('1d' === a ? 1 : s / t.blockHeight) * t.bytesPerBlock * r;
    }
    getPixel(e, t, n = 0, s = 0) {
        const r = this.texelByteSize, a = this.bytesPerRow, i = this.height, o = this.data[s];
        return w(new Uint8Array(o), e, t, n, s, i, a, r, this.format);
    }
    setPixel(e, t, n, s, r) {
        const a = this.texelByteSize, i = this.bytesPerRow, o = this.height, l = this.data[s];
        !function(e, t, n, s, r, a, i, o, l, c) {
            const u = s * (i >>= r) * (a >>= r) + n * i + t * o;
            switch(l){
                case 'r8unorm':
                    return void I(e, u, '8unorm', 1, c);
                case 'r8snorm':
                    return void I(e, u, '8snorm', 1, c);
                case 'r8uint':
                    return void I(e, u, '8uint', 1, c);
                case 'r8sint':
                    return void I(e, u, '8sint', 1, c);
                case 'rg8unorm':
                    return void I(e, u, '8unorm', 2, c);
                case 'rg8snorm':
                    return void I(e, u, '8snorm', 2, c);
                case 'rg8uint':
                    return void I(e, u, '8uint', 2, c);
                case 'rg8sint':
                    return void I(e, u, '8sint', 2, c);
                case 'rgba8unorm-srgb':
                case 'rgba8unorm':
                case 'bgra8unorm-srgb':
                case 'bgra8unorm':
                    return void I(e, u, '8unorm', 4, c);
                case 'rgba8snorm':
                    return void I(e, u, '8snorm', 4, c);
                case 'rgba8uint':
                    return void I(e, u, '8uint', 4, c);
                case 'rgba8sint':
                    return void I(e, u, '8sint', 4, c);
                case 'r16uint':
                    return void I(e, u, '16uint', 1, c);
                case 'r16sint':
                    return void I(e, u, '16sint', 1, c);
                case 'r16float':
                    return void I(e, u, '16float', 1, c);
                case 'rg16uint':
                    return void I(e, u, '16uint', 2, c);
                case 'rg16sint':
                    return void I(e, u, '16sint', 2, c);
                case 'rg16float':
                    return void I(e, u, '16float', 2, c);
                case 'rgba16uint':
                    return void I(e, u, '16uint', 4, c);
                case 'rgba16sint':
                    return void I(e, u, '16sint', 4, c);
                case 'rgba16float':
                    return void I(e, u, '16float', 4, c);
                case 'r32uint':
                    return void I(e, u, '32uint', 1, c);
                case 'r32sint':
                    return void I(e, u, '32sint', 1, c);
                case 'depth16unorm':
                case 'depth24plus':
                case 'depth24plus-stencil8':
                case 'depth32float':
                case 'depth32float-stencil8':
                case 'r32float':
                    return void I(e, u, '32float', 1, c);
                case 'rg32uint':
                    return void I(e, u, '32uint', 2, c);
                case 'rg32sint':
                    return void I(e, u, '32sint', 2, c);
                case 'rg32float':
                    return void I(e, u, '32float', 2, c);
                case 'rgba32uint':
                    return void I(e, u, '32uint', 4, c);
                case 'rgba32sint':
                    return void I(e, u, '32sint', 4, c);
                case 'rgba32float':
                    return void I(e, u, '32float', 4, c);
                case 'rg11b10ufloat':
                    console.error('TODO: rg11b10ufloat not supported for writing');
            }
        }(new Uint8Array(l), e, t, n, s, o, i, a, this.format, r);
    }
}
((e)=>{
    e[e.token = 0] = 'token', e[e.keyword = 1] = 'keyword', e[e.reserved = 2] = 'reserved';
})(H || (H = {}));
class We {
    constructor(e, t, n){
        this.name = e, this.type = t, this.rule = n;
    }
    toString() {
        return this.name;
    }
}
class qe {
}
q = qe, qe.none = new We('', H.reserved, ''), qe.eof = new We('EOF', H.token, ''), qe.reserved = {
    asm: new We('asm', H.reserved, 'asm'),
    bf16: new We('bf16', H.reserved, 'bf16'),
    do: new We('do', H.reserved, 'do'),
    enum: new We('enum', H.reserved, 'enum'),
    f16: new We('f16', H.reserved, 'f16'),
    f64: new We('f64', H.reserved, 'f64'),
    handle: new We('handle', H.reserved, 'handle'),
    i8: new We('i8', H.reserved, 'i8'),
    i16: new We('i16', H.reserved, 'i16'),
    i64: new We('i64', H.reserved, 'i64'),
    mat: new We('mat', H.reserved, 'mat'),
    premerge: new We('premerge', H.reserved, 'premerge'),
    regardless: new We('regardless', H.reserved, 'regardless'),
    typedef: new We('typedef', H.reserved, 'typedef'),
    u8: new We('u8', H.reserved, 'u8'),
    u16: new We('u16', H.reserved, 'u16'),
    u64: new We('u64', H.reserved, 'u64'),
    unless: new We('unless', H.reserved, 'unless'),
    using: new We('using', H.reserved, 'using'),
    vec: new We('vec', H.reserved, 'vec'),
    void: new We('void', H.reserved, 'void')
}, qe.keywords = {
    array: new We('array', H.keyword, 'array'),
    atomic: new We('atomic', H.keyword, 'atomic'),
    bool: new We('bool', H.keyword, 'bool'),
    f32: new We('f32', H.keyword, 'f32'),
    i32: new We('i32', H.keyword, 'i32'),
    mat2x2: new We('mat2x2', H.keyword, 'mat2x2'),
    mat2x3: new We('mat2x3', H.keyword, 'mat2x3'),
    mat2x4: new We('mat2x4', H.keyword, 'mat2x4'),
    mat3x2: new We('mat3x2', H.keyword, 'mat3x2'),
    mat3x3: new We('mat3x3', H.keyword, 'mat3x3'),
    mat3x4: new We('mat3x4', H.keyword, 'mat3x4'),
    mat4x2: new We('mat4x2', H.keyword, 'mat4x2'),
    mat4x3: new We('mat4x3', H.keyword, 'mat4x3'),
    mat4x4: new We('mat4x4', H.keyword, 'mat4x4'),
    ptr: new We('ptr', H.keyword, 'ptr'),
    sampler: new We('sampler', H.keyword, 'sampler'),
    sampler_comparison: new We('sampler_comparison', H.keyword, 'sampler_comparison'),
    struct: new We('struct', H.keyword, 'struct'),
    texture_1d: new We('texture_1d', H.keyword, 'texture_1d'),
    texture_2d: new We('texture_2d', H.keyword, 'texture_2d'),
    texture_2d_array: new We('texture_2d_array', H.keyword, 'texture_2d_array'),
    texture_3d: new We('texture_3d', H.keyword, 'texture_3d'),
    texture_cube: new We('texture_cube', H.keyword, 'texture_cube'),
    texture_cube_array: new We('texture_cube_array', H.keyword, 'texture_cube_array'),
    texture_multisampled_2d: new We('texture_multisampled_2d', H.keyword, 'texture_multisampled_2d'),
    texture_storage_1d: new We('texture_storage_1d', H.keyword, 'texture_storage_1d'),
    texture_storage_2d: new We('texture_storage_2d', H.keyword, 'texture_storage_2d'),
    texture_storage_2d_array: new We('texture_storage_2d_array', H.keyword, 'texture_storage_2d_array'),
    texture_storage_3d: new We('texture_storage_3d', H.keyword, 'texture_storage_3d'),
    texture_depth_2d: new We('texture_depth_2d', H.keyword, 'texture_depth_2d'),
    texture_depth_2d_array: new We('texture_depth_2d_array', H.keyword, 'texture_depth_2d_array'),
    texture_depth_cube: new We('texture_depth_cube', H.keyword, 'texture_depth_cube'),
    texture_depth_cube_array: new We('texture_depth_cube_array', H.keyword, 'texture_depth_cube_array'),
    texture_depth_multisampled_2d: new We('texture_depth_multisampled_2d', H.keyword, 'texture_depth_multisampled_2d'),
    texture_external: new We('texture_external', H.keyword, 'texture_external'),
    u32: new We('u32', H.keyword, 'u32'),
    vec2: new We('vec2', H.keyword, 'vec2'),
    vec3: new We('vec3', H.keyword, 'vec3'),
    vec4: new We('vec4', H.keyword, 'vec4'),
    bitcast: new We('bitcast', H.keyword, 'bitcast'),
    block: new We('block', H.keyword, 'block'),
    break: new We('break', H.keyword, 'break'),
    case: new We('case', H.keyword, 'case'),
    continue: new We('continue', H.keyword, 'continue'),
    continuing: new We('continuing', H.keyword, 'continuing'),
    default: new We('default', H.keyword, 'default'),
    diagnostic: new We('diagnostic', H.keyword, 'diagnostic'),
    discard: new We('discard', H.keyword, 'discard'),
    else: new We('else', H.keyword, 'else'),
    enable: new We('enable', H.keyword, 'enable'),
    fallthrough: new We('fallthrough', H.keyword, 'fallthrough'),
    false: new We('false', H.keyword, 'false'),
    fn: new We('fn', H.keyword, 'fn'),
    for: new We('for', H.keyword, 'for'),
    function: new We('function', H.keyword, 'function'),
    if: new We('if', H.keyword, 'if'),
    let: new We('let', H.keyword, 'let'),
    const: new We('const', H.keyword, 'const'),
    loop: new We('loop', H.keyword, 'loop'),
    while: new We('while', H.keyword, 'while'),
    private: new We('private', H.keyword, 'private'),
    read: new We('read', H.keyword, 'read'),
    read_write: new We('read_write', H.keyword, 'read_write'),
    return: new We('return', H.keyword, 'return'),
    requires: new We('requires', H.keyword, 'requires'),
    storage: new We('storage', H.keyword, 'storage'),
    switch: new We('switch', H.keyword, 'switch'),
    true: new We('true', H.keyword, 'true'),
    alias: new We('alias', H.keyword, 'alias'),
    type: new We('type', H.keyword, 'type'),
    uniform: new We('uniform', H.keyword, 'uniform'),
    var: new We('var', H.keyword, 'var'),
    override: new We('override', H.keyword, 'override'),
    workgroup: new We('workgroup', H.keyword, 'workgroup'),
    write: new We('write', H.keyword, 'write'),
    r8unorm: new We('r8unorm', H.keyword, 'r8unorm'),
    r8snorm: new We('r8snorm', H.keyword, 'r8snorm'),
    r8uint: new We('r8uint', H.keyword, 'r8uint'),
    r8sint: new We('r8sint', H.keyword, 'r8sint'),
    r16uint: new We('r16uint', H.keyword, 'r16uint'),
    r16sint: new We('r16sint', H.keyword, 'r16sint'),
    r16float: new We('r16float', H.keyword, 'r16float'),
    rg8unorm: new We('rg8unorm', H.keyword, 'rg8unorm'),
    rg8snorm: new We('rg8snorm', H.keyword, 'rg8snorm'),
    rg8uint: new We('rg8uint', H.keyword, 'rg8uint'),
    rg8sint: new We('rg8sint', H.keyword, 'rg8sint'),
    r32uint: new We('r32uint', H.keyword, 'r32uint'),
    r32sint: new We('r32sint', H.keyword, 'r32sint'),
    r32float: new We('r32float', H.keyword, 'r32float'),
    rg16uint: new We('rg16uint', H.keyword, 'rg16uint'),
    rg16sint: new We('rg16sint', H.keyword, 'rg16sint'),
    rg16float: new We('rg16float', H.keyword, 'rg16float'),
    rgba8unorm: new We('rgba8unorm', H.keyword, 'rgba8unorm'),
    rgba8unorm_srgb: new We('rgba8unorm_srgb', H.keyword, 'rgba8unorm_srgb'),
    rgba8snorm: new We('rgba8snorm', H.keyword, 'rgba8snorm'),
    rgba8uint: new We('rgba8uint', H.keyword, 'rgba8uint'),
    rgba8sint: new We('rgba8sint', H.keyword, 'rgba8sint'),
    bgra8unorm: new We('bgra8unorm', H.keyword, 'bgra8unorm'),
    bgra8unorm_srgb: new We('bgra8unorm_srgb', H.keyword, 'bgra8unorm_srgb'),
    rgb10a2unorm: new We('rgb10a2unorm', H.keyword, 'rgb10a2unorm'),
    rg11b10float: new We('rg11b10float', H.keyword, 'rg11b10float'),
    rg32uint: new We('rg32uint', H.keyword, 'rg32uint'),
    rg32sint: new We('rg32sint', H.keyword, 'rg32sint'),
    rg32float: new We('rg32float', H.keyword, 'rg32float'),
    rgba16uint: new We('rgba16uint', H.keyword, 'rgba16uint'),
    rgba16sint: new We('rgba16sint', H.keyword, 'rgba16sint'),
    rgba16float: new We('rgba16float', H.keyword, 'rgba16float'),
    rgba32uint: new We('rgba32uint', H.keyword, 'rgba32uint'),
    rgba32sint: new We('rgba32sint', H.keyword, 'rgba32sint'),
    rgba32float: new We('rgba32float', H.keyword, 'rgba32float'),
    static_assert: new We('static_assert', H.keyword, 'static_assert')
}, qe.tokens = {
    decimal_float_literal: new We('decimal_float_literal', H.token, /((-?[0-9]*\.[0-9]+|-?[0-9]+\.[0-9]*)((e|E)(\+|-)?[0-9]+)?[fh]?)|(-?[0-9]+(e|E)(\+|-)?[0-9]+[fh]?)|(-?[0-9]+[fh])/),
    hex_float_literal: new We('hex_float_literal', H.token, /-?0x((([0-9a-fA-F]*\.[0-9a-fA-F]+|[0-9a-fA-F]+\.[0-9a-fA-F]*)((p|P)(\+|-)?[0-9]+[fh]?)?)|([0-9a-fA-F]+(p|P)(\+|-)?[0-9]+[fh]?))/),
    int_literal: new We('int_literal', H.token, /-?0x[0-9a-fA-F]+|0i?|-?[1-9][0-9]*i?/),
    uint_literal: new We('uint_literal', H.token, /0x[0-9a-fA-F]+u|0u|[1-9][0-9]*u/),
    name: new We('name', H.token, /([_\p{XID_Start}][\p{XID_Continue}]+)|([\p{XID_Start}])/u),
    ident: new We('ident', H.token, /[_a-zA-Z][0-9a-zA-Z_]*/),
    and: new We('and', H.token, '&'),
    and_and: new We('and_and', H.token, '&&'),
    arrow: new We('arrow ', H.token, '->'),
    attr: new We('attr', H.token, '@'),
    forward_slash: new We('forward_slash', H.token, '/'),
    bang: new We('bang', H.token, '!'),
    bracket_left: new We('bracket_left', H.token, '['),
    bracket_right: new We('bracket_right', H.token, ']'),
    brace_left: new We('brace_left', H.token, '{'),
    brace_right: new We('brace_right', H.token, '}'),
    colon: new We('colon', H.token, ':'),
    comma: new We('comma', H.token, ','),
    equal: new We('equal', H.token, '='),
    equal_equal: new We('equal_equal', H.token, '=='),
    not_equal: new We('not_equal', H.token, '!='),
    greater_than: new We('greater_than', H.token, '>'),
    greater_than_equal: new We('greater_than_equal', H.token, '>='),
    shift_right: new We('shift_right', H.token, '>>'),
    less_than: new We('less_than', H.token, '<'),
    less_than_equal: new We('less_than_equal', H.token, '<='),
    shift_left: new We('shift_left', H.token, '<<'),
    modulo: new We('modulo', H.token, '%'),
    minus: new We('minus', H.token, '-'),
    minus_minus: new We('minus_minus', H.token, '--'),
    period: new We('period', H.token, '.'),
    plus: new We('plus', H.token, '+'),
    plus_plus: new We('plus_plus', H.token, '++'),
    or: new We('or', H.token, '|'),
    or_or: new We('or_or', H.token, '||'),
    paren_left: new We('paren_left', H.token, '('),
    paren_right: new We('paren_right', H.token, ')'),
    semicolon: new We('semicolon', H.token, ';'),
    star: new We('star', H.token, '*'),
    tilde: new We('tilde', H.token, '~'),
    underscore: new We('underscore', H.token, '_'),
    xor: new We('xor', H.token, '^'),
    plus_equal: new We('plus_equal', H.token, '+='),
    minus_equal: new We('minus_equal', H.token, '-='),
    times_equal: new We('times_equal', H.token, '*='),
    division_equal: new We('division_equal', H.token, '/='),
    modulo_equal: new We('modulo_equal', H.token, '%='),
    and_equal: new We('and_equal', H.token, '&='),
    or_equal: new We('or_equal', H.token, '|='),
    xor_equal: new We('xor_equal', H.token, '^='),
    shift_right_equal: new We('shift_right_equal', H.token, '>>='),
    shift_left_equal: new We('shift_left_equal', H.token, '<<=')
}, qe.simpleTokens = {
    '@': q.tokens.attr,
    '{': q.tokens.brace_left,
    '}': q.tokens.brace_right,
    ':': q.tokens.colon,
    ',': q.tokens.comma,
    '(': q.tokens.paren_left,
    ')': q.tokens.paren_right,
    ';': q.tokens.semicolon
}, qe.literalTokens = {
    '&': q.tokens.and,
    '&&': q.tokens.and_and,
    '->': q.tokens.arrow,
    '/': q.tokens.forward_slash,
    '!': q.tokens.bang,
    '[': q.tokens.bracket_left,
    ']': q.tokens.bracket_right,
    '=': q.tokens.equal,
    '==': q.tokens.equal_equal,
    '!=': q.tokens.not_equal,
    '>': q.tokens.greater_than,
    '>=': q.tokens.greater_than_equal,
    '>>': q.tokens.shift_right,
    '<': q.tokens.less_than,
    '<=': q.tokens.less_than_equal,
    '<<': q.tokens.shift_left,
    '%': q.tokens.modulo,
    '-': q.tokens.minus,
    '--': q.tokens.minus_minus,
    '.': q.tokens.period,
    '+': q.tokens.plus,
    '++': q.tokens.plus_plus,
    '|': q.tokens.or,
    '||': q.tokens.or_or,
    '*': q.tokens.star,
    '~': q.tokens.tilde,
    _: q.tokens.underscore,
    '^': q.tokens.xor,
    '+=': q.tokens.plus_equal,
    '-=': q.tokens.minus_equal,
    '*=': q.tokens.times_equal,
    '/=': q.tokens.division_equal,
    '%=': q.tokens.modulo_equal,
    '&=': q.tokens.and_equal,
    '|=': q.tokens.or_equal,
    '^=': q.tokens.xor_equal,
    '>>=': q.tokens.shift_right_equal,
    '<<=': q.tokens.shift_left_equal
}, qe.regexTokens = {
    decimal_float_literal: q.tokens.decimal_float_literal,
    hex_float_literal: q.tokens.hex_float_literal,
    int_literal: q.tokens.int_literal,
    uint_literal: q.tokens.uint_literal,
    ident: q.tokens.ident
}, qe.storage_class = [
    q.keywords.function,
    q.keywords.private,
    q.keywords.workgroup,
    q.keywords.uniform,
    q.keywords.storage
], qe.access_mode = [
    q.keywords.read,
    q.keywords.write,
    q.keywords.read_write
], qe.sampler_type = [
    q.keywords.sampler,
    q.keywords.sampler_comparison
], qe.sampled_texture_type = [
    q.keywords.texture_1d,
    q.keywords.texture_2d,
    q.keywords.texture_2d_array,
    q.keywords.texture_3d,
    q.keywords.texture_cube,
    q.keywords.texture_cube_array
], qe.multisampled_texture_type = [
    q.keywords.texture_multisampled_2d
], qe.storage_texture_type = [
    q.keywords.texture_storage_1d,
    q.keywords.texture_storage_2d,
    q.keywords.texture_storage_2d_array,
    q.keywords.texture_storage_3d
], qe.depth_texture_type = [
    q.keywords.texture_depth_2d,
    q.keywords.texture_depth_2d_array,
    q.keywords.texture_depth_cube,
    q.keywords.texture_depth_cube_array,
    q.keywords.texture_depth_multisampled_2d
], qe.texture_external_type = [
    q.keywords.texture_external
], qe.any_texture_type = [
    ...q.sampled_texture_type,
    ...q.multisampled_texture_type,
    ...q.storage_texture_type,
    ...q.depth_texture_type,
    ...q.texture_external_type
], qe.texel_format = [
    q.keywords.r8unorm,
    q.keywords.r8snorm,
    q.keywords.r8uint,
    q.keywords.r8sint,
    q.keywords.r16uint,
    q.keywords.r16sint,
    q.keywords.r16float,
    q.keywords.rg8unorm,
    q.keywords.rg8snorm,
    q.keywords.rg8uint,
    q.keywords.rg8sint,
    q.keywords.r32uint,
    q.keywords.r32sint,
    q.keywords.r32float,
    q.keywords.rg16uint,
    q.keywords.rg16sint,
    q.keywords.rg16float,
    q.keywords.rgba8unorm,
    q.keywords.rgba8unorm_srgb,
    q.keywords.rgba8snorm,
    q.keywords.rgba8uint,
    q.keywords.rgba8sint,
    q.keywords.bgra8unorm,
    q.keywords.bgra8unorm_srgb,
    q.keywords.rgb10a2unorm,
    q.keywords.rg11b10float,
    q.keywords.rg32uint,
    q.keywords.rg32sint,
    q.keywords.rg32float,
    q.keywords.rgba16uint,
    q.keywords.rgba16sint,
    q.keywords.rgba16float,
    q.keywords.rgba32uint,
    q.keywords.rgba32sint,
    q.keywords.rgba32float
], qe.const_literal = [
    q.tokens.int_literal,
    q.tokens.uint_literal,
    q.tokens.decimal_float_literal,
    q.tokens.hex_float_literal,
    q.keywords.true,
    q.keywords.false
], qe.literal_or_ident = [
    q.tokens.ident,
    q.tokens.int_literal,
    q.tokens.uint_literal,
    q.tokens.decimal_float_literal,
    q.tokens.hex_float_literal,
    q.tokens.name
], qe.element_count_expression = [
    q.tokens.int_literal,
    q.tokens.uint_literal,
    q.tokens.ident
], qe.template_types = [
    q.keywords.vec2,
    q.keywords.vec3,
    q.keywords.vec4,
    q.keywords.mat2x2,
    q.keywords.mat2x3,
    q.keywords.mat2x4,
    q.keywords.mat3x2,
    q.keywords.mat3x3,
    q.keywords.mat3x4,
    q.keywords.mat4x2,
    q.keywords.mat4x3,
    q.keywords.mat4x4,
    q.keywords.atomic,
    q.keywords.bitcast,
    ...q.any_texture_type
], qe.attribute_name = [
    q.tokens.ident,
    q.keywords.block,
    q.keywords.diagnostic
], qe.assignment_operators = [
    q.tokens.equal,
    q.tokens.plus_equal,
    q.tokens.minus_equal,
    q.tokens.times_equal,
    q.tokens.division_equal,
    q.tokens.modulo_equal,
    q.tokens.and_equal,
    q.tokens.or_equal,
    q.tokens.xor_equal,
    q.tokens.shift_right_equal,
    q.tokens.shift_left_equal
], qe.increment_operators = [
    q.tokens.plus_plus,
    q.tokens.minus_minus
];
class He {
    constructor(e, t, n, s, r){
        this.type = e, this.lexeme = t, this.line = n, this.start = s, this.end = r;
    }
    toString() {
        return this.lexeme;
    }
    isTemplateType() {
        return -1 != qe.template_types.indexOf(this.type);
    }
    isArrayType() {
        return this.type == qe.keywords.array;
    }
    isArrayOrTemplateType() {
        return this.isArrayType() || this.isTemplateType();
    }
}
class ze {
    constructor(e){
        this._tokens = [], this._start = 0, this._current = 0, this._line = 1, this._source = null != e ? e : '';
    }
    scanTokens() {
        for(; !this._isAtEnd();)if (this._start = this._current, !this.scanToken()) throw `Invalid syntax at line ${this._line}`;
        return this._tokens.push(new He(qe.eof, '', this._line, this._current, this._current)), this._tokens;
    }
    scanToken() {
        let e = this._advance();
        if ('\n' == e) return this._line++, !0;
        if (this._isWhitespace(e)) return !0;
        if ('/' == e) {
            if ('/' == this._peekAhead()) {
                for(; '\n' != e;){
                    if (this._isAtEnd()) return !0;
                    e = this._advance();
                }
                return this._line++, !0;
            }
            if ('*' == this._peekAhead()) {
                this._advance();
                let t = 1;
                for(; t > 0;){
                    if (this._isAtEnd()) return !0;
                    if (e = this._advance(), '\n' == e) this._line++;
                    else if ('*' == e) {
                        if ('/' == this._peekAhead() && (this._advance(), t--, 0 == t)) return !0;
                    } else '/' == e && '*' == this._peekAhead() && (this._advance(), t++);
                }
                return !0;
            }
        }
        const t = qe.simpleTokens[e];
        if (t) return this._addToken(t), !0;
        let n = qe.none;
        const s = this._isAlpha(e), r = '_' === e;
        if (this._isAlphaNumeric(e)) {
            let t = this._peekAhead();
            for(; this._isAlphaNumeric(t);)e += this._advance(), t = this._peekAhead();
        }
        if (s) {
            const t = qe.keywords[e];
            if (t) return this._addToken(t), !0;
        }
        if (s || r) return this._addToken(qe.tokens.ident), !0;
        for(;;){
            let t = this._findType(e);
            const s = this._peekAhead();
            if ('-' == e && this._tokens.length > 0) {
                if ('=' == s) return this._current++, e += s, this._addToken(qe.tokens.minus_equal), !0;
                if ('-' == s) return this._current++, e += s, this._addToken(qe.tokens.minus_minus), !0;
                const n = this._tokens.length - 1;
                if ((-1 != qe.literal_or_ident.indexOf(this._tokens[n].type) || this._tokens[n].type == qe.tokens.paren_right) && '>' != s) return this._addToken(t), !0;
            }
            if ('>' == e && ('>' == s || '=' == s)) {
                let e = !1, n = this._tokens.length - 1;
                for(let t = 0; t < 5 && n >= 0 && -1 === qe.assignment_operators.indexOf(this._tokens[n].type); ++t, --n)if (this._tokens[n].type === qe.tokens.less_than) {
                    n > 0 && this._tokens[n - 1].isArrayOrTemplateType() && (e = !0);
                    break;
                }
                if (e) return this._addToken(t), !0;
            }
            if (t === qe.none) {
                let s = e, r = 0;
                const a = 2;
                for(let e = 0; e < a; ++e)if (s += this._peekAhead(e), t = this._findType(s), t !== qe.none) {
                    r = e;
                    break;
                }
                if (t === qe.none) return n !== qe.none && (this._current--, this._addToken(n), !0);
                e = s, this._current += r + 1;
            }
            if (n = t, this._isAtEnd()) break;
            e += this._advance();
        }
        return n !== qe.none && (this._addToken(n), !0);
    }
    _findType(e) {
        for(const t in qe.regexTokens){
            const n = qe.regexTokens[t];
            if (this._match(e, n.rule)) return n;
        }
        const t = qe.literalTokens[e];
        return t || qe.none;
    }
    _match(e, t) {
        const n = t.exec(e);
        return n && 0 == n.index && n[0] == e;
    }
    _isAtEnd() {
        return this._current >= this._source.length;
    }
    _isAlpha(e) {
        return !this._isNumeric(e) && !this._isWhitespace(e) && '_' !== e && '.' !== e && '(' !== e && ')' !== e && '[' !== e && ']' !== e && '{' !== e && '}' !== e && ',' !== e && ';' !== e && ':' !== e && '=' !== e && '!' !== e && '<' !== e && '>' !== e && '+' !== e && '-' !== e && '*' !== e && '/' !== e && '%' !== e && '&' !== e && '|' !== e && '^' !== e && '~' !== e && '@' !== e && '#' !== e && '?' !== e && '\'' !== e && '`' !== e && '"' !== e && '\\' !== e && '\n' !== e && '\r' !== e && '\t' !== e && '\0' !== e;
    }
    _isNumeric(e) {
        return e >= '0' && e <= '9';
    }
    _isAlphaNumeric(e) {
        return this._isAlpha(e) || this._isNumeric(e) || '_' === e;
    }
    _isWhitespace(e) {
        return ' ' == e || '\t' == e || '\r' == e;
    }
    _advance(e = 0) {
        let t = this._source[this._current];
        return e = e || 0, e++, this._current += e, t;
    }
    _peekAhead(e = 0) {
        return e = e || 0, this._current + e >= this._source.length ? '\0' : this._source[this._current + e];
    }
    _addToken(e) {
        const t = this._source.substring(this._start, this._current);
        this._tokens.push(new He(e, t, this._line, this._start, this._current));
    }
}
function Re(e) {
    return Array.isArray(e) || (null == e ? void 0 : e.buffer) instanceof ArrayBuffer;
}
const Ge = new Float32Array(1), Xe = new Uint32Array(Ge.buffer), je = new Uint32Array(Ge.buffer), Ze = new Int32Array(1), Qe = new Float32Array(Ze.buffer), Ye = new Uint32Array(Ze.buffer), Ke = new Uint32Array(1), Je = new Float32Array(Ke.buffer), et = new Int32Array(Ke.buffer);
function tt(e, t, n) {
    if (t === n) return e;
    if ('f32' === t) {
        if ('i32' === n || 'x32' === n) return Ge[0] = e, Xe[0];
        if ('u32' === n) return Ge[0] = e, je[0];
    } else if ('i32' === t || 'x32' === t) {
        if ('f32' === n) return Ze[0] = e, Qe[0];
        if ('u32' === n) return Ze[0] = e, Ye[0];
    } else if ('u32' === t) {
        if ('f32' === n) return Ke[0] = e, Je[0];
        if ('i32' === n || 'x32' === n) return Ke[0] = e, et[0];
    }
    return console.error(`Unsupported cast from ${t} to ${n}`), e;
}
class nt {
    constructor(e){
        this.resources = null, this.inUse = !1, this.info = null, this.node = e;
    }
}
class st {
    constructor(e, t){
        this.align = e, this.size = t;
    }
}
class rt {
    constructor(){
        this.uniforms = [], this.storage = [], this.textures = [], this.samplers = [], this.aliases = [], this.overrides = [], this.structs = [], this.entry = new d, this.functions = [], this._types = new Map, this._functions = new Map;
    }
    _isStorageTexture(e) {
        return 'texture_storage_1d' == e.name || 'texture_storage_2d' == e.name || 'texture_storage_2d_array' == e.name || 'texture_storage_3d' == e.name;
    }
    updateAST(e) {
        for (const t of e)t instanceof C && this._functions.set(t.name, new nt(t));
        for (const t of e)if (t instanceof ie) {
            const e = this.getTypeInfo(t, null);
            e instanceof n && this.structs.push(e);
        }
        for (const t of e)if (t instanceof ee) this.aliases.push(this._getAliasInfo(t));
        else if (t instanceof F) {
            const e = t, n = this._getAttributeNum(e.attributes, 'id', 0), s = null != e.type ? this.getTypeInfo(e.type, e.attributes) : null;
            this.overrides.push(new h(e.name, s, e.attributes, n));
        } else if (this._isUniformVar(t)) {
            const e = t, n = this._getAttributeNum(e.attributes, 'group', 0), s = this._getAttributeNum(e.attributes, 'binding', 0), r = this.getTypeInfo(e.type, e.attributes), a = new o(e.name, r, n, s, e.attributes, i.Uniform, e.access);
            a.access || (a.access = 'read'), this.uniforms.push(a);
        } else if (this._isStorageVar(t)) {
            const e = t, n = this._getAttributeNum(e.attributes, 'group', 0), s = this._getAttributeNum(e.attributes, 'binding', 0), r = this.getTypeInfo(e.type, e.attributes), a = this._isStorageTexture(r), l = new o(e.name, r, n, s, e.attributes, a ? i.StorageTexture : i.Storage, e.access);
            l.access || (l.access = 'read'), this.storage.push(l);
        } else if (this._isTextureVar(t)) {
            const e = t, n = this._getAttributeNum(e.attributes, 'group', 0), s = this._getAttributeNum(e.attributes, 'binding', 0), r = this.getTypeInfo(e.type, e.attributes), a = this._isStorageTexture(r), l = new o(e.name, r, n, s, e.attributes, a ? i.StorageTexture : i.Texture, e.access);
            l.access || (l.access = 'read'), a ? this.storage.push(l) : this.textures.push(l);
        } else if (this._isSamplerVar(t)) {
            const e = t, n = this._getAttributeNum(e.attributes, 'group', 0), s = this._getAttributeNum(e.attributes, 'binding', 0), r = this.getTypeInfo(e.type, e.attributes), a = new o(e.name, r, n, s, e.attributes, i.Sampler, e.access);
            this.samplers.push(a);
        }
        for (const t of e)if (t instanceof C) {
            const e = this._getAttribute(t, 'vertex'), n = this._getAttribute(t, 'fragment'), s = this._getAttribute(t, 'compute'), r = e || n || s, a = new p(t.name, null == r ? void 0 : r.name, t.attributes);
            a.attributes = t.attributes, a.startLine = t.startLine, a.endLine = t.endLine, this.functions.push(a), this._functions.get(t.name).info = a, r && (this._functions.get(t.name).inUse = !0, a.inUse = !0, a.resources = this._findResources(t, !!r), a.inputs = this._getInputs(t.args), a.outputs = this._getOutputs(t.returnType), this.entry[r.name].push(a)), a.arguments = t.args.map((e)=>new f(e.name, this.getTypeInfo(e.type, e.attributes), e.attributes)), a.returnType = t.returnType ? this.getTypeInfo(t.returnType, t.attributes) : null;
        }
        for (const e of this._functions.values())e.info && (e.info.inUse = e.inUse, this._addCalls(e.node, e.info.calls));
        for (const e of this._functions.values())e.node.search((t)=>{
            var n, s, r;
            if (t instanceof Ce) {
                if (t.value) {
                    if (Re(t.value)) for (const s of t.value)for (const t of this.overrides)s === t.name && (null === (n = e.info) || void 0 === n || n.overrides.push(t));
                    else for (const n of this.overrides)t.value === n.name && (null === (s = e.info) || void 0 === s || s.overrides.push(n));
                }
            } else if (t instanceof me) for (const n of this.overrides)t.name === n.name && (null === (r = e.info) || void 0 === r || r.overrides.push(n));
        });
        for (const e of this.uniforms)this._markStructsInUse(e.type);
        for (const e of this.storage)this._markStructsInUse(e.type);
    }
    getStructInfo(e) {
        for (const t of this.structs)if (t.name == e) return t;
        return null;
    }
    getOverrideInfo(e) {
        for (const t of this.overrides)if (t.name == e) return t;
        return null;
    }
    _markStructsInUse(e) {
        if (e) {
            if (e.isStruct) {
                if (e.inUse = !0, e.members) for (const t of e.members)this._markStructsInUse(t.type);
            } else if (e.isArray) this._markStructsInUse(e.format);
            else if (e.isTemplate) e.format && this._markStructsInUse(e.format);
            else {
                const t = this._getAlias(e.name);
                t && this._markStructsInUse(t);
            }
        }
    }
    _addCalls(e, t) {
        var n;
        for (const s of e.calls){
            const e = null === (n = this._functions.get(s.name)) || void 0 === n ? void 0 : n.info;
            e && t.add(e);
        }
    }
    findResource(e, t, n) {
        if (n) {
            for (const s of this.entry.compute)if (s.name === n) {
                for (const n of s.resources)if (n.group == e && n.binding == t) return n;
            }
            for (const s of this.entry.vertex)if (s.name === n) {
                for (const n of s.resources)if (n.group == e && n.binding == t) return n;
            }
            for (const s of this.entry.fragment)if (s.name === n) {
                for (const n of s.resources)if (n.group == e && n.binding == t) return n;
            }
        }
        for (const n of this.uniforms)if (n.group == e && n.binding == t) return n;
        for (const n of this.storage)if (n.group == e && n.binding == t) return n;
        for (const n of this.textures)if (n.group == e && n.binding == t) return n;
        for (const n of this.samplers)if (n.group == e && n.binding == t) return n;
        return null;
    }
    _findResource(e) {
        for (const t of this.uniforms)if (t.name == e) return t;
        for (const t of this.storage)if (t.name == e) return t;
        for (const t of this.textures)if (t.name == e) return t;
        for (const t of this.samplers)if (t.name == e) return t;
        return null;
    }
    _markStructsFromAST(e) {
        const t = this.getTypeInfo(e, null);
        this._markStructsInUse(t);
    }
    _findResources(e, t) {
        const n = [], s = this, r = [];
        return e.search((a)=>{
            if (a instanceof A) r.push({});
            else if (a instanceof E) r.pop();
            else if (a instanceof B) {
                const e = a;
                t && null !== e.type && this._markStructsFromAST(e.type), r.length > 0 && (r[r.length - 1][e.name] = e);
            } else if (a instanceof pe) {
                const e = a;
                t && null !== e.type && this._markStructsFromAST(e.type);
            } else if (a instanceof M) {
                const e = a;
                t && null !== e.type && this._markStructsFromAST(e.type), r.length > 0 && (r[r.length - 1][e.name] = e);
            } else if (a instanceof me) {
                const e = a;
                if (r.length > 0) {
                    if (r[r.length - 1][e.name]) return;
                }
                const t = s._findResource(e.name);
                t && n.push(t);
            } else if (a instanceof de) {
                const r = a, i = s._functions.get(r.name);
                i && (t && (i.inUse = !0), e.calls.add(i.node), null === i.resources && (i.resources = s._findResources(i.node, t)), n.push(...i.resources));
            } else if (a instanceof G) {
                const r = a, i = s._functions.get(r.name);
                i && (t && (i.inUse = !0), e.calls.add(i.node), null === i.resources && (i.resources = s._findResources(i.node, t)), n.push(...i.resources));
            }
        }), [
            ...new Map(n.map((e)=>[
                    e.name,
                    e
                ])).values()
        ];
    }
    getBindGroups() {
        const e = [];
        function t(t, n) {
            t >= e.length && (e.length = t + 1), void 0 === e[t] && (e[t] = []), n >= e[t].length && (e[t].length = n + 1);
        }
        for (const n of this.uniforms){
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        for (const n of this.storage){
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        for (const n of this.textures){
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        for (const n of this.samplers){
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        return e;
    }
    _getOutputs(e, t) {
        if (void 0 === t && (t = []), e instanceof ie) this._getStructOutputs(e, t);
        else {
            const n = this._getOutputInfo(e);
            null !== n && t.push(n);
        }
        return t;
    }
    _getStructOutputs(e, t) {
        for (const n of e.members)if (n.type instanceof ie) this._getStructOutputs(n.type, t);
        else {
            const e = this._getAttribute(n, 'location') || this._getAttribute(n, 'builtin');
            if (null !== e) {
                const s = this.getTypeInfo(n.type, n.type.attributes), r = this._parseInt(e.value), a = new u(n.name, s, e.name, r);
                t.push(a);
            }
        }
    }
    _getOutputInfo(e) {
        const t = this._getAttribute(e, 'location') || this._getAttribute(e, 'builtin');
        if (null !== t) {
            const n = this.getTypeInfo(e, e.attributes), s = this._parseInt(t.value);
            return new u('', n, t.name, s);
        }
        return null;
    }
    _getInputs(e, t) {
        void 0 === t && (t = []);
        for (const n of e)if (n.type instanceof ie) this._getStructInputs(n.type, t);
        else {
            const e = this._getInputInfo(n);
            null !== e && t.push(e);
        }
        return t;
    }
    _getStructInputs(e, t) {
        for (const n of e.members)if (n.type instanceof ie) this._getStructInputs(n.type, t);
        else {
            const e = this._getInputInfo(n);
            null !== e && t.push(e);
        }
    }
    _getInputInfo(e) {
        const t = this._getAttribute(e, 'location') || this._getAttribute(e, 'builtin');
        if (null !== t) {
            const n = this._getAttribute(e, 'interpolation'), s = this.getTypeInfo(e.type, e.attributes), r = this._parseInt(t.value), a = new c(e.name, s, t.name, r);
            return null !== n && (a.interpolation = this._parseString(n.value)), a;
        }
        return null;
    }
    _parseString(e) {
        return e instanceof Array && (e = e[0]), e;
    }
    _parseInt(e) {
        e instanceof Array && (e = e[0]);
        const t = parseInt(e);
        return isNaN(t) ? e : t;
    }
    _getAlias(e) {
        for (const t of this.aliases)if (t.name == e) return t.type;
        return null;
    }
    _getAliasInfo(e) {
        return new l(e.name, this.getTypeInfo(e.type, null));
    }
    getTypeInfoByName(e) {
        for (const t of this.structs)if (t.name == e) return t;
        for (const t of this.aliases)if (t.name == e) return t.type;
        return null;
    }
    getTypeInfo(i, o = null) {
        if (this._types.has(i)) return this._types.get(i);
        if (i instanceof le) {
            const e = i.type ? this.getTypeInfo(i.type, i.attributes) : null, t = new r(i.name, e, o);
            return this._types.set(i, t), this._updateTypeInfo(t), t;
        }
        if (i instanceof ce) {
            const e = i, t = e.format ? this.getTypeInfo(e.format, e.attributes) : null, n = new s(e.name, o);
            return n.format = t, n.count = e.count, this._types.set(i, n), this._updateTypeInfo(n), n;
        }
        if (i instanceof ie) {
            const e = i, s = new n(e.name, o);
            s.startLine = e.startLine, s.endLine = e.endLine;
            for (const n of e.members){
                const e = this.getTypeInfo(n.type, n.attributes);
                s.members.push(new t(n.name, e, n.attributes));
            }
            return this._types.set(i, s), this._updateTypeInfo(s), s;
        }
        if (i instanceof ue) {
            const t = i, n = t.format instanceof re, s = t.format ? n ? this.getTypeInfo(t.format, null) : new e(t.format, null) : null, r = new a(t.name, s, o, t.access);
            return this._types.set(i, r), this._updateTypeInfo(r), r;
        }
        if (i instanceof oe) {
            const e = i, t = e.format ? this.getTypeInfo(e.format, null) : null, n = new a(e.name, t, o, e.access);
            return this._types.set(i, n), this._updateTypeInfo(n), n;
        }
        const l = new e(i.name, o);
        return this._types.set(i, l), this._updateTypeInfo(l), l;
    }
    _updateTypeInfo(e) {
        var t, a, i;
        const o = this._getTypeSize(e);
        if (e.size = null !== (t = null == o ? void 0 : o.size) && void 0 !== t ? t : 0, e instanceof s && e.format) {
            const t = this._getTypeSize(e.format);
            e.stride = Math.max(null !== (a = null == t ? void 0 : t.size) && void 0 !== a ? a : 0, null !== (i = null == t ? void 0 : t.align) && void 0 !== i ? i : 0), this._updateTypeInfo(e.format);
        }
        e instanceof r && this._updateTypeInfo(e.format), e instanceof n && this._updateStructInfo(e);
    }
    _updateStructInfo(e) {
        var t;
        let n = 0, s = 0, r = 0, a = 0;
        for(let i = 0, o = e.members.length; i < o; ++i){
            const o = e.members[i], l = this._getTypeSize(o);
            if (!l) continue;
            null !== (t = this._getAlias(o.type.name)) && void 0 !== t || o.type;
            const c = l.align, u = l.size;
            n = this._roundUp(c, n + s), s = u, r = n, a = Math.max(a, c), o.offset = n, o.size = u, this._updateTypeInfo(o.type);
        }
        e.size = this._roundUp(a, r + s), e.align = a;
    }
    _getTypeSize(r) {
        var a, i;
        if (null == r) return null;
        const o = this._getAttributeNum(r.attributes, 'size', 0), l = this._getAttributeNum(r.attributes, 'align', 0);
        if (r instanceof t && (r = r.type), r instanceof e) {
            const e = this._getAlias(r.name);
            null !== e && (r = e);
        }
        {
            const e = rt._typeInfo[r.name];
            if (void 0 !== e) {
                const t = 'f16' === (null === (a = r.format) || void 0 === a ? void 0 : a.name) ? 2 : 1;
                return new st(Math.max(l, e.align / t), Math.max(o, e.size / t));
            }
        }
        {
            const e = rt._typeInfo[r.name.substring(0, r.name.length - 1)];
            if (e) {
                const t = 'h' === r.name[r.name.length - 1] ? 2 : 1;
                return new st(Math.max(l, e.align / t), Math.max(o, e.size / t));
            }
        }
        if (r instanceof s) {
            let e = r, t = 8, n = 8;
            const s = this._getTypeSize(e.format);
            null !== s && (n = s.size, t = s.align);
            return n = e.count * this._getAttributeNum(null !== (i = null == r ? void 0 : r.attributes) && void 0 !== i ? i : null, 'stride', this._roundUp(t, n)), o && (n = o), new st(Math.max(l, t), Math.max(o, n));
        }
        if (r instanceof n) {
            let e = 0, t = 0, n = 0, s = 0, a = 0;
            for (const t of r.members){
                const r = this._getTypeSize(t.type);
                null !== r && (e = Math.max(r.align, e), n = this._roundUp(r.align, n + s), s = r.size, a = n);
            }
            return t = this._roundUp(e, a + s), new st(Math.max(l, e), Math.max(o, t));
        }
        return null;
    }
    _isUniformVar(e) {
        return e instanceof B && 'uniform' == e.storage;
    }
    _isStorageVar(e) {
        return e instanceof B && 'storage' == e.storage;
    }
    _isTextureVar(e) {
        return e instanceof B && null !== e.type && -1 != rt._textureTypes.indexOf(e.type.name);
    }
    _isSamplerVar(e) {
        return e instanceof B && null !== e.type && -1 != rt._samplerTypes.indexOf(e.type.name);
    }
    _getAttribute(e, t) {
        const n = e;
        if (!n || !n.attributes) return null;
        const s = n.attributes;
        for (let e of s)if (e.name == t) return e;
        return null;
    }
    _getAttributeNum(e, t, n) {
        if (null === e) return n;
        for (let s of e)if (s.name == t) {
            let e = null !== s && null !== s.value ? s.value : n;
            return e instanceof Array && (e = e[0]), 'number' == typeof e ? e : 'string' == typeof e ? parseInt(e) : n;
        }
        return n;
    }
    _roundUp(e, t) {
        return Math.ceil(t / e) * e;
    }
}
rt._typeInfo = {
    f16: {
        align: 2,
        size: 2
    },
    i32: {
        align: 4,
        size: 4
    },
    u32: {
        align: 4,
        size: 4
    },
    f32: {
        align: 4,
        size: 4
    },
    atomic: {
        align: 4,
        size: 4
    },
    vec2: {
        align: 8,
        size: 8
    },
    vec3: {
        align: 16,
        size: 12
    },
    vec4: {
        align: 16,
        size: 16
    },
    mat2x2: {
        align: 8,
        size: 16
    },
    mat3x2: {
        align: 8,
        size: 24
    },
    mat4x2: {
        align: 8,
        size: 32
    },
    mat2x3: {
        align: 16,
        size: 32
    },
    mat3x3: {
        align: 16,
        size: 48
    },
    mat4x3: {
        align: 16,
        size: 64
    },
    mat2x4: {
        align: 16,
        size: 32
    },
    mat3x4: {
        align: 16,
        size: 48
    },
    mat4x4: {
        align: 16,
        size: 64
    }
}, rt._textureTypes = qe.any_texture_type.map((e)=>e.name), rt._samplerTypes = qe.sampler_type.map((e)=>e.name);
let at = 0;
class it {
    constructor(e, t, n){
        this.id = at++, this.name = e, this.value = t, this.node = n;
    }
    clone() {
        return new it(this.name, this.value, this.node);
    }
}
class ot {
    constructor(e){
        this.id = at++, this.name = e.name, this.node = e;
    }
    clone() {
        return new ot(this.node);
    }
}
class lt {
    constructor(e){
        this.parent = null, this.variables = new Map, this.functions = new Map, this.currentFunctionName = '', this.id = at++, e && (this.parent = e, this.currentFunctionName = e.currentFunctionName);
    }
    getVariable(e) {
        var t;
        return this.variables.has(e) ? null !== (t = this.variables.get(e)) && void 0 !== t ? t : null : this.parent ? this.parent.getVariable(e) : null;
    }
    getFunction(e) {
        var t;
        return this.functions.has(e) ? null !== (t = this.functions.get(e)) && void 0 !== t ? t : null : this.parent ? this.parent.getFunction(e) : null;
    }
    createVariable(e, t, n) {
        this.variables.set(e, new it(e, t, null != n ? n : null));
    }
    setVariable(e, t, n) {
        const s = this.getVariable(e);
        null !== s ? s.value = t : this.createVariable(e, t, n);
    }
    getVariableValue(e) {
        var t;
        const n = this.getVariable(e);
        return null !== (t = null == n ? void 0 : n.value) && void 0 !== t ? t : null;
    }
    clone() {
        return new lt(this);
    }
}
class ct {
    evalExpression(e, t) {
        return null;
    }
    getTypeInfo(e) {
        return null;
    }
    getVariableName(e, t) {
        return '';
    }
}
class ut {
    constructor(e){
        this.exec = e;
    }
    getTypeInfo(e) {
        return this.exec.getTypeInfo(e);
    }
    All(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        let s = !0;
        if (n instanceof Fe) return n.data.forEach((e)=>{
            e || (s = !1);
        }), new Oe(s ? 1 : 0, this.getTypeInfo('bool'));
        throw new Error(`All() expects a vector argument. Line ${e.line}`);
    }
    Any(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) {
            const e = n.data.some((e)=>e);
            return new Oe(e ? 1 : 0, this.getTypeInfo('bool'));
        }
        throw new Error(`Any() expects a vector argument. Line ${e.line}`);
    }
    Select(e, t) {
        const n = this.exec.evalExpression(e.args[2], t);
        if (!(n instanceof Oe)) throw new Error(`Select() expects a bool condition. Line ${e.line}`);
        return n.value ? this.exec.evalExpression(e.args[1], t) : this.exec.evalExpression(e.args[0], t);
    }
    ArrayLength(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.evalExpression(n, t);
        if (s instanceof Ue && 0 === s.typeInfo.size) {
            const e = s.typeInfo, t = s.buffer.byteLength / e.stride;
            return new Oe(t, this.getTypeInfo('u32'));
        }
        return new Oe(s.typeInfo.size, this.getTypeInfo('u32'));
    }
    Abs(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.abs(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.abs(s.value), s.typeInfo);
    }
    Acos(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.acos(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.acos(s.value), n.typeInfo);
    }
    Acosh(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.acosh(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.acosh(s.value), n.typeInfo);
    }
    Asin(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.asin(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.asin(s.value), n.typeInfo);
    }
    Asinh(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.asinh(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.asinh(s.value), n.typeInfo);
    }
    Atan(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.atan(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.atan(s.value), n.typeInfo);
    }
    Atanh(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.atanh(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.atanh(s.value), n.typeInfo);
    }
    Atan2(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) return new Fe(n.data.map((e, t)=>Math.atan2(e, s.data[t])), n.typeInfo);
        const r = n, a = s;
        return new Oe(Math.atan2(r.value, a.value), n.typeInfo);
    }
    Ceil(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.ceil(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.ceil(s.value), n.typeInfo);
    }
    _clamp(e, t, n) {
        return Math.min(Math.max(e, t), n);
    }
    Clamp(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t);
        if (n instanceof Fe && s instanceof Fe && r instanceof Fe) return new Fe(n.data.map((e, t)=>this._clamp(e, s.data[t], r.data[t])), n.typeInfo);
        const a = n, i = s, o = r;
        return new Oe(this._clamp(a.value, i.value, o.value), n.typeInfo);
    }
    Cos(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.cos(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.cos(s.value), n.typeInfo);
    }
    Cosh(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.cosh(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.cos(s.value), n.typeInfo);
    }
    CountLeadingZeros(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.clz32(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.clz32(s.value), n.typeInfo);
    }
    _countOneBits(e) {
        let t = 0;
        for(; 0 !== e;)1 & e && t++, e >>= 1;
        return t;
    }
    CountOneBits(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>this._countOneBits(e)), n.typeInfo);
        const s = n;
        return new Oe(this._countOneBits(s.value), n.typeInfo);
    }
    _countTrailingZeros(e) {
        if (0 === e) return 32;
        let t = 0;
        for(; !(1 & e);)e >>= 1, t++;
        return t;
    }
    CountTrailingZeros(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>this._countTrailingZeros(e)), n.typeInfo);
        const s = n;
        return new Oe(this._countTrailingZeros(s.value), n.typeInfo);
    }
    Cross(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) {
            if (3 !== n.data.length || 3 !== s.data.length) return console.error(`Cross() expects 3D vectors. Line ${e.line}`), null;
            const t = n.data, r = s.data;
            return new Fe([
                t[1] * r[2] - r[1] * t[2],
                t[2] * r[0] - r[2] * t[0],
                t[0] * r[1] - r[0] * t[1]
            ], n.typeInfo);
        }
        return console.error(`Cross() expects vector arguments. Line ${e.line}`), null;
    }
    Degrees(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = 180 / Math.PI;
        if (n instanceof Fe) return new Fe(n.data.map((e)=>e * s), n.typeInfo);
        return new Oe(n.value * s, this.getTypeInfo('f32'));
    }
    Determinant(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Me) {
            const e = n.data, t = n.typeInfo.getTypeName(), s = t.endsWith('h') ? this.getTypeInfo('f16') : this.getTypeInfo('f32');
            if ('mat2x2' === t || 'mat2x2f' === t || 'mat2x2h' === t) return new Oe(e[0] * e[3] - e[1] * e[2], s);
            if ('mat2x3' === t || 'mat2x3f' === t || 'mat2x3h' === t) return new Oe(e[0] * (e[4] * e[8] - e[5] * e[7]) - e[1] * (e[3] * e[8] - e[5] * e[6]) + e[2] * (e[3] * e[7] - e[4] * e[6]), s);
            if ('mat2x4' === t || 'mat2x4f' === t || 'mat2x4h' === t) console.error(`TODO: Determinant for ${t}`);
            else if ('mat3x2' === t || 'mat3x2f' === t || 'mat3x2h' === t) console.error(`TODO: Determinant for ${t}`);
            else {
                if ('mat3x3' === t || 'mat3x3f' === t || 'mat3x3h' === t) return new Oe(e[0] * (e[4] * e[8] - e[5] * e[7]) - e[1] * (e[3] * e[8] - e[5] * e[6]) + e[2] * (e[3] * e[7] - e[4] * e[6]), s);
                'mat3x4' === t || 'mat3x4f' === t || 'mat3x4h' === t || 'mat4x2' === t || 'mat4x2f' === t || 'mat4x2h' === t || 'mat4x3' === t || 'mat4x3f' === t || 'mat4x3h' === t ? console.error(`TODO: Determinant for ${t}`) : 'mat4x4' !== t && 'mat4x4f' !== t && 'mat4x4h' !== t || console.error(`TODO: Determinant for ${t}`);
            }
        }
        return console.error(`Determinant expects a matrix argument. Line ${e.line}`), null;
    }
    Distance(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) {
            let e = 0;
            for(let t = 0; t < n.data.length; ++t)e += (n.data[t] - s.data[t]) * (n.data[t] - s.data[t]);
            return new Oe(Math.sqrt(e), this.getTypeInfo('f32'));
        }
        const r = n, a = s;
        return new Oe(Math.abs(r.value - a.value), n.typeInfo);
    }
    _dot(e, t) {
        let n = 0;
        for(let s = 0; s < e.length; ++s)n += t[s] * e[s];
        return n;
    }
    Dot(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        return n instanceof Fe && s instanceof Fe ? new Oe(this._dot(n.data, s.data), this.getTypeInfo('f32')) : (console.error(`Dot() expects vector arguments. Line ${e.line}`), null);
    }
    Dot4U8Packed(e, t) {
        return console.error(`TODO: dot4U8Packed. Line ${e.line}`), null;
    }
    Dot4I8Packed(e, t) {
        return console.error(`TODO: dot4I8Packed. Line ${e.line}`), null;
    }
    Exp(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.exp(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.exp(s.value), n.typeInfo);
    }
    Exp2(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.pow(2, e)), n.typeInfo);
        const s = n;
        return new Oe(Math.pow(2, s.value), n.typeInfo);
    }
    ExtractBits(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t);
        if ('u32' !== s.typeInfo.name && 'x32' !== s.typeInfo.name) return console.error(`ExtractBits() expects an i32 offset argument. Line ${e.line}`), null;
        if ('u32' !== r.typeInfo.name && 'x32' !== r.typeInfo.name) return console.error(`ExtractBits() expects an i32 count argument. Line ${e.line}`), null;
        const a = s.value, i = r.value;
        if (n instanceof Fe) return new Fe(n.data.map((e)=>e >> a & (1 << i) - 1), n.typeInfo);
        if ('i32' !== n.typeInfo.name && 'x32' !== n.typeInfo.name) return console.error(`ExtractBits() expects an i32 argument. Line ${e.line}`), null;
        const o = n.value;
        return new Oe(o >> a & (1 << i) - 1, this.getTypeInfo('i32'));
    }
    FaceForward(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t);
        if (n instanceof Fe && s instanceof Fe && r instanceof Fe) {
            const e = this._dot(s.data, r.data);
            return new Fe(e < 0 ? Array.from(n.data) : n.data.map((e)=>-e), n.typeInfo);
        }
        return console.error(`FaceForward() expects vector arguments. Line ${e.line}`), null;
    }
    _firstLeadingBit(e) {
        return 0 === e ? -1 : 31 - Math.clz32(e);
    }
    FirstLeadingBit(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>this._firstLeadingBit(e)), n.typeInfo);
        const s = n;
        return new Oe(this._firstLeadingBit(s.value), n.typeInfo);
    }
    _firstTrailingBit(e) {
        return 0 === e ? -1 : Math.log2(e & -e);
    }
    FirstTrailingBit(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>this._firstTrailingBit(e)), n.typeInfo);
        const s = n;
        return new Oe(this._firstTrailingBit(s.value), n.typeInfo);
    }
    Floor(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.floor(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.floor(s.value), n.typeInfo);
    }
    Fma(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t);
        if (n instanceof Fe && s instanceof Fe && r instanceof Fe) return n.data.length !== s.data.length || n.data.length !== r.data.length ? (console.error(`Fma() expects vectors of the same length. Line ${e.line}`), null) : new Fe(n.data.map((e, t)=>e * s.data[t] + r.data[t]), n.typeInfo);
        const a = n, i = s, o = r;
        return new Oe(a.value * i.value + o.value, a.typeInfo);
    }
    Fract(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>e - Math.floor(e)), n.typeInfo);
        const s = n;
        return new Oe(s.value - Math.floor(s.value), n.typeInfo);
    }
    Frexp(e, t) {
        return console.error(`TODO: frexp. Line ${e.line}`), null;
    }
    InsertBits(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t), a = this.exec.evalExpression(e.args[3], t);
        if ('u32' !== r.typeInfo.name && 'x32' !== r.typeInfo.name) return console.error(`InsertBits() expects an i32 offset argument. Line ${e.line}`), null;
        const i = r.value, o = (1 << a.value) - 1 << i, l = ~o;
        if (n instanceof Fe && s instanceof Fe) return new Fe(n.data.map((e, t)=>e & l | s.data[t] << i & o), n.typeInfo);
        const c = n.value, u = s.value;
        return new Oe(c & l | u << i & o, n.typeInfo);
    }
    InverseSqrt(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>1 / Math.sqrt(e)), n.typeInfo);
        const s = n;
        return new Oe(1 / Math.sqrt(s.value), n.typeInfo);
    }
    Ldexp(e, t) {
        return console.error(`TODO: ldexp. Line ${e.line}`), null;
    }
    Length(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) {
            let e = 0;
            return n.data.forEach((t)=>{
                e += t * t;
            }), new Oe(Math.sqrt(e), this.getTypeInfo('f32'));
        }
        const s = n;
        return new Oe(Math.abs(s.value), n.typeInfo);
    }
    Log(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.log(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.log(s.value), n.typeInfo);
    }
    Log2(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.log2(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.log2(s.value), n.typeInfo);
    }
    Max(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) return new Fe(n.data.map((e, t)=>Math.max(e, s.data[t])), n.typeInfo);
        const r = n, a = s;
        return new Oe(Math.max(r.value, a.value), n.typeInfo);
    }
    Min(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) return new Fe(n.data.map((e, t)=>Math.min(e, s.data[t])), n.typeInfo);
        const r = n, a = s;
        return new Oe(Math.min(r.value, a.value), n.typeInfo);
    }
    Mix(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t);
        if (n instanceof Fe && s instanceof Fe && r instanceof Fe) return new Fe(n.data.map((e, t)=>n.data[t] * (1 - r.data[t]) + s.data[t] * r.data[t]), n.typeInfo);
        const a = s, i = r;
        return new Oe(n.value * (1 - i.value) + a.value * i.value, n.typeInfo);
    }
    Modf(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) return new Fe(n.data.map((e, t)=>e % s.data[t]), n.typeInfo);
        const r = s;
        return new Oe(n.value % r.value, n.typeInfo);
    }
    Normalize(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) {
            const s = this.Length(e, t).value;
            return new Fe(n.data.map((e)=>e / s), n.typeInfo);
        }
        return console.error(`Normalize() expects a vector argument. Line ${e.line}`), null;
    }
    Pow(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) return new Fe(n.data.map((e, t)=>Math.pow(e, s.data[t])), n.typeInfo);
        const r = n, a = s;
        return new Oe(Math.pow(r.value, a.value), n.typeInfo);
    }
    QuantizeToF16(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>e), n.typeInfo);
        return new Oe(n.value, n.typeInfo);
    }
    Radians(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>e * Math.PI / 180), n.typeInfo);
        return new Oe(n.value * Math.PI / 180, this.getTypeInfo('f32'));
    }
    Reflect(e, t) {
        let n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (n instanceof Fe && s instanceof Fe) {
            const e = this._dot(n.data, s.data);
            return new Fe(n.data.map((t, n)=>t - 2 * e * s.data[n]), n.typeInfo);
        }
        return console.error(`Reflect() expects vector arguments. Line ${e.line}`), null;
    }
    Refract(e, t) {
        let n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t);
        if (n instanceof Fe && s instanceof Fe && r instanceof Oe) {
            const e = this._dot(s.data, n.data);
            return new Fe(n.data.map((t, n)=>{
                const a = 1 - r.value * r.value * (1 - e * e);
                if (a < 0) return 0;
                const i = Math.sqrt(a);
                return r.value * t - (r.value * e + i) * s.data[n];
            }), n.typeInfo);
        }
        return console.error(`Refract() expects vector arguments and a scalar argument. Line ${e.line}`), null;
    }
    ReverseBits(e, t) {
        return console.error(`TODO: reverseBits. Line ${e.line}`), null;
    }
    Round(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.round(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.round(s.value), n.typeInfo);
    }
    Saturate(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.min(Math.max(e, 0), 1)), n.typeInfo);
        const s = n;
        return new Oe(Math.min(Math.max(s.value, 0), 1), n.typeInfo);
    }
    Sign(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.sign(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.sign(s.value), n.typeInfo);
    }
    Sin(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.sin(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.sin(s.value), n.typeInfo);
    }
    Sinh(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.sinh(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.sinh(s.value), n.typeInfo);
    }
    _smoothstep(e, t, n) {
        const s = Math.min(Math.max((n - e) / (t - e), 0), 1);
        return s * s * (3 - 2 * s);
    }
    SmoothStep(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t), r = this.exec.evalExpression(e.args[2], t);
        if (r instanceof Fe && n instanceof Fe && s instanceof Fe) return new Fe(r.data.map((e, t)=>this._smoothstep(n.data[t], s.data[t], e)), r.typeInfo);
        const a = n, i = s, o = r;
        return new Oe(this._smoothstep(a.value, i.value, o.value), r.typeInfo);
    }
    Sqrt(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.sqrt(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.sqrt(s.value), n.typeInfo);
    }
    Step(e, t) {
        const n = this.exec.evalExpression(e.args[0], t), s = this.exec.evalExpression(e.args[1], t);
        if (s instanceof Fe && n instanceof Fe) return new Fe(s.data.map((e, t)=>e < n.data[t] ? 0 : 1), s.typeInfo);
        const r = n;
        return new Oe(s.value < r.value ? 0 : 1, r.typeInfo);
    }
    Tan(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.tan(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.tan(s.value), n.typeInfo);
    }
    Tanh(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.tanh(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.tanh(s.value), n.typeInfo);
    }
    _getTransposeType(e) {
        const t = e.getTypeName();
        return 'mat2x2f' === t || 'mat2x2h' === t ? e : 'mat2x3f' === t ? this.getTypeInfo('mat3x2f') : 'mat2x3h' === t ? this.getTypeInfo('mat3x2h') : 'mat2x4f' === t ? this.getTypeInfo('mat4x2f') : 'mat2x4h' === t ? this.getTypeInfo('mat4x2h') : 'mat3x2f' === t ? this.getTypeInfo('mat2x3f') : 'mat3x2h' === t ? this.getTypeInfo('mat2x3h') : 'mat3x3f' === t || 'mat3x3h' === t ? e : 'mat3x4f' === t ? this.getTypeInfo('mat4x3f') : 'mat3x4h' === t ? this.getTypeInfo('mat4x3h') : 'mat4x2f' === t ? this.getTypeInfo('mat2x4f') : 'mat4x2h' === t ? this.getTypeInfo('mat2x4h') : 'mat4x3f' === t ? this.getTypeInfo('mat3x4f') : 'mat4x3h' === t ? this.getTypeInfo('mat3x4h') : ('mat4x4f' === t || 'mat4x4h' === t || console.error(`Invalid matrix type ${t}`), e);
    }
    Transpose(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (!(n instanceof Me)) return console.error(`Transpose() expects a matrix argument. Line ${e.line}`), null;
        const s = this._getTransposeType(n.typeInfo);
        if ('mat2x2' === n.typeInfo.name || 'mat2x2f' === n.typeInfo.name || 'mat2x2h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[2],
                e[1],
                e[3]
            ], s);
        }
        if ('mat2x3' === n.typeInfo.name || 'mat2x3f' === n.typeInfo.name || 'mat2x3h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[3],
                e[6],
                e[1],
                e[4],
                e[7]
            ], s);
        }
        if ('mat2x4' === n.typeInfo.name || 'mat2x4f' === n.typeInfo.name || 'mat2x4h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[4],
                e[8],
                e[12],
                e[1],
                e[5],
                e[9],
                e[13]
            ], s);
        }
        if ('mat3x2' === n.typeInfo.name || 'mat3x2f' === n.typeInfo.name || 'mat3x2h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[3],
                e[1],
                e[4],
                e[2],
                e[5]
            ], s);
        }
        if ('mat3x3' === n.typeInfo.name || 'mat3x3f' === n.typeInfo.name || 'mat3x3h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[3],
                e[6],
                e[1],
                e[4],
                e[7],
                e[2],
                e[5],
                e[8]
            ], s);
        }
        if ('mat3x4' === n.typeInfo.name || 'mat3x4f' === n.typeInfo.name || 'mat3x4h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[4],
                e[8],
                e[12],
                e[1],
                e[5],
                e[9],
                e[13],
                e[2],
                e[6],
                e[10],
                e[14]
            ], s);
        }
        if ('mat4x2' === n.typeInfo.name || 'mat4x2f' === n.typeInfo.name || 'mat4x2h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[4],
                e[1],
                e[5],
                e[2],
                e[6]
            ], s);
        }
        if ('mat4x3' === n.typeInfo.name || 'mat4x3f' === n.typeInfo.name || 'mat4x3h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[4],
                e[8],
                e[1],
                e[5],
                e[9],
                e[2],
                e[6],
                e[10]
            ], s);
        }
        if ('mat4x4' === n.typeInfo.name || 'mat4x4f' === n.typeInfo.name || 'mat4x4h' === n.typeInfo.name) {
            const e = n.data;
            return new Me([
                e[0],
                e[4],
                e[8],
                e[12],
                e[1],
                e[5],
                e[9],
                e[13],
                e[2],
                e[6],
                e[10],
                e[14],
                e[3],
                e[7],
                e[11],
                e[15]
            ], s);
        }
        return console.error(`Invalid matrix type ${n.typeInfo.name}`), null;
    }
    Trunc(e, t) {
        const n = this.exec.evalExpression(e.args[0], t);
        if (n instanceof Fe) return new Fe(n.data.map((e)=>Math.trunc(e)), n.typeInfo);
        const s = n;
        return new Oe(Math.trunc(s.value), n.typeInfo);
    }
    Dpdx(e, t) {
        return console.error(`TODO: dpdx. Line ${e.line}`), null;
    }
    DpdxCoarse(e, t) {
        return console.error(`TODO: dpdxCoarse. Line ${e.line}`), null;
    }
    DpdxFine(e, t) {
        return console.error('TODO: dpdxFine'), null;
    }
    Dpdy(e, t) {
        return console.error('TODO: dpdy'), null;
    }
    DpdyCoarse(e, t) {
        return console.error('TODO: dpdyCoarse'), null;
    }
    DpdyFine(e, t) {
        return console.error('TODO: dpdyFine'), null;
    }
    Fwidth(e, t) {
        return console.error('TODO: fwidth'), null;
    }
    FwidthCoarse(e, t) {
        return console.error('TODO: fwidthCoarse'), null;
    }
    FwidthFine(e, t) {
        return console.error('TODO: fwidthFine'), null;
    }
    TextureDimensions(e, t) {
        const n = e.args[0], s = e.args.length > 1 ? this.exec.evalExpression(e.args[1], t).value : 0;
        if (n instanceof me) {
            const r = n.name, a = t.getVariableValue(r);
            if (a instanceof Pe) {
                if (s < 0 || s >= a.mipLevelCount) return console.error(`Invalid mip level for textureDimensions. Line ${e.line}`), null;
                const t = a.getMipLevelSize(s), n = a.dimension;
                return '1d' === n ? new Oe(t[0], this.getTypeInfo('u32')) : '3d' === n ? new Fe(t, this.getTypeInfo('vec3u')) : '2d' === n ? new Fe(t.slice(0, 2), this.getTypeInfo('vec2u')) : (console.error(`Invalid texture dimension ${n} not found. Line ${e.line}`), null);
            }
            return console.error(`Texture ${r} not found. Line ${e.line}`), null;
        }
        return console.error(`Invalid texture argument for textureDimensions. Line ${e.line}`), null;
    }
    TextureGather(e, t) {
        return console.error('TODO: textureGather'), null;
    }
    TextureGatherCompare(e, t) {
        return console.error('TODO: textureGatherCompare'), null;
    }
    TextureLoad(e, t) {
        const n = e.args[0], s = this.exec.evalExpression(e.args[1], t), r = e.args.length > 2 ? this.exec.evalExpression(e.args[2], t).value : 0;
        if (!(s instanceof Fe) || 2 !== s.data.length) return console.error(`Invalid UV argument for textureLoad. Line ${e.line}`), null;
        if (n instanceof me) {
            const a = n.name, i = t.getVariableValue(a);
            if (i instanceof Pe) {
                const t = Math.floor(s.data[0]), n = Math.floor(s.data[1]);
                if (t < 0 || t >= i.width || n < 0 || n >= i.height) return console.error(`Texture ${a} out of bounds. Line ${e.line}`), null;
                const o = i.getPixel(t, n, 0, r);
                return null === o ? (console.error(`Invalid texture format for textureLoad. Line ${e.line}`), null) : new Fe(o, this.getTypeInfo('vec4f'));
            }
            return console.error(`Texture ${a} not found. Line ${e.line}`), null;
        }
        return console.error(`Invalid texture argument for textureLoad. Line ${e.line}`), null;
    }
    TextureNumLayers(e, t) {
        const n = e.args[0];
        if (n instanceof me) {
            const s = n.name, r = t.getVariableValue(s);
            return r instanceof Pe ? new Oe(r.depthOrArrayLayers, this.getTypeInfo('u32')) : (console.error(`Texture ${s} not found. Line ${e.line}`), null);
        }
        return console.error(`Invalid texture argument for textureNumLayers. Line ${e.line}`), null;
    }
    TextureNumLevels(e, t) {
        const n = e.args[0];
        if (n instanceof me) {
            const s = n.name, r = t.getVariableValue(s);
            return r instanceof Pe ? new Oe(r.mipLevelCount, this.getTypeInfo('u32')) : (console.error(`Texture ${s} not found. Line ${e.line}`), null);
        }
        return console.error(`Invalid texture argument for textureNumLevels. Line ${e.line}`), null;
    }
    TextureNumSamples(e, t) {
        const n = e.args[0];
        if (n instanceof me) {
            const s = n.name, r = t.getVariableValue(s);
            return r instanceof Pe ? new Oe(r.sampleCount, this.getTypeInfo('u32')) : (console.error(`Texture ${s} not found. Line ${e.line}`), null);
        }
        return console.error(`Invalid texture argument for textureNumSamples. Line ${e.line}`), null;
    }
    TextureSample(e, t) {
        return console.error('TODO: textureSample'), null;
    }
    TextureSampleBias(e, t) {
        return console.error('TODO: textureSampleBias'), null;
    }
    TextureSampleCompare(e, t) {
        return console.error('TODO: textureSampleCompare'), null;
    }
    TextureSampleCompareLevel(e, t) {
        return console.error('TODO: textureSampleCompareLevel'), null;
    }
    TextureSampleGrad(e, t) {
        return console.error('TODO: textureSampleGrad'), null;
    }
    TextureSampleLevel(e, t) {
        return console.error('TODO: textureSampleLevel'), null;
    }
    TextureSampleBaseClampToEdge(e, t) {
        return console.error('TODO: textureSampleBaseClampToEdge'), null;
    }
    TextureStore(e, t) {
        const n = e.args[0], s = this.exec.evalExpression(e.args[1], t), r = 4 === e.args.length ? this.exec.evalExpression(e.args[2], t).value : 0, a = 4 === e.args.length ? this.exec.evalExpression(e.args[3], t).data : this.exec.evalExpression(e.args[2], t).data;
        if (4 !== a.length) return console.error(`Invalid value argument for textureStore. Line ${e.line}`), null;
        if (!(s instanceof Fe) || 2 !== s.data.length) return console.error(`Invalid UV argument for textureStore. Line ${e.line}`), null;
        if (n instanceof me) {
            const i = n.name, o = t.getVariableValue(i);
            if (o instanceof Pe) {
                const t = o.getMipLevelSize(0), n = Math.floor(s.data[0]), l = Math.floor(s.data[1]);
                return n < 0 || n >= t[0] || l < 0 || l >= t[1] ? (console.error(`Texture ${i} out of bounds. Line ${e.line}`), null) : (o.setPixel(n, l, 0, r, Array.from(a)), null);
            }
            return console.error(`Texture ${i} not found. Line ${e.line}`), null;
        }
        return console.error(`Invalid texture argument for textureStore. Line ${e.line}`), null;
    }
    AtomicLoad(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t);
        return t.getVariable(s).value.getSubData(this.exec, n.postfix, t);
    }
    AtomicStore(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t);
        return o instanceof Oe && i instanceof Oe && (o.value = i.value), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), null;
    }
    AtomicAdd(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value += i.value), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicSub(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value -= i.value), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicMax(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value = Math.max(o.value, i.value)), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicMin(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value = Math.min(o.value, i.value)), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicAnd(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value = o.value & i.value), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicOr(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value = o.value | i.value), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicXor(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value = o.value ^ i.value), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicExchange(e, t) {
        let n = e.args[0];
        n instanceof we && (n = n.right);
        const s = this.exec.getVariableName(n, t), r = t.getVariable(s);
        let a = e.args[1];
        const i = this.exec.evalExpression(a, t), o = r.value.getSubData(this.exec, n.postfix, t), l = new Oe(o.value, o.typeInfo);
        return o instanceof Oe && i instanceof Oe && (o.value = i.value), r.value instanceof Ue && r.value.setDataValue(this.exec, o, n.postfix, t), l;
    }
    AtomicCompareExchangeWeak(e, t) {
        return console.error('TODO: atomicCompareExchangeWeak'), null;
    }
    Pack4x8snorm(e, t) {
        return console.error('TODO: pack4x8snorm'), null;
    }
    Pack4x8unorm(e, t) {
        return console.error('TODO: pack4x8unorm'), null;
    }
    Pack4xI8(e, t) {
        return console.error('TODO: pack4xI8'), null;
    }
    Pack4xU8(e, t) {
        return console.error('TODO: pack4xU8'), null;
    }
    Pack4x8Clamp(e, t) {
        return console.error('TODO: pack4x8Clamp'), null;
    }
    Pack4xU8Clamp(e, t) {
        return console.error('TODO: pack4xU8Clamp'), null;
    }
    Pack2x16snorm(e, t) {
        return console.error('TODO: pack2x16snorm'), null;
    }
    Pack2x16unorm(e, t) {
        return console.error('TODO: pack2x16unorm'), null;
    }
    Pack2x16float(e, t) {
        return console.error('TODO: pack2x16float'), null;
    }
    Unpack4x8snorm(e, t) {
        return console.error('TODO: unpack4x8snorm'), null;
    }
    Unpack4x8unorm(e, t) {
        return console.error('TODO: unpack4x8unorm'), null;
    }
    Unpack4xI8(e, t) {
        return console.error('TODO: unpack4xI8'), null;
    }
    Unpack4xU8(e, t) {
        return console.error('TODO: unpack4xU8'), null;
    }
    Unpack2x16snorm(e, t) {
        return console.error('TODO: unpack2x16snorm'), null;
    }
    Unpack2x16unorm(e, t) {
        return console.error('TODO: unpack2x16unorm'), null;
    }
    Unpack2x16float(e, t) {
        return console.error('TODO: unpack2x16float'), null;
    }
    StorageBarrier(e, t) {
        return null;
    }
    TextureBarrier(e, t) {
        return null;
    }
    WorkgroupBarrier(e, t) {
        return null;
    }
    WorkgroupUniformLoad(e, t) {
        return null;
    }
    SubgroupAdd(e, t) {
        return console.error('TODO: subgroupAdd'), null;
    }
    SubgroupExclusiveAdd(e, t) {
        return console.error('TODO: subgroupExclusiveAdd'), null;
    }
    SubgroupInclusiveAdd(e, t) {
        return console.error('TODO: subgroupInclusiveAdd'), null;
    }
    SubgroupAll(e, t) {
        return console.error('TODO: subgroupAll'), null;
    }
    SubgroupAnd(e, t) {
        return console.error('TODO: subgroupAnd'), null;
    }
    SubgroupAny(e, t) {
        return console.error('TODO: subgroupAny'), null;
    }
    SubgroupBallot(e, t) {
        return console.error('TODO: subgroupBallot'), null;
    }
    SubgroupBroadcast(e, t) {
        return console.error('TODO: subgroupBroadcast'), null;
    }
    SubgroupBroadcastFirst(e, t) {
        return console.error('TODO: subgroupBroadcastFirst'), null;
    }
    SubgroupElect(e, t) {
        return console.error('TODO: subgroupElect'), null;
    }
    SubgroupMax(e, t) {
        return console.error('TODO: subgroupMax'), null;
    }
    SubgroupMin(e, t) {
        return console.error('TODO: subgroupMin'), null;
    }
    SubgroupMul(e, t) {
        return console.error('TODO: subgroupMul'), null;
    }
    SubgroupExclusiveMul(e, t) {
        return console.error('TODO: subgroupExclusiveMul'), null;
    }
    SubgroupInclusiveMul(e, t) {
        return console.error('TODO: subgroupInclusiveMul'), null;
    }
    SubgroupOr(e, t) {
        return console.error('TODO: subgroupOr'), null;
    }
    SubgroupShuffle(e, t) {
        return console.error('TODO: subgroupShuffle'), null;
    }
    SubgroupShuffleDown(e, t) {
        return console.error('TODO: subgroupShuffleDown'), null;
    }
    SubgroupShuffleUp(e, t) {
        return console.error('TODO: subgroupShuffleUp'), null;
    }
    SubgroupShuffleXor(e, t) {
        return console.error('TODO: subgroupShuffleXor'), null;
    }
    SubgroupXor(e, t) {
        return console.error('TODO: subgroupXor'), null;
    }
    QuadBroadcast(e, t) {
        return console.error('TODO: quadBroadcast'), null;
    }
    QuadSwapDiagonal(e, t) {
        return console.error('TODO: quadSwapDiagonal'), null;
    }
    QuadSwapX(e, t) {
        return console.error('TODO: quadSwapX'), null;
    }
    QuadSwapY(e, t) {
        return console.error('TODO: quadSwapY'), null;
    }
}
const ht = {
    vec2: 2,
    vec2f: 2,
    vec2i: 2,
    vec2u: 2,
    vec2b: 2,
    vec2h: 2,
    vec3: 3,
    vec3f: 3,
    vec3i: 3,
    vec3u: 3,
    vec3b: 3,
    vec3h: 3,
    vec4: 4,
    vec4f: 4,
    vec4i: 4,
    vec4u: 4,
    vec4b: 4,
    vec4h: 4
}, ft = {
    mat2x2: [
        2,
        2,
        4
    ],
    mat2x2f: [
        2,
        2,
        4
    ],
    mat2x2h: [
        2,
        2,
        4
    ],
    mat2x3: [
        2,
        3,
        6
    ],
    mat2x3f: [
        2,
        3,
        6
    ],
    mat2x3h: [
        2,
        3,
        6
    ],
    mat2x4: [
        2,
        4,
        8
    ],
    mat2x4f: [
        2,
        4,
        8
    ],
    mat2x4h: [
        2,
        4,
        8
    ],
    mat3x2: [
        3,
        2,
        6
    ],
    mat3x2f: [
        3,
        2,
        6
    ],
    mat3x2h: [
        3,
        2,
        6
    ],
    mat3x3: [
        3,
        3,
        9
    ],
    mat3x3f: [
        3,
        3,
        9
    ],
    mat3x3h: [
        3,
        3,
        9
    ],
    mat3x4: [
        3,
        4,
        12
    ],
    mat3x4f: [
        3,
        4,
        12
    ],
    mat3x4h: [
        3,
        4,
        12
    ],
    mat4x2: [
        4,
        2,
        8
    ],
    mat4x2f: [
        4,
        2,
        8
    ],
    mat4x2h: [
        4,
        2,
        8
    ],
    mat4x3: [
        4,
        3,
        12
    ],
    mat4x3f: [
        4,
        3,
        12
    ],
    mat4x3h: [
        4,
        3,
        12
    ],
    mat4x4: [
        4,
        4,
        16
    ],
    mat4x4f: [
        4,
        4,
        16
    ],
    mat4x4h: [
        4,
        4,
        16
    ]
};
class pt extends ct {
    constructor(e, t){
        var n;
        super(), this.ast = null != e ? e : [], this.reflection = new rt, this.reflection.updateAST(this.ast), this.context = null !== (n = null == t ? void 0 : t.clone()) && void 0 !== n ? n : new lt, this.builtins = new ut(this), this.typeInfo = {
            bool: this.getTypeInfo(re.bool),
            i32: this.getTypeInfo(re.i32),
            u32: this.getTypeInfo(re.u32),
            f32: this.getTypeInfo(re.f32),
            f16: this.getTypeInfo(re.f16),
            vec2f: this.getTypeInfo(oe.vec2f),
            vec2u: this.getTypeInfo(oe.vec2u),
            vec2i: this.getTypeInfo(oe.vec2i),
            vec2h: this.getTypeInfo(oe.vec2h),
            vec3f: this.getTypeInfo(oe.vec3f),
            vec3u: this.getTypeInfo(oe.vec3u),
            vec3i: this.getTypeInfo(oe.vec3i),
            vec3h: this.getTypeInfo(oe.vec3h),
            vec4f: this.getTypeInfo(oe.vec4f),
            vec4u: this.getTypeInfo(oe.vec4u),
            vec4i: this.getTypeInfo(oe.vec4i),
            vec4h: this.getTypeInfo(oe.vec4h),
            mat2x2f: this.getTypeInfo(oe.mat2x2f),
            mat2x3f: this.getTypeInfo(oe.mat2x3f),
            mat2x4f: this.getTypeInfo(oe.mat2x4f),
            mat3x2f: this.getTypeInfo(oe.mat3x2f),
            mat3x3f: this.getTypeInfo(oe.mat3x3f),
            mat3x4f: this.getTypeInfo(oe.mat3x4f),
            mat4x2f: this.getTypeInfo(oe.mat4x2f),
            mat4x3f: this.getTypeInfo(oe.mat4x3f),
            mat4x4f: this.getTypeInfo(oe.mat4x4f)
        };
    }
    getVariableValue(e) {
        var t, n;
        const r = null !== (n = null === (t = this.context.getVariable(e)) || void 0 === t ? void 0 : t.value) && void 0 !== n ? n : null;
        if (null === r) return null;
        if (r instanceof Oe) return r.value;
        if (r instanceof Fe) return Array.from(r.data);
        if (r instanceof Me) return Array.from(r.data);
        if (r instanceof Ue && r.typeInfo instanceof s) {
            if ('u32' === r.typeInfo.format.name) return Array.from(new Uint32Array(r.buffer, r.offset, r.typeInfo.count));
            if ('i32' === r.typeInfo.format.name) return Array.from(new Int32Array(r.buffer, r.offset, r.typeInfo.count));
            if ('f32' === r.typeInfo.format.name) return Array.from(new Float32Array(r.buffer, r.offset, r.typeInfo.count));
        }
        return console.error(`Unsupported return variable type ${r.typeInfo.name}`), null;
    }
    execute(e) {
        (e = null != e ? e : {}).constants && this._setOverrides(e.constants, this.context), this._execStatements(this.ast, this.context);
    }
    dispatchWorkgroups(e, t, n, s) {
        const r = this.context.clone();
        (s = null != s ? s : {}).constants && this._setOverrides(s.constants, r), this._execStatements(this.ast, r);
        const a = r.getFunction(e);
        if (!a) return void console.error(`Function ${e} not found`);
        if ('number' == typeof t) t = [
            t,
            1,
            1
        ];
        else {
            if (0 === t.length) return void console.error('Invalid dispatch count');
            1 === t.length ? t = [
                t[0],
                1,
                1
            ] : 2 === t.length ? t = [
                t[0],
                t[1],
                1
            ] : t.length > 3 && (t = [
                t[0],
                t[1],
                t[2]
            ]);
        }
        const i = t[0], o = t[1], l = t[2], c = this.getTypeInfo('vec3u');
        r.setVariable('@num_workgroups', new Fe(t, c));
        for(const e in n)for(const t in n[e]){
            const s = n[e][t];
            r.variables.forEach((n)=>{
                var r;
                const a = n.node;
                if (null == a ? void 0 : a.attributes) {
                    let i = null, o = null;
                    for (const e of a.attributes)'binding' === e.name ? i = e.value : 'group' === e.name && (o = e.value);
                    if (t == i && e == o) {
                        if (void 0 !== s.texture && void 0 !== s.descriptor) {
                            const e = new Pe(s.texture, this.getTypeInfo(a.type), s.descriptor, null !== (r = s.texture.view) && void 0 !== r ? r : null);
                            n.value = e;
                        } else void 0 !== s.uniform ? n.value = new Ue(s.uniform, this.getTypeInfo(a.type)) : n.value = new Ue(s, this.getTypeInfo(a.type));
                    }
                }
            });
        }
        for(let e = 0; e < l; ++e)for(let t = 0; t < o; ++t)for(let n = 0; n < i; ++n)r.setVariable('@workgroup_id', new Fe([
            n,
            t,
            e
        ], this.getTypeInfo('vec3u'))), this._dispatchWorkgroup(a, [
            n,
            t,
            e
        ], r);
    }
    execStatement(e, t) {
        if (e instanceof Q) return this.evalExpression(e.value, t);
        if (e instanceof ne) {
            if (e.condition) {
                const n = this.evalExpression(e.condition, t);
                if (!(n instanceof Oe)) throw new Error('Invalid break-if condition');
                if (!n.value) return null;
            }
            return pt._breakObj;
        }
        if (e instanceof se) return pt._continueObj;
        if (e instanceof M) this._let(e, t);
        else if (e instanceof B) this._var(e, t);
        else if (e instanceof U) this._const(e, t);
        else if (e instanceof C) this._function(e, t);
        else {
            if (e instanceof Z) return this._if(e, t);
            if (e instanceof j) return this._switch(e, t);
            if (e instanceof O) return this._for(e, t);
            if (e instanceof N) return this._while(e, t);
            if (e instanceof X) return this._loop(e, t);
            if (e instanceof V) {
                const n = t.clone();
                return n.currentFunctionName = t.currentFunctionName, this._execStatements(e.body, n);
            }
            if (e instanceof R) this._assign(e, t);
            else if (e instanceof z) this._increment(e, t);
            else {
                if (e instanceof ie) return null;
                if (e instanceof F) {
                    const n = e.name;
                    null === t.getVariable(n) && t.setVariable(n, new Oe(0, this.getTypeInfo('u32')));
                } else if (e instanceof G) this._call(e, t);
                else {
                    if (e instanceof J) return null;
                    if (e instanceof ee) return null;
                    console.error('Invalid statement type.', e, `Line ${e.line}`);
                }
            }
        }
        return null;
    }
    evalExpression(e, t) {
        return e instanceof ke ? this._evalBinaryOp(e, t) : e instanceof ge ? this._evalLiteral(e, t) : e instanceof me ? this._evalVariable(e, t) : e instanceof de ? this._evalCall(e, t) : e instanceof pe ? this._evalCreate(e, t) : e instanceof _e ? this._evalConst(e, t) : e instanceof xe ? this._evalBitcast(e, t) : e instanceof we ? this._evalUnaryOp(e, t) : (console.error('Invalid expression type', e, `Line ${e.line}`), null);
    }
    getTypeInfo(e) {
        var t;
        if (e instanceof re) {
            const t = this.reflection.getTypeInfo(e);
            if (null !== t) return t;
        }
        let n = null !== (t = this.typeInfo[e]) && void 0 !== t ? t : null;
        return null !== n || (n = this.reflection.getTypeInfoByName(e)), n;
    }
    _setOverrides(e, t) {
        for(const n in e){
            const s = e[n], r = this.reflection.getOverrideInfo(n);
            null !== r ? (null === r.type && (r.type = this.getTypeInfo('u32')), 'u32' === r.type.name || 'i32' === r.type.name || 'f32' === r.type.name || 'f16' === r.type.name ? t.setVariable(n, new Oe(s, r.type)) : 'bool' === r.type.name ? t.setVariable(n, new Oe(s ? 1 : 0, r.type)) : 'vec2' === r.type.name || 'vec3' === r.type.name || 'vec4' === r.type.name || 'vec2f' === r.type.name || 'vec3f' === r.type.name || 'vec4f' === r.type.name || 'vec2i' === r.type.name || 'vec3i' === r.type.name || 'vec4i' === r.type.name || 'vec2u' === r.type.name || 'vec3u' === r.type.name || 'vec4u' === r.type.name || 'vec2h' === r.type.name || 'vec3h' === r.type.name || 'vec4h' === r.type.name ? t.setVariable(n, new Fe(s, r.type)) : console.error(`Invalid constant type for ${n}`)) : console.error(`Override ${n} does not exist in the shader.`);
        }
    }
    _dispatchWorkgroup(e, t, n) {
        const s = [
            1,
            1,
            1
        ];
        for (const t of e.node.attributes)if ('workgroup_size' === t.name) {
            if (t.value.length > 0) {
                const e = n.getVariableValue(t.value[0]);
                s[0] = e instanceof Oe ? e.value : parseInt(t.value[0]);
            }
            if (t.value.length > 1) {
                const e = n.getVariableValue(t.value[1]);
                s[1] = e instanceof Oe ? e.value : parseInt(t.value[1]);
            }
            if (t.value.length > 2) {
                const e = n.getVariableValue(t.value[2]);
                s[2] = e instanceof Oe ? e.value : parseInt(t.value[2]);
            }
        }
        const r = this.getTypeInfo('vec3u'), a = this.getTypeInfo('u32');
        n.setVariable('@workgroup_size', new Fe(s, r));
        const i = s[0], o = s[1], l = s[2];
        for(let c = 0, u = 0; c < l; ++c)for(let l = 0; l < o; ++l)for(let o = 0; o < i; ++o, ++u){
            const i = [
                o,
                l,
                c
            ], h = [
                o + t[0] * s[0],
                l + t[1] * s[1],
                c + t[2] * s[2]
            ];
            n.setVariable('@local_invocation_id', new Fe(i, r)), n.setVariable('@global_invocation_id', new Fe(h, r)), n.setVariable('@local_invocation_index', new Oe(u, a)), this._dispatchExec(e, n);
        }
    }
    _dispatchExec(e, t) {
        for (const n of e.node.args)for (const e of n.attributes)if ('builtin' === e.name) {
            const s = `@${e.value}`, r = t.getVariable(s);
            void 0 !== r && t.variables.set(n.name, r);
        }
        this._execStatements(e.node.body, t);
    }
    getVariableName(e, t) {
        for(; e instanceof we;)e = e.right;
        return e instanceof me ? e.name : (console.error('Unknown variable type', e, 'Line', e.line), null);
    }
    _execStatements(e, t) {
        for (const n of e){
            if (n instanceof Array) {
                const e = t.clone(), s = this._execStatements(n, e);
                if (s) return s;
                continue;
            }
            const e = this.execStatement(n, t);
            if (e) return e;
        }
        return null;
    }
    _call(e, t) {
        const n = t.clone();
        n.currentFunctionName = e.name;
        const s = t.getFunction(e.name);
        if (s) {
            for(let t = 0; t < s.node.args.length; ++t){
                const r = s.node.args[t], a = this.evalExpression(e.args[t], n);
                n.setVariable(r.name, a, r);
            }
            this._execStatements(s.node.body, n);
        } else if (e.isBuiltin) this._callBuiltinFunction(e, n);
        else this.getTypeInfo(e.name) && this._evalCreate(e, t);
    }
    _increment(e, t) {
        const n = this.getVariableName(e.variable, t), s = t.getVariable(n);
        s ? '++' === e.operator ? s.value instanceof Oe ? s.value.value++ : console.error(`Variable ${n} is not a scalar. Line ${e.line}`) : '--' === e.operator ? s.value instanceof Oe ? s.value.value-- : console.error(`Variable ${n} is not a scalar. Line ${e.line}`) : console.error(`Unknown increment operator ${e.operator}. Line ${e.line}`) : console.error(`Variable ${n} not found. Line ${e.line}`);
    }
    _getVariableData(e, t) {
        if (e instanceof me) {
            const n = this.getVariableName(e, t), s = t.getVariable(n);
            return null === s ? (console.error(`Variable ${n} not found. Line ${e.line}`), null) : s.value.getSubData(this, e.postfix, t);
        }
        if (e instanceof we) {
            if ('*' === e.operator) {
                const n = this._getVariableData(e.right, t);
                return n instanceof Ve ? n.reference.getSubData(this, e.postfix, t) : (console.error(`Variable ${e.right} is not a pointer. Line ${e.line}`), null);
            }
            if ('&' === e.operator) {
                const n = this._getVariableData(e.right, t);
                return new Ve(n);
            }
        }
        return null;
    }
    _assign(e, t) {
        let n = null, s = '<var>', r = null;
        if (e.variable instanceof we) {
            const n = this._getVariableData(e.variable, t), s = this.evalExpression(e.value, t), r = e.operator;
            if ('=' === r) {
                if (n instanceof Oe || n instanceof Fe || n instanceof Me) {
                    if (s instanceof Oe || s instanceof Fe || s instanceof Me && n.data.length === s.data.length) return void n.data.set(s.data);
                    console.error(`Invalid assignment. Line ${e.line}`);
                } else if (n instanceof Ue && s instanceof Ue && n.buffer.byteLength - n.offset >= s.buffer.byteLength - s.offset) return void (n.buffer.byteLength % 4 == 0 ? new Uint32Array(n.buffer, n.offset, n.typeInfo.size / 4).set(new Uint32Array(s.buffer, s.offset, s.typeInfo.size / 4)) : new Uint8Array(n.buffer, n.offset, n.typeInfo.size).set(new Uint8Array(s.buffer, s.offset, s.typeInfo.size)));
                return console.error(`Invalid assignment. Line ${e.line}`), null;
            }
            if ('+=' === r) return n instanceof Oe || n instanceof Fe || n instanceof Me ? s instanceof Oe || s instanceof Fe || s instanceof Me ? void n.data.set(s.data.map((e, t)=>n.data[t] + e)) : void console.error(`Invalid assignment . Line ${e.line}`) : void console.error(`Invalid assignment. Line ${e.line}`);
            if ('-=' === r) return (n instanceof Oe || n instanceof Fe || n instanceof Me) && (s instanceof Oe || s instanceof Fe || s instanceof Me) ? void n.data.set(s.data.map((e, t)=>n.data[t] - e)) : void console.error(`Invalid assignment. Line ${e.line}`);
        }
        if (e.variable instanceof we) {
            if ('*' === e.variable.operator) {
                s = this.getVariableName(e.variable.right, t);
                const r = t.getVariable(s);
                if (!(r && r.value instanceof Ve)) return void console.error(`Variable ${s} is not a pointer. Line ${e.line}`);
                n = r.value.reference;
                let a = e.variable.postfix;
                if (!a) {
                    let t = e.variable.right;
                    for(; t instanceof we;){
                        if (t.postfix) {
                            a = t.postfix;
                            break;
                        }
                        t = t.right;
                    }
                }
                a && (n = n.getSubData(this, a, t));
            }
        } else {
            r = e.variable.postfix, s = this.getVariableName(e.variable, t);
            const a = t.getVariable(s);
            if (null === a) return void console.error(`Variable ${s} not found. Line ${e.line}`);
            n = a.value;
        }
        if (n instanceof Ve && (n = n.reference), null === n) return void console.error(`Variable ${s} not found. Line ${e.line}`);
        const a = this.evalExpression(e.value, t), i = e.operator;
        if ('=' === i) {
            if (n instanceof Ue) n.setDataValue(this, a, r, t);
            else if (r) {
                if (!(n instanceof Fe || n instanceof Me)) return void console.error(`Variable ${s} is not a vector or matrix. Line ${e.line}`);
                if (r instanceof be) {
                    const i = this.evalExpression(r.index, t).value;
                    if (n instanceof Fe) {
                        if (!(a instanceof Oe)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                        n.data[i] = a.value;
                    } else {
                        if (!(n instanceof Me)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                        {
                            const i = this.evalExpression(r.index, t).value;
                            if (i < 0) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                            if (!(a instanceof Fe)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                            {
                                const t = n.typeInfo.getTypeName();
                                if ('mat2x2' === t || 'mat2x2f' === t || 'mat2x2h' === t) {
                                    if (!(i < 2 && 2 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[2 * i] = a.data[0], n.data[2 * i + 1] = a.data[1];
                                } else if ('mat2x3' === t || 'mat2x3f' === t || 'mat2x3h' === t) {
                                    if (!(i < 2 && 3 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[3 * i] = a.data[0], n.data[3 * i + 1] = a.data[1], n.data[3 * i + 2] = a.data[2];
                                } else if ('mat2x4' === t || 'mat2x4f' === t || 'mat2x4h' === t) {
                                    if (!(i < 2 && 4 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[4 * i] = a.data[0], n.data[4 * i + 1] = a.data[1], n.data[4 * i + 2] = a.data[2], n.data[4 * i + 3] = a.data[3];
                                } else if ('mat3x2' === t || 'mat3x2f' === t || 'mat3x2h' === t) {
                                    if (!(i < 3 && 2 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[2 * i] = a.data[0], n.data[2 * i + 1] = a.data[1];
                                } else if ('mat3x3' === t || 'mat3x3f' === t || 'mat3x3h' === t) {
                                    if (!(i < 3 && 3 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[3 * i] = a.data[0], n.data[3 * i + 1] = a.data[1], n.data[3 * i + 2] = a.data[2];
                                } else if ('mat3x4' === t || 'mat3x4f' === t || 'mat3x4h' === t) {
                                    if (!(i < 3 && 4 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[4 * i] = a.data[0], n.data[4 * i + 1] = a.data[1], n.data[4 * i + 2] = a.data[2], n.data[4 * i + 3] = a.data[3];
                                } else if ('mat4x2' === t || 'mat4x2f' === t || 'mat4x2h' === t) {
                                    if (!(i < 4 && 2 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[2 * i] = a.data[0], n.data[2 * i + 1] = a.data[1];
                                } else if ('mat4x3' === t || 'mat4x3f' === t || 'mat4x3h' === t) {
                                    if (!(i < 4 && 3 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[3 * i] = a.data[0], n.data[3 * i + 1] = a.data[1], n.data[3 * i + 2] = a.data[2];
                                } else {
                                    if ('mat4x4' !== t && 'mat4x4f' !== t && 'mat4x4h' !== t) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    if (!(i < 4 && 4 === a.data.length)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                                    n.data[4 * i] = a.data[0], n.data[4 * i + 1] = a.data[1], n.data[4 * i + 2] = a.data[2], n.data[4 * i + 3] = a.data[3];
                                }
                            }
                        }
                    }
                } else if (r instanceof fe) {
                    const t = r.value;
                    if (!(n instanceof Fe)) return void console.error(`Invalid assignment to ${t}. Variable ${s} is not a vector. Line ${e.line}`);
                    if (a instanceof Oe) {
                        if (t.length > 1) return void console.error(`Invalid assignment to ${t} for variable ${s}. Line ${e.line}`);
                        if ('x' === t) n.data[0] = a.value;
                        else if ('y' === t) {
                            if (n.data.length < 2) return void console.error(`Invalid assignment to ${t} for variable ${s}. Line ${e.line}`);
                            n.data[1] = a.value;
                        } else if ('z' === t) {
                            if (n.data.length < 3) return void console.error(`Invalid assignment to ${t} for variable ${s}. Line ${e.line}`);
                            n.data[2] = a.value;
                        } else if ('w' === t) {
                            if (n.data.length < 4) return void console.error(`Invalid assignment to ${t} for variable ${s}. Line ${e.line}`);
                            n.data[3] = a.value;
                        }
                    } else {
                        if (!(a instanceof Fe)) return void console.error(`Invalid assignment to ${s}. Line ${e.line}`);
                        if (t.length !== a.data.length) return void console.error(`Invalid assignment to ${t} for variable ${s}. Line ${e.line}`);
                        for(let r = 0; r < t.length; ++r){
                            const i = t[r];
                            if ('x' === i || 'r' === i) n.data[0] = a.data[r];
                            else if ('y' === i || 'g' === i) {
                                if (a.data.length < 2) return void console.error(`Invalid assignment to ${i} for variable ${s}. Line ${e.line}`);
                                n.data[1] = a.data[r];
                            } else if ('z' === i || 'b' === i) {
                                if (a.data.length < 3) return void console.error(`Invalid assignment to ${i} for variable ${s}. Line ${e.line}`);
                                n.data[2] = a.data[r];
                            } else {
                                if ('w' !== i && 'a' !== i) return void console.error(`Invalid assignment to ${i} for variable ${s}. Line ${e.line}`);
                                if (a.data.length < 4) return void console.error(`Invalid assignment to ${i} for variable ${s}. Line ${e.line}`);
                                n.data[3] = a.data[r];
                            }
                        }
                    }
                }
            } else n instanceof Oe && a instanceof Oe ? n.value = a.value : n instanceof Fe && a instanceof Fe || n instanceof Me && a instanceof Me ? n.data.set(a.data) : console.error(`Invalid assignment to ${s}. Line ${e.line}`);
        } else {
            const s = n.getSubData(this, r, t);
            if (s instanceof Fe && a instanceof Oe) {
                const t = s.data, n = a.value;
                if ('+=' === i) for(let e = 0; e < t.length; ++e)t[e] += n;
                else if ('-=' === i) for(let e = 0; e < t.length; ++e)t[e] -= n;
                else if ('*=' === i) for(let e = 0; e < t.length; ++e)t[e] *= n;
                else if ('/=' === i) for(let e = 0; e < t.length; ++e)t[e] /= n;
                else if ('%=' === i) for(let e = 0; e < t.length; ++e)t[e] %= n;
                else if ('&=' === i) for(let e = 0; e < t.length; ++e)t[e] &= n;
                else if ('|=' === i) for(let e = 0; e < t.length; ++e)t[e] |= n;
                else if ('^=' === i) for(let e = 0; e < t.length; ++e)t[e] ^= n;
                else if ('<<=' === i) for(let e = 0; e < t.length; ++e)t[e] <<= n;
                else if ('>>=' === i) for(let e = 0; e < t.length; ++e)t[e] >>= n;
                else console.error(`Invalid operator ${i}. Line ${e.line}`);
            } else if (s instanceof Fe && a instanceof Fe) {
                const t = s.data, n = a.data;
                if (t.length !== n.length) return void console.error(`Vector length mismatch. Line ${e.line}`);
                if ('+=' === i) for(let e = 0; e < t.length; ++e)t[e] += n[e];
                else if ('-=' === i) for(let e = 0; e < t.length; ++e)t[e] -= n[e];
                else if ('*=' === i) for(let e = 0; e < t.length; ++e)t[e] *= n[e];
                else if ('/=' === i) for(let e = 0; e < t.length; ++e)t[e] /= n[e];
                else if ('%=' === i) for(let e = 0; e < t.length; ++e)t[e] %= n[e];
                else if ('&=' === i) for(let e = 0; e < t.length; ++e)t[e] &= n[e];
                else if ('|=' === i) for(let e = 0; e < t.length; ++e)t[e] |= n[e];
                else if ('^=' === i) for(let e = 0; e < t.length; ++e)t[e] ^= n[e];
                else if ('<<=' === i) for(let e = 0; e < t.length; ++e)t[e] <<= n[e];
                else if ('>>=' === i) for(let e = 0; e < t.length; ++e)t[e] >>= n[e];
                else console.error(`Invalid operator ${i}. Line ${e.line}`);
            } else {
                if (!(s instanceof Oe && a instanceof Oe)) return void console.error(`Invalid type for ${e.operator} operator. Line ${e.line}`);
                '+=' === i ? s.value += a.value : '-=' === i ? s.value -= a.value : '*=' === i ? s.value *= a.value : '/=' === i ? s.value /= a.value : '%=' === i ? s.value %= a.value : '&=' === i ? s.value &= a.value : '|=' === i ? s.value |= a.value : '^=' === i ? s.value ^= a.value : '<<=' === i ? s.value <<= a.value : '>>=' === i ? s.value >>= a.value : console.error(`Invalid operator ${i}. Line ${e.line}`);
            }
            n instanceof Ue && n.setDataValue(this, s, r, t);
        }
    }
    _function(e, t) {
        const n = new ot(e);
        t.functions.set(e.name, n);
    }
    _const(e, t) {
        let n = null;
        null !== e.value && (n = this.evalExpression(e.value, t)), t.createVariable(e.name, n, e);
    }
    _let(e, t) {
        let n = null;
        if (null !== e.value) {
            if (n = this.evalExpression(e.value, t), null === n) return void console.error(`Invalid value for variable ${e.name}. Line ${e.line}`);
            e.value instanceof we || (n = n.clone());
        } else {
            const s = e.type.name;
            if ('f32' === s || 'i32' === s || 'u32' === s || 'bool' === s || 'f16' === s || 'vec2' === s || 'vec3' === s || 'vec4' === s || 'vec2f' === s || 'vec3f' === s || 'vec4f' === s || 'vec2i' === s || 'vec3i' === s || 'vec4i' === s || 'vec2u' === s || 'vec3u' === s || 'vec4u' === s || 'vec2h' === s || 'vec3h' === s || 'vec4h' === s || 'vec2b' === s || 'vec3b' === s || 'vec4b' === s || 'mat2x2' === s || 'mat2x3' === s || 'mat2x4' === s || 'mat3x2' === s || 'mat3x3' === s || 'mat3x4' === s || 'mat4x2' === s || 'mat4x3' === s || 'mat4x4' === s || 'mat2x2f' === s || 'mat2x3f' === s || 'mat2x4f' === s || 'mat3x2f' === s || 'mat3x3f' === s || 'mat3x4f' === s || 'mat4x2f' === s || 'mat4x3f' === s || 'mat4x4f' === s || 'mat2x2h' === s || 'mat2x3h' === s || 'mat2x4h' === s || 'mat3x2h' === s || 'mat3x3h' === s || 'mat3x4h' === s || 'mat4x2h' === s || 'mat4x3h' === s || 'mat4x4h' === s || 'array' === s) {
                const s = new pe(e.type, []);
                n = this._evalCreate(s, t);
            }
        }
        t.createVariable(e.name, n, e);
    }
    _var(e, t) {
        let n = null;
        if (null !== e.value) {
            if (n = this.evalExpression(e.value, t), null === n) return void console.error(`Invalid value for variable ${e.name}. Line ${e.line}`);
            e.value instanceof we || (n = n.clone());
        } else {
            if (null === e.type) return void console.error(`Variable ${e.name} has no type. Line ${e.line}`);
            const s = e.type.name;
            if ('f32' === s || 'i32' === s || 'u32' === s || 'bool' === s || 'f16' === s || 'vec2' === s || 'vec3' === s || 'vec4' === s || 'vec2f' === s || 'vec3f' === s || 'vec4f' === s || 'vec2i' === s || 'vec3i' === s || 'vec4i' === s || 'vec2u' === s || 'vec3u' === s || 'vec4u' === s || 'vec2h' === s || 'vec3h' === s || 'vec4h' === s || 'vec2b' === s || 'vec3b' === s || 'vec4b' === s || 'mat2x2' === s || 'mat2x3' === s || 'mat2x4' === s || 'mat3x2' === s || 'mat3x3' === s || 'mat3x4' === s || 'mat4x2' === s || 'mat4x3' === s || 'mat4x4' === s || 'mat2x2f' === s || 'mat2x3f' === s || 'mat2x4f' === s || 'mat3x2f' === s || 'mat3x3f' === s || 'mat3x4f' === s || 'mat4x2f' === s || 'mat4x3f' === s || 'mat4x4f' === s || 'mat2x2h' === s || 'mat2x3h' === s || 'mat2x4h' === s || 'mat3x2h' === s || 'mat3x3h' === s || 'mat3x4h' === s || 'mat4x2h' === s || 'mat4x3h' === s || 'mat4x4h' === s || e.type instanceof ce || e.type instanceof ie || e.type instanceof oe) {
                const s = new pe(e.type, []);
                n = this._evalCreate(s, t);
            }
        }
        t.createVariable(e.name, n, e);
    }
    _switch(e, t) {
        t = t.clone();
        const n = this.evalExpression(e.condition, t);
        if (!(n instanceof Oe)) return console.error(`Invalid if condition. Line ${e.line}`), null;
        let s = null;
        for (const r of e.cases)if (r instanceof Se) for (const a of r.selectors){
            if (a instanceof Te) {
                s = r;
                continue;
            }
            const i = this.evalExpression(a, t);
            if (!(i instanceof Oe)) return console.error(`Invalid case selector. Line ${e.line}`), null;
            if (i.value === n.value) return this._execStatements(r.body, t);
        }
        else r instanceof Ae && (s = r);
        return s ? this._execStatements(s.body, t) : null;
    }
    _if(e, t) {
        t = t.clone();
        const n = this.evalExpression(e.condition, t);
        if (!(n instanceof Oe)) return console.error(`Invalid if condition. Line ${e.line}`), null;
        if (n.value) return this._execStatements(e.body, t);
        for (const n of e.elseif){
            const s = this.evalExpression(n.condition, t);
            if (!(s instanceof Oe)) return console.error(`Invalid if condition. Line ${e.line}`), null;
            if (s.value) return this._execStatements(n.body, t);
        }
        return e.else ? this._execStatements(e.else, t) : null;
    }
    _getScalarValue(e) {
        return e instanceof Oe ? e.value : (console.error('Expected scalar value.', e), 0);
    }
    _for(e, t) {
        for(t = t.clone(), this.execStatement(e.init, t); this._getScalarValue(this.evalExpression(e.condition, t));){
            const n = this._execStatements(e.body, t);
            if (n === pt._breakObj) break;
            if (null !== n && n !== pt._continueObj) return n;
            this.execStatement(e.increment, t);
        }
        return null;
    }
    _loop(e, t) {
        for(t = t.clone();;){
            const n = this._execStatements(e.body, t);
            if (n === pt._breakObj) break;
            if (n === pt._continueObj) {
                if (e.continuing) {
                    if (this._execStatements(e.continuing.body, t) === pt._breakObj) break;
                }
            } else if (null !== n) return n;
        }
        return null;
    }
    _while(e, t) {
        for(t = t.clone(); this._getScalarValue(this.evalExpression(e.condition, t));){
            const n = this._execStatements(e.body, t);
            if (n === pt._breakObj) break;
            if (n !== pt._continueObj && null !== n) return n;
        }
        return null;
    }
    _evalBitcast(e, t) {
        const n = this.evalExpression(e.value, t), s = e.type;
        if (n instanceof Oe) {
            const e = tt(n.value, n.typeInfo.name, s.name);
            return new Oe(e, this.getTypeInfo(s));
        }
        if (n instanceof Fe) {
            const t = n.typeInfo.getTypeName();
            let r = '';
            if (t.endsWith('f')) r = 'f32';
            else if (t.endsWith('i')) r = 'i32';
            else if (t.endsWith('u')) r = 'u32';
            else if (t.endsWith('b')) r = 'bool';
            else {
                if (!t.endsWith('h')) return console.error(`Unknown vector type ${t}. Line ${e.line}`), null;
                r = 'f16';
            }
            const a = s.getTypeName();
            let i = '';
            if (a.endsWith('f')) i = 'f32';
            else if (a.endsWith('i')) i = 'i32';
            else if (a.endsWith('u')) i = 'u32';
            else if (a.endsWith('b')) i = 'bool';
            else {
                if (!a.endsWith('h')) return console.error(`Unknown vector type ${i}. Line ${e.line}`), null;
                i = 'f16';
            }
            const o = function(e, t, n) {
                if (t === n) return e;
                const s = new Array(e.length);
                for(let r = 0; r < e.length; r++)s[r] = tt(e[r], t, n);
                return s;
            }(Array.from(n.data), r, i);
            return new Fe(o, this.getTypeInfo(s));
        }
        return console.error(`TODO: bitcast for ${n.typeInfo.name}. Line ${e.line}`), null;
    }
    _evalConst(e, t) {
        return t.getVariableValue(e.name).clone().getSubData(this, e.postfix, t);
    }
    _evalCreate(e, t) {
        var r;
        if (e instanceof pe) {
            if (null === e.type) return Ne.void;
            switch(e.type.getTypeName()){
                case 'bool':
                case 'i32':
                case 'u32':
                case 'f32':
                case 'f16':
                    return this._callConstructorValue(e, t);
                case 'vec2':
                case 'vec3':
                case 'vec4':
                case 'vec2f':
                case 'vec3f':
                case 'vec4f':
                case 'vec2h':
                case 'vec3h':
                case 'vec4h':
                case 'vec2i':
                case 'vec3i':
                case 'vec4i':
                case 'vec2u':
                case 'vec3u':
                case 'vec4u':
                case 'vec2b':
                case 'vec3b':
                case 'vec4b':
                    return this._callConstructorVec(e, t);
                case 'mat2x2':
                case 'mat2x2f':
                case 'mat2x2h':
                case 'mat2x3':
                case 'mat2x3f':
                case 'mat2x3h':
                case 'mat2x4':
                case 'mat2x4f':
                case 'mat2x4h':
                case 'mat3x2':
                case 'mat3x2f':
                case 'mat3x2h':
                case 'mat3x3':
                case 'mat3x3f':
                case 'mat3x3h':
                case 'mat3x4':
                case 'mat3x4f':
                case 'mat3x4h':
                case 'mat4x2':
                case 'mat4x2f':
                case 'mat4x2h':
                case 'mat4x3':
                case 'mat4x3f':
                case 'mat4x3h':
                case 'mat4x4':
                case 'mat4x4f':
                case 'mat4x4h':
                    return this._callConstructorMatrix(e, t);
            }
        }
        const a = e instanceof pe ? e.type.name : e.name, i = e instanceof pe ? this.getTypeInfo(e.type) : this.getTypeInfo(e.name);
        if (null === i) return console.error(`Unknown type ${a}. Line ${e.line}`), null;
        if (0 === i.size) return null;
        const o = new Ue(new ArrayBuffer(i.size), i, 0);
        if (i instanceof n) {
            if (e.args) for(let n = 0; n < e.args.length; ++n){
                const s = i.members[n], r = e.args[n], a = this.evalExpression(r, t);
                o.setData(this, a, s.type, s.offset, t);
            }
        } else if (i instanceof s) {
            let n = 0;
            if (e.args) for(let s = 0; s < e.args.length; ++s){
                const a = e.args[s], l = this.evalExpression(a, t);
                null === i.format && ('x32' === (null === (r = l.typeInfo) || void 0 === r ? void 0 : r.name) ? i.format = this.getTypeInfo('i32') : i.format = l.typeInfo), o.setData(this, l, i.format, n, t), n += i.stride;
            }
        } else console.error(`Unknown type "${a}". Line ${e.line}`);
        return e instanceof pe ? o.getSubData(this, e.postfix, t) : o;
    }
    _evalLiteral(e, t) {
        const n = this.getTypeInfo(e.type), s = n.name;
        if ('x32' === s || 'u32' === s || 'f32' === s || 'f16' === s || 'i32' === s || 'bool' === s) return new Oe(e.scalarValue, n);
        return 'vec2' === s || 'vec3' === s || 'vec4' === s || 'vec2f' === s || 'vec3f' === s || 'vec4f' === s || 'vec2h' === s || 'vec3h' === s || 'vec4h' === s || 'vec2i' === s || 'vec3i' === s || 'vec4i' === s || 'vec2u' === s || 'vec3u' === s || 'vec4u' === s ? this._callConstructorVec(e, t) : 'mat2x2' === s || 'mat2x3' === s || 'mat2x4' === s || 'mat3x2' === s || 'mat3x3' === s || 'mat3x4' === s || 'mat4x2' === s || 'mat4x3' === s || 'mat4x4' === s || 'mat2x2f' === s || 'mat2x3f' === s || 'mat2x4f' === s || 'mat3x2f' === s || 'mat3x3f' === s || 'mat3x4f' === s || 'mat4x2f' === s || 'mat4x3f' === s || 'mat4x4f' === s || 'mat2x2h' === s || 'mat2x3h' === s || 'mat2x4h' === s || 'mat3x2h' === s || 'mat3x3h' === s || 'mat3x4h' === s || 'mat4x2h' === s || 'mat4x3h' === s || 'mat4x4h' === s ? this._callConstructorMatrix(e, t) : e.value;
    }
    _evalVariable(e, t) {
        const n = t.getVariableValue(e.name);
        return null === n ? n : n.getSubData(this, e.postfix, t);
    }
    _maxFormatTypeInfo(e) {
        let t = e[0];
        if ('f32' === t.name) return t;
        for(let n = 1; n < e.length; ++n){
            const s = pt._priority.get(t.name);
            pt._priority.get(e[n].name) < s && (t = e[n]);
        }
        return 'x32' === t.name ? this.getTypeInfo('i32') : t;
    }
    _evalUnaryOp(e, t) {
        const n = this.evalExpression(e.right, t);
        if ('&' === e.operator) return new Ve(n);
        if ('*' === e.operator) return n instanceof Ve ? n.reference.getSubData(this, e.postfix, t) : (console.error(`Invalid dereference. Line ${e.line}`), null);
        const s = n instanceof Oe ? n.value : n instanceof Fe ? Array.from(n.data) : null;
        switch(e.operator){
            case '+':
                {
                    if (Re(s)) {
                        const e = s.map((e, t)=>+e);
                        return new Fe(e, n.typeInfo);
                    }
                    const e = s, t = this._maxFormatTypeInfo([
                        n.typeInfo,
                        n.typeInfo
                    ]);
                    return new Oe(+e, t);
                }
            case '-':
                {
                    if (Re(s)) {
                        const e = s.map((e, t)=>-e);
                        return new Fe(e, n.typeInfo);
                    }
                    const e = s, t = this._maxFormatTypeInfo([
                        n.typeInfo,
                        n.typeInfo
                    ]);
                    return new Oe(-e, t);
                }
            case '!':
                {
                    if (Re(s)) {
                        const e = s.map((e, t)=>e ? 0 : 1);
                        return new Fe(e, n.typeInfo);
                    }
                    const e = s, t = this._maxFormatTypeInfo([
                        n.typeInfo,
                        n.typeInfo
                    ]);
                    return new Oe(e ? 0 : 1, t);
                }
            case '~':
                {
                    if (Re(s)) {
                        const e = s.map((e, t)=>~e);
                        return new Fe(e, n.typeInfo);
                    }
                    const e = s, t = this._maxFormatTypeInfo([
                        n.typeInfo,
                        n.typeInfo
                    ]);
                    return new Oe(~e, t);
                }
        }
        return console.error(`Invalid unary operator ${e.operator}. Line ${e.line}`), null;
    }
    _evalBinaryOp(e, t) {
        const n = this.evalExpression(e.left, t), s = this.evalExpression(e.right, t), r = n instanceof Oe ? n.value : n instanceof Fe || n instanceof Me ? Array.from(n.data) : null, a = s instanceof Oe ? s.value : s instanceof Fe || s instanceof Me ? Array.from(s.data) : null;
        switch(e.operator){
            case '+':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e + s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t + e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e + t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t + i, o);
                }
            case '-':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e - s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t - e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e - t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t - i, o);
                }
            case '*':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, i = a;
                        if (n instanceof Me && s instanceof Me) {
                            const r = function(e, t, n, s) {
                                if (void 0 === ft[t.name] || void 0 === ft[s.name]) return null;
                                const r = ft[t.name][0], a = ft[t.name][1], i = ft[s.name][0];
                                if (r !== ft[s.name][1]) return null;
                                const o = new Array(i * a);
                                for(let t = 0; t < a; t++)for(let s = 0; s < i; s++){
                                    let l = 0;
                                    for(let i = 0; i < r; i++)l += e[i * a + t] * n[s * r + i];
                                    o[t * i + s] = l;
                                }
                                return o;
                            }(t, n.typeInfo, i, s.typeInfo);
                            if (null === r) return console.error(`Matrix multiplication failed. Line ${e.line}.`), null;
                            const a = ft[s.typeInfo.name][0], o = ft[n.typeInfo.name][1], l = this.getTypeInfo(`mat${a}x${o}f`);
                            return new Me(r, l);
                        }
                        if (n instanceof Me && s instanceof Fe) {
                            const r = function(e, t, n, s) {
                                if (void 0 === ft[t.name] || void 0 === ht[s.name]) return null;
                                const r = ft[t.name][0], a = ft[t.name][1];
                                if (r !== n.length) return null;
                                const i = new Array(a);
                                for(let t = 0; t < a; t++){
                                    let s = 0;
                                    for(let i = 0; i < r; i++)s += e[i * a + t] * n[i];
                                    i[t] = s;
                                }
                                return i;
                            }(t, n.typeInfo, i, s.typeInfo);
                            return null === r ? (console.error(`Matrix vector multiplication failed. Line ${e.line}.`), null) : new Fe(r, s.typeInfo);
                        }
                        if (n instanceof Fe && s instanceof Me) {
                            const r = function(e, t, n, s) {
                                if (void 0 === ht[t.name] || void 0 === ft[s.name]) return null;
                                const r = ft[s.name][0], a = ft[s.name][1];
                                if (a !== e.length) return null;
                                const i = [];
                                for(let t = 0; t < r; t++){
                                    let s = 0;
                                    for(let i = 0; i < a; i++)s += e[i] * n[i * r + t];
                                    i[t] = s;
                                }
                                return i;
                            }(t, n.typeInfo, i, s.typeInfo);
                            return null === r ? (console.error(`Matrix vector multiplication failed. Line ${e.line}.`), null) : new Fe(r, n.typeInfo);
                        }
                        {
                            if (t.length !== i.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                            const s = t.map((e, t)=>e * i[t]);
                            return new Fe(s, n.typeInfo);
                        }
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t * e);
                        return n instanceof Me ? new Me(t, n.typeInfo) : new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e * t);
                        return s instanceof Me ? new Me(t, s.typeInfo) : new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t * i, o);
                }
            case '%':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e % s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t % e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e % t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t % i, o);
                }
            case '/':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e / s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t / e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e / t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t / i, o);
                }
            case '&':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e & s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t & e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e & t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t & i, o);
                }
            case '|':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e | s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t | e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e | t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t | i, o);
                }
            case '^':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e ^ s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t ^ e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e ^ t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t ^ i, o);
                }
            case '<<':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e << s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t << e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e << t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t << i, o);
                }
            case '>>':
                {
                    if (Re(r) && Re(a)) {
                        const t = r, s = a;
                        if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                        const i = t.map((e, t)=>e >> s[t]);
                        return new Fe(i, n.typeInfo);
                    }
                    if (Re(r)) {
                        const e = a, t = r.map((t, n)=>t >> e);
                        return new Fe(t, n.typeInfo);
                    }
                    if (Re(a)) {
                        const e = r, t = a.map((t, n)=>e >> t);
                        return new Fe(t, s.typeInfo);
                    }
                    const t = r, i = a, o = this._maxFormatTypeInfo([
                        n.typeInfo,
                        s.typeInfo
                    ]);
                    return new Oe(t >> i, o);
                }
            case '>':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e > s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t > e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e > t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r > a ? 1 : 0, this.getTypeInfo('bool'));
            case '<':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e < s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t < e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e < t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r < a ? 1 : 0, this.getTypeInfo('bool'));
            case '==':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e === s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t == e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e == t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r === a ? 1 : 0, this.getTypeInfo('bool'));
            case '!=':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e !== s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t !== e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e !== t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r !== a ? 1 : 0, this.getTypeInfo('bool'));
            case '>=':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e >= s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t >= e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e >= t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r >= a ? 1 : 0, this.getTypeInfo('bool'));
            case '<=':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e <= s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t <= e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e <= t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r <= a ? 1 : 0, this.getTypeInfo('bool'));
            case '&&':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e && s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t && e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e && t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r && a ? 1 : 0, this.getTypeInfo('bool'));
            case '||':
                if (Re(r) && Re(a)) {
                    const t = r, s = a;
                    if (t.length !== s.length) return console.error(`Vector length mismatch. Line ${e.line}.`), null;
                    const i = t.map((e, t)=>e || s[t] ? 1 : 0);
                    return new Fe(i, n.typeInfo);
                }
                if (Re(r)) {
                    const e = a, t = r.map((t, n)=>t || e ? 1 : 0);
                    return new Fe(t, n.typeInfo);
                }
                if (Re(a)) {
                    const e = r, t = a.map((t, n)=>e || t ? 1 : 0);
                    return new Fe(t, s.typeInfo);
                }
                return new Oe(r || a ? 1 : 0, this.getTypeInfo('bool'));
        }
        return console.error(`Unknown operator ${e.operator}. Line ${e.line}`), null;
    }
    _evalCall(e, t) {
        if (null !== e.cachedReturnValue) return e.cachedReturnValue;
        const n = t.clone();
        n.currentFunctionName = e.name;
        const s = t.getFunction(e.name);
        if (!s) {
            if (e.isBuiltin) return this._callBuiltinFunction(e, n);
            return this.getTypeInfo(e.name) ? this._evalCreate(e, t) : (console.error(`Unknown function "${e.name}". Line ${e.line}`), null);
        }
        for(let t = 0; t < s.node.args.length; ++t){
            const r = s.node.args[t], a = this.evalExpression(e.args[t], n);
            n.createVariable(r.name, a, r);
        }
        return this._execStatements(s.node.body, n);
    }
    _callBuiltinFunction(e, t) {
        switch(e.name){
            case 'all':
                return this.builtins.All(e, t);
            case 'any':
                return this.builtins.Any(e, t);
            case 'select':
                return this.builtins.Select(e, t);
            case 'arrayLength':
                return this.builtins.ArrayLength(e, t);
            case 'abs':
                return this.builtins.Abs(e, t);
            case 'acos':
                return this.builtins.Acos(e, t);
            case 'acosh':
                return this.builtins.Acosh(e, t);
            case 'asin':
                return this.builtins.Asin(e, t);
            case 'asinh':
                return this.builtins.Asinh(e, t);
            case 'atan':
                return this.builtins.Atan(e, t);
            case 'atanh':
                return this.builtins.Atanh(e, t);
            case 'atan2':
                return this.builtins.Atan2(e, t);
            case 'ceil':
                return this.builtins.Ceil(e, t);
            case 'clamp':
                return this.builtins.Clamp(e, t);
            case 'cos':
                return this.builtins.Cos(e, t);
            case 'cosh':
                return this.builtins.Cosh(e, t);
            case 'countLeadingZeros':
                return this.builtins.CountLeadingZeros(e, t);
            case 'countOneBits':
                return this.builtins.CountOneBits(e, t);
            case 'countTrailingZeros':
                return this.builtins.CountTrailingZeros(e, t);
            case 'cross':
                return this.builtins.Cross(e, t);
            case 'degrees':
                return this.builtins.Degrees(e, t);
            case 'determinant':
                return this.builtins.Determinant(e, t);
            case 'distance':
                return this.builtins.Distance(e, t);
            case 'dot':
                return this.builtins.Dot(e, t);
            case 'dot4U8Packed':
                return this.builtins.Dot4U8Packed(e, t);
            case 'dot4I8Packed':
                return this.builtins.Dot4I8Packed(e, t);
            case 'exp':
                return this.builtins.Exp(e, t);
            case 'exp2':
                return this.builtins.Exp2(e, t);
            case 'extractBits':
                return this.builtins.ExtractBits(e, t);
            case 'faceForward':
                return this.builtins.FaceForward(e, t);
            case 'firstLeadingBit':
                return this.builtins.FirstLeadingBit(e, t);
            case 'firstTrailingBit':
                return this.builtins.FirstTrailingBit(e, t);
            case 'floor':
                return this.builtins.Floor(e, t);
            case 'fma':
                return this.builtins.Fma(e, t);
            case 'fract':
                return this.builtins.Fract(e, t);
            case 'frexp':
                return this.builtins.Frexp(e, t);
            case 'insertBits':
                return this.builtins.InsertBits(e, t);
            case 'inverseSqrt':
                return this.builtins.InverseSqrt(e, t);
            case 'ldexp':
                return this.builtins.Ldexp(e, t);
            case 'length':
                return this.builtins.Length(e, t);
            case 'log':
                return this.builtins.Log(e, t);
            case 'log2':
                return this.builtins.Log2(e, t);
            case 'max':
                return this.builtins.Max(e, t);
            case 'min':
                return this.builtins.Min(e, t);
            case 'mix':
                return this.builtins.Mix(e, t);
            case 'modf':
                return this.builtins.Modf(e, t);
            case 'normalize':
                return this.builtins.Normalize(e, t);
            case 'pow':
                return this.builtins.Pow(e, t);
            case 'quantizeToF16':
                return this.builtins.QuantizeToF16(e, t);
            case 'radians':
                return this.builtins.Radians(e, t);
            case 'reflect':
                return this.builtins.Reflect(e, t);
            case 'refract':
                return this.builtins.Refract(e, t);
            case 'reverseBits':
                return this.builtins.ReverseBits(e, t);
            case 'round':
                return this.builtins.Round(e, t);
            case 'saturate':
                return this.builtins.Saturate(e, t);
            case 'sign':
                return this.builtins.Sign(e, t);
            case 'sin':
                return this.builtins.Sin(e, t);
            case 'sinh':
                return this.builtins.Sinh(e, t);
            case 'smoothStep':
                return this.builtins.SmoothStep(e, t);
            case 'sqrt':
                return this.builtins.Sqrt(e, t);
            case 'step':
                return this.builtins.Step(e, t);
            case 'tan':
                return this.builtins.Tan(e, t);
            case 'tanh':
                return this.builtins.Tanh(e, t);
            case 'transpose':
                return this.builtins.Transpose(e, t);
            case 'trunc':
                return this.builtins.Trunc(e, t);
            case 'dpdx':
                return this.builtins.Dpdx(e, t);
            case 'dpdxCoarse':
                return this.builtins.DpdxCoarse(e, t);
            case 'dpdxFine':
                return this.builtins.DpdxFine(e, t);
            case 'dpdy':
                return this.builtins.Dpdy(e, t);
            case 'dpdyCoarse':
                return this.builtins.DpdyCoarse(e, t);
            case 'dpdyFine':
                return this.builtins.DpdyFine(e, t);
            case 'fwidth':
                return this.builtins.Fwidth(e, t);
            case 'fwidthCoarse':
                return this.builtins.FwidthCoarse(e, t);
            case 'fwidthFine':
                return this.builtins.FwidthFine(e, t);
            case 'textureDimensions':
                return this.builtins.TextureDimensions(e, t);
            case 'textureGather':
                return this.builtins.TextureGather(e, t);
            case 'textureGatherCompare':
                return this.builtins.TextureGatherCompare(e, t);
            case 'textureLoad':
                return this.builtins.TextureLoad(e, t);
            case 'textureNumLayers':
                return this.builtins.TextureNumLayers(e, t);
            case 'textureNumLevels':
                return this.builtins.TextureNumLevels(e, t);
            case 'textureNumSamples':
                return this.builtins.TextureNumSamples(e, t);
            case 'textureSample':
                return this.builtins.TextureSample(e, t);
            case 'textureSampleBias':
                return this.builtins.TextureSampleBias(e, t);
            case 'textureSampleCompare':
                return this.builtins.TextureSampleCompare(e, t);
            case 'textureSampleCompareLevel':
                return this.builtins.TextureSampleCompareLevel(e, t);
            case 'textureSampleGrad':
                return this.builtins.TextureSampleGrad(e, t);
            case 'textureSampleLevel':
                return this.builtins.TextureSampleLevel(e, t);
            case 'textureSampleBaseClampToEdge':
                return this.builtins.TextureSampleBaseClampToEdge(e, t);
            case 'textureStore':
                return this.builtins.TextureStore(e, t);
            case 'atomicLoad':
                return this.builtins.AtomicLoad(e, t);
            case 'atomicStore':
                return this.builtins.AtomicStore(e, t);
            case 'atomicAdd':
                return this.builtins.AtomicAdd(e, t);
            case 'atomicSub':
                return this.builtins.AtomicSub(e, t);
            case 'atomicMax':
                return this.builtins.AtomicMax(e, t);
            case 'atomicMin':
                return this.builtins.AtomicMin(e, t);
            case 'atomicAnd':
                return this.builtins.AtomicAnd(e, t);
            case 'atomicOr':
                return this.builtins.AtomicOr(e, t);
            case 'atomicXor':
                return this.builtins.AtomicXor(e, t);
            case 'atomicExchange':
                return this.builtins.AtomicExchange(e, t);
            case 'atomicCompareExchangeWeak':
                return this.builtins.AtomicCompareExchangeWeak(e, t);
            case 'pack4x8snorm':
                return this.builtins.Pack4x8snorm(e, t);
            case 'pack4x8unorm':
                return this.builtins.Pack4x8unorm(e, t);
            case 'pack4xI8':
                return this.builtins.Pack4xI8(e, t);
            case 'pack4xU8':
                return this.builtins.Pack4xU8(e, t);
            case 'pack4x8Clamp':
                return this.builtins.Pack4x8Clamp(e, t);
            case 'pack4xU8Clamp':
                return this.builtins.Pack4xU8Clamp(e, t);
            case 'pack2x16snorm':
                return this.builtins.Pack2x16snorm(e, t);
            case 'pack2x16unorm':
                return this.builtins.Pack2x16unorm(e, t);
            case 'pack2x16float':
                return this.builtins.Pack2x16float(e, t);
            case 'unpack4x8snorm':
                return this.builtins.Unpack4x8snorm(e, t);
            case 'unpack4x8unorm':
                return this.builtins.Unpack4x8unorm(e, t);
            case 'unpack4xI8':
                return this.builtins.Unpack4xI8(e, t);
            case 'unpack4xU8':
                return this.builtins.Unpack4xU8(e, t);
            case 'unpack2x16snorm':
                return this.builtins.Unpack2x16snorm(e, t);
            case 'unpack2x16unorm':
                return this.builtins.Unpack2x16unorm(e, t);
            case 'unpack2x16float':
                return this.builtins.Unpack2x16float(e, t);
            case 'storageBarrier':
                return this.builtins.StorageBarrier(e, t);
            case 'textureBarrier':
                return this.builtins.TextureBarrier(e, t);
            case 'workgroupBarrier':
                return this.builtins.WorkgroupBarrier(e, t);
            case 'workgroupUniformLoad':
                return this.builtins.WorkgroupUniformLoad(e, t);
            case 'subgroupAdd':
                return this.builtins.SubgroupAdd(e, t);
            case 'subgroupExclusiveAdd':
                return this.builtins.SubgroupExclusiveAdd(e, t);
            case 'subgroupInclusiveAdd':
                return this.builtins.SubgroupInclusiveAdd(e, t);
            case 'subgroupAll':
                return this.builtins.SubgroupAll(e, t);
            case 'subgroupAnd':
                return this.builtins.SubgroupAnd(e, t);
            case 'subgroupAny':
                return this.builtins.SubgroupAny(e, t);
            case 'subgroupBallot':
                return this.builtins.SubgroupBallot(e, t);
            case 'subgroupBroadcast':
                return this.builtins.SubgroupBroadcast(e, t);
            case 'subgroupBroadcastFirst':
                return this.builtins.SubgroupBroadcastFirst(e, t);
            case 'subgroupElect':
                return this.builtins.SubgroupElect(e, t);
            case 'subgroupMax':
                return this.builtins.SubgroupMax(e, t);
            case 'subgroupMin':
                return this.builtins.SubgroupMin(e, t);
            case 'subgroupMul':
                return this.builtins.SubgroupMul(e, t);
            case 'subgroupExclusiveMul':
                return this.builtins.SubgroupExclusiveMul(e, t);
            case 'subgroupInclusiveMul':
                return this.builtins.SubgroupInclusiveMul(e, t);
            case 'subgroupOr':
                return this.builtins.SubgroupOr(e, t);
            case 'subgroupShuffle':
                return this.builtins.SubgroupShuffle(e, t);
            case 'subgroupShuffleDown':
                return this.builtins.SubgroupShuffleDown(e, t);
            case 'subgroupShuffleUp':
                return this.builtins.SubgroupShuffleUp(e, t);
            case 'subgroupShuffleXor':
                return this.builtins.SubgroupShuffleXor(e, t);
            case 'subgroupXor':
                return this.builtins.SubgroupXor(e, t);
            case 'quadBroadcast':
                return this.builtins.QuadBroadcast(e, t);
            case 'quadSwapDiagonal':
                return this.builtins.QuadSwapDiagonal(e, t);
            case 'quadSwapX':
                return this.builtins.QuadSwapX(e, t);
            case 'quadSwapY':
                return this.builtins.QuadSwapY(e, t);
        }
        const n = t.getFunction(e.name);
        if (n) {
            const s = t.clone();
            for(let t = 0; t < n.node.args.length; ++t){
                const r = n.node.args[t], a = this.evalExpression(e.args[t], s);
                s.setVariable(r.name, a, r);
            }
            return this._execStatements(n.node.body, s);
        }
        return null;
    }
    _callConstructorValue(e, t) {
        if (!e.args || 0 === e.args.length) return new Oe(0, this.getTypeInfo(e.type));
        const n = this.evalExpression(e.args[0], t);
        return n.typeInfo = this.getTypeInfo(e.type), n.getSubData(this, e.postfix, t).clone();
    }
    _callConstructorVec(e, t) {
        const n = this.getTypeInfo(e.type), s = e.type.getTypeName(), r = ht[s];
        if (void 0 === r) return console.error(`Invalid vec constructor ${s}. Line ${e.line}`), null;
        const a = [];
        if (e instanceof ge) {
            if (e.isVector) {
                const t = e.vectorValue;
                for (const e of t)a.push(e);
            } else a.push(e.scalarValue);
        } else if (e.args) for (const n of e.args){
            const e = this.evalExpression(n, t);
            if (e instanceof Fe) {
                const t = e.data;
                for(let e = 0; e < t.length; ++e){
                    let n = t[e];
                    a.push(n);
                }
            } else if (e instanceof Oe) {
                let t = e.value;
                a.push(t);
            }
        }
        if (e.type instanceof oe && null === e.type.format && (e.type.format = oe.f32), 0 === a.length) {
            const s = new Array(r).fill(0);
            return new Fe(s, n).getSubData(this, e.postfix, t);
        }
        if (1 === a.length) for(; a.length < r;)a.push(a[0]);
        if (a.length < r) return console.error(`Invalid vec constructor. Line ${e.line}`), null;
        return new Fe(a.length > r ? a.slice(0, r) : a, n).getSubData(this, e.postfix, t);
    }
    _callConstructorMatrix(e, t) {
        const n = this.getTypeInfo(e.type), s = e.type.getTypeName(), r = ft[s];
        if (void 0 === r) return console.error(`Invalid matrix constructor ${s}. Line ${e.line}`), null;
        const i = [];
        if (e instanceof ge) {
            if (e.isVector) {
                const t = e.vectorValue;
                for (const e of t)i.push(e);
            } else i.push(e.scalarValue);
        } else if (e.args) for (const n of e.args){
            const e = this.evalExpression(n, t);
            e instanceof Fe ? i.push(...e.data) : e instanceof Oe ? i.push(e.value) : e instanceof Me && i.push(...e.data);
        }
        if (n instanceof a && null === n.format && (n.format = this.getTypeInfo('f32')), 0 === i.length) {
            const s = new Array(r[2]).fill(0);
            return new Me(s, n).getSubData(this, e.postfix, t);
        }
        return i.length !== r[2] ? (console.error(`Invalid matrix constructor. Line ${e.line}`), null) : new Me(i, n).getSubData(this, e.postfix, t);
    }
}
pt._breakObj = new De(new e('BREAK', null), null), pt._continueObj = new De(new e('CONTINUE', null), null), pt._priority = new Map([
    [
        'f32',
        0
    ],
    [
        'f16',
        1
    ],
    [
        'u32',
        2
    ],
    [
        'i32',
        3
    ],
    [
        'x32',
        3
    ]
]);
class dt {
    constructor(){
        this.constants = new Map, this.aliases = new Map, this.structs = new Map;
    }
}
class mt {
    constructor(){
        this._tokens = [], this._current = 0, this._currentLine = 1, this._deferArrayCountEval = [], this._currentLoop = [], this._context = new dt, this._exec = new pt, this._forwardTypeCount = 0;
    }
    parse(e) {
        this._initialize(e), this._deferArrayCountEval.length = 0;
        const t = [];
        for(; !this._isAtEnd();){
            const e = this._global_decl_or_directive();
            if (!e) break;
            t.push(e);
        }
        if (this._deferArrayCountEval.length > 0) {
            for (const e of this._deferArrayCountEval){
                const t = e.arrayType, n = e.countNode;
                if (n instanceof me) {
                    const e = n.name, s = this._context.constants.get(e);
                    if (s) try {
                        const e = s.constEvaluate(this._exec);
                        t.count = e;
                    } catch (e) {}
                }
            }
            this._deferArrayCountEval.length = 0;
        }
        if (this._forwardTypeCount > 0) for (const e of t)e.search((e)=>{
            e instanceof Le || e instanceof le ? e.type = this._forwardType(e.type) : e instanceof ce ? e.format = this._forwardType(e.format) : e instanceof B || e instanceof M || e instanceof U ? e.type = this._forwardType(e.type) : e instanceof C ? e.returnType = this._forwardType(e.returnType) : e instanceof Ee && (e.type = this._forwardType(e.type));
        });
        return t;
    }
    _forwardType(e) {
        if (e instanceof ae) {
            const t = this._getType(e.name);
            if (t) return t;
        } else e instanceof le ? e.type = this._forwardType(e.type) : e instanceof ce && (e.format = this._forwardType(e.format));
        return e;
    }
    _initialize(e) {
        if (e) {
            if ('string' == typeof e) {
                const t = new ze(e);
                this._tokens = t.scanTokens();
            } else this._tokens = e;
        } else this._tokens = [];
        this._current = 0;
    }
    _updateNode(e, t) {
        return e.line = null != t ? t : this._currentLine, e;
    }
    _error(e, t) {
        return {
            token: e,
            message: t,
            toString: ()=>`${t}`
        };
    }
    _isAtEnd() {
        return this._current >= this._tokens.length || this._peek().type == qe.eof;
    }
    _match(e) {
        if (e instanceof We) return !!this._check(e) && (this._advance(), !0);
        for(let t = 0, n = e.length; t < n; ++t){
            const n = e[t];
            if (this._check(n)) return this._advance(), !0;
        }
        return !1;
    }
    _consume(e, t) {
        if (this._check(e)) return this._advance();
        throw this._error(this._peek(), `${t}. Line:${this._currentLine}`);
    }
    _check(e) {
        if (this._isAtEnd()) return !1;
        const t = this._peek();
        if (e instanceof Array) {
            const n = t.type;
            let s = !1;
            for (const t of e){
                if (n === t) return !0;
                t === qe.tokens.name && (s = !0);
            }
            if (s) {
                const e = qe.tokens.name.rule.exec(t.lexeme);
                if (e && 0 == e.index && e[0] == t.lexeme) return !0;
            }
            return !1;
        }
        if (t.type === e) return !0;
        if (e === qe.tokens.name) {
            const e = qe.tokens.name.rule.exec(t.lexeme);
            return e && 0 == e.index && e[0] == t.lexeme;
        }
        return !1;
    }
    _advance() {
        var e, t;
        return this._currentLine = null !== (t = null === (e = this._peek()) || void 0 === e ? void 0 : e.line) && void 0 !== t ? t : -1, this._isAtEnd() || this._current++, this._previous();
    }
    _peek() {
        return this._tokens[this._current];
    }
    _previous() {
        return this._tokens[this._current - 1];
    }
    _global_decl_or_directive() {
        for(; this._match(qe.tokens.semicolon) && !this._isAtEnd(););
        if (this._match(qe.keywords.alias)) {
            const e = this._type_alias();
            return this._consume(qe.tokens.semicolon, 'Expected \';\''), this._exec.reflection.updateAST([
                e
            ]), e;
        }
        if (this._match(qe.keywords.diagnostic)) {
            const e = this._diagnostic();
            return this._consume(qe.tokens.semicolon, 'Expected \';\''), this._exec.reflection.updateAST([
                e
            ]), e;
        }
        if (this._match(qe.keywords.requires)) {
            const e = this._requires_directive();
            return this._consume(qe.tokens.semicolon, 'Expected \';\''), this._exec.reflection.updateAST([
                e
            ]), e;
        }
        if (this._match(qe.keywords.enable)) {
            const e = this._enable_directive();
            return this._consume(qe.tokens.semicolon, 'Expected \';\''), this._exec.reflection.updateAST([
                e
            ]), e;
        }
        const e = this._attribute();
        if (this._check(qe.keywords.var)) {
            const t = this._global_variable_decl();
            return null != t && (t.attributes = e), this._consume(qe.tokens.semicolon, 'Expected \';\'.'), this._exec.reflection.updateAST([
                t
            ]), t;
        }
        if (this._check(qe.keywords.override)) {
            const t = this._override_variable_decl();
            return null != t && (t.attributes = e), this._consume(qe.tokens.semicolon, 'Expected \';\'.'), this._exec.reflection.updateAST([
                t
            ]), t;
        }
        if (this._check(qe.keywords.let)) {
            const t = this._global_let_decl();
            return null != t && (t.attributes = e), this._consume(qe.tokens.semicolon, 'Expected \';\'.'), this._exec.reflection.updateAST([
                t
            ]), t;
        }
        if (this._check(qe.keywords.const)) {
            const t = this._global_const_decl();
            return null != t && (t.attributes = e), this._consume(qe.tokens.semicolon, 'Expected \';\'.'), this._exec.reflection.updateAST([
                t
            ]), t;
        }
        if (this._check(qe.keywords.struct)) {
            const t = this._struct_decl();
            return null != t && (t.attributes = e), this._exec.reflection.updateAST([
                t
            ]), t;
        }
        if (this._check(qe.keywords.fn)) {
            const t = this._function_decl();
            return null != t && (t.attributes = e), this._exec.reflection.updateAST([
                t
            ]), t;
        }
        return null;
    }
    _function_decl() {
        if (!this._match(qe.keywords.fn)) return null;
        const e = this._currentLine, t = this._consume(qe.tokens.ident, 'Expected function name.').toString();
        this._consume(qe.tokens.paren_left, 'Expected \'(\' for function arguments.');
        const n = [];
        if (!this._check(qe.tokens.paren_right)) do {
            if (this._check(qe.tokens.paren_right)) break;
            const e = this._attribute(), t = this._consume(qe.tokens.name, 'Expected argument name.').toString();
            this._consume(qe.tokens.colon, 'Expected \':\' for argument type.');
            const s = this._attribute(), r = this._type_decl();
            null != r && (r.attributes = s, n.push(this._updateNode(new Ee(t, r, e))));
        }while (this._match(qe.tokens.comma));
        this._consume(qe.tokens.paren_right, 'Expected \')\' after function arguments.');
        let s = null;
        if (this._match(qe.tokens.arrow)) {
            const e = this._attribute();
            s = this._type_decl(), null != s && (s.attributes = e);
        }
        const r = this._compound_statement(), a = this._currentLine;
        return this._updateNode(new C(t, n, s, r, e, a), e);
    }
    _compound_statement() {
        const e = [];
        for(this._consume(qe.tokens.brace_left, 'Expected \'{\' for block.'); !this._check(qe.tokens.brace_right);){
            const t = this._statement();
            null !== t && e.push(t);
        }
        return this._consume(qe.tokens.brace_right, 'Expected \'}\' for block.'), e;
    }
    _statement() {
        for(; this._match(qe.tokens.semicolon) && !this._isAtEnd(););
        if (this._check(qe.tokens.attr) && this._attribute(), this._check(qe.keywords.if)) return this._if_statement();
        if (this._check(qe.keywords.switch)) return this._switch_statement();
        if (this._check(qe.keywords.loop)) return this._loop_statement();
        if (this._check(qe.keywords.for)) return this._for_statement();
        if (this._check(qe.keywords.while)) return this._while_statement();
        if (this._check(qe.keywords.continuing)) return this._continuing_statement();
        if (this._check(qe.keywords.static_assert)) return this._static_assert_statement();
        if (this._check(qe.tokens.brace_left)) return this._compound_statement();
        let e = null;
        if (this._check(qe.keywords.return)) e = this._return_statement();
        else if (this._check([
            qe.keywords.var,
            qe.keywords.let,
            qe.keywords.const
        ])) e = this._variable_statement();
        else if (this._match(qe.keywords.discard)) e = this._updateNode(new te);
        else if (this._match(qe.keywords.break)) {
            const t = this._updateNode(new ne);
            if (this._currentLoop.length > 0) {
                const e = this._currentLoop[this._currentLoop.length - 1];
                t.loopId = e.id;
            }
            e = t, this._check(qe.keywords.if) && (this._advance(), t.condition = this._optional_paren_expression());
        } else if (this._match(qe.keywords.continue)) {
            const t = this._updateNode(new se);
            if (!(this._currentLoop.length > 0)) throw this._error(this._peek(), `Continue statement must be inside a loop. Line: ${t.line}`);
            {
                const e = this._currentLoop[this._currentLoop.length - 1];
                t.loopId = e.id;
            }
            e = t;
        } else e = this._increment_decrement_statement() || this._func_call_statement() || this._assignment_statement();
        return null != e && this._consume(qe.tokens.semicolon, 'Expected \';\' after statement.'), e;
    }
    _static_assert_statement() {
        if (!this._match(qe.keywords.static_assert)) return null;
        const e = this._currentLine, t = this._optional_paren_expression();
        return this._updateNode(new D(t), e);
    }
    _while_statement() {
        if (!this._match(qe.keywords.while)) return null;
        const e = this._updateNode(new N(null, null));
        return this._currentLoop.push(e), e.condition = this._optional_paren_expression(), this._check(qe.tokens.attr) && this._attribute(), e.body = this._compound_statement(), this._currentLoop.pop(), e;
    }
    _continuing_statement() {
        const e = this._currentLoop.length > 0 ? this._currentLoop[this._currentLoop.length - 1].id : -1;
        if (!this._match(qe.keywords.continuing)) return null;
        const t = this._currentLine, n = this._compound_statement();
        return this._updateNode(new V(n, e), t);
    }
    _for_statement() {
        if (!this._match(qe.keywords.for)) return null;
        this._consume(qe.tokens.paren_left, 'Expected \'(\'.');
        const e = this._updateNode(new O(null, null, null, null));
        return this._currentLoop.push(e), e.init = this._check(qe.tokens.semicolon) ? null : this._for_init(), this._consume(qe.tokens.semicolon, 'Expected \';\'.'), e.condition = this._check(qe.tokens.semicolon) ? null : this._short_circuit_or_expression(), this._consume(qe.tokens.semicolon, 'Expected \';\'.'), e.increment = this._check(qe.tokens.paren_right) ? null : this._for_increment(), this._consume(qe.tokens.paren_right, 'Expected \')\'.'), this._check(qe.tokens.attr) && this._attribute(), e.body = this._compound_statement(), this._currentLoop.pop(), e;
    }
    _for_init() {
        return this._variable_statement() || this._func_call_statement() || this._assignment_statement();
    }
    _for_increment() {
        return this._func_call_statement() || this._increment_decrement_statement() || this._assignment_statement();
    }
    _variable_statement() {
        if (this._check(qe.keywords.var)) {
            const e = this._variable_decl();
            if (null === e) throw this._error(this._peek(), 'Variable declaration expected.');
            let t = null;
            return this._match(qe.tokens.equal) && (t = this._short_circuit_or_expression()), this._updateNode(new B(e.name, e.type, e.storage, e.access, t), e.line);
        }
        if (this._match(qe.keywords.let)) {
            const e = this._currentLine, t = this._consume(qe.tokens.name, 'Expected name for let.').toString();
            let n = null;
            if (this._match(qe.tokens.colon)) {
                const e = this._attribute();
                n = this._type_decl(), null != n && (n.attributes = e);
            }
            this._consume(qe.tokens.equal, 'Expected \'=\' for let.');
            const s = this._short_circuit_or_expression();
            return this._updateNode(new M(t, n, null, null, s), e);
        }
        if (this._match(qe.keywords.const)) {
            const e = this._currentLine, t = this._consume(qe.tokens.name, 'Expected name for const.').toString();
            let n = null;
            if (this._match(qe.tokens.colon)) {
                const e = this._attribute();
                n = this._type_decl(), null != n && (n.attributes = e);
            }
            this._consume(qe.tokens.equal, 'Expected \'=\' for const.');
            const s = this._short_circuit_or_expression();
            return null === n && s instanceof ge && (n = s.type), this._updateNode(new U(t, n, null, null, s), e);
        }
        return null;
    }
    _increment_decrement_statement() {
        const e = this._current, t = this._unary_expression();
        if (null == t) return null;
        if (!this._check(qe.increment_operators)) return this._current = e, null;
        const n = this._consume(qe.increment_operators, 'Expected increment operator');
        return this._updateNode(new z(n.type === qe.tokens.plus_plus ? P.increment : P.decrement, t));
    }
    _assignment_statement() {
        let e = null;
        const t = this._currentLine;
        if (this._check(qe.tokens.brace_right)) return null;
        let n = this._match(qe.tokens.underscore);
        if (n || (e = this._unary_expression()), !n && null == e) return null;
        const s = this._consume(qe.assignment_operators, 'Expected assignment operator.'), r = this._short_circuit_or_expression();
        return this._updateNode(new R(W.parse(s.lexeme), e, r), t);
    }
    _func_call_statement() {
        if (!this._check(qe.tokens.ident)) return null;
        const e = this._currentLine, t = this._current, n = this._consume(qe.tokens.ident, 'Expected function name.'), s = this._argument_expression_list();
        return null === s ? (this._current = t, null) : this._updateNode(new G(n.lexeme, s), e);
    }
    _loop_statement() {
        if (!this._match(qe.keywords.loop)) return null;
        this._check(qe.tokens.attr) && this._attribute(), this._consume(qe.tokens.brace_left, 'Expected \'{\' for loop.');
        const e = this._updateNode(new X([], null));
        this._currentLoop.push(e);
        let t = this._statement();
        for(; null !== t;){
            if (Array.isArray(t)) for (let n of t)e.body.push(n);
            else e.body.push(t);
            if (t instanceof V) {
                e.continuing = t;
                break;
            }
            t = this._statement();
        }
        return this._currentLoop.pop(), this._consume(qe.tokens.brace_right, 'Expected \'}\' for loop.'), e;
    }
    _switch_statement() {
        if (!this._match(qe.keywords.switch)) return null;
        const e = this._updateNode(new j(null, []));
        if (this._currentLoop.push(e), e.condition = this._optional_paren_expression(), this._check(qe.tokens.attr) && this._attribute(), this._consume(qe.tokens.brace_left, 'Expected \'{\' for switch.'), e.cases = this._switch_body(), null == e.cases || 0 == e.cases.length) throw this._error(this._previous(), 'Expected \'case\' or \'default\'.');
        return this._consume(qe.tokens.brace_right, 'Expected \'}\' for switch.'), this._currentLoop.pop(), e;
    }
    _switch_body() {
        const e = [];
        let t = !1;
        for(; this._check([
            qe.keywords.default,
            qe.keywords.case
        ]);){
            if (this._match(qe.keywords.case)) {
                const n = this._case_selectors();
                for (const e of n)if (e instanceof Te) {
                    if (t) throw this._error(this._previous(), 'Multiple default cases in switch statement.');
                    t = !0;
                    break;
                }
                this._match(qe.tokens.colon), this._check(qe.tokens.attr) && this._attribute(), this._consume(qe.tokens.brace_left, 'Exected \'{\' for switch case.');
                const s = this._case_body();
                this._consume(qe.tokens.brace_right, 'Exected \'}\' for switch case.'), e.push(this._updateNode(new Se(n, s)));
            }
            if (this._match(qe.keywords.default)) {
                if (t) throw this._error(this._previous(), 'Multiple default cases in switch statement.');
                this._match(qe.tokens.colon), this._check(qe.tokens.attr) && this._attribute(), this._consume(qe.tokens.brace_left, 'Exected \'{\' for switch default.');
                const n = this._case_body();
                this._consume(qe.tokens.brace_right, 'Exected \'}\' for switch default.'), e.push(this._updateNode(new Ae(n)));
            }
        }
        return e;
    }
    _case_selectors() {
        const e = [];
        for(this._match(qe.keywords.default) ? e.push(this._updateNode(new Te)) : e.push(this._shift_expression()); this._match(qe.tokens.comma);)this._match(qe.keywords.default) ? e.push(this._updateNode(new Te)) : e.push(this._shift_expression());
        return e;
    }
    _case_body() {
        if (this._match(qe.keywords.fallthrough)) return this._consume(qe.tokens.semicolon, 'Expected \';\''), [];
        let e = this._statement();
        if (null == e) return [];
        e instanceof Array || (e = [
            e
        ]);
        const t = this._case_body();
        return 0 == t.length ? e : [
            ...e,
            t[0]
        ];
    }
    _if_statement() {
        if (!this._match(qe.keywords.if)) return null;
        const e = this._currentLine, t = this._optional_paren_expression();
        this._check(qe.tokens.attr) && this._attribute();
        const n = this._compound_statement();
        let s = [];
        this._match_elseif() && (this._check(qe.tokens.attr) && this._attribute(), s = this._elseif_statement(s));
        let r = null;
        return this._match(qe.keywords.else) && (this._check(qe.tokens.attr) && this._attribute(), r = this._compound_statement()), this._updateNode(new Z(t, n, s, r), e);
    }
    _match_elseif() {
        return this._tokens[this._current].type === qe.keywords.else && this._tokens[this._current + 1].type === qe.keywords.if && (this._advance(), this._advance(), !0);
    }
    _elseif_statement(e = []) {
        const t = this._optional_paren_expression(), n = this._compound_statement();
        return e.push(this._updateNode(new $e(t, n))), this._match_elseif() && (this._check(qe.tokens.attr) && this._attribute(), this._elseif_statement(e)), e;
    }
    _return_statement() {
        if (!this._match(qe.keywords.return)) return null;
        const e = this._short_circuit_or_expression();
        return this._updateNode(new Q(e));
    }
    _short_circuit_or_expression() {
        let e = this._short_circuit_and_expr();
        for(; this._match(qe.tokens.or_or);)e = this._updateNode(new ke(this._previous().toString(), e, this._short_circuit_and_expr()));
        return e;
    }
    _short_circuit_and_expr() {
        let e = this._inclusive_or_expression();
        for(; this._match(qe.tokens.and_and);)e = this._updateNode(new ke(this._previous().toString(), e, this._inclusive_or_expression()));
        return e;
    }
    _inclusive_or_expression() {
        let e = this._exclusive_or_expression();
        for(; this._match(qe.tokens.or);)e = this._updateNode(new ke(this._previous().toString(), e, this._exclusive_or_expression()));
        return e;
    }
    _exclusive_or_expression() {
        let e = this._and_expression();
        for(; this._match(qe.tokens.xor);)e = this._updateNode(new ke(this._previous().toString(), e, this._and_expression()));
        return e;
    }
    _and_expression() {
        let e = this._equality_expression();
        for(; this._match(qe.tokens.and);)e = this._updateNode(new ke(this._previous().toString(), e, this._equality_expression()));
        return e;
    }
    _equality_expression() {
        const e = this._relational_expression();
        return this._match([
            qe.tokens.equal_equal,
            qe.tokens.not_equal
        ]) ? this._updateNode(new ke(this._previous().toString(), e, this._relational_expression())) : e;
    }
    _relational_expression() {
        let e = this._shift_expression();
        for(; this._match([
            qe.tokens.less_than,
            qe.tokens.greater_than,
            qe.tokens.less_than_equal,
            qe.tokens.greater_than_equal
        ]);)e = this._updateNode(new ke(this._previous().toString(), e, this._shift_expression()));
        return e;
    }
    _shift_expression() {
        let e = this._additive_expression();
        for(; this._match([
            qe.tokens.shift_left,
            qe.tokens.shift_right
        ]);)e = this._updateNode(new ke(this._previous().toString(), e, this._additive_expression()));
        return e;
    }
    _additive_expression() {
        let e = this._multiplicative_expression();
        for(; this._match([
            qe.tokens.plus,
            qe.tokens.minus
        ]);)e = this._updateNode(new ke(this._previous().toString(), e, this._multiplicative_expression()));
        return e;
    }
    _multiplicative_expression() {
        let e = this._unary_expression();
        for(; this._match([
            qe.tokens.star,
            qe.tokens.forward_slash,
            qe.tokens.modulo
        ]);)e = this._updateNode(new ke(this._previous().toString(), e, this._unary_expression()));
        return e;
    }
    _unary_expression() {
        return this._match([
            qe.tokens.minus,
            qe.tokens.bang,
            qe.tokens.tilde,
            qe.tokens.star,
            qe.tokens.and
        ]) ? this._updateNode(new we(this._previous().toString(), this._unary_expression())) : this._singular_expression();
    }
    _singular_expression() {
        const e = this._primary_expression(), t = this._postfix_expression();
        return t && (e.postfix = t), e;
    }
    _postfix_expression() {
        if (this._match(qe.tokens.bracket_left)) {
            const e = this._short_circuit_or_expression();
            this._consume(qe.tokens.bracket_right, 'Expected \']\'.');
            const t = this._updateNode(new be(e)), n = this._postfix_expression();
            return n && (t.postfix = n), t;
        }
        if (this._match(qe.tokens.period)) {
            const e = this._consume(qe.tokens.name, 'Expected member name.'), t = this._postfix_expression(), n = this._updateNode(new fe(e.lexeme));
            return t && (n.postfix = t), n;
        }
        return null;
    }
    _getStruct(e) {
        if (this._context.aliases.has(e)) return this._context.aliases.get(e).type;
        if (this._context.structs.has(e)) return this._context.structs.get(e);
        return null;
    }
    _getType(e) {
        const t = this._getStruct(e);
        if (null !== t) return t;
        switch(e){
            case 'void':
                return re.void;
            case 'bool':
                return re.bool;
            case 'i32':
                return re.i32;
            case 'u32':
                return re.u32;
            case 'f32':
                return re.f32;
            case 'f16':
                return re.f16;
            case 'vec2f':
                return oe.vec2f;
            case 'vec3f':
                return oe.vec3f;
            case 'vec4f':
                return oe.vec4f;
            case 'vec2i':
                return oe.vec2i;
            case 'vec3i':
                return oe.vec3i;
            case 'vec4i':
                return oe.vec4i;
            case 'vec2u':
                return oe.vec2u;
            case 'vec3u':
                return oe.vec3u;
            case 'vec4u':
                return oe.vec4u;
            case 'vec2h':
                return oe.vec2h;
            case 'vec3h':
                return oe.vec3h;
            case 'vec4h':
                return oe.vec4h;
            case 'mat2x2f':
                return oe.mat2x2f;
            case 'mat2x3f':
                return oe.mat2x3f;
            case 'mat2x4f':
                return oe.mat2x4f;
            case 'mat3x2f':
                return oe.mat3x2f;
            case 'mat3x3f':
                return oe.mat3x3f;
            case 'mat3x4f':
                return oe.mat3x4f;
            case 'mat4x2f':
                return oe.mat4x2f;
            case 'mat4x3f':
                return oe.mat4x3f;
            case 'mat4x4f':
                return oe.mat4x4f;
            case 'mat2x2h':
                return oe.mat2x2h;
            case 'mat2x3h':
                return oe.mat2x3h;
            case 'mat2x4h':
                return oe.mat2x4h;
            case 'mat3x2h':
                return oe.mat3x2h;
            case 'mat3x3h':
                return oe.mat3x3h;
            case 'mat3x4h':
                return oe.mat3x4h;
            case 'mat4x2h':
                return oe.mat4x2h;
            case 'mat4x3h':
                return oe.mat4x3h;
            case 'mat4x4h':
                return oe.mat4x4h;
            case 'mat2x2i':
                return oe.mat2x2i;
            case 'mat2x3i':
                return oe.mat2x3i;
            case 'mat2x4i':
                return oe.mat2x4i;
            case 'mat3x2i':
                return oe.mat3x2i;
            case 'mat3x3i':
                return oe.mat3x3i;
            case 'mat3x4i':
                return oe.mat3x4i;
            case 'mat4x2i':
                return oe.mat4x2i;
            case 'mat4x3i':
                return oe.mat4x3i;
            case 'mat4x4i':
                return oe.mat4x4i;
            case 'mat2x2u':
                return oe.mat2x2u;
            case 'mat2x3u':
                return oe.mat2x3u;
            case 'mat2x4u':
                return oe.mat2x4u;
            case 'mat3x2u':
                return oe.mat3x2u;
            case 'mat3x3u':
                return oe.mat3x3u;
            case 'mat3x4u':
                return oe.mat3x4u;
            case 'mat4x2u':
                return oe.mat4x2u;
            case 'mat4x3u':
                return oe.mat4x3u;
            case 'mat4x4u':
                return oe.mat4x4u;
        }
        return null;
    }
    _validateTypeRange(e, t) {
        if ('i32' === t.name) {
            if (e < -2147483648 || e > 2147483647) throw this._error(this._previous(), `Value out of range for i32: ${e}. Line: ${this._currentLine}.`);
        } else if ('u32' === t.name && (e < 0 || e > 4294967295)) throw this._error(this._previous(), `Value out of range for u32: ${e}. Line: ${this._currentLine}.`);
    }
    _primary_expression() {
        if (this._match(qe.tokens.ident)) {
            const e = this._previous().toString();
            if (this._check(qe.tokens.paren_left)) {
                const t = this._argument_expression_list(), n = this._getType(e);
                return null !== n ? this._updateNode(new pe(n, t)) : this._updateNode(new de(e, t));
            }
            if (this._context.constants.has(e)) {
                const t = this._context.constants.get(e);
                return this._updateNode(new _e(e, t.value));
            }
            return this._updateNode(new me(e));
        }
        if (this._match(qe.tokens.int_literal)) {
            const e = this._previous().toString();
            let t = e.endsWith('i') || e.endsWith('i') ? re.i32 : e.endsWith('u') || e.endsWith('U') ? re.u32 : re.x32;
            const n = parseInt(e);
            return this._validateTypeRange(n, t), this._updateNode(new ge(new Oe(n, this._exec.getTypeInfo(t)), t));
        }
        if (this._match(qe.tokens.uint_literal)) {
            const e = parseInt(this._previous().toString());
            return this._validateTypeRange(e, re.u32), this._updateNode(new ge(new Oe(e, this._exec.getTypeInfo(re.u32)), re.u32));
        }
        if (this._match([
            qe.tokens.decimal_float_literal,
            qe.tokens.hex_float_literal
        ])) {
            let e = this._previous().toString(), t = e.endsWith('h');
            t && (e = e.substring(0, e.length - 1));
            const n = parseFloat(e);
            this._validateTypeRange(n, t ? re.f16 : re.f32);
            const s = t ? re.f16 : re.f32;
            return this._updateNode(new ge(new Oe(n, this._exec.getTypeInfo(s)), s));
        }
        if (this._match([
            qe.keywords.true,
            qe.keywords.false
        ])) {
            let e = this._previous().toString() === qe.keywords.true.rule;
            return this._updateNode(new ge(new Oe(e ? 1 : 0, this._exec.getTypeInfo(re.bool)), re.bool));
        }
        if (this._check(qe.tokens.paren_left)) return this._paren_expression();
        if (this._match(qe.keywords.bitcast)) {
            this._consume(qe.tokens.less_than, 'Expected \'<\'.');
            const e = this._type_decl();
            this._consume(qe.tokens.greater_than, 'Expected \'>\'.');
            const t = this._paren_expression();
            return this._updateNode(new xe(e, t));
        }
        const e = this._type_decl(), t = this._argument_expression_list();
        return this._updateNode(new pe(e, t));
    }
    _argument_expression_list() {
        if (!this._match(qe.tokens.paren_left)) return null;
        const e = [];
        do {
            if (this._check(qe.tokens.paren_right)) break;
            const t = this._short_circuit_or_expression();
            e.push(t);
        }while (this._match(qe.tokens.comma));
        return this._consume(qe.tokens.paren_right, 'Expected \')\' for agument list'), e;
    }
    _optional_paren_expression() {
        this._match(qe.tokens.paren_left);
        const e = this._short_circuit_or_expression();
        return this._match(qe.tokens.paren_right), e;
    }
    _paren_expression() {
        this._consume(qe.tokens.paren_left, 'Expected \'(\'.');
        const e = this._short_circuit_or_expression();
        return this._consume(qe.tokens.paren_right, 'Expected \')\'.'), e;
    }
    _struct_decl() {
        if (!this._match(qe.keywords.struct)) return null;
        const e = this._currentLine, t = this._consume(qe.tokens.ident, 'Expected name for struct.').toString();
        this._consume(qe.tokens.brace_left, 'Expected \'{\' for struct body.');
        const n = [];
        for(; !this._check(qe.tokens.brace_right);){
            const e = this._attribute(), t = this._consume(qe.tokens.name, 'Expected variable name.').toString();
            this._consume(qe.tokens.colon, 'Expected \':\' for struct member type.');
            const s = this._attribute(), r = this._type_decl();
            null != r && (r.attributes = s), this._check(qe.tokens.brace_right) ? this._match(qe.tokens.comma) : this._consume(qe.tokens.comma, 'Expected \',\' for struct member.'), n.push(this._updateNode(new Le(t, r, e)));
        }
        this._consume(qe.tokens.brace_right, 'Expected \'}\' after struct body.');
        const s = this._currentLine, r = this._updateNode(new ie(t, n, e, s), e);
        return this._context.structs.set(t, r), r;
    }
    _global_variable_decl() {
        const e = this._variable_decl();
        if (!e) return null;
        if (this._match(qe.tokens.equal)) {
            const t = this._const_expression();
            e.value = t;
        }
        if (null !== e.type && e.value instanceof ge) {
            if ('x32' !== e.value.type.name) {
                if (e.type.getTypeName() !== e.value.type.getTypeName()) throw this._error(this._peek(), `Invalid cast from ${e.value.type.name} to ${e.type.name}. Line:${this._currentLine}`);
            }
            e.value.isScalar && this._validateTypeRange(e.value.scalarValue, e.type), e.value.type = e.type;
        } else null === e.type && e.value instanceof ge && (e.type = 'x32' === e.value.type.name ? re.i32 : e.value.type, e.value.isScalar && this._validateTypeRange(e.value.scalarValue, e.type));
        return e;
    }
    _override_variable_decl() {
        const e = this._override_decl();
        return e && this._match(qe.tokens.equal) && (e.value = this._const_expression()), e;
    }
    _global_const_decl() {
        var e;
        if (!this._match(qe.keywords.const)) return null;
        const t = this._consume(qe.tokens.name, 'Expected variable name'), n = this._currentLine;
        let s = null;
        if (this._match(qe.tokens.colon)) {
            const e = this._attribute();
            s = this._type_decl(), null != s && (s.attributes = e);
        }
        let r = null;
        this._consume(qe.tokens.equal, 'const declarations require an assignment');
        const i = this._short_circuit_or_expression();
        try {
            let e = [
                re.f32
            ], n = i.constEvaluate(this._exec, e);
            n instanceof Oe && this._validateTypeRange(n.value, e[0]), e[0] instanceof oe && null === e[0].format && n.typeInfo instanceof a && null !== n.typeInfo.format && ('f16' === n.typeInfo.format.name ? e[0].format = re.f16 : 'f32' === n.typeInfo.format.name ? e[0].format = re.f32 : 'i32' === n.typeInfo.format.name ? e[0].format = re.i32 : 'u32' === n.typeInfo.format.name ? e[0].format = re.u32 : 'bool' === n.typeInfo.format.name ? e[0].format = re.bool : console.error(`TODO: impelement template format type ${n.typeInfo.format.name}`)), r = this._updateNode(new ge(n, e[0])), this._exec.context.setVariable(t.toString(), n);
        } catch (e) {
            r = i;
        }
        if (null !== s && r instanceof ge) {
            if ('x32' !== r.type.name) {
                if (s.getTypeName() !== r.type.getTypeName()) throw this._error(this._peek(), `Invalid cast from ${r.type.name} to ${s.name}. Line:${this._currentLine}`);
            }
            r.type = s, r.isScalar && this._validateTypeRange(r.scalarValue, r.type);
        } else null === s && r instanceof ge && (s = null !== (e = null == r ? void 0 : r.type) && void 0 !== e ? e : re.f32, s === re.x32 && (s = re.i32));
        const o = this._updateNode(new U(t.toString(), s, '', '', r), n);
        return this._context.constants.set(o.name, o), o;
    }
    _global_let_decl() {
        if (!this._match(qe.keywords.let)) return null;
        const e = this._currentLine, t = this._consume(qe.tokens.name, 'Expected variable name');
        let n = null;
        if (this._match(qe.tokens.colon)) {
            const e = this._attribute();
            n = this._type_decl(), null != n && (n.attributes = e);
        }
        let s = null;
        if (this._match(qe.tokens.equal) && (s = this._const_expression()), null !== n && s instanceof ge) {
            if ('x32' !== s.type.name) {
                if (n.getTypeName() !== s.type.getTypeName()) throw this._error(this._peek(), `Invalid cast from ${s.type.name} to ${n.name}. Line:${this._currentLine}`);
            }
            s.type = n;
        } else null === n && s instanceof ge && (n = 'x32' === s.type.name ? re.i32 : s.type);
        return s instanceof ge && s.isScalar && this._validateTypeRange(s.scalarValue, n), this._updateNode(new M(t.toString(), n, '', '', s), e);
    }
    _const_expression() {
        return this._short_circuit_or_expression();
    }
    _variable_decl() {
        if (!this._match(qe.keywords.var)) return null;
        const e = this._currentLine;
        let t = '', n = '';
        this._match(qe.tokens.less_than) && (t = this._consume(qe.storage_class, 'Expected storage_class.').toString(), this._match(qe.tokens.comma) && (n = this._consume(qe.access_mode, 'Expected access_mode.').toString()), this._consume(qe.tokens.greater_than, 'Expected \'>\'.'));
        const s = this._consume(qe.tokens.name, 'Expected variable name');
        let r = null;
        if (this._match(qe.tokens.colon)) {
            const e = this._attribute();
            r = this._type_decl(), null != r && (r.attributes = e);
        }
        return this._updateNode(new B(s.toString(), r, t, n, null), e);
    }
    _override_decl() {
        if (!this._match(qe.keywords.override)) return null;
        const e = this._consume(qe.tokens.name, 'Expected variable name');
        let t = null;
        if (this._match(qe.tokens.colon)) {
            const e = this._attribute();
            t = this._type_decl(), null != t && (t.attributes = e);
        }
        return this._updateNode(new F(e.toString(), t, null));
    }
    _diagnostic() {
        this._consume(qe.tokens.paren_left, 'Expected \'(\'');
        const e = this._consume(qe.tokens.ident, 'Expected severity control name.');
        this._consume(qe.tokens.comma, 'Expected \',\'');
        let t = this._consume(qe.tokens.ident, 'Expected diagnostic rule name.').toString();
        if (this._match(qe.tokens.period)) t += `.${this._consume(qe.tokens.ident, 'Expected diagnostic message.').toString()}`;
        return this._consume(qe.tokens.paren_right, 'Expected \')\''), this._updateNode(new J(e.toString(), t));
    }
    _enable_directive() {
        const e = this._consume(qe.tokens.ident, 'identity expected.');
        return this._updateNode(new Y(e.toString()));
    }
    _requires_directive() {
        const e = [
            this._consume(qe.tokens.ident, 'identity expected.').toString()
        ];
        for(; this._match(qe.tokens.comma);){
            const t = this._consume(qe.tokens.ident, 'identity expected.');
            e.push(t.toString());
        }
        return this._updateNode(new K(e));
    }
    _type_alias() {
        const e = this._consume(qe.tokens.ident, 'identity expected.');
        this._consume(qe.tokens.equal, 'Expected \'=\' for type alias.');
        let t = this._type_decl();
        if (null === t) throw this._error(this._peek(), 'Expected Type for Alias.');
        this._context.aliases.has(t.name) && (t = this._context.aliases.get(t.name).type);
        const n = this._updateNode(new ee(e.toString(), t));
        return this._context.aliases.set(n.name, n), n;
    }
    _type_decl() {
        if (this._check([
            qe.tokens.ident,
            ...qe.texel_format,
            qe.keywords.bool,
            qe.keywords.f32,
            qe.keywords.i32,
            qe.keywords.u32
        ])) {
            const e = this._advance().toString();
            if (this._context.structs.has(e)) return this._context.structs.get(e);
            if (this._context.aliases.has(e)) return this._context.aliases.get(e).type;
            if (!this._getType(e)) {
                const t = this._updateNode(new ae(e));
                return this._forwardTypeCount++, t;
            }
            return this._updateNode(new re(e));
        }
        let e = this._texture_sampler_types();
        if (e) return e;
        if (this._check(qe.template_types)) {
            let e = this._advance().toString(), t = null, n = null;
            this._match(qe.tokens.less_than) && (t = this._type_decl(), n = null, this._match(qe.tokens.comma) && (n = this._consume(qe.access_mode, 'Expected access_mode for pointer').toString()), this._consume(qe.tokens.greater_than, 'Expected \'>\' for type.'));
            return this._updateNode(new oe(e, t, n));
        }
        if (this._match(qe.keywords.ptr)) {
            let e = this._previous().toString();
            this._consume(qe.tokens.less_than, 'Expected \'<\' for pointer.');
            const t = this._consume(qe.storage_class, 'Expected storage_class for pointer');
            this._consume(qe.tokens.comma, 'Expected \',\' for pointer.');
            const n = this._type_decl();
            let s = null;
            this._match(qe.tokens.comma) && (s = this._consume(qe.access_mode, 'Expected access_mode for pointer').toString()), this._consume(qe.tokens.greater_than, 'Expected \'>\' for pointer.');
            return this._updateNode(new le(e, t.toString(), n, s));
        }
        const t = this._attribute();
        if (this._match(qe.keywords.array)) {
            let e = null, n = -1;
            const s = this._previous();
            let r = null;
            if (this._match(qe.tokens.less_than)) {
                e = this._type_decl(), this._context.aliases.has(e.name) && (e = this._context.aliases.get(e.name).type);
                let t = '';
                if (this._match(qe.tokens.comma)) {
                    r = this._shift_expression();
                    try {
                        t = r.constEvaluate(this._exec).toString(), r = null;
                    } catch (e) {
                        t = '1';
                    }
                }
                this._consume(qe.tokens.greater_than, 'Expected \'>\' for array.'), n = t ? parseInt(t) : 0;
            }
            const a = this._updateNode(new ce(s.toString(), t, e, n));
            return r && this._deferArrayCountEval.push({
                arrayType: a,
                countNode: r
            }), a;
        }
        return null;
    }
    _texture_sampler_types() {
        if (this._match(qe.sampler_type)) return this._updateNode(new ue(this._previous().toString(), null, null));
        if (this._match(qe.depth_texture_type)) return this._updateNode(new ue(this._previous().toString(), null, null));
        if (this._match(qe.sampled_texture_type) || this._match(qe.multisampled_texture_type)) {
            const e = this._previous();
            this._consume(qe.tokens.less_than, 'Expected \'<\' for sampler type.');
            const t = this._type_decl();
            return this._consume(qe.tokens.greater_than, 'Expected \'>\' for sampler type.'), this._updateNode(new ue(e.toString(), t, null));
        }
        if (this._match(qe.storage_texture_type)) {
            const e = this._previous();
            this._consume(qe.tokens.less_than, 'Expected \'<\' for sampler type.');
            const t = this._consume(qe.texel_format, 'Invalid texel format.').toString();
            this._consume(qe.tokens.comma, 'Expected \',\' after texel format.');
            const n = this._consume(qe.access_mode, 'Expected access mode for storage texture type.').toString();
            return this._consume(qe.tokens.greater_than, 'Expected \'>\' for sampler type.'), this._updateNode(new ue(e.toString(), t, n));
        }
        return null;
    }
    _attribute() {
        let e = [];
        for(; this._match(qe.tokens.attr);){
            const t = this._consume(qe.attribute_name, 'Expected attribute name'), n = this._updateNode(new Ce(t.toString(), null));
            if (this._match(qe.tokens.paren_left)) {
                if (n.value = this._consume(qe.literal_or_ident, 'Expected attribute value').toString(), this._check(qe.tokens.comma)) {
                    this._advance();
                    do {
                        const e = this._consume(qe.literal_or_ident, 'Expected attribute value').toString();
                        n.value instanceof Array || (n.value = [
                            n.value
                        ]), n.value.push(e);
                    }while (this._match(qe.tokens.comma));
                }
                this._consume(qe.tokens.paren_right, 'Expected \')\'');
            }
            e.push(n);
        }
        return 0 == e.length ? null : e;
    }
}
class _t extends rt {
    constructor(e){
        super(), e && this.update(e);
    }
    update(e) {
        const t = (new mt).parse(e);
        this.updateAST(t);
    }
}
class gt {
    get line() {
        return -1;
    }
}
class xt extends gt {
    constructor(e){
        super(), this.node = e;
    }
    get line() {
        return this.node.line;
    }
}
class yt extends gt {
    constructor(e, t){
        super(), this.node = e, this.statement = t;
    }
    get line() {
        return this.statement.line;
    }
}
class bt extends gt {
    constructor(e){
        super(), this.id = e;
    }
}
class vt extends gt {
    constructor(e){
        super(), this.id = e;
    }
}
class wt extends gt {
    constructor(e, t){
        super(), this.id = e, this.node = t;
    }
    get line() {
        return this.node.line;
    }
}
class kt extends gt {
    constructor(e, t, n){
        super(), this.id = e, this.condition = t, this.node = n;
    }
    get line() {
        return this.node.line;
    }
}
class It extends gt {
    constructor(e, t, n){
        super(), this.lineNo = -1, this.condition = e, this.position = t, this.lineNo = n;
    }
    get line() {
        var e, t;
        return null !== (t = null === (e = this.condition) || void 0 === e ? void 0 : e.line) && void 0 !== t ? t : this.lineNo;
    }
}
class Tt extends gt {
    constructor(e){
        super(), this.statements = [], this.statements = e;
    }
    get line() {
        return this.statements.length > 0 ? this.statements[0].line : -1;
    }
}
class St {
    constructor(e, t){
        this.parent = null, this.commands = [], this.current = 0, this.parentCallExpr = null, this.context = e, this.parent = null != t ? t : null;
    }
    get isAtEnd() {
        return this.current >= this.commands.length;
    }
    getNextCommand() {
        if (this.current >= this.commands.length) return null;
        const e = this.commands[this.current];
        return this.current++, e;
    }
    getCurrentCommand() {
        return this.current >= this.commands.length ? null : this.commands[this.current];
    }
}
class At {
    constructor(){
        this.states = [];
    }
    get isEmpty() {
        return 0 == this.states.length;
    }
    get last() {
        var e;
        return null !== (e = this.states[this.states.length - 1]) && void 0 !== e ? e : null;
    }
    pop() {
        this.states.pop();
    }
}
class Et {
    constructor(e, t){
        this._runTimer = null, this.breakpoints = new Set, this.runStateCallback = null, this._code = e;
        const n = (new mt).parse(e);
        this._exec = new pt(n), this.runStateCallback = null != t ? t : null;
    }
    getVariableValue(e) {
        var t, n;
        const s = null !== (n = null === (t = this.context.getVariable(e)) || void 0 === t ? void 0 : t.value) && void 0 !== n ? n : null;
        return null === s ? null : s instanceof Oe ? s.value : s instanceof Fe || s instanceof Me ? Array.from(s.data) : (console.error(`Unsupported return variable type ${s.typeInfo.name}`), null);
    }
    reset() {
        this._exec = new pt(this._exec.ast), this.startDebug();
    }
    startDebug() {
        this._execStack = new At;
        const e = this._createState(this._exec.ast, this._exec.context);
        this._execStack.states.push(e);
    }
    get context() {
        const e = this.currentState;
        return null === e ? this._exec.context : e.context;
    }
    get currentState() {
        for(;;){
            if (this._execStack.isEmpty) return null;
            let e = this._execStack.last;
            if (null === e) return null;
            if (e.isAtEnd) {
                if (this._execStack.pop(), this._execStack.isEmpty) return null;
                e = this._execStack.last;
            }
            return e;
        }
    }
    get currentCommand() {
        for(;;){
            if (this._execStack.isEmpty) return null;
            let e = this._execStack.last;
            if (null === e) return null;
            if (e.isAtEnd) {
                if (this._execStack.pop(), this._execStack.isEmpty) return null;
                e = this._execStack.last;
            }
            const t = e.getCurrentCommand();
            if (null !== t) return t;
        }
    }
    toggleBreakpoint(e) {
        this.breakpoints.has(e) ? this.breakpoints.delete(e) : this.breakpoints.add(e);
    }
    clearBreakpoints() {
        this.breakpoints.clear();
    }
    get isRunning() {
        return null !== this._runTimer;
    }
    run() {
        this.isRunning || (this._runTimer = setInterval(()=>{
            const e = this.currentCommand;
            if (e && this.breakpoints.has(e.line)) return clearInterval(this._runTimer), this._runTimer = null, void (null !== this.runStateCallback && this.runStateCallback());
            this.stepNext(!0) || (clearInterval(this._runTimer), this._runTimer = null, null !== this.runStateCallback && this.runStateCallback());
        }, 0), null !== this.runStateCallback && this.runStateCallback());
    }
    pause() {
        null !== this._runTimer && (clearInterval(this._runTimer), this._runTimer = null, null !== this.runStateCallback && this.runStateCallback());
    }
    _setOverrides(e, t) {
        for(const n in e){
            const s = e[n], r = this._exec.reflection.getOverrideInfo(n);
            null !== r ? (null === r.type && (r.type = this._exec.getTypeInfo('u32')), 'u32' === r.type.name || 'i32' === r.type.name || 'f32' === r.type.name || 'f16' === r.type.name ? t.setVariable(n, new Oe(s, r.type)) : 'bool' === r.type.name ? t.setVariable(n, new Oe(s ? 1 : 0, r.type)) : 'vec2' === r.type.name || 'vec3' === r.type.name || 'vec4' === r.type.name || 'vec2f' === r.type.name || 'vec3f' === r.type.name || 'vec4f' === r.type.name || 'vec2i' === r.type.name || 'vec3i' === r.type.name || 'vec4i' === r.type.name || 'vec2u' === r.type.name || 'vec3u' === r.type.name || 'vec4u' === r.type.name || 'vec2h' === r.type.name || 'vec3h' === r.type.name || 'vec4h' === r.type.name ? t.setVariable(n, new Fe(s, r.type)) : console.error(`Invalid constant type for ${n}`)) : console.error(`Override ${n} does not exist in the shader.`);
        }
    }
    debugWorkgroup(e, t, n, s, r) {
        this._execStack = new At;
        const a = this._exec.context;
        a.currentFunctionName = e, this._dispatchId = t, (r = null != r ? r : {}).constants && this._setOverrides(r.constants, a), this._exec._execStatements(this._exec.ast, a);
        const i = a.getFunction(e);
        if (!i) return console.error(`Function ${e} not found`), !1;
        if ('number' == typeof n) n = [
            n,
            1,
            1
        ];
        else {
            if (0 === n.length) return console.error('Invalid dispatch count'), !1;
            1 === n.length ? n = [
                n[0],
                1,
                1
            ] : 2 === n.length ? n = [
                n[0],
                n[1],
                1
            ] : n.length > 3 && (n = [
                n[0],
                n[1],
                n[2]
            ]);
        }
        const o = n[2], l = n[1], c = n[0], u = this._exec.typeInfo.vec3u;
        a.setVariable('@num_workgroups', new Fe(n, u));
        for(const e in s)for(const t in s[e]){
            const n = s[e][t];
            a.variables.forEach((s)=>{
                var r;
                const a = s.node;
                if (null == a ? void 0 : a.attributes) {
                    let i = null, o = null;
                    for (const e of a.attributes)'binding' === e.name ? i = e.value : 'group' === e.name && (o = e.value);
                    if (t == i && e == o) {
                        if (void 0 !== n.texture && void 0 !== n.descriptor) {
                            const e = new Pe(n.texture, this._exec.getTypeInfo(a.type), n.descriptor, null !== (r = n.texture.view) && void 0 !== r ? r : null);
                            s.value = e;
                        } else void 0 !== n.uniform ? s.value = new Ue(n.uniform, this._exec.getTypeInfo(a.type)) : s.value = new Ue(n, this._exec.getTypeInfo(a.type));
                    }
                }
            });
        }
        let h = !1;
        for(let e = 0; e < o && !h; ++e)for(let t = 0; t < l && !h; ++t)for(let n = 0; n < c && !h; ++n)if (a.setVariable('@workgroup_id', new Fe([
            n,
            t,
            e
        ], u)), this._dispatchWorkgroup(i, [
            n,
            t,
            e
        ], a)) {
            h = !0;
            break;
        }
        return h;
    }
    _shouldExecuteNextCommand() {
        const e = this.currentCommand;
        if (null === e) return !1;
        if (e instanceof It) {
            if (null === e.condition) return !0;
        } else if (e instanceof bt || e instanceof vt) return !0;
        return !1;
    }
    stepInto() {
        this.isRunning || this.stepNext(!0);
    }
    stepOver() {
        this.isRunning || this.stepNext(!1);
    }
    stepOut() {
        const e = this.currentState;
        if (null === e) return;
        const t = e.parent;
        this.isRunning && (clearInterval(this._runTimer), this._runTimer = null), this._runTimer = setInterval(()=>{
            const e = this.currentCommand;
            if (e && this.breakpoints.has(e.line)) return clearInterval(this._runTimer), this._runTimer = null, void (null !== this.runStateCallback && this.runStateCallback());
            this.stepNext(!0) || (clearInterval(this._runTimer), this._runTimer = null, null !== this.runStateCallback && this.runStateCallback());
            this.currentState === t && (clearInterval(this._runTimer), this._runTimer = null, null !== this.runStateCallback && this.runStateCallback());
        }, 0), null !== this.runStateCallback && this.runStateCallback();
    }
    stepNext(e = !0) {
        if (!this._execStack) {
            this._execStack = new At;
            const e = this._createState(this._exec.ast, this._exec.context);
            this._execStack.states.push(e);
        }
        for(;;){
            if (this._execStack.isEmpty) return !1;
            let t = this._execStack.last;
            if (null === t) return !1;
            if (t.isAtEnd) {
                if (this._execStack.pop(), this._execStack.isEmpty) return !1;
                t = this._execStack.last;
            }
            const n = t.getNextCommand();
            if (null !== n) {
                if (e && n instanceof yt) {
                    const e = n.node, s = t.context.getFunction(e.name);
                    if (!s) continue;
                    const r = this._createState(s.node.body, t.context.clone(), t);
                    for(let t = 0; t < s.node.args.length; ++t){
                        const n = s.node.args[t], a = this._exec.evalExpression(e.args[t], r.context);
                        r.context.createVariable(n.name, a, n);
                    }
                    if (r.parentCallExpr = e, this._execStack.states.push(r), r.context.currentFunctionName = s.name, this._shouldExecuteNextCommand()) continue;
                    return !0;
                }
                if (n instanceof xt) {
                    const s = n.node;
                    if (e && s instanceof G) {
                        const e = t.context.getFunction(s.name);
                        if (e) {
                            const n = this._createState(e.node.body, t.context.clone(), t);
                            for(let t = 0; t < e.node.args.length; ++t){
                                const r = e.node.args[t], a = this._exec.evalExpression(s.args[t], n.context);
                                n.context.createVariable(r.name, a, r);
                            }
                            if (this._execStack.states.push(n), n.context.currentFunctionName = e.name, this._shouldExecuteNextCommand()) continue;
                            return !0;
                        }
                    }
                    const r = this._exec.execStatement(s, t.context);
                    if (null != r && !(r instanceof Ne)) {
                        let e = t;
                        for(; e;){
                            if (e.parentCallExpr) {
                                e.parentCallExpr.setCachedReturnValue(r);
                                break;
                            }
                            e = e.parent;
                        }
                        if (null === e && console.error('Could not find CallExpr to store return value in'), this._shouldExecuteNextCommand()) continue;
                        return !0;
                    }
                } else {
                    if (n instanceof bt) continue;
                    if (n instanceof vt) continue;
                    if (n instanceof wt) {
                        const e = n.id;
                        for(; !this._execStack.isEmpty;){
                            t = this._execStack.last;
                            for(let n = t.commands.length - 1; n >= 0; --n){
                                const s = t.commands[n];
                                if (s instanceof bt && s.id === e) return t.current = n + 1, !0;
                            }
                            this._execStack.pop();
                        }
                        return console.error('Continue statement used outside of a loop'), !1;
                    }
                    if (n instanceof kt) {
                        const e = n.id;
                        if (n.condition) {
                            const e = this._exec.evalExpression(n.condition, t.context);
                            if (!(e instanceof Oe)) return console.error('Condition must be a scalar'), !1;
                            if (!e.value) {
                                if (this._shouldExecuteNextCommand()) continue;
                                return !0;
                            }
                        }
                        for(; !this._execStack.isEmpty;){
                            t = this._execStack.last;
                            for(let n = t.commands.length - 1; n >= 0; --n){
                                const s = t.commands[n];
                                if (s instanceof vt && s.id === e) return t.current = n + 1, !0;
                            }
                            this._execStack.pop();
                        }
                        return console.error('Break statement used outside of a loop'), !1;
                    }
                    if (n instanceof It) {
                        if (n.condition) {
                            const e = this._exec.evalExpression(n.condition, t.context);
                            if (!(e instanceof Oe)) return console.error('Condition must be a scalar'), !1;
                            if (e.value) {
                                if (this._shouldExecuteNextCommand()) continue;
                                return !0;
                            }
                        }
                        if (t.current = n.position, this._shouldExecuteNextCommand()) continue;
                        return !0;
                    }
                    if (n instanceof Tt) {
                        const e = this._createState(n.statements, t.context.clone(), t);
                        this._execStack.states.push(e);
                        continue;
                    }
                }
                if (t.isAtEnd && (this._execStack.pop(), this._execStack.isEmpty)) return !1;
                if (!this._shouldExecuteNextCommand()) return !0;
            }
        }
    }
    _dispatchWorkgroup(e, t, n) {
        const s = [
            1,
            1,
            1
        ];
        for (const t of e.node.attributes)if ('workgroup_size' === t.name) {
            if (Array.isArray(t.value)) {
                if (t.value.length > 0) {
                    const e = n.getVariableValue(t.value[0]);
                    s[0] = e instanceof Oe ? e.value : parseInt(t.value[0]);
                }
                if (t.value.length > 1) {
                    const e = n.getVariableValue(t.value[1]);
                    s[1] = e instanceof Oe ? e.value : parseInt(t.value[1]);
                }
                if (t.value.length > 2) {
                    const e = n.getVariableValue(t.value[2]);
                    s[2] = e instanceof Oe ? e.value : parseInt(t.value[2]);
                }
            } else {
                const e = n.getVariableValue(t.value);
                e instanceof Oe ? s[0] = e.value : e instanceof Fe ? (s[0] = e.data[0], s[1] = e.data.length > 1 ? e.data[1] : 1, s[2] = e.data.length > 2 ? e.data[2] : 1) : s[0] = parseInt(t.value);
            }
        }
        const r = this._exec.typeInfo.vec3u, a = this._exec.typeInfo.u32;
        n.setVariable('@workgroup_size', new Fe(s, r));
        const i = s[0], o = s[1], l = s[2];
        let c = !1;
        for(let e = 0, u = 0; e < l && !c; ++e)for(let l = 0; l < o && !c; ++l)for(let o = 0; o < i && !c; ++o, ++u){
            const i = [
                o,
                l,
                e
            ], h = [
                o + t[0] * s[0],
                l + t[1] * s[1],
                e + t[2] * s[2]
            ];
            if (n.setVariable('@local_invocation_id', new Fe(i, r)), n.setVariable('@global_invocation_id', new Fe(h, r)), n.setVariable('@local_invocation_index', new Oe(u, a)), h[0] === this._dispatchId[0] && h[1] === this._dispatchId[1] && h[2] === this._dispatchId[2]) {
                c = !0;
                break;
            }
        }
        return c && this._dispatchExec(e, n), c;
    }
    _dispatchExec(e, t) {
        for (const n of e.node.args)for (const e of n.attributes)if ('builtin' === e.name) {
            const s = `@${e.value}`, r = t.getVariable(s);
            null !== r && t.variables.set(n.name, r);
        }
        const n = this._createState(e.node.body, t);
        this._execStack.states.push(n);
    }
    _createState(e, t, n) {
        const s = new St(t, null != n ? n : null);
        for (const t of e)if (t instanceof M || t instanceof B || t instanceof U || t instanceof R) {
            const e = [];
            this._collectFunctionCalls(t.value, e);
            for (const n of e)s.commands.push(new yt(n, t));
            s.commands.push(new xt(t));
        } else if (t instanceof G) {
            const e = [];
            for (const n of t.args)this._collectFunctionCalls(n, e);
            for (const n of e)s.commands.push(new yt(n, t));
            s.commands.push(new xt(t));
        } else if (t instanceof Q) {
            const e = [];
            this._collectFunctionCalls(t.value, e);
            for (const n of e)s.commands.push(new yt(n, t));
            s.commands.push(new xt(t));
        } else if (t instanceof z) s.commands.push(new xt(t));
        else {
            if (t instanceof C) {
                const e = new ot(t);
                s.context.functions.set(t.name, e);
                continue;
            }
            if (t instanceof Z) {
                const e = [];
                this._collectFunctionCalls(t.condition, e);
                for (const n of e)s.commands.push(new yt(n, t));
                let n = new It(t.condition, 0, t.line);
                s.commands.push(n), t.body.length > 0 && s.commands.push(new Tt(t.body));
                const r = new It(null, 0, t.line);
                s.commands.push(r);
                for (const e of t.elseif){
                    n.position = s.commands.length;
                    const a = [];
                    this._collectFunctionCalls(e.condition, a);
                    for (const e of a)s.commands.push(new yt(e, t));
                    n = new It(e.condition, 0, e.line), s.commands.push(n), e.body.length > 0 && s.commands.push(new Tt(e.body)), s.commands.push(r);
                }
                n.position = s.commands.length, t.else && s.commands.push(new Tt(t.else)), r.position = s.commands.length;
            } else if (t instanceof j) {
                const e = [];
                this._collectFunctionCalls(t.condition, e);
                for (const n of e)s.commands.push(new yt(n, t));
                let n = null;
                for (const e of t.cases){
                    if (e instanceof Ae) {
                        n = e;
                        break;
                    }
                    if (e instanceof Se) {
                        for (const t of e.selectors)if (t instanceof Te) {
                            n = e;
                            break;
                        }
                    }
                }
                const r = [];
                for (const e of t.cases){
                    if (e === n) continue;
                    if (!(e instanceof Se)) continue;
                    let a = null;
                    for (const n of e.selectors){
                        let e = new ke('==', t.condition, n);
                        a && (e = new ke('||', a, e)), a = e;
                    }
                    const i = new It(a, 0, e.line);
                    s.commands.push(i), e.body.length > 0 && s.commands.push(new Tt(e.body));
                    const o = new It(null, 0, e.line);
                    r.push(o), s.commands.push(o), i.position = s.commands.length;
                }
                n && s.commands.push(new Tt(n.body)), s.commands.push(new vt(t.id));
                const a = s.commands.length;
                for(let e = 0; e < r.length; ++e)r[e].position = a;
            } else if (t instanceof N) {
                const e = [];
                s.commands.push(new bt(t.id)), this._collectFunctionCalls(t.condition, e);
                for (const n of e)s.commands.push(new yt(n, t));
                const n = new It(t.condition, 0, t.line);
                s.commands.push(n);
                let r = t.line;
                t.body.length > 0 && (s.commands.push(new Tt(t.body)), r = t.body[t.body.length - 1].line), s.commands.push(new It(t.condition, 0, r)), s.commands.push(new vt(t.id)), n.position = s.commands.length;
            } else if (t instanceof O) {
                t.init && s.commands.push(new xt(t.init));
                let e = s.commands.length;
                null === t.increment && s.commands.push(new bt(t.id));
                let n = null;
                if (t.condition) {
                    const e = [];
                    this._collectFunctionCalls(t.condition, e);
                    for (const n of e)s.commands.push(new yt(n, t));
                    n = new It(t.condition, 0, t.line), s.commands.push(n);
                }
                let r = t.line;
                t.body.length > 0 && (s.commands.push(new Tt(t.body)), r = t.body[t.body.length - 1].line), t.increment && (s.commands.push(new bt(t.id)), s.commands.push(new xt(t.increment))), s.commands.push(new It(null, e, r)), s.commands.push(new vt(t.id)), n.position = s.commands.length;
            } else if (t instanceof X) {
                let e = s.commands.length;
                t.continuing || s.commands.push(new bt(t.id));
                let n = t.line;
                t.body.length > 0 && (s.commands.push(new Tt(t.body)), n = t.body[t.body.length - 1].line), s.commands.push(new It(null, e, n)), s.commands.push(new vt(t.id));
            } else t instanceof V ? (s.commands.push(new bt(t.loopId)), s.commands.push(new Tt(t.body))) : t instanceof se ? s.commands.push(new wt(t.loopId, t)) : t instanceof ne ? s.commands.push(new kt(t.loopId, t.condition, t)) : t instanceof D ? s.commands.push(new xt(t)) : t instanceof ie || console.error(`TODO: statement type ${t.constructor.name}`);
        }
        return s;
    }
    _collectFunctionCalls(e, t) {
        if (e instanceof de) {
            if (e.args) for (const n of e.args)this._collectFunctionCalls(n, t);
            e.isBuiltin || t.push(e);
        } else if (e instanceof ke) this._collectFunctionCalls(e.left, t), this._collectFunctionCalls(e.right, t);
        else if (e instanceof we) this._collectFunctionCalls(e.right, t);
        else if (e instanceof pe) {
            if (e.args) for (const n of e.args)this._collectFunctionCalls(n, t);
        } else e instanceof xe ? this._collectFunctionCalls(e.value, t) : e instanceof be ? this._collectFunctionCalls(e.index, t) : ge || console.error(`TODO: expression type ${e.constructor.name}`);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2i0Fi":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Calculate WebGL 64 bit float
 * @param a  - the input float number
 * @param out - the output array. If not supplied, a new array is created.
 * @param startIndex - the index in the output array to fill from. Default 0.
 * @returns - the fp64 representation of the input number
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fp64ify", ()=>fp64ify);
/**
 * Calculate the low part of a WebGL 64 bit float
 * @param a the input float number
 * @returns the lower 32 bit of the number
 */ parcelHelpers.export(exports, "fp64LowPart", ()=>fp64LowPart);
/**
 * Calculate WebGL 64 bit matrix (transposed "Float64Array")
 * @param matrix  the input matrix
 * @returns the fp64 representation of the input matrix
 */ parcelHelpers.export(exports, "fp64ifyMatrix4", ()=>fp64ifyMatrix4);
function fp64ify(a, out = [], startIndex = 0) {
    const hiPart = Math.fround(a);
    const loPart = a - hiPart;
    out[startIndex] = hiPart;
    out[startIndex + 1] = loPart;
    return out;
}
function fp64LowPart(a) {
    return a - Math.fround(a);
}
function fp64ifyMatrix4(matrix) {
    // Transpose the projection matrix to column major for GLSL.
    const matrixFP64 = new Float32Array(32);
    for(let i = 0; i < 4; ++i)for(let j = 0; j < 4; ++j){
        const index = i * 4 + j;
        fp64ify(matrix[j * 4 + i], matrixFP64, index * 2);
    }
    return matrixFP64;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7IenJ":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// import {ShaderModule} from '../../types';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fp32", ()=>fp32);
const fp32shader = /* glsl */ `\
#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND

// All these functions are for substituting tan() function from Intel GPU only
const float TWO_PI = 6.2831854820251465;
const float PI_2 = 1.5707963705062866;
const float PI_16 = 0.1963495463132858;

const float SIN_TABLE_0 = 0.19509032368659973;
const float SIN_TABLE_1 = 0.3826834261417389;
const float SIN_TABLE_2 = 0.5555702447891235;
const float SIN_TABLE_3 = 0.7071067690849304;

const float COS_TABLE_0 = 0.9807852506637573;
const float COS_TABLE_1 = 0.9238795042037964;
const float COS_TABLE_2 = 0.8314695954322815;
const float COS_TABLE_3 = 0.7071067690849304;

const float INVERSE_FACTORIAL_3 = 1.666666716337204e-01; // 1/3!
const float INVERSE_FACTORIAL_5 = 8.333333767950535e-03; // 1/5!
const float INVERSE_FACTORIAL_7 = 1.9841270113829523e-04; // 1/7!
const float INVERSE_FACTORIAL_9 = 2.75573188446287533e-06; // 1/9!

float sin_taylor_fp32(float a) {
  float r, s, t, x;

  if (a == 0.0) {
    return 0.0;
  }

  x = -a * a;
  s = a;
  r = a;

  r = r * x;
  t = r * INVERSE_FACTORIAL_3;
  s = s + t;

  r = r * x;
  t = r * INVERSE_FACTORIAL_5;
  s = s + t;

  r = r * x;
  t = r * INVERSE_FACTORIAL_7;
  s = s + t;

  r = r * x;
  t = r * INVERSE_FACTORIAL_9;
  s = s + t;

  return s;
}

void sincos_taylor_fp32(float a, out float sin_t, out float cos_t) {
  if (a == 0.0) {
    sin_t = 0.0;
    cos_t = 1.0;
  }
  sin_t = sin_taylor_fp32(a);
  cos_t = sqrt(1.0 - sin_t * sin_t);
}

float tan_taylor_fp32(float a) {
    float sin_a;
    float cos_a;

    if (a == 0.0) {
        return 0.0;
    }

    // 2pi range reduction
    float z = floor(a / TWO_PI);
    float r = a - TWO_PI * z;

    float t;
    float q = floor(r / PI_2 + 0.5);
    int j = int(q);

    if (j < -2 || j > 2) {
        return 1.0 / 0.0;
    }

    t = r - PI_2 * q;

    q = floor(t / PI_16 + 0.5);
    int k = int(q);
    int abs_k = int(abs(float(k)));

    if (abs_k > 4) {
        return 1.0 / 0.0;
    } else {
        t = t - PI_16 * q;
    }

    float u = 0.0;
    float v = 0.0;

    float sin_t, cos_t;
    float s, c;
    sincos_taylor_fp32(t, sin_t, cos_t);

    if (k == 0) {
        s = sin_t;
        c = cos_t;
    } else {
        if (abs(float(abs_k) - 1.0) < 0.5) {
            u = COS_TABLE_0;
            v = SIN_TABLE_0;
        } else if (abs(float(abs_k) - 2.0) < 0.5) {
            u = COS_TABLE_1;
            v = SIN_TABLE_1;
        } else if (abs(float(abs_k) - 3.0) < 0.5) {
            u = COS_TABLE_2;
            v = SIN_TABLE_2;
        } else if (abs(float(abs_k) - 4.0) < 0.5) {
            u = COS_TABLE_3;
            v = SIN_TABLE_3;
        }
        if (k > 0) {
            s = u * sin_t + v * cos_t;
            c = u * cos_t - v * sin_t;
        } else {
            s = u * sin_t - v * cos_t;
            c = u * cos_t + v * sin_t;
        }
    }

    if (j == 0) {
        sin_a = s;
        cos_a = c;
    } else if (j == 1) {
        sin_a = c;
        cos_a = -s;
    } else if (j == -1) {
        sin_a = -c;
        cos_a = s;
    } else {
        sin_a = -s;
        cos_a = -c;
    }
    return sin_a / cos_a;
}
#endif

float tan_fp32(float a) {
#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND
  return tan_taylor_fp32(a);
#else
  return tan(a);
#endif
}
`;
const fp32 = {
    name: 'fp32',
    vs: fp32shader
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"g1i3d":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fp64arithmetic", ()=>fp64arithmetic);
parcelHelpers.export(exports, "fp64", ()=>fp64);
parcelHelpers.export(exports, "fp64ify", ()=>(0, _fp64UtilsJs.fp64ify));
parcelHelpers.export(exports, "fp64LowPart", ()=>(0, _fp64UtilsJs.fp64LowPart));
parcelHelpers.export(exports, "fp64ifyMatrix4", ()=>(0, _fp64UtilsJs.fp64ifyMatrix4));
var _fp64UtilsJs = require("../../../modules/math/fp64/fp64-utils.js");
var _fp64ArithmeticGlslJs = require("./fp64-arithmetic-glsl.js");
var _fp64FunctionsGlslJs = require("./fp64-functions-glsl.js");
const defaultUniforms = {
    // Used in LUMA_FP64_CODE_ELIMINATION_WORKAROUND
    ONE: 1.0
};
const fp64arithmetic = {
    name: 'fp64arithmetic',
    vs: (0, _fp64ArithmeticGlslJs.fp64arithmeticShader),
    defaultUniforms,
    uniformTypes: {
        ONE: 'f32'
    },
    fp64ify: // Additional Functions
    (0, _fp64UtilsJs.fp64ify),
    fp64LowPart: (0, _fp64UtilsJs.fp64LowPart),
    fp64ifyMatrix4: (0, _fp64UtilsJs.fp64ifyMatrix4)
};
const fp64 = {
    name: 'fp64',
    vs: (0, _fp64FunctionsGlslJs.fp64functionShader),
    dependencies: [
        fp64arithmetic
    ],
    fp64ify: // Additional Functions
    (0, _fp64UtilsJs.fp64ify),
    fp64LowPart: (0, _fp64UtilsJs.fp64LowPart),
    fp64ifyMatrix4: (0, _fp64UtilsJs.fp64ifyMatrix4)
};

},{"../../../modules/math/fp64/fp64-utils.js":"2i0Fi","./fp64-arithmetic-glsl.js":"c5mr4","./fp64-functions-glsl.js":"esKS6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"c5mr4":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fp64arithmeticShader", ()=>fp64arithmeticShader);
const fp64arithmeticShader = /* glsl */ `\

uniform fp64arithmeticUniforms {
  uniform float ONE;
} fp64;

/*
About LUMA_FP64_CODE_ELIMINATION_WORKAROUND

The purpose of this workaround is to prevent shader compilers from
optimizing away necessary arithmetic operations by swapping their sequences
or transform the equation to some 'equivalent' form.

The method is to multiply an artifical variable, ONE, which will be known to
the compiler to be 1 only at runtime. The whole expression is then represented
as a polynomial with respective to ONE. In the coefficients of all terms, only one a
and one b should appear

err = (a + b) * ONE^6 - a * ONE^5 - (a + b) * ONE^4 + a * ONE^3 - b - (a + b) * ONE^2 + a * ONE
*/

// Divide float number to high and low floats to extend fraction bits
vec2 split(float a) {
  const float SPLIT = 4097.0;
  float t = a * SPLIT;
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float a_hi = t * fp64.ONE - (t - a);
  float a_lo = a * fp64.ONE - a_hi;
#else
  float a_hi = t - (t - a);
  float a_lo = a - a_hi;
#endif
  return vec2(a_hi, a_lo);
}

// Divide float number again when high float uses too many fraction bits
vec2 split2(vec2 a) {
  vec2 b = split(a.x);
  b.y += a.y;
  return b;
}

// Special sum operation when a > b
vec2 quickTwoSum(float a, float b) {
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float sum = (a + b) * fp64.ONE;
  float err = b - (sum - a) * fp64.ONE;
#else
  float sum = a + b;
  float err = b - (sum - a);
#endif
  return vec2(sum, err);
}

// General sum operation
vec2 twoSum(float a, float b) {
  float s = (a + b);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float v = (s * fp64.ONE - a) * fp64.ONE;
  float err = (a - (s - v) * fp64.ONE) * fp64.ONE * fp64.ONE * fp64.ONE + (b - v);
#else
  float v = s - a;
  float err = (a - (s - v)) + (b - v);
#endif
  return vec2(s, err);
}

vec2 twoSub(float a, float b) {
  float s = (a - b);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float v = (s * fp64.ONE - a) * fp64.ONE;
  float err = (a - (s - v) * fp64.ONE) * fp64.ONE * fp64.ONE * fp64.ONE - (b + v);
#else
  float v = s - a;
  float err = (a - (s - v)) - (b + v);
#endif
  return vec2(s, err);
}

vec2 twoSqr(float a) {
  float prod = a * a;
  vec2 a_fp64 = split(a);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float err = ((a_fp64.x * a_fp64.x - prod) * fp64.ONE + 2.0 * a_fp64.x *
    a_fp64.y * fp64.ONE * fp64.ONE) + a_fp64.y * a_fp64.y * fp64.ONE * fp64.ONE * fp64.ONE;
#else
  float err = ((a_fp64.x * a_fp64.x - prod) + 2.0 * a_fp64.x * a_fp64.y) + a_fp64.y * a_fp64.y;
#endif
  return vec2(prod, err);
}

vec2 twoProd(float a, float b) {
  float prod = a * b;
  vec2 a_fp64 = split(a);
  vec2 b_fp64 = split(b);
  float err = ((a_fp64.x * b_fp64.x - prod) + a_fp64.x * b_fp64.y +
    a_fp64.y * b_fp64.x) + a_fp64.y * b_fp64.y;
  return vec2(prod, err);
}

vec2 sum_fp64(vec2 a, vec2 b) {
  vec2 s, t;
  s = twoSum(a.x, b.x);
  t = twoSum(a.y, b.y);
  s.y += t.x;
  s = quickTwoSum(s.x, s.y);
  s.y += t.y;
  s = quickTwoSum(s.x, s.y);
  return s;
}

vec2 sub_fp64(vec2 a, vec2 b) {
  vec2 s, t;
  s = twoSub(a.x, b.x);
  t = twoSub(a.y, b.y);
  s.y += t.x;
  s = quickTwoSum(s.x, s.y);
  s.y += t.y;
  s = quickTwoSum(s.x, s.y);
  return s;
}

vec2 mul_fp64(vec2 a, vec2 b) {
  vec2 prod = twoProd(a.x, b.x);
  // y component is for the error
  prod.y += a.x * b.y;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  prod = split2(prod);
#endif
  prod = quickTwoSum(prod.x, prod.y);
  prod.y += a.y * b.x;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  prod = split2(prod);
#endif
  prod = quickTwoSum(prod.x, prod.y);
  return prod;
}

vec2 div_fp64(vec2 a, vec2 b) {
  float xn = 1.0 / b.x;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  vec2 yn = mul_fp64(a, vec2(xn, 0));
#else
  vec2 yn = a * xn;
#endif
  float diff = (sub_fp64(a, mul_fp64(b, yn))).x;
  vec2 prod = twoProd(xn, diff);
  return sum_fp64(yn, prod);
}

vec2 sqrt_fp64(vec2 a) {
  if (a.x == 0.0 && a.y == 0.0) return vec2(0.0, 0.0);
  if (a.x < 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);

  float x = 1.0 / sqrt(a.x);
  float yn = a.x * x;
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  vec2 yn_sqr = twoSqr(yn) * fp64.ONE;
#else
  vec2 yn_sqr = twoSqr(yn);
#endif
  float diff = sub_fp64(a, yn_sqr).x;
  vec2 prod = twoProd(x * 0.5, diff);
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  return sum_fp64(split(yn), prod);
#else
  return sum_fp64(vec2(yn, 0.0), prod);
#endif
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"esKS6":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fp64functionShader", ()=>fp64functionShader);
const fp64functionShader = /* glsl */ `\
const vec2 E_FP64 = vec2(2.7182817459106445e+00, 8.254840366817007e-08);
const vec2 LOG2_FP64 = vec2(0.6931471824645996e+00, -1.9046542121259336e-09);
const vec2 PI_FP64 = vec2(3.1415927410125732, -8.742278012618954e-8);
const vec2 TWO_PI_FP64 = vec2(6.2831854820251465, -1.7484556025237907e-7);
const vec2 PI_2_FP64 = vec2(1.5707963705062866, -4.371139006309477e-8);
const vec2 PI_4_FP64 = vec2(0.7853981852531433, -2.1855695031547384e-8);
const vec2 PI_16_FP64 = vec2(0.19634954631328583, -5.463923757886846e-9);
const vec2 PI_16_2_FP64 = vec2(0.39269909262657166, -1.0927847515773692e-8);
const vec2 PI_16_3_FP64 = vec2(0.5890486240386963, -1.4906100798128818e-9);
const vec2 PI_180_FP64 = vec2(0.01745329238474369, 1.3519960498364902e-10);

const vec2 SIN_TABLE_0_FP64 = vec2(0.19509032368659973, -1.6704714833615242e-9);
const vec2 SIN_TABLE_1_FP64 = vec2(0.3826834261417389, 6.22335089017767e-9);
const vec2 SIN_TABLE_2_FP64 = vec2(0.5555702447891235, -1.1769521357507529e-8);
const vec2 SIN_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617041793133e-8);

const vec2 COS_TABLE_0_FP64 = vec2(0.9807852506637573, 2.9739473106360492e-8);
const vec2 COS_TABLE_1_FP64 = vec2(0.9238795042037964, 2.8307490351764386e-8);
const vec2 COS_TABLE_2_FP64 = vec2(0.8314695954322815, 1.6870263741530778e-8);
const vec2 COS_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617152815436e-8);

const vec2 INVERSE_FACTORIAL_3_FP64 = vec2(1.666666716337204e-01, -4.967053879312289e-09); // 1/3!
const vec2 INVERSE_FACTORIAL_4_FP64 = vec2(4.16666679084301e-02, -1.2417634698280722e-09); // 1/4!
const vec2 INVERSE_FACTORIAL_5_FP64 = vec2(8.333333767950535e-03, -4.34617203337595e-10); // 1/5!
const vec2 INVERSE_FACTORIAL_6_FP64 = vec2(1.3888889225199819e-03, -3.3631094437103215e-11); // 1/6!
const vec2 INVERSE_FACTORIAL_7_FP64 = vec2(1.9841270113829523e-04,  -2.725596874933456e-12); // 1/7!
const vec2 INVERSE_FACTORIAL_8_FP64 = vec2(2.4801587642286904e-05, -3.406996025904184e-13); // 1/8!
const vec2 INVERSE_FACTORIAL_9_FP64 = vec2(2.75573188446287533e-06, 3.7935713937038186e-14); // 1/9!
const vec2 INVERSE_FACTORIAL_10_FP64 = vec2(2.755731998149713e-07, -7.575112367869873e-15); // 1/10!

float nint(float d) {
    if (d == floor(d)) return d;
    return floor(d + 0.5);
}

vec2 nint_fp64(vec2 a) {
    float hi = nint(a.x);
    float lo;
    vec2 tmp;
    if (hi == a.x) {
        lo = nint(a.y);
        tmp = quickTwoSum(hi, lo);
    } else {
        lo = 0.0;
        if (abs(hi - a.x) == 0.5 && a.y < 0.0) {
            hi -= 1.0;
        }
        tmp = vec2(hi, lo);
    }
    return tmp;
}

/* k_power controls how much range reduction we would like to have
Range reduction uses the following method:
assume a = k_power * r + m * log(2), k and m being integers.
Set k_power = 4 (we can choose other k to trade accuracy with performance.
we only need to calculate exp(r) and using exp(a) = 2^m * exp(r)^k_power;
*/

vec2 exp_fp64(vec2 a) {
  // We need to make sure these two numbers match
  // as bit-wise shift is not available in GLSL 1.0
  const int k_power = 4;
  const float k = 16.0;

  const float inv_k = 1.0 / k;

  if (a.x <= -88.0) return vec2(0.0, 0.0);
  if (a.x >= 88.0) return vec2(1.0 / 0.0, 1.0 / 0.0);
  if (a.x == 0.0 && a.y == 0.0) return vec2(1.0, 0.0);
  if (a.x == 1.0 && a.y == 0.0) return E_FP64;

  float m = floor(a.x / LOG2_FP64.x + 0.5);
  vec2 r = sub_fp64(a, mul_fp64(LOG2_FP64, vec2(m, 0.0))) * inv_k;
  vec2 s, t, p;

  p = mul_fp64(r, r);
  s = sum_fp64(r, p * 0.5);
  p = mul_fp64(p, r);
  t = mul_fp64(p, INVERSE_FACTORIAL_3_FP64);

  s = sum_fp64(s, t);
  p = mul_fp64(p, r);
  t = mul_fp64(p, INVERSE_FACTORIAL_4_FP64);

  s = sum_fp64(s, t);
  p = mul_fp64(p, r);
  t = mul_fp64(p, INVERSE_FACTORIAL_5_FP64);

  // s = sum_fp64(s, t);
  // p = mul_fp64(p, r);
  // t = mul_fp64(p, INVERSE_FACTORIAL_6_FP64);

  // s = sum_fp64(s, t);
  // p = mul_fp64(p, r);
  // t = mul_fp64(p, INVERSE_FACTORIAL_7_FP64);

  s = sum_fp64(s, t);


  // At this point, s = exp(r) - 1; but after following 4 recursions, we will get exp(r) ^ 512 - 1.
  for (int i = 0; i < k_power; i++) {
    s = sum_fp64(s * 2.0, mul_fp64(s, s));
  }

#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
  s = sum_fp64(s, vec2(fp64.ONE, 0.0));
#else
  s = sum_fp64(s, vec2(1.0, 0.0));
#endif

  return s * pow(2.0, m);
//   return r;
}

vec2 log_fp64(vec2 a)
{
  if (a.x == 1.0 && a.y == 0.0) return vec2(0.0, 0.0);
  if (a.x <= 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);
  vec2 x = vec2(log(a.x), 0.0);
  vec2 s;
#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
  s = vec2(fp64.ONE, 0.0);
#else
  s = vec2(1.0, 0.0);
#endif

  x = sub_fp64(sum_fp64(x, mul_fp64(a, exp_fp64(-x))), s);
  return x;
}

vec2 sin_taylor_fp64(vec2 a) {
  vec2 r, s, t, x;

  if (a.x == 0.0 && a.y == 0.0) {
    return vec2(0.0, 0.0);
  }

  x = -mul_fp64(a, a);
  s = a;
  r = a;

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_3_FP64);
  s = sum_fp64(s, t);

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_5_FP64);
  s = sum_fp64(s, t);

  /* keep the following commented code in case we need them
  for extra accuracy from the Taylor expansion*/

  // r = mul_fp64(r, x);
  // t = mul_fp64(r, INVERSE_FACTORIAL_7_FP64);
  // s = sum_fp64(s, t);

  // r = mul_fp64(r, x);
  // t = mul_fp64(r, INVERSE_FACTORIAL_9_FP64);
  // s = sum_fp64(s, t);

  return s;
}

vec2 cos_taylor_fp64(vec2 a) {
  vec2 r, s, t, x;

  if (a.x == 0.0 && a.y == 0.0) {
    return vec2(1.0, 0.0);
  }

  x = -mul_fp64(a, a);
  r = x;
  s = sum_fp64(vec2(1.0, 0.0), r * 0.5);

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_4_FP64);
  s = sum_fp64(s, t);

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_6_FP64);
  s = sum_fp64(s, t);

  /* keep the following commented code in case we need them
  for extra accuracy from the Taylor expansion*/

  // r = mul_fp64(r, x);
  // t = mul_fp64(r, INVERSE_FACTORIAL_8_FP64);
  // s = sum_fp64(s, t);

  // r = mul_fp64(r, x);
  // t = mul_fp64(r, INVERSE_FACTORIAL_10_FP64);
  // s = sum_fp64(s, t);

  return s;
}

void sincos_taylor_fp64(vec2 a, out vec2 sin_t, out vec2 cos_t) {
  if (a.x == 0.0 && a.y == 0.0) {
    sin_t = vec2(0.0, 0.0);
    cos_t = vec2(1.0, 0.0);
  }

  sin_t = sin_taylor_fp64(a);
  cos_t = sqrt_fp64(sub_fp64(vec2(1.0, 0.0), mul_fp64(sin_t, sin_t)));
}

vec2 sin_fp64(vec2 a) {
    if (a.x == 0.0 && a.y == 0.0) {
        return vec2(0.0, 0.0);
    }

    // 2pi range reduction
    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));
    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));

    vec2 t;
    float q = floor(r.x / PI_2_FP64.x + 0.5);
    int j = int(q);

    if (j < -2 || j > 2) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    }

    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));

    q = floor(t.x / PI_16_FP64.x + 0.5);
    int k = int(q);

    if (k == 0) {
        if (j == 0) {
            return sin_taylor_fp64(t);
        } else if (j == 1) {
            return cos_taylor_fp64(t);
        } else if (j == -1) {
            return -cos_taylor_fp64(t);
        } else {
            return -sin_taylor_fp64(t);
        }
    }

    int abs_k = int(abs(float(k)));

    if (abs_k > 4) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    } else {
        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));
    }

    vec2 u = vec2(0.0, 0.0);
    vec2 v = vec2(0.0, 0.0);

#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
    if (abs(float(abs_k) - 1.0) < 0.5) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs(float(abs_k) - 2.0) < 0.5) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs(float(abs_k) - 3.0) < 0.5) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs(float(abs_k) - 4.0) < 0.5) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#else
    if (abs_k == 1) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs_k == 2) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs_k == 3) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs_k == 4) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#endif

    vec2 sin_t, cos_t;
    sincos_taylor_fp64(t, sin_t, cos_t);



    vec2 result = vec2(0.0, 0.0);
    if (j == 0) {
        if (k > 0) {
            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        }
    } else if (j == 1) {
        if (k > 0) {
            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        } else {
            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    } else if (j == -1) {
        if (k > 0) {
            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));
        } else {
            result = -sum_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));
        }
    } else {
        if (k > 0) {
            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));
        }
    }

    return result;
}

vec2 cos_fp64(vec2 a) {
    if (a.x == 0.0 && a.y == 0.0) {
        return vec2(1.0, 0.0);
    }

    // 2pi range reduction
    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));
    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));

    vec2 t;
    float q = floor(r.x / PI_2_FP64.x + 0.5);
    int j = int(q);

    if (j < -2 || j > 2) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    }

    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));

    q = floor(t.x / PI_16_FP64.x + 0.5);
    int k = int(q);

    if (k == 0) {
        if (j == 0) {
            return cos_taylor_fp64(t);
        } else if (j == 1) {
            return -sin_taylor_fp64(t);
        } else if (j == -1) {
            return sin_taylor_fp64(t);
        } else {
            return -cos_taylor_fp64(t);
        }
    }

    int abs_k = int(abs(float(k)));

    if (abs_k > 4) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    } else {
        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));
    }

    vec2 u = vec2(0.0, 0.0);
    vec2 v = vec2(0.0, 0.0);

#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
    if (abs(float(abs_k) - 1.0) < 0.5) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs(float(abs_k) - 2.0) < 0.5) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs(float(abs_k) - 3.0) < 0.5) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs(float(abs_k) - 4.0) < 0.5) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#else
    if (abs_k == 1) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs_k == 2) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs_k == 3) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs_k == 4) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#endif

    vec2 sin_t, cos_t;
    sincos_taylor_fp64(t, sin_t, cos_t);

    vec2 result = vec2(0.0, 0.0);
    if (j == 0) {
        if (k > 0) {
            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        } else {
            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    } else if (j == 1) {
        if (k > 0) {
            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));
        }
    } else if (j == -1) {
        if (k > 0) {
            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        }
    } else {
        if (k > 0) {
            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));
        } else {
            result = -sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    }

    return result;
}

vec2 tan_fp64(vec2 a) {
    vec2 sin_a;
    vec2 cos_a;

    if (a.x == 0.0 && a.y == 0.0) {
        return vec2(0.0, 0.0);
    }

    // 2pi range reduction
    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));
    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));

    vec2 t;
    float q = floor(r.x / PI_2_FP64.x + 0.5);
    int j = int(q);


    if (j < -2 || j > 2) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    }

    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));

    q = floor(t.x / PI_16_FP64.x + 0.5);
    int k = int(q);
    int abs_k = int(abs(float(k)));

    // We just can't get PI/16 * 3.0 very accurately.
    // so let's just store it
    if (abs_k > 4) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    } else {
        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));
    }


    vec2 u = vec2(0.0, 0.0);
    vec2 v = vec2(0.0, 0.0);

    vec2 sin_t, cos_t;
    vec2 s, c;
    sincos_taylor_fp64(t, sin_t, cos_t);

    if (k == 0) {
        s = sin_t;
        c = cos_t;
    } else {
#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
        if (abs(float(abs_k) - 1.0) < 0.5) {
            u = COS_TABLE_0_FP64;
            v = SIN_TABLE_0_FP64;
        } else if (abs(float(abs_k) - 2.0) < 0.5) {
            u = COS_TABLE_1_FP64;
            v = SIN_TABLE_1_FP64;
        } else if (abs(float(abs_k) - 3.0) < 0.5) {
            u = COS_TABLE_2_FP64;
            v = SIN_TABLE_2_FP64;
        } else if (abs(float(abs_k) - 4.0) < 0.5) {
            u = COS_TABLE_3_FP64;
            v = SIN_TABLE_3_FP64;
        }
#else
        if (abs_k == 1) {
            u = COS_TABLE_0_FP64;
            v = SIN_TABLE_0_FP64;
        } else if (abs_k == 2) {
            u = COS_TABLE_1_FP64;
            v = SIN_TABLE_1_FP64;
        } else if (abs_k == 3) {
            u = COS_TABLE_2_FP64;
            v = SIN_TABLE_2_FP64;
        } else if (abs_k == 4) {
            u = COS_TABLE_3_FP64;
            v = SIN_TABLE_3_FP64;
        }
#endif
        if (k > 0) {
            s = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
            c = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        } else {
            s = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
            c = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    }

    if (j == 0) {
        sin_a = s;
        cos_a = c;
    } else if (j == 1) {
        sin_a = c;
        cos_a = -s;
    } else if (j == -1) {
        sin_a = -c;
        cos_a = s;
    } else {
        sin_a = -s;
        cos_a = -c;
    }
    return div_fp64(sin_a, cos_a);
}

vec2 radians_fp64(vec2 degree) {
  return mul_fp64(degree, PI_180_FP64);
}

vec2 mix_fp64(vec2 a, vec2 b, float x) {
  vec2 range = sub_fp64(b, a);
  return sum_fp64(a, mul_fp64(range, vec2(x, 0.0)));
}

// Vector functions
// vec2 functions
void vec2_sum_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = sum_fp64(a[0], b[0]);
    out_val[1] = sum_fp64(a[1], b[1]);
}

void vec2_sub_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = sub_fp64(a[0], b[0]);
    out_val[1] = sub_fp64(a[1], b[1]);
}

void vec2_mul_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = mul_fp64(a[0], b[0]);
    out_val[1] = mul_fp64(a[1], b[1]);
}

void vec2_div_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = div_fp64(a[0], b[0]);
    out_val[1] = div_fp64(a[1], b[1]);
}

void vec2_mix_fp64(vec2 x[2], vec2 y[2], float a, out vec2 out_val[2]) {
  vec2 range[2];
  vec2_sub_fp64(y, x, range);
  vec2 portion[2];
  portion[0] = range[0] * a;
  portion[1] = range[1] * a;
  vec2_sum_fp64(x, portion, out_val);
}

vec2 vec2_length_fp64(vec2 x[2]) {
  return sqrt_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])));
}

void vec2_normalize_fp64(vec2 x[2], out vec2 out_val[2]) {
  vec2 length = vec2_length_fp64(x);
  vec2 length_vec2[2];
  length_vec2[0] = length;
  length_vec2[1] = length;

  vec2_div_fp64(x, length_vec2, out_val);
}

vec2 vec2_distance_fp64(vec2 x[2], vec2 y[2]) {
  vec2 diff[2];
  vec2_sub_fp64(x, y, diff);
  return vec2_length_fp64(diff);
}

vec2 vec2_dot_fp64(vec2 a[2], vec2 b[2]) {
  vec2 v[2];

  v[0] = mul_fp64(a[0], b[0]);
  v[1] = mul_fp64(a[1], b[1]);

  return sum_fp64(v[0], v[1]);
}

// vec3 functions
void vec3_sub_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {
  for (int i = 0; i < 3; i++) {
    out_val[i] = sum_fp64(a[i], b[i]);
  }
}

void vec3_sum_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {
  for (int i = 0; i < 3; i++) {
    out_val[i] = sum_fp64(a[i], b[i]);
  }
}

vec2 vec3_length_fp64(vec2 x[3]) {
  return sqrt_fp64(sum_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])),
    mul_fp64(x[2], x[2])));
}

vec2 vec3_distance_fp64(vec2 x[3], vec2 y[3]) {
  vec2 diff[3];
  vec3_sub_fp64(x, y, diff);
  return vec3_length_fp64(diff);
}

// vec4 functions
void vec4_fp64(vec4 a, out vec2 out_val[4]) {
  out_val[0].x = a[0];
  out_val[0].y = 0.0;

  out_val[1].x = a[1];
  out_val[1].y = 0.0;

  out_val[2].x = a[2];
  out_val[2].y = 0.0;

  out_val[3].x = a[3];
  out_val[3].y = 0.0;
}

void vec4_scalar_mul_fp64(vec2 a[4], vec2 b, out vec2 out_val[4]) {
  out_val[0] = mul_fp64(a[0], b);
  out_val[1] = mul_fp64(a[1], b);
  out_val[2] = mul_fp64(a[2], b);
  out_val[3] = mul_fp64(a[3], b);
}

void vec4_sum_fp64(vec2 a[4], vec2 b[4], out vec2 out_val[4]) {
  for (int i = 0; i < 4; i++) {
    out_val[i] = sum_fp64(a[i], b[i]);
  }
}

void vec4_dot_fp64(vec2 a[4], vec2 b[4], out vec2 out_val) {
  vec2 v[4];

  v[0] = mul_fp64(a[0], b[0]);
  v[1] = mul_fp64(a[1], b[1]);
  v[2] = mul_fp64(a[2], b[2]);
  v[3] = mul_fp64(a[3], b[3]);

  out_val = sum_fp64(sum_fp64(v[0], v[1]), sum_fp64(v[2], v[3]));
}

void mat4_vec4_mul_fp64(vec2 b[16], vec2 a[4], out vec2 out_val[4]) {
  vec2 tmp[4];

  for (int i = 0; i < 4; i++)
  {
    for (int j = 0; j < 4; j++)
    {
      tmp[j] = b[j + i * 4];
    }
    vec4_dot_fp64(a, tmp, out_val[i]);
  }
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"j6JaV":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// cyan color
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "picking", ()=>picking);
const DEFAULT_HIGHLIGHT_COLOR = [
    0,
    1,
    1,
    1
];
const vs = /* glsl */ `\
uniform pickingUniforms {
  float isActive;
  float isAttribute;
  float isHighlightActive;
  float useFloatColors;
  vec3 highlightedObjectColor;
  vec4 highlightColor;
} picking;

out vec4 picking_vRGBcolor_Avalid;

// Normalize unsigned byte color to 0-1 range
vec3 picking_normalizeColor(vec3 color) {
  return picking.useFloatColors > 0.5 ? color : color / 255.0;
}

// Normalize unsigned byte color to 0-1 range
vec4 picking_normalizeColor(vec4 color) {
  return picking.useFloatColors > 0.5 ? color : color / 255.0;
}

bool picking_isColorZero(vec3 color) {
  return dot(color, vec3(1.0)) < 0.00001;
}

bool picking_isColorValid(vec3 color) {
  return dot(color, vec3(1.0)) > 0.00001;
}

// Check if this vertex is highlighted 
bool isVertexHighlighted(vec3 vertexColor) {
  vec3 highlightedObjectColor = picking_normalizeColor(picking.highlightedObjectColor);
  return
    bool(picking.isHighlightActive) && picking_isColorZero(abs(vertexColor - highlightedObjectColor));
}

// Set the current picking color
void picking_setPickingColor(vec3 pickingColor) {
  pickingColor = picking_normalizeColor(pickingColor);

  if (bool(picking.isActive)) {
    // Use alpha as the validity flag. If pickingColor is [0, 0, 0] fragment is non-pickable
    picking_vRGBcolor_Avalid.a = float(picking_isColorValid(pickingColor));

    if (!bool(picking.isAttribute)) {
      // Stores the picking color so that the fragment shader can render it during picking
      picking_vRGBcolor_Avalid.rgb = pickingColor;
    }
  } else {
    // Do the comparison with selected item color in vertex shader as it should mean fewer compares
    picking_vRGBcolor_Avalid.a = float(isVertexHighlighted(pickingColor));
  }
}

void picking_setPickingAttribute(float value) {
  if (bool(picking.isAttribute)) {
    picking_vRGBcolor_Avalid.r = value;
  }
}

void picking_setPickingAttribute(vec2 value) {
  if (bool(picking.isAttribute)) {
    picking_vRGBcolor_Avalid.rg = value;
  }
}

void picking_setPickingAttribute(vec3 value) {
  if (bool(picking.isAttribute)) {
    picking_vRGBcolor_Avalid.rgb = value;
  }
}
`;
const fs = /* glsl */ `\
uniform pickingUniforms {
  float isActive;
  float isAttribute;
  float isHighlightActive;
  float useFloatColors;
  vec3 highlightedObjectColor;
  vec4 highlightColor;
} picking;

in vec4 picking_vRGBcolor_Avalid;

/*
 * Returns highlight color if this item is selected.
 */
vec4 picking_filterHighlightColor(vec4 color) {
  // If we are still picking, we don't highlight
  if (picking.isActive > 0.5) {
    return color;
  }

  bool selected = bool(picking_vRGBcolor_Avalid.a);

  if (selected) {
    // Blend in highlight color based on its alpha value
    float highLightAlpha = picking.highlightColor.a;
    float blendedAlpha = highLightAlpha + color.a * (1.0 - highLightAlpha);
    float highLightRatio = highLightAlpha / blendedAlpha;

    vec3 blendedRGB = mix(color.rgb, picking.highlightColor.rgb, highLightRatio);
    return vec4(blendedRGB, blendedAlpha);
  } else {
    return color;
  }
}

/*
 * Returns picking color if picking enabled else unmodified argument.
 */
vec4 picking_filterPickingColor(vec4 color) {
  if (bool(picking.isActive)) {
    if (picking_vRGBcolor_Avalid.a == 0.0) {
      discard;
    }
    return picking_vRGBcolor_Avalid;
  }
  return color;
}

/*
 * Returns picking color if picking is enabled if not
 * highlight color if this item is selected, otherwise unmodified argument.
 */
vec4 picking_filterColor(vec4 color) {
  vec4 highlightColor = picking_filterHighlightColor(color);
  return picking_filterPickingColor(highlightColor);
}
`;
const picking = {
    props: {},
    uniforms: {},
    name: 'picking',
    uniformTypes: {
        isActive: 'f32',
        isAttribute: 'f32',
        isHighlightActive: 'f32',
        useFloatColors: 'f32',
        highlightedObjectColor: 'vec3<f32>',
        highlightColor: 'vec4<f32>'
    },
    defaultUniforms: {
        isActive: false,
        isAttribute: false,
        isHighlightActive: false,
        useFloatColors: true,
        highlightedObjectColor: [
            0,
            0,
            0
        ],
        highlightColor: DEFAULT_HIGHLIGHT_COLOR
    },
    vs,
    fs,
    getUniforms
};
function getUniforms(opts = {}, prevUniforms) {
    const uniforms = {};
    if (opts.highlightedObjectColor === undefined) ;
    else if (opts.highlightedObjectColor === null) uniforms.isHighlightActive = false;
    else {
        uniforms.isHighlightActive = true;
        const highlightedObjectColor = opts.highlightedObjectColor.slice(0, 3);
        uniforms.highlightedObjectColor = highlightedObjectColor;
    }
    if (opts.highlightColor) {
        const color = Array.from(opts.highlightColor, (x)=>x / 255);
        if (!Number.isFinite(color[3])) color[3] = 1;
        uniforms.highlightColor = color;
    }
    if (opts.isActive !== undefined) {
        uniforms.isActive = Boolean(opts.isActive);
        uniforms.isAttribute = Boolean(opts.isAttribute);
    }
    if (opts.useFloatColors !== undefined) uniforms.useFloatColors = Boolean(opts.useFloatColors);
    return uniforms;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6akIe":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LIGHT_TYPE", ()=>LIGHT_TYPE);
parcelHelpers.export(exports, "lighting", ()=>lighting);
var _core = require("@luma.gl/core");
var _lightingUniformsGlslJs = require("./lighting-uniforms-glsl.js");
var _lightingUniformsWgslJs = require("./lighting-uniforms-wgsl.js");
/** Max number of supported lights (in addition to ambient light */ const MAX_LIGHTS = 3;
/** Whether to divide */ const COLOR_FACTOR = 255.0;
var LIGHT_TYPE;
(function(LIGHT_TYPE) {
    LIGHT_TYPE[LIGHT_TYPE["POINT"] = 0] = "POINT";
    LIGHT_TYPE[LIGHT_TYPE["DIRECTIONAL"] = 1] = "DIRECTIONAL";
})(LIGHT_TYPE || (LIGHT_TYPE = {}));
const lighting = {
    props: {},
    uniforms: {},
    name: 'lighting',
    defines: {
        MAX_LIGHTS
    },
    uniformTypes: {
        enabled: 'i32',
        lightType: 'i32',
        directionalLightCount: 'i32',
        pointLightCount: 'i32',
        ambientLightColor: 'vec3<f32>',
        // TODO define as arrays once we have appropriate uniformTypes
        lightColor0: 'vec3<f32>',
        lightPosition0: 'vec3<f32>',
        // TODO - could combine direction and attenuation
        lightDirection0: 'vec3<f32>',
        lightAttenuation0: 'vec3<f32>',
        lightColor1: 'vec3<f32>',
        lightPosition1: 'vec3<f32>',
        lightDirection1: 'vec3<f32>',
        lightAttenuation1: 'vec3<f32>',
        lightColor2: 'vec3<f32>',
        lightPosition2: 'vec3<f32>',
        lightDirection2: 'vec3<f32>',
        lightAttenuation2: 'vec3<f32>'
    },
    defaultUniforms: {
        enabled: 1,
        lightType: LIGHT_TYPE.POINT,
        directionalLightCount: 0,
        pointLightCount: 0,
        ambientLightColor: [
            0.1,
            0.1,
            0.1
        ],
        lightColor0: [
            1,
            1,
            1
        ],
        lightPosition0: [
            1,
            1,
            2
        ],
        // TODO - could combine direction and attenuation
        lightDirection0: [
            1,
            1,
            1
        ],
        lightAttenuation0: [
            1,
            0,
            0
        ],
        lightColor1: [
            1,
            1,
            1
        ],
        lightPosition1: [
            1,
            1,
            2
        ],
        lightDirection1: [
            1,
            1,
            1
        ],
        lightAttenuation1: [
            1,
            0,
            0
        ],
        lightColor2: [
            1,
            1,
            1
        ],
        lightPosition2: [
            1,
            1,
            2
        ],
        lightDirection2: [
            1,
            1,
            1
        ],
        lightAttenuation2: [
            1,
            0,
            0
        ]
    },
    source: (0, _lightingUniformsWgslJs.lightingUniformsWGSL),
    vs: (0, _lightingUniformsGlslJs.lightingUniformsGLSL),
    fs: (0, _lightingUniformsGlslJs.lightingUniformsGLSL),
    getUniforms
};
function getUniforms(props, prevUniforms = {}) {
    // Copy props so we can modify
    props = props ? {
        ...props
    } : props;
    // TODO legacy
    if (!props) return {
        ...lighting.defaultUniforms
    };
    // Support for array of lights. Type of light is detected by type field
    if (props.lights) props = {
        ...props,
        ...extractLightTypes(props.lights),
        lights: undefined
    };
    // Specify lights separately
    const { ambientLight, pointLights, directionalLights } = props || {};
    const hasLights = ambientLight || pointLights && pointLights.length > 0 || directionalLights && directionalLights.length > 0;
    // TODO - this may not be the correct decision
    if (!hasLights) return {
        ...lighting.defaultUniforms,
        enabled: 0
    };
    const uniforms = {
        ...lighting.defaultUniforms,
        ...prevUniforms,
        ...getLightSourceUniforms({
            ambientLight,
            pointLights,
            directionalLights
        })
    };
    if (props.enabled !== undefined) uniforms.enabled = props.enabled ? 1 : 0;
    return uniforms;
}
function getLightSourceUniforms({ ambientLight, pointLights = [], directionalLights = [] }) {
    const lightSourceUniforms = {};
    lightSourceUniforms.ambientLightColor = convertColor(ambientLight);
    let currentLight = 0;
    for (const pointLight of pointLights){
        lightSourceUniforms.lightType = LIGHT_TYPE.POINT;
        const i = currentLight;
        lightSourceUniforms[`lightColor${i}`] = convertColor(pointLight);
        lightSourceUniforms[`lightPosition${i}`] = pointLight.position;
        lightSourceUniforms[`lightAttenuation${i}`] = pointLight.attenuation || [
            1,
            0,
            0
        ];
        currentLight++;
    }
    for (const directionalLight of directionalLights){
        lightSourceUniforms.lightType = LIGHT_TYPE.DIRECTIONAL;
        const i = currentLight;
        lightSourceUniforms[`lightColor${i}`] = convertColor(directionalLight);
        lightSourceUniforms[`lightDirection${i}`] = directionalLight.direction;
        currentLight++;
    }
    if (currentLight > MAX_LIGHTS) (0, _core.log).warn('MAX_LIGHTS exceeded')();
    lightSourceUniforms.directionalLightCount = directionalLights.length;
    lightSourceUniforms.pointLightCount = pointLights.length;
    return lightSourceUniforms;
}
function extractLightTypes(lights) {
    const lightSources = {
        pointLights: [],
        directionalLights: []
    };
    for (const light of lights || [])switch(light.type){
        case 'ambient':
            // Note: Only uses last ambient light
            // TODO - add ambient light sources on CPU?
            lightSources.ambientLight = light;
            break;
        case 'directional':
            lightSources.directionalLights?.push(light);
            break;
        case 'point':
            lightSources.pointLights?.push(light);
            break;
        default:
    }
    return lightSources;
}
/** Take color 0-255 and intensity as input and output 0.0-1.0 range */ function convertColor(colorDef = {}) {
    const { color = [
        0,
        0,
        0
    ], intensity = 1.0 } = colorDef;
    return color.map((component)=>component * intensity / COLOR_FACTOR);
}

},{"@luma.gl/core":"7TxCR","./lighting-uniforms-glsl.js":"aM2Bk","./lighting-uniforms-wgsl.js":"itwC6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aM2Bk":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightingUniformsGLSL", ()=>lightingUniformsGLSL);
const lightingUniformsGLSL = /* glsl */ `\
precision highp int;

// #if (defined(SHADER_TYPE_FRAGMENT) && defined(LIGHTING_FRAGMENT)) || (defined(SHADER_TYPE_VERTEX) && defined(LIGHTING_VERTEX))
struct AmbientLight {
  vec3 color;
};

struct PointLight {
  vec3 color;
  vec3 position;
  vec3 attenuation; // 2nd order x:Constant-y:Linear-z:Exponential
};

struct DirectionalLight {
  vec3 color;
  vec3 direction;
};

uniform lightingUniforms {
  int enabled;
  int lightType;

  int directionalLightCount;
  int pointLightCount;

  vec3 ambientColor;

  vec3 lightColor0;
  vec3 lightPosition0;
  vec3 lightDirection0;
  vec3 lightAttenuation0;

  vec3 lightColor1;
  vec3 lightPosition1;
  vec3 lightDirection1;
  vec3 lightAttenuation1;

  vec3 lightColor2;
  vec3 lightPosition2;
  vec3 lightDirection2;
  vec3 lightAttenuation2;
} lighting;

PointLight lighting_getPointLight(int index) {
  switch (index) {
    case 0:
      return PointLight(lighting.lightColor0, lighting.lightPosition0, lighting.lightAttenuation0);
    case 1:
      return PointLight(lighting.lightColor1, lighting.lightPosition1, lighting.lightAttenuation1);
    case 2:
    default:  
      return PointLight(lighting.lightColor2, lighting.lightPosition2, lighting.lightAttenuation2);
  }
}

DirectionalLight lighting_getDirectionalLight(int index) {
  switch (index) {
    case 0:
      return DirectionalLight(lighting.lightColor0, lighting.lightDirection0);
    case 1:
      return DirectionalLight(lighting.lightColor1, lighting.lightDirection1);
    case 2:
    default:   
      return DirectionalLight(lighting.lightColor2, lighting.lightDirection2);
  }
} 

float getPointLightAttenuation(PointLight pointLight, float distance) {
  return pointLight.attenuation.x
       + pointLight.attenuation.y * distance
       + pointLight.attenuation.z * distance * distance;
}

// #endif
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"itwC6":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightingUniformsWGSL", ()=>lightingUniformsWGSL);
const lightingUniformsWGSL = /* wgsl */ `\
// #if (defined(SHADER_TYPE_FRAGMENT) && defined(LIGHTING_FRAGMENT)) || (defined(SHADER_TYPE_VERTEX) && defined(LIGHTING_VERTEX))
struct AmbientLight {
  color: vec3<f32>,
};

struct PointLight {
  color: vec3<f32>,
  position: vec3<f32>,
  attenuation: vec3<f32>, // 2nd order x:Constant-y:Linear-z:Exponential
};

struct DirectionalLight {
  color: vec3<f32>,
  direction: vec3<f32>,
};

struct lightingUniforms {
  enabled: i32,
  pointLightCount: i32,
  directionalLightCount: i32,

  ambientColor: vec3<f32>,

  // TODO - support multiple lights by uncommenting arrays below
  lightType: i32,
  lightColor: vec3<f32>,
  lightDirection: vec3<f32>,
  lightPosition: vec3<f32>,
  lightAttenuation: vec3<f32>,

  // AmbientLight ambientLight;
  // PointLight pointLight[MAX_LIGHTS];
  // DirectionalLight directionalLight[MAX_LIGHTS];
};

// Binding 0:1 is reserved for lighting (Note: could go into separate bind group as it is stable across draw calls)
@binding(1) @group(0) var<uniform> lighting : lightingUniforms;

fn lighting_getPointLight(index: i32) -> PointLight {
  return PointLight(lighting.lightColor, lighting.lightPosition, lighting.lightAttenuation);
}

fn lighting_getDirectionalLight(index: i32) -> DirectionalLight {
  return DirectionalLight(lighting.lightColor, lighting.lightDirection);
} 

fn getPointLightAttenuation(pointLight: PointLight, distance: f32) -> f32 {
  return pointLight.attenuation.x
       + pointLight.attenuation.y * distance
       + pointLight.attenuation.z * distance * distance;
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3997R":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gouraudMaterial", ()=>gouraudMaterial);
var _lightingJs = require("../lights/lighting.js");
var _phongShadersGlslJs = require("../phong-material/phong-shaders-glsl.js");
var _phongShadersWgslJs = require("../phong-material/phong-shaders-wgsl.js");
const gouraudMaterial = {
    props: {},
    name: 'gouraudMaterial',
    // Note these are switched between phong and gouraud
    vs: (0, _phongShadersGlslJs.PHONG_FS).replace('phongMaterial', 'gouraudMaterial'),
    fs: (0, _phongShadersGlslJs.PHONG_VS).replace('phongMaterial', 'gouraudMaterial'),
    source: (0, _phongShadersWgslJs.PHONG_WGSL).replaceAll('phongMaterial', 'gouraudMaterial'),
    defines: {
        LIGHTING_VERTEX: 1
    },
    dependencies: [
        (0, _lightingJs.lighting)
    ],
    uniformTypes: {
        ambient: 'f32',
        diffuse: 'f32',
        shininess: 'f32',
        specularColor: 'vec3<f32>'
    },
    defaultUniforms: {
        ambient: 0.35,
        diffuse: 0.6,
        shininess: 32,
        specularColor: [
            0.15,
            0.15,
            0.15
        ]
    },
    getUniforms (props) {
        const uniforms = {
            ...props
        };
        if (uniforms.specularColor) uniforms.specularColor = uniforms.specularColor.map((x)=>x / 255);
        return {
            ...gouraudMaterial.defaultUniforms,
            ...uniforms
        };
    }
};

},{"../lights/lighting.js":"6akIe","../phong-material/phong-shaders-glsl.js":"1NXNB","../phong-material/phong-shaders-wgsl.js":"gqRsk","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1NXNB":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PHONG_VS", ()=>PHONG_VS);
parcelHelpers.export(exports, "PHONG_FS", ()=>PHONG_FS);
const PHONG_VS = /* glsl */ `\
uniform phongMaterialUniforms {
  uniform float ambient;
  uniform float diffuse;
  uniform float shininess;
  uniform vec3  specularColor;
} material;
`;
const PHONG_FS = /* glsl */ `\
uniform phongMaterialUniforms {
  uniform float ambient;
  uniform float diffuse;
  uniform float shininess;
  uniform vec3  specularColor;
} material;

vec3 lighting_getLightColor(vec3 surfaceColor, vec3 light_direction, vec3 view_direction, vec3 normal_worldspace, vec3 color) {
  vec3 halfway_direction = normalize(light_direction + view_direction);
  float lambertian = dot(light_direction, normal_worldspace);
  float specular = 0.0;
  if (lambertian > 0.0) {
    float specular_angle = max(dot(normal_worldspace, halfway_direction), 0.0);
    specular = pow(specular_angle, material.shininess);
  }
  lambertian = max(lambertian, 0.0);
  return (lambertian * material.diffuse * surfaceColor + specular * material.specularColor) * color;
}

vec3 lighting_getLightColor(vec3 surfaceColor, vec3 cameraPosition, vec3 position_worldspace, vec3 normal_worldspace) {
  vec3 lightColor = surfaceColor;

  if (lighting.enabled == 0) {
    return lightColor;
  }

  vec3 view_direction = normalize(cameraPosition - position_worldspace);
  lightColor = material.ambient * surfaceColor * lighting.ambientColor;

  for (int i = 0; i < lighting.pointLightCount; i++) {
    PointLight pointLight = lighting_getPointLight(i);
    vec3 light_position_worldspace = pointLight.position;
    vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
    float light_attenuation = getPointLightAttenuation(pointLight, distance(light_position_worldspace, position_worldspace));
    lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color / light_attenuation);
  }

  int totalLights = min(MAX_LIGHTS, lighting.pointLightCount + lighting.directionalLightCount);
  for (int i = lighting.pointLightCount; i < totalLights; i++) {
    DirectionalLight directionalLight = lighting_getDirectionalLight(i);
    lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
  }
  
  return lightColor;
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gqRsk":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PHONG_WGSL", ()=>PHONG_WGSL);
const PHONG_WGSL = /* wgsl */ `\
struct phongMaterialUniforms {
  ambient: f32,
  diffuse: f32,
  shininess: f32,
  specularColor: vec3<f32>,
};

@binding(2) @group(0) var<uniform> phongMaterial : phongMaterialUniforms;

fn lighting_getLightColor(surfaceColor: vec3<f32>, light_direction: vec3<f32>, view_direction: vec3<f32>, normal_worldspace: vec3<f32>, color: vec3<f32>) -> vec3<f32> {
  let halfway_direction: vec3<f32> = normalize(light_direction + view_direction);
  var lambertian: f32 = dot(light_direction, normal_worldspace);
  var specular: f32 = 0.0;
  if (lambertian > 0.0) {
    let specular_angle = max(dot(normal_worldspace, halfway_direction), 0.0);
    specular = pow(specular_angle, phongMaterial.shininess);
  }
  lambertian = max(lambertian, 0.0);
  return (lambertian * phongMaterial.diffuse * surfaceColor + specular * phongMaterial.specularColor) * color;
}

fn lighting_getLightColor2(surfaceColor: vec3<f32>, cameraPosition: vec3<f32>, position_worldspace: vec3<f32>, normal_worldspace: vec3<f32>) -> vec3<f32> {
  var lightColor: vec3<f32> = surfaceColor;

  if (lighting.enabled == 0) {
    return lightColor;
  }

  let view_direction: vec3<f32> = normalize(cameraPosition - position_worldspace);
  lightColor = phongMaterial.ambient * surfaceColor * lighting.ambientColor;

  if (lighting.lightType == 0) {
    let pointLight: PointLight  = lighting_getPointLight(0);
    let light_position_worldspace: vec3<f32> = pointLight.position;
    let light_direction: vec3<f32> = normalize(light_position_worldspace - position_worldspace);
    lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
  } else if (lighting.lightType == 1) {
    var directionalLight: DirectionalLight = lighting_getDirectionalLight(0);
    lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
  }
  
  return lightColor;
  /*
  for (int i = 0; i < MAX_LIGHTS; i++) {
    if (i >= lighting.pointLightCount) {
      break;
    }
    PointLight pointLight = lighting.pointLight[i];
    vec3 light_position_worldspace = pointLight.position;
    vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
    lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
  }

  for (int i = 0; i < MAX_LIGHTS; i++) {
    if (i >= lighting.directionalLightCount) {
      break;
    }
    DirectionalLight directionalLight = lighting.directionalLight[i];
    lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
  }
  */
}

fn lighting_getSpecularLightColor(cameraPosition: vec3<f32>, position_worldspace: vec3<f32>, normal_worldspace: vec3<f32>) -> vec3<f32>{
  var lightColor = vec3<f32>(0, 0, 0);
  let surfaceColor = vec3<f32>(0, 0, 0);

  if (lighting.enabled == 0) {
    let view_direction = normalize(cameraPosition - position_worldspace);

    switch (lighting.lightType) {
      case 0, default: {
        let pointLight: PointLight = lighting_getPointLight(0);
        let light_position_worldspace: vec3<f32> = pointLight.position;
        let light_direction: vec3<f32> = normalize(light_position_worldspace - position_worldspace);
        lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
      }
      case 1: {
        let directionalLight: DirectionalLight = lighting_getDirectionalLight(0);
        lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
      }
    }
  }
  return lightColor;
}
`; // TODO - handle multiple lights
 /**
    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting.pointLightCount) {
        break;
      }
      PointLight pointLight = lighting_getPointLight(i);
      vec3 light_position_worldspace = pointLight.position;
      vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
      lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
    }

    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting.directionalLightCount) {
        break;
      }
      PointLight pointLight = lighting_getDirectionalLight(i);
      lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
    }
  }
    /**
    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting.pointLightCount) {
        break;
      }
      PointLight pointLight = lighting_getPointLight(i);
      vec3 light_position_worldspace = pointLight.position;
      vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
      lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
    }

    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting.directionalLightCount) {
        break;
      }
      PointLight pointLight = lighting_getDirectionalLight(i);
      lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
    }
  }
  */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lcE29":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "layerUniforms", ()=>layerUniforms);
const uniformBlock = `\
uniform layerUniforms {
  uniform float opacity;
} layer;
`;
const layerUniforms = {
    name: 'layer',
    vs: uniformBlock,
    fs: uniformBlock,
    getUniforms: (props)=>{
        return {
            // apply gamma to opacity to make it visually "linear"
            // TODO - v10: use raw opacity?
            opacity: Math.pow(props.opacity, 1 / 2.2)
        };
    },
    uniformTypes: {
        opacity: 'f32'
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1yy3M":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const source = /* wgsl */ `\
const SMOOTH_EDGE_RADIUS: f32 = 0.5;

struct VertexGeometry {
  position: vec4<f32>,
  worldPosition: vec3<f32>,
  worldPositionAlt: vec3<f32>,
  normal: vec3<f32>,
  uv: vec2<f32>,
  pickingColor: vec3<f32>,
};

var<private> geometry_: VertexGeometry = VertexGeometry(
  vec4<f32>(0.0, 0.0, 1.0, 0.0),
  vec3<f32>(0.0, 0.0, 0.0),
  vec3<f32>(0.0, 0.0, 0.0),
  vec3<f32>(0.0, 0.0, 0.0),
  vec2<f32>(0.0, 0.0),
  vec3<f32>(0.0, 0.0, 0.0)
);

struct FragmentGeometry {
  uv: vec2<f32>,
};

var<private> fragmentGeometry: FragmentGeometry;

fn smoothedge(edge: f32, x: f32) -> f32 {
  return smoothstep(edge - SMOOTH_EDGE_RADIUS, edge + SMOOTH_EDGE_RADIUS, x);
}
`;
const defines = '#define SMOOTH_EDGE_RADIUS 0.5';
const vs = /* glsl */ `\
${defines}

struct VertexGeometry {
  vec4 position;
  vec3 worldPosition;
  vec3 worldPositionAlt;
  vec3 normal;
  vec2 uv;
  vec3 pickingColor;
} geometry = VertexGeometry(
  vec4(0.0, 0.0, 1.0, 0.0),
  vec3(0.0),
  vec3(0.0),
  vec3(0.0),
  vec2(0.0),
  vec3(0.0)
);
`;
const fs = /* glsl */ `\
${defines}

struct FragmentGeometry {
  vec2 uv;
} geometry;

float smoothedge(float edge, float x) {
  return smoothstep(edge - SMOOTH_EDGE_RADIUS, edge + SMOOTH_EDGE_RADIUS, x);
}
`;
exports.default = {
    name: 'geometry',
    source,
    vs,
    fs
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iq4ky":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _shadertools = require("@luma.gl/shadertools");
var _geometryJs = require("../misc/geometry.js");
var _geometryJsDefault = parcelHelpers.interopDefault(_geometryJs);
var _viewportUniformsJs = require("./viewport-uniforms.js");
var _projectWgslJs = require("./project.wgsl.js");
var _projectGlslJs = require("./project.glsl.js");
const INITIAL_MODULE_OPTIONS = {};
function getUniforms(opts = INITIAL_MODULE_OPTIONS) {
    if ('viewport' in opts) return (0, _viewportUniformsJs.getUniformsFromViewport)(opts);
    return {};
}
exports.default = {
    name: 'project',
    dependencies: [
        (0, _shadertools.fp32),
        (0, _geometryJsDefault.default)
    ],
    source: (0, _projectWgslJs.projectWGSL),
    vs: (0, _projectGlslJs.projectGLSL),
    getUniforms,
    uniformTypes: {
        wrapLongitude: 'f32',
        coordinateSystem: 'i32',
        commonUnitsPerMeter: 'vec3<f32>',
        projectionMode: 'i32',
        scale: 'f32',
        commonUnitsPerWorldUnit: 'vec3<f32>',
        commonUnitsPerWorldUnit2: 'vec3<f32>',
        center: 'vec4<f32>',
        modelMatrix: 'mat4x4<f32>',
        viewProjectionMatrix: 'mat4x4<f32>',
        viewportSize: 'vec2<f32>',
        devicePixelRatio: 'f32',
        focalDistance: 'f32',
        cameraPosition: 'vec3<f32>',
        coordinateOrigin: 'vec3<f32>',
        commonOrigin: 'vec3<f32>',
        pseudoMeters: 'f32'
    }
};

},{"@luma.gl/shadertools":"iH5G2","../misc/geometry.js":"1yy3M","./viewport-uniforms.js":"8W447","./project.wgsl.js":"5hZ3L","./project.glsl.js":"uX0Q0","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8W447":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable complexity, camelcase */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOffsetOrigin", ()=>getOffsetOrigin);
/**
 * Returns uniforms for shaders based on current projection
 * includes: projection matrix suitable for shaders
 *
 * TODO - Ensure this works with any viewport, not just WebMercatorViewports
 *
 * @param {WebMercatorViewport} viewport -
 * @return {Float32Array} - 4x4 projection matrix that can be used in shaders
 */ parcelHelpers.export(exports, "getUniformsFromViewport", ()=>getUniformsFromViewport);
var _core = require("@math.gl/core");
var _constantsJs = require("../../lib/constants.js");
var _memoizeJs = require("../../utils/memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
// To quickly set a vector to zero
const ZERO_VECTOR = [
    0,
    0,
    0,
    0
];
// 4x4 matrix that drops 4th component of vector
const VECTOR_TO_POINT_MATRIX = [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0
];
const IDENTITY_MATRIX = [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
];
const DEFAULT_PIXELS_PER_UNIT2 = [
    0,
    0,
    0
];
const DEFAULT_COORDINATE_ORIGIN = [
    0,
    0,
    0
];
const getMemoizedViewportUniforms = (0, _memoizeJsDefault.default)(calculateViewportUniforms);
function getOffsetOrigin(viewport, coordinateSystem, coordinateOrigin = DEFAULT_COORDINATE_ORIGIN) {
    if (coordinateOrigin.length < 3) coordinateOrigin = [
        coordinateOrigin[0],
        coordinateOrigin[1],
        0
    ];
    let shaderCoordinateOrigin = coordinateOrigin;
    let geospatialOrigin;
    let offsetMode = true;
    if (coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT_OFFSETS || coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).METER_OFFSETS) geospatialOrigin = coordinateOrigin;
    else geospatialOrigin = viewport.isGeospatial ? [
        Math.fround(viewport.longitude),
        Math.fround(viewport.latitude),
        0
    ] : null;
    switch(viewport.projectionMode){
        case (0, _constantsJs.PROJECTION_MODE).WEB_MERCATOR:
            if (coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT || coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).CARTESIAN) {
                geospatialOrigin = [
                    0,
                    0,
                    0
                ];
                offsetMode = false;
            }
            break;
        case (0, _constantsJs.PROJECTION_MODE).WEB_MERCATOR_AUTO_OFFSET:
            if (coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT) // viewport center in world space
            // @ts-expect-error when using LNGLAT coordinates, we expect the viewport to be geospatial, in which case geospatialOrigin is defined
            shaderCoordinateOrigin = geospatialOrigin;
            else if (coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).CARTESIAN) {
                // viewport center in common space
                shaderCoordinateOrigin = [
                    Math.fround(viewport.center[0]),
                    Math.fround(viewport.center[1]),
                    0
                ];
                // Geospatial origin (wgs84) must match shaderCoordinateOrigin (common)
                geospatialOrigin = viewport.unprojectPosition(shaderCoordinateOrigin);
                shaderCoordinateOrigin[0] -= coordinateOrigin[0];
                shaderCoordinateOrigin[1] -= coordinateOrigin[1];
                shaderCoordinateOrigin[2] -= coordinateOrigin[2];
            }
            break;
        case (0, _constantsJs.PROJECTION_MODE).IDENTITY:
            shaderCoordinateOrigin = viewport.position.map(Math.fround);
            shaderCoordinateOrigin[2] = shaderCoordinateOrigin[2] || 0;
            break;
        case (0, _constantsJs.PROJECTION_MODE).GLOBE:
            offsetMode = false;
            geospatialOrigin = null;
            break;
        default:
            // Unknown projection mode
            offsetMode = false;
    }
    return {
        geospatialOrigin,
        shaderCoordinateOrigin,
        offsetMode
    };
}
// The code that utilizes Matrix4 does the same calculation as their mat4 counterparts,
// has lower performance but provides error checking.
function calculateMatrixAndOffset(viewport, coordinateSystem, coordinateOrigin) {
    const { viewMatrixUncentered, projectionMatrix } = viewport;
    let { viewMatrix, viewProjectionMatrix } = viewport;
    let projectionCenter = ZERO_VECTOR;
    let originCommon = ZERO_VECTOR;
    let cameraPosCommon = viewport.cameraPosition;
    const { geospatialOrigin, shaderCoordinateOrigin, offsetMode } = getOffsetOrigin(viewport, coordinateSystem, coordinateOrigin);
    if (offsetMode) {
        // Calculate transformed projectionCenter (using 64 bit precision JS)
        // This is the key to offset mode precision
        // (avoids doing this addition in 32 bit precision in GLSL)
        // @ts-expect-error the 4th component is assigned below
        originCommon = viewport.projectPosition(geospatialOrigin || shaderCoordinateOrigin);
        cameraPosCommon = [
            cameraPosCommon[0] - originCommon[0],
            cameraPosCommon[1] - originCommon[1],
            cameraPosCommon[2] - originCommon[2]
        ];
        originCommon[3] = 1;
        // projectionCenter = new Matrix4(viewProjectionMatrix)
        //   .transformVector([positionPixels[0], positionPixels[1], 0.0, 1.0]);
        projectionCenter = (0, _core.vec4).transformMat4([], originCommon, viewProjectionMatrix);
        // Always apply uncentered projection matrix if available (shader adds center)
        viewMatrix = viewMatrixUncentered || viewMatrix;
        // Zero out 4th coordinate ("after" model matrix) - avoids further translations
        // viewMatrix = new Matrix4(viewMatrixUncentered || viewMatrix)
        //   .multiplyRight(VECTOR_TO_POINT_MATRIX);
        viewProjectionMatrix = (0, _core.mat4).multiply([], projectionMatrix, viewMatrix);
        viewProjectionMatrix = (0, _core.mat4).multiply([], viewProjectionMatrix, VECTOR_TO_POINT_MATRIX);
    }
    return {
        viewMatrix: viewMatrix,
        viewProjectionMatrix: viewProjectionMatrix,
        projectionCenter,
        originCommon,
        cameraPosCommon,
        shaderCoordinateOrigin,
        geospatialOrigin
    };
}
function getUniformsFromViewport({ viewport, devicePixelRatio = 1, modelMatrix = null, // Match Layer.defaultProps
coordinateSystem = (0, _constantsJs.COORDINATE_SYSTEM).DEFAULT, coordinateOrigin = DEFAULT_COORDINATE_ORIGIN, autoWrapLongitude = false }) {
    if (coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).DEFAULT) coordinateSystem = viewport.isGeospatial ? (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT : (0, _constantsJs.COORDINATE_SYSTEM).CARTESIAN;
    const uniforms = getMemoizedViewportUniforms({
        viewport,
        devicePixelRatio,
        coordinateSystem,
        coordinateOrigin
    });
    uniforms.wrapLongitude = autoWrapLongitude;
    uniforms.modelMatrix = modelMatrix || IDENTITY_MATRIX;
    return uniforms;
}
function calculateViewportUniforms({ viewport, devicePixelRatio, coordinateSystem, coordinateOrigin }) {
    const { projectionCenter, viewProjectionMatrix, originCommon, cameraPosCommon, shaderCoordinateOrigin, geospatialOrigin } = calculateMatrixAndOffset(viewport, coordinateSystem, coordinateOrigin);
    // Calculate projection pixels per unit
    const distanceScales = viewport.getDistanceScales();
    const viewportSize = [
        viewport.width * devicePixelRatio,
        viewport.height * devicePixelRatio
    ];
    // Distance at which screen pixels are projected.
    // Used to scale sizes in clipspace to match screen pixels.
    // When using Viewport class's default projection matrix, this yields 1 for orthographic
    // and `viewport.focalDistance` for perspective views
    const focalDistance = (0, _core.vec4).transformMat4([], [
        0,
        0,
        -viewport.focalDistance,
        1
    ], viewport.projectionMatrix)[3] || 1;
    const uniforms = {
        // Projection mode values
        coordinateSystem,
        projectionMode: viewport.projectionMode,
        coordinateOrigin: shaderCoordinateOrigin,
        commonOrigin: originCommon.slice(0, 3),
        center: projectionCenter,
        // Backward compatibility
        // TODO: remove in v9
        // @ts-expect-error _pseudoMeters is only defined on WebMercator viewport
        pseudoMeters: Boolean(viewport._pseudoMeters),
        // Screen size
        viewportSize,
        devicePixelRatio,
        focalDistance,
        commonUnitsPerMeter: distanceScales.unitsPerMeter,
        commonUnitsPerWorldUnit: distanceScales.unitsPerMeter,
        commonUnitsPerWorldUnit2: DEFAULT_PIXELS_PER_UNIT2,
        scale: viewport.scale,
        wrapLongitude: false,
        viewProjectionMatrix,
        modelMatrix: IDENTITY_MATRIX,
        // This is for lighting calculations
        cameraPosition: cameraPosCommon
    };
    if (geospatialOrigin) {
        // Get high-precision DistanceScales from geospatial viewport
        // TODO: stricter types in Viewport classes
        const distanceScalesAtOrigin = viewport.getDistanceScales(geospatialOrigin);
        switch(coordinateSystem){
            case (0, _constantsJs.COORDINATE_SYSTEM).METER_OFFSETS:
                uniforms.commonUnitsPerWorldUnit = distanceScalesAtOrigin.unitsPerMeter;
                uniforms.commonUnitsPerWorldUnit2 = distanceScalesAtOrigin.unitsPerMeter2;
                break;
            case (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT:
            case (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT_OFFSETS:
                // @ts-expect-error _pseudoMeters only exists on WebMercatorView
                if (!viewport._pseudoMeters) uniforms.commonUnitsPerMeter = distanceScalesAtOrigin.unitsPerMeter;
                uniforms.commonUnitsPerWorldUnit = distanceScalesAtOrigin.unitsPerDegree;
                uniforms.commonUnitsPerWorldUnit2 = distanceScalesAtOrigin.unitsPerDegree2;
                break;
            // a.k.a "preprojected" positions
            case (0, _constantsJs.COORDINATE_SYSTEM).CARTESIAN:
                uniforms.commonUnitsPerWorldUnit = [
                    1,
                    1,
                    distanceScalesAtOrigin.unitsPerMeter[2]
                ];
                uniforms.commonUnitsPerWorldUnit2 = [
                    0,
                    0,
                    distanceScalesAtOrigin.unitsPerMeter2[2]
                ];
                break;
            default:
                break;
        }
    }
    return uniforms;
}

},{"@math.gl/core":"6z0Tv","../../lib/constants.js":"k6l9N","../../utils/memoize.js":"4XQCO","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6z0Tv":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// classes
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Vector2", ()=>(0, _vector2Js.Vector2));
parcelHelpers.export(exports, "Vector3", ()=>(0, _vector3Js.Vector3));
parcelHelpers.export(exports, "Vector4", ()=>(0, _vector4Js.Vector4));
parcelHelpers.export(exports, "Matrix3", ()=>(0, _matrix3Js.Matrix3));
parcelHelpers.export(exports, "Matrix4", ()=>(0, _matrix4Js.Matrix4));
parcelHelpers.export(exports, "Quaternion", ()=>(0, _quaternionJs.Quaternion));
// experimental
parcelHelpers.export(exports, "SphericalCoordinates", ()=>(0, _sphericalCoordinatesJs.SphericalCoordinates));
parcelHelpers.export(exports, "Pose", ()=>(0, _poseJs.Pose));
parcelHelpers.export(exports, "Euler", ()=>(0, _eulerJs.Euler));
parcelHelpers.export(exports, "_MathUtils", ()=>_mathUtilsJs);
// lib
parcelHelpers.export(exports, "assert", ()=>(0, _assertJs.assert));
parcelHelpers.export(exports, "config", ()=>(0, _commonJs.config));
parcelHelpers.export(exports, "configure", ()=>(0, _commonJs.configure));
parcelHelpers.export(exports, "formatValue", ()=>(0, _commonJs.formatValue));
parcelHelpers.export(exports, "isArray", ()=>(0, _commonJs.isArray));
parcelHelpers.export(exports, "clone", ()=>(0, _commonJs.clone));
parcelHelpers.export(exports, "equals", ()=>(0, _commonJs.equals));
parcelHelpers.export(exports, "exactEquals", ()=>(0, _commonJs.exactEquals));
parcelHelpers.export(exports, "toRadians", ()=>(0, _commonJs.toRadians));
parcelHelpers.export(exports, "toDegrees", ()=>(0, _commonJs.toDegrees));
parcelHelpers.export(exports, "radians", ()=>(0, _commonJs.radians));
parcelHelpers.export(exports, "degrees", ()=>(0, _commonJs.degrees));
parcelHelpers.export(exports, "sin", ()=>(0, _commonJs.sin));
parcelHelpers.export(exports, "cos", ()=>(0, _commonJs.cos));
parcelHelpers.export(exports, "tan", ()=>(0, _commonJs.tan));
parcelHelpers.export(exports, "asin", ()=>(0, _commonJs.asin));
parcelHelpers.export(exports, "acos", ()=>(0, _commonJs.acos));
parcelHelpers.export(exports, "atan", ()=>(0, _commonJs.atan));
parcelHelpers.export(exports, "clamp", ()=>(0, _commonJs.clamp));
parcelHelpers.export(exports, "lerp", ()=>(0, _commonJs.lerp));
parcelHelpers.export(exports, "withEpsilon", ()=>(0, _commonJs.withEpsilon));
// DEPRECATED
parcelHelpers.export(exports, "_SphericalCoordinates", ()=>(0, _sphericalCoordinatesJs.SphericalCoordinates));
parcelHelpers.export(exports, "_Pose", ()=>(0, _poseJs.Pose));
parcelHelpers.export(exports, "_Euler", ()=>(0, _eulerJs.Euler));
/** @deprecated Use Matrix3 */ parcelHelpers.export(exports, "mat3", ()=>_mat3Js);
/** @deprecated Use Matrix4 */ parcelHelpers.export(exports, "mat4", ()=>_mat4Js);
/** @deprecated Use Quaterinion */ parcelHelpers.export(exports, "quat", ()=>_quatJs);
/** @deprecated UseVector */ parcelHelpers.export(exports, "vec2", ()=>_vec2Js);
/** @deprecated Use Vector3 */ parcelHelpers.export(exports, "vec3", ()=>_vec3Js);
/** @deprecated Use Vector4 */ parcelHelpers.export(exports, "vec4", ()=>_vec4Js);
var _vector2Js = require("./classes/vector2.js");
var _vector3Js = require("./classes/vector3.js");
var _vector4Js = require("./classes/vector4.js");
var _matrix3Js = require("./classes/matrix3.js");
var _matrix4Js = require("./classes/matrix4.js");
var _quaternionJs = require("./classes/quaternion.js");
var _sphericalCoordinatesJs = require("./classes/spherical-coordinates.js");
var _poseJs = require("./classes/pose.js");
var _eulerJs = require("./classes/euler.js");
var _mathUtilsJs = require("./lib/math-utils.js");
var _assertJs = require("./lib/assert.js");
var _commonJs = require("./lib/common.js");
var _mat3Js = require("./gl-matrix/mat3.js");
var _mat4Js = require("./gl-matrix/mat4.js");
var _quatJs = require("./gl-matrix/quat.js");
var _vec2Js = require("./gl-matrix/vec2.js");
var _vec3Js = require("./gl-matrix/vec3.js");
var _vec4Js = require("./gl-matrix/vec4.js");

},{"./classes/vector2.js":false,"./classes/vector3.js":"2bKBC","./classes/vector4.js":false,"./classes/matrix3.js":false,"./classes/matrix4.js":"jX6tL","./classes/quaternion.js":false,"./classes/spherical-coordinates.js":false,"./classes/pose.js":false,"./classes/euler.js":false,"./lib/math-utils.js":false,"./lib/assert.js":false,"./lib/common.js":"4XdF5","./gl-matrix/mat3.js":false,"./gl-matrix/mat4.js":"iBAKs","./gl-matrix/quat.js":false,"./gl-matrix/vec2.js":"l8RgT","./gl-matrix/vec3.js":"i7WcS","./gl-matrix/vec4.js":"2yXLd","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2bKBC":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Copyright (c) 2017 Uber Technologies, Inc.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Three-element vector class with common linear algebra operations.
 * Subclass of Array<number> meaning that it is highly compatible with other libraries
 */ parcelHelpers.export(exports, "Vector3", ()=>Vector3);
var _vectorJs = require("./base/vector.js");
var _commonJs = require("../lib/common.js");
var _validatorsJs = require("../lib/validators.js");
// @ts-ignore gl-matrix types
var _vec3Js = require("../gl-matrix/vec3.js");
/* eslint-disable camelcase */ var _glMatrixExtrasJs = require("../lib/gl-matrix-extras.js");
const ORIGIN = [
    0,
    0,
    0
];
let ZERO;
class Vector3 extends (0, _vectorJs.Vector) {
    static get ZERO() {
        if (!ZERO) {
            ZERO = new Vector3(0, 0, 0);
            Object.freeze(ZERO);
        }
        return ZERO;
    }
    /**
     * @class
     * @param x
     * @param y
     * @param z
     */ constructor(x = 0, y = 0, z = 0){
        // PERF NOTE: initialize elements as double precision numbers
        super(-0, -0, -0);
        if (arguments.length === 1 && (0, _commonJs.isArray)(x)) this.copy(x);
        else {
            // this.set(x, y, z);
            if ((0, _commonJs.config).debug) {
                (0, _validatorsJs.checkNumber)(x);
                (0, _validatorsJs.checkNumber)(y);
                (0, _validatorsJs.checkNumber)(z);
            }
            // @ts-expect-error TS2412: Property '0' of type 'number | [number, number, number]' is not assignable to numeric index type 'number'
            this[0] = x;
            this[1] = y;
            this[2] = z;
        }
    }
    set(x, y, z) {
        this[0] = x;
        this[1] = y;
        this[2] = z;
        return this.check();
    }
    copy(array) {
        this[0] = array[0];
        this[1] = array[1];
        this[2] = array[2];
        return this.check();
    }
    fromObject(object) {
        if ((0, _commonJs.config).debug) {
            (0, _validatorsJs.checkNumber)(object.x);
            (0, _validatorsJs.checkNumber)(object.y);
            (0, _validatorsJs.checkNumber)(object.z);
        }
        this[0] = object.x;
        this[1] = object.y;
        this[2] = object.z;
        return this.check();
    }
    toObject(object) {
        object.x = this[0];
        object.y = this[1];
        object.z = this[2];
        return object;
    }
    // Getters/setters
    get ELEMENTS() {
        return 3;
    }
    get z() {
        return this[2];
    }
    set z(value) {
        this[2] = (0, _validatorsJs.checkNumber)(value);
    }
    // ACCESSORS
    angle(vector) {
        return (0, _vec3Js.angle)(this, vector);
    }
    // MODIFIERS
    cross(vector) {
        (0, _vec3Js.cross)(this, this, vector);
        return this.check();
    }
    rotateX({ radians, origin = ORIGIN }) {
        (0, _vec3Js.rotateX)(this, this, origin, radians);
        return this.check();
    }
    rotateY({ radians, origin = ORIGIN }) {
        (0, _vec3Js.rotateY)(this, this, origin, radians);
        return this.check();
    }
    rotateZ({ radians, origin = ORIGIN }) {
        (0, _vec3Js.rotateZ)(this, this, origin, radians);
        return this.check();
    }
    // Transforms
    // transforms as point (4th component is implicitly 1)
    transform(matrix4) {
        return this.transformAsPoint(matrix4);
    }
    // transforms as point (4th component is implicitly 1)
    transformAsPoint(matrix4) {
        (0, _vec3Js.transformMat4)(this, this, matrix4);
        return this.check();
    }
    // transforms as vector  (4th component is implicitly 0, ignores translation. slightly faster)
    transformAsVector(matrix4) {
        (0, _glMatrixExtrasJs.vec3_transformMat4AsVector)(this, this, matrix4);
        return this.check();
    }
    transformByMatrix3(matrix3) {
        (0, _vec3Js.transformMat3)(this, this, matrix3);
        return this.check();
    }
    transformByMatrix2(matrix2) {
        (0, _glMatrixExtrasJs.vec3_transformMat2)(this, this, matrix2);
        return this.check();
    }
    transformByQuaternion(quaternion) {
        (0, _vec3Js.transformQuat)(this, this, quaternion);
        return this.check();
    }
}

},{"./base/vector.js":"8j1nW","../lib/common.js":"4XdF5","../lib/validators.js":"ciggz","../gl-matrix/vec3.js":"i7WcS","../lib/gl-matrix-extras.js":"4iy67","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8j1nW":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Copyright (c) 2017 Uber Technologies, Inc.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Base class for vectors with at least 2 elements */ parcelHelpers.export(exports, "Vector", ()=>Vector);
var _mathArrayJs = require("./math-array.js");
var _validatorsJs = require("../../lib/validators.js");
var _assertJs = require("../../lib/assert.js");
class Vector extends (0, _mathArrayJs.MathArray) {
    // ACCESSORS
    get x() {
        return this[0];
    }
    set x(value) {
        this[0] = (0, _validatorsJs.checkNumber)(value);
    }
    get y() {
        return this[1];
    }
    set y(value) {
        this[1] = (0, _validatorsJs.checkNumber)(value);
    }
    /**
     * Returns the length of the vector from the origin to the point described by this vector
     *
     * @note `length` is a reserved word for Arrays, so `v.length()` will return number of elements
     * Instead we provide `len` and `magnitude`
     */ len() {
        return Math.sqrt(this.lengthSquared());
    }
    /**
     * Returns the length of the vector from the origin to the point described by this vector
     */ magnitude() {
        return this.len();
    }
    /**
     * Returns the squared length of the vector from the origin to the point described by this vector
     */ lengthSquared() {
        let length = 0;
        for(let i = 0; i < this.ELEMENTS; ++i)length += this[i] * this[i];
        return length;
    }
    /**
     * Returns the squared length of the vector from the origin to the point described by this vector
     */ magnitudeSquared() {
        return this.lengthSquared();
    }
    distance(mathArray) {
        return Math.sqrt(this.distanceSquared(mathArray));
    }
    distanceSquared(mathArray) {
        let length = 0;
        for(let i = 0; i < this.ELEMENTS; ++i){
            const dist = this[i] - mathArray[i];
            length += dist * dist;
        }
        return (0, _validatorsJs.checkNumber)(length);
    }
    dot(mathArray) {
        let product = 0;
        for(let i = 0; i < this.ELEMENTS; ++i)product += this[i] * mathArray[i];
        return (0, _validatorsJs.checkNumber)(product);
    }
    // MODIFIERS
    normalize() {
        const length = this.magnitude();
        if (length !== 0) for(let i = 0; i < this.ELEMENTS; ++i)this[i] /= length;
        return this.check();
    }
    multiply(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= vector[i];
        return this.check();
    }
    divide(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] /= vector[i];
        return this.check();
    }
    // THREE.js compatibility
    lengthSq() {
        return this.lengthSquared();
    }
    distanceTo(vector) {
        return this.distance(vector);
    }
    distanceToSquared(vector) {
        return this.distanceSquared(vector);
    }
    getComponent(i) {
        (0, _assertJs.assert)(i >= 0 && i < this.ELEMENTS, 'index is out of range');
        return (0, _validatorsJs.checkNumber)(this[i]);
    }
    setComponent(i, value) {
        (0, _assertJs.assert)(i >= 0 && i < this.ELEMENTS, 'index is out of range');
        this[i] = value;
        return this.check();
    }
    addVectors(a, b) {
        return this.copy(a).add(b);
    }
    subVectors(a, b) {
        return this.copy(a).subtract(b);
    }
    multiplyVectors(a, b) {
        return this.copy(a).multiply(b);
    }
    addScaledVector(a, b) {
        // @ts-expect-error error TS2351: Cannot use 'new' with an expression whose type lacks a call or construct signature.
        return this.add(new this.constructor(a).multiplyScalar(b));
    }
}

},{"./math-array.js":"fhqP3","../../lib/validators.js":"ciggz","../../lib/assert.js":"dO8hJ","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fhqP3":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Base class for vectors and matrices */ parcelHelpers.export(exports, "MathArray", ()=>MathArray);
var _commonJs = require("../../lib/common.js");
class MathArray extends Array {
    // Common methods
    /**
     * Clone the current object
     * @returns a new copy of this object
     */ clone() {
        // @ts-expect-error TS2351: Cannot use 'new' with an expression whose type lacks a call or construct signature.
        return new this.constructor().copy(this); // eslint-disable-line
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = array[i + offset];
        return this.check();
    }
    toArray(targetArray = [], offset = 0) {
        for(let i = 0; i < this.ELEMENTS; ++i)targetArray[offset + i] = this[i];
        return targetArray;
    }
    toObject(targetObject) {
        return targetObject;
    }
    from(arrayOrObject) {
        return Array.isArray(arrayOrObject) ? this.copy(arrayOrObject) : this.fromObject(arrayOrObject);
    }
    to(arrayOrObject) {
        // @ts-ignore
        if (arrayOrObject === this) return this;
        // @ts-expect-error TS2339: Property 'toObject' does not exist on type 'MathArray'.
        return (0, _commonJs.isArray)(arrayOrObject) ? this.toArray(arrayOrObject) : this.toObject(arrayOrObject);
    }
    toTarget(target) {
        return target ? this.to(target) : this;
    }
    /** @deprecated */ toFloat32Array() {
        return new Float32Array(this);
    }
    toString() {
        return this.formatString((0, _commonJs.config));
    }
    /** Formats string according to options */ formatString(opts) {
        let string = '';
        for(let i = 0; i < this.ELEMENTS; ++i)string += (i > 0 ? ', ' : '') + (0, _commonJs.formatValue)(this[i], opts);
        return `${opts.printTypes ? this.constructor.name : ''}[${string}]`;
    }
    equals(array) {
        if (!array || this.length !== array.length) return false;
        for(let i = 0; i < this.ELEMENTS; ++i){
            if (!(0, _commonJs.equals)(this[i], array[i])) return false;
        }
        return true;
    }
    exactEquals(array) {
        if (!array || this.length !== array.length) return false;
        for(let i = 0; i < this.ELEMENTS; ++i){
            if (this[i] !== array[i]) return false;
        }
        return true;
    }
    // Modifiers
    /** Negates all values in this object */ negate() {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = -this[i];
        return this.check();
    }
    lerp(a, b, t) {
        if (t === undefined) return this.lerp(this, a, b);
        for(let i = 0; i < this.ELEMENTS; ++i){
            const ai = a[i];
            const endValue = typeof b === 'number' ? b : b[i];
            this[i] = ai + t * (endValue - ai);
        }
        return this.check();
    }
    /** Minimal */ min(vector) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.min(vector[i], this[i]);
        return this.check();
    }
    /** Maximal */ max(vector) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.max(vector[i], this[i]);
        return this.check();
    }
    clamp(minVector, maxVector) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.min(Math.max(this[i], minVector[i]), maxVector[i]);
        return this.check();
    }
    add(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] += vector[i];
        return this.check();
    }
    subtract(...vectors) {
        for (const vector of vectors)for(let i = 0; i < this.ELEMENTS; ++i)this[i] -= vector[i];
        return this.check();
    }
    scale(scale) {
        if (typeof scale === 'number') for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= scale;
        else for(let i = 0; i < this.ELEMENTS && i < scale.length; ++i)this[i] *= scale[i];
        return this.check();
    }
    /**
     * Multiplies all elements by `scale`
     * Note: `Matrix4.multiplyByScalar` only scales its 3x3 "minor"
     */ multiplyByScalar(scalar) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= scalar;
        return this.check();
    }
    // Debug checks
    /** Throws an error if array length is incorrect or contains illegal values */ check() {
        if ((0, _commonJs.config).debug && !this.validate()) throw new Error(`math.gl: ${this.constructor.name} some fields set to invalid numbers'`);
        return this;
    }
    /** Returns false if the array length is incorrect or contains illegal values */ validate() {
        let valid = this.length === this.ELEMENTS;
        for(let i = 0; i < this.ELEMENTS; ++i)valid = valid && Number.isFinite(this[i]);
        return valid;
    }
    // three.js compatibility
    /** @deprecated */ sub(a) {
        return this.subtract(a);
    }
    /** @deprecated */ setScalar(a) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = a;
        return this.check();
    }
    /** @deprecated */ addScalar(a) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] += a;
        return this.check();
    }
    /** @deprecated */ subScalar(a) {
        return this.addScalar(-a);
    }
    /** @deprecated */ multiplyScalar(scalar) {
        // Multiplies all elements
        // `Matrix4.scale` only scales its 3x3 "minor"
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] *= scalar;
        return this.check();
    }
    /** @deprecated */ divideScalar(a) {
        return this.multiplyByScalar(1 / a);
    }
    /** @deprecated */ clampScalar(min, max) {
        for(let i = 0; i < this.ELEMENTS; ++i)this[i] = Math.min(Math.max(this[i], min), max);
        return this.check();
    }
    /** @deprecated */ get elements() {
        return this;
    }
}

},{"../../lib/common.js":"4XdF5","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4XdF5":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
parcelHelpers.export(exports, "configure", ()=>configure);
/**
 * Formats a value into a string
 * @param value
 * @param param1
 * @returns
 */ parcelHelpers.export(exports, "formatValue", ()=>formatValue);
/**
 * Check if value is an "array"
 * Returns `true` if value is either an array or a typed array
 * Note: returns `false` for `ArrayBuffer` and `DataView` instances
 * @note isTypedArray and isNumericArray are often more useful in TypeScript
 */ parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "clone", ()=>clone);
parcelHelpers.export(exports, "toRadians", ()=>toRadians);
parcelHelpers.export(exports, "toDegrees", ()=>toDegrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "degrees", ()=>degrees);
/**
 * "GLSL equivalent" of `Math.sin`: Works on single values and vectors
 * @deprecated
 */ parcelHelpers.export(exports, "sin", ()=>sin);
/**
 * "GLSL equivalent" of `Math.cos`: Works on single values and vectors
 * @deprecated
 */ parcelHelpers.export(exports, "cos", ()=>cos);
/**
 * "GLSL equivalent" of `Math.tan`: Works on single values and vectors
 * @deprecated
 */ parcelHelpers.export(exports, "tan", ()=>tan);
/**
 * "GLSL equivalent" of `Math.asin`: Works on single values and vectors
 * @deprecated
 */ parcelHelpers.export(exports, "asin", ()=>asin);
/**
 * "GLSL equivalent" of `Math.acos`: Works on single values and vectors
 * @deprecated
 */ parcelHelpers.export(exports, "acos", ()=>acos);
/**
 * "GLSL equivalent" of `Math.atan`: Works on single values and vectors
 * @deprecated
 */ parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "lerp", ()=>lerp);
/* eslint-disable */ /**
 * Compares any two math objects, using `equals` method if available.
 * @param a
 * @param b
 * @param epsilon
 * @returns
 */ parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "exactEquals", ()=>exactEquals);
/* eslint-enable */ parcelHelpers.export(exports, "withEpsilon", ()=>withEpsilon);
const RADIANS_TO_DEGREES = 1 / Math.PI * 180;
const DEGREES_TO_RADIANS = 1 / 180 * Math.PI;
const DEFAULT_CONFIG = {
    EPSILON: 1e-12,
    debug: false,
    precision: 4,
    printTypes: false,
    printDegrees: false,
    printRowMajor: true,
    _cartographicRadians: false
};
// Configuration is truly global as of v3.6 to ensure single config even if multiple copies of math.gl
// Multiple copies of config can be quite tricky to debug...
globalThis.mathgl = globalThis.mathgl || {
    config: {
        ...DEFAULT_CONFIG
    }
};
const config = globalThis.mathgl.config;
function configure(options) {
    // Only copy existing keys
    Object.assign(config, options);
    return config;
}
function formatValue(value, { precision = config.precision } = {}) {
    value = round(value);
    // get rid of trailing zeros
    return `${parseFloat(value.toPrecision(precision))}`;
}
function isArray(value) {
    return Array.isArray(value) || ArrayBuffer.isView(value) && !(value instanceof DataView);
}
function clone(array) {
    return 'clone' in array ? array.clone() : array.slice();
}
function toRadians(degrees) {
    return radians(degrees);
}
function toDegrees(radians) {
    return degrees(radians);
}
function radians(degrees, result) {
    return map(degrees, (degrees)=>degrees * DEGREES_TO_RADIANS, result);
}
function degrees(radians, result) {
    return map(radians, (radians)=>radians * RADIANS_TO_DEGREES, result);
}
function sin(radians, result) {
    return map(radians, (angle)=>Math.sin(angle), result);
}
function cos(radians, result) {
    return map(radians, (angle)=>Math.cos(angle), result);
}
function tan(radians, result) {
    return map(radians, (angle)=>Math.tan(angle), result);
}
function asin(radians, result) {
    return map(radians, (angle)=>Math.asin(angle), result);
}
function acos(radians, result) {
    return map(radians, (angle)=>Math.acos(angle), result);
}
function atan(radians, result) {
    return map(radians, (angle)=>Math.atan(angle), result);
}
function clamp(value, min, max) {
    return map(value, (value)=>Math.max(min, Math.min(max, value)));
}
function lerp(a, b, t) {
    if (isArray(a)) return a.map((ai, i)=>lerp(ai, b[i], t));
    return t * b + (1 - t) * a;
}
function equals(a, b, epsilon) {
    const oldEpsilon = config.EPSILON;
    if (epsilon) config.EPSILON = epsilon;
    try {
        if (a === b) return true;
        if (isArray(a) && isArray(b)) {
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; ++i){
                // eslint-disable-next-line max-depth
                if (!equals(a[i], b[i])) return false;
            }
            return true;
        }
        if (a && a.equals) return a.equals(b);
        if (b && b.equals) return b.equals(a);
        if (typeof a === 'number' && typeof b === 'number') return Math.abs(a - b) <= config.EPSILON * Math.max(1, Math.abs(a), Math.abs(b));
        return false;
    } finally{
        config.EPSILON = oldEpsilon;
    }
}
function exactEquals(a, b) {
    if (a === b) return true;
    if (a && typeof a === 'object' && b && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (a.exactEquals) return a.exactEquals(b);
    }
    if (isArray(a) && isArray(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; ++i){
            if (!exactEquals(a[i], b[i])) return false;
        }
        return true;
    }
    return false;
}
function withEpsilon(epsilon, func) {
    const oldPrecision = config.EPSILON;
    config.EPSILON = epsilon;
    let value;
    try {
        value = func();
    } finally{
        config.EPSILON = oldPrecision;
    }
    return value;
}
// HELPERS
function round(value) {
    return Math.round(value / config.EPSILON) * config.EPSILON;
}
// If the array has a clone function, calls it, otherwise returns a copy
function duplicateArray(array) {
    // @ts-expect-error We check for math.gl class methods
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return array.clone ? array.clone() : new Array(array.length);
}
// If the argument value is an array, applies the func element wise,
// otherwise applies func to the argument value
function map(value, func, result) {
    if (isArray(value)) {
        const array = value;
        result = result || duplicateArray(array);
        for(let i = 0; i < result.length && i < array.length; ++i){
            const val = typeof value === 'number' ? value : value[i];
            result[i] = func(val, i, result);
        }
        return result;
    }
    return func(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ciggz":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateVector", ()=>validateVector);
parcelHelpers.export(exports, "checkNumber", ()=>checkNumber);
parcelHelpers.export(exports, "checkVector", ()=>checkVector);
parcelHelpers.export(exports, "deprecated", ()=>deprecated);
var _commonJs = require("./common.js");
function validateVector(v, length) {
    if (v.length !== length) return false;
    // Could be arguments "array" (v.every not availasble)
    for(let i = 0; i < v.length; ++i){
        if (!Number.isFinite(v[i])) return false;
    }
    return true;
}
function checkNumber(value) {
    if (!Number.isFinite(value)) throw new Error(`Invalid number ${JSON.stringify(value)}`);
    return value;
}
function checkVector(v, length, callerName = '') {
    if ((0, _commonJs.config).debug && !validateVector(v, length)) throw new Error(`math.gl: ${callerName} some fields set to invalid numbers'`);
    return v;
}
const map = {};
function deprecated(method, version) {
    if (!map[method]) {
        map[method] = true;
        // eslint-disable-next-line
        console.warn(`${method} has been removed in version ${version}, see upgrade guide for more information`);
    }
}

},{"./common.js":"4XdF5","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dO8hJ":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(`math.gl assertion ${message}`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"i7WcS":[function(require,module,exports,__globalThis) {
// @eslint-disable
// @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 3 Dimensional Vector
 * @module vec3
 */ /**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */ parcelHelpers.export(exports, "create", ()=>create);
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */ parcelHelpers.export(exports, "clone", ()=>clone);
/**
 * Calculates the length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate length of
 * @returns {Number} length of a
 */ parcelHelpers.export(exports, "length", ()=>length);
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */ parcelHelpers.export(exports, "fromValues", ()=>fromValues);
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the source vector
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "copy", ()=>copy);
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "set", ()=>set);
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "subtract", ()=>subtract);
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "multiply", ()=>multiply);
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "divide", ()=>divide);
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to ceil
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "ceil", ()=>ceil);
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to floor
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "floor", ()=>floor);
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "min", ()=>min);
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "max", ()=>max);
/**
 * symmetric round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to round
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "scaleAndAdd", ()=>scaleAndAdd);
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} distance between a and b
 */ parcelHelpers.export(exports, "distance", ()=>distance);
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} squared distance between a and b
 */ parcelHelpers.export(exports, "squaredDistance", ()=>squaredDistance);
/**
 * Calculates the squared length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ parcelHelpers.export(exports, "squaredLength", ()=>squaredLength);
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to negate
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "negate", ()=>negate);
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to invert
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "inverse", ()=>inverse);
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "normalize", ()=>normalize);
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */ parcelHelpers.export(exports, "dot", ()=>dot);
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "cross", ()=>cross);
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "lerp", ()=>lerp);
/**
 * Performs a spherical linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "slerp", ()=>slerp);
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "hermite", ()=>hermite);
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "bezier", ()=>bezier);
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If omitted, a unit vector will be returned
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "random", ()=>random);
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "transformMat4", ()=>transformMat4);
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "transformMat3", ()=>transformMat3);
/**
 * Transforms the vec3 with a quat
 * Can also be used for dual quaternions. (Multiply it with the real part)
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "transformQuat", ()=>transformQuat);
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "rotateX", ()=>rotateX);
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "rotateY", ()=>rotateY);
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "rotateZ", ()=>rotateZ);
/**
 * Get the angle between two 3D vectors
 * @param {ReadonlyVec3} a The first operand
 * @param {ReadonlyVec3} b The second operand
 * @returns {Number} The angle in radians
 */ parcelHelpers.export(exports, "angle", ()=>angle);
/**
 * Set the components of a vec3 to zero
 *
 * @param {vec3} out the receiving vector
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "zero", ()=>zero);
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */ parcelHelpers.export(exports, "str", ()=>str);
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ parcelHelpers.export(exports, "exactEquals", ()=>exactEquals);
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "sub", ()=>sub);
parcelHelpers.export(exports, "mul", ()=>mul);
parcelHelpers.export(exports, "div", ()=>div);
parcelHelpers.export(exports, "dist", ()=>dist);
parcelHelpers.export(exports, "sqrDist", ()=>sqrDist);
parcelHelpers.export(exports, "len", ()=>len);
parcelHelpers.export(exports, "sqrLen", ()=>sqrLen);
parcelHelpers.export(exports, "forEach", ()=>forEach);
var _commonJs = require("./common.js");
function create() {
    const out = new _commonJs.ARRAY_TYPE(3);
    if (_commonJs.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function clone(a) {
    const out = new _commonJs.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function length(a) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function fromValues(x, y, z) {
    const out = new _commonJs.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function set(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function multiply(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function divide(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function ceil(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function floor(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function min(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function max(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function round(out, a) {
    out[0] = _commonJs.round(a[0]);
    out[1] = _commonJs.round(a[1]);
    out[2] = _commonJs.round(a[2]);
    return out;
}
function scale(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function scaleAndAdd(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function distance(a, b) {
    const x = b[0] - a[0];
    const y = b[1] - a[1];
    const z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function squaredDistance(a, b) {
    const x = b[0] - a[0];
    const y = b[1] - a[1];
    const z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function squaredLength(a) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    return x * x + y * y + z * z;
}
function negate(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function inverse(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function normalize(out, a) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    let len = x * x + y * y + z * z;
    if (len > 0) // TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cross(out, a, b) {
    const ax = a[0];
    const ay = a[1];
    const az = a[2];
    const bx = b[0];
    const by = b[1];
    const bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function lerp(out, a, b, t) {
    const ax = a[0];
    const ay = a[1];
    const az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function slerp(out, a, b, t) {
    const angle = Math.acos(Math.min(Math.max(dot(a, b), -1), 1));
    const sinTotal = Math.sin(angle);
    const ratioA = Math.sin((1 - t) * angle) / sinTotal;
    const ratioB = Math.sin(t * angle) / sinTotal;
    out[0] = ratioA * a[0] + ratioB * b[0];
    out[1] = ratioA * a[1] + ratioB * b[1];
    out[2] = ratioA * a[2] + ratioB * b[2];
    return out;
}
function hermite(out, a, b, c, d, t) {
    const factorTimes2 = t * t;
    const factor1 = factorTimes2 * (2 * t - 3) + 1;
    const factor2 = factorTimes2 * (t - 2) + t;
    const factor3 = factorTimes2 * (t - 1);
    const factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function bezier(out, a, b, c, d, t) {
    const inverseFactor = 1 - t;
    const inverseFactorTimesTwo = inverseFactor * inverseFactor;
    const factorTimes2 = t * t;
    const factor1 = inverseFactorTimesTwo * inverseFactor;
    const factor2 = 3 * t * inverseFactorTimesTwo;
    const factor3 = 3 * factorTimes2 * inverseFactor;
    const factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function random(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    const r = _commonJs.RANDOM() * 2.0 * Math.PI;
    const z = _commonJs.RANDOM() * 2.0 - 1.0;
    const zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function transformMat4(out, a, m) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    let w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function transformMat3(out, a, m) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function transformQuat(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    const qx = q[0];
    const qy = q[1];
    const qz = q[2];
    const qw = q[3];
    const x = a[0];
    const y = a[1];
    const z = a[2];
    // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    let uvx = qy * z - qz * y;
    let uvy = qz * x - qx * z;
    let uvz = qx * y - qy * x;
    // var uuv = vec3.cross([], qvec, uv);
    let uuvx = qy * uvz - qz * uvy;
    let uuvy = qz * uvx - qx * uvz;
    let uuvz = qx * uvy - qy * uvx;
    // vec3.scale(uv, uv, 2 * w);
    const w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2;
    // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2;
    // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function rotateX(out, a, b, rad) {
    const p = [];
    const r = [];
    // Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    // perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad);
    // translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function rotateY(out, a, b, rad) {
    const p = [];
    const r = [];
    // Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    // perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad);
    // translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function rotateZ(out, a, b, rad) {
    const p = [];
    const r = [];
    // Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    // perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2];
    // translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function angle(a, b) {
    const ax = a[0];
    const ay = a[1];
    const az = a[2];
    const bx = b[0];
    const by = b[1];
    const bz = b[2];
    const mag = Math.sqrt((ax * ax + ay * ay + az * az) * (bx * bx + by * by + bz * bz));
    const cosine = mag && dot(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function zero(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function str(a) {
    return `vec3(${a[0]}, ${a[1]}, ${a[2]})`;
}
function exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function equals(a, b) {
    const a0 = a[0];
    const a1 = a[1];
    const a2 = a[2];
    const b0 = b[0];
    const b1 = b[1];
    const b2 = b[2];
    return Math.abs(a0 - b0) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
const sub = subtract;
const mul = multiply;
const div = divide;
const dist = distance;
const sqrDist = squaredDistance;
const len = length;
const sqrLen = squaredLength;
const forEach = function() {
    const vec = create();
    return function(a, stride, offset, count, fn, arg) {
        let i;
        let l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

},{"./common.js":"ibvuK","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ibvuK":[function(require,module,exports,__globalThis) {
// @eslint-disable
// @ts-nocheck
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EPSILON", ()=>EPSILON);
parcelHelpers.export(exports, "ARRAY_TYPE", ()=>ARRAY_TYPE);
parcelHelpers.export(exports, "RANDOM", ()=>RANDOM);
parcelHelpers.export(exports, "ANGLE_ORDER", ()=>ANGLE_ORDER);
/**
 * Symmetric round
 * see https://www.npmjs.com/package/round-half-up-symmetric#user-content-detailed-background
 *
 * @param {Number} a value to round
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Sets the type of array used when creating new vectors and matrices
 *
 * @param {Float32ArrayConstructor | ArrayConstructor} type Array type, such as Float32Array or Array
 */ parcelHelpers.export(exports, "setMatrixArrayType", ()=>setMatrixArrayType);
/**
 * Convert Degree To Radian
 *
 * @param {Number} a Angle in Degrees
 */ parcelHelpers.export(exports, "toRadian", ()=>toRadian);
/**
 * Tests whether or not the arguments have approximately the same value, within an absolute
 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less
 * than or equal to 1.0, and a relative tolerance is used for larger values)
 *
 * @param {Number} a The first number to test.
 * @param {Number} b The second number to test.
 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
 */ parcelHelpers.export(exports, "equals", ()=>equals);
const EPSILON = 0.000001;
let ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
const RANDOM = Math.random;
const ANGLE_ORDER = 'zyx';
function round(a) {
    if (a >= 0) return Math.round(a);
    return a % 0.5 === 0 ? Math.floor(a) : Math.round(a);
}
function setMatrixArrayType(type) {
    ARRAY_TYPE = type;
}
const degree = Math.PI / 180;
function toRadian(a) {
    return a * degree;
}
function equals(a, b) {
    return Math.abs(a - b) <= EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4iy67":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// vec2 additions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vec2_transformMat4AsVector", ()=>vec2_transformMat4AsVector);
// vec3 additions
// Transform as vector, only uses 3x3 minor matrix
parcelHelpers.export(exports, "vec3_transformMat4AsVector", ()=>vec3_transformMat4AsVector);
parcelHelpers.export(exports, "vec3_transformMat2", ()=>vec3_transformMat2);
// vec4 additions
parcelHelpers.export(exports, "vec4_transformMat2", ()=>vec4_transformMat2);
parcelHelpers.export(exports, "vec4_transformMat3", ()=>vec4_transformMat3);
function vec2_transformMat4AsVector(out, a, m) {
    const x = a[0];
    const y = a[1];
    const w = m[3] * x + m[7] * y || 1.0;
    out[0] = (m[0] * x + m[4] * y) / w;
    out[1] = (m[1] * x + m[5] * y) / w;
    return out;
}
function vec3_transformMat4AsVector(out, a, m) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    const w = m[3] * x + m[7] * y + m[11] * z || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z) / w;
    return out;
}
function vec3_transformMat2(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    out[2] = a[2];
    return out;
}
function vec4_transformMat2(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function vec4_transformMat3(out, a, m) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    out[0] = m[0] * x + m[3] * y + m[6] * z;
    out[1] = m[1] * x + m[4] * y + m[7] * z;
    out[2] = m[2] * x + m[5] * y + m[8] * z;
    out[3] = a[3];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jX6tL":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Copyright (c) 2017 Uber Technologies, Inc.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A 4x4 matrix with common linear algebra operations
 * Subclass of Array<number> meaning that it is highly compatible with other libraries
 */ parcelHelpers.export(exports, "Matrix4", ()=>Matrix4);
var _matrixJs = require("./base/matrix.js");
var _validatorsJs = require("../lib/validators.js");
/* eslint-disable camelcase */ var _glMatrixExtrasJs = require("../lib/gl-matrix-extras.js");
// @ts-ignore gl-matrix types...
var _mat4Js = require("../gl-matrix/mat4.js");
var _vec2Js = require("../gl-matrix/vec2.js");
var _vec3Js = require("../gl-matrix/vec3.js");
var _vec4Js = require("../gl-matrix/vec4.js");
// eslint-disable-next-line no-shadow
var INDICES;
(function(INDICES) {
    INDICES[INDICES["COL0ROW0"] = 0] = "COL0ROW0";
    INDICES[INDICES["COL0ROW1"] = 1] = "COL0ROW1";
    INDICES[INDICES["COL0ROW2"] = 2] = "COL0ROW2";
    INDICES[INDICES["COL0ROW3"] = 3] = "COL0ROW3";
    INDICES[INDICES["COL1ROW0"] = 4] = "COL1ROW0";
    INDICES[INDICES["COL1ROW1"] = 5] = "COL1ROW1";
    INDICES[INDICES["COL1ROW2"] = 6] = "COL1ROW2";
    INDICES[INDICES["COL1ROW3"] = 7] = "COL1ROW3";
    INDICES[INDICES["COL2ROW0"] = 8] = "COL2ROW0";
    INDICES[INDICES["COL2ROW1"] = 9] = "COL2ROW1";
    INDICES[INDICES["COL2ROW2"] = 10] = "COL2ROW2";
    INDICES[INDICES["COL2ROW3"] = 11] = "COL2ROW3";
    INDICES[INDICES["COL3ROW0"] = 12] = "COL3ROW0";
    INDICES[INDICES["COL3ROW1"] = 13] = "COL3ROW1";
    INDICES[INDICES["COL3ROW2"] = 14] = "COL3ROW2";
    INDICES[INDICES["COL3ROW3"] = 15] = "COL3ROW3";
})(INDICES || (INDICES = {}));
const DEFAULT_FOVY = 45 * Math.PI / 180;
const DEFAULT_ASPECT = 1;
const DEFAULT_NEAR = 0.1;
const DEFAULT_FAR = 500;
const IDENTITY_MATRIX = Object.freeze([
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
]);
class Matrix4 extends (0, _matrixJs.Matrix) {
    static get IDENTITY() {
        return getIdentityMatrix();
    }
    static get ZERO() {
        return getZeroMatrix();
    }
    get ELEMENTS() {
        return 16;
    }
    get RANK() {
        return 4;
    }
    get INDICES() {
        return INDICES;
    }
    constructor(array){
        // PERF NOTE: initialize elements as double precision numbers
        super(-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0);
        if (arguments.length === 1 && Array.isArray(array)) this.copy(array);
        else this.identity();
    }
    copy(array) {
        this[0] = array[0];
        this[1] = array[1];
        this[2] = array[2];
        this[3] = array[3];
        this[4] = array[4];
        this[5] = array[5];
        this[6] = array[6];
        this[7] = array[7];
        this[8] = array[8];
        this[9] = array[9];
        this[10] = array[10];
        this[11] = array[11];
        this[12] = array[12];
        this[13] = array[13];
        this[14] = array[14];
        this[15] = array[15];
        return this.check();
    }
    // eslint-disable-next-line max-params
    set(m00, m10, m20, m30, m01, m11, m21, m31, m02, m12, m22, m32, m03, m13, m23, m33) {
        this[0] = m00;
        this[1] = m10;
        this[2] = m20;
        this[3] = m30;
        this[4] = m01;
        this[5] = m11;
        this[6] = m21;
        this[7] = m31;
        this[8] = m02;
        this[9] = m12;
        this[10] = m22;
        this[11] = m32;
        this[12] = m03;
        this[13] = m13;
        this[14] = m23;
        this[15] = m33;
        return this.check();
    }
    // accepts row major order, stores as column major
    // eslint-disable-next-line max-params
    setRowMajor(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
        this[0] = m00;
        this[1] = m10;
        this[2] = m20;
        this[3] = m30;
        this[4] = m01;
        this[5] = m11;
        this[6] = m21;
        this[7] = m31;
        this[8] = m02;
        this[9] = m12;
        this[10] = m22;
        this[11] = m32;
        this[12] = m03;
        this[13] = m13;
        this[14] = m23;
        this[15] = m33;
        return this.check();
    }
    toRowMajor(result) {
        result[0] = this[0];
        result[1] = this[4];
        result[2] = this[8];
        result[3] = this[12];
        result[4] = this[1];
        result[5] = this[5];
        result[6] = this[9];
        result[7] = this[13];
        result[8] = this[2];
        result[9] = this[6];
        result[10] = this[10];
        result[11] = this[14];
        result[12] = this[3];
        result[13] = this[7];
        result[14] = this[11];
        result[15] = this[15];
        return result;
    }
    // Constructors
    /** Set to identity matrix */ identity() {
        return this.copy(IDENTITY_MATRIX);
    }
    /**
     *
     * @param object
     * @returns self
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fromObject(object) {
        return this.check();
    }
    /**
     * Calculates a 4x4 matrix from the given quaternion
     * @param quaternion Quaternion to create matrix from
     * @returns self
     */ fromQuaternion(quaternion) {
        (0, _mat4Js.fromQuat)(this, quaternion);
        return this.check();
    }
    /**
     * Generates a frustum matrix with the given bounds
     * @param view.left - Left bound of the frustum
     * @param view.right - Right bound of the frustum
     * @param view.bottom - Bottom bound of the frustum
     * @param view.top - Top bound of the frustum
     * @param view.near - Near bound of the frustum
     * @param view.far - Far bound of the frustum. Can be set to Infinity.
     * @returns self
     */ frustum(view) {
        const { left, right, bottom, top, near = DEFAULT_NEAR, far = DEFAULT_FAR } = view;
        if (far === Infinity) computeInfinitePerspectiveOffCenter(this, left, right, bottom, top, near);
        else (0, _mat4Js.frustum)(this, left, right, bottom, top, near, far);
        return this.check();
    }
    /**
     * Generates a look-at matrix with the given eye position, focal point,
     * and up axis
     * @param view.eye - (vector) Position of the viewer
     * @param view.center - (vector) Point the viewer is looking at
     * @param view.up - (vector) Up axis
     * @returns self
     */ lookAt(view) {
        const { eye, center = [
            0,
            0,
            0
        ], up = [
            0,
            1,
            0
        ] } = view;
        (0, _mat4Js.lookAt)(this, eye, center, up);
        return this.check();
    }
    /**
     * Generates a orthogonal projection matrix with the given bounds
     * from "traditional" view space parameters
     * @param view.left - Left bound of the frustum
     * @param view.right number  Right bound of the frustum
     * @param view.bottom - Bottom bound of the frustum
     * @param view.top number  Top bound of the frustum
     * @param view.near - Near bound of the frustum
     * @param view.far number  Far bound of the frustum
     * @returns self
     */ ortho(view) {
        const { left, right, bottom, top, near = DEFAULT_NEAR, far = DEFAULT_FAR } = view;
        (0, _mat4Js.ortho)(this, left, right, bottom, top, near, far);
        return this.check();
    }
    /**
     * Generates an orthogonal projection matrix with the same parameters
     * as a perspective matrix (plus focalDistance)
     * @param view.fovy Vertical field of view in radians
     * @param view.aspect Aspect ratio. Typically viewport width / viewport height
     * @param view.focalDistance Distance in the view frustum used for extent calculations
     * @param view.near Near bound of the frustum
     * @param view.far Far bound of the frustum
     * @returns self
     */ orthographic(view) {
        const { fovy = DEFAULT_FOVY, aspect = DEFAULT_ASPECT, focalDistance = 1, near = DEFAULT_NEAR, far = DEFAULT_FAR } = view;
        checkRadians(fovy);
        const halfY = fovy / 2;
        const top = focalDistance * Math.tan(halfY); // focus_plane is the distance from the camera
        const right = top * aspect;
        return this.ortho({
            left: -right,
            right,
            bottom: -top,
            top,
            near,
            far
        });
    }
    /**
     * Generates a perspective projection matrix with the given bounds
     * @param view.fovy Vertical field of view in radians
     * @param view.aspect Aspect ratio. typically viewport width/height
     * @param view.near Near bound of the frustum
     * @param view.far Far bound of the frustum
     * @returns self
     */ perspective(view) {
        const { fovy = 45 * Math.PI / 180, aspect = 1, near = 0.1, far = 500 } = view;
        checkRadians(fovy);
        (0, _mat4Js.perspective)(this, fovy, aspect, near, far);
        return this.check();
    }
    // Accessors
    determinant() {
        return (0, _mat4Js.determinant)(this);
    }
    /**
     * Extracts the non-uniform scale assuming the matrix is an affine transformation.
     * The scales are the "lengths" of the column vectors in the upper-left 3x3 matrix.
     * @param result
     * @returns self
     */ getScale(result = [
        -0,
        -0,
        -0
    ]) {
        // explicit is faster than hypot...
        result[0] = Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]);
        result[1] = Math.sqrt(this[4] * this[4] + this[5] * this[5] + this[6] * this[6]);
        result[2] = Math.sqrt(this[8] * this[8] + this[9] * this[9] + this[10] * this[10]);
        // result[0] = Math.hypot(this[0], this[1], this[2]);
        // result[1] = Math.hypot(this[4], this[5], this[6]);
        // result[2] = Math.hypot(this[8], this[9], this[10]);
        return result;
    }
    /**
     * Gets the translation portion, assuming the matrix is a affine transformation matrix.
     * @param result
     * @returns self
     */ getTranslation(result = [
        -0,
        -0,
        -0
    ]) {
        result[0] = this[12];
        result[1] = this[13];
        result[2] = this[14];
        return result;
    }
    /**
     * Gets upper left 3x3 pure rotation matrix (non-scaling), assume affine transformation matrix
     * @param result
     * @param scaleResult
     * @returns self
     */ getRotation(result, scaleResult) {
        result = result || [
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0
        ];
        scaleResult = scaleResult || [
            -0,
            -0,
            -0
        ];
        const scale = this.getScale(scaleResult);
        const inverseScale0 = 1 / scale[0];
        const inverseScale1 = 1 / scale[1];
        const inverseScale2 = 1 / scale[2];
        result[0] = this[0] * inverseScale0;
        result[1] = this[1] * inverseScale1;
        result[2] = this[2] * inverseScale2;
        result[3] = 0;
        result[4] = this[4] * inverseScale0;
        result[5] = this[5] * inverseScale1;
        result[6] = this[6] * inverseScale2;
        result[7] = 0;
        result[8] = this[8] * inverseScale0;
        result[9] = this[9] * inverseScale1;
        result[10] = this[10] * inverseScale2;
        result[11] = 0;
        result[12] = 0;
        result[13] = 0;
        result[14] = 0;
        result[15] = 1;
        return result;
    }
    /**
     *
     * @param result
     * @param scaleResult
     * @returns self
     */ getRotationMatrix3(result, scaleResult) {
        result = result || [
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0
        ];
        scaleResult = scaleResult || [
            -0,
            -0,
            -0
        ];
        const scale = this.getScale(scaleResult);
        const inverseScale0 = 1 / scale[0];
        const inverseScale1 = 1 / scale[1];
        const inverseScale2 = 1 / scale[2];
        result[0] = this[0] * inverseScale0;
        result[1] = this[1] * inverseScale1;
        result[2] = this[2] * inverseScale2;
        result[3] = this[4] * inverseScale0;
        result[4] = this[5] * inverseScale1;
        result[5] = this[6] * inverseScale2;
        result[6] = this[8] * inverseScale0;
        result[7] = this[9] * inverseScale1;
        result[8] = this[10] * inverseScale2;
        return result;
    }
    // Modifiers
    transpose() {
        (0, _mat4Js.transpose)(this, this);
        return this.check();
    }
    invert() {
        (0, _mat4Js.invert)(this, this);
        return this.check();
    }
    // Operations
    multiplyLeft(a) {
        (0, _mat4Js.multiply)(this, a, this);
        return this.check();
    }
    multiplyRight(a) {
        (0, _mat4Js.multiply)(this, this, a);
        return this.check();
    }
    // Rotates a matrix by the given angle around the X axis
    rotateX(radians) {
        (0, _mat4Js.rotateX)(this, this, radians);
        // mat4_rotate(this, this, radians, [1, 0, 0]);
        return this.check();
    }
    // Rotates a matrix by the given angle around the Y axis.
    rotateY(radians) {
        (0, _mat4Js.rotateY)(this, this, radians);
        // mat4_rotate(this, this, radians, [0, 1, 0]);
        return this.check();
    }
    /**
     * Rotates a matrix by the given angle around the Z axis.
     * @param radians
     * @returns self
     */ rotateZ(radians) {
        (0, _mat4Js.rotateZ)(this, this, radians);
        // mat4_rotate(this, this, radians, [0, 0, 1]);
        return this.check();
    }
    /**
     *
     * @param param0
     * @returns self
     */ rotateXYZ(angleXYZ) {
        return this.rotateX(angleXYZ[0]).rotateY(angleXYZ[1]).rotateZ(angleXYZ[2]);
    }
    /**
     *
     * @param radians
     * @param axis
     * @returns self
     */ rotateAxis(radians, axis) {
        (0, _mat4Js.rotate)(this, this, radians, axis);
        return this.check();
    }
    /**
     *
     * @param factor
     * @returns self
     */ scale(factor) {
        (0, _mat4Js.scale)(this, this, Array.isArray(factor) ? factor : [
            factor,
            factor,
            factor
        ]);
        return this.check();
    }
    /**
     *
     * @param vec
     * @returns self
     */ translate(vector) {
        (0, _mat4Js.translate)(this, this, vector);
        return this.check();
    }
    // Transforms
    /**
     * Transforms any 2, 3 or 4 element vector. 2 and 3 elements are treated as points
     * @param vector
     * @param result
     * @returns self
     */ transform(vector, result) {
        if (vector.length === 4) {
            result = (0, _vec4Js.transformMat4)(result || [
                -0,
                -0,
                -0,
                -0
            ], vector, this);
            (0, _validatorsJs.checkVector)(result, 4);
            return result;
        }
        return this.transformAsPoint(vector, result);
    }
    /**
     * Transforms any 2 or 3 element array as point (w implicitly 1)
     * @param vector
     * @param result
     * @returns self
     */ transformAsPoint(vector, result) {
        const { length } = vector;
        let out;
        switch(length){
            case 2:
                out = (0, _vec2Js.transformMat4)(result || [
                    -0,
                    -0
                ], vector, this);
                break;
            case 3:
                out = (0, _vec3Js.transformMat4)(result || [
                    -0,
                    -0,
                    -0
                ], vector, this);
                break;
            default:
                throw new Error('Illegal vector');
        }
        (0, _validatorsJs.checkVector)(out, vector.length);
        return out;
    }
    /**
     * Transforms any 2 or 3 element array as vector (w implicitly 0)
     * @param vector
     * @param result
     * @returns self
     */ transformAsVector(vector, result) {
        let out;
        switch(vector.length){
            case 2:
                out = (0, _glMatrixExtrasJs.vec2_transformMat4AsVector)(result || [
                    -0,
                    -0
                ], vector, this);
                break;
            case 3:
                out = (0, _glMatrixExtrasJs.vec3_transformMat4AsVector)(result || [
                    -0,
                    -0,
                    -0
                ], vector, this);
                break;
            default:
                throw new Error('Illegal vector');
        }
        (0, _validatorsJs.checkVector)(out, vector.length);
        return out;
    }
    /** @deprecated */ transformPoint(vector, result) {
        return this.transformAsPoint(vector, result);
    }
    /** @deprecated */ transformVector(vector, result) {
        return this.transformAsPoint(vector, result);
    }
    /** @deprecated */ transformDirection(vector, result) {
        return this.transformAsVector(vector, result);
    }
    // three.js math API compatibility
    makeRotationX(radians) {
        return this.identity().rotateX(radians);
    }
    makeTranslation(x, y, z) {
        return this.identity().translate([
            x,
            y,
            z
        ]);
    }
}
// TODO initializing static members directly is an option, but make sure no tree-shaking issues
let ZERO;
let IDENTITY;
function getZeroMatrix() {
    if (!ZERO) {
        ZERO = new Matrix4([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        Object.freeze(ZERO);
    }
    return ZERO;
}
function getIdentityMatrix() {
    if (!IDENTITY) {
        IDENTITY = new Matrix4();
        Object.freeze(IDENTITY);
    }
    return IDENTITY;
}
// HELPER FUNCTIONS
function checkRadians(possiblyDegrees) {
    if (possiblyDegrees > Math.PI * 2) throw Error('expected radians');
}
// eslint-disable-next-line max-params
function computeInfinitePerspectiveOffCenter(result, left, right, bottom, top, near) {
    const column0Row0 = 2 * near / (right - left);
    const column1Row1 = 2 * near / (top - bottom);
    const column2Row0 = (right + left) / (right - left);
    const column2Row1 = (top + bottom) / (top - bottom);
    const column2Row2 = -1;
    const column2Row3 = -1;
    const column3Row2 = -2 * near;
    result[0] = column0Row0;
    result[1] = 0;
    result[2] = 0;
    result[3] = 0;
    result[4] = 0;
    result[5] = column1Row1;
    result[6] = 0;
    result[7] = 0;
    result[8] = column2Row0;
    result[9] = column2Row1;
    result[10] = column2Row2;
    result[11] = column2Row3;
    result[12] = 0;
    result[13] = 0;
    result[14] = column3Row2;
    result[15] = 0;
    return result;
}

},{"./base/matrix.js":"211bT","../lib/validators.js":"ciggz","../lib/gl-matrix-extras.js":"4iy67","../gl-matrix/mat4.js":"iBAKs","../gl-matrix/vec2.js":"l8RgT","../gl-matrix/vec3.js":"i7WcS","../gl-matrix/vec4.js":"2yXLd","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"211bT":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Copyright (c) 2017 Uber Technologies, Inc.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Base class for matrices */ parcelHelpers.export(exports, "Matrix", ()=>Matrix);
var _mathArrayJs = require("./math-array.js");
var _validatorsJs = require("../../lib/validators.js");
var _commonJs = require("../../lib/common.js");
class Matrix extends (0, _mathArrayJs.MathArray) {
    // fromObject(object) {
    //   const array = object.elements;
    //   return this.fromRowMajor(array);
    // }
    // toObject(object) {
    //   const array = object.elements;
    //   this.toRowMajor(array);
    //   return object;
    // }
    // TODO better override formatString?
    toString() {
        let string = '[';
        if ((0, _commonJs.config).printRowMajor) {
            string += 'row-major:';
            for(let row = 0; row < this.RANK; ++row)for(let col = 0; col < this.RANK; ++col)string += ` ${this[col * this.RANK + row]}`;
        } else {
            string += 'column-major:';
            for(let i = 0; i < this.ELEMENTS; ++i)string += ` ${this[i]}`;
        }
        string += ']';
        return string;
    }
    getElementIndex(row, col) {
        return col * this.RANK + row;
    }
    // By default assumes row major indices
    getElement(row, col) {
        return this[col * this.RANK + row];
    }
    // By default assumes row major indices
    setElement(row, col, value) {
        this[col * this.RANK + row] = (0, _validatorsJs.checkNumber)(value);
        return this;
    }
    getColumn(columnIndex, result = new Array(this.RANK).fill(-0)) {
        const firstIndex = columnIndex * this.RANK;
        for(let i = 0; i < this.RANK; ++i)result[i] = this[firstIndex + i];
        return result;
    }
    setColumn(columnIndex, columnVector) {
        const firstIndex = columnIndex * this.RANK;
        for(let i = 0; i < this.RANK; ++i)this[firstIndex + i] = columnVector[i];
        return this;
    }
}

},{"./math-array.js":"fhqP3","../../lib/validators.js":"ciggz","../../lib/common.js":"4XdF5","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iBAKs":[function(require,module,exports,__globalThis) {
// @eslint-disable
// @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */ /**
 * Creates a new identity mat4
 *
 * @returns a new 4x4 matrix
 */ parcelHelpers.export(exports, "create", ()=>create);
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */ parcelHelpers.export(exports, "clone", ()=>clone);
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "copy", ()=>copy);
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */ parcelHelpers.export(exports, "fromValues", ()=>fromValues);
/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "set", ()=>set);
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "identity", ()=>identity);
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "transpose", ()=>transpose);
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "invert", ()=>invert);
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "adjoint", ()=>adjoint);
/**
 * Calculates the determinant of a mat4
 *
 * @param {ReadonlyMat4} a the source matrix
 * @returns {Number} determinant of a
 */ parcelHelpers.export(exports, "determinant", ()=>determinant);
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "multiply", ()=>multiply);
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "translate", ()=>translate);
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {ReadonlyVec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "rotate", ()=>rotate);
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "rotateX", ()=>rotateX);
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "rotateY", ()=>rotateY);
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "rotateZ", ()=>rotateZ);
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromTranslation", ()=>fromTranslation);
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Scaling vector
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromScaling", ()=>fromScaling);
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromRotation", ()=>fromRotation);
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromXRotation", ()=>fromXRotation);
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromYRotation", ()=>fromYRotation);
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromZRotation", ()=>fromZRotation);
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromRotationTranslation", ()=>fromRotationTranslation);
/**
 * Creates a new mat4 from a dual quat.
 *
 * @param {mat4} out Matrix
 * @param {ReadonlyQuat2} a Dual Quaternion
 * @returns {mat4} mat4 receiving operation result
 */ parcelHelpers.export(exports, "fromQuat2", ()=>fromQuat2);
/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */ parcelHelpers.export(exports, "getTranslation", ()=>getTranslation);
/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */ parcelHelpers.export(exports, "getScaling", ()=>getScaling);
/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */ parcelHelpers.export(exports, "getRotation", ()=>getRotation);
/**
 * Decomposes a transformation matrix into its rotation, translation
 * and scale components. Returns only the rotation component
 * @param  {quat} out_r Quaternion to receive the rotation component
 * @param  {vec3} out_t Vector to receive the translation vector
 * @param  {vec3} out_s Vector to receive the scaling factor
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @returns {quat} out_r
 */ parcelHelpers.export(exports, "decompose", ()=>decompose);
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromRotationTranslationScale", ()=>fromRotationTranslationScale);
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @param {ReadonlyVec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromRotationTranslationScaleOrigin", ()=>fromRotationTranslationScaleOrigin);
/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "fromQuat", ()=>fromQuat);
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "frustum", ()=>frustum);
/**
 * Generates a perspective projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "perspectiveNO", ()=>perspectiveNO);
parcelHelpers.export(exports, "perspective", ()=>perspective);
/**
 * Generates a perspective projection matrix suitable for WebGPU with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "perspectiveZO", ()=>perspectiveZO);
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "perspectiveFromFieldOfView", ()=>perspectiveFromFieldOfView);
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "orthoNO", ()=>orthoNO);
parcelHelpers.export(exports, "ortho", ()=>ortho);
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "orthoZO", ()=>orthoZO);
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis.
 * If you want a matrix that actually makes an object look at another object, you should use targetTo instead.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "lookAt", ()=>lookAt);
/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "targetTo", ()=>targetTo);
/**
 * Returns a string representation of a mat4
 *
 * @param {ReadonlyMat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */ parcelHelpers.export(exports, "str", ()=>str);
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {ReadonlyMat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */ parcelHelpers.export(exports, "frob", ()=>frob);
/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "subtract", ()=>subtract);
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "multiplyScalar", ()=>multiplyScalar);
/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */ parcelHelpers.export(exports, "multiplyScalarAndAdd", ()=>multiplyScalarAndAdd);
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */ parcelHelpers.export(exports, "exactEquals", ()=>exactEquals);
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */ parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "mul", ()=>mul);
parcelHelpers.export(exports, "sub", ()=>sub);
var _commonJs = require("./common.js");
function create() {
    const out = new _commonJs.ARRAY_TYPE(16);
    if (_commonJs.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function clone(a) {
    const out = new _commonJs.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function fromValues(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    const out = new _commonJs.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function set(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function transpose(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        const a01 = a[1];
        const a02 = a[2];
        const a03 = a[3];
        const a12 = a[6];
        const a13 = a[7];
        const a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function invert(out, a) {
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a03 = a[3];
    const a10 = a[4];
    const a11 = a[5];
    const a12 = a[6];
    const a13 = a[7];
    const a20 = a[8];
    const a21 = a[9];
    const a22 = a[10];
    const a23 = a[11];
    const a30 = a[12];
    const a31 = a[13];
    const a32 = a[14];
    const a33 = a[15];
    const b00 = a00 * a11 - a01 * a10;
    const b01 = a00 * a12 - a02 * a10;
    const b02 = a00 * a13 - a03 * a10;
    const b03 = a01 * a12 - a02 * a11;
    const b04 = a01 * a13 - a03 * a11;
    const b05 = a02 * a13 - a03 * a12;
    const b06 = a20 * a31 - a21 * a30;
    const b07 = a20 * a32 - a22 * a30;
    const b08 = a20 * a33 - a23 * a30;
    const b09 = a21 * a32 - a22 * a31;
    const b10 = a21 * a33 - a23 * a31;
    const b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function adjoint(out, a) {
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a03 = a[3];
    const a10 = a[4];
    const a11 = a[5];
    const a12 = a[6];
    const a13 = a[7];
    const a20 = a[8];
    const a21 = a[9];
    const a22 = a[10];
    const a23 = a[11];
    const a30 = a[12];
    const a31 = a[13];
    const a32 = a[14];
    const a33 = a[15];
    const b00 = a00 * a11 - a01 * a10;
    const b01 = a00 * a12 - a02 * a10;
    const b02 = a00 * a13 - a03 * a10;
    const b03 = a01 * a12 - a02 * a11;
    const b04 = a01 * a13 - a03 * a11;
    const b05 = a02 * a13 - a03 * a12;
    const b06 = a20 * a31 - a21 * a30;
    const b07 = a20 * a32 - a22 * a30;
    const b08 = a20 * a33 - a23 * a30;
    const b09 = a21 * a32 - a22 * a31;
    const b10 = a21 * a33 - a23 * a31;
    const b11 = a22 * a33 - a23 * a32;
    out[0] = a11 * b11 - a12 * b10 + a13 * b09;
    out[1] = a02 * b10 - a01 * b11 - a03 * b09;
    out[2] = a31 * b05 - a32 * b04 + a33 * b03;
    out[3] = a22 * b04 - a21 * b05 - a23 * b03;
    out[4] = a12 * b08 - a10 * b11 - a13 * b07;
    out[5] = a00 * b11 - a02 * b08 + a03 * b07;
    out[6] = a32 * b02 - a30 * b05 - a33 * b01;
    out[7] = a20 * b05 - a22 * b02 + a23 * b01;
    out[8] = a10 * b10 - a11 * b08 + a13 * b06;
    out[9] = a01 * b08 - a00 * b10 - a03 * b06;
    out[10] = a30 * b04 - a31 * b02 + a33 * b00;
    out[11] = a21 * b02 - a20 * b04 - a23 * b00;
    out[12] = a11 * b07 - a10 * b09 - a12 * b06;
    out[13] = a00 * b09 - a01 * b07 + a02 * b06;
    out[14] = a31 * b01 - a30 * b03 - a32 * b00;
    out[15] = a20 * b03 - a21 * b01 + a22 * b00;
    return out;
}
function determinant(a) {
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a03 = a[3];
    const a10 = a[4];
    const a11 = a[5];
    const a12 = a[6];
    const a13 = a[7];
    const a20 = a[8];
    const a21 = a[9];
    const a22 = a[10];
    const a23 = a[11];
    const a30 = a[12];
    const a31 = a[13];
    const a32 = a[14];
    const a33 = a[15];
    const b0 = a00 * a11 - a01 * a10;
    const b1 = a00 * a12 - a02 * a10;
    const b2 = a01 * a12 - a02 * a11;
    const b3 = a20 * a31 - a21 * a30;
    const b4 = a20 * a32 - a22 * a30;
    const b5 = a21 * a32 - a22 * a31;
    const b6 = a00 * b5 - a01 * b4 + a02 * b3;
    const b7 = a10 * b5 - a11 * b4 + a12 * b3;
    const b8 = a20 * b2 - a21 * b1 + a22 * b0;
    const b9 = a30 * b2 - a31 * b1 + a32 * b0;
    // Calculate the determinant
    return a13 * b6 - a03 * b7 + a33 * b8 - a23 * b9;
}
function multiply(out, a, b) {
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a03 = a[3];
    const a10 = a[4];
    const a11 = a[5];
    const a12 = a[6];
    const a13 = a[7];
    const a20 = a[8];
    const a21 = a[9];
    const a22 = a[10];
    const a23 = a[11];
    const a30 = a[12];
    const a31 = a[13];
    const a32 = a[14];
    const a33 = a[15];
    // Cache only the current line of the second matrix
    let b0 = b[0];
    let b1 = b[1];
    let b2 = b[2];
    let b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function translate(out, a, v) {
    const x = v[0];
    const y = v[1];
    const z = v[2];
    let a00;
    let a01;
    let a02;
    let a03;
    let a10;
    let a11;
    let a12;
    let a13;
    let a20;
    let a21;
    let a22;
    let a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function scale(out, a, v) {
    const x = v[0];
    const y = v[1];
    const z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function rotate(out, a, rad, axis) {
    let x = axis[0];
    let y = axis[1];
    let z = axis[2];
    let len = Math.sqrt(x * x + y * y + z * z);
    let c;
    let s;
    let t;
    let a00;
    let a01;
    let a02;
    let a03;
    let a10;
    let a11;
    let a12;
    let a13;
    let a20;
    let a21;
    let a22;
    let a23;
    let b00;
    let b01;
    let b02;
    let b10;
    let b11;
    let b12;
    let b20;
    let b21;
    let b22;
    if (len < _commonJs.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function rotateX(out, a, rad) {
    const s = Math.sin(rad);
    const c = Math.cos(rad);
    const a10 = a[4];
    const a11 = a[5];
    const a12 = a[6];
    const a13 = a[7];
    const a20 = a[8];
    const a21 = a[9];
    const a22 = a[10];
    const a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function rotateY(out, a, rad) {
    const s = Math.sin(rad);
    const c = Math.cos(rad);
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a03 = a[3];
    const a20 = a[8];
    const a21 = a[9];
    const a22 = a[10];
    const a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function rotateZ(out, a, rad) {
    const s = Math.sin(rad);
    const c = Math.cos(rad);
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a03 = a[3];
    const a10 = a[4];
    const a11 = a[5];
    const a12 = a[6];
    const a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function fromTranslation(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function fromScaling(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function fromRotation(out, rad, axis) {
    let x = axis[0];
    let y = axis[1];
    let z = axis[2];
    let len = Math.sqrt(x * x + y * y + z * z);
    let c;
    let s;
    let t;
    if (len < _commonJs.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function fromXRotation(out, rad) {
    const s = Math.sin(rad);
    const c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function fromYRotation(out, rad) {
    const s = Math.sin(rad);
    const c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function fromZRotation(out, rad) {
    const s = Math.sin(rad);
    const c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function fromRotationTranslation(out, q, v) {
    // Quaternion math
    const x = q[0];
    const y = q[1];
    const z = q[2];
    const w = q[3];
    const x2 = x + x;
    const y2 = y + y;
    const z2 = z + z;
    const xx = x * x2;
    const xy = x * y2;
    const xz = x * z2;
    const yy = y * y2;
    const yz = y * z2;
    const zz = z * z2;
    const wx = w * x2;
    const wy = w * y2;
    const wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function fromQuat2(out, a) {
    const translation = new _commonJs.ARRAY_TYPE(3);
    const bx = -a[0];
    const by = -a[1];
    const bz = -a[2];
    const bw = a[3];
    const ax = a[4];
    const ay = a[5];
    const az = a[6];
    const aw = a[7];
    const magnitude = bx * bx + by * by + bz * bz + bw * bw;
    // Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    fromRotationTranslation(out, a, translation);
    return out;
}
function getTranslation(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function getScaling(out, mat) {
    const m11 = mat[0];
    const m12 = mat[1];
    const m13 = mat[2];
    const m21 = mat[4];
    const m22 = mat[5];
    const m23 = mat[6];
    const m31 = mat[8];
    const m32 = mat[9];
    const m33 = mat[10];
    out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    return out;
}
function getRotation(out, mat) {
    const scaling = new _commonJs.ARRAY_TYPE(3);
    getScaling(scaling, mat);
    const is1 = 1 / scaling[0];
    const is2 = 1 / scaling[1];
    const is3 = 1 / scaling[2];
    const sm11 = mat[0] * is1;
    const sm12 = mat[1] * is2;
    const sm13 = mat[2] * is3;
    const sm21 = mat[4] * is1;
    const sm22 = mat[5] * is2;
    const sm23 = mat[6] * is3;
    const sm31 = mat[8] * is1;
    const sm32 = mat[9] * is2;
    const sm33 = mat[10] * is3;
    const trace = sm11 + sm22 + sm33;
    let S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function decompose(out_r, out_t, out_s, mat) {
    out_t[0] = mat[12];
    out_t[1] = mat[13];
    out_t[2] = mat[14];
    const m11 = mat[0];
    const m12 = mat[1];
    const m13 = mat[2];
    const m21 = mat[4];
    const m22 = mat[5];
    const m23 = mat[6];
    const m31 = mat[8];
    const m32 = mat[9];
    const m33 = mat[10];
    out_s[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out_s[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out_s[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    const is1 = 1 / out_s[0];
    const is2 = 1 / out_s[1];
    const is3 = 1 / out_s[2];
    const sm11 = m11 * is1;
    const sm12 = m12 * is2;
    const sm13 = m13 * is3;
    const sm21 = m21 * is1;
    const sm22 = m22 * is2;
    const sm23 = m23 * is3;
    const sm31 = m31 * is1;
    const sm32 = m32 * is2;
    const sm33 = m33 * is3;
    const trace = sm11 + sm22 + sm33;
    let S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out_r[3] = 0.25 * S;
        out_r[0] = (sm23 - sm32) / S;
        out_r[1] = (sm31 - sm13) / S;
        out_r[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out_r[3] = (sm23 - sm32) / S;
        out_r[0] = 0.25 * S;
        out_r[1] = (sm12 + sm21) / S;
        out_r[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out_r[3] = (sm31 - sm13) / S;
        out_r[0] = (sm12 + sm21) / S;
        out_r[1] = 0.25 * S;
        out_r[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out_r[3] = (sm12 - sm21) / S;
        out_r[0] = (sm31 + sm13) / S;
        out_r[1] = (sm23 + sm32) / S;
        out_r[2] = 0.25 * S;
    }
    return out_r;
}
function fromRotationTranslationScale(out, q, v, s) {
    // Quaternion math
    const x = q[0];
    const y = q[1];
    const z = q[2];
    const w = q[3];
    const x2 = x + x;
    const y2 = y + y;
    const z2 = z + z;
    const xx = x * x2;
    const xy = x * y2;
    const xz = x * z2;
    const yy = y * y2;
    const yz = y * z2;
    const zz = z * z2;
    const wx = w * x2;
    const wy = w * y2;
    const wz = w * z2;
    const sx = s[0];
    const sy = s[1];
    const sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
    // Quaternion math
    const x = q[0];
    const y = q[1];
    const z = q[2];
    const w = q[3];
    const x2 = x + x;
    const y2 = y + y;
    const z2 = z + z;
    const xx = x * x2;
    const xy = x * y2;
    const xz = x * z2;
    const yy = y * y2;
    const yz = y * z2;
    const zz = z * z2;
    const wx = w * x2;
    const wy = w * y2;
    const wz = w * z2;
    const sx = s[0];
    const sy = s[1];
    const sz = s[2];
    const ox = o[0];
    const oy = o[1];
    const oz = o[2];
    const out0 = (1 - (yy + zz)) * sx;
    const out1 = (xy + wz) * sx;
    const out2 = (xz - wy) * sx;
    const out4 = (xy - wz) * sy;
    const out5 = (1 - (xx + zz)) * sy;
    const out6 = (yz + wx) * sy;
    const out8 = (xz + wy) * sz;
    const out9 = (yz - wx) * sz;
    const out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function fromQuat(out, q) {
    const x = q[0];
    const y = q[1];
    const z = q[2];
    const w = q[3];
    const x2 = x + x;
    const y2 = y + y;
    const z2 = z + z;
    const xx = x * x2;
    const yx = y * x2;
    const yy = y * y2;
    const zx = z * x2;
    const zy = z * y2;
    const zz = z * z2;
    const wx = w * x2;
    const wy = w * y2;
    const wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function frustum(out, left, right, bottom, top, near, far) {
    const rl = 1 / (right - left);
    const tb = 1 / (top - bottom);
    const nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function perspectiveNO(out, fovy, aspect, near, far) {
    const f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        const nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
const perspective = perspectiveNO;
function perspectiveZO(out, fovy, aspect, near, far) {
    const f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        const nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function perspectiveFromFieldOfView(out, fov, near, far) {
    const upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    const downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    const leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    const rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    const xScale = 2.0 / (leftTan + rightTan);
    const yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function orthoNO(out, left, right, bottom, top, near, far) {
    const lr = 1 / (left - right);
    const bt = 1 / (bottom - top);
    const nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
const ortho = orthoNO;
function orthoZO(out, left, right, bottom, top, near, far) {
    const lr = 1 / (left - right);
    const bt = 1 / (bottom - top);
    const nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function lookAt(out, eye, center, up) {
    let len;
    let x0;
    let x1;
    let x2;
    let y0;
    let y1;
    let y2;
    let z0;
    let z1;
    let z2;
    const eyex = eye[0];
    const eyey = eye[1];
    const eyez = eye[2];
    const upx = up[0];
    const upy = up[1];
    const upz = up[2];
    const centerx = center[0];
    const centery = center[1];
    const centerz = center[2];
    if (Math.abs(eyex - centerx) < _commonJs.EPSILON && Math.abs(eyey - centery) < _commonJs.EPSILON && Math.abs(eyez - centerz) < _commonJs.EPSILON) return identity(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function targetTo(out, eye, target, up) {
    const eyex = eye[0];
    const eyey = eye[1];
    const eyez = eye[2];
    const upx = up[0];
    const upy = up[1];
    const upz = up[2];
    let z0 = eyex - target[0];
    let z1 = eyey - target[1];
    let z2 = eyez - target[2];
    let len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    let x0 = upy * z2 - upz * z1;
    let x1 = upz * z0 - upx * z2;
    let x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function str(a) {
    return `mat4(${a[0]}, ${a[1]}, ${a[2]}, ${a[3]}, ${a[4]}, ${a[5]}, ${a[6]}, ${a[7]}, ${a[8]}, ${a[9]}, ${a[10]}, ${a[11]}, ${a[12]}, ${a[13]}, ${a[14]}, ${a[15]})`;
}
function frob(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] + a[4] * a[4] + a[5] * a[5] + a[6] * a[6] + a[7] * a[7] + a[8] * a[8] + a[9] * a[9] + a[10] * a[10] + a[11] * a[11] + a[12] * a[12] + a[13] * a[13] + a[14] * a[14] + a[15] * a[15]);
}
function add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function multiplyScalar(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function multiplyScalarAndAdd(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function equals(a, b) {
    const a0 = a[0];
    const a1 = a[1];
    const a2 = a[2];
    const a3 = a[3];
    const a4 = a[4];
    const a5 = a[5];
    const a6 = a[6];
    const a7 = a[7];
    const a8 = a[8];
    const a9 = a[9];
    const a10 = a[10];
    const a11 = a[11];
    const a12 = a[12];
    const a13 = a[13];
    const a14 = a[14];
    const a15 = a[15];
    const b0 = b[0];
    const b1 = b[1];
    const b2 = b[2];
    const b3 = b[3];
    const b4 = b[4];
    const b5 = b[5];
    const b6 = b[6];
    const b7 = b[7];
    const b8 = b[8];
    const b9 = b[9];
    const b10 = b[10];
    const b11 = b[11];
    const b12 = b[12];
    const b13 = b[13];
    const b14 = b[14];
    const b15 = b[15];
    return Math.abs(a0 - b0) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
const mul = multiply;
const sub = subtract;

},{"./common.js":"ibvuK","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"l8RgT":[function(require,module,exports,__globalThis) {
// @eslint-disable
// @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 2 Dimensional Vector
 * @module vec2
 */ /**
 * Creates a new, empty vec2
 *
 * @returns a new 2D vector
 */ parcelHelpers.export(exports, "create", ()=>create);
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param a vector to clone
 * @returns a new 2D vector
 */ parcelHelpers.export(exports, "clone", ()=>clone);
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param x X component
 * @param y Y component
 * @returns a new 2D vector
 */ parcelHelpers.export(exports, "fromValues", ()=>fromValues);
/**
 * Copy the values from one vec2 to another
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the source vector
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "copy", ()=>copy);
/**
 * Set the components of a vec2 to the given values
 *
 * @param {NumericArray} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "set", ()=>set);
/**
 * Adds two vec2's
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Subtracts vector b from vector a
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "subtract", ()=>subtract);
/**
 * Multiplies two vec2's
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "multiply", ()=>multiply);
/**
 * Divides two vec2's
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "divide", ()=>divide);
/**
 * Math.ceil the components of a vec2
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a vector to ceil
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "ceil", ()=>ceil);
/**
 * Math.floor the components of a vec2
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a vector to floor
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "floor", ()=>floor);
/**
 * Returns the minimum of two vec2's
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "min", ()=>min);
/**
 * Returns the maximum of two vec2's
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "max", ()=>max);
/**
 * symmetric round the components of a vec2
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a vector to round
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Scales a vec2 by a scalar number
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "scaleAndAdd", ()=>scaleAndAdd);
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {Number} distance between a and b
 */ parcelHelpers.export(exports, "distance", ()=>distance);
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {Number} squared distance between a and b
 */ parcelHelpers.export(exports, "squaredDistance", ()=>squaredDistance);
/**
 * Calculates the length of a vec2
 *
 * @param {Readonly<NumericArray>} a vector to calculate length of
 * @returns {Number} length of a
 */ parcelHelpers.export(exports, "length", ()=>length);
/**
 * Calculates the squared length of a vec2
 *
 * @param {Readonly<NumericArray>} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ parcelHelpers.export(exports, "squaredLength", ()=>squaredLength);
/**
 * Negates the components of a vec2
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a vector to negate
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "negate", ()=>negate);
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a vector to invert
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "inverse", ()=>inverse);
/**
 * Normalize a vec2
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a vector to normalize
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "normalize", ()=>normalize);
/**
 * Calculates the dot product of two vec2's
 *
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {Number} dot product of a and b
 */ parcelHelpers.export(exports, "dot", ()=>dot);
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @returns {vec3} out
 */ parcelHelpers.export(exports, "cross", ()=>cross);
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the first operand
 * @param {Readonly<NumericArray>} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "lerp", ()=>lerp);
/**
 * Generates a random vector with the given scale
 *
 * @param {NumericArray} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If omitted, a unit vector will be returned
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "random", ()=>random);
/**
 * Transforms the vec2 with a mat2
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the vector to transform
 * @param {ReadonlyMat2} m matrix to transform with
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "transformMat2", ()=>transformMat2);
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the vector to transform
 * @param {ReadonlyMat2d} m matrix to transform with
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "transformMat2d", ()=>transformMat2d);
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the vector to transform
 * @param {ReadonlyMat3} m matrix to transform with
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "transformMat3", ()=>transformMat3);
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {NumericArray} out the receiving vector
 * @param {Readonly<NumericArray>} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "transformMat4", ()=>transformMat4);
/**
 * Rotate a 2D vector
 * @param {NumericArray} out The receiving vec2
 * @param {Readonly<NumericArray>} a The vec2 point to rotate
 * @param {Readonly<NumericArray>} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "rotate", ()=>rotate);
/**
 * Get the angle between two 2D vectors
 * @param {Readonly<NumericArray>} a The first operand
 * @param {Readonly<NumericArray>} b The second operand
 * @returns {Number} The angle in radians
 */ parcelHelpers.export(exports, "angle", ()=>angle);
/**
 * Set the components of a vec2 to zero
 *
 * @param {NumericArray} out the receiving vector
 * @returns {NumericArray} out
 */ parcelHelpers.export(exports, "zero", ()=>zero);
/**
 * Returns a string representation of a vector
 *
 * @param {Readonly<NumericArray>} a vector to represent as a string
 * @returns {String} string representation of the vector
 */ parcelHelpers.export(exports, "str", ()=>str);
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {Readonly<NumericArray>} a The first vector.
 * @param {Readonly<NumericArray>} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ parcelHelpers.export(exports, "exactEquals", ()=>exactEquals);
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {Readonly<NumericArray>} a The first vector.
 * @param {Readonly<NumericArray>} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "len", ()=>len);
parcelHelpers.export(exports, "sub", ()=>sub);
parcelHelpers.export(exports, "mul", ()=>mul);
parcelHelpers.export(exports, "div", ()=>div);
parcelHelpers.export(exports, "dist", ()=>dist);
parcelHelpers.export(exports, "sqrDist", ()=>sqrDist);
parcelHelpers.export(exports, "sqrLen", ()=>sqrLen);
parcelHelpers.export(exports, "forEach", ()=>forEach);
var _commonJs = require("./common.js");
function create() {
    const out = new _commonJs.ARRAY_TYPE(2);
    if (_commonJs.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function clone(a) {
    const out = new _commonJs.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function fromValues(x, y) {
    const out = new _commonJs.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function set(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function multiply(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function divide(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function ceil(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function floor(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function min(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function max(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function round(out, a) {
    out[0] = _commonJs.round(a[0]);
    out[1] = _commonJs.round(a[1]);
    return out;
}
function scale(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function scaleAndAdd(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function distance(a, b) {
    const x = b[0] - a[0];
    const y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
}
function squaredDistance(a, b) {
    const x = b[0] - a[0];
    const y = b[1] - a[1];
    return x * x + y * y;
}
function length(a) {
    const x = a[0];
    const y = a[1];
    return Math.sqrt(x * x + y * y);
}
function squaredLength(a) {
    const x = a[0];
    const y = a[1];
    return x * x + y * y;
}
function negate(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function inverse(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function normalize(out, a) {
    const x = a[0];
    const y = a[1];
    let len = x * x + y * y;
    if (len > 0) // TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function cross(out, a, b) {
    const z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function lerp(out, a, b, t) {
    const ax = a[0];
    const ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function random(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    const r = _commonJs.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function transformMat2(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function transformMat2d(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function transformMat3(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function transformMat4(out, a, m) {
    const x = a[0];
    const y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function rotate(out, a, b, rad) {
    // Translate point to the origin
    const p0 = a[0] - b[0];
    const p1 = a[1] - b[1];
    const sinC = Math.sin(rad);
    const cosC = Math.cos(rad);
    // perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function angle(a, b) {
    const x1 = a[0];
    const y1 = a[1];
    const x2 = b[0];
    const y2 = b[1];
    // mag is the product of the magnitudes of a and b
    const mag = Math.sqrt((x1 * x1 + y1 * y1) * (x2 * x2 + y2 * y2));
    // mag &&.. short circuits if mag == 0
    const cosine = mag && (x1 * x2 + y1 * y2) / mag;
    // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function zero(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function str(a) {
    return `vec2(${a[0]}, ${a[1]})`;
}
function exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function equals(a, b) {
    const a0 = a[0];
    const a1 = a[1];
    const b0 = b[0];
    const b1 = b[1];
    return Math.abs(a0 - b0) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
const len = length;
const sub = subtract;
const mul = multiply;
const div = divide;
const dist = distance;
const sqrDist = squaredDistance;
const sqrLen = squaredLength;
const forEach = function() {
    const vec = create();
    return function(a, stride, offset, count, fn, arg) {
        let i;
        let l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

},{"./common.js":"ibvuK","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2yXLd":[function(require,module,exports,__globalThis) {
// @eslint-disable
// @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 4 Dimensional Vector
 * @module vec4
 */ /**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */ parcelHelpers.export(exports, "create", ()=>create);
/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {ReadonlyVec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */ parcelHelpers.export(exports, "clone", ()=>clone);
/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */ parcelHelpers.export(exports, "fromValues", ()=>fromValues);
/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the source vector
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "copy", ()=>copy);
/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "set", ()=>set);
/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "add", ()=>add);
/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "subtract", ()=>subtract);
/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "multiply", ()=>multiply);
/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "divide", ()=>divide);
/**
 * Math.ceil the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to ceil
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "ceil", ()=>ceil);
/**
 * Math.floor the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to floor
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "floor", ()=>floor);
/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "min", ()=>min);
/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "max", ()=>max);
/**
 * symmetric round the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to round
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "scale", ()=>scale);
/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "scaleAndAdd", ()=>scaleAndAdd);
/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} distance between a and b
 */ parcelHelpers.export(exports, "distance", ()=>distance);
/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} squared distance between a and b
 */ parcelHelpers.export(exports, "squaredDistance", ()=>squaredDistance);
/**
 * Calculates the length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate length of
 * @returns {Number} length of a
 */ parcelHelpers.export(exports, "length", ()=>length);
/**
 * Calculates the squared length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ parcelHelpers.export(exports, "squaredLength", ()=>squaredLength);
/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to negate
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "negate", ()=>negate);
/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to invert
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "inverse", ()=>inverse);
/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to normalize
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "normalize", ()=>normalize);
/**
 * Calculates the dot product of two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} dot product of a and b
 */ parcelHelpers.export(exports, "dot", ()=>dot);
/**
 * Returns the cross-product of three vectors in a 4-dimensional space
 *
 * @param {ReadonlyVec4} result the receiving vector
 * @param {ReadonlyVec4} U the first vector
 * @param {ReadonlyVec4} V the second vector
 * @param {ReadonlyVec4} W the third vector
 * @returns {vec4} result
 */ parcelHelpers.export(exports, "cross", ()=>cross);
/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "lerp", ()=>lerp);
/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If omitted, a unit vector will be returned
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "random", ()=>random);
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "transformMat4", ()=>transformMat4);
/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "transformQuat", ()=>transformQuat);
/**
 * Set the components of a vec4 to zero
 *
 * @param {vec4} out the receiving vector
 * @returns {vec4} out
 */ parcelHelpers.export(exports, "zero", ()=>zero);
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec4} a vector to represent as a string
 * @returns {String} string representation of the vector
 */ parcelHelpers.export(exports, "str", ()=>str);
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ parcelHelpers.export(exports, "exactEquals", ()=>exactEquals);
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "sub", ()=>sub);
parcelHelpers.export(exports, "mul", ()=>mul);
parcelHelpers.export(exports, "div", ()=>div);
parcelHelpers.export(exports, "dist", ()=>dist);
parcelHelpers.export(exports, "sqrDist", ()=>sqrDist);
parcelHelpers.export(exports, "len", ()=>len);
parcelHelpers.export(exports, "sqrLen", ()=>sqrLen);
parcelHelpers.export(exports, "forEach", ()=>forEach);
var _commonJs = require("./common.js");
function create() {
    const out = new _commonJs.ARRAY_TYPE(4);
    if (_commonJs.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function clone(a) {
    const out = new _commonJs.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function fromValues(x, y, z, w) {
    const out = new _commonJs.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function set(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function multiply(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function divide(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function ceil(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function floor(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function min(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function max(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function round(out, a) {
    out[0] = _commonJs.round(a[0]);
    out[1] = _commonJs.round(a[1]);
    out[2] = _commonJs.round(a[2]);
    out[3] = _commonJs.round(a[3]);
    return out;
}
function scale(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function scaleAndAdd(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function distance(a, b) {
    const x = b[0] - a[0];
    const y = b[1] - a[1];
    const z = b[2] - a[2];
    const w = b[3] - a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function squaredDistance(a, b) {
    const x = b[0] - a[0];
    const y = b[1] - a[1];
    const z = b[2] - a[2];
    const w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function length(a) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    const w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function squaredLength(a) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    const w = a[3];
    return x * x + y * y + z * z + w * w;
}
function negate(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function inverse(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function normalize(out, a) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    const w = a[3];
    let len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function cross(out, u, v, w) {
    const A = v[0] * w[1] - v[1] * w[0];
    const B = v[0] * w[2] - v[2] * w[0];
    const C = v[0] * w[3] - v[3] * w[0];
    const D = v[1] * w[2] - v[2] * w[1];
    const E = v[1] * w[3] - v[3] * w[1];
    const F = v[2] * w[3] - v[3] * w[2];
    const G = u[0];
    const H = u[1];
    const I = u[2];
    const J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function lerp(out, a, b, t) {
    const ax = a[0];
    const ay = a[1];
    const az = a[2];
    const aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function random(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    let v1;
    let v2;
    let v3;
    let v4;
    let s1;
    let s2;
    do {
        v1 = _commonJs.RANDOM() * 2 - 1;
        v2 = _commonJs.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = _commonJs.RANDOM() * 2 - 1;
        v4 = _commonJs.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    const d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function transformMat4(out, a, m) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    const w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function transformQuat(out, a, q) {
    const x = a[0];
    const y = a[1];
    const z = a[2];
    const qx = q[0];
    const qy = q[1];
    const qz = q[2];
    const qw = q[3];
    // calculate quat * vec
    const ix = qw * x + qy * z - qz * y;
    const iy = qw * y + qz * x - qx * z;
    const iz = qw * z + qx * y - qy * x;
    const iw = -qx * x - qy * y - qz * z;
    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function zero(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function str(a) {
    return `vec4(${a[0]}, ${a[1]}, ${a[2]}, ${a[3]})`;
}
function exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function equals(a, b) {
    const a0 = a[0];
    const a1 = a[1];
    const a2 = a[2];
    const a3 = a[3];
    const b0 = b[0];
    const b1 = b[1];
    const b2 = b[2];
    const b3 = b[3];
    return Math.abs(a0 - b0) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= _commonJs.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
const sub = subtract;
const mul = multiply;
const div = divide;
const dist = distance;
const sqrDist = squaredDistance;
const len = length;
const sqrLen = squaredLength;
const forEach = function() {
    const vec = create();
    return function(a, stride, offset, count, fn, arg) {
        let i;
        let l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

},{"./common.js":"ibvuK","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"k6l9N":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Note: The numeric values here are matched by shader code in the
// "project" and "project64" shader modules. Both places need to be
// updated.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COORDINATE_SYSTEM", ()=>COORDINATE_SYSTEM);
parcelHelpers.export(exports, "PROJECTION_MODE", ()=>PROJECTION_MODE);
parcelHelpers.export(exports, "UNIT", ()=>UNIT);
parcelHelpers.export(exports, "EVENT_HANDLERS", ()=>EVENT_HANDLERS);
parcelHelpers.export(exports, "RECOGNIZERS", ()=>RECOGNIZERS);
parcelHelpers.export(exports, "OPERATION", ()=>OPERATION);
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _mjolnirJs = require("mjolnir.js");
const COORDINATE_SYSTEM = {
    /**
     * `LNGLAT` if rendering into a geospatial viewport, `CARTESIAN` otherwise
     */ DEFAULT: -1,
    /**
     * Positions are interpreted as [longitude, latitude, elevation]
     * longitude/latitude are in degrees, elevation is in meters.
     * Dimensions are in meters.
     */ LNGLAT: 1,
    /**
     * Positions are interpreted as [x, y, z] in meter offsets from the coordinate origin.
     * Dimensions are in meters.
     */ METER_OFFSETS: 2,
    /**
     * Positions are interpreted as [deltaLng, deltaLat, elevation] from the coordinate origin.
     * deltaLng/deltaLat are in degrees, elevation is in meters.
     * Dimensions are in meters.
     */ LNGLAT_OFFSETS: 3,
    /**
     * Positions and dimensions are in the common units of the viewport.
     */ CARTESIAN: 0
};
// Deprecated
/* eslint-disable accessor-pairs */ Object.defineProperty(COORDINATE_SYSTEM, 'IDENTITY', {
    get: ()=>{
        (0, _logJsDefault.default).deprecated('COORDINATE_SYSTEM.IDENTITY', 'COORDINATE_SYSTEM.CARTESIAN')();
        return 0;
    }
});
const PROJECTION_MODE = {
    /**
     * Render geospatial data in Web Mercator projection
     */ WEB_MERCATOR: 1,
    /**
     * Render geospatial data as a 3D globe
     */ GLOBE: 2,
    /**
     * (Internal use only) Web Mercator projection at high zoom
     */ WEB_MERCATOR_AUTO_OFFSET: 4,
    /**
     * No transformation
     */ IDENTITY: 0
};
const UNIT = {
    common: 0,
    meters: 1,
    pixels: 2
};
const EVENT_HANDLERS = {
    click: 'onClick',
    panstart: 'onDragStart',
    panmove: 'onDrag',
    panend: 'onDragEnd'
};
const RECOGNIZERS = {
    multipan: [
        (0, _mjolnirJs.Pan),
        {
            threshold: 10,
            direction: (0, _mjolnirJs.InputDirection).Vertical,
            pointers: 2
        }
    ],
    pinch: [
        (0, _mjolnirJs.Pinch),
        {},
        null,
        [
            'multipan'
        ]
    ],
    pan: [
        (0, _mjolnirJs.Pan),
        {
            threshold: 1
        },
        [
            'pinch'
        ],
        [
            'multipan'
        ]
    ],
    dblclick: [
        (0, _mjolnirJs.Tap),
        {
            event: 'dblclick',
            taps: 2
        }
    ],
    click: [
        (0, _mjolnirJs.Tap),
        {
            event: 'click'
        },
        null,
        [
            'dblclick'
        ]
    ]
};
const OPERATION = {
    DRAW: 'draw',
    MASK: 'mask',
    TERRAIN: 'terrain'
};

},{"../utils/log.js":"9S0lD","mjolnir.js":"hECWP","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hECWP":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventManager", ()=>(0, _eventManagerJs.EventManager));
parcelHelpers.export(exports, "Recognizer", ()=>(0, _indexJs.Recognizer));
parcelHelpers.export(exports, "Pan", ()=>(0, _indexJs.Pan));
parcelHelpers.export(exports, "Rotate", ()=>(0, _indexJs.Rotate));
parcelHelpers.export(exports, "Pinch", ()=>(0, _indexJs.Pinch));
parcelHelpers.export(exports, "Swipe", ()=>(0, _indexJs.Swipe));
parcelHelpers.export(exports, "Press", ()=>(0, _indexJs.Press));
parcelHelpers.export(exports, "Tap", ()=>(0, _indexJs.Tap));
parcelHelpers.export(exports, "InputDirection", ()=>(0, _indexJs.InputDirection));
parcelHelpers.export(exports, "InputEvent", ()=>(0, _indexJs.InputEvent));
var _eventManagerJs = require("./event-manager.js");
var _indexJs = require("./hammerjs/index.js");

},{"./event-manager.js":"bl4mO","./hammerjs/index.js":"1oQHW","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bl4mO":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Unified API for subscribing to events about both
// basic input events (e.g. 'mousemove', 'touchstart', 'wheel')
// and gestural input (e.g. 'click', 'tap', 'panstart').
// Delegates gesture related event registration and handling to Hammer.js.
parcelHelpers.export(exports, "EventManager", ()=>EventManager);
var _indexJs = require("./hammerjs/index.js");
var _wheelInputJs = require("./inputs/wheel-input.js");
var _moveInputJs = require("./inputs/move-input.js");
var _keyInputJs = require("./inputs/key-input.js");
var _contextmenuInputJs = require("./inputs/contextmenu-input.js");
var _eventRegistrarJs = require("./utils/event-registrar.js");
function normalizeRecognizer(item) {
    if ('recognizer' in item) return item;
    let recognizer;
    const itemArray = Array.isArray(item) ? [
        ...item
    ] : [
        item
    ];
    if (typeof itemArray[0] === 'function') {
        // Backward compatibility: v2 / hammerjs style
        const RecognizerType = itemArray.shift();
        const options = itemArray.shift() || {};
        recognizer = new RecognizerType(options);
    } else recognizer = itemArray.shift();
    return {
        recognizer,
        recognizeWith: typeof itemArray[0] === 'string' ? [
            itemArray[0]
        ] : itemArray[0],
        requireFailure: typeof itemArray[1] === 'string' ? [
            itemArray[1]
        ] : itemArray[1]
    };
}
class EventManager {
    constructor(element = null, options = {}){
        /**
         * Handle basic events using the 'hammer.input' Hammer.js API:
         * Before running Recognizers, Hammer emits a 'hammer.input' event
         * with the basic event info. This function emits all basic events
         * aliased to the "class" of event received.
         * See constants.BASIC_EVENT_CLASSES basic event class definitions.
         */ this._onBasicInput = (event)=>{
            this.manager.emit(event.srcEvent.type, event);
        };
        /**
         * Handle events not supported by Hammer.js,
         * and pipe back out through same (Hammer) channel used by other events.
         */ this._onOtherEvent = (event)=>{
            // console.log('onotherevent', event.type, event)
            this.manager.emit(event.type, event);
        };
        this.options = {
            recognizers: [],
            events: {},
            touchAction: 'compute',
            tabIndex: 0,
            cssProps: {},
            ...options
        };
        this.events = new Map();
        this.element = element;
        if (!element) return;
        this.manager = new (0, _indexJs.Manager)(element, this.options);
        for (const item of this.options.recognizers){
            const { recognizer, recognizeWith, requireFailure } = normalizeRecognizer(item);
            this.manager.add(recognizer);
            if (recognizeWith) recognizer.recognizeWith(recognizeWith);
            if (requireFailure) recognizer.requireFailure(requireFailure);
        }
        this.manager.on('hammer.input', this._onBasicInput);
        // Handle events not handled by Hammer.js:
        // - mouse wheel
        // - pointer/touch/mouse move
        this.wheelInput = new (0, _wheelInputJs.WheelInput)(element, this._onOtherEvent, {
            enable: false
        });
        this.moveInput = new (0, _moveInputJs.MoveInput)(element, this._onOtherEvent, {
            enable: false
        });
        this.keyInput = new (0, _keyInputJs.KeyInput)(element, this._onOtherEvent, {
            enable: false,
            tabIndex: options.tabIndex
        });
        this.contextmenuInput = new (0, _contextmenuInputJs.ContextmenuInput)(element, this._onOtherEvent, {
            enable: false
        });
        // Register all passed events.
        this.on(this.options.events);
    }
    getElement() {
        return this.element;
    }
    // Tear down internal event management implementations.
    destroy() {
        // manager etc. cannot exist if there is no element
        if (!this.element) return;
        this.wheelInput.destroy();
        this.moveInput.destroy();
        this.keyInput.destroy();
        this.contextmenuInput.destroy();
        this.manager.destroy();
    }
    /** Register an event handler function to be called on `event` */ on(event, handler, opts) {
        this._addEventHandler(event, handler, opts, false);
    }
    once(event, handler, opts) {
        this._addEventHandler(event, handler, opts, true);
    }
    watch(event, handler, opts) {
        this._addEventHandler(event, handler, opts, false, true);
    }
    off(event, handler) {
        this._removeEventHandler(event, handler);
    }
    /*
     * Enable/disable recognizer for the given event
     */ _toggleRecognizer(name, enabled) {
        const { manager } = this;
        if (!manager) return;
        const recognizer = manager.get(name);
        if (recognizer) {
            recognizer.set({
                enable: enabled
            });
            manager.touchAction.update();
        }
        this.wheelInput?.enableEventType(name, enabled);
        this.moveInput?.enableEventType(name, enabled);
        this.keyInput?.enableEventType(name, enabled);
        this.contextmenuInput?.enableEventType(name, enabled);
    }
    /**
     * Process the event registration for a single event + handler.
     */ _addEventHandler(event, handler, opts, once, passive) {
        if (typeof event !== 'string') {
            // @ts-ignore
            opts = handler;
            // If `event` is a map, call `on()` for each entry.
            for (const [eventName, eventHandler] of Object.entries(event))this._addEventHandler(eventName, eventHandler, opts, once, passive);
            return;
        }
        const { manager, events } = this;
        if (!manager) return;
        let eventRegistrar = events.get(event);
        if (!eventRegistrar) {
            // Enable recognizer for this event.
            const recognizerName = this._getRecognizerName(event) || event;
            eventRegistrar = new (0, _eventRegistrarJs.EventRegistrar)(this, recognizerName);
            events.set(event, eventRegistrar);
            // Listen to the event
            if (manager) manager.on(event, eventRegistrar.handleEvent);
        }
        eventRegistrar.add(event, handler, opts, once, passive);
        if (!eventRegistrar.isEmpty()) this._toggleRecognizer(eventRegistrar.recognizerName, true);
    }
    /**
     * Process the event deregistration for a single event + handler.
     */ _removeEventHandler(event, handler) {
        if (typeof event !== 'string') {
            // If `event` is a map, call `off()` for each entry.
            for (const [eventName, eventHandler] of Object.entries(event))this._removeEventHandler(eventName, eventHandler);
            return;
        }
        const { events } = this;
        const eventRegistrar = events.get(event);
        if (!eventRegistrar) return;
        eventRegistrar.remove(event, handler);
        if (eventRegistrar.isEmpty()) {
            const { recognizerName } = eventRegistrar;
            // Disable recognizer if no more handlers are attached to its events
            let isRecognizerUsed = false;
            for (const eh of events.values())if (eh.recognizerName === recognizerName && !eh.isEmpty()) {
                isRecognizerUsed = true;
                break;
            }
            if (!isRecognizerUsed) this._toggleRecognizer(recognizerName, false);
        }
    }
    _getRecognizerName(event) {
        return this.manager.recognizers.find((recognizer)=>{
            return recognizer.getEventNames().includes(event);
        })?.options.event;
    }
}

},{"./hammerjs/index.js":"1oQHW","./inputs/wheel-input.js":"7vGgx","./inputs/move-input.js":"lR31G","./inputs/key-input.js":"cumKq","./inputs/contextmenu-input.js":"9EPP9","./utils/event-registrar.js":"LepZg","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1oQHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputEvent", ()=>(0, _inputConstsJs.InputEvent));
parcelHelpers.export(exports, "RecognizerState", ()=>(0, _recognizerStateJs.RecognizerState));
parcelHelpers.export(exports, "InputDirection", ()=>(0, _inputConstsJs.InputDirection));
parcelHelpers.export(exports, "Manager", ()=>(0, _managerJs.Manager));
parcelHelpers.export(exports, "Input", ()=>(0, _inputJs.Input));
parcelHelpers.export(exports, "TouchAction", ()=>(0, _touchactionJs.TouchAction));
parcelHelpers.export(exports, "PointerEventInput", ()=>(0, _pointereventJs.PointerEventInput));
parcelHelpers.export(exports, "Recognizer", ()=>(0, _recognizerJs.Recognizer));
parcelHelpers.export(exports, "AttrRecognizer", ()=>(0, _attributeJs.AttrRecognizer));
parcelHelpers.export(exports, "Tap", ()=>(0, _tapJs.TapRecognizer));
parcelHelpers.export(exports, "Pan", ()=>(0, _panJs.PanRecognizer));
parcelHelpers.export(exports, "Swipe", ()=>(0, _swipeJs.SwipeRecognizer));
parcelHelpers.export(exports, "Pinch", ()=>(0, _pinchJs.PinchRecognizer));
parcelHelpers.export(exports, "Rotate", ()=>(0, _rotateJs.RotateRecognizer));
parcelHelpers.export(exports, "Press", ()=>(0, _pressJs.PressRecognizer));
var _inputConstsJs = require("./input/input-consts.js");
var _recognizerStateJs = require("./recognizer/recognizer-state.js");
var _managerJs = require("./manager.js");
var _inputJs = require("./input/input.js");
var _touchactionJs = require("./touchaction/touchaction.js");
var _pointereventJs = require("./inputs/pointerevent.js");
var _recognizerJs = require("./recognizer/recognizer.js");
var _attributeJs = require("./recognizers/attribute.js");
var _tapJs = require("./recognizers/tap.js");
var _panJs = require("./recognizers/pan.js");
var _swipeJs = require("./recognizers/swipe.js");
var _pinchJs = require("./recognizers/pinch.js");
var _rotateJs = require("./recognizers/rotate.js");
var _pressJs = require("./recognizers/press.js");

},{"./input/input-consts.js":"l5Wx6","./recognizer/recognizer-state.js":"6zX1r","./manager.js":"5f6by","./input/input.js":"561Mc","./touchaction/touchaction.js":"BsAEt","./inputs/pointerevent.js":"aYEzu","./recognizer/recognizer.js":"2eKo8","./recognizers/attribute.js":"4ixqv","./recognizers/tap.js":"g5HMb","./recognizers/pan.js":"5eAx3","./recognizers/swipe.js":"kOli6","./recognizers/pinch.js":"39M2Z","./recognizers/rotate.js":"cRdXB","./recognizers/press.js":"lhrew","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"l5Wx6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MOBILE_REGEX", ()=>MOBILE_REGEX);
parcelHelpers.export(exports, "COMPUTE_INTERVAL", ()=>COMPUTE_INTERVAL);
parcelHelpers.export(exports, "InputEvent", ()=>InputEvent);
parcelHelpers.export(exports, "InputDirection", ()=>InputDirection);
const MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
const COMPUTE_INTERVAL = 25;
var InputEvent;
(function(InputEvent) {
    InputEvent[InputEvent["Start"] = 1] = "Start";
    InputEvent[InputEvent["Move"] = 2] = "Move";
    InputEvent[InputEvent["End"] = 4] = "End";
    InputEvent[InputEvent["Cancel"] = 8] = "Cancel";
})(InputEvent || (InputEvent = {}));
var InputDirection;
(function(InputDirection) {
    InputDirection[InputDirection["None"] = 0] = "None";
    InputDirection[InputDirection["Left"] = 1] = "Left";
    InputDirection[InputDirection["Right"] = 2] = "Right";
    InputDirection[InputDirection["Up"] = 4] = "Up";
    InputDirection[InputDirection["Down"] = 8] = "Down";
    InputDirection[InputDirection["Horizontal"] = 3] = "Horizontal";
    InputDirection[InputDirection["Vertical"] = 12] = "Vertical";
    InputDirection[InputDirection["All"] = 15] = "All";
})(InputDirection || (InputDirection = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6zX1r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RecognizerState", ()=>RecognizerState);
var RecognizerState;
(function(RecognizerState) {
    RecognizerState[RecognizerState["Possible"] = 1] = "Possible";
    RecognizerState[RecognizerState["Began"] = 2] = "Began";
    RecognizerState[RecognizerState["Changed"] = 4] = "Changed";
    RecognizerState[RecognizerState["Ended"] = 8] = "Ended";
    RecognizerState[RecognizerState["Recognized"] = 8] = "Recognized";
    RecognizerState[RecognizerState["Cancelled"] = 16] = "Cancelled";
    RecognizerState[RecognizerState["Failed"] = 32] = "Failed";
})(RecognizerState || (RecognizerState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5f6by":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manager
 */ parcelHelpers.export(exports, "Manager", ()=>Manager);
var _touchactionJs = require("./touchaction/touchaction.js");
var _pointereventJs = require("./inputs/pointerevent.js");
var _splitStrJs = require("./utils/split-str.js");
var _prefixedJs = require("./utils/prefixed.js");
var _recognizerStateJs = require("./recognizer/recognizer-state.js");
const STOP = 1;
const FORCED_STOP = 2;
const defaultOptions = {
    touchAction: 'compute',
    enable: true,
    inputTarget: null,
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         */ userSelect: 'none',
        /**
         * (Webkit) Disable default dragging behavior
         */ // @ts-ignore
        userDrag: 'none',
        /**
         * (iOS only) Disables the default callout shown when you touch and hold a touch target.
         * When you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         */ // @ts-ignore
        touchCallout: 'none',
        /**
         * (iOS only) Sets the color of the highlight that appears over a link while it's being tapped.
         */ // @ts-ignore
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};
class Manager {
    constructor(element, options){
        this.options = {
            ...defaultOptions,
            ...options,
            cssProps: {
                ...defaultOptions.cssProps,
                ...options.cssProps
            },
            inputTarget: options.inputTarget || element
        };
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = new (0, _pointereventJs.PointerEventInput)(this);
        this.touchAction = new (0, _touchactionJs.TouchAction)(this, this.options.touchAction);
        this.toggleCssProps(true);
    }
    /**
     * set options
     */ set(options) {
        Object.assign(this.options, options);
        // Options that need a little more setup
        if (options.touchAction) this.touchAction.update();
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    }
    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     */ stop(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    }
    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     */ recognize(inputData) {
        const { session } = this;
        if (session.stopped) return;
        // run the touch-action polyfill
        if (this.session.prevented) inputData.srcEvent.preventDefault();
        let recognizer;
        const { recognizers } = this;
        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        let { curRecognizer } = session;
        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || curRecognizer && curRecognizer.state & (0, _recognizerStateJs.RecognizerState).Recognized) curRecognizer = session.curRecognizer = null;
        let i = 0;
        while(i < recognizers.length){
            recognizer = recognizers[i];
            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && // 1
            (!curRecognizer || recognizer === curRecognizer || // 2
            recognizer.canRecognizeWith(curRecognizer))) // 3
            recognizer.recognize(inputData);
            else recognizer.reset();
            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & ((0, _recognizerStateJs.RecognizerState).Began | (0, _recognizerStateJs.RecognizerState).Changed | (0, _recognizerStateJs.RecognizerState).Ended)) curRecognizer = session.curRecognizer = recognizer;
            i++;
        }
    }
    /**
     * get a recognizer by its event name.
     */ get(recognizerName) {
        const { recognizers } = this;
        for(let i = 0; i < recognizers.length; i++){
            if (recognizers[i].options.event === recognizerName) return recognizers[i];
        }
        return null;
    }
    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     */ add(recognizer) {
        if (Array.isArray(recognizer)) {
            for (const item of recognizer)this.add(item);
            return this;
        }
        // remove existing
        const existing = this.get(recognizer.options.event);
        if (existing) this.remove(existing);
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
    }
    /**
     * remove a recognizer by name or instance
     */ remove(recognizerOrName) {
        if (Array.isArray(recognizerOrName)) {
            for (const item of recognizerOrName)this.remove(item);
            return this;
        }
        const recognizer = typeof recognizerOrName === 'string' ? this.get(recognizerOrName) : recognizerOrName;
        // let's make sure this recognizer exists
        if (recognizer) {
            const { recognizers } = this;
            const index = recognizers.indexOf(recognizer);
            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }
        return this;
    }
    /**
     * bind event
     */ on(events, handler) {
        if (!events || !handler) return;
        const { handlers } = this;
        for (const event of (0, _splitStrJs.splitStr)(events)){
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        }
    }
    /**
     * unbind event, leave hander blank to remove all handlers
     */ off(events, handler) {
        if (!events) return;
        const { handlers } = this;
        for (const event of (0, _splitStrJs.splitStr)(events)){
            if (!handler) delete handlers[event];
            else if (handlers[event]) handlers[event].splice(handlers[event].indexOf(handler), 1);
        }
    }
    /**
     * emit event to the listeners
     */ emit(event, data) {
        // no handlers, so skip it all
        const handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) return;
        const evt = data;
        evt.type = event;
        evt.preventDefault = function() {
            data.srcEvent.preventDefault();
        };
        let i = 0;
        while(i < handlers.length){
            handlers[i](evt);
            i++;
        }
    }
    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy() {
        this.toggleCssProps(false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
    /**
     * add/remove the css properties as defined in manager.options.cssProps
     */ toggleCssProps(add) {
        const { element } = this;
        if (!element) return;
        for (const [name, value] of Object.entries(this.options.cssProps)){
            const prop = (0, _prefixedJs.prefixed)(element.style, name);
            if (add) {
                this.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = this.oldCssProps[prop] || '';
        }
        if (!add) this.oldCssProps = {};
    }
}

},{"./touchaction/touchaction.js":"BsAEt","./inputs/pointerevent.js":"aYEzu","./utils/split-str.js":"6skhE","./utils/prefixed.js":"1ZeEX","./recognizer/recognizer-state.js":"6zX1r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"BsAEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 */ parcelHelpers.export(exports, "TouchAction", ()=>TouchAction);
var _touchactionConstsJs = require("./touchaction-Consts.js");
var _cleanTouchActionsJs = require("./clean-touch-actions.js");
var _cleanTouchActionsJsDefault = parcelHelpers.interopDefault(_cleanTouchActionsJs);
class TouchAction {
    constructor(manager, value){
        this.actions = '';
        this.manager = manager;
        this.set(value);
    }
    /**
     * set the touchAction value on the element or enable the polyfill
     */ set(value) {
        // find out the touch-action by the event handlers
        if (value === (0, _touchactionConstsJs.TOUCH_ACTION_COMPUTE)) value = this.compute();
        if (this.manager.element) {
            this.manager.element.style.touchAction = value;
            this.actions = value;
        }
    }
    /**
     * just re-set the touchAction value
     */ update() {
        this.set(this.manager.options.touchAction);
    }
    /**
     * compute the value for the touchAction property based on the recognizer's settings
     */ compute() {
        let actions = [];
        for (const recognizer of this.manager.recognizers)if (recognizer.options.enable) actions = actions.concat(recognizer.getTouchAction());
        return (0, _cleanTouchActionsJsDefault.default)(actions.join(' '));
    }
}

},{"./touchaction-Consts.js":"7YG7L","./clean-touch-actions.js":"3hnf0","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7YG7L":[function(require,module,exports,__globalThis) {
// magical touchAction value
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TOUCH_ACTION_COMPUTE", ()=>TOUCH_ACTION_COMPUTE);
parcelHelpers.export(exports, "TOUCH_ACTION_AUTO", ()=>TOUCH_ACTION_AUTO);
parcelHelpers.export(exports, "TOUCH_ACTION_MANIPULATION", ()=>TOUCH_ACTION_MANIPULATION);
parcelHelpers.export(exports, "TOUCH_ACTION_NONE", ()=>TOUCH_ACTION_NONE);
parcelHelpers.export(exports, "TOUCH_ACTION_PAN_X", ()=>TOUCH_ACTION_PAN_X);
parcelHelpers.export(exports, "TOUCH_ACTION_PAN_Y", ()=>TOUCH_ACTION_PAN_Y);
const TOUCH_ACTION_COMPUTE = 'compute';
const TOUCH_ACTION_AUTO = 'auto';
const TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
const TOUCH_ACTION_NONE = 'none';
const TOUCH_ACTION_PAN_X = 'pan-x';
const TOUCH_ACTION_PAN_Y = 'pan-y';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3hnf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cleanTouchActions);
var _touchactionConstsJs = require("./touchaction-Consts.js");
function cleanTouchActions(actions) {
    // none
    if (actions.includes((0, _touchactionConstsJs.TOUCH_ACTION_NONE))) return 0, _touchactionConstsJs.TOUCH_ACTION_NONE;
    const hasPanX = actions.includes((0, _touchactionConstsJs.TOUCH_ACTION_PAN_X));
    const hasPanY = actions.includes((0, _touchactionConstsJs.TOUCH_ACTION_PAN_Y));
    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) return 0, _touchactionConstsJs.TOUCH_ACTION_NONE;
    // pan-x OR pan-y
    if (hasPanX || hasPanY) return hasPanX ? (0, _touchactionConstsJs.TOUCH_ACTION_PAN_X) : (0, _touchactionConstsJs.TOUCH_ACTION_PAN_Y);
    // manipulation
    if (actions.includes((0, _touchactionConstsJs.TOUCH_ACTION_MANIPULATION))) return 0, _touchactionConstsJs.TOUCH_ACTION_MANIPULATION;
    return 0, _touchactionConstsJs.TOUCH_ACTION_AUTO;
}

},{"./touchaction-Consts.js":"7YG7L","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aYEzu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Pointer events input
 */ parcelHelpers.export(exports, "PointerEventInput", ()=>PointerEventInput);
var _inputConstsJs = require("../input/input-consts.js");
var _inputJs = require("../input/input.js");
const POINTER_INPUT_MAP = {
    pointerdown: (0, _inputConstsJs.InputEvent).Start,
    pointermove: (0, _inputConstsJs.InputEvent).Move,
    pointerup: (0, _inputConstsJs.InputEvent).End,
    pointercancel: (0, _inputConstsJs.InputEvent).Cancel,
    pointerout: (0, _inputConstsJs.InputEvent).Cancel
};
const POINTER_ELEMENT_EVENTS = 'pointerdown';
const POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
class PointerEventInput extends (0, _inputJs.Input) {
    constructor(manager){
        super(manager);
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        this.store = this.manager.session.pointerEvents = [];
        this.init();
    }
    /**
     * handle mouse events
     */ handler(ev) {
        const { store } = this;
        let removePointer = false;
        // @ts-ignore
        const eventType = POINTER_INPUT_MAP[ev.type];
        const pointerType = ev.pointerType;
        const isTouch = pointerType === 'touch';
        // get index of the event in the store
        let storeIndex = store.findIndex((e)=>e.pointerId === ev.pointerId);
        // start and mouse must be down
        if (eventType & (0, _inputConstsJs.InputEvent).Start && (ev.buttons || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & ((0, _inputConstsJs.InputEvent).End | (0, _inputConstsJs.InputEvent).Cancel)) removePointer = true;
        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) return;
        // update the event in the store
        store[storeIndex] = ev;
        this.callback(eventType, {
            pointers: store,
            changedPointers: [
                ev
            ],
            eventType,
            pointerType,
            srcEvent: ev
        });
        if (removePointer) // remove from the store
        store.splice(storeIndex, 1);
    }
}

},{"../input/input-consts.js":"l5Wx6","../input/input.js":"561Mc","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"561Mc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * create new input type manager
 */ parcelHelpers.export(exports, "Input", ()=>Input);
var _eventListenersJs = require("../utils/event-listeners.js");
var _getWindowForElementJs = require("../utils/get-window-for-element.js");
var _inputHandlerJs = require("./input-handler.js");
class Input {
    constructor(manager){
        this.evEl = '';
        this.evWin = '';
        this.evTarget = '';
        /** smaller wrapper around the handler, for the scope and the enabled state of the manager,
         * so when disabled the input events are completely bypassed.
         */ this.domHandler = (ev)=>{
            if (this.manager.options.enable) this.handler(ev);
        };
        this.manager = manager;
        this.element = manager.element;
        this.target = manager.options.inputTarget || manager.element;
    }
    callback(eventType, input) {
        (0, _inputHandlerJs.inputHandler)(this.manager, eventType, input);
    }
    // eslint-disable @typescript-eslint/unbound-method
    /**
     * bind the events
     */ init() {
        (0, _eventListenersJs.addEventListeners)(this.element, this.evEl, this.domHandler);
        (0, _eventListenersJs.addEventListeners)(this.target, this.evTarget, this.domHandler);
        (0, _eventListenersJs.addEventListeners)((0, _getWindowForElementJs.getWindowForElement)(this.element), this.evWin, this.domHandler);
    }
    /**
     * unbind the events
     */ destroy() {
        (0, _eventListenersJs.removeEventListeners)(this.element, this.evEl, this.domHandler);
        (0, _eventListenersJs.removeEventListeners)(this.target, this.evTarget, this.domHandler);
        (0, _eventListenersJs.removeEventListeners)((0, _getWindowForElementJs.getWindowForElement)(this.element), this.evWin, this.domHandler);
    }
}

},{"../utils/event-listeners.js":"duCiQ","../utils/get-window-for-element.js":"9bDKx","./input-handler.js":"12B8b","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"duCiQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * addEventListener with multiple events at once
 */ parcelHelpers.export(exports, "addEventListeners", ()=>addEventListeners);
/**
 * removeEventListener with multiple events at once
 */ parcelHelpers.export(exports, "removeEventListeners", ()=>removeEventListeners);
var _splitStrJs = require("./split-str.js");
function addEventListeners(target, types, handler) {
    if (!target) return;
    for (const type of (0, _splitStrJs.splitStr)(types))target.addEventListener(type, handler, false);
}
function removeEventListeners(target, types, handler) {
    if (!target) return;
    for (const type of (0, _splitStrJs.splitStr)(types))target.removeEventListener(type, handler, false);
}

},{"./split-str.js":"6skhE","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6skhE":[function(require,module,exports,__globalThis) {
/**
 * split string on whitespace
 * @returns {Array} words
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitStr", ()=>splitStr);
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9bDKx":[function(require,module,exports,__globalThis) {
/**
 * get the window object of an element
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWindowForElement", ()=>getWindowForElement);
function getWindowForElement(element) {
    const doc = element.ownerDocument || element;
    return doc.defaultView;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"12B8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * handle input events
 */ parcelHelpers.export(exports, "inputHandler", ()=>inputHandler);
var _inputConstsJs = require("./input-consts.js");
var _computeInputDataJs = require("./compute-input-data.js");
function inputHandler(manager, eventType, input) {
    const pointersLen = input.pointers.length;
    const changedPointersLen = input.changedPointers.length;
    const isFirst = eventType & (0, _inputConstsJs.InputEvent).Start && pointersLen - changedPointersLen === 0;
    const isFinal = eventType & ((0, _inputConstsJs.InputEvent).End | (0, _inputConstsJs.InputEvent).Cancel) && pointersLen - changedPointersLen === 0;
    input.isFirst = Boolean(isFirst);
    input.isFinal = Boolean(isFinal);
    if (isFirst) manager.session = {};
    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;
    // compute scale, rotation etc
    const processedInput = (0, _computeInputDataJs.computeInputData)(manager, input);
    // emit secret event
    manager.emit('hammer.input', processedInput);
    manager.recognize(processedInput);
    manager.session.prevInput = processedInput;
}

},{"./input-consts.js":"l5Wx6","./compute-input-data.js":"8LNJF","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8LNJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 */ parcelHelpers.export(exports, "computeInputData", ()=>computeInputData);
var _hasParentJs = require("../utils/has-parent.js");
var _hasParentJsDefault = parcelHelpers.interopDefault(_hasParentJs);
var _simpleCloneInputDataJs = require("./simple-clone-input-data.js");
var _getCenterJs = require("./get-center.js");
var _getDistanceJs = require("./get-distance.js");
var _getAngleJs = require("./get-angle.js");
var _getDirectionJs = require("./get-direction.js");
var _getDeltaXyJs = require("./get-delta-xy.js");
var _getVelocityJs = require("./get-velocity.js");
var _getScaleJs = require("./get-scale.js");
var _getRotationJs = require("./get-rotation.js");
var _computeIntervalInputDataJs = require("./compute-interval-input-data.js");
function computeInputData(manager, input) {
    const { session } = manager;
    const { pointers } = input;
    const { length: pointersLength } = pointers;
    // store the first input to calculate the distance and direction
    if (!session.firstInput) session.firstInput = (0, _simpleCloneInputDataJs.simpleCloneInputData)(input);
    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = (0, _simpleCloneInputDataJs.simpleCloneInputData)(input);
    else if (pointersLength === 1) session.firstMultiple = false;
    const { firstInput, firstMultiple } = session;
    const offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
    const center = input.center = (0, _getCenterJs.getCenter)(pointers);
    input.timeStamp = Date.now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;
    input.angle = (0, _getAngleJs.getPointAngle)(offsetCenter, center);
    input.distance = (0, _getDistanceJs.getPointDistance)(offsetCenter, center);
    const { deltaX, deltaY } = (0, _getDeltaXyJs.computeDeltaXY)(session, input);
    input.deltaX = deltaX;
    input.deltaY = deltaY;
    input.offsetDirection = (0, _getDirectionJs.getDirection)(input.deltaX, input.deltaY);
    const overallVelocity = (0, _getVelocityJs.getVelocity)(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = Math.abs(overallVelocity.x) > Math.abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
    input.scale = firstMultiple ? (0, _getScaleJs.getScale)(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? (0, _getRotationJs.getRotation)(firstMultiple.pointers, pointers) : 0;
    input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
    // find the correct target
    let target = manager.element;
    if ((0, _hasParentJsDefault.default)(input.srcEvent.target, target)) target = input.srcEvent.target;
    input.target = target;
    (0, _computeIntervalInputDataJs.computeIntervalInputData)(session, input);
    // All the optional fields have been populated
    return input;
}

},{"../utils/has-parent.js":"2bR21","./simple-clone-input-data.js":"dQxWQ","./get-center.js":"ewsBO","./get-distance.js":"icAso","./get-angle.js":"jNf7O","./get-direction.js":"ajFuY","./get-delta-xy.js":"lIOx8","./get-velocity.js":"dzYap","./get-scale.js":"iz8aH","./get-rotation.js":"3xyjy","./compute-interval-input-data.js":"htxtJ","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2bR21":[function(require,module,exports,__globalThis) {
/**
 * find if a node is in the given parent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasParent);
function hasParent(node, parent) {
    let ancestor = node;
    while(ancestor){
        if (ancestor === parent) return true;
        ancestor = ancestor.parentNode;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dQxWQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 */ parcelHelpers.export(exports, "simpleCloneInputData", ()=>simpleCloneInputData);
var _getCenterJs = require("./get-center.js");
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    const pointers = [];
    let i = 0;
    while(i < input.pointers.length){
        pointers[i] = {
            clientX: Math.round(input.pointers[i].clientX),
            clientY: Math.round(input.pointers[i].clientY)
        };
        i++;
    }
    return {
        timeStamp: Date.now(),
        pointers,
        center: (0, _getCenterJs.getCenter)(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

},{"./get-center.js":"ewsBO","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ewsBO":[function(require,module,exports,__globalThis) {
/**
 * get the center of all the pointers
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCenter", ()=>getCenter);
function getCenter(pointers) {
    const pointersLength = pointers.length;
    // no need to loop when only one touch
    if (pointersLength === 1) return {
        x: Math.round(pointers[0].clientX),
        y: Math.round(pointers[0].clientY)
    };
    let x = 0;
    let y = 0;
    let i = 0;
    while(i < pointersLength){
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }
    return {
        x: Math.round(x / pointersLength),
        y: Math.round(y / pointersLength)
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"icAso":[function(require,module,exports,__globalThis) {
/**
 * calculate the absolute distance between two points
 * @returns distance
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPointDistance", ()=>getPointDistance);
/**
 * calculate the absolute distance between two pointer events
 * @returns distance
 */ parcelHelpers.export(exports, "getEventDistance", ()=>getEventDistance);
function getPointDistance(p1, p2) {
    const x = p2.x - p1.x;
    const y = p2.y - p1.y;
    return Math.sqrt(x * x + y * y);
}
function getEventDistance(p1, p2) {
    const x = p2.clientX - p1.clientX;
    const y = p2.clientY - p1.clientY;
    return Math.sqrt(x * x + y * y);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jNf7O":[function(require,module,exports,__globalThis) {
/**
 * calculate the angle between two coordinates
 * @returns angle in degrees
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPointAngle", ()=>getPointAngle);
/**
 * calculate the angle between two pointer events
 * @returns angle in degrees
 */ parcelHelpers.export(exports, "getEventAngle", ()=>getEventAngle);
function getPointAngle(p1, p2) {
    const x = p2.x - p1.x;
    const y = p2.y - p1.y;
    return Math.atan2(y, x) * 180 / Math.PI;
}
function getEventAngle(p1, p2) {
    const x = p2.clientX - p1.clientX;
    const y = p2.clientY - p1.clientY;
    return Math.atan2(y, x) * 180 / Math.PI;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ajFuY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * get the direction between two points
 * @returns direction
 */ parcelHelpers.export(exports, "getDirection", ()=>getDirection);
var _inputConstsJs = require("./input-consts.js");
function getDirection(dx, dy) {
    if (dx === dy) return (0, _inputConstsJs.InputDirection).None;
    if (Math.abs(dx) >= Math.abs(dy)) return dx < 0 ? (0, _inputConstsJs.InputDirection).Left : (0, _inputConstsJs.InputDirection).Right;
    return dy < 0 ? (0, _inputConstsJs.InputDirection).Up : (0, _inputConstsJs.InputDirection).Down;
}

},{"./input-consts.js":"l5Wx6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lIOx8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Populates input.deltaX, input.deltaY */ parcelHelpers.export(exports, "computeDeltaXY", ()=>computeDeltaXY);
var _inputConstsJs = require("./input-consts.js");
function computeDeltaXY(session, input) {
    // getCenter is called before computeDeltaXY
    const center = input.center;
    let offset = session.offsetDelta;
    let prevDelta = session.prevDelta;
    const prevInput = session.prevInput;
    if (input.eventType === (0, _inputConstsJs.InputEvent).Start || prevInput?.eventType === (0, _inputConstsJs.InputEvent).End) {
        prevDelta = session.prevDelta = {
            x: prevInput?.deltaX || 0,
            y: prevInput?.deltaY || 0
        };
        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }
    return {
        deltaX: prevDelta.x + (center.x - offset.x),
        deltaY: prevDelta.y + (center.y - offset.y)
    };
}

},{"./input-consts.js":"l5Wx6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dzYap":[function(require,module,exports,__globalThis) {
/**
 * calculate the velocity between two points. unit is in px per ms.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVelocity", ()=>getVelocity);
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iz8aH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 */ parcelHelpers.export(exports, "getScale", ()=>getScale);
var _getDistanceJs = require("./get-distance.js");
function getScale(start, end) {
    return (0, _getDistanceJs.getEventDistance)(end[0], end[1]) / (0, _getDistanceJs.getEventDistance)(start[0], start[1]);
}

},{"./get-distance.js":"icAso","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3xyjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * calculate the rotation degrees between two pointer sets
 * @returns rotation in degrees
 */ parcelHelpers.export(exports, "getRotation", ()=>getRotation);
var _getAngleJs = require("./get-angle.js");
function getRotation(start, end) {
    return (0, _getAngleJs.getEventAngle)(end[1], end[0]) - (0, _getAngleJs.getEventAngle)(start[1], start[0]);
}

},{"./get-angle.js":"jNf7O","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"htxtJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * velocity is calculated every x ms
 */ parcelHelpers.export(exports, "computeIntervalInputData", ()=>computeIntervalInputData);
var _inputConstsJs = require("./input-consts.js");
var _getVelocityJs = require("./get-velocity.js");
var _getDirectionJs = require("./get-direction.js");
function computeIntervalInputData(session, input) {
    const last = session.lastInterval || input;
    const deltaTime = input.timeStamp - last.timeStamp;
    let velocity;
    let velocityX;
    let velocityY;
    let direction;
    if (input.eventType !== (0, _inputConstsJs.InputEvent).Cancel && (deltaTime > (0, _inputConstsJs.COMPUTE_INTERVAL) || last.velocity === undefined)) {
        const deltaX = input.deltaX - last.deltaX;
        const deltaY = input.deltaY - last.deltaY;
        const v = (0, _getVelocityJs.getVelocity)(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = Math.abs(v.x) > Math.abs(v.y) ? v.x : v.y;
        direction = (0, _getDirectionJs.getDirection)(deltaX, deltaY);
        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }
    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

},{"./input-consts.js":"l5Wx6","./get-velocity.js":"dzYap","./get-direction.js":"ajFuY","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1ZeEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * get the prefixed property
 * @returns prefixed property name
 */ parcelHelpers.export(exports, "prefixed", ()=>prefixed);
const VENDOR_PREFIXES = [
    '',
    'webkit',
    'Moz',
    'MS',
    'ms',
    'o'
];
function prefixed(obj, property) {
    const camelProp = property[0].toUpperCase() + property.slice(1);
    for (const prefix of VENDOR_PREFIXES){
        const prop = prefix ? prefix + camelProp : property;
        if (prop in obj) return prop;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2eKo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 */ parcelHelpers.export(exports, "Recognizer", ()=>Recognizer);
var _recognizerStateJs = require("./recognizer-state.js");
var _uniqueIdJs = require("../utils/unique-id.js");
var _stateStrJs = require("./state-str.js");
class Recognizer {
    constructor(options){
        this.options = options;
        this.id = (0, _uniqueIdJs.uniqueId)();
        this.state = (0, _recognizerStateJs.RecognizerState).Possible;
        this.simultaneous = {};
        this.requireFail = [];
    }
    /**
     * set options
     */ set(options) {
        Object.assign(this.options, options);
        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager.touchAction.update();
        return this;
    }
    /**
     * recognize simultaneous with an other recognizer.
     */ recognizeWith(recognizerOrName) {
        if (Array.isArray(recognizerOrName)) {
            for (const item of recognizerOrName)this.recognizeWith(item);
            return this;
        }
        let otherRecognizer;
        if (typeof recognizerOrName === 'string') {
            otherRecognizer = this.manager.get(recognizerOrName);
            if (!otherRecognizer) throw new Error(`Cannot find recognizer ${recognizerOrName}`);
        } else otherRecognizer = recognizerOrName;
        const { simultaneous } = this;
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    }
    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     */ dropRecognizeWith(recognizerOrName) {
        if (Array.isArray(recognizerOrName)) {
            for (const item of recognizerOrName)this.dropRecognizeWith(item);
            return this;
        }
        let otherRecognizer;
        if (typeof recognizerOrName === 'string') otherRecognizer = this.manager.get(recognizerOrName);
        else otherRecognizer = recognizerOrName;
        if (otherRecognizer) delete this.simultaneous[otherRecognizer.id];
        return this;
    }
    /**
     * recognizer can only run when an other is failing
     */ requireFailure(recognizerOrName) {
        if (Array.isArray(recognizerOrName)) {
            for (const item of recognizerOrName)this.requireFailure(item);
            return this;
        }
        let otherRecognizer;
        if (typeof recognizerOrName === 'string') {
            otherRecognizer = this.manager.get(recognizerOrName);
            if (!otherRecognizer) throw new Error(`Cannot find recognizer ${recognizerOrName}`);
        } else otherRecognizer = recognizerOrName;
        const { requireFail } = this;
        if (requireFail.indexOf(otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    }
    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     */ dropRequireFailure(recognizerOrName) {
        if (Array.isArray(recognizerOrName)) {
            for (const item of recognizerOrName)this.dropRequireFailure(item);
            return this;
        }
        let otherRecognizer;
        if (typeof recognizerOrName === 'string') otherRecognizer = this.manager.get(recognizerOrName);
        else otherRecognizer = recognizerOrName;
        if (otherRecognizer) {
            const index = this.requireFail.indexOf(otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
        }
        return this;
    }
    /**
     * has require failures boolean
     */ hasRequireFailures() {
        return Boolean(this.requireFail.find((recognier)=>recognier.options.enable));
    }
    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     */ canRecognizeWith(otherRecognizer) {
        return Boolean(this.simultaneous[otherRecognizer.id]);
    }
    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     */ emit(input) {
        // Some recognizers override emit() with their own logic
        if (!input) return;
        const { state } = this;
        // 'panstart' and 'panmove'
        if (state < (0, _recognizerStateJs.RecognizerState).Ended) this.manager.emit(this.options.event + (0, _stateStrJs.stateStr)(state), input);
        // simple 'eventName' events
        this.manager.emit(this.options.event, input);
        // additional event(panleft, panright, pinchin, pinchout...)
        if (input.additionalEvent) this.manager.emit(input.additionalEvent, input);
        // panend and pancancel
        if (state >= (0, _recognizerStateJs.RecognizerState).Ended) this.manager.emit(this.options.event + (0, _stateStrJs.stateStr)(state), input);
    }
    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     */ tryEmit(input) {
        if (this.canEmit()) this.emit(input);
        else // it's failing anyway
        this.state = (0, _recognizerStateJs.RecognizerState).Failed;
    }
    /**
     * can we emit?
     */ canEmit() {
        let i = 0;
        while(i < this.requireFail.length){
            if (!(this.requireFail[i].state & ((0, _recognizerStateJs.RecognizerState).Failed | (0, _recognizerStateJs.RecognizerState).Possible))) return false;
            i++;
        }
        return true;
    }
    /**
     * update the recognizer
     */ recognize(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        const inputDataClone = {
            ...inputData
        };
        // is is enabled and allow recognizing?
        if (!this.options.enable) {
            this.reset();
            this.state = (0, _recognizerStateJs.RecognizerState).Failed;
            return;
        }
        // reset when we've reached the end
        if (this.state & ((0, _recognizerStateJs.RecognizerState).Recognized | (0, _recognizerStateJs.RecognizerState).Cancelled | (0, _recognizerStateJs.RecognizerState).Failed)) this.state = (0, _recognizerStateJs.RecognizerState).Possible;
        this.state = this.process(inputDataClone);
        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & ((0, _recognizerStateJs.RecognizerState).Began | (0, _recognizerStateJs.RecognizerState).Changed | (0, _recognizerStateJs.RecognizerState).Ended | (0, _recognizerStateJs.RecognizerState).Cancelled)) this.tryEmit(inputDataClone);
    }
    /**
     * return the event names that are emitted by this recognizer
     */ getEventNames() {
        return [
            this.options.event
        ];
    }
    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     */ reset() {}
}

},{"./recognizer-state.js":"6zX1r","../utils/unique-id.js":"a7CR5","./state-str.js":"br648","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"a7CR5":[function(require,module,exports,__globalThis) {
/**
 * get a unique id
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
let _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"br648":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * get a usable string, used as event postfix
 */ parcelHelpers.export(exports, "stateStr", ()=>stateStr);
var _recognizerStateJs = require("./recognizer-state.js");
function stateStr(state) {
    if (state & (0, _recognizerStateJs.RecognizerState).Cancelled) return 'cancel';
    else if (state & (0, _recognizerStateJs.RecognizerState).Ended) return 'end';
    else if (state & (0, _recognizerStateJs.RecognizerState).Changed) return 'move';
    else if (state & (0, _recognizerStateJs.RecognizerState).Began) return 'start';
    return '';
}

},{"./recognizer-state.js":"6zX1r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4ixqv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 */ parcelHelpers.export(exports, "AttrRecognizer", ()=>AttrRecognizer);
var _recognizerJs = require("../recognizer/recognizer.js");
var _recognizerStateJs = require("../recognizer/recognizer-state.js");
var _inputConstsJs = require("../input/input-consts.js");
class AttrRecognizer extends (0, _recognizerJs.Recognizer) {
    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     */ attrTest(input) {
        const optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    }
    /**
     * Process the input and return the state for the recognizer
     */ process(input) {
        const { state } = this;
        const { eventType } = input;
        const isRecognized = state & ((0, _recognizerStateJs.RecognizerState).Began | (0, _recognizerStateJs.RecognizerState).Changed);
        const isValid = this.attrTest(input);
        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & (0, _inputConstsJs.InputEvent).Cancel || !isValid)) return state | (0, _recognizerStateJs.RecognizerState).Cancelled;
        else if (isRecognized || isValid) {
            if (eventType & (0, _inputConstsJs.InputEvent).End) return state | (0, _recognizerStateJs.RecognizerState).Ended;
            else if (!(state & (0, _recognizerStateJs.RecognizerState).Began)) return (0, _recognizerStateJs.RecognizerState).Began;
            return state | (0, _recognizerStateJs.RecognizerState).Changed;
        }
        return (0, _recognizerStateJs.RecognizerState).Failed;
    }
}

},{"../recognizer/recognizer.js":"2eKo8","../recognizer/recognizer-state.js":"6zX1r","../input/input-consts.js":"l5Wx6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"g5HMb":[function(require,module,exports,__globalThis) {
/* global setTimeout, clearTimeout */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 */ parcelHelpers.export(exports, "TapRecognizer", ()=>TapRecognizer);
var _recognizerJs = require("../recognizer/recognizer.js");
var _touchactionConstsJs = require("../touchaction/touchaction-Consts.js");
var _inputConstsJs = require("../input/input-consts.js");
var _recognizerStateJs = require("../recognizer/recognizer-state.js");
var _getDistanceJs = require("../input/get-distance.js");
class TapRecognizer extends (0, _recognizerJs.Recognizer) {
    constructor(options = {}){
        super({
            enable: true,
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10,
            ...options
        });
        /** previous time for tap counting */ this.pTime = null;
        /** previous center for tap counting */ this.pCenter = null;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    getTouchAction() {
        return [
            (0, _touchactionConstsJs.TOUCH_ACTION_MANIPULATION)
        ];
    }
    process(input) {
        const { options } = this;
        const validPointers = input.pointers.length === options.pointers;
        const validMovement = input.distance < options.threshold;
        const validTouchTime = input.deltaTime < options.time;
        this.reset();
        if (input.eventType & (0, _inputConstsJs.InputEvent).Start && this.count === 0) return this.failTimeout();
        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType !== (0, _inputConstsJs.InputEvent).End) return this.failTimeout();
            const validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
            const validMultiTap = !this.pCenter || (0, _getDistanceJs.getPointDistance)(this.pCenter, input.center) < options.posThreshold;
            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) this.count = 1;
            else this.count += 1;
            this._input = input;
            // if tap count matches we have recognized it,
            // else it has began recognizing...
            const tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) return (0, _recognizerStateJs.RecognizerState).Recognized;
                this._timer = setTimeout(()=>{
                    this.state = (0, _recognizerStateJs.RecognizerState).Recognized;
                    this.tryEmit(this._input);
                }, options.interval);
                return (0, _recognizerStateJs.RecognizerState).Began;
            }
        }
        return (0, _recognizerStateJs.RecognizerState).Failed;
    }
    failTimeout() {
        this._timer = setTimeout(()=>{
            this.state = (0, _recognizerStateJs.RecognizerState).Failed;
        }, this.options.interval);
        return (0, _recognizerStateJs.RecognizerState).Failed;
    }
    reset() {
        clearTimeout(this._timer);
    }
    emit(input) {
        if (this.state === (0, _recognizerStateJs.RecognizerState).Recognized) {
            input.tapCount = this.count;
            this.manager.emit(this.options.event, input);
        }
    }
}

},{"../recognizer/recognizer.js":"2eKo8","../touchaction/touchaction-Consts.js":"7YG7L","../input/input-consts.js":"l5Wx6","../recognizer/recognizer-state.js":"6zX1r","../input/get-distance.js":"icAso","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5eAx3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 */ parcelHelpers.export(exports, "PanRecognizer", ()=>PanRecognizer);
var _attributeJs = require("./attribute.js");
var _inputConstsJs = require("../input/input-consts.js");
var _recognizerStateJs = require("../recognizer/recognizer-state.js");
var _touchactionConstsJs = require("../touchaction/touchaction-Consts.js");
const EVENT_NAMES = [
    '',
    'start',
    'move',
    'end',
    'cancel',
    'up',
    'down',
    'left',
    'right'
];
class PanRecognizer extends (0, _attributeJs.AttrRecognizer) {
    constructor(options = {}){
        super({
            enable: true,
            pointers: 1,
            event: 'pan',
            threshold: 10,
            direction: (0, _inputConstsJs.InputDirection).All,
            ...options
        });
        this.pX = null;
        this.pY = null;
    }
    getTouchAction() {
        const { options: { direction } } = this;
        const actions = [];
        if (direction & (0, _inputConstsJs.InputDirection).Horizontal) actions.push((0, _touchactionConstsJs.TOUCH_ACTION_PAN_Y));
        if (direction & (0, _inputConstsJs.InputDirection).Vertical) actions.push((0, _touchactionConstsJs.TOUCH_ACTION_PAN_X));
        return actions;
    }
    getEventNames() {
        return EVENT_NAMES.map((suffix)=>this.options.event + suffix);
    }
    directionTest(input) {
        const { options } = this;
        let hasMoved = true;
        let { distance } = input;
        let { direction } = input;
        const x = input.deltaX;
        const y = input.deltaY;
        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & (0, _inputConstsJs.InputDirection).Horizontal) {
                direction = x === 0 ? (0, _inputConstsJs.InputDirection).None : x < 0 ? (0, _inputConstsJs.InputDirection).Left : (0, _inputConstsJs.InputDirection).Right;
                hasMoved = x !== this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = y === 0 ? (0, _inputConstsJs.InputDirection).None : y < 0 ? (0, _inputConstsJs.InputDirection).Up : (0, _inputConstsJs.InputDirection).Down;
                hasMoved = y !== this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && Boolean(direction & options.direction);
    }
    attrTest(input) {
        return super.attrTest(input) && (Boolean(this.state & (0, _recognizerStateJs.RecognizerState).Began) || !(this.state & (0, _recognizerStateJs.RecognizerState).Began) && this.directionTest(input));
    }
    emit(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        const direction = (0, _inputConstsJs.InputDirection)[input.direction].toLowerCase();
        if (direction) input.additionalEvent = this.options.event + direction;
        super.emit(input);
    }
}

},{"./attribute.js":"4ixqv","../input/input-consts.js":"l5Wx6","../recognizer/recognizer-state.js":"6zX1r","../touchaction/touchaction-Consts.js":"7YG7L","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kOli6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 */ parcelHelpers.export(exports, "SwipeRecognizer", ()=>SwipeRecognizer);
var _attributeJs = require("./attribute.js");
var _inputConstsJs = require("../input/input-consts.js");
var _panJs = require("./pan.js");
const EVENT_NAMES = [
    '',
    'up',
    'down',
    'left',
    'right'
];
class SwipeRecognizer extends (0, _attributeJs.AttrRecognizer) {
    constructor(options = {}){
        super({
            enable: true,
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: (0, _inputConstsJs.InputDirection).All,
            pointers: 1,
            ...options
        });
    }
    getTouchAction() {
        return (0, _panJs.PanRecognizer).prototype.getTouchAction.call(this);
    }
    getEventNames() {
        return EVENT_NAMES.map((suffix)=>this.options.event + suffix);
    }
    attrTest(input) {
        const { direction } = this.options;
        let velocity = 0;
        if (direction & (0, _inputConstsJs.InputDirection).All) velocity = input.overallVelocity;
        else if (direction & (0, _inputConstsJs.InputDirection).Horizontal) velocity = input.overallVelocityX;
        else if (direction & (0, _inputConstsJs.InputDirection).Vertical) velocity = input.overallVelocityY;
        return super.attrTest(input) && Boolean(direction & input.offsetDirection) && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && Math.abs(velocity) > this.options.velocity && Boolean(input.eventType & (0, _inputConstsJs.InputEvent).End);
    }
    emit(input) {
        const direction = (0, _inputConstsJs.InputDirection)[input.offsetDirection].toLowerCase();
        if (direction) this.manager.emit(this.options.event + direction, input);
        this.manager.emit(this.options.event, input);
    }
}

},{"./attribute.js":"4ixqv","../input/input-consts.js":"l5Wx6","./pan.js":"5eAx3","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"39M2Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 */ parcelHelpers.export(exports, "PinchRecognizer", ()=>PinchRecognizer);
var _attributeJs = require("./attribute.js");
var _touchactionConstsJs = require("../touchaction/touchaction-Consts.js");
var _recognizerStateJs = require("../recognizer/recognizer-state.js");
const EVENT_NAMES = [
    '',
    'start',
    'move',
    'end',
    'cancel',
    'in',
    'out'
];
class PinchRecognizer extends (0, _attributeJs.AttrRecognizer) {
    constructor(options = {}){
        super({
            enable: true,
            event: 'pinch',
            threshold: 0,
            pointers: 2,
            ...options
        });
    }
    getTouchAction() {
        return [
            (0, _touchactionConstsJs.TOUCH_ACTION_NONE)
        ];
    }
    getEventNames() {
        return EVENT_NAMES.map((suffix)=>this.options.event + suffix);
    }
    attrTest(input) {
        return super.attrTest(input) && (Math.abs(input.scale - 1) > this.options.threshold || Boolean(this.state & (0, _recognizerStateJs.RecognizerState).Began));
    }
    emit(input) {
        if (input.scale !== 1) {
            const inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        super.emit(input);
    }
}

},{"./attribute.js":"4ixqv","../touchaction/touchaction-Consts.js":"7YG7L","../recognizer/recognizer-state.js":"6zX1r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cRdXB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 */ parcelHelpers.export(exports, "RotateRecognizer", ()=>RotateRecognizer);
var _attributeJs = require("./attribute.js");
var _touchactionConstsJs = require("../touchaction/touchaction-Consts.js");
var _recognizerStateJs = require("../recognizer/recognizer-state.js");
const EVENT_NAMES = [
    '',
    'start',
    'move',
    'end',
    'cancel'
];
class RotateRecognizer extends (0, _attributeJs.AttrRecognizer) {
    constructor(options = {}){
        super({
            enable: true,
            event: 'rotate',
            threshold: 0,
            pointers: 2,
            ...options
        });
    }
    getTouchAction() {
        return [
            (0, _touchactionConstsJs.TOUCH_ACTION_NONE)
        ];
    }
    getEventNames() {
        return EVENT_NAMES.map((suffix)=>this.options.event + suffix);
    }
    attrTest(input) {
        return super.attrTest(input) && (Math.abs(input.rotation) > this.options.threshold || Boolean(this.state & (0, _recognizerStateJs.RecognizerState).Began));
    }
}

},{"./attribute.js":"4ixqv","../touchaction/touchaction-Consts.js":"7YG7L","../recognizer/recognizer-state.js":"6zX1r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lhrew":[function(require,module,exports,__globalThis) {
/* global setTimeout, clearTimeout */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 */ parcelHelpers.export(exports, "PressRecognizer", ()=>PressRecognizer);
var _recognizerJs = require("../recognizer/recognizer.js");
var _recognizerStateJs = require("../recognizer/recognizer-state.js");
var _touchactionConstsJs = require("../touchaction/touchaction-Consts.js");
var _inputConstsJs = require("../input/input-consts.js");
const EVENT_NAMES = [
    '',
    'up'
];
class PressRecognizer extends (0, _recognizerJs.Recognizer) {
    constructor(options = {}){
        super({
            enable: true,
            event: 'press',
            pointers: 1,
            time: 251,
            threshold: 9,
            ...options
        });
        this._timer = null;
        this._input = null;
    }
    getTouchAction() {
        return [
            (0, _touchactionConstsJs.TOUCH_ACTION_AUTO)
        ];
    }
    getEventNames() {
        return EVENT_NAMES.map((suffix)=>this.options.event + suffix);
    }
    process(input) {
        const { options } = this;
        const validPointers = input.pointers.length === options.pointers;
        const validMovement = input.distance < options.threshold;
        const validTime = input.deltaTime > options.time;
        this._input = input;
        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || input.eventType & ((0, _inputConstsJs.InputEvent).End | (0, _inputConstsJs.InputEvent).Cancel) && !validTime) this.reset();
        else if (input.eventType & (0, _inputConstsJs.InputEvent).Start) {
            this.reset();
            this._timer = setTimeout(()=>{
                this.state = (0, _recognizerStateJs.RecognizerState).Recognized;
                this.tryEmit();
            }, options.time);
        } else if (input.eventType & (0, _inputConstsJs.InputEvent).End) return (0, _recognizerStateJs.RecognizerState).Recognized;
        return (0, _recognizerStateJs.RecognizerState).Failed;
    }
    reset() {
        clearTimeout(this._timer);
    }
    emit(input) {
        if (this.state !== (0, _recognizerStateJs.RecognizerState).Recognized) return;
        if (input && input.eventType & (0, _inputConstsJs.InputEvent).End) this.manager.emit(`${this.options.event}up`, input);
        else {
            this._input.timeStamp = Date.now();
            this.manager.emit(this.options.event, this._input);
        }
    }
}

},{"../recognizer/recognizer.js":"2eKo8","../recognizer/recognizer-state.js":"6zX1r","../touchaction/touchaction-Consts.js":"7YG7L","../input/input-consts.js":"l5Wx6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7vGgx":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WheelInput", ()=>WheelInput);
var _inputJs = require("./input.js");
var _globalsJs = require("../utils/globals.js");
const firefox = (0, _globalsJs.userAgent).indexOf('firefox') !== -1;
// Constants for normalizing input delta
const WHEEL_DELTA_MAGIC_SCALER = 4.000244140625;
const WHEEL_DELTA_PER_LINE = 40;
// Slow down zoom if shift key is held for more precise zooming
const SHIFT_MULTIPLIER = 0.25;
class WheelInput extends (0, _inputJs.Input) {
    constructor(element, callback, options){
        super(element, callback, {
            enable: true,
            ...options
        });
        /* eslint-disable complexity, max-statements */ this.handleEvent = (event)=>{
            if (!this.options.enable) return;
            let value = event.deltaY;
            if (globalThis.WheelEvent) {
                // Firefox doubles the values on retina screens...
                if (firefox && event.deltaMode === globalThis.WheelEvent.DOM_DELTA_PIXEL) value /= globalThis.devicePixelRatio;
                if (event.deltaMode === globalThis.WheelEvent.DOM_DELTA_LINE) value *= WHEEL_DELTA_PER_LINE;
            }
            if (value !== 0 && value % WHEEL_DELTA_MAGIC_SCALER === 0) // This one is definitely a mouse wheel event.
            // Normalize this value to match trackpad.
            value = Math.floor(value / WHEEL_DELTA_MAGIC_SCALER);
            if (event.shiftKey && value) value = value * SHIFT_MULTIPLIER;
            this.callback({
                type: 'wheel',
                center: {
                    x: event.clientX,
                    y: event.clientY
                },
                delta: -value,
                srcEvent: event,
                pointerType: 'mouse',
                target: event.target
            });
        };
        element.addEventListener('wheel', this.handleEvent, {
            passive: false
        });
    }
    destroy() {
        this.element.removeEventListener('wheel', this.handleEvent);
    }
    /**
     * Enable this input (begin processing events)
     * if the specified event type is among those handled by this input.
     */ enableEventType(eventType, enabled) {
        if (eventType === 'wheel') this.options.enable = enabled;
    }
}

},{"./input.js":"dakeq","../utils/globals.js":"h6MYL","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dakeq":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>Input);
class Input {
    constructor(element, callback, options){
        this.element = element;
        this.callback = callback;
        this.options = options;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"h6MYL":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Purpose: include this in your module to avoids adding dependencies on
// micro modules like 'global'
/* global window, global, document, navigator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgent", ()=>userAgent);
parcelHelpers.export(exports, "window", ()=>window_);
parcelHelpers.export(exports, "global", ()=>global_);
parcelHelpers.export(exports, "document", ()=>document_);
var global = arguments[3];
const userAgent = typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent.toLowerCase() : '';
const window_ = typeof window !== 'undefined' ? window : global;
const global_ = typeof global !== 'undefined' ? global : window;
const document_ = typeof document !== 'undefined' ? document : {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lR31G":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hammer.js swallows 'move' events (for pointer/touch/mouse)
 * when the pointer is not down. This class sets up a handler
 * specifically for these events to work around this limitation.
 * Note that this could be extended to more intelligently handle
 * move events across input types, e.g. storing multiple simultaneous
 * pointer/touch events, calculating speed/direction, etc.
 */ parcelHelpers.export(exports, "MoveInput", ()=>MoveInput);
var _inputJs = require("./input.js");
const MOUSE_EVENTS = [
    'mousedown',
    'mousemove',
    'mouseup',
    'mouseover',
    'mouseout',
    'mouseleave'
];
class MoveInput extends (0, _inputJs.Input) {
    constructor(element, callback, options){
        super(element, callback, {
            enable: true,
            ...options
        });
        this.handleEvent = (event)=>{
            this.handleOverEvent(event);
            this.handleOutEvent(event);
            this.handleEnterEvent(event);
            this.handleLeaveEvent(event);
            this.handleMoveEvent(event);
        };
        this.pressed = false;
        const { enable } = this.options;
        this.enableMoveEvent = enable;
        this.enableLeaveEvent = enable;
        this.enableEnterEvent = enable;
        this.enableOutEvent = enable;
        this.enableOverEvent = enable;
        MOUSE_EVENTS.forEach((event)=>element.addEventListener(event, this.handleEvent));
    }
    destroy() {
        MOUSE_EVENTS.forEach((event)=>this.element.removeEventListener(event, this.handleEvent));
    }
    /**
     * Enable this input (begin processing events)
     * if the specified event type is among those handled by this input.
     */ enableEventType(eventType, enabled) {
        switch(eventType){
            case 'pointermove':
                this.enableMoveEvent = enabled;
                break;
            case 'pointerover':
                this.enableOverEvent = enabled;
                break;
            case 'pointerout':
                this.enableOutEvent = enabled;
                break;
            case 'pointerenter':
                this.enableEnterEvent = enabled;
                break;
            case 'pointerleave':
                this.enableLeaveEvent = enabled;
                break;
            default:
        }
    }
    handleOverEvent(event) {
        if (this.enableOverEvent && event.type === 'mouseover') this._emit('pointerover', event);
    }
    handleOutEvent(event) {
        if (this.enableOutEvent && event.type === 'mouseout') this._emit('pointerout', event);
    }
    handleEnterEvent(event) {
        if (this.enableEnterEvent && event.type === 'mouseenter') this._emit('pointerenter', event);
    }
    handleLeaveEvent(event) {
        if (this.enableLeaveEvent && event.type === 'mouseleave') this._emit('pointerleave', event);
    }
    handleMoveEvent(event) {
        if (this.enableMoveEvent) switch(event.type){
            case 'mousedown':
                if (event.button >= 0) // Button is down
                this.pressed = true;
                break;
            case 'mousemove':
                // Move events use `bottons` to track the button being pressed
                if (event.buttons === 0) // Button is not down
                this.pressed = false;
                if (!this.pressed) // Drag events are emitted by hammer already
                // we just need to emit the move event on hover
                this._emit('pointermove', event);
                break;
            case 'mouseup':
                this.pressed = false;
                break;
            default:
        }
    }
    _emit(type, event) {
        this.callback({
            type,
            center: {
                x: event.clientX,
                y: event.clientY
            },
            srcEvent: event,
            pointerType: 'mouse',
            target: event.target
        });
    }
}

},{"./input.js":"dakeq","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cumKq":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyInput", ()=>KeyInput);
var _inputJs = require("./input.js");
const KEY_EVENTS = [
    'keydown',
    'keyup'
];
class KeyInput extends (0, _inputJs.Input) {
    constructor(element, callback, options){
        super(element, callback, {
            enable: true,
            tabIndex: 0,
            ...options
        });
        this.handleEvent = (event)=>{
            // Ignore if focused on text input
            const targetElement = event.target || event.srcElement;
            if (targetElement.tagName === 'INPUT' && targetElement.type === 'text' || targetElement.tagName === 'TEXTAREA') return;
            if (this.enableDownEvent && event.type === 'keydown') this.callback({
                type: 'keydown',
                srcEvent: event,
                key: event.key,
                target: event.target
            });
            if (this.enableUpEvent && event.type === 'keyup') this.callback({
                type: 'keyup',
                srcEvent: event,
                key: event.key,
                target: event.target
            });
        };
        this.enableDownEvent = this.options.enable;
        this.enableUpEvent = this.options.enable;
        element.tabIndex = this.options.tabIndex;
        element.style.outline = 'none';
        KEY_EVENTS.forEach((event)=>element.addEventListener(event, this.handleEvent));
    }
    destroy() {
        KEY_EVENTS.forEach((event)=>this.element.removeEventListener(event, this.handleEvent));
    }
    /**
     * Enable this input (begin processing events)
     * if the specified event type is among those handled by this input.
     */ enableEventType(eventType, enabled) {
        if (eventType === 'keydown') this.enableDownEvent = enabled;
        if (eventType === 'keyup') this.enableUpEvent = enabled;
    }
}

},{"./input.js":"dakeq","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9EPP9":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextmenuInput", ()=>ContextmenuInput);
var _inputJs = require("./input.js");
class ContextmenuInput extends (0, _inputJs.Input) {
    constructor(element, callback, options){
        super(element, callback, options);
        this.handleEvent = (event)=>{
            if (!this.options.enable) return;
            this.callback({
                type: 'contextmenu',
                center: {
                    x: event.clientX,
                    y: event.clientY
                },
                srcEvent: event,
                pointerType: 'mouse',
                target: event.target
            });
        };
        element.addEventListener('contextmenu', this.handleEvent);
    }
    destroy() {
        this.element.removeEventListener('contextmenu', this.handleEvent);
    }
    /**
     * Enable this input (begin processing events)
     * if the specified event type is among those handled by this input.
     */ enableEventType(eventType, enabled) {
        if (eventType === 'contextmenu') this.options.enable = enabled;
    }
}

},{"./input.js":"dakeq","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"LepZg":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventRegistrar", ()=>EventRegistrar);
var _eventUtilsJs = require("./event-utils.js");
const DEFAULT_OPTIONS = {
    srcElement: 'root',
    priority: 0
};
class EventRegistrar {
    constructor(eventManager, recognizerName){
        /**
         * Handles hammerjs event
         */ this.handleEvent = (event)=>{
            if (this.isEmpty()) return;
            const mjolnirEvent = this._normalizeEvent(event);
            let target = event.srcEvent.target;
            while(target && target !== mjolnirEvent.rootElement){
                this._emit(mjolnirEvent, target);
                if (mjolnirEvent.handled) return;
                target = target.parentNode;
            }
            this._emit(mjolnirEvent, 'root');
        };
        this.eventManager = eventManager;
        this.recognizerName = recognizerName;
        this.handlers = [];
        // Element -> handler map
        this.handlersByElement = new Map();
        this._active = false;
    }
    // Returns true if there are no non-passive handlers
    isEmpty() {
        return !this._active;
    }
    add(type, handler, options, once = false, passive = false) {
        const { handlers, handlersByElement } = this;
        const opts = {
            ...DEFAULT_OPTIONS,
            ...options
        };
        let entries = handlersByElement.get(opts.srcElement);
        if (!entries) {
            entries = [];
            handlersByElement.set(opts.srcElement, entries);
        }
        const entry = {
            type,
            handler,
            srcElement: opts.srcElement,
            priority: opts.priority
        };
        if (once) entry.once = true;
        if (passive) entry.passive = true;
        handlers.push(entry);
        this._active = this._active || !entry.passive;
        // Sort handlers by descending priority
        // Handlers with the same priority are excuted in the order of registration
        let insertPosition = entries.length - 1;
        while(insertPosition >= 0){
            if (entries[insertPosition].priority >= entry.priority) break;
            insertPosition--;
        }
        entries.splice(insertPosition + 1, 0, entry);
    }
    remove(type, handler) {
        const { handlers, handlersByElement } = this;
        for(let i = handlers.length - 1; i >= 0; i--){
            const entry = handlers[i];
            if (entry.type === type && entry.handler === handler) {
                handlers.splice(i, 1);
                const entries = handlersByElement.get(entry.srcElement);
                entries.splice(entries.indexOf(entry), 1);
                if (entries.length === 0) handlersByElement.delete(entry.srcElement);
            }
        }
        this._active = handlers.some((entry)=>!entry.passive);
    }
    /**
     * Invoke handlers on a particular element
     */ _emit(event, srcElement) {
        const entries = this.handlersByElement.get(srcElement);
        if (entries) {
            let immediatePropagationStopped = false;
            // Prevents the current event from bubbling up
            const stopPropagation = ()=>{
                event.handled = true;
            };
            // Prevent any remaining listeners from being called
            const stopImmediatePropagation = ()=>{
                event.handled = true;
                immediatePropagationStopped = true;
            };
            const entriesToRemove = [];
            for(let i = 0; i < entries.length; i++){
                const { type, handler, once } = entries[i];
                // @ts-ignore
                handler({
                    ...event,
                    type,
                    stopPropagation,
                    stopImmediatePropagation
                });
                if (once) entriesToRemove.push(entries[i]);
                if (immediatePropagationStopped) break;
            }
            for(let i = 0; i < entriesToRemove.length; i++){
                const { type, handler } = entriesToRemove[i];
                this.remove(type, handler);
            }
        }
    }
    /**
     * Normalizes hammerjs and custom events to have predictable fields.
     */ _normalizeEvent(event) {
        const rootElement = this.eventManager.getElement();
        // @ts-ignore
        return {
            ...event,
            ...(0, _eventUtilsJs.whichButtons)(event),
            ...(0, _eventUtilsJs.getOffsetPosition)(event, rootElement),
            preventDefault: ()=>{
                event.srcEvent.preventDefault();
            },
            stopImmediatePropagation: null,
            stopPropagation: null,
            handled: false,
            rootElement
        };
    }
}

},{"./event-utils.js":"A3PMq","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"A3PMq":[function(require,module,exports,__globalThis) {
// mjolnir.js
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* Constants */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Extract the involved mouse button
 */ parcelHelpers.export(exports, "whichButtons", ()=>whichButtons);
/**
 * Calculate event position relative to the root element
 */ parcelHelpers.export(exports, "getOffsetPosition", ()=>getOffsetPosition);
const DOWN_EVENT = 1;
const MOVE_EVENT = 2;
const UP_EVENT = 4;
const MOUSE_EVENTS = {
    pointerdown: DOWN_EVENT,
    pointermove: MOVE_EVENT,
    pointerup: UP_EVENT,
    mousedown: DOWN_EVENT,
    mousemove: MOVE_EVENT,
    mouseup: UP_EVENT
};
// MouseEvent.button https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
const MOUSE_EVENT_BUTTON_LEFT = 0;
const MOUSE_EVENT_BUTTON_MIDDLE = 1;
const MOUSE_EVENT_BUTTON_RIGHT = 2;
// MouseEvent.buttons https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
const MOUSE_EVENT_BUTTONS_LEFT_MASK = 1;
const MOUSE_EVENT_BUTTONS_RIGHT_MASK = 2;
const MOUSE_EVENT_BUTTONS_MIDDLE_MASK = 4;
function whichButtons(event) {
    const eventType = MOUSE_EVENTS[event.srcEvent.type];
    if (!eventType) // Not a mouse evet
    return null;
    const { buttons, button } = event.srcEvent;
    let leftButton = false;
    let middleButton = false;
    let rightButton = false;
    if (eventType === MOVE_EVENT) {
        leftButton = Boolean(buttons & MOUSE_EVENT_BUTTONS_LEFT_MASK);
        middleButton = Boolean(buttons & MOUSE_EVENT_BUTTONS_MIDDLE_MASK);
        rightButton = Boolean(buttons & MOUSE_EVENT_BUTTONS_RIGHT_MASK);
    } else {
        leftButton = button === MOUSE_EVENT_BUTTON_LEFT;
        middleButton = button === MOUSE_EVENT_BUTTON_MIDDLE;
        rightButton = button === MOUSE_EVENT_BUTTON_RIGHT;
    }
    return {
        leftButton,
        middleButton,
        rightButton
    };
}
function getOffsetPosition(event, rootElement) {
    const center = event.center;
    // `center` is a hammer.js event property
    if (!center) // Not a gestural event
    return null;
    const rect = rootElement.getBoundingClientRect();
    // Fix scale for map affected by a CSS transform.
    // See https://stackoverflow.com/a/26893663/3528533
    const scaleX = rect.width / rootElement.offsetWidth || 1;
    const scaleY = rect.height / rootElement.offsetHeight || 1;
    // Calculate center relative to the root element
    const offsetCenter = {
        x: (center.x - rect.left - rootElement.clientLeft) / scaleX,
        y: (center.y - rect.top - rootElement.clientTop) / scaleY
    };
    return {
        center,
        offsetCenter
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4XQCO":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function isEqual(a, b) {
    if (a === b) return true;
    if (Array.isArray(a)) {
        // Special treatment for arrays: compare 1-level deep
        // This is to support equality of matrix/coordinate props
        const len = a.length;
        if (!b || b.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}
function memoize(compute) {
    let cachedArgs = {};
    let cachedResult;
    return (args)=>{
        for(const key in args)if (!isEqual(args[key], cachedArgs[key])) {
            cachedResult = compute(args);
            cachedArgs = args;
            break;
        }
        return cachedResult;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5hZ3L":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "projectWGSLHeader", ()=>projectWGSLHeader);
parcelHelpers.export(exports, "projectWGSL", ()=>projectWGSL);
var _constantsJs = require("../../lib/constants.js");
// We are generating these from the js code in constants.js
const COORDINATE_SYSTEM_WGSL_CONSTANTS = Object.keys((0, _constantsJs.COORDINATE_SYSTEM)).map((key)=>`const COORDINATE_SYSTEM_${key}: i32 = ${(0, _constantsJs.COORDINATE_SYSTEM)[key]};`).join('');
const PROJECTION_MODE_WGSL_CONSTANTS = Object.keys((0, _constantsJs.PROJECTION_MODE)).map((key)=>`const PROJECTION_MODE_${key}: i32 = ${(0, _constantsJs.PROJECTION_MODE)[key]};`).join('');
const UNIT_WGSL_CONSTANTS = Object.keys((0, _constantsJs.UNIT)).map((key)=>`const UNIT_${key.toUpperCase()}: i32 = ${(0, _constantsJs.UNIT)[key]};`).join('');
const projectWGSLHeader = /* wgsl */ `\
${COORDINATE_SYSTEM_WGSL_CONSTANTS}
${PROJECTION_MODE_WGSL_CONSTANTS}
${UNIT_WGSL_CONSTANTS}

const TILE_SIZE: f32 = 512.0;
const PI: f32 = 3.1415926536;
const WORLD_SCALE: f32 = TILE_SIZE / (PI * 2.0);
const ZERO_64_LOW: vec3<f32> = vec3<f32>(0.0, 0.0, 0.0);
const EARTH_RADIUS: f32 = 6370972.0; // meters
const GLOBE_RADIUS: f32 = 256.0;

// -----------------------------------------------------------------------------
// Uniform block (converted from GLSL uniform block)
// -----------------------------------------------------------------------------
struct ProjectUniforms {
  wrapLongitude: i32,
  coordinateSystem: i32,
  commonUnitsPerMeter: vec3<f32>,
  projectionMode: i32,
  scale: f32,
  commonUnitsPerWorldUnit: vec3<f32>,
  commonUnitsPerWorldUnit2: vec3<f32>,
  center: vec4<f32>,
  modelMatrix: mat4x4<f32>,
  viewProjectionMatrix: mat4x4<f32>,
  viewportSize: vec2<f32>,
  devicePixelRatio: f32,
  focalDistance: f32,
  cameraPosition: vec3<f32>,
  coordinateOrigin: vec3<f32>,
  commonOrigin: vec3<f32>,
  pseudoMeters: i32,
};

@group(0) @binding(0)
var<uniform> project: ProjectUniforms;

// -----------------------------------------------------------------------------
// Geometry data
// (In your GLSL code, "geometry" was assumed to be available globally. In WGSL,
// you might supply this via vertex attributes or a uniform. Here we define a
// uniform struct for demonstration.)
// -----------------------------------------------------------------------------

// Structure to carry additional geometry data used by deck.gl filters.
struct Geometry {
  worldPosition: vec3<f32>,
  worldPositionAlt: vec3<f32>,
  position: vec4<f32>,
  uv: vec2<f32>,
  pickingColor: vec3<f32>,
};

// @group(0) @binding(1)
var<private> geometry: Geometry;
`;
const projectWGSL = /* wgsl */ `\
${projectWGSLHeader}

// -----------------------------------------------------------------------------
// Functions
// -----------------------------------------------------------------------------

// Returns an adjustment factor for commonUnitsPerMeter
fn _project_size_at_latitude(lat: f32) -> f32 {
  let y = clamp(lat, -89.9, 89.9);
  return 1.0 / cos(radians(y));
}

// Overloaded version: scales a value in meters at a given latitude.
fn _project_size_at_latitude_m(meters: f32, lat: f32) -> f32 {
  return meters * project.commonUnitsPerMeter.z * _project_size_at_latitude(lat);
}

// Computes a non-linear scale factor based on geometry.
// (Note: This function relies on "geometry" being provided.)
fn project_size() -> f32 {
  if (project.projectionMode == PROJECTION_MODE_WEB_MERCATOR &&
      project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT &&
      project.pseudoMeters == 0) {
    if (geometry.position.w == 0.0) {
      return _project_size_at_latitude(geometry.worldPosition.y);
    }
    let y: f32 = geometry.position.y / TILE_SIZE * 2.0 - 1.0;
    let y2 = y * y;
    let y4 = y2 * y2;
    let y6 = y4 * y2;
    return 1.0 + 4.9348 * y2 + 4.0587 * y4 + 1.5642 * y6;
  }
  return 1.0;
}

// Overloads to scale offsets (meters to world units)
fn project_size_float(meters: f32) -> f32 {
  return meters * project.commonUnitsPerMeter.z * project_size();
}

fn project_size_vec2(meters: vec2<f32>) -> vec2<f32> {
  return meters * project.commonUnitsPerMeter.xy * project_size();
}

fn project_size_vec3(meters: vec3<f32>) -> vec3<f32> {
  return meters * project.commonUnitsPerMeter * project_size();
}

fn project_size_vec4(meters: vec4<f32>) -> vec4<f32> {
  return vec4<f32>(meters.xyz * project.commonUnitsPerMeter, meters.w);
}

// Returns a rotation matrix aligning the z\u{2011}axis with the given up vector.
fn project_get_orientation_matrix(up: vec3<f32>) -> mat3x3<f32> {
  let uz = normalize(up);
  let ux = select(
    vec3<f32>(1.0, 0.0, 0.0),
    normalize(vec3<f32>(uz.y, -uz.x, 0.0)),
    abs(uz.z) == 1.0
  );
  let uy = cross(uz, ux);
  return mat3x3<f32>(ux, uy, uz);
}

// Since WGSL does not support "out" parameters, we return a struct.
struct RotationResult {
  needsRotation: bool,
  transform: mat3x3<f32>,
};

fn project_needs_rotation(commonPosition: vec3<f32>) -> RotationResult {
  if (project.projectionMode == PROJECTION_MODE_GLOBE) {
    return RotationResult(true, project_get_orientation_matrix(commonPosition));
  } else {
    return RotationResult(false, mat3x3<f32>());  // identity alternative if needed
  };
}

// Projects a normal vector from the current coordinate system to world space.
fn project_normal(vector: vec3<f32>) -> vec3<f32> {
  let normal_modelspace = project.modelMatrix * vec4<f32>(vector, 0.0);
  var n = normalize(normal_modelspace.xyz * project.commonUnitsPerMeter);
  let rotResult = project_needs_rotation(geometry.position.xyz);
  if (rotResult.needsRotation) {
    n = rotResult.transform * n;
  }
  return n;
}

// Applies a scale offset based on y-offset (dy)
fn project_offset_(offset: vec4<f32>) -> vec4<f32> {
  let dy: f32 = offset.y;
  let commonUnitsPerWorldUnit = project.commonUnitsPerWorldUnit + project.commonUnitsPerWorldUnit2 * dy;
  return vec4<f32>(offset.xyz * commonUnitsPerWorldUnit, offset.w);
}

// Projects lng/lat coordinates to a unit tile [0,1]
fn project_mercator_(lnglat: vec2<f32>) -> vec2<f32> {
  var x = lnglat.x;
  if (project.wrapLongitude != 0) {
    x = ((x + 180.0) % 360.0) - 180.0;
  }
  let y = clamp(lnglat.y, -89.9, 89.9);
  return vec2<f32>(
    radians(x) + PI,
    PI + log(tan(PI * 0.25 + radians(y) * 0.5))
  ) * WORLD_SCALE;
}

// Projects lng/lat/z coordinates for a globe projection.
fn project_globe_(lnglatz: vec3<f32>) -> vec3<f32> {
  let lambda = radians(lnglatz.x);
  let phi = radians(lnglatz.y);
  let cosPhi = cos(phi);
  let D = (lnglatz.z / EARTH_RADIUS + 1.0) * GLOBE_RADIUS;
  return vec3<f32>(
    sin(lambda) * cosPhi,
    -cos(lambda) * cosPhi,
    sin(phi)
  ) * D;
}

// Projects positions (with an optional 64-bit low part) from the input
// coordinate system to the common space.
fn project_position_vec4_f64(position: vec4<f32>, position64Low: vec3<f32>) -> vec4<f32> {
  var position_world = project.modelMatrix * position;

  // Work around for a Mac+NVIDIA bug:
  if (project.projectionMode == PROJECTION_MODE_WEB_MERCATOR) {
    if (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
      return vec4<f32>(
        project_mercator_(position_world.xy),
        _project_size_at_latitude_m(position_world.z, position_world.y),
        position_world.w
      );
    }
    if (project.coordinateSystem == COORDINATE_SYSTEM_CARTESIAN) {
      position_world = vec4f(position_world.xyz + project.coordinateOrigin, position_world.w);
    }
  }
  if (project.projectionMode == PROJECTION_MODE_GLOBE) {
    if (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
      return vec4<f32>(
        project_globe_(position_world.xyz),
        position_world.w
      );
    }
  }
  if (project.projectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET) {
    if (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
      if (abs(position_world.y - project.coordinateOrigin.y) > 0.25) {
        return vec4<f32>(
          project_mercator_(position_world.xy) - project.commonOrigin.xy,
          project_size_float(position_world.z),
          position_world.w
        );
      }
    }
  }
  if (project.projectionMode == PROJECTION_MODE_IDENTITY ||
      (project.projectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET &&
       (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT ||
        project.coordinateSystem == COORDINATE_SYSTEM_CARTESIAN))) {
    position_world = vec4f(position_world.xyz - project.coordinateOrigin, position_world.w);
  }

  return project_offset_(position_world) +
         project_offset_(project.modelMatrix * vec4<f32>(position64Low, 0.0));
}

// Overloaded versions for different input types.
fn project_position_vec4_f32(position: vec4<f32>) -> vec4<f32> {
  return project_position_vec4_f64(position, ZERO_64_LOW);
}

fn project_position_vec3_f64(position: vec3<f32>, position64Low: vec3<f32>) -> vec3<f32> {
  let projected_position = project_position_vec4_f64(vec4<f32>(position, 1.0), position64Low);
  return projected_position.xyz;
}

fn project_position_vec3_f32(position: vec3<f32>) -> vec3<f32> {
  let projected_position = project_position_vec4_f64(vec4<f32>(position, 1.0), ZERO_64_LOW);
  return projected_position.xyz;
}

fn project_position_vec2_f32(position: vec2<f32>) -> vec2<f32> {
  let projected_position = project_position_vec4_f64(vec4<f32>(position, 0.0, 1.0), ZERO_64_LOW);
  return projected_position.xy;
}

// Transforms a common space position to clip space.
fn project_common_position_to_clipspace_with_projection(position: vec4<f32>, viewProjectionMatrix: mat4x4<f32>, center: vec4<f32>) -> vec4<f32> {
  return viewProjectionMatrix * position + center;
}

// Uses the project viewProjectionMatrix and center.
fn project_common_position_to_clipspace(position: vec4<f32>) -> vec4<f32> {
  return project_common_position_to_clipspace_with_projection(position, project.viewProjectionMatrix, project.center);
}

// Returns a clip space offset corresponding to a given number of screen pixels.
fn project_pixel_size_to_clipspace(pixels: vec2<f32>) -> vec2<f32> {
  let offset = pixels / project.viewportSize * project.devicePixelRatio * 2.0;
  return offset * project.focalDistance;
}

fn project_meter_size_to_pixel(meters: f32) -> f32 {
  return project_size_float(meters) * project.scale;
}

fn project_unit_size_to_pixel(size: f32, unit: i32) -> f32 {
  if (unit == UNIT_METERS) {
    return project_meter_size_to_pixel(size);
  } else if (unit == UNIT_COMMON) {
    return size * project.scale;
  }
  // UNIT_PIXELS: no scaling applied.
  return size;
}

fn project_pixel_size_float(pixels: f32) -> f32 {
  return pixels / project.scale;
}

fn project_pixel_size_vec2(pixels: vec2<f32>) -> vec2<f32> {
  return pixels / project.scale;
}
`;

},{"../../lib/constants.js":"k6l9N","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"uX0Q0":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "projectGLSL", ()=>projectGLSL);
var _constantsJs = require("../../lib/constants.js");
// We are generating these from the js code in constants.js
const COORDINATE_SYSTEM_GLSL_CONSTANTS = Object.keys((0, _constantsJs.COORDINATE_SYSTEM)).map((key)=>`const int COORDINATE_SYSTEM_${key} = ${(0, _constantsJs.COORDINATE_SYSTEM)[key]};`).join('');
const PROJECTION_MODE_GLSL_CONSTANTS = Object.keys((0, _constantsJs.PROJECTION_MODE)).map((key)=>`const int PROJECTION_MODE_${key} = ${(0, _constantsJs.PROJECTION_MODE)[key]};`).join('');
const UNIT_GLSL_CONSTANTS = Object.keys((0, _constantsJs.UNIT)).map((key)=>`const int UNIT_${key.toUpperCase()} = ${(0, _constantsJs.UNIT)[key]};`).join('');
const projectGLSL = /* glsl */ `\
${COORDINATE_SYSTEM_GLSL_CONSTANTS}
${PROJECTION_MODE_GLSL_CONSTANTS}
${UNIT_GLSL_CONSTANTS}
uniform projectUniforms {
bool wrapLongitude;
int coordinateSystem;
vec3 commonUnitsPerMeter;
int projectionMode;
float scale;
vec3 commonUnitsPerWorldUnit;
vec3 commonUnitsPerWorldUnit2;
vec4 center;
mat4 modelMatrix;
mat4 viewProjectionMatrix;
vec2 viewportSize;
float devicePixelRatio;
float focalDistance;
vec3 cameraPosition;
vec3 coordinateOrigin;
vec3 commonOrigin;
bool pseudoMeters;
} project;
const float TILE_SIZE = 512.0;
const float PI = 3.1415926536;
const float WORLD_SCALE = TILE_SIZE / (PI * 2.0);
const vec3 ZERO_64_LOW = vec3(0.0);
const float EARTH_RADIUS = 6370972.0;
const float GLOBE_RADIUS = 256.0;
float project_size_at_latitude(float lat) {
float y = clamp(lat, -89.9, 89.9);
return 1.0 / cos(radians(y));
}
float project_size() {
if (project.projectionMode == PROJECTION_MODE_WEB_MERCATOR &&
project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT &&
project.pseudoMeters == false) {
if (geometry.position.w == 0.0) {
return project_size_at_latitude(geometry.worldPosition.y);
}
float y = geometry.position.y / TILE_SIZE * 2.0 - 1.0;
float y2 = y * y;
float y4 = y2 * y2;
float y6 = y4 * y2;
return 1.0 + 4.9348 * y2 + 4.0587 * y4 + 1.5642 * y6;
}
return 1.0;
}
float project_size_at_latitude(float meters, float lat) {
return meters * project.commonUnitsPerMeter.z * project_size_at_latitude(lat);
}
float project_size(float meters) {
return meters * project.commonUnitsPerMeter.z * project_size();
}
vec2 project_size(vec2 meters) {
return meters * project.commonUnitsPerMeter.xy * project_size();
}
vec3 project_size(vec3 meters) {
return meters * project.commonUnitsPerMeter * project_size();
}
vec4 project_size(vec4 meters) {
return vec4(meters.xyz * project.commonUnitsPerMeter, meters.w);
}
mat3 project_get_orientation_matrix(vec3 up) {
vec3 uz = normalize(up);
vec3 ux = abs(uz.z) == 1.0 ? vec3(1.0, 0.0, 0.0) : normalize(vec3(uz.y, -uz.x, 0));
vec3 uy = cross(uz, ux);
return mat3(ux, uy, uz);
}
bool project_needs_rotation(vec3 commonPosition, out mat3 transform) {
if (project.projectionMode == PROJECTION_MODE_GLOBE) {
transform = project_get_orientation_matrix(commonPosition);
return true;
}
return false;
}
vec3 project_normal(vec3 vector) {
vec4 normal_modelspace = project.modelMatrix * vec4(vector, 0.0);
vec3 n = normalize(normal_modelspace.xyz * project.commonUnitsPerMeter);
mat3 rotation;
if (project_needs_rotation(geometry.position.xyz, rotation)) {
n = rotation * n;
}
return n;
}
vec4 project_offset_(vec4 offset) {
float dy = offset.y;
vec3 commonUnitsPerWorldUnit = project.commonUnitsPerWorldUnit + project.commonUnitsPerWorldUnit2 * dy;
return vec4(offset.xyz * commonUnitsPerWorldUnit, offset.w);
}
vec2 project_mercator_(vec2 lnglat) {
float x = lnglat.x;
if (project.wrapLongitude) {
x = mod(x + 180., 360.0) - 180.;
}
float y = clamp(lnglat.y, -89.9, 89.9);
return vec2(
radians(x) + PI,
PI + log(tan_fp32(PI * 0.25 + radians(y) * 0.5))
) * WORLD_SCALE;
}
vec3 project_globe_(vec3 lnglatz) {
float lambda = radians(lnglatz.x);
float phi = radians(lnglatz.y);
float cosPhi = cos(phi);
float D = (lnglatz.z / EARTH_RADIUS + 1.0) * GLOBE_RADIUS;
return vec3(
sin(lambda) * cosPhi,
-cos(lambda) * cosPhi,
sin(phi)
) * D;
}
vec4 project_position(vec4 position, vec3 position64Low) {
vec4 position_world = project.modelMatrix * position;
if (project.projectionMode == PROJECTION_MODE_WEB_MERCATOR) {
if (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
return vec4(
project_mercator_(position_world.xy),
project_size_at_latitude(position_world.z, position_world.y),
position_world.w
);
}
if (project.coordinateSystem == COORDINATE_SYSTEM_CARTESIAN) {
position_world.xyz += project.coordinateOrigin;
}
}
if (project.projectionMode == PROJECTION_MODE_GLOBE) {
if (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
return vec4(
project_globe_(position_world.xyz),
position_world.w
);
}
}
if (project.projectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET) {
if (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
if (abs(position_world.y - project.coordinateOrigin.y) > 0.25) {
return vec4(
project_mercator_(position_world.xy) - project.commonOrigin.xy,
project_size(position_world.z),
position_world.w
);
}
}
}
if (project.projectionMode == PROJECTION_MODE_IDENTITY ||
(project.projectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET &&
(project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT ||
project.coordinateSystem == COORDINATE_SYSTEM_CARTESIAN))) {
position_world.xyz -= project.coordinateOrigin;
}
return project_offset_(position_world) + project_offset_(project.modelMatrix * vec4(position64Low, 0.0));
}
vec4 project_position(vec4 position) {
return project_position(position, ZERO_64_LOW);
}
vec3 project_position(vec3 position, vec3 position64Low) {
vec4 projected_position = project_position(vec4(position, 1.0), position64Low);
return projected_position.xyz;
}
vec3 project_position(vec3 position) {
vec4 projected_position = project_position(vec4(position, 1.0), ZERO_64_LOW);
return projected_position.xyz;
}
vec2 project_position(vec2 position) {
vec4 projected_position = project_position(vec4(position, 0.0, 1.0), ZERO_64_LOW);
return projected_position.xy;
}
vec4 project_common_position_to_clipspace(vec4 position, mat4 viewProjectionMatrix, vec4 center) {
return viewProjectionMatrix * position + center;
}
vec4 project_common_position_to_clipspace(vec4 position) {
return project_common_position_to_clipspace(position, project.viewProjectionMatrix, project.center);
}
vec2 project_pixel_size_to_clipspace(vec2 pixels) {
vec2 offset = pixels / project.viewportSize * project.devicePixelRatio * 2.0;
return offset * project.focalDistance;
}
float project_size_to_pixel(float meters) {
return project_size(meters) * project.scale;
}
float project_size_to_pixel(float size, int unit) {
if (unit == UNIT_METERS) return project_size_to_pixel(size);
if (unit == UNIT_COMMON) return size * project.scale;
return size;
}
float project_pixel_size(float pixels) {
return pixels / project.scale;
}
vec2 project_pixel_size(vec2 pixels) {
return pixels / project.scale;
}
`;

},{"../../lib/constants.js":"k6l9N","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gO5dh":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _projectJs = require("../project/project.js");
var _projectJsDefault = parcelHelpers.interopDefault(_projectJs);
const source = /* wgsl */ `\
// Define a structure to hold both the clip-space position and the common position.
struct ProjectResult {
  clipPosition: vec4<f32>,
  commonPosition: vec4<f32>,
};

// This function mimics the GLSL version with the 'out' parameter by returning both values.
fn project_position_to_clipspace_and_commonspace(
    position: vec3<f32>,
    position64Low: vec3<f32>,
    offset: vec3<f32>
) -> ProjectResult {
  // Compute the projected position.
  let projectedPosition: vec3<f32> = project_position_vec3_f64(position, position64Low);

  // Start with the provided offset.
  var finalOffset: vec3<f32> = offset;

  // Get whether a rotation is needed and the rotation matrix.
  let rotationResult = project_needs_rotation(projectedPosition);

  // If rotation is needed, update the offset.
  if (rotationResult.needsRotation) {
    finalOffset = rotationResult.transform * offset;
  }

  // Compute the common position.
  let commonPosition: vec4<f32> = vec4<f32>(projectedPosition + finalOffset, 1.0);

  // Convert to clip-space.
  let clipPosition: vec4<f32> = project_common_position_to_clipspace(commonPosition);

  return ProjectResult(clipPosition, commonPosition);
}

// A convenience overload that returns only the clip-space position.
fn project_position_to_clipspace(
    position: vec3<f32>,
    position64Low: vec3<f32>,
    offset: vec3<f32>
) -> vec4<f32> {
  return project_position_to_clipspace_and_commonspace(position, position64Low, offset).clipPosition;
}
`;
const vs = /* glsl */ `\
vec4 project_position_to_clipspace(
  vec3 position, vec3 position64Low, vec3 offset, out vec4 commonPosition
) {
  vec3 projectedPosition = project_position(position, position64Low);
  mat3 rotation;
  if (project_needs_rotation(projectedPosition, rotation)) {
    // offset is specified as ENU
    // when in globe projection, rotate offset so that the ground alighs with the surface of the globe
    offset = rotation * offset;
  }
  commonPosition = vec4(projectedPosition + offset, 1.0);
  return project_common_position_to_clipspace(commonPosition);
}

vec4 project_position_to_clipspace(
  vec3 position, vec3 position64Low, vec3 offset
) {
  vec4 commonPosition;
  return project_position_to_clipspace(position, position64Low, offset, commonPosition);
}
`;
exports.default = {
    name: 'project32',
    dependencies: [
        (0, _projectJsDefault.default)
    ],
    source,
    vs
};

},{"../project/project.js":"iq4ky","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dLi7u":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantsJs = require("../../lib/constants.js");
var _projectJs = require("../project/project.js");
var _projectJsDefault = parcelHelpers.interopDefault(_projectJs);
var _core = require("@math.gl/core");
var _memoizeJs = require("../../utils/memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
var _webMercator = require("@math.gl/web-mercator");
const uniformBlock = /* glsl */ `
uniform shadowUniforms {
  bool drawShadowMap;
  bool useShadowMap;
  vec4 color;
  highp int lightId;
  float lightCount;
  mat4 viewProjectionMatrix0;
  mat4 viewProjectionMatrix1;
  vec4 projectCenter0;
  vec4 projectCenter1;
} shadow;
`;
const vertex = /* glsl */ `
const int max_lights = 2;

out vec3 shadow_vPosition[max_lights];

vec4 shadow_setVertexPosition(vec4 position_commonspace) {
  mat4 viewProjectionMatrices[max_lights];
  viewProjectionMatrices[0] = shadow.viewProjectionMatrix0;
  viewProjectionMatrices[1] = shadow.viewProjectionMatrix1;
  vec4 projectCenters[max_lights];
  projectCenters[0] = shadow.projectCenter0;
  projectCenters[1] = shadow.projectCenter1;

  if (shadow.drawShadowMap) {
    return project_common_position_to_clipspace(position_commonspace, viewProjectionMatrices[shadow.lightId], projectCenters[shadow.lightId]);
  }
  if (shadow.useShadowMap) {
    for (int i = 0; i < max_lights; i++) {
      if(i < int(shadow.lightCount)) {
        vec4 shadowMap_position = project_common_position_to_clipspace(position_commonspace, viewProjectionMatrices[i], projectCenters[i]);
        shadow_vPosition[i] = (shadowMap_position.xyz / shadowMap_position.w + 1.0) / 2.0;
      }
    }
  }
  return gl_Position;
}
`;
const vs = `
${uniformBlock}
${vertex}
`;
const fragment = /* glsl */ `
const int max_lights = 2;
uniform sampler2D shadow_uShadowMap0;
uniform sampler2D shadow_uShadowMap1;

in vec3 shadow_vPosition[max_lights];

const vec4 bitPackShift = vec4(1.0, 255.0, 65025.0, 16581375.0);
const vec4 bitUnpackShift = 1.0 / bitPackShift;
const vec4 bitMask = vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0,  0.0);

float shadow_getShadowWeight(vec3 position, sampler2D shadowMap) {
  vec4 rgbaDepth = texture(shadowMap, position.xy);

  float z = dot(rgbaDepth, bitUnpackShift);
  return smoothstep(0.001, 0.01, position.z - z);
}

vec4 shadow_filterShadowColor(vec4 color) {
  if (shadow.drawShadowMap) {
    vec4 rgbaDepth = fract(gl_FragCoord.z * bitPackShift);
    rgbaDepth -= rgbaDepth.gbaa * bitMask;
    return rgbaDepth;
  }
  if (shadow.useShadowMap) {
    float shadowAlpha = 0.0;
    shadowAlpha += shadow_getShadowWeight(shadow_vPosition[0], shadow_uShadowMap0);
    if(shadow.lightCount > 1.0) {
      shadowAlpha += shadow_getShadowWeight(shadow_vPosition[1], shadow_uShadowMap1);
    }
    shadowAlpha *= shadow.color.a / shadow.lightCount;
    float blendedAlpha = shadowAlpha + color.a * (1.0 - shadowAlpha);

    return vec4(
      mix(color.rgb, shadow.color.rgb, shadowAlpha / blendedAlpha),
      blendedAlpha
    );
  }
  return color;
}
`;
const fs = `
${uniformBlock}
${fragment}
`;
const getMemoizedViewportCenterPosition = (0, _memoizeJsDefault.default)(getViewportCenterPosition);
const getMemoizedViewProjectionMatrices = (0, _memoizeJsDefault.default)(getViewProjectionMatrices);
const DEFAULT_SHADOW_COLOR = [
    0,
    0,
    0,
    1.0
];
const VECTOR_TO_POINT_MATRIX = [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0
];
function screenToCommonSpace(xyz, pixelUnprojectionMatrix) {
    const [x, y, z] = xyz;
    const coord = (0, _webMercator.pixelsToWorld)([
        x,
        y,
        z
    ], pixelUnprojectionMatrix);
    if (Number.isFinite(z)) return coord;
    return [
        coord[0],
        coord[1],
        0
    ];
}
function getViewportCenterPosition({ viewport, center }) {
    return new (0, _core.Matrix4)(viewport.viewProjectionMatrix).invert().transform(center);
}
function getViewProjectionMatrices({ viewport, shadowMatrices }) {
    const projectionMatrices = [];
    const pixelUnprojectionMatrix = viewport.pixelUnprojectionMatrix;
    const farZ = viewport.isGeospatial ? undefined : 1;
    const corners = [
        [
            0,
            0,
            farZ
        ],
        [
            viewport.width,
            0,
            farZ
        ],
        [
            0,
            viewport.height,
            farZ
        ],
        [
            viewport.width,
            viewport.height,
            farZ
        ],
        [
            0,
            0,
            -1
        ],
        [
            viewport.width,
            0,
            -1
        ],
        [
            0,
            viewport.height,
            -1
        ],
        [
            viewport.width,
            viewport.height,
            -1
        ] // bottom right near
    ].map((pixel)=>// @ts-expect-error z may be undefined
        screenToCommonSpace(pixel, pixelUnprojectionMatrix));
    for (const shadowMatrix of shadowMatrices){
        const viewMatrix = shadowMatrix.clone().translate(new (0, _core.Vector3)(viewport.center).negate());
        const positions = corners.map((corner)=>viewMatrix.transform(corner));
        const projectionMatrix = new (0, _core.Matrix4)().ortho({
            left: Math.min(...positions.map((position)=>position[0])),
            right: Math.max(...positions.map((position)=>position[0])),
            bottom: Math.min(...positions.map((position)=>position[1])),
            top: Math.max(...positions.map((position)=>position[1])),
            near: Math.min(...positions.map((position)=>-position[2])),
            far: Math.max(...positions.map((position)=>-position[2]))
        });
        projectionMatrices.push(projectionMatrix.multiplyRight(shadowMatrix));
    }
    return projectionMatrices;
}
/* eslint-disable camelcase */ // eslint-disable-next-line complexity
function createShadowUniforms(opts) {
    const { shadowEnabled = true, project: projectProps } = opts;
    if (!shadowEnabled || !projectProps || !opts.shadowMatrices || !opts.shadowMatrices.length) return {
        drawShadowMap: false,
        useShadowMap: false,
        shadow_uShadowMap0: opts.dummyShadowMap,
        shadow_uShadowMap1: opts.dummyShadowMap
    };
    const projectUniforms = (0, _projectJsDefault.default).getUniforms(projectProps);
    const center = getMemoizedViewportCenterPosition({
        viewport: projectProps.viewport,
        center: projectUniforms.center
    });
    const projectCenters = [];
    const viewProjectionMatrices = getMemoizedViewProjectionMatrices({
        shadowMatrices: opts.shadowMatrices,
        viewport: projectProps.viewport
    }).slice();
    for(let i = 0; i < opts.shadowMatrices.length; i++){
        const viewProjectionMatrix = viewProjectionMatrices[i];
        const viewProjectionMatrixCentered = viewProjectionMatrix.clone().translate(new (0, _core.Vector3)(projectProps.viewport.center).negate());
        if (projectUniforms.coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT && projectUniforms.projectionMode === (0, _constantsJs.PROJECTION_MODE).WEB_MERCATOR) {
            viewProjectionMatrices[i] = viewProjectionMatrixCentered;
            projectCenters[i] = center;
        } else {
            viewProjectionMatrices[i] = viewProjectionMatrix.clone().multiplyRight(VECTOR_TO_POINT_MATRIX);
            projectCenters[i] = viewProjectionMatrixCentered.transform(center);
        }
    }
    const uniforms = {
        drawShadowMap: Boolean(opts.drawToShadowMap),
        useShadowMap: opts.shadowMaps ? opts.shadowMaps.length > 0 : false,
        color: opts.shadowColor || DEFAULT_SHADOW_COLOR,
        lightId: opts.shadowLightId || 0,
        lightCount: opts.shadowMatrices.length,
        shadow_uShadowMap0: opts.dummyShadowMap,
        shadow_uShadowMap1: opts.dummyShadowMap
    };
    for(let i = 0; i < viewProjectionMatrices.length; i++){
        uniforms[`viewProjectionMatrix${i}`] = viewProjectionMatrices[i];
        uniforms[`projectCenter${i}`] = projectCenters[i];
    }
    for(let i = 0; i < 2; i++)uniforms[`shadow_uShadowMap${i}`] = opts.shadowMaps && opts.shadowMaps[i] || opts.dummyShadowMap;
    return uniforms;
}
exports.default = {
    name: 'shadow',
    dependencies: [
        (0, _projectJsDefault.default)
    ],
    vs,
    fs,
    inject: {
        'vs:DECKGL_FILTER_GL_POSITION': `
    position = shadow_setVertexPosition(geometry.position);
    `,
        'fs:DECKGL_FILTER_COLOR': `
    color = shadow_filterShadowColor(color);
    `
    },
    getUniforms: createShadowUniforms,
    uniformTypes: {
        drawShadowMap: 'f32',
        useShadowMap: 'f32',
        color: 'vec4<f32>',
        lightId: 'i32',
        lightCount: 'f32',
        viewProjectionMatrix0: 'mat4x4<f32>',
        viewProjectionMatrix1: 'mat4x4<f32>',
        projectCenter0: 'vec4<f32>',
        projectCenter1: 'vec4<f32>'
    }
};

},{"../../lib/constants.js":"k6l9N","../project/project.js":"iq4ky","@math.gl/core":"6z0Tv","../../utils/memoize.js":"4XQCO","@math.gl/web-mercator":"3nSdG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3nSdG":[function(require,module,exports,__globalThis) {
// Classic web-mercator-project
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebMercatorViewport", ()=>(0, _webMercatorViewportJs.WebMercatorViewport));
parcelHelpers.export(exports, "getBounds", ()=>(0, _getBoundsJs.getBounds));
parcelHelpers.export(exports, "fitBounds", ()=>(0, _fitBoundsJs.fitBounds));
parcelHelpers.export(exports, "normalizeViewportProps", ()=>(0, _normalizeViewportPropsJs.normalizeViewportProps));
parcelHelpers.export(exports, "flyToViewport", ()=>(0, _flyToViewportJs.flyToViewport));
parcelHelpers.export(exports, "getFlyToDuration", ()=>(0, _flyToViewportJs.getFlyToDuration));
parcelHelpers.export(exports, "MAX_LATITUDE", ()=>(0, _webMercatorUtilsJs.MAX_LATITUDE));
parcelHelpers.export(exports, "lngLatToWorld", ()=>(0, _webMercatorUtilsJs.lngLatToWorld));
parcelHelpers.export(exports, "worldToLngLat", ()=>(0, _webMercatorUtilsJs.worldToLngLat));
parcelHelpers.export(exports, "worldToPixels", ()=>(0, _webMercatorUtilsJs.worldToPixels));
parcelHelpers.export(exports, "pixelsToWorld", ()=>(0, _webMercatorUtilsJs.pixelsToWorld));
parcelHelpers.export(exports, "zoomToScale", ()=>(0, _webMercatorUtilsJs.zoomToScale));
parcelHelpers.export(exports, "scaleToZoom", ()=>(0, _webMercatorUtilsJs.scaleToZoom));
parcelHelpers.export(exports, "altitudeToFovy", ()=>(0, _webMercatorUtilsJs.altitudeToFovy));
parcelHelpers.export(exports, "fovyToAltitude", ()=>(0, _webMercatorUtilsJs.fovyToAltitude));
parcelHelpers.export(exports, "getMeterZoom", ()=>(0, _webMercatorUtilsJs.getMeterZoom));
parcelHelpers.export(exports, "unitsPerMeter", ()=>(0, _webMercatorUtilsJs.unitsPerMeter));
parcelHelpers.export(exports, "getDistanceScales", ()=>(0, _webMercatorUtilsJs.getDistanceScales));
parcelHelpers.export(exports, "addMetersToLngLat", ()=>(0, _webMercatorUtilsJs.addMetersToLngLat));
parcelHelpers.export(exports, "getViewMatrix", ()=>(0, _webMercatorUtilsJs.getViewMatrix));
parcelHelpers.export(exports, "getProjectionMatrix", ()=>(0, _webMercatorUtilsJs.getProjectionMatrix));
parcelHelpers.export(exports, "getProjectionParameters", ()=>(0, _webMercatorUtilsJs.getProjectionParameters));
/** @deprecated default export */ parcelHelpers.export(exports, "default", ()=>(0, _webMercatorViewportJs.WebMercatorViewport));
var _webMercatorViewportJs = require("./web-mercator-viewport.js");
var _getBoundsJs = require("./get-bounds.js");
var _fitBoundsJs = require("./fit-bounds.js");
var _normalizeViewportPropsJs = require("./normalize-viewport-props.js");
var _flyToViewportJs = require("./fly-to-viewport.js");
var _webMercatorUtilsJs = require("./web-mercator-utils.js");

},{"./web-mercator-viewport.js":"7bPeW","./get-bounds.js":"kylBM","./fit-bounds.js":"lKvUZ","./normalize-viewport-props.js":"fkxg6","./fly-to-viewport.js":"9FaED","./web-mercator-utils.js":"jfx5Q","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7bPeW":[function(require,module,exports,__globalThis) {
// View and Projection Matrix calculations for mapbox-js style map view properties
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The WebMercatorViewport class creates
 * - view/projection matrices
 * - "uniform values" (for shaders) from mercator params
 *
 * Note: Instances are immutable in the sense that they only have accessors.
 * A new viewport instance should be created if any parameters have changed.
 */ parcelHelpers.export(exports, "WebMercatorViewport", ()=>WebMercatorViewport);
var _mathUtilsJs = require("./math-utils.js");
var _webMercatorUtilsJs = require("./web-mercator-utils.js");
var _fitBoundsJs = require("./fit-bounds.js");
var _getBoundsJs = require("./get-bounds.js");
var _core = require("@math.gl/core");
class WebMercatorViewport {
    /**
     * @classdesc
     * Creates view/projection matrices from mercator params
     * Note: The Viewport is immutable in the sense that it only has accessors.
     * A new viewport instance should be created if any parameters have changed.
     */ // eslint-disable-next-line max-statements
    constructor(props = {
        width: 1,
        height: 1
    }){
        /** Two viewports are equal if width and height are identical, and if
         * their view and projection matrices are (approximately) equal.
         */ this.equals = (viewport)=>{
            if (!(viewport instanceof WebMercatorViewport)) return false;
            return viewport.width === this.width && viewport.height === this.height && (0, _core.mat4).equals(viewport.projectionMatrix, this.projectionMatrix) && (0, _core.mat4).equals(viewport.viewMatrix, this.viewMatrix);
        };
        /**
         * Projects xyz (possibly latitude and longitude) to pixel coordinates in window
         * using viewport projection parameters
         * - [longitude, latitude] to [x, y]
         * - [longitude, latitude, Z] => [x, y, z]
         * Note: By default, returns top-left coordinates for canvas/SVG type render
         *
         * @param lngLatZ - [lng, lat] or [lng, lat, Z]
         * @param options - options
         * @param options.topLeft=true - Whether projected coords are top left
         * @return - screen coordinates [x, y] or [x, y, z], z as pixel depth
         */ this.project = (lngLatZ, options = {})=>{
            const { topLeft = true } = options;
            const worldPosition = this.projectPosition(lngLatZ);
            const coord = (0, _webMercatorUtilsJs.worldToPixels)(worldPosition, this.pixelProjectionMatrix);
            const [x, y] = coord;
            const y2 = topLeft ? y : this.height - y;
            return lngLatZ.length === 2 ? [
                x,
                y2
            ] : [
                x,
                y2,
                coord[2]
            ];
        };
        /**
         * Unproject pixel coordinates on screen onto world coordinates, possibly `[lon, lat]` on map.
         *
         * - [x, y] => [lng, lat]
         * - [x, y, z] => [lng, lat, Z]
         *
         * @param xyz - screen coordinates, z as pixel depth
         * @param options - options
         * @param options.topLeft=true - Whether projected coords are top left
         * @param options.targetZ=0 - If pixel depth is unknown, targetZ is used as
         *   the elevation plane to unproject onto
         * @return - [lng, lat, Z] or [X, Y, Z]
         */ this.unproject = (xyz, options = {})=>{
            const { topLeft = true, targetZ } = options;
            const [x, y, z] = xyz;
            const y2 = topLeft ? y : this.height - y;
            const targetZWorld = targetZ && targetZ * this.distanceScales.unitsPerMeter[2];
            const coord = (0, _webMercatorUtilsJs.pixelsToWorld)([
                x,
                y2,
                z
            ], this.pixelUnprojectionMatrix, targetZWorld);
            const [X, Y, Z] = this.unprojectPosition(coord);
            if (Number.isFinite(z)) return [
                X,
                Y,
                Z
            ];
            return Number.isFinite(targetZ) ? [
                X,
                Y,
                targetZ
            ] : [
                X,
                Y
            ];
        };
        // NON_LINEAR PROJECTION HOOKS
        // Used for web meractor projection
        this.projectPosition = (xyz)=>{
            const [X, Y] = (0, _webMercatorUtilsJs.lngLatToWorld)(xyz);
            const Z = (xyz[2] || 0) * this.distanceScales.unitsPerMeter[2];
            return [
                X,
                Y,
                Z
            ];
        };
        this.unprojectPosition = (xyz)=>{
            const [X, Y] = (0, _webMercatorUtilsJs.worldToLngLat)(xyz);
            const Z = (xyz[2] || 0) * this.distanceScales.metersPerUnit[2];
            return [
                X,
                Y,
                Z
            ];
        };
        let { // Map state
        width, height, altitude = null, fovy = null } = props;
        const { latitude = 0, longitude = 0, zoom = 0, pitch = 0, bearing = 0, position = null, nearZMultiplier = 0.02, farZMultiplier = 1.01 } = props;
        // Silently allow apps to send in 0,0 to facilitate isomorphic render etc
        width = width || 1;
        height = height || 1;
        // `fovy` & `altitude` are independent parameters, one for the
        // projection and the latter for the view matrix. In the past,
        // the `fovy` was always derived from the `altitude`
        if (fovy === null && altitude === null) {
            altitude = (0, _webMercatorUtilsJs.DEFAULT_ALTITUDE);
            fovy = (0, _webMercatorUtilsJs.altitudeToFovy)(altitude);
        } else if (fovy === null) fovy = (0, _webMercatorUtilsJs.altitudeToFovy)(altitude);
        else if (altitude === null) altitude = (0, _webMercatorUtilsJs.fovyToAltitude)(fovy);
        const scale = (0, _webMercatorUtilsJs.zoomToScale)(zoom);
        // Altitude - prevent division by 0
        // TODO - just throw an Error instead?
        altitude = Math.max(0.75, altitude);
        const distanceScales = (0, _webMercatorUtilsJs.getDistanceScales)({
            longitude,
            latitude
        });
        const center = (0, _webMercatorUtilsJs.lngLatToWorld)([
            longitude,
            latitude
        ]);
        center.push(0);
        if (position) (0, _core.vec3).add(center, center, (0, _core.vec3).mul([], position, distanceScales.unitsPerMeter));
        this.projectionMatrix = (0, _webMercatorUtilsJs.getProjectionMatrix)({
            width,
            height,
            scale,
            center,
            pitch,
            fovy,
            nearZMultiplier,
            farZMultiplier
        });
        this.viewMatrix = (0, _webMercatorUtilsJs.getViewMatrix)({
            height,
            scale,
            center,
            pitch,
            bearing,
            altitude
        });
        // Save parameters
        this.width = width;
        this.height = height;
        this.scale = scale;
        this.latitude = latitude;
        this.longitude = longitude;
        this.zoom = zoom;
        this.pitch = pitch;
        this.bearing = bearing;
        this.altitude = altitude;
        this.fovy = fovy;
        this.center = center;
        this.meterOffset = position || [
            0,
            0,
            0
        ];
        this.distanceScales = distanceScales;
        this._initMatrices();
        Object.freeze(this);
    }
    _initMatrices() {
        const { width, height, projectionMatrix, viewMatrix } = this;
        // Note: As usual, matrix operations should be applied in "reverse" order
        // since vectors will be multiplied in from the right during transformation
        const vpm = (0, _mathUtilsJs.createMat4)();
        (0, _core.mat4).multiply(vpm, vpm, projectionMatrix);
        (0, _core.mat4).multiply(vpm, vpm, viewMatrix);
        this.viewProjectionMatrix = vpm;
        // Calculate matrices and scales needed for projection
        /**
         * Builds matrices that converts preprojected lngLats to screen pixels
         * and vice versa.
         * Note: Currently returns bottom-left coordinates!
         * Note: Starts with the GL projection matrix and adds steps to the
         *       scale and translate that matrix onto the window.
         * Note: WebGL controls clip space to screen projection with gl.viewport
         *       and does not need this step.
         */ const m = (0, _mathUtilsJs.createMat4)();
        // matrix for conversion from location to screen coordinates
        (0, _core.mat4).scale(m, m, [
            width / 2,
            -height / 2,
            1
        ]);
        (0, _core.mat4).translate(m, m, [
            1,
            -1,
            0
        ]);
        (0, _core.mat4).multiply(m, m, vpm);
        const mInverse = (0, _core.mat4).invert((0, _mathUtilsJs.createMat4)(), m);
        if (!mInverse) throw new Error('Pixel project matrix not invertible');
        this.pixelProjectionMatrix = m;
        this.pixelUnprojectionMatrix = mInverse;
    }
    /**
     * Project [lng,lat] on sphere onto [x,y] on 512*512 Mercator Zoom 0 tile.
     * Performs the nonlinear part of the web mercator projection.
     * Remaining projection is done with 4x4 matrices which also handles
     * perspective.
     *
     * @param lngLat - [lng, lat] coordinates
     *   Specifies a point on the sphere to project onto the map.
     * @return [x,y] coordinates.
     */ projectFlat(lngLat) {
        return (0, _webMercatorUtilsJs.lngLatToWorld)(lngLat);
    }
    /**
     * Unproject world point [x,y] on map onto {lat, lon} on sphere
     *
     * @param xy - array with [x,y] members
     *  representing point on projected map plane
     * @return - array with [lat,lon] of point on sphere.
     *   Has toArray method if you need a GeoJSON Array.
     *   Per cartographic tradition, lat and lon are specified as degrees.
     */ unprojectFlat(xy) {
        return (0, _webMercatorUtilsJs.worldToLngLat)(xy);
    }
    /**
     * Get the map center that place a given [lng, lat] coordinate at screen point [x, y]
     * @param opt
     * @param opt.lngLat - [lng,lat] coordinates
     *   Specifies a point on the sphere.
     * @param opt.pos - [x,y] coordinates
     *   Specifies a point on the screen.
     * @return [lng,lat] new map center.
     */ getMapCenterByLngLatPosition({ lngLat, pos }) {
        const fromLocation = (0, _webMercatorUtilsJs.pixelsToWorld)(pos, this.pixelUnprojectionMatrix);
        const toLocation = (0, _webMercatorUtilsJs.lngLatToWorld)(lngLat);
        const translate = (0, _core.vec2).add([], toLocation, (0, _core.vec2).negate([], fromLocation));
        const newCenter = (0, _core.vec2).add([], this.center, translate);
        return (0, _webMercatorUtilsJs.worldToLngLat)(newCenter);
    }
    /**
     * Returns a new viewport that fit around the given rectangle.
     * Only supports non-perspective mode.
     * @param bounds - [[lon, lat], [lon, lat]]
     * @param [options]
     * @param [options.padding] - The amount of padding in pixels to add to the given bounds.
     * @param [options.offset] - The center of the given bounds relative to the map's center,
     *    [x, y] measured in pixels.
     * @returns {WebMercatorViewport}
     */ fitBounds(bounds, options = {}) {
        const { width, height } = this;
        const { longitude, latitude, zoom } = (0, _fitBoundsJs.fitBounds)(Object.assign({
            width,
            height,
            bounds
        }, options));
        return new WebMercatorViewport({
            width,
            height,
            longitude,
            latitude,
            zoom
        });
    }
    /**
     * Returns the bounding box of the viewport.
     * @param [options]
     * @param [options.z] - The altitude at which the bounds should be calculated.
     * @returns {Array} bounds - [[lon, lat], [lon, lat]]
     */ getBounds(options) {
        const corners = this.getBoundingRegion(options);
        const west = Math.min(...corners.map((p)=>p[0]));
        const east = Math.max(...corners.map((p)=>p[0]));
        const south = Math.min(...corners.map((p)=>p[1]));
        const north = Math.max(...corners.map((p)=>p[1]));
        return [
            [
                west,
                south
            ],
            [
                east,
                north
            ]
        ];
    }
    /**
     * Returns the bounding box of the viewport.
     * @param [options]
     * @param [options.z] - The altitude at which the bounds should be calculated.
     * @returns {Array} an array of 4 points that define the visible region
     */ getBoundingRegion(options = {}) {
        return (0, _getBoundsJs.getBounds)(this, options.z || 0);
    }
    // DEPRECATED
    /** @deprecated Legacy method name */ getLocationAtPoint({ lngLat, pos }) {
        return this.getMapCenterByLngLatPosition({
            lngLat,
            pos
        });
    }
}

},{"./math-utils.js":"kayvU","./web-mercator-utils.js":"jfx5Q","./fit-bounds.js":"lKvUZ","./get-bounds.js":"kylBM","@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kayvU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Helper, avoids low-precision 32 bit matrices from gl-matrix mat4.create()
parcelHelpers.export(exports, "createMat4", ()=>createMat4);
// Transforms a vec4 with a projection matrix
parcelHelpers.export(exports, "transformVector", ()=>transformVector);
parcelHelpers.export(exports, "mod", ()=>mod);
parcelHelpers.export(exports, "lerp", ()=>lerp);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "log2", ()=>log2);
var _core = require("@math.gl/core");
function createMat4() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function transformVector(matrix, vector) {
    const result = (0, _core.vec4).transformMat4([], vector, matrix);
    (0, _core.vec4).scale(result, result, 1 / result[3]);
    return result;
}
function mod(value, divisor) {
    const modulus = value % divisor;
    return modulus < 0 ? divisor + modulus : modulus;
}
function lerp(start, end, step) {
    return step * end + (1 - step) * start;
}
function clamp(x, min, max) {
    return x < min ? min : x > max ? max : x;
}
function ieLog2(x) {
    return Math.log(x) * Math.LOG2E;
}
const log2 = Math.log2 || ieLog2;

},{"@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jfx5Q":[function(require,module,exports,__globalThis) {
// TODO - THE UTILITIES IN THIS FILE SHOULD BE IMPORTED FROM WEB-MERCATOR-VIEWPORT MODULE
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_LATITUDE", ()=>MAX_LATITUDE);
parcelHelpers.export(exports, "DEFAULT_ALTITUDE", ()=>DEFAULT_ALTITUDE);
/** Logarithimic zoom to linear scale **/ parcelHelpers.export(exports, "zoomToScale", ()=>zoomToScale);
/** Linear scale to logarithimic zoom **/ parcelHelpers.export(exports, "scaleToZoom", ()=>scaleToZoom);
/**
 * Project [lng,lat] on sphere onto [x,y] on 512*512 Mercator Zoom 0 tile.
 * Performs the nonlinear part of the web mercator projection.
 * Remaining projection is done with 4x4 matrices which also handles
 * perspective.
 *
 * @param lngLat - [lng, lat] coordinates
 *   Specifies a point on the sphere to project onto the map.
 * @return [x,y] coordinates.
 */ parcelHelpers.export(exports, "lngLatToWorld", ()=>lngLatToWorld);
/**
 * Unproject world point [x,y] on map onto {lat, lon} on sphere
 *
 * @param xy - array with [x,y] members
 *  representing point on projected map plane
 * @return - array with [x,y] of point on sphere.
 *   Has toArray method if you need a GeoJSON Array.
 *   Per cartographic tradition, lat and lon are specified as degrees.
 */ parcelHelpers.export(exports, "worldToLngLat", ()=>worldToLngLat);
/**
 * Returns the zoom level that gives a 1 meter pixel at a certain latitude
 * 1 = C*cos(y)/2^z/TILE_SIZE = C*cos(y)/2^(z+9)
 */ parcelHelpers.export(exports, "getMeterZoom", ()=>getMeterZoom);
/**
 * Calculate the conversion from meter to common units at a given latitude
 * This is a cheaper version of `getDistanceScales`
 * @param latitude center latitude in degrees
 * @returns common units per meter
 */ parcelHelpers.export(exports, "unitsPerMeter", ()=>unitsPerMeter);
/**
 * Calculate distance scales in meters around current lat/lon, both for
 * degrees and pixels.
 * In mercator projection mode, the distance scales vary significantly
 * with latitude.
 */ parcelHelpers.export(exports, "getDistanceScales", ()=>getDistanceScales);
/**
 * Offset a lng/lat position by meterOffset (northing, easting)
 */ parcelHelpers.export(exports, "addMetersToLngLat", ()=>addMetersToLngLat);
/**
 *
 * view and projection matrix creation is intentionally kept compatible with
 * mapbox-gl's implementation to ensure that seamless interoperation
 * with mapbox and react-map-gl. See: https://github.com/mapbox/mapbox-gl-js
 */ parcelHelpers.export(exports, "getViewMatrix", ()=>getViewMatrix);
/**
 * Calculates mapbox compatible projection matrix from parameters
 *
 * @param options.width Width of "viewport" or window
 * @param options.height Height of "viewport" or window
 * @param options.scale Scale at the current zoom
 * @param options.center Offset of the target, vec3 in world space
 * @param options.offset Offset of the focal point, vec2 in screen space
 * @param options.pitch Camera angle in degrees (0 is straight down)
 * @param options.fovy field of view in degrees
 * @param options.altitude if provided, field of view is calculated using `altitudeToFovy()`
 * @param options.nearZMultiplier control z buffer
 * @param options.farZMultiplier control z buffer
 * @returns project parameters object
 */ parcelHelpers.export(exports, "getProjectionParameters", ()=>getProjectionParameters);
/**
 * CALCULATE PROJECTION MATRIX: PROJECTS FROM CAMERA (VIEW) SPACE TO CLIPSPACE
 *
 * To match mapbox's z buffer:
 *  - \<= 0.28: nearZMultiplier: 0.1, farZmultiplier: 1
 *  - \>= 0.29: nearZMultiplier: 1 / height, farZMultiplier: 1.01
 *
 * @param options Viewport options
 * @param options.width Width of "viewport" or window
 * @param options.height Height of "viewport" or window
 * @param options.scale Scale at the current zoom
 * @param options.center Offset of the target, vec3 in world space
 * @param options.offset Offset of the focal point, vec2 in screen space
 * @param options.pitch Camera angle in degrees (0 is straight down)
 * @param options.fovy field of view in degrees
 * @param options.altitude if provided, field of view is calculated using `altitudeToFovy()`
 * @param options.nearZMultiplier control z buffer
 * @param options.farZMultiplier control z buffer
 * @returns 4x4 projection matrix
 */ parcelHelpers.export(exports, "getProjectionMatrix", ()=>getProjectionMatrix);
/**
 *
 * Convert an altitude to field of view such that the
 * focal distance is equal to the altitude
 *
 * @param altitude - altitude of camera in screen units
 * @return fovy field of view in degrees
 */ parcelHelpers.export(exports, "altitudeToFovy", ()=>altitudeToFovy);
/**
 *
 * Convert an field of view such that the
 * focal distance is equal to the altitude
 *
 * @param fovy - field of view in degrees
 * @return altitude altitude of camera in screen units
 */ parcelHelpers.export(exports, "fovyToAltitude", ()=>fovyToAltitude);
// Project flat coordinates to pixels on screen.
parcelHelpers.export(exports, "worldToPixels", ()=>worldToPixels);
/**
 * Unproject pixels on screen to flat coordinates.
 *
 * @param xyz - pixel coordinate on screen.
 * @param pixelUnprojectionMatrix - unprojection matrix 4x4
 * @param targetZ - if pixel coordinate does not have a 3rd component (depth),
 *    targetZ is used as the elevation plane to unproject onto
 * @return [x, y, Z] flat coordinates on 512*512 Mercator Zoom 0 tile.
 */ parcelHelpers.export(exports, "pixelsToWorld", ()=>pixelsToWorld);
var _mathUtilsJs = require("./math-utils.js");
var _core = require("@math.gl/core");
var _assertJs = require("./assert.js");
// CONSTANTS
const PI = Math.PI;
const PI_4 = PI / 4;
const DEGREES_TO_RADIANS = PI / 180;
const RADIANS_TO_DEGREES = 180 / PI;
const TILE_SIZE = 512;
// Average circumference (40075 km equatorial, 40007 km meridional)
const EARTH_CIRCUMFERENCE = 40.03e6;
const MAX_LATITUDE = 85.051129;
const DEFAULT_ALTITUDE = 1.5;
function zoomToScale(zoom) {
    return Math.pow(2, zoom);
}
function scaleToZoom(scale) {
    return (0, _mathUtilsJs.log2)(scale);
}
function lngLatToWorld(lngLat) {
    const [lng, lat] = lngLat;
    (0, _assertJs.assert)(Number.isFinite(lng));
    (0, _assertJs.assert)(Number.isFinite(lat) && lat >= -90 && lat <= 90, 'invalid latitude');
    const lambda2 = lng * DEGREES_TO_RADIANS;
    const phi2 = lat * DEGREES_TO_RADIANS;
    const x = TILE_SIZE * (lambda2 + PI) / (2 * PI);
    const y = TILE_SIZE * (PI + Math.log(Math.tan(PI_4 + phi2 * 0.5))) / (2 * PI);
    return [
        x,
        y
    ];
}
function worldToLngLat(xy) {
    const [x, y] = xy;
    const lambda2 = x / TILE_SIZE * (2 * PI) - PI;
    const phi2 = 2 * (Math.atan(Math.exp(y / TILE_SIZE * (2 * PI) - PI)) - PI_4);
    return [
        lambda2 * RADIANS_TO_DEGREES,
        phi2 * RADIANS_TO_DEGREES
    ];
}
function getMeterZoom(options) {
    const { latitude } = options;
    (0, _assertJs.assert)(Number.isFinite(latitude));
    const latCosine = Math.cos(latitude * DEGREES_TO_RADIANS);
    return scaleToZoom(EARTH_CIRCUMFERENCE * latCosine) - 9;
}
function unitsPerMeter(latitude) {
    const latCosine = Math.cos(latitude * DEGREES_TO_RADIANS);
    return TILE_SIZE / EARTH_CIRCUMFERENCE / latCosine;
}
function getDistanceScales(options) {
    const { latitude, longitude, highPrecision = false } = options;
    (0, _assertJs.assert)(Number.isFinite(latitude) && Number.isFinite(longitude));
    const worldSize = TILE_SIZE;
    const latCosine = Math.cos(latitude * DEGREES_TO_RADIANS);
    /**
     * Number of pixels occupied by one degree longitude around current lat/lon:
       unitsPerDegreeX = d(lngLatToWorld([lng, lat])[0])/d(lng)
         = scale * TILE_SIZE * DEGREES_TO_RADIANS / (2 * PI)
       unitsPerDegreeY = d(lngLatToWorld([lng, lat])[1])/d(lat)
         = -scale * TILE_SIZE * DEGREES_TO_RADIANS / cos(lat * DEGREES_TO_RADIANS)  / (2 * PI)
     */ const unitsPerDegreeX = worldSize / 360;
    const unitsPerDegreeY = unitsPerDegreeX / latCosine;
    /**
     * Number of pixels occupied by one meter around current lat/lon:
     */ const altUnitsPerMeter = worldSize / EARTH_CIRCUMFERENCE / latCosine;
    /**
     * LngLat: longitude -> east and latitude -> north (bottom left)
     * UTM meter offset: x -> east and y -> north (bottom left)
     * World space: x -> east and y -> south (top left)
     *
     * Y needs to be flipped when converting delta degree/meter to delta pixels
     */ const result = {
        unitsPerMeter: [
            altUnitsPerMeter,
            altUnitsPerMeter,
            altUnitsPerMeter
        ],
        metersPerUnit: [
            1 / altUnitsPerMeter,
            1 / altUnitsPerMeter,
            1 / altUnitsPerMeter
        ],
        unitsPerDegree: [
            unitsPerDegreeX,
            unitsPerDegreeY,
            altUnitsPerMeter
        ],
        degreesPerUnit: [
            1 / unitsPerDegreeX,
            1 / unitsPerDegreeY,
            1 / altUnitsPerMeter
        ]
    };
    /**
     * Taylor series 2nd order for 1/latCosine
       f'(a) * (x - a)
         = d(1/cos(lat * DEGREES_TO_RADIANS))/d(lat) * dLat
         = DEGREES_TO_RADIANS * tan(lat * DEGREES_TO_RADIANS) / cos(lat * DEGREES_TO_RADIANS) * dLat
     */ if (highPrecision) {
        const latCosine2 = DEGREES_TO_RADIANS * Math.tan(latitude * DEGREES_TO_RADIANS) / latCosine;
        const unitsPerDegreeY2 = unitsPerDegreeX * latCosine2 / 2;
        const altUnitsPerDegree2 = worldSize / EARTH_CIRCUMFERENCE * latCosine2;
        const altUnitsPerMeter2 = altUnitsPerDegree2 / unitsPerDegreeY * altUnitsPerMeter;
        result.unitsPerDegree2 = [
            0,
            unitsPerDegreeY2,
            altUnitsPerDegree2
        ];
        result.unitsPerMeter2 = [
            altUnitsPerMeter2,
            0,
            altUnitsPerMeter2
        ];
    }
    // Main results, used for converting meters to latlng deltas and scaling offsets
    return result;
}
function addMetersToLngLat(lngLatZ, xyz) {
    const [longitude, latitude, z0] = lngLatZ;
    const [x, y, z] = xyz;
    // eslint-disable-next-line no-shadow
    const { unitsPerMeter, unitsPerMeter2 } = getDistanceScales({
        longitude,
        latitude,
        highPrecision: true
    });
    const worldspace = lngLatToWorld(lngLatZ);
    worldspace[0] += x * (unitsPerMeter[0] + unitsPerMeter2[0] * y);
    worldspace[1] += y * (unitsPerMeter[1] + unitsPerMeter2[1] * y);
    const newLngLat = worldToLngLat(worldspace);
    const newZ = (z0 || 0) + (z || 0);
    return Number.isFinite(z0) || Number.isFinite(z) ? [
        newLngLat[0],
        newLngLat[1],
        newZ
    ] : newLngLat;
}
function getViewMatrix(options) {
    const { // Viewport props
    height, pitch, bearing, altitude, // Pre-calculated parameters
    scale, center } = options;
    // VIEW MATRIX: PROJECTS MERCATOR WORLD COORDINATES
    // Note that mercator world coordinates typically need to be flipped
    //
    // Note: As usual, matrix operation orders should be read in reverse
    // since vectors will be multiplied from the right during transformation
    const vm = (0, _mathUtilsJs.createMat4)();
    // Move camera to altitude (along the pitch & bearing direction)
    (0, _core.mat4).translate(vm, vm, [
        0,
        0,
        -altitude
    ]);
    // Rotate by bearing, and then by pitch (which tilts the view)
    (0, _core.mat4).rotateX(vm, vm, -pitch * DEGREES_TO_RADIANS);
    (0, _core.mat4).rotateZ(vm, vm, bearing * DEGREES_TO_RADIANS);
    const relativeScale = scale / height;
    (0, _core.mat4).scale(vm, vm, [
        relativeScale,
        relativeScale,
        relativeScale
    ]);
    if (center) (0, _core.mat4).translate(vm, vm, (0, _core.vec3).negate([], center));
    return vm;
}
function getProjectionParameters(options) {
    const { width, height, altitude, pitch = 0, offset, center, scale, nearZMultiplier = 1, farZMultiplier = 1 } = options;
    let { fovy = altitudeToFovy(DEFAULT_ALTITUDE) } = options;
    // For back-compatibility allow field of view to be
    // derived from altitude
    if (altitude !== undefined) fovy = altitudeToFovy(altitude);
    const fovRadians = fovy * DEGREES_TO_RADIANS;
    const pitchRadians = pitch * DEGREES_TO_RADIANS;
    // Distance from camera to the target
    const focalDistance = fovyToAltitude(fovy);
    let cameraToSeaLevelDistance = focalDistance;
    if (center) cameraToSeaLevelDistance += center[2] * scale / Math.cos(pitchRadians) / height;
    const fovAboveCenter = fovRadians * (0.5 + (offset ? offset[1] : 0) / height);
    // Find the distance from the center point to the center top
    // in focal distance units using law of sines.
    const topHalfSurfaceDistance = Math.sin(fovAboveCenter) * cameraToSeaLevelDistance / Math.sin((0, _mathUtilsJs.clamp)(Math.PI / 2 - pitchRadians - fovAboveCenter, 0.01, Math.PI - 0.01));
    // Calculate z distance of the farthest fragment that should be rendered.
    const furthestDistance = Math.sin(pitchRadians) * topHalfSurfaceDistance + cameraToSeaLevelDistance;
    // Matches mapbox limit
    const horizonDistance = cameraToSeaLevelDistance * 10;
    // Calculate z value of the farthest fragment that should be rendered.
    const farZ = Math.min(furthestDistance * farZMultiplier, horizonDistance);
    return {
        fov: fovRadians,
        aspect: width / height,
        focalDistance,
        near: nearZMultiplier,
        far: farZ
    };
}
function getProjectionMatrix(options) {
    const { fov, aspect, near, far } = getProjectionParameters(options);
    const projectionMatrix = (0, _core.mat4).perspective([], fov, aspect, near, far // far plane
    );
    return projectionMatrix;
}
function altitudeToFovy(altitude) {
    return 2 * Math.atan(0.5 / altitude) * RADIANS_TO_DEGREES;
}
function fovyToAltitude(fovy) {
    return 0.5 / Math.tan(0.5 * fovy * DEGREES_TO_RADIANS);
}
function worldToPixels(xyz, pixelProjectionMatrix) {
    const [x, y, z = 0] = xyz;
    (0, _assertJs.assert)(Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(z));
    return (0, _mathUtilsJs.transformVector)(pixelProjectionMatrix, [
        x,
        y,
        z,
        1
    ]);
}
function pixelsToWorld(xyz, pixelUnprojectionMatrix, targetZ = 0) {
    const [x, y, z] = xyz;
    (0, _assertJs.assert)(Number.isFinite(x) && Number.isFinite(y), 'invalid pixel coordinate');
    if (Number.isFinite(z)) {
        // Has depth component
        const coord = (0, _mathUtilsJs.transformVector)(pixelUnprojectionMatrix, [
            x,
            y,
            z,
            1
        ]);
        return coord;
    }
    // since we don't know the correct projected z value for the point,
    // unproject two points to get a line and then find the point on that line with z=0
    const coord0 = (0, _mathUtilsJs.transformVector)(pixelUnprojectionMatrix, [
        x,
        y,
        0,
        1
    ]);
    const coord1 = (0, _mathUtilsJs.transformVector)(pixelUnprojectionMatrix, [
        x,
        y,
        1,
        1
    ]);
    const z0 = coord0[2];
    const z1 = coord1[2];
    const t = z0 === z1 ? 0 : ((targetZ || 0) - z0) / (z1 - z0);
    return (0, _core.vec2).lerp([], coord0, coord1, t);
}

},{"./math-utils.js":"kayvU","@math.gl/core":"6z0Tv","./assert.js":"erQZS","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"erQZS":[function(require,module,exports,__globalThis) {
// Replacement for the external assert method to reduce bundle size
// Note: We don't use the second "message" argument in calling code,
// so no need to support it here
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(message || '@math.gl/web-mercator: assertion failed.');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lKvUZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns map settings {latitude, longitude, zoom}
 * that will contain the provided corners within the provided width.
 *
 * > _Note: Only supports non-perspective mode._
 *
 * @param options fit bounds parameters
 * @returns - latitude, longitude and zoom
 */ parcelHelpers.export(exports, "fitBounds", ()=>fitBounds);
var _assertJs = require("./assert.js");
var _mathUtilsJs = require("./math-utils.js");
var _webMercatorUtilsJs = require("./web-mercator-utils.js");
function fitBounds(options) {
    const { width, height, bounds, minExtent = 0, maxZoom = 24, offset = [
        0,
        0
    ] } = options;
    const [[west, south], [east, north]] = bounds;
    const padding = getPaddingObject(options.padding);
    const nw = (0, _webMercatorUtilsJs.lngLatToWorld)([
        west,
        (0, _mathUtilsJs.clamp)(north, -(0, _webMercatorUtilsJs.MAX_LATITUDE), (0, _webMercatorUtilsJs.MAX_LATITUDE))
    ]);
    const se = (0, _webMercatorUtilsJs.lngLatToWorld)([
        east,
        (0, _mathUtilsJs.clamp)(south, -(0, _webMercatorUtilsJs.MAX_LATITUDE), (0, _webMercatorUtilsJs.MAX_LATITUDE))
    ]);
    // width/height on the Web Mercator plane
    const size = [
        Math.max(Math.abs(se[0] - nw[0]), minExtent),
        Math.max(Math.abs(se[1] - nw[1]), minExtent)
    ];
    const targetSize = [
        width - padding.left - padding.right - Math.abs(offset[0]) * 2,
        height - padding.top - padding.bottom - Math.abs(offset[1]) * 2
    ];
    (0, _assertJs.assert)(targetSize[0] > 0 && targetSize[1] > 0);
    // scale = screen pixels per unit on the Web Mercator plane
    const scaleX = targetSize[0] / size[0];
    const scaleY = targetSize[1] / size[1];
    // Find how much we need to shift the center
    const offsetX = (padding.right - padding.left) / 2 / scaleX;
    const offsetY = (padding.top - padding.bottom) / 2 / scaleY;
    const center = [
        (se[0] + nw[0]) / 2 + offsetX,
        (se[1] + nw[1]) / 2 + offsetY
    ];
    const centerLngLat = (0, _webMercatorUtilsJs.worldToLngLat)(center);
    const zoom = Math.min(maxZoom, (0, _mathUtilsJs.log2)(Math.abs(Math.min(scaleX, scaleY))));
    (0, _assertJs.assert)(Number.isFinite(zoom));
    return {
        longitude: centerLngLat[0],
        latitude: centerLngLat[1],
        zoom
    };
}
// Helpers
function getPaddingObject(padding = 0) {
    if (typeof padding === 'number') return {
        top: padding,
        bottom: padding,
        left: padding,
        right: padding
    };
    // Make sure all the required properties are set
    (0, _assertJs.assert)(Number.isFinite(padding.top) && Number.isFinite(padding.bottom) && Number.isFinite(padding.left) && Number.isFinite(padding.right));
    return padding;
}

},{"./assert.js":"erQZS","./math-utils.js":"kayvU","./web-mercator-utils.js":"jfx5Q","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kylBM":[function(require,module,exports,__globalThis) {
/* eslint-disable camelcase */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Returns the quad at the intersection of the frustum and the given z plane
 * @param {WebMercatorViewport} viewport
 * @param {Number} z - elevation in meters
 */ parcelHelpers.export(exports, "getBounds", ()=>getBounds);
var _core = require("@math.gl/core");
var _webMercatorUtilsJs = require("./web-mercator-utils.js");
var _mathUtilsJs = require("./math-utils.js");
const DEGREES_TO_RADIANS = Math.PI / 180;
function getBounds(viewport, z = 0) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { width, height, unproject } = viewport;
    const unprojectOps = {
        targetZ: z
    };
    const bottomLeft = unproject([
        0,
        height
    ], unprojectOps);
    const bottomRight = unproject([
        width,
        height
    ], unprojectOps);
    let topLeft;
    let topRight;
    const halfFov = viewport.fovy ? 0.5 * viewport.fovy * DEGREES_TO_RADIANS : Math.atan(0.5 / viewport.altitude);
    const angleToGround = (90 - viewport.pitch) * DEGREES_TO_RADIANS;
    // The top plane is parallel to the ground if halfFov == angleToGround
    if (halfFov > angleToGround - 0.01) {
        // intersect with the far plane
        topLeft = unprojectOnFarPlane(viewport, 0, z);
        topRight = unprojectOnFarPlane(viewport, width, z);
    } else {
        // intersect with the top plane
        topLeft = unproject([
            0,
            0
        ], unprojectOps);
        topRight = unproject([
            width,
            0
        ], unprojectOps);
    }
    return [
        bottomLeft,
        bottomRight,
        topRight,
        topLeft
    ];
}
/*
 * Find a point on the far clipping plane of the viewport
 * @param {WebMercatorViewport} viewport
 * @param {Number} x - projected x in screen space
 * @param {Number} targetZ - the elevation of the point in meters
 */ function unprojectOnFarPlane(viewport, x, targetZ) {
    const { pixelUnprojectionMatrix } = viewport;
    const coord0 = (0, _mathUtilsJs.transformVector)(pixelUnprojectionMatrix, [
        x,
        0,
        1,
        1
    ]);
    const coord1 = (0, _mathUtilsJs.transformVector)(pixelUnprojectionMatrix, [
        x,
        viewport.height,
        1,
        1
    ]);
    const z = targetZ * viewport.distanceScales.unitsPerMeter[2];
    const t = (z - coord0[2]) / (coord1[2] - coord0[2]);
    const coord = (0, _core.vec2).lerp([], coord0, coord1, t);
    const result = (0, _webMercatorUtilsJs.worldToLngLat)(coord);
    result.push(targetZ);
    return result;
}

},{"@math.gl/core":"6z0Tv","./web-mercator-utils.js":"jfx5Q","./math-utils.js":"kayvU","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fkxg6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Apply mathematical constraints to viewport props
 * @param props
 */ // eslint-disable-next-line complexity
parcelHelpers.export(exports, "normalizeViewportProps", ()=>normalizeViewportProps);
var _webMercatorUtilsJs = require("./web-mercator-utils.js");
var _mathUtilsJs = require("./math-utils.js");
// defined by mapbox-gl
const TILE_SIZE = 512;
function normalizeViewportProps(props) {
    const { width, height, pitch = 0 } = props;
    let { longitude, latitude, zoom, bearing = 0 } = props;
    // Normalize degrees
    if (longitude < -180 || longitude > 180) longitude = (0, _mathUtilsJs.mod)(longitude + 180, 360) - 180;
    if (bearing < -180 || bearing > 180) bearing = (0, _mathUtilsJs.mod)(bearing + 180, 360) - 180;
    // Constrain zoom and shift center at low zoom levels
    const minZoom = (0, _mathUtilsJs.log2)(height / TILE_SIZE);
    if (zoom <= minZoom) {
        zoom = minZoom;
        latitude = 0;
    } else {
        // Eliminate white space above and below the map
        const halfHeightPixels = height / 2 / Math.pow(2, zoom);
        const minLatitude = (0, _webMercatorUtilsJs.worldToLngLat)([
            0,
            halfHeightPixels
        ])[1];
        if (latitude < minLatitude) latitude = minLatitude;
        else {
            const maxLatitude = (0, _webMercatorUtilsJs.worldToLngLat)([
                0,
                TILE_SIZE - halfHeightPixels
            ])[1];
            if (latitude > maxLatitude) latitude = maxLatitude;
        }
    }
    return {
        width,
        height,
        longitude,
        latitude,
        zoom,
        pitch,
        bearing
    };
}

},{"./web-mercator-utils.js":"jfx5Q","./math-utils.js":"kayvU","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9FaED":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * mapbox-gl-js flyTo : https://www.mapbox.com/mapbox-gl-js/api/#map#flyto.
 * It implements “Smooth and efficient zooming and panning.” algorithm by
 * "Jarke J. van Wijk and Wim A.A. Nuij"
 */ parcelHelpers.export(exports, "flyToViewport", ()=>flyToViewport);
// returns transition duration in milliseconds
parcelHelpers.export(exports, "getFlyToDuration", ()=>getFlyToDuration);
var _mathUtilsJs = require("./math-utils.js");
var _webMercatorUtilsJs = require("./web-mercator-utils.js");
var _core = require("@math.gl/core");
const EPSILON = 0.01;
const VIEWPORT_TRANSITION_PROPS = [
    'longitude',
    'latitude',
    'zoom'
];
const DEFAULT_OPTS = {
    curve: 1.414,
    speed: 1.2
};
function flyToViewport(startProps, endProps, t, options) {
    // Equations from above paper are referred where needed.
    const { startZoom, startCenterXY, uDelta, w0, u1, S, rho, rho2, r0 } = getFlyToTransitionParams(startProps, endProps, options);
    // If change in center is too small, do linear interpolaiton.
    if (u1 < EPSILON) {
        const viewport = {};
        for (const key of VIEWPORT_TRANSITION_PROPS){
            const startValue = startProps[key];
            const endValue = endProps[key];
            // @ts-ignore-error properties are populated dynamically
            viewport[key] = (0, _mathUtilsJs.lerp)(startValue, endValue, t);
        }
        // @ts-expect-error properties are populated dynamically
        return viewport;
    }
    const s = t * S;
    const w = Math.cosh(r0) / Math.cosh(r0 + rho * s);
    const u = w0 * ((Math.cosh(r0) * Math.tanh(r0 + rho * s) - Math.sinh(r0)) / rho2) / u1;
    const scaleIncrement = 1 / w; // Using w method for scaling.
    const newZoom = startZoom + (0, _webMercatorUtilsJs.scaleToZoom)(scaleIncrement);
    const newCenterWorld = (0, _core.vec2).scale([], uDelta, u);
    (0, _core.vec2).add(newCenterWorld, newCenterWorld, startCenterXY);
    const newCenter = (0, _webMercatorUtilsJs.worldToLngLat)(newCenterWorld);
    return {
        longitude: newCenter[0],
        latitude: newCenter[1],
        zoom: newZoom
    };
}
function getFlyToDuration(startProps, endProps, options) {
    const opts = {
        ...DEFAULT_OPTS,
        ...options
    };
    const { screenSpeed, speed, maxDuration } = opts;
    const { S, rho } = getFlyToTransitionParams(startProps, endProps, opts);
    const length = 1000 * S;
    let duration;
    if (Number.isFinite(screenSpeed)) duration = length / (screenSpeed / rho);
    else duration = length / speed;
    return Number.isFinite(maxDuration) && duration > maxDuration ? 0 : duration;
}
// Private Methods
// Calculate all parameters that are static for given startProps and endProps
function getFlyToTransitionParams(startProps, endProps, opts) {
    opts = Object.assign({}, DEFAULT_OPTS, opts);
    const rho = opts.curve;
    const startZoom = startProps.zoom;
    const startCenter = [
        startProps.longitude,
        startProps.latitude
    ];
    const startScale = (0, _webMercatorUtilsJs.zoomToScale)(startZoom);
    const endZoom = endProps.zoom;
    const endCenter = [
        endProps.longitude,
        endProps.latitude
    ];
    const scale = (0, _webMercatorUtilsJs.zoomToScale)(endZoom - startZoom);
    const startCenterXY = (0, _webMercatorUtilsJs.lngLatToWorld)(startCenter);
    const endCenterXY = (0, _webMercatorUtilsJs.lngLatToWorld)(endCenter);
    const uDelta = (0, _core.vec2).sub([], endCenterXY, startCenterXY);
    const w0 = Math.max(startProps.width, startProps.height);
    const w1 = w0 / scale;
    const u1 = (0, _core.vec2).length(uDelta) * startScale;
    // u0 is treated as '0' in Eq (9).
    // If u1 is too small, will generate invalid number
    const _u1 = Math.max(u1, EPSILON);
    // Implement Equation (9) from above algorithm.
    const rho2 = rho * rho;
    const b0 = (w1 * w1 - w0 * w0 + rho2 * rho2 * _u1 * _u1) / (2 * w0 * rho2 * _u1);
    const b1 = (w1 * w1 - w0 * w0 - rho2 * rho2 * _u1 * _u1) / (2 * w1 * rho2 * _u1);
    const r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0);
    const r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    const S = (r1 - r0) / rho;
    return {
        startZoom,
        startCenterXY,
        uDelta,
        w0,
        u1,
        S,
        rho,
        rho2,
        r0,
        r1
    };
}

},{"./math-utils.js":"kayvU","./web-mercator-utils.js":"jfx5Q","@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9SQCI":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _shadertools = require("@luma.gl/shadertools");
exports.default = {
    ...(0, _shadertools.picking),
    defaultUniforms: {
        ...(0, _shadertools.picking).defaultUniforms,
        useFloatColors: false
    },
    inject: {
        'vs:DECKGL_FILTER_GL_POSITION': `
    // for picking depth values
    picking_setPickingAttribute(position.z / position.w);
  `,
        'vs:DECKGL_FILTER_COLOR': `
  picking_setPickingColor(geometry.pickingColor);
  `,
        'fs:DECKGL_FILTER_COLOR': {
            order: 99,
            injection: `
  // use highlight color if this fragment belongs to the selected object.
  color = picking_filterHighlightColor(color);

  // use picking color if rendering to picking FBO.
  color = picking_filterPickingColor(color);
    `
        }
    }
};

},{"@luma.gl/shadertools":"iH5G2","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"e7Z2E":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ambientLightJs = require("./ambient-light.js");
var _directionalLightJs = require("./directional-light.js");
var _core = require("@math.gl/core");
var _shadowPassJs = require("../../passes/shadow-pass.js");
var _shadowPassJsDefault = parcelHelpers.interopDefault(_shadowPassJs);
var _shadowJs = require("../../shaderlib/shadow/shadow.js");
var _shadowJsDefault = parcelHelpers.interopDefault(_shadowJs);
const DEFAULT_AMBIENT_LIGHT_PROPS = {
    color: [
        255,
        255,
        255
    ],
    intensity: 1.0
};
const DEFAULT_DIRECTIONAL_LIGHT_PROPS = [
    {
        color: [
            255,
            255,
            255
        ],
        intensity: 1.0,
        direction: [
            -1,
            3,
            -1
        ]
    },
    {
        color: [
            255,
            255,
            255
        ],
        intensity: 0.9,
        direction: [
            1,
            -8,
            -2.5
        ]
    }
];
const DEFAULT_SHADOW_COLOR = [
    0,
    0,
    0,
    200 / 255
];
class LightingEffect {
    constructor(props = {}){
        this.id = 'lighting-effect';
        this.shadowColor = DEFAULT_SHADOW_COLOR;
        this.shadow = false;
        this.directionalLights = [];
        this.pointLights = [];
        this.shadowPasses = [];
        this.dummyShadowMap = null;
        this.setProps(props);
    }
    setup(context) {
        this.context = context;
        const { device, deck } = context;
        if (this.shadow && !this.dummyShadowMap) {
            this._createShadowPasses(device);
            deck._addDefaultShaderModule((0, _shadowJsDefault.default));
            this.dummyShadowMap = device.createTexture({
                width: 1,
                height: 1
            });
        }
    }
    setProps(props) {
        this.ambientLight = undefined;
        this.directionalLights = [];
        this.pointLights = [];
        for(const key in props){
            const lightSource = props[key];
            switch(lightSource.type){
                case 'ambient':
                    this.ambientLight = lightSource;
                    break;
                case 'directional':
                    this.directionalLights.push(lightSource);
                    break;
                case 'point':
                    this.pointLights.push(lightSource);
                    break;
                default:
            }
        }
        this._applyDefaultLights();
        this.shadow = this.directionalLights.some((light)=>light.shadow);
        if (this.context) // Create resources if necessary
        this.setup(this.context);
        this.props = props;
    }
    preRender({ layers, layerFilter, viewports, onViewportActive, views }) {
        if (!this.shadow) return;
        // create light matrix every frame to make sure always updated from light source
        this.shadowMatrices = this._calculateMatrices();
        for(let i = 0; i < this.shadowPasses.length; i++){
            const shadowPass = this.shadowPasses[i];
            shadowPass.render({
                layers,
                layerFilter,
                viewports,
                onViewportActive,
                views,
                shaderModuleProps: {
                    shadow: {
                        shadowLightId: i,
                        dummyShadowMap: this.dummyShadowMap,
                        shadowMatrices: this.shadowMatrices
                    }
                }
            });
        }
    }
    getShaderModuleProps(layer, otherShaderModuleProps) {
        const shadowProps = this.shadow ? {
            project: otherShaderModuleProps.project,
            shadowMaps: this.shadowPasses.map((shadowPass)=>shadowPass.getShadowMap()),
            dummyShadowMap: this.dummyShadowMap,
            shadowColor: this.shadowColor,
            shadowMatrices: this.shadowMatrices
        } : {};
        // when not rendering to screen, turn off lighting by adding empty light source object
        // lights shader module relies on the `lightSources` to turn on/off lighting
        const lightingProps = {
            enabled: true,
            ambientLight: this.ambientLight,
            directionalLights: this.directionalLights.map((directionalLight)=>directionalLight.getProjectedLight({
                    layer
                })),
            pointLights: this.pointLights.map((pointLight)=>pointLight.getProjectedLight({
                    layer
                }))
        };
        // @ts-expect-error material is not a Layer prop
        const materialProps = layer.props.material;
        return {
            shadow: shadowProps,
            lighting: lightingProps,
            phongMaterial: materialProps,
            gouraudMaterial: materialProps
        };
    }
    cleanup(context) {
        for (const shadowPass of this.shadowPasses)shadowPass.delete();
        this.shadowPasses.length = 0;
        if (this.dummyShadowMap) {
            this.dummyShadowMap.destroy();
            this.dummyShadowMap = null;
            context.deck._removeDefaultShaderModule((0, _shadowJsDefault.default));
        }
    }
    _calculateMatrices() {
        const lightMatrices = [];
        for (const light of this.directionalLights){
            const viewMatrix = new (0, _core.Matrix4)().lookAt({
                eye: new (0, _core.Vector3)(light.direction).negate()
            });
            lightMatrices.push(viewMatrix);
        }
        return lightMatrices;
    }
    _createShadowPasses(device) {
        for(let i = 0; i < this.directionalLights.length; i++){
            const shadowPass = new (0, _shadowPassJsDefault.default)(device);
            this.shadowPasses[i] = shadowPass;
        }
    }
    _applyDefaultLights() {
        const { ambientLight, pointLights, directionalLights } = this;
        if (!ambientLight && pointLights.length === 0 && directionalLights.length === 0) {
            this.ambientLight = new (0, _ambientLightJs.AmbientLight)(DEFAULT_AMBIENT_LIGHT_PROPS);
            this.directionalLights.push(new (0, _directionalLightJs.DirectionalLight)(DEFAULT_DIRECTIONAL_LIGHT_PROPS[0]), new (0, _directionalLightJs.DirectionalLight)(DEFAULT_DIRECTIONAL_LIGHT_PROPS[1]));
        }
    }
}
exports.default = LightingEffect;

},{"./ambient-light.js":"aahwA","./directional-light.js":"2EfV5","@math.gl/core":"6z0Tv","../../passes/shadow-pass.js":"jBhea","../../shaderlib/shadow/shadow.js":"dLi7u","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aahwA":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmbientLight", ()=>AmbientLight);
const DEFAULT_LIGHT_COLOR = [
    255,
    255,
    255
];
const DEFAULT_LIGHT_INTENSITY = 1.0;
let idCount = 0;
class AmbientLight {
    constructor(props = {}){
        this.type = 'ambient';
        const { color = DEFAULT_LIGHT_COLOR } = props;
        const { intensity = DEFAULT_LIGHT_INTENSITY } = props;
        this.id = props.id || `ambient-${idCount++}`;
        this.color = color;
        this.intensity = intensity;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2EfV5":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionalLight", ()=>DirectionalLight);
var _core = require("@math.gl/core");
const DEFAULT_LIGHT_COLOR = [
    255,
    255,
    255
];
const DEFAULT_LIGHT_INTENSITY = 1.0;
const DEFAULT_LIGHT_DIRECTION = [
    0.0,
    0.0,
    -1
];
let idCount = 0;
class DirectionalLight {
    constructor(props = {}){
        this.type = 'directional';
        const { color = DEFAULT_LIGHT_COLOR } = props;
        const { intensity = DEFAULT_LIGHT_INTENSITY } = props;
        const { direction = DEFAULT_LIGHT_DIRECTION } = props;
        const { _shadow = false } = props;
        this.id = props.id || `directional-${idCount++}`;
        this.color = color;
        this.intensity = intensity;
        this.type = 'directional';
        this.direction = new (0, _core.Vector3)(direction).normalize().toArray();
        this.shadow = _shadow;
    }
    getProjectedLight(opts) {
        return this;
    }
}

},{"@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jBhea":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layersPassJs = require("./layers-pass.js");
var _layersPassJsDefault = parcelHelpers.interopDefault(_layersPassJs);
class ShadowPass extends (0, _layersPassJsDefault.default) {
    constructor(device, props){
        super(device, props);
        // The shadowMap texture
        const shadowMap = device.createTexture({
            format: 'rgba8unorm',
            width: 1,
            height: 1,
            sampler: {
                minFilter: 'linear',
                magFilter: 'linear',
                addressModeU: 'clamp-to-edge',
                addressModeV: 'clamp-to-edge'
            },
            mipmaps: true
        });
        const depthBuffer = device.createTexture({
            format: 'depth16unorm',
            width: 1,
            height: 1,
            mipmaps: false
        });
        this.fbo = device.createFramebuffer({
            id: 'shadowmap',
            width: 1,
            height: 1,
            colorAttachments: [
                shadowMap
            ],
            // Depth attachment has to be specified for depth test to work
            depthStencilAttachment: depthBuffer
        });
    }
    delete() {
        if (this.fbo) {
            this.fbo.destroy();
            this.fbo = null;
        }
    }
    getShadowMap() {
        return this.fbo.colorAttachments[0].texture;
    }
    render(params) {
        const target = this.fbo;
        // @ts-expect-error TODO - assuming WebGL context
        const pixelRatio = this.device.canvasContext.cssToDeviceRatio();
        const viewport = params.viewports[0];
        const width = viewport.width * pixelRatio;
        const height = viewport.height * pixelRatio;
        const clearColor = [
            1,
            1,
            1,
            1
        ];
        if (width !== target.width || height !== target.height) target.resize({
            width,
            height
        });
        super.render({
            ...params,
            clearColor,
            target,
            pass: 'shadow'
        });
    }
    getLayerParameters(layer, layerIndex, viewport) {
        return {
            ...layer.props.parameters,
            blend: false,
            depthWriteEnabled: true,
            depthCompare: 'less-equal'
        };
    }
    shouldDrawLayer(layer) {
        return layer.props.shadowEnabled !== false;
    }
    getShaderModuleProps(layer, effects, otherShaderModuleProps) {
        return {
            shadow: {
                project: otherShaderModuleProps.project,
                drawToShadowMap: true
            }
        };
    }
}
exports.default = ShadowPass;

},{"./layers-pass.js":"286vl","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"286vl":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// If the _index prop is defined, return a layer index that's relative to its parent
// Otherwise return the index of the layer among all rendered layers
// This is done recursively, i.e. if the user overrides a layer's default index,
// all its descendants will be resolved relative to that index.
// This implementation assumes that parent layers always appear before its children
// which is true if the layer array comes from the LayerManager
parcelHelpers.export(exports, "layerIndexResolver", ()=>layerIndexResolver);
var _passJs = require("./pass.js");
var _passJsDefault = parcelHelpers.interopDefault(_passJs);
class LayersPass extends (0, _passJsDefault.default) {
    constructor(){
        super(...arguments);
        this._lastRenderIndex = -1;
    }
    render(options) {
        // @ts-expect-error TODO - assuming WebGL context
        const [width, height] = this.device.canvasContext.getDrawingBufferSize();
        // Explicitly specify clearColor and clearDepth, overriding render pass defaults.
        const clearCanvas = options.clearCanvas ?? true;
        const clearColor = options.clearColor ?? (clearCanvas ? [
            0,
            0,
            0,
            0
        ] : false);
        const clearDepth = clearCanvas ? 1 : false;
        const clearStencil = clearCanvas ? 0 : false;
        const colorMask = options.colorMask ?? 0xf;
        const parameters = {
            viewport: [
                0,
                0,
                width,
                height
            ]
        };
        if (options.colorMask) parameters.colorMask = colorMask;
        if (options.scissorRect) parameters.scissorRect = options.scissorRect;
        const renderPass = this.device.beginRenderPass({
            framebuffer: options.target,
            parameters,
            clearColor: clearColor,
            clearDepth,
            clearStencil
        });
        try {
            return this._drawLayers(renderPass, options);
        } finally{
            renderPass.end();
            // TODO(ibgreen): WebGPU - submit may not be needed here but initial port had issues with out of render loop rendering
            this.device.submit();
        }
    }
    /** Draw a list of layers in a list of viewports */ _drawLayers(renderPass, options) {
        const { target, shaderModuleProps, viewports, views, onViewportActive, clearStack = true } = options;
        options.pass = options.pass || 'unknown';
        if (clearStack) this._lastRenderIndex = -1;
        const renderStats = [];
        for (const viewport of viewports){
            const view = views && views[viewport.id];
            // Update context to point to this viewport
            onViewportActive?.(viewport);
            const drawLayerParams = this._getDrawLayerParams(viewport, options);
            // render this viewport
            const subViewports = viewport.subViewports || [
                viewport
            ];
            for (const subViewport of subViewports){
                const stats = this._drawLayersInViewport(renderPass, {
                    target,
                    shaderModuleProps,
                    viewport: subViewport,
                    view,
                    pass: options.pass,
                    layers: options.layers
                }, drawLayerParams);
                renderStats.push(stats);
            }
        }
        return renderStats;
    }
    // When a viewport contains multiple subviewports (e.g. repeated web mercator map),
    // this is only done once for the parent viewport
    /* Resolve the parameters needed to draw each layer */ _getDrawLayerParams(viewport, { layers, pass, isPicking = false, layerFilter, cullRect, effects, shaderModuleProps }, /** Internal flag, true if only used to determine whether each layer should be drawn */ evaluateShouldDrawOnly = false) {
        const drawLayerParams = [];
        const indexResolver = layerIndexResolver(this._lastRenderIndex + 1);
        const drawContext = {
            layer: layers[0],
            viewport,
            isPicking,
            renderPass: pass,
            cullRect
        };
        const layerFilterCache = {};
        for(let layerIndex = 0; layerIndex < layers.length; layerIndex++){
            const layer = layers[layerIndex];
            // Check if we should draw layer
            const shouldDrawLayer = this._shouldDrawLayer(layer, drawContext, layerFilter, layerFilterCache);
            const layerParam = {
                shouldDrawLayer
            };
            if (shouldDrawLayer && !evaluateShouldDrawOnly) {
                layerParam.shouldDrawLayer = true;
                // This is the "logical" index for ordering this layer in the stack
                // used to calculate polygon offsets
                // It can be the same as another layer
                layerParam.layerRenderIndex = indexResolver(layer, shouldDrawLayer);
                layerParam.shaderModuleProps = this._getShaderModuleProps(layer, effects, pass, shaderModuleProps);
                layerParam.layerParameters = {
                    ...layer.context.deck?.props.parameters,
                    ...this.getLayerParameters(layer, layerIndex, viewport)
                };
            }
            drawLayerParams[layerIndex] = layerParam;
        }
        return drawLayerParams;
    }
    // Draws a list of layers in one viewport
    // TODO - when picking we could completely skip rendering viewports that dont
    // intersect with the picking rect
    /* eslint-disable max-depth, max-statements */ _drawLayersInViewport(renderPass, { layers, shaderModuleProps: globalModuleParameters, pass, target, viewport, view }, drawLayerParams) {
        const glViewport = getGLViewport(this.device, {
            shaderModuleProps: globalModuleParameters,
            target,
            viewport
        });
        if (view && view.props.clear) {
            const clearOpts = view.props.clear === true ? {
                color: true,
                depth: true
            } : view.props.clear;
            const clearRenderPass = this.device.beginRenderPass({
                framebuffer: target,
                parameters: {
                    viewport: glViewport,
                    scissorRect: glViewport
                },
                clearColor: clearOpts.color ? [
                    0,
                    0,
                    0,
                    0
                ] : false,
                clearDepth: clearOpts.depth ? 1 : false
            });
            clearRenderPass.end();
        }
        // render layers in normal colors
        const renderStatus = {
            totalCount: layers.length,
            visibleCount: 0,
            compositeCount: 0,
            pickableCount: 0
        };
        renderPass.setParameters({
            viewport: glViewport
        });
        // render layers in normal colors
        for(let layerIndex = 0; layerIndex < layers.length; layerIndex++){
            const layer = layers[layerIndex];
            const drawLayerParameters = drawLayerParams[layerIndex];
            const { shouldDrawLayer } = drawLayerParameters;
            // Calculate stats
            if (shouldDrawLayer && layer.props.pickable) renderStatus.pickableCount++;
            if (layer.isComposite) renderStatus.compositeCount++;
            if (layer.isDrawable && drawLayerParameters.shouldDrawLayer) {
                const { layerRenderIndex, shaderModuleProps, layerParameters } = drawLayerParameters;
                // Draw the layer
                renderStatus.visibleCount++;
                this._lastRenderIndex = Math.max(this._lastRenderIndex, layerRenderIndex);
                // overwrite layer.context.viewport with the sub viewport
                if (shaderModuleProps.project) shaderModuleProps.project.viewport = viewport;
                // TODO v9 - we are sending renderPass both as a parameter and through the context.
                // Long-term, it is likely better not to have user defined layer methods have to access
                // the "global" layer context.
                layer.context.renderPass = renderPass;
                try {
                    layer._drawLayer({
                        renderPass,
                        shaderModuleProps,
                        uniforms: {
                            layerIndex: layerRenderIndex
                        },
                        parameters: layerParameters
                    });
                } catch (err) {
                    layer.raiseError(err, `drawing ${layer} to ${pass}`);
                }
            }
        }
        return renderStatus;
    }
    /* eslint-enable max-depth, max-statements */ /* Methods for subclass overrides */ shouldDrawLayer(layer) {
        return true;
    }
    getShaderModuleProps(layer, effects, otherShaderModuleProps) {
        return null;
    }
    getLayerParameters(layer, layerIndex, viewport) {
        return layer.props.parameters;
    }
    /* Private */ _shouldDrawLayer(layer, drawContext, layerFilter, layerFilterCache) {
        const shouldDrawLayer = layer.props.visible && this.shouldDrawLayer(layer);
        if (!shouldDrawLayer) return false;
        drawContext.layer = layer;
        let parent = layer.parent;
        while(parent){
            // @ts-ignore
            if (!parent.props.visible || !parent.filterSubLayer(drawContext)) return false;
            drawContext.layer = parent;
            parent = parent.parent;
        }
        if (layerFilter) {
            const rootLayerId = drawContext.layer.id;
            if (!(rootLayerId in layerFilterCache)) layerFilterCache[rootLayerId] = layerFilter(drawContext);
            if (!layerFilterCache[rootLayerId]) return false;
        }
        // If a layer is drawn, update its viewportChanged flag
        layer.activateViewport(drawContext.viewport);
        return true;
    }
    _getShaderModuleProps(layer, effects, pass, overrides) {
        // @ts-expect-error TODO - assuming WebGL context
        const devicePixelRatio = this.device.canvasContext.cssToDeviceRatio();
        const layerProps = layer.internalState?.propsInTransition || layer.props;
        const shaderModuleProps = {
            layer: layerProps,
            picking: {
                isActive: false
            },
            project: {
                viewport: layer.context.viewport,
                devicePixelRatio,
                modelMatrix: layerProps.modelMatrix,
                coordinateSystem: layerProps.coordinateSystem,
                coordinateOrigin: layerProps.coordinateOrigin,
                autoWrapLongitude: layer.wrapLongitude
            }
        };
        if (effects) for (const effect of effects)mergeModuleParameters(shaderModuleProps, effect.getShaderModuleProps?.(layer, shaderModuleProps));
        return mergeModuleParameters(shaderModuleProps, this.getShaderModuleProps(layer, effects, shaderModuleProps), overrides);
    }
}
exports.default = LayersPass;
function layerIndexResolver(startIndex = 0, layerIndices = {}) {
    const resolvers = {};
    const resolveLayerIndex = (layer, isDrawn)=>{
        const indexOverride = layer.props._offset;
        const layerId = layer.id;
        const parentId = layer.parent && layer.parent.id;
        let index;
        if (parentId && !(parentId in layerIndices)) // Populate layerIndices with the parent layer's index
        resolveLayerIndex(layer.parent, false);
        if (parentId in resolvers) {
            const resolver = resolvers[parentId] = resolvers[parentId] || layerIndexResolver(layerIndices[parentId], layerIndices);
            index = resolver(layer, isDrawn);
            resolvers[layerId] = resolver;
        } else if (Number.isFinite(indexOverride)) {
            index = indexOverride + (layerIndices[parentId] || 0);
            // Mark layer as needing its own resolver
            // We don't actually create it until it's used for the first time
            resolvers[layerId] = null;
        } else index = startIndex;
        if (isDrawn && index >= startIndex) startIndex = index + 1;
        layerIndices[layerId] = index;
        return index;
    };
    return resolveLayerIndex;
}
// Convert viewport top-left CSS coordinates to bottom up WebGL coordinates
function getGLViewport(device, { shaderModuleProps, target, viewport }) {
    const pixelRatio = shaderModuleProps?.project?.devicePixelRatio ?? // @ts-expect-error TODO - assuming WebGL context
    device.canvasContext.cssToDeviceRatio();
    // Default framebuffer is used when writing to canvas
    // @ts-expect-error TODO - assuming WebGL context
    const [, drawingBufferHeight] = device.canvasContext.getDrawingBufferSize();
    const height = target ? target.height : drawingBufferHeight;
    // Convert viewport top-left CSS coordinates to bottom up WebGL coordinates
    const dimensions = viewport;
    return [
        dimensions.x * pixelRatio,
        height - (dimensions.y + dimensions.height) * pixelRatio,
        dimensions.width * pixelRatio,
        dimensions.height * pixelRatio
    ];
}
function mergeModuleParameters(target, ...sources) {
    for (const source of sources)if (source) {
        for(const key in source)if (target[key]) Object.assign(target[key], source[key]);
        else target[key] = source[key];
    }
    return target;
}

},{"./pass.js":"jP9wR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jP9wR":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Base class for passes
 * @todo v9 - should the luma.gl RenderPass be owned by this class?
 * Currently owned by subclasses
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Pass {
    /** Create a new Pass instance */ constructor(device, props = {
        id: 'pass'
    }){
        const { id } = props;
        this.id = id; // id of this pass
        this.device = device;
        this.props = {
            ...props
        };
    }
    setProps(props) {
        Object.assign(this.props, props);
    }
    render(params) {}
    cleanup() {}
}
exports.default = Pass;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6itdD":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layersPassJs = require("./layers-pass.js");
var _layersPassJsDefault = parcelHelpers.interopDefault(_layersPassJs);
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
const PICKING_BLENDING = {
    blendColorOperation: 'add',
    blendColorSrcFactor: 'one',
    blendColorDstFactor: 'zero',
    blendAlphaOperation: 'add',
    blendAlphaSrcFactor: 'constant-alpha',
    blendAlphaDstFactor: 'zero'
};
class PickLayersPass extends (0, _layersPassJsDefault.default) {
    constructor(){
        super(...arguments);
        this._colorEncoderState = null;
    }
    render(props) {
        if ('pickingFBO' in props) // When drawing into an off-screen buffer, use the alpha channel to encode layer index
        return this._drawPickingBuffer(props);
        // When drawing to screen (debug mode), do not use the alpha channel so that result is always visible
        return super.render(props);
    }
    // Private
    // Draws list of layers and viewports into the picking buffer
    // Note: does not sample the buffer, that has to be done by the caller
    _drawPickingBuffer({ layers, layerFilter, views, viewports, onViewportActive, pickingFBO, deviceRect: { x, y, width, height }, cullRect, effects, pass = 'picking', pickZ, shaderModuleProps }) {
        this.pickZ = pickZ;
        const colorEncoderState = this._resetColorEncoder(pickZ);
        const scissorRect = [
            x,
            y,
            width,
            height
        ];
        // Make sure we clear scissor test and fbo bindings in case of exceptions
        // We are only interested in one pixel, no need to render anything else
        // Note that the callback here is called synchronously.
        // Set blend mode for picking
        // always overwrite existing pixel with [r,g,b,layerIndex]
        const renderStatus = super.render({
            target: pickingFBO,
            layers,
            layerFilter,
            views,
            viewports,
            onViewportActive,
            cullRect,
            effects: effects?.filter((e)=>e.useInPicking),
            pass,
            isPicking: true,
            shaderModuleProps,
            clearColor: [
                0,
                0,
                0,
                0
            ],
            colorMask: 0xf,
            scissorRect
        });
        // Clear the temp field
        this._colorEncoderState = null;
        const decodePickingColor = colorEncoderState && decodeColor.bind(null, colorEncoderState);
        return {
            decodePickingColor,
            stats: renderStatus
        };
    }
    shouldDrawLayer(layer) {
        const { pickable, operation } = layer.props;
        return pickable && operation.includes('draw') || operation.includes('terrain') || operation.includes('mask');
    }
    getShaderModuleProps(layer, effects, otherShaderModuleProps) {
        return {
            picking: {
                isActive: 1,
                isAttribute: this.pickZ
            },
            lighting: {
                enabled: false
            }
        };
    }
    getLayerParameters(layer, layerIndex, viewport) {
        // TODO use Parameters type
        const pickParameters = {
            ...layer.props.parameters
        };
        const { pickable, operation } = layer.props;
        if (!this._colorEncoderState || operation.includes('terrain')) pickParameters.blend = false;
        else if (pickable && operation.includes('draw')) {
            Object.assign(pickParameters, PICKING_BLENDING);
            pickParameters.blend = true;
            // TODO: blendColor no longer part of luma.gl API
            pickParameters.blendColor = encodeColor(this._colorEncoderState, layer, viewport);
        }
        return pickParameters;
    }
    _resetColorEncoder(pickZ) {
        // Track encoded layer indices
        this._colorEncoderState = pickZ ? null : {
            byLayer: new Map(),
            byAlpha: []
        };
        // Temporarily store it on the instance so that it can be accessed by this.getLayerParameters
        return this._colorEncoderState;
    }
}
exports.default = PickLayersPass;
// Assign an unique alpha value for each pickable layer and track the encoding in the cache object
// Returns normalized blend color
function encodeColor(encoded, layer, viewport) {
    const { byLayer, byAlpha } = encoded;
    let a;
    // Encode layerIndex in the alpha channel
    // TODO - combine small layers to better utilize the picking color space
    let entry = byLayer.get(layer);
    if (entry) {
        entry.viewports.push(viewport);
        a = entry.a;
    } else {
        a = byLayer.size + 1;
        if (a <= 255) {
            entry = {
                a,
                layer,
                viewports: [
                    viewport
                ]
            };
            byLayer.set(layer, entry);
            byAlpha[a] = entry;
        } else {
            (0, _logJsDefault.default).warn('Too many pickable layers, only picking the first 255')();
            a = 0;
        }
    }
    return [
        0,
        0,
        0,
        a / 255
    ];
}
// Given a picked color, retrieve the corresponding layer and viewports from cache
function decodeColor(encoded, pickedColor) {
    const entry = encoded.byAlpha[pickedColor[3]];
    return entry && {
        pickedLayer: entry.layer,
        pickedViewports: entry.viewports,
        pickedObjectIndex: entry.layer.decodePickingColor(pickedColor)
    };
}

},{"./layers-pass.js":"286vl","../utils/log.js":"9S0lD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"94R9P":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layerManagerJs = require("./layer-manager.js");
var _layerManagerJsDefault = parcelHelpers.interopDefault(_layerManagerJs);
var _viewManagerJs = require("./view-manager.js");
var _viewManagerJsDefault = parcelHelpers.interopDefault(_viewManagerJs);
var _mapViewJs = require("../views/map-view.js");
var _mapViewJsDefault = parcelHelpers.interopDefault(_mapViewJs);
var _effectManagerJs = require("./effect-manager.js");
var _effectManagerJsDefault = parcelHelpers.interopDefault(_effectManagerJs);
var _deckRendererJs = require("./deck-renderer.js");
var _deckRendererJsDefault = parcelHelpers.interopDefault(_deckRendererJs);
var _deckPickerJs = require("./deck-picker.js");
var _deckPickerJsDefault = parcelHelpers.interopDefault(_deckPickerJs);
var _widgetManagerJs = require("./widget-manager.js");
var _tooltipJs = require("./tooltip.js");
var _tooltipJsDefault = parcelHelpers.interopDefault(_tooltipJs);
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _deepEqualJs = require("../utils/deep-equal.js");
var _typedArrayManagerJs = require("../utils/typed-array-manager.js");
var _typedArrayManagerJsDefault = parcelHelpers.interopDefault(_typedArrayManagerJs);
var _initJs = require("./init.js");
var _core = require("@luma.gl/core");
var _webgl = require("@luma.gl/webgl");
var _engine = require("@luma.gl/engine");
var _constants = require("@luma.gl/constants");
var _stats = require("@probe.gl/stats");
var _mjolnirJs = require("mjolnir.js");
var _assertJs = require("../utils/assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
var _constantsJs = require("./constants.js");
/* global document */ // eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}
const getCursor = ({ isDragging })=>isDragging ? 'grabbing' : 'grab';
const defaultProps = {
    id: '',
    width: '100%',
    height: '100%',
    style: null,
    viewState: null,
    initialViewState: null,
    pickingRadius: 0,
    layerFilter: null,
    parameters: {},
    parent: null,
    device: null,
    deviceProps: {},
    gl: null,
    canvas: null,
    layers: [],
    effects: [],
    views: null,
    controller: null,
    useDevicePixels: true,
    touchAction: 'none',
    eventRecognizerOptions: {},
    _framebuffer: null,
    _animate: false,
    _pickable: true,
    _typedArrayManagerProps: {},
    _customRender: null,
    widgets: [],
    onDeviceInitialized: noop,
    onWebGLInitialized: noop,
    onResize: noop,
    onViewStateChange: noop,
    onInteractionStateChange: noop,
    onBeforeRender: noop,
    onAfterRender: noop,
    onLoad: noop,
    onError: (error)=>(0, _logJsDefault.default).error(error.message, error.cause)(),
    onHover: null,
    onClick: null,
    onDragStart: null,
    onDrag: null,
    onDragEnd: null,
    _onMetrics: null,
    getCursor,
    getTooltip: null,
    debug: false,
    drawPickingColors: false
};
/* eslint-disable max-statements */ class Deck {
    constructor(props){
        this.width = 0;
        this.height = 0;
        // Allows attaching arbitrary data to the instance
        this.userData = {};
        this.device = null;
        this.canvas = null;
        this.viewManager = null;
        this.layerManager = null;
        this.effectManager = null;
        this.deckRenderer = null;
        this.deckPicker = null;
        this.eventManager = null;
        this.widgetManager = null;
        this.tooltip = null;
        this.animationLoop = null;
        this.cursorState = {
            isHovering: false,
            isDragging: false
        };
        this.stats = new (0, _stats.Stats)({
            id: 'deck.gl'
        });
        this.metrics = {
            fps: 0,
            setPropsTime: 0,
            updateAttributesTime: 0,
            framesRedrawn: 0,
            pickTime: 0,
            pickCount: 0,
            gpuTime: 0,
            gpuTimePerFrame: 0,
            cpuTime: 0,
            cpuTimePerFrame: 0,
            bufferMemory: 0,
            textureMemory: 0,
            renderbufferMemory: 0,
            gpuMemory: 0
        };
        this._metricsCounter = 0;
        this._needsRedraw = 'Initial render';
        this._pickRequest = {
            mode: 'hover',
            x: -1,
            y: -1,
            radius: 0,
            event: null
        };
        /**
         * Pick and store the object under the pointer on `pointerdown`.
         * This object is reused for subsequent `onClick` and `onDrag*` callbacks.
         */ this._lastPointerDownInfo = null;
        // The `pointermove` event may fire multiple times in between two animation frames,
        // it's a waste of time to run picking without rerender. Instead we save the last pick
        // request and only do it once on the next animation frame.
        /** Internal use only: event handler for pointerdown */ this._onPointerMove = (event)=>{
            const { _pickRequest } = this;
            if (event.type === 'pointerleave') {
                _pickRequest.x = -1;
                _pickRequest.y = -1;
                _pickRequest.radius = 0;
            } else if (event.leftButton || event.rightButton) // Do not trigger onHover callbacks if mouse button is down.
            return;
            else {
                const pos = event.offsetCenter;
                // Do not trigger callbacks when click/hover position is invalid. Doing so will cause a
                // assertion error when attempting to unproject the position.
                if (!pos) return;
                _pickRequest.x = pos.x;
                _pickRequest.y = pos.y;
                _pickRequest.radius = this.props.pickingRadius;
            }
            if (this.layerManager) this.layerManager.context.mousePosition = {
                x: _pickRequest.x,
                y: _pickRequest.y
            };
            _pickRequest.event = event;
        };
        /** Internal use only: event handler for click & drag */ this._onEvent = (event)=>{
            const eventHandlerProp = (0, _constantsJs.EVENT_HANDLERS)[event.type];
            const pos = event.offsetCenter;
            if (!eventHandlerProp || !pos || !this.layerManager) return;
            // Reuse last picked object
            const layers = this.layerManager.getLayers();
            const info = this.deckPicker.getLastPickedObject({
                x: pos.x,
                y: pos.y,
                layers,
                viewports: this.getViewports(pos)
            }, this._lastPointerDownInfo);
            const { layer } = info;
            const layerHandler = layer && (layer[eventHandlerProp] || layer.props[eventHandlerProp]);
            const rootHandler = this.props[eventHandlerProp];
            let handled = false;
            if (layerHandler) handled = layerHandler.call(layer, info, event);
            if (!handled) {
                rootHandler?.(info, event);
                this.widgetManager.onEvent(info, event);
            }
        };
        /** Internal use only: evnet handler for pointerdown */ this._onPointerDown = (event)=>{
            // TODO(ibgreen) Picking not yet supported on WebGPU
            if (this.device?.type === 'webgpu') return;
            const pos = event.offsetCenter;
            const pickedInfo = this._pick('pickObject', 'pickObject Time', {
                x: pos.x,
                y: pos.y,
                radius: this.props.pickingRadius
            });
            this._lastPointerDownInfo = pickedInfo.result[0] || pickedInfo.emptyInfo;
        };
        // @ts-ignore views
        this.props = {
            ...defaultProps,
            ...props
        };
        props = this.props;
        if (props.viewState && props.initialViewState) (0, _logJsDefault.default).warn('View state tracking is disabled. Use either `initialViewState` for auto update or `viewState` for manual update.')();
        this.viewState = this.props.initialViewState;
        // See if we already have a device
        if (props.device) this.device = props.device;
        let deviceOrPromise = this.device;
        // Attach a new luma.gl device to a WebGL2 context if supplied
        if (!deviceOrPromise && props.gl) {
            if (props.gl instanceof WebGLRenderingContext) (0, _logJsDefault.default).error('WebGL1 context not supported.')();
            deviceOrPromise = (0, _webgl.webgl2Adapter).attach(props.gl);
        }
        // Create a new device
        if (!deviceOrPromise) // Create the "best" device supported from the registered adapters
        deviceOrPromise = (0, _core.luma).createDevice({
            type: 'best-available',
            // luma by default throws if a device is already attached
            // asynchronous device creation could happen after finalize() is called
            // TODO - createDevice should support AbortController?
            _reuseDevices: true,
            adapters: [
                (0, _webgl.webgl2Adapter)
            ],
            ...props.deviceProps,
            createCanvasContext: {
                canvas: this._createCanvas(props),
                useDevicePixels: this.props.useDevicePixels,
                // TODO v9.2 - replace AnimationLoop's `autoResizeDrawingBuffer` with CanvasContext's `autoResize`
                autoResize: false
            }
        });
        this.animationLoop = this._createAnimationLoop(deviceOrPromise, props);
        this.setProps(props);
        // UNSAFE/experimental prop: only set at initialization to avoid performance hit
        if (props._typedArrayManagerProps) (0, _typedArrayManagerJsDefault.default).setOptions(props._typedArrayManagerProps);
        this.animationLoop.start();
    }
    /** Stop rendering and dispose all resources */ finalize() {
        this.animationLoop?.stop();
        this.animationLoop?.destroy();
        this.animationLoop = null;
        this._lastPointerDownInfo = null;
        this.layerManager?.finalize();
        this.layerManager = null;
        this.viewManager?.finalize();
        this.viewManager = null;
        this.effectManager?.finalize();
        this.effectManager = null;
        this.deckRenderer?.finalize();
        this.deckRenderer = null;
        this.deckPicker?.finalize();
        this.deckPicker = null;
        this.eventManager?.destroy();
        this.eventManager = null;
        this.widgetManager?.finalize();
        this.widgetManager = null;
        if (!this.props.canvas && !this.props.device && !this.props.gl && this.canvas) {
            // remove internally created canvas
            this.canvas.parentElement?.removeChild(this.canvas);
            this.canvas = null;
        }
    }
    /** Partially update props */ setProps(props) {
        this.stats.get('setProps Time').timeStart();
        if ('onLayerHover' in props) (0, _logJsDefault.default).removed('onLayerHover', 'onHover')();
        if ('onLayerClick' in props) (0, _logJsDefault.default).removed('onLayerClick', 'onClick')();
        if (props.initialViewState && // depth = 3 when comparing viewStates: viewId.position.0
        !(0, _deepEqualJs.deepEqual)(this.props.initialViewState, props.initialViewState, 3)) // Overwrite internal view state
        this.viewState = props.initialViewState;
        // Merge with existing props
        Object.assign(this.props, props);
        // Update CSS size of canvas
        this._setCanvasSize(this.props);
        // We need to overwrite CSS style width and height with actual, numeric values
        const resolvedProps = Object.create(this.props);
        Object.assign(resolvedProps, {
            views: this._getViews(),
            width: this.width,
            height: this.height,
            viewState: this._getViewState()
        });
        // Update the animation loop
        this.animationLoop?.setProps(resolvedProps);
        // If initialized, update sub manager props
        if (this.layerManager) {
            this.viewManager.setProps(resolvedProps);
            // Make sure that any new layer gets initialized with the current viewport
            this.layerManager.activateViewport(this.getViewports()[0]);
            this.layerManager.setProps(resolvedProps);
            this.effectManager.setProps(resolvedProps);
            this.deckRenderer.setProps(resolvedProps);
            this.deckPicker.setProps(resolvedProps);
            this.widgetManager.setProps(resolvedProps);
        }
        this.stats.get('setProps Time').timeEnd();
    }
    // Public API
    /**
     * Check if a redraw is needed
     * @returns `false` or a string summarizing the redraw reason
     */ needsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        if (!this.layerManager) // Not initialized or already finalized
        return false;
        if (this.props._animate) return 'Deck._animate';
        let redraw = this._needsRedraw;
        if (opts.clearRedrawFlags) this._needsRedraw = false;
        const viewManagerNeedsRedraw = this.viewManager.needsRedraw(opts);
        const layerManagerNeedsRedraw = this.layerManager.needsRedraw(opts);
        const effectManagerNeedsRedraw = this.effectManager.needsRedraw(opts);
        const deckRendererNeedsRedraw = this.deckRenderer.needsRedraw(opts);
        redraw = redraw || viewManagerNeedsRedraw || layerManagerNeedsRedraw || effectManagerNeedsRedraw || deckRendererNeedsRedraw;
        return redraw;
    }
    /**
     * Redraw the GL context
     * @param reason If not provided, only redraw if deemed necessary. Otherwise redraw regardless of internal states.
     * @returns
     */ redraw(reason) {
        if (!this.layerManager) // Not yet initialized
        return;
        // Check if we need to redraw
        let redrawReason = this.needsRedraw({
            clearRedrawFlags: true
        });
        // User-supplied should take precedent, however the redraw flags get cleared regardless
        redrawReason = reason || redrawReason;
        if (!redrawReason) return;
        this.stats.get('Redraw Count').incrementCount();
        if (this.props._customRender) this.props._customRender(redrawReason);
        else this._drawLayers(redrawReason);
    }
    /** Flag indicating that the Deck instance has initialized its resources and it's safe to call public methods. */ get isInitialized() {
        return this.viewManager !== null;
    }
    /** Get a list of views that are currently rendered */ getViews() {
        (0, _assertJsDefault.default)(this.viewManager);
        return this.viewManager.views;
    }
    /** Get a list of viewports that are currently rendered.
     * @param rect If provided, only returns viewports within the given bounding box.
     */ getViewports(rect) {
        (0, _assertJsDefault.default)(this.viewManager);
        return this.viewManager.getViewports(rect);
    }
    /** Get the current canvas element. */ getCanvas() {
        return this.canvas;
    }
    /** Query the object rendered on top at a given point */ pickObject(opts) {
        const infos = this._pick('pickObject', 'pickObject Time', opts).result;
        return infos.length ? infos[0] : null;
    }
    /* Query all rendered objects at a given point */ pickMultipleObjects(opts) {
        opts.depth = opts.depth || 10;
        return this._pick('pickObject', 'pickMultipleObjects Time', opts).result;
    }
    /* Query all objects rendered on top within a bounding box */ pickObjects(opts) {
        return this._pick('pickObjects', 'pickObjects Time', opts);
    }
    /** Experimental
     * Add a global resource for sharing among layers
     */ _addResources(resources, forceUpdate = false) {
        for(const id in resources)this.layerManager.resourceManager.add({
            resourceId: id,
            data: resources[id],
            forceUpdate
        });
    }
    /** Experimental
     * Remove a global resource
     */ _removeResources(resourceIds) {
        for (const id of resourceIds)this.layerManager.resourceManager.remove(id);
    }
    /** Experimental
     * Register a default effect. Effects will be sorted by order, those with a low order will be rendered first
     */ _addDefaultEffect(effect) {
        this.effectManager.addDefaultEffect(effect);
    }
    _addDefaultShaderModule(module) {
        this.layerManager.addDefaultShaderModule(module);
    }
    _removeDefaultShaderModule(module) {
        this.layerManager?.removeDefaultShaderModule(module);
    }
    _pick(method, statKey, opts) {
        (0, _assertJsDefault.default)(this.deckPicker);
        const { stats } = this;
        stats.get('Pick Count').incrementCount();
        stats.get(statKey).timeStart();
        const infos = this.deckPicker[method]({
            // layerManager, viewManager and effectManager are always defined if deckPicker is
            layers: this.layerManager.getLayers(opts),
            views: this.viewManager.getViews(),
            viewports: this.getViewports(opts),
            onViewportActive: this.layerManager.activateViewport,
            effects: this.effectManager.getEffects(),
            ...opts
        });
        stats.get(statKey).timeEnd();
        return infos;
    }
    /** Resolve props.canvas to element */ _createCanvas(props) {
        let canvas = props.canvas;
        // TODO EventManager should accept element id
        if (typeof canvas === 'string') {
            canvas = document.getElementById(canvas);
            (0, _assertJsDefault.default)(canvas);
        }
        if (!canvas) {
            canvas = document.createElement('canvas');
            canvas.id = props.id || 'deckgl-overlay';
            const parent = props.parent || document.body;
            parent.appendChild(canvas);
        }
        Object.assign(canvas.style, props.style);
        return canvas;
    }
    /** Updates canvas width and/or height, if provided as props */ _setCanvasSize(props) {
        if (!this.canvas) return;
        const { width, height } = props;
        // Set size ONLY if props are being provided, otherwise let canvas be layouted freely
        if (width || width === 0) {
            const cssWidth = Number.isFinite(width) ? `${width}px` : width;
            this.canvas.style.width = cssWidth;
        }
        if (height || height === 0) {
            const cssHeight = Number.isFinite(height) ? `${height}px` : height;
            // Note: position==='absolute' required for height 100% to work
            this.canvas.style.position = props.style?.position || 'absolute';
            this.canvas.style.height = cssHeight;
        }
    }
    /** If canvas size has changed, reads out the new size and update */ _updateCanvasSize() {
        const { canvas } = this;
        if (!canvas) return;
        // Fallback to width/height when clientWidth/clientHeight are undefined (OffscreenCanvas).
        const newWidth = canvas.clientWidth ?? canvas.width;
        const newHeight = canvas.clientHeight ?? canvas.height;
        if (newWidth !== this.width || newHeight !== this.height) {
            // @ts-expect-error private assign to read-only property
            this.width = newWidth;
            // @ts-expect-error private assign to read-only property
            this.height = newHeight;
            this.viewManager?.setProps({
                width: newWidth,
                height: newHeight
            });
            // Make sure that any new layer gets initialized with the current viewport
            this.layerManager?.activateViewport(this.getViewports()[0]);
            this.props.onResize({
                width: newWidth,
                height: newHeight
            });
        }
    }
    _createAnimationLoop(deviceOrPromise, props) {
        const { // width,
        // height,
        gl, // debug,
        onError, // onBeforeRender,
        // onAfterRender,
        useDevicePixels } = props;
        return new (0, _engine.AnimationLoop)({
            device: deviceOrPromise,
            useDevicePixels,
            // TODO v9
            autoResizeDrawingBuffer: !gl,
            autoResizeViewport: false,
            // @ts-expect-error luma.gl needs to accept Promise<void> return value
            onInitialize: (context)=>this._setDevice(context.device),
            onRender: this._onRenderFrame.bind(this),
            // @ts-expect-error typing mismatch: AnimationLoop does not accept onError:null
            onError
        });
    }
    // Get the most relevant view state: props.viewState, if supplied, shadows internal viewState
    // TODO: For backwards compatibility ensure numeric width and height is added to the viewState
    _getViewState() {
        return this.props.viewState || this.viewState;
    }
    // Get the view descriptor list
    _getViews() {
        const { views } = this.props;
        const normalizedViews = Array.isArray(views) ? views : views ? [
            views
        ] : [
            new (0, _mapViewJsDefault.default)({
                id: 'default-view'
            })
        ];
        if (normalizedViews.length && this.props.controller) // Backward compatibility: support controller prop
        normalizedViews[0].props.controller = this.props.controller;
        return normalizedViews;
    }
    _onContextLost() {
        const { onError } = this.props;
        if (this.animationLoop && onError) onError(new Error('WebGL context is lost'));
    }
    /** Actually run picking */ _pickAndCallback() {
        if (this.device?.type === 'webgpu') return;
        const { _pickRequest } = this;
        if (_pickRequest.event) {
            // Perform picking
            const { result, emptyInfo } = this._pick('pickObject', 'pickObject Time', _pickRequest);
            this.cursorState.isHovering = result.length > 0;
            // There are 4 possible scenarios:
            // result is [outInfo, pickedInfo] (moved from one pickable layer to another)
            // result is [outInfo] (moved outside of a pickable layer)
            // result is [pickedInfo] (moved into or over a pickable layer)
            // result is [] (nothing is or was picked)
            //
            // `layer.props.onHover` should be called on all affected layers (out/over)
            // `deck.props.onHover` should be called with the picked info if any, or empty info otherwise
            // `deck.props.getTooltip` should be called with the picked info if any, or empty info otherwise
            // Execute callbacks
            let pickedInfo = emptyInfo;
            let handled = false;
            for (const info of result){
                pickedInfo = info;
                handled = info.layer?.onHover(info, _pickRequest.event) || handled;
            }
            if (!handled) {
                this.props.onHover?.(pickedInfo, _pickRequest.event);
                this.widgetManager.onHover(pickedInfo, _pickRequest.event);
            }
            // Clear pending pickRequest
            _pickRequest.event = null;
        }
    }
    _updateCursor() {
        const container = this.props.parent || this.canvas;
        if (container) container.style.cursor = this.props.getCursor(this.cursorState);
    }
    _setDevice(device) {
        this.device = device;
        if (!this.animationLoop) // finalize() has been called
        return;
        // if external context...
        if (!this.canvas) this.canvas = this.device.canvasContext?.canvas;
        if (this.device.type === 'webgl') this.device.setParametersWebGL({
            blend: true,
            blendFunc: [
                770,
                771,
                1,
                771
            ],
            polygonOffsetFill: true,
            depthTest: true,
            depthFunc: 515
        });
        this.props.onDeviceInitialized(this.device);
        if (this.device.type === 'webgl') // Legacy callback - warn?
        // @ts-expect-error gl is not visible on Device base class
        this.props.onWebGLInitialized(this.device.gl);
        // timeline for transitions
        const timeline = new (0, _engine.Timeline)();
        timeline.play();
        this.animationLoop.attachTimeline(timeline);
        this.eventManager = new (0, _mjolnirJs.EventManager)(this.props.parent || this.canvas, {
            touchAction: this.props.touchAction,
            recognizers: Object.keys((0, _constantsJs.RECOGNIZERS)).map((eventName)=>{
                // Resolve recognizer settings
                const [RecognizerConstructor, defaultOptions, recognizeWith, requestFailure] = (0, _constantsJs.RECOGNIZERS)[eventName];
                const optionsOverride = this.props.eventRecognizerOptions?.[eventName];
                const options = {
                    ...defaultOptions,
                    ...optionsOverride,
                    event: eventName
                };
                return {
                    recognizer: new RecognizerConstructor(options),
                    recognizeWith,
                    requestFailure
                };
            }),
            events: {
                pointerdown: this._onPointerDown,
                pointermove: this._onPointerMove,
                pointerleave: this._onPointerMove
            }
        });
        for(const eventType in 0, _constantsJs.EVENT_HANDLERS)this.eventManager.on(eventType, this._onEvent);
        this.viewManager = new (0, _viewManagerJsDefault.default)({
            timeline,
            eventManager: this.eventManager,
            onViewStateChange: this._onViewStateChange.bind(this),
            onInteractionStateChange: this._onInteractionStateChange.bind(this),
            views: this._getViews(),
            viewState: this._getViewState(),
            width: this.width,
            height: this.height
        });
        // viewManager must be initialized before layerManager
        // layerManager depends on viewport created by viewManager.
        const viewport = this.viewManager.getViewports()[0];
        // Note: avoid React setState due GL animation loop / setState timing issue
        this.layerManager = new (0, _layerManagerJsDefault.default)(this.device, {
            deck: this,
            stats: this.stats,
            viewport,
            timeline
        });
        this.effectManager = new (0, _effectManagerJsDefault.default)({
            deck: this,
            device: this.device
        });
        this.deckRenderer = new (0, _deckRendererJsDefault.default)(this.device);
        this.deckPicker = new (0, _deckPickerJsDefault.default)(this.device);
        this.widgetManager = new (0, _widgetManagerJs.WidgetManager)({
            deck: this,
            parentElement: this.canvas?.parentElement
        });
        this.widgetManager.addDefault(new (0, _tooltipJsDefault.default)());
        this.setProps(this.props);
        this._updateCanvasSize();
        this.props.onLoad();
    }
    /** Internal only: default render function (redraw all layers and views) */ _drawLayers(redrawReason, renderOptions) {
        const { device, gl } = this.layerManager.context;
        this.props.onBeforeRender({
            device,
            gl
        });
        const opts = {
            target: this.props._framebuffer,
            layers: this.layerManager.getLayers(),
            viewports: this.viewManager.getViewports(),
            onViewportActive: this.layerManager.activateViewport,
            views: this.viewManager.getViews(),
            pass: 'screen',
            effects: this.effectManager.getEffects(),
            ...renderOptions
        };
        this.deckRenderer?.renderLayers(opts);
        if (opts.pass === 'screen') // This method could be called when drawing to picking buffer, texture etc.
        // Only when drawing to screen, update all widgets (UI components)
        this.widgetManager.onRedraw({
            viewports: opts.viewports,
            layers: opts.layers
        });
        this.props.onAfterRender({
            device,
            gl
        });
    }
    // Callbacks
    _onRenderFrame() {
        this._getFrameStats();
        // Log perf stats every second
        if (this._metricsCounter++ % 60 === 0) {
            this._getMetrics();
            this.stats.reset();
            (0, _logJsDefault.default).table(4, this.metrics)();
            // Experimental: report metrics
            if (this.props._onMetrics) this.props._onMetrics(this.metrics);
        }
        this._updateCanvasSize();
        this._updateCursor();
        // Update layers if needed (e.g. some async prop has loaded)
        // Note: This can trigger a redraw
        this.layerManager.updateLayers();
        // Perform picking request if any
        // TODO(ibgreen): Picking not yet supported on WebGPU
        if (this.device?.type !== 'webgpu') this._pickAndCallback();
        // Redraw if necessary
        this.redraw();
        // Update viewport transition if needed
        // Note: this can trigger `onViewStateChange`, and affect layers
        // We want to defer these changes to the next frame
        if (this.viewManager) this.viewManager.updateViewStates();
    }
    // Callbacks
    _onViewStateChange(params) {
        // Let app know that view state is changing, and give it a chance to change it
        const viewState = this.props.onViewStateChange(params) || params.viewState;
        // If initialViewState was set on creation, auto track position
        if (this.viewState) {
            this.viewState = {
                ...this.viewState,
                [params.viewId]: viewState
            };
            if (!this.props.viewState) // Apply internal view state
            {
                if (this.viewManager) this.viewManager.setProps({
                    viewState: this.viewState
                });
            }
        }
    }
    _onInteractionStateChange(interactionState) {
        this.cursorState.isDragging = interactionState.isDragging || false;
        this.props.onInteractionStateChange(interactionState);
    }
    _getFrameStats() {
        const { stats } = this;
        stats.get('frameRate').timeEnd();
        stats.get('frameRate').timeStart();
        // Get individual stats from luma.gl so reset works
        const animationLoopStats = this.animationLoop.stats;
        stats.get('GPU Time').addTime(animationLoopStats.get('GPU Time').lastTiming);
        stats.get('CPU Time').addTime(animationLoopStats.get('CPU Time').lastTiming);
    }
    _getMetrics() {
        const { metrics, stats } = this;
        metrics.fps = stats.get('frameRate').getHz();
        metrics.setPropsTime = stats.get('setProps Time').time;
        metrics.updateAttributesTime = stats.get('Update Attributes').time;
        metrics.framesRedrawn = stats.get('Redraw Count').count;
        metrics.pickTime = stats.get('pickObject Time').time + stats.get('pickMultipleObjects Time').time + stats.get('pickObjects Time').time;
        metrics.pickCount = stats.get('Pick Count').count;
        // Luma stats
        metrics.gpuTime = stats.get('GPU Time').time;
        metrics.cpuTime = stats.get('CPU Time').time;
        metrics.gpuTimePerFrame = stats.get('GPU Time').getAverageTime();
        metrics.cpuTimePerFrame = stats.get('CPU Time').getAverageTime();
        const memoryStats = (0, _core.luma).stats.get('Memory Usage');
        metrics.bufferMemory = memoryStats.get('Buffer Memory').count;
        metrics.textureMemory = memoryStats.get('Texture Memory').count;
        metrics.renderbufferMemory = memoryStats.get('Renderbuffer Memory').count;
        metrics.gpuMemory = memoryStats.get('GPU Memory').count;
    }
}
Deck.defaultProps = defaultProps;
// This is used to defeat tree shaking of init.js
// https://github.com/visgl/deck.gl/issues/3213
Deck.VERSION = (0, _initJs.VERSION);
exports.default = Deck;

},{"./layer-manager.js":"k2sZX","./view-manager.js":"1dmVF","../views/map-view.js":"eBM7P","./effect-manager.js":"7jWxM","./deck-renderer.js":"idBfW","./deck-picker.js":"kXNG9","./widget-manager.js":"2nxq8","./tooltip.js":"1nqYZ","../utils/log.js":"9S0lD","../utils/deep-equal.js":"1MkgV","../utils/typed-array-manager.js":"6eAB3","./init.js":"i151I","@luma.gl/core":"7TxCR","@luma.gl/webgl":"9NtH7","@luma.gl/engine":"joT4s","@luma.gl/constants":"9mN7r","@probe.gl/stats":"GKYog","mjolnir.js":"hECWP","../utils/assert.js":"3Sh37","./constants.js":"k6l9N","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"k2sZX":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _engine = require("@luma.gl/engine");
var _indexJs = require("../shaderlib/index.js");
var _constantsJs = require("../lifecycle/constants.js");
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _indexJs1 = require("../debug/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _flattenJs = require("../utils/flatten.js");
var _stats = require("@probe.gl/stats");
var _resourceManagerJs = require("./resource/resource-manager.js");
var _resourceManagerJsDefault = parcelHelpers.interopDefault(_resourceManagerJs);
var _viewportJs = require("../viewports/viewport.js");
var _viewportJsDefault = parcelHelpers.interopDefault(_viewportJs);
const TRACE_SET_LAYERS = 'layerManager.setLayers';
const TRACE_ACTIVATE_VIEWPORT = 'layerManager.activateViewport';
class LayerManager {
    /**
     * @param device
     * @param param1
     */ // eslint-disable-next-line
    constructor(device, props){
        this._lastRenderedLayers = [];
        this._needsRedraw = false;
        this._needsUpdate = false;
        this._nextLayers = null;
        this._debug = false;
        // This flag is separate from _needsUpdate because it can be set during an update and should trigger another full update
        this._defaultShaderModulesChanged = false;
        //
        // INTERNAL METHODS
        //
        /** Make a viewport "current" in layer context, updating viewportChanged flags */ this.activateViewport = (viewport)=>{
            (0, _indexJsDefault.default)(TRACE_ACTIVATE_VIEWPORT, this, viewport);
            if (viewport) this.context.viewport = viewport;
        };
        const { deck, stats, viewport, timeline } = props || {};
        // Currently deck.gl expects the DeckGL.layers array to be different
        // whenever React rerenders. If the same layers array is used, the
        // LayerManager's diffing algorithm will generate a fatal error and
        // break the rendering.
        // `this._lastRenderedLayers` stores the UNFILTERED layers sent
        // down to LayerManager, so that `layers` reference can be compared.
        // If it's the same across two React render calls, the diffing logic
        // will be skipped.
        this.layers = [];
        this.resourceManager = new (0, _resourceManagerJsDefault.default)({
            device,
            protocol: 'deck://'
        });
        this.context = {
            mousePosition: null,
            userData: {},
            layerManager: this,
            device,
            // @ts-expect-error
            gl: device?.gl,
            deck,
            shaderAssembler: (0, _indexJs.getShaderAssembler)(device?.info?.shadingLanguage || 'glsl'),
            defaultShaderModules: [
                (0, _indexJs.layerUniforms)
            ],
            renderPass: undefined,
            stats: stats || new (0, _stats.Stats)({
                id: 'deck.gl'
            }),
            // Make sure context.viewport is not empty on the first layer initialization
            viewport: viewport || new (0, _viewportJsDefault.default)({
                id: 'DEFAULT-INITIAL-VIEWPORT'
            }),
            timeline: timeline || new (0, _engine.Timeline)(),
            resourceManager: this.resourceManager,
            onError: undefined
        };
        Object.seal(this);
    }
    /** Method to call when the layer manager is not needed anymore. */ finalize() {
        this.resourceManager.finalize();
        // Finalize all layers
        for (const layer of this.layers)this._finalizeLayer(layer);
    }
    /** Check if a redraw is needed */ needsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        let redraw = this._needsRedraw;
        if (opts.clearRedrawFlags) this._needsRedraw = false;
        // This layers list doesn't include sublayers, relying on composite layers
        for (const layer of this.layers){
            // Call every layer to clear their flags
            const layerNeedsRedraw = layer.getNeedsRedraw(opts);
            redraw = redraw || layerNeedsRedraw;
        }
        return redraw;
    }
    /** Check if a deep update of all layers is needed */ needsUpdate() {
        if (this._nextLayers && this._nextLayers !== this._lastRenderedLayers) // New layers array may be the same as the old one if `setProps` is called by React
        return 'layers changed';
        if (this._defaultShaderModulesChanged) return 'shader modules changed';
        return this._needsUpdate;
    }
    /** Layers will be redrawn (in next animation frame) */ setNeedsRedraw(reason) {
        this._needsRedraw = this._needsRedraw || reason;
    }
    /** Layers will be updated deeply (in next animation frame)
      Potentially regenerating attributes and sub layers */ setNeedsUpdate(reason) {
        this._needsUpdate = this._needsUpdate || reason;
    }
    /** Gets a list of currently rendered layers. Optionally filter by id. */ getLayers({ layerIds } = {}) {
        // Filtering by layerId compares beginning of strings, so that sublayers will be included
        // Dependes on the convention of adding suffixes to the parent's layer name
        return layerIds ? this.layers.filter((layer)=>layerIds.find((layerId)=>layer.id.indexOf(layerId) === 0)) : this.layers;
    }
    /** Set props needed for layer rendering and picking. */ setProps(props) {
        if ('debug' in props) this._debug = props.debug;
        // A way for apps to add data to context that can be accessed in layers
        if ('userData' in props) this.context.userData = props.userData;
        // New layers will be processed in `updateLayers` in the next update cycle
        if ('layers' in props) this._nextLayers = props.layers;
        if ('onError' in props) this.context.onError = props.onError;
    }
    /** Supply a new layer list, initiating sublayer generation and layer matching */ setLayers(newLayers, reason) {
        (0, _indexJsDefault.default)(TRACE_SET_LAYERS, this, reason, newLayers);
        this._lastRenderedLayers = newLayers;
        const flatLayers = (0, _flattenJs.flatten)(newLayers, Boolean);
        for (const layer of flatLayers)layer.context = this.context;
        this._updateLayers(this.layers, flatLayers);
    }
    /** Update layers from last cycle if `setNeedsUpdate()` has been called */ updateLayers() {
        // NOTE: For now, even if only some layer has changed, we update all layers
        // to ensure that layer id maps etc remain consistent even if different
        // sublayers are rendered
        const reason = this.needsUpdate();
        if (reason) {
            this.setNeedsRedraw(`updating layers: ${reason}`);
            // Force a full update
            this.setLayers(this._nextLayers || this._lastRenderedLayers, reason);
        }
        // Updated, clear the backlog
        this._nextLayers = null;
    }
    /** Register a default shader module */ addDefaultShaderModule(module) {
        const { defaultShaderModules } = this.context;
        if (!defaultShaderModules.find((m)=>m.name === module.name)) {
            defaultShaderModules.push(module);
            this._defaultShaderModulesChanged = true;
        }
    }
    /** Deregister a default shader module */ removeDefaultShaderModule(module) {
        const { defaultShaderModules } = this.context;
        const i = defaultShaderModules.findIndex((m)=>m.name === module.name);
        if (i >= 0) {
            defaultShaderModules.splice(i, 1);
            this._defaultShaderModulesChanged = true;
        }
    }
    _handleError(stage, error, layer) {
        layer.raiseError(error, `${stage} of ${layer}`);
    }
    // TODO - mark layers with exceptions as bad and remove from rendering cycle?
    /** Match all layers, checking for caught errors
      to avoid having an exception in one layer disrupt other layers */ _updateLayers(oldLayers, newLayers) {
        // Create old layer map
        const oldLayerMap = {};
        for (const oldLayer of oldLayers)if (oldLayerMap[oldLayer.id]) (0, _logJsDefault.default).warn(`Multiple old layers with same id ${oldLayer.id}`)();
        else oldLayerMap[oldLayer.id] = oldLayer;
        if (this._defaultShaderModulesChanged) {
            for (const layer of oldLayers){
                layer.setNeedsUpdate();
                layer.setChangeFlags({
                    extensionsChanged: true
                });
            }
            this._defaultShaderModulesChanged = false;
        }
        // Allocate array for generated layers
        const generatedLayers = [];
        // Match sublayers
        this._updateSublayersRecursively(newLayers, oldLayerMap, generatedLayers);
        // Finalize unmatched layers
        this._finalizeOldLayers(oldLayerMap);
        let needsUpdate = false;
        for (const layer of generatedLayers)if (layer.hasUniformTransition()) {
            needsUpdate = `Uniform transition in ${layer}`;
            break;
        }
        this._needsUpdate = needsUpdate;
        this.layers = generatedLayers;
    }
    /* eslint-disable complexity,max-statements */ // Note: adds generated layers to `generatedLayers` array parameter
    _updateSublayersRecursively(newLayers, oldLayerMap, generatedLayers) {
        for (const newLayer of newLayers){
            newLayer.context = this.context;
            // Given a new coming layer, find its matching old layer (if any)
            const oldLayer = oldLayerMap[newLayer.id];
            if (oldLayer === null) // null, rather than undefined, means this id was originally there
            (0, _logJsDefault.default).warn(`Multiple new layers with same id ${newLayer.id}`)();
            // Remove the old layer from candidates, as it has been matched with this layer
            oldLayerMap[newLayer.id] = null;
            let sublayers = null;
            // We must not generate exceptions until after layer matching is complete
            try {
                if (this._debug && oldLayer !== newLayer) newLayer.validateProps();
                if (!oldLayer) this._initializeLayer(newLayer);
                else {
                    this._transferLayerState(oldLayer, newLayer);
                    this._updateLayer(newLayer);
                }
                generatedLayers.push(newLayer);
                // Call layer lifecycle method: render sublayers
                sublayers = newLayer.isComposite ? newLayer.getSubLayers() : null;
            // End layer lifecycle method: render sublayers
            } catch (err) {
                this._handleError('matching', err, newLayer); // Record first exception
            }
            if (sublayers) this._updateSublayersRecursively(sublayers, oldLayerMap, generatedLayers);
        }
    }
    /* eslint-enable complexity,max-statements */ // Finalize any old layers that were not matched
    _finalizeOldLayers(oldLayerMap) {
        for(const layerId in oldLayerMap){
            const layer = oldLayerMap[layerId];
            if (layer) this._finalizeLayer(layer);
        }
    }
    // / EXCEPTION SAFE LAYER ACCESS
    /** Safely initializes a single layer, calling layer methods */ _initializeLayer(layer) {
        try {
            layer._initialize();
            layer.lifecycle = (0, _constantsJs.LIFECYCLE).INITIALIZED;
        } catch (err) {
            this._handleError('initialization', err, layer);
        // TODO - what should the lifecycle state be here? LIFECYCLE.INITIALIZATION_FAILED?
        }
    }
    /** Transfer state from one layer to a newer version */ _transferLayerState(oldLayer, newLayer) {
        newLayer._transferState(oldLayer);
        newLayer.lifecycle = (0, _constantsJs.LIFECYCLE).MATCHED;
        if (newLayer !== oldLayer) oldLayer.lifecycle = (0, _constantsJs.LIFECYCLE).AWAITING_GC;
    }
    /** Safely updates a single layer, cleaning all flags */ _updateLayer(layer) {
        try {
            layer._update();
        } catch (err) {
            this._handleError('update', err, layer);
        }
    }
    /** Safely finalizes a single layer, removing all resources */ _finalizeLayer(layer) {
        this._needsRedraw = this._needsRedraw || `finalized ${layer}`;
        layer.lifecycle = (0, _constantsJs.LIFECYCLE).AWAITING_FINALIZATION;
        try {
            layer._finalize();
            layer.lifecycle = (0, _constantsJs.LIFECYCLE).FINALIZED;
        } catch (err) {
            this._handleError('finalization', err, layer);
        }
    }
}
exports.default = LayerManager;

},{"@luma.gl/engine":"joT4s","../shaderlib/index.js":"1z7oa","../lifecycle/constants.js":"1XIxh","../utils/log.js":"9S0lD","../debug/index.js":"7gIzA","../utils/flatten.js":"8GYLR","@probe.gl/stats":"GKYog","./resource/resource-manager.js":"3Eq9V","../viewports/viewport.js":"9yrml","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"joT4s":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// luma.gl Engine API
// Animation
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timeline", ()=>(0, _timelineJs.Timeline));
parcelHelpers.export(exports, "KeyFrames", ()=>(0, _keyFramesJs.KeyFrames));
parcelHelpers.export(exports, "AnimationLoopTemplate", ()=>(0, _animationLoopTemplateJs.AnimationLoopTemplate));
parcelHelpers.export(exports, "AnimationLoop", ()=>(0, _animationLoopJs.AnimationLoop));
parcelHelpers.export(exports, "makeAnimationLoop", ()=>(0, _makeAnimationLoopJs.makeAnimationLoop));
parcelHelpers.export(exports, "Model", ()=>(0, _modelJs.Model));
parcelHelpers.export(exports, "BufferTransform", ()=>(0, _bufferTransformJs.BufferTransform));
parcelHelpers.export(exports, "TextureTransform", ()=>(0, _textureTransformJs.TextureTransform));
parcelHelpers.export(exports, "PipelineFactory", ()=>(0, _pipelineFactoryJs.PipelineFactory));
parcelHelpers.export(exports, "ShaderFactory", ()=>(0, _shaderFactoryJs.ShaderFactory));
parcelHelpers.export(exports, "ClipSpace", ()=>(0, _clipSpaceJs.ClipSpace));
parcelHelpers.export(exports, "BackgroundTextureModel", ()=>(0, _billboardTextureModelJs.BackgroundTextureModel));
// Scenegraph Core nodes
parcelHelpers.export(exports, "ScenegraphNode", ()=>(0, _scenegraphNodeJs.ScenegraphNode));
parcelHelpers.export(exports, "GroupNode", ()=>(0, _groupNodeJs.GroupNode));
parcelHelpers.export(exports, "ModelNode", ()=>(0, _modelNodeJs.ModelNode));
parcelHelpers.export(exports, "Geometry", ()=>(0, _geometryJs.Geometry));
parcelHelpers.export(exports, "GPUGeometry", ()=>(0, _gpuGeometryJs.GPUGeometry));
parcelHelpers.export(exports, "ConeGeometry", ()=>(0, _coneGeometryJs.ConeGeometry));
parcelHelpers.export(exports, "CubeGeometry", ()=>(0, _cubeGeometryJs.CubeGeometry));
parcelHelpers.export(exports, "CylinderGeometry", ()=>(0, _cylinderGeometryJs.CylinderGeometry));
parcelHelpers.export(exports, "IcoSphereGeometry", ()=>(0, _icoSphereGeometryJs.IcoSphereGeometry));
parcelHelpers.export(exports, "PlaneGeometry", ()=>(0, _planeGeometryJs.PlaneGeometry));
parcelHelpers.export(exports, "SphereGeometry", ()=>(0, _sphereGeometryJs.SphereGeometry));
parcelHelpers.export(exports, "TruncatedConeGeometry", ()=>(0, _truncatedConeGeometryJs.TruncatedConeGeometry));
parcelHelpers.export(exports, "ShaderInputs", ()=>(0, _shaderInputsJs.ShaderInputs));
// Application Utilities
parcelHelpers.export(exports, "makeRandomGenerator", ()=>(0, _randomJs.makeRandomGenerator));
parcelHelpers.export(exports, "setPathPrefix", ()=>(0, _loadFileJs.setPathPrefix));
parcelHelpers.export(exports, "loadImage", ()=>(0, _loadFileJs.loadImage));
parcelHelpers.export(exports, "loadImageBitmap", ()=>(0, _loadFileJs.loadImageBitmap));
parcelHelpers.export(exports, "ShaderPassRenderer", ()=>(0, _shaderPassRendererJs.ShaderPassRenderer));
parcelHelpers.export(exports, "Swap", ()=>(0, _swapJs.Swap));
parcelHelpers.export(exports, "SwapBuffers", ()=>(0, _swapJs.SwapBuffers));
parcelHelpers.export(exports, "SwapFramebuffers", ()=>(0, _swapJs.SwapFramebuffers));
parcelHelpers.export(exports, "Computation", ()=>(0, _computationJs.Computation));
parcelHelpers.export(exports, "AsyncTexture", ()=>(0, _asyncTextureJs.AsyncTexture));
parcelHelpers.export(exports, "PickingManager", ()=>(0, _pickingManagerJs.PickingManager));
parcelHelpers.export(exports, "indexPicking", ()=>(0, _indexPickingJs.picking));
parcelHelpers.export(exports, "colorPicking", ()=>(0, _colorPickingJs.picking));
parcelHelpers.export(exports, "requestAnimationFramePolyfill", ()=>(0, _requestAnimationFrameJs.requestAnimationFramePolyfill));
parcelHelpers.export(exports, "cancelAnimationFramePolyfill", ()=>(0, _requestAnimationFrameJs.cancelAnimationFramePolyfill));
// DEPRECATED
parcelHelpers.export(exports, "LegacyPickingManager", ()=>(0, _legacyPickingManagerJs.LegacyPickingManager));
var _timelineJs = require("./animation/timeline.js");
var _keyFramesJs = require("./animation/key-frames.js");
var _animationLoopTemplateJs = require("./animation-loop/animation-loop-template.js");
var _animationLoopJs = require("./animation-loop/animation-loop.js");
var _makeAnimationLoopJs = require("./animation-loop/make-animation-loop.js");
var _modelJs = require("./model/model.js");
var _bufferTransformJs = require("./compute/buffer-transform.js");
var _textureTransformJs = require("./compute/texture-transform.js");
var _pipelineFactoryJs = require("./factories/pipeline-factory.js");
var _shaderFactoryJs = require("./factories/shader-factory.js");
var _clipSpaceJs = require("./models/clip-space.js");
var _billboardTextureModelJs = require("./models/billboard-texture-model.js");
var _scenegraphNodeJs = require("./scenegraph/scenegraph-node.js");
var _groupNodeJs = require("./scenegraph/group-node.js");
var _modelNodeJs = require("./scenegraph/model-node.js");
var _geometryJs = require("./geometry/geometry.js");
var _gpuGeometryJs = require("./geometry/gpu-geometry.js");
var _coneGeometryJs = require("./geometries/cone-geometry.js");
var _cubeGeometryJs = require("./geometries/cube-geometry.js");
var _cylinderGeometryJs = require("./geometries/cylinder-geometry.js");
var _icoSphereGeometryJs = require("./geometries/ico-sphere-geometry.js");
var _planeGeometryJs = require("./geometries/plane-geometry.js");
var _sphereGeometryJs = require("./geometries/sphere-geometry.js");
var _truncatedConeGeometryJs = require("./geometries/truncated-cone-geometry.js");
var _shaderInputsJs = require("./shader-inputs.js");
var _randomJs = require("./application-utils/random.js");
var _loadFileJs = require("./application-utils/load-file.js");
var _shaderPassRendererJs = require("./passes/shader-pass-renderer.js");
var _swapJs = require("./compute/swap.js");
var _computationJs = require("./compute/computation.js");
var _asyncTextureJs = require("./async-texture/async-texture.js");
var _pickingManagerJs = require("./modules/picking/picking-manager.js");
var _indexPickingJs = require("./modules/picking/index-picking.js");
var _colorPickingJs = require("./modules/picking/color-picking.js");
var _requestAnimationFrameJs = require("./animation-loop/request-animation-frame.js");
var _legacyPickingManagerJs = require("./modules/picking/legacy-picking-manager.js");

},{"./animation/timeline.js":"azbcl","./animation/key-frames.js":false,"./animation-loop/animation-loop-template.js":false,"./animation-loop/animation-loop.js":"d2lhb","./animation-loop/make-animation-loop.js":false,"./model/model.js":"iuKtW","./compute/buffer-transform.js":"fC0JD","./compute/texture-transform.js":false,"./factories/pipeline-factory.js":false,"./factories/shader-factory.js":false,"./models/clip-space.js":false,"./models/billboard-texture-model.js":false,"./scenegraph/scenegraph-node.js":false,"./scenegraph/group-node.js":false,"./scenegraph/model-node.js":false,"./geometry/geometry.js":"boguL","./geometry/gpu-geometry.js":false,"./geometries/cone-geometry.js":false,"./geometries/cube-geometry.js":false,"./geometries/cylinder-geometry.js":false,"./geometries/ico-sphere-geometry.js":false,"./geometries/plane-geometry.js":false,"./geometries/sphere-geometry.js":false,"./geometries/truncated-cone-geometry.js":false,"./shader-inputs.js":false,"./application-utils/random.js":false,"./application-utils/load-file.js":false,"./passes/shader-pass-renderer.js":false,"./compute/swap.js":false,"./compute/computation.js":false,"./async-texture/async-texture.js":false,"./modules/picking/picking-manager.js":false,"./modules/picking/index-picking.js":false,"./modules/picking/color-picking.js":false,"./animation-loop/request-animation-frame.js":false,"./modules/picking/legacy-picking-manager.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"azbcl":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timeline", ()=>Timeline);
let channelHandles = 1;
let animationHandles = 1;
class Timeline {
    time = 0;
    channels = new Map();
    animations = new Map();
    playing = false;
    lastEngineTime = -1;
    constructor(){}
    addChannel(props) {
        const { delay = 0, duration = Number.POSITIVE_INFINITY, rate = 1, repeat = 1 } = props;
        const channelId = channelHandles++;
        const channel = {
            time: 0,
            delay,
            duration,
            rate,
            repeat
        };
        this._setChannelTime(channel, this.time);
        this.channels.set(channelId, channel);
        return channelId;
    }
    removeChannel(channelId) {
        this.channels.delete(channelId);
        for (const [animationHandle, animation] of this.animations)if (animation.channel === channelId) this.detachAnimation(animationHandle);
    }
    isFinished(channelId) {
        const channel = this.channels.get(channelId);
        if (channel === undefined) return false;
        return this.time >= channel.delay + channel.duration * channel.repeat;
    }
    getTime(channelId) {
        if (channelId === undefined) return this.time;
        const channel = this.channels.get(channelId);
        if (channel === undefined) return -1;
        return channel.time;
    }
    setTime(time) {
        this.time = Math.max(0, time);
        const channels = this.channels.values();
        for (const channel of channels)this._setChannelTime(channel, this.time);
        const animations = this.animations.values();
        for (const animationData of animations){
            const { animation, channel } = animationData;
            animation.setTime(this.getTime(channel));
        }
    }
    play() {
        this.playing = true;
    }
    pause() {
        this.playing = false;
        this.lastEngineTime = -1;
    }
    reset() {
        this.setTime(0);
    }
    attachAnimation(animation, channelHandle) {
        const animationHandle = animationHandles++;
        this.animations.set(animationHandle, {
            animation,
            channel: channelHandle
        });
        animation.setTime(this.getTime(channelHandle));
        return animationHandle;
    }
    detachAnimation(channelId) {
        this.animations.delete(channelId);
    }
    update(engineTime) {
        if (this.playing) {
            if (this.lastEngineTime === -1) this.lastEngineTime = engineTime;
            this.setTime(this.time + (engineTime - this.lastEngineTime));
            this.lastEngineTime = engineTime;
        }
    }
    _setChannelTime(channel, time) {
        const offsetTime = time - channel.delay;
        const totalDuration = channel.duration * channel.repeat;
        // Note(Tarek): Don't loop on final repeat.
        if (offsetTime >= totalDuration) channel.time = channel.duration * channel.rate;
        else {
            channel.time = Math.max(0, offsetTime) % channel.duration;
            channel.time *= channel.rate;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"d2lhb":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Convenient animation loop */ parcelHelpers.export(exports, "AnimationLoop", ()=>AnimationLoop);
var _core = require("@luma.gl/core");
var _requestAnimationFrameJs = require("./request-animation-frame.js");
var _stats = require("@probe.gl/stats");
let statIdCounter = 0;
const DEFAULT_ANIMATION_LOOP_PROPS = {
    device: null,
    onAddHTML: ()=>'',
    onInitialize: async ()=>{
        return null;
    },
    onRender: ()=>{},
    onFinalize: ()=>{},
    onError: (error)=>console.error(error),
    stats: (0, _core.luma).stats.get(`animation-loop-${statIdCounter++}`),
    // view parameters
    useDevicePixels: true,
    autoResizeViewport: false,
    autoResizeDrawingBuffer: false
};
class AnimationLoop {
    device = null;
    canvas = null;
    props;
    animationProps = null;
    timeline = null;
    stats;
    cpuTime;
    gpuTime;
    frameRate;
    display;
    needsRedraw = 'initialized';
    _initialized = false;
    _running = false;
    _animationFrameId = null;
    _nextFramePromise = null;
    _resolveNextFrame = null;
    _cpuStartTime = 0;
    _error = null;
    // _gpuTimeQuery: Query | null = null;
    /*
     * @param {HTMLCanvasElement} canvas - if provided, width and height will be passed to context
     */ constructor(props){
        this.props = {
            ...DEFAULT_ANIMATION_LOOP_PROPS,
            ...props
        };
        props = this.props;
        if (!props.device) throw new Error('No device provided');
        const { useDevicePixels = true } = this.props;
        // state
        this.stats = props.stats || new (0, _stats.Stats)({
            id: 'animation-loop-stats'
        });
        this.cpuTime = this.stats.get('CPU Time');
        this.gpuTime = this.stats.get('GPU Time');
        this.frameRate = this.stats.get('Frame Rate');
        this.setProps({
            autoResizeViewport: props.autoResizeViewport,
            autoResizeDrawingBuffer: props.autoResizeDrawingBuffer,
            useDevicePixels
        });
        // Bind methods
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this._onMousemove = this._onMousemove.bind(this);
        this._onMouseleave = this._onMouseleave.bind(this);
    }
    destroy() {
        this.stop();
        this._setDisplay(null);
    }
    /** @deprecated Use .destroy() */ delete() {
        this.destroy();
    }
    setError(error) {
        this.props.onError(error);
        this._error = Error();
        const canvas = this.device?.canvasContext?.canvas;
        if (canvas instanceof HTMLCanvasElement) {
            const errorDiv = document.createElement('h1');
            errorDiv.innerHTML = error.message;
            errorDiv.style.position = 'absolute';
            errorDiv.style.top = '20%'; // left: 50%; transform: translate(-50%, -50%);';
            errorDiv.style.left = '10px';
            errorDiv.style.color = 'black';
            errorDiv.style.backgroundColor = 'red';
            document.body.appendChild(errorDiv);
        // canvas.style.position = 'absolute';
        }
    }
    /** Flags this animation loop as needing redraw */ setNeedsRedraw(reason) {
        this.needsRedraw = this.needsRedraw || reason;
        return this;
    }
    /** TODO - move these props to CanvasContext? */ setProps(props) {
        if ('autoResizeViewport' in props) this.props.autoResizeViewport = props.autoResizeViewport || false;
        if ('autoResizeDrawingBuffer' in props) this.props.autoResizeDrawingBuffer = props.autoResizeDrawingBuffer || false;
        if ('useDevicePixels' in props) this.props.useDevicePixels = props.useDevicePixels || false;
        return this;
    }
    /** Starts a render loop if not already running */ async start() {
        if (this._running) return this;
        this._running = true;
        try {
            let appContext;
            if (!this._initialized) {
                this._initialized = true;
                // Create the WebGL context
                await this._initDevice();
                this._initialize();
                // Note: onIntialize can return a promise (e.g. in case app needs to load resources)
                await this.props.onInitialize(this._getAnimationProps());
            }
            // check that we haven't been stopped
            if (!this._running) return null;
            // Start the loop
            if (appContext !== false) {
                // cancel any pending renders to ensure only one loop can ever run
                this._cancelAnimationFrame();
                this._requestAnimationFrame();
            }
            return this;
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            this.props.onError(error);
            // this._running = false; // TODO
            throw error;
        }
    }
    /** Stops a render loop if already running, finalizing */ stop() {
        // console.debug(`Stopping ${this.constructor.name}`);
        if (this._running) {
            // call callback
            // If stop is called immediately, we can end up in a state where props haven't been initialized...
            if (this.animationProps && !this._error) this.props.onFinalize(this.animationProps);
            this._cancelAnimationFrame();
            this._nextFramePromise = null;
            this._resolveNextFrame = null;
            this._running = false;
        }
        return this;
    }
    /** Explicitly draw a frame */ redraw() {
        if (this.device?.isLost || this._error) return this;
        this._beginFrameTimers();
        this._setupFrame();
        this._updateAnimationProps();
        this._renderFrame(this._getAnimationProps());
        // clear needsRedraw flag
        this._clearNeedsRedraw();
        if (this._resolveNextFrame) {
            this._resolveNextFrame(this);
            this._nextFramePromise = null;
            this._resolveNextFrame = null;
        }
        this._endFrameTimers();
        return this;
    }
    /** Add a timeline, it will be automatically updated by the animation loop. */ attachTimeline(timeline) {
        this.timeline = timeline;
        return this.timeline;
    }
    /** Remove a timeline */ detachTimeline() {
        this.timeline = null;
    }
    /** Wait until a render completes */ waitForRender() {
        this.setNeedsRedraw('waitForRender');
        if (!this._nextFramePromise) this._nextFramePromise = new Promise((resolve)=>{
            this._resolveNextFrame = resolve;
        });
        return this._nextFramePromise;
    }
    /** TODO - should use device.deviceContext */ async toDataURL() {
        this.setNeedsRedraw('toDataURL');
        await this.waitForRender();
        if (this.canvas instanceof HTMLCanvasElement) return this.canvas.toDataURL();
        throw new Error('OffscreenCanvas');
    }
    // PRIVATE METHODS
    _initialize() {
        this._startEventHandling();
        // Initialize the callback data
        this._initializeAnimationProps();
        this._updateAnimationProps();
        // Default viewport setup, in case onInitialize wants to render
        this._resizeCanvasDrawingBuffer();
        this._resizeViewport();
    // this._gpuTimeQuery = Query.isSupported(this.gl, ['timers']) ? new Query(this.gl) : null;
    }
    _setDisplay(display) {
        if (this.display) {
            this.display.destroy();
            this.display.animationLoop = null;
        }
        // store animation loop on the display
        if (display) display.animationLoop = this;
        this.display = display;
    }
    _requestAnimationFrame() {
        if (!this._running) return;
        // VR display has a separate animation frame to sync with headset
        // TODO WebVR API discontinued, replaced by WebXR: https://immersive-web.github.io/webxr/
        // See https://developer.mozilla.org/en-US/docs/Web/API/VRDisplay/requestAnimationFrame
        // if (this.display && this.display.requestAnimationFrame) {
        //   this._animationFrameId = this.display.requestAnimationFrame(this._animationFrame.bind(this));
        // }
        this._animationFrameId = (0, _requestAnimationFrameJs.requestAnimationFramePolyfill)(this._animationFrame.bind(this));
    }
    _cancelAnimationFrame() {
        if (this._animationFrameId === null) return;
        // VR display has a separate animation frame to sync with headset
        // TODO WebVR API discontinued, replaced by WebXR: https://immersive-web.github.io/webxr/
        // See https://developer.mozilla.org/en-US/docs/Web/API/VRDisplay/requestAnimationFrame
        // if (this.display && this.display.cancelAnimationFramePolyfill) {
        //   this.display.cancelAnimationFrame(this._animationFrameId);
        // }
        (0, _requestAnimationFrameJs.cancelAnimationFramePolyfill)(this._animationFrameId);
        this._animationFrameId = null;
    }
    _animationFrame() {
        if (!this._running) return;
        this.redraw();
        this._requestAnimationFrame();
    }
    // Called on each frame, can be overridden to call onRender multiple times
    // to support e.g. stereoscopic rendering
    _renderFrame(animationProps) {
        // Allow e.g. VR display to render multiple frames.
        if (this.display) {
            this.display._renderFrame(animationProps);
            return;
        }
        // call callback
        this.props.onRender(this._getAnimationProps());
        // end callback
        // Submit commands (necessary on WebGPU)
        this.device?.submit();
    }
    _clearNeedsRedraw() {
        this.needsRedraw = false;
    }
    _setupFrame() {
        this._resizeCanvasDrawingBuffer();
        this._resizeViewport();
    }
    // Initialize the  object that will be passed to app callbacks
    _initializeAnimationProps() {
        const canvas = this.device?.canvasContext?.canvas;
        if (!this.device || !canvas) throw new Error('loop');
        this.animationProps = {
            animationLoop: this,
            device: this.device,
            canvas,
            timeline: this.timeline,
            // Initial values
            useDevicePixels: this.props.useDevicePixels,
            needsRedraw: false,
            // Placeholders
            width: 1,
            height: 1,
            aspect: 1,
            // Animation props
            time: 0,
            startTime: Date.now(),
            engineTime: 0,
            tick: 0,
            tock: 0,
            // Experimental
            _mousePosition: null // Event props
        };
    }
    _getAnimationProps() {
        if (!this.animationProps) throw new Error('animationProps');
        return this.animationProps;
    }
    // Update the context object that will be passed to app callbacks
    _updateAnimationProps() {
        if (!this.animationProps) return;
        // Can this be replaced with canvas context?
        const { width, height, aspect } = this._getSizeAndAspect();
        if (width !== this.animationProps.width || height !== this.animationProps.height) this.setNeedsRedraw('drawing buffer resized');
        if (aspect !== this.animationProps.aspect) this.setNeedsRedraw('drawing buffer aspect changed');
        this.animationProps.width = width;
        this.animationProps.height = height;
        this.animationProps.aspect = aspect;
        this.animationProps.needsRedraw = this.needsRedraw;
        // Update time properties
        this.animationProps.engineTime = Date.now() - this.animationProps.startTime;
        if (this.timeline) this.timeline.update(this.animationProps.engineTime);
        this.animationProps.tick = Math.floor(this.animationProps.time / 1000 * 60);
        this.animationProps.tock++;
        // For back compatibility
        this.animationProps.time = this.timeline ? this.timeline.getTime() : this.animationProps.engineTime;
    }
    /** Wait for supplied device */ async _initDevice() {
        this.device = await this.props.device;
        if (!this.device) throw new Error('No device provided');
        this.canvas = this.device.canvasContext?.canvas || null;
    // this._createInfoDiv();
    }
    _createInfoDiv() {
        if (this.canvas && this.props.onAddHTML) {
            const wrapperDiv = document.createElement('div');
            document.body.appendChild(wrapperDiv);
            wrapperDiv.style.position = 'relative';
            const div = document.createElement('div');
            div.style.position = 'absolute';
            div.style.left = '10px';
            div.style.bottom = '10px';
            div.style.width = '300px';
            div.style.background = 'white';
            if (this.canvas instanceof HTMLCanvasElement) wrapperDiv.appendChild(this.canvas);
            wrapperDiv.appendChild(div);
            const html = this.props.onAddHTML(div);
            if (html) div.innerHTML = html;
        }
    }
    _getSizeAndAspect() {
        if (!this.device) return {
            width: 1,
            height: 1,
            aspect: 1
        };
        // https://webglfundamentals.org/webgl/lessons/webgl-resizing-the-canvas.html
        const [width, height] = this.device?.canvasContext?.getPixelSize() || [
            1,
            1
        ];
        // https://webglfundamentals.org/webgl/lessons/webgl-anti-patterns.html
        let aspect = 1;
        const canvas = this.device?.canvasContext?.canvas;
        // @ts-expect-error
        if (canvas && canvas.clientHeight) // @ts-expect-error
        aspect = canvas.clientWidth / canvas.clientHeight;
        else if (width > 0 && height > 0) aspect = width / height;
        return {
            width,
            height,
            aspect
        };
    }
    /** Default viewport setup */ _resizeViewport() {
        // TODO can we use canvas context to code this in a portable way?
        // @ts-expect-error Expose on canvasContext
        if (this.props.autoResizeViewport && this.device.gl) // @ts-expect-error Expose canvasContext
        this.device.gl.viewport(0, 0, // @ts-expect-error Expose canvasContext
        this.device.gl.drawingBufferWidth, // @ts-expect-error Expose canvasContext
        this.device.gl.drawingBufferHeight);
    }
    /**
     * Resize the render buffer of the canvas to match canvas client size
     * Optionally multiplying with devicePixel ratio
     */ _resizeCanvasDrawingBuffer() {
        if (this.props.autoResizeDrawingBuffer) this.device?.canvasContext?.resize({
            useDevicePixels: this.props.useDevicePixels
        });
    }
    _beginFrameTimers() {
        this.frameRate.timeEnd();
        this.frameRate.timeStart();
        // Check if timer for last frame has completed.
        // GPU timer results are never available in the same
        // frame they are captured.
        // if (
        //   this._gpuTimeQuery &&
        //   this._gpuTimeQuery.isResultAvailable() &&
        //   !this._gpuTimeQuery.isTimerDisjoint()
        // ) {
        //   this.stats.get('GPU Time').addTime(this._gpuTimeQuery.getTimerMilliseconds());
        // }
        // if (this._gpuTimeQuery) {
        //   // GPU time query start
        //   this._gpuTimeQuery.beginTimeElapsedQuery();
        // }
        this.cpuTime.timeStart();
    }
    _endFrameTimers() {
        this.cpuTime.timeEnd();
    // if (this._gpuTimeQuery) {
    //   // GPU time query end. Results will be available on next frame.
    //   this._gpuTimeQuery.end();
    // }
    }
    // Event handling
    _startEventHandling() {
        if (this.canvas) {
            this.canvas.addEventListener('mousemove', this._onMousemove.bind(this));
            this.canvas.addEventListener('mouseleave', this._onMouseleave.bind(this));
        }
    }
    _onMousemove(event) {
        if (event instanceof MouseEvent) this._getAnimationProps()._mousePosition = [
            event.offsetX,
            event.offsetY
        ];
    }
    _onMouseleave(event) {
        this._getAnimationProps()._mousePosition = null;
    }
}

},{"@luma.gl/core":"7TxCR","./request-animation-frame.js":"dsEpO","@probe.gl/stats":"GKYog","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dsEpO":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* global window, setTimeout, clearTimeout */ /** Node.js polyfill for requestAnimationFrame */ // / <reference types="@types/node" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestAnimationFramePolyfill", ()=>requestAnimationFramePolyfill);
/** Node.js polyfill for cancelAnimationFrame */ parcelHelpers.export(exports, "cancelAnimationFramePolyfill", ()=>cancelAnimationFramePolyfill);
function requestAnimationFramePolyfill(callback) {
    return typeof window !== 'undefined' && window.requestAnimationFrame ? window.requestAnimationFrame(callback) : setTimeout(callback, 1000 / 60);
}
function cancelAnimationFramePolyfill(timerId) {
    return typeof window !== 'undefined' && window.cancelAnimationFrame ? window.cancelAnimationFrame(timerId) : clearTimeout(timerId);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iuKtW":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * v9 Model API
 * A model
 * - automatically reuses pipelines (programs) when possible
 * - automatically rebuilds pipelines if necessary to accommodate changed settings
 * shadertools integration
 * - accepts modules and performs shader transpilation
 */ parcelHelpers.export(exports, "Model", ()=>Model);
// HELPERS
/** Create a shadertools platform info from the Device */ parcelHelpers.export(exports, "getPlatformInfo", ()=>getPlatformInfo);
var _core = require("@luma.gl/core");
var _shadertools = require("@luma.gl/shadertools");
var _gpuGeometryJs = require("../geometry/gpu-geometry.js");
var _pipelineFactoryJs = require("../factories/pipeline-factory.js");
var _shaderFactoryJs = require("../factories/shader-factory.js");
var _debugShaderLayoutJs = require("../debug/debug-shader-layout.js");
var _debugFramebufferJs = require("../debug/debug-framebuffer.js");
var _deepEqualJs = require("../utils/deep-equal.js");
var _uidJs = require("../utils/uid.js");
var _shaderInputsJs = require("../shader-inputs.js");
// import type {AsyncTextureProps} from '../async-texture/async-texture';
var _asyncTextureJs = require("../async-texture/async-texture.js");
var _splitUniformsAndBindingsJs = require("./split-uniforms-and-bindings.js");
const LOG_DRAW_PRIORITY = 2;
const LOG_DRAW_TIMEOUT = 10000;
class Model {
    static defaultProps = {
        ...(0, _core.RenderPipeline).defaultProps,
        source: undefined,
        vs: null,
        fs: null,
        id: 'unnamed',
        handle: undefined,
        userData: {},
        defines: {},
        modules: [],
        moduleSettings: undefined,
        geometry: null,
        indexBuffer: null,
        attributes: {},
        constantAttributes: {},
        varyings: [],
        isInstanced: undefined,
        instanceCount: 0,
        vertexCount: 0,
        shaderInputs: undefined,
        pipelineFactory: undefined,
        shaderFactory: undefined,
        transformFeedback: undefined,
        shaderAssembler: (0, _shadertools.ShaderAssembler).getDefaultShaderAssembler(),
        debugShaders: undefined,
        disableWarnings: undefined
    };
    device;
    id;
    // @ts-expect-error assigned in function called from constructor
    source;
    // @ts-expect-error assigned in function called from constructor
    vs;
    // @ts-expect-error assigned in function called from constructor
    fs;
    pipelineFactory;
    shaderFactory;
    userData = {};
    // Fixed properties (change can trigger pipeline rebuild)
    /** The render pipeline GPU parameters, depth testing etc */ parameters;
    /** The primitive topology */ topology;
    /** Buffer layout */ bufferLayout;
    // Dynamic properties
    /** Use instanced rendering */ isInstanced = undefined;
    /** instance count. `undefined` means not instanced */ instanceCount = 0;
    /** Vertex count */ vertexCount;
    /** Index buffer */ indexBuffer = null;
    /** Buffer-valued attributes */ bufferAttributes = {};
    /** Constant-valued attributes */ constantAttributes = {};
    /** Bindings (textures, samplers, uniform buffers) */ bindings = {};
    /** Sets uniforms @deprecated Use uniform buffers and setBindings() for portability*/ uniforms = {};
    /**
     * VertexArray
     * @note not implemented: if bufferLayout is updated, vertex array has to be rebuilt!
     * @todo - allow application to define multiple vertex arrays?
     * */ vertexArray;
    /** TransformFeedback, WebGL 2 only. */ transformFeedback = null;
    /** The underlying GPU "program". @note May be recreated if parameters change */ pipeline;
    /** ShaderInputs instance */ // @ts-expect-error Assigned in function called by constructor
    shaderInputs;
    // @ts-expect-error Assigned in function called by constructor
    _uniformStore;
    _attributeInfos = {};
    _gpuGeometry = null;
    _getModuleUniforms;
    props;
    _pipelineNeedsUpdate = 'newly created';
    _needsRedraw = 'initializing';
    _destroyed = false;
    /** "Time" of last draw. Monotonically increasing timestamp */ _lastDrawTimestamp = -1;
    get [Symbol.toStringTag]() {
        return 'Model';
    }
    toString() {
        return `Model(${this.id})`;
    }
    constructor(device, props){
        this.props = {
            ...Model.defaultProps,
            ...props
        };
        props = this.props;
        this.id = props.id || (0, _uidJs.uid)('model');
        this.device = device;
        Object.assign(this.userData, props.userData);
        // Setup shader module inputs
        const moduleMap = Object.fromEntries(this.props.modules?.map((module)=>[
                module.name,
                module
            ]) || []);
        const shaderInputs = props.shaderInputs || new (0, _shaderInputsJs.ShaderInputs)(moduleMap, {
            disableWarnings: this.props.disableWarnings
        });
        // @ts-ignore
        this.setShaderInputs(shaderInputs);
        // Setup shader assembler
        const platformInfo = getPlatformInfo(device);
        // Extract modules from shader inputs if not supplied
        const modules = // @ts-ignore shaderInputs is assigned in setShaderInputs above.
        (this.props.modules?.length > 0 ? this.props.modules : this.shaderInputs?.getModules()) || [];
        const isWebGPU = this.device.type === 'webgpu';
        // WebGPU
        // TODO - hack to support unified WGSL shader
        // TODO - this is wrong, compile a single shader
        if (isWebGPU && this.props.source) {
            // WGSL
            const { source, getUniforms } = this.props.shaderAssembler.assembleWGSLShader({
                platformInfo,
                ...this.props,
                modules
            });
            this.source = source;
            // @ts-expect-error
            this._getModuleUniforms = getUniforms;
            // Extract shader layout after modules have been added to WGSL source, to include any bindings added by modules
            this.props.shaderLayout ||= (0, _shadertools.getShaderLayoutFromWGSL)(this.source);
        } else {
            // GLSL
            const { vs, fs, getUniforms } = this.props.shaderAssembler.assembleGLSLShaderPair({
                platformInfo,
                ...this.props,
                modules
            });
            this.vs = vs;
            this.fs = fs;
            // @ts-expect-error
            this._getModuleUniforms = getUniforms;
        }
        this.vertexCount = this.props.vertexCount;
        this.instanceCount = this.props.instanceCount;
        this.topology = this.props.topology;
        this.bufferLayout = this.props.bufferLayout;
        this.parameters = this.props.parameters;
        // Geometry, if provided, sets topology and vertex cound
        if (props.geometry) this.setGeometry(props.geometry);
        this.pipelineFactory = props.pipelineFactory || (0, _pipelineFactoryJs.PipelineFactory).getDefaultPipelineFactory(this.device);
        this.shaderFactory = props.shaderFactory || (0, _shaderFactoryJs.ShaderFactory).getDefaultShaderFactory(this.device);
        // Create the pipeline
        // @note order is important
        this.pipeline = this._updatePipeline();
        this.vertexArray = device.createVertexArray({
            renderPipeline: this.pipeline
        });
        // Now we can apply geometry attributes
        if (this._gpuGeometry) this._setGeometryAttributes(this._gpuGeometry);
        // Apply any dynamic settings that will not trigger pipeline change
        if ('isInstanced' in props) this.isInstanced = props.isInstanced;
        if (props.instanceCount) this.setInstanceCount(props.instanceCount);
        if (props.vertexCount) this.setVertexCount(props.vertexCount);
        if (props.indexBuffer) this.setIndexBuffer(props.indexBuffer);
        if (props.attributes) this.setAttributes(props.attributes);
        if (props.constantAttributes) this.setConstantAttributes(props.constantAttributes);
        if (props.bindings) this.setBindings(props.bindings);
        if (props.uniforms) this.setUniformsWebGL(props.uniforms);
        if (props.moduleSettings) // log.warn('Model.props.moduleSettings is deprecated. Use Model.shaderInputs.setProps()')();
        this.updateModuleSettingsWebGL(props.moduleSettings);
        if (props.transformFeedback) this.transformFeedback = props.transformFeedback;
        // Catch any access to non-standard props
        Object.seal(this);
    }
    destroy() {
        if (this._destroyed) return;
        this.pipelineFactory.release(this.pipeline);
        this.shaderFactory.release(this.pipeline.vs);
        if (this.pipeline.fs) this.shaderFactory.release(this.pipeline.fs);
        this._uniformStore.destroy();
        // TODO - mark resource as managed and destroyIfManaged() ?
        this._gpuGeometry?.destroy();
        this._destroyed = true;
    }
    // Draw call
    /** Query redraw status. Clears the status. */ needsRedraw() {
        // Catch any writes to already bound resources
        if (this._getBindingsUpdateTimestamp() > this._lastDrawTimestamp) this.setNeedsRedraw('contents of bound textures or buffers updated');
        const needsRedraw = this._needsRedraw;
        this._needsRedraw = false;
        return needsRedraw;
    }
    /** Mark the model as needing a redraw */ setNeedsRedraw(reason) {
        this._needsRedraw ||= reason;
    }
    predraw() {
        // Update uniform buffers if needed
        this.updateShaderInputs();
        // Check if the pipeline is invalidated
        this.pipeline = this._updatePipeline();
    }
    draw(renderPass) {
        const loadingBinding = this._areBindingsLoading();
        if (loadingBinding) {
            (0, _core.log).info(LOG_DRAW_PRIORITY, `>>> DRAWING ABORTED ${this.id}: ${loadingBinding} not loaded`)();
            return false;
        }
        try {
            renderPass.pushDebugGroup(`${this}.predraw(${renderPass})`);
            this.predraw();
        } finally{
            renderPass.popDebugGroup();
        }
        let drawSuccess;
        try {
            renderPass.pushDebugGroup(`${this}.draw(${renderPass})`);
            this._logDrawCallStart();
            // Update the pipeline if invalidated
            // TODO - inside RenderPass is likely the worst place to do this from performance perspective.
            // Application can call Model.predraw() to avoid this.
            this.pipeline = this._updatePipeline();
            // Set pipeline state, we may be sharing a pipeline so we need to set all state on every draw
            // Any caching needs to be done inside the pipeline functions
            // TODO this is a busy initialized check for all bindings every frame
            const syncBindings = this._getBindings();
            this.pipeline.setBindings(syncBindings, {
                disableWarnings: this.props.disableWarnings
            });
            if (!isObjectEmpty(this.uniforms)) this.pipeline.setUniformsWebGL(this.uniforms);
            const { indexBuffer } = this.vertexArray;
            const indexCount = indexBuffer ? indexBuffer.byteLength / (indexBuffer.indexType === 'uint32' ? 4 : 2) : undefined;
            drawSuccess = this.pipeline.draw({
                renderPass,
                vertexArray: this.vertexArray,
                isInstanced: this.isInstanced,
                vertexCount: this.vertexCount,
                instanceCount: this.instanceCount,
                indexCount,
                transformFeedback: this.transformFeedback || undefined,
                // WebGL shares underlying cached pipelines even for models that have different parameters and topology,
                // so we must provide our unique parameters to each draw
                // (In WebGPU most parameters are encoded in the pipeline and cannot be changed per draw call)
                parameters: this.parameters,
                topology: this.topology
            });
        } finally{
            renderPass.popDebugGroup();
            this._logDrawCallEnd();
        }
        this._logFramebuffer(renderPass);
        // Update needsRedraw flag
        if (drawSuccess) {
            this._lastDrawTimestamp = this.device.timestamp;
            this._needsRedraw = false;
        } else this._needsRedraw = 'waiting for resource initialization';
        return drawSuccess;
    }
    // Update fixed fields (can trigger pipeline rebuild)
    /**
     * Updates the optional geometry
     * Geometry, set topology and bufferLayout
     * @note Can trigger a pipeline rebuild / pipeline cache fetch on WebGPU
     */ setGeometry(geometry) {
        this._gpuGeometry?.destroy();
        const gpuGeometry = geometry && (0, _gpuGeometryJs.makeGPUGeometry)(this.device, geometry);
        if (gpuGeometry) {
            this.setTopology(gpuGeometry.topology || 'triangle-list');
            const bufferLayoutHelper = new (0, _core._BufferLayoutHelper)(this.bufferLayout);
            this.bufferLayout = bufferLayoutHelper.mergeBufferLayouts(gpuGeometry.bufferLayout, this.bufferLayout);
            if (this.vertexArray) this._setGeometryAttributes(gpuGeometry);
        }
        this._gpuGeometry = gpuGeometry;
    }
    /**
     * Updates the primitive topology ('triangle-list', 'triangle-strip' etc).
     * @note Triggers a pipeline rebuild / pipeline cache fetch on WebGPU
     */ setTopology(topology) {
        if (topology !== this.topology) {
            this.topology = topology;
            this._setPipelineNeedsUpdate('topology');
        }
    }
    /**
     * Updates the buffer layout.
     * @note Triggers a pipeline rebuild / pipeline cache fetch
     */ setBufferLayout(bufferLayout) {
        const bufferLayoutHelper = new (0, _core._BufferLayoutHelper)(this.bufferLayout);
        this.bufferLayout = this._gpuGeometry ? bufferLayoutHelper.mergeBufferLayouts(bufferLayout, this._gpuGeometry.bufferLayout) : bufferLayout;
        this._setPipelineNeedsUpdate('bufferLayout');
        // Recreate the pipeline
        this.pipeline = this._updatePipeline();
        // vertex array needs to be updated if we update buffer layout,
        // but not if we update parameters
        this.vertexArray = this.device.createVertexArray({
            renderPipeline: this.pipeline
        });
        // Reapply geometry attributes to the new vertex array
        if (this._gpuGeometry) this._setGeometryAttributes(this._gpuGeometry);
    }
    /**
     * Set GPU parameters.
     * @note Can trigger a pipeline rebuild / pipeline cache fetch.
     * @param parameters
     */ setParameters(parameters) {
        if (!(0, _deepEqualJs.deepEqual)(parameters, this.parameters, 2)) {
            this.parameters = parameters;
            this._setPipelineNeedsUpdate('parameters');
        }
    }
    // Update dynamic fields
    /**
     * Updates the instance count (used in draw calls)
     * @note Any attributes with stepMode=instance need to be at least this big
     */ setInstanceCount(instanceCount) {
        this.instanceCount = instanceCount;
        // luma.gl examples don't set props.isInstanced and rely on auto-detection
        // but deck.gl sets instanceCount even for models that are not instanced.
        if (this.isInstanced === undefined && instanceCount > 0) this.isInstanced = true;
        this.setNeedsRedraw('instanceCount');
    }
    /**
     * Updates the vertex count (used in draw calls)
     * @note Any attributes with stepMode=vertex need to be at least this big
     */ setVertexCount(vertexCount) {
        this.vertexCount = vertexCount;
        this.setNeedsRedraw('vertexCount');
    }
    /** Set the shader inputs */ setShaderInputs(shaderInputs) {
        this.shaderInputs = shaderInputs;
        this._uniformStore = new (0, _core.UniformStore)(this.shaderInputs.modules);
        // Create uniform buffer bindings for all modules that actually have uniforms
        for (const [moduleName, module] of Object.entries(this.shaderInputs.modules))if (shaderModuleHasUniforms(module)) {
            const uniformBuffer = this._uniformStore.getManagedUniformBuffer(this.device, moduleName);
            this.bindings[`${moduleName}Uniforms`] = uniformBuffer;
        }
        this.setNeedsRedraw('shaderInputs');
    }
    /** Update uniform buffers from the model's shader inputs */ updateShaderInputs() {
        this._uniformStore.setUniforms(this.shaderInputs.getUniformValues());
        this.setBindings(this.shaderInputs.getBindingValues());
        // TODO - this is already tracked through buffer/texture update times?
        this.setNeedsRedraw('shaderInputs');
    }
    /**
     * Sets bindings (textures, samplers, uniform buffers)
     */ setBindings(bindings) {
        Object.assign(this.bindings, bindings);
        this.setNeedsRedraw('bindings');
    }
    /**
     * Updates optional transform feedback. WebGL only.
     */ setTransformFeedback(transformFeedback) {
        this.transformFeedback = transformFeedback;
        this.setNeedsRedraw('transformFeedback');
    }
    /**
     * Sets the index buffer
     * @todo - how to unset it if we change geometry?
     */ setIndexBuffer(indexBuffer) {
        this.vertexArray.setIndexBuffer(indexBuffer);
        this.setNeedsRedraw('indexBuffer');
    }
    /**
     * Sets attributes (buffers)
     * @note Overrides any attributes previously set with the same name
     */ setAttributes(buffers, options) {
        const disableWarnings = options?.disableWarnings ?? this.props.disableWarnings;
        if (buffers.indices) (0, _core.log).warn(`Model:${this.id} setAttributes() - indexBuffer should be set using setIndexBuffer()`)();
        // ensure bufferLayout order matches source layout so we bind
        // the correct buffers to the correct indices in webgpu.
        this.bufferLayout = (0, _core.sortedBufferLayoutByShaderSourceLocations)(this.pipeline.shaderLayout, this.bufferLayout);
        const bufferLayoutHelper = new (0, _core._BufferLayoutHelper)(this.bufferLayout);
        // Check if all buffers have a layout
        for (const [bufferName, buffer] of Object.entries(buffers)){
            const bufferLayout = bufferLayoutHelper.getBufferLayout(bufferName);
            if (!bufferLayout) {
                if (!disableWarnings) (0, _core.log).warn(`Model(${this.id}): Missing layout for buffer "${bufferName}".`)();
                continue; // eslint-disable-line no-continue
            }
            // In WebGL, for an interleaved attribute we may need to set multiple attributes
            // but in WebGPU, we set it according to the buffer's position in the vertexArray
            const attributeNames = bufferLayoutHelper.getAttributeNamesForBuffer(bufferLayout);
            let set = false;
            for (const attributeName of attributeNames){
                const attributeInfo = this._attributeInfos[attributeName];
                if (attributeInfo) {
                    const location = this.device.type === 'webgpu' ? bufferLayoutHelper.getBufferIndex(attributeInfo.bufferName) : attributeInfo.location;
                    this.vertexArray.setBuffer(location, buffer);
                    set = true;
                }
            }
            if (!set && !disableWarnings) (0, _core.log).warn(`Model(${this.id}): Ignoring buffer "${buffer.id}" for unknown attribute "${bufferName}"`)();
        }
        this.setNeedsRedraw('attributes');
    }
    /**
     * Sets constant attributes
     * @note Overrides any attributes previously set with the same name
     * Constant attributes are only supported in WebGL, not in WebGPU
     * Any attribute that is disabled in the current vertex array object
     * is read from the context's global constant value for that attribute location.
     * @param constantAttributes
     */ setConstantAttributes(attributes, options) {
        for (const [attributeName, value] of Object.entries(attributes)){
            const attributeInfo = this._attributeInfos[attributeName];
            if (attributeInfo) this.vertexArray.setConstantWebGL(attributeInfo.location, value);
            else if (!(options?.disableWarnings ?? this.props.disableWarnings)) (0, _core.log).warn(`Model "${this.id}: Ignoring constant supplied for unknown attribute "${attributeName}"`)();
        }
        this.setNeedsRedraw('constants');
    }
    // DEPRECATED METHODS
    /**
     * Sets individual uniforms
     * @deprecated WebGL only, use uniform buffers for portability
     * @param uniforms
     */ setUniforms(uniforms) {
        this.setUniformsWebGL(uniforms);
    }
    /**
     * Sets individual uniforms
     * @deprecated WebGL only, use uniform buffers for portability
     * @param uniforms
     */ setUniformsWebGL(uniforms) {
        if (!isObjectEmpty(uniforms)) {
            this.pipeline.setUniformsWebGL(uniforms);
            Object.assign(this.uniforms, uniforms);
        }
        this.setNeedsRedraw('uniforms');
    }
    /**
     * @deprecated Updates shader module settings (which results in uniforms being set)
     */ updateModuleSettingsWebGL(props) {
        // log.warn('Model.updateModuleSettings is deprecated. Use Model.shaderInputs.setProps()')();
        const { bindings, uniforms } = (0, _splitUniformsAndBindingsJs.splitUniformsAndBindings)(this._getModuleUniforms(props));
        Object.assign(this.bindings, bindings);
        Object.assign(this.uniforms, uniforms);
        this.setNeedsRedraw('moduleSettings');
    }
    // Internal methods
    /** Check that bindings are loaded. Returns id of first binding that is still loading. */ _areBindingsLoading() {
        for (const binding of Object.values(this.bindings)){
            if (binding instanceof (0, _asyncTextureJs.AsyncTexture) && !binding.isReady) return binding.id;
        }
        return false;
    }
    /** Extracts texture view from loaded async textures. Returns null if any textures have not yet been loaded. */ _getBindings() {
        const validBindings = {};
        for (const [name, binding] of Object.entries(this.bindings)){
            if (binding instanceof (0, _asyncTextureJs.AsyncTexture)) // Check that async textures are loaded
            {
                if (binding.isReady) validBindings[name] = binding.texture;
            } else validBindings[name] = binding;
        }
        return validBindings;
    }
    /** Get the timestamp of the latest updated bound GPU memory resource (buffer/texture). */ _getBindingsUpdateTimestamp() {
        let timestamp = 0;
        for (const binding of Object.values(this.bindings)){
            if (binding instanceof (0, _core.TextureView)) timestamp = Math.max(timestamp, binding.texture.updateTimestamp);
            else if (binding instanceof (0, _core.Buffer) || binding instanceof (0, _core.Texture)) timestamp = Math.max(timestamp, binding.updateTimestamp);
            else if (binding instanceof (0, _asyncTextureJs.AsyncTexture)) timestamp = binding.texture ? Math.max(timestamp, binding.texture.updateTimestamp) : Infinity;
            else if (!(binding instanceof (0, _core.Sampler))) timestamp = Math.max(timestamp, binding.buffer.updateTimestamp);
        }
        return timestamp;
    }
    /**
     * Updates the optional geometry attributes
     * Geometry, sets several attributes, indexBuffer, and also vertex count
     * @note Can trigger a pipeline rebuild / pipeline cache fetch on WebGPU
     */ _setGeometryAttributes(gpuGeometry) {
        // Filter geometry attribute so that we don't issue warnings for unused attributes
        const attributes = {
            ...gpuGeometry.attributes
        };
        for (const [attributeName] of Object.entries(attributes))if (!this.pipeline.shaderLayout.attributes.find((layout)=>layout.name === attributeName) && attributeName !== 'positions') delete attributes[attributeName];
        // TODO - delete previous geometry?
        this.vertexCount = gpuGeometry.vertexCount;
        this.setIndexBuffer(gpuGeometry.indices || null);
        this.setAttributes(gpuGeometry.attributes, {
            disableWarnings: true
        });
        this.setAttributes(attributes, {
            disableWarnings: this.props.disableWarnings
        });
        this.setNeedsRedraw('geometry attributes');
    }
    /** Mark pipeline as needing update */ _setPipelineNeedsUpdate(reason) {
        this._pipelineNeedsUpdate ||= reason;
        this.setNeedsRedraw(reason);
    }
    /** Update pipeline if needed */ _updatePipeline() {
        if (this._pipelineNeedsUpdate) {
            let prevShaderVs = null;
            let prevShaderFs = null;
            if (this.pipeline) {
                (0, _core.log).log(1, `Model ${this.id}: Recreating pipeline because "${this._pipelineNeedsUpdate}".`)();
                prevShaderVs = this.pipeline.vs;
                prevShaderFs = this.pipeline.fs;
            }
            this._pipelineNeedsUpdate = false;
            const vs = this.shaderFactory.createShader({
                id: `${this.id}-vertex`,
                stage: 'vertex',
                source: this.source || this.vs,
                debugShaders: this.props.debugShaders
            });
            let fs = null;
            if (this.source) fs = vs;
            else if (this.fs) fs = this.shaderFactory.createShader({
                id: `${this.id}-fragment`,
                stage: 'fragment',
                source: this.source || this.fs,
                debugShaders: this.props.debugShaders
            });
            this.pipeline = this.pipelineFactory.createRenderPipeline({
                ...this.props,
                bufferLayout: this.bufferLayout,
                topology: this.topology,
                parameters: this.parameters,
                // TODO - why set bindings here when we reset them every frame?
                // Should we expose a BindGroup abstraction?
                bindings: this._getBindings(),
                vs,
                fs
            });
            this._attributeInfos = (0, _core.getAttributeInfosFromLayouts)(this.pipeline.shaderLayout, this.bufferLayout);
            if (prevShaderVs) this.shaderFactory.release(prevShaderVs);
            if (prevShaderFs) this.shaderFactory.release(prevShaderFs);
        }
        return this.pipeline;
    }
    /** Throttle draw call logging */ _lastLogTime = 0;
    _logOpen = false;
    _logDrawCallStart() {
        // IF level is 4 or higher, log every frame.
        const logDrawTimeout = (0, _core.log).level > 3 ? 0 : LOG_DRAW_TIMEOUT;
        if ((0, _core.log).level < 2 || Date.now() - this._lastLogTime < logDrawTimeout) return;
        this._lastLogTime = Date.now();
        this._logOpen = true;
        (0, _core.log).group(LOG_DRAW_PRIORITY, `>>> DRAWING MODEL ${this.id}`, {
            collapsed: (0, _core.log).level <= 2
        })();
    }
    _logDrawCallEnd() {
        if (this._logOpen) {
            const shaderLayoutTable = (0, _debugShaderLayoutJs.getDebugTableForShaderLayout)(this.pipeline.shaderLayout, this.id);
            // log.table(logLevel, attributeTable)();
            // log.table(logLevel, uniformTable)();
            (0, _core.log).table(LOG_DRAW_PRIORITY, shaderLayoutTable)();
            const uniformTable = this.shaderInputs.getDebugTable();
            // Add any global uniforms
            for (const [name, value] of Object.entries(this.uniforms))uniformTable[name] = {
                value
            };
            (0, _core.log).table(LOG_DRAW_PRIORITY, uniformTable)();
            const attributeTable = this._getAttributeDebugTable();
            (0, _core.log).table(LOG_DRAW_PRIORITY, this._attributeInfos)();
            (0, _core.log).table(LOG_DRAW_PRIORITY, attributeTable)();
            (0, _core.log).groupEnd(LOG_DRAW_PRIORITY)();
            this._logOpen = false;
        }
    }
    _drawCount = 0;
    _logFramebuffer(renderPass) {
        const debugFramebuffers = this.device.props.debugFramebuffers;
        this._drawCount++;
        // Update first 3 frames and then every 60 frames
        if (!debugFramebuffers) // } || (this._drawCount++ > 3 && this._drawCount % 60)) {
        return;
        // TODO - display framebuffer output in debug window
        const framebuffer = renderPass.props.framebuffer;
        if (framebuffer) (0, _debugFramebufferJs.debugFramebuffer)(framebuffer, {
            id: framebuffer.id,
            minimap: true
        });
    }
    _getAttributeDebugTable() {
        const table = {};
        for (const [name, attributeInfo] of Object.entries(this._attributeInfos)){
            const values = this.vertexArray.attributes[attributeInfo.location];
            table[attributeInfo.location] = {
                name,
                type: attributeInfo.shaderType,
                values: values ? this._getBufferOrConstantValues(values, attributeInfo.bufferDataType) : 'null'
            };
        }
        if (this.vertexArray.indexBuffer) {
            const { indexBuffer } = this.vertexArray;
            const values = indexBuffer.indexType === 'uint32' ? new Uint32Array(indexBuffer.debugData) : new Uint16Array(indexBuffer.debugData);
            table.indices = {
                name: 'indices',
                type: indexBuffer.indexType,
                values: values.toString()
            };
        }
        return table;
    }
    // TODO - fix typing of luma data types
    _getBufferOrConstantValues(attribute, dataType) {
        const TypedArrayConstructor = (0, _core.getTypedArrayFromDataType)(dataType);
        const typedArray = attribute instanceof (0, _core.Buffer) ? new TypedArrayConstructor(attribute.debugData) : attribute;
        return typedArray.toString();
    }
}
function shaderModuleHasUniforms(module) {
    return Boolean(module.uniformTypes && !isObjectEmpty(module.uniformTypes));
}
function getPlatformInfo(device) {
    return {
        type: device.type,
        shaderLanguage: device.info.shadingLanguage,
        shaderLanguageVersion: device.info.shadingLanguageVersion,
        gpu: device.info.gpu,
        // HACK - we pretend that the DeviceFeatures is a Set, it has a similar API
        features: device.features
    };
}
/** Returns true if given object is empty, false otherwise. */ function isObjectEmpty(obj) {
    // @ts-ignore key is unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for(const key in obj)return false;
    return true;
}

},{"@luma.gl/core":"7TxCR","@luma.gl/shadertools":"iH5G2","../geometry/gpu-geometry.js":"4lM81","../factories/pipeline-factory.js":"g1I5b","../factories/shader-factory.js":"bJQHd","../debug/debug-shader-layout.js":"j0rwp","../debug/debug-framebuffer.js":"iJWZG","../utils/deep-equal.js":"3m9xT","../utils/uid.js":"34Ynl","../shader-inputs.js":"gRC7p","../async-texture/async-texture.js":"8IOpf","./split-uniforms-and-bindings.js":"llbhx","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4lM81":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GPUGeometry", ()=>GPUGeometry);
parcelHelpers.export(exports, "makeGPUGeometry", ()=>makeGPUGeometry);
parcelHelpers.export(exports, "getIndexBufferFromGeometry", ()=>getIndexBufferFromGeometry);
parcelHelpers.export(exports, "getAttributeBuffersFromGeometry", ()=>getAttributeBuffersFromGeometry);
var _core = require("@luma.gl/core");
var _uidJs = require("../utils/uid.js");
class GPUGeometry {
    id;
    userData = {};
    /** Determines how vertices are read from the 'vertex' attributes */ topology;
    bufferLayout = [];
    vertexCount;
    indices;
    attributes;
    constructor(props){
        this.id = props.id || (0, _uidJs.uid)('geometry');
        this.topology = props.topology;
        this.indices = props.indices || null;
        this.attributes = props.attributes;
        this.vertexCount = props.vertexCount;
        this.bufferLayout = props.bufferLayout || [];
        if (this.indices) {
            if (!(this.indices.usage & (0, _core.Buffer).INDEX)) throw new Error('Index buffer must have INDEX usage');
        }
    }
    destroy() {
        this.indices?.destroy();
        for (const attribute of Object.values(this.attributes))attribute.destroy();
    }
    getVertexCount() {
        return this.vertexCount;
    }
    getAttributes() {
        return this.attributes;
    }
    getIndexes() {
        return this.indices || null;
    }
    _calculateVertexCount(positions) {
        // Assume that positions is a fully packed float32x3 buffer
        const vertexCount = positions.byteLength / 12;
        return vertexCount;
    }
}
function makeGPUGeometry(device, geometry) {
    if (geometry instanceof GPUGeometry) return geometry;
    const indices = getIndexBufferFromGeometry(device, geometry);
    const { attributes, bufferLayout } = getAttributeBuffersFromGeometry(device, geometry);
    return new GPUGeometry({
        topology: geometry.topology || 'triangle-list',
        bufferLayout,
        vertexCount: geometry.vertexCount,
        indices,
        attributes
    });
}
function getIndexBufferFromGeometry(device, geometry) {
    if (!geometry.indices) return undefined;
    const data = geometry.indices.value;
    return device.createBuffer({
        usage: (0, _core.Buffer).INDEX,
        data
    });
}
function getAttributeBuffersFromGeometry(device, geometry) {
    const bufferLayout = [];
    const attributes = {};
    for (const [attributeName, attribute] of Object.entries(geometry.attributes)){
        let name = attributeName;
        // TODO Map some GLTF attribute names (is this still needed?)
        switch(attributeName){
            case 'POSITION':
                name = 'positions';
                break;
            case 'NORMAL':
                name = 'normals';
                break;
            case 'TEXCOORD_0':
                name = 'texCoords';
                break;
            case 'COLOR_0':
                name = 'colors';
                break;
        }
        if (attribute) {
            attributes[name] = device.createBuffer({
                data: attribute.value,
                id: `${attributeName}-buffer`
            });
            const { value, size, normalized } = attribute;
            // @ts-expect-error
            bufferLayout.push({
                name,
                format: (0, _core.getVertexFormatFromAttribute)(value, size, normalized)
            });
        }
    }
    const vertexCount = geometry._calculateVertexCount(geometry.attributes, geometry.indices);
    return {
        attributes,
        bufferLayout,
        vertexCount
    };
}

},{"@luma.gl/core":"7TxCR","../utils/uid.js":"34Ynl","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"34Ynl":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a UID.
 * @param id= - Identifier base name
 * @return uid
 **/ parcelHelpers.export(exports, "uid", ()=>uid);
const uidCounters = {};
function uid(id = 'id') {
    uidCounters[id] = uidCounters[id] || 1;
    const count = uidCounters[id]++;
    return `${id}-${count}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"g1I5b":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Efficiently creates / caches pipelines
 */ parcelHelpers.export(exports, "PipelineFactory", ()=>PipelineFactory);
var _core = require("@luma.gl/core");
class PipelineFactory {
    static defaultProps = {
        ...(0, _core.RenderPipeline).defaultProps
    };
    /** Get the singleton default pipeline factory for the specified device */ static getDefaultPipelineFactory(device) {
        device._lumaData.defaultPipelineFactory = device._lumaData.defaultPipelineFactory || new PipelineFactory(device);
        return device._lumaData.defaultPipelineFactory;
    }
    device;
    destroyPolicy;
    _hashCounter = 0;
    _hashes = {};
    _renderPipelineCache = {};
    _computePipelineCache = {};
    constructor(device){
        this.device = device;
        this.destroyPolicy = device.props._factoryDestroyPolicy;
    }
    /** Return a RenderPipeline matching props. Reuses a similar pipeline if already created. */ createRenderPipeline(props) {
        const allProps = {
            ...(0, _core.RenderPipeline).defaultProps,
            ...props
        };
        const hash = this._hashRenderPipeline(allProps);
        if (!this._renderPipelineCache[hash]) {
            const pipeline = this.device.createRenderPipeline({
                ...allProps,
                id: allProps.id ? `${allProps.id}-cached` : undefined
            });
            pipeline.hash = hash;
            this._renderPipelineCache[hash] = {
                pipeline,
                useCount: 0
            };
        }
        this._renderPipelineCache[hash].useCount++;
        return this._renderPipelineCache[hash].pipeline;
    }
    createComputePipeline(props) {
        const allProps = {
            ...(0, _core.ComputePipeline).defaultProps,
            ...props
        };
        const hash = this._hashComputePipeline(allProps);
        if (!this._computePipelineCache[hash]) {
            const pipeline = this.device.createComputePipeline({
                ...allProps,
                id: allProps.id ? `${allProps.id}-cached` : undefined
            });
            pipeline.hash = hash;
            this._computePipelineCache[hash] = {
                pipeline,
                useCount: 0
            };
        }
        this._computePipelineCache[hash].useCount++;
        return this._computePipelineCache[hash].pipeline;
    }
    release(pipeline) {
        const hash = pipeline.hash;
        const cache = pipeline instanceof (0, _core.ComputePipeline) ? this._computePipelineCache : this._renderPipelineCache;
        cache[hash].useCount--;
        if (cache[hash].useCount === 0) {
            if (this.destroyPolicy === 'unused') {
                cache[hash].pipeline.destroy();
                delete cache[hash];
            }
        }
    }
    // PRIVATE
    _hashComputePipeline(props) {
        const shaderHash = this._getHash(props.shader.source);
        return `${shaderHash}`;
    }
    /** Calculate a hash based on all the inputs for a render pipeline */ _hashRenderPipeline(props) {
        const vsHash = props.vs ? this._getHash(props.vs.source) : 0;
        const fsHash = props.fs ? this._getHash(props.fs.source) : 0;
        // WebGL specific
        // const {varyings = [], bufferMode = {}} = props;
        // const varyingHashes = varyings.map((v) => this._getHash(v));
        const varyingHash = '-'; // `${varyingHashes.join('/')}B${bufferMode}`
        const bufferLayoutHash = this._getHash(JSON.stringify(props.bufferLayout));
        switch(this.device.type){
            case 'webgl':
                // WebGL is more dynamic
                return `${vsHash}/${fsHash}V${varyingHash}BL${bufferLayoutHash}`;
            default:
                // On WebGPU we need to rebuild the pipeline if topology, parameters or bufferLayout change
                const parameterHash = this._getHash(JSON.stringify(props.parameters));
                // TODO - Can json.stringify() generate different strings for equivalent objects if order of params is different?
                // create a deepHash() to deduplicate?
                return `${vsHash}/${fsHash}V${varyingHash}T${props.topology}P${parameterHash}BL${bufferLayoutHash}`;
        }
    }
    _getHash(key) {
        if (this._hashes[key] === undefined) this._hashes[key] = this._hashCounter++;
        return this._hashes[key];
    }
}

},{"@luma.gl/core":"7TxCR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bJQHd":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Manages a cached pool of Shaders for reuse. */ parcelHelpers.export(exports, "ShaderFactory", ()=>ShaderFactory);
var _core = require("@luma.gl/core");
class ShaderFactory {
    static defaultProps = {
        ...(0, _core.Shader).defaultProps
    };
    /** Returns the default ShaderFactory for the given {@link Device}, creating one if necessary. */ static getDefaultShaderFactory(device) {
        device._lumaData.defaultShaderFactory ||= new ShaderFactory(device);
        return device._lumaData.defaultShaderFactory;
    }
    device;
    destroyPolicy;
    _cache = {};
    /** @internal */ constructor(device){
        this.device = device;
        this.destroyPolicy = device.props._factoryDestroyPolicy;
    }
    /** Requests a {@link Shader} from the cache, creating a new Shader only if necessary. */ createShader(props) {
        const key = this._hashShader(props);
        let cacheEntry = this._cache[key];
        if (!cacheEntry) {
            const shader = this.device.createShader({
                ...props,
                id: props.id ? `${props.id}-cached` : undefined
            });
            this._cache[key] = cacheEntry = {
                shader,
                useCount: 0
            };
        }
        cacheEntry.useCount++;
        return cacheEntry.shader;
    }
    /** Releases a previously-requested {@link Shader}, destroying it if no users remain. */ release(shader) {
        const key = this._hashShader(shader);
        const cacheEntry = this._cache[key];
        if (cacheEntry) {
            cacheEntry.useCount--;
            if (cacheEntry.useCount === 0) {
                if (this.destroyPolicy === 'unused') {
                    delete this._cache[key];
                    cacheEntry.shader.destroy();
                }
            }
        }
    }
    // PRIVATE
    _hashShader(value) {
        return `${value.stage}:${value.source}`;
    }
}

},{"@luma.gl/core":"7TxCR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"j0rwp":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Extracts a table suitable for `console.table()` from a shader layout to assist in debugging.
 * @param layout shader layout
 * @param name app should provide the most meaningful name, usually the model or pipeline name / id.
 * @returns
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDebugTableForShaderLayout", ()=>getDebugTableForShaderLayout);
function getDebugTableForShaderLayout(layout, name) {
    const table = {};
    const header = 'Values'; // '`Shader Layout for ${name}`;
    if (layout.attributes.length === 0 && !layout.varyings?.length) return {
        'No attributes or varyings': {
            [header]: 'N/A'
        }
    };
    for (const attributeDeclaration of layout.attributes)if (attributeDeclaration) {
        const glslDeclaration = `${attributeDeclaration.location} ${attributeDeclaration.name}: ${attributeDeclaration.type}`;
        table[`in ${glslDeclaration}`] = {
            [header]: attributeDeclaration.stepMode || 'vertex'
        };
    }
    for (const varyingDeclaration of layout.varyings || []){
        const glslDeclaration = `${varyingDeclaration.location} ${varyingDeclaration.name}`;
        table[`out ${glslDeclaration}`] = {
            [header]: JSON.stringify(varyingDeclaration)
        };
    }
    return table;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iJWZG":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// import {copyTextureToImage} from '../debug/copy-texture-to-image';
/** Only works with 1st device? */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// let targetImage: HTMLImageElement | null = null;
/** Debug utility to draw FBO contents onto screen */ // eslint-disable-next-line
parcelHelpers.export(exports, "debugFramebuffer", ()=>debugFramebuffer);
let canvas = null;
let ctx = null;
function debugFramebuffer(fbo, { id, minimap, opaque, top = '0', left = '0', rgbaScale = 1 }) {
    if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.id = id;
        canvas.title = id;
        canvas.style.zIndex = '100';
        canvas.style.position = 'absolute';
        canvas.style.top = top; // ⚠️
        canvas.style.left = left; // ⚠️
        canvas.style.border = 'blue 5px solid';
        canvas.style.transform = 'scaleY(-1)';
        document.body.appendChild(canvas);
        ctx = canvas.getContext('2d');
    // targetImage = new Image();
    }
    // const canvasHeight = (minimap ? 2 : 1) * fbo.height;
    if (canvas.width !== fbo.width || canvas.height !== fbo.height) {
        canvas.width = fbo.width / 2;
        canvas.height = fbo.height / 2;
        canvas.style.width = '400px';
        canvas.style.height = '400px';
    }
    // const image = copyTextureToImage(fbo, {targetMaxHeight: 100, targetImage});
    // ctx.drawImage(image, 0, 0);
    const color = fbo.device.readPixelsToArrayWebGL(fbo);
    const imageData = ctx?.createImageData(fbo.width, fbo.height);
    if (imageData) {
        // Full map
        const offset = 0;
        // if (color.some((v) => v > 0)) {
        //   console.error('THERE IS NON-ZERO DATA IN THE FBO!');
        // }
        for(let i = 0; i < color.length; i += 4){
            imageData.data[offset + i + 0] = color[i + 0] * rgbaScale;
            imageData.data[offset + i + 1] = color[i + 1] * rgbaScale;
            imageData.data[offset + i + 2] = color[i + 2] * rgbaScale;
            imageData.data[offset + i + 3] = opaque ? 255 : color[i + 3] * rgbaScale;
        }
        ctx?.putImageData(imageData, 0, 0);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3m9xT":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Fast partial deep equal for prop.
 *
 * @param a Prop
 * @param b Prop to compare against `a`
 * @param depth Depth to which to recurse in nested Objects/Arrays. Use 0 (default) for shallow comparison, -1 for infinite depth
 */ /* eslint-disable complexity */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
function deepEqual(a, b, depth) {
    if (a === b) return true;
    if (!depth || !a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!deepEqual(a[i], b[i], depth - 1)) return false;
        }
        return true;
    }
    if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!deepEqual(a[key], b[key], depth - 1)) return false;
        }
        return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gRC7p":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ShaderInputs holds uniform and binding values for one or more shader modules,
 * - It can generate binary data for any uniform buffer
 * - It can manage a uniform buffer for each block
 * - It can update managed uniform buffers with a single call
 * - It performs some book keeping on what has changed to minimize unnecessary writes to uniform buffers.
 */ parcelHelpers.export(exports, "ShaderInputs", ()=>ShaderInputs);
var _core = require("@luma.gl/core");
// import type {ShaderUniformType, UniformValue, UniformFormat, UniformInfoDevice, Texture, Sampler} from '@luma.gl/core';
var _shadertools = require("@luma.gl/shadertools");
var _splitUniformsAndBindingsJs = require("./model/split-uniforms-and-bindings.js");
class ShaderInputs {
    options = {
        disableWarnings: false
    };
    /**
     * The map of modules
     * @todo should should this include the resolved dependencies?
     */ // @ts-ignore Fix typings
    modules;
    /** Stores the uniform values for each module */ moduleUniforms;
    /** Stores the uniform bindings for each module  */ moduleBindings;
    /** Tracks if uniforms have changed */ // moduleUniformsChanged: Record<keyof ShaderPropsT, false | string>;
    /**
     * Create a new UniformStore instance
     * @param modules
     */ constructor(// @ts-ignore Fix typings
    modules, options){
        Object.assign(this.options, options);
        // Extract modules with dependencies
        const resolvedModules = (0, _shadertools.getShaderModuleDependencies)(Object.values(modules).filter((module)=>module.dependencies));
        for (const resolvedModule of resolvedModules)// @ts-ignore
        modules[resolvedModule.name] = resolvedModule;
        (0, _core.log).log(1, 'Creating ShaderInputs with modules', Object.keys(modules))();
        // Store the module definitions and create storage for uniform values and binding values, per module
        // @ts-ignore Fix typings
        this.modules = modules;
        this.moduleUniforms = {};
        this.moduleBindings = {};
        // Initialize the modules
        for (const [name, module] of Object.entries(modules)){
            this._addModule(module);
            if (module.name && name !== module.name && !this.options.disableWarnings) (0, _core.log).warn(`Module name: ${name} vs ${module.name}`)();
        }
    }
    /** Destroy */ destroy() {}
    /**
     * Set module props
     */ setProps(props) {
        for (const name of Object.keys(props)){
            const moduleName = name;
            const moduleProps = props[moduleName] || {};
            const module = this.modules[moduleName];
            if (!module) {
                // Ignore props for unregistered modules
                if (!this.options.disableWarnings) (0, _core.log).warn(`Module ${name} not found`)();
                continue; // eslint-disable-line no-continue
            }
            const oldUniforms = this.moduleUniforms[moduleName];
            const oldBindings = this.moduleBindings[moduleName];
            const uniformsAndBindings = module.getUniforms?.(moduleProps, oldUniforms) || moduleProps;
            const { uniforms, bindings } = (0, _splitUniformsAndBindingsJs.splitUniformsAndBindings)(uniformsAndBindings);
            this.moduleUniforms[moduleName] = {
                ...oldUniforms,
                ...uniforms
            };
            this.moduleBindings[moduleName] = {
                ...oldBindings,
                ...bindings
            };
        // this.moduleUniformsChanged ||= moduleName;
        // console.log(`setProps(${String(moduleName)}`, moduleName, this.moduleUniforms[moduleName])
        }
    }
    /**
     * Return the map of modules
     * @todo should should this include the resolved dependencies?
     */ getModules() {
        return Object.values(this.modules);
    }
    /** Get all uniform values for all modules */ getUniformValues() {
        return this.moduleUniforms;
    }
    /** Merges all bindings for the shader (from the various modules) */ getBindingValues() {
        const bindings = {};
        for (const moduleBindings of Object.values(this.moduleBindings))Object.assign(bindings, moduleBindings);
        return bindings;
    }
    // INTERNAL
    /** Return a debug table that can be used for console.table() or log.table() */ getDebugTable() {
        const table = {};
        for (const [moduleName, module] of Object.entries(this.moduleUniforms))for (const [key, value] of Object.entries(module))table[`${moduleName}.${key}`] = {
            type: this.modules[moduleName].uniformTypes?.[key],
            value: String(value)
        };
        return table;
    }
    _addModule(module) {
        const moduleName = module.name;
        // Get default uniforms from module
        this.moduleUniforms[moduleName] = module.defaultUniforms || {};
        this.moduleBindings[moduleName] = {};
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/shadertools":"iH5G2","./model/split-uniforms-and-bindings.js":"llbhx","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"llbhx":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUniformValue", ()=>isUniformValue);
parcelHelpers.export(exports, "splitUniformsAndBindings", ()=>splitUniformsAndBindings);
var _types = require("@math.gl/types");
function isUniformValue(value) {
    return (0, _types.isNumericArray)(value) || typeof value === 'number' || typeof value === 'boolean';
}
function splitUniformsAndBindings(uniforms) {
    const result = {
        bindings: {},
        uniforms: {}
    };
    Object.keys(uniforms).forEach((name)=>{
        const uniform = uniforms[name];
        if (isUniformValue(uniform)) result.uniforms[name] = uniform;
        else result.bindings[name] = uniform;
    });
    return result;
}

},{"@math.gl/types":"cxF2f","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cxF2f":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTypedArray", ()=>(0, _isArrayJs.isTypedArray));
parcelHelpers.export(exports, "isNumberArray", ()=>(0, _isArrayJs.isNumberArray));
parcelHelpers.export(exports, "isNumericArray", ()=>(0, _isArrayJs.isNumericArray));
var _isArrayJs = require("./is-array.js");

},{"./is-array.js":"N5qMn","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"N5qMn":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Check is an array is a typed array
 * @param value value to be tested
 * @returns input with type narrowed to TypedArray, or null
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
/**
 * Check is an array is an array of numbers)
 * @param value value to be tested
 * @returns input with type narrowed to NumberArray, or null
 */ parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
/**
 * Check is an array is a numeric array (typed array or array of numbers)
 * @param value value to be tested
 * @returns input with type narrowed to NumericArray, or null
 */ parcelHelpers.export(exports, "isNumericArray", ()=>isNumericArray);
function isTypedArray(value) {
    return ArrayBuffer.isView(value) && !(value instanceof DataView);
}
function isNumberArray(value) {
    if (Array.isArray(value)) return value.length === 0 || typeof value[0] === 'number';
    return false;
}
function isNumericArray(value) {
    return isTypedArray(value) || isNumberArray(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8IOpf":[function(require,module,exports,__globalThis) {
// luma.gl, MIT license
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * It is very convenient to be able to initialize textures with promises
 * This can add considerable complexity to the Texture class, and doesn't
 * fit with the immutable nature of WebGPU resources.
 * Instead, luma.gl offers async textures as a separate class.
 */ parcelHelpers.export(exports, "AsyncTexture", ()=>AsyncTexture);
var _loadFileJs = require("../application-utils/load-file.js");
var _uidJs = require("../utils/uid.js");
class AsyncTexture {
    device;
    id;
    // TODO - should we type these as possibly `null`? It will make usage harder?
    // @ts-expect-error
    texture;
    // @ts-expect-error
    sampler;
    // @ts-expect-error
    view;
    ready;
    isReady = false;
    destroyed = false;
    resolveReady = ()=>{};
    rejectReady = ()=>{};
    get [Symbol.toStringTag]() {
        return 'AsyncTexture';
    }
    toString() {
        return `AsyncTexture:"${this.id}"(${this.isReady ? 'ready' : 'loading'})`;
    }
    constructor(device, props){
        this.device = device;
        this.id = props.id || (0, _uidJs.uid)('async-texture');
        // this.id = typeof props?.data === 'string' ? props.data.slice(-20) : uid('async-texture');
        // Signature: new AsyncTexture(device, {data: url})
        if (typeof props?.data === 'string' && props.dimension === '2d') props = {
            ...props,
            data: (0, _loadFileJs.loadImageBitmap)(props.data)
        };
        this.ready = new Promise((resolve, reject)=>{
            this.resolveReady = ()=>{
                this.isReady = true;
                resolve();
            };
            this.rejectReady = reject;
        });
        this.initAsync(props);
    }
    async initAsync(props) {
        const asyncData = props.data;
        let data;
        try {
            data = await awaitAllPromises(asyncData);
        } catch (error) {
            this.rejectReady(error);
        }
        // Check that we haven't been destroyed while waiting for texture data to load
        if (this.destroyed) return;
        // Now we can actually create the texture
        // @ts-expect-error Discriminated union
        const syncProps = {
            ...props,
            data
        };
        this.texture = this.device.createTexture(syncProps);
        this.sampler = this.texture.sampler;
        this.view = this.texture.view;
        this.isReady = true;
        this.resolveReady();
    }
    destroy() {
        if (this.texture) {
            this.texture.destroy();
            // @ts-expect-error
            this.texture = null;
        }
        this.destroyed = true;
    }
    /**
     * Textures are immutable and cannot be resized after creation,
     * but we can create a similar texture with the same parameters but a new size.
     * @note Does not copy contents of the texture
     * @todo Abort pending promise and create a texture with the new size?
     */ resize(size) {
        if (!this.isReady) throw new Error('Cannot resize texture before it is ready');
        if (size.width === this.texture.width && size.height === this.texture.height) return false;
        if (this.texture) {
            const texture = this.texture;
            this.texture = texture.clone(size);
            texture.destroy();
        }
        return true;
    }
}
// HELPERS
/** Resolve all promises in a nested data structure */ async function awaitAllPromises(x) {
    x = await x;
    if (Array.isArray(x)) return await Promise.all(x.map(awaitAllPromises));
    if (x && typeof x === 'object' && x.constructor === Object) {
        const object = x;
        const values = await Promise.all(Object.values(object));
        const keys = Object.keys(object);
        const resolvedObject = {};
        for(let i = 0; i < keys.length; i++)resolvedObject[keys[i]] = values[i];
        return resolvedObject;
    }
    return x;
}

},{"../application-utils/load-file.js":"4ttwl","../utils/uid.js":"34Ynl","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4ttwl":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Set a relative path prefix
 */ parcelHelpers.export(exports, "setPathPrefix", ()=>setPathPrefix);
/**
 * Loads ImageBitmap asynchronously. Respects setPathPrefix.
 * image.crossOrigin can be set via opts.crossOrigin, default to 'anonymous'
 * @returns a promise tracking the load
 */ parcelHelpers.export(exports, "loadImageBitmap", ()=>loadImageBitmap);
/**
 * Loads image asynchronously. Respects setPathPrefix.
 * image.crossOrigin can be set via opts.crossOrigin, default to 'anonymous'
 * @returns a promise tracking the load
 * @deprecated Use `loadImageBitmap()` unless you are supporting old versions of Safari.
 */ parcelHelpers.export(exports, "loadImage", ()=>loadImage);
let pathPrefix = '';
function setPathPrefix(prefix) {
    pathPrefix = prefix;
}
async function loadImageBitmap(url, opts) {
    const image = new Image();
    image.crossOrigin = opts?.crossOrigin || 'anonymous';
    image.src = url.startsWith('http') ? url : pathPrefix + url;
    await image.decode();
    return opts ? await createImageBitmap(image, opts) : await createImageBitmap(image);
}
async function loadImage(url, opts) {
    return await new Promise((resolve, reject)=>{
        try {
            const image = new Image();
            image.onload = ()=>resolve(image);
            image.onerror = ()=>reject(new Error(`Could not load image ${url}.`));
            image.crossOrigin = opts?.crossOrigin || 'anonymous';
            image.src = url.startsWith('http') ? url : pathPrefix + url;
        } catch (error) {
            reject(error);
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fC0JD":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages a WebGL program (pipeline) for buffer→buffer transforms.
 * @note Only works under WebGL2.
 */ parcelHelpers.export(exports, "BufferTransform", ()=>BufferTransform);
var _core = require("@luma.gl/core");
var _shadertools = require("@luma.gl/shadertools");
var _modelJs = require("../model/model.js");
class BufferTransform {
    device;
    model;
    transformFeedback;
    static defaultProps = {
        ...(0, _modelJs.Model).defaultProps,
        outputs: undefined,
        feedbackBuffers: undefined
    };
    static isSupported(device) {
        return device?.info?.type === 'webgl';
    }
    constructor(device, props = BufferTransform.defaultProps){
        if (!BufferTransform.isSupported(device)) throw new Error('BufferTransform not yet implemented on WebGPU');
        this.device = device;
        this.model = new (0, _modelJs.Model)(this.device, {
            id: props.id || 'buffer-transform-model',
            fs: props.fs || (0, _shadertools.getPassthroughFS)(),
            topology: props.topology || 'point-list',
            varyings: props.outputs || props.varyings,
            ...props
        });
        this.transformFeedback = this.device.createTransformFeedback({
            layout: this.model.pipeline.shaderLayout,
            // @ts-expect-error TODO
            buffers: props.feedbackBuffers
        });
        this.model.setTransformFeedback(this.transformFeedback);
        Object.seal(this);
    }
    /** Destroy owned resources. */ destroy() {
        if (this.model) this.model.destroy();
    }
    /** @deprecated Use {@link destroy}. */ delete() {
        this.destroy();
    }
    /** Run one transform loop. */ run(options) {
        if (options?.inputBuffers) this.model.setAttributes(options.inputBuffers);
        if (options?.outputBuffers) this.transformFeedback.setBuffers(options.outputBuffers);
        const renderPass = this.device.beginRenderPass(options);
        this.model.draw(renderPass);
        renderPass.end();
    }
    // DEPRECATED METHODS
    /** @deprecated App knows what buffers it is passing in - Returns the {@link Buffer} or {@link BufferRange} for given varying name. */ getBuffer(varyingName) {
        return this.transformFeedback.getBuffer(varyingName);
    }
    /** @deprecated App knows what buffers it is passing in - Reads the {@link Buffer} or {@link BufferRange} for given varying name. */ readAsync(varyingName) {
        const result = this.getBuffer(varyingName);
        if (!result) throw new Error('BufferTransform#getBuffer');
        if (result instanceof (0, _core.Buffer)) return result.readAsync();
        const { buffer, byteOffset = 0, byteLength = buffer.byteLength } = result;
        return buffer.readAsync(byteOffset, byteLength);
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/shadertools":"iH5G2","../model/model.js":"iuKtW","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"boguL":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geometry", ()=>Geometry);
var _uidJs = require("../utils/uid.js");
class Geometry {
    id;
    /** Determines how vertices are read from the 'vertex' attributes */ topology;
    vertexCount;
    indices;
    attributes;
    userData = {};
    constructor(props){
        const { attributes = {}, indices = null, vertexCount = null } = props;
        this.id = props.id || (0, _uidJs.uid)('geometry');
        this.topology = props.topology;
        if (indices) this.indices = ArrayBuffer.isView(indices) ? {
            value: indices,
            size: 1
        } : indices;
        // @ts-expect-error
        this.attributes = {};
        for (const [attributeName, attributeValue] of Object.entries(attributes)){
            // Wrap "unwrapped" arrays and try to autodetect their type
            const attribute = ArrayBuffer.isView(attributeValue) ? {
                value: attributeValue
            } : attributeValue;
            if (!ArrayBuffer.isView(attribute.value)) throw new Error(`${this._print(attributeName)}: must be typed array or object with value as typed array`);
            if ((attributeName === 'POSITION' || attributeName === 'positions') && !attribute.size) attribute.size = 3;
            // Move indices to separate field
            if (attributeName === 'indices') {
                if (this.indices) throw new Error('Multiple indices detected');
                this.indices = attribute;
            } else this.attributes[attributeName] = attribute;
        }
        if (this.indices && this.indices.isIndexed !== undefined) {
            this.indices = Object.assign({}, this.indices);
            delete this.indices.isIndexed;
        }
        this.vertexCount = vertexCount || this._calculateVertexCount(this.attributes, this.indices);
    }
    getVertexCount() {
        return this.vertexCount;
    }
    /**
     * Return an object with all attributes plus indices added as a field.
     * TODO Geometry types are a mess
     */ getAttributes() {
        return this.indices ? {
            indices: this.indices,
            ...this.attributes
        } : this.attributes;
    }
    // PRIVATE
    _print(attributeName) {
        return `Geometry ${this.id} attribute ${attributeName}`;
    }
    /**
     * GeometryAttribute
     * value: typed array
     * type: indices, vertices, uvs
     * size: elements per vertex
     * target: WebGL buffer type (string or constant)
     *
     * @param attributes
     * @param indices
     * @returns
     */ _setAttributes(attributes, indices) {
        return this;
    }
    _calculateVertexCount(attributes, indices) {
        if (indices) return indices.value.length;
        let vertexCount = Infinity;
        for (const attribute of Object.values(attributes)){
            const { value, size, constant } = attribute;
            if (!constant && value && size !== undefined && size >= 1) vertexCount = Math.min(vertexCount, value.length / size);
        }
        // assert(Number.isFinite(vertexCount));
        return vertexCount;
    }
}

},{"../utils/uid.js":"34Ynl","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1XIxh":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LIFECYCLE", ()=>LIFECYCLE);
parcelHelpers.export(exports, "COMPONENT_SYMBOL", ()=>COMPONENT_SYMBOL);
parcelHelpers.export(exports, "PROP_TYPES_SYMBOL", ()=>PROP_TYPES_SYMBOL);
parcelHelpers.export(exports, "DEPRECATED_PROPS_SYMBOL", ()=>DEPRECATED_PROPS_SYMBOL);
parcelHelpers.export(exports, "ASYNC_DEFAULTS_SYMBOL", ()=>ASYNC_DEFAULTS_SYMBOL);
parcelHelpers.export(exports, "ASYNC_ORIGINAL_SYMBOL", ()=>ASYNC_ORIGINAL_SYMBOL);
parcelHelpers.export(exports, "ASYNC_RESOLVED_SYMBOL", ()=>ASYNC_RESOLVED_SYMBOL);
const LIFECYCLE = {
    NO_STATE: 'Awaiting state',
    MATCHED: 'Matched. State transferred from previous layer',
    INITIALIZED: 'Initialized',
    AWAITING_GC: 'Discarded. Awaiting garbage collection',
    AWAITING_FINALIZATION: 'No longer matched. Awaiting garbage collection',
    FINALIZED: 'Finalized! Awaiting garbage collection'
};
const COMPONENT_SYMBOL = Symbol.for('component');
const PROP_TYPES_SYMBOL = Symbol.for('propTypes');
const DEPRECATED_PROPS_SYMBOL = Symbol.for('deprecatedProps');
const ASYNC_DEFAULTS_SYMBOL = Symbol.for('asyncPropDefaults');
const ASYNC_ORIGINAL_SYMBOL = Symbol.for('asyncPropOriginal');
const ASYNC_RESOLVED_SYMBOL = Symbol.for('asyncPropResolved');

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8GYLR":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Flattens a nested array into a single level array,
 * or a single value into an array with one value
 * @example flatten([[1, [2]], [3], 4]) => [1, 2, 3, 4]
 * @example flatten(1) => [1]
 * @param array The array to flatten.
 * @param filter= - Optional predicate called on each `value` to
 *   determine if it should be included (pushed onto) the resulting array.
 * @return Returns the new flattened array (new array or `result` if provided)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flatten", ()=>flatten);
/** Uses copyWithin to significantly speed up typed array value filling */ parcelHelpers.export(exports, "fillArray", ()=>fillArray);
function flatten(array, filter = ()=>true) {
    // Wrap single object in array
    if (!Array.isArray(array)) return filter(array) ? [
        array
    ] : [];
    // Deep flatten and filter the array
    return flattenArray(array, filter, []);
}
/** Deep flattens an array. Helper to `flatten`, see its parameters */ function flattenArray(array, filter, result) {
    let index = -1;
    while(++index < array.length){
        const value = array[index];
        if (Array.isArray(value)) flattenArray(value, filter, result);
        else if (filter(value)) result.push(value);
    }
    return result;
}
function fillArray({ target, source, start = 0, count = 1 }) {
    const length = source.length;
    const total = count * length;
    let copied = 0;
    for(let i = start; copied < length; copied++)target[i++] = source[copied];
    while(copied < total)// If we have copied less than half, copy everything we got
    // else copy remaining in one operation
    if (copied < total - copied) {
        target.copyWithin(start + copied, start, start + copied);
        copied *= 2;
    } else {
        target.copyWithin(start + copied, start, start + total - copied);
        copied = total;
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3Eq9V":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resourceJs = require("./resource.js");
var _resourceJsDefault = parcelHelpers.interopDefault(_resourceJs);
class ResourceManager {
    constructor(props){
        this.protocol = props.protocol || 'resource://';
        this._context = {
            device: props.device,
            // @ts-expect-error
            gl: props.device?.gl,
            resourceManager: this
        };
        this._resources = {};
        this._consumers = {};
        this._pruneRequest = null;
    }
    contains(resourceId) {
        if (resourceId.startsWith(this.protocol)) return true;
        return resourceId in this._resources;
    }
    add({ resourceId, data, forceUpdate = false, persistent = true }) {
        let res = this._resources[resourceId];
        if (res) res.setData(data, forceUpdate);
        else {
            res = new (0, _resourceJsDefault.default)(resourceId, data, this._context);
            this._resources[resourceId] = res;
        }
        // persistent resources can only be removed by calling `remove`
        // non-persistent resources may be released when there are no more consumers
        res.persistent = persistent;
    }
    remove(resourceId) {
        const res = this._resources[resourceId];
        if (res) {
            res.delete();
            delete this._resources[resourceId];
        }
    }
    unsubscribe({ consumerId }) {
        const consumer = this._consumers[consumerId];
        if (consumer) {
            for(const requestId in consumer){
                const request = consumer[requestId];
                const resource = this._resources[request.resourceId];
                if (resource) resource.unsubscribe(request);
            }
            delete this._consumers[consumerId];
            this.prune();
        }
    }
    subscribe({ resourceId, onChange, consumerId, requestId = 'default' }) {
        const { _resources: resources, protocol } = this;
        if (resourceId.startsWith(protocol)) {
            resourceId = resourceId.replace(protocol, '');
            if (!resources[resourceId]) // Add placeholder. When this resource becomes available, the consumer will be notified.
            this.add({
                resourceId,
                data: null,
                persistent: false
            });
        }
        const res = resources[resourceId];
        this._track(consumerId, requestId, res, onChange);
        if (res) return res.getData();
        return undefined;
    }
    prune() {
        if (!this._pruneRequest) // prune() may be called multiple times in the same animation frame.
        // Batch multiple requests together
        // @ts-ignore setTimeout returns NodeJS.Timeout in node
        this._pruneRequest = setTimeout(()=>this._prune(), 0);
    }
    finalize() {
        for(const key in this._resources)this._resources[key].delete();
    }
    _track(consumerId, requestId, resource, onChange) {
        const consumers = this._consumers;
        const consumer = consumers[consumerId] = consumers[consumerId] || {};
        let request = consumer[requestId];
        const oldResource = request && request.resourceId && this._resources[request.resourceId];
        if (oldResource) {
            oldResource.unsubscribe(request);
            this.prune();
        }
        if (resource) {
            if (request) {
                request.onChange = onChange;
                request.resourceId = resource.id;
            } else request = {
                onChange,
                resourceId: resource.id
            };
            consumer[requestId] = request;
            resource.subscribe(request);
        }
    }
    _prune() {
        this._pruneRequest = null;
        for (const key of Object.keys(this._resources)){
            const res = this._resources[key];
            if (!res.persistent && !res.inUse()) {
                res.delete();
                delete this._resources[key];
            }
        }
    }
}
exports.default = ResourceManager;

},{"./resource.js":"5JCJX","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5JCJX":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@loaders.gl/core");
class Resource {
    constructor(id, data, context){
        this._loadCount = 0;
        this._subscribers = new Set();
        this.id = id;
        this.context = context;
        this.setData(data);
    }
    // consumer: {onChange: Function}
    subscribe(consumer) {
        this._subscribers.add(consumer);
    }
    unsubscribe(consumer) {
        this._subscribers.delete(consumer);
    }
    inUse() {
        return this._subscribers.size > 0;
    }
    delete() {
    // Remove any resources created
    }
    getData() {
        return this.isLoaded ? this._error ? Promise.reject(this._error) : this._content : this._loader.then(()=>this.getData());
    }
    setData(data, forceUpdate) {
        if (data === this._data && !forceUpdate) return;
        this._data = data;
        const loadCount = ++this._loadCount;
        let loader = data;
        if (typeof data === 'string') loader = (0, _core.load)(data);
        if (loader instanceof Promise) {
            this.isLoaded = false;
            this._loader = loader.then((result)=>{
                // check if source has changed
                if (this._loadCount === loadCount) {
                    this.isLoaded = true;
                    this._error = undefined;
                    this._content = result;
                }
            }).catch((error)=>{
                if (this._loadCount === loadCount) {
                    this.isLoaded = true;
                    this._error = error || true;
                }
            });
        } else {
            this.isLoaded = true;
            this._error = undefined;
            this._content = data;
        }
        for (const subscriber of this._subscribers)subscriber.onChange(this.getData());
    }
}
exports.default = Resource;

},{"@loaders.gl/core":"30VLs","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9yrml":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _mathUtilsJs = require("../utils/math-utils.js");
var _core = require("@math.gl/core");
var _webMercator = require("@math.gl/web-mercator");
var _constantsJs = require("../lib/constants.js");
const DEGREES_TO_RADIANS = Math.PI / 180;
const IDENTITY = (0, _mathUtilsJs.createMat4)();
const ZERO_VECTOR = [
    0,
    0,
    0
];
const DEFAULT_DISTANCE_SCALES = {
    unitsPerMeter: [
        1,
        1,
        1
    ],
    metersPerUnit: [
        1,
        1,
        1
    ]
};
// / Helpers
function createProjectionMatrix({ width, height, orthographic, fovyRadians, focalDistance, padding, near, far }) {
    const aspect = width / height;
    const matrix = orthographic ? new (0, _core.Matrix4)().orthographic({
        fovy: fovyRadians,
        aspect,
        focalDistance,
        near,
        far
    }) : new (0, _core.Matrix4)().perspective({
        fovy: fovyRadians,
        aspect,
        near,
        far
    });
    if (padding) {
        const { left = 0, right = 0, top = 0, bottom = 0 } = padding;
        const offsetX = (0, _core.clamp)((left + width - right) / 2, 0, width) - width / 2;
        const offsetY = (0, _core.clamp)((top + height - bottom) / 2, 0, height) - height / 2;
        // pixels to clip space
        matrix[8] -= offsetX * 2 / width;
        matrix[9] += offsetY * 2 / height;
    }
    return matrix;
}
/**
 * Manages coordinate system transformations.
 *
 * Note: The Viewport is immutable in the sense that it only has accessors.
 * A new viewport instance should be created if any parameters have changed.
 */ class Viewport {
    // eslint-disable-next-line complexity
    constructor(opts = {}){
        this._frustumPlanes = {};
        // @ts-ignore
        this.id = opts.id || this.constructor.displayName || 'viewport';
        this.x = opts.x || 0;
        this.y = opts.y || 0;
        // Silently allow apps to send in w,h = 0,0
        this.width = opts.width || 1;
        this.height = opts.height || 1;
        this.zoom = opts.zoom || 0;
        this.padding = opts.padding;
        this.distanceScales = opts.distanceScales || DEFAULT_DISTANCE_SCALES;
        this.focalDistance = opts.focalDistance || 1;
        this.position = opts.position || ZERO_VECTOR;
        this.modelMatrix = opts.modelMatrix || null;
        const { longitude, latitude } = opts;
        this.isGeospatial = Number.isFinite(latitude) && Number.isFinite(longitude);
        this._initProps(opts);
        this._initMatrices(opts);
        // Bind methods for easy access
        this.equals = this.equals.bind(this);
        this.project = this.project.bind(this);
        this.unproject = this.unproject.bind(this);
        this.projectPosition = this.projectPosition.bind(this);
        this.unprojectPosition = this.unprojectPosition.bind(this);
        this.projectFlat = this.projectFlat.bind(this);
        this.unprojectFlat = this.unprojectFlat.bind(this);
    }
    get subViewports() {
        return null;
    }
    get metersPerPixel() {
        return this.distanceScales.metersPerUnit[2] / this.scale;
    }
    get projectionMode() {
        if (this.isGeospatial) return this.zoom < 12 ? (0, _constantsJs.PROJECTION_MODE).WEB_MERCATOR : (0, _constantsJs.PROJECTION_MODE).WEB_MERCATOR_AUTO_OFFSET;
        return (0, _constantsJs.PROJECTION_MODE).IDENTITY;
    }
    // Two viewports are equal if width and height are identical, and if
    // their view and projection matrices are (approximately) equal.
    equals(viewport) {
        if (!(viewport instanceof Viewport)) return false;
        if (this === viewport) return true;
        return viewport.width === this.width && viewport.height === this.height && viewport.scale === this.scale && (0, _core.equals)(viewport.projectionMatrix, this.projectionMatrix) && (0, _core.equals)(viewport.viewMatrix, this.viewMatrix);
    // TODO - check distance scales?
    }
    /**
     * Projects xyz (possibly latitude and longitude) to pixel coordinates in window
     * using viewport projection parameters
     * - [longitude, latitude] to [x, y]
     * - [longitude, latitude, Z] => [x, y, z]
     * Note: By default, returns top-left coordinates for canvas/SVG type render
     *
     * @param {Array} lngLatZ - [lng, lat] or [lng, lat, Z]
     * @param {Object} opts - options
     * @param {Object} opts.topLeft=true - Whether projected coords are top left
     * @return {Array} - [x, y] or [x, y, z] in top left coords
     */ project(xyz, { topLeft = true } = {}) {
        const worldPosition = this.projectPosition(xyz);
        const coord = (0, _webMercator.worldToPixels)(worldPosition, this.pixelProjectionMatrix);
        const [x, y] = coord;
        const y2 = topLeft ? y : this.height - y;
        return xyz.length === 2 ? [
            x,
            y2
        ] : [
            x,
            y2,
            coord[2]
        ];
    }
    /**
     * Unproject pixel coordinates on screen onto world coordinates,
     * (possibly [lon, lat]) on map.
     * - [x, y] => [lng, lat]
     * - [x, y, z] => [lng, lat, Z]
     * @param {Array} xyz -
     * @param {Object} opts - options
     * @param {Object} opts.topLeft=true - Whether origin is top left
     * @return {Array|null} - [lng, lat, Z] or [X, Y, Z]
     */ unproject(xyz, { topLeft = true, targetZ } = {}) {
        const [x, y, z] = xyz;
        const y2 = topLeft ? y : this.height - y;
        const targetZWorld = targetZ && targetZ * this.distanceScales.unitsPerMeter[2];
        const coord = (0, _webMercator.pixelsToWorld)([
            x,
            y2,
            z
        ], this.pixelUnprojectionMatrix, targetZWorld);
        const [X, Y, Z] = this.unprojectPosition(coord);
        if (Number.isFinite(z)) return [
            X,
            Y,
            Z
        ];
        return Number.isFinite(targetZ) ? [
            X,
            Y,
            targetZ
        ] : [
            X,
            Y
        ];
    }
    // NON_LINEAR PROJECTION HOOKS
    // Used for web meractor projection
    projectPosition(xyz) {
        const [X, Y] = this.projectFlat(xyz);
        const Z = (xyz[2] || 0) * this.distanceScales.unitsPerMeter[2];
        return [
            X,
            Y,
            Z
        ];
    }
    unprojectPosition(xyz) {
        const [X, Y] = this.unprojectFlat(xyz);
        const Z = (xyz[2] || 0) * this.distanceScales.metersPerUnit[2];
        return [
            X,
            Y,
            Z
        ];
    }
    /**
     * Project [lng,lat] on sphere onto [x,y] on 512*512 Mercator Zoom 0 tile.
     * Performs the nonlinear part of the web mercator projection.
     * Remaining projection is done with 4x4 matrices which also handles
     * perspective.
     * @param {Array} lngLat - [lng, lat] coordinates
     *   Specifies a point on the sphere to project onto the map.
     * @return {Array} [x,y] coordinates.
     */ projectFlat(xyz) {
        if (this.isGeospatial) {
            // Shader clamps latitude to +-89.9, see /shaderlib/project/project.glsl.js
            // lngLatToWorld([0, -89.9])[1] = -317.9934163758329
            // lngLatToWorld([0, 89.9])[1] = 829.9934163758271
            const result = (0, _webMercator.lngLatToWorld)(xyz);
            result[1] = (0, _core.clamp)(result[1], -318, 830);
            return result;
        }
        return xyz;
    }
    /**
     * Unproject world point [x,y] on map onto {lat, lon} on sphere
     * @param {object|Vector} xy - object with {x,y} members
     *  representing point on projected map plane
     * @return {GeoCoordinates} - object with {lat,lon} of point on sphere.
     *   Has toArray method if you need a GeoJSON Array.
     *   Per cartographic tradition, lat and lon are specified as degrees.
     */ unprojectFlat(xyz) {
        if (this.isGeospatial) return (0, _webMercator.worldToLngLat)(xyz);
        return xyz;
    }
    /**
     * Get bounds of the current viewport
     * @return {Array} - [minX, minY, maxX, maxY]
     */ getBounds(options = {}) {
        const unprojectOption = {
            targetZ: options.z || 0
        };
        const topLeft = this.unproject([
            0,
            0
        ], unprojectOption);
        const topRight = this.unproject([
            this.width,
            0
        ], unprojectOption);
        const bottomLeft = this.unproject([
            0,
            this.height
        ], unprojectOption);
        const bottomRight = this.unproject([
            this.width,
            this.height
        ], unprojectOption);
        return [
            Math.min(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
            Math.min(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1]),
            Math.max(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
            Math.max(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1])
        ];
    }
    getDistanceScales(coordinateOrigin) {
        if (coordinateOrigin && this.isGeospatial) return (0, _webMercator.getDistanceScales)({
            longitude: coordinateOrigin[0],
            latitude: coordinateOrigin[1],
            highPrecision: true
        });
        return this.distanceScales;
    }
    containsPixel({ x, y, width = 1, height = 1 }) {
        return x < this.x + this.width && this.x < x + width && y < this.y + this.height && this.y < y + height;
    }
    // Extract frustum planes in common space
    getFrustumPlanes() {
        if (this._frustumPlanes.near) // @ts-ignore
        return this._frustumPlanes;
        Object.assign(this._frustumPlanes, (0, _mathUtilsJs.getFrustumPlanes)(this.viewProjectionMatrix));
        // @ts-ignore
        return this._frustumPlanes;
    }
    // EXPERIMENTAL METHODS
    /**
     * Needed by panning and linear transition
     * Pan the viewport to place a given world coordinate at screen point [x, y]
     *
     * @param {Array} coords - world coordinates
     * @param {Array} pixel - [x,y] coordinates on screen
     * @return {Object} props of the new viewport
     */ panByPosition(coords, pixel) {
        return null;
    }
    // INTERNAL METHODS
    /* eslint-disable complexity, max-statements */ _initProps(opts) {
        const longitude = opts.longitude;
        const latitude = opts.latitude;
        if (this.isGeospatial) {
            if (!Number.isFinite(opts.zoom)) this.zoom = (0, _webMercator.getMeterZoom)({
                latitude
            }) + Math.log2(this.focalDistance);
            this.distanceScales = opts.distanceScales || (0, _webMercator.getDistanceScales)({
                latitude,
                longitude
            });
        }
        const scale = Math.pow(2, this.zoom);
        this.scale = scale;
        const { position, modelMatrix } = opts;
        let meterOffset = ZERO_VECTOR;
        if (position) meterOffset = modelMatrix ? new (0, _core.Matrix4)(modelMatrix).transformAsVector(position, []) : position;
        if (this.isGeospatial) {
            // Determine camera center in common space
            const center = this.projectPosition([
                longitude,
                latitude,
                0
            ]);
            this.center = new (0, _core.Vector3)(meterOffset)// Convert to pixels in current zoom
            .scale(this.distanceScales.unitsPerMeter).add(center);
        } else this.center = this.projectPosition(meterOffset);
    }
    /* eslint-enable complexity, max-statements */ _initMatrices(opts) {
        const { // View matrix
        viewMatrix = IDENTITY, // Projection matrix
        projectionMatrix = null, // Projection matrix parameters, used if projectionMatrix not supplied
        orthographic = false, fovyRadians, fovy = 75, near = 0.1, far = 1000, padding = null, focalDistance = 1 } = opts;
        this.viewMatrixUncentered = viewMatrix;
        // Make a centered version of the matrix for projection modes without an offset
        this.viewMatrix = new (0, _core.Matrix4)()// Apply the uncentered view matrix
        .multiplyRight(viewMatrix)// And center it
        .translate(new (0, _core.Vector3)(this.center).negate());
        this.projectionMatrix = projectionMatrix || createProjectionMatrix({
            width: this.width,
            height: this.height,
            orthographic,
            fovyRadians: fovyRadians || fovy * DEGREES_TO_RADIANS,
            focalDistance,
            padding,
            near,
            far
        });
        // Note: As usual, matrix operations should be applied in "reverse" order
        // since vectors will be multiplied in from the right during transformation
        const vpm = (0, _mathUtilsJs.createMat4)();
        (0, _core.mat4).multiply(vpm, vpm, this.projectionMatrix);
        (0, _core.mat4).multiply(vpm, vpm, this.viewMatrix);
        this.viewProjectionMatrix = vpm;
        // console.log('VPM', this.viewMatrix, this.projectionMatrix, this.viewProjectionMatrix);
        // Calculate inverse view matrix
        this.viewMatrixInverse = (0, _core.mat4).invert([], this.viewMatrix) || this.viewMatrix;
        // Decompose camera parameters
        this.cameraPosition = (0, _mathUtilsJs.getCameraPosition)(this.viewMatrixInverse);
        /*
         * Builds matrices that converts preprojected lngLats to screen pixels
         * and vice versa.
         * Note: Currently returns bottom-left coordinates!
         * Note: Starts with the GL projection matrix and adds steps to the
         *       scale and translate that matrix onto the window.
         * Note: WebGL controls clip space to screen projection with gl.viewport
         *       and does not need this step.
         */ // matrix for conversion from world location to screen (pixel) coordinates
        const viewportMatrix = (0, _mathUtilsJs.createMat4)(); // matrix from NDC to viewport.
        const pixelProjectionMatrix = (0, _mathUtilsJs.createMat4)(); // matrix from world space to viewport.
        (0, _core.mat4).scale(viewportMatrix, viewportMatrix, [
            this.width / 2,
            -this.height / 2,
            1
        ]);
        (0, _core.mat4).translate(viewportMatrix, viewportMatrix, [
            1,
            -1,
            0
        ]);
        (0, _core.mat4).multiply(pixelProjectionMatrix, viewportMatrix, this.viewProjectionMatrix);
        this.pixelProjectionMatrix = pixelProjectionMatrix;
        this.pixelUnprojectionMatrix = (0, _core.mat4).invert((0, _mathUtilsJs.createMat4)(), this.pixelProjectionMatrix);
        if (!this.pixelUnprojectionMatrix) (0, _logJsDefault.default).warn('Pixel project matrix not invertible')();
    }
}
Viewport.displayName = 'Viewport';
exports.default = Viewport;

},{"../utils/log.js":"9S0lD","../utils/math-utils.js":"kiHqg","@math.gl/core":"6z0Tv","@math.gl/web-mercator":"3nSdG","../lib/constants.js":"k6l9N","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kiHqg":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Extensions to math.gl library. Intended to be folded back.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Helper, avoids low-precision 32 bit matrices from gl-matrix mat4.create()
parcelHelpers.export(exports, "createMat4", ()=>createMat4);
parcelHelpers.export(exports, "mod", ()=>mod);
// Extract camera vectors (move to math library?)
parcelHelpers.export(exports, "getCameraPosition", ()=>getCameraPosition);
// https://www.gamedevs.org/uploads/fast-extraction-viewing-frustum-planes-from-world-view-projection-matrix.pdf
parcelHelpers.export(exports, "getFrustumPlanes", ()=>getFrustumPlanes);
/**
 * Calculate the low part of a WebGL 64 bit float
 * @param x {number} - the input float number
 * @returns {number} - the lower 32 bit of the number
 */ parcelHelpers.export(exports, "fp64LowPart", ()=>fp64LowPart);
/**
 * Split a Float64Array into a double-length Float32Array
 * @param typedArray
 * @param options
 * @param options.size  - per attribute size
 * @param options.startIndex - start index in the source array
 * @param options.endIndex  - end index in the source array
 * @returns {} - high part, low part for each attribute:
    [1xHi, 1yHi, 1zHi, 1xLow, 1yLow, 1zLow, 2xHi, ...]
 */ parcelHelpers.export(exports, "toDoublePrecisionArray", ()=>toDoublePrecisionArray);
parcelHelpers.export(exports, "mergeBounds", ()=>mergeBounds);
var _typedArrayManagerJs = require("./typed-array-manager.js");
var _typedArrayManagerJsDefault = parcelHelpers.interopDefault(_typedArrayManagerJs);
var _core = require("@math.gl/core");
function createMat4() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function mod(value, divisor) {
    const modulus = value % divisor;
    return modulus < 0 ? divisor + modulus : modulus;
}
function getCameraPosition(viewMatrixInverse) {
    // Read the translation from the inverse view matrix
    return [
        viewMatrixInverse[12],
        viewMatrixInverse[13],
        viewMatrixInverse[14]
    ];
}
function getFrustumPlanes(viewProjectionMatrix) {
    return {
        left: getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[0], viewProjectionMatrix[7] + viewProjectionMatrix[4], viewProjectionMatrix[11] + viewProjectionMatrix[8], viewProjectionMatrix[15] + viewProjectionMatrix[12]),
        right: getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[0], viewProjectionMatrix[7] - viewProjectionMatrix[4], viewProjectionMatrix[11] - viewProjectionMatrix[8], viewProjectionMatrix[15] - viewProjectionMatrix[12]),
        bottom: getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[1], viewProjectionMatrix[7] + viewProjectionMatrix[5], viewProjectionMatrix[11] + viewProjectionMatrix[9], viewProjectionMatrix[15] + viewProjectionMatrix[13]),
        top: getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[1], viewProjectionMatrix[7] - viewProjectionMatrix[5], viewProjectionMatrix[11] - viewProjectionMatrix[9], viewProjectionMatrix[15] - viewProjectionMatrix[13]),
        near: getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[2], viewProjectionMatrix[7] + viewProjectionMatrix[6], viewProjectionMatrix[11] + viewProjectionMatrix[10], viewProjectionMatrix[15] + viewProjectionMatrix[14]),
        far: getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[2], viewProjectionMatrix[7] - viewProjectionMatrix[6], viewProjectionMatrix[11] - viewProjectionMatrix[10], viewProjectionMatrix[15] - viewProjectionMatrix[14])
    };
}
const scratchVector = new (0, _core.Vector3)();
function getFrustumPlane(a, b, c, d) {
    scratchVector.set(a, b, c);
    const L = scratchVector.len();
    return {
        distance: d / L,
        normal: new (0, _core.Vector3)(-a / L, -b / L, -c / L)
    };
}
function fp64LowPart(x) {
    return x - Math.fround(x);
}
let scratchArray;
function toDoublePrecisionArray(typedArray, options) {
    const { size = 1, startIndex = 0 } = options;
    const endIndex = options.endIndex !== undefined ? options.endIndex : typedArray.length;
    const count = (endIndex - startIndex) / size;
    scratchArray = (0, _typedArrayManagerJsDefault.default).allocate(scratchArray, count, {
        type: Float32Array,
        size: size * 2
    });
    let sourceIndex = startIndex;
    let targetIndex = 0;
    while(sourceIndex < endIndex){
        for(let j = 0; j < size; j++){
            const value = typedArray[sourceIndex++];
            scratchArray[targetIndex + j] = value;
            scratchArray[targetIndex + j + size] = fp64LowPart(value);
        }
        targetIndex += size * 2;
    }
    return scratchArray.subarray(0, count * size * 2);
}
function mergeBounds(boundsList) {
    let mergedBounds = null;
    let isMerged = false;
    for (const bounds of boundsList){
        /* eslint-disable-next-line no-continue */ if (!bounds) continue;
        if (!mergedBounds) mergedBounds = bounds;
        else {
            if (!isMerged) {
                // Copy to avoid mutating input bounds
                mergedBounds = [
                    [
                        mergedBounds[0][0],
                        mergedBounds[0][1]
                    ],
                    [
                        mergedBounds[1][0],
                        mergedBounds[1][1]
                    ]
                ];
                isMerged = true;
            }
            mergedBounds[0][0] = Math.min(mergedBounds[0][0], bounds[0][0]);
            mergedBounds[0][1] = Math.min(mergedBounds[0][1], bounds[0][1]);
            mergedBounds[1][0] = Math.max(mergedBounds[1][0], bounds[1][0]);
            mergedBounds[1][1] = Math.max(mergedBounds[1][1], bounds[1][1]);
        }
    }
    return mergedBounds;
}

},{"./typed-array-manager.js":"6eAB3","@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6eAB3":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypedArrayManager", ()=>TypedArrayManager);
class TypedArrayManager {
    constructor(options = {}){
        this._pool = [];
        this.opts = {
            overAlloc: 2,
            poolSize: 100
        };
        this.setOptions(options);
    }
    setOptions(options) {
        Object.assign(this.opts, options);
    }
    allocate(typedArray, count, { size = 1, type, padding = 0, copy = false, initialize = false, maxCount }) {
        const Type = type || typedArray && typedArray.constructor || Float32Array;
        const newSize = count * size + padding;
        if (ArrayBuffer.isView(typedArray)) {
            if (newSize <= typedArray.length) return typedArray;
            if (newSize * typedArray.BYTES_PER_ELEMENT <= typedArray.buffer.byteLength) return new Type(typedArray.buffer, 0, newSize);
        }
        let maxSize = Infinity;
        if (maxCount) maxSize = maxCount * size + padding;
        const newArray = this._allocate(Type, newSize, initialize, maxSize);
        if (typedArray && copy) newArray.set(typedArray);
        else if (!initialize) // Hack - always initialize the first 4 elements. NaNs crash the Attribute validation
        newArray.fill(0, 0, 4);
        this._release(typedArray);
        return newArray;
    }
    release(typedArray) {
        this._release(typedArray);
    }
    _allocate(Type, size, initialize, maxSize) {
        // Allocate at least one element to ensure a valid buffer
        let sizeToAllocate = Math.max(Math.ceil(size * this.opts.overAlloc), 1);
        // Don't over allocate after certain specified number of elements
        if (sizeToAllocate > maxSize) sizeToAllocate = maxSize;
        // Check if available in pool
        const pool = this._pool;
        const byteLength = Type.BYTES_PER_ELEMENT * sizeToAllocate;
        const i = pool.findIndex((b)=>b.byteLength >= byteLength);
        if (i >= 0) {
            // Create a new array using an existing buffer
            const array = new Type(pool.splice(i, 1)[0], 0, sizeToAllocate);
            if (initialize) // Viewing a buffer with a different type may create NaNs
            array.fill(0);
            return array;
        }
        return new Type(sizeToAllocate);
    }
    _release(typedArray) {
        if (!ArrayBuffer.isView(typedArray)) return;
        const pool = this._pool;
        const { buffer } = typedArray;
        // Save the buffer of the released array into the pool
        // Sort buffers by size
        // TODO - implement binary search?
        const { byteLength } = buffer;
        const i = pool.findIndex((b)=>b.byteLength >= byteLength);
        if (i < 0) pool.push(buffer);
        else if (i > 0 || pool.length < this.opts.poolSize) pool.splice(i, 0, buffer);
        if (pool.length > this.opts.poolSize) // Drop the smallest one
        pool.shift();
    }
}
exports.default = new TypedArrayManager();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1dmVF":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepEqualJs = require("../utils/deep-equal.js");
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _flattenJs = require("../utils/flatten.js");
class ViewManager {
    constructor(props){
        // List of view descriptors, gets re-evaluated when width/height changes
        this.views = [];
        this.width = 100;
        this.height = 100;
        this.viewState = {};
        this.controllers = {};
        this.timeline = props.timeline;
        this._viewports = []; // Generated viewports
        this._viewportMap = {};
        this._isUpdating = false;
        this._needsRedraw = 'First render';
        this._needsUpdate = 'Initialize';
        this._eventManager = props.eventManager;
        this._eventCallbacks = {
            onViewStateChange: props.onViewStateChange,
            onInteractionStateChange: props.onInteractionStateChange
        };
        Object.seal(this);
        // Init with default map viewport
        this.setProps(props);
    }
    /** Remove all resources and event listeners */ finalize() {
        for(const key in this.controllers){
            const controller = this.controllers[key];
            if (controller) controller.finalize();
        }
        this.controllers = {};
    }
    /** Check if a redraw is needed */ needsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        const redraw = this._needsRedraw;
        if (opts.clearRedrawFlags) this._needsRedraw = false;
        return redraw;
    }
    /** Mark the manager as dirty. Will rebuild all viewports and update controllers. */ setNeedsUpdate(reason) {
        this._needsUpdate = this._needsUpdate || reason;
        this._needsRedraw = this._needsRedraw || reason;
    }
    /** Checks each viewport for transition updates */ updateViewStates() {
        for(const viewId in this.controllers){
            const controller = this.controllers[viewId];
            if (controller) controller.updateTransition();
        }
    }
    /** Get a set of viewports for a given width and height
     * TODO - Intention is for deck.gl to autodeduce width and height and drop the need for props
     * @param rect (object, optional) - filter the viewports
     *   + not provided - return all viewports
     *   + {x, y} - only return viewports that contain this pixel
     *   + {x, y, width, height} - only return viewports that overlap with this rectangle
     */ getViewports(rect) {
        if (rect) return this._viewports.filter((viewport)=>viewport.containsPixel(rect));
        return this._viewports;
    }
    /** Get a map of all views */ getViews() {
        const viewMap = {};
        this.views.forEach((view)=>{
            viewMap[view.id] = view;
        });
        return viewMap;
    }
    /** Resolves a viewId string to a View */ getView(viewId) {
        return this.views.find((view)=>view.id === viewId);
    }
    /** Returns the viewState for a specific viewId. Matches the viewState by
      1. view.viewStateId
      2. view.id
      3. root viewState
      then applies the view's filter if any */ getViewState(viewOrViewId) {
        const view = typeof viewOrViewId === 'string' ? this.getView(viewOrViewId) : viewOrViewId;
        // Backward compatibility: view state for single view
        const viewState = view && this.viewState[view.getViewStateId()] || this.viewState;
        return view ? view.filterViewState(viewState) : viewState;
    }
    getViewport(viewId) {
        return this._viewportMap[viewId];
    }
    /**
     * Unproject pixel coordinates on screen onto world coordinates,
     * (possibly [lon, lat]) on map.
     * - [x, y] => [lng, lat]
     * - [x, y, z] => [lng, lat, Z]
     * @param {Array} xyz -
     * @param {Object} opts - options
     * @param {Object} opts.topLeft=true - Whether origin is top left
     * @return {Array|null} - [lng, lat, Z] or [X, Y, Z]
     */ unproject(xyz, opts) {
        const viewports = this.getViewports();
        const pixel = {
            x: xyz[0],
            y: xyz[1]
        };
        for(let i = viewports.length - 1; i >= 0; --i){
            const viewport = viewports[i];
            if (viewport.containsPixel(pixel)) {
                const p = xyz.slice();
                p[0] -= viewport.x;
                p[1] -= viewport.y;
                return viewport.unproject(p, opts);
            }
        }
        return null;
    }
    /** Update the manager with new Deck props */ setProps(props) {
        if (props.views) this._setViews(props.views);
        if (props.viewState) this._setViewState(props.viewState);
        if ('width' in props || 'height' in props) this._setSize(props.width, props.height);
        // Important: avoid invoking _update() inside itself
        // Nested updates result in unexpected side effects inside _rebuildViewports()
        // when using auto control in pure-js
        if (!this._isUpdating) this._update();
    }
    //
    // PRIVATE METHODS
    //
    _update() {
        this._isUpdating = true;
        // Only rebuild viewports if the update flag is set
        if (this._needsUpdate) {
            this._needsUpdate = false;
            this._rebuildViewports();
        }
        // If viewport transition(s) are triggered during viewports update, controller(s)
        // will immediately call `onViewStateChange` which calls `viewManager.setProps` again.
        if (this._needsUpdate) {
            this._needsUpdate = false;
            this._rebuildViewports();
        }
        this._isUpdating = false;
    }
    _setSize(width, height) {
        if (width !== this.width || height !== this.height) {
            this.width = width;
            this.height = height;
            this.setNeedsUpdate('Size changed');
        }
    }
    // Update the view descriptor list and set change flag if needed
    // Does not actually rebuild the `Viewport`s until `getViewports` is called
    _setViews(views) {
        views = (0, _flattenJs.flatten)(views, Boolean);
        const viewsChanged = this._diffViews(views, this.views);
        if (viewsChanged) this.setNeedsUpdate('views changed');
        this.views = views;
    }
    _setViewState(viewState) {
        if (viewState) {
            // depth = 3 when comparing viewStates: viewId.position.0
            const viewStateChanged = !(0, _deepEqualJs.deepEqual)(viewState, this.viewState, 3);
            if (viewStateChanged) this.setNeedsUpdate('viewState changed');
            this.viewState = viewState;
        } else (0, _logJsDefault.default).warn('missing `viewState` or `initialViewState`')();
    }
    _createController(view, props) {
        const Controller = props.type;
        const controller = new Controller({
            timeline: this.timeline,
            eventManager: this._eventManager,
            // Set an internal callback that calls the prop callback if provided
            onViewStateChange: this._eventCallbacks.onViewStateChange,
            onStateChange: this._eventCallbacks.onInteractionStateChange,
            makeViewport: (viewState)=>this.getView(view.id)?.makeViewport({
                    viewState,
                    width: this.width,
                    height: this.height
                })
        });
        return controller;
    }
    _updateController(view, viewState, viewport, controller) {
        const controllerProps = view.controller;
        if (controllerProps && viewport) {
            const resolvedProps = {
                ...viewState,
                ...controllerProps,
                id: view.id,
                x: viewport.x,
                y: viewport.y,
                width: viewport.width,
                height: viewport.height
            };
            // Create controller if not already existing or if the type of the
            // controller has changed.
            if (!controller || controller.constructor !== controllerProps.type) controller = this._createController(view, resolvedProps);
            if (controller) controller.setProps(resolvedProps);
            return controller;
        }
        return null;
    }
    // Rebuilds viewports from descriptors towards a certain window size
    _rebuildViewports() {
        const { views } = this;
        const oldControllers = this.controllers;
        this._viewports = [];
        this.controllers = {};
        let invalidateControllers = false;
        // Create controllers in reverse order, so that views on top receive events first
        for(let i = views.length; i--;){
            const view = views[i];
            const viewState = this.getViewState(view);
            const viewport = view.makeViewport({
                viewState,
                width: this.width,
                height: this.height
            });
            let oldController = oldControllers[view.id];
            const hasController = Boolean(view.controller);
            if (hasController && !oldController) // When a new controller is added, invalidate all controllers below it so that
            // events are registered in the correct order
            invalidateControllers = true;
            if ((invalidateControllers || !hasController) && oldController) {
                // Remove and reattach invalidated controller
                oldController.finalize();
                oldController = null;
            }
            // Update the controller
            this.controllers[view.id] = this._updateController(view, viewState, viewport, oldController);
            if (viewport) this._viewports.unshift(viewport);
        }
        // Remove unused controllers
        for(const id in oldControllers){
            const oldController = oldControllers[id];
            if (oldController && !this.controllers[id]) oldController.finalize();
        }
        this._buildViewportMap();
    }
    _buildViewportMap() {
        // Build a view id to view index
        this._viewportMap = {};
        this._viewports.forEach((viewport)=>{
            if (viewport.id) // TODO - issue warning if multiple viewports use same id
            this._viewportMap[viewport.id] = this._viewportMap[viewport.id] || viewport;
        });
    }
    // Check if viewport array has changed, returns true if any change
    // Note that descriptors can be the same
    _diffViews(newViews, oldViews) {
        if (newViews.length !== oldViews.length) return true;
        return newViews.some((_, i)=>!newViews[i].equals(oldViews[i]));
    }
}
exports.default = ViewManager;

},{"../utils/deep-equal.js":"1MkgV","../utils/log.js":"9S0lD","../utils/flatten.js":"8GYLR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1MkgV":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Fast partial deep equal for prop.
 *
 * @param a Prop
 * @param b Prop to compare against `a`
 * @param depth Depth to which to recurse in nested Objects/Arrays. Use 0 (default) for shallow comparison, -1 for infinite depth
 */ /* eslint-disable complexity */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
function deepEqual(a, b, depth) {
    if (a === b) return true;
    if (!depth || !a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!deepEqual(a[i], b[i], depth - 1)) return false;
        }
        return true;
    }
    if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!deepEqual(a[key], b[key], depth - 1)) return false;
        }
        return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eBM7P":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _webMercatorViewportJs = require("../viewports/web-mercator-viewport.js");
var _webMercatorViewportJsDefault = parcelHelpers.interopDefault(_webMercatorViewportJs);
var _mapControllerJs = require("../controllers/map-controller.js");
var _mapControllerJsDefault = parcelHelpers.interopDefault(_mapControllerJs);
class MapView extends (0, _viewJsDefault.default) {
    constructor(props = {}){
        super(props);
    }
    getViewportType() {
        return 0, _webMercatorViewportJsDefault.default;
    }
    get ControllerType() {
        return 0, _mapControllerJsDefault.default;
    }
}
MapView.displayName = 'MapView';
exports.default = MapView;

},{"./view.js":"tjAv3","../viewports/web-mercator-viewport.js":"3azhZ","../controllers/map-controller.js":"75nE6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"tjAv3":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _positionsJs = require("../utils/positions.js");
var _deepEqualJs = require("../utils/deep-equal.js");
class View {
    constructor(props){
        const { id, x = 0, y = 0, width = '100%', height = '100%', padding = null } = props;
        // @ts-ignore
        this.id = id || this.constructor.displayName || 'view';
        this.props = {
            ...props,
            id: this.id
        };
        // Extents
        this._x = (0, _positionsJs.parsePosition)(x);
        this._y = (0, _positionsJs.parsePosition)(y);
        this._width = (0, _positionsJs.parsePosition)(width);
        this._height = (0, _positionsJs.parsePosition)(height);
        this._padding = padding && {
            left: (0, _positionsJs.parsePosition)(padding.left || 0),
            right: (0, _positionsJs.parsePosition)(padding.right || 0),
            top: (0, _positionsJs.parsePosition)(padding.top || 0),
            bottom: (0, _positionsJs.parsePosition)(padding.bottom || 0)
        };
        // Bind methods for easy access
        this.equals = this.equals.bind(this);
        Object.seal(this);
    }
    equals(view) {
        if (this === view) return true;
        // To correctly compare padding use depth=2
        return this.constructor === view.constructor && (0, _deepEqualJs.deepEqual)(this.props, view.props, 2);
    }
    /** Make viewport from canvas dimensions and view state */ makeViewport({ width, height, viewState }) {
        viewState = this.filterViewState(viewState);
        // Resolve relative viewport dimensions
        const viewportDimensions = this.getDimensions({
            width,
            height
        });
        if (!viewportDimensions.height || !viewportDimensions.width) return null;
        const ViewportType = this.getViewportType(viewState);
        return new ViewportType({
            ...viewState,
            ...this.props,
            ...viewportDimensions
        });
    }
    getViewStateId() {
        const { viewState } = this.props;
        if (typeof viewState === 'string') // if View.viewState is a string, return it
        return viewState;
        return viewState?.id || this.id;
    }
    // Allows view to override (or completely define) viewState
    filterViewState(viewState) {
        if (this.props.viewState && typeof this.props.viewState === 'object') {
            // If we have specified an id, then intent is to override,
            // If not, completely specify the view state
            if (!this.props.viewState.id) return this.props.viewState;
            // Merge in all props from View's viewState, except id
            const newViewState = {
                ...viewState
            };
            for(const key in this.props.viewState)if (key !== 'id') newViewState[key] = this.props.viewState[key];
            return newViewState;
        }
        return viewState;
    }
    /** Resolve the dimensions of the view from overall canvas dimensions */ getDimensions({ width, height }) {
        const dimensions = {
            x: (0, _positionsJs.getPosition)(this._x, width),
            y: (0, _positionsJs.getPosition)(this._y, height),
            width: (0, _positionsJs.getPosition)(this._width, width),
            height: (0, _positionsJs.getPosition)(this._height, height)
        };
        if (this._padding) dimensions.padding = {
            left: (0, _positionsJs.getPosition)(this._padding.left, width),
            top: (0, _positionsJs.getPosition)(this._padding.top, height),
            right: (0, _positionsJs.getPosition)(this._padding.right, width),
            bottom: (0, _positionsJs.getPosition)(this._padding.bottom, height)
        };
        return dimensions;
    }
    // Used by sub classes to resolve controller props
    get controller() {
        const opts = this.props.controller;
        if (!opts) return null;
        if (opts === true) return {
            type: this.ControllerType
        };
        if (typeof opts === 'function') return {
            type: opts
        };
        return {
            type: this.ControllerType,
            ...opts
        };
    }
}
exports.default = View;

},{"../utils/positions.js":"6Y4Ok","../utils/deep-equal.js":"1MkgV","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6Y4Ok":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Takes a number or a string of formats `50%`, `33.3%` or `200px`
parcelHelpers.export(exports, "parsePosition", ()=>parsePosition);
parcelHelpers.export(exports, "getPosition", ()=>getPosition);
const PERCENT_OR_PIXELS_REGEX = /([0-9]+\.?[0-9]*)(%|px)/;
function parsePosition(value) {
    switch(typeof value){
        case 'number':
            return {
                position: value,
                relative: false
            };
        case 'string':
            const match = PERCENT_OR_PIXELS_REGEX.exec(value);
            if (match && match.length >= 3) {
                const relative = match[2] === '%';
                const position = parseFloat(match[1]);
                return {
                    position: relative ? position / 100 : position,
                    relative
                };
            }
        // fallthrough
        default:
            // eslint-disable-line
            throw new Error(`Could not parse position string ${value}`);
    }
}
function getPosition(position, extent) {
    return position.relative ? Math.round(position.position * extent) : position.position;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3azhZ":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// View and Projection Matrix calculations for mapbox-js style
// map view properties
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewportJs = require("./viewport.js");
var _viewportJsDefault = parcelHelpers.interopDefault(_viewportJs);
var _webMercator = require("@math.gl/web-mercator");
var _core = require("@math.gl/core");
/**
 * Manages transformations to/from WGS84 coordinates using the Web Mercator Projection.
 */ class WebMercatorViewport extends (0, _viewportJsDefault.default) {
    /* eslint-disable complexity, max-statements */ constructor(opts = {}){
        const { latitude = 0, longitude = 0, zoom = 0, pitch = 0, bearing = 0, nearZMultiplier = 0.1, farZMultiplier = 1.01, nearZ, farZ, orthographic = false, projectionMatrix, repeat = false, worldOffset = 0, position, padding, // backward compatibility
        // TODO: remove in v9
        legacyMeterSizes = false } = opts;
        let { width, height, altitude = 1.5 } = opts;
        const scale = Math.pow(2, zoom);
        // Silently allow apps to send in 0,0 to facilitate isomorphic render etc
        width = width || 1;
        height = height || 1;
        let fovy;
        let projectionParameters = null;
        if (projectionMatrix) {
            altitude = projectionMatrix[5] / 2;
            fovy = (0, _webMercator.altitudeToFovy)(altitude);
        } else {
            if (opts.fovy) {
                fovy = opts.fovy;
                altitude = (0, _webMercator.fovyToAltitude)(fovy);
            } else fovy = (0, _webMercator.altitudeToFovy)(altitude);
            let offset;
            if (padding) {
                const { top = 0, bottom = 0 } = padding;
                offset = [
                    0,
                    (0, _core.clamp)((top + height - bottom) / 2, 0, height) - height / 2
                ];
            }
            projectionParameters = (0, _webMercator.getProjectionParameters)({
                width,
                height,
                scale,
                center: position && [
                    0,
                    0,
                    position[2] * (0, _webMercator.unitsPerMeter)(latitude)
                ],
                offset,
                pitch,
                fovy,
                nearZMultiplier,
                farZMultiplier
            });
            if (Number.isFinite(nearZ)) projectionParameters.near = nearZ;
            if (Number.isFinite(farZ)) projectionParameters.far = farZ;
        }
        // The uncentered matrix allows us two move the center addition to the
        // shader (cheap) which gives a coordinate system that has its center in
        // the layer's center position. This makes rotations and other modelMatrx
        // transforms much more useful.
        let viewMatrixUncentered = (0, _webMercator.getViewMatrix)({
            height,
            pitch,
            bearing,
            scale,
            altitude
        });
        if (worldOffset) {
            const viewOffset = new (0, _core.Matrix4)().translate([
                512 * worldOffset,
                0,
                0
            ]);
            viewMatrixUncentered = viewOffset.multiplyLeft(viewMatrixUncentered);
        }
        super({
            ...opts,
            // x, y,
            width,
            height,
            // view matrix
            viewMatrix: viewMatrixUncentered,
            longitude,
            latitude,
            zoom,
            // projection matrix parameters
            ...projectionParameters,
            fovy,
            focalDistance: altitude
        });
        // Save parameters
        this.latitude = latitude;
        this.longitude = longitude;
        this.zoom = zoom;
        this.pitch = pitch;
        this.bearing = bearing;
        this.altitude = altitude;
        this.fovy = fovy;
        this.orthographic = orthographic;
        this._subViewports = repeat ? [] : null;
        this._pseudoMeters = legacyMeterSizes;
        Object.freeze(this);
    }
    /* eslint-enable complexity, max-statements */ get subViewports() {
        if (this._subViewports && !this._subViewports.length) {
            // Cache sub viewports so that we only calculate them once
            const bounds = this.getBounds();
            const minOffset = Math.floor((bounds[0] + 180) / 360);
            const maxOffset = Math.ceil((bounds[2] - 180) / 360);
            for(let x = minOffset; x <= maxOffset; x++){
                const offsetViewport = x ? new WebMercatorViewport({
                    ...this,
                    worldOffset: x
                }) : this;
                this._subViewports.push(offsetViewport);
            }
        }
        return this._subViewports;
    }
    projectPosition(xyz) {
        if (this._pseudoMeters) // Backward compatibility
        return super.projectPosition(xyz);
        const [X, Y] = this.projectFlat(xyz);
        const Z = (xyz[2] || 0) * (0, _webMercator.unitsPerMeter)(xyz[1]);
        return [
            X,
            Y,
            Z
        ];
    }
    unprojectPosition(xyz) {
        if (this._pseudoMeters) // Backward compatibility
        return super.unprojectPosition(xyz);
        const [X, Y] = this.unprojectFlat(xyz);
        const Z = (xyz[2] || 0) / (0, _webMercator.unitsPerMeter)(Y);
        return [
            X,
            Y,
            Z
        ];
    }
    /**
     * Add a meter delta to a base lnglat coordinate, returning a new lnglat array
     *
     * Note: Uses simple linear approximation around the viewport center
     * Error increases with size of offset (roughly 1% per 100km)
     *
     * @param {[Number,Number]|[Number,Number,Number]) lngLatZ - base coordinate
     * @param {[Number,Number]|[Number,Number,Number]) xyz - array of meter deltas
     * @return {[Number,Number]|[Number,Number,Number]) array of [lng,lat,z] deltas
     */ addMetersToLngLat(lngLatZ, xyz) {
        return (0, _webMercator.addMetersToLngLat)(lngLatZ, xyz);
    }
    panByPosition(coords, pixel) {
        const fromLocation = (0, _webMercator.pixelsToWorld)(pixel, this.pixelUnprojectionMatrix);
        const toLocation = this.projectFlat(coords);
        const translate = (0, _core.vec2).add([], toLocation, (0, _core.vec2).negate([], fromLocation));
        const newCenter = (0, _core.vec2).add([], this.center, translate);
        const [longitude, latitude] = this.unprojectFlat(newCenter);
        return {
            longitude,
            latitude
        };
    }
    getBounds(options = {}) {
        // @ts-ignore
        const corners = (0, _webMercator.getBounds)(this, options.z || 0);
        return [
            Math.min(corners[0][0], corners[1][0], corners[2][0], corners[3][0]),
            Math.min(corners[0][1], corners[1][1], corners[2][1], corners[3][1]),
            Math.max(corners[0][0], corners[1][0], corners[2][0], corners[3][0]),
            Math.max(corners[0][1], corners[1][1], corners[2][1], corners[3][1])
        ];
    }
    /**
     * Returns a new viewport that fit around the given rectangle.
     * Only supports non-perspective mode.
     */ fitBounds(/** [[lon, lat], [lon, lat]] */ bounds, options = {}) {
        const { width, height } = this;
        const { longitude, latitude, zoom } = (0, _webMercator.fitBounds)({
            width,
            height,
            bounds,
            ...options
        });
        return new WebMercatorViewport({
            width,
            height,
            longitude,
            latitude,
            zoom
        });
    }
}
WebMercatorViewport.displayName = 'WebMercatorViewport';
exports.default = WebMercatorViewport;

},{"./viewport.js":"9yrml","@math.gl/web-mercator":"3nSdG","@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"75nE6":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* Utils */ parcelHelpers.export(exports, "MapState", ()=>MapState);
var _core = require("@math.gl/core");
var _controllerJs = require("./controller.js");
var _controllerJsDefault = parcelHelpers.interopDefault(_controllerJs);
var _viewStateJs = require("./view-state.js");
var _viewStateJsDefault = parcelHelpers.interopDefault(_viewStateJs);
var _webMercator = require("@math.gl/web-mercator");
var _assertJs = require("../utils/assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
var _linearInterpolatorJs = require("../transitions/linear-interpolator.js");
var _linearInterpolatorJsDefault = parcelHelpers.interopDefault(_linearInterpolatorJs);
const PITCH_MOUSE_THRESHOLD = 5;
const PITCH_ACCEL = 1.2;
class MapState extends (0, _viewStateJsDefault.default) {
    constructor(options){
        const { /** Mapbox viewport properties */ /** The width of the viewport */ width, /** The height of the viewport */ height, /** The latitude at the center of the viewport */ latitude, /** The longitude at the center of the viewport */ longitude, /** The tile zoom level of the map. */ zoom, /** The bearing of the viewport in degrees */ bearing = 0, /** The pitch of the viewport in degrees */ pitch = 0, /**
         * Specify the altitude of the viewport camera
         * Unit: map heights, default 1.5
         * Non-public API, see https://github.com/mapbox/mapbox-gl-js/issues/1137
         */ altitude = 1.5, /** Viewport position */ position = [
            0,
            0,
            0
        ], /** Viewport constraints */ maxZoom = 20, minZoom = 0, maxPitch = 60, minPitch = 0, /** Interaction states, required to calculate change during transform */ /* The point on map being grabbed when the operation first started */ startPanLngLat, /* Center of the zoom when the operation first started */ startZoomLngLat, /* Pointer position when rotation started */ startRotatePos, /** Bearing when current perspective rotate operation started */ startBearing, /** Pitch when current perspective rotate operation started */ startPitch, /** Zoom when current zoom operation started */ startZoom, /** Normalize viewport props to fit map height into viewport */ normalize = true } = options;
        (0, _assertJsDefault.default)(Number.isFinite(longitude)); // `longitude` must be supplied
        (0, _assertJsDefault.default)(Number.isFinite(latitude)); // `latitude` must be supplied
        (0, _assertJsDefault.default)(Number.isFinite(zoom)); // `zoom` must be supplied
        super({
            width,
            height,
            latitude,
            longitude,
            zoom,
            bearing,
            pitch,
            altitude,
            maxZoom,
            minZoom,
            maxPitch,
            minPitch,
            normalize,
            position
        }, {
            startPanLngLat,
            startZoomLngLat,
            startRotatePos,
            startBearing,
            startPitch,
            startZoom
        });
        this.makeViewport = options.makeViewport;
    }
    /**
     * Start panning
     * @param {[Number, Number]} pos - position on screen where the pointer grabs
     */ panStart({ pos }) {
        return this._getUpdatedState({
            startPanLngLat: this._unproject(pos)
        });
    }
    /**
     * Pan
     * @param {[Number, Number]} pos - position on screen where the pointer is
     * @param {[Number, Number], optional} startPos - where the pointer grabbed at
     *   the start of the operation. Must be supplied of `panStart()` was not called
     */ pan({ pos, startPos }) {
        const startPanLngLat = this.getState().startPanLngLat || this._unproject(startPos);
        if (!startPanLngLat) return this;
        const viewport = this.makeViewport(this.getViewportProps());
        const newProps = viewport.panByPosition(startPanLngLat, pos);
        return this._getUpdatedState(newProps);
    }
    /**
     * End panning
     * Must call if `panStart()` was called
     */ panEnd() {
        return this._getUpdatedState({
            startPanLngLat: null
        });
    }
    /**
     * Start rotating
     * @param {[Number, Number]} pos - position on screen where the center is
     */ rotateStart({ pos }) {
        return this._getUpdatedState({
            startRotatePos: pos,
            startBearing: this.getViewportProps().bearing,
            startPitch: this.getViewportProps().pitch
        });
    }
    /**
     * Rotate
     * @param {[Number, Number]} pos - position on screen where the center is
     */ rotate({ pos, deltaAngleX = 0, deltaAngleY = 0 }) {
        const { startRotatePos, startBearing, startPitch } = this.getState();
        if (!startRotatePos || startBearing === undefined || startPitch === undefined) return this;
        let newRotation;
        if (pos) newRotation = this._getNewRotation(pos, startRotatePos, startPitch, startBearing);
        else newRotation = {
            bearing: startBearing + deltaAngleX,
            pitch: startPitch + deltaAngleY
        };
        return this._getUpdatedState(newRotation);
    }
    /**
     * End rotating
     * Must call if `rotateStart()` was called
     */ rotateEnd() {
        return this._getUpdatedState({
            startBearing: null,
            startPitch: null
        });
    }
    /**
     * Start zooming
     * @param {[Number, Number]} pos - position on screen where the center is
     */ zoomStart({ pos }) {
        return this._getUpdatedState({
            startZoomLngLat: this._unproject(pos),
            startZoom: this.getViewportProps().zoom
        });
    }
    /**
     * Zoom
     * @param {[Number, Number]} pos - position on screen where the current center is
     * @param {[Number, Number]} startPos - the center position at
     *   the start of the operation. Must be supplied of `zoomStart()` was not called
     * @param {Number} scale - a number between [0, 1] specifying the accumulated
     *   relative scale.
     */ zoom({ pos, startPos, scale }) {
        // Make sure we zoom around the current mouse position rather than map center
        let { startZoom, startZoomLngLat } = this.getState();
        if (!startZoomLngLat) {
            // We have two modes of zoom:
            // scroll zoom that are discrete events (transform from the current zoom level),
            // and pinch zoom that are continuous events (transform from the zoom level when
            // pinch started).
            // If startZoom state is defined, then use the startZoom state;
            // otherwise assume discrete zooming
            startZoom = this.getViewportProps().zoom;
            startZoomLngLat = this._unproject(startPos) || this._unproject(pos);
        }
        if (!startZoomLngLat) return this;
        const { maxZoom, minZoom } = this.getViewportProps();
        let zoom = startZoom + Math.log2(scale);
        zoom = (0, _core.clamp)(zoom, minZoom, maxZoom);
        const zoomedViewport = this.makeViewport({
            ...this.getViewportProps(),
            zoom
        });
        return this._getUpdatedState({
            zoom,
            ...zoomedViewport.panByPosition(startZoomLngLat, pos)
        });
    }
    /**
     * End zooming
     * Must call if `zoomStart()` was called
     */ zoomEnd() {
        return this._getUpdatedState({
            startZoomLngLat: null,
            startZoom: null
        });
    }
    zoomIn(speed = 2) {
        return this._zoomFromCenter(speed);
    }
    zoomOut(speed = 2) {
        return this._zoomFromCenter(1 / speed);
    }
    moveLeft(speed = 100) {
        return this._panFromCenter([
            speed,
            0
        ]);
    }
    moveRight(speed = 100) {
        return this._panFromCenter([
            -speed,
            0
        ]);
    }
    moveUp(speed = 100) {
        return this._panFromCenter([
            0,
            speed
        ]);
    }
    moveDown(speed = 100) {
        return this._panFromCenter([
            0,
            -speed
        ]);
    }
    rotateLeft(speed = 15) {
        return this._getUpdatedState({
            bearing: this.getViewportProps().bearing - speed
        });
    }
    rotateRight(speed = 15) {
        return this._getUpdatedState({
            bearing: this.getViewportProps().bearing + speed
        });
    }
    rotateUp(speed = 10) {
        return this._getUpdatedState({
            pitch: this.getViewportProps().pitch + speed
        });
    }
    rotateDown(speed = 10) {
        return this._getUpdatedState({
            pitch: this.getViewportProps().pitch - speed
        });
    }
    shortestPathFrom(viewState) {
        // const endViewStateProps = new this.ControllerState(endProps).shortestPathFrom(startViewstate);
        const fromProps = viewState.getViewportProps();
        const props = {
            ...this.getViewportProps()
        };
        const { bearing, longitude } = props;
        if (Math.abs(bearing - fromProps.bearing) > 180) props.bearing = bearing < 0 ? bearing + 360 : bearing - 360;
        if (Math.abs(longitude - fromProps.longitude) > 180) props.longitude = longitude < 0 ? longitude + 360 : longitude - 360;
        return props;
    }
    // Apply any constraints (mathematical or defined by _viewportProps) to map state
    applyConstraints(props) {
        // Ensure zoom is within specified range
        const { maxZoom, minZoom, zoom } = props;
        props.zoom = (0, _core.clamp)(zoom, minZoom, maxZoom);
        // Ensure pitch is within specified range
        const { maxPitch, minPitch, pitch } = props;
        props.pitch = (0, _core.clamp)(pitch, minPitch, maxPitch);
        // Normalize viewport props to fit map height into viewport
        const { normalize = true } = props;
        if (normalize) Object.assign(props, (0, _webMercator.normalizeViewportProps)(props));
        return props;
    }
    /* Private methods */ _zoomFromCenter(scale) {
        const { width, height } = this.getViewportProps();
        return this.zoom({
            pos: [
                width / 2,
                height / 2
            ],
            scale
        });
    }
    _panFromCenter(offset) {
        const { width, height } = this.getViewportProps();
        return this.pan({
            startPos: [
                width / 2,
                height / 2
            ],
            pos: [
                width / 2 + offset[0],
                height / 2 + offset[1]
            ]
        });
    }
    _getUpdatedState(newProps) {
        // @ts-ignore
        return new this.constructor({
            makeViewport: this.makeViewport,
            ...this.getViewportProps(),
            ...this.getState(),
            ...newProps
        });
    }
    _unproject(pos) {
        const viewport = this.makeViewport(this.getViewportProps());
        // @ts-ignore
        return pos && viewport.unproject(pos);
    }
    _getNewRotation(pos, startPos, startPitch, startBearing) {
        const deltaX = pos[0] - startPos[0];
        const deltaY = pos[1] - startPos[1];
        const centerY = pos[1];
        const startY = startPos[1];
        const { width, height } = this.getViewportProps();
        const deltaScaleX = deltaX / width;
        let deltaScaleY = 0;
        if (deltaY > 0) {
            if (Math.abs(height - startY) > PITCH_MOUSE_THRESHOLD) // Move from 0 to -1 as we drag upwards
            deltaScaleY = deltaY / (startY - height) * PITCH_ACCEL;
        } else if (deltaY < 0) {
            if (startY > PITCH_MOUSE_THRESHOLD) // Move from 0 to 1 as we drag upwards
            deltaScaleY = 1 - centerY / startY;
        }
        // clamp deltaScaleY to [-1, 1] so that rotation is constrained between minPitch and maxPitch.
        // deltaScaleX does not need to be clamped as bearing does not have constraints.
        deltaScaleY = (0, _core.clamp)(deltaScaleY, -1, 1);
        const { minPitch, maxPitch } = this.getViewportProps();
        const bearing = startBearing + 180 * deltaScaleX;
        let pitch = startPitch;
        if (deltaScaleY > 0) // Gradually increase pitch
        pitch = startPitch + deltaScaleY * (maxPitch - startPitch);
        else if (deltaScaleY < 0) // Gradually decrease pitch
        pitch = startPitch - deltaScaleY * (minPitch - startPitch);
        return {
            pitch,
            bearing
        };
    }
}
class MapController extends (0, _controllerJsDefault.default) {
    constructor(){
        super(...arguments);
        this.ControllerState = MapState;
        this.transition = {
            transitionDuration: 300,
            transitionInterpolator: new (0, _linearInterpolatorJsDefault.default)({
                transitionProps: {
                    compare: [
                        'longitude',
                        'latitude',
                        'zoom',
                        'bearing',
                        'pitch',
                        'position'
                    ],
                    required: [
                        'longitude',
                        'latitude',
                        'zoom'
                    ]
                }
            })
        };
        this.dragMode = 'pan';
    }
    setProps(props) {
        props.position = props.position || [
            0,
            0,
            0
        ];
        const oldProps = this.props;
        super.setProps(props);
        const dimensionChanged = !oldProps || oldProps.height !== props.height;
        if (dimensionChanged) // Dimensions changed, normalize the props
        this.updateViewport(new this.ControllerState({
            makeViewport: this.makeViewport,
            ...props,
            ...this.state
        }));
    }
}
exports.default = MapController;

},{"@math.gl/core":"6z0Tv","./controller.js":"ep4CT","./view-state.js":"ezZbn","@math.gl/web-mercator":"3nSdG","../utils/assert.js":"3Sh37","../transitions/linear-interpolator.js":"1f6ng","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ep4CT":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable max-statements, complexity */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transitionManagerJs = require("./transition-manager.js");
var _transitionManagerJsDefault = parcelHelpers.interopDefault(_transitionManagerJs);
var _linearInterpolatorJs = require("../transitions/linear-interpolator.js");
var _linearInterpolatorJsDefault = parcelHelpers.interopDefault(_linearInterpolatorJs);
const NO_TRANSITION_PROPS = {
    transitionDuration: 0
};
const DEFAULT_INERTIA = 300;
const INERTIA_EASING = (t)=>1 - (1 - t) * (1 - t);
const EVENT_TYPES = {
    WHEEL: [
        'wheel'
    ],
    PAN: [
        'panstart',
        'panmove',
        'panend'
    ],
    PINCH: [
        'pinchstart',
        'pinchmove',
        'pinchend'
    ],
    MULTI_PAN: [
        'multipanstart',
        'multipanmove',
        'multipanend'
    ],
    DOUBLE_CLICK: [
        'dblclick'
    ],
    KEYBOARD: [
        'keydown'
    ]
};
const pinchEventWorkaround = {};
class Controller {
    constructor(opts){
        this.state = {};
        this._events = {};
        this._interactionState = {
            isDragging: false
        };
        this._customEvents = [];
        this._eventStartBlocked = null;
        this._panMove = false;
        this.invertPan = false;
        this.dragMode = 'rotate';
        this.inertia = 0;
        this.scrollZoom = true;
        this.dragPan = true;
        this.dragRotate = true;
        this.doubleClickZoom = true;
        this.touchZoom = true;
        this.touchRotate = false;
        this.keyboard = true;
        this.transitionManager = new (0, _transitionManagerJsDefault.default)({
            ...opts,
            getControllerState: (props)=>new this.ControllerState(props),
            onViewStateChange: this._onTransition.bind(this),
            onStateChange: this._setInteractionState.bind(this)
        });
        this.handleEvent = this.handleEvent.bind(this);
        this.eventManager = opts.eventManager;
        this.onViewStateChange = opts.onViewStateChange || (()=>{});
        this.onStateChange = opts.onStateChange || (()=>{});
        this.makeViewport = opts.makeViewport;
    }
    set events(customEvents) {
        this.toggleEvents(this._customEvents, false);
        this.toggleEvents(customEvents, true);
        this._customEvents = customEvents;
        // Make sure default events are not overwritten
        if (this.props) this.setProps(this.props);
    }
    finalize() {
        for(const eventName in this._events)if (this._events[eventName]) // @ts-ignore (2345) event type string cannot be assifned to enum
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.eventManager?.off(eventName, this.handleEvent);
        this.transitionManager.finalize();
    }
    /**
     * Callback for events
     */ handleEvent(event) {
        // Force recalculate controller state
        this._controllerState = undefined;
        const eventStartBlocked = this._eventStartBlocked;
        switch(event.type){
            case 'panstart':
                return eventStartBlocked ? false : this._onPanStart(event);
            case 'panmove':
                return this._onPan(event);
            case 'panend':
                return this._onPanEnd(event);
            case 'pinchstart':
                return eventStartBlocked ? false : this._onPinchStart(event);
            case 'pinchmove':
                return this._onPinch(event);
            case 'pinchend':
                return this._onPinchEnd(event);
            case 'multipanstart':
                return eventStartBlocked ? false : this._onMultiPanStart(event);
            case 'multipanmove':
                return this._onMultiPan(event);
            case 'multipanend':
                return this._onMultiPanEnd(event);
            case 'dblclick':
                return this._onDoubleClick(event);
            case 'wheel':
                return this._onWheel(event);
            case 'keydown':
                return this._onKeyDown(event);
            default:
                return false;
        }
    }
    /* Event utils */ // Event object: http://hammerjs.github.io/api/#event-object
    get controllerState() {
        this._controllerState = this._controllerState || new this.ControllerState({
            makeViewport: this.makeViewport,
            ...this.props,
            ...this.state
        });
        return this._controllerState;
    }
    getCenter(event) {
        const { x, y } = this.props;
        const { offsetCenter } = event;
        return [
            offsetCenter.x - x,
            offsetCenter.y - y
        ];
    }
    isPointInBounds(pos, event) {
        const { width, height } = this.props;
        if (event && event.handled) return false;
        const inside = pos[0] >= 0 && pos[0] <= width && pos[1] >= 0 && pos[1] <= height;
        if (inside && event) event.stopPropagation();
        return inside;
    }
    isFunctionKeyPressed(event) {
        const { srcEvent } = event;
        return Boolean(srcEvent.metaKey || srcEvent.altKey || srcEvent.ctrlKey || srcEvent.shiftKey);
    }
    isDragging() {
        return this._interactionState.isDragging || false;
    }
    // When a multi-touch event ends, e.g. pinch, not all pointers are lifted at the same time.
    // This triggers a brief `pan` event.
    // Calling this method will temporarily disable *start events to avoid conflicting transitions.
    blockEvents(timeout) {
        /* global setTimeout */ const timer = setTimeout(()=>{
            if (this._eventStartBlocked === timer) this._eventStartBlocked = null;
        }, timeout);
        this._eventStartBlocked = timer;
    }
    /**
     * Extract interactivity options
     */ setProps(props) {
        if (props.dragMode) this.dragMode = props.dragMode;
        this.props = props;
        if (!('transitionInterpolator' in props)) // Add default transition interpolator
        props.transitionInterpolator = this._getTransitionProps().transitionInterpolator;
        this.transitionManager.processViewStateChange(props);
        const { inertia } = props;
        this.inertia = Number.isFinite(inertia) ? inertia : inertia === true ? DEFAULT_INERTIA : 0;
        // TODO - make sure these are not reset on every setProps
        const { scrollZoom = true, dragPan = true, dragRotate = true, doubleClickZoom = true, touchZoom = true, touchRotate = false, keyboard = true } = props;
        // Register/unregister events
        const isInteractive = Boolean(this.onViewStateChange);
        this.toggleEvents(EVENT_TYPES.WHEEL, isInteractive && scrollZoom);
        // We always need the pan events to set the correct isDragging state, even if dragPan & dragRotate are both false
        this.toggleEvents(EVENT_TYPES.PAN, isInteractive);
        this.toggleEvents(EVENT_TYPES.PINCH, isInteractive && (touchZoom || touchRotate));
        this.toggleEvents(EVENT_TYPES.MULTI_PAN, isInteractive && touchRotate);
        this.toggleEvents(EVENT_TYPES.DOUBLE_CLICK, isInteractive && doubleClickZoom);
        this.toggleEvents(EVENT_TYPES.KEYBOARD, isInteractive && keyboard);
        // Interaction toggles
        this.scrollZoom = scrollZoom;
        this.dragPan = dragPan;
        this.dragRotate = dragRotate;
        this.doubleClickZoom = doubleClickZoom;
        this.touchZoom = touchZoom;
        this.touchRotate = touchRotate;
        this.keyboard = keyboard;
    }
    updateTransition() {
        this.transitionManager.updateTransition();
    }
    toggleEvents(eventNames, enabled) {
        if (this.eventManager) eventNames.forEach((eventName)=>{
            if (this._events[eventName] !== enabled) {
                this._events[eventName] = enabled;
                if (enabled) // eslint-disable-next-line @typescript-eslint/unbound-method
                this.eventManager.on(eventName, this.handleEvent);
                else // eslint-disable-next-line @typescript-eslint/unbound-method
                this.eventManager.off(eventName, this.handleEvent);
            }
        });
    }
    // Private Methods
    /* Callback util */ // formats map state and invokes callback function
    updateViewport(newControllerState, extraProps = null, interactionState = {}) {
        const viewState = {
            ...newControllerState.getViewportProps(),
            ...extraProps
        };
        // TODO - to restore diffing, we need to include interactionState
        const changed = this.controllerState !== newControllerState;
        // const oldViewState = this.controllerState.getViewportProps();
        // const changed = Object.keys(viewState).some(key => oldViewState[key] !== viewState[key]);
        this.state = newControllerState.getState();
        this._setInteractionState(interactionState);
        if (changed) {
            const oldViewState = this.controllerState && this.controllerState.getViewportProps();
            if (this.onViewStateChange) this.onViewStateChange({
                viewState,
                interactionState: this._interactionState,
                oldViewState,
                viewId: this.props.id
            });
        }
    }
    _onTransition(params) {
        this.onViewStateChange({
            ...params,
            interactionState: this._interactionState,
            viewId: this.props.id
        });
    }
    _setInteractionState(newStates) {
        Object.assign(this._interactionState, newStates);
        this.onStateChange(this._interactionState);
    }
    /* Event handlers */ // Default handler for the `panstart` event.
    _onPanStart(event) {
        const pos = this.getCenter(event);
        if (!this.isPointInBounds(pos, event)) return false;
        let alternateMode = this.isFunctionKeyPressed(event) || event.rightButton || false;
        if (this.invertPan || this.dragMode === 'pan') // invertPan is replaced by props.dragMode, keeping for backward compatibility
        alternateMode = !alternateMode;
        const newControllerState = this.controllerState[alternateMode ? 'panStart' : 'rotateStart']({
            pos
        });
        this._panMove = alternateMode;
        this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
            isDragging: true
        });
        return true;
    }
    // Default handler for the `panmove` and `panend` event.
    _onPan(event) {
        if (!this.isDragging()) return false;
        return this._panMove ? this._onPanMove(event) : this._onPanRotate(event);
    }
    _onPanEnd(event) {
        if (!this.isDragging()) return false;
        return this._panMove ? this._onPanMoveEnd(event) : this._onPanRotateEnd(event);
    }
    // Default handler for panning to move.
    // Called by `_onPan` when panning without function key pressed.
    _onPanMove(event) {
        if (!this.dragPan) return false;
        const pos = this.getCenter(event);
        const newControllerState = this.controllerState.pan({
            pos
        });
        this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
            isDragging: true,
            isPanning: true
        });
        return true;
    }
    _onPanMoveEnd(event) {
        const { inertia } = this;
        if (this.dragPan && inertia && event.velocity) {
            const pos = this.getCenter(event);
            const endPos = [
                pos[0] + event.velocityX * inertia / 2,
                pos[1] + event.velocityY * inertia / 2
            ];
            const newControllerState = this.controllerState.pan({
                pos: endPos
            }).panEnd();
            this.updateViewport(newControllerState, {
                ...this._getTransitionProps(),
                transitionDuration: inertia,
                transitionEasing: INERTIA_EASING
            }, {
                isDragging: false,
                isPanning: true
            });
        } else {
            const newControllerState = this.controllerState.panEnd();
            this.updateViewport(newControllerState, null, {
                isDragging: false,
                isPanning: false
            });
        }
        return true;
    }
    // Default handler for panning to rotate.
    // Called by `_onPan` when panning with function key pressed.
    _onPanRotate(event) {
        if (!this.dragRotate) return false;
        const pos = this.getCenter(event);
        const newControllerState = this.controllerState.rotate({
            pos
        });
        this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
            isDragging: true,
            isRotating: true
        });
        return true;
    }
    _onPanRotateEnd(event) {
        const { inertia } = this;
        if (this.dragRotate && inertia && event.velocity) {
            const pos = this.getCenter(event);
            const endPos = [
                pos[0] + event.velocityX * inertia / 2,
                pos[1] + event.velocityY * inertia / 2
            ];
            const newControllerState = this.controllerState.rotate({
                pos: endPos
            }).rotateEnd();
            this.updateViewport(newControllerState, {
                ...this._getTransitionProps(),
                transitionDuration: inertia,
                transitionEasing: INERTIA_EASING
            }, {
                isDragging: false,
                isRotating: true
            });
        } else {
            const newControllerState = this.controllerState.rotateEnd();
            this.updateViewport(newControllerState, null, {
                isDragging: false,
                isRotating: false
            });
        }
        return true;
    }
    // Default handler for the `wheel` event.
    _onWheel(event) {
        if (!this.scrollZoom) return false;
        const pos = this.getCenter(event);
        if (!this.isPointInBounds(pos, event)) return false;
        event.srcEvent.preventDefault();
        const { speed = 0.01, smooth = false } = this.scrollZoom === true ? {} : this.scrollZoom;
        const { delta } = event;
        // Map wheel delta to relative scale
        let scale = 2 / (1 + Math.exp(-Math.abs(delta * speed)));
        if (delta < 0 && scale !== 0) scale = 1 / scale;
        const newControllerState = this.controllerState.zoom({
            pos,
            scale
        });
        this.updateViewport(newControllerState, {
            ...this._getTransitionProps({
                around: pos
            }),
            transitionDuration: smooth ? 250 : 1
        }, {
            isZooming: true,
            isPanning: true
        });
        return true;
    }
    _onMultiPanStart(event) {
        const pos = this.getCenter(event);
        if (!this.isPointInBounds(pos, event)) return false;
        const newControllerState = this.controllerState.rotateStart({
            pos
        });
        this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
            isDragging: true
        });
        return true;
    }
    _onMultiPan(event) {
        if (!this.touchRotate) return false;
        if (!this.isDragging()) return false;
        const pos = this.getCenter(event);
        pos[0] -= event.deltaX;
        const newControllerState = this.controllerState.rotate({
            pos
        });
        this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
            isDragging: true,
            isRotating: true
        });
        return true;
    }
    _onMultiPanEnd(event) {
        if (!this.isDragging()) return false;
        const { inertia } = this;
        if (this.touchRotate && inertia && event.velocityY) {
            const pos = this.getCenter(event);
            const endPos = [
                pos[0],
                pos[1] += event.velocityY * inertia / 2
            ];
            const newControllerState = this.controllerState.rotate({
                pos: endPos
            });
            this.updateViewport(newControllerState, {
                ...this._getTransitionProps(),
                transitionDuration: inertia,
                transitionEasing: INERTIA_EASING
            }, {
                isDragging: false,
                isRotating: true
            });
            this.blockEvents(inertia);
        } else {
            const newControllerState = this.controllerState.rotateEnd();
            this.updateViewport(newControllerState, null, {
                isDragging: false,
                isRotating: false
            });
        }
        return true;
    }
    // Default handler for the `pinchstart` event.
    _onPinchStart(event) {
        const pos = this.getCenter(event);
        if (!this.isPointInBounds(pos, event)) return false;
        const newControllerState = this.controllerState.zoomStart({
            pos
        }).rotateStart({
            pos
        });
        // hack - hammer's `rotation` field doesn't seem to produce the correct angle
        pinchEventWorkaround._startPinchRotation = event.rotation;
        pinchEventWorkaround._lastPinchEvent = event;
        this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
            isDragging: true
        });
        return true;
    }
    // Default handler for the `pinchmove` and `pinchend` events.
    _onPinch(event) {
        if (!this.touchZoom && !this.touchRotate) return false;
        if (!this.isDragging()) return false;
        let newControllerState = this.controllerState;
        if (this.touchZoom) {
            const { scale } = event;
            const pos = this.getCenter(event);
            newControllerState = newControllerState.zoom({
                pos,
                scale
            });
        }
        if (this.touchRotate) {
            const { rotation } = event;
            newControllerState = newControllerState.rotate({
                deltaAngleX: pinchEventWorkaround._startPinchRotation - rotation
            });
        }
        this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
            isDragging: true,
            isPanning: this.touchZoom,
            isZooming: this.touchZoom,
            isRotating: this.touchRotate
        });
        pinchEventWorkaround._lastPinchEvent = event;
        return true;
    }
    _onPinchEnd(event) {
        if (!this.isDragging()) return false;
        const { inertia } = this;
        const { _lastPinchEvent } = pinchEventWorkaround;
        if (this.touchZoom && inertia && _lastPinchEvent && event.scale !== _lastPinchEvent.scale) {
            const pos = this.getCenter(event);
            let newControllerState = this.controllerState.rotateEnd();
            const z = Math.log2(event.scale);
            const velocityZ = (z - Math.log2(_lastPinchEvent.scale)) / (event.deltaTime - _lastPinchEvent.deltaTime);
            const endScale = Math.pow(2, z + velocityZ * inertia / 2);
            newControllerState = newControllerState.zoom({
                pos,
                scale: endScale
            }).zoomEnd();
            this.updateViewport(newControllerState, {
                ...this._getTransitionProps({
                    around: pos
                }),
                transitionDuration: inertia,
                transitionEasing: INERTIA_EASING
            }, {
                isDragging: false,
                isPanning: this.touchZoom,
                isZooming: this.touchZoom,
                isRotating: false
            });
            this.blockEvents(inertia);
        } else {
            const newControllerState = this.controllerState.zoomEnd().rotateEnd();
            this.updateViewport(newControllerState, null, {
                isDragging: false,
                isPanning: false,
                isZooming: false,
                isRotating: false
            });
        }
        pinchEventWorkaround._startPinchRotation = null;
        pinchEventWorkaround._lastPinchEvent = null;
        return true;
    }
    // Default handler for the `dblclick` event.
    _onDoubleClick(event) {
        if (!this.doubleClickZoom) return false;
        const pos = this.getCenter(event);
        if (!this.isPointInBounds(pos, event)) return false;
        const isZoomOut = this.isFunctionKeyPressed(event);
        const newControllerState = this.controllerState.zoom({
            pos,
            scale: isZoomOut ? 0.5 : 2
        });
        this.updateViewport(newControllerState, this._getTransitionProps({
            around: pos
        }), {
            isZooming: true,
            isPanning: true
        });
        this.blockEvents(100);
        return true;
    }
    // Default handler for the `keydown` event
    _onKeyDown(event) {
        if (!this.keyboard) return false;
        const funcKey = this.isFunctionKeyPressed(event);
        // @ts-ignore
        const { zoomSpeed, moveSpeed, rotateSpeedX, rotateSpeedY } = this.keyboard === true ? {} : this.keyboard;
        const { controllerState } = this;
        let newControllerState;
        const interactionState = {};
        switch(event.srcEvent.code){
            case 'Minus':
                newControllerState = funcKey ? controllerState.zoomOut(zoomSpeed).zoomOut(zoomSpeed) : controllerState.zoomOut(zoomSpeed);
                interactionState.isZooming = true;
                break;
            case 'Equal':
                newControllerState = funcKey ? controllerState.zoomIn(zoomSpeed).zoomIn(zoomSpeed) : controllerState.zoomIn(zoomSpeed);
                interactionState.isZooming = true;
                break;
            case 'ArrowLeft':
                if (funcKey) {
                    newControllerState = controllerState.rotateLeft(rotateSpeedX);
                    interactionState.isRotating = true;
                } else {
                    newControllerState = controllerState.moveLeft(moveSpeed);
                    interactionState.isPanning = true;
                }
                break;
            case 'ArrowRight':
                if (funcKey) {
                    newControllerState = controllerState.rotateRight(rotateSpeedX);
                    interactionState.isRotating = true;
                } else {
                    newControllerState = controllerState.moveRight(moveSpeed);
                    interactionState.isPanning = true;
                }
                break;
            case 'ArrowUp':
                if (funcKey) {
                    newControllerState = controllerState.rotateUp(rotateSpeedY);
                    interactionState.isRotating = true;
                } else {
                    newControllerState = controllerState.moveUp(moveSpeed);
                    interactionState.isPanning = true;
                }
                break;
            case 'ArrowDown':
                if (funcKey) {
                    newControllerState = controllerState.rotateDown(rotateSpeedY);
                    interactionState.isRotating = true;
                } else {
                    newControllerState = controllerState.moveDown(moveSpeed);
                    interactionState.isPanning = true;
                }
                break;
            default:
                return false;
        }
        this.updateViewport(newControllerState, this._getTransitionProps(), interactionState);
        return true;
    }
    _getTransitionProps(opts) {
        const { transition } = this;
        if (!transition || !transition.transitionInterpolator) return NO_TRANSITION_PROPS;
        // Enables Transitions on double-tap and key-down events.
        return opts ? {
            ...transition,
            transitionInterpolator: new (0, _linearInterpolatorJsDefault.default)({
                ...opts,
                ...transition.transitionInterpolator.opts,
                makeViewport: this.controllerState.makeViewport
            })
        } : transition;
    }
}
exports.default = Controller;

},{"./transition-manager.js":"5ZuD6","../transitions/linear-interpolator.js":"1f6ng","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5ZuD6":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRANSITION_EVENTS", ()=>TRANSITION_EVENTS);
var _transitionJs = require("../transitions/transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
const noop = ()=>{};
const TRANSITION_EVENTS = {
    BREAK: 1,
    SNAP_TO_END: 2,
    IGNORE: 3
};
const DEFAULT_EASING = (t)=>t;
const DEFAULT_INTERRUPTION = TRANSITION_EVENTS.BREAK;
class TransitionManager {
    constructor(opts){
        this._onTransitionUpdate = (transition)=>{
            // NOTE: Be cautious re-ordering statements in this function.
            const { time, settings: { interpolator, startProps, endProps, duration, easing } } = transition;
            const t = easing(time / duration);
            const viewport = interpolator.interpolateProps(startProps, endProps, t);
            // This gurantees all props (e.g. bearing, longitude) are normalized
            // So when viewports are compared they are in same range.
            this.propsInTransition = this.getControllerState({
                ...this.props,
                ...viewport
            }).getViewportProps();
            this.onViewStateChange({
                viewState: this.propsInTransition,
                oldViewState: this.props
            });
        };
        this.getControllerState = opts.getControllerState;
        this.propsInTransition = null;
        this.transition = new (0, _transitionJsDefault.default)(opts.timeline);
        this.onViewStateChange = opts.onViewStateChange || noop;
        this.onStateChange = opts.onStateChange || noop;
    }
    finalize() {
        this.transition.cancel();
    }
    // Returns current transitioned viewport.
    getViewportInTransition() {
        return this.propsInTransition;
    }
    // Process the vewiport change, either ignore or trigger a new transition.
    // Return true if a new transition is triggered, false otherwise.
    processViewStateChange(nextProps) {
        let transitionTriggered = false;
        const currentProps = this.props;
        // Set this.props here as '_triggerTransition' calls '_updateViewport' that uses this.props.
        this.props = nextProps;
        // NOTE: Be cautious re-ordering statements in this function.
        if (!currentProps || this._shouldIgnoreViewportChange(currentProps, nextProps)) return false;
        if (this._isTransitionEnabled(nextProps)) {
            let startProps = currentProps;
            if (this.transition.inProgress) {
                // @ts-expect-error
                const { interruption, endProps } = this.transition.settings;
                startProps = {
                    ...currentProps,
                    ...interruption === TRANSITION_EVENTS.SNAP_TO_END ? endProps : this.propsInTransition || currentProps
                };
            }
            this._triggerTransition(startProps, nextProps);
            transitionTriggered = true;
        } else this.transition.cancel();
        return transitionTriggered;
    }
    updateTransition() {
        this.transition.update();
    }
    // Helper methods
    _isTransitionEnabled(props) {
        const { transitionDuration, transitionInterpolator } = props;
        return (transitionDuration > 0 || transitionDuration === 'auto') && Boolean(transitionInterpolator);
    }
    _isUpdateDueToCurrentTransition(props) {
        if (this.transition.inProgress && this.propsInTransition) // @ts-expect-error
        return this.transition.settings.interpolator.arePropsEqual(props, this.propsInTransition);
        return false;
    }
    _shouldIgnoreViewportChange(currentProps, nextProps) {
        if (this.transition.inProgress) {
            // @ts-expect-error
            const transitionSettings = this.transition.settings;
            // Ignore update if it is requested to be ignored
            return transitionSettings.interruption === TRANSITION_EVENTS.IGNORE || // Ignore update if it is due to current active transition.
            this._isUpdateDueToCurrentTransition(nextProps);
        }
        if (this._isTransitionEnabled(nextProps)) // Ignore if none of the viewport props changed.
        return nextProps.transitionInterpolator.arePropsEqual(currentProps, nextProps);
        return true;
    }
    _triggerTransition(startProps, endProps) {
        const startViewstate = this.getControllerState(startProps);
        const endViewStateProps = this.getControllerState(endProps).shortestPathFrom(startViewstate);
        // update transitionDuration for 'auto' mode
        const transitionInterpolator = endProps.transitionInterpolator;
        const duration = transitionInterpolator.getDuration ? transitionInterpolator.getDuration(startProps, endProps) : endProps.transitionDuration;
        if (duration === 0) return;
        const initialProps = transitionInterpolator.initializeProps(startProps, endViewStateProps);
        this.propsInTransition = {};
        const transitionSettings = {
            duration,
            easing: endProps.transitionEasing || DEFAULT_EASING,
            interpolator: transitionInterpolator,
            interruption: endProps.transitionInterruption || DEFAULT_INTERRUPTION,
            startProps: initialProps.start,
            endProps: initialProps.end,
            onStart: endProps.onTransitionStart,
            onUpdate: this._onTransitionUpdate,
            onInterrupt: this._onTransitionEnd(endProps.onTransitionInterrupt),
            onEnd: this._onTransitionEnd(endProps.onTransitionEnd)
        };
        this.transition.start(transitionSettings);
        this.onStateChange({
            inTransition: true
        });
        this.updateTransition();
    }
    _onTransitionEnd(callback) {
        return (transition)=>{
            this.propsInTransition = null;
            this.onStateChange({
                inTransition: false,
                isZooming: false,
                isPanning: false,
                isRotating: false
            });
            callback?.(transition);
        };
    }
}
exports.default = TransitionManager;

},{"../transitions/transition.js":"gMqhw","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gMqhw":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Transition {
    /**
     * @params timeline {Timeline}
     */ constructor(timeline){
        this._inProgress = false;
        this._handle = null;
        this.time = 0;
        // @ts-expect-error
        this.settings = {
            duration: 0
        };
        this._timeline = timeline;
    }
    /* Public API */ get inProgress() {
        return this._inProgress;
    }
    /**
     * (re)start this transition.
     * @params props {object} - optional overriding props. see constructor
     */ start(settings) {
        this.cancel();
        // @ts-expect-error
        this.settings = settings;
        this._inProgress = true;
        this.settings.onStart?.(this);
    }
    /**
     * end this transition if it is in progress.
     */ end() {
        if (this._inProgress) {
            this._timeline.removeChannel(this._handle);
            this._handle = null;
            this._inProgress = false;
            this.settings.onEnd?.(this);
        }
    }
    /**
     * cancel this transition if it is in progress.
     */ cancel() {
        if (this._inProgress) {
            this.settings.onInterrupt?.(this);
            this._timeline.removeChannel(this._handle);
            this._handle = null;
            this._inProgress = false;
        }
    }
    /**
     * update this transition. Returns `true` if updated.
     */ update() {
        if (!this._inProgress) return false;
        // It is important to initialize the handle during `update` instead of `start`.
        // The CPU time that the `start` frame takes should not be counted towards the duration.
        // On the other hand, `update` always happens during a render cycle. The clock starts when the
        // transition is rendered for the first time.
        if (this._handle === null) {
            const { _timeline: timeline, settings } = this;
            this._handle = timeline.addChannel({
                delay: timeline.getTime(),
                duration: settings.duration
            });
        }
        this.time = this._timeline.getTime(this._handle);
        // Call subclass method
        this._onUpdate();
        // Call user callback
        this.settings.onUpdate?.(this);
        // This only works if `settings.duration` is set
        // Spring transition must call `end` manually
        if (this._timeline.isFinished(this._handle)) this.end();
        return true;
    }
    /* Private API */ _onUpdate() {
    // for subclass override
    }
}
exports.default = Transition;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1f6ng":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transitionInterpolatorJs = require("./transition-interpolator.js");
var _transitionInterpolatorJsDefault = parcelHelpers.interopDefault(_transitionInterpolatorJs);
var _core = require("@math.gl/core");
const DEFAULT_PROPS = [
    'longitude',
    'latitude',
    'zoom',
    'bearing',
    'pitch'
];
const DEFAULT_REQUIRED_PROPS = [
    'longitude',
    'latitude',
    'zoom'
];
class LinearInterpolator extends (0, _transitionInterpolatorJsDefault.default) {
    /**
     * @param {Object} opts
     * @param {Array} opts.transitionProps - list of props to apply linear transition to.
     * @param {Array} opts.around - a screen point to zoom/rotate around.
     * @param {Function} opts.makeViewport - construct a viewport instance with given props.
     */ constructor(opts = {}){
        // Backward compatibility
        const transitionProps = Array.isArray(opts) ? opts : opts.transitionProps;
        const normalizedOpts = Array.isArray(opts) ? {} : opts;
        normalizedOpts.transitionProps = Array.isArray(transitionProps) ? {
            compare: transitionProps,
            required: transitionProps
        } : transitionProps || {
            compare: DEFAULT_PROPS,
            required: DEFAULT_REQUIRED_PROPS
        };
        super(normalizedOpts.transitionProps);
        this.opts = normalizedOpts;
    }
    initializeProps(startProps, endProps) {
        const result = super.initializeProps(startProps, endProps);
        const { makeViewport, around } = this.opts;
        if (makeViewport && around) {
            const startViewport = makeViewport(startProps);
            const endViewport = makeViewport(endProps);
            const aroundPosition = startViewport.unproject(around);
            result.start.around = around;
            Object.assign(result.end, {
                around: endViewport.project(aroundPosition),
                aroundPosition,
                width: endProps.width,
                height: endProps.height
            });
        }
        return result;
    }
    interpolateProps(startProps, endProps, t) {
        const propsInTransition = {};
        for (const key of this._propsToExtract)propsInTransition[key] = (0, _core.lerp)(startProps[key] || 0, endProps[key] || 0, t);
        if (endProps.aroundPosition && this.opts.makeViewport) {
            // Linear transition should be performed in common space
            const viewport = this.opts.makeViewport({
                ...endProps,
                ...propsInTransition
            });
            Object.assign(propsInTransition, viewport.panByPosition(endProps.aroundPosition, // anchor point in current screen coordinates
            (0, _core.lerp)(startProps.around, endProps.around, t)));
        }
        return propsInTransition;
    }
}
exports.default = LinearInterpolator;

},{"./transition-interpolator.js":"9qOb2","@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9qOb2":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@math.gl/core");
var _assertJs = require("../utils/assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
class TransitionInterpolator {
    /**
     * @param opts {array|object}
     * @param opts.compare {array} - prop names used in equality check
     * @param opts.extract {array} - prop names needed for interpolation
     * @param opts.required {array} - prop names that must be supplied
     * alternatively, supply one list of prop names as `opts` if all of the above are the same.
     */ constructor(opts){
        const { compare, extract, required } = opts;
        this._propsToCompare = compare;
        this._propsToExtract = extract || compare;
        this._requiredProps = required;
    }
    /**
     * Checks if two sets of props need transition in between
     * @param currentProps {object} - a list of viewport props
     * @param nextProps {object} - a list of viewport props
     * @returns {bool} - true if two props are equivalent
     */ arePropsEqual(currentProps, nextProps) {
        for (const key of this._propsToCompare){
            if (!(key in currentProps) || !(key in nextProps) || !(0, _core.equals)(currentProps[key], nextProps[key])) return false;
        }
        return true;
    }
    /**
     * Called before transition starts to validate/pre-process start and end props
     * @param startProps {object} - a list of starting viewport props
     * @param endProps {object} - a list of target viewport props
     * @returns {Object} {start, end} - start and end props to be passed
     *   to `interpolateProps`
     */ initializeProps(startProps, endProps) {
        const startViewStateProps = {};
        const endViewStateProps = {};
        for (const key of this._propsToExtract)if (key in startProps || key in endProps) {
            startViewStateProps[key] = startProps[key];
            endViewStateProps[key] = endProps[key];
        }
        this._checkRequiredProps(startViewStateProps);
        this._checkRequiredProps(endViewStateProps);
        return {
            start: startViewStateProps,
            end: endViewStateProps
        };
    }
    /**
     * Returns transition duration
     * @param startProps {object} - a list of starting viewport props
     * @param endProps {object} - a list of target viewport props
     * @returns {Number} - transition duration in milliseconds
     */ getDuration(startProps, endProps) {
        return endProps.transitionDuration;
    }
    _checkRequiredProps(props) {
        if (!this._requiredProps) return;
        this._requiredProps.forEach((propName)=>{
            const value = props[propName];
            (0, _assertJsDefault.default)(Number.isFinite(value) || Array.isArray(value), `${propName} is required for transition`);
        });
    }
}
exports.default = TransitionInterpolator;

},{"@math.gl/core":"6z0Tv","../utils/assert.js":"3Sh37","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3Sh37":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Replacement for the external assert method to reduce bundle size
// Note: We don't use the second "message" argument in calling code,
// so no need to support it here
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assert);
function assert(condition, message) {
    if (!condition) throw new Error(message || 'deck.gl: assertion failed.');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ezZbn":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class ViewState {
    constructor(props, state){
        this._viewportProps = this.applyConstraints(props);
        this._state = state;
    }
    getViewportProps() {
        return this._viewportProps;
    }
    getState() {
        return this._state;
    }
}
exports.default = ViewState;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7jWxM":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepEqualJs = require("../utils/deep-equal.js");
var _lightingEffectJs = require("../effects/lighting/lighting-effect.js");
var _lightingEffectJsDefault = parcelHelpers.interopDefault(_lightingEffectJs);
const DEFAULT_LIGHTING_EFFECT = new (0, _lightingEffectJsDefault.default)();
/** Sort two effects. Returns 0 if equal, negative if e1 < e2, positive if e1 > e2 */ function compareEffects(e1, e2) {
    const o1 = e1.order ?? Infinity;
    const o2 = e2.order ?? Infinity;
    return o1 - o2;
}
class EffectManager {
    constructor(context){
        this._resolvedEffects = [];
        /** Effect instances and order preference pairs, sorted by order */ this._defaultEffects = [];
        this.effects = [];
        this._context = context;
        this._needsRedraw = 'Initial render';
        this._setEffects([]);
    }
    /**
     * Register a new default effect, i.e. an effect presents regardless of user supplied props.effects
     */ addDefaultEffect(effect) {
        const defaultEffects = this._defaultEffects;
        if (!defaultEffects.find((e)=>e.id === effect.id)) {
            const index = defaultEffects.findIndex((e)=>compareEffects(e, effect) > 0);
            if (index < 0) defaultEffects.push(effect);
            else defaultEffects.splice(index, 0, effect);
            effect.setup(this._context);
            this._setEffects(this.effects);
        }
    }
    setProps(props) {
        if ('effects' in props) // Compare effects against each other shallowly
        {
            if (!(0, _deepEqualJs.deepEqual)(props.effects, this.effects, 1)) this._setEffects(props.effects);
        }
    }
    needsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        const redraw = this._needsRedraw;
        if (opts.clearRedrawFlags) this._needsRedraw = false;
        return redraw;
    }
    getEffects() {
        return this._resolvedEffects;
    }
    _setEffects(effects) {
        const oldEffectsMap = {};
        for (const effect of this.effects)oldEffectsMap[effect.id] = effect;
        const nextEffects = [];
        for (const effect of effects){
            const oldEffect = oldEffectsMap[effect.id];
            let effectToAdd = effect;
            if (oldEffect && oldEffect !== effect) {
                if (oldEffect.setProps) {
                    oldEffect.setProps(effect.props);
                    effectToAdd = oldEffect;
                } else oldEffect.cleanup(this._context);
            } else if (!oldEffect) effect.setup(this._context);
            nextEffects.push(effectToAdd);
            delete oldEffectsMap[effect.id];
        }
        for(const removedEffectId in oldEffectsMap)oldEffectsMap[removedEffectId].cleanup(this._context);
        this.effects = nextEffects;
        this._resolvedEffects = nextEffects.concat(this._defaultEffects);
        // Special case for lighting: only add default instance if no LightingEffect is specified
        if (!effects.some((effect)=>effect instanceof (0, _lightingEffectJsDefault.default))) this._resolvedEffects.push(DEFAULT_LIGHTING_EFFECT);
        this._needsRedraw = 'effects changed';
    }
    finalize() {
        for (const effect of this._resolvedEffects)effect.cleanup(this._context);
        this.effects.length = 0;
        this._resolvedEffects.length = 0;
        this._defaultEffects.length = 0;
    }
}
exports.default = EffectManager;

},{"../utils/deep-equal.js":"1MkgV","../effects/lighting/lighting-effect.js":"e7Z2E","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"idBfW":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../debug/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _drawLayersPassJs = require("../passes/draw-layers-pass.js");
var _drawLayersPassJsDefault = parcelHelpers.interopDefault(_drawLayersPassJs);
var _pickLayersPassJs = require("../passes/pick-layers-pass.js");
var _pickLayersPassJsDefault = parcelHelpers.interopDefault(_pickLayersPassJs);
const TRACE_RENDER_LAYERS = 'deckRenderer.renderLayers';
class DeckRenderer {
    constructor(device){
        this.device = device;
        this.layerFilter = null;
        this.drawPickingColors = false;
        this.drawLayersPass = new (0, _drawLayersPassJsDefault.default)(device);
        this.pickLayersPass = new (0, _pickLayersPassJsDefault.default)(device);
        this.renderCount = 0;
        this._needsRedraw = 'Initial render';
        this.renderBuffers = [];
        this.lastPostProcessEffect = null;
    }
    setProps(props) {
        if (this.layerFilter !== props.layerFilter) {
            this.layerFilter = props.layerFilter;
            this._needsRedraw = 'layerFilter changed';
        }
        if (this.drawPickingColors !== props.drawPickingColors) {
            this.drawPickingColors = props.drawPickingColors;
            this._needsRedraw = 'drawPickingColors changed';
        }
    }
    renderLayers(opts) {
        if (!opts.viewports.length) return;
        const layerPass = this.drawPickingColors ? this.pickLayersPass : this.drawLayersPass;
        const renderOpts = {
            layerFilter: this.layerFilter,
            isPicking: this.drawPickingColors,
            ...opts
        };
        if (renderOpts.effects) this._preRender(renderOpts.effects, renderOpts);
        const outputBuffer = this.lastPostProcessEffect ? this.renderBuffers[0] : renderOpts.target;
        if (this.lastPostProcessEffect) {
            renderOpts.clearColor = [
                0,
                0,
                0,
                0
            ];
            renderOpts.clearCanvas = true;
        }
        const renderStats = layerPass.render({
            ...renderOpts,
            target: outputBuffer
        });
        if (renderOpts.effects) this._postRender(renderOpts.effects, renderOpts);
        this.renderCount++;
        (0, _indexJsDefault.default)(TRACE_RENDER_LAYERS, this, renderStats, opts);
    }
    needsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        const redraw = this._needsRedraw;
        if (opts.clearRedrawFlags) this._needsRedraw = false;
        return redraw;
    }
    finalize() {
        const { renderBuffers } = this;
        for (const buffer of renderBuffers)buffer.delete();
        renderBuffers.length = 0;
    }
    _preRender(effects, opts) {
        this.lastPostProcessEffect = null;
        opts.preRenderStats = opts.preRenderStats || {};
        for (const effect of effects){
            opts.preRenderStats[effect.id] = effect.preRender(opts);
            if (effect.postRender) this.lastPostProcessEffect = effect.id;
        }
        if (this.lastPostProcessEffect) this._resizeRenderBuffers();
    }
    _resizeRenderBuffers() {
        const { renderBuffers } = this;
        const size = this.device.canvasContext.getDrawingBufferSize();
        if (renderBuffers.length === 0) [
            0,
            1
        ].map((i)=>{
            const texture = this.device.createTexture({
                sampler: {
                    minFilter: 'linear',
                    magFilter: 'linear'
                }
            });
            renderBuffers.push(this.device.createFramebuffer({
                id: `deck-renderbuffer-${i}`,
                colorAttachments: [
                    texture
                ]
            }));
        });
        for (const buffer of renderBuffers)buffer.resize(size);
    }
    _postRender(effects, opts) {
        const { renderBuffers } = this;
        const params = {
            ...opts,
            inputBuffer: renderBuffers[0],
            swapBuffer: renderBuffers[1]
        };
        for (const effect of effects)if (effect.postRender) {
            // If not the last post processing effect, unset the target so that
            // it only renders between the swap buffers
            params.target = effect.id === this.lastPostProcessEffect ? opts.target : undefined;
            const buffer = effect.postRender(params);
            // Buffer cannot be null if target is unset
            params.inputBuffer = buffer;
            params.swapBuffer = buffer === renderBuffers[0] ? renderBuffers[1] : renderBuffers[0];
        }
    }
}
exports.default = DeckRenderer;

},{"../debug/index.js":"7gIzA","../passes/draw-layers-pass.js":"hEHHs","../passes/pick-layers-pass.js":"6itdD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hEHHs":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layersPassJs = require("./layers-pass.js");
var _layersPassJsDefault = parcelHelpers.interopDefault(_layersPassJs);
class DrawLayersPass extends (0, _layersPassJsDefault.default) {
    shouldDrawLayer(layer) {
        const { operation } = layer.props;
        return operation.includes('draw') || operation.includes('terrain');
    }
}
exports.default = DrawLayersPass;

},{"./layers-pass.js":"286vl","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kXNG9":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pickLayersPassJs = require("../passes/pick-layers-pass.js");
var _pickLayersPassJsDefault = parcelHelpers.interopDefault(_pickLayersPassJs);
var _queryObjectJs = require("./picking/query-object.js");
var _pickInfoJs = require("./picking/pick-info.js");
class DeckPicker {
    constructor(device){
        this._pickable = true;
        this.device = device;
        this.pickLayersPass = new (0, _pickLayersPassJsDefault.default)(device);
        this.lastPickedInfo = {
            index: -1,
            layerId: null,
            info: null
        };
    }
    setProps(props) {
        if ('layerFilter' in props) this.layerFilter = props.layerFilter;
        if ('_pickable' in props) this._pickable = props._pickable;
    }
    finalize() {
        if (this.pickingFBO) this.pickingFBO.destroy();
        if (this.depthFBO) this.depthFBO.destroy();
    }
    /** Pick the closest info at given coordinate */ pickObject(opts) {
        return this._pickClosestObject(opts);
    }
    /** Get all unique infos within a bounding box */ pickObjects(opts) {
        return this._pickVisibleObjects(opts);
    }
    // Returns a new picking info object by assuming the last picked object is still picked
    getLastPickedObject({ x, y, layers, viewports }, lastPickedInfo = this.lastPickedInfo.info) {
        const lastPickedLayerId = lastPickedInfo && lastPickedInfo.layer && lastPickedInfo.layer.id;
        const lastPickedViewportId = lastPickedInfo && lastPickedInfo.viewport && lastPickedInfo.viewport.id;
        const layer = lastPickedLayerId ? layers.find((l)=>l.id === lastPickedLayerId) : null;
        const viewport = lastPickedViewportId && viewports.find((v)=>v.id === lastPickedViewportId) || viewports[0];
        const coordinate = viewport && viewport.unproject([
            x - viewport.x,
            y - viewport.y
        ]);
        const info = {
            x,
            y,
            viewport,
            coordinate,
            layer
        };
        return {
            ...lastPickedInfo,
            ...info
        };
    }
    // Private
    /** Ensures that picking framebuffer exists and matches the canvas size */ _resizeBuffer() {
        // Create a frame buffer if not already available
        if (!this.pickingFBO) {
            this.pickingFBO = this.device.createFramebuffer({
                colorAttachments: [
                    'rgba8unorm'
                ],
                depthStencilAttachment: 'depth16unorm'
            });
            if (this.device.isTextureFormatRenderable('rgba32float')) {
                const depthFBO = this.device.createFramebuffer({
                    colorAttachments: [
                        'rgba32float'
                    ],
                    depthStencilAttachment: 'depth16unorm'
                });
                this.depthFBO = depthFBO;
            }
        }
        // Resize it to current canvas size (this is a noop if size hasn't changed)
        const { canvas } = this.device.getDefaultCanvasContext();
        this.pickingFBO?.resize({
            width: canvas.width,
            height: canvas.height
        });
        this.depthFBO?.resize({
            width: canvas.width,
            height: canvas.height
        });
    }
    /** Preliminary filtering of the layers list. Skid picking pass if no layer is pickable. */ _getPickable(layers) {
        if (this._pickable === false) return null;
        const pickableLayers = layers.filter((layer)=>this.pickLayersPass.shouldDrawLayer(layer) && !layer.isComposite);
        return pickableLayers.length ? pickableLayers : null;
    }
    /** Pick the closest object at the given coordinate */ // eslint-disable-next-line max-statements,complexity
    _pickClosestObject({ layers, views, viewports, x, y, radius = 0, depth = 1, mode = 'query', unproject3D, onViewportActive, effects }) {
        // @ts-expect-error TODO - assuming WebGL context
        const pixelRatio = this.device.canvasContext.cssToDeviceRatio();
        const pickableLayers = this._getPickable(layers);
        if (!pickableLayers || viewports.length === 0) return {
            result: [],
            emptyInfo: (0, _pickInfoJs.getEmptyPickingInfo)({
                viewports,
                x,
                y,
                pixelRatio
            })
        };
        this._resizeBuffer();
        // Convert from canvas top-left to WebGL bottom-left coordinates
        // Top-left coordinates [x, y] to bottom-left coordinates [deviceX, deviceY]
        // And compensate for pixelRatio
        // @ts-expect-error TODO - assuming WebGL context
        const devicePixelRange = this.device.canvasContext.cssToDevicePixels([
            x,
            y
        ], true);
        const devicePixel = [
            devicePixelRange.x + Math.floor(devicePixelRange.width / 2),
            devicePixelRange.y + Math.floor(devicePixelRange.height / 2)
        ];
        const deviceRadius = Math.round(radius * pixelRatio);
        const { width, height } = this.pickingFBO;
        const deviceRect = this._getPickingRect({
            deviceX: devicePixel[0],
            deviceY: devicePixel[1],
            deviceRadius,
            deviceWidth: width,
            deviceHeight: height
        });
        const cullRect = {
            x: x - radius,
            y: y - radius,
            width: radius * 2 + 1,
            height: radius * 2 + 1
        };
        let infos;
        const result = [];
        const affectedLayers = new Set();
        for(let i = 0; i < depth; i++){
            let pickInfo;
            if (deviceRect) {
                const pickedResult = this._drawAndSample({
                    layers: pickableLayers,
                    views,
                    viewports,
                    onViewportActive,
                    deviceRect,
                    cullRect,
                    effects,
                    pass: `picking:${mode}`
                });
                pickInfo = (0, _queryObjectJs.getClosestObject)({
                    ...pickedResult,
                    deviceX: devicePixel[0],
                    deviceY: devicePixel[1],
                    deviceRadius,
                    deviceRect
                });
            } else pickInfo = {
                pickedColor: null,
                pickedObjectIndex: -1
            };
            let z;
            if (pickInfo.pickedLayer && unproject3D && this.depthFBO) {
                const { pickedColors: pickedColors2 } = this._drawAndSample({
                    layers: [
                        pickInfo.pickedLayer
                    ],
                    views,
                    viewports,
                    onViewportActive,
                    deviceRect: {
                        x: pickInfo.pickedX,
                        y: pickInfo.pickedY,
                        width: 1,
                        height: 1
                    },
                    cullRect,
                    effects,
                    pass: `picking:${mode}:z`
                }, true);
                // picked value is in common space (pixels) from the camera target (viewport.position)
                // convert it to meters from the ground
                if (pickedColors2[3]) z = pickedColors2[0];
            }
            // Only exclude if we need to run picking again.
            // We need to run picking again if an object is detected AND
            // we have not exhausted the requested depth.
            if (pickInfo.pickedLayer && i + 1 < depth) {
                affectedLayers.add(pickInfo.pickedLayer);
                pickInfo.pickedLayer.disablePickingIndex(pickInfo.pickedObjectIndex);
            }
            // This logic needs to run even if no object is picked.
            infos = (0, _pickInfoJs.processPickInfo)({
                pickInfo,
                lastPickedInfo: this.lastPickedInfo,
                mode,
                layers: pickableLayers,
                viewports,
                x,
                y,
                z,
                pixelRatio
            });
            for (const info of infos.values())if (info.layer) result.push(info);
            // If no object is picked stop.
            if (!pickInfo.pickedColor) break;
        }
        // reset only affected buffers
        for (const layer of affectedLayers)layer.restorePickingColors();
        return {
            result,
            emptyInfo: infos.get(null)
        };
    }
    /** Pick all objects within the given bounding box */ // eslint-disable-next-line max-statements
    _pickVisibleObjects({ layers, views, viewports, x, y, width = 1, height = 1, mode = 'query', maxObjects = null, onViewportActive, effects }) {
        const pickableLayers = this._getPickable(layers);
        if (!pickableLayers || viewports.length === 0) return [];
        this._resizeBuffer();
        // Convert from canvas top-left to WebGL bottom-left coordinates
        // And compensate for pixelRatio
        // @ts-expect-error TODO - assuming WebGL context
        const pixelRatio = this.device.canvasContext.cssToDeviceRatio();
        // @ts-expect-error TODO - assuming WebGL context
        const leftTop = this.device.canvasContext.cssToDevicePixels([
            x,
            y
        ], true);
        // take left and top (y inverted in device pixels) from start location
        const deviceLeft = leftTop.x;
        const deviceTop = leftTop.y + leftTop.height;
        // take right and bottom (y inverted in device pixels) from end location
        // @ts-expect-error TODO - assuming WebGL context
        const rightBottom = this.device.canvasContext.cssToDevicePixels([
            x + width,
            y + height
        ], true);
        const deviceRight = rightBottom.x + rightBottom.width;
        const deviceBottom = rightBottom.y;
        const deviceRect = {
            x: deviceLeft,
            y: deviceBottom,
            // deviceTop and deviceRight represent the first pixel outside the desired rect
            width: deviceRight - deviceLeft,
            height: deviceTop - deviceBottom
        };
        const pickedResult = this._drawAndSample({
            layers: pickableLayers,
            views,
            viewports,
            onViewportActive,
            deviceRect,
            cullRect: {
                x,
                y,
                width,
                height
            },
            effects,
            pass: `picking:${mode}`
        });
        const pickInfos = (0, _queryObjectJs.getUniqueObjects)(pickedResult);
        // `getUniqueObjects` dedup by picked color
        // However different picked color may be linked to the same picked object, e.g. stroke and fill of the same polygon
        // picked from different sub layers of a GeoJsonLayer
        // Here after resolving the picked index with `layer.getPickingInfo`, we need to dedup again by unique picked objects
        const uniquePickedObjects = new Map();
        const uniqueInfos = [];
        const limitMaxObjects = Number.isFinite(maxObjects);
        for(let i = 0; i < pickInfos.length; i++){
            if (limitMaxObjects && uniqueInfos.length >= maxObjects) break;
            const pickInfo = pickInfos[i];
            let info = {
                color: pickInfo.pickedColor,
                layer: null,
                index: pickInfo.pickedObjectIndex,
                picked: true,
                x,
                y,
                pixelRatio
            };
            info = (0, _pickInfoJs.getLayerPickingInfo)({
                layer: pickInfo.pickedLayer,
                info,
                mode
            });
            // info.layer is always populated because it's a picked pixel
            const pickedLayerId = info.layer.id;
            if (!uniquePickedObjects.has(pickedLayerId)) uniquePickedObjects.set(pickedLayerId, new Set());
            const uniqueObjectsInLayer = uniquePickedObjects.get(pickedLayerId);
            // info.object may be null if the layer is using non-iterable data.
            // Fall back to using index as identifier.
            const pickedObjectKey = info.object ?? info.index;
            if (!uniqueObjectsInLayer.has(pickedObjectKey)) {
                uniqueObjectsInLayer.add(pickedObjectKey);
                uniqueInfos.push(info);
            }
        }
        return uniqueInfos;
    }
    _drawAndSample({ layers, views, viewports, onViewportActive, deviceRect, cullRect, effects, pass }, pickZ = false) {
        const pickingFBO = pickZ ? this.depthFBO : this.pickingFBO;
        const opts = {
            layers,
            layerFilter: this.layerFilter,
            views,
            viewports,
            onViewportActive,
            pickingFBO,
            deviceRect,
            cullRect,
            effects,
            pass,
            pickZ,
            preRenderStats: {},
            isPicking: true
        };
        for (const effect of effects)if (effect.useInPicking) opts.preRenderStats[effect.id] = effect.preRender(opts);
        const { decodePickingColor } = this.pickLayersPass.render(opts);
        // Read from an already rendered picking buffer
        // Returns an Uint8ClampedArray of picked pixels
        const { x, y, width, height } = deviceRect;
        const pickedColors = new (pickZ ? Float32Array : Uint8Array)(width * height * 4);
        this.device.readPixelsToArrayWebGL(pickingFBO, {
            sourceX: x,
            sourceY: y,
            sourceWidth: width,
            sourceHeight: height,
            target: pickedColors
        });
        return {
            pickedColors,
            decodePickingColor
        };
    }
    // Calculate a picking rect centered on deviceX and deviceY and clipped to device
    // Returns null if pixel is outside of device
    _getPickingRect({ deviceX, deviceY, deviceRadius, deviceWidth, deviceHeight }) {
        // Create a box of size `radius * 2 + 1` centered at [deviceX, deviceY]
        const x = Math.max(0, deviceX - deviceRadius);
        const y = Math.max(0, deviceY - deviceRadius);
        const width = Math.min(deviceWidth, deviceX + deviceRadius + 1) - x;
        const height = Math.min(deviceHeight, deviceY + deviceRadius + 1) - y;
        // x, y out of bounds.
        if (width <= 0 || height <= 0) return null;
        return {
            x,
            y,
            width,
            height
        };
    }
}
exports.default = DeckPicker;

},{"../passes/pick-layers-pass.js":"6itdD","./picking/query-object.js":"N5iy0","./picking/pick-info.js":"fb39b","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"N5iy0":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable max-depth, max-statements */ /**
 * Pick at a specified pixel with a tolerance radius
 * Returns the closest object to the pixel in shape `{pickedColor, pickedLayer, pickedObjectIndex}`
 */ parcelHelpers.export(exports, "getClosestObject", ()=>getClosestObject);
/**
 * Examines a picking buffer for unique colors
 * Returns array of unique objects in shape `{x, y, pickedColor, pickedLayer, pickedObjectIndex}`
 */ parcelHelpers.export(exports, "getUniqueObjects", ()=>getUniqueObjects);
var _logJs = require("../../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
const NO_PICKED_OBJECT = {
    pickedColor: null,
    pickedObjectIndex: -1
};
function getClosestObject({ pickedColors, decodePickingColor, deviceX, deviceY, deviceRadius, deviceRect }) {
    // Traverse all pixels in picking results and find the one closest to the supplied
    // [deviceX, deviceY]
    const { x, y, width, height } = deviceRect;
    let minSquareDistanceToCenter = deviceRadius * deviceRadius;
    let closestPixelIndex = -1;
    let i = 0;
    for(let row = 0; row < height; row++){
        const dy = row + y - deviceY;
        const dy2 = dy * dy;
        if (dy2 > minSquareDistanceToCenter) // skip this row
        i += 4 * width;
        else for(let col = 0; col < width; col++){
            // Decode picked layer from color
            const pickedLayerIndex = pickedColors[i + 3] - 1;
            if (pickedLayerIndex >= 0) {
                const dx = col + x - deviceX;
                const d2 = dx * dx + dy2;
                if (d2 <= minSquareDistanceToCenter) {
                    minSquareDistanceToCenter = d2;
                    closestPixelIndex = i;
                }
            }
            i += 4;
        }
    }
    if (closestPixelIndex >= 0) {
        // Decode picked object index from color
        const pickedColor = pickedColors.slice(closestPixelIndex, closestPixelIndex + 4);
        const pickedObject = decodePickingColor(pickedColor);
        if (pickedObject) {
            const dy = Math.floor(closestPixelIndex / 4 / width);
            const dx = closestPixelIndex / 4 - dy * width;
            return {
                ...pickedObject,
                pickedColor,
                pickedX: x + dx,
                pickedY: y + dy
            };
        }
        (0, _logJsDefault.default).error('Picked non-existent layer. Is picking buffer corrupt?')();
    }
    return NO_PICKED_OBJECT;
}
function getUniqueObjects({ pickedColors, decodePickingColor }) {
    const uniqueColors = new Map();
    // Traverse all pixels in picking results and get unique colors
    if (pickedColors) for(let i = 0; i < pickedColors.length; i += 4){
        // Decode picked layer from color
        const pickedLayerIndex = pickedColors[i + 3] - 1;
        if (pickedLayerIndex >= 0) {
            const pickedColor = pickedColors.slice(i, i + 4);
            const colorKey = pickedColor.join(',');
            // eslint-disable-next-line
            if (!uniqueColors.has(colorKey)) {
                const pickedObject = decodePickingColor(pickedColor);
                // eslint-disable-next-line
                if (pickedObject) uniqueColors.set(colorKey, {
                    ...pickedObject,
                    color: pickedColor
                });
                else (0, _logJsDefault.default).error('Picked non-existent layer. Is picking buffer corrupt?')();
            }
        }
    }
    return Array.from(uniqueColors.values());
}

},{"../../utils/log.js":"9S0lD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fb39b":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Generates some basic information of the picking action: x, y, coordinates etc.
 * Regardless if anything is picked
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEmptyPickingInfo", ()=>getEmptyPickingInfo);
/* eslint-disable max-depth */ /** Generates the picking info of a picking operation */ parcelHelpers.export(exports, "processPickInfo", ()=>processPickInfo);
/** Walk up the layer composite chain to populate the info object */ parcelHelpers.export(exports, "getLayerPickingInfo", ()=>getLayerPickingInfo);
function getEmptyPickingInfo({ pickInfo, viewports, pixelRatio, x, y, z }) {
    // If more than one viewports are used in the picking pass, locate the viewport that
    // drew the picked pixel
    let pickedViewport = viewports[0];
    if (viewports.length > 1) // Find the viewport that contain the picked pixel
    pickedViewport = getViewportFromCoordinates(pickInfo?.pickedViewports || viewports, {
        x,
        y
    });
    let coordinate;
    if (pickedViewport) {
        const point = [
            x - pickedViewport.x,
            y - pickedViewport.y
        ];
        if (z !== undefined) point[2] = z;
        coordinate = pickedViewport.unproject(point);
    }
    return {
        color: null,
        layer: null,
        viewport: pickedViewport,
        index: -1,
        picked: false,
        x,
        y,
        pixel: [
            x,
            y
        ],
        coordinate,
        devicePixel: pickInfo && 'pickedX' in pickInfo ? [
            pickInfo.pickedX,
            pickInfo.pickedY
        ] : undefined,
        pixelRatio
    };
}
function processPickInfo(opts) {
    const { pickInfo, lastPickedInfo, mode, layers } = opts;
    const { pickedColor, pickedLayer, pickedObjectIndex } = pickInfo;
    const affectedLayers = pickedLayer ? [
        pickedLayer
    ] : [];
    if (mode === 'hover') {
        // only invoke onHover events if picked object has changed
        const lastPickedPixelIndex = lastPickedInfo.index;
        const lastPickedLayerId = lastPickedInfo.layerId;
        const pickedLayerId = pickedLayer ? pickedLayer.props.id : null;
        // proceed only if picked object changed
        if (pickedLayerId !== lastPickedLayerId || pickedObjectIndex !== lastPickedPixelIndex) {
            if (pickedLayerId !== lastPickedLayerId) {
                // We cannot store a ref to lastPickedLayer in the context because
                // the state of an outdated layer is no longer valid
                // and the props may have changed
                const lastPickedLayer = layers.find((layer)=>layer.props.id === lastPickedLayerId);
                if (lastPickedLayer) // Let leave event fire before enter event
                affectedLayers.unshift(lastPickedLayer);
            }
            // Update layer manager context
            lastPickedInfo.layerId = pickedLayerId;
            lastPickedInfo.index = pickedObjectIndex;
            lastPickedInfo.info = null;
        }
    }
    const baseInfo = getEmptyPickingInfo(opts);
    // Use a Map to store all picking infos.
    // The following two forEach loops are the result of
    // https://github.com/visgl/deck.gl/issues/443
    // Please be very careful when changing this pattern
    const infos = new Map();
    // Make sure infos always contain something even if no layer is affected
    infos.set(null, baseInfo);
    affectedLayers.forEach((layer)=>{
        let info = {
            ...baseInfo
        };
        if (layer === pickedLayer) {
            info.color = pickedColor;
            info.index = pickedObjectIndex;
            info.picked = true;
        }
        info = getLayerPickingInfo({
            layer,
            info,
            mode
        });
        const rootLayer = info.layer;
        if (layer === pickedLayer && mode === 'hover') lastPickedInfo.info = info;
        // This guarantees that there will be only one copy of info for
        // one composite layer
        infos.set(rootLayer.id, info);
        if (mode === 'hover') rootLayer.updateAutoHighlight(info);
    });
    return infos;
}
function getLayerPickingInfo({ layer, info, mode }) {
    while(layer && info){
        // For a composite layer, sourceLayer will point to the sublayer
        // where the event originates from.
        // It provides additional context for the composite layer's
        // getPickingInfo() method to populate the info object
        const sourceLayer = info.layer || null;
        info.sourceLayer = sourceLayer;
        info.layer = layer;
        // layer.pickLayer() function requires a non-null ```layer.state```
        // object to function properly. So the layer referenced here
        // must be the "current" layer, not an "out-dated" / "invalidated" layer
        info = layer.getPickingInfo({
            info,
            mode,
            sourceLayer
        });
        layer = layer.parent;
    }
    return info;
}
/** Indentifies which viewport, if any corresponds to x and y
   If multiple viewports contain the target pixel, last viewport drawn is returend
   Returns first viewport if no match */ function getViewportFromCoordinates(viewports, pixel) {
    // find the last viewport that contains the pixel
    for(let i = viewports.length - 1; i >= 0; i--){
        const viewport = viewports[i];
        if (viewport.containsPixel(pixel)) return viewport;
    }
    return viewports[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2nxq8":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WidgetManager", ()=>WidgetManager);
var _constantsJs = require("./constants.js");
var _deepEqualJs = require("../utils/deep-equal.js");
const PLACEMENTS = {
    'top-left': {
        top: 0,
        left: 0
    },
    'top-right': {
        top: 0,
        right: 0
    },
    'bottom-left': {
        bottom: 0,
        left: 0
    },
    'bottom-right': {
        bottom: 0,
        right: 0
    },
    fill: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    }
};
const DEFAULT_PLACEMENT = 'top-left';
const ROOT_CONTAINER_ID = '__root';
class WidgetManager {
    constructor({ deck, parentElement }){
        /** Widgets added via the imperative API */ this.defaultWidgets = [];
        /** Widgets received from the declarative API */ this.widgets = [];
        /** Resolved widgets from both imperative and declarative APIs */ this.resolvedWidgets = [];
        /** Mounted HTML containers */ this.containers = {};
        /** Viewport provided to widget on redraw */ this.lastViewports = {};
        this.deck = deck;
        this.parentElement = parentElement;
    }
    getWidgets() {
        return this.resolvedWidgets;
    }
    /** Declarative API to configure widgets */ setProps(props) {
        if (props.widgets && !(0, _deepEqualJs.deepEqual)(props.widgets, this.widgets, 1)) this._setWidgets(props.widgets);
    }
    finalize() {
        for (const widget of this.getWidgets())this._remove(widget);
        this.defaultWidgets.length = 0;
        this.resolvedWidgets.length = 0;
        for(const id in this.containers)this.containers[id].remove();
    }
    /** Imperative API. Widgets added this way are not affected by the declarative prop. */ addDefault(widget) {
        if (!this.defaultWidgets.find((w)=>w.id === widget.id)) {
            this._add(widget);
            this.defaultWidgets.push(widget);
            // Update widget list
            this._setWidgets(this.widgets);
        }
    }
    /** Resolve widgets from the declarative prop */ _setWidgets(nextWidgets) {
        const oldWidgetMap = {};
        for (const widget of this.resolvedWidgets)oldWidgetMap[widget.id] = widget;
        // Clear and rebuild the list
        this.resolvedWidgets.length = 0;
        // Add all default widgets
        for (const widget of this.defaultWidgets){
            oldWidgetMap[widget.id] = null;
            this.resolvedWidgets.push(widget);
        }
        for (let widget of nextWidgets){
            const oldWidget = oldWidgetMap[widget.id];
            if (!oldWidget) // Widget is new
            this._add(widget);
            else if (// Widget placement changed
            oldWidget.viewId !== widget.viewId || oldWidget.placement !== widget.placement) {
                this._remove(oldWidget);
                this._add(widget);
            } else if (widget !== oldWidget) {
                // Widget props changed
                oldWidget.setProps(widget.props);
                widget = oldWidget;
            }
            // mark as matched
            oldWidgetMap[widget.id] = null;
            this.resolvedWidgets.push(widget);
        }
        for(const id in oldWidgetMap){
            const oldWidget = oldWidgetMap[id];
            if (oldWidget) // No longer exists
            this._remove(oldWidget);
        }
        this.widgets = nextWidgets;
    }
    _add(widget) {
        const { viewId = null, placement = DEFAULT_PLACEMENT } = widget;
        const element = widget.onAdd({
            deck: this.deck,
            viewId
        });
        if (element) this._getContainer(viewId, placement).append(element);
        widget._element = element;
    }
    _remove(widget) {
        widget.onRemove?.();
        if (widget._element) widget._element.remove();
        widget._element = undefined;
    }
    /* global document */ _getContainer(viewId, placement) {
        const containerId = viewId || ROOT_CONTAINER_ID;
        let viewContainer = this.containers[containerId];
        if (!viewContainer) {
            viewContainer = document.createElement('div');
            viewContainer.style.pointerEvents = 'none';
            viewContainer.style.position = 'absolute';
            viewContainer.style.overflow = 'hidden';
            this.parentElement?.append(viewContainer);
            this.containers[containerId] = viewContainer;
        }
        let container = viewContainer.querySelector(`.${placement}`);
        if (!container) {
            container = document.createElement('div');
            container.className = placement;
            container.style.position = 'absolute';
            container.style.zIndex = '2';
            Object.assign(container.style, PLACEMENTS[placement]);
            viewContainer.append(container);
        }
        return container;
    }
    _updateContainers() {
        const canvasWidth = this.deck.width;
        const canvasHeight = this.deck.height;
        for(const id in this.containers){
            const viewport = this.lastViewports[id] || null;
            const visible = id === ROOT_CONTAINER_ID || viewport;
            const container = this.containers[id];
            if (visible) {
                container.style.display = 'block';
                // Align the container with the view
                container.style.left = `${viewport ? viewport.x : 0}px`;
                container.style.top = `${viewport ? viewport.y : 0}px`;
                container.style.width = `${viewport ? viewport.width : canvasWidth}px`;
                container.style.height = `${viewport ? viewport.height : canvasHeight}px`;
            } else container.style.display = 'none';
        }
    }
    onRedraw({ viewports, layers }) {
        const viewportsById = viewports.reduce((acc, v)=>{
            acc[v.id] = v;
            return acc;
        }, {});
        for (const widget of this.getWidgets()){
            const { viewId } = widget;
            if (viewId) {
                // Attached to a specific view
                const viewport = viewportsById[viewId];
                if (viewport) {
                    if (widget.onViewportChange) widget.onViewportChange(viewport);
                    widget.onRedraw?.({
                        viewports: [
                            viewport
                        ],
                        layers
                    });
                }
            } else {
                // Not attached to a specific view
                if (widget.onViewportChange) for (const viewport of viewports)widget.onViewportChange(viewport);
                widget.onRedraw?.({
                    viewports,
                    layers
                });
            }
        }
        this.lastViewports = viewportsById;
        this._updateContainers();
    }
    onHover(info, event) {
        for (const widget of this.getWidgets()){
            const { viewId } = widget;
            if (!viewId || viewId === info.viewport?.id) widget.onHover?.(info, event);
        }
    }
    onEvent(info, event) {
        const eventHandlerProp = (0, _constantsJs.EVENT_HANDLERS)[event.type];
        if (!eventHandlerProp) return;
        for (const widget of this.getWidgets()){
            const { viewId } = widget;
            if (!viewId || viewId === info.viewport?.id) widget[eventHandlerProp]?.(info, event);
        }
    }
}

},{"./constants.js":"k6l9N","../utils/deep-equal.js":"1MkgV","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1nqYZ":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* global document */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const defaultStyle = {
    zIndex: '1',
    position: 'absolute',
    pointerEvents: 'none',
    color: '#a0a7b4',
    backgroundColor: '#29323c',
    padding: '10px',
    top: '0',
    left: '0',
    display: 'none'
};
class Tooltip {
    constructor(){
        this.id = 'default-tooltip';
        this.placement = 'fill';
        this.props = {};
        this.isVisible = false;
    }
    onAdd({ deck }) {
        const el = document.createElement('div');
        el.className = 'deck-tooltip';
        Object.assign(el.style, defaultStyle);
        this.deck = deck;
        this.element = el;
        return el;
    }
    onRemove() {
        this.deck = undefined;
        this.element = undefined;
    }
    setProps() {}
    onViewportChange(viewport) {
        if (this.isVisible && viewport.id === this.lastViewport?.id && viewport !== this.lastViewport) // Camera has moved, clear tooltip
        this.setTooltip(null);
    }
    onHover(info) {
        const { deck } = this;
        const getTooltip = deck && deck.props.getTooltip;
        if (!getTooltip) return;
        const displayInfo = getTooltip(info);
        this.lastViewport = info.viewport;
        this.setTooltip(displayInfo, info.x, info.y);
    }
    setTooltip(displayInfo, x, y) {
        const el = this.element;
        if (!el) return;
        if (typeof displayInfo === 'string') el.innerText = displayInfo;
        else if (!displayInfo) {
            this.isVisible = false;
            el.style.display = 'none';
            return;
        } else {
            if (displayInfo.text) el.innerText = displayInfo.text;
            if (displayInfo.html) el.innerHTML = displayInfo.html;
            if (displayInfo.className) el.className = displayInfo.className;
        }
        this.isVisible = true;
        el.style.display = 'block';
        el.style.transform = `translate(${x}px, ${y}px)`;
        if (displayInfo && typeof displayInfo === 'object' && 'style' in displayInfo) Object.assign(el.style, displayInfo.style);
    }
}
exports.default = Tooltip;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9NtH7":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// WebGL adapter classes
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "webgl2Adapter", ()=>(0, _webglAdapterJs.webgl2Adapter));
// WebGL Device classes
parcelHelpers.export(exports, "WebGLDevice", ()=>(0, _webglDeviceJs.WebGLDevice));
parcelHelpers.export(exports, "WebGLCanvasContext", ()=>(0, _webglCanvasContextJs.WebGLCanvasContext));
// WebGL Resource classes
parcelHelpers.export(exports, "WEBGLBuffer", ()=>(0, _webglBufferJs.WEBGLBuffer));
parcelHelpers.export(exports, "WEBGLTexture", ()=>(0, _webglTextureJs.WEBGLTexture));
// export {WEBGLExternalTexture} from './adapter/resources/webgl-external-texture';
parcelHelpers.export(exports, "WEBGLShader", ()=>(0, _webglShaderJs.WEBGLShader));
parcelHelpers.export(exports, "WEBGLSampler", ()=>(0, _webglSamplerJs.WEBGLSampler));
parcelHelpers.export(exports, "WEBGLFramebuffer", ()=>(0, _webglFramebufferJs.WEBGLFramebuffer));
parcelHelpers.export(exports, "WEBGLRenderPipeline", ()=>(0, _webglRenderPipelineJs.WEBGLRenderPipeline));
// export {WEBGLComputePipeline} from './adapter/resources/webgl-compute-pipeline';
parcelHelpers.export(exports, "WEBGLCommandEncoder", ()=>(0, _webglCommandEncoderJs.WEBGLCommandEncoder));
parcelHelpers.export(exports, "WEBGLRenderPass", ()=>(0, _webglRenderPassJs.WEBGLRenderPass));
// export {WEBGLComputePass} from './adapter/resources/webgl-compute-pass';
parcelHelpers.export(exports, "WEBGLVertexArray", ()=>(0, _webglVertexArrayJs.WEBGLVertexArray));
// WebGL adapter classes
parcelHelpers.export(exports, "WEBGLTransformFeedback", ()=>(0, _webglTransformFeedbackJs.WEBGLTransformFeedback));
// WebGL adapter classes
parcelHelpers.export(exports, "Accessor", ()=>(0, _accessorJs.Accessor));
// Unified parameter API
parcelHelpers.export(exports, "setDeviceParameters", ()=>(0, _deviceParametersJs.setDeviceParameters));
parcelHelpers.export(exports, "withDeviceParameters", ()=>(0, _deviceParametersJs.withDeviceParameters));
// HELPERS - EXPERIMENTAL
parcelHelpers.export(exports, "getShaderLayoutFromGLSL", ()=>(0, _getShaderLayoutJs.getShaderLayoutFromGLSL));
parcelHelpers.export(exports, "WebGLStateTracker", ()=>(0, _webglStateTrackerJs.WebGLStateTracker));
// DEPRECATED TEST EXPORTS
parcelHelpers.export(exports, "resetGLParameters", ()=>(0, _unifiedParameterApiJs.resetGLParameters));
parcelHelpers.export(exports, "setGLParameters", ()=>(0, _unifiedParameterApiJs.setGLParameters));
parcelHelpers.export(exports, "getGLParameters", ()=>(0, _unifiedParameterApiJs.getGLParameters));
parcelHelpers.export(exports, "withGLParameters", ()=>(0, _withParametersJs.withGLParameters));
var _webglAdapterJs = require("./adapter/webgl-adapter.js");
var _webglDeviceJs = require("./adapter/webgl-device.js");
var _webglCanvasContextJs = require("./adapter/webgl-canvas-context.js");
var _webglBufferJs = require("./adapter/resources/webgl-buffer.js");
var _webglTextureJs = require("./adapter/resources/webgl-texture.js");
var _webglShaderJs = require("./adapter/resources/webgl-shader.js");
var _webglSamplerJs = require("./adapter/resources/webgl-sampler.js");
var _webglFramebufferJs = require("./adapter/resources/webgl-framebuffer.js");
var _webglRenderPipelineJs = require("./adapter/resources/webgl-render-pipeline.js");
var _webglCommandEncoderJs = require("./adapter/resources/webgl-command-encoder.js");
var _webglRenderPassJs = require("./adapter/resources/webgl-render-pass.js");
var _webglVertexArrayJs = require("./adapter/resources/webgl-vertex-array.js");
var _webglTransformFeedbackJs = require("./adapter/resources/webgl-transform-feedback.js");
var _accessorJs = require("./deprecated/accessor.js");
var _deviceParametersJs = require("./adapter/converters/device-parameters.js");
var _getShaderLayoutJs = require("./adapter/helpers/get-shader-layout.js");
var _webglStateTrackerJs = require("./context/state-tracker/webgl-state-tracker.js");
var _unifiedParameterApiJs = require("./context/parameters/unified-parameter-api.js");
var _withParametersJs = require("./context/state-tracker/with-parameters.js");

},{"./adapter/webgl-adapter.js":"jpWIY","./adapter/webgl-device.js":"afxB6","./adapter/webgl-canvas-context.js":false,"./adapter/resources/webgl-buffer.js":"fIu5h","./adapter/resources/webgl-texture.js":false,"./adapter/resources/webgl-shader.js":false,"./adapter/resources/webgl-sampler.js":false,"./adapter/resources/webgl-framebuffer.js":false,"./adapter/resources/webgl-render-pipeline.js":false,"./adapter/resources/webgl-command-encoder.js":false,"./adapter/resources/webgl-render-pass.js":false,"./adapter/resources/webgl-vertex-array.js":false,"./adapter/resources/webgl-transform-feedback.js":false,"./deprecated/accessor.js":false,"./adapter/converters/device-parameters.js":false,"./adapter/helpers/get-shader-layout.js":false,"./context/state-tracker/webgl-state-tracker.js":false,"./context/parameters/unified-parameter-api.js":false,"./context/state-tracker/with-parameters.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jpWIY":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebGLAdapter", ()=>WebGLAdapter);
parcelHelpers.export(exports, "webgl2Adapter", ()=>webgl2Adapter);
var _core = require("@luma.gl/core");
var _webglDeviceJs = require("./webgl-device.js");
var _polyfillWebgl1ExtensionsJs = require("../context/polyfills/polyfill-webgl1-extensions.js");
var _spectorJs = require("../context/debug/spector.js");
var _webglDeveloperToolsJs = require("../context/debug/webgl-developer-tools.js");
const LOG_LEVEL = 1;
class WebGLAdapter extends (0, _core.Adapter) {
    /** type of device's created by this adapter */ type = 'webgl';
    constructor(){
        super();
        // Add spector default props to device default props, so that runtime settings are observed
        (0, _core.Device).defaultProps = {
            ...(0, _core.Device).defaultProps,
            ...(0, _spectorJs.DEFAULT_SPECTOR_PROPS)
        };
        // @ts-ignore DEPRECATED For backwards compatibility luma.registerDevices
        (0, _webglDeviceJs.WebGLDevice).adapter = this;
    }
    /** Check if WebGL 2 is available */ isSupported() {
        return typeof WebGL2RenderingContext !== 'undefined';
    }
    /** Force any created WebGL contexts to be WebGL2 contexts, polyfilled with WebGL1 extensions */ enforceWebGL2(enable) {
        (0, _polyfillWebgl1ExtensionsJs.enforceWebGL2)(enable);
    }
    /**
     * Get a device instance from a GL context
     * Creates a WebGLCanvasContext against the contexts canvas
     * @note autoResize will be disabled, assuming that whoever created the external context will be handling resizes.
     * @param gl
     * @returns
     */ async attach(gl) {
        if (gl instanceof (0, _webglDeviceJs.WebGLDevice)) return gl;
        // @ts-expect-error
        if (gl?.device instanceof (0, _core.Device)) // @ts-expect-error
        return gl.device;
        if (!isWebGL(gl)) throw new Error('Invalid WebGL2RenderingContext');
        // We create a new device using the provided WebGL context and its canvas
        // Assume that whoever created the external context will be handling resizes.
        return new (0, _webglDeviceJs.WebGLDevice)({
            _handle: gl,
            createCanvasContext: {
                canvas: gl.canvas,
                autoResize: false
            }
        });
    }
    async create(props = {}) {
        (0, _core.log).groupCollapsed(LOG_LEVEL, 'WebGLDevice created')();
        const promises = [];
        // Load webgl and spector debug scripts from CDN if requested
        if (props.debugWebGL || props.debug) promises.push((0, _webglDeveloperToolsJs.loadWebGLDeveloperTools)());
        if (props.debugSpectorJS) promises.push((0, _spectorJs.loadSpectorJS)(props));
        // Wait for all the loads to settle before creating the context.
        // The Device.create() functions are async, so in contrast to the constructor, we can `await` here.
        const results = await Promise.allSettled(promises);
        for (const result of results)if (result.status === 'rejected') (0, _core.log).error(`Failed to initialize debug libraries ${result.reason}`)();
        const device = new (0, _webglDeviceJs.WebGLDevice)(props);
        // Log some debug info about the newly created context
        const message = `\
${device._reused ? 'Reusing' : 'Created'} device with WebGL2 ${device.debug ? 'debug ' : ''}context: \
${device.info.vendor}, ${device.info.renderer} for canvas: ${device.canvasContext.id}`;
        (0, _core.log).probe(LOG_LEVEL, message)();
        (0, _core.log).table(LOG_LEVEL, device.info)();
        (0, _core.log).groupEnd(LOG_LEVEL)();
        return device;
    }
}
/** Check if supplied parameter is a WebGL2RenderingContext */ function isWebGL(gl) {
    if (typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext) return true;
    // Look for debug contexts, headless gl etc
    return Boolean(gl && Number.isFinite(gl._version));
}
const webgl2Adapter = new WebGLAdapter();

},{"@luma.gl/core":"7TxCR","./webgl-device.js":"afxB6","../context/polyfills/polyfill-webgl1-extensions.js":"31ciR","../context/debug/spector.js":"9oiSc","../context/debug/webgl-developer-tools.js":"5wukC","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"afxB6":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** WebGPU style Device API for a WebGL context */ parcelHelpers.export(exports, "WebGLDevice", ()=>WebGLDevice);
var _core = require("@luma.gl/core");
var _webglStateTrackerJs = require("../context/state-tracker/webgl-state-tracker.js");
var _createBrowserContextJs = require("../context/helpers/create-browser-context.js");
var _webglDeviceInfoJs = require("./device-helpers/webgl-device-info.js");
var _webglDeviceFeaturesJs = require("./device-helpers/webgl-device-features.js");
var _webglDeviceLimitsJs = require("./device-helpers/webgl-device-limits.js");
var _webglCanvasContextJs = require("./webgl-canvas-context.js");
var _spectorJs = require("../context/debug/spector.js");
var _webglDeveloperToolsJs = require("../context/debug/webgl-developer-tools.js");
var _webglTextureTableJs = require("./converters/webgl-texture-table.js");
var _uidJs = require("../utils/uid.js");
var _webglBufferJs = require("./resources/webgl-buffer.js");
var _webglShaderJs = require("./resources/webgl-shader.js");
var _webglSamplerJs = require("./resources/webgl-sampler.js");
var _webglTextureJs = require("./resources/webgl-texture.js");
var _webglFramebufferJs = require("./resources/webgl-framebuffer.js");
var _webglRenderPassJs = require("./resources/webgl-render-pass.js");
var _webglRenderPipelineJs = require("./resources/webgl-render-pipeline.js");
var _webglCommandEncoderJs = require("./resources/webgl-command-encoder.js");
var _webglVertexArrayJs = require("./resources/webgl-vertex-array.js");
var _webglTransformFeedbackJs = require("./resources/webgl-transform-feedback.js");
var _webglQuerySetJs = require("./resources/webgl-query-set.js");
var _webglTextureUtilsJs = require("./helpers/webgl-texture-utils.js");
var _unifiedParameterApiJs = require("../context/parameters/unified-parameter-api.js");
var _withParametersJs = require("../context/state-tracker/with-parameters.js");
var _webglExtensionsJs = require("../context/helpers/webgl-extensions.js");
class WebGLDevice extends (0, _core.Device) {
    //
    // Public `Device` API
    //
    /** type of this device */ type = 'webgl';
    // Use the ! assertion to handle the case where _reuseDevices causes the constructor to return early
    /** The underlying WebGL context */ handle;
    features;
    limits;
    info;
    canvasContext;
    lost;
    _resolveContextLost;
    /** WebGL2 context. */ gl;
    debug = false;
    /** State used by luma.gl classes: TODO - move to canvasContext*/ _canvasSizeInfo = {
        clientWidth: 0,
        clientHeight: 0,
        devicePixelRatio: 1
    };
    /** State used by luma.gl classes - TODO - not used? */ _extensions = {};
    _polyfilled = false;
    /** Instance of Spector.js (if initialized) */ spectorJS;
    //
    // Public API
    //
    constructor(props){
        super({
            ...props,
            id: props.id || (0, _uidJs.uid)('webgl-device')
        });
        const canvasContextProps = (0, _core.Device)._getCanvasContextProps(props);
        // WebGL requires a canvas to be created before creating the context
        if (!canvasContextProps) throw new Error('WebGLDevice requires props.createCanvasContext to be set');
        // Check if the WebGL context is already associated with a device
        // Note that this can be avoided in webgl2adapter.create() if
        // DeviceProps._reuseDevices is set.
        // @ts-expect-error device is attached to context
        let device = canvasContextProps.canvas?.gl?.device;
        if (device) throw new Error(`WebGL context already attached to device ${device.id}`);
        // Create and instrument context
        this.canvasContext = new (0, _webglCanvasContextJs.WebGLCanvasContext)(this, canvasContextProps);
        this.lost = new Promise((resolve)=>{
            this._resolveContextLost = resolve;
        });
        const webglContextAttributes = {
            ...props.webgl
        };
        // Copy props from CanvasContextProps
        if (canvasContextProps.alphaMode === 'premultiplied') webglContextAttributes.premultipliedAlpha = true;
        if (props.powerPreference !== undefined) webglContextAttributes.powerPreference = props.powerPreference;
        // Check if we should attach to an externally created context or create a new context
        const externalGLContext = this.props._handle;
        const gl = externalGLContext || (0, _createBrowserContextJs.createBrowserContext)(this.canvasContext.canvas, {
            onContextLost: (event)=>this._resolveContextLost?.({
                    reason: 'destroyed',
                    message: 'Entered sleep mode, or too many apps or browser tabs are using the GPU.'
                }),
            // eslint-disable-next-line no-console
            onContextRestored: (event)=>console.log('WebGL context restored')
        }, webglContextAttributes);
        if (!gl) throw new Error('WebGL context creation failed');
        // Note that the browser will only create one WebGL context per canvas.
        // This means that a newly created gl context may already have a device attached to it.
        // @ts-expect-error luma.gl stores a device reference on the context.
        device = gl.device;
        if (device) {
            if (props._reuseDevices) {
                (0, _core.log).log(1, `Not creating a new Device, instead returning a reference to Device ${device.id} already attached to WebGL context`, device)();
                device._reused = true;
                return device;
            }
            throw new Error(`WebGL context already attached to device ${device.id}`);
        }
        this.handle = gl;
        this.gl = gl;
        // Add spector debug instrumentation to context
        // We need to trust spector integration to decide if spector should be initialized
        // We also run spector instrumentation first, otherwise spector can clobber luma instrumentation.
        this.spectorJS = (0, _spectorJs.initializeSpectorJS)({
            ...this.props,
            gl: this.handle
        });
        // Instrument context
        this.gl.device = this; // Update GL context: Link webgl context back to device
        // TODO - remove, this is only used to detect debug contexts.
        this.gl._version = 2; // Update GL context: Store WebGL version field on gl context (HACK to identify debug contexts)
        // initialize luma Device fields
        this.info = (0, _webglDeviceInfoJs.getDeviceInfo)(this.gl, this._extensions);
        this.limits = new (0, _webglDeviceLimitsJs.WebGLDeviceLimits)(this.gl);
        this.features = new (0, _webglDeviceFeaturesJs.WebGLDeviceFeatures)(this.gl, this._extensions, this.props._disabledFeatures);
        if (this.props._initializeFeatures) this.features.initializeFeatures();
        if (canvasContextProps.autoResize !== false) this.canvasContext.resize();
        // Install context state tracking
        const glState = new (0, _webglStateTrackerJs.WebGLStateTracker)(this.gl, {
            log: (...args)=>(0, _core.log).log(1, ...args)()
        });
        glState.trackState(this.gl, {
            copyState: false
        });
        // DEBUG contexts: Add luma debug instrumentation to the context, force log level to at least 1
        const debugWebGL = props.debugWebGL || props.debug;
        const traceWebGL = props.debugWebGL;
        if (debugWebGL) {
            this.gl = (0, _webglDeveloperToolsJs.makeDebugContext)(this.gl, {
                debugWebGL,
                traceWebGL
            });
            (0, _core.log).warn('WebGL debug mode activated. Performance reduced.')();
            if (props.debugWebGL) (0, _core.log).level = Math.max((0, _core.log).level, 1);
        }
    }
    /**
     * Destroys the device
     *
     * @note "Detaches" from the WebGL context unless _reuseDevices is true.
     *
     * @note The underlying WebGL context is not immediately destroyed,
     * but may be destroyed later through normal JavaScript garbage collection.
     * This is a fundamental limitation since WebGL does not offer any
     * browser API for destroying WebGL contexts.
     */ destroy() {
        // Note that deck.gl (especially in React strict mode) depends on being able
        // to asynchronously create a Device against the same canvas (i.e. WebGL context)
        // multiple times and getting the same device back. Since deck.gl is not aware
        // of this sharing, it might call destroy() multiple times on the same device.
        // Therefore we must do nothing in destroy() if props._reuseDevices is true
        if (!this.props._reuseDevices && !this._reused) // Delete the reference to the device that we store on the WebGL context
        delete this.gl.device;
    }
    get isLost() {
        return this.gl.isContextLost();
    }
    // IMPLEMENTATION OF ABSTRACT DEVICE
    createCanvasContext(props) {
        throw new Error('WebGL only supports a single canvas');
    }
    createBuffer(props) {
        const newProps = this._normalizeBufferProps(props);
        return new (0, _webglBufferJs.WEBGLBuffer)(this, newProps);
    }
    createTexture(props) {
        return new (0, _webglTextureJs.WEBGLTexture)(this, props);
    }
    createExternalTexture(props) {
        throw new Error('createExternalTexture() not implemented'); // return new Program(props);
    }
    createSampler(props) {
        return new (0, _webglSamplerJs.WEBGLSampler)(this, props);
    }
    createShader(props) {
        return new (0, _webglShaderJs.WEBGLShader)(this, props);
    }
    createFramebuffer(props) {
        return new (0, _webglFramebufferJs.WEBGLFramebuffer)(this, props);
    }
    createVertexArray(props) {
        return new (0, _webglVertexArrayJs.WEBGLVertexArray)(this, props);
    }
    createTransformFeedback(props) {
        return new (0, _webglTransformFeedbackJs.WEBGLTransformFeedback)(this, props);
    }
    createQuerySet(props) {
        return new (0, _webglQuerySetJs.WEBGLQuerySet)(this, props);
    }
    createRenderPipeline(props) {
        return new (0, _webglRenderPipelineJs.WEBGLRenderPipeline)(this, props);
    }
    beginRenderPass(props) {
        return new (0, _webglRenderPassJs.WEBGLRenderPass)(this, props);
    }
    createComputePipeline(props) {
        throw new Error('ComputePipeline not supported in WebGL');
    }
    beginComputePass(props) {
        throw new Error('ComputePass not supported in WebGL');
    }
    renderPass = null;
    createCommandEncoder(props = {}) {
        return new (0, _webglCommandEncoderJs.WEBGLCommandEncoder)(this, props);
    }
    /**
     * Offscreen Canvas Support: Commit the frame
     * https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/commit
     * Chrome's offscreen canvas does not require gl.commit
     */ submit() {
        this.renderPass?.end();
        this.renderPass = null;
    // this.canvasContext.commit();
    }
    //
    // TEMPORARY HACKS - will be removed in v9.1
    //
    /** @deprecated - should use command encoder */ readPixelsToArrayWebGL(source, options) {
        return (0, _webglTextureUtilsJs.readPixelsToArray)(source, options);
    }
    /** @deprecated - should use command encoder */ readPixelsToBufferWebGL(source, options) {
        return (0, _webglTextureUtilsJs.readPixelsToBuffer)(source, options);
    }
    setParametersWebGL(parameters) {
        (0, _unifiedParameterApiJs.setGLParameters)(this.gl, parameters);
    }
    getParametersWebGL(parameters) {
        return (0, _unifiedParameterApiJs.getGLParameters)(this.gl, parameters);
    }
    withParametersWebGL(parameters, func) {
        return (0, _withParametersJs.withGLParameters)(this.gl, parameters, func);
    }
    resetWebGL() {
        (0, _core.log).warn('WebGLDevice.resetWebGL is deprecated, use only for debugging')();
        (0, _unifiedParameterApiJs.resetGLParameters)(this.gl);
    }
    _getDeviceSpecificTextureFormatCapabilities(capabilities) {
        return (0, _webglTextureTableJs.getTextureFormatCapabilitiesWebGL)(this.gl, capabilities, this._extensions);
    }
    //
    // WebGL-only API (not part of `Device` API)
    //
    /**
     * Triggers device (or WebGL context) loss.
     * @note primarily intended for testing how application reacts to device loss
     */ loseDevice() {
        let deviceLossTriggered = false;
        const extensions = this.getExtension('WEBGL_lose_context');
        const ext = extensions.WEBGL_lose_context;
        if (ext) {
            deviceLossTriggered = true;
            ext.loseContext();
        // ext.loseContext should trigger context loss callback but the platform may not do this, so do it explicitly
        }
        this._resolveContextLost?.({
            reason: 'destroyed',
            message: 'Application triggered context loss'
        });
        return deviceLossTriggered;
    }
    /** Save current WebGL context state onto an internal stack */ pushState() {
        const webglState = (0, _webglStateTrackerJs.WebGLStateTracker).get(this.gl);
        webglState.push();
    }
    /** Restores previously saved context state */ popState() {
        const webglState = (0, _webglStateTrackerJs.WebGLStateTracker).get(this.gl);
        webglState.pop();
    }
    /**
     * Storing data on a special field on WebGLObjects makes that data visible in SPECTOR chrome debug extension
     * luma.gl ids and props can be inspected
     */ setSpectorMetadata(handle, props) {
        // @ts-expect-error
        // eslint-disable-next-line camelcase
        handle.__SPECTOR_Metadata = props;
    }
    /**
     * Returns the GL.<KEY> constant that corresponds to a numeric value of a GL constant
     * Be aware that there are some duplicates especially for constants that are 0,
     * so this isn't guaranteed to return the right key in all cases.
     */ getGLKey(value, options) {
        const number = Number(value);
        for(const key in this.gl){
            // @ts-ignore expect-error depends on settings
            if (this.gl[key] === number) return `GL.${key}`;
        }
        // No constant found. Stringify the value and return it.
        return options?.emptyIfUnknown ? '' : String(value);
    }
    /**
     * Returns a map with any GL.<KEY> constants mapped to strings, both for keys and values
     */ getGLKeys(glParameters) {
        const opts = {
            emptyIfUnknown: true
        };
        return Object.entries(glParameters).reduce((keys, [key, value])=>{
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            keys[`${key}:${this.getGLKey(key, opts)}`] = `${value}:${this.getGLKey(value, opts)}`;
            return keys;
        }, {});
    }
    /** Store constants */ _constants;
    /**
     * Set a constant value for a location. Disabled attributes at that location will read from this value
     * @note WebGL constants are stored globally on the WebGL context, not the VertexArray
     * so they need to be updated before every render
     * @todo - remember/cache values to avoid setting them unnecessarily?
     */ setConstantAttributeWebGL(location, constant) {
        const maxVertexAttributes = this.limits.maxVertexAttributes;
        this._constants = this._constants || new Array(maxVertexAttributes).fill(null);
        const currentConstant = this._constants[location];
        if (currentConstant && compareConstantArrayValues(currentConstant, constant)) (0, _core.log).info(1, `setConstantAttributeWebGL(${location}) could have been skipped, value unchanged`)();
        this._constants[location] = constant;
        switch(constant.constructor){
            case Float32Array:
                setConstantFloatArray(this, location, constant);
                break;
            case Int32Array:
                setConstantIntArray(this, location, constant);
                break;
            case Uint32Array:
                setConstantUintArray(this, location, constant);
                break;
            default:
                throw new Error('constant');
        }
    }
    /** Ensure extensions are only requested once */ getExtension(name) {
        (0, _webglExtensionsJs.getWebGLExtension)(this.gl, name, this._extensions);
        return this._extensions;
    }
}
/** Set constant float array attribute */ function setConstantFloatArray(device, location, array) {
    switch(array.length){
        case 1:
            device.gl.vertexAttrib1fv(location, array);
            break;
        case 2:
            device.gl.vertexAttrib2fv(location, array);
            break;
        case 3:
            device.gl.vertexAttrib3fv(location, array);
            break;
        case 4:
            device.gl.vertexAttrib4fv(location, array);
            break;
        default:
    }
}
/** Set constant signed int array attribute */ function setConstantIntArray(device, location, array) {
    device.gl.vertexAttribI4iv(location, array);
// TODO - not clear if we need to use the special forms, more testing needed
// switch (array.length) {
//   case 1:
//     gl.vertexAttribI1iv(location, array);
//     break;
//   case 2:
//     gl.vertexAttribI2iv(location, array);
//     break;
//   case 3:
//     gl.vertexAttribI3iv(location, array);
//     break;
//   case 4:
//     break;
//   default:
//     assert(false);
// }
}
/** Set constant unsigned int array attribute */ function setConstantUintArray(device, location, array) {
    device.gl.vertexAttribI4uiv(location, array);
// TODO - not clear if we need to use the special forms, more testing needed
// switch (array.length) {
//   case 1:
//     gl.vertexAttribI1uiv(location, array);
//     break;
//   case 2:
//     gl.vertexAttribI2uiv(location, array);
//     break;
//   case 3:
//     gl.vertexAttribI3uiv(location, array);
//     break;
//   case 4:
//     gl.vertexAttribI4uiv(location, array);
//     break;
//   default:
//     assert(false);
// }
}
/**
 * Compares contents of two typed arrays
 * @todo max length?
 */ function compareConstantArrayValues(v1, v2) {
    if (!v1 || !v2 || v1.length !== v2.length || v1.constructor !== v2.constructor) return false;
    for(let i = 0; i < v1.length; ++i){
        if (v1[i] !== v2[i]) return false;
    }
    return true;
}

},{"@luma.gl/core":"7TxCR","../context/state-tracker/webgl-state-tracker.js":"1Ixaj","../context/helpers/create-browser-context.js":"bZOZc","./device-helpers/webgl-device-info.js":"fafZ5","./device-helpers/webgl-device-features.js":"3RHfb","./device-helpers/webgl-device-limits.js":"bR8yi","./webgl-canvas-context.js":"3gJwb","../context/debug/spector.js":"9oiSc","../context/debug/webgl-developer-tools.js":"5wukC","./converters/webgl-texture-table.js":"4LosF","../utils/uid.js":"dOKUn","./resources/webgl-buffer.js":"fIu5h","./resources/webgl-shader.js":"6OohC","./resources/webgl-sampler.js":"e2AQF","./resources/webgl-texture.js":"YIvAu","./resources/webgl-framebuffer.js":"bYeR6","./resources/webgl-render-pass.js":"Jtb3q","./resources/webgl-render-pipeline.js":"7Levz","./resources/webgl-command-encoder.js":"bUzlw","./resources/webgl-vertex-array.js":"3OAtg","./resources/webgl-transform-feedback.js":"7C9wO","./resources/webgl-query-set.js":"fp1xV","./helpers/webgl-texture-utils.js":"lgYH8","../context/parameters/unified-parameter-api.js":"j2HhX","../context/state-tracker/with-parameters.js":"2A4LM","../context/helpers/webgl-extensions.js":"1LAmB","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1Ixaj":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// HELPER CLASS - WebGLStateTracker
/**
 * Support for listening to context state changes and intercepting state queries
 * NOTE: this system does not handle buffer bindings
 */ parcelHelpers.export(exports, "WebGLStateTracker", ()=>WebGLStateTracker);
var _unifiedParameterApiJs = require("../parameters/unified-parameter-api.js");
var _deepArrayEqualJs = require("./deep-array-equal.js");
var _webglParameterTablesJs = require("../parameters/webgl-parameter-tables.js");
class WebGLStateTracker {
    static get(gl) {
        // @ts-expect-error
        return gl.state;
    }
    gl;
    program = null;
    stateStack = [];
    enable = true;
    cache = null;
    log;
    initialized = false;
    constructor(gl, props){
        this.gl = gl;
        this.log = props?.log || (()=>{});
        this._updateCache = this._updateCache.bind(this);
        Object.seal(this);
    }
    push(values = {}) {
        this.stateStack.push({});
    }
    pop() {
        // assert(this.stateStack.length > 0);
        // Use the saved values in the state stack to restore parameters
        const oldValues = this.stateStack[this.stateStack.length - 1];
        (0, _unifiedParameterApiJs.setGLParameters)(this.gl, oldValues);
        // Don't pop until we have reset parameters (to make sure other "stack frames" are not affected)
        this.stateStack.pop();
    }
    /**
     * Initialize WebGL state caching on a context
     * can be called multiple times to enable/disable
     *
     * @note After calling this function, context state will be cached
     * .push() and .pop() will be available for saving,
     * temporarily modifying, and then restoring state.
     */ trackState(gl, options) {
        this.cache = options.copyState ? (0, _unifiedParameterApiJs.getGLParameters)(gl) : Object.assign({}, (0, _webglParameterTablesJs.GL_PARAMETER_DEFAULTS));
        if (this.initialized) throw new Error('WebGLStateTracker');
        this.initialized = true;
        // @ts-expect-error
        this.gl.state = this;
        installProgramSpy(gl);
        // intercept all setter functions in the table
        for(const key in 0, _webglParameterTablesJs.GL_HOOKED_SETTERS){
            const setter = (0, _webglParameterTablesJs.GL_HOOKED_SETTERS)[key];
            installSetterSpy(gl, key, setter);
        }
        // intercept all getter functions in the table
        installGetterOverride(gl, 'getParameter');
        installGetterOverride(gl, 'isEnabled');
    }
    /**
    // interceptor for context set functions - update our cache and our stack
    // values (Object) - the key values for this setter
     * @param values
     * @returns
     */ _updateCache(values) {
        let valueChanged = false;
        let oldValue; // = undefined
        const oldValues = this.stateStack.length > 0 ? this.stateStack[this.stateStack.length - 1] : null;
        for(const key in values){
            // assert(key !== undefined);
            const value = values[key];
            const cached = this.cache[key];
            // Check that value hasn't already been shadowed
            if (!(0, _deepArrayEqualJs.deepArrayEqual)(value, cached)) {
                valueChanged = true;
                oldValue = cached;
                // First, save current value being shadowed
                // If a state stack frame is active, save the current parameter values for pop
                // but first check that value hasn't already been shadowed and saved
                if (oldValues && !(key in oldValues)) oldValues[key] = cached;
                // Save current value being shadowed
                this.cache[key] = value;
            }
        }
        return {
            valueChanged,
            oldValue
        };
    }
}
// HELPER FUNCTIONS - INSTALL GET/SET INTERCEPTORS (SPYS) ON THE CONTEXT
/**
// Overrides a WebGL2RenderingContext state "getter" function
// to return values directly from cache
 * @param gl
 * @param functionName
 */ function installGetterOverride(gl, functionName) {
    // Get the original function from the WebGL2RenderingContext
    const originalGetterFunc = gl[functionName].bind(gl);
    // Wrap it with a spy so that we can update our state cache when it gets called
    gl[functionName] = function get(pname) {
        if (pname === undefined || (0, _webglParameterTablesJs.NON_CACHE_PARAMETERS).has(pname)) // Invalid or blacklisted parameter, do not cache
        return originalGetterFunc(pname);
        const glState = WebGLStateTracker.get(gl);
        if (!(pname in glState.cache)) // WebGL limits are not prepopulated in the cache, call the original getter when first queried.
        glState.cache[pname] = originalGetterFunc(pname);
        // Optionally call the original function to do a "hard" query from the WebGL2RenderingContext
        return glState.enable ? glState.cache[pname] : originalGetterFunc(pname);
    };
    // Set the name of this anonymous function to help in debugging and profiling
    Object.defineProperty(gl[functionName], 'name', {
        value: `${functionName}-from-cache`,
        configurable: false
    });
}
/**
// Overrides a WebGL2RenderingContext state "setter" function
// to call a setter spy before the actual setter. Allows us to keep a cache
// updated with a copy of the WebGL context state.
 * @param gl
 * @param functionName
 * @param setter
 * @returns
 */ function installSetterSpy(gl, functionName, setter) {
    // Get the original function from the WebGL2RenderingContext
    if (!gl[functionName]) // TODO - remove?
    // This could happen if we try to intercept WebGL2 method on a WebGL1 context
    return;
    const originalSetterFunc = gl[functionName].bind(gl);
    // Wrap it with a spy so that we can update our state cache when it gets called
    gl[functionName] = function set(...params) {
        // Update the value
        // Call the setter with the state cache and the params so that it can store the parameters
        const glState = WebGLStateTracker.get(gl);
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const { valueChanged, oldValue } = setter(glState._updateCache, ...params);
        // Call the original WebGL2RenderingContext func to make sure the context actually gets updated
        if (valueChanged) originalSetterFunc(...params);
        // Note: if the original function fails to set the value, our state cache will be bad
        // No solution for this at the moment, but assuming that this is unlikely to be a real problem
        // We could call the setter after the originalSetterFunc. Concern is that this would
        // cause different behavior in debug mode, where originalSetterFunc can throw exceptions
        return oldValue;
    };
    // Set the name of this anonymous function to help in debugging and profiling
    Object.defineProperty(gl[functionName], 'name', {
        value: `${functionName}-to-cache`,
        configurable: false
    });
}
function installProgramSpy(gl) {
    const originalUseProgram = gl.useProgram.bind(gl);
    gl.useProgram = function useProgramLuma(handle) {
        const glState = WebGLStateTracker.get(gl);
        if (glState.program !== handle) {
            originalUseProgram(handle);
            glState.program = handle;
        }
    };
}

},{"../parameters/unified-parameter-api.js":"j2HhX","./deep-array-equal.js":"iEcm8","../parameters/webgl-parameter-tables.js":"7lYNj","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"j2HhX":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets any GL parameter regardless of function (gl.blendMode, ...)
 *
 * @note requires a `cache` object to be set on the context (gl.state.cache)
 * This object is used to fill in any missing values for composite setter functions
 */ parcelHelpers.export(exports, "setGLParameters", ()=>setGLParameters);
/**
 * Reads the entire WebGL state from a context

  // default to querying all parameters

  * @returns - a newly created map, with values keyed by GL parameters
 *
 * @note Copies the state from a context (gl.getParameter should not be overriden)
 * Reads the entire WebGL state from a context
 *
 * @note This can generates a huge amount of synchronous driver roundtrips and should be
 * considered a very slow operation, to be used only if/when a context already manipulated
 * by external code needs to be synchronized for the first time
 */ parcelHelpers.export(exports, "getGLParameters", ()=>getGLParameters);
/**
 * Reset all parameters to a (almost) pure context state
 * @note viewport and scissor will be set to the values in GL_PARAMETER_DEFAULTS,
 * NOT the canvas size dimensions, so they will have to be properly set after
 * calling this function.
 */ parcelHelpers.export(exports, "resetGLParameters", ()=>resetGLParameters);
var _webglParameterTablesJs = require("./webgl-parameter-tables.js");
function setGLParameters(gl, parameters) {
    if (isObjectEmpty(parameters)) return;
    const compositeSetters = {};
    // HANDLE PRIMITIVE SETTERS (and make note of any composite setters)
    for(const key in parameters){
        const glConstant = Number(key);
        const setter = (0, _webglParameterTablesJs.GL_PARAMETER_SETTERS)[key];
        if (setter) {
            // Composite setters should only be called once, so save them
            if (typeof setter === 'string') compositeSetters[setter] = true;
            else // if (gl[glConstant] !== undefined) {
            // TODO - added above check since this is being called on WebGL2 parameters in WebGL1...
            // TODO - deep equal on values? only call setter if value has changed?
            // NOTE - the setter will automatically update this.state
            setter(gl, parameters[key], glConstant);
        }
    }
    // HANDLE COMPOSITE SETTERS
    // NOTE: any non-provided values needed by composite setters are filled in from state cache
    // The cache parameter is automatically retrieved from the context
    // This depends on `trackContextState`, which is technically a "circular" dependency.
    // But it is too inconvenient to always require a cache parameter here.
    // This is the ONLY external dependency in this module/
    // @ts-expect-error
    const cache = gl.state && gl.state.cache;
    if (cache) for(const key in compositeSetters){
        // TODO - avoid calling composite setters if values have not changed.
        const compositeSetter = (0, _webglParameterTablesJs.GL_COMPOSITE_PARAMETER_SETTERS)[key];
        // Note - if `trackContextState` has been called,
        // the setter will automatically update this.state.cache
        compositeSetter(gl, parameters, cache);
    }
// Add a log for the else case?
}
function getGLParameters(gl, parameters = (0, _webglParameterTablesJs.GL_PARAMETER_DEFAULTS)) {
    // support both arrays of parameters and objects (keys represent parameters)
    if (typeof parameters === 'number') {
        // single GL enum
        const key = parameters;
        const getter = (0, _webglParameterTablesJs.GL_PARAMETER_GETTERS)[key];
        return getter ? getter(gl, key) : gl.getParameter(key);
    }
    const parameterKeys = Array.isArray(parameters) ? parameters : Object.keys(parameters);
    const state = {};
    for (const key of parameterKeys){
        const getter = (0, _webglParameterTablesJs.GL_PARAMETER_GETTERS)[key];
        state[key] = getter ? getter(gl, Number(key)) : gl.getParameter(Number(key));
    }
    return state;
}
function resetGLParameters(gl) {
    setGLParameters(gl, (0, _webglParameterTablesJs.GL_PARAMETER_DEFAULTS));
}
// Helpers
// Returns true if given object is empty, false otherwise.
function isObjectEmpty(object) {
    // @ts-ignore dummy key variable
    for(const key in object)return false;
    return true;
}

},{"./webgl-parameter-tables.js":"7lYNj","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7lYNj":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Tables describing WebGL parameters
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GL_PARAMETER_DEFAULTS", ()=>GL_PARAMETER_DEFAULTS);
parcelHelpers.export(exports, "GL_PARAMETER_SETTERS", ()=>GL_PARAMETER_SETTERS);
parcelHelpers.export(exports, "GL_COMPOSITE_PARAMETER_SETTERS", ()=>GL_COMPOSITE_PARAMETER_SETTERS);
parcelHelpers.export(exports, "GL_HOOKED_SETTERS", ()=>GL_HOOKED_SETTERS);
parcelHelpers.export(exports, "GL_PARAMETER_GETTERS", ()=>GL_PARAMETER_GETTERS);
parcelHelpers.export(exports, "NON_CACHE_PARAMETERS", ()=>NON_CACHE_PARAMETERS);
var _constants = require("@luma.gl/constants");
const GL_PARAMETER_DEFAULTS = {
    [3042]: false,
    [32773]: new Float32Array([
        0,
        0,
        0,
        0
    ]),
    [32777]: 32774,
    [34877]: 32774,
    [32969]: 1,
    [32968]: 0,
    [32971]: 1,
    [32970]: 0,
    [3106]: new Float32Array([
        0,
        0,
        0,
        0
    ]),
    [3107]: [
        true,
        true,
        true,
        true
    ],
    [2884]: false,
    [2885]: 1029,
    [2929]: false,
    [2931]: 1,
    [2932]: 513,
    [2928]: new Float32Array([
        0,
        1
    ]),
    [2930]: true,
    [3024]: true,
    [35725]: null,
    // FRAMEBUFFER_BINDING and DRAW_FRAMEBUFFER_BINDING(WebGL2) refer same state.
    [36006]: null,
    [36007]: null,
    [34229]: null,
    [34964]: null,
    [2886]: 2305,
    [33170]: 4352,
    [2849]: 1,
    [32823]: false,
    [32824]: 0,
    [10752]: 0,
    [32926]: false,
    [32928]: false,
    [32938]: 1.0,
    [32939]: false,
    [3089]: false,
    // Note: Dynamic value. If scissor test enabled we expect users to set correct scissor box
    [3088]: new Int32Array([
        0,
        0,
        1024,
        1024
    ]),
    [2960]: false,
    [2961]: 0,
    [2968]: 0xffffffff,
    [36005]: 0xffffffff,
    [2962]: 519,
    [2967]: 0,
    [2963]: 0xffffffff,
    [34816]: 519,
    [36003]: 0,
    [36004]: 0xffffffff,
    [2964]: 7680,
    [2965]: 7680,
    [2966]: 7680,
    [34817]: 7680,
    [34818]: 7680,
    [34819]: 7680,
    // Dynamic value: We use [0, 0, 1024, 1024] as default, but usually this is updated in each frame.
    [2978]: [
        0,
        0,
        1024,
        1024
    ],
    [36389]: null,
    [36662]: null,
    [36663]: null,
    [35053]: null,
    [35055]: null,
    [35723]: 4352,
    [36010]: null,
    [35977]: false,
    [3333]: 4,
    [3317]: 4,
    [37440]: false,
    [37441]: false,
    [37443]: 37444,
    [3330]: 0,
    [3332]: 0,
    [3331]: 0,
    [3314]: 0,
    [32878]: 0,
    [3316]: 0,
    [3315]: 0,
    [32877]: 0
};
// SETTER TABLES - ENABLES SETTING ANY PARAMETER WITH A COMMON API
const enable = (gl, value, key)=>value ? gl.enable(key) : gl.disable(key);
const hint = (gl, value, key)=>gl.hint(key, value);
const pixelStorei = (gl, value, key)=>gl.pixelStorei(key, value);
const bindFramebuffer = (gl, value, key)=>{
    const target = key === 36006 ? 36009 : 36008;
    return gl.bindFramebuffer(target, value);
};
const bindBuffer = (gl, value, key)=>{
    const bindingMap = {
        [34964]: 34962,
        [36662]: 36662,
        [36663]: 36663,
        [35053]: 35051,
        [35055]: 35052
    };
    const glTarget = bindingMap[key];
    gl.bindBuffer(glTarget, value);
};
// Utility
function isArray(array) {
    return Array.isArray(array) || ArrayBuffer.isView(array) && !(array instanceof DataView);
}
const GL_PARAMETER_SETTERS = {
    [3042]: enable,
    [32773]: (gl, value)=>gl.blendColor(...value),
    [32777]: 'blendEquation',
    [34877]: 'blendEquation',
    [32969]: 'blendFunc',
    [32968]: 'blendFunc',
    [32971]: 'blendFunc',
    [32970]: 'blendFunc',
    [3106]: (gl, value)=>gl.clearColor(...value),
    [3107]: (gl, value)=>gl.colorMask(...value),
    [2884]: enable,
    [2885]: (gl, value)=>gl.cullFace(value),
    [2929]: enable,
    [2931]: (gl, value)=>gl.clearDepth(value),
    [2932]: (gl, value)=>gl.depthFunc(value),
    [2928]: (gl, value)=>gl.depthRange(...value),
    [2930]: (gl, value)=>gl.depthMask(value),
    [3024]: enable,
    [35723]: hint,
    [35725]: (gl, value)=>gl.useProgram(value),
    [36007]: (gl, value)=>gl.bindRenderbuffer(36161, value),
    [36389]: (gl, value)=>gl.bindTransformFeedback?.(36386, value),
    [34229]: (gl, value)=>gl.bindVertexArray(value),
    // NOTE: FRAMEBUFFER_BINDING and DRAW_FRAMEBUFFER_BINDING(WebGL2) refer same state.
    [36006]: bindFramebuffer,
    [36010]: bindFramebuffer,
    // Buffers
    [34964]: bindBuffer,
    [36662]: bindBuffer,
    [36663]: bindBuffer,
    [35053]: bindBuffer,
    [35055]: bindBuffer,
    [2886]: (gl, value)=>gl.frontFace(value),
    [33170]: hint,
    [2849]: (gl, value)=>gl.lineWidth(value),
    [32823]: enable,
    [32824]: 'polygonOffset',
    [10752]: 'polygonOffset',
    [35977]: enable,
    [32926]: enable,
    [32928]: enable,
    [32938]: 'sampleCoverage',
    [32939]: 'sampleCoverage',
    [3089]: enable,
    [3088]: (gl, value)=>gl.scissor(...value),
    [2960]: enable,
    [2961]: (gl, value)=>gl.clearStencil(value),
    [2968]: (gl, value)=>gl.stencilMaskSeparate(1028, value),
    [36005]: (gl, value)=>gl.stencilMaskSeparate(1029, value),
    [2962]: 'stencilFuncFront',
    [2967]: 'stencilFuncFront',
    [2963]: 'stencilFuncFront',
    [34816]: 'stencilFuncBack',
    [36003]: 'stencilFuncBack',
    [36004]: 'stencilFuncBack',
    [2964]: 'stencilOpFront',
    [2965]: 'stencilOpFront',
    [2966]: 'stencilOpFront',
    [34817]: 'stencilOpBack',
    [34818]: 'stencilOpBack',
    [34819]: 'stencilOpBack',
    [2978]: (gl, value)=>gl.viewport(...value),
    // WEBGL2 EXTENSIONS
    // EXT_depth_clamp https://registry.khronos.org/webgl/extensions/EXT_depth_clamp/
    [34383]: enable,
    // WEBGL_provoking_vertex https://registry.khronos.org/webgl/extensions/WEBGL_provoking_vertex/
    // [GL.PROVOKING_VERTEX_WEBL]: TODO - extension function needed
    // WEBGL_polygon_mode https://registry.khronos.org/webgl/extensions/WEBGL_polygon_mode/
    // POLYGON_MODE_WEBGL  TODO - extension function needed
    [10754]: enable,
    // WEBGL_clip_cull_distance https://registry.khronos.org/webgl/extensions/WEBGL_clip_cull_distance/
    [12288]: enable,
    [12289]: enable,
    [12290]: enable,
    [12291]: enable,
    [12292]: enable,
    [12293]: enable,
    [12294]: enable,
    [12295]: enable,
    // PIXEL PACK/UNPACK MODES
    [3333]: pixelStorei,
    [3317]: pixelStorei,
    [37440]: pixelStorei,
    [37441]: pixelStorei,
    [37443]: pixelStorei,
    [3330]: pixelStorei,
    [3332]: pixelStorei,
    [3331]: pixelStorei,
    [3314]: pixelStorei,
    [32878]: pixelStorei,
    [3316]: pixelStorei,
    [3315]: pixelStorei,
    [32877]: pixelStorei,
    // Function-style setters
    framebuffer: (gl, framebuffer)=>{
        // accepts 1) a WebGLFramebuffer 2) null (default framebuffer), or 3) luma.gl Framebuffer class
        // framebuffer is null when restoring to default framebuffer, otherwise use the WebGL handle.
        const handle = framebuffer && 'handle' in framebuffer ? framebuffer.handle : framebuffer;
        return gl.bindFramebuffer(36160, handle);
    },
    blend: (gl, value)=>value ? gl.enable(3042) : gl.disable(3042),
    blendColor: (gl, value)=>gl.blendColor(...value),
    blendEquation: (gl, args)=>{
        const separateModes = typeof args === 'number' ? [
            args,
            args
        ] : args;
        gl.blendEquationSeparate(...separateModes);
    },
    blendFunc: (gl, args)=>{
        const separateFuncs = args?.length === 2 ? [
            ...args,
            ...args
        ] : args;
        gl.blendFuncSeparate(...separateFuncs);
    },
    clearColor: (gl, value)=>gl.clearColor(...value),
    clearDepth: (gl, value)=>gl.clearDepth(value),
    clearStencil: (gl, value)=>gl.clearStencil(value),
    colorMask: (gl, value)=>gl.colorMask(...value),
    cull: (gl, value)=>value ? gl.enable(2884) : gl.disable(2884),
    cullFace: (gl, value)=>gl.cullFace(value),
    depthTest: (gl, value)=>value ? gl.enable(2929) : gl.disable(2929),
    depthFunc: (gl, value)=>gl.depthFunc(value),
    depthMask: (gl, value)=>gl.depthMask(value),
    depthRange: (gl, value)=>gl.depthRange(...value),
    dither: (gl, value)=>value ? gl.enable(3024) : gl.disable(3024),
    derivativeHint: (gl, value)=>{
        // gl1: 'OES_standard_derivatives'
        gl.hint(35723, value);
    },
    frontFace: (gl, value)=>gl.frontFace(value),
    mipmapHint: (gl, value)=>gl.hint(33170, value),
    lineWidth: (gl, value)=>gl.lineWidth(value),
    polygonOffsetFill: (gl, value)=>value ? gl.enable(32823) : gl.disable(32823),
    polygonOffset: (gl, value)=>gl.polygonOffset(...value),
    sampleCoverage: (gl, value)=>gl.sampleCoverage(value[0], value[1] || false),
    scissorTest: (gl, value)=>value ? gl.enable(3089) : gl.disable(3089),
    scissor: (gl, value)=>gl.scissor(...value),
    stencilTest: (gl, value)=>value ? gl.enable(2960) : gl.disable(2960),
    stencilMask: (gl, value)=>{
        value = isArray(value) ? value : [
            value,
            value
        ];
        const [mask, backMask] = value;
        gl.stencilMaskSeparate(1028, mask);
        gl.stencilMaskSeparate(1029, backMask);
    },
    stencilFunc: (gl, args)=>{
        args = isArray(args) && args.length === 3 ? [
            ...args,
            ...args
        ] : args;
        const [func, ref, mask, backFunc, backRef, backMask] = args;
        gl.stencilFuncSeparate(1028, func, ref, mask);
        gl.stencilFuncSeparate(1029, backFunc, backRef, backMask);
    },
    stencilOp: (gl, args)=>{
        args = isArray(args) && args.length === 3 ? [
            ...args,
            ...args
        ] : args;
        const [sfail, dpfail, dppass, backSfail, backDpfail, backDppass] = args;
        gl.stencilOpSeparate(1028, sfail, dpfail, dppass);
        gl.stencilOpSeparate(1029, backSfail, backDpfail, backDppass);
    },
    viewport: (gl, value)=>gl.viewport(...value)
};
function getValue(glEnum, values, cache) {
    return values[glEnum] !== undefined ? values[glEnum] : cache[glEnum];
}
const GL_COMPOSITE_PARAMETER_SETTERS = {
    blendEquation: (gl, values, cache)=>gl.blendEquationSeparate(getValue(32777, values, cache), getValue(34877, values, cache)),
    blendFunc: (gl, values, cache)=>gl.blendFuncSeparate(getValue(32969, values, cache), getValue(32968, values, cache), getValue(32971, values, cache), getValue(32970, values, cache)),
    polygonOffset: (gl, values, cache)=>gl.polygonOffset(getValue(32824, values, cache), getValue(10752, values, cache)),
    sampleCoverage: (gl, values, cache)=>gl.sampleCoverage(getValue(32938, values, cache), getValue(32939, values, cache)),
    stencilFuncFront: (gl, values, cache)=>gl.stencilFuncSeparate(1028, getValue(2962, values, cache), getValue(2967, values, cache), getValue(2963, values, cache)),
    stencilFuncBack: (gl, values, cache)=>gl.stencilFuncSeparate(1029, getValue(34816, values, cache), getValue(36003, values, cache), getValue(36004, values, cache)),
    stencilOpFront: (gl, values, cache)=>gl.stencilOpSeparate(1028, getValue(2964, values, cache), getValue(2965, values, cache), getValue(2966, values, cache)),
    stencilOpBack: (gl, values, cache)=>gl.stencilOpSeparate(1029, getValue(34817, values, cache), getValue(34818, values, cache), getValue(34819, values, cache))
};
const GL_HOOKED_SETTERS = {
    // GENERIC SETTERS
    enable: (update, capability)=>update({
            [capability]: true
        }),
    disable: (update, capability)=>update({
            [capability]: false
        }),
    pixelStorei: (update, pname, value)=>update({
            [pname]: value
        }),
    hint: (update, pname, value)=>update({
            [pname]: value
        }),
    // SPECIFIC SETTERS
    useProgram: (update, value)=>update({
            [35725]: value
        }),
    bindRenderbuffer: (update, target, value)=>update({
            [36007]: value
        }),
    bindTransformFeedback: (update, target, value)=>update({
            [36389]: value
        }),
    bindVertexArray: (update, value)=>update({
            [34229]: value
        }),
    bindFramebuffer: (update, target, framebuffer)=>{
        switch(target){
            case 36160:
                return update({
                    [36006]: framebuffer,
                    [36010]: framebuffer
                });
            case 36009:
                return update({
                    [36006]: framebuffer
                });
            case 36008:
                return update({
                    [36010]: framebuffer
                });
            default:
                return null;
        }
    },
    bindBuffer: (update, target, buffer)=>{
        const pname = {
            [34962]: [
                34964
            ],
            [36662]: [
                36662
            ],
            [36663]: [
                36663
            ],
            [35051]: [
                35053
            ],
            [35052]: [
                35055
            ]
        }[target];
        if (pname) return update({
            [pname]: buffer
        });
        // targets that should not be cached
        return {
            valueChanged: true
        };
    },
    blendColor: (update, r, g, b, a)=>update({
            [32773]: new Float32Array([
                r,
                g,
                b,
                a
            ])
        }),
    blendEquation: (update, mode)=>update({
            [32777]: mode,
            [34877]: mode
        }),
    blendEquationSeparate: (update, modeRGB, modeAlpha)=>update({
            [32777]: modeRGB,
            [34877]: modeAlpha
        }),
    blendFunc: (update, src, dst)=>update({
            [32969]: src,
            [32968]: dst,
            [32971]: src,
            [32970]: dst
        }),
    blendFuncSeparate: (update, srcRGB, dstRGB, srcAlpha, dstAlpha)=>update({
            [32969]: srcRGB,
            [32968]: dstRGB,
            [32971]: srcAlpha,
            [32970]: dstAlpha
        }),
    clearColor: (update, r, g, b, a)=>update({
            [3106]: new Float32Array([
                r,
                g,
                b,
                a
            ])
        }),
    clearDepth: (update, depth)=>update({
            [2931]: depth
        }),
    clearStencil: (update, s)=>update({
            [2961]: s
        }),
    colorMask: (update, r, g, b, a)=>update({
            [3107]: [
                r,
                g,
                b,
                a
            ]
        }),
    cullFace: (update, mode)=>update({
            [2885]: mode
        }),
    depthFunc: (update, func)=>update({
            [2932]: func
        }),
    depthRange: (update, zNear, zFar)=>update({
            [2928]: new Float32Array([
                zNear,
                zFar
            ])
        }),
    depthMask: (update, mask)=>update({
            [2930]: mask
        }),
    frontFace: (update, face)=>update({
            [2886]: face
        }),
    lineWidth: (update, width)=>update({
            [2849]: width
        }),
    polygonOffset: (update, factor, units)=>update({
            [32824]: factor,
            [10752]: units
        }),
    sampleCoverage: (update, value, invert)=>update({
            [32938]: value,
            [32939]: invert
        }),
    scissor: (update, x, y, width, height)=>update({
            [3088]: new Int32Array([
                x,
                y,
                width,
                height
            ])
        }),
    stencilMask: (update, mask)=>update({
            [2968]: mask,
            [36005]: mask
        }),
    stencilMaskSeparate: (update, face, mask)=>update({
            [face === 1028 ? 2968 : 36005]: mask
        }),
    stencilFunc: (update, func, ref, mask)=>update({
            [2962]: func,
            [2967]: ref,
            [2963]: mask,
            [34816]: func,
            [36003]: ref,
            [36004]: mask
        }),
    stencilFuncSeparate: (update, face, func, ref, mask)=>update({
            [face === 1028 ? 2962 : 34816]: func,
            [face === 1028 ? 2967 : 36003]: ref,
            [face === 1028 ? 2963 : 36004]: mask
        }),
    stencilOp: (update, fail, zfail, zpass)=>update({
            [2964]: fail,
            [2965]: zfail,
            [2966]: zpass,
            [34817]: fail,
            [34818]: zfail,
            [34819]: zpass
        }),
    stencilOpSeparate: (update, face, fail, zfail, zpass)=>update({
            [face === 1028 ? 2964 : 34817]: fail,
            [face === 1028 ? 2965 : 34818]: zfail,
            [face === 1028 ? 2966 : 34819]: zpass
        }),
    viewport: (update, x, y, width, height)=>update({
            [2978]: [
                x,
                y,
                width,
                height
            ]
        })
};
// GETTER TABLE - FOR READING OUT AN ENTIRE CONTEXT
const isEnabled = (gl, key)=>gl.isEnabled(key);
const GL_PARAMETER_GETTERS = {
    [3042]: isEnabled,
    [2884]: isEnabled,
    [2929]: isEnabled,
    [3024]: isEnabled,
    [32823]: isEnabled,
    [32926]: isEnabled,
    [32928]: isEnabled,
    [3089]: isEnabled,
    [2960]: isEnabled,
    [35977]: isEnabled
};
const NON_CACHE_PARAMETERS = new Set([
    34016,
    36388,
    36387,
    35983,
    35368,
    34965,
    35739,
    35738,
    3074,
    34853,
    34854,
    34855,
    34856,
    34857,
    34858,
    34859,
    34860,
    34861,
    34862,
    34863,
    34864,
    34865,
    34866,
    34867,
    34868,
    35097,
    32873,
    35869,
    32874,
    34068
]);

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9mN7r":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// WebGL constants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GL", ()=>(0, _webglConstantsJs.GL));
var _webglConstantsJs = require("./webgl-constants.js");

},{"./webgl-constants.js":"6xqDZ","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6xqDZ":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable key-spacing, max-len, no-inline-comments, camelcase */ /**
 * Standard WebGL, WebGL2 and extension constants (OpenGL constants)
 * @note (Most) of these constants are also defined on the WebGLRenderingContext interface.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants
 * @privateRemarks Locally called `GLEnum` instead of `GL`, because `babel-plugin-inline-webl-constants`
 *  both depends on and processes this module, but shouldn't replace these declarations.
 */ // eslint-disable-next-line no-shadow
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GL", ()=>GLEnum);
var GLEnum;
(function(GLEnum) {
    // Clearing buffers
    // Constants passed to clear() to clear buffer masks.
    /** Passed to clear to clear the current depth buffer. */ GLEnum[GLEnum["DEPTH_BUFFER_BIT"] = 256] = "DEPTH_BUFFER_BIT";
    /** Passed to clear to clear the current stencil buffer. */ GLEnum[GLEnum["STENCIL_BUFFER_BIT"] = 1024] = "STENCIL_BUFFER_BIT";
    /** Passed to clear to clear the current color buffer. */ GLEnum[GLEnum["COLOR_BUFFER_BIT"] = 16384] = "COLOR_BUFFER_BIT";
    // Rendering primitives
    // Constants passed to drawElements() or drawArrays() to specify what kind of primitive to render.
    /** Passed to drawElements or drawArrays to draw single points. */ GLEnum[GLEnum["POINTS"] = 0] = "POINTS";
    /** Passed to drawElements or drawArrays to draw lines. Each vertex connects to the one after it. */ GLEnum[GLEnum["LINES"] = 1] = "LINES";
    /** Passed to drawElements or drawArrays to draw lines. Each set of two vertices is treated as a separate line segment. */ GLEnum[GLEnum["LINE_LOOP"] = 2] = "LINE_LOOP";
    /** Passed to drawElements or drawArrays to draw a connected group of line segments from the first vertex to the last. */ GLEnum[GLEnum["LINE_STRIP"] = 3] = "LINE_STRIP";
    /** Passed to drawElements or drawArrays to draw triangles. Each set of three vertices creates a separate triangle. */ GLEnum[GLEnum["TRIANGLES"] = 4] = "TRIANGLES";
    /** Passed to drawElements or drawArrays to draw a connected group of triangles. */ GLEnum[GLEnum["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    /** Passed to drawElements or drawArrays to draw a connected group of triangles. Each vertex connects to the previous and the first vertex in the fan. */ GLEnum[GLEnum["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
    // Blending modes
    // Constants passed to blendFunc() or blendFuncSeparate() to specify the blending mode (for both, RBG and alpha, or separately).
    /** Passed to blendFunc or blendFuncSeparate to turn off a component. */ GLEnum[GLEnum["ZERO"] = 0] = "ZERO";
    /** Passed to blendFunc or blendFuncSeparate to turn on a component. */ GLEnum[GLEnum["ONE"] = 1] = "ONE";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by the source elements color. */ GLEnum[GLEnum["SRC_COLOR"] = 768] = "SRC_COLOR";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by one minus the source elements color. */ GLEnum[GLEnum["ONE_MINUS_SRC_COLOR"] = 769] = "ONE_MINUS_SRC_COLOR";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by the source's alpha. */ GLEnum[GLEnum["SRC_ALPHA"] = 770] = "SRC_ALPHA";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by one minus the source's alpha. */ GLEnum[GLEnum["ONE_MINUS_SRC_ALPHA"] = 771] = "ONE_MINUS_SRC_ALPHA";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by the destination's alpha. */ GLEnum[GLEnum["DST_ALPHA"] = 772] = "DST_ALPHA";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by one minus the destination's alpha. */ GLEnum[GLEnum["ONE_MINUS_DST_ALPHA"] = 773] = "ONE_MINUS_DST_ALPHA";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by the destination's color. */ GLEnum[GLEnum["DST_COLOR"] = 774] = "DST_COLOR";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by one minus the destination's color. */ GLEnum[GLEnum["ONE_MINUS_DST_COLOR"] = 775] = "ONE_MINUS_DST_COLOR";
    /** Passed to blendFunc or blendFuncSeparate to multiply a component by the minimum of source's alpha or one minus the destination's alpha. */ GLEnum[GLEnum["SRC_ALPHA_SATURATE"] = 776] = "SRC_ALPHA_SATURATE";
    /** Passed to blendFunc or blendFuncSeparate to specify a constant color blend function. */ GLEnum[GLEnum["CONSTANT_COLOR"] = 32769] = "CONSTANT_COLOR";
    /** Passed to blendFunc or blendFuncSeparate to specify one minus a constant color blend function. */ GLEnum[GLEnum["ONE_MINUS_CONSTANT_COLOR"] = 32770] = "ONE_MINUS_CONSTANT_COLOR";
    /** Passed to blendFunc or blendFuncSeparate to specify a constant alpha blend function. */ GLEnum[GLEnum["CONSTANT_ALPHA"] = 32771] = "CONSTANT_ALPHA";
    /** Passed to blendFunc or blendFuncSeparate to specify one minus a constant alpha blend function. */ GLEnum[GLEnum["ONE_MINUS_CONSTANT_ALPHA"] = 32772] = "ONE_MINUS_CONSTANT_ALPHA";
    // Blending equations
    // Constants passed to blendEquation() or blendEquationSeparate() to control
    // how the blending is calculated (for both, RBG and alpha, or separately).
    /** Passed to blendEquation or blendEquationSeparate to set an addition blend function. */ /** Passed to blendEquation or blendEquationSeparate to specify a subtraction blend function (source - destination). */ /** Passed to blendEquation or blendEquationSeparate to specify a reverse subtraction blend function (destination - source). */ GLEnum[GLEnum["FUNC_ADD"] = 32774] = "FUNC_ADD";
    GLEnum[GLEnum["FUNC_SUBTRACT"] = 32778] = "FUNC_SUBTRACT";
    GLEnum[GLEnum["FUNC_REVERSE_SUBTRACT"] = 32779] = "FUNC_REVERSE_SUBTRACT";
    // Getting GL parameter information
    // Constants passed to getParameter() to specify what information to return.
    /** Passed to getParameter to get the current RGB blend function. */ GLEnum[GLEnum["BLEND_EQUATION"] = 32777] = "BLEND_EQUATION";
    /** Passed to getParameter to get the current RGB blend function. Same as BLEND_EQUATION */ GLEnum[GLEnum["BLEND_EQUATION_RGB"] = 32777] = "BLEND_EQUATION_RGB";
    /** Passed to getParameter to get the current alpha blend function. Same as BLEND_EQUATION */ GLEnum[GLEnum["BLEND_EQUATION_ALPHA"] = 34877] = "BLEND_EQUATION_ALPHA";
    /** Passed to getParameter to get the current destination RGB blend function. */ GLEnum[GLEnum["BLEND_DST_RGB"] = 32968] = "BLEND_DST_RGB";
    /** Passed to getParameter to get the current destination RGB blend function. */ GLEnum[GLEnum["BLEND_SRC_RGB"] = 32969] = "BLEND_SRC_RGB";
    /** Passed to getParameter to get the current destination alpha blend function. */ GLEnum[GLEnum["BLEND_DST_ALPHA"] = 32970] = "BLEND_DST_ALPHA";
    /** Passed to getParameter to get the current source alpha blend function. */ GLEnum[GLEnum["BLEND_SRC_ALPHA"] = 32971] = "BLEND_SRC_ALPHA";
    /** Passed to getParameter to return a the current blend color. */ GLEnum[GLEnum["BLEND_COLOR"] = 32773] = "BLEND_COLOR";
    /** Passed to getParameter to get the array buffer binding. */ GLEnum[GLEnum["ARRAY_BUFFER_BINDING"] = 34964] = "ARRAY_BUFFER_BINDING";
    /** Passed to getParameter to get the current element array buffer. */ GLEnum[GLEnum["ELEMENT_ARRAY_BUFFER_BINDING"] = 34965] = "ELEMENT_ARRAY_BUFFER_BINDING";
    /** Passed to getParameter to get the current lineWidth (set by the lineWidth method). */ GLEnum[GLEnum["LINE_WIDTH"] = 2849] = "LINE_WIDTH";
    /** Passed to getParameter to get the current size of a point drawn with gl.POINTS */ GLEnum[GLEnum["ALIASED_POINT_SIZE_RANGE"] = 33901] = "ALIASED_POINT_SIZE_RANGE";
    /** Passed to getParameter to get the range of available widths for a line. Returns a length-2 array with the lo value at 0, and hight at 1. */ GLEnum[GLEnum["ALIASED_LINE_WIDTH_RANGE"] = 33902] = "ALIASED_LINE_WIDTH_RANGE";
    /** Passed to getParameter to get the current value of cullFace. Should return FRONT, BACK, or FRONT_AND_BACK */ GLEnum[GLEnum["CULL_FACE_MODE"] = 2885] = "CULL_FACE_MODE";
    /** Passed to getParameter to determine the current value of frontFace. Should return CW or CCW. */ GLEnum[GLEnum["FRONT_FACE"] = 2886] = "FRONT_FACE";
    /** Passed to getParameter to return a length-2 array of floats giving the current depth range. */ GLEnum[GLEnum["DEPTH_RANGE"] = 2928] = "DEPTH_RANGE";
    /** Passed to getParameter to determine if the depth write mask is enabled. */ GLEnum[GLEnum["DEPTH_WRITEMASK"] = 2930] = "DEPTH_WRITEMASK";
    /** Passed to getParameter to determine the current depth clear value. */ GLEnum[GLEnum["DEPTH_CLEAR_VALUE"] = 2931] = "DEPTH_CLEAR_VALUE";
    /** Passed to getParameter to get the current depth function. Returns NEVER, ALWAYS, LESS, EQUAL, LEQUAL, GREATER, GEQUAL, or NOTEQUAL. */ GLEnum[GLEnum["DEPTH_FUNC"] = 2932] = "DEPTH_FUNC";
    /** Passed to getParameter to get the value the stencil will be cleared to. */ GLEnum[GLEnum["STENCIL_CLEAR_VALUE"] = 2961] = "STENCIL_CLEAR_VALUE";
    /** Passed to getParameter to get the current stencil function. Returns NEVER, ALWAYS, LESS, EQUAL, LEQUAL, GREATER, GEQUAL, or NOTEQUAL. */ GLEnum[GLEnum["STENCIL_FUNC"] = 2962] = "STENCIL_FUNC";
    /** Passed to getParameter to get the current stencil fail function. Should return KEEP, REPLACE, INCR, DECR, INVERT, INCR_WRAP, or DECR_WRAP. */ GLEnum[GLEnum["STENCIL_FAIL"] = 2964] = "STENCIL_FAIL";
    /** Passed to getParameter to get the current stencil fail function should the depth buffer test fail. Should return KEEP, REPLACE, INCR, DECR, INVERT, INCR_WRAP, or DECR_WRAP. */ GLEnum[GLEnum["STENCIL_PASS_DEPTH_FAIL"] = 2965] = "STENCIL_PASS_DEPTH_FAIL";
    /** Passed to getParameter to get the current stencil fail function should the depth buffer test pass. Should return KEEP, REPLACE, INCR, DECR, INVERT, INCR_WRAP, or DECR_WRAP. */ GLEnum[GLEnum["STENCIL_PASS_DEPTH_PASS"] = 2966] = "STENCIL_PASS_DEPTH_PASS";
    /** Passed to getParameter to get the reference value used for stencil tests. */ GLEnum[GLEnum["STENCIL_REF"] = 2967] = "STENCIL_REF";
    GLEnum[GLEnum["STENCIL_VALUE_MASK"] = 2963] = "STENCIL_VALUE_MASK";
    GLEnum[GLEnum["STENCIL_WRITEMASK"] = 2968] = "STENCIL_WRITEMASK";
    GLEnum[GLEnum["STENCIL_BACK_FUNC"] = 34816] = "STENCIL_BACK_FUNC";
    GLEnum[GLEnum["STENCIL_BACK_FAIL"] = 34817] = "STENCIL_BACK_FAIL";
    GLEnum[GLEnum["STENCIL_BACK_PASS_DEPTH_FAIL"] = 34818] = "STENCIL_BACK_PASS_DEPTH_FAIL";
    GLEnum[GLEnum["STENCIL_BACK_PASS_DEPTH_PASS"] = 34819] = "STENCIL_BACK_PASS_DEPTH_PASS";
    GLEnum[GLEnum["STENCIL_BACK_REF"] = 36003] = "STENCIL_BACK_REF";
    GLEnum[GLEnum["STENCIL_BACK_VALUE_MASK"] = 36004] = "STENCIL_BACK_VALUE_MASK";
    GLEnum[GLEnum["STENCIL_BACK_WRITEMASK"] = 36005] = "STENCIL_BACK_WRITEMASK";
    /** An Int32Array with four elements for the current viewport dimensions. */ GLEnum[GLEnum["VIEWPORT"] = 2978] = "VIEWPORT";
    /** An Int32Array with four elements for the current scissor box dimensions. */ GLEnum[GLEnum["SCISSOR_BOX"] = 3088] = "SCISSOR_BOX";
    GLEnum[GLEnum["COLOR_CLEAR_VALUE"] = 3106] = "COLOR_CLEAR_VALUE";
    GLEnum[GLEnum["COLOR_WRITEMASK"] = 3107] = "COLOR_WRITEMASK";
    GLEnum[GLEnum["UNPACK_ALIGNMENT"] = 3317] = "UNPACK_ALIGNMENT";
    GLEnum[GLEnum["PACK_ALIGNMENT"] = 3333] = "PACK_ALIGNMENT";
    GLEnum[GLEnum["MAX_TEXTURE_SIZE"] = 3379] = "MAX_TEXTURE_SIZE";
    GLEnum[GLEnum["MAX_VIEWPORT_DIMS"] = 3386] = "MAX_VIEWPORT_DIMS";
    GLEnum[GLEnum["SUBPIXEL_BITS"] = 3408] = "SUBPIXEL_BITS";
    GLEnum[GLEnum["RED_BITS"] = 3410] = "RED_BITS";
    GLEnum[GLEnum["GREEN_BITS"] = 3411] = "GREEN_BITS";
    GLEnum[GLEnum["BLUE_BITS"] = 3412] = "BLUE_BITS";
    GLEnum[GLEnum["ALPHA_BITS"] = 3413] = "ALPHA_BITS";
    GLEnum[GLEnum["DEPTH_BITS"] = 3414] = "DEPTH_BITS";
    GLEnum[GLEnum["STENCIL_BITS"] = 3415] = "STENCIL_BITS";
    GLEnum[GLEnum["POLYGON_OFFSET_UNITS"] = 10752] = "POLYGON_OFFSET_UNITS";
    GLEnum[GLEnum["POLYGON_OFFSET_FACTOR"] = 32824] = "POLYGON_OFFSET_FACTOR";
    GLEnum[GLEnum["TEXTURE_BINDING_2D"] = 32873] = "TEXTURE_BINDING_2D";
    GLEnum[GLEnum["SAMPLE_BUFFERS"] = 32936] = "SAMPLE_BUFFERS";
    GLEnum[GLEnum["SAMPLES"] = 32937] = "SAMPLES";
    GLEnum[GLEnum["SAMPLE_COVERAGE_VALUE"] = 32938] = "SAMPLE_COVERAGE_VALUE";
    GLEnum[GLEnum["SAMPLE_COVERAGE_INVERT"] = 32939] = "SAMPLE_COVERAGE_INVERT";
    GLEnum[GLEnum["COMPRESSED_TEXTURE_FORMATS"] = 34467] = "COMPRESSED_TEXTURE_FORMATS";
    GLEnum[GLEnum["VENDOR"] = 7936] = "VENDOR";
    GLEnum[GLEnum["RENDERER"] = 7937] = "RENDERER";
    GLEnum[GLEnum["VERSION"] = 7938] = "VERSION";
    GLEnum[GLEnum["IMPLEMENTATION_COLOR_READ_TYPE"] = 35738] = "IMPLEMENTATION_COLOR_READ_TYPE";
    GLEnum[GLEnum["IMPLEMENTATION_COLOR_READ_FORMAT"] = 35739] = "IMPLEMENTATION_COLOR_READ_FORMAT";
    GLEnum[GLEnum["BROWSER_DEFAULT_WEBGL"] = 37444] = "BROWSER_DEFAULT_WEBGL";
    // Buffers
    // Constants passed to bufferData(), bufferSubData(), bindBuffer(), or
    // getBufferParameter().
    /** Passed to bufferData as a hint about whether the contents of the buffer are likely to be used often and not change often. */ GLEnum[GLEnum["STATIC_DRAW"] = 35044] = "STATIC_DRAW";
    /** Passed to bufferData as a hint about whether the contents of the buffer are likely to not be used often. */ GLEnum[GLEnum["STREAM_DRAW"] = 35040] = "STREAM_DRAW";
    /** Passed to bufferData as a hint about whether the contents of the buffer are likely to be used often and change often. */ GLEnum[GLEnum["DYNAMIC_DRAW"] = 35048] = "DYNAMIC_DRAW";
    /** Passed to bindBuffer or bufferData to specify the type of buffer being used. */ GLEnum[GLEnum["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    /** Passed to bindBuffer or bufferData to specify the type of buffer being used. */ GLEnum[GLEnum["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    /** Passed to getBufferParameter to get a buffer's size. */ GLEnum[GLEnum["BUFFER_SIZE"] = 34660] = "BUFFER_SIZE";
    /** Passed to getBufferParameter to get the hint for the buffer passed in when it was created. */ GLEnum[GLEnum["BUFFER_USAGE"] = 34661] = "BUFFER_USAGE";
    // Vertex attributes
    // Constants passed to getVertexAttrib().
    /** Passed to getVertexAttrib to read back the current vertex attribute. */ GLEnum[GLEnum["CURRENT_VERTEX_ATTRIB"] = 34342] = "CURRENT_VERTEX_ATTRIB";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_ENABLED"] = 34338] = "VERTEX_ATTRIB_ARRAY_ENABLED";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_SIZE"] = 34339] = "VERTEX_ATTRIB_ARRAY_SIZE";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_STRIDE"] = 34340] = "VERTEX_ATTRIB_ARRAY_STRIDE";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_TYPE"] = 34341] = "VERTEX_ATTRIB_ARRAY_TYPE";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_NORMALIZED"] = 34922] = "VERTEX_ATTRIB_ARRAY_NORMALIZED";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_POINTER"] = 34373] = "VERTEX_ATTRIB_ARRAY_POINTER";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_BUFFER_BINDING"] = 34975] = "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING";
    // Culling
    // Constants passed to cullFace().
    /** Passed to enable/disable to turn on/off culling. Can also be used with getParameter to find the current culling method. */ GLEnum[GLEnum["CULL_FACE"] = 2884] = "CULL_FACE";
    /** Passed to cullFace to specify that only front faces should be culled. */ GLEnum[GLEnum["FRONT"] = 1028] = "FRONT";
    /** Passed to cullFace to specify that only back faces should be culled. */ GLEnum[GLEnum["BACK"] = 1029] = "BACK";
    /** Passed to cullFace to specify that front and back faces should be culled. */ GLEnum[GLEnum["FRONT_AND_BACK"] = 1032] = "FRONT_AND_BACK";
    // Enabling and disabling
    // Constants passed to enable() or disable().
    /** Passed to enable/disable to turn on/off blending. Can also be used with getParameter to find the current blending method. */ GLEnum[GLEnum["BLEND"] = 3042] = "BLEND";
    /** Passed to enable/disable to turn on/off the depth test. Can also be used with getParameter to query the depth test. */ GLEnum[GLEnum["DEPTH_TEST"] = 2929] = "DEPTH_TEST";
    /** Passed to enable/disable to turn on/off dithering. Can also be used with getParameter to find the current dithering method. */ GLEnum[GLEnum["DITHER"] = 3024] = "DITHER";
    /** Passed to enable/disable to turn on/off the polygon offset. Useful for rendering hidden-line images, decals, and or solids with highlighted edges. Can also be used with getParameter to query the scissor test. */ GLEnum[GLEnum["POLYGON_OFFSET_FILL"] = 32823] = "POLYGON_OFFSET_FILL";
    /** Passed to enable/disable to turn on/off the alpha to coverage. Used in multi-sampling alpha channels. */ GLEnum[GLEnum["SAMPLE_ALPHA_TO_COVERAGE"] = 32926] = "SAMPLE_ALPHA_TO_COVERAGE";
    /** Passed to enable/disable to turn on/off the sample coverage. Used in multi-sampling. */ GLEnum[GLEnum["SAMPLE_COVERAGE"] = 32928] = "SAMPLE_COVERAGE";
    /** Passed to enable/disable to turn on/off the scissor test. Can also be used with getParameter to query the scissor test. */ GLEnum[GLEnum["SCISSOR_TEST"] = 3089] = "SCISSOR_TEST";
    /** Passed to enable/disable to turn on/off the stencil test. Can also be used with getParameter to query the stencil test. */ GLEnum[GLEnum["STENCIL_TEST"] = 2960] = "STENCIL_TEST";
    // Errors
    // Constants returned from getError().
    /** Returned from getError(). */ GLEnum[GLEnum["NO_ERROR"] = 0] = "NO_ERROR";
    /** Returned from getError(). */ GLEnum[GLEnum["INVALID_ENUM"] = 1280] = "INVALID_ENUM";
    /** Returned from getError(). */ GLEnum[GLEnum["INVALID_VALUE"] = 1281] = "INVALID_VALUE";
    /** Returned from getError(). */ GLEnum[GLEnum["INVALID_OPERATION"] = 1282] = "INVALID_OPERATION";
    /** Returned from getError(). */ GLEnum[GLEnum["OUT_OF_MEMORY"] = 1285] = "OUT_OF_MEMORY";
    /** Returned from getError(). */ GLEnum[GLEnum["CONTEXT_LOST_WEBGL"] = 37442] = "CONTEXT_LOST_WEBGL";
    // Front face directions
    // Constants passed to frontFace().
    /** Passed to frontFace to specify the front face of a polygon is drawn in the clockwise direction */ GLEnum[GLEnum["CW"] = 2304] = "CW";
    /** Passed to frontFace to specify the front face of a polygon is drawn in the counter clockwise direction */ GLEnum[GLEnum["CCW"] = 2305] = "CCW";
    // Hints
    // Constants passed to hint()
    /** There is no preference for this behavior. */ GLEnum[GLEnum["DONT_CARE"] = 4352] = "DONT_CARE";
    /** The most efficient behavior should be used. */ GLEnum[GLEnum["FASTEST"] = 4353] = "FASTEST";
    /** The most correct or the highest quality option should be used. */ GLEnum[GLEnum["NICEST"] = 4354] = "NICEST";
    /** Hint for the quality of filtering when generating mipmap images with WebGLRenderingContext.generateMipmap(). */ GLEnum[GLEnum["GENERATE_MIPMAP_HINT"] = 33170] = "GENERATE_MIPMAP_HINT";
    // Data types
    GLEnum[GLEnum["BYTE"] = 5120] = "BYTE";
    GLEnum[GLEnum["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    GLEnum[GLEnum["SHORT"] = 5122] = "SHORT";
    GLEnum[GLEnum["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    GLEnum[GLEnum["INT"] = 5124] = "INT";
    GLEnum[GLEnum["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    GLEnum[GLEnum["FLOAT"] = 5126] = "FLOAT";
    GLEnum[GLEnum["DOUBLE"] = 5130] = "DOUBLE";
    // Pixel formats
    GLEnum[GLEnum["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    GLEnum[GLEnum["ALPHA"] = 6406] = "ALPHA";
    GLEnum[GLEnum["RGB"] = 6407] = "RGB";
    GLEnum[GLEnum["RGBA"] = 6408] = "RGBA";
    GLEnum[GLEnum["LUMINANCE"] = 6409] = "LUMINANCE";
    GLEnum[GLEnum["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    // Pixel types
    // UNSIGNED_BYTE = 0x1401,
    GLEnum[GLEnum["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    GLEnum[GLEnum["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    GLEnum[GLEnum["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    // Shaders
    // Constants passed to createShader() or getShaderParameter()
    /** Passed to createShader to define a fragment shader. */ GLEnum[GLEnum["FRAGMENT_SHADER"] = 35632] = "FRAGMENT_SHADER";
    /** Passed to createShader to define a vertex shader */ GLEnum[GLEnum["VERTEX_SHADER"] = 35633] = "VERTEX_SHADER";
    /** Passed to getShaderParameter to get the status of the compilation. Returns false if the shader was not compiled. You can then query getShaderInfoLog to find the exact error */ GLEnum[GLEnum["COMPILE_STATUS"] = 35713] = "COMPILE_STATUS";
    /** Passed to getShaderParameter to determine if a shader was deleted via deleteShader. Returns true if it was, false otherwise. */ GLEnum[GLEnum["DELETE_STATUS"] = 35712] = "DELETE_STATUS";
    /** Passed to getProgramParameter after calling linkProgram to determine if a program was linked correctly. Returns false if there were errors. Use getProgramInfoLog to find the exact error. */ GLEnum[GLEnum["LINK_STATUS"] = 35714] = "LINK_STATUS";
    /** Passed to getProgramParameter after calling validateProgram to determine if it is valid. Returns false if errors were found. */ GLEnum[GLEnum["VALIDATE_STATUS"] = 35715] = "VALIDATE_STATUS";
    /** Passed to getProgramParameter after calling attachShader to determine if the shader was attached correctly. Returns false if errors occurred. */ GLEnum[GLEnum["ATTACHED_SHADERS"] = 35717] = "ATTACHED_SHADERS";
    /** Passed to getProgramParameter to get the number of attributes active in a program. */ GLEnum[GLEnum["ACTIVE_ATTRIBUTES"] = 35721] = "ACTIVE_ATTRIBUTES";
    /** Passed to getProgramParameter to get the number of uniforms active in a program. */ GLEnum[GLEnum["ACTIVE_UNIFORMS"] = 35718] = "ACTIVE_UNIFORMS";
    /** The maximum number of entries possible in the vertex attribute list. */ GLEnum[GLEnum["MAX_VERTEX_ATTRIBS"] = 34921] = "MAX_VERTEX_ATTRIBS";
    GLEnum[GLEnum["MAX_VERTEX_UNIFORM_VECTORS"] = 36347] = "MAX_VERTEX_UNIFORM_VECTORS";
    GLEnum[GLEnum["MAX_VARYING_VECTORS"] = 36348] = "MAX_VARYING_VECTORS";
    GLEnum[GLEnum["MAX_COMBINED_TEXTURE_IMAGE_UNITS"] = 35661] = "MAX_COMBINED_TEXTURE_IMAGE_UNITS";
    GLEnum[GLEnum["MAX_VERTEX_TEXTURE_IMAGE_UNITS"] = 35660] = "MAX_VERTEX_TEXTURE_IMAGE_UNITS";
    /** Implementation dependent number of maximum texture units. At least 8. */ GLEnum[GLEnum["MAX_TEXTURE_IMAGE_UNITS"] = 34930] = "MAX_TEXTURE_IMAGE_UNITS";
    GLEnum[GLEnum["MAX_FRAGMENT_UNIFORM_VECTORS"] = 36349] = "MAX_FRAGMENT_UNIFORM_VECTORS";
    GLEnum[GLEnum["SHADER_TYPE"] = 35663] = "SHADER_TYPE";
    GLEnum[GLEnum["SHADING_LANGUAGE_VERSION"] = 35724] = "SHADING_LANGUAGE_VERSION";
    GLEnum[GLEnum["CURRENT_PROGRAM"] = 35725] = "CURRENT_PROGRAM";
    // Depth or stencil tests
    // Constants passed to depthFunc() or stencilFunc().
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will never pass, i.e., nothing will be drawn. */ GLEnum[GLEnum["NEVER"] = 512] = "NEVER";
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than the stored value. */ GLEnum[GLEnum["LESS"] = 513] = "LESS";
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is equals to the stored value. */ GLEnum[GLEnum["EQUAL"] = 514] = "EQUAL";
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than or equal to the stored value. */ GLEnum[GLEnum["LEQUAL"] = 515] = "LEQUAL";
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than the stored value. */ GLEnum[GLEnum["GREATER"] = 516] = "GREATER";
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is not equal to the stored value. */ GLEnum[GLEnum["NOTEQUAL"] = 517] = "NOTEQUAL";
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than or equal to the stored value. */ GLEnum[GLEnum["GEQUAL"] = 518] = "GEQUAL";
    /** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass, i.e., pixels will be drawn in the order they are drawn. */ GLEnum[GLEnum["ALWAYS"] = 519] = "ALWAYS";
    // Stencil actions
    // Constants passed to stencilOp().
    GLEnum[GLEnum["KEEP"] = 7680] = "KEEP";
    GLEnum[GLEnum["REPLACE"] = 7681] = "REPLACE";
    GLEnum[GLEnum["INCR"] = 7682] = "INCR";
    GLEnum[GLEnum["DECR"] = 7683] = "DECR";
    GLEnum[GLEnum["INVERT"] = 5386] = "INVERT";
    GLEnum[GLEnum["INCR_WRAP"] = 34055] = "INCR_WRAP";
    GLEnum[GLEnum["DECR_WRAP"] = 34056] = "DECR_WRAP";
    // Textures
    // Constants passed to texParameteri(),
    // texParameterf(), bindTexture(), texImage2D(), and others.
    GLEnum[GLEnum["NEAREST"] = 9728] = "NEAREST";
    GLEnum[GLEnum["LINEAR"] = 9729] = "LINEAR";
    GLEnum[GLEnum["NEAREST_MIPMAP_NEAREST"] = 9984] = "NEAREST_MIPMAP_NEAREST";
    GLEnum[GLEnum["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
    GLEnum[GLEnum["NEAREST_MIPMAP_LINEAR"] = 9986] = "NEAREST_MIPMAP_LINEAR";
    GLEnum[GLEnum["LINEAR_MIPMAP_LINEAR"] = 9987] = "LINEAR_MIPMAP_LINEAR";
    /** The texture magnification function is used when the pixel being textured maps to an area less than or equal to one texture element. It sets the texture magnification function to either GL_NEAREST or GL_LINEAR (see below). GL_NEAREST is generally faster than GL_LINEAR, but it can produce textured images with sharper edges because the transition between texture elements is not as smooth. Default: GL_LINEAR.  */ GLEnum[GLEnum["TEXTURE_MAG_FILTER"] = 10240] = "TEXTURE_MAG_FILTER";
    /** The texture minifying function is used whenever the pixel being textured maps to an area greater than one texture element. There are six defined minifying functions. Two of them use the nearest one or nearest four texture elements to compute the texture value. The other four use mipmaps. Default: GL_NEAREST_MIPMAP_LINEAR */ GLEnum[GLEnum["TEXTURE_MIN_FILTER"] = 10241] = "TEXTURE_MIN_FILTER";
    /** Sets the wrap parameter for texture coordinate  to either GL_CLAMP_TO_EDGE, GL_MIRRORED_REPEAT, or GL_REPEAT. G */ GLEnum[GLEnum["TEXTURE_WRAP_S"] = 10242] = "TEXTURE_WRAP_S";
    /** Sets the wrap parameter for texture coordinate  to either GL_CLAMP_TO_EDGE, GL_MIRRORED_REPEAT, or GL_REPEAT. G */ GLEnum[GLEnum["TEXTURE_WRAP_T"] = 10243] = "TEXTURE_WRAP_T";
    GLEnum[GLEnum["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    GLEnum[GLEnum["TEXTURE"] = 5890] = "TEXTURE";
    GLEnum[GLEnum["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    GLEnum[GLEnum["TEXTURE_BINDING_CUBE_MAP"] = 34068] = "TEXTURE_BINDING_CUBE_MAP";
    GLEnum[GLEnum["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    GLEnum[GLEnum["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    GLEnum[GLEnum["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    GLEnum[GLEnum["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    GLEnum[GLEnum["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    GLEnum[GLEnum["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
    GLEnum[GLEnum["MAX_CUBE_MAP_TEXTURE_SIZE"] = 34076] = "MAX_CUBE_MAP_TEXTURE_SIZE";
    // TEXTURE0 - 31 0x84C0 - 0x84DF A texture unit.
    GLEnum[GLEnum["TEXTURE0"] = 33984] = "TEXTURE0";
    GLEnum[GLEnum["ACTIVE_TEXTURE"] = 34016] = "ACTIVE_TEXTURE";
    GLEnum[GLEnum["REPEAT"] = 10497] = "REPEAT";
    GLEnum[GLEnum["CLAMP_TO_EDGE"] = 33071] = "CLAMP_TO_EDGE";
    GLEnum[GLEnum["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
    // Emulation
    GLEnum[GLEnum["TEXTURE_WIDTH"] = 4096] = "TEXTURE_WIDTH";
    GLEnum[GLEnum["TEXTURE_HEIGHT"] = 4097] = "TEXTURE_HEIGHT";
    // Uniform types
    GLEnum[GLEnum["FLOAT_VEC2"] = 35664] = "FLOAT_VEC2";
    GLEnum[GLEnum["FLOAT_VEC3"] = 35665] = "FLOAT_VEC3";
    GLEnum[GLEnum["FLOAT_VEC4"] = 35666] = "FLOAT_VEC4";
    GLEnum[GLEnum["INT_VEC2"] = 35667] = "INT_VEC2";
    GLEnum[GLEnum["INT_VEC3"] = 35668] = "INT_VEC3";
    GLEnum[GLEnum["INT_VEC4"] = 35669] = "INT_VEC4";
    GLEnum[GLEnum["BOOL"] = 35670] = "BOOL";
    GLEnum[GLEnum["BOOL_VEC2"] = 35671] = "BOOL_VEC2";
    GLEnum[GLEnum["BOOL_VEC3"] = 35672] = "BOOL_VEC3";
    GLEnum[GLEnum["BOOL_VEC4"] = 35673] = "BOOL_VEC4";
    GLEnum[GLEnum["FLOAT_MAT2"] = 35674] = "FLOAT_MAT2";
    GLEnum[GLEnum["FLOAT_MAT3"] = 35675] = "FLOAT_MAT3";
    GLEnum[GLEnum["FLOAT_MAT4"] = 35676] = "FLOAT_MAT4";
    GLEnum[GLEnum["SAMPLER_2D"] = 35678] = "SAMPLER_2D";
    GLEnum[GLEnum["SAMPLER_CUBE"] = 35680] = "SAMPLER_CUBE";
    // Shader precision-specified types
    GLEnum[GLEnum["LOW_FLOAT"] = 36336] = "LOW_FLOAT";
    GLEnum[GLEnum["MEDIUM_FLOAT"] = 36337] = "MEDIUM_FLOAT";
    GLEnum[GLEnum["HIGH_FLOAT"] = 36338] = "HIGH_FLOAT";
    GLEnum[GLEnum["LOW_INT"] = 36339] = "LOW_INT";
    GLEnum[GLEnum["MEDIUM_INT"] = 36340] = "MEDIUM_INT";
    GLEnum[GLEnum["HIGH_INT"] = 36341] = "HIGH_INT";
    // Framebuffers and renderbuffers
    GLEnum[GLEnum["FRAMEBUFFER"] = 36160] = "FRAMEBUFFER";
    GLEnum[GLEnum["RENDERBUFFER"] = 36161] = "RENDERBUFFER";
    GLEnum[GLEnum["RGBA4"] = 32854] = "RGBA4";
    GLEnum[GLEnum["RGB5_A1"] = 32855] = "RGB5_A1";
    GLEnum[GLEnum["RGB565"] = 36194] = "RGB565";
    GLEnum[GLEnum["DEPTH_COMPONENT16"] = 33189] = "DEPTH_COMPONENT16";
    GLEnum[GLEnum["STENCIL_INDEX"] = 6401] = "STENCIL_INDEX";
    GLEnum[GLEnum["STENCIL_INDEX8"] = 36168] = "STENCIL_INDEX8";
    GLEnum[GLEnum["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
    GLEnum[GLEnum["RENDERBUFFER_WIDTH"] = 36162] = "RENDERBUFFER_WIDTH";
    GLEnum[GLEnum["RENDERBUFFER_HEIGHT"] = 36163] = "RENDERBUFFER_HEIGHT";
    GLEnum[GLEnum["RENDERBUFFER_INTERNAL_FORMAT"] = 36164] = "RENDERBUFFER_INTERNAL_FORMAT";
    GLEnum[GLEnum["RENDERBUFFER_RED_SIZE"] = 36176] = "RENDERBUFFER_RED_SIZE";
    GLEnum[GLEnum["RENDERBUFFER_GREEN_SIZE"] = 36177] = "RENDERBUFFER_GREEN_SIZE";
    GLEnum[GLEnum["RENDERBUFFER_BLUE_SIZE"] = 36178] = "RENDERBUFFER_BLUE_SIZE";
    GLEnum[GLEnum["RENDERBUFFER_ALPHA_SIZE"] = 36179] = "RENDERBUFFER_ALPHA_SIZE";
    GLEnum[GLEnum["RENDERBUFFER_DEPTH_SIZE"] = 36180] = "RENDERBUFFER_DEPTH_SIZE";
    GLEnum[GLEnum["RENDERBUFFER_STENCIL_SIZE"] = 36181] = "RENDERBUFFER_STENCIL_SIZE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE"] = 36048] = "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_OBJECT_NAME"] = 36049] = "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL"] = 36050] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE"] = 36051] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE";
    GLEnum[GLEnum["COLOR_ATTACHMENT0"] = 36064] = "COLOR_ATTACHMENT0";
    GLEnum[GLEnum["DEPTH_ATTACHMENT"] = 36096] = "DEPTH_ATTACHMENT";
    GLEnum[GLEnum["STENCIL_ATTACHMENT"] = 36128] = "STENCIL_ATTACHMENT";
    GLEnum[GLEnum["DEPTH_STENCIL_ATTACHMENT"] = 33306] = "DEPTH_STENCIL_ATTACHMENT";
    GLEnum[GLEnum["NONE"] = 0] = "NONE";
    GLEnum[GLEnum["FRAMEBUFFER_COMPLETE"] = 36053] = "FRAMEBUFFER_COMPLETE";
    GLEnum[GLEnum["FRAMEBUFFER_INCOMPLETE_ATTACHMENT"] = 36054] = "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
    GLEnum[GLEnum["FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT"] = 36055] = "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
    GLEnum[GLEnum["FRAMEBUFFER_INCOMPLETE_DIMENSIONS"] = 36057] = "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
    GLEnum[GLEnum["FRAMEBUFFER_UNSUPPORTED"] = 36061] = "FRAMEBUFFER_UNSUPPORTED";
    GLEnum[GLEnum["FRAMEBUFFER_BINDING"] = 36006] = "FRAMEBUFFER_BINDING";
    GLEnum[GLEnum["RENDERBUFFER_BINDING"] = 36007] = "RENDERBUFFER_BINDING";
    GLEnum[GLEnum["READ_FRAMEBUFFER"] = 36008] = "READ_FRAMEBUFFER";
    GLEnum[GLEnum["DRAW_FRAMEBUFFER"] = 36009] = "DRAW_FRAMEBUFFER";
    GLEnum[GLEnum["MAX_RENDERBUFFER_SIZE"] = 34024] = "MAX_RENDERBUFFER_SIZE";
    GLEnum[GLEnum["INVALID_FRAMEBUFFER_OPERATION"] = 1286] = "INVALID_FRAMEBUFFER_OPERATION";
    // Pixel storage modes
    // Constants passed to pixelStorei().
    GLEnum[GLEnum["UNPACK_FLIP_Y_WEBGL"] = 37440] = "UNPACK_FLIP_Y_WEBGL";
    GLEnum[GLEnum["UNPACK_PREMULTIPLY_ALPHA_WEBGL"] = 37441] = "UNPACK_PREMULTIPLY_ALPHA_WEBGL";
    GLEnum[GLEnum["UNPACK_COLORSPACE_CONVERSION_WEBGL"] = 37443] = "UNPACK_COLORSPACE_CONVERSION_WEBGL";
    // Additional constants defined WebGL 2
    // These constants are defined on the WebGL2RenderingContext interface.
    // All WebGL 1 constants are also available in a WebGL 2 context.
    // Getting GL parameter information
    // Constants passed to getParameter()
    // to specify what information to return.
    GLEnum[GLEnum["READ_BUFFER"] = 3074] = "READ_BUFFER";
    GLEnum[GLEnum["UNPACK_ROW_LENGTH"] = 3314] = "UNPACK_ROW_LENGTH";
    GLEnum[GLEnum["UNPACK_SKIP_ROWS"] = 3315] = "UNPACK_SKIP_ROWS";
    GLEnum[GLEnum["UNPACK_SKIP_PIXELS"] = 3316] = "UNPACK_SKIP_PIXELS";
    GLEnum[GLEnum["PACK_ROW_LENGTH"] = 3330] = "PACK_ROW_LENGTH";
    GLEnum[GLEnum["PACK_SKIP_ROWS"] = 3331] = "PACK_SKIP_ROWS";
    GLEnum[GLEnum["PACK_SKIP_PIXELS"] = 3332] = "PACK_SKIP_PIXELS";
    GLEnum[GLEnum["TEXTURE_BINDING_3D"] = 32874] = "TEXTURE_BINDING_3D";
    GLEnum[GLEnum["UNPACK_SKIP_IMAGES"] = 32877] = "UNPACK_SKIP_IMAGES";
    GLEnum[GLEnum["UNPACK_IMAGE_HEIGHT"] = 32878] = "UNPACK_IMAGE_HEIGHT";
    GLEnum[GLEnum["MAX_3D_TEXTURE_SIZE"] = 32883] = "MAX_3D_TEXTURE_SIZE";
    GLEnum[GLEnum["MAX_ELEMENTS_VERTICES"] = 33000] = "MAX_ELEMENTS_VERTICES";
    GLEnum[GLEnum["MAX_ELEMENTS_INDICES"] = 33001] = "MAX_ELEMENTS_INDICES";
    GLEnum[GLEnum["MAX_TEXTURE_LOD_BIAS"] = 34045] = "MAX_TEXTURE_LOD_BIAS";
    GLEnum[GLEnum["MAX_FRAGMENT_UNIFORM_COMPONENTS"] = 35657] = "MAX_FRAGMENT_UNIFORM_COMPONENTS";
    GLEnum[GLEnum["MAX_VERTEX_UNIFORM_COMPONENTS"] = 35658] = "MAX_VERTEX_UNIFORM_COMPONENTS";
    GLEnum[GLEnum["MAX_ARRAY_TEXTURE_LAYERS"] = 35071] = "MAX_ARRAY_TEXTURE_LAYERS";
    GLEnum[GLEnum["MIN_PROGRAM_TEXEL_OFFSET"] = 35076] = "MIN_PROGRAM_TEXEL_OFFSET";
    GLEnum[GLEnum["MAX_PROGRAM_TEXEL_OFFSET"] = 35077] = "MAX_PROGRAM_TEXEL_OFFSET";
    GLEnum[GLEnum["MAX_VARYING_COMPONENTS"] = 35659] = "MAX_VARYING_COMPONENTS";
    GLEnum[GLEnum["FRAGMENT_SHADER_DERIVATIVE_HINT"] = 35723] = "FRAGMENT_SHADER_DERIVATIVE_HINT";
    GLEnum[GLEnum["RASTERIZER_DISCARD"] = 35977] = "RASTERIZER_DISCARD";
    GLEnum[GLEnum["VERTEX_ARRAY_BINDING"] = 34229] = "VERTEX_ARRAY_BINDING";
    GLEnum[GLEnum["MAX_VERTEX_OUTPUT_COMPONENTS"] = 37154] = "MAX_VERTEX_OUTPUT_COMPONENTS";
    GLEnum[GLEnum["MAX_FRAGMENT_INPUT_COMPONENTS"] = 37157] = "MAX_FRAGMENT_INPUT_COMPONENTS";
    GLEnum[GLEnum["MAX_SERVER_WAIT_TIMEOUT"] = 37137] = "MAX_SERVER_WAIT_TIMEOUT";
    GLEnum[GLEnum["MAX_ELEMENT_INDEX"] = 36203] = "MAX_ELEMENT_INDEX";
    // Textures
    // Constants passed to texParameteri(),
    // texParameterf(), bindTexture(), texImage2D(), and others.
    GLEnum[GLEnum["RED"] = 6403] = "RED";
    GLEnum[GLEnum["RGB8"] = 32849] = "RGB8";
    GLEnum[GLEnum["RGBA8"] = 32856] = "RGBA8";
    GLEnum[GLEnum["RGB10_A2"] = 32857] = "RGB10_A2";
    GLEnum[GLEnum["TEXTURE_3D"] = 32879] = "TEXTURE_3D";
    /** Sets the wrap parameter for texture coordinate  to either GL_CLAMP_TO_EDGE, GL_MIRRORED_REPEAT, or GL_REPEAT. G */ GLEnum[GLEnum["TEXTURE_WRAP_R"] = 32882] = "TEXTURE_WRAP_R";
    GLEnum[GLEnum["TEXTURE_MIN_LOD"] = 33082] = "TEXTURE_MIN_LOD";
    GLEnum[GLEnum["TEXTURE_MAX_LOD"] = 33083] = "TEXTURE_MAX_LOD";
    GLEnum[GLEnum["TEXTURE_BASE_LEVEL"] = 33084] = "TEXTURE_BASE_LEVEL";
    GLEnum[GLEnum["TEXTURE_MAX_LEVEL"] = 33085] = "TEXTURE_MAX_LEVEL";
    GLEnum[GLEnum["TEXTURE_COMPARE_MODE"] = 34892] = "TEXTURE_COMPARE_MODE";
    GLEnum[GLEnum["TEXTURE_COMPARE_FUNC"] = 34893] = "TEXTURE_COMPARE_FUNC";
    GLEnum[GLEnum["SRGB"] = 35904] = "SRGB";
    GLEnum[GLEnum["SRGB8"] = 35905] = "SRGB8";
    GLEnum[GLEnum["SRGB8_ALPHA8"] = 35907] = "SRGB8_ALPHA8";
    GLEnum[GLEnum["COMPARE_REF_TO_TEXTURE"] = 34894] = "COMPARE_REF_TO_TEXTURE";
    GLEnum[GLEnum["RGBA32F"] = 34836] = "RGBA32F";
    GLEnum[GLEnum["RGB32F"] = 34837] = "RGB32F";
    GLEnum[GLEnum["RGBA16F"] = 34842] = "RGBA16F";
    GLEnum[GLEnum["RGB16F"] = 34843] = "RGB16F";
    GLEnum[GLEnum["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    GLEnum[GLEnum["TEXTURE_BINDING_2D_ARRAY"] = 35869] = "TEXTURE_BINDING_2D_ARRAY";
    GLEnum[GLEnum["R11F_G11F_B10F"] = 35898] = "R11F_G11F_B10F";
    GLEnum[GLEnum["RGB9_E5"] = 35901] = "RGB9_E5";
    GLEnum[GLEnum["RGBA32UI"] = 36208] = "RGBA32UI";
    GLEnum[GLEnum["RGB32UI"] = 36209] = "RGB32UI";
    GLEnum[GLEnum["RGBA16UI"] = 36214] = "RGBA16UI";
    GLEnum[GLEnum["RGB16UI"] = 36215] = "RGB16UI";
    GLEnum[GLEnum["RGBA8UI"] = 36220] = "RGBA8UI";
    GLEnum[GLEnum["RGB8UI"] = 36221] = "RGB8UI";
    GLEnum[GLEnum["RGBA32I"] = 36226] = "RGBA32I";
    GLEnum[GLEnum["RGB32I"] = 36227] = "RGB32I";
    GLEnum[GLEnum["RGBA16I"] = 36232] = "RGBA16I";
    GLEnum[GLEnum["RGB16I"] = 36233] = "RGB16I";
    GLEnum[GLEnum["RGBA8I"] = 36238] = "RGBA8I";
    GLEnum[GLEnum["RGB8I"] = 36239] = "RGB8I";
    GLEnum[GLEnum["RED_INTEGER"] = 36244] = "RED_INTEGER";
    GLEnum[GLEnum["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    GLEnum[GLEnum["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    GLEnum[GLEnum["R8"] = 33321] = "R8";
    GLEnum[GLEnum["RG8"] = 33323] = "RG8";
    GLEnum[GLEnum["R16F"] = 33325] = "R16F";
    GLEnum[GLEnum["R32F"] = 33326] = "R32F";
    GLEnum[GLEnum["RG16F"] = 33327] = "RG16F";
    GLEnum[GLEnum["RG32F"] = 33328] = "RG32F";
    GLEnum[GLEnum["R8I"] = 33329] = "R8I";
    GLEnum[GLEnum["R8UI"] = 33330] = "R8UI";
    GLEnum[GLEnum["R16I"] = 33331] = "R16I";
    GLEnum[GLEnum["R16UI"] = 33332] = "R16UI";
    GLEnum[GLEnum["R32I"] = 33333] = "R32I";
    GLEnum[GLEnum["R32UI"] = 33334] = "R32UI";
    GLEnum[GLEnum["RG8I"] = 33335] = "RG8I";
    GLEnum[GLEnum["RG8UI"] = 33336] = "RG8UI";
    GLEnum[GLEnum["RG16I"] = 33337] = "RG16I";
    GLEnum[GLEnum["RG16UI"] = 33338] = "RG16UI";
    GLEnum[GLEnum["RG32I"] = 33339] = "RG32I";
    GLEnum[GLEnum["RG32UI"] = 33340] = "RG32UI";
    GLEnum[GLEnum["R8_SNORM"] = 36756] = "R8_SNORM";
    GLEnum[GLEnum["RG8_SNORM"] = 36757] = "RG8_SNORM";
    GLEnum[GLEnum["RGB8_SNORM"] = 36758] = "RGB8_SNORM";
    GLEnum[GLEnum["RGBA8_SNORM"] = 36759] = "RGBA8_SNORM";
    GLEnum[GLEnum["RGB10_A2UI"] = 36975] = "RGB10_A2UI";
    /* covered by extension
    COMPRESSED_R11_EAC  = 0x9270,
    COMPRESSED_SIGNED_R11_EAC = 0x9271,
    COMPRESSED_RG11_EAC = 0x9272,
    COMPRESSED_SIGNED_RG11_EAC  = 0x9273,
    COMPRESSED_RGB8_ETC2  = 0x9274,
    COMPRESSED_SRGB8_ETC2 = 0x9275,
    COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2  = 0x9276,
    COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC  = 0x9277,
    COMPRESSED_RGBA8_ETC2_EAC = 0x9278,
    COMPRESSED_SRGB8_ALPHA8_ETC2_EAC  = 0x9279,
    */ GLEnum[GLEnum["TEXTURE_IMMUTABLE_FORMAT"] = 37167] = "TEXTURE_IMMUTABLE_FORMAT";
    GLEnum[GLEnum["TEXTURE_IMMUTABLE_LEVELS"] = 33503] = "TEXTURE_IMMUTABLE_LEVELS";
    // Pixel types
    GLEnum[GLEnum["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    GLEnum[GLEnum["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    GLEnum[GLEnum["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    GLEnum[GLEnum["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    GLEnum[GLEnum["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    GLEnum[GLEnum["HALF_FLOAT"] = 5131] = "HALF_FLOAT";
    GLEnum[GLEnum["RG"] = 33319] = "RG";
    GLEnum[GLEnum["RG_INTEGER"] = 33320] = "RG_INTEGER";
    GLEnum[GLEnum["INT_2_10_10_10_REV"] = 36255] = "INT_2_10_10_10_REV";
    // Queries
    GLEnum[GLEnum["CURRENT_QUERY"] = 34917] = "CURRENT_QUERY";
    /** Returns a GLuint containing the query result. */ GLEnum[GLEnum["QUERY_RESULT"] = 34918] = "QUERY_RESULT";
    /** Whether query result is available. */ GLEnum[GLEnum["QUERY_RESULT_AVAILABLE"] = 34919] = "QUERY_RESULT_AVAILABLE";
    /** Occlusion query (if drawing passed depth test)  */ GLEnum[GLEnum["ANY_SAMPLES_PASSED"] = 35887] = "ANY_SAMPLES_PASSED";
    /** Occlusion query less accurate/faster version */ GLEnum[GLEnum["ANY_SAMPLES_PASSED_CONSERVATIVE"] = 36202] = "ANY_SAMPLES_PASSED_CONSERVATIVE";
    // Draw buffers
    GLEnum[GLEnum["MAX_DRAW_BUFFERS"] = 34852] = "MAX_DRAW_BUFFERS";
    GLEnum[GLEnum["DRAW_BUFFER0"] = 34853] = "DRAW_BUFFER0";
    GLEnum[GLEnum["DRAW_BUFFER1"] = 34854] = "DRAW_BUFFER1";
    GLEnum[GLEnum["DRAW_BUFFER2"] = 34855] = "DRAW_BUFFER2";
    GLEnum[GLEnum["DRAW_BUFFER3"] = 34856] = "DRAW_BUFFER3";
    GLEnum[GLEnum["DRAW_BUFFER4"] = 34857] = "DRAW_BUFFER4";
    GLEnum[GLEnum["DRAW_BUFFER5"] = 34858] = "DRAW_BUFFER5";
    GLEnum[GLEnum["DRAW_BUFFER6"] = 34859] = "DRAW_BUFFER6";
    GLEnum[GLEnum["DRAW_BUFFER7"] = 34860] = "DRAW_BUFFER7";
    GLEnum[GLEnum["DRAW_BUFFER8"] = 34861] = "DRAW_BUFFER8";
    GLEnum[GLEnum["DRAW_BUFFER9"] = 34862] = "DRAW_BUFFER9";
    GLEnum[GLEnum["DRAW_BUFFER10"] = 34863] = "DRAW_BUFFER10";
    GLEnum[GLEnum["DRAW_BUFFER11"] = 34864] = "DRAW_BUFFER11";
    GLEnum[GLEnum["DRAW_BUFFER12"] = 34865] = "DRAW_BUFFER12";
    GLEnum[GLEnum["DRAW_BUFFER13"] = 34866] = "DRAW_BUFFER13";
    GLEnum[GLEnum["DRAW_BUFFER14"] = 34867] = "DRAW_BUFFER14";
    GLEnum[GLEnum["DRAW_BUFFER15"] = 34868] = "DRAW_BUFFER15";
    GLEnum[GLEnum["MAX_COLOR_ATTACHMENTS"] = 36063] = "MAX_COLOR_ATTACHMENTS";
    GLEnum[GLEnum["COLOR_ATTACHMENT1"] = 36065] = "COLOR_ATTACHMENT1";
    GLEnum[GLEnum["COLOR_ATTACHMENT2"] = 36066] = "COLOR_ATTACHMENT2";
    GLEnum[GLEnum["COLOR_ATTACHMENT3"] = 36067] = "COLOR_ATTACHMENT3";
    GLEnum[GLEnum["COLOR_ATTACHMENT4"] = 36068] = "COLOR_ATTACHMENT4";
    GLEnum[GLEnum["COLOR_ATTACHMENT5"] = 36069] = "COLOR_ATTACHMENT5";
    GLEnum[GLEnum["COLOR_ATTACHMENT6"] = 36070] = "COLOR_ATTACHMENT6";
    GLEnum[GLEnum["COLOR_ATTACHMENT7"] = 36071] = "COLOR_ATTACHMENT7";
    GLEnum[GLEnum["COLOR_ATTACHMENT8"] = 36072] = "COLOR_ATTACHMENT8";
    GLEnum[GLEnum["COLOR_ATTACHMENT9"] = 36073] = "COLOR_ATTACHMENT9";
    GLEnum[GLEnum["COLOR_ATTACHMENT10"] = 36074] = "COLOR_ATTACHMENT10";
    GLEnum[GLEnum["COLOR_ATTACHMENT11"] = 36075] = "COLOR_ATTACHMENT11";
    GLEnum[GLEnum["COLOR_ATTACHMENT12"] = 36076] = "COLOR_ATTACHMENT12";
    GLEnum[GLEnum["COLOR_ATTACHMENT13"] = 36077] = "COLOR_ATTACHMENT13";
    GLEnum[GLEnum["COLOR_ATTACHMENT14"] = 36078] = "COLOR_ATTACHMENT14";
    GLEnum[GLEnum["COLOR_ATTACHMENT15"] = 36079] = "COLOR_ATTACHMENT15";
    // Samplers
    GLEnum[GLEnum["SAMPLER_3D"] = 35679] = "SAMPLER_3D";
    GLEnum[GLEnum["SAMPLER_2D_SHADOW"] = 35682] = "SAMPLER_2D_SHADOW";
    GLEnum[GLEnum["SAMPLER_2D_ARRAY"] = 36289] = "SAMPLER_2D_ARRAY";
    GLEnum[GLEnum["SAMPLER_2D_ARRAY_SHADOW"] = 36292] = "SAMPLER_2D_ARRAY_SHADOW";
    GLEnum[GLEnum["SAMPLER_CUBE_SHADOW"] = 36293] = "SAMPLER_CUBE_SHADOW";
    GLEnum[GLEnum["INT_SAMPLER_2D"] = 36298] = "INT_SAMPLER_2D";
    GLEnum[GLEnum["INT_SAMPLER_3D"] = 36299] = "INT_SAMPLER_3D";
    GLEnum[GLEnum["INT_SAMPLER_CUBE"] = 36300] = "INT_SAMPLER_CUBE";
    GLEnum[GLEnum["INT_SAMPLER_2D_ARRAY"] = 36303] = "INT_SAMPLER_2D_ARRAY";
    GLEnum[GLEnum["UNSIGNED_INT_SAMPLER_2D"] = 36306] = "UNSIGNED_INT_SAMPLER_2D";
    GLEnum[GLEnum["UNSIGNED_INT_SAMPLER_3D"] = 36307] = "UNSIGNED_INT_SAMPLER_3D";
    GLEnum[GLEnum["UNSIGNED_INT_SAMPLER_CUBE"] = 36308] = "UNSIGNED_INT_SAMPLER_CUBE";
    GLEnum[GLEnum["UNSIGNED_INT_SAMPLER_2D_ARRAY"] = 36311] = "UNSIGNED_INT_SAMPLER_2D_ARRAY";
    GLEnum[GLEnum["MAX_SAMPLES"] = 36183] = "MAX_SAMPLES";
    GLEnum[GLEnum["SAMPLER_BINDING"] = 35097] = "SAMPLER_BINDING";
    // Buffers
    GLEnum[GLEnum["PIXEL_PACK_BUFFER"] = 35051] = "PIXEL_PACK_BUFFER";
    GLEnum[GLEnum["PIXEL_UNPACK_BUFFER"] = 35052] = "PIXEL_UNPACK_BUFFER";
    GLEnum[GLEnum["PIXEL_PACK_BUFFER_BINDING"] = 35053] = "PIXEL_PACK_BUFFER_BINDING";
    GLEnum[GLEnum["PIXEL_UNPACK_BUFFER_BINDING"] = 35055] = "PIXEL_UNPACK_BUFFER_BINDING";
    GLEnum[GLEnum["COPY_READ_BUFFER"] = 36662] = "COPY_READ_BUFFER";
    GLEnum[GLEnum["COPY_WRITE_BUFFER"] = 36663] = "COPY_WRITE_BUFFER";
    GLEnum[GLEnum["COPY_READ_BUFFER_BINDING"] = 36662] = "COPY_READ_BUFFER_BINDING";
    GLEnum[GLEnum["COPY_WRITE_BUFFER_BINDING"] = 36663] = "COPY_WRITE_BUFFER_BINDING";
    // Data types
    GLEnum[GLEnum["FLOAT_MAT2x3"] = 35685] = "FLOAT_MAT2x3";
    GLEnum[GLEnum["FLOAT_MAT2x4"] = 35686] = "FLOAT_MAT2x4";
    GLEnum[GLEnum["FLOAT_MAT3x2"] = 35687] = "FLOAT_MAT3x2";
    GLEnum[GLEnum["FLOAT_MAT3x4"] = 35688] = "FLOAT_MAT3x4";
    GLEnum[GLEnum["FLOAT_MAT4x2"] = 35689] = "FLOAT_MAT4x2";
    GLEnum[GLEnum["FLOAT_MAT4x3"] = 35690] = "FLOAT_MAT4x3";
    GLEnum[GLEnum["UNSIGNED_INT_VEC2"] = 36294] = "UNSIGNED_INT_VEC2";
    GLEnum[GLEnum["UNSIGNED_INT_VEC3"] = 36295] = "UNSIGNED_INT_VEC3";
    GLEnum[GLEnum["UNSIGNED_INT_VEC4"] = 36296] = "UNSIGNED_INT_VEC4";
    GLEnum[GLEnum["UNSIGNED_NORMALIZED"] = 35863] = "UNSIGNED_NORMALIZED";
    GLEnum[GLEnum["SIGNED_NORMALIZED"] = 36764] = "SIGNED_NORMALIZED";
    // Vertex attributes
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_INTEGER"] = 35069] = "VERTEX_ATTRIB_ARRAY_INTEGER";
    GLEnum[GLEnum["VERTEX_ATTRIB_ARRAY_DIVISOR"] = 35070] = "VERTEX_ATTRIB_ARRAY_DIVISOR";
    // Transform feedback
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_BUFFER_MODE"] = 35967] = "TRANSFORM_FEEDBACK_BUFFER_MODE";
    GLEnum[GLEnum["MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS"] = 35968] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_VARYINGS"] = 35971] = "TRANSFORM_FEEDBACK_VARYINGS";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_BUFFER_START"] = 35972] = "TRANSFORM_FEEDBACK_BUFFER_START";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_BUFFER_SIZE"] = 35973] = "TRANSFORM_FEEDBACK_BUFFER_SIZE";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN"] = 35976] = "TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN";
    GLEnum[GLEnum["MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS"] = 35978] = "MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS";
    GLEnum[GLEnum["MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS"] = 35979] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS";
    GLEnum[GLEnum["INTERLEAVED_ATTRIBS"] = 35980] = "INTERLEAVED_ATTRIBS";
    GLEnum[GLEnum["SEPARATE_ATTRIBS"] = 35981] = "SEPARATE_ATTRIBS";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_BUFFER"] = 35982] = "TRANSFORM_FEEDBACK_BUFFER";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_BUFFER_BINDING"] = 35983] = "TRANSFORM_FEEDBACK_BUFFER_BINDING";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK"] = 36386] = "TRANSFORM_FEEDBACK";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_PAUSED"] = 36387] = "TRANSFORM_FEEDBACK_PAUSED";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_ACTIVE"] = 36388] = "TRANSFORM_FEEDBACK_ACTIVE";
    GLEnum[GLEnum["TRANSFORM_FEEDBACK_BINDING"] = 36389] = "TRANSFORM_FEEDBACK_BINDING";
    // Framebuffers and renderbuffers
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING"] = 33296] = "FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE"] = 33297] = "FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_RED_SIZE"] = 33298] = "FRAMEBUFFER_ATTACHMENT_RED_SIZE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_GREEN_SIZE"] = 33299] = "FRAMEBUFFER_ATTACHMENT_GREEN_SIZE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_BLUE_SIZE"] = 33300] = "FRAMEBUFFER_ATTACHMENT_BLUE_SIZE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE"] = 33301] = "FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE"] = 33302] = "FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE"] = 33303] = "FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE";
    GLEnum[GLEnum["FRAMEBUFFER_DEFAULT"] = 33304] = "FRAMEBUFFER_DEFAULT";
    // DEPTH_STENCIL_ATTACHMENT  = 0x821A,
    // DEPTH_STENCIL = 0x84F9,
    GLEnum[GLEnum["DEPTH24_STENCIL8"] = 35056] = "DEPTH24_STENCIL8";
    GLEnum[GLEnum["DRAW_FRAMEBUFFER_BINDING"] = 36006] = "DRAW_FRAMEBUFFER_BINDING";
    GLEnum[GLEnum["READ_FRAMEBUFFER_BINDING"] = 36010] = "READ_FRAMEBUFFER_BINDING";
    GLEnum[GLEnum["RENDERBUFFER_SAMPLES"] = 36011] = "RENDERBUFFER_SAMPLES";
    GLEnum[GLEnum["FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER"] = 36052] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER";
    GLEnum[GLEnum["FRAMEBUFFER_INCOMPLETE_MULTISAMPLE"] = 36182] = "FRAMEBUFFER_INCOMPLETE_MULTISAMPLE";
    // Uniforms
    GLEnum[GLEnum["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
    GLEnum[GLEnum["UNIFORM_BUFFER_BINDING"] = 35368] = "UNIFORM_BUFFER_BINDING";
    GLEnum[GLEnum["UNIFORM_BUFFER_START"] = 35369] = "UNIFORM_BUFFER_START";
    GLEnum[GLEnum["UNIFORM_BUFFER_SIZE"] = 35370] = "UNIFORM_BUFFER_SIZE";
    GLEnum[GLEnum["MAX_VERTEX_UNIFORM_BLOCKS"] = 35371] = "MAX_VERTEX_UNIFORM_BLOCKS";
    GLEnum[GLEnum["MAX_FRAGMENT_UNIFORM_BLOCKS"] = 35373] = "MAX_FRAGMENT_UNIFORM_BLOCKS";
    GLEnum[GLEnum["MAX_COMBINED_UNIFORM_BLOCKS"] = 35374] = "MAX_COMBINED_UNIFORM_BLOCKS";
    GLEnum[GLEnum["MAX_UNIFORM_BUFFER_BINDINGS"] = 35375] = "MAX_UNIFORM_BUFFER_BINDINGS";
    GLEnum[GLEnum["MAX_UNIFORM_BLOCK_SIZE"] = 35376] = "MAX_UNIFORM_BLOCK_SIZE";
    GLEnum[GLEnum["MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS"] = 35377] = "MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS";
    GLEnum[GLEnum["MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS"] = 35379] = "MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS";
    GLEnum[GLEnum["UNIFORM_BUFFER_OFFSET_ALIGNMENT"] = 35380] = "UNIFORM_BUFFER_OFFSET_ALIGNMENT";
    GLEnum[GLEnum["ACTIVE_UNIFORM_BLOCKS"] = 35382] = "ACTIVE_UNIFORM_BLOCKS";
    GLEnum[GLEnum["UNIFORM_TYPE"] = 35383] = "UNIFORM_TYPE";
    GLEnum[GLEnum["UNIFORM_SIZE"] = 35384] = "UNIFORM_SIZE";
    GLEnum[GLEnum["UNIFORM_BLOCK_INDEX"] = 35386] = "UNIFORM_BLOCK_INDEX";
    GLEnum[GLEnum["UNIFORM_OFFSET"] = 35387] = "UNIFORM_OFFSET";
    GLEnum[GLEnum["UNIFORM_ARRAY_STRIDE"] = 35388] = "UNIFORM_ARRAY_STRIDE";
    GLEnum[GLEnum["UNIFORM_MATRIX_STRIDE"] = 35389] = "UNIFORM_MATRIX_STRIDE";
    GLEnum[GLEnum["UNIFORM_IS_ROW_MAJOR"] = 35390] = "UNIFORM_IS_ROW_MAJOR";
    GLEnum[GLEnum["UNIFORM_BLOCK_BINDING"] = 35391] = "UNIFORM_BLOCK_BINDING";
    GLEnum[GLEnum["UNIFORM_BLOCK_DATA_SIZE"] = 35392] = "UNIFORM_BLOCK_DATA_SIZE";
    GLEnum[GLEnum["UNIFORM_BLOCK_ACTIVE_UNIFORMS"] = 35394] = "UNIFORM_BLOCK_ACTIVE_UNIFORMS";
    GLEnum[GLEnum["UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES"] = 35395] = "UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES";
    GLEnum[GLEnum["UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER"] = 35396] = "UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER";
    GLEnum[GLEnum["UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER"] = 35398] = "UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER";
    // Sync objects
    GLEnum[GLEnum["OBJECT_TYPE"] = 37138] = "OBJECT_TYPE";
    GLEnum[GLEnum["SYNC_CONDITION"] = 37139] = "SYNC_CONDITION";
    GLEnum[GLEnum["SYNC_STATUS"] = 37140] = "SYNC_STATUS";
    GLEnum[GLEnum["SYNC_FLAGS"] = 37141] = "SYNC_FLAGS";
    GLEnum[GLEnum["SYNC_FENCE"] = 37142] = "SYNC_FENCE";
    GLEnum[GLEnum["SYNC_GPU_COMMANDS_COMPLETE"] = 37143] = "SYNC_GPU_COMMANDS_COMPLETE";
    GLEnum[GLEnum["UNSIGNALED"] = 37144] = "UNSIGNALED";
    GLEnum[GLEnum["SIGNALED"] = 37145] = "SIGNALED";
    GLEnum[GLEnum["ALREADY_SIGNALED"] = 37146] = "ALREADY_SIGNALED";
    GLEnum[GLEnum["TIMEOUT_EXPIRED"] = 37147] = "TIMEOUT_EXPIRED";
    GLEnum[GLEnum["CONDITION_SATISFIED"] = 37148] = "CONDITION_SATISFIED";
    GLEnum[GLEnum["WAIT_FAILED"] = 37149] = "WAIT_FAILED";
    GLEnum[GLEnum["SYNC_FLUSH_COMMANDS_BIT"] = 1] = "SYNC_FLUSH_COMMANDS_BIT";
    // Miscellaneous constants
    GLEnum[GLEnum["COLOR"] = 6144] = "COLOR";
    GLEnum[GLEnum["DEPTH"] = 6145] = "DEPTH";
    GLEnum[GLEnum["STENCIL"] = 6146] = "STENCIL";
    GLEnum[GLEnum["MIN"] = 32775] = "MIN";
    GLEnum[GLEnum["MAX"] = 32776] = "MAX";
    GLEnum[GLEnum["DEPTH_COMPONENT24"] = 33190] = "DEPTH_COMPONENT24";
    GLEnum[GLEnum["STREAM_READ"] = 35041] = "STREAM_READ";
    GLEnum[GLEnum["STREAM_COPY"] = 35042] = "STREAM_COPY";
    GLEnum[GLEnum["STATIC_READ"] = 35045] = "STATIC_READ";
    GLEnum[GLEnum["STATIC_COPY"] = 35046] = "STATIC_COPY";
    GLEnum[GLEnum["DYNAMIC_READ"] = 35049] = "DYNAMIC_READ";
    GLEnum[GLEnum["DYNAMIC_COPY"] = 35050] = "DYNAMIC_COPY";
    GLEnum[GLEnum["DEPTH_COMPONENT32F"] = 36012] = "DEPTH_COMPONENT32F";
    GLEnum[GLEnum["DEPTH32F_STENCIL8"] = 36013] = "DEPTH32F_STENCIL8";
    GLEnum[GLEnum["INVALID_INDEX"] = 4294967295] = "INVALID_INDEX";
    GLEnum[GLEnum["TIMEOUT_IGNORED"] = -1] = "TIMEOUT_IGNORED";
    GLEnum[GLEnum["MAX_CLIENT_WAIT_TIMEOUT_WEBGL"] = 37447] = "MAX_CLIENT_WAIT_TIMEOUT_WEBGL";
    // Constants defined in WebGL extensions
    // WEBGL_debug_renderer_info
    /** Passed to getParameter to get the vendor string of the graphics driver. */ GLEnum[GLEnum["UNMASKED_VENDOR_WEBGL"] = 37445] = "UNMASKED_VENDOR_WEBGL";
    /** Passed to getParameter to get the renderer string of the graphics driver. */ GLEnum[GLEnum["UNMASKED_RENDERER_WEBGL"] = 37446] = "UNMASKED_RENDERER_WEBGL";
    // EXT_texture_filter_anisotropic
    /** Returns the maximum available anisotropy. */ GLEnum[GLEnum["MAX_TEXTURE_MAX_ANISOTROPY_EXT"] = 34047] = "MAX_TEXTURE_MAX_ANISOTROPY_EXT";
    /** Passed to texParameter to set the desired maximum anisotropy for a texture. */ GLEnum[GLEnum["TEXTURE_MAX_ANISOTROPY_EXT"] = 34046] = "TEXTURE_MAX_ANISOTROPY_EXT";
    // EXT_texture_norm16 - https://khronos.org/registry/webgl/extensions/EXT_texture_norm16/
    GLEnum[GLEnum["R16_EXT"] = 33322] = "R16_EXT";
    GLEnum[GLEnum["RG16_EXT"] = 33324] = "RG16_EXT";
    GLEnum[GLEnum["RGB16_EXT"] = 32852] = "RGB16_EXT";
    GLEnum[GLEnum["RGBA16_EXT"] = 32859] = "RGBA16_EXT";
    GLEnum[GLEnum["R16_SNORM_EXT"] = 36760] = "R16_SNORM_EXT";
    GLEnum[GLEnum["RG16_SNORM_EXT"] = 36761] = "RG16_SNORM_EXT";
    GLEnum[GLEnum["RGB16_SNORM_EXT"] = 36762] = "RGB16_SNORM_EXT";
    GLEnum[GLEnum["RGBA16_SNORM_EXT"] = 36763] = "RGBA16_SNORM_EXT";
    // WEBGL_compressed_texture_s3tc (BC1, BC2, BC3)
    /** A DXT1-compressed image in an RGB image format. */ GLEnum[GLEnum["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
    /** A DXT1-compressed image in an RGB image format with a simple on/off alpha value. */ GLEnum[GLEnum["COMPRESSED_RGBA_S3TC_DXT1_EXT"] = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT";
    /** A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression. */ GLEnum[GLEnum["COMPRESSED_RGBA_S3TC_DXT3_EXT"] = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT";
    /** A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3 compression in how the alpha compression is done. */ GLEnum[GLEnum["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
    // WEBGL_compressed_texture_s3tc_srgb (BC1, BC2, BC3 -  SRGB)
    GLEnum[GLEnum["COMPRESSED_SRGB_S3TC_DXT1_EXT"] = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT";
    GLEnum[GLEnum["COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT"] = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT";
    GLEnum[GLEnum["COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT"] = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT";
    GLEnum[GLEnum["COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT"] = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT";
    // WEBGL_compressed_texture_rgtc (BC4, BC5)
    GLEnum[GLEnum["COMPRESSED_RED_RGTC1_EXT"] = 36283] = "COMPRESSED_RED_RGTC1_EXT";
    GLEnum[GLEnum["COMPRESSED_SIGNED_RED_RGTC1_EXT"] = 36284] = "COMPRESSED_SIGNED_RED_RGTC1_EXT";
    GLEnum[GLEnum["COMPRESSED_RED_GREEN_RGTC2_EXT"] = 36285] = "COMPRESSED_RED_GREEN_RGTC2_EXT";
    GLEnum[GLEnum["COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT"] = 36286] = "COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT";
    // WEBGL_compressed_texture_bptc (BC6, BC7)
    GLEnum[GLEnum["COMPRESSED_RGBA_BPTC_UNORM_EXT"] = 36492] = "COMPRESSED_RGBA_BPTC_UNORM_EXT";
    GLEnum[GLEnum["COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT"] = 36493] = "COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT";
    GLEnum[GLEnum["COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT"] = 36494] = "COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT";
    GLEnum[GLEnum["COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT"] = 36495] = "COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT";
    // WEBGL_compressed_texture_es3
    /** One-channel (red) unsigned format compression. */ GLEnum[GLEnum["COMPRESSED_R11_EAC"] = 37488] = "COMPRESSED_R11_EAC";
    /** One-channel (red) signed format compression. */ GLEnum[GLEnum["COMPRESSED_SIGNED_R11_EAC"] = 37489] = "COMPRESSED_SIGNED_R11_EAC";
    /** Two-channel (red and green) unsigned format compression. */ GLEnum[GLEnum["COMPRESSED_RG11_EAC"] = 37490] = "COMPRESSED_RG11_EAC";
    /** Two-channel (red and green) signed format compression. */ GLEnum[GLEnum["COMPRESSED_SIGNED_RG11_EAC"] = 37491] = "COMPRESSED_SIGNED_RG11_EAC";
    /** Compresses RGB8 data with no alpha channel. */ GLEnum[GLEnum["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
    /** Compresses RGBA8 data. The RGB part is encoded the same as RGB_ETC2, but the alpha part is encoded separately. */ GLEnum[GLEnum["COMPRESSED_RGBA8_ETC2_EAC"] = 37493] = "COMPRESSED_RGBA8_ETC2_EAC";
    /** Compresses sRGB8 data with no alpha channel. */ GLEnum[GLEnum["COMPRESSED_SRGB8_ETC2"] = 37494] = "COMPRESSED_SRGB8_ETC2";
    /** Compresses sRGBA8 data. The sRGB part is encoded the same as SRGB_ETC2, but the alpha part is encoded separately. */ GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ETC2_EAC"] = 37495] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC";
    /** Similar to RGB8_ETC, but with ability to punch through the alpha channel, which means to make it completely opaque or transparent. */ GLEnum[GLEnum["COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37496] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    /** Similar to SRGB8_ETC, but with ability to punch through the alpha channel, which means to make it completely opaque or transparent. */ GLEnum[GLEnum["COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37497] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    // WEBGL_compressed_texture_pvrtc
    /** RGB compression in 4-bit mode. One block for each 4×4 pixels. */ GLEnum[GLEnum["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
    /** RGBA compression in 4-bit mode. One block for each 4×4 pixels. */ GLEnum[GLEnum["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
    /** RGB compression in 2-bit mode. One block for each 8×4 pixels. */ GLEnum[GLEnum["COMPRESSED_RGB_PVRTC_2BPPV1_IMG"] = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG";
    /** RGBA compression in 2-bit mode. One block for each 8×4 pixels. */ GLEnum[GLEnum["COMPRESSED_RGBA_PVRTC_2BPPV1_IMG"] = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG";
    // WEBGL_compressed_texture_etc1
    /** Compresses 24-bit RGB data with no alpha channel. */ GLEnum[GLEnum["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL";
    // WEBGL_compressed_texture_atc
    GLEnum[GLEnum["COMPRESSED_RGB_ATC_WEBGL"] = 35986] = "COMPRESSED_RGB_ATC_WEBGL";
    GLEnum[GLEnum["COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL"] = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL";
    GLEnum[GLEnum["COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL"] = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL";
    // WEBGL_compressed_texture_astc
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_4x4_KHR"] = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_5x4_KHR"] = 37809] = "COMPRESSED_RGBA_ASTC_5x4_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_5x5_KHR"] = 37810] = "COMPRESSED_RGBA_ASTC_5x5_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_6x5_KHR"] = 37811] = "COMPRESSED_RGBA_ASTC_6x5_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_6x6_KHR"] = 37812] = "COMPRESSED_RGBA_ASTC_6x6_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_8x5_KHR"] = 37813] = "COMPRESSED_RGBA_ASTC_8x5_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_8x6_KHR"] = 37814] = "COMPRESSED_RGBA_ASTC_8x6_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_8x8_KHR"] = 37815] = "COMPRESSED_RGBA_ASTC_8x8_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_10x5_KHR"] = 37816] = "COMPRESSED_RGBA_ASTC_10x5_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_10x6_KHR"] = 37817] = "COMPRESSED_RGBA_ASTC_10x6_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_10x8_KHR"] = 37818] = "COMPRESSED_RGBA_ASTC_10x8_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_10x10_KHR"] = 37819] = "COMPRESSED_RGBA_ASTC_10x10_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_12x10_KHR"] = 37820] = "COMPRESSED_RGBA_ASTC_12x10_KHR";
    GLEnum[GLEnum["COMPRESSED_RGBA_ASTC_12x12_KHR"] = 37821] = "COMPRESSED_RGBA_ASTC_12x12_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR"] = 37840] = "COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR"] = 37841] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR"] = 37842] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR"] = 37843] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR"] = 37844] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR"] = 37845] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR"] = 37846] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR"] = 37847] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR"] = 37848] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR"] = 37849] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR"] = 37850] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR"] = 37851] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR"] = 37852] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR";
    GLEnum[GLEnum["COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR"] = 37853] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR";
    // EXT_disjoint_timer_query
    /** The number of bits used to hold the query result for the given target. */ GLEnum[GLEnum["QUERY_COUNTER_BITS_EXT"] = 34916] = "QUERY_COUNTER_BITS_EXT";
    /** The currently active query. */ GLEnum[GLEnum["CURRENT_QUERY_EXT"] = 34917] = "CURRENT_QUERY_EXT";
    /** The query result. */ GLEnum[GLEnum["QUERY_RESULT_EXT"] = 34918] = "QUERY_RESULT_EXT";
    /** A Boolean indicating whether or not a query result is available. */ GLEnum[GLEnum["QUERY_RESULT_AVAILABLE_EXT"] = 34919] = "QUERY_RESULT_AVAILABLE_EXT";
    /** Elapsed time (in nanoseconds). */ GLEnum[GLEnum["TIME_ELAPSED_EXT"] = 35007] = "TIME_ELAPSED_EXT";
    /** The current time. */ GLEnum[GLEnum["TIMESTAMP_EXT"] = 36392] = "TIMESTAMP_EXT";
    /** A Boolean indicating whether or not the GPU performed any disjoint operation (lost context) */ GLEnum[GLEnum["GPU_DISJOINT_EXT"] = 36795] = "GPU_DISJOINT_EXT";
    // KHR_parallel_shader_compile https://registry.khronos.org/webgl/extensions/KHR_parallel_shader_compile
    /** a non-blocking poll operation, so that compile/link status availability can be queried without potentially incurring stalls */ GLEnum[GLEnum["COMPLETION_STATUS_KHR"] = 37297] = "COMPLETION_STATUS_KHR";
    // EXT_depth_clamp https://registry.khronos.org/webgl/extensions/EXT_depth_clamp/
    /** Disables depth clipping */ GLEnum[GLEnum["DEPTH_CLAMP_EXT"] = 34383] = "DEPTH_CLAMP_EXT";
    // WEBGL_provoking_vertex https://registry.khronos.org/webgl/extensions/WEBGL_provoking_vertex/
    /** Values of first vertex in primitive are used for flat shading */ GLEnum[GLEnum["FIRST_VERTEX_CONVENTION_WEBGL"] = 36429] = "FIRST_VERTEX_CONVENTION_WEBGL";
    /** Values of first vertex in primitive are used for flat shading */ GLEnum[GLEnum["LAST_VERTEX_CONVENTION_WEBGL"] = 36430] = "LAST_VERTEX_CONVENTION_WEBGL";
    /** Controls which vertex in primitive is used for flat shading */ GLEnum[GLEnum["PROVOKING_VERTEX_WEBL"] = 36431] = "PROVOKING_VERTEX_WEBL";
    // WEBGL_polygon_mode https://registry.khronos.org/webgl/extensions/WEBGL_polygon_mode/
    GLEnum[GLEnum["POLYGON_MODE_WEBGL"] = 2880] = "POLYGON_MODE_WEBGL";
    GLEnum[GLEnum["POLYGON_OFFSET_LINE_WEBGL"] = 10754] = "POLYGON_OFFSET_LINE_WEBGL";
    GLEnum[GLEnum["LINE_WEBGL"] = 6913] = "LINE_WEBGL";
    GLEnum[GLEnum["FILL_WEBGL"] = 6914] = "FILL_WEBGL";
    // WEBGL_clip_cull_distance https://registry.khronos.org/webgl/extensions/WEBGL_clip_cull_distance/
    /** Max clip distances */ GLEnum[GLEnum["MAX_CLIP_DISTANCES_WEBGL"] = 3378] = "MAX_CLIP_DISTANCES_WEBGL";
    /** Max cull distances */ GLEnum[GLEnum["MAX_CULL_DISTANCES_WEBGL"] = 33529] = "MAX_CULL_DISTANCES_WEBGL";
    /** Max clip and cull distances */ GLEnum[GLEnum["MAX_COMBINED_CLIP_AND_CULL_DISTANCES_WEBGL"] = 33530] = "MAX_COMBINED_CLIP_AND_CULL_DISTANCES_WEBGL";
    /** Enable gl_ClipDistance[0] and gl_CullDistance[0] */ GLEnum[GLEnum["CLIP_DISTANCE0_WEBGL"] = 12288] = "CLIP_DISTANCE0_WEBGL";
    /** Enable gl_ClipDistance[1] and gl_CullDistance[1] */ GLEnum[GLEnum["CLIP_DISTANCE1_WEBGL"] = 12289] = "CLIP_DISTANCE1_WEBGL";
    /** Enable gl_ClipDistance[2] and gl_CullDistance[2] */ GLEnum[GLEnum["CLIP_DISTANCE2_WEBGL"] = 12290] = "CLIP_DISTANCE2_WEBGL";
    /** Enable gl_ClipDistance[3] and gl_CullDistance[3] */ GLEnum[GLEnum["CLIP_DISTANCE3_WEBGL"] = 12291] = "CLIP_DISTANCE3_WEBGL";
    /** Enable gl_ClipDistance[4] and gl_CullDistance[4] */ GLEnum[GLEnum["CLIP_DISTANCE4_WEBGL"] = 12292] = "CLIP_DISTANCE4_WEBGL";
    /** Enable gl_ClipDistance[5] and gl_CullDistance[5] */ GLEnum[GLEnum["CLIP_DISTANCE5_WEBGL"] = 12293] = "CLIP_DISTANCE5_WEBGL";
    /** Enable gl_ClipDistance[6] and gl_CullDistance[6] */ GLEnum[GLEnum["CLIP_DISTANCE6_WEBGL"] = 12294] = "CLIP_DISTANCE6_WEBGL";
    /** Enable gl_ClipDistance[7] and gl_CullDistance[7] */ GLEnum[GLEnum["CLIP_DISTANCE7_WEBGL"] = 12295] = "CLIP_DISTANCE7_WEBGL";
    /** EXT_polygon_offset_clamp https://registry.khronos.org/webgl/extensions/EXT_polygon_offset_clamp/ */ GLEnum[GLEnum["POLYGON_OFFSET_CLAMP_EXT"] = 36379] = "POLYGON_OFFSET_CLAMP_EXT";
    /** EXT_clip_control https://registry.khronos.org/webgl/extensions/EXT_clip_control/ */ GLEnum[GLEnum["LOWER_LEFT_EXT"] = 36001] = "LOWER_LEFT_EXT";
    GLEnum[GLEnum["UPPER_LEFT_EXT"] = 36002] = "UPPER_LEFT_EXT";
    GLEnum[GLEnum["NEGATIVE_ONE_TO_ONE_EXT"] = 37726] = "NEGATIVE_ONE_TO_ONE_EXT";
    GLEnum[GLEnum["ZERO_TO_ONE_EXT"] = 37727] = "ZERO_TO_ONE_EXT";
    GLEnum[GLEnum["CLIP_ORIGIN_EXT"] = 37724] = "CLIP_ORIGIN_EXT";
    GLEnum[GLEnum["CLIP_DEPTH_MODE_EXT"] = 37725] = "CLIP_DEPTH_MODE_EXT";
    /** WEBGL_blend_func_extended https://registry.khronos.org/webgl/extensions/WEBGL_blend_func_extended/ */ GLEnum[GLEnum["SRC1_COLOR_WEBGL"] = 35065] = "SRC1_COLOR_WEBGL";
    GLEnum[GLEnum["SRC1_ALPHA_WEBGL"] = 34185] = "SRC1_ALPHA_WEBGL";
    GLEnum[GLEnum["ONE_MINUS_SRC1_COLOR_WEBGL"] = 35066] = "ONE_MINUS_SRC1_COLOR_WEBGL";
    GLEnum[GLEnum["ONE_MINUS_SRC1_ALPHA_WEBGL"] = 35067] = "ONE_MINUS_SRC1_ALPHA_WEBGL";
    GLEnum[GLEnum["MAX_DUAL_SOURCE_DRAW_BUFFERS_WEBGL"] = 35068] = "MAX_DUAL_SOURCE_DRAW_BUFFERS_WEBGL";
    /** EXT_texture_mirror_clamp_to_edge https://registry.khronos.org/webgl/extensions/EXT_texture_mirror_clamp_to_edge/ */ GLEnum[GLEnum["MIRROR_CLAMP_TO_EDGE_EXT"] = 34627] = "MIRROR_CLAMP_TO_EDGE_EXT";
})(GLEnum || (GLEnum = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iEcm8":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** deeply compare two arrays */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepArrayEqual", ()=>deepArrayEqual);
function deepArrayEqual(x, y) {
    if (x === y) return true;
    const isArrayX = Array.isArray(x) || ArrayBuffer.isView(x);
    const isArrayY = Array.isArray(y) || ArrayBuffer.isView(y);
    // @ts-expect-error TODO fix
    if (isArrayX && isArrayY && x.length === y.length) {
        // @ts-expect-error TODO fix
        for(let i = 0; i < x.length; ++i){
            if (x[i] !== y[i]) return false;
        }
        return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bZOZc":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Create a WebGL context for a canvas
 * Note calling this multiple time on the same canvas does return the same context
 * @param canvas A canvas element or offscreen canvas
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserContext", ()=>createBrowserContext) /* TODO - can we call this asynchronously to catch the error events?
export async function createBrowserContextAsync(canvas: HTMLCanvasElement | OffscreenCanvas, props: ContextProps): Promise<WebGL2RenderingContext> {
  props = {...DEFAULT_CONTEXT_PROPS, ...props};

 // Try to extract any extra information about why context creation failed
 let errorMessage = null;
 const onCreateError = (error) => (errorMessage = error.statusMessage || errorMessage);
 canvas.addEventListener('webglcontextcreationerror', onCreateError, false);

 const gl = createBrowserContext(canvas, props);

 // Give the listener a chance to fire
 await new Promise(resolve => setTimeout(resolve, 0));

 canvas.removeEventListener('webglcontextcreationerror', onCreateError, false);

 return gl;
}
*/ ;
function createBrowserContext(canvas, props, webglContextAttributes) {
    // Try to extract any extra information about why context creation failed
    let errorMessage = '';
    // const onCreateError = error => (errorMessage = error.statusMessage || errorMessage);
    // Avoid multiple listeners?
    // canvas.removeEventListener('webglcontextcreationerror', onCreateError, false);
    // canvas.addEventListener('webglcontextcreationerror', onCreateError, false);
    const webglProps = {
        preserveDrawingBuffer: true,
        // failIfMajorPerformanceCaveat: true,
        ...webglContextAttributes
    };
    // Create the desired context
    let gl = null;
    // Create a webgl2 context
    gl ||= canvas.getContext('webgl2', webglProps);
    if (webglProps.failIfMajorPerformanceCaveat) errorMessage ||= 'Only software GPU is available. Set `failIfMajorPerformanceCaveat: false` to allow.';
    // Creation failed with failIfMajorPerformanceCaveat - Try a Software GPU
    if (!gl && !webglContextAttributes.failIfMajorPerformanceCaveat) {
        webglProps.failIfMajorPerformanceCaveat = false;
        gl = canvas.getContext('webgl2', webglProps);
        // @ts-expect-error
        gl.luma ||= {};
        // @ts-expect-error
        gl.luma.softwareRenderer = true;
    }
    if (!gl) {
        gl = canvas.getContext('webgl', {});
        if (gl) {
            gl = null;
            errorMessage ||= 'Your browser only supports WebGL1';
        }
    }
    if (!gl) {
        errorMessage ||= 'Your browser does not support WebGL';
        throw new Error(`Failed to create WebGL context: ${errorMessage}`);
    }
    // Carefully extract and wrap callbacks to prevent addEventListener from rebinding them.
    const { onContextLost, onContextRestored } = props;
    canvas.addEventListener('webglcontextlost', (event)=>onContextLost(event), false);
    canvas.addEventListener('webglcontextrestored', (event)=>onContextRestored(event), false);
    // @ts-expect-error
    gl.luma ||= {};
    return gl;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fafZ5":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @returns strings identifying the GPU vendor and driver. */ parcelHelpers.export(exports, "getDeviceInfo", ()=>getDeviceInfo);
var _constants = require("@luma.gl/constants");
var _webglExtensionsJs = require("../../context/helpers/webgl-extensions.js");
function getDeviceInfo(gl, extensions) {
    // "Masked" info is always available, but don't contain much useful information
    const vendorMasked = gl.getParameter(7936);
    const rendererMasked = gl.getParameter(7937);
    // If we are lucky, unmasked info is available
    // https://www.khronos.org/registry/webgl/extensions/WEBGL_debug_renderer_info/
    (0, _webglExtensionsJs.getWebGLExtension)(gl, 'WEBGL_debug_renderer_info', extensions);
    const ext = extensions.WEBGL_debug_renderer_info;
    const vendorUnmasked = gl.getParameter(ext ? ext.UNMASKED_VENDOR_WEBGL : 7936);
    const rendererUnmasked = gl.getParameter(ext ? ext.UNMASKED_RENDERER_WEBGL : 7937);
    const vendor = vendorUnmasked || vendorMasked;
    const renderer = rendererUnmasked || rendererMasked;
    // Driver version
    const version = gl.getParameter(7938);
    // "Sniff" the GPU type and backend from the info. This works best if unmasked info is available.
    const gpu = identifyGPUVendor(vendor, renderer);
    const gpuBackend = identifyGPUBackend(vendor, renderer);
    const gpuType = identifyGPUType(vendor, renderer);
    // Determine GLSL version
    // For now, skip parsing of the long version string, just use context type below to deduce version
    // const version = gl.getParameter(GL.SHADING_LANGUAGE_VERSION) as string;
    // const shadingLanguageVersion = parseGLSLVersion(version);
    const shadingLanguage = 'glsl';
    const shadingLanguageVersion = 300;
    return {
        type: 'webgl',
        gpu,
        gpuType,
        gpuBackend,
        vendor,
        renderer,
        version,
        shadingLanguage,
        shadingLanguageVersion
    };
}
/** "Sniff" the GPU type from the info. This works best if unmasked info is available. */ function identifyGPUVendor(vendor, renderer) {
    if (/NVIDIA/i.exec(vendor) || /NVIDIA/i.exec(renderer)) return 'nvidia';
    if (/INTEL/i.exec(vendor) || /INTEL/i.exec(renderer)) return 'intel';
    if (/Apple/i.exec(vendor) || /Apple/i.exec(renderer)) return 'apple';
    if (/AMD/i.exec(vendor) || /AMD/i.exec(renderer) || /ATI/i.exec(vendor) || /ATI/i.exec(renderer)) return 'amd';
    if (/SwiftShader/i.exec(vendor) || /SwiftShader/i.exec(renderer)) return 'software';
    return 'unknown';
}
/** "Sniff" the GPU backend from the info. This works best if unmasked info is available. */ function identifyGPUBackend(vendor, renderer) {
    if (/Metal/i.exec(vendor) || /Metal/i.exec(renderer)) return 'metal';
    if (/ANGLE/i.exec(vendor) || /ANGLE/i.exec(renderer)) return 'opengl';
    return 'unknown';
}
function identifyGPUType(vendor, renderer) {
    if (/SwiftShader/i.exec(vendor) || /SwiftShader/i.exec(renderer)) return 'cpu';
    const gpuVendor = identifyGPUVendor(vendor, renderer);
    switch(gpuVendor){
        case 'intel':
            return 'integrated';
        case 'software':
            return 'cpu';
        case 'unknown':
            return 'unknown';
        default:
            return 'discrete';
    }
}

},{"@luma.gl/constants":"9mN7r","../../context/helpers/webgl-extensions.js":"1LAmB","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1LAmB":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Ensure extensions are only requested once */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWebGLExtension", ()=>getWebGLExtension);
function getWebGLExtension(gl, name, extensions) {
    if (extensions[name] === undefined) extensions[name] = gl.getExtension(name) || null;
    return extensions[name];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3RHfb":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Feature detection for WebGL
// Provides a function that enables simple checking of which WebGL features are
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * WebGL extensions exposed as luma.gl features
 * To minimize GL log noise and improve performance, this class ensures that
 * - WebGL extensions are not queried until the corresponding feature is checked.
 * - WebGL extensions are only queried once.
 */ parcelHelpers.export(exports, "WebGLDeviceFeatures", ()=>WebGLDeviceFeatures);
var _core = require("@luma.gl/core");
var _webglExtensionsJs = require("../../context/helpers/webgl-extensions.js");
var _webglTextureTableJs = require("../converters/webgl-texture-table.js");
/**
 * Defines luma.gl "feature" names and semantics
 * when value is 'string' it is the name of the extension that enables this feature
 */ const WEBGL_FEATURES = {
    // optional WebGPU features
    'depth-clip-control': 'EXT_depth_clamp',
    // 'timestamp-query' // GPUQueryType "timestamp-query"
    // "indirect-first-instance"
    // Textures are handled by getTextureFeatures()
    // 'depth32float-stencil8' // GPUTextureFormat 'depth32float-stencil8'
    // optional WebGL features
    'timer-query-webgl': 'EXT_disjoint_timer_query_webgl2',
    'compilation-status-async-webgl': 'KHR_parallel_shader_compile',
    'polygon-mode-webgl': 'WEBGL_polygon_mode',
    'provoking-vertex-webgl': 'WEBGL_provoking_vertex',
    'shader-clip-cull-distance-webgl': 'WEBGL_clip_cull_distance',
    'shader-noperspective-interpolation-webgl': 'NV_shader_noperspective_interpolation',
    'shader-conservative-depth-webgl': 'EXT_conservative_depth'
};
class WebGLDeviceFeatures extends (0, _core.DeviceFeatures) {
    gl;
    extensions;
    testedFeatures = new Set();
    constructor(gl, extensions, disabledFeatures){
        super([], disabledFeatures);
        this.gl = gl;
        this.extensions = extensions;
        // TODO - is this really needed?
        // Enable EXT_float_blend first: https://developer.mozilla.org/en-US/docs/Web/API/EXT_float_blend
        (0, _webglExtensionsJs.getWebGLExtension)(gl, 'EXT_color_buffer_float', extensions);
    }
    *[Symbol.iterator]() {
        const features = this.getFeatures();
        for (const feature of features)if (this.has(feature)) yield feature;
        return [];
    }
    has(feature) {
        if (this.disabledFeatures?.[feature]) return false;
        // We have already tested this feature
        if (!this.testedFeatures.has(feature)) {
            this.testedFeatures.add(feature);
            // Check the feature once
            if ((0, _webglTextureTableJs.isTextureFeature)(feature) && (0, _webglTextureTableJs.checkTextureFeature)(this.gl, feature, this.extensions)) this.features.add(feature);
            if (this.getWebGLFeature(feature)) this.features.add(feature);
        }
        return this.features.has(feature);
    }
    // FOR DEVICE
    initializeFeatures() {
        // Initialize all features by checking them.
        // Except WEBGL_polygon_mode since Chrome logs ugly console warnings
        const features = this.getFeatures().filter((feature)=>feature !== 'polygon-mode-webgl');
        for (const feature of features)this.has(feature);
    }
    // IMPLEMENTATION
    getFeatures() {
        return [
            ...Object.keys(WEBGL_FEATURES),
            ...Object.keys((0, _webglTextureTableJs.TEXTURE_FEATURES))
        ];
    }
    /** Extract all WebGL features */ getWebGLFeature(feature) {
        const featureInfo = WEBGL_FEATURES[feature];
        // string value requires checking the corresponding WebGL extension
        const isSupported = typeof featureInfo === 'string' ? Boolean((0, _webglExtensionsJs.getWebGLExtension)(this.gl, featureInfo, this.extensions)) : Boolean(featureInfo);
        return isSupported;
    }
}

},{"@luma.gl/core":"7TxCR","../../context/helpers/webgl-extensions.js":"1LAmB","../converters/webgl-texture-table.js":"4LosF","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4LosF":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TEXTURE_FEATURES", ()=>TEXTURE_FEATURES);
parcelHelpers.export(exports, "isTextureFeature", ()=>isTextureFeature);
/** Checks a texture feature (for Device.features). Mainly compressed texture support */ parcelHelpers.export(exports, "checkTextureFeature", ()=>checkTextureFeature);
parcelHelpers.export(exports, "WEBGL_TEXTURE_FORMATS", ()=>WEBGL_TEXTURE_FORMATS);
// FUNCTIONS
/** Checks if a texture format is supported */ parcelHelpers.export(exports, "isWebGLTextureFormatCapabilitiesed", ()=>isWebGLTextureFormatCapabilitiesed);
/** Checks if a texture format is supported, renderable, filterable etc */ parcelHelpers.export(exports, "getTextureFormatCapabilitiesWebGL", ()=>getTextureFormatCapabilitiesWebGL);
/** Get parameters necessary to work with format in WebGL: internalFormat, dataFormat, type, compressed, */ parcelHelpers.export(exports, "getTextureFormatWebGL", ()=>getTextureFormatWebGL);
parcelHelpers.export(exports, "getDepthStencilAttachmentWebGL", ()=>getDepthStencilAttachmentWebGL);
/** TODO - VERY roundabout legacy way of calculating bytes per pixel */ parcelHelpers.export(exports, "getTextureFormatBytesPerPixel", ()=>getTextureFormatBytesPerPixel);
// DATA TYPE HELPERS
parcelHelpers.export(exports, "getWebGLPixelDataFormat", ()=>getWebGLPixelDataFormat);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _webglExtensionsJs = require("../../context/helpers/webgl-extensions.js");
var _vertexFormatsJs = require("./vertex-formats.js");
/* eslint-disable camelcase */ // TEXTURE FEATURES
// Define local webgl extension strings to optimize minification
const X_S3TC = 'WEBGL_compressed_texture_s3tc'; // BC1, BC2, BC3
const X_S3TC_SRGB = 'WEBGL_compressed_texture_s3tc_srgb'; // BC1, BC2, BC3
const X_RGTC = 'EXT_texture_compression_rgtc'; // BC4, BC5
const X_BPTC = 'EXT_texture_compression_bptc'; // BC6, BC7
const X_ETC2 = 'WEBGL_compressed_texture_etc'; // Renamed from 'WEBGL_compressed_texture_es3'
const X_ASTC = 'WEBGL_compressed_texture_astc';
const X_ETC1 = 'WEBGL_compressed_texture_etc1';
const X_PVRTC = 'WEBGL_compressed_texture_pvrtc';
const X_ATC = 'WEBGL_compressed_texture_atc';
// Define local webgl extension strings to optimize minification
const EXT_texture_norm16 = 'EXT_texture_norm16';
const EXT_render_snorm = 'EXT_render_snorm';
const EXT_color_buffer_float = 'EXT_color_buffer_float';
const TEXTURE_FEATURES = {
    'float32-renderable-webgl': [
        'EXT_color_buffer_float'
    ],
    'float16-renderable-webgl': [
        'EXT_color_buffer_half_float'
    ],
    'rgb9e5ufloat-renderable-webgl': [
        'WEBGL_render_shared_exponent'
    ],
    'snorm8-renderable-webgl': [
        EXT_render_snorm
    ],
    'norm16-renderable-webgl': [
        EXT_texture_norm16
    ],
    'snorm16-renderable-webgl': [
        EXT_texture_norm16,
        EXT_render_snorm
    ],
    'float32-filterable': [
        'OES_texture_float_linear'
    ],
    'float16-filterable-webgl': [
        'OES_texture_half_float_linear'
    ],
    'texture-filterable-anisotropic-webgl': [
        'EXT_texture_filter_anisotropic'
    ],
    'texture-blend-float-webgl': [
        'EXT_float_blend'
    ],
    'texture-compression-bc': [
        X_S3TC,
        X_S3TC_SRGB,
        X_RGTC,
        X_BPTC
    ],
    // 'texture-compression-bc3-srgb-webgl': [X_S3TC_SRGB],
    // 'texture-compression-bc3-webgl': [X_S3TC],
    'texture-compression-bc5-webgl': [
        X_RGTC
    ],
    'texture-compression-bc7-webgl': [
        X_BPTC
    ],
    'texture-compression-etc2': [
        X_ETC2
    ],
    'texture-compression-astc': [
        X_ASTC
    ],
    'texture-compression-etc1-webgl': [
        X_ETC1
    ],
    'texture-compression-pvrtc-webgl': [
        X_PVRTC
    ],
    'texture-compression-atc-webgl': [
        X_ATC
    ]
};
function isTextureFeature(feature) {
    return feature in TEXTURE_FEATURES;
}
function checkTextureFeature(gl, feature, extensions) {
    const textureExtensions = TEXTURE_FEATURES[feature] || [];
    return textureExtensions.every((extension)=>(0, _webglExtensionsJs.getWebGLExtension)(gl, extension, extensions));
}
const WEBGL_TEXTURE_FORMATS = {
    // 8-bit formats
    'r8unorm': {
        gl: 33321,
        rb: true
    },
    'r8snorm': {
        gl: 36756
    },
    'r8uint': {
        gl: 33330,
        rb: true
    },
    'r8sint': {
        gl: 33329,
        rb: true
    },
    // 16-bit formats
    'rg8unorm': {
        gl: 33323,
        rb: true
    },
    'rg8snorm': {
        gl: 36757
    },
    'rg8uint': {
        gl: 33336,
        rb: true
    },
    'rg8sint': {
        gl: 33335,
        rb: true
    },
    'r16uint': {
        gl: 33332,
        rb: true
    },
    'r16sint': {
        gl: 33331,
        rb: true
    },
    'r16float': {
        gl: 33325,
        rb: true
    },
    'r16unorm-webgl': {
        gl: 33322,
        rb: true
    },
    'r16snorm-webgl': {
        gl: 36760
    },
    // Packed 16-bit formats
    'rgba4unorm-webgl': {
        gl: 32854,
        rb: true
    },
    'rgb565unorm-webgl': {
        gl: 36194,
        rb: true
    },
    'rgb5a1unorm-webgl': {
        gl: 32855,
        rb: true
    },
    // 24-bit formats
    'rgb8unorm-webgl': {
        gl: 32849
    },
    'rgb8snorm-webgl': {
        gl: 36758
    },
    // 32-bit formats  
    'rgba8unorm': {
        gl: 32856
    },
    'rgba8unorm-srgb': {
        gl: 35907
    },
    'rgba8snorm': {
        gl: 36759
    },
    'rgba8uint': {
        gl: 36220
    },
    'rgba8sint': {
        gl: 36238
    },
    // reverse colors, webgpu only
    'bgra8unorm': {},
    'bgra8unorm-srgb': {},
    'rg16uint': {
        gl: 33338
    },
    'rg16sint': {
        gl: 33337
    },
    'rg16float': {
        gl: 33327,
        rb: true
    },
    'rg16unorm-webgl': {
        gl: 33324
    },
    'rg16snorm-webgl': {
        gl: 36761
    },
    'r32uint': {
        gl: 33334,
        rb: true
    },
    'r32sint': {
        gl: 33333,
        rb: true
    },
    'r32float': {
        gl: 33326
    },
    // Packed 32-bit formats
    'rgb9e5ufloat': {
        gl: 35901
    },
    'rg11b10ufloat': {
        gl: 35898,
        rb: true
    },
    'rgb10a2unorm': {
        gl: 32857,
        rb: true
    },
    'rgb10a2uint-webgl': {
        gl: 36975,
        rb: true
    },
    // 48-bit formats
    'rgb16unorm-webgl': {
        gl: 32852
    },
    'rgb16snorm-webgl': {
        gl: 36762
    },
    // 64-bit formats
    'rg32uint': {
        gl: 33340,
        rb: true
    },
    'rg32sint': {
        gl: 33339,
        rb: true
    },
    'rg32float': {
        gl: 33328,
        rb: true
    },
    'rgba16uint': {
        gl: 36214,
        rb: true
    },
    'rgba16sint': {
        gl: 36232,
        rb: true
    },
    'rgba16float': {
        gl: 34842
    },
    'rgba16unorm-webgl': {
        gl: 32859,
        rb: true
    },
    'rgba16snorm-webgl': {
        gl: 36763
    },
    // 96-bit formats (deprecated!)
    'rgb32float-webgl': {
        gl: 34837,
        x: EXT_color_buffer_float,
        dataFormat: 6407,
        types: [
            5126
        ]
    },
    // 128-bit formats
    'rgba32uint': {
        gl: 36208,
        rb: true
    },
    'rgba32sint': {
        gl: 36226,
        rb: true
    },
    'rgba32float': {
        gl: 34836,
        rb: true
    },
    // Depth and stencil formats
    'stencil8': {
        gl: 36168,
        rb: true
    },
    'depth16unorm': {
        gl: 33189,
        dataFormat: 6402,
        types: [
            5123
        ],
        rb: true
    },
    'depth24plus': {
        gl: 33190,
        dataFormat: 6402,
        types: [
            5125
        ]
    },
    'depth32float': {
        gl: 36012,
        dataFormat: 6402,
        types: [
            5126
        ],
        rb: true
    },
    // The depth component of the "depth24plus" and "depth24plus-stencil8" formats may be implemented as either a 24-bit depth value or a "depth32float" value.
    'depth24plus-stencil8': {
        gl: 35056,
        rb: true,
        depthTexture: true,
        dataFormat: 34041,
        types: [
            34042
        ]
    },
    // "depth32float-stencil8" feature - TODO below is render buffer only?
    'depth32float-stencil8': {
        gl: 36013,
        dataFormat: 34041,
        types: [
            36269
        ],
        rb: true
    },
    // BC compressed formats: check device.features.has("texture-compression-bc");
    'bc1-rgb-unorm-webgl': {
        gl: 33776,
        x: X_S3TC
    },
    'bc1-rgb-unorm-srgb-webgl': {
        gl: 35916,
        x: X_S3TC_SRGB
    },
    'bc1-rgba-unorm': {
        gl: 33777,
        x: X_S3TC
    },
    'bc1-rgba-unorm-srgb': {
        gl: 35916,
        x: X_S3TC_SRGB
    },
    'bc2-rgba-unorm': {
        gl: 33778,
        x: X_S3TC
    },
    'bc2-rgba-unorm-srgb': {
        gl: 35918,
        x: X_S3TC_SRGB
    },
    'bc3-rgba-unorm': {
        gl: 33779,
        x: X_S3TC
    },
    'bc3-rgba-unorm-srgb': {
        gl: 35919,
        x: X_S3TC_SRGB
    },
    'bc4-r-unorm': {
        gl: 36283,
        x: X_RGTC
    },
    'bc4-r-snorm': {
        gl: 36284,
        x: X_RGTC
    },
    'bc5-rg-unorm': {
        gl: 36285,
        x: X_RGTC
    },
    'bc5-rg-snorm': {
        gl: 36286,
        x: X_RGTC
    },
    'bc6h-rgb-ufloat': {
        gl: 36495,
        x: X_BPTC
    },
    'bc6h-rgb-float': {
        gl: 36494,
        x: X_BPTC
    },
    'bc7-rgba-unorm': {
        gl: 36492,
        x: X_BPTC
    },
    'bc7-rgba-unorm-srgb': {
        gl: 36493,
        x: X_BPTC
    },
    // WEBGL_compressed_texture_etc: device.features.has("texture-compression-etc2")
    // Note: Supposedly guaranteed availability compressed formats in WebGL2, but through CPU decompression
    'etc2-rgb8unorm': {
        gl: 37492
    },
    'etc2-rgb8unorm-srgb': {
        gl: 37494
    },
    'etc2-rgb8a1unorm': {
        gl: 37496
    },
    'etc2-rgb8a1unorm-srgb': {
        gl: 37497
    },
    'etc2-rgba8unorm': {
        gl: 37493
    },
    'etc2-rgba8unorm-srgb': {
        gl: 37495
    },
    'eac-r11unorm': {
        gl: 37488
    },
    'eac-r11snorm': {
        gl: 37489
    },
    'eac-rg11unorm': {
        gl: 37490
    },
    'eac-rg11snorm': {
        gl: 37491
    },
    // X_ASTC compressed formats: device.features.has("texture-compression-astc")
    'astc-4x4-unorm': {
        gl: 37808
    },
    'astc-4x4-unorm-srgb': {
        gl: 37840
    },
    'astc-5x4-unorm': {
        gl: 37809
    },
    'astc-5x4-unorm-srgb': {
        gl: 37841
    },
    'astc-5x5-unorm': {
        gl: 37810
    },
    'astc-5x5-unorm-srgb': {
        gl: 37842
    },
    'astc-6x5-unorm': {
        gl: 37811
    },
    'astc-6x5-unorm-srgb': {
        gl: 37843
    },
    'astc-6x6-unorm': {
        gl: 37812
    },
    'astc-6x6-unorm-srgb': {
        gl: 37844
    },
    'astc-8x5-unorm': {
        gl: 37813
    },
    'astc-8x5-unorm-srgb': {
        gl: 37845
    },
    'astc-8x6-unorm': {
        gl: 37814
    },
    'astc-8x6-unorm-srgb': {
        gl: 37846
    },
    'astc-8x8-unorm': {
        gl: 37815
    },
    'astc-8x8-unorm-srgb': {
        gl: 37847
    },
    'astc-10x5-unorm': {
        gl: 37819
    },
    'astc-10x5-unorm-srgb': {
        gl: 37851
    },
    'astc-10x6-unorm': {
        gl: 37817
    },
    'astc-10x6-unorm-srgb': {
        gl: 37849
    },
    'astc-10x8-unorm': {
        gl: 37818
    },
    'astc-10x8-unorm-srgb': {
        gl: 37850
    },
    'astc-10x10-unorm': {
        gl: 37819
    },
    'astc-10x10-unorm-srgb': {
        gl: 37851
    },
    'astc-12x10-unorm': {
        gl: 37820
    },
    'astc-12x10-unorm-srgb': {
        gl: 37852
    },
    'astc-12x12-unorm': {
        gl: 37821
    },
    'astc-12x12-unorm-srgb': {
        gl: 37853
    },
    // WEBGL_compressed_texture_pvrtc
    'pvrtc-rgb4unorm-webgl': {
        gl: 35840
    },
    'pvrtc-rgba4unorm-webgl': {
        gl: 35842
    },
    'pvrtc-rbg2unorm-webgl': {
        gl: 35841
    },
    'pvrtc-rgba2unorm-webgl': {
        gl: 35843
    },
    // WEBGL_compressed_texture_etc1
    'etc1-rbg-unorm-webgl': {
        gl: 36196
    },
    // WEBGL_compressed_texture_atc
    'atc-rgb-unorm-webgl': {
        gl: 35986
    },
    'atc-rgba-unorm-webgl': {
        gl: 35986
    },
    'atc-rgbai-unorm-webgl': {
        gl: 34798
    }
};
function isWebGLTextureFormatCapabilitiesed(gl, format, extensions) {
    const webglTextureInfo = WEBGL_TEXTURE_FORMATS[format];
    // Check that we have a GL constant
    if (!webglTextureInfo?.gl) return false;
    // Check extensions
    const extension = webglTextureInfo.x;
    if (extension) return Boolean((0, _webglExtensionsJs.getWebGLExtension)(gl, extension, extensions));
    return true;
}
function getTextureFormatCapabilitiesWebGL(gl, formatSupport, extensions) {
    let supported = formatSupport.create;
    const webglFormatInfo = WEBGL_TEXTURE_FORMATS[formatSupport.format];
    // Support Check that we have a GL constant
    if (webglFormatInfo?.gl === undefined) supported = false;
    if (webglFormatInfo?.x) supported = supported && Boolean((0, _webglExtensionsJs.getWebGLExtension)(gl, webglFormatInfo.x, extensions));
    return {
        format: formatSupport.format,
        // @ts-ignore
        create: supported && formatSupport.create,
        // @ts-ignore
        render: supported && formatSupport.render,
        // @ts-ignore
        filter: supported && formatSupport.filter,
        // @ts-ignore
        blend: supported && formatSupport.blend,
        // @ts-ignore
        store: supported && formatSupport.store
    };
}
function getTextureFormatWebGL(format) {
    const formatData = WEBGL_TEXTURE_FORMATS[format];
    const webglFormat = convertTextureFormatToGL(format);
    const decoded = (0, _core.decodeTextureFormat)(format);
    return {
        internalFormat: webglFormat,
        format: formatData?.dataFormat || getWebGLPixelDataFormat(decoded.channels, decoded.integer, decoded.normalized, webglFormat),
        // depth formats don't have a type
        type: decoded.dataType ? (0, _vertexFormatsJs.getGLFromVertexType)(decoded.dataType) : formatData?.types?.[0] || 5121,
        compressed: decoded.compressed || false
    };
}
function getDepthStencilAttachmentWebGL(format) {
    const formatInfo = (0, _core.decodeTextureFormat)(format);
    switch(formatInfo.attachment){
        case 'depth':
            return 36096;
        case 'stencil':
            return 36128;
        case 'depth-stencil':
            return 33306;
        default:
            throw new Error(`Not a depth stencil format: ${format}`);
    }
}
function getTextureFormatBytesPerPixel(format) {
    const formatInfo = (0, _core.decodeTextureFormat)(format);
    return formatInfo.bytesPerPixel;
}
function getWebGLPixelDataFormat(channels, integer, normalized, format) {
    // WebGL1 formats use same internalFormat
    if (format === 6408 || format === 6407) return format;
    // prettier-ignore
    switch(channels){
        case 'r':
            return integer && !normalized ? 36244 : 6403;
        case 'rg':
            return integer && !normalized ? 33320 : 33319;
        case 'rgb':
            return integer && !normalized ? 36248 : 6407;
        case 'rgba':
            return integer && !normalized ? 36249 : 6408;
        case 'bgra':
            throw new Error('bgra pixels not supported by WebGL');
        default:
            return 6408;
    }
}
/**
 * Map WebGPU style texture format strings to GL constants
 */ function convertTextureFormatToGL(format) {
    const formatInfo = WEBGL_TEXTURE_FORMATS[format];
    const webglFormat = formatInfo?.gl;
    if (webglFormat === undefined) throw new Error(`Unsupported texture format ${format}`);
    return webglFormat;
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../../context/helpers/webgl-extensions.js":"1LAmB","./vertex-formats.js":"eyjBq","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eyjBq":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Get vertex format from GL constants */ parcelHelpers.export(exports, "getVertexFormatFromGL", ()=>getVertexFormatFromGL);
/** Get data type from GL constants */ parcelHelpers.export(exports, "getVertexTypeFromGL", ()=>getVertexTypeFromGL);
parcelHelpers.export(exports, "getGLFromVertexType", ()=>getGLFromVertexType);
var _constants = require("@luma.gl/constants");
function getVertexFormatFromGL(type, components) {
    const base = getVertexTypeFromGL(type);
    // prettier-ignore
    switch(components){
        // @ts-expect-error TODO deal with lack of formats
        case 1:
            return base;
        case 2:
            return `${base}x2`;
        // @ts-expect-error TODO deal with lack of formats
        case 3:
            return `${base}x3`;
        case 4:
            return `${base}x4`;
    }
    // @ts-ignore unreachable
    throw new Error(String(components));
}
function getVertexTypeFromGL(type, normalized = false) {
    // prettier-ignore
    switch(type){
        // WebGPU does not support normalized 32 bit integer attributes
        case 5124:
            return normalized ? 'sint32' : 'sint32';
        case 5125:
            return normalized ? 'uint32' : 'uint32';
        case 5122:
            return normalized ? 'sint16' : 'unorm16';
        case 5123:
            return normalized ? 'uint16' : 'unorm16';
        case 5120:
            return normalized ? 'sint8' : 'snorm16';
        case 5121:
            return normalized ? 'uint8' : 'unorm8';
        case 5126:
            return 'float32';
        case 5131:
            return 'float16';
    }
    // @ts-ignore unreachable
    throw new Error(String(type));
}
function getGLFromVertexType(dataType) {
    // prettier-ignore
    switch(dataType){
        case 'uint8':
            return 5121;
        case 'sint8':
            return 5120;
        case 'unorm8':
            return 5121;
        case 'snorm8':
            return 5120;
        case 'uint16':
            return 5123;
        case 'sint16':
            return 5122;
        case 'unorm16':
            return 5123;
        case 'snorm16':
            return 5122;
        case 'uint32':
            return 5125;
        case 'sint32':
            return 5124;
        // WebGPU does not support normalized 32 bit integer attributes
        // case 'unorm32': return GL.UNSIGNED_INT;
        // case 'snorm32': return GL.INT;
        case 'float16':
            return 5131;
        case 'float32':
            return 5126;
    }
    // @ts-ignore unreachable
    throw new Error(String(dataType));
}

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bR8yi":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// prettier-ignore
parcelHelpers.export(exports, "WebGLDeviceLimits", ()=>WebGLDeviceLimits);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
class WebGLDeviceLimits extends (0, _core.DeviceLimits) {
    get maxTextureDimension1D() {
        return 0;
    }
    get maxTextureDimension2D() {
        return this.getParameter(3379);
    }
    get maxTextureDimension3D() {
        return this.getParameter(32883);
    }
    get maxTextureArrayLayers() {
        return this.getParameter(35071);
    }
    get maxBindGroups() {
        return 0;
    }
    get maxDynamicUniformBuffersPerPipelineLayout() {
        return 0;
    }
    get maxDynamicStorageBuffersPerPipelineLayout() {
        return 0;
    }
    get maxSampledTexturesPerShaderStage() {
        return this.getParameter(35660);
    }
    get maxSamplersPerShaderStage() {
        return this.getParameter(35661);
    }
    get maxStorageBuffersPerShaderStage() {
        return 0;
    }
    get maxStorageTexturesPerShaderStage() {
        return 0;
    }
    get maxUniformBuffersPerShaderStage() {
        return this.getParameter(35375);
    }
    get maxUniformBufferBindingSize() {
        return this.getParameter(35376);
    }
    get maxStorageBufferBindingSize() {
        return 0;
    }
    get minUniformBufferOffsetAlignment() {
        return this.getParameter(35380);
    }
    get minStorageBufferOffsetAlignment() {
        return 0;
    }
    get maxVertexBuffers() {
        return 16;
    }
    get maxVertexAttributes() {
        return this.getParameter(34921);
    }
    get maxVertexBufferArrayStride() {
        return 2048;
    }
    get maxInterStageShaderComponents() {
        return this.getParameter(35659);
    }
    get maxComputeWorkgroupStorageSize() {
        return 0;
    }
    get maxComputeInvocationsPerWorkgroup() {
        return 0;
    }
    get maxComputeWorkgroupSizeX() {
        return 0;
    }
    get maxComputeWorkgroupSizeY() {
        return 0;
    }
    get maxComputeWorkgroupSizeZ() {
        return 0;
    }
    get maxComputeWorkgroupsPerDimension() {
        return 0;
    }
    // PRIVATE
    gl;
    limits = {};
    constructor(gl){
        super();
        this.gl = gl;
    }
    getParameter(parameter) {
        if (this.limits[parameter] === undefined) this.limits[parameter] = this.gl.getParameter(parameter);
        return this.limits[parameter] || 0;
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3gJwb":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A WebGL Canvas Context which manages the canvas and handles drawing buffer resizing etc
 */ parcelHelpers.export(exports, "WebGLCanvasContext", ()=>WebGLCanvasContext);
var _core = require("@luma.gl/core");
var _webglFramebufferJs = require("./resources/webgl-framebuffer.js");
class WebGLCanvasContext extends (0, _core.CanvasContext) {
    device;
    format = 'rgba8unorm';
    depthStencilFormat = 'depth24plus';
    presentationSize;
    _framebuffer = null;
    get [Symbol.toStringTag]() {
        return 'WebGLCanvasContext';
    }
    constructor(device, props){
        // Note: Base class creates / looks up the canvas (unless under Node.js)
        super(props);
        this.device = device;
        this.presentationSize = [
            -1,
            -1
        ];
        this._setAutoCreatedCanvasId(`${this.device.id}-canvas`);
        this.update();
    }
    getCurrentFramebuffer() {
        this.update();
        // Setting handle to null returns a reference to the default framebuffer
        this._framebuffer = this._framebuffer || new (0, _webglFramebufferJs.WEBGLFramebuffer)(this.device, {
            handle: null
        });
        return this._framebuffer;
    }
    /** Resizes and updates render targets if necessary */ update() {
        const size = this.getPixelSize();
        const sizeChanged = size[0] !== this.presentationSize[0] || size[1] !== this.presentationSize[1];
        if (sizeChanged) {
            this.presentationSize = size;
            this.resize();
        }
    }
    /**
     * Resize the canvas' drawing buffer.
     *
     * Can match the canvas CSS size, and optionally also consider devicePixelRatio
     * Can be called every frame
     *
     * Regardless of size, the drawing buffer will always be scaled to the viewport, but
     * for best visual results, usually set to either:
     *  canvas CSS width x canvas CSS height
     *  canvas CSS width * devicePixelRatio x canvas CSS height * devicePixelRatio
     * See http://webgl2fundamentals.org/webgl/lessons/webgl-resizing-the-canvas.html
     */ resize(options) {
        if (!this.device.gl) return;
        // Resize browser context .
        if (this.canvas) {
            const devicePixelRatio = this.getDevicePixelRatio(options?.useDevicePixels);
            this.setDevicePixelRatio(devicePixelRatio, options);
            return;
        }
    }
    commit() {
    // gl.commit was ultimately removed from the WebGL standard??
    // if (this.offScreen && this.gl.commit) {
    //   // @ts-expect-error gl.commit is not officially part of WebGL2RenderingContext
    //   this.gl.commit();
    // }
    }
}

},{"@luma.gl/core":"7TxCR","./resources/webgl-framebuffer.js":"bYeR6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bYeR6":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** luma.gl Framebuffer, WebGL implementation  */ parcelHelpers.export(exports, "WEBGLFramebuffer", ()=>WEBGLFramebuffer);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _webglTextureTableJs = require("../converters/webgl-texture-table.js");
class WEBGLFramebuffer extends (0, _core.Framebuffer) {
    device;
    gl;
    handle;
    colorAttachments = [];
    depthStencilAttachment = null;
    constructor(device, props){
        super(device, props);
        // WebGL default framebuffer handle is null
        const isDefaultFramebuffer = props.handle === null;
        this.device = device;
        this.gl = device.gl;
        this.handle = this.props.handle || isDefaultFramebuffer ? this.props.handle : this.gl.createFramebuffer();
        if (!isDefaultFramebuffer) {
            // default framebuffer handle is null, so we can't set spector metadata...
            device.setSpectorMetadata(this.handle, {
                id: this.props.id,
                props: this.props
            });
            // Auto create textures for attachments if needed
            this.autoCreateAttachmentTextures();
            this.updateAttachments();
        }
    }
    /** destroys any auto created resources etc. */ destroy() {
        super.destroy(); // destroys owned resources etc.
        if (!this.destroyed && this.handle !== null) this.gl.deleteFramebuffer(this.handle);
    }
    updateAttachments() {
        /** Attach from a map of attachments */ // @ts-expect-error native bindFramebuffer is overridden by our state tracker
        const prevHandle = this.gl.bindFramebuffer(36160, this.handle);
        // Walk the attachments
        for(let i = 0; i < this.colorAttachments.length; ++i){
            const attachment = this.colorAttachments[i];
            if (attachment) {
                const attachmentPoint = 36064 + i;
                this._attachTextureView(attachmentPoint, attachment);
            }
        }
        if (this.depthStencilAttachment) {
            const attachmentPoint = (0, _webglTextureTableJs.getDepthStencilAttachmentWebGL)(this.depthStencilAttachment.props.format);
            this._attachTextureView(attachmentPoint, this.depthStencilAttachment);
        }
        /** Check the status */ if (this.device.props.debug) {
            const status = this.gl.checkFramebufferStatus(36160);
            if (status !== 36053) throw new Error(`Framebuffer ${_getFrameBufferStatus(status)}`);
        }
        this.gl.bindFramebuffer(36160, prevHandle);
    }
    // PRIVATE
    /** In WebGL we must use renderbuffers for depth/stencil attachments (unless we have extensions) */ // protected override createDepthStencilTexture(format: TextureFormat): Texture {
    //   // return new WEBGLRenderbuffer(this.device, {
    //   return new WEBGLTexture(this.device, {
    //     id: `${this.id}-depth-stencil`,
    //     format,
    //     width: this.width,
    //     height: this.height,
    //     mipmaps: false
    //   });
    // }
    /**
     * @param attachment
     * @param texture
     * @param layer = 0 - index into WEBGLTextureArray and Texture3D or face for `TextureCubeMap`
     * @param level = 0 - mipmapLevel
     */ _attachTextureView(attachment, textureView) {
        const { gl } = this.device;
        const { texture } = textureView;
        const level = textureView.props.baseMipLevel;
        const layer = textureView.props.baseArrayLayer;
        gl.bindTexture(texture.glTarget, texture.handle);
        switch(texture.glTarget){
            case 35866:
            case 32879:
                gl.framebufferTextureLayer(36160, attachment, texture.handle, level, layer);
                break;
            case 34067:
                // layer must be a cubemap face (or if index, converted to cube map face)
                const face = mapIndexToCubeMapFace(layer);
                gl.framebufferTexture2D(36160, attachment, face, texture.handle, level);
                break;
            case 3553:
                gl.framebufferTexture2D(36160, attachment, 3553, texture.handle, level);
                break;
            default:
                throw new Error('Illegal texture type');
        }
        gl.bindTexture(texture.glTarget, null);
    }
}
// Helper functions
// Map an index to a cube map face constant
function mapIndexToCubeMapFace(layer) {
    // TEXTURE_CUBE_MAP_POSITIVE_X is a big value (0x8515)
    // if smaller assume layer is index, otherwise assume it is already a cube map face constant
    return layer < 34069 ? layer + 34069 : layer;
}
// Helper METHODS
// Get a string describing the framebuffer error if installed
function _getFrameBufferStatus(status) {
    switch(status){
        case 36053:
            return 'success';
        case 36054:
            return 'Mismatched attachments';
        case 36055:
            return 'No attachments';
        case 36057:
            return 'Height/width mismatch';
        case 36061:
            return 'Unsupported or split attachments';
        // WebGL2
        case 36182:
            return 'Samples mismatch';
        // OVR_multiview2 extension
        // case GL.FRAMEBUFFER_INCOMPLETE_VIEW_TARGETS_OVR: return 'baseViewIndex mismatch';
        default:
            return `${status}`;
    }
} /**
 * Attachment resize is expected to be a noop if size is same
 *
protected override resizeAttachments(width: number, height: number): this {
  // for default framebuffer, just update the stored size
  if (this.handle === null) {
    // assert(width === undefined && height === undefined);
    this.width = this.gl.drawingBufferWidth;
    this.height = this.gl.drawingBufferHeight;
    return this;
  }

  if (width === undefined) {
    width = this.gl.drawingBufferWidth;
  }
  if (height === undefined) {
    height = this.gl.drawingBufferHeight;
  }

  // TODO Not clear that this is better than default destroy/create implementation

  for (const colorAttachment of this.colorAttachments) {
    colorAttachment.texture.clone({width, height});
  }
  if (this.depthStencilAttachment) {
    this.depthStencilAttachment.texture.resize({width, height});
  }
  return this;
}
*/ 

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../converters/webgl-texture-table.js":"4LosF","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9oiSc":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SPECTOR_PROPS", ()=>DEFAULT_SPECTOR_PROPS);
/** Loads spector from CDN if not already installed */ parcelHelpers.export(exports, "loadSpectorJS", ()=>loadSpectorJS);
parcelHelpers.export(exports, "initializeSpectorJS", ()=>initializeSpectorJS);
var _core = require("@luma.gl/core");
var _loadScriptJs = require("../../utils/load-script.js");
const LOG_LEVEL = 1;
let spector = null;
let initialized = false;
const DEFAULT_SPECTOR_PROPS = {
    debugSpectorJS: (0, _core.log).get('debug-spectorjs'),
    // https://github.com/BabylonJS/Spector.js#basic-usage
    // https://forum.babylonjs.com/t/spectorcdn-is-temporarily-off/48241
    // spectorUrl: 'https://spectorcdn.babylonjs.com/spector.bundle.js';
    debugSpectorJSUrl: 'https://cdn.jsdelivr.net/npm/spectorjs@0.9.30/dist/spector.bundle.js',
    gl: undefined
};
async function loadSpectorJS(props) {
    if (!globalThis.SPECTOR) try {
        await (0, _loadScriptJs.loadScript)(props.debugSpectorJSUrl || DEFAULT_SPECTOR_PROPS.debugSpectorJSUrl);
    } catch (error) {
        (0, _core.log).warn(String(error));
    }
}
function initializeSpectorJS(props) {
    props = {
        ...DEFAULT_SPECTOR_PROPS,
        ...props
    };
    if (!props.debugSpectorJS) return null;
    if (!spector && globalThis.SPECTOR && !globalThis.luma?.spector) {
        (0, _core.log).probe(LOG_LEVEL, 'SPECTOR found and initialized. Start with `luma.spector.displayUI()`')();
        const { Spector: SpectorJS } = globalThis.SPECTOR;
        spector = new SpectorJS();
        if (globalThis.luma) globalThis.luma.spector = spector;
    }
    if (!spector) return null;
    if (!initialized) {
        initialized = true;
        // enables recording some extra information merged in the capture like texture memory sizes and formats
        spector.spyCanvases();
        // A callback when results are ready
        spector?.onCaptureStarted.add((capture)=>(0, _core.log).info('Spector capture started:', capture)());
        spector?.onCapture.add((capture)=>{
            (0, _core.log).info('Spector capture complete:', capture)();
            // Use undocumented Spector API to open the UI with our capture
            // See https://github.com/BabylonJS/Spector.js/blob/767ad1195a25b85a85c381f400eb50a979239eca/src/spector.ts#L124
            spector?.getResultUI();
            // @ts-expect-error private
            spector?.resultView.display();
            // @ts-expect-error private
            spector?.resultView.addCapture(capture);
        });
    }
    if (props.gl) {
        // capture startup
        const gl = props.gl;
        // @ts-expect-error
        const device = gl.device;
        spector?.startCapture(props.gl, 500); // 500 commands
        // @ts-expect-error
        gl.device = device;
        new Promise((resolve)=>setTimeout(resolve, 2000)).then((_)=>{
            (0, _core.log).info('Spector capture stopped after 2 seconds')();
            spector?.stopCapture();
        // spector?.displayUI();
        });
    }
    return spector;
}

},{"@luma.gl/core":"7TxCR","../../utils/load-script.js":"63azW","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"63azW":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Load a script (identified by an url). When the url returns, the
 * content of this file is added into a new script element, attached to the DOM (body element)
 * @param scriptUrl defines the url of the script to laod
 * @param scriptId defines the id of the script element
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadScript", ()=>loadScript);
async function loadScript(scriptUrl, scriptId) {
    const head = document.getElementsByTagName('head')[0];
    if (!head) throw new Error('loadScript');
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', scriptUrl);
    if (scriptId) script.id = scriptId;
    return new Promise((resolve, reject)=>{
        script.onload = resolve;
        script.onerror = (error)=>reject(new Error(`Unable to load script '${scriptUrl}': ${error}`));
        head.appendChild(script);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5wukC":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Loads Khronos WebGLDeveloperTools from CDN if not already installed
 * const WebGLDebugUtils = require('webgl-debug');
 * @see https://github.com/KhronosGroup/WebGLDeveloperTools
 * @see https://github.com/vorg/webgl-debug
 */ parcelHelpers.export(exports, "loadWebGLDeveloperTools", ()=>loadWebGLDeveloperTools);
// Returns (a potentially new) context with debug instrumentation turned off or on.
// Note that this actually returns a new context
parcelHelpers.export(exports, "makeDebugContext", ()=>makeDebugContext);
var _core = require("@luma.gl/core");
// Rename constant to prevent inlining. We need the full set of constants for generating debug strings.
var _constants = require("@luma.gl/constants");
var _env = require("@probe.gl/env");
var _loadScriptJs = require("../../utils/load-script.js");
const WEBGL_DEBUG_CDN_URL = 'https://unpkg.com/webgl-debug@2.0.1/index.js';
// Helper to get shared context data
function getWebGLContextData(gl) {
    gl.luma = gl.luma || {};
    return gl.luma;
}
async function loadWebGLDeveloperTools() {
    if ((0, _env.isBrowser)() && !globalThis.WebGLDebugUtils) {
        globalThis.global = globalThis.global || globalThis;
        // @ts-expect-error Developer tools expects global to be set
        globalThis.global.module = {};
        await (0, _loadScriptJs.loadScript)(WEBGL_DEBUG_CDN_URL);
    }
}
function makeDebugContext(gl, props = {}) {
    return props.debugWebGL || props.traceWebGL ? getDebugContext(gl, props) : getRealContext(gl);
}
// Returns the real context from either of the real/debug contexts
function getRealContext(gl) {
    const data = getWebGLContextData(gl);
    // If the context has a realContext member, it is a debug context so return the realContext
    return data.realContext ? data.realContext : gl;
}
// Returns the debug context from either of the real/debug contexts
function getDebugContext(gl, props) {
    if (!globalThis.WebGLDebugUtils) {
        (0, _core.log).warn('webgl-debug not loaded')();
        return gl;
    }
    const data = getWebGLContextData(gl);
    // If this already has a debug context, return it.
    if (data.debugContext) return data.debugContext;
    // Create a new debug context
    globalThis.WebGLDebugUtils.init({
        ...(0, _constants.GL),
        ...gl
    });
    const glDebug = globalThis.WebGLDebugUtils.makeDebugContext(gl, onGLError.bind(null, props), onValidateGLFunc.bind(null, props));
    // Make sure we have all WebGL2 and extension constants (todo dynamic import to circumvent minification?)
    for(const key in 0, _constants.GL)if (!(key in glDebug) && typeof (0, _constants.GL)[key] === 'number') glDebug[key] = (0, _constants.GL)[key];
    // Ensure we have a clean prototype on the instrumented object
    // Note: setPrototypeOf does come with perf warnings, but we already take a bigger perf reduction
    // by synchronizing the WebGL errors after each WebGL call.
    class WebGLDebugContext {
    }
    Object.setPrototypeOf(glDebug, Object.getPrototypeOf(gl));
    Object.setPrototypeOf(WebGLDebugContext, glDebug);
    const debugContext = Object.create(WebGLDebugContext);
    // Store the debug context
    data.realContext = gl;
    data.debugContext = debugContext;
    debugContext.debug = true;
    // Return it
    return debugContext;
}
// DEBUG TRACING
function getFunctionString(functionName, functionArgs) {
    // Cover bug in webgl-debug-tools
    functionArgs = Array.from(functionArgs).map((arg)=>arg === undefined ? 'undefined' : arg);
    let args = globalThis.WebGLDebugUtils.glFunctionArgsToString(functionName, functionArgs);
    args = `${args.slice(0, 100)}${args.length > 100 ? '...' : ''}`;
    return `gl.${functionName}(${args})`;
}
function onGLError(props, err, functionName, args) {
    // Cover bug in webgl-debug-tools
    args = Array.from(args).map((arg)=>arg === undefined ? 'undefined' : arg);
    const errorMessage = globalThis.WebGLDebugUtils.glEnumToString(err);
    const functionArgs = globalThis.WebGLDebugUtils.glFunctionArgsToString(functionName, args);
    const message = `${errorMessage} in gl.${functionName}(${functionArgs})`;
    (0, _core.log).error(message)();
    debugger; // eslint-disable-line
// throw new Error(message);
}
// Don't generate function string until it is needed
function onValidateGLFunc(props, functionName, functionArgs) {
    let functionString = '';
    if ((0, _core.log).level >= 1) {
        functionString = getFunctionString(functionName, functionArgs);
        if (props.traceWebGL) (0, _core.log).log(1, functionString)();
    }
    for (const arg of functionArgs)if (arg === undefined) {
        functionString = functionString || getFunctionString(functionName, functionArgs);
        debugger; // eslint-disable-line
    // throw new Error(`Undefined argument: ${functionString}`);
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","@probe.gl/env":"hQL54","../../utils/load-script.js":"63azW","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dOKUn":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a UID.
 * @param id= - Identifier base name
 * @return uid
 **/ parcelHelpers.export(exports, "uid", ()=>uid);
const uidCounters = {};
function uid(id = 'id') {
    uidCounters[id] = uidCounters[id] || 1;
    const count = uidCounters[id]++;
    return `${id}-${count}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fIu5h":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** WebGL Buffer interface */ parcelHelpers.export(exports, "WEBGLBuffer", ()=>WEBGLBuffer);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
class WEBGLBuffer extends (0, _core.Buffer) {
    device;
    gl;
    handle;
    /** Target in OpenGL defines the type of buffer */ glTarget;
    /** Usage is a hint on how frequently the buffer will be updates */ glUsage;
    /** Index type is needed when issuing draw calls, so we pre-compute it */ glIndexType = 5123;
    /** Number of bytes allocated on the GPU for this buffer */ byteLength;
    /** Number of bytes used */ bytesUsed;
    constructor(device, props = {}){
        super(device, props);
        this.device = device;
        this.gl = this.device.gl;
        const handle = typeof props === 'object' ? props.handle : undefined;
        this.handle = handle || this.gl.createBuffer();
        device.setSpectorMetadata(this.handle, {
            ...this.props,
            data: typeof this.props.data
        });
        // - In WebGL1, need to make sure we use GL.ELEMENT_ARRAY_BUFFER when initializing element buffers
        //   otherwise buffer type will lock to generic (non-element) buffer
        // - In WebGL2, we can use GL.COPY_READ_BUFFER which avoids locking the type here
        this.glTarget = getWebGLTarget(this.props.usage);
        this.glUsage = getWebGLUsage(this.props.usage);
        this.glIndexType = this.props.indexType === 'uint32' ? 5125 : 5123;
        // Set data: (re)initializes the buffer
        if (props.data) this._initWithData(props.data, props.byteOffset, props.byteLength);
        else this._initWithByteLength(props.byteLength || 0);
    }
    // PRIVATE METHODS
    /** Allocate a new buffer and initialize to contents of typed array */ _initWithData(data, byteOffset = 0, byteLength = data.byteLength + byteOffset) {
        // const glTarget = this.device.isWebGL2 ? GL.COPY_WRITE_BUFFER : this.glTarget;
        const glTarget = this.glTarget;
        this.gl.bindBuffer(glTarget, this.handle);
        this.gl.bufferData(glTarget, byteLength, this.glUsage);
        this.gl.bufferSubData(glTarget, byteOffset, data);
        this.gl.bindBuffer(glTarget, null);
        this.bytesUsed = byteLength;
        this.byteLength = byteLength;
        this._setDebugData(data, byteOffset, byteLength);
        this.trackAllocatedMemory(byteLength);
    }
    // Allocate a GPU buffer of specified size.
    _initWithByteLength(byteLength) {
        // assert(byteLength >= 0);
        // Workaround needed for Safari (#291):
        // gl.bufferData with size equal to 0 crashes. Instead create zero sized array.
        let data = byteLength;
        if (byteLength === 0) // @ts-expect-error
        data = new Float32Array(0);
        // const glTarget = this.device.isWebGL2 ? GL.COPY_WRITE_BUFFER : this.glTarget;
        const glTarget = this.glTarget;
        this.gl.bindBuffer(glTarget, this.handle);
        this.gl.bufferData(glTarget, data, this.glUsage);
        this.gl.bindBuffer(glTarget, null);
        this.bytesUsed = byteLength;
        this.byteLength = byteLength;
        this._setDebugData(null, 0, byteLength);
        this.trackAllocatedMemory(byteLength);
        return this;
    }
    destroy() {
        if (!this.destroyed && this.handle) {
            this.removeStats();
            this.trackDeallocatedMemory();
            this.gl.deleteBuffer(this.handle);
            this.destroyed = true;
            // @ts-expect-error
            this.handle = null;
        }
    }
    write(data, byteOffset = 0) {
        const srcOffset = 0;
        const byteLength = undefined; // data.byteLength;
        // Create the buffer - binding it here for the first time locks the type
        // In WebGL2, use GL.COPY_WRITE_BUFFER to avoid locking the type
        const glTarget = 36663;
        this.gl.bindBuffer(glTarget, this.handle);
        // WebGL2: subData supports additional srcOffset and length parameters
        if (srcOffset !== 0 || byteLength !== undefined) this.gl.bufferSubData(glTarget, byteOffset, data, srcOffset, byteLength);
        else this.gl.bufferSubData(glTarget, byteOffset, data);
        this.gl.bindBuffer(glTarget, null);
        this._setDebugData(data, byteOffset, data.byteLength);
    }
    /** Asynchronously read data from the buffer */ async readAsync(byteOffset = 0, byteLength) {
        return this.readSyncWebGL(byteOffset, byteLength);
    }
    /** Synchronously read data from the buffer. WebGL only. */ readSyncWebGL(byteOffset = 0, byteLength) {
        byteLength = byteLength ?? this.byteLength - byteOffset;
        const data = new Uint8Array(byteLength);
        const dstOffset = 0;
        // Use GL.COPY_READ_BUFFER to avoid disturbing other targets and locking type
        this.gl.bindBuffer(36662, this.handle);
        this.gl.getBufferSubData(36662, byteOffset, data, dstOffset, byteLength);
        this.gl.bindBuffer(36662, null);
        // Update local `data` if offsets are 0
        this._setDebugData(data, byteOffset, byteLength);
        return data;
    }
}
/**
 * Returns a WebGL buffer target
 *
 * @param usage
 * static MAP_READ = 0x01;
 * static MAP_WRITE = 0x02;
 * static COPY_SRC = 0x0004;
 * static COPY_DST = 0x0008;
 * static INDEX = 0x0010;
 * static VERTEX = 0x0020;
 * static UNIFORM = 0x0040;
 * static STORAGE = 0x0080;
 * static INDIRECT = 0x0100;
 * static QUERY_RESOLVE = 0x0200;
 *
 * @returns WebGL buffer targe
 *
 * Buffer bind points in WebGL2
 * gl.COPY_READ_BUFFER: Buffer for copying from one buffer object to another.
 * gl.COPY_WRITE_BUFFER: Buffer for copying from one buffer object to another.
 * gl.TRANSFORM_FEEDBACK_BUFFER: Buffer for transform feedback operations.
 * gl.PIXEL_PACK_BUFFER: Buffer used for pixel transfer operations.
 * gl.PIXEL_UNPACK_BUFFER: Buffer used for pixel transfer operations.
 */ function getWebGLTarget(usage) {
    if (usage & (0, _core.Buffer).INDEX) return 34963;
    if (usage & (0, _core.Buffer).VERTEX) return 34962;
    if (usage & (0, _core.Buffer).UNIFORM) return 35345;
    // Binding a buffer for the first time locks the type
    // In WebGL2, we can use GL.COPY_WRITE_BUFFER to avoid locking the type
    return 34962;
}
/** @todo usage is not passed correctly */ function getWebGLUsage(usage) {
    if (usage & (0, _core.Buffer).INDEX) return 35044;
    if (usage & (0, _core.Buffer).VERTEX) return 35044;
    if (usage & (0, _core.Buffer).UNIFORM) return 35048;
    return 35044;
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6OohC":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An immutable compiled shader program that execute portions of the GPU Pipeline
 */ parcelHelpers.export(exports, "WEBGLShader", ()=>WEBGLShader) // TODO - Original code from luma.gl v8 - keep until new debug functionality has matured
 // if (!compilationSuccess) {
 //   const parsedLog = shaderLog ? parseShaderCompilerLog(shaderLog) : [];
 //   const messages = parsedLog.filter(message => message.type === 'error');
 //   const formattedLog = formatCompilerLog(messages, source, {showSourceCode: 'all', html: true});
 //   const shaderDescription = `${this.stage} shader ${shaderName}`;
 //   log.error(`GLSL compilation errors in ${shaderDescription}\n${formattedLog}`)();
 //   displayShaderLog(parsedLog, source, shaderName);
 // }
;
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _parseShaderCompilerLogJs = require("../helpers/parse-shader-compiler-log.js");
class WEBGLShader extends (0, _core.Shader) {
    device;
    handle;
    constructor(device, props){
        super(device, props);
        this.device = device;
        switch(this.props.stage){
            case 'vertex':
                this.handle = this.props.handle || this.device.gl.createShader(35633);
                break;
            case 'fragment':
                this.handle = this.props.handle || this.device.gl.createShader(35632);
                break;
            default:
                throw new Error(this.props.stage);
        }
        this._compile(this.source);
    }
    destroy() {
        if (this.handle) {
            this.removeStats();
            this.device.gl.deleteShader(this.handle);
            // this.handle = null;
            this.destroyed = true;
        }
    }
    get asyncCompilationStatus() {
        return this._waitForCompilationComplete().then(()=>this.compilationStatus);
    }
    async getCompilationInfo() {
        await this._waitForCompilationComplete();
        return this.getCompilationInfoSync();
    }
    getCompilationInfoSync() {
        const shaderLog = this.device.gl.getShaderInfoLog(this.handle);
        return shaderLog ? (0, _parseShaderCompilerLogJs.parseShaderCompilerLog)(shaderLog) : [];
    }
    getTranslatedSource() {
        const extensions = this.device.getExtension('WEBGL_debug_shaders');
        const ext = extensions.WEBGL_debug_shaders;
        return ext?.getTranslatedShaderSource(this.handle) || null;
    }
    // PRIVATE METHODS
    /** Compile a shader and get compilation status */ async _compile(source) {
        source = source.startsWith('#version ') ? source : `#version 300 es\n${source}`;
        const { gl } = this.device;
        gl.shaderSource(this.handle, source);
        gl.compileShader(this.handle);
        // For performance reasons, avoid checking shader compilation errors on production
        if (!this.device.props.debug) {
            this.compilationStatus = 'pending';
            return;
        }
        // Sync case - slower, but advantage is that it throws in the constructor, making break on error more useful
        if (!this.device.features.has('compilation-status-async-webgl')) {
            this._getCompilationStatus();
            // The `Shader` base class will determine if debug window should be opened based on this.compilationStatus
            this.debugShader();
            if (this.compilationStatus === 'error') throw new Error(`GLSL compilation errors in ${this.props.stage} shader ${this.props.id}`);
            return;
        }
        // async case
        (0, _core.log).once(1, 'Shader compilation is asynchronous')();
        await this._waitForCompilationComplete();
        (0, _core.log).info(2, `Shader ${this.id} - async compilation complete: ${this.compilationStatus}`)();
        this._getCompilationStatus();
        // The `Shader` base class will determine if debug window should be opened based on this.compilationStatus
        this.debugShader();
    }
    /** Use KHR_parallel_shader_compile extension if available */ async _waitForCompilationComplete() {
        const waitMs = async (ms)=>await new Promise((resolve)=>setTimeout(resolve, ms));
        const DELAY_MS = 10; // Shader compilation is typically quite fast (with some exceptions)
        // If status polling is not available, we can't wait for completion. Just wait a little to minimize blocking
        if (!this.device.features.has('compilation-status-async-webgl')) {
            await waitMs(DELAY_MS);
            return;
        }
        const { gl } = this.device;
        for(;;){
            const complete = gl.getShaderParameter(this.handle, 37297);
            if (complete) return;
            await waitMs(DELAY_MS);
        }
    }
    /**
     * Get the shader compilation status
     * TODO - Load log even when no error reported, to catch warnings?
     * https://gamedev.stackexchange.com/questions/30429/how-to-detect-glsl-warnings
     */ _getCompilationStatus() {
        this.compilationStatus = this.device.gl.getShaderParameter(this.handle, 35713) ? 'success' : 'error';
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../helpers/parse-shader-compiler-log.js":"1K2tL","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1K2tL":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Parse a WebGL-format GLSL compilation log into an array of WebGPU style message records.
 * This follows documented WebGL conventions for compilation logs.
 * Based on https://github.com/wwwtyro/gl-format-compiler-error (public domain)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseShaderCompilerLog", ()=>parseShaderCompilerLog);
function parseShaderCompilerLog(errLog) {
    // Parse the error - note: browser and driver dependent
    const lines = errLog.split(/\r?\n/);
    const messages = [];
    for (const line of lines){
        if (line.length <= 1) continue; // eslint-disable-line no-continue
        const segments = line.split(':');
        // Check for messages with no line information `ERROR: unsupported shader version`
        if (segments.length === 2) {
            const [messageType, message] = segments;
            messages.push({
                message: message.trim(),
                type: getMessageType(messageType),
                lineNum: 0,
                linePos: 0
            });
            continue; // eslint-disable-line no-continue
        }
        const [messageType, linePosition, lineNumber, ...rest] = segments;
        let lineNum = parseInt(lineNumber, 10);
        if (isNaN(lineNum)) lineNum = 0;
        let linePos = parseInt(linePosition, 10);
        if (isNaN(linePos)) linePos = 0;
        messages.push({
            message: rest.join(':').trim(),
            type: getMessageType(messageType),
            lineNum,
            linePos
        });
    }
    return messages;
}
/** Ensure supported type */ function getMessageType(messageType) {
    const MESSAGE_TYPES = [
        'warning',
        'error',
        'info'
    ];
    const lowerCaseType = messageType.toLowerCase();
    return MESSAGE_TYPES.includes(lowerCaseType) ? lowerCaseType : 'info';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"e2AQF":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sampler object -
 * so that they can be set directly on the texture
 * https://github.com/WebGLSamples/WebGL2Samples/blob/master/samples/sampler_object.html
 */ parcelHelpers.export(exports, "WEBGLSampler", ()=>WEBGLSampler);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _samplerParametersJs = require("../converters/sampler-parameters.js");
class WEBGLSampler extends (0, _core.Sampler) {
    device;
    handle;
    parameters;
    constructor(device, props){
        super(device, props);
        this.device = device;
        this.parameters = (0, _samplerParametersJs.convertSamplerParametersToWebGL)(props);
        this.handle = this.handle || this.device.gl.createSampler();
        this._setSamplerParameters(this.parameters);
    }
    destroy() {
        if (this.handle) {
            this.device.gl.deleteSampler(this.handle);
            // @ts-expect-error read-only/undefined
            this.handle = undefined;
        }
    }
    toString() {
        return `Sampler(${this.id},${JSON.stringify(this.props)})`;
    }
    /** Set sampler parameters on the sampler */ _setSamplerParameters(parameters) {
        for (const [pname, value] of Object.entries(parameters)){
            // Apparently there are integer/float conversion issues requires two parameter setting functions in JavaScript.
            // For now, pick the float version for parameters specified as GLfloat.
            const param = Number(pname);
            switch(param){
                case 33082:
                case 33083:
                    this.device.gl.samplerParameterf(this.handle, param, value);
                    break;
                default:
                    this.device.gl.samplerParameteri(this.handle, param, value);
                    break;
            }
        }
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../converters/sampler-parameters.js":"62r49","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"62r49":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert WebGPU-style sampler props to WebGL
 * @param props
 * @returns
 */ parcelHelpers.export(exports, "convertSamplerParametersToWebGL", ()=>convertSamplerParametersToWebGL);
var _constants = require("@luma.gl/constants");
var _deviceParametersJs = require("./device-parameters.js");
function convertSamplerParametersToWebGL(props) {
    const params = {};
    if (props.addressModeU) params[10242] = convertAddressMode(props.addressModeU);
    if (props.addressModeV) params[10243] = convertAddressMode(props.addressModeV);
    if (props.addressModeW) params[32882] = convertAddressMode(props.addressModeW);
    if (props.magFilter) params[10240] = convertMaxFilterMode(props.magFilter);
    if (props.minFilter || props.mipmapFilter) // TODO - arbitrary choice of linear?
    params[10241] = convertMinFilterMode(props.minFilter || 'linear', props.mipmapFilter);
    if (props.lodMinClamp !== undefined) params[33082] = props.lodMinClamp;
    if (props.lodMaxClamp !== undefined) params[33083] = props.lodMaxClamp;
    if (props.type === 'comparison-sampler') // Setting prop.compare turns this into a comparison sampler
    params[34892] = 34894;
    if (props.compare) params[34893] = (0, _deviceParametersJs.convertCompareFunction)('compare', props.compare);
    // Note depends on WebGL extension
    if (props.maxAnisotropy) params[34046] = props.maxAnisotropy;
    return params;
}
// HELPERS
/** Convert address more */ function convertAddressMode(addressMode) {
    switch(addressMode){
        case 'clamp-to-edge':
            return 33071;
        case 'repeat':
            return 10497;
        case 'mirror-repeat':
            return 33648;
    }
}
function convertMaxFilterMode(maxFilter) {
    switch(maxFilter){
        case 'nearest':
            return 9728;
        case 'linear':
            return 9729;
    }
}
/**
 * WebGPU has separate min filter and mipmap filter,
 * WebGL is combined and effectively offers 6 options
 */ function convertMinFilterMode(minFilter, mipmapFilter = 'none') {
    if (!mipmapFilter) return convertMaxFilterMode(minFilter);
    switch(mipmapFilter){
        case 'none':
            return convertMaxFilterMode(minFilter);
        case 'nearest':
            return minFilter === 'nearest' ? 9984 : 9986;
        case 'linear':
            return minFilter === 'nearest' ? 9985 : 9987;
    }
}

},{"@luma.gl/constants":"9mN7r","./device-parameters.js":"o0nGc","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"o0nGc":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-unused-expressions */ // For expression ? gl.enable() : gl.disable()
/**
 * Execute a function with a set of temporary WebGL parameter overrides
 * - Saves current "global" WebGL context settings
 * - Sets the supplies WebGL context parameters,
 * - Executes supplied function
 * - Restores parameters
 * - Returns the return value of the supplied function
 */ parcelHelpers.export(exports, "withDeviceAndGLParameters", ()=>withDeviceAndGLParameters);
/**
 * Execute a function with a set of temporary WebGL parameter overrides
 * - Saves current "global" WebGL context settings
 * - Sets the supplies WebGL context parameters,
 * - Executes supplied function
 * - Restores parameters
 * - Returns the return value of the supplied function
 * @deprecated use withDeviceParameters instead
 */ parcelHelpers.export(exports, "withGLParameters", ()=>withGLParameters);
/**
 * Execute a function with a set of temporary WebGL parameter overrides
 * - Saves current "global" WebGL context settings
 * - Sets the supplies WebGL context parameters,
 * - Executes supplied function
 * - Restores parameters
 * - Returns the return value of the supplied function
 */ parcelHelpers.export(exports, "withDeviceParameters", ()=>withDeviceParameters);
/** Set WebGPU Style Parameters */ parcelHelpers.export(exports, "setDeviceParameters", ()=>setDeviceParameters);
/*
      rasterizationState: {
        cullMode: "back",
      },

      depthStencilState: {
        depthWriteEnabled: true,
        depthCompare: "less",
        format: "depth24plus-stencil8",
      },

      colorStates: [
        {
          format: "bgra8unorm",
          // colorBlend.srcFactor = wgpu::BlendFactor::SrcAlpha;
          // colorBlend.dstFactor = wgpu::BlendFactor::OneMinusSrcAlpha;
          // alphaBlend.srcFactor = wgpu::BlendFactor::SrcAlpha;
          // alphaBlend.dstFactor = wgpu::BlendFactor::OneMinusSrcAlpha;
        },
      ],
    });
*/ parcelHelpers.export(exports, "convertCompareFunction", ()=>convertCompareFunction);
parcelHelpers.export(exports, "convertToCompareFunction", ()=>convertToCompareFunction);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _unifiedParameterApiJs = require("../../context/parameters/unified-parameter-api.js");
function withDeviceAndGLParameters(device, parameters, glParameters, func) {
    if (isObjectEmpty(parameters)) // Avoid setting state if no parameters provided. Just call and return
    return func(device);
    // Wrap in a try-catch to ensure that parameters are restored on exceptions
    const webglDevice = device;
    webglDevice.pushState();
    try {
        setDeviceParameters(device, parameters);
        (0, _unifiedParameterApiJs.setGLParameters)(webglDevice.gl, glParameters);
        return func(device);
    } finally{
        webglDevice.popState();
    }
}
function withGLParameters(device, parameters, func) {
    if (isObjectEmpty(parameters)) // Avoid setting state if no parameters provided. Just call and return
    return func(device);
    // Wrap in a try-catch to ensure that parameters are restored on exceptions
    const webglDevice = device;
    webglDevice.pushState();
    try {
        (0, _unifiedParameterApiJs.setGLParameters)(webglDevice.gl, parameters);
        return func(device);
    } finally{
        webglDevice.popState();
    }
}
function withDeviceParameters(device, parameters, func) {
    if (isObjectEmpty(parameters)) // Avoid setting state if no parameters provided. Just call and return
    return func(device);
    // Wrap in a try-catch to ensure that parameters are restored on exceptions'
    const webglDevice = device;
    webglDevice.pushState();
    try {
        setDeviceParameters(device, parameters);
        return func(device);
    } finally{
        webglDevice.popState();
    }
}
function setDeviceParameters(device, parameters) {
    const webglDevice = device;
    const { gl } = webglDevice;
    // RASTERIZATION SETTINGS
    if (parameters.cullMode) switch(parameters.cullMode){
        case 'none':
            gl.disable(2884);
            break;
        case 'front':
            gl.enable(2884);
            gl.cullFace(1028);
            break;
        case 'back':
            gl.enable(2884);
            gl.cullFace(1029);
            break;
    }
    if (parameters.frontFace) gl.frontFace(map('frontFace', parameters.frontFace, {
        ccw: 2305,
        cw: 2304
    }));
    if (parameters.unclippedDepth) {
        if (device.features.has('depth-clip-control')) // EXT_depth_clamp
        gl.enable(34383);
    }
    if (parameters.depthBias !== undefined) {
        gl.enable(32823);
        gl.polygonOffset(parameters.depthBias, parameters.depthBiasSlopeScale || 0);
    }
    // depthBiasSlopeScale: {
    //   // Handled by depthBias
    // },
    // WEBGL EXTENSIONS
    if (parameters.provokingVertex) {
        if (device.features.has('provoking-vertex-webgl')) {
            const extensions = webglDevice.getExtension('WEBGL_provoking_vertex');
            const ext = extensions.WEBGL_provoking_vertex;
            const vertex = map('provokingVertex', parameters.provokingVertex, {
                first: 36429,
                last: 36430
            });
            ext?.provokingVertexWEBGL(vertex);
        }
    }
    if (parameters.polygonMode || parameters.polygonOffsetLine) {
        if (device.features.has('polygon-mode-webgl')) {
            if (parameters.polygonMode) {
                const extensions = webglDevice.getExtension('WEBGL_polygon_mode');
                const ext = extensions.WEBGL_polygon_mode;
                const mode = map('polygonMode', parameters.polygonMode, {
                    fill: 6914,
                    line: 6913
                });
                ext?.polygonModeWEBGL(1028, mode);
                ext?.polygonModeWEBGL(1029, mode);
            }
            if (parameters.polygonOffsetLine) gl.enable(10754);
        }
    }
    if (device.features.has('shader-clip-cull-distance-webgl')) {
        if (parameters.clipDistance0) gl.enable(12288);
        if (parameters.clipDistance1) gl.enable(12289);
        if (parameters.clipDistance2) gl.enable(12290);
        if (parameters.clipDistance3) gl.enable(12291);
        if (parameters.clipDistance4) gl.enable(12292);
        if (parameters.clipDistance5) gl.enable(12293);
        if (parameters.clipDistance6) gl.enable(12294);
        if (parameters.clipDistance7) gl.enable(12295);
    }
    // DEPTH STENCIL
    if (parameters.depthWriteEnabled !== undefined) gl.depthMask(mapBoolean('depthWriteEnabled', parameters.depthWriteEnabled));
    if (parameters.depthCompare) {
        parameters.depthCompare !== 'always' ? gl.enable(2929) : gl.disable(2929);
        gl.depthFunc(convertCompareFunction('depthCompare', parameters.depthCompare));
    }
    if (parameters.stencilWriteMask) {
        const mask = parameters.stencilWriteMask;
        gl.stencilMaskSeparate(1028, mask);
        gl.stencilMaskSeparate(1029, mask);
    }
    if (parameters.stencilReadMask) // stencilReadMask is handle inside stencil***Compare.
    (0, _core.log).warn('stencilReadMask not supported under WebGL');
    if (parameters.stencilCompare) {
        const mask = parameters.stencilReadMask || 0xffffffff;
        const glValue = convertCompareFunction('depthCompare', parameters.stencilCompare);
        // TODO - ensure back doesn't overwrite
        parameters.stencilCompare !== 'always' ? gl.enable(2960) : gl.disable(2960);
        gl.stencilFuncSeparate(1028, glValue, 0, mask);
        gl.stencilFuncSeparate(1029, glValue, 0, mask);
    }
    if (parameters.stencilPassOperation && parameters.stencilFailOperation && parameters.stencilDepthFailOperation) {
        const dppass = convertStencilOperation('stencilPassOperation', parameters.stencilPassOperation);
        const sfail = convertStencilOperation('stencilFailOperation', parameters.stencilFailOperation);
        const dpfail = convertStencilOperation('stencilDepthFailOperation', parameters.stencilDepthFailOperation);
        gl.stencilOpSeparate(1028, sfail, dpfail, dppass);
        gl.stencilOpSeparate(1029, sfail, dpfail, dppass);
    }
    // stencilDepthFailOperation() {
    //   // handled by stencilPassOperation
    // },
    // stencilFailOperation() {
    //   // handled by stencilPassOperation
    // },
    // COLOR STATE
    switch(parameters.blend){
        case true:
            gl.enable(3042);
            break;
        case false:
            gl.disable(3042);
            break;
        default:
    }
    if (parameters.blendColorOperation || parameters.blendAlphaOperation) {
        const colorEquation = convertBlendOperationToEquation('blendColorOperation', parameters.blendColorOperation || 'add');
        const alphaEquation = convertBlendOperationToEquation('blendAlphaOperation', parameters.blendAlphaOperation || 'add');
        gl.blendEquationSeparate(colorEquation, alphaEquation);
        const colorSrcFactor = convertBlendFactorToFunction('blendColorSrcFactor', parameters.blendColorSrcFactor || 'one');
        const colorDstFactor = convertBlendFactorToFunction('blendColorDstFactor', parameters.blendColorDstFactor || 'zero');
        const alphaSrcFactor = convertBlendFactorToFunction('blendAlphaSrcFactor', parameters.blendAlphaSrcFactor || 'one');
        const alphaDstFactor = convertBlendFactorToFunction('blendAlphaDstFactor', parameters.blendAlphaDstFactor || 'zero');
        gl.blendFuncSeparate(colorSrcFactor, colorDstFactor, alphaSrcFactor, alphaDstFactor);
    }
}
function convertCompareFunction(parameter, value) {
    return map(parameter, value, {
        never: 512,
        less: 513,
        equal: 514,
        'less-equal': 515,
        greater: 516,
        'not-equal': 517,
        'greater-equal': 518,
        always: 519
    });
}
function convertToCompareFunction(parameter, value) {
    return map(parameter, value, {
        [512]: 'never',
        [513]: 'less',
        [514]: 'equal',
        [515]: 'less-equal',
        [516]: 'greater',
        [517]: 'not-equal',
        [518]: 'greater-equal',
        [519]: 'always'
    });
}
function convertStencilOperation(parameter, value) {
    return map(parameter, value, {
        keep: 7680,
        zero: 0,
        replace: 7681,
        invert: 5386,
        'increment-clamp': 7682,
        'decrement-clamp': 7683,
        'increment-wrap': 34055,
        'decrement-wrap': 34056
    });
}
function convertBlendOperationToEquation(parameter, value) {
    return map(parameter, value, {
        add: 32774,
        subtract: 32778,
        'reverse-subtract': 32779,
        min: 32775,
        max: 32776
    });
}
function convertBlendFactorToFunction(parameter, value) {
    return map(parameter, value, {
        one: 1,
        zero: 0,
        'src-color': 768,
        'one-minus-src-color': 769,
        'dst-color': 774,
        'one-minus-dst-color': 775,
        'src-alpha': 770,
        'one-minus-src-alpha': 771,
        'dst-alpha': 772,
        'one-minus-dst-alpha': 773,
        'src-alpha-saturated': 776,
        'constant-color': 32769,
        'one-minus-constant-color': 32770,
        'constant-alpha': 32771,
        'one-minus-constant-alpha': 32772
    });
}
function message(parameter, value) {
    return `Illegal parameter ${value} for ${parameter}`;
}
function map(parameter, value, valueMap) {
    if (!(value in valueMap)) throw new Error(message(parameter, value));
    return valueMap[value];
}
function mapBoolean(parameter, value) {
    return value;
}
/** Returns true if given object is empty, false otherwise. */ function isObjectEmpty(obj) {
    let isEmpty = true;
    // @ts-ignore key is unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for(const key in obj){
        isEmpty = false;
        break;
    }
    return isEmpty;
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../../context/parameters/unified-parameter-api.js":"j2HhX","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"YIvAu":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * WebGL... the texture API from hell... hopefully made simpler
 */ parcelHelpers.export(exports, "WEBGLTexture", ()=>WEBGLTexture) // TODO - Remove when texture refactor is complete
 /*
setCubeMapData(options: {
  width: number;
  height: number;
  data: Record<GL, Texture2DData> | Record<TextureCubeFace, Texture2DData>;
  format?: any;
  type?: any;
  /** @deprecated Use .data *
  pixels: any;
}): void {
  const {gl} = this;

  const {width, height, pixels, data, format = GL.RGBA, type = GL.UNSIGNED_BYTE} = options;

  // pixel data (imageDataMap) is an Object from Face to Image or Promise.
  // For example:
  // {
  // GL.TEXTURE_CUBE_MAP_POSITIVE_X : Image-or-Promise,
  // GL.TEXTURE_CUBE_MAP_NEGATIVE_X : Image-or-Promise,
  // ... }
  // To provide multiple level-of-details (LODs) this can be Face to Array
  // of Image or Promise, like this
  // {
  // GL.TEXTURE_CUBE_MAP_POSITIVE_X : [Image-or-Promise-LOD-0, Image-or-Promise-LOD-1],
  // GL.TEXTURE_CUBE_MAP_NEGATIVE_X : [Image-or-Promise-LOD-0, Image-or-Promise-LOD-1],
  // ... }

  const imageDataMap = this._getImageDataMap(pixels || data);

  const resolvedFaces = WEBGLTexture.FACES.map(face => {
    const facePixels = imageDataMap[face];
    return Array.isArray(facePixels) ? facePixels : [facePixels];
  });
  this.bind();

  WEBGLTexture.FACES.forEach((face, index) => {
    if (resolvedFaces[index].length > 1 && this.props.mipmaps !== false) {
      // If the user provides multiple LODs, then automatic mipmap
      // generation generateMipmap() should be disabled to avoid overwritting them.
      log.warn(`${this.id} has mipmap and multiple LODs.`)();
    }
    resolvedFaces[index].forEach((image, lodLevel) => {
      // TODO: adjust width & height for LOD!
      if (width && height) {
        gl.texImage2D(face, lodLevel, format, width, height, 0 /* border*, format, type, image);
      } else {
        gl.texImage2D(face, lodLevel, format, format, type, image);
      }
    });
  });

  this.unbind();
}
*/ ;
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _webglTextureTableJs = require("../converters/webgl-texture-table.js");
var _samplerParametersJs = require("../converters/sampler-parameters.js");
var _webglSamplerJs = require("./webgl-sampler.js");
var _webglTextureViewJs = require("./webgl-texture-view.js");
var _webglTextureUtilsJs = require("../helpers/webgl-texture-utils.js");
class WEBGLTexture extends (0, _core.Texture) {
    // readonly MAX_ATTRIBUTES: number;
    device;
    gl;
    handle;
    sampler = undefined;
    view = undefined;
    mipmaps;
    // Texture type
    /** Whether the internal format is compressed */ compressed;
    /**
     * The WebGL target corresponding to the texture type
     * @note `target` cannot be modified by bind:
     * textures are special because when you first bind them to a target,
     * When you first bind a texture as a GL_TEXTURE_2D, you are saying that this texture is a 2D texture.
     * And it will always be a 2D texture; this state cannot be changed ever.
     * A texture that was first bound as a GL_TEXTURE_2D, must always be bound as a GL_TEXTURE_2D;
     * attempting to bind it as GL_TEXTURE_3D will give rise to a run-time error
     */ glTarget;
    /** The WebGL format - essentially channel structure */ glFormat;
    /** The WebGL data format - the type of each channel */ glType;
    /** The WebGL constant corresponding to the WebGPU style constant in format */ glInternalFormat;
    // state
    /** Texture binding slot - TODO - move to texture view? */ textureUnit = 0;
    constructor(device, props){
        super(device, props);
        // Texture base class strips out the data prop, so we need to add it back in
        const propsWithData = {
            ...this.props
        };
        propsWithData.data = props.data;
        this.device = device;
        this.gl = this.device.gl;
        // Note: In WebGL the texture target defines the type of texture on first bind.
        this.glTarget = (0, _webglTextureUtilsJs.getWebGLTextureTarget)(this.props.dimension);
        // The target format of this texture
        const formatInfo = (0, _webglTextureTableJs.getTextureFormatWebGL)(this.props.format);
        this.glInternalFormat = formatInfo.internalFormat;
        this.glFormat = formatInfo.format;
        this.glType = formatInfo.type;
        this.compressed = formatInfo.compressed;
        this.mipmaps = Boolean(this.props.mipmaps);
        this._initialize(propsWithData);
        Object.seal(this);
    }
    /** Initialize texture with supplied props */ // eslint-disable-next-line max-statements
    _initialize(propsWithData) {
        this.handle = this.props.handle || this.gl.createTexture();
        this.device.setSpectorMetadata(this.handle, {
            ...this.props,
            data: propsWithData.data
        });
        let { width, height } = propsWithData;
        if (!width || !height) {
            const textureSize = (0, _core.Texture).getTextureDataSize(propsWithData.data);
            width = textureSize?.width || 1;
            height = textureSize?.height || 1;
        }
        // Store opts for accessors
        this.width = width;
        this.height = height;
        this.depth = propsWithData.depth;
        // Set texture sampler parameters
        this.setSampler(propsWithData.sampler);
        // @ts-ignore TODO - fix types
        this.view = new (0, _webglTextureViewJs.WEBGLTextureView)(this.device, {
            ...this.props,
            texture: this
        });
        this.bind();
        (0, _webglTextureUtilsJs.initializeTextureStorage)(this.gl, this.mipLevels, this);
        if (propsWithData.data) // prettier-ignore
        switch(propsWithData.dimension){
            case '1d':
                this.setTexture1DData(propsWithData.data);
                break;
            case '2d':
                this.setTexture2DData(propsWithData.data);
                break;
            case '3d':
                this.setTexture3DData(propsWithData.data);
                break;
            case 'cube':
                this.setTextureCubeData(propsWithData.data);
                break;
            case '2d-array':
                this.setTextureArrayData(propsWithData.data);
                break;
            case 'cube-array':
                this.setTextureCubeArrayData(propsWithData.data);
                break;
            // @ts-expect-error
            default:
                throw new Error(propsWithData.dimension);
        }
        if (this.mipmaps) this.generateMipmap();
    }
    destroy() {
        if (this.handle) {
            this.gl.deleteTexture(this.handle);
            this.removeStats();
            this.trackDeallocatedMemory('Texture');
            // this.handle = null;
            this.destroyed = true;
        }
    }
    createView(props) {
        return new (0, _webglTextureViewJs.WEBGLTextureView)(this.device, {
            ...props,
            texture: this
        });
    }
    setSampler(sampler = {}) {
        let samplerProps;
        if (sampler instanceof (0, _webglSamplerJs.WEBGLSampler)) {
            this.sampler = sampler;
            samplerProps = sampler.props;
        } else {
            this.sampler = new (0, _webglSamplerJs.WEBGLSampler)(this.device, sampler);
            samplerProps = sampler;
        }
        const parameters = (0, _samplerParametersJs.convertSamplerParametersToWebGL)(samplerProps);
        this._setSamplerParameters(parameters);
    }
    // Call to regenerate mipmaps after modifying texture(s)
    generateMipmap(options) {
        const isFilterableAndRenderable = this.device.isTextureFormatRenderable(this.props.format) && this.device.isTextureFormatFilterable(this.props.format);
        if (!isFilterableAndRenderable) {
            (0, _core.log).warn(`${this} is not renderable or filterable, may not be able to generate mipmaps`)();
            if (!options?.force) return;
        }
        try {
            this.gl.bindTexture(this.glTarget, this.handle);
            this.gl.generateMipmap(this.glTarget);
        } catch (error) {
            (0, _core.log).warn(`Error generating mipmap for ${this}: ${error.message}`)();
        } finally{
            this.gl.bindTexture(this.glTarget, null);
        }
    }
    // Image Data Setters
    copyExternalImage(options) {
        const size = (0, _core.Texture).getExternalImageSize(options.image);
        const opts = {
            ...(0, _core.Texture).defaultCopyExternalImageOptions,
            ...size,
            ...options
        };
        const { image, depth, mipLevel, x, y, z, flipY } = opts;
        let { width, height } = opts;
        const { dimension, glTarget, glFormat, glInternalFormat, glType } = this;
        // WebGL will error if we try to copy outside the bounds of the texture
        width = Math.min(width, this.width - x);
        height = Math.min(height, this.height - y);
        if (options.sourceX || options.sourceY) // requires copyTexSubImage2D from a framebuffer'
        throw new Error('WebGL does not support sourceX/sourceY)');
        (0, _webglTextureUtilsJs.copyExternalImageToMipLevel)(this.device.gl, this.handle, image, {
            dimension,
            mipLevel,
            x,
            y,
            z,
            width,
            height,
            depth,
            glFormat,
            glInternalFormat,
            glType,
            glTarget,
            flipY
        });
        return {
            width: opts.width,
            height: opts.height
        };
    }
    setTexture1DData(data) {
        throw new Error('setTexture1DData not supported in WebGL.');
    }
    /** Set a simple texture */ setTexture2DData(lodData, depth = 0) {
        this.bind();
        const lodArray = (0, _core.Texture).normalizeTextureData(lodData, this);
        // If the user provides multiple LODs, then automatic mipmap
        // generation generateMipmap() should be disabled to avoid overwriting them.
        if (lodArray.length > 1 && this.props.mipmaps !== false) (0, _core.log).warn(`Texture ${this.id} mipmap and multiple LODs.`)();
        for(let lodLevel = 0; lodLevel < lodArray.length; lodLevel++){
            const imageData = lodArray[lodLevel];
            this._setMipLevel(depth, lodLevel, imageData);
        }
        this.unbind();
    }
    /**
     * Sets a 3D texture
     * @param data
     */ setTexture3DData(data) {
        if (this.props.dimension !== '3d') throw new Error(this.id);
        if (ArrayBuffer.isView(data)) {
            this.bind();
            (0, _webglTextureUtilsJs.copyCPUDataToMipLevel)(this.device.gl, data, this);
            this.unbind();
        }
    }
    /**
     * Set a Texture Cube Data
     * @todo - could support TextureCubeArray with depth
     * @param data
     * @param index
     */ setTextureCubeData(data, depth = 0) {
        if (this.props.dimension !== 'cube') throw new Error(this.id);
        for (const face of (0, _core.Texture).CubeFaces)this.setTextureCubeFaceData(data[face], face);
    }
    /**
     * Sets an entire texture array
     * @param data
     */ setTextureArrayData(data) {
        if (this.props.dimension !== '2d-array') throw new Error(this.id);
        throw new Error('setTextureArrayData not implemented.');
    }
    /**
     * Sets an entire texture cube array
     * @param data
     */ setTextureCubeArrayData(data) {
        throw new Error('setTextureCubeArrayData not supported in WebGL2.');
    }
    setTextureCubeFaceData(lodData, face, depth = 0) {
        // assert(this.props.dimension === 'cube');
        // If the user provides multiple LODs, then automatic mipmap
        // generation generateMipmap() should be disabled to avoid overwriting them.
        if (Array.isArray(lodData) && lodData.length > 1 && this.props.mipmaps !== false) (0, _core.log).warn(`${this.id} has mipmap and multiple LODs.`)();
        const faceDepth = (0, _core.Texture).CubeFaces.indexOf(face);
        this.setTexture2DData(lodData, faceDepth);
    }
    // DEPRECATED METHODS
    /** Update external texture (video frame or canvas) @deprecated Use ExternalTexture */ update() {
        throw new Error('Texture.update() not implemented. Use ExternalTexture');
    }
    // INTERNAL METHODS
    /** @todo update this method to accept LODs */ setImageDataForFace(options) {
        const { face, width, height, pixels, data, format = 6408, type = 5121 } = options;
        const { gl } = this;
        const imageData = pixels || data;
        this.bind();
        if (imageData instanceof Promise) imageData.then((resolvedImageData)=>this.setImageDataForFace(Object.assign({}, options, {
                face,
                data: resolvedImageData,
                pixels: resolvedImageData
            })));
        else if (this.width || this.height) gl.texImage2D(face, 0, format, width, height, 0 /* border*/ , format, type, imageData);
        else gl.texImage2D(face, 0, format, format, type, imageData);
    }
    _getImageDataMap(faceData) {
        for(let i = 0; i < (0, _core.Texture).CubeFaces.length; ++i){
            const faceName = (0, _core.Texture).CubeFaces[i];
            if (faceData[faceName]) {
                faceData[34069 + i] = faceData[faceName];
                delete faceData[faceName];
            }
        }
        return faceData;
    }
    // RESOURCE METHODS
    /**
     * Sets sampler parameters on texture
     */ _setSamplerParameters(parameters) {
        (0, _core.log).log(1, `${this.id} sampler parameters`, this.device.getGLKeys(parameters))();
        this.gl.bindTexture(this.glTarget, this.handle);
        for (const [pname, pvalue] of Object.entries(parameters)){
            const param = Number(pname);
            const value = pvalue;
            // Apparently integer/float issues require two different texture parameter setting functions in JavaScript.
            // For now, pick the float version for parameters specified as GLfloat.
            switch(param){
                case 33082:
                case 33083:
                    this.gl.texParameterf(this.glTarget, param, value);
                    break;
                case 10241:
                    this.gl.texParameteri(this.glTarget, param, value);
                    break;
                case 10242:
                case 10243:
                    this.gl.texParameteri(this.glTarget, param, value);
                    break;
                case 34046:
                    // We have to query feature before using it
                    if (this.device.features.has('texture-filterable-anisotropic-webgl')) this.gl.texParameteri(this.glTarget, param, value);
                    break;
                default:
                    this.gl.texParameteri(this.glTarget, param, value);
                    break;
            }
        }
        this.gl.bindTexture(this.glTarget, null);
    }
    // INTERNAL SETTERS
    /**
     * Copy a region of data from a CPU memory buffer into this texture.
     * @todo -   GLUnpackParameters parameters
     */ _setMipLevel(depth, mipLevel, textureData, glTarget = this.glTarget) {
        // if (!textureData) {
        //   clearMipLevel(this.device.gl, {...this, depth, level});
        //   return;
        // }
        if ((0, _core.Texture).isExternalImage(textureData)) {
            (0, _webglTextureUtilsJs.copyExternalImageToMipLevel)(this.device.gl, this.handle, textureData, {
                ...this,
                depth,
                mipLevel,
                glTarget,
                flipY: this.props.flipY
            });
            return;
        }
        // @ts-expect-error
        if ((0, _core.Texture).isTextureLevelData(textureData)) {
            (0, _webglTextureUtilsJs.copyCPUDataToMipLevel)(this.device.gl, textureData.data, {
                ...this,
                depth,
                mipLevel,
                glTarget
            });
            return;
        }
        throw new Error('Texture: invalid image data');
    }
    // HELPERS
    getActiveUnit() {
        return this.gl.getParameter(34016) - 33984;
    }
    bind(textureUnit) {
        const { gl } = this;
        if (textureUnit !== undefined) {
            this.textureUnit = textureUnit;
            gl.activeTexture(33984 + textureUnit);
        }
        gl.bindTexture(this.glTarget, this.handle);
        return textureUnit;
    }
    unbind(textureUnit) {
        const { gl } = this;
        if (textureUnit !== undefined) {
            this.textureUnit = textureUnit;
            gl.activeTexture(33984 + textureUnit);
        }
        gl.bindTexture(this.glTarget, null);
        return textureUnit;
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../converters/webgl-texture-table.js":"4LosF","../converters/sampler-parameters.js":"62r49","./webgl-sampler.js":"e2AQF","./webgl-texture-view.js":"lPJVv","../helpers/webgl-texture-utils.js":"lgYH8","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lPJVv":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// import {decodeTextureFormat} from '@luma.gl/core';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEBGLTextureView", ()=>WEBGLTextureView);
var _core = require("@luma.gl/core");
class WEBGLTextureView extends (0, _core.TextureView) {
    device;
    gl;
    handle;
    texture;
    constructor(device, props){
        super(device, {
            ...(0, _core.Texture).defaultProps,
            ...props
        });
        this.device = device;
        this.gl = this.device.gl;
        this.handle = null;
        this.texture = props.texture;
    }
}

},{"@luma.gl/core":"7TxCR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lgYH8":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Initializes a texture memory space
 * Clear all the textures and mip levels of a two-dimensional or array texture at the same time.
 * On some implementations faster than repeatedly setting levels
 *
 * @note From WebGL 2 spec section 3.7.6:
 * @see https://registry.khronos.org/webgl/specs/latest/2.0/
 * - The image contents are set as if a buffer of sufficient size initialized to 0 would be passed to each level's texImage2D/3D
 * - texStorage2D should be considered a preferred alternative to texImage2D. It may have lower memory costs than texImage2D in some implementations.
 * - Once texStorage*D has been called, the texture is immutable and can only be updated with texSubImage*(), not texImage()
 */ parcelHelpers.export(exports, "initializeTextureStorage", ()=>initializeTextureStorage);
/**
 * Copy a region of compressed data from a GPU memory buffer into this texture.
 */ parcelHelpers.export(exports, "copyExternalImageToMipLevel", ()=>copyExternalImageToMipLevel);
/**
 * Copy a region of data from a CPU memory buffer into this texture.
 */ parcelHelpers.export(exports, "copyCPUDataToMipLevel", ()=>copyCPUDataToMipLevel);
/**
 * Copy a region of compressed data from a GPU memory buffer into this texture.
 */ parcelHelpers.export(exports, "copyGPUBufferToMipLevel", ()=>copyGPUBufferToMipLevel);
// INTERNAL HELPERS
/** Convert a WebGPU style texture constant to a WebGL style texture constant */ parcelHelpers.export(exports, "getWebGLTextureTarget", ()=>getWebGLTextureTarget);
/**
 * In WebGL, cube maps specify faces by overriding target instead of using the depth parameter.
 * @note We still bind the texture using GL.TEXTURE_CUBE_MAP, but we need to use the face-specific target when setting mip levels.
 * @returns glTarget unchanged, if dimension !== 'cube'.
 */ parcelHelpers.export(exports, "getWebGLCubeFaceTarget", ()=>getWebGLCubeFaceTarget);
/**
 * Copies data from a type  or a Texture object into ArrayBuffer object.
 * App can provide targetPixelArray or have it auto allocated by this method
 *  newly allocated by this method unless provided by app.
 * @deprecated Use CommandEncoder.copyTextureToBuffer and Buffer.read
 * @note Slow requires roundtrip to GPU
 *
 * @param source
 * @param options
 * @returns pixel array,
 */ parcelHelpers.export(exports, "readPixelsToArray", ()=>readPixelsToArray);
/**
 * Copies data from a Framebuffer or a Texture object into a Buffer object.
 * NOTE: doesn't wait for copy to be complete, it programs GPU to perform a DMA transffer.
 * @deprecated Use CommandEncoder
 * @param source
 * @param options
 */ parcelHelpers.export(exports, "readPixelsToBuffer", ()=>readPixelsToBuffer);
/**
 * Copy a rectangle from a Framebuffer or Texture object into a texture (at an offset)
 * @deprecated Use CommandEncoder
 */ // eslint-disable-next-line complexity, max-statements
parcelHelpers.export(exports, "copyToTexture", ()=>copyToTexture);
/**
 * Wraps a given texture into a framebuffer object, that can be further used
 * to read data from the texture object.
 */ parcelHelpers.export(exports, "toFramebuffer", ()=>toFramebuffer);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _typedArrayUtilsJs = require("./typed-array-utils.js");
var _formatUtilsJs = require("./format-utils.js");
var _webglTextureJs = require("../resources/webgl-texture.js");
var _withParametersJs = require("../../context/state-tracker/with-parameters.js");
/** A "border" parameter is required in many WebGL texture APIs, but must always be 0... */ const BORDER = 0;
function initializeTextureStorage(gl, levels, options) {
    const { dimension, width, height, depth = 0 } = options;
    const { glInternalFormat } = options;
    const glTarget = options.glTarget; // getWebGLCubeFaceTarget(options.glTarget, dimension, depth);
    switch(dimension){
        case '2d-array':
        case '3d':
            gl.texStorage3D(glTarget, levels, glInternalFormat, width, height, depth);
            break;
        default:
            gl.texStorage2D(glTarget, levels, glInternalFormat, width, height);
    }
}
function copyExternalImageToMipLevel(gl, handle, image, options) {
    const { width, height } = options;
    const { dimension, depth = 0, mipLevel = 0 } = options;
    const { x = 0, y = 0, z = 0 } = options;
    const { glFormat, glType } = options;
    const glTarget = getWebGLCubeFaceTarget(options.glTarget, dimension, depth);
    const glParameters = options.flipY ? {
        [37440]: true
    } : {};
    (0, _withParametersJs.withGLParameters)(gl, glParameters, ()=>{
        switch(dimension){
            case '2d-array':
            case '3d':
                gl.bindTexture(glTarget, handle);
                // prettier-ignore
                gl.texSubImage3D(glTarget, mipLevel, x, y, z, width, height, depth, glFormat, glType, image);
                gl.bindTexture(glTarget, null);
                break;
            case '2d':
            case 'cube':
                gl.bindTexture(glTarget, handle);
                // prettier-ignore
                gl.texSubImage2D(glTarget, mipLevel, x, y, width, height, glFormat, glType, image);
                gl.bindTexture(glTarget, null);
                break;
            default:
                throw new Error(dimension);
        }
    });
}
function copyCPUDataToMipLevel(gl, typedArray, options) {
    const { dimension, width, height, depth = 0, mipLevel = 0, byteOffset = 0 } = options;
    const { x = 0, y = 0, z = 0 } = options;
    const { glFormat, glType, compressed } = options;
    const glTarget = getWebGLCubeFaceTarget(options.glTarget, dimension, depth);
    // gl.bindTexture(glTarget, null);
    switch(dimension){
        case '2d-array':
        case '3d':
            if (compressed) // prettier-ignore
            gl.compressedTexSubImage3D(glTarget, mipLevel, x, y, z, width, height, depth, glFormat, typedArray, byteOffset); // , byteLength
            else // prettier-ignore
            gl.texSubImage3D(glTarget, mipLevel, x, y, z, width, height, depth, glFormat, glType, typedArray, byteOffset); // , byteLength
            break;
        case '2d':
        case 'cube':
            if (compressed) // prettier-ignore
            gl.compressedTexSubImage2D(glTarget, mipLevel, x, y, width, height, glFormat, typedArray, byteOffset); // , byteLength
            else // prettier-ignore
            gl.texSubImage2D(glTarget, mipLevel, x, y, width, height, glFormat, glType, typedArray, byteOffset); // , byteLength
            break;
        default:
            throw new Error(dimension);
    }
}
function copyGPUBufferToMipLevel(gl, webglBuffer, byteLength, options) {
    const { dimension, width, height, depth = 0, mipLevel = 0, byteOffset = 0 } = options;
    const { x = 0, y = 0, z = 0 } = options;
    const { glFormat, glType, compressed } = options;
    const glTarget = getWebGLCubeFaceTarget(options.glTarget, dimension, depth);
    gl.bindBuffer(35052, webglBuffer);
    switch(dimension){
        case '2d-array':
        case '3d':
            // 3 dimensional textures requires 3D texture functions
            if (compressed) // TODO enable extension?
            // prettier-ignore
            gl.compressedTexSubImage3D(glTarget, mipLevel, x, y, z, width, height, depth, glFormat, byteLength, byteOffset);
            else // prettier-ignore
            gl.texSubImage3D(glTarget, mipLevel, x, y, z, width, height, depth, glFormat, glType, byteOffset);
            break;
        case '2d':
        case 'cube':
            if (compressed) // prettier-ignore
            gl.compressedTexSubImage2D(glTarget, mipLevel, x, y, width, height, glFormat, byteLength, byteOffset);
            else // prettier-ignore
            gl.texSubImage2D(glTarget, mipLevel, x, y, width, height, BORDER, glFormat, byteOffset);
            break;
        default:
            throw new Error(dimension);
    }
}
function getWebGLTextureTarget(dimension) {
    // prettier-ignore
    switch(dimension){
        case '1d':
            break; // not supported in any WebGL version
        case '2d':
            return 3553; // supported in WebGL1
        case '3d':
            return 32879; // supported in WebGL2
        case 'cube':
            return 34067; // supported in WebGL1
        case '2d-array':
            return 35866; // supported in WebGL2
        case 'cube-array':
            break; // not supported in any WebGL version
    }
    throw new Error(dimension);
}
function getWebGLCubeFaceTarget(glTarget, dimension, level) {
    return dimension === 'cube' ? 34069 + level : glTarget;
}
function readPixelsToArray(source, options) {
    const { sourceX = 0, sourceY = 0, sourceAttachment = 0 // TODO - support gl.readBuffer
     } = options || {};
    let { target: target1 = null, // following parameters are auto deduced if not provided
    sourceWidth, sourceHeight, sourceDepth, sourceFormat, sourceType } = options || {};
    const { framebuffer, deleteFramebuffer } = getFramebuffer(source);
    // assert(framebuffer);
    const { gl, handle } = framebuffer;
    sourceWidth ||= framebuffer.width;
    sourceHeight ||= framebuffer.height;
    const texture = framebuffer.colorAttachments[sourceAttachment]?.texture;
    if (!texture) throw new Error(`Invalid framebuffer attachment ${sourceAttachment}`);
    sourceDepth = texture?.depth || 1;
    sourceFormat ||= texture?.glFormat || 6408;
    // Deduce the type from color attachment if not provided.
    sourceType ||= texture?.glType || 5121;
    // Deduce type and allocated pixelArray if needed
    target1 = getPixelArray(target1, sourceType, sourceFormat, sourceWidth, sourceHeight, sourceDepth);
    // Pixel array available, if necessary, deduce type from it.
    sourceType = sourceType || (0, _typedArrayUtilsJs.getGLTypeFromTypedArray)(target1);
    // Note: luma.gl overrides bindFramebuffer so that we can reliably restore the previous framebuffer (this is the only function for which we do that)
    const prevHandle = gl.bindFramebuffer(36160, handle);
    // Select the color attachment to read from
    gl.readBuffer(36064 + sourceAttachment);
    // There is a lot of hedging in the WebGL2 spec about what formats are guaranteed to be readable
    // (It should always be possible to read RGBA/UNSIGNED_BYTE, but most other combinations are not guaranteed)
    // Querying is possible but expensive:
    // const {device} = framebuffer;
    // texture.glReadFormat ||= gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT);
    // texture.glReadType ||= gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE);
    // console.log('params', device.getGLKey(texture.glReadFormat), device.getGLKey(texture.glReadType));
    gl.readPixels(sourceX, sourceY, sourceWidth, sourceHeight, sourceFormat, sourceType, target1);
    gl.readBuffer(36064);
    gl.bindFramebuffer(36160, prevHandle || null);
    if (deleteFramebuffer) framebuffer.destroy();
    return target1;
}
function readPixelsToBuffer(source, options) {
    const { target: target1, sourceX = 0, sourceY = 0, sourceFormat = 6408, targetByteOffset = 0 } = options || {};
    // following parameters are auto deduced if not provided
    let { sourceWidth, sourceHeight, sourceType } = options || {};
    const { framebuffer, deleteFramebuffer } = getFramebuffer(source);
    // assert(framebuffer);
    sourceWidth = sourceWidth || framebuffer.width;
    sourceHeight = sourceHeight || framebuffer.height;
    // Asynchronous read (PIXEL_PACK_BUFFER) is WebGL2 only feature
    const webglFramebuffer = framebuffer;
    // deduce type if not available.
    sourceType = sourceType || 5121;
    let webglBufferTarget = target1;
    if (!webglBufferTarget) {
        // Create new buffer with enough size
        const components = (0, _formatUtilsJs.glFormatToComponents)(sourceFormat);
        const byteCount = (0, _formatUtilsJs.glTypeToBytes)(sourceType);
        const byteLength = targetByteOffset + sourceWidth * sourceHeight * components * byteCount;
        webglBufferTarget = webglFramebuffer.device.createBuffer({
            byteLength
        });
    }
    // TODO(donmccurdy): Do we have tests to confirm this is working?
    const commandEncoder = source.device.createCommandEncoder();
    commandEncoder.copyTextureToBuffer({
        sourceTexture: source,
        width: sourceWidth,
        height: sourceHeight,
        origin: [
            sourceX,
            sourceY
        ],
        destinationBuffer: webglBufferTarget,
        byteOffset: targetByteOffset
    });
    commandEncoder.destroy();
    if (deleteFramebuffer) framebuffer.destroy();
    return webglBufferTarget;
}
function copyToTexture(sourceTexture, destinationTexture, options) {
    const { sourceX = 0, sourceY = 0, // attachment = GL.COLOR_ATTACHMENT0, // TODO - support gl.readBuffer
    targetMipmaplevel = 0, targetInternalFormat = 6408 } = options || {};
    let { targetX, targetY, targetZ, width, height// defaults to target height
     } = options || {};
    const { framebuffer, deleteFramebuffer } = getFramebuffer(sourceTexture);
    // assert(framebuffer);
    const webglFramebuffer = framebuffer;
    const { device, handle } = webglFramebuffer;
    const isSubCopy = typeof targetX !== 'undefined' || typeof targetY !== 'undefined' || typeof targetZ !== 'undefined';
    targetX = targetX || 0;
    targetY = targetY || 0;
    targetZ = targetZ || 0;
    const prevHandle = device.gl.bindFramebuffer(36160, handle);
    // TODO - support gl.readBuffer (WebGL2 only)
    // const prevBuffer = gl.readBuffer(attachment);
    // assert(target);
    let texture = null;
    let textureTarget;
    if (destinationTexture instanceof (0, _webglTextureJs.WEBGLTexture)) {
        texture = destinationTexture;
        width = Number.isFinite(width) ? width : texture.width;
        height = Number.isFinite(height) ? height : texture.height;
        texture?.bind(0);
        // @ts-ignore
        textureTarget = texture.target;
    } else // @ts-ignore
    textureTarget = target;
    if (!isSubCopy) device.gl.copyTexImage2D(textureTarget, targetMipmaplevel, targetInternalFormat, sourceX, sourceY, width, height, 0 /* border must be 0 */ );
    else switch(textureTarget){
        case 3553:
        case 34067:
            device.gl.copyTexSubImage2D(textureTarget, targetMipmaplevel, targetX, targetY, sourceX, sourceY, width, height);
            break;
        case 35866:
        case 32879:
            device.gl.copyTexSubImage3D(textureTarget, targetMipmaplevel, targetX, targetY, targetZ, sourceX, sourceY, width, height);
            break;
        default:
    }
    if (texture) texture.unbind();
    // @ts-expect-error
    device.gl.bindFramebuffer(36160, prevHandle || null);
    if (deleteFramebuffer) framebuffer.destroy();
    return texture;
}
function getFramebuffer(source) {
    if (!(source instanceof (0, _core.Framebuffer))) return {
        framebuffer: toFramebuffer(source),
        deleteFramebuffer: true
    };
    return {
        framebuffer: source,
        deleteFramebuffer: false
    };
}
function toFramebuffer(texture, props) {
    const { device, width, height, id } = texture;
    const framebuffer = device.createFramebuffer({
        ...props,
        id: `framebuffer-for-${id}`,
        width,
        height,
        colorAttachments: [
            texture
        ]
    });
    return framebuffer;
}
// eslint-disable-next-line max-params
function getPixelArray(pixelArray, glType, glFormat, width, height, depth) {
    if (pixelArray) return pixelArray;
    // const formatInfo = decodeTextureFormat(format);
    // Allocate pixel array if not already available, using supplied type
    glType ||= 5121;
    const ArrayType = (0, _typedArrayUtilsJs.getTypedArrayFromGLType)(glType, {
        clamped: false
    });
    const components = (0, _formatUtilsJs.glFormatToComponents)(glFormat);
    // TODO - check for composite type (components = 1).
    return new ArrayType(width * height * components);
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","./typed-array-utils.js":"8ee1I","./format-utils.js":"5Olb2","../resources/webgl-texture.js":"YIvAu","../../context/state-tracker/with-parameters.js":"2A4LM","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8ee1I":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts TYPED ARRAYS to corresponding GL constant
 * Used to auto deduce gl parameter types
 * @deprecated Use getDataTypeFromTypedArray
 * @param arrayOrType
 * @returns
 */ parcelHelpers.export(exports, "getGLTypeFromTypedArray", ()=>getGLTypeFromTypedArray);
/**
 * Converts GL constant to corresponding TYPED ARRAY
 * Used to auto deduce gl parameter types
 * @deprecated Use getTypedArrayFromDataType
 * @param glType
 * @param param1
 * @returns
 */ // eslint-disable-next-line complexity
parcelHelpers.export(exports, "getTypedArrayFromGLType", ()=>getTypedArrayFromGLType);
/**
 * Flip rows (can be used on arrays returned from `Framebuffer.readPixels`)
 * https: *stackoverflow.com/questions/41969562/
 * how-can-i-flip-the-result-of-webglrenderingcontext-readpixels
 * @param param0
 */ parcelHelpers.export(exports, "flipRows", ()=>flipRows);
parcelHelpers.export(exports, "scalePixels", ()=>scalePixels);
var _constants = require("@luma.gl/constants");
const ERR_TYPE_DEDUCTION = 'Failed to deduce GL constant from typed array';
function getGLTypeFromTypedArray(arrayOrType) {
    // If typed array, look up constructor
    const type = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
    switch(type){
        case Float32Array:
            return 5126;
        case Uint16Array:
            return 5123;
        case Uint32Array:
            return 5125;
        case Uint8Array:
            return 5121;
        case Uint8ClampedArray:
            return 5121;
        case Int8Array:
            return 5120;
        case Int16Array:
            return 5122;
        case Int32Array:
            return 5124;
        default:
            throw new Error(ERR_TYPE_DEDUCTION);
    }
}
function getTypedArrayFromGLType(glType, options) {
    const { clamped = true } = options || {};
    // Sorted in some order of likelihood to reduce amount of comparisons
    switch(glType){
        case 5126:
            return Float32Array;
        case 5123:
        case 33635:
        case 32819:
        case 32820:
            return Uint16Array;
        case 5125:
            return Uint32Array;
        case 5121:
            return clamped ? Uint8ClampedArray : Uint8Array;
        case 5120:
            return Int8Array;
        case 5122:
            return Int16Array;
        case 5124:
            return Int32Array;
        default:
            throw new Error('Failed to deduce typed array type from GL constant');
    }
}
function flipRows(options) {
    const { data, width, height, bytesPerPixel = 4, temp } = options;
    const bytesPerRow = width * bytesPerPixel;
    // make a temp buffer to hold one row
    const tempBuffer = temp || new Uint8Array(bytesPerRow);
    for(let y = 0; y < height / 2; ++y){
        const topOffset = y * bytesPerRow;
        const bottomOffset = (height - y - 1) * bytesPerRow;
        // make copy of a row on the top half
        tempBuffer.set(data.subarray(topOffset, topOffset + bytesPerRow));
        // copy a row from the bottom half to the top
        data.copyWithin(topOffset, bottomOffset, bottomOffset + bytesPerRow);
        // copy the copy of the top half row to the bottom half
        data.set(tempBuffer, bottomOffset);
    }
}
function scalePixels(options) {
    const { data, width, height } = options;
    const newWidth = Math.round(width / 2);
    const newHeight = Math.round(height / 2);
    const newData = new Uint8Array(newWidth * newHeight * 4);
    for(let y = 0; y < newHeight; y++){
        for(let x = 0; x < newWidth; x++)for(let c = 0; c < 4; c++)newData[(y * newWidth + x) * 4 + c] = data[(y * 2 * width + x * 2) * 4 + c];
    }
    return {
        data: newData,
        width: newWidth,
        height: newHeight
    };
}

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5Olb2":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Returns number of components in a specific readPixels WebGL format
parcelHelpers.export(exports, "glFormatToComponents", ()=>glFormatToComponents);
// Return byte count for given readPixels WebGL type
parcelHelpers.export(exports, "glTypeToBytes", ()=>glTypeToBytes);
var _constants = require("@luma.gl/constants");
function glFormatToComponents(format) {
    switch(format){
        case 6406:
        case 33326:
        case 6403:
        case 36244:
            return 1;
        case 33339:
        case 33340:
        case 33328:
        case 33320:
        case 33319:
            return 2;
        case 6407:
        case 36248:
        case 34837:
            return 3;
        case 6408:
        case 36249:
        case 34836:
            return 4;
        // TODO: Add support for additional WebGL2 formats
        default:
            return 0;
    }
}
function glTypeToBytes(type) {
    switch(type){
        case 5121:
            return 1;
        case 33635:
        case 32819:
        case 32820:
            return 2;
        case 5126:
            return 4;
        // TODO: Add support for additional WebGL2 types
        default:
            return 0;
    }
}

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2A4LM":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Execute a function with a set of temporary WebGL parameter overrides
 * - Saves current "global" WebGL context settings
 * - Sets the supplies WebGL context parameters,
 * - Executes supplied function
 * - Restores parameters
 * - Returns the return value of the supplied function
 */ parcelHelpers.export(exports, "withGLParameters", ()=>withGLParameters);
var _unifiedParameterApiJs = require("../parameters/unified-parameter-api.js");
var _webglStateTrackerJs = require("./webgl-state-tracker.js");
function withGLParameters(gl, parameters, func) {
    if (isObjectEmpty(parameters)) // Avoid setting state if no parameters provided. Just call and return
    return func(gl);
    const { nocatch = true } = parameters;
    const webglState = (0, _webglStateTrackerJs.WebGLStateTracker).get(gl);
    webglState.push();
    (0, _unifiedParameterApiJs.setGLParameters)(gl, parameters);
    // Setup is done, call the function
    let value;
    if (nocatch) {
        // Avoid try catch to minimize stack size impact for safe execution paths
        value = func(gl);
        webglState.pop();
    } else // Wrap in a try-catch to ensure that parameters are restored on exceptions
    try {
        value = func(gl);
    } finally{
        webglState.pop();
    }
    return value;
}
// Helpers
// Returns true if given object is empty, false otherwise.
function isObjectEmpty(object) {
    // @ts-ignore - dummy key variable
    for(const key in object)return false;
    return true;
}

},{"../parameters/unified-parameter-api.js":"j2HhX","./webgl-state-tracker.js":"1Ixaj","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"Jtb3q":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEBGLRenderPass", ()=>WEBGLRenderPass);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _withParametersJs = require("../../context/state-tracker/with-parameters.js");
var _unifiedParameterApiJs = require("../../context/parameters/unified-parameter-api.js");
const COLOR_CHANNELS = [
    0x1,
    0x2,
    0x4,
    0x8
]; // GPUColorWrite RED, GREEN, BLUE, ALPHA
class WEBGLRenderPass extends (0, _core.RenderPass) {
    device;
    /** Parameters that should be applied before each draw call */ glParameters;
    constructor(device, props){
        super(device, props);
        this.device = device;
        // If no viewport is provided, apply reasonably defaults
        let viewport;
        if (!props?.parameters?.viewport) {
            if (props?.framebuffer) {
                // Set the viewport to the size of the framebuffer
                const { width, height } = props.framebuffer;
                viewport = [
                    0,
                    0,
                    width,
                    height
                ];
            } else {
                // Instead of using our own book-keeping, we can just read the values from the WebGL context
                const [width, height] = device.getCanvasContext().getDrawingBufferSize();
                viewport = [
                    0,
                    0,
                    width,
                    height
                ];
            }
        }
        // TODO - do parameters (scissorRect) affect the clear operation?
        this.device.pushState();
        this.setParameters({
            viewport,
            ...this.props.parameters
        });
        // Specify mapping of draw buffer locations to color attachments
        const webglFramebuffer = this.props.framebuffer;
        if (webglFramebuffer?.handle) {
            if (this.props.framebuffer) {
                const drawBuffers = this.props.framebuffer.colorAttachments.map((_, i)=>36064 + i);
                this.device.gl.drawBuffers(drawBuffers);
            } else this.device.gl.drawBuffers([
                1029
            ]);
        }
        // Hack - for now WebGL draws in "immediate mode" (instead of queueing the operations)...
        this.clear();
    }
    end() {
        this.device.popState();
    // should add commands to CommandEncoder.
    }
    pushDebugGroup(groupLabel) {}
    popDebugGroup() {}
    insertDebugMarker(markerLabel) {}
    // beginOcclusionQuery(queryIndex: number): void;
    // endOcclusionQuery(): void;
    // executeBundles(bundles: Iterable<GPURenderBundle>): void;
    /**
     * Maps RenderPass parameters to GL parameters
     */ setParameters(parameters = {}) {
        const glParameters = {
            ...this.glParameters
        };
        // Framebuffers are specified using parameters in WebGL
        glParameters.framebuffer = this.props.framebuffer || null;
        if (this.props.depthReadOnly) glParameters.depthMask = !this.props.depthReadOnly;
        glParameters.stencilMask = this.props.stencilReadOnly ? 0 : 1;
        glParameters[35977] = this.props.discard;
        // Map the four renderpass parameters to WebGL parameters
        if (parameters.viewport) {
            // WebGPU viewports are 6 coordinates (X, Y, Z)
            if (parameters.viewport.length >= 6) {
                glParameters.viewport = parameters.viewport.slice(0, 4);
                glParameters.depthRange = [
                    parameters.viewport[4],
                    parameters.viewport[5]
                ];
            } else // WebGL viewports are 4 coordinates (X, Y)
            glParameters.viewport = parameters.viewport;
        }
        if (parameters.scissorRect) {
            glParameters.scissorTest = true;
            glParameters.scissor = parameters.scissorRect;
        }
        if (parameters.blendConstant) glParameters.blendColor = parameters.blendConstant;
        if (parameters.stencilReference) {
            // eslint-disable-next-line no-console
            console.warn('RenderPassParameters.stencilReference not yet implemented in WebGL');
            // parameters.stencilFunc = [func, ref, mask];
            // Does this work?
            parameters[2967] = parameters.stencilReference;
        }
        if (parameters.colorMask) glParameters.colorMask = COLOR_CHANNELS.map((channel)=>Boolean(channel & parameters.colorMask));
        this.glParameters = glParameters;
        (0, _unifiedParameterApiJs.setGLParameters)(this.device.gl, glParameters);
    }
    beginOcclusionQuery(queryIndex) {
        const webglQuerySet = this.props.occlusionQuerySet;
        webglQuerySet?.beginOcclusionQuery();
    }
    endOcclusionQuery() {
        const webglQuerySet = this.props.occlusionQuerySet;
        webglQuerySet?.endOcclusionQuery();
    }
    // PRIVATE
    /**
     * Optionally clears depth, color and stencil buffers based on parameters
     */ clear() {
        const glParameters = {
            ...this.glParameters
        };
        let clearMask = 0;
        if (this.props.clearColors) this.props.clearColors.forEach((color, drawBufferIndex)=>{
            if (color) this.clearColorBuffer(drawBufferIndex, color);
        });
        if (this.props.clearColor !== false && this.props.clearColors === undefined) {
            clearMask |= 16384;
            glParameters.clearColor = this.props.clearColor;
        }
        if (this.props.clearDepth !== false) {
            clearMask |= 256;
            glParameters.clearDepth = this.props.clearDepth;
        }
        if (this.props.clearStencil !== false) {
            clearMask |= 1024;
            glParameters.clearStencil = this.props.clearStencil;
        }
        if (clearMask !== 0) // Temporarily set any clear "colors" and call clear
        (0, _withParametersJs.withGLParameters)(this.device.gl, glParameters, ()=>{
            this.device.gl.clear(clearMask);
        });
    }
    /**
     * WebGL2 - clear a specific color buffer
     */ clearColorBuffer(drawBuffer = 0, value = [
        0,
        0,
        0,
        0
    ]) {
        (0, _withParametersJs.withGLParameters)(this.device.gl, {
            framebuffer: this.props.framebuffer
        }, ()=>{
            // Method selection per OpenGL ES 3 docs
            switch(value.constructor){
                case Int8Array:
                case Int16Array:
                case Int32Array:
                    this.device.gl.clearBufferiv(6144, drawBuffer, value);
                    break;
                case Uint8Array:
                case Uint8ClampedArray:
                case Uint16Array:
                case Uint32Array:
                    this.device.gl.clearBufferuiv(6144, drawBuffer, value);
                    break;
                case Float32Array:
                    this.device.gl.clearBufferfv(6144, drawBuffer, value);
                    break;
                default:
                    throw new Error('clearColorBuffer: color must be typed array');
            }
        });
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../../context/state-tracker/with-parameters.js":"2A4LM","../../context/parameters/unified-parameter-api.js":"j2HhX","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7Levz":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Creates a new render pipeline */ parcelHelpers.export(exports, "WEBGLRenderPipeline", ()=>WEBGLRenderPipeline);
var _core = require("@luma.gl/core");
// import {getAttributeInfosFromLayouts} from '@luma.gl/core';
var _constants = require("@luma.gl/constants");
var _getShaderLayoutJs = require("../helpers/get-shader-layout.js");
var _deviceParametersJs = require("../converters/device-parameters.js");
var _setUniformJs = require("../helpers/set-uniform.js");
var _splitUniformsAndBindingsJs = require("../../utils/split-uniforms-and-bindings.js");
var _webglBufferJs = require("./webgl-buffer.js");
var _webglFramebufferJs = require("./webgl-framebuffer.js");
var _webglTextureJs = require("./webgl-texture.js");
var _webglTextureViewJs = require("./webgl-texture-view.js");
var _webglTopologyUtilsJs = require("../helpers/webgl-topology-utils.js");
const LOG_PROGRAM_PERF_PRIORITY = 4;
class WEBGLRenderPipeline extends (0, _core.RenderPipeline) {
    /** The WebGL device that created this render pipeline */ device;
    /** Handle to underlying WebGL program */ handle;
    /** vertex shader */ vs;
    /** fragment shader */ fs;
    /** The layout extracted from shader by WebGL introspection APIs */ introspectedLayout;
    /** Uniforms set on this model */ uniforms = {};
    /** Bindings set on this model */ bindings = {};
    /** WebGL varyings */ varyings = null;
    _uniformCount = 0;
    _uniformSetters = {};
    constructor(device, props){
        super(device, props);
        this.device = device;
        this.handle = this.props.handle || this.device.gl.createProgram();
        this.device.setSpectorMetadata(this.handle, {
            id: this.props.id
        });
        // Create shaders if needed
        this.vs = props.vs;
        this.fs = props.fs;
        // assert(this.vs.stage === 'vertex');
        // assert(this.fs.stage === 'fragment');
        // Setup varyings if supplied
        // @ts-expect-error WebGL only
        const { varyings, bufferMode = 35981 } = props;
        if (varyings && varyings.length > 0) {
            this.varyings = varyings;
            this.device.gl.transformFeedbackVaryings(this.handle, varyings, bufferMode);
        }
        this._linkShaders();
        (0, _core.log).time(1, `RenderPipeline ${this.id} - shaderLayout introspection`)();
        this.introspectedLayout = (0, _getShaderLayoutJs.getShaderLayoutFromGLSL)(this.device.gl, this.handle);
        (0, _core.log).timeEnd(1, `RenderPipeline ${this.id} - shaderLayout introspection`)();
        // Merge provided layout with introspected layout
        this.shaderLayout = mergeShaderLayout(this.introspectedLayout, props.shaderLayout);
    }
    destroy() {
        if (this.handle) {
            this.device.gl.deleteProgram(this.handle);
            // this.handle = null;
            this.destroyed = true;
        }
    }
    /**
     * Bindings include: textures, samplers and uniform buffers
     * @todo needed for portable model
     */ setBindings(bindings, options) {
        // if (log.priority >= 2) {
        //   checkUniformValues(uniforms, this.id, this._uniformSetters);
        // }
        for (const [name, value] of Object.entries(bindings)){
            // Accept both `xyz` and `xyzUniforms` as valid names for `xyzUniforms` uniform block
            // This convention allows shaders to name uniform blocks as `uniform appUniforms {} app;`
            // and reference them as `app` from both GLSL and JS.
            // TODO - this is rather hacky - we could also remap the name directly in the shader layout.
            const binding = this.shaderLayout.bindings.find((binding_)=>binding_.name === name) || this.shaderLayout.bindings.find((binding_)=>binding_.name === `${name}Uniforms`);
            if (!binding) {
                const validBindings = this.shaderLayout.bindings.map((binding_)=>`"${binding_.name}"`).join(', ');
                if (!options?.disableWarnings) (0, _core.log).warn(`No binding "${name}" in render pipeline "${this.id}", expected one of ${validBindings}`, value)();
                continue; // eslint-disable-line no-continue
            }
            if (!value) (0, _core.log).warn(`Unsetting binding "${name}" in render pipeline "${this.id}"`)();
            switch(binding.type){
                case 'uniform':
                    // @ts-expect-error
                    if (!(value instanceof (0, _webglBufferJs.WEBGLBuffer)) && !(value.buffer instanceof (0, _webglBufferJs.WEBGLBuffer))) throw new Error('buffer value');
                    break;
                case 'texture':
                    if (!(value instanceof (0, _webglTextureViewJs.WEBGLTextureView) || value instanceof (0, _webglTextureJs.WEBGLTexture) || value instanceof (0, _webglFramebufferJs.WEBGLFramebuffer))) throw new Error('texture value');
                    break;
                case 'sampler':
                    (0, _core.log).warn(`Ignoring sampler ${name}`)();
                    break;
                default:
                    throw new Error(binding.type);
            }
            this.bindings[name] = value;
        }
    }
    /** @todo needed for portable model
     * @note The WebGL API is offers many ways to draw things
     * This function unifies those ways into a single call using common parameters with sane defaults
     */ draw(options) {
        const { renderPass, parameters = this.props.parameters, topology = this.props.topology, vertexArray, vertexCount, // indexCount,
        instanceCount, isInstanced = false, firstVertex = 0, // firstIndex,
        // firstInstance,
        // baseVertex,
        transformFeedback } = options;
        const glDrawMode = (0, _webglTopologyUtilsJs.getGLDrawMode)(topology);
        const isIndexed = Boolean(vertexArray.indexBuffer);
        const glIndexType = vertexArray.indexBuffer?.glIndexType;
        // Note that we sometimes get called with 0 instances
        // If we are using async linking, we need to wait until linking completes
        if (this.linkStatus !== 'success') {
            (0, _core.log).info(2, `RenderPipeline:${this.id}.draw() aborted - waiting for shader linking`)();
            return false;
        }
        // Avoid WebGL draw call when not rendering any data or values are incomplete
        // Note: async textures set as uniforms might still be loading.
        // Now that all uniforms have been updated, check if any texture
        // in the uniforms is not yet initialized, then we don't draw
        if (!this._areTexturesRenderable()) {
            (0, _core.log).info(2, `RenderPipeline:${this.id}.draw() aborted - textures not yet loaded`)();
            //  Note: false means that the app needs to redraw the pipeline again.
            return false;
        }
        // (isInstanced && instanceCount === 0)
        // if (vertexCount === 0) {
        //   log.info(2, `RenderPipeline:${this.id}.draw() aborted - no vertices to draw`)();
        //   Note: false means that the app needs to redraw the pipeline again.
        //   return true;
        // }
        this.device.gl.useProgram(this.handle);
        // Note: Rebinds constant attributes before each draw call
        vertexArray.bindBeforeRender(renderPass);
        if (transformFeedback) transformFeedback.begin(this.props.topology);
        // We have to apply bindings before every draw call since other draw calls will overwrite
        this._applyBindings();
        this._applyUniforms();
        const webglRenderPass = renderPass;
        (0, _deviceParametersJs.withDeviceAndGLParameters)(this.device, parameters, webglRenderPass.glParameters, ()=>{
            if (isIndexed && isInstanced) this.device.gl.drawElementsInstanced(glDrawMode, vertexCount || 0, glIndexType, firstVertex, instanceCount || 0);
            else if (isIndexed) this.device.gl.drawElements(glDrawMode, vertexCount || 0, glIndexType, firstVertex); // indexCount?
            else if (isInstanced) this.device.gl.drawArraysInstanced(glDrawMode, firstVertex, vertexCount || 0, instanceCount || 0);
            else this.device.gl.drawArrays(glDrawMode, firstVertex, vertexCount || 0);
            if (transformFeedback) transformFeedback.end();
        });
        vertexArray.unbindAfterRender(renderPass);
        return true;
    }
    // DEPRECATED METHODS
    setUniformsWebGL(uniforms) {
        const { bindings } = (0, _splitUniformsAndBindingsJs.splitUniformsAndBindings)(uniforms);
        Object.keys(bindings).forEach((name)=>{
            (0, _core.log).warn(`Unsupported value "${JSON.stringify(bindings[name])}" used in setUniforms() for key ${name}. Use setBindings() instead?`)();
        });
        // TODO - check against layout
        Object.assign(this.uniforms, uniforms);
    }
    // PRIVATE METHODS
    // setAttributes(attributes: Record<string, Buffer>): void {}
    // setBindings(bindings: Record<string, Binding>): void {}
    async _linkShaders() {
        const { gl } = this.device;
        gl.attachShader(this.handle, this.vs.handle);
        gl.attachShader(this.handle, this.fs.handle);
        (0, _core.log).time(LOG_PROGRAM_PERF_PRIORITY, `linkProgram for ${this.id}`)();
        gl.linkProgram(this.handle);
        (0, _core.log).timeEnd(LOG_PROGRAM_PERF_PRIORITY, `linkProgram for ${this.id}`)();
        // TODO Avoid checking program linking error in production
        (0, _core.log).level;
        if (!this.device.features.has('compilation-status-async-webgl')) {
            const status = this._getLinkStatus();
            this._reportLinkStatus(status);
            return;
        }
        // async case
        (0, _core.log).once(1, 'RenderPipeline linking is asynchronous')();
        await this._waitForLinkComplete();
        (0, _core.log).info(2, `RenderPipeline ${this.id} - async linking complete: ${this.linkStatus}`)();
        const status = this._getLinkStatus();
        this._reportLinkStatus(status);
    }
    /** Report link status. First, check for shader compilation failures if linking fails */ async _reportLinkStatus(status) {
        switch(status){
            case 'success':
                return;
            default:
                // First check for shader compilation failures if linking fails
                switch(this.vs.compilationStatus){
                    case 'error':
                        this.vs.debugShader();
                        throw new Error(`Error during compilation of shader ${this.vs.id}`);
                    case 'pending':
                        this.vs.asyncCompilationStatus.then(()=>this.vs.debugShader());
                        break;
                    case 'success':
                        break;
                }
                switch(this.fs?.compilationStatus){
                    case 'error':
                        this.fs.debugShader();
                        throw new Error(`Error during compilation of shader ${this.fs.id}`);
                    case 'pending':
                        this.fs.asyncCompilationStatus.then(()=>this.fs.debugShader());
                        break;
                    case 'success':
                        break;
                }
                const linkErrorLog = this.device.gl.getProgramInfoLog(this.handle);
                throw new Error(`Error during ${status}: ${linkErrorLog}`);
        }
    }
    /**
     * Get the shader compilation status
     * TODO - Load log even when no error reported, to catch warnings?
     * https://gamedev.stackexchange.com/questions/30429/how-to-detect-glsl-warnings
     */ _getLinkStatus() {
        const { gl } = this.device;
        const linked = gl.getProgramParameter(this.handle, 35714);
        if (!linked) {
            this.linkStatus = 'error';
            return 'linking';
        }
        gl.validateProgram(this.handle);
        const validated = gl.getProgramParameter(this.handle, 35715);
        if (!validated) {
            this.linkStatus = 'error';
            return 'validation';
        }
        this.linkStatus = 'success';
        return 'success';
    }
    /** Use KHR_parallel_shader_compile extension if available */ async _waitForLinkComplete() {
        const waitMs = async (ms)=>await new Promise((resolve)=>setTimeout(resolve, ms));
        const DELAY_MS = 10; // Shader compilation is typically quite fast (with some exceptions)
        // If status polling is not available, we can't wait for completion. Just wait a little to minimize blocking
        if (!this.device.features.has('compilation-status-async-webgl')) {
            await waitMs(DELAY_MS);
            return;
        }
        const { gl } = this.device;
        for(;;){
            const complete = gl.getProgramParameter(this.handle, 37297);
            if (complete) return;
            await waitMs(DELAY_MS);
        }
    }
    /**
     * Checks if all texture-values uniforms are renderable (i.e. loaded)
     * Update a texture if needed (e.g. from video)
     * Note: This is currently done before every draw call
     */ _areTexturesRenderable() {
        let texturesRenderable = true;
        for (const bindingInfo of this.shaderLayout.bindings)if (!this.bindings[bindingInfo.name] && !this.bindings[bindingInfo.name.replace(/Uniforms$/, '')]) {
            (0, _core.log).warn(`Binding ${bindingInfo.name} not found in ${this.id}`)();
            texturesRenderable = false;
        }
        // TODO - remove this should be handled by ExternalTexture
        // for (const [, texture] of Object.entries(this.bindings)) {
        //   if (texture instanceof WEBGLTexture) {
        //     texture.update();
        //   }
        // }
        return texturesRenderable;
    }
    /** Apply any bindings (before each draw call) */ _applyBindings() {
        // If we are using async linking, we need to wait until linking completes
        if (this.linkStatus !== 'success') return;
        const { gl } = this.device;
        gl.useProgram(this.handle);
        let textureUnit = 0;
        let uniformBufferIndex = 0;
        for (const binding of this.shaderLayout.bindings){
            // Accept both `xyz` and `xyzUniforms` as valid names for `xyzUniforms` uniform block
            const value = this.bindings[binding.name] || this.bindings[binding.name.replace(/Uniforms$/, '')];
            if (!value) throw new Error(`No value for binding ${binding.name} in ${this.id}`);
            switch(binding.type){
                case 'uniform':
                    // Set buffer
                    const { name } = binding;
                    const location = gl.getUniformBlockIndex(this.handle, name);
                    if (location === 4294967295) throw new Error(`Invalid uniform block name ${name}`);
                    gl.uniformBlockBinding(this.handle, uniformBufferIndex, location);
                    // console.debug(binding, location);
                    if (value instanceof (0, _webglBufferJs.WEBGLBuffer)) gl.bindBufferBase(35345, uniformBufferIndex, value.handle);
                    else gl.bindBufferRange(35345, uniformBufferIndex, // @ts-expect-error
                    value.buffer.handle, // @ts-expect-error
                    value.offset || 0, // @ts-expect-error
                    value.size || value.buffer.byteLength - value.offset);
                    uniformBufferIndex += 1;
                    break;
                case 'texture':
                    if (!(value instanceof (0, _webglTextureViewJs.WEBGLTextureView) || value instanceof (0, _webglTextureJs.WEBGLTexture) || value instanceof (0, _webglFramebufferJs.WEBGLFramebuffer))) throw new Error('texture');
                    let texture;
                    if (value instanceof (0, _webglTextureViewJs.WEBGLTextureView)) texture = value.texture;
                    else if (value instanceof (0, _webglTextureJs.WEBGLTexture)) texture = value;
                    else if (value instanceof (0, _webglFramebufferJs.WEBGLFramebuffer) && value.colorAttachments[0] instanceof (0, _webglTextureViewJs.WEBGLTextureView)) {
                        (0, _core.log).warn('Passing framebuffer in texture binding may be deprecated. Use fbo.colorAttachments[0] instead')();
                        texture = value.colorAttachments[0].texture;
                    } else throw new Error('No texture');
                    gl.activeTexture(33984 + textureUnit);
                    gl.bindTexture(texture.glTarget, texture.handle);
                    // gl.bindSampler(textureUnit, sampler.handle);
                    textureUnit += 1;
                    break;
                case 'sampler':
                    break;
                case 'storage':
                case 'read-only-storage':
                    throw new Error(`binding type '${binding.type}' not supported in WebGL`);
            }
        }
    }
    /**
     * Due to program sharing, uniforms need to be reset before every draw call
     * (though caching will avoid redundant WebGL calls)
     */ _applyUniforms() {
        for (const uniformLayout of this.shaderLayout.uniforms || []){
            const { name, location, type, textureUnit } = uniformLayout;
            const value = this.uniforms[name] ?? textureUnit;
            if (value !== undefined) (0, _setUniformJs.setUniform)(this.device.gl, location, type, value);
        }
    }
}
/**
 * Merges an provided shader layout into a base shader layout
 * In WebGL, this allows the auto generated shader layout to be overridden by the application
 * Typically to change the format of the vertex attributes (from float32x4 to uint8x4 etc).
 * @todo Drop this? Aren't all use cases covered by mergeBufferLayout()?
 */ function mergeShaderLayout(baseLayout, overrideLayout) {
    // Deep clone the base layout
    const mergedLayout = {
        ...baseLayout,
        attributes: baseLayout.attributes.map((attribute)=>({
                ...attribute
            }))
    };
    // Merge the attributes
    for (const attribute of overrideLayout?.attributes || []){
        const baseAttribute = mergedLayout.attributes.find((attr)=>attr.name === attribute.name);
        if (!baseAttribute) (0, _core.log).warn(`shader layout attribute ${attribute.name} not present in shader`);
        else {
            baseAttribute.type = attribute.type || baseAttribute.type;
            baseAttribute.stepMode = attribute.stepMode || baseAttribute.stepMode;
        }
    }
    return mergedLayout;
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../helpers/get-shader-layout.js":"l7bTj","../converters/device-parameters.js":"o0nGc","../helpers/set-uniform.js":"7uiz7","../../utils/split-uniforms-and-bindings.js":"liLld","./webgl-buffer.js":"fIu5h","./webgl-framebuffer.js":"bYeR6","./webgl-texture.js":"YIvAu","./webgl-texture-view.js":"lPJVv","../helpers/webgl-topology-utils.js":"eQ8Qb","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"l7bTj":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Extract metadata describing binding information for a program's shaders
 * Note: `linkProgram()` needs to have been called
 * (although linking does not need to have been successful).
 */ parcelHelpers.export(exports, "getShaderLayoutFromGLSL", ()=>getShaderLayoutFromGLSL);
var _constants = require("@luma.gl/constants");
var _decodeWebglTypesJs = require("./decode-webgl-types.js");
function getShaderLayoutFromGLSL(gl, program) {
    const shaderLayout = {
        attributes: [],
        bindings: []
    };
    shaderLayout.attributes = readAttributeDeclarations(gl, program);
    // Uniform blocks
    const uniformBlocks = readUniformBlocks(gl, program);
    for (const uniformBlock of uniformBlocks){
        const uniforms = uniformBlock.uniforms.map((uniform)=>({
                name: uniform.name,
                format: uniform.format,
                byteOffset: uniform.byteOffset,
                byteStride: uniform.byteStride,
                arrayLength: uniform.arrayLength
            }));
        shaderLayout.bindings.push({
            type: 'uniform',
            name: uniformBlock.name,
            group: 0,
            location: uniformBlock.location,
            visibility: (uniformBlock.vertex ? 0x1 : 0) & (uniformBlock.fragment ? 0x2 : 0),
            minBindingSize: uniformBlock.byteLength,
            uniforms
        });
    }
    const uniforms = readUniformBindings(gl, program);
    let textureUnit = 0;
    for (const uniform of uniforms)if ((0, _decodeWebglTypesJs.isSamplerUniform)(uniform.type)) {
        const { viewDimension, sampleType } = getSamplerInfo(uniform.type);
        shaderLayout.bindings.push({
            type: 'texture',
            name: uniform.name,
            group: 0,
            location: textureUnit,
            viewDimension,
            sampleType
        });
        // @ts-expect-error
        uniform.textureUnit = textureUnit;
        textureUnit += 1;
    }
    if (uniforms.length) shaderLayout.uniforms = uniforms;
    // Varyings
    const varyings = readVaryings(gl, program);
    // Note - samplers are always in unform bindings, even if uniform blocks are used
    if (varyings?.length) shaderLayout.varyings = varyings;
    return shaderLayout;
}
// HELPERS
/**
 * Extract info about all transform feedback varyings
 *
 * linkProgram needs to have been called, although linking does not need to have been successful
 */ function readAttributeDeclarations(gl, program) {
    const attributes = [];
    const count = gl.getProgramParameter(program, 35721);
    for(let index = 0; index < count; index++){
        const activeInfo = gl.getActiveAttrib(program, index);
        if (!activeInfo) throw new Error('activeInfo');
        const { name, type: compositeType /* , size*/  } = activeInfo;
        const location = gl.getAttribLocation(program, name);
        // Add only user provided attributes, for built-in attributes like `gl_InstanceID` location will be < 0
        if (location >= 0) {
            const { attributeType } = (0, _decodeWebglTypesJs.decodeGLAttributeType)(compositeType);
            // Whether an attribute is instanced is essentially fixed by the structure of the shader code,
            // so it is arguably a static property of the shader.
            // There is no hint in the shader declarations
            // Heuristic: Any attribute name containing the word "instance" will be assumed to be instanced
            const stepMode = /instance/i.test(name) ? 'instance' : 'vertex';
            attributes.push({
                name,
                location,
                stepMode,
                type: attributeType
            });
        }
    }
    // Sort by declaration order
    attributes.sort((a, b)=>a.location - b.location);
    return attributes;
}
/**
 * Extract info about all transform feedback varyings
 *
 * linkProgram needs to have been called, although linking does not need to have been successful
 */ function readVaryings(gl, program) {
    const varyings = [];
    const count = gl.getProgramParameter(program, 35971);
    for(let location = 0; location < count; location++){
        const activeInfo = gl.getTransformFeedbackVarying(program, location);
        if (!activeInfo) throw new Error('activeInfo');
        const { name, type: compositeType, size } = activeInfo;
        const { glType, components } = (0, _decodeWebglTypesJs.decodeGLUniformType)(compositeType);
        const varying = {
            location,
            name,
            type: glType,
            size: size * components
        }; // Base values
        varyings.push(varying);
    }
    varyings.sort((a, b)=>a.location - b.location);
    return varyings;
}
/**
 * Extract info about all uniforms
 *
 * Query uniform locations and build name to setter map.
 */ function readUniformBindings(gl, program) {
    const uniforms = [];
    const uniformCount = gl.getProgramParameter(program, 35718);
    for(let i = 0; i < uniformCount; i++){
        const activeInfo = gl.getActiveUniform(program, i);
        if (!activeInfo) throw new Error('activeInfo');
        const { name: rawName, size, type } = activeInfo;
        const { name, isArray } = parseUniformName(rawName);
        let webglLocation = gl.getUniformLocation(program, name);
        const uniformInfo = {
            // WebGL locations are uniquely typed but just numbers
            location: webglLocation,
            name,
            size,
            type,
            isArray
        };
        uniforms.push(uniformInfo);
        // Array (e.g. matrix) uniforms can occupy several 4x4 byte banks
        if (uniformInfo.size > 1) for(let j = 0; j < uniformInfo.size; j++){
            const elementName = `${name}[${j}]`;
            webglLocation = gl.getUniformLocation(program, elementName);
            const arrayElementUniformInfo = {
                ...uniformInfo,
                name: elementName,
                location: webglLocation
            };
            uniforms.push(arrayElementUniformInfo);
        }
    }
    return uniforms;
}
/**
 * Extract info about all "active" uniform blocks
 * @note In WebGL, "active" just means that unused (inactive) blocks may have been optimized away during linking)
 */ function readUniformBlocks(gl, program) {
    const getBlockParameter = (blockIndex, pname)=>gl.getActiveUniformBlockParameter(program, blockIndex, pname);
    const uniformBlocks = [];
    const blockCount = gl.getProgramParameter(program, 35382);
    for(let blockIndex = 0; blockIndex < blockCount; blockIndex++){
        const blockInfo = {
            name: gl.getActiveUniformBlockName(program, blockIndex) || '',
            location: getBlockParameter(blockIndex, 35391),
            byteLength: getBlockParameter(blockIndex, 35392),
            vertex: getBlockParameter(blockIndex, 35396),
            fragment: getBlockParameter(blockIndex, 35398),
            uniformCount: getBlockParameter(blockIndex, 35394),
            uniforms: []
        };
        const uniformIndices = getBlockParameter(blockIndex, 35395) || [];
        const uniformType = gl.getActiveUniforms(program, uniformIndices, 35383); // Array of GLenum indicating the types of the uniforms.
        const uniformArrayLength = gl.getActiveUniforms(program, uniformIndices, 35384); // Array of GLuint indicating the sizes of the uniforms.
        // const uniformBlockIndex = gl.getActiveUniforms(
        //   program,
        //   uniformIndices,
        //   GL.UNIFORM_BLOCK_INDEX
        // ); // Array of GLint indicating the block indices of the uniforms.
        const uniformOffset = gl.getActiveUniforms(program, uniformIndices, 35387); // Array of GLint indicating the uniform buffer offsets.
        const uniformStride = gl.getActiveUniforms(program, uniformIndices, 35388); // Array of GLint indicating the strides between the elements.
        // const uniformMatrixStride = gl.getActiveUniforms(
        //   program,
        //   uniformIndices,
        //   GL.UNIFORM_MATRIX_STRIDE
        // ); // Array of GLint indicating the strides between columns of a column-major matrix or a row-major matrix.
        // const uniformRowMajor = gl.getActiveUniforms(program, uniformIndices, GL.UNIFORM_IS_ROW_MAJOR);
        for(let i = 0; i < blockInfo.uniformCount; ++i){
            const activeInfo = gl.getActiveUniform(program, uniformIndices[i]);
            if (!activeInfo) throw new Error('activeInfo');
            blockInfo.uniforms.push({
                name: activeInfo.name,
                format: (0, _decodeWebglTypesJs.decodeGLUniformType)(uniformType[i]).format,
                type: uniformType[i],
                arrayLength: uniformArrayLength[i],
                byteOffset: uniformOffset[i],
                byteStride: uniformStride[i]
            });
        }
        uniformBlocks.push(blockInfo);
    }
    uniformBlocks.sort((a, b)=>a.location - b.location);
    return uniformBlocks;
}
/**
 * TOOD - compare with a above, confirm copy, then delete
  const bindings: Binding[] = [];
  const count = gl.getProgramParameter(program, gl.ACTIVE_UNIFORM_BLOCKS);
  for (let blockIndex = 0; blockIndex < count; blockIndex++) {
    const vertex = gl.getActiveUniformBlockParameter(program, blockIndex, gl.UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER),
    const fragment = gl.getActiveUniformBlockParameter(program, blockIndex, gl.UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER),
    const visibility = (vertex) + (fragment);
    const binding: BufferBinding = {
      location: gl.getActiveUniformBlockParameter(program, blockIndex, gl.UNIFORM_BLOCK_BINDING),
      // name: gl.getActiveUniformBlockName(program, blockIndex),
      type: 'uniform',
      visibility,
      minBindingSize: gl.getActiveUniformBlockParameter(program, blockIndex, gl.UNIFORM_BLOCK_DATA_SIZE),
      // uniformCount: gl.getActiveUniformBlockParameter(program, blockIndex, gl.UNIFORM_BLOCK_ACTIVE_UNIFORMS),
      // uniformIndices: gl.getActiveUniformBlockParameter(program, blockIndex, gl.UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES),
    }
    bindings.push(binding);
  }
*/ const SAMPLER_UNIFORMS_GL_TO_GPU = {
    [35678]: [
        '2d',
        'float'
    ],
    [35680]: [
        'cube',
        'float'
    ],
    [35679]: [
        '3d',
        'float'
    ],
    [35682]: [
        '3d',
        'depth'
    ],
    [36289]: [
        '2d-array',
        'float'
    ],
    [36292]: [
        '2d-array',
        'depth'
    ],
    [36293]: [
        'cube',
        'float'
    ],
    [36298]: [
        '2d',
        'sint'
    ],
    [36299]: [
        '3d',
        'sint'
    ],
    [36300]: [
        'cube',
        'sint'
    ],
    [36303]: [
        '2d-array',
        'uint'
    ],
    [36306]: [
        '2d',
        'uint'
    ],
    [36307]: [
        '3d',
        'uint'
    ],
    [36308]: [
        'cube',
        'uint'
    ],
    [36311]: [
        '2d-array',
        'uint'
    ]
};
function getSamplerInfo(type) {
    const sampler = SAMPLER_UNIFORMS_GL_TO_GPU[type];
    if (!sampler) throw new Error('sampler');
    const [viewDimension, sampleType] = sampler;
    return {
        viewDimension,
        sampleType
    };
}
// HELPERS
function parseUniformName(name) {
    // Shortcut to avoid redundant or bad matches
    if (name[name.length - 1] !== ']') return {
        name,
        length: 1,
        isArray: false
    };
    // if array name then clean the array brackets
    const UNIFORM_NAME_REGEXP = /([^[]*)(\[[0-9]+\])?/;
    const matches = UNIFORM_NAME_REGEXP.exec(name);
    if (!matches || matches.length < 2) throw new Error(`Failed to parse GLSL uniform name ${name}`);
    return {
        name: matches[1],
        length: matches[2] ? 1 : 0,
        isArray: Boolean(matches[2])
    };
}

},{"@luma.gl/constants":"9mN7r","./decode-webgl-types.js":"cc9BN","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cc9BN":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Check is uniform is of sampler type */ parcelHelpers.export(exports, "isSamplerUniform", ()=>isSamplerUniform);
/** Decomposes a composite type (GL.VEC3) into a basic type (GL.FLOAT) and components (3) */ parcelHelpers.export(exports, "decodeGLUniformType", ()=>decodeGLUniformType);
/** Decomposes a composite type (GL.VEC3) into a basic type (GL.FLOAT) and components (3) */ parcelHelpers.export(exports, "decodeGLAttributeType", ()=>decodeGLAttributeType);
/** Decomposes a composite type GL.VEC3 into a basic type (GL.FLOAT) and components (3) */ parcelHelpers.export(exports, "decomposeCompositeGLDataType", ()=>decomposeCompositeGLDataType);
parcelHelpers.export(exports, "getCompositeGLDataType", ()=>getCompositeGLDataType);
var _constants = require("@luma.gl/constants");
function isSamplerUniform(type) {
    return SAMPLER_TYPES.includes(type);
}
const SAMPLER_TYPES = [
    35678,
    35680,
    35679,
    35682,
    36289,
    36292,
    36293,
    36298,
    36299,
    36300,
    36303,
    36306,
    36307,
    36308,
    36311
];
// Composite types table
const COMPOSITE_GL_TYPES = {
    [5126]: [
        5126,
        1,
        'float',
        'f32',
        'float32'
    ],
    [35664]: [
        5126,
        2,
        'vec2',
        'vec2<f32>',
        'float32x2'
    ],
    [35665]: [
        5126,
        3,
        'vec3',
        'vec3<f32>',
        'float32x3'
    ],
    [35666]: [
        5126,
        4,
        'vec4',
        'vec4<f32>',
        'float32x4'
    ],
    [5124]: [
        5124,
        1,
        'int',
        'i32',
        'sint32'
    ],
    [35667]: [
        5124,
        2,
        'ivec2',
        'vec2<i32>',
        'sint32x2'
    ],
    [35668]: [
        5124,
        3,
        'ivec3',
        'vec3<i32>',
        'sint32x3'
    ],
    [35669]: [
        5124,
        4,
        'ivec4',
        'vec4<i32>',
        'sint32x4'
    ],
    [5125]: [
        5125,
        1,
        'uint',
        'u32',
        'uint32'
    ],
    [36294]: [
        5125,
        2,
        'uvec2',
        'vec2<u32>',
        'uint32x2'
    ],
    [36295]: [
        5125,
        3,
        'uvec3',
        'vec3<u32>',
        'uint32x3'
    ],
    [36296]: [
        5125,
        4,
        'uvec4',
        'vec4<u32>',
        'uint32x4'
    ],
    [35670]: [
        5126,
        1,
        'bool',
        'f32',
        'float32'
    ],
    [35671]: [
        5126,
        2,
        'bvec2',
        'vec2<f32>',
        'float32x2'
    ],
    [35672]: [
        5126,
        3,
        'bvec3',
        'vec3<f32>',
        'float32x3'
    ],
    [35673]: [
        5126,
        4,
        'bvec4',
        'vec4<f32>',
        'float32x4'
    ],
    // TODO - are sizes/components below correct?
    [35674]: [
        5126,
        8,
        'mat2',
        'mat2x2<f32>'
    ],
    [35685]: [
        5126,
        8,
        'mat2x3',
        'mat2x3<f32>'
    ],
    [35686]: [
        5126,
        8,
        'mat2x4',
        'mat2x4<f32>'
    ],
    [35687]: [
        5126,
        12,
        'mat3x2',
        'mat3x2<f32>'
    ],
    [35675]: [
        5126,
        12,
        'mat3',
        'mat3x3<f32>'
    ],
    [35688]: [
        5126,
        12,
        'mat3x4',
        'mat3x4<f32>'
    ],
    [35689]: [
        5126,
        16,
        'mat4x2',
        'mat4x2<f32>'
    ],
    [35690]: [
        5126,
        16,
        'mat4x3',
        'mat4x3<f32>'
    ],
    [35676]: [
        5126,
        16,
        'mat4',
        'mat4x4<f32>'
    ] // 16
};
function decodeGLUniformType(glUniformType) {
    const typeAndSize = COMPOSITE_GL_TYPES[glUniformType];
    if (!typeAndSize) throw new Error('uniform');
    const [glType, components, , format] = typeAndSize;
    return {
        format,
        components,
        glType
    };
}
function decodeGLAttributeType(glAttributeType) {
    const typeAndSize = COMPOSITE_GL_TYPES[glAttributeType];
    if (!typeAndSize) throw new Error('attribute');
    const [, components, , shaderType, vertexFormat] = typeAndSize;
    // TODO sanity - if (shaderType.startsWith('mat' ...))
    const attributeType = shaderType;
    return {
        attributeType,
        vertexFormat,
        components
    }; // , glType};
}
function decomposeCompositeGLDataType(compositeGLDataType) {
    const typeAndSize = COMPOSITE_GL_TYPES[compositeGLDataType];
    if (!typeAndSize) return null;
    const [type, components] = typeAndSize;
    return {
        type,
        components
    };
}
function getCompositeGLDataType(type, components) {
    switch(type){
        case 5120:
        case 5121:
        case 5122:
        case 5123:
            type = 5126;
            break;
        default:
    }
    for(const glType in COMPOSITE_GL_TYPES){
        const [compType, compComponents, name] = COMPOSITE_GL_TYPES[glType];
        if (compType === type && compComponents === components) return {
            glType: Number(glType),
            name
        };
    }
    return null;
}

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7uiz7":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Set a raw uniform (without type conversion and caching) */ /* eslint-disable max-len */ parcelHelpers.export(exports, "setUniform", ()=>setUniform);
var _constants = require("@luma.gl/constants");
function setUniform(gl, location, type, value) {
    const gl2 = gl;
    // Prepare the value for WebGL setters
    let uniformValue = value;
    if (uniformValue === true) uniformValue = 1;
    if (uniformValue === false) uniformValue = 0;
    const arrayValue = typeof uniformValue === 'number' ? [
        uniformValue
    ] : uniformValue;
    // prettier-ignore
    switch(type){
        case 35678:
        case 35680:
        case 35679:
        case 35682:
        case 36289:
        case 36292:
        case 36293:
        case 36298:
        case 36299:
        case 36300:
        case 36303:
        case 36306:
        case 36307:
        case 36308:
        case 36311:
            if (typeof value !== 'number') throw new Error('samplers must be set to integers');
            return gl.uniform1i(location, value);
        case 5126:
            return gl.uniform1fv(location, arrayValue);
        case 35664:
            return gl.uniform2fv(location, arrayValue);
        case 35665:
            return gl.uniform3fv(location, arrayValue);
        case 35666:
            return gl.uniform4fv(location, arrayValue);
        case 5124:
            return gl.uniform1iv(location, arrayValue);
        case 35667:
            return gl.uniform2iv(location, arrayValue);
        case 35668:
            return gl.uniform3iv(location, arrayValue);
        case 35669:
            return gl.uniform4iv(location, arrayValue);
        case 35670:
            return gl.uniform1iv(location, arrayValue);
        case 35671:
            return gl.uniform2iv(location, arrayValue);
        case 35672:
            return gl.uniform3iv(location, arrayValue);
        case 35673:
            return gl.uniform4iv(location, arrayValue);
        // WEBGL2 - unsigned integers
        case 5125:
            return gl2.uniform1uiv(location, arrayValue, 1);
        case 36294:
            return gl2.uniform2uiv(location, arrayValue, 2);
        case 36295:
            return gl2.uniform3uiv(location, arrayValue, 3);
        case 36296:
            return gl2.uniform4uiv(location, arrayValue, 4);
        // WebGL2 - quadratic matrices
        // false: don't transpose the matrix
        case 35674:
            return gl.uniformMatrix2fv(location, false, arrayValue);
        case 35675:
            return gl.uniformMatrix3fv(location, false, arrayValue);
        case 35676:
            return gl.uniformMatrix4fv(location, false, arrayValue);
        // WebGL2 - rectangular matrices
        case 35685:
            return gl2.uniformMatrix2x3fv(location, false, arrayValue);
        case 35686:
            return gl2.uniformMatrix2x4fv(location, false, arrayValue);
        case 35687:
            return gl2.uniformMatrix3x2fv(location, false, arrayValue);
        case 35688:
            return gl2.uniformMatrix3x4fv(location, false, arrayValue);
        case 35689:
            return gl2.uniformMatrix4x2fv(location, false, arrayValue);
        case 35690:
            return gl2.uniformMatrix4x3fv(location, false, arrayValue);
    }
    throw new Error('Illegal uniform');
}

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"liLld":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUniformValue", ()=>isUniformValue);
parcelHelpers.export(exports, "splitUniformsAndBindings", ()=>splitUniformsAndBindings);
var _types = require("@math.gl/types");
function isUniformValue(value) {
    return (0, _types.isNumericArray)(value) !== null || typeof value === 'number' || typeof value === 'boolean';
}
function splitUniformsAndBindings(uniforms) {
    const result = {
        bindings: {},
        uniforms: {}
    };
    Object.keys(uniforms).forEach((name)=>{
        const uniform = uniforms[name];
        if (isUniformValue(uniform)) result.uniforms[name] = uniform;
        else result.bindings[name] = uniform;
    });
    return result;
}

},{"@math.gl/types":"cxF2f","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eQ8Qb":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Counts the number of complete primitives given a number of vertices and a drawMode
parcelHelpers.export(exports, "getPrimitiveDrawMode", ()=>getPrimitiveDrawMode);
// Counts the number of complete "primitives" given a number of vertices and a drawMode
parcelHelpers.export(exports, "getPrimitiveCount", ()=>getPrimitiveCount);
// Counts the number of vertices after splitting the vertex stream into separate "primitives"
parcelHelpers.export(exports, "getVertexCount", ()=>getVertexCount);
/** Get the primitive type for draw */ parcelHelpers.export(exports, "getGLDrawMode", ()=>getGLDrawMode);
/** Get the primitive type for transform feedback */ parcelHelpers.export(exports, "getGLPrimitive", ()=>getGLPrimitive);
var _constants = require("@luma.gl/constants");
function getPrimitiveDrawMode(drawMode) {
    switch(drawMode){
        case 0:
            return 0;
        case 1:
            return 1;
        case 3:
            return 1;
        case 2:
            return 1;
        case 4:
            return 4;
        case 5:
            return 4;
        case 6:
            return 4;
        default:
            throw new Error('drawMode');
    }
}
function getPrimitiveCount(options) {
    const { drawMode, vertexCount } = options;
    switch(drawMode){
        case 0:
        case 2:
            return vertexCount;
        case 1:
            return vertexCount / 2;
        case 3:
            return vertexCount - 1;
        case 4:
            return vertexCount / 3;
        case 5:
        case 6:
            return vertexCount - 2;
        default:
            throw new Error('drawMode');
    }
}
function getVertexCount(options) {
    const { drawMode, vertexCount } = options;
    const primitiveCount = getPrimitiveCount({
        drawMode,
        vertexCount
    });
    switch(getPrimitiveDrawMode(drawMode)){
        case 0:
            return primitiveCount;
        case 1:
            return primitiveCount * 2;
        case 4:
            return primitiveCount * 3;
        default:
            throw new Error('drawMode');
    }
}
function getGLDrawMode(topology) {
    // prettier-ignore
    switch(topology){
        case 'point-list':
            return 0;
        case 'line-list':
            return 1;
        case 'line-strip':
            return 3;
        case 'triangle-list':
            return 4;
        case 'triangle-strip':
            return 5;
        default:
            throw new Error(topology);
    }
}
function getGLPrimitive(topology) {
    // prettier-ignore
    switch(topology){
        case 'point-list':
            return 0;
        case 'line-list':
            return 1;
        case 'line-strip':
            return 1;
        case 'triangle-list':
            return 4;
        case 'triangle-strip':
            return 4;
        default:
            throw new Error(topology);
    }
}

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bUzlw":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEBGLCommandEncoder", ()=>WEBGLCommandEncoder);
var _core = require("@luma.gl/core");
var _webglCommandBufferJs = require("./webgl-command-buffer.js");
class WEBGLCommandEncoder extends (0, _core.CommandEncoder) {
    device;
    commandBuffer;
    constructor(device, props){
        super(device, props);
        this.device = device;
        this.commandBuffer = new (0, _webglCommandBufferJs.WEBGLCommandBuffer)(device);
    }
    destroy() {}
    finish() {
        this.commandBuffer.submitCommands();
    }
    // beginRenderPass(GPURenderPassDescriptor descriptor): GPURenderPassEncoder;
    // beginComputePass(optional GPUComputePassDescriptor descriptor = {}): GPUComputePassEncoder;
    // finish(options?: {id?: string}): GPUCommandBuffer;
    copyBufferToBuffer(options) {
        this.commandBuffer.commands.push({
            name: 'copy-buffer-to-buffer',
            options
        });
    }
    copyBufferToTexture(options) {
        this.commandBuffer.commands.push({
            name: 'copy-buffer-to-texture',
            options
        });
    }
    copyTextureToBuffer(options) {
        this.commandBuffer.commands.push({
            name: 'copy-texture-to-buffer',
            options
        });
    }
    copyTextureToTexture(options) {
        this.commandBuffer.commands.push({
            name: 'copy-texture-to-texture',
            options
        });
    }
    // clearTexture(options: ClearTextureOptions): void {
    //   this.commandBuffer.commands.push({name: 'copy-texture-to-texture', options});
    // }
    pushDebugGroup(groupLabel) {}
    popDebugGroup() {}
    insertDebugMarker(markerLabel) {}
    resolveQuerySet(querySet, destination, options) {}
}

},{"@luma.gl/core":"7TxCR","./webgl-command-buffer.js":"eI1Uh","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eI1Uh":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEBGLCommandBuffer", ()=>WEBGLCommandBuffer);
/** Clear one mip level of a texture *
function _clearTexture(device: WebGLDevice, options: ClearTextureOptions) {
  const BORDER = 0;
  const {dimension, width, height, depth = 0, mipLevel = 0} = options;
  const {glInternalFormat, glFormat, glType, compressed} = options;
  const glTarget = getWebGLCubeFaceTarget(options.glTarget, dimension, depth);

  switch (dimension) {
    case '2d-array':
    case '3d':
      if (compressed) {
        // prettier-ignore
        device.gl.compressedTexImage3D(glTarget, mipLevel, glInternalFormat, width, height, depth, BORDER, null);
      } else {
        // prettier-ignore
        device.gl.texImage3D( glTarget, mipLevel, glInternalFormat, width, height, depth, BORDER, glFormat, glType, null);
      }
      break;

    case '2d':
    case 'cube':
      if (compressed) {
        // prettier-ignore
        device.gl.compressedTexImage2D(glTarget, mipLevel, glInternalFormat, width, height, BORDER, null);
      } else {
        // prettier-ignore
        device.gl.texImage2D(glTarget, mipLevel, glInternalFormat, width, height, BORDER, glFormat, glType, null);
      }
      break;

    default:
      throw new Error(dimension);
  }
}
  */ // function _readTexture(device: WebGLDevice, options: CopyTextureToBufferOptions) {}
// HELPERS
/**
 * In WebGL, cube maps specify faces by overriding target instead of using the depth parameter.
 * @note We still bind the texture using GL.TEXTURE_CUBE_MAP, but we need to use the face-specific target when setting mip levels.
 * @returns glTarget unchanged, if dimension !== 'cube'.
 */ parcelHelpers.export(exports, "getWebGLCubeFaceTarget", ()=>getWebGLCubeFaceTarget);
/**
 * Returns number of components in a specific readPixels WebGL format
 * @todo use shadertypes utils instead?
 */ parcelHelpers.export(exports, "glFormatToComponents", ()=>glFormatToComponents);
/**
 * Return byte count for given readPixels WebGL type
 * @todo use shadertypes utils instead?
 */ parcelHelpers.export(exports, "glTypeToBytes", ()=>glTypeToBytes);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _webglTextureJs = require("./webgl-texture.js");
var _webglTextureTableJs = require("../converters/webgl-texture-table.js");
class WEBGLCommandBuffer extends (0, _core.CommandBuffer) {
    device;
    commands = [];
    constructor(device){
        super(device, {});
        this.device = device;
    }
    submitCommands(commands = this.commands) {
        for (const command of commands)switch(command.name){
            case 'copy-buffer-to-buffer':
                _copyBufferToBuffer(this.device, command.options);
                break;
            case 'copy-buffer-to-texture':
                _copyBufferToTexture(this.device, command.options);
                break;
            case 'copy-texture-to-buffer':
                _copyTextureToBuffer(this.device, command.options);
                break;
            case 'copy-texture-to-texture':
                _copyTextureToTexture(this.device, command.options);
                break;
            // case 'clear-texture':
            //   _clearTexture(this.device, command.options);
            //   break;
            default:
                throw new Error(command.name);
        }
    }
}
function _copyBufferToBuffer(device, options) {
    const source = options.sourceBuffer;
    const destination = options.destinationBuffer;
    // {In WebGL2 we can p}erform the copy on the GPU
    // Use GL.COPY_READ_BUFFER+GL.COPY_WRITE_BUFFER avoid disturbing other targets and locking type
    device.gl.bindBuffer(36662, source.handle);
    device.gl.bindBuffer(36663, destination.handle);
    device.gl.copyBufferSubData(36662, 36663, options.sourceOffset ?? 0, options.destinationOffset ?? 0, options.size);
    device.gl.bindBuffer(36662, null);
    device.gl.bindBuffer(36663, null);
}
/**
 * Copies data from a Buffer object into a Texture object
 * NOTE: doesn't wait for copy to be complete
 */ function _copyBufferToTexture(device, options) {
    throw new Error('Not implemented');
}
/**
 * Copies data from a Texture object into a Buffer object.
 * NOTE: doesn't wait for copy to be complete
 */ function _copyTextureToBuffer(device, options) {
    const { /** Texture to copy to/from. */ sourceTexture, /**  Mip-map level of the texture to copy to/from. (Default 0) */ mipLevel = 0, /** Defines which aspects of the texture to copy to/from. */ aspect = 'all', /** Width to copy */ width = options.sourceTexture.width, /** Height to copy */ height = options.sourceTexture.height, depthOrArrayLayers = 0, /** Defines the origin of the copy - the minimum corner of the texture sub-region to copy to/from. */ origin = [
        0,
        0
    ], /** Destination buffer */ destinationBuffer, /** Offset, in bytes, from the beginning of the buffer to the start of the image data (default 0) */ byteOffset = 0, /**
     * The stride, in bytes, between the beginning of each block row and the subsequent block row.
     * Required if there are multiple block rows (i.e. the copy height or depth is more than one block).
     */ bytesPerRow, /**
     * Number of block rows per single image of the texture.
     * rowsPerImage &times; bytesPerRow is the stride, in bytes, between the beginning of each image of data and the subsequent image.
     * Required if there are multiple images (i.e. the copy depth is more than one).
     */ rowsPerImage } = options;
    // TODO - Not possible to read just stencil or depth part in WebGL?
    if (aspect !== 'all') throw new Error('aspect not supported in WebGL');
    // TODO - mipLevels are set when attaching texture to framebuffer
    if (mipLevel !== 0 || depthOrArrayLayers !== 0 || bytesPerRow || rowsPerImage) throw new Error('not implemented');
    // Asynchronous read (PIXEL_PACK_BUFFER) is WebGL2 only feature
    const { framebuffer, destroyFramebuffer } = getFramebuffer(sourceTexture);
    let prevHandle;
    try {
        const webglBuffer = destinationBuffer;
        const sourceWidth = width || framebuffer.width;
        const sourceHeight = height || framebuffer.height;
        const sourceParams = (0, _webglTextureTableJs.getTextureFormatWebGL)(framebuffer.colorAttachments[0].texture.props.format);
        const sourceFormat = sourceParams.format;
        const sourceType = sourceParams.type;
        // if (!target) {
        //   // Create new buffer with enough size
        //   const components = glFormatToComponents(sourceFormat);
        //   const byteCount = glTypeToBytes(sourceType);
        //   const byteLength = byteOffset + sourceWidth * sourceHeight * components * byteCount;
        //   target = device.createBuffer({byteLength});
        // }
        device.gl.bindBuffer(35051, webglBuffer.handle);
        // @ts-expect-error native bindFramebuffer is overridden by our state tracker
        prevHandle = device.gl.bindFramebuffer(36160, framebuffer.handle);
        device.gl.readPixels(origin[0], origin[1], sourceWidth, sourceHeight, sourceFormat, sourceType, byteOffset);
    } finally{
        device.gl.bindBuffer(35051, null);
        // prevHandle may be unassigned if the try block failed before binding
        if (prevHandle !== undefined) device.gl.bindFramebuffer(36160, prevHandle);
        if (destroyFramebuffer) framebuffer.destroy();
    }
}
/**
 * Copies data from a Framebuffer or a Texture object into a Buffer object.
 * NOTE: doesn't wait for copy to be complete, it programs GPU to perform a DMA transfer.
export function readPixelsToBuffer(
  source: Framebuffer | Texture,
  options?: {
    sourceX?: number;
    sourceY?: number;
    sourceFormat?: number;
    target?: Buffer; // A new Buffer object is created when not provided.
    targetByteOffset?: number; // byte offset in buffer object
    // following parameters are auto deduced if not provided
    sourceWidth?: number;
    sourceHeight?: number;
    sourceType?: number;
  }
): Buffer
 */ /**
 * Copy a rectangle from a Framebuffer or Texture object into a texture (at an offset)
 */ // eslint-disable-next-line complexity, max-statements
function _copyTextureToTexture(device, options) {
    const { /** Texture to copy to/from. */ sourceTexture, /**  Mip-map level of the texture to copy to (Default 0) */ destinationMipLevel = 0, /** Defines which aspects of the texture to copy to/from. */ // aspect = 'all',
    /** Defines the origin of the copy - the minimum corner of the texture sub-region to copy from. */ origin = [
        0,
        0
    ], /** Defines the origin of the copy - the minimum corner of the texture sub-region to copy to. */ destinationOrigin = [
        0,
        0
    ], /** Texture to copy to/from. */ destinationTexture } = options;
    let { width = options.destinationTexture.width, height = options.destinationTexture.height } = options;
    const { framebuffer, destroyFramebuffer } = getFramebuffer(sourceTexture);
    const [sourceX, sourceY] = origin;
    const [destinationX, destinationY, destinationZ] = destinationOrigin;
    // @ts-expect-error native bindFramebuffer is overridden by our state tracker
    const prevHandle = device.gl.bindFramebuffer(36160, framebuffer.handle);
    // TODO - support gl.readBuffer (WebGL2 only)
    // const prevBuffer = gl.readBuffer(attachment);
    let texture = null;
    let textureTarget;
    if (destinationTexture instanceof (0, _webglTextureJs.WEBGLTexture)) {
        texture = destinationTexture;
        width = Number.isFinite(width) ? width : texture.width;
        height = Number.isFinite(height) ? height : texture.height;
        texture.bind(0);
        textureTarget = texture.glTarget;
    } else throw new Error('invalid destination');
    switch(textureTarget){
        case 3553:
        case 34067:
            device.gl.copyTexSubImage2D(textureTarget, destinationMipLevel, destinationX, destinationY, sourceX, sourceY, width, height);
            break;
        case 35866:
        case 32879:
            device.gl.copyTexSubImage3D(textureTarget, destinationMipLevel, destinationX, destinationY, destinationZ, sourceX, sourceY, width, height);
            break;
        default:
    }
    if (texture) texture.unbind();
    device.gl.bindFramebuffer(36160, prevHandle);
    if (destroyFramebuffer) framebuffer.destroy();
}
function getWebGLCubeFaceTarget(glTarget, dimension, level) {
    return dimension === 'cube' ? 34069 + level : glTarget;
}
/** Wrap a texture in a framebuffer so that we can use WebGL APIs that work on framebuffers */ function getFramebuffer(source) {
    if (source instanceof (0, _core.Texture)) {
        const { width, height, id } = source;
        const framebuffer = source.device.createFramebuffer({
            id: `framebuffer-for-${id}`,
            width,
            height,
            colorAttachments: [
                source
            ]
        });
        return {
            framebuffer,
            destroyFramebuffer: true
        };
    }
    return {
        framebuffer: source,
        destroyFramebuffer: false
    };
}
function glFormatToComponents(format) {
    switch(format){
        case 6406:
        case 33326:
        case 6403:
            return 1;
        case 33328:
        case 33319:
            return 2;
        case 6407:
        case 34837:
            return 3;
        case 6408:
        case 34836:
            return 4;
        // TODO: Add support for additional WebGL2 formats
        default:
            throw new Error('GLFormat');
    }
}
function glTypeToBytes(type) {
    switch(type){
        case 5121:
            return 1;
        case 33635:
        case 32819:
        case 32820:
            return 2;
        case 5126:
            return 4;
        // TODO: Add support for additional WebGL2 types
        default:
            throw new Error('GLType');
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","./webgl-texture.js":"YIvAu","../converters/webgl-texture-table.js":"4LosF","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3OAtg":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** VertexArrayObject wrapper */ parcelHelpers.export(exports, "WEBGLVertexArray", ()=>WEBGLVertexArray);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _env = require("@probe.gl/env");
var _vertexFormatsJs = require("../converters/vertex-formats.js");
var _fillArrayJs = require("../../utils/fill-array.js");
class WEBGLVertexArray extends (0, _core.VertexArray) {
    get [Symbol.toStringTag]() {
        return 'VertexArray';
    }
    device;
    handle;
    /** Attribute 0 buffer constant */ buffer = null;
    bufferValue = null;
    /** * Attribute 0 can not be disable on most desktop OpenGL based browsers */ static isConstantAttributeZeroSupported(device) {
        return (0, _env.getBrowser)() === 'Chrome';
    }
    // Create a VertexArray
    constructor(device, props){
        super(device, props);
        this.device = device;
        this.handle = this.device.gl.createVertexArray();
    }
    destroy() {
        super.destroy();
        if (this.buffer) this.buffer?.destroy();
        if (this.handle) {
            this.device.gl.deleteVertexArray(this.handle);
            // @ts-expect-error read-only/undefined
            this.handle = undefined;
        }
    // Auto-delete elements?
    // return [this.elements];
    }
    /**
    // Set (bind/unbind) an elements buffer, for indexed rendering.
    // Must be a Buffer bound to GL.ELEMENT_ARRAY_BUFFER or null. Constants not supported
     *
     * @param elementBuffer
     */ setIndexBuffer(indexBuffer) {
        const buffer = indexBuffer;
        // Explicitly allow `null` to support clearing the index buffer
        if (buffer && buffer.glTarget !== 34963) throw new Error('Use .setBuffer()');
        // In WebGL The GL.ELEMENT_ARRAY_BUFFER_BINDING is stored on the VertexArrayObject
        this.device.gl.bindVertexArray(this.handle);
        this.device.gl.bindBuffer(34963, buffer ? buffer.handle : null);
        this.indexBuffer = buffer;
        // Unbind to prevent unintended changes to the VAO.
        this.device.gl.bindVertexArray(null);
    }
    /** Set a location in vertex attributes array to a buffer, enables the location, sets divisor */ setBuffer(location, attributeBuffer) {
        const buffer = attributeBuffer;
        // Sanity check target
        if (buffer.glTarget === 34963) throw new Error('Use .setIndexBuffer()');
        const { size, type, stride, offset, normalized, integer, divisor } = this._getAccessor(location);
        this.device.gl.bindVertexArray(this.handle);
        // A non-zero buffer object must be bound to the GL_ARRAY_BUFFER target
        this.device.gl.bindBuffer(34962, buffer.handle);
        // WebGL2 supports *integer* data formats, i.e. GPU will see integer values
        if (integer) this.device.gl.vertexAttribIPointer(location, size, type, stride, offset);
        else // Attaches ARRAY_BUFFER with specified buffer format to location
        this.device.gl.vertexAttribPointer(location, size, type, normalized, stride, offset);
        // Clear binding - keeping it may cause [.WebGL-0x12804417100]
        // GL_INVALID_OPERATION: A transform feedback buffer that would be written to is also bound to a non-transform-feedback target
        this.device.gl.bindBuffer(34962, null);
        // Mark as non-constant
        this.device.gl.enableVertexAttribArray(location);
        // Set the step mode 0=vertex, 1=instance
        this.device.gl.vertexAttribDivisor(location, divisor || 0);
        this.attributes[location] = buffer;
        // Unbind to prevent unintended changes to the VAO.
        this.device.gl.bindVertexArray(null);
    }
    /** Set a location in vertex attributes array to a constant value, disables the location */ setConstantWebGL(location, value) {
        this._enable(location, false);
        this.attributes[location] = value;
    }
    bindBeforeRender() {
        this.device.gl.bindVertexArray(this.handle);
        this._applyConstantAttributes();
    }
    unbindAfterRender() {
        // Unbind to prevent unintended changes to the VAO.
        this.device.gl.bindVertexArray(null);
    }
    // Internal methods
    /**
     * Constant attributes need to be reset before every draw call
     * Any attribute that is disabled in the current vertex array object
     * is read from the context's global constant value for that attribute location.
     * @note Constant attributes are only supported in WebGL, not in WebGPU
     */ _applyConstantAttributes() {
        for(let location = 0; location < this.maxVertexAttributes; ++location){
            const constant = this.attributes[location];
            // A typed array means this is a constant
            if (ArrayBuffer.isView(constant)) this.device.setConstantAttributeWebGL(location, constant);
        }
    }
    /**
     * Set a location in vertex attributes array to a buffer, enables the location, sets divisor
     * @note requires vertex array to be bound
     */ // protected _setAttributeLayout(location: number): void {
    //   const {size, type, stride, offset, normalized, integer, divisor} = this._getAccessor(location);
    //   // WebGL2 supports *integer* data formats, i.e. GPU will see integer values
    //   if (integer) {
    //     this.device.gl.vertexAttribIPointer(location, size, type, stride, offset);
    //   } else {
    //     // Attaches ARRAY_BUFFER with specified buffer format to location
    //     this.device.gl.vertexAttribPointer(location, size, type, normalized, stride, offset);
    //   }
    //   this.device.gl.vertexAttribDivisor(location, divisor || 0);
    // }
    /** Get an accessor from the  */ _getAccessor(location) {
        const attributeInfo = this.attributeInfos[location];
        if (!attributeInfo) throw new Error(`Unknown attribute location ${location}`);
        const glType = (0, _vertexFormatsJs.getGLFromVertexType)(attributeInfo.bufferDataType);
        return {
            size: attributeInfo.bufferComponents,
            type: glType,
            stride: attributeInfo.byteStride,
            offset: attributeInfo.byteOffset,
            normalized: attributeInfo.normalized,
            // it is the shader attribute declaration, not the vertex memory format,
            // that determines if the data in the buffer will be treated as integers.
            //
            // Also note that WebGL supports assigning non-normalized integer data to floating point attributes,
            // but as far as we can tell, WebGPU does not.
            integer: attributeInfo.integer,
            divisor: attributeInfo.stepMode === 'instance' ? 1 : 0
        };
    }
    /**
     * Enabling an attribute location makes it reference the currently bound buffer
     * Disabling an attribute location makes it reference the global constant value
     * TODO - handle single values for size 1 attributes?
     * TODO - convert classic arrays based on known type?
     */ _enable(location, enable = true) {
        // Attribute 0 cannot be disabled in most desktop OpenGL based browsers...
        const canDisableAttributeZero = WEBGLVertexArray.isConstantAttributeZeroSupported(this.device);
        const canDisableAttribute = canDisableAttributeZero || location !== 0;
        if (enable || canDisableAttribute) {
            location = Number(location);
            this.device.gl.bindVertexArray(this.handle);
            if (enable) this.device.gl.enableVertexAttribArray(location);
            else this.device.gl.disableVertexAttribArray(location);
            this.device.gl.bindVertexArray(null);
        }
    }
    /**
     * Provide a means to create a buffer that is equivalent to a constant.
     * NOTE: Desktop OpenGL cannot disable attribute 0.
     * https://stackoverflow.com/questions/20305231/webgl-warning-attribute-0-is-disabled-
     * this-has-significant-performance-penalty
     */ getConstantBuffer(elementCount, value) {
        // Create buffer only when needed, and reuse it (avoids inflating buffer creation statistics)
        const constantValue = normalizeConstantArrayValue(value);
        const byteLength = constantValue.byteLength * elementCount;
        const length = constantValue.length * elementCount;
        if (this.buffer && byteLength !== this.buffer.byteLength) throw new Error(`Buffer size is immutable, byte length ${byteLength} !== ${this.buffer.byteLength}.`);
        let updateNeeded = !this.buffer;
        this.buffer = this.buffer || this.device.createBuffer({
            byteLength
        });
        // Reallocate and update contents if needed
        updateNeeded = updateNeeded || !compareConstantArrayValues(constantValue, this.bufferValue);
        if (updateNeeded) {
            // Create a typed array that is big enough, and fill it with the required data
            const typedArray = (0, _core.getScratchArray)(value.constructor, length);
            (0, _fillArrayJs.fillArray)({
                target: typedArray,
                source: constantValue,
                start: 0,
                count: length
            });
            this.buffer.write(typedArray);
            this.bufferValue = value;
        }
        return this.buffer;
    }
}
// HELPER FUNCTIONS
/**
 * TODO - convert Arrays based on known type? (read type from accessor, don't assume Float32Array)
 * TODO - handle single values for size 1 attributes?
 */ function normalizeConstantArrayValue(arrayValue) {
    if (Array.isArray(arrayValue)) return new Float32Array(arrayValue);
    return arrayValue;
}
/**
 *
 */ function compareConstantArrayValues(v1, v2) {
    if (!v1 || !v2 || v1.length !== v2.length || v1.constructor !== v2.constructor) return false;
    for(let i = 0; i < v1.length; ++i){
        if (v1[i] !== v2[i]) return false;
    }
    return true;
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","@probe.gl/env":"hQL54","../converters/vertex-formats.js":"eyjBq","../../utils/fill-array.js":"9EISE","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9EISE":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Uses copyWithin to significantly speed up typed array value filling
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillArray", ()=>fillArray);
function fillArray(options) {
    const { target, source, start = 0, count = 1 } = options;
    const length = source.length;
    const total = count * length;
    let copied = 0;
    for(let i = start; copied < length; copied++)target[i++] = source[copied];
    while(copied < total)// If we have copied less than half, copy everything we got
    // else copy remaining in one operation
    if (copied < total - copied) {
        target.copyWithin(start + copied, start, start + copied);
        copied *= 2;
    } else {
        target.copyWithin(start + copied, start, start + total - copied);
        copied = total;
    }
    return options.target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7C9wO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEBGLTransformFeedback", ()=>WEBGLTransformFeedback);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
var _indexJs = require("../../index.js");
var _webglTopologyUtilsJs = require("../helpers/webgl-topology-utils.js");
class WEBGLTransformFeedback extends (0, _core.TransformFeedback) {
    device;
    gl;
    handle;
    /**
     * NOTE: The Model already has this information while drawing, but
     * TransformFeedback currently needs it internally, to look up
     * varying information outside of a draw() call.
     */ layout;
    buffers = {};
    unusedBuffers = {};
    /**
     * Allows us to avoid a Chrome bug where a buffer that is already bound to a
     * different target cannot be bound to 'TRANSFORM_FEEDBACK_BUFFER' target.
     * This a major workaround, see: https://github.com/KhronosGroup/WebGL/issues/2346
     */ bindOnUse = true;
    _bound = false;
    constructor(device, props){
        super(device, props);
        this.device = device;
        this.gl = device.gl;
        this.handle = this.props.handle || this.gl.createTransformFeedback();
        this.layout = this.props.layout;
        if (props.buffers) this.setBuffers(props.buffers);
        Object.seal(this);
    }
    destroy() {
        this.gl.deleteTransformFeedback(this.handle);
        super.destroy();
    }
    begin(topology = 'point-list') {
        this.gl.bindTransformFeedback(36386, this.handle);
        if (this.bindOnUse) this._bindBuffers();
        this.gl.beginTransformFeedback((0, _webglTopologyUtilsJs.getGLPrimitive)(topology));
    }
    end() {
        this.gl.endTransformFeedback();
        if (this.bindOnUse) this._unbindBuffers();
        this.gl.bindTransformFeedback(36386, null);
    }
    // SUBCLASS
    setBuffers(buffers) {
        this.buffers = {};
        this.unusedBuffers = {};
        this.bind(()=>{
            for(const bufferName in buffers)this.setBuffer(bufferName, buffers[bufferName]);
        });
    }
    setBuffer(locationOrName, bufferOrRange) {
        const location = this._getVaryingIndex(locationOrName);
        const { buffer, byteLength, byteOffset } = this._getBufferRange(bufferOrRange);
        if (location < 0) {
            this.unusedBuffers[locationOrName] = buffer;
            (0, _core.log).warn(`${this.id} unusedBuffers varying buffer ${locationOrName}`)();
            return;
        }
        this.buffers[location] = {
            buffer,
            byteLength,
            byteOffset
        };
        // Need to avoid chrome bug where buffer that is already bound to a different target
        // cannot be bound to 'TRANSFORM_FEEDBACK_BUFFER' target.
        if (!this.bindOnUse) this._bindBuffer(location, buffer, byteOffset, byteLength);
    }
    getBuffer(locationOrName) {
        if (isIndex(locationOrName)) return this.buffers[locationOrName] || null;
        const location = this._getVaryingIndex(locationOrName);
        return location >= 0 ? this.buffers[location] : null;
    }
    bind(funcOrHandle = this.handle) {
        if (typeof funcOrHandle !== 'function') {
            this.gl.bindTransformFeedback(36386, funcOrHandle);
            return this;
        }
        let value;
        if (!this._bound) {
            this.gl.bindTransformFeedback(36386, this.handle);
            this._bound = true;
            value = funcOrHandle();
            this._bound = false;
            this.gl.bindTransformFeedback(36386, null);
        } else value = funcOrHandle();
        return value;
    }
    unbind() {
        this.bind(null);
    }
    // PRIVATE METHODS
    /** Extract offsets for bindBufferRange */ _getBufferRange(bufferOrRange) {
        if (bufferOrRange instanceof (0, _indexJs.WEBGLBuffer)) return {
            buffer: bufferOrRange,
            byteOffset: 0,
            byteLength: bufferOrRange.byteLength
        };
        // To use bindBufferRange either offset or size must be specified.
        // @ts-expect-error Must be a BufferRange.
        const { buffer, byteOffset = 0, byteLength = bufferOrRange.buffer.byteLength } = bufferOrRange;
        return {
            buffer,
            byteOffset,
            byteLength
        };
    }
    _getVaryingIndex(locationOrName) {
        if (isIndex(locationOrName)) return Number(locationOrName);
        for (const varying of this.layout.varyings){
            if (locationOrName === varying.name) return varying.location;
        }
        return -1;
    }
    /**
     * Need to avoid chrome bug where buffer that is already bound to a different target
     * cannot be bound to 'TRANSFORM_FEEDBACK_BUFFER' target.
     */ _bindBuffers() {
        for(const bufferIndex in this.buffers){
            const { buffer, byteLength, byteOffset } = this._getBufferRange(this.buffers[bufferIndex]);
            this._bindBuffer(Number(bufferIndex), buffer, byteOffset, byteLength);
        }
    }
    _unbindBuffers() {
        for(const bufferIndex in this.buffers)this.gl.bindBufferBase(35982, Number(bufferIndex), null);
    }
    _bindBuffer(index, buffer, byteOffset = 0, byteLength) {
        const handle = buffer && buffer.handle;
        if (!handle || byteLength === undefined) this.gl.bindBufferBase(35982, index, handle);
        else this.gl.bindBufferRange(35982, index, handle, byteOffset, byteLength);
    }
}
/**
 * Returns true if the given value is an integer, or a string that
 * trivially converts to an integer (only numeric characters).
 */ function isIndex(value) {
    if (typeof value === 'number') return Number.isInteger(value);
    return /^\d+$/.test(value);
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","../../index.js":"9NtH7","../helpers/webgl-topology-utils.js":"eQ8Qb","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fp1xV":[function(require,module,exports,__globalThis) {
// WebGL2 Query (also handles disjoint timer extensions)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Asynchronous queries for different kinds of information
 */ parcelHelpers.export(exports, "WEBGLQuerySet", ()=>WEBGLQuerySet);
var _core = require("@luma.gl/core");
var _constants = require("@luma.gl/constants");
class WEBGLQuerySet extends (0, _core.QuerySet) {
    device;
    handle;
    target = null;
    _queryPending = false;
    _pollingPromise = null;
    get [Symbol.toStringTag]() {
        return 'Query';
    }
    // Create a query class
    constructor(device, props){
        super(device, props);
        this.device = device;
        if (props.count > 1) throw new Error('WebGL QuerySet can only have one value');
        this.handle = this.device.gl.createQuery();
        Object.seal(this);
    }
    destroy() {
        this.device.gl.deleteQuery(this.handle);
    }
    // FOR RENDER PASS AND COMMAND ENCODER
    /**
     * Shortcut for timer query (dependent on extension in both WebGL1 and 2)
     * Measures GPU time delta between this call and a matching `end` call in the
     * GPU instruction stream.
     */ beginTimestampQuery() {
        return this._begin(35007);
    }
    endTimestampQuery() {
        this._end();
    }
    // Shortcut for occlusion queries
    beginOcclusionQuery(options) {
        return this._begin(options?.conservative ? 36202 : 35887);
    }
    endOcclusionQuery() {
        this._end();
    }
    // Shortcut for transformFeedbackQuery
    beginTransformFeedbackQuery() {
        return this._begin(35976);
    }
    endTransformFeedbackQuery() {
        this._end();
    }
    async resolveQuery() {
        const value = await this.pollQuery();
        return [
            value
        ];
    }
    // PRIVATE METHODS
    /**
     * Due to OpenGL API limitations, after calling `begin()` on one Query
     * instance, `end()` must be called on that same instance before
     * calling `begin()` on another query. While there can be multiple
     * outstanding queries representing disjoint `begin()`/`end()` intervals.
     * It is not possible to interleave or overlap `begin` and `end` calls.
     */ _begin(target) {
        // Don't start a new query if one is already active.
        if (this._queryPending) return;
        this.target = target;
        this.device.gl.beginQuery(this.target, this.handle);
        return;
    }
    // ends the current query
    _end() {
        // Can't end a new query if the last one hasn't been resolved.
        if (this._queryPending) return;
        if (this.target) {
            this.device.gl.endQuery(this.target);
            this.target = null;
            this._queryPending = true;
        }
        return;
    }
    // Returns true if the query result is available
    isResultAvailable() {
        if (!this._queryPending) return false;
        const resultAvailable = this.device.gl.getQueryParameter(this.handle, 34919);
        if (resultAvailable) this._queryPending = false;
        return resultAvailable;
    }
    // Timing query is disjoint, i.e. results are invalid
    isTimerDisjoint() {
        return this.device.gl.getParameter(36795);
    }
    // Returns query result.
    getResult() {
        return this.device.gl.getQueryParameter(this.handle, 34918);
    }
    // Returns the query result, converted to milliseconds to match JavaScript conventions.
    getTimerMilliseconds() {
        return this.getResult() / 1e6;
    }
    // Polls the query
    pollQuery(limit = Number.POSITIVE_INFINITY) {
        if (this._pollingPromise) return this._pollingPromise;
        let counter = 0;
        this._pollingPromise = new Promise((resolve, reject)=>{
            const poll = ()=>{
                if (this.isResultAvailable()) {
                    resolve(this.getResult());
                    this._pollingPromise = null;
                } else if (counter++ > limit) {
                    reject('Timed out');
                    this._pollingPromise = null;
                } else requestAnimationFrame(poll);
            };
            requestAnimationFrame(poll);
        });
        return this._pollingPromise;
    }
}

},{"@luma.gl/core":"7TxCR","@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"31ciR":[function(require,module,exports,__globalThis) {
// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Goal is to make WebGL2 contexts look like WebGL1
// @note Partly inspired by with some older code from the `regl` library
/* eslint-disable camelcase */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Make browser return WebGL2 contexts even if WebGL1 contexts are requested
 * @param enforce
 * @returns
 */ parcelHelpers.export(exports, "enforceWebGL2", ()=>enforceWebGL2);
/** Install WebGL1-only extensions on WebGL2 contexts */ parcelHelpers.export(exports, "polyfillWebGL1Extensions", ()=>polyfillWebGL1Extensions) // Update unsized WebGL1 formats to sized WebGL2 formats
 // todo move to texture format file
 // export function getInternalFormat(gl: WebGL2RenderingContext, format: GL, type: GL): GL {
 //   // webgl2 texture formats
 //   // https://webgl2fundamentals.org/webgl/lessons/webgl-data-textures.html
 //   switch (format) {
 //     case GL.DEPTH_COMPONENT:
 //       return GL.DEPTH_COMPONENT24;
 //     case GL.DEPTH_STENCIL:
 //       return GL.DEPTH24_STENCIL8;
 //     case GL.RGBA:
 //       return type === GL.HALF_FLOAT ? GL.RGBA16F : GL.RGBA32F;
 //     case GL.RGB:
 //       return type === GL.HALF_FLOAT ? GL.RGB16F : GL.RGB32F;
 //     default:
 //       return format;
 //   }
 // }
 /*
// texture type to update on the fly
export function getTextureType(gl: WebGL2RenderingContext, type: GL): GL {
  if (type === HALF_FLOAT_OES) {
    return GL.HALF_FLOAT;
  }
  return type;
}

  // And texImage2D to convert the internalFormat to webgl2.
  const webgl2 = this;
  const origTexImage = gl.texImage2D;
  gl.texImage2D = function (target, miplevel, iformat, a, typeFor6, c, d, typeFor9, f) {
    if (arguments.length == 6) {
      var ifmt = webgl2.getInternalFormat(gl, iformat, typeFor6);
      origTexImage.apply(gl, [target, miplevel, ifmt, a, webgl.getTextureType(gl, typeFor6), c]);
    } else {
      // arguments.length == 9
      var ifmt = webgl2.getInternalFormat(gl, iformat, typeFor9);
      origTexImage.apply(gl, [
        target,
        miplevel,
        ifmt,
        a,
        typeFor6,
        c,
        d,
        webgl2.getTextureType(gl, typeFor9),
        f
      ]);
    }
  };
};
*/ ;
var _constants = require("@luma.gl/constants");
// webgl1 extensions natively supported by webgl2
const WEBGL1_STATIC_EXTENSIONS = {
    WEBGL_depth_texture: {
        UNSIGNED_INT_24_8_WEBGL: 34042
    },
    OES_element_index_uint: {},
    OES_texture_float: {},
    OES_texture_half_float: {
        // @ts-expect-error different numbers?
        HALF_FLOAT_OES: 5131
    },
    EXT_color_buffer_float: {},
    OES_standard_derivatives: {
        FRAGMENT_SHADER_DERIVATIVE_HINT_OES: 35723
    },
    EXT_frag_depth: {},
    EXT_blend_minmax: {
        MIN_EXT: 32775,
        MAX_EXT: 32776
    },
    EXT_shader_texture_lod: {}
};
const getWEBGL_draw_buffers = (gl)=>({
        drawBuffersWEBGL (buffers) {
            return gl.drawBuffers(buffers);
        },
        COLOR_ATTACHMENT0_WEBGL: 36064,
        COLOR_ATTACHMENT1_WEBGL: 36065,
        COLOR_ATTACHMENT2_WEBGL: 36066,
        COLOR_ATTACHMENT3_WEBGL: 36067
    }); // - too many fields
const getOES_vertex_array_object = (gl)=>({
        VERTEX_ARRAY_BINDING_OES: 34229,
        createVertexArrayOES () {
            return gl.createVertexArray();
        },
        deleteVertexArrayOES (vertexArray) {
            return gl.deleteVertexArray(vertexArray);
        },
        isVertexArrayOES (vertexArray) {
            return gl.isVertexArray(vertexArray);
        },
        bindVertexArrayOES (vertexArray) {
            return gl.bindVertexArray(vertexArray);
        }
    });
const getANGLE_instanced_arrays = (gl)=>({
        VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE: 0x88fe,
        drawArraysInstancedANGLE (...args) {
            return gl.drawArraysInstanced(...args);
        },
        drawElementsInstancedANGLE (...args) {
            return gl.drawElementsInstanced(...args);
        },
        vertexAttribDivisorANGLE (...args) {
            return gl.vertexAttribDivisor(...args);
        }
    });
function enforceWebGL2(enforce = true) {
    const prototype = HTMLCanvasElement.prototype;
    if (!enforce && prototype.originalGetContext) {
        // Reset the original getContext function
        prototype.getContext = prototype.originalGetContext;
        prototype.originalGetContext = undefined;
        return;
    }
    // Store the original getContext function
    prototype.originalGetContext = prototype.getContext;
    // Override the getContext function
    prototype.getContext = function(contextId, options) {
        // Attempt to force WebGL2 for all WebGL1 contexts
        if (contextId === 'webgl' || contextId === 'experimental-webgl') {
            const context = this.originalGetContext('webgl2', options);
            // Work around test mocking
            if (context instanceof HTMLElement) polyfillWebGL1Extensions(context);
            return context;
        }
        // For any other type, return the original context
        return this.originalGetContext(contextId, options);
    };
}
function polyfillWebGL1Extensions(gl) {
    // Enable, to support float and half-float textures
    gl.getExtension('EXT_color_buffer_float');
    // WebGL1 extensions implemented using WebGL2 APIs
    const boundExtensions = {
        ...WEBGL1_STATIC_EXTENSIONS,
        WEBGL_disjoint_timer_query: gl.getExtension('EXT_disjoint_timer_query_webgl2'),
        WEBGL_draw_buffers: getWEBGL_draw_buffers(gl),
        OES_vertex_array_object: getOES_vertex_array_object(gl),
        ANGLE_instanced_arrays: getANGLE_instanced_arrays(gl)
    };
    // Override gl.getExtension
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const originalGetExtension = gl.getExtension;
    gl.getExtension = function(extensionName) {
        const ext = originalGetExtension.call(gl, extensionName);
        if (ext) return ext;
        // Injected extensions
        if (extensionName in boundExtensions) return boundExtensions[extensionName];
        return null;
    };
    // Override gl.getSupportedExtensions
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const originalGetSupportedExtensions = gl.getSupportedExtensions;
    gl.getSupportedExtensions = function() {
        const extensions = originalGetSupportedExtensions.apply(gl) || [];
        return extensions?.concat(Object.keys(boundExtensions));
    };
}

},{"@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3EOhx":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable complexity */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataColumnJs = require("./data-column.js");
var _dataColumnJsDefault = parcelHelpers.interopDefault(_dataColumnJs);
var _assertJs = require("../../utils/assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
var _iterableUtilsJs = require("../../utils/iterable-utils.js");
var _flattenJs = require("../../utils/flatten.js");
var _rangeJs = require("../../utils/range.js");
var _glUtilsJs = require("./gl-utils.js");
var _transitionSettingsJs = require("./transition-settings.js");
class Attribute extends (0, _dataColumnJsDefault.default) {
    constructor(device, opts){
        super(device, opts, {
            startIndices: null,
            lastExternalBuffer: null,
            binaryValue: null,
            binaryAccessor: null,
            needsUpdate: true,
            needsRedraw: false,
            layoutChanged: false,
            updateRanges: _rangeJs.FULL
        });
        /** Legacy approach to set attribute value - read `isConstant` instead for attribute state */ this.constant = false;
        // eslint-disable-next-line
        this.settings.update = opts.update || (opts.accessor ? this._autoUpdater : undefined);
        Object.seal(this.settings);
        Object.seal(this.state);
        // Check all fields and generate helpful error messages
        this._validateAttributeUpdaters();
    }
    get startIndices() {
        return this.state.startIndices;
    }
    set startIndices(layout) {
        this.state.startIndices = layout;
    }
    needsUpdate() {
        return this.state.needsUpdate;
    }
    needsRedraw({ clearChangedFlags = false } = {}) {
        const needsRedraw = this.state.needsRedraw;
        this.state.needsRedraw = needsRedraw && !clearChangedFlags;
        return needsRedraw;
    }
    layoutChanged() {
        return this.state.layoutChanged;
    }
    setAccessor(accessor) {
        var _a;
        (_a = this.state).layoutChanged || (_a.layoutChanged = !(0, _glUtilsJs.bufferLayoutEqual)(accessor, this.getAccessor()));
        super.setAccessor(accessor);
    }
    getUpdateTriggers() {
        const { accessor } = this.settings;
        // Backards compatibility: allow attribute name to be used as update trigger key
        return [
            this.id
        ].concat(typeof accessor !== 'function' && accessor || []);
    }
    supportsTransition() {
        return Boolean(this.settings.transition);
    }
    // Resolve transition settings object if transition is enabled, otherwise `null`
    getTransitionSetting(opts) {
        if (!opts || !this.supportsTransition()) return null;
        const { accessor } = this.settings;
        // TODO: have the layer resolve these transition settings itself?
        const layerSettings = this.settings.transition;
        // these are the transition settings passed in by the user
        const userSettings = Array.isArray(accessor) ? opts[accessor.find((a)=>opts[a])] : opts[accessor];
        // Shorthand: use duration instead of parameter object
        return (0, _transitionSettingsJs.normalizeTransitionSettings)(userSettings, layerSettings);
    }
    setNeedsUpdate(reason = this.id, dataRange) {
        this.state.needsUpdate = this.state.needsUpdate || reason;
        this.setNeedsRedraw(reason);
        if (dataRange) {
            const { startRow = 0, endRow = Infinity } = dataRange;
            this.state.updateRanges = _rangeJs.add(this.state.updateRanges, [
                startRow,
                endRow
            ]);
        } else this.state.updateRanges = _rangeJs.FULL;
    }
    clearNeedsUpdate() {
        this.state.needsUpdate = false;
        this.state.updateRanges = _rangeJs.EMPTY;
    }
    setNeedsRedraw(reason = this.id) {
        this.state.needsRedraw = this.state.needsRedraw || reason;
    }
    allocate(numInstances) {
        const { state, settings } = this;
        if (settings.noAlloc) // Data is provided through a Buffer object.
        return false;
        if (settings.update) {
            super.allocate(numInstances, state.updateRanges !== _rangeJs.FULL);
            return true;
        }
        return false;
    }
    updateBuffer({ numInstances, data, props, context }) {
        if (!this.needsUpdate()) return false;
        const { state: { updateRanges }, settings: { update, noAlloc } } = this;
        let updated = true;
        if (update) {
            // Custom updater - typically for non-instanced layers
            for (const [startRow, endRow] of updateRanges)update.call(context, this, {
                data,
                startRow,
                endRow,
                props,
                numInstances
            });
            if (!this.value) ;
            else if (this.constant || !this.buffer || this.buffer.byteLength < this.value.byteLength + this.byteOffset) {
                this.setData({
                    value: this.value,
                    constant: this.constant
                });
                // Setting attribute.constant in updater is a legacy approach that interferes with allocation in the next cycle
                // Respect it here but reset after use
                this.constant = false;
            } else for (const [startRow, endRow] of updateRanges){
                const startOffset = Number.isFinite(startRow) ? this.getVertexOffset(startRow) : 0;
                const endOffset = Number.isFinite(endRow) ? this.getVertexOffset(endRow) : noAlloc || !Number.isFinite(numInstances) ? this.value.length : numInstances * this.size;
                super.updateSubBuffer({
                    startOffset,
                    endOffset
                });
            }
            this._checkAttributeArray();
        } else updated = false;
        this.clearNeedsUpdate();
        this.setNeedsRedraw();
        return updated;
    }
    // Use generic value
    // Returns true if successful
    setConstantValue(value) {
        // TODO(ibgreen): WebGPU does not support constant values
        const isWebGPU = this.device.type === 'webgpu';
        if (isWebGPU || value === undefined || typeof value === 'function') return false;
        const hasChanged = this.setData({
            constant: true,
            value
        });
        if (hasChanged) this.setNeedsRedraw();
        this.clearNeedsUpdate();
        return true;
    }
    // Use external buffer
    // Returns true if successful
    // eslint-disable-next-line max-statements
    setExternalBuffer(buffer) {
        const { state } = this;
        if (!buffer) {
            state.lastExternalBuffer = null;
            return false;
        }
        this.clearNeedsUpdate();
        if (state.lastExternalBuffer === buffer) return true;
        state.lastExternalBuffer = buffer;
        this.setNeedsRedraw();
        this.setData(buffer);
        return true;
    }
    // Binary value is a typed array packed from mapping the source data with the accessor
    // If the returned value from the accessor is the same as the attribute value, set it directly
    // Otherwise use the auto updater for transform/normalization
    setBinaryValue(buffer, startIndices = null) {
        const { state, settings } = this;
        if (!buffer) {
            state.binaryValue = null;
            state.binaryAccessor = null;
            return false;
        }
        if (settings.noAlloc) // Let the layer handle this
        return false;
        if (state.binaryValue === buffer) {
            this.clearNeedsUpdate();
            return true;
        }
        state.binaryValue = buffer;
        this.setNeedsRedraw();
        const needsUpdate = settings.transform || startIndices !== this.startIndices;
        if (needsUpdate) {
            if (ArrayBuffer.isView(buffer)) buffer = {
                value: buffer
            };
            const binaryValue = buffer;
            (0, _assertJsDefault.default)(ArrayBuffer.isView(binaryValue.value), `invalid ${settings.accessor}`);
            const needsNormalize = Boolean(binaryValue.size) && binaryValue.size !== this.size;
            state.binaryAccessor = (0, _iterableUtilsJs.getAccessorFromBuffer)(binaryValue.value, {
                size: binaryValue.size || this.size,
                stride: binaryValue.stride,
                offset: binaryValue.offset,
                startIndices: startIndices,
                nested: needsNormalize
            });
            // Fall through to auto updater
            return false;
        }
        this.clearNeedsUpdate();
        this.setData(buffer);
        return true;
    }
    getVertexOffset(row) {
        const { startIndices } = this;
        const vertexIndex = startIndices ? row < startIndices.length ? startIndices[row] : this.numInstances : row;
        return vertexIndex * this.size;
    }
    getValue() {
        const shaderAttributeDefs = this.settings.shaderAttributes;
        const result = super.getValue();
        if (!shaderAttributeDefs) return result;
        for(const shaderAttributeName in shaderAttributeDefs)Object.assign(result, super.getValue(shaderAttributeName, shaderAttributeDefs[shaderAttributeName]));
        return result;
    }
    /** Generate WebGPU-style buffer layout descriptor from this attribute */ getBufferLayout(/** A luma.gl Model-shaped object that supplies additional hint to attribute resolution */ modelInfo) {
        // Clear change flag
        this.state.layoutChanged = false;
        const shaderAttributeDefs = this.settings.shaderAttributes;
        const result = super._getBufferLayout();
        const { stepMode } = this.settings;
        if (stepMode === 'dynamic') // If model info is provided, use isInstanced flag to determine step mode
        // If no model info is provided, assume it's an instanced model (most common use case)
        result.stepMode = modelInfo ? modelInfo.isInstanced ? 'instance' : 'vertex' : 'instance';
        else result.stepMode = stepMode ?? 'vertex';
        if (!shaderAttributeDefs) return result;
        for(const shaderAttributeName in shaderAttributeDefs){
            const map = super._getBufferLayout(shaderAttributeName, shaderAttributeDefs[shaderAttributeName]);
            // @ts-ignore
            result.attributes.push(...map.attributes);
        }
        return result;
    }
    /* eslint-disable max-depth, max-statements */ _autoUpdater(attribute, { data, startRow, endRow, props, numInstances }) {
        if (attribute.constant) {
            // @ts-ignore TODO(ibgreen) declare context?
            if (this.context.device.type !== 'webgpu') return;
        }
        const { settings, state, value, size, startIndices } = attribute;
        const { accessor, transform } = settings;
        let accessorFunc = state.binaryAccessor || // @ts-ignore
        (typeof accessor === 'function' ? accessor : props[accessor]);
        // TODO(ibgreen) WebGPU needs buffers, generate an accessor function from a constant
        if (typeof accessorFunc !== 'function') accessorFunc = ()=>accessorFunc;
        (0, _assertJsDefault.default)(typeof accessorFunc === 'function', `accessor "${accessor}" is not a function`);
        let i = attribute.getVertexOffset(startRow);
        const { iterable, objectInfo } = (0, _iterableUtilsJs.createIterable)(data, startRow, endRow);
        for (const object of iterable){
            objectInfo.index++;
            let objectValue = accessorFunc(object, objectInfo);
            if (transform) // transform callbacks could be bound to a particular layer instance.
            // always point `this` to the current layer.
            objectValue = transform.call(this, objectValue);
            if (startIndices) {
                const numVertices = (objectInfo.index < startIndices.length - 1 ? startIndices[objectInfo.index + 1] : numInstances) - startIndices[objectInfo.index];
                if (objectValue && Array.isArray(objectValue[0])) {
                    let startIndex = i;
                    for (const item of objectValue){
                        attribute._normalizeValue(item, value, startIndex);
                        startIndex += size;
                    }
                } else if (objectValue && objectValue.length > size) value.set(objectValue, i);
                else {
                    attribute._normalizeValue(objectValue, objectInfo.target, 0);
                    (0, _flattenJs.fillArray)({
                        target: value,
                        source: objectInfo.target,
                        start: i,
                        count: numVertices
                    });
                }
                i += numVertices * size;
            } else {
                attribute._normalizeValue(objectValue, value, i);
                i += size;
            }
        }
    }
    /* eslint-enable max-depth, max-statements */ // Validate deck.gl level fields
    _validateAttributeUpdaters() {
        const { settings } = this;
        // Check that 'update' is a valid function
        const hasUpdater = settings.noAlloc || typeof settings.update === 'function';
        if (!hasUpdater) throw new Error(`Attribute ${this.id} missing update or accessor`);
    }
    // check that the first few elements of the attribute are reasonable
    /* eslint-disable no-fallthrough */ _checkAttributeArray() {
        const { value } = this;
        const limit = Math.min(4, this.size);
        if (value && value.length >= limit) {
            let valid = true;
            switch(limit){
                case 4:
                    valid = valid && Number.isFinite(value[3]);
                case 3:
                    valid = valid && Number.isFinite(value[2]);
                case 2:
                    valid = valid && Number.isFinite(value[1]);
                case 1:
                    valid = valid && Number.isFinite(value[0]);
                    break;
                default:
                    valid = false;
            }
            if (!valid) throw new Error(`Illegal attribute generated for ${this.id}`);
        }
    }
}
exports.default = Attribute;

},{"./data-column.js":"5qBx1","../../utils/assert.js":"3Sh37","../../utils/iterable-utils.js":"akgls","../../utils/flatten.js":"8GYLR","../../utils/range.js":"e3MgE","./gl-utils.js":"5o7Hm","./transition-settings.js":"fZusS","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5qBx1":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@luma.gl/core");
var _glUtilsJs = require("./gl-utils.js");
var _typedArrayManagerJs = require("../../utils/typed-array-manager.js");
var _typedArrayManagerJsDefault = parcelHelpers.interopDefault(_typedArrayManagerJs);
var _mathUtilsJs = require("../../utils/math-utils.js");
var _logJs = require("../../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
function resolveShaderAttribute(baseAccessor, shaderAttributeOptions) {
    if (shaderAttributeOptions.offset) (0, _logJsDefault.default).removed('shaderAttribute.offset', 'vertexOffset, elementOffset')();
    // All shader attributes share the parent's stride
    const stride = (0, _glUtilsJs.getStride)(baseAccessor);
    // `vertexOffset` is used to access the neighboring vertex's value
    // e.g. `nextPositions` in polygon
    const vertexOffset = shaderAttributeOptions.vertexOffset !== undefined ? shaderAttributeOptions.vertexOffset : baseAccessor.vertexOffset || 0;
    // `elementOffset` is defined when shader attribute's size is smaller than the parent's
    // e.g. `translations` in transform matrix
    const elementOffset = shaderAttributeOptions.elementOffset || 0;
    const offset = // offsets defined by the attribute
    vertexOffset * stride + elementOffset * baseAccessor.bytesPerElement + // offsets defined by external buffers if any
    (baseAccessor.offset || 0);
    return {
        ...shaderAttributeOptions,
        offset,
        stride
    };
}
function resolveDoublePrecisionShaderAttributes(baseAccessor, shaderAttributeOptions) {
    const resolvedOptions = resolveShaderAttribute(baseAccessor, shaderAttributeOptions);
    return {
        high: resolvedOptions,
        low: {
            ...resolvedOptions,
            offset: resolvedOptions.offset + baseAccessor.size * 4
        }
    };
}
class DataColumn {
    /* eslint-disable max-statements */ constructor(device, opts, state){
        this._buffer = null;
        this.device = device;
        this.id = opts.id || '';
        this.size = opts.size || 1;
        const logicalType = opts.logicalType || opts.type;
        const doublePrecision = logicalType === 'float64';
        let { defaultValue } = opts;
        defaultValue = Number.isFinite(defaultValue) ? [
            defaultValue
        ] : defaultValue || new Array(this.size).fill(0);
        let bufferType;
        if (doublePrecision) bufferType = 'float32';
        else if (!logicalType && opts.isIndexed) bufferType = 'uint32';
        else bufferType = logicalType || 'float32';
        // This is the attribute type defined by the layer
        // If an external buffer is provided, this.type may be overwritten
        // But we always want to use defaultType for allocation
        let defaultType = (0, _glUtilsJs.typedArrayFromDataType)(logicalType || bufferType);
        this.doublePrecision = doublePrecision;
        // `fp64: false` tells a double-precision attribute to allocate Float32Arrays
        // by default when using auto-packing. This is more efficient in use cases where
        // high precision is unnecessary, but the `64Low` attribute is still required
        // by the shader.
        if (doublePrecision && opts.fp64 === false) defaultType = Float32Array;
        this.value = null;
        this.settings = {
            ...opts,
            defaultType,
            defaultValue: defaultValue,
            logicalType,
            type: bufferType,
            normalized: bufferType.includes('norm'),
            size: this.size,
            bytesPerElement: defaultType.BYTES_PER_ELEMENT
        };
        this.state = {
            ...state,
            externalBuffer: null,
            bufferAccessor: this.settings,
            allocatedValue: null,
            numInstances: 0,
            bounds: null,
            constant: false
        };
    }
    /* eslint-enable max-statements */ get isConstant() {
        return this.state.constant;
    }
    get buffer() {
        return this._buffer;
    }
    get byteOffset() {
        const accessor = this.getAccessor();
        if (accessor.vertexOffset) return accessor.vertexOffset * (0, _glUtilsJs.getStride)(accessor);
        return 0;
    }
    get numInstances() {
        return this.state.numInstances;
    }
    set numInstances(n) {
        this.state.numInstances = n;
    }
    delete() {
        if (this._buffer) {
            this._buffer.delete();
            this._buffer = null;
        }
        (0, _typedArrayManagerJsDefault.default).release(this.state.allocatedValue);
    }
    getBuffer() {
        if (this.state.constant) return null;
        return this.state.externalBuffer || this._buffer;
    }
    getValue(attributeName = this.id, options = null) {
        const result = {};
        if (this.state.constant) {
            const value = this.value;
            if (options) {
                const shaderAttributeDef = resolveShaderAttribute(this.getAccessor(), options);
                const offset = shaderAttributeDef.offset / value.BYTES_PER_ELEMENT;
                const size = shaderAttributeDef.size || this.size;
                result[attributeName] = value.subarray(offset, offset + size);
            } else result[attributeName] = value;
        } else result[attributeName] = this.getBuffer();
        if (this.doublePrecision) {
            if (this.value instanceof Float64Array) result[`${attributeName}64Low`] = result[attributeName];
            else // Disable fp64 low part
            result[`${attributeName}64Low`] = new Float32Array(this.size);
        }
        return result;
    }
    _getBufferLayout(attributeName = this.id, options = null) {
        const accessor = this.getAccessor();
        const attributes = [];
        const result = {
            name: this.id,
            byteStride: (0, _glUtilsJs.getStride)(accessor),
            attributes
        };
        if (this.doublePrecision) {
            const doubleShaderAttributeDefs = resolveDoublePrecisionShaderAttributes(accessor, options || {});
            attributes.push((0, _glUtilsJs.getBufferAttributeLayout)(attributeName, {
                ...accessor,
                ...doubleShaderAttributeDefs.high
            }, this.device.type), (0, _glUtilsJs.getBufferAttributeLayout)(`${attributeName}64Low`, {
                ...accessor,
                ...doubleShaderAttributeDefs.low
            }, this.device.type));
        } else if (options) {
            const shaderAttributeDef = resolveShaderAttribute(accessor, options);
            attributes.push((0, _glUtilsJs.getBufferAttributeLayout)(attributeName, {
                ...accessor,
                ...shaderAttributeDef
            }, this.device.type));
        } else attributes.push((0, _glUtilsJs.getBufferAttributeLayout)(attributeName, accessor, this.device.type));
        return result;
    }
    setAccessor(accessor) {
        this.state.bufferAccessor = accessor;
    }
    getAccessor() {
        return this.state.bufferAccessor;
    }
    // Returns [min: Array(size), max: Array(size)]
    /* eslint-disable max-depth */ getBounds() {
        if (this.state.bounds) return this.state.bounds;
        let result = null;
        if (this.state.constant && this.value) {
            const min = Array.from(this.value);
            result = [
                min,
                min
            ];
        } else {
            const { value, numInstances, size } = this;
            const len = numInstances * size;
            if (value && len && value.length >= len) {
                const min = new Array(size).fill(Infinity);
                const max = new Array(size).fill(-Infinity);
                for(let i = 0; i < len;)for(let j = 0; j < size; j++){
                    const v = value[i++];
                    if (v < min[j]) min[j] = v;
                    if (v > max[j]) max[j] = v;
                }
                result = [
                    min,
                    max
                ];
            }
        }
        this.state.bounds = result;
        return result;
    }
    // returns true if success
    // eslint-disable-next-line max-statements
    setData(data) {
        const { state } = this;
        let opts;
        if (ArrayBuffer.isView(data)) opts = {
            value: data
        };
        else if (data instanceof (0, _core.Buffer)) opts = {
            buffer: data
        };
        else opts = data;
        const accessor = {
            ...this.settings,
            ...opts
        };
        if (ArrayBuffer.isView(opts.value)) {
            if (!opts.type) {
                // Deduce data type
                const is64Bit = this.doublePrecision && opts.value instanceof Float64Array;
                if (is64Bit) accessor.type = 'float32';
                else {
                    const type = (0, _glUtilsJs.dataTypeFromTypedArray)(opts.value);
                    accessor.type = accessor.normalized ? type.replace('int', 'norm') : type;
                }
            }
            accessor.bytesPerElement = opts.value.BYTES_PER_ELEMENT;
            accessor.stride = (0, _glUtilsJs.getStride)(accessor);
        }
        state.bounds = null; // clear cached bounds
        if (opts.constant) {
            // set constant
            let value = opts.value;
            value = this._normalizeValue(value, [], 0);
            if (this.settings.normalized) value = this.normalizeConstant(value);
            const hasChanged = !state.constant || !this._areValuesEqual(value, this.value);
            if (!hasChanged) return false;
            state.externalBuffer = null;
            state.constant = true;
            this.value = ArrayBuffer.isView(value) ? value : new Float32Array(value);
        } else if (opts.buffer) {
            const buffer = opts.buffer;
            state.externalBuffer = buffer;
            state.constant = false;
            this.value = opts.value || null;
        } else if (opts.value) {
            this._checkExternalBuffer(opts);
            let value = opts.value;
            state.externalBuffer = null;
            state.constant = false;
            this.value = value;
            let { buffer } = this;
            const stride = (0, _glUtilsJs.getStride)(accessor);
            const byteOffset = (accessor.vertexOffset || 0) * stride;
            if (this.doublePrecision && value instanceof Float64Array) value = (0, _mathUtilsJs.toDoublePrecisionArray)(value, accessor);
            if (this.settings.isIndexed) {
                const ArrayType = this.settings.defaultType;
                if (value.constructor !== ArrayType) // Cast the index buffer to expected type
                value = new ArrayType(value);
            }
            // A small over allocation is used as safety margin
            // Shader attributes may try to access this buffer with bigger offsets
            const requiredBufferSize = value.byteLength + byteOffset + stride * 2;
            if (!buffer || buffer.byteLength < requiredBufferSize) buffer = this._createBuffer(requiredBufferSize);
            buffer.write(value, byteOffset);
        }
        this.setAccessor(accessor);
        return true;
    }
    updateSubBuffer(opts = {}) {
        this.state.bounds = null; // clear cached bounds
        const value = this.value;
        const { startOffset = 0, endOffset } = opts;
        this.buffer.write(this.doublePrecision && value instanceof Float64Array ? (0, _mathUtilsJs.toDoublePrecisionArray)(value, {
            size: this.size,
            startIndex: startOffset,
            endIndex: endOffset
        }) : value.subarray(startOffset, endOffset), startOffset * value.BYTES_PER_ELEMENT + this.byteOffset);
    }
    allocate(numInstances, copy = false) {
        const { state } = this;
        const oldValue = state.allocatedValue;
        // Allocate at least one element to ensure a valid buffer
        const value = (0, _typedArrayManagerJsDefault.default).allocate(oldValue, numInstances + 1, {
            size: this.size,
            type: this.settings.defaultType,
            copy
        });
        this.value = value;
        const { byteOffset } = this;
        let { buffer } = this;
        if (!buffer || buffer.byteLength < value.byteLength + byteOffset) {
            buffer = this._createBuffer(value.byteLength + byteOffset);
            if (copy && oldValue) // Upload the full existing attribute value to the GPU, so that updateBuffer
            // can choose to only update a partial range.
            // TODO - copy old buffer to new buffer on the GPU
            buffer.write(oldValue instanceof Float64Array ? (0, _mathUtilsJs.toDoublePrecisionArray)(oldValue, this) : oldValue, byteOffset);
        }
        state.allocatedValue = value;
        state.constant = false;
        state.externalBuffer = null;
        this.setAccessor(this.settings);
        return true;
    }
    // PRIVATE HELPER METHODS
    _checkExternalBuffer(opts) {
        const { value } = opts;
        if (!ArrayBuffer.isView(value)) throw new Error(`Attribute ${this.id} value is not TypedArray`);
        const ArrayType = this.settings.defaultType;
        let illegalArrayType = false;
        if (this.doublePrecision) // not 32bit or 64bit
        illegalArrayType = value.BYTES_PER_ELEMENT < 4;
        if (illegalArrayType) throw new Error(`Attribute ${this.id} does not support ${value.constructor.name}`);
        if (!(value instanceof ArrayType) && this.settings.normalized && !('normalized' in opts)) (0, _logJsDefault.default).warn(`Attribute ${this.id} is normalized`)();
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
    normalizeConstant(value) {
        /* eslint-disable complexity */ switch(this.settings.type){
            case 'snorm8':
                // normalize [-128, 127] to [-1, 1]
                return new Float32Array(value).map((x)=>(x + 128) / 255 * 2 - 1);
            case 'snorm16':
                // normalize [-32768, 32767] to [-1, 1]
                return new Float32Array(value).map((x)=>(x + 32768) / 65535 * 2 - 1);
            case 'unorm8':
                // normalize [0, 255] to [0, 1]
                return new Float32Array(value).map((x)=>x / 255);
            case 'unorm16':
                // normalize [0, 65535] to [0, 1]
                return new Float32Array(value).map((x)=>x / 65535);
            default:
                // No normalization for gl.FLOAT and gl.HALF_FLOAT
                return value;
        }
    }
    /* check user supplied values and apply fallback */ _normalizeValue(value, out, start) {
        const { defaultValue, size } = this.settings;
        if (Number.isFinite(value)) {
            out[start] = value;
            return out;
        }
        if (!value) {
            let i = size;
            while(--i >= 0)out[start + i] = defaultValue[i];
            return out;
        }
        // Important - switch cases are 5x more performant than a for loop!
        /* eslint-disable no-fallthrough, default-case */ switch(size){
            case 4:
                out[start + 3] = Number.isFinite(value[3]) ? value[3] : defaultValue[3];
            case 3:
                out[start + 2] = Number.isFinite(value[2]) ? value[2] : defaultValue[2];
            case 2:
                out[start + 1] = Number.isFinite(value[1]) ? value[1] : defaultValue[1];
            case 1:
                out[start + 0] = Number.isFinite(value[0]) ? value[0] : defaultValue[0];
                break;
            default:
                // In the rare case where the attribute size > 4, do it the slow way
                // This is used for e.g. transform matrices
                let i = size;
                while(--i >= 0)out[start + i] = Number.isFinite(value[i]) ? value[i] : defaultValue[i];
        }
        return out;
    }
    _areValuesEqual(value1, value2) {
        if (!value1 || !value2) return false;
        const { size } = this;
        for(let i = 0; i < size; i++){
            if (value1[i] !== value2[i]) return false;
        }
        return true;
    }
    _createBuffer(byteLength) {
        if (this._buffer) this._buffer.destroy();
        const { isIndexed, type } = this.settings;
        this._buffer = this.device.createBuffer({
            ...this._buffer?.props,
            id: this.id,
            // TODO(ibgreen) - WebGPU requires COPY_DST and COPY_SRC to allow write / read
            usage: (isIndexed ? (0, _core.Buffer).INDEX : (0, _core.Buffer).VERTEX) | (0, _core.Buffer).COPY_DST,
            indexType: isIndexed ? type : undefined,
            byteLength
        });
        return this._buffer;
    }
}
exports.default = DataColumn;

},{"@luma.gl/core":"7TxCR","./gl-utils.js":"5o7Hm","../../utils/typed-array-manager.js":"6eAB3","../../utils/math-utils.js":"kiHqg","../../utils/log.js":"9S0lD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5o7Hm":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "typedArrayFromDataType", ()=>typedArrayFromDataType);
parcelHelpers.export(exports, "dataTypeFromTypedArray", ()=>dataTypeFromTypedArray);
parcelHelpers.export(exports, "getBufferAttributeLayout", ()=>getBufferAttributeLayout);
parcelHelpers.export(exports, "getStride", ()=>getStride);
parcelHelpers.export(exports, "bufferLayoutEqual", ()=>bufferLayoutEqual);
var _core = require("@luma.gl/core");
function typedArrayFromDataType(type) {
    // Sorted in some order of likelihood to reduce amount of comparisons
    switch(type){
        case 'float64':
            return Float64Array;
        case 'uint8':
        case 'unorm8':
            return Uint8ClampedArray;
        default:
            return (0, _core.getTypedArrayFromDataType)(type);
    }
}
const dataTypeFromTypedArray = (0, _core.getDataTypeFromTypedArray);
function getBufferAttributeLayout(name, accessor, deviceType) {
    // TODO(ibgreen): WebGPU change. Currently we always use normalized 8 bit integers
    const type = deviceType === 'webgpu' && accessor.type === 'uint8' ? 'unorm8' : accessor.type;
    return {
        attribute: name,
        // @ts-expect-error Not all combinations are valid vertex formats; it's up to DataColumn to ensure
        format: accessor.size > 1 ? `${type}x${accessor.size}` : accessor.type,
        byteOffset: accessor.offset || 0
    };
}
function getStride(accessor) {
    return accessor.stride || accessor.size * accessor.bytesPerElement;
}
function bufferLayoutEqual(accessor1, accessor2) {
    return accessor1.type === accessor2.type && accessor1.size === accessor2.size && getStride(accessor1) === getStride(accessor2) && (accessor1.offset || 0) === (accessor2.offset || 0);
}

},{"@luma.gl/core":"7TxCR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"akgls":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Create an Iterable
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols
 * and a "context" tracker from the given data
 */ parcelHelpers.export(exports, "createIterable", ()=>createIterable);
/*
 * Returns true if data is an async iterable object
 */ parcelHelpers.export(exports, "isAsyncIterable", ()=>isAsyncIterable);
/*
 * Create an accessor function from a flat buffer that yields the value at each object index
 */ parcelHelpers.export(exports, "getAccessorFromBuffer", ()=>getAccessorFromBuffer);
const EMPTY_ARRAY = [];
const placeholderArray = [];
function createIterable(data, startRow = 0, endRow = Infinity) {
    let iterable = EMPTY_ARRAY;
    const objectInfo = {
        index: -1,
        data,
        // visitor can optionally utilize this to avoid constructing a new array for every object
        target: []
    };
    if (!data) iterable = EMPTY_ARRAY;
    else if (typeof data[Symbol.iterator] === 'function') // data is already an iterable
    iterable = data;
    else if (data.length > 0) {
        placeholderArray.length = data.length;
        iterable = placeholderArray;
    }
    if (startRow > 0 || Number.isFinite(endRow)) {
        iterable = (Array.isArray(iterable) ? iterable : Array.from(iterable)).slice(startRow, endRow);
        objectInfo.index = startRow - 1;
    }
    return {
        iterable,
        objectInfo
    };
}
function isAsyncIterable(data) {
    return data && data[Symbol.asyncIterator];
}
function getAccessorFromBuffer(typedArray, options) {
    const { size, stride, offset, startIndices, nested } = options;
    const bytesPerElement = typedArray.BYTES_PER_ELEMENT;
    const elementStride = stride ? stride / bytesPerElement : size;
    const elementOffset = offset ? offset / bytesPerElement : 0;
    const vertexCount = Math.floor((typedArray.length - elementOffset) / elementStride);
    return (_, { index, target })=>{
        if (!startIndices) {
            const sourceIndex = index * elementStride + elementOffset;
            for(let j = 0; j < size; j++)target[j] = typedArray[sourceIndex + j];
            return target;
        }
        const startIndex = startIndices[index];
        const endIndex = startIndices[index + 1] || vertexCount;
        let result;
        if (nested) {
            result = new Array(endIndex - startIndex);
            for(let i = startIndex; i < endIndex; i++){
                const sourceIndex = i * elementStride + elementOffset;
                target = new Array(size);
                for(let j = 0; j < size; j++)target[j] = typedArray[sourceIndex + j];
                result[i - startIndex] = target;
            }
        } else if (elementStride === size) result = typedArray.subarray(startIndex * size + elementOffset, endIndex * size + elementOffset);
        else {
            result = new typedArray.constructor((endIndex - startIndex) * size);
            let targetIndex = 0;
            for(let i = startIndex; i < endIndex; i++){
                const sourceIndex = i * elementStride + elementOffset;
                for(let j = 0; j < size; j++)result[targetIndex++] = typedArray[sourceIndex + j];
            }
        }
        return result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"e3MgE":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/*
 * range (Array)
 *   + start (Number) - the start index (incl.)
 *   + end (Number) - the end index (excl.)
 * rangeList (Array) - array of sorted, combined ranges
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "FULL", ()=>FULL);
// Insert a range into a range collection
parcelHelpers.export(exports, "add", ()=>add);
const EMPTY = [];
const FULL = [
    [
        0,
        Infinity
    ]
];
function add(rangeList, range) {
    // Noop if range collection already covers all
    if (rangeList === FULL) return rangeList;
    // Validate the input range
    if (range[0] < 0) range[0] = 0;
    if (range[0] >= range[1]) return rangeList;
    // TODO - split off to tree-shakable Range class
    const newRangeList = [];
    const len = rangeList.length;
    let insertPosition = 0;
    for(let i = 0; i < len; i++){
        const range0 = rangeList[i];
        if (range0[1] < range[0]) {
            // the current range is to the left of the new range
            newRangeList.push(range0);
            insertPosition = i + 1;
        } else if (range0[0] > range[1]) // the current range is to the right of the new range
        newRangeList.push(range0);
        else range = [
            Math.min(range0[0], range[0]),
            Math.max(range0[1], range[1])
        ];
    }
    newRangeList.splice(insertPosition, 0, range);
    return newRangeList;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fZusS":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeTransitionSettings", ()=>normalizeTransitionSettings);
const DEFAULT_TRANSITION_SETTINGS = {
    interpolation: {
        duration: 0,
        easing: (t)=>t
    },
    spring: {
        stiffness: 0.05,
        damping: 0.5
    }
};
function normalizeTransitionSettings(userSettings, layerSettings) {
    if (!userSettings) return null;
    if (Number.isFinite(userSettings)) userSettings = {
        type: 'interpolation',
        duration: userSettings
    };
    const type = userSettings.type || 'interpolation';
    return {
        ...DEFAULT_TRANSITION_SETTINGS[type],
        ...layerSettings,
        ...userSettings,
        type
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8sB6D":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable guard-for-in */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _attributeJs = require("./attribute.js");
var _attributeJsDefault = parcelHelpers.interopDefault(_attributeJs);
var _logJs = require("../../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _memoizeJs = require("../../utils/memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
var _mathUtilsJs = require("../../utils/math-utils.js");
var _indexJs = require("../../debug/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _attributeTransitionManagerJs = require("./attribute-transition-manager.js");
var _attributeTransitionManagerJsDefault = parcelHelpers.interopDefault(_attributeTransitionManagerJs);
const TRACE_INVALIDATE = 'attributeManager.invalidate';
const TRACE_UPDATE_START = 'attributeManager.updateStart';
const TRACE_UPDATE_END = 'attributeManager.updateEnd';
const TRACE_ATTRIBUTE_UPDATE_START = 'attribute.updateStart';
const TRACE_ATTRIBUTE_ALLOCATE = 'attribute.allocate';
const TRACE_ATTRIBUTE_UPDATE_END = 'attribute.updateEnd';
class AttributeManager {
    constructor(device, { id = 'attribute-manager', stats, timeline } = {}){
        this.mergeBoundsMemoized = (0, _memoizeJsDefault.default)((0, _mathUtilsJs.mergeBounds));
        this.id = id;
        this.device = device;
        this.attributes = {};
        this.updateTriggers = {};
        this.needsRedraw = true;
        this.userData = {};
        this.stats = stats;
        this.attributeTransitionManager = new (0, _attributeTransitionManagerJsDefault.default)(device, {
            id: `${id}-transitions`,
            timeline
        });
        // For debugging sanity, prevent uninitialized members
        Object.seal(this);
    }
    finalize() {
        for(const attributeName in this.attributes)this.attributes[attributeName].delete();
        this.attributeTransitionManager.finalize();
    }
    // Returns the redraw flag, optionally clearing it.
    // Redraw flag will be set if any attributes attributes changed since
    // flag was last cleared.
    //
    // @param {String} [clearRedrawFlags=false] - whether to clear the flag
    // @return {false|String} - reason a redraw is needed.
    getNeedsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        const redraw = this.needsRedraw;
        this.needsRedraw = this.needsRedraw && !opts.clearRedrawFlags;
        return redraw && this.id;
    }
    // Sets the redraw flag.
    // @param {Boolean} redraw=true
    setNeedsRedraw() {
        this.needsRedraw = true;
    }
    // Adds attributes
    add(attributes) {
        this._add(attributes);
    }
    // Adds attributes
    addInstanced(attributes) {
        this._add(attributes, {
            stepMode: 'instance'
        });
    }
    /**
     * Removes attributes
     * Takes an array of attribute names and delete them from
     * the attribute map if they exists
     *
     * @example
     * attributeManager.remove(['position']);
     *
     * @param {Object} attributeNameArray - attribute name array (see above)
     */ remove(attributeNameArray) {
        for (const name of attributeNameArray)if (this.attributes[name] !== undefined) {
            this.attributes[name].delete();
            delete this.attributes[name];
        }
    }
    // Marks an attribute for update
    invalidate(triggerName, dataRange) {
        const invalidatedAttributes = this._invalidateTrigger(triggerName, dataRange);
        // For performance tuning
        (0, _indexJsDefault.default)(TRACE_INVALIDATE, this, triggerName, invalidatedAttributes);
    }
    invalidateAll(dataRange) {
        for(const attributeName in this.attributes)this.attributes[attributeName].setNeedsUpdate(attributeName, dataRange);
        // For performance tuning
        (0, _indexJsDefault.default)(TRACE_INVALIDATE, this, 'all');
    }
    // Ensure all attribute buffers are updated from props or data.
    // eslint-disable-next-line complexity
    update({ data, numInstances, startIndices = null, transitions, props = {}, buffers = {}, context = {} }) {
        // keep track of whether some attributes are updated
        let updated = false;
        (0, _indexJsDefault.default)(TRACE_UPDATE_START, this);
        if (this.stats) this.stats.get('Update Attributes').timeStart();
        for(const attributeName in this.attributes){
            const attribute = this.attributes[attributeName];
            const accessorName = attribute.settings.accessor;
            attribute.startIndices = startIndices;
            attribute.numInstances = numInstances;
            if (props[attributeName]) (0, _logJsDefault.default).removed(`props.${attributeName}`, `data.attributes.${attributeName}`)();
            if (attribute.setExternalBuffer(buffers[attributeName])) ;
            else if (attribute.setBinaryValue(typeof accessorName === 'string' ? buffers[accessorName] : undefined, data.startIndices)) ;
            else if (typeof accessorName === 'string' && !buffers[accessorName] && attribute.setConstantValue(props[accessorName])) ;
            else if (attribute.needsUpdate()) {
                // Step 4: update via updater callback
                updated = true;
                this._updateAttribute({
                    attribute,
                    numInstances,
                    data,
                    props,
                    context
                });
            }
            this.needsRedraw = this.needsRedraw || attribute.needsRedraw();
        }
        if (updated) // Only initiate alloc/update (and logging) if actually needed
        (0, _indexJsDefault.default)(TRACE_UPDATE_END, this, numInstances);
        if (this.stats) this.stats.get('Update Attributes').timeEnd();
        this.attributeTransitionManager.update({
            attributes: this.attributes,
            numInstances,
            transitions
        });
    }
    // Update attribute transition to the current timestamp
    // Returns `true` if any transition is in progress
    updateTransition() {
        const { attributeTransitionManager } = this;
        const transitionUpdated = attributeTransitionManager.run();
        this.needsRedraw = this.needsRedraw || transitionUpdated;
        return transitionUpdated;
    }
    /**
     * Returns all attribute descriptors
     * Note: Format matches luma.gl Model/Program.setAttributes()
     * @return {Object} attributes - descriptors
     */ getAttributes() {
        return {
            ...this.attributes,
            ...this.attributeTransitionManager.getAttributes()
        };
    }
    /**
     * Computes the spatial bounds of a given set of attributes
     */ getBounds(attributeNames) {
        const bounds = attributeNames.map((attributeName)=>this.attributes[attributeName]?.getBounds());
        return this.mergeBoundsMemoized(bounds);
    }
    /**
     * Returns changed attribute descriptors
     * This indicates which WebGLBuffers need to be updated
     * @return {Object} attributes - descriptors
     */ getChangedAttributes(opts = {
        clearChangedFlags: false
    }) {
        const { attributes, attributeTransitionManager } = this;
        const changedAttributes = {
            ...attributeTransitionManager.getAttributes()
        };
        for(const attributeName in attributes){
            const attribute = attributes[attributeName];
            if (attribute.needsRedraw(opts) && !attributeTransitionManager.hasAttribute(attributeName)) changedAttributes[attributeName] = attribute;
        }
        return changedAttributes;
    }
    /** Generate WebGPU-style buffer layout descriptors from all attributes */ getBufferLayouts(/** A luma.gl Model-shaped object that supplies additional hint to attribute resolution */ modelInfo) {
        return Object.values(this.getAttributes()).map((attribute)=>attribute.getBufferLayout(modelInfo));
    }
    // PRIVATE METHODS
    /** Register new attributes */ _add(/** A map from attribute name to attribute descriptors */ attributes, /** Additional attribute settings to pass to all attributes */ overrideOptions) {
        for(const attributeName in attributes){
            const attribute = attributes[attributeName];
            const props = {
                ...attribute,
                id: attributeName,
                size: attribute.isIndexed && 1 || attribute.size || 1,
                ...overrideOptions
            };
            // Initialize the attribute descriptor, with WebGL and metadata fields
            this.attributes[attributeName] = new (0, _attributeJsDefault.default)(this.device, props);
        }
        this._mapUpdateTriggersToAttributes();
    }
    // build updateTrigger name to attribute name mapping
    _mapUpdateTriggersToAttributes() {
        const triggers = {};
        for(const attributeName in this.attributes){
            const attribute = this.attributes[attributeName];
            attribute.getUpdateTriggers().forEach((triggerName)=>{
                if (!triggers[triggerName]) triggers[triggerName] = [];
                triggers[triggerName].push(attributeName);
            });
        }
        this.updateTriggers = triggers;
    }
    _invalidateTrigger(triggerName, dataRange) {
        const { attributes, updateTriggers } = this;
        const invalidatedAttributes = updateTriggers[triggerName];
        if (invalidatedAttributes) invalidatedAttributes.forEach((name)=>{
            const attribute = attributes[name];
            if (attribute) attribute.setNeedsUpdate(attribute.id, dataRange);
        });
        return invalidatedAttributes;
    }
    _updateAttribute(opts) {
        const { attribute, numInstances } = opts;
        (0, _indexJsDefault.default)(TRACE_ATTRIBUTE_UPDATE_START, attribute);
        if (attribute.constant) {
            // The attribute is flagged as constant outside of an update cycle
            // Skip allocation and updater call
            // @ts-ignore value can be set to an array by user but always cast to typed array during attribute update
            attribute.setConstantValue(attribute.value);
            return;
        }
        if (attribute.allocate(numInstances)) (0, _indexJsDefault.default)(TRACE_ATTRIBUTE_ALLOCATE, attribute, numInstances);
        // Calls update on any buffers that need update
        const updated = attribute.updateBuffer(opts);
        if (updated) {
            this.needsRedraw = true;
            (0, _indexJsDefault.default)(TRACE_ATTRIBUTE_UPDATE_END, attribute, numInstances);
        }
    }
}
exports.default = AttributeManager;

},{"./attribute.js":"3EOhx","../../utils/log.js":"9S0lD","../../utils/memoize.js":"4XQCO","../../utils/math-utils.js":"kiHqg","../../debug/index.js":"7gIzA","./attribute-transition-manager.js":"es5H6","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"es5H6":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// deck.gl, MIT license
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gpuInterpolationTransitionJs = require("../../transitions/gpu-interpolation-transition.js");
var _gpuInterpolationTransitionJsDefault = parcelHelpers.interopDefault(_gpuInterpolationTransitionJs);
var _gpuSpringTransitionJs = require("../../transitions/gpu-spring-transition.js");
var _gpuSpringTransitionJsDefault = parcelHelpers.interopDefault(_gpuSpringTransitionJs);
var _logJs = require("../../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
const TRANSITION_TYPES = {
    interpolation: (0, _gpuInterpolationTransitionJsDefault.default),
    spring: (0, _gpuSpringTransitionJsDefault.default)
};
class AttributeTransitionManager {
    constructor(device, { id, timeline }){
        if (!device) throw new Error('AttributeTransitionManager is constructed without device');
        this.id = id;
        this.device = device;
        this.timeline = timeline;
        this.transitions = {};
        this.needsRedraw = false;
        this.numInstances = 1;
    }
    finalize() {
        for(const attributeName in this.transitions)this._removeTransition(attributeName);
    }
    /* Public methods */ // Called when attribute manager updates
    // Check the latest attributes for updates.
    update({ attributes, transitions, numInstances }) {
        // Transform class will crash if elementCount is 0
        this.numInstances = numInstances || 1;
        for(const attributeName in attributes){
            const attribute = attributes[attributeName];
            const settings = attribute.getTransitionSetting(transitions);
            // this attribute might not support transitions?
            if (!settings) continue; // eslint-disable-line no-continue
            this._updateAttribute(attributeName, attribute, settings);
        }
        for(const attributeName in this.transitions){
            const attribute = attributes[attributeName];
            if (!attribute || !attribute.getTransitionSetting(transitions)) // Animated attribute has been removed
            this._removeTransition(attributeName);
        }
    }
    // Returns `true` if attribute is transition-enabled
    hasAttribute(attributeName) {
        const transition = this.transitions[attributeName];
        return transition && transition.inProgress;
    }
    // Get all the animated attributes
    getAttributes() {
        const animatedAttributes = {};
        for(const attributeName in this.transitions){
            const transition = this.transitions[attributeName];
            if (transition.inProgress) animatedAttributes[attributeName] = transition.attributeInTransition;
        }
        return animatedAttributes;
    }
    /* eslint-disable max-statements */ // Called every render cycle, run transform feedback
    // Returns `true` if anything changes
    run() {
        if (this.numInstances === 0) return false;
        for(const attributeName in this.transitions){
            const updated = this.transitions[attributeName].update();
            if (updated) this.needsRedraw = true;
        }
        const needsRedraw = this.needsRedraw;
        this.needsRedraw = false;
        return needsRedraw;
    }
    /* eslint-enable max-statements */ /* Private methods */ _removeTransition(attributeName) {
        this.transitions[attributeName].delete();
        delete this.transitions[attributeName];
    }
    // Check an attributes for updates
    // Returns a transition object if a new transition is triggered.
    _updateAttribute(attributeName, attribute, settings) {
        const transition = this.transitions[attributeName];
        // an attribute can change transition type when it updates
        // let's remove the transition when that happens so we can create the new transition type
        // TODO: when switching transition types, make sure to carry over the attribute's
        // previous buffers, currentLength, startIndices, etc, to be used as the starting point
        // for the next transition
        let isNew = !transition || transition.type !== settings.type;
        if (isNew) {
            if (transition) this._removeTransition(attributeName);
            const TransitionType = TRANSITION_TYPES[settings.type];
            if (TransitionType) this.transitions[attributeName] = new TransitionType({
                attribute,
                timeline: this.timeline,
                device: this.device
            });
            else {
                (0, _logJsDefault.default).error(`unsupported transition type '${settings.type}'`)();
                isNew = false;
            }
        }
        if (isNew || attribute.needsRedraw()) {
            this.needsRedraw = true;
            this.transitions[attributeName].start(settings, this.numInstances);
        }
    }
}
exports.default = AttributeTransitionManager;

},{"../../transitions/gpu-interpolation-transition.js":"jNY2z","../../transitions/gpu-spring-transition.js":"84dH9","../../utils/log.js":"9S0lD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jNY2z":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _engine = require("@luma.gl/engine");
var _shadertools = require("@luma.gl/shadertools");
var _constants = require("@luma.gl/constants");
var _gpuTransitionUtilsJs = require("./gpu-transition-utils.js");
var _gpuTransitionJs = require("./gpu-transition.js");
class GPUInterpolationTransition extends (0, _gpuTransitionJs.GPUTransitionBase) {
    constructor({ device, attribute, timeline }){
        super({
            device,
            attribute,
            timeline
        });
        this.type = 'interpolation';
        this.transform = getTransform(device, attribute);
    }
    start(transitionSettings, numInstances) {
        const prevLength = this.currentLength;
        const prevStartIndices = this.currentStartIndices;
        super.start(transitionSettings, numInstances, transitionSettings.duration);
        if (transitionSettings.duration <= 0) {
            this.transition.cancel();
            return;
        }
        const { buffers, attribute } = this;
        // Alternate between two buffers when new transitions start.
        // Last destination buffer is used as an attribute (from state),
        // And the other buffer is now the current buffer.
        (0, _gpuTransitionUtilsJs.cycleBuffers)(buffers);
        buffers[0] = (0, _gpuTransitionUtilsJs.padBuffer)({
            device: this.device,
            buffer: buffers[0],
            attribute,
            fromLength: prevLength,
            toLength: this.currentLength,
            fromStartIndices: prevStartIndices,
            getData: transitionSettings.enter
        });
        buffers[1] = (0, _gpuTransitionUtilsJs.matchBuffer)({
            device: this.device,
            source: buffers[0],
            target: buffers[1]
        });
        this.setBuffer(buffers[1]);
        const { transform } = this;
        const model = transform.model;
        let vertexCount = Math.floor(this.currentLength / attribute.size);
        if (useFp64(attribute)) vertexCount /= 2;
        model.setVertexCount(vertexCount);
        if (attribute.isConstant) {
            model.setAttributes({
                aFrom: buffers[0]
            });
            model.setConstantAttributes({
                aTo: attribute.value
            });
        } else model.setAttributes({
            aFrom: buffers[0],
            aTo: attribute.getBuffer()
        });
        transform.transformFeedback.setBuffers({
            vCurrent: buffers[1]
        });
    }
    onUpdate() {
        const { duration, easing } = this.settings;
        const { time } = this.transition;
        let t = time / duration;
        if (easing) t = easing(t);
        const { model } = this.transform;
        const interpolationProps = {
            time: t
        };
        model.shaderInputs.setProps({
            interpolation: interpolationProps
        });
        this.transform.run({
            discard: true
        });
    }
    delete() {
        super.delete();
        this.transform.destroy();
    }
}
exports.default = GPUInterpolationTransition;
const uniformBlock = `\
uniform interpolationUniforms {
  float time;
} interpolation;
`;
const interpolationUniforms = {
    name: 'interpolation',
    vs: uniformBlock,
    uniformTypes: {
        time: 'f32'
    }
};
const vs = `\
#version 300 es
#define SHADER_NAME interpolation-transition-vertex-shader

in ATTRIBUTE_TYPE aFrom;
in ATTRIBUTE_TYPE aTo;
out ATTRIBUTE_TYPE vCurrent;

void main(void) {
  vCurrent = mix(aFrom, aTo, interpolation.time);
  gl_Position = vec4(0.0);
}
`;
const vs64 = `\
#version 300 es
#define SHADER_NAME interpolation-transition-vertex-shader

in ATTRIBUTE_TYPE aFrom;
in ATTRIBUTE_TYPE aFrom64Low;
in ATTRIBUTE_TYPE aTo;
in ATTRIBUTE_TYPE aTo64Low;
out ATTRIBUTE_TYPE vCurrent;
out ATTRIBUTE_TYPE vCurrent64Low;

vec2 mix_fp64(vec2 a, vec2 b, float x) {
  vec2 range = sub_fp64(b, a);
  return sum_fp64(a, mul_fp64(range, vec2(x, 0.0)));
}

void main(void) {
  for (int i=0; i<ATTRIBUTE_SIZE; i++) {
    vec2 value = mix_fp64(vec2(aFrom[i], aFrom64Low[i]), vec2(aTo[i], aTo64Low[i]), interpolation.time);
    vCurrent[i] = value.x;
    vCurrent64Low[i] = value.y;
  }
  gl_Position = vec4(0.0);
}
`;
function useFp64(attribute) {
    return attribute.doublePrecision && attribute.value instanceof Float64Array;
}
function getTransform(device, attribute) {
    const attributeSize = attribute.size;
    const attributeType = (0, _gpuTransitionUtilsJs.getAttributeTypeFromSize)(attributeSize);
    const inputFormat = (0, _gpuTransitionUtilsJs.getFloat32VertexFormat)(attributeSize);
    const bufferLayout = attribute.getBufferLayout();
    if (useFp64(attribute)) return new (0, _engine.BufferTransform)(device, {
        vs: vs64,
        bufferLayout: [
            {
                name: 'aFrom',
                byteStride: 8 * attributeSize,
                attributes: [
                    {
                        attribute: 'aFrom',
                        format: inputFormat,
                        byteOffset: 0
                    },
                    {
                        attribute: 'aFrom64Low',
                        format: inputFormat,
                        byteOffset: 4 * attributeSize
                    }
                ]
            },
            {
                name: 'aTo',
                byteStride: 8 * attributeSize,
                attributes: [
                    {
                        attribute: 'aTo',
                        format: inputFormat,
                        byteOffset: 0
                    },
                    {
                        attribute: 'aTo64Low',
                        format: inputFormat,
                        byteOffset: 4 * attributeSize
                    }
                ]
            }
        ],
        // @ts-expect-error fp64 module only sets ONE uniform via defaultUniforms
        modules: [
            (0, _shadertools.fp64arithmetic),
            interpolationUniforms
        ],
        defines: {
            ATTRIBUTE_TYPE: attributeType,
            ATTRIBUTE_SIZE: attributeSize
        },
        // Default uniforms are not set without this
        moduleSettings: {},
        varyings: [
            'vCurrent',
            'vCurrent64Low'
        ],
        bufferMode: 35980,
        disableWarnings: true
    });
    return new (0, _engine.BufferTransform)(device, {
        vs,
        bufferLayout: [
            {
                name: 'aFrom',
                format: inputFormat
            },
            {
                name: 'aTo',
                format: bufferLayout.attributes[0].format
            }
        ],
        modules: [
            interpolationUniforms
        ],
        defines: {
            ATTRIBUTE_TYPE: attributeType
        },
        varyings: [
            'vCurrent'
        ],
        // TODO investigate why this is needed
        disableWarnings: true
    });
}

},{"@luma.gl/engine":"joT4s","@luma.gl/shadertools":"iH5G2","@luma.gl/constants":"9mN7r","./gpu-transition-utils.js":"4cbfl","./gpu-transition.js":"dkcCM","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4cbfl":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Create a new empty attribute with the same settings: type, shader layout etc. */ parcelHelpers.export(exports, "cloneAttribute", ()=>cloneAttribute);
/** Returns the GLSL attribute type for the given number of float32 components. */ parcelHelpers.export(exports, "getAttributeTypeFromSize", ()=>getAttributeTypeFromSize);
/** Returns the {@link VertexFormat} for the given number of float32 components. */ parcelHelpers.export(exports, "getFloat32VertexFormat", ()=>getFloat32VertexFormat);
parcelHelpers.export(exports, "cycleBuffers", ()=>cycleBuffers);
parcelHelpers.export(exports, "getAttributeBufferLength", ()=>getAttributeBufferLength);
parcelHelpers.export(exports, "matchBuffer", ()=>matchBuffer);
/* eslint-disable complexity */ // This helper is used when transitioning attributes from a set of values in one buffer layout
// to a set of values in a different buffer layout. (Buffer layouts are used when attribute values
// within a buffer should be grouped for drawElements, like the Polygon layer.) For example, a
// buffer layout of [3, 4] might have data [A1, A2, A3, B1, B2, B3, B4]. If it needs to transition
// to a buffer layout of [4, 2], it should produce a buffer, using the transition setting's `enter`
// function, that looks like this: [A1, A2, A3, A4 (user `enter` fn), B1, B2, 0]. Note: the final
// 0 in this buffer is because we never shrink buffers, only grow them, for performance reasons.
//
// padBuffer may return either the original buffer, or a new buffer if the size of the original
// was insufficient. Callers are responsible for disposing of the original buffer if needed.
parcelHelpers.export(exports, "padBuffer", ()=>padBuffer);
var _arrayUtilsJs = require("../utils/array-utils.js");
var _attributeJs = require("../lib/attribute/attribute.js");
var _attributeJsDefault = parcelHelpers.interopDefault(_attributeJs);
var _constants = require("@luma.gl/constants");
function cloneAttribute(attribute) {
    // `attribute.settings` is the original options passed when constructing the attribute.
    // This ensures that we set the proper `doublePrecision` flag and shader attributes.
    const { device, settings, value } = attribute;
    const newAttribute = new (0, _attributeJsDefault.default)(device, settings);
    // Placeholder value - necessary for generating the correct buffer layout
    newAttribute.setData({
        value: value instanceof Float64Array ? new Float64Array(0) : new Float32Array(0),
        normalized: settings.normalized
    });
    return newAttribute;
}
function getAttributeTypeFromSize(size) {
    switch(size){
        case 1:
            return 'float';
        case 2:
            return 'vec2';
        case 3:
            return 'vec3';
        case 4:
            return 'vec4';
        default:
            throw new Error(`No defined attribute type for size "${size}"`);
    }
}
function getFloat32VertexFormat(size) {
    switch(size){
        case 1:
            return 'float32';
        case 2:
            return 'float32x2';
        case 3:
            return 'float32x3';
        case 4:
            return 'float32x4';
        default:
            throw new Error('invalid type size');
    }
}
function cycleBuffers(buffers) {
    buffers.push(buffers.shift());
}
function getAttributeBufferLength(attribute, numInstances) {
    const { doublePrecision, settings, value, size } = attribute;
    const multiplier = doublePrecision && value instanceof Float64Array ? 2 : 1;
    let maxVertexOffset = 0;
    const { shaderAttributes } = attribute.settings;
    if (shaderAttributes) for (const shaderAttribute of Object.values(shaderAttributes))maxVertexOffset = Math.max(maxVertexOffset, shaderAttribute.vertexOffset ?? 0);
    return (settings.noAlloc ? value.length : (numInstances + maxVertexOffset) * size) * multiplier;
}
function matchBuffer({ device, source, target }) {
    if (!target || target.byteLength < source.byteLength) {
        target?.destroy();
        target = device.createBuffer({
            byteLength: source.byteLength,
            usage: source.usage
        });
    }
    return target;
}
function padBuffer({ device, buffer, attribute, fromLength, toLength, fromStartIndices, getData = (x)=>x }) {
    // TODO: move the precisionMultiplier logic to the attribute when retrieving
    // its `size` and `elementOffset`?
    const precisionMultiplier = attribute.doublePrecision && attribute.value instanceof Float64Array ? 2 : 1;
    const size = attribute.size * precisionMultiplier;
    const byteOffset = attribute.byteOffset;
    // Transform feedback can only write to float varyings
    // Attributes of format unorm8/uint8 (1 byte per element) etc will be padded to float32 (4 bytes per element)
    const targetByteOffset = attribute.settings.bytesPerElement < 4 ? byteOffset / attribute.settings.bytesPerElement * 4 : byteOffset;
    const toStartIndices = attribute.startIndices;
    const hasStartIndices = fromStartIndices && toStartIndices;
    const isConstant = attribute.isConstant;
    // check if buffer needs to be padded
    if (!hasStartIndices && buffer && fromLength >= toLength) return buffer;
    const ArrayType = attribute.value instanceof Float64Array ? Float32Array : attribute.value.constructor;
    const toData = isConstant ? attribute.value : new ArrayType(attribute.getBuffer().readSyncWebGL(byteOffset, toLength * ArrayType.BYTES_PER_ELEMENT).buffer);
    if (attribute.settings.normalized && !isConstant) {
        const getter = getData;
        getData = (value, chunk)=>attribute.normalizeConstant(getter(value, chunk));
    }
    const getMissingData = isConstant ? (i, chunk)=>getData(toData, chunk) : (i, chunk)=>getData(toData.subarray(i + byteOffset, i + byteOffset + size), chunk);
    // TODO(v9.1): Avoid non-portable synchronous reads.
    const source = buffer ? new Float32Array(buffer.readSyncWebGL(targetByteOffset, fromLength * 4).buffer) : new Float32Array(0);
    const target = new Float32Array(toLength);
    (0, _arrayUtilsJs.padArray)({
        source,
        target,
        sourceStartIndices: fromStartIndices,
        targetStartIndices: toStartIndices,
        size,
        getData: getMissingData
    });
    if (!buffer || buffer.byteLength < target.byteLength + targetByteOffset) {
        buffer?.destroy();
        buffer = device.createBuffer({
            byteLength: target.byteLength + targetByteOffset,
            usage: 35050
        });
    }
    buffer.write(target, targetByteOffset);
    return buffer;
}

},{"../utils/array-utils.js":"dQfeO","../lib/attribute/attribute.js":"3EOhx","@luma.gl/constants":"9mN7r","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dQfeO":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/*
 * Helper function for padArray
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * The padArray function stretches a source array to the size of a target array.
   The arrays can have internal structures (like the attributes of PathLayer and
   SolidPolygonLayer), defined by the optional sourceStartIndices and targetStartIndices parameters.
   If the target array is larger, the getData callback is used to fill in the blanks.
 */ parcelHelpers.export(exports, "padArray", ()=>padArray);
function padArrayChunk(options) {
    const { source, target, start = 0, size, getData } = options;
    const end = options.end || target.length;
    const sourceLength = source.length;
    const targetLength = end - start;
    if (sourceLength > targetLength) {
        target.set(source.subarray(0, targetLength), start);
        return;
    }
    target.set(source, start);
    if (!getData) return;
    // source is not large enough to fill target space, call `getData` to get filler data
    let i = sourceLength;
    while(i < targetLength){
        const datum = getData(i, source);
        for(let j = 0; j < size; j++){
            target[start + i] = datum[j] || 0;
            i++;
        }
    }
}
function padArray({ source, target, size, getData, sourceStartIndices, targetStartIndices }) {
    if (!sourceStartIndices || !targetStartIndices) {
        // Flat arrays
        padArrayChunk({
            source,
            target,
            size,
            getData
        });
        return target;
    }
    // Arrays have internal structure
    let sourceIndex = 0;
    let targetIndex = 0;
    const getChunkData = getData && ((i, chunk)=>getData(i + targetIndex, chunk));
    const n = Math.min(sourceStartIndices.length, targetStartIndices.length);
    for(let i = 1; i < n; i++){
        const nextSourceIndex = sourceStartIndices[i] * size;
        const nextTargetIndex = targetStartIndices[i] * size;
        padArrayChunk({
            source: source.subarray(sourceIndex, nextSourceIndex),
            target,
            start: targetIndex,
            end: nextTargetIndex,
            size,
            getData: getChunkData
        });
        sourceIndex = nextSourceIndex;
        targetIndex = nextTargetIndex;
    }
    if (targetIndex < target.length) padArrayChunk({
        // @ts-ignore
        source: [],
        target,
        start: targetIndex,
        size,
        getData: getChunkData
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dkcCM":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GPUTransitionBase", ()=>GPUTransitionBase);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _gpuTransitionUtilsJs = require("./gpu-transition-utils.js");
class GPUTransitionBase {
    constructor({ device, attribute, timeline }){
        this.buffers = [];
        /** The vertex count of the last buffer.
         * Buffer may be larger than the actual length we want to use
         * because we only reallocate buffers when they grow, not when they shrink,
         * due to performance costs */ this.currentLength = 0;
        this.device = device;
        this.transition = new (0, _transitionJsDefault.default)(timeline);
        this.attribute = attribute;
        this.attributeInTransition = (0, _gpuTransitionUtilsJs.cloneAttribute)(attribute);
        this.currentStartIndices = attribute.startIndices;
    }
    get inProgress() {
        return this.transition.inProgress;
    }
    start(transitionSettings, numInstances, duration = Infinity) {
        this.settings = transitionSettings;
        this.currentStartIndices = this.attribute.startIndices;
        this.currentLength = (0, _gpuTransitionUtilsJs.getAttributeBufferLength)(this.attribute, numInstances);
        this.transition.start({
            ...transitionSettings,
            duration
        });
    }
    update() {
        const updated = this.transition.update();
        if (updated) this.onUpdate();
        return updated;
    }
    setBuffer(buffer) {
        this.attributeInTransition.setData({
            buffer,
            normalized: this.attribute.settings.normalized,
            // Retain placeholder value to generate correct shader layout
            value: this.attributeInTransition.value
        });
    }
    cancel() {
        this.transition.cancel();
    }
    delete() {
        this.cancel();
        for (const buffer of this.buffers)buffer.destroy();
        this.buffers.length = 0;
    }
}

},{"./transition.js":"gMqhw","./gpu-transition-utils.js":"4cbfl","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"84dH9":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _engine = require("@luma.gl/engine");
var _gpuTransitionUtilsJs = require("./gpu-transition-utils.js");
var _gpuTransitionJs = require("./gpu-transition.js");
class GPUSpringTransition extends (0, _gpuTransitionJs.GPUTransitionBase) {
    constructor({ device, attribute, timeline }){
        super({
            device,
            attribute,
            timeline
        });
        this.type = 'spring';
        this.texture = getTexture(device);
        this.framebuffer = getFramebuffer(device, this.texture);
        this.transform = getTransform(device, attribute);
    }
    start(transitionSettings, numInstances) {
        const prevLength = this.currentLength;
        const prevStartIndices = this.currentStartIndices;
        super.start(transitionSettings, numInstances);
        const { buffers, attribute } = this;
        for(let i = 0; i < 2; i++)buffers[i] = (0, _gpuTransitionUtilsJs.padBuffer)({
            device: this.device,
            buffer: buffers[i],
            attribute,
            fromLength: prevLength,
            toLength: this.currentLength,
            fromStartIndices: prevStartIndices,
            getData: transitionSettings.enter
        });
        buffers[2] = (0, _gpuTransitionUtilsJs.matchBuffer)({
            device: this.device,
            source: buffers[0],
            target: buffers[2]
        });
        this.setBuffer(buffers[1]);
        const { model } = this.transform;
        model.setVertexCount(Math.floor(this.currentLength / attribute.size));
        if (attribute.isConstant) model.setConstantAttributes({
            aTo: attribute.value
        });
        else model.setAttributes({
            aTo: attribute.getBuffer()
        });
    }
    onUpdate() {
        const { buffers, transform, framebuffer, transition } = this;
        const settings = this.settings;
        transform.model.setAttributes({
            aPrev: buffers[0],
            aCur: buffers[1]
        });
        transform.transformFeedback.setBuffers({
            vNext: buffers[2]
        });
        const springProps = {
            stiffness: settings.stiffness,
            damping: settings.damping
        };
        transform.model.shaderInputs.setProps({
            spring: springProps
        });
        transform.run({
            framebuffer,
            discard: false,
            parameters: {
                viewport: [
                    0,
                    0,
                    1,
                    1
                ]
            },
            clearColor: [
                0,
                0,
                0,
                0
            ]
        });
        (0, _gpuTransitionUtilsJs.cycleBuffers)(buffers);
        this.setBuffer(buffers[1]);
        const isTransitioning = this.device.readPixelsToArrayWebGL(framebuffer)[0] > 0;
        if (!isTransitioning) transition.end();
    }
    delete() {
        super.delete();
        this.transform.destroy();
        this.texture.destroy();
        this.framebuffer.destroy();
    }
}
exports.default = GPUSpringTransition;
const uniformBlock = `\
uniform springUniforms {
  float damping;
  float stiffness;
} spring;
`;
const springUniforms = {
    name: 'spring',
    vs: uniformBlock,
    uniformTypes: {
        damping: 'f32',
        stiffness: 'f32'
    }
};
const vs = `\
#version 300 es
#define SHADER_NAME spring-transition-vertex-shader

#define EPSILON 0.00001

in ATTRIBUTE_TYPE aPrev;
in ATTRIBUTE_TYPE aCur;
in ATTRIBUTE_TYPE aTo;
out ATTRIBUTE_TYPE vNext;
out float vIsTransitioningFlag;

ATTRIBUTE_TYPE getNextValue(ATTRIBUTE_TYPE cur, ATTRIBUTE_TYPE prev, ATTRIBUTE_TYPE dest) {
  ATTRIBUTE_TYPE velocity = cur - prev;
  ATTRIBUTE_TYPE delta = dest - cur;
  ATTRIBUTE_TYPE force = delta * spring.stiffness;
  ATTRIBUTE_TYPE resistance = velocity * spring.damping;
  return force - resistance + velocity + cur;
}

void main(void) {
  bool isTransitioning = length(aCur - aPrev) > EPSILON || length(aTo - aCur) > EPSILON;
  vIsTransitioningFlag = isTransitioning ? 1.0 : 0.0;

  vNext = getNextValue(aCur, aPrev, aTo);
  gl_Position = vec4(0, 0, 0, 1);
  gl_PointSize = 100.0;
}
`;
const fs = `\
#version 300 es
#define SHADER_NAME spring-transition-is-transitioning-fragment-shader

in float vIsTransitioningFlag;

out vec4 fragColor;

void main(void) {
  if (vIsTransitioningFlag == 0.0) {
    discard;
  }
  fragColor = vec4(1.0);
}`;
function getTransform(device, attribute) {
    const attributeType = (0, _gpuTransitionUtilsJs.getAttributeTypeFromSize)(attribute.size);
    const format = (0, _gpuTransitionUtilsJs.getFloat32VertexFormat)(attribute.size);
    return new (0, _engine.BufferTransform)(device, {
        vs,
        fs,
        bufferLayout: [
            {
                name: 'aPrev',
                format
            },
            {
                name: 'aCur',
                format
            },
            {
                name: 'aTo',
                format: attribute.getBufferLayout().attributes[0].format
            }
        ],
        varyings: [
            'vNext'
        ],
        modules: [
            springUniforms
        ],
        defines: {
            ATTRIBUTE_TYPE: attributeType
        },
        parameters: {
            depthCompare: 'always',
            blendColorOperation: 'max',
            blendColorSrcFactor: 'one',
            blendColorDstFactor: 'one',
            blendAlphaOperation: 'max',
            blendAlphaSrcFactor: 'one',
            blendAlphaDstFactor: 'one'
        }
    });
}
function getTexture(device) {
    return device.createTexture({
        data: new Uint8Array(4),
        format: 'rgba8unorm',
        mipmaps: false,
        width: 1,
        height: 1
    });
}
function getFramebuffer(device, texture) {
    return device.createFramebuffer({
        id: 'spring-transition-is-transitioning-framebuffer',
        width: 1,
        height: 1,
        colorAttachments: [
            texture
        ]
    });
}

},{"@luma.gl/engine":"joT4s","./gpu-transition-utils.js":"4cbfl","./gpu-transition.js":"dkcCM","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gOEmJ":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable react/no-direct-mutation-state */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@luma.gl/core");
var _webgl = require("@luma.gl/webgl");
var _constantsJs = require("./constants.js");
var _attributeManagerJs = require("./attribute/attribute-manager.js");
var _attributeManagerJsDefault = parcelHelpers.interopDefault(_attributeManagerJs);
var _uniformTransitionManagerJs = require("./uniform-transition-manager.js");
var _uniformTransitionManagerJsDefault = parcelHelpers.interopDefault(_uniformTransitionManagerJs);
var _propsJs = require("../lifecycle/props.js");
var _constantsJs1 = require("../lifecycle/constants.js");
var _countJs = require("../utils/count.js");
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _indexJs = require("../debug/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _assertJs = require("../utils/assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
var _memoizeJs = require("../utils/memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
var _shaderJs = require("../utils/shader.js");
var _projectFunctionsJs = require("../shaderlib/project/project-functions.js");
var _typedArrayManagerJs = require("../utils/typed-array-manager.js");
var _typedArrayManagerJsDefault = parcelHelpers.interopDefault(_typedArrayManagerJs);
var _componentJs = require("../lifecycle/component.js");
var _componentJsDefault = parcelHelpers.interopDefault(_componentJs);
var _layerStateJs = require("./layer-state.js");
var _layerStateJsDefault = parcelHelpers.interopDefault(_layerStateJs);
var _webMercator = require("@math.gl/web-mercator");
var _core1 = require("@loaders.gl/core");
const TRACE_CHANGE_FLAG = 'layer.changeFlag';
const TRACE_INITIALIZE = 'layer.initialize';
const TRACE_UPDATE = 'layer.update';
const TRACE_FINALIZE = 'layer.finalize';
const TRACE_MATCHED = 'layer.matched';
const MAX_PICKING_COLOR_CACHE_SIZE = 2 ** 24 - 1;
const EMPTY_ARRAY = Object.freeze([]);
// Only compare the same two viewports once
const areViewportsEqual = (0, _memoizeJsDefault.default)(({ oldViewport, viewport })=>{
    return oldViewport.equals(viewport);
});
let pickingColorCache = new Uint8ClampedArray(0);
const defaultProps = {
    // data: Special handling for null, see below
    data: {
        type: 'data',
        value: EMPTY_ARRAY,
        async: true
    },
    dataComparator: {
        type: 'function',
        value: null,
        optional: true
    },
    _dataDiff: {
        type: 'function',
        // @ts-ignore __diff is not defined on data
        value: (data)=>data && data.__diff,
        optional: true
    },
    dataTransform: {
        type: 'function',
        value: null,
        optional: true
    },
    onDataLoad: {
        type: 'function',
        value: null,
        optional: true
    },
    onError: {
        type: 'function',
        value: null,
        optional: true
    },
    fetch: {
        type: 'function',
        value: (url, { propName, layer, loaders, loadOptions, signal })=>{
            const { resourceManager } = layer.context;
            loadOptions = loadOptions || layer.getLoadOptions();
            loaders = loaders || layer.props.loaders;
            if (signal) loadOptions = {
                ...loadOptions,
                fetch: {
                    ...loadOptions?.fetch,
                    signal
                }
            };
            let inResourceManager = resourceManager.contains(url);
            if (!inResourceManager && !loadOptions) {
                // If there is no layer-specific load options, then attempt to cache this resource in the data manager
                resourceManager.add({
                    resourceId: url,
                    data: (0, _core1.load)(url, loaders),
                    persistent: false
                });
                inResourceManager = true;
            }
            if (inResourceManager) return resourceManager.subscribe({
                resourceId: url,
                onChange: (data)=>layer.internalState?.reloadAsyncProp(propName, data),
                consumerId: layer.id,
                requestId: propName
            });
            return (0, _core1.load)(url, loaders, loadOptions);
        }
    },
    updateTriggers: {},
    visible: true,
    pickable: false,
    opacity: {
        type: 'number',
        min: 0,
        max: 1,
        value: 1
    },
    operation: 'draw',
    onHover: {
        type: 'function',
        value: null,
        optional: true
    },
    onClick: {
        type: 'function',
        value: null,
        optional: true
    },
    onDragStart: {
        type: 'function',
        value: null,
        optional: true
    },
    onDrag: {
        type: 'function',
        value: null,
        optional: true
    },
    onDragEnd: {
        type: 'function',
        value: null,
        optional: true
    },
    coordinateSystem: (0, _constantsJs.COORDINATE_SYSTEM).DEFAULT,
    coordinateOrigin: {
        type: 'array',
        value: [
            0,
            0,
            0
        ],
        compare: true
    },
    modelMatrix: {
        type: 'array',
        value: null,
        compare: true,
        optional: true
    },
    wrapLongitude: false,
    positionFormat: 'XYZ',
    colorFormat: 'RGBA',
    parameters: {
        type: 'object',
        value: {},
        optional: true,
        compare: 2
    },
    loadOptions: {
        type: 'object',
        value: null,
        optional: true,
        ignore: true
    },
    transitions: null,
    extensions: [],
    loaders: {
        type: 'array',
        value: [],
        optional: true,
        ignore: true
    },
    // Offset depth based on layer index to avoid z-fighting.
    // Negative values pull layer towards the camera
    // https://www.opengl.org/archives/resources/faq/technical/polygonoffset.htm
    getPolygonOffset: {
        type: 'function',
        value: ({ layerIndex })=>[
                0,
                -layerIndex * 100
            ]
    },
    // Selection/Highlighting
    highlightedObjectIndex: null,
    autoHighlight: false,
    highlightColor: {
        type: 'accessor',
        value: [
            0,
            0,
            128,
            128
        ]
    }
};
class Layer extends (0, _componentJsDefault.default) {
    constructor(){
        super(...arguments);
        this.internalState = null;
        this.lifecycle = (0, _constantsJs1.LIFECYCLE).NO_STATE; // Helps track and debug the life cycle of the layers
        this.parent = null;
    }
    static get componentName() {
        return Object.prototype.hasOwnProperty.call(this, 'layerName') ? this.layerName : '';
    }
    get root() {
        // eslint-disable-next-line
        let layer = this;
        while(layer.parent)layer = layer.parent;
        return layer;
    }
    toString() {
        const className = this.constructor.layerName || this.constructor.name;
        return `${className}({id: '${this.props.id}'})`;
    }
    // Public API for users
    /** Projects a point with current view state from the current layer's coordinate system to screen */ project(xyz) {
        (0, _assertJsDefault.default)(this.internalState);
        const viewport = this.internalState.viewport || this.context.viewport;
        const worldPosition = (0, _projectFunctionsJs.getWorldPosition)(xyz, {
            viewport,
            modelMatrix: this.props.modelMatrix,
            coordinateOrigin: this.props.coordinateOrigin,
            coordinateSystem: this.props.coordinateSystem
        });
        const [x, y, z] = (0, _webMercator.worldToPixels)(worldPosition, viewport.pixelProjectionMatrix);
        return xyz.length === 2 ? [
            x,
            y
        ] : [
            x,
            y,
            z
        ];
    }
    /** Unprojects a screen pixel to the current view's default coordinate system
        Note: this does not reverse `project`. */ unproject(xy) {
        (0, _assertJsDefault.default)(this.internalState);
        const viewport = this.internalState.viewport || this.context.viewport;
        return viewport.unproject(xy);
    }
    /** Projects a point with current view state from the current layer's coordinate system to the world space */ projectPosition(xyz, params) {
        (0, _assertJsDefault.default)(this.internalState);
        const viewport = this.internalState.viewport || this.context.viewport;
        return (0, _projectFunctionsJs.projectPosition)(xyz, {
            viewport,
            modelMatrix: this.props.modelMatrix,
            coordinateOrigin: this.props.coordinateOrigin,
            coordinateSystem: this.props.coordinateSystem,
            ...params
        });
    }
    // Public API for custom layer implementation
    /** `true` if this layer renders other layers */ get isComposite() {
        return false;
    }
    /** `true` if the layer renders to screen */ get isDrawable() {
        return true;
    }
    /** Updates selected state members and marks the layer for redraw */ setState(partialState) {
        this.setChangeFlags({
            stateChanged: true
        });
        Object.assign(this.state, partialState);
        this.setNeedsRedraw();
    }
    /** Sets the redraw flag for this layer, will trigger a redraw next animation frame */ setNeedsRedraw() {
        if (this.internalState) this.internalState.needsRedraw = true;
    }
    /** Mark this layer as needs a deep update */ setNeedsUpdate() {
        if (this.internalState) {
            this.context.layerManager.setNeedsUpdate(String(this));
            this.internalState.needsUpdate = true;
        }
    }
    /** Returns true if all async resources are loaded */ get isLoaded() {
        return this.internalState ? !this.internalState.isAsyncPropLoading() : false;
    }
    /** Returns true if using shader-based WGS84 longitude wrapping */ get wrapLongitude() {
        return this.props.wrapLongitude;
    }
    /** @deprecated Returns true if the layer is visible in the picking pass */ isPickable() {
        return this.props.pickable && this.props.visible;
    }
    /** Returns an array of models used by this layer, can be overriden by layer subclass */ getModels() {
        const state = this.state;
        return state && (state.models || state.model && [
            state.model
        ]) || [];
    }
    /** Update shader input parameters */ setShaderModuleProps(...props) {
        for (const model of this.getModels())model.shaderInputs.setProps(...props);
    }
    /** Returns the attribute manager of this layer */ getAttributeManager() {
        return this.internalState && this.internalState.attributeManager;
    }
    /** Returns the most recent layer that matched to this state
      (When reacting to an async event, this layer may no longer be the latest) */ getCurrentLayer() {
        return this.internalState && this.internalState.layer;
    }
    /** Returns the default parse options for async props */ getLoadOptions() {
        return this.props.loadOptions;
    }
    use64bitPositions() {
        const { coordinateSystem } = this.props;
        return coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).DEFAULT || coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT || coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).CARTESIAN;
    }
    // Event handling
    onHover(info, pickingEvent) {
        if (this.props.onHover) return this.props.onHover(info, pickingEvent) || false;
        return false;
    }
    onClick(info, pickingEvent) {
        if (this.props.onClick) return this.props.onClick(info, pickingEvent) || false;
        return false;
    }
    // Returns the picking color that doesn't match any subfeature
    // Use if some graphics do not belong to any pickable subfeature
    // @return {Array} - a black color
    nullPickingColor() {
        return [
            0,
            0,
            0
        ];
    }
    // Returns the picking color that doesn't match any subfeature
    // Use if some graphics do not belong to any pickable subfeature
    encodePickingColor(i, target = []) {
        target[0] = i + 1 & 255;
        target[1] = i + 1 >> 8 & 255;
        target[2] = i + 1 >> 8 >> 8 & 255;
        return target;
    }
    // Returns the index corresponding to a picking color that doesn't match any subfeature
    // @param {Uint8Array} color - color array to be decoded
    // @return {Array} - the decoded picking color
    decodePickingColor(color) {
        (0, _assertJsDefault.default)(color instanceof Uint8Array);
        const [i1, i2, i3] = color;
        // 1 was added to seperate from no selection
        const index = i1 + i2 * 256 + i3 * 65536 - 1;
        return index;
    }
    /** Deduces number of instances. Intention is to support:
      - Explicit setting of numInstances
      - Auto-deduction for ES6 containers that define a size member
      - Auto-deduction for Classic Arrays via the built-in length attribute
      - Auto-deduction via arrays */ getNumInstances() {
        // First Check if app has provided an explicit value
        if (Number.isFinite(this.props.numInstances)) return this.props.numInstances;
        // Second check if the layer has set its own value
        if (this.state && this.state.numInstances !== undefined) return this.state.numInstances;
        // Use container library to get a count for any ES6 container or object
        return (0, _countJs.count)(this.props.data);
    }
    /** Buffer layout describes how many attribute values are packed for each data object
        The default (null) is one value each object.
        Some data formats (e.g. paths, polygons) have various length. Their buffer layout
        is in the form of [L0, L1, L2, ...] */ getStartIndices() {
        // First Check if startIndices is provided as an explicit value
        if (this.props.startIndices) return this.props.startIndices;
        // Second check if the layer has set its own value
        if (this.state && this.state.startIndices) return this.state.startIndices;
        return null;
    }
    // Default implementation
    getBounds() {
        return this.getAttributeManager()?.getBounds([
            'positions',
            'instancePositions'
        ]);
    }
    getShaders(shaders) {
        shaders = (0, _shaderJs.mergeShaders)(shaders, {
            disableWarnings: true,
            modules: this.context.defaultShaderModules
        });
        for (const extension of this.props.extensions)shaders = (0, _shaderJs.mergeShaders)(shaders, extension.getShaders.call(this, extension));
        return shaders;
    }
    /** Controls if updateState should be called. By default returns true if any prop has changed */ shouldUpdateState(params) {
        return params.changeFlags.propsOrDataChanged;
    }
    /** Default implementation, all attributes will be invalidated and updated when data changes */ // eslint-disable-next-line complexity
    updateState(params) {
        const attributeManager = this.getAttributeManager();
        const { dataChanged } = params.changeFlags;
        if (dataChanged && attributeManager) {
            if (Array.isArray(dataChanged)) // is partial update
            for (const dataRange of dataChanged)attributeManager.invalidateAll(dataRange);
            else attributeManager.invalidateAll();
        }
        // Enable/disable picking buffer
        if (attributeManager) {
            const { props } = params;
            const hasPickingBuffer = this.internalState.hasPickingBuffer;
            const needsPickingBuffer = Number.isInteger(props.highlightedObjectIndex) || props.pickable || props.extensions.some((extension)=>extension.getNeedsPickingBuffer.call(this, extension));
            // Only generate picking buffer if needed
            if (hasPickingBuffer !== needsPickingBuffer) {
                this.internalState.hasPickingBuffer = needsPickingBuffer;
                const { pickingColors, instancePickingColors } = attributeManager.attributes;
                const pickingColorsAttribute = pickingColors || instancePickingColors;
                if (pickingColorsAttribute) {
                    if (needsPickingBuffer && pickingColorsAttribute.constant) {
                        pickingColorsAttribute.constant = false;
                        attributeManager.invalidate(pickingColorsAttribute.id);
                    }
                    if (!pickingColorsAttribute.value && !needsPickingBuffer) {
                        pickingColorsAttribute.constant = true;
                        pickingColorsAttribute.value = [
                            0,
                            0,
                            0
                        ];
                    }
                }
            }
        }
    }
    /** Called once when layer is no longer matched and state will be discarded. Layers can destroy WebGL resources here. */ finalizeState(context) {
        for (const model of this.getModels())model.destroy();
        const attributeManager = this.getAttributeManager();
        if (attributeManager) attributeManager.finalize();
        if (this.context) this.context.resourceManager.unsubscribe({
            consumerId: this.id
        });
        if (this.internalState) {
            this.internalState.uniformTransitions.clear();
            this.internalState.finalize();
        }
    }
    // If state has a model, draw it with supplied uniforms
    draw(opts) {
        for (const model of this.getModels())model.draw(opts.renderPass);
    }
    // called to populate the info object that is passed to the event handler
    // @return null to cancel event
    getPickingInfo({ info, mode, sourceLayer }) {
        const { index } = info;
        if (index >= 0) // If props.data is an indexable array, get the object
        {
            if (Array.isArray(this.props.data)) info.object = this.props.data[index];
        }
        return info;
    }
    // END LIFECYCLE METHODS
    // / INTERNAL METHODS - called by LayerManager, DeckRenderer and DeckPicker
    /** (Internal) Propagate an error event through the system */ raiseError(error, message) {
        if (message) // Duplicating error message for backward compatibility, see #7986
        // TODO - revisit in v9
        error = new Error(`${message}: ${error.message}`, {
            cause: error
        });
        if (!this.props.onError?.(error)) this.context?.onError?.(error, this);
    }
    /** (Internal) Checks if this layer needs redraw */ getNeedsRedraw(opts = {
        clearRedrawFlags: false
    }) {
        return this._getNeedsRedraw(opts);
    }
    /** (Internal) Checks if this layer needs a deep update */ needsUpdate() {
        if (!this.internalState) return false;
        // Call subclass lifecycle method
        return this.internalState.needsUpdate || this.hasUniformTransition() || this.shouldUpdateState(this._getUpdateParams());
    // End lifecycle method
    }
    /** Checks if this layer has ongoing uniform transition */ hasUniformTransition() {
        return this.internalState?.uniformTransitions.active || false;
    }
    /** Called when this layer is rendered into the given viewport */ activateViewport(viewport) {
        if (!this.internalState) return;
        const oldViewport = this.internalState.viewport;
        this.internalState.viewport = viewport;
        if (!oldViewport || !areViewportsEqual({
            oldViewport,
            viewport
        })) {
            this.setChangeFlags({
                viewportChanged: true
            });
            if (this.isComposite) {
                if (this.needsUpdate()) // Composite layers may add/remove sublayers on viewport change
                // Because we cannot change the layers list during a draw cycle, we don't want to update sublayers right away
                // This will not call update immediately, but mark the layerManager as needs update on the next frame
                this.setNeedsUpdate();
            } else this._update();
        }
    }
    /** Default implementation of attribute invalidation, can be redefined */ invalidateAttribute(name = 'all') {
        const attributeManager = this.getAttributeManager();
        if (!attributeManager) return;
        if (name === 'all') attributeManager.invalidateAll();
        else attributeManager.invalidate(name);
    }
    /** Send updated attributes to the WebGL model */ updateAttributes(changedAttributes) {
        // If some buffer layout changed
        let bufferLayoutChanged = false;
        for(const id in changedAttributes)if (changedAttributes[id].layoutChanged()) bufferLayoutChanged = true;
        for (const model of this.getModels())this._setModelAttributes(model, changedAttributes, bufferLayoutChanged);
    }
    /** Recalculate any attributes if needed */ _updateAttributes() {
        const attributeManager = this.getAttributeManager();
        if (!attributeManager) return;
        const props = this.props;
        // Figure out data length
        const numInstances = this.getNumInstances();
        const startIndices = this.getStartIndices();
        attributeManager.update({
            data: props.data,
            numInstances,
            startIndices,
            props,
            transitions: props.transitions,
            // @ts-ignore (TS2339) property attribute is not present on some acceptable data types
            buffers: props.data.attributes,
            context: this
        });
        const changedAttributes = attributeManager.getChangedAttributes({
            clearChangedFlags: true
        });
        this.updateAttributes(changedAttributes);
    }
    /** Update attribute transitions. This is called in drawLayer, no model updates required. */ _updateAttributeTransition() {
        const attributeManager = this.getAttributeManager();
        if (attributeManager) attributeManager.updateTransition();
    }
    /** Update uniform (prop) transitions. This is called in updateState, may result in model updates. */ _updateUniformTransition() {
        // @ts-ignore (TS2339) internalState is alwasy defined when this method is called
        const { uniformTransitions } = this.internalState;
        if (uniformTransitions.active) {
            // clone props
            const propsInTransition = uniformTransitions.update();
            const props = Object.create(this.props);
            for(const key in propsInTransition)Object.defineProperty(props, key, {
                value: propsInTransition[key]
            });
            return props;
        }
        return this.props;
    }
    /** Updater for the automatically populated instancePickingColors attribute */ calculateInstancePickingColors(attribute, { numInstances }) {
        if (attribute.constant) return;
        // calculateInstancePickingColors always generates the same sequence.
        // pickingColorCache saves the largest generated sequence for reuse
        const cacheSize = Math.floor(pickingColorCache.length / 4);
        // Record when using the picking buffer cache, so that layers can always point at the most recently allocated cache
        // @ts-ignore (TS2531) internalState is always defined when this method is called
        this.internalState.usesPickingColorCache = true;
        if (cacheSize < numInstances) {
            if (numInstances > MAX_PICKING_COLOR_CACHE_SIZE) (0, _logJsDefault.default).warn('Layer has too many data objects. Picking might not be able to distinguish all objects.')();
            pickingColorCache = (0, _typedArrayManagerJsDefault.default).allocate(pickingColorCache, numInstances, {
                size: 4,
                copy: true,
                maxCount: Math.max(numInstances, MAX_PICKING_COLOR_CACHE_SIZE)
            });
            // If the attribute is larger than the cache, resize the cache and populate the missing chunk
            const newCacheSize = Math.floor(pickingColorCache.length / 4);
            const pickingColor = [
                0,
                0,
                0
            ];
            for(let i = cacheSize; i < newCacheSize; i++){
                this.encodePickingColor(i, pickingColor);
                pickingColorCache[i * 4 + 0] = pickingColor[0];
                pickingColorCache[i * 4 + 1] = pickingColor[1];
                pickingColorCache[i * 4 + 2] = pickingColor[2];
                pickingColorCache[i * 4 + 3] = 0;
            }
        }
        attribute.value = pickingColorCache.subarray(0, numInstances * 4);
    }
    /** Apply changed attributes to model */ _setModelAttributes(model, changedAttributes, bufferLayoutChanged = false) {
        if (!Object.keys(changedAttributes).length) return;
        if (bufferLayoutChanged) {
            // AttributeManager is always defined when this method is called
            const attributeManager = this.getAttributeManager();
            model.setBufferLayout(attributeManager.getBufferLayouts(model));
            // All attributes must be reset after buffer layout change
            changedAttributes = attributeManager.getAttributes();
        }
        // @ts-ignore luma.gl type issue
        const excludeAttributes = model.userData?.excludeAttributes || {};
        const attributeBuffers = {};
        const constantAttributes = {};
        for(const name in changedAttributes){
            if (excludeAttributes[name]) continue;
            const values = changedAttributes[name].getValue();
            for(const attributeName in values){
                const value = values[attributeName];
                if (value instanceof (0, _core.Buffer)) {
                    if (changedAttributes[name].settings.isIndexed) model.setIndexBuffer(value);
                    else attributeBuffers[attributeName] = value;
                } else if (value) constantAttributes[attributeName] = value;
            }
        }
        // TODO - update buffer map?
        model.setAttributes(attributeBuffers);
        model.setConstantAttributes(constantAttributes);
    }
    /** (Internal) Sets the picking color at the specified index to null picking color. Used for multi-depth picking.
       This method may be overriden by layer implementations */ disablePickingIndex(objectIndex) {
        const data = this.props.data;
        if (!('attributes' in data)) {
            this._disablePickingIndex(objectIndex);
            return;
        }
        // @ts-ignore (TS2531) this method is only called internally with attributeManager defined
        const { pickingColors, instancePickingColors } = this.getAttributeManager().attributes;
        const colors = pickingColors || instancePickingColors;
        const externalColorAttribute = colors && data.attributes && data.attributes[colors.id];
        if (externalColorAttribute && externalColorAttribute.value) {
            const values = externalColorAttribute.value;
            const objectColor = this.encodePickingColor(objectIndex);
            for(let index = 0; index < data.length; index++){
                const i = colors.getVertexOffset(index);
                if (values[i] === objectColor[0] && values[i + 1] === objectColor[1] && values[i + 2] === objectColor[2]) this._disablePickingIndex(index);
            }
        } else this._disablePickingIndex(objectIndex);
    }
    // TODO - simplify subclassing interface
    _disablePickingIndex(objectIndex) {
        // @ts-ignore (TS2531) this method is only called internally with attributeManager defined
        const { pickingColors, instancePickingColors } = this.getAttributeManager().attributes;
        const colors = pickingColors || instancePickingColors;
        if (!colors) return;
        const start = colors.getVertexOffset(objectIndex);
        const end = colors.getVertexOffset(objectIndex + 1);
        // Fill the sub buffer with 0s, 1 byte per element
        colors.buffer.write(new Uint8Array(end - start), start);
    }
    /** (Internal) Re-enable all picking indices after multi-depth picking */ restorePickingColors() {
        // @ts-ignore (TS2531) this method is only called internally with attributeManager defined
        const { pickingColors, instancePickingColors } = this.getAttributeManager().attributes;
        const colors = pickingColors || instancePickingColors;
        if (!colors) return;
        // The picking color cache may have been freed and then reallocated. This ensures we read from the currently allocated cache.
        if (// @ts-ignore (TS2531) this method is only called internally with internalState defined
        this.internalState.usesPickingColorCache && colors.value.buffer !== pickingColorCache.buffer) colors.value = pickingColorCache.subarray(0, colors.value.length);
        colors.updateSubBuffer({
            startOffset: 0
        });
    }
    /* eslint-disable max-statements */ /* (Internal) Called by layer manager when a new layer is found */ _initialize() {
        (0, _assertJsDefault.default)(!this.internalState); // finalized layer cannot be reused
        (0, _assertJsDefault.default)(Number.isFinite(this.props.coordinateSystem)); // invalid coordinateSystem
        (0, _indexJsDefault.default)(TRACE_INITIALIZE, this);
        const attributeManager = this._getAttributeManager();
        if (attributeManager) // All instanced layers get instancePickingColors attribute by default
        // Their shaders can use it to render a picking scene
        // TODO - this slightly slows down non instanced layers
        attributeManager.addInstanced({
            instancePickingColors: {
                type: 'uint8',
                size: 4,
                noAlloc: true,
                // Updaters are always called with `this` pointing to the layer
                // eslint-disable-next-line @typescript-eslint/unbound-method
                update: this.calculateInstancePickingColors
            }
        });
        this.internalState = new (0, _layerStateJsDefault.default)({
            attributeManager,
            layer: this
        });
        this._clearChangeFlags(); // populate this.internalState.changeFlags
        this.state = {};
        // for backwards compatibility with older layers
        // TODO - remove in next release
        /* eslint-disable accessor-pairs */ Object.defineProperty(this.state, 'attributeManager', {
            get: ()=>{
                (0, _logJsDefault.default).deprecated('layer.state.attributeManager', 'layer.getAttributeManager()')();
                return attributeManager;
            }
        });
        /* eslint-enable accessor-pairs */ this.internalState.uniformTransitions = new (0, _uniformTransitionManagerJsDefault.default)(this.context.timeline);
        this.internalState.onAsyncPropUpdated = this._onAsyncPropUpdated.bind(this);
        // Ensure any async props are updated
        this.internalState.setAsyncProps(this.props);
        // Call subclass lifecycle methods
        this.initializeState(this.context);
        // Initialize extensions
        for (const extension of this.props.extensions)extension.initializeState.call(this, this.context, extension);
        // End subclass lifecycle methods
        // initializeState callback tends to clear state
        this.setChangeFlags({
            dataChanged: 'init',
            propsChanged: 'init',
            viewportChanged: true,
            extensionsChanged: true
        });
        this._update();
    }
    /** (Internal) Called by layer manager to transfer state from an old layer */ _transferState(oldLayer) {
        (0, _indexJsDefault.default)(TRACE_MATCHED, this, this === oldLayer);
        const { state, internalState } = oldLayer;
        if (this === oldLayer) return;
        // Move internalState
        this.internalState = internalState;
        // Move state
        this.state = state;
        // We keep the state ref on old layers to support async actions
        // oldLayer.state = null;
        // Ensure any async props are updated
        this.internalState.setAsyncProps(this.props);
        this._diffProps(this.props, this.internalState.getOldProps());
    }
    /** (Internal) Called by layer manager when a new layer is added or an existing layer is matched with a new instance */ _update() {
        // Call subclass lifecycle method
        const stateNeedsUpdate = this.needsUpdate();
        // End lifecycle method
        (0, _indexJsDefault.default)(TRACE_UPDATE, this, stateNeedsUpdate);
        if (!stateNeedsUpdate) return;
        const currentProps = this.props;
        const context = this.context;
        const internalState = this.internalState;
        const currentViewport = context.viewport;
        const propsInTransition = this._updateUniformTransition();
        internalState.propsInTransition = propsInTransition;
        // Overwrite this.context.viewport during update to use the last activated viewport on this layer
        // In multi-view applications, a layer may only be drawn in one of the views
        // Which would make the "active" viewport different from the shared context
        context.viewport = internalState.viewport || currentViewport;
        // Overwrite this.props during update to use in-transition prop values
        this.props = propsInTransition;
        try {
            const updateParams = this._getUpdateParams();
            const oldModels = this.getModels();
            // Safely call subclass lifecycle methods
            if (context.device) this.updateState(updateParams);
            else try {
                this.updateState(updateParams);
            } catch (error) {
            // ignore error if gl context is missing
            }
            // Execute extension updates
            for (const extension of this.props.extensions)extension.updateState.call(this, updateParams, extension);
            this.setNeedsRedraw();
            // Check if attributes need recalculation
            this._updateAttributes();
            const modelChanged = this.getModels()[0] !== oldModels[0];
            this._postUpdate(updateParams, modelChanged);
        // End subclass lifecycle methods
        } finally{
            // Restore shared context
            context.viewport = currentViewport;
            this.props = currentProps;
            this._clearChangeFlags();
            internalState.needsUpdate = false;
            internalState.resetOldProps();
        }
    }
    /* eslint-enable max-statements */ /** (Internal) Called by manager when layer is about to be disposed
        Note: not guaranteed to be called on application shutdown */ _finalize() {
        (0, _indexJsDefault.default)(TRACE_FINALIZE, this);
        // Call subclass lifecycle method
        this.finalizeState(this.context);
        // Finalize extensions
        for (const extension of this.props.extensions)extension.finalizeState.call(this, this.context, extension);
    }
    // Calculates uniforms
    _drawLayer({ renderPass, shaderModuleProps = null, uniforms = {}, parameters = {} }) {
        this._updateAttributeTransition();
        const currentProps = this.props;
        const context = this.context;
        // Overwrite this.props during redraw to use in-transition prop values
        // `internalState.propsInTransition` could be missing if `updateState` failed
        // @ts-ignore (TS2339) internalState is alwasy defined when this method is called
        this.props = this.internalState.propsInTransition || currentProps;
        try {
            // TODO/ib - hack move to luma Model.draw
            if (shaderModuleProps) this.setShaderModuleProps(shaderModuleProps);
            // Apply polygon offset to avoid z-fighting
            // TODO - move to draw-layers
            const { getPolygonOffset } = this.props;
            const offsets = getPolygonOffset && getPolygonOffset(uniforms) || [
                0,
                0
            ];
            if (context.device instanceof (0, _webgl.WebGLDevice)) context.device.setParametersWebGL({
                polygonOffset: offsets
            });
            for (const model of this.getModels())if (model.device.type === 'webgpu') // TODO(ibgreen): model.setParameters currently wipes parameters. Semantics TBD.
            model.setParameters({
                ...model.parameters,
                ...parameters
            });
            else model.setParameters(parameters);
            // Call subclass lifecycle method
            if (context.device instanceof (0, _webgl.WebGLDevice)) context.device.withParametersWebGL(parameters, ()=>{
                const opts = {
                    renderPass,
                    shaderModuleProps,
                    uniforms,
                    parameters,
                    context
                };
                // extensions
                for (const extension of this.props.extensions)extension.draw.call(this, opts, extension);
                this.draw(opts);
            });
            else {
                const opts = {
                    renderPass,
                    shaderModuleProps,
                    uniforms,
                    parameters,
                    context
                };
                // extensions
                for (const extension of this.props.extensions)extension.draw.call(this, opts, extension);
                this.draw(opts);
            }
        } finally{
            this.props = currentProps;
        }
    // End lifecycle method
    }
    // Helper methods
    /** Returns the current change flags */ getChangeFlags() {
        return this.internalState?.changeFlags;
    }
    /* eslint-disable complexity */ /** Dirty some change flags, will be handled by updateLayer */ setChangeFlags(flags) {
        if (!this.internalState) return;
        const { changeFlags } = this.internalState;
        /* eslint-disable no-fallthrough, max-depth */ for(const key in flags)if (flags[key]) {
            let flagChanged = false;
            switch(key){
                case 'dataChanged':
                    // changeFlags.dataChanged may be `false`, a string (reason) or an array of ranges
                    const dataChangedReason = flags[key];
                    const prevDataChangedReason = changeFlags[key];
                    if (dataChangedReason && Array.isArray(prevDataChangedReason)) {
                        // Merge partial updates
                        changeFlags.dataChanged = Array.isArray(dataChangedReason) ? prevDataChangedReason.concat(dataChangedReason) : dataChangedReason;
                        flagChanged = true;
                    }
                default:
                    if (!changeFlags[key]) {
                        changeFlags[key] = flags[key];
                        flagChanged = true;
                    }
            }
            if (flagChanged) (0, _indexJsDefault.default)(TRACE_CHANGE_FLAG, this, key, flags);
        }
        /* eslint-enable no-fallthrough, max-depth */ // Update composite flags
        const propsOrDataChanged = Boolean(changeFlags.dataChanged || changeFlags.updateTriggersChanged || changeFlags.propsChanged || changeFlags.extensionsChanged);
        changeFlags.propsOrDataChanged = propsOrDataChanged;
        changeFlags.somethingChanged = propsOrDataChanged || changeFlags.viewportChanged || changeFlags.stateChanged;
    }
    /* eslint-enable complexity */ /** Clear all changeFlags, typically after an update */ _clearChangeFlags() {
        // @ts-ignore TS2531 this method can only be called internally with internalState assigned
        this.internalState.changeFlags = {
            dataChanged: false,
            propsChanged: false,
            updateTriggersChanged: false,
            viewportChanged: false,
            stateChanged: false,
            extensionsChanged: false,
            propsOrDataChanged: false,
            somethingChanged: false
        };
    }
    /** Compares the layers props with old props from a matched older layer
        and extracts change flags that describe what has change so that state
        can be update correctly with minimal effort */ _diffProps(newProps, oldProps) {
        const changeFlags = (0, _propsJs.diffProps)(newProps, oldProps);
        // iterate over changedTriggers
        if (changeFlags.updateTriggersChanged) {
            for(const key in changeFlags.updateTriggersChanged)if (changeFlags.updateTriggersChanged[key]) this.invalidateAttribute(key);
        }
        // trigger uniform transitions
        if (changeFlags.transitionsChanged) for(const key in changeFlags.transitionsChanged)// prop changed and transition is enabled
        // @ts-ignore (TS2531) internalState is always defined when this method is called
        this.internalState.uniformTransitions.add(key, oldProps[key], newProps[key], newProps.transitions?.[key]);
        return this.setChangeFlags(changeFlags);
    }
    /** (Internal) called by layer manager to perform extra props validation (in development only) */ validateProps() {
        (0, _propsJs.validateProps)(this.props);
    }
    /** (Internal) Called by deck picker when the hovered object changes to update the auto highlight */ updateAutoHighlight(info) {
        if (this.props.autoHighlight && !Number.isInteger(this.props.highlightedObjectIndex)) this._updateAutoHighlight(info);
    }
    // May be overriden by subclasses
    // TODO - simplify subclassing interface
    /** Update picking module parameters to highlight the hovered object */ _updateAutoHighlight(info) {
        const picking = {
            // @ts-ignore
            highlightedObjectColor: info.picked ? info.color : null
        };
        const { highlightColor } = this.props;
        if (info.picked && typeof highlightColor === 'function') // @ts-ignore
        picking.highlightColor = highlightColor(info);
        this.setShaderModuleProps({
            picking
        });
        // setShaderModuleProps does not trigger redraw
        this.setNeedsRedraw();
    }
    /** Create new attribute manager */ _getAttributeManager() {
        const context = this.context;
        return new (0, _attributeManagerJsDefault.default)(context.device, {
            id: this.props.id,
            stats: context.stats,
            timeline: context.timeline
        });
    }
    // Private methods
    /** Called after updateState to perform common tasks */ _postUpdate(updateParams, forceUpdate) {
        const { props, oldProps } = updateParams;
        // Note: Automatic instance count update only works for single layers
        const model = this.state.model;
        if (model?.isInstanced) model.setInstanceCount(this.getNumInstances());
        // Set picking module parameters to match props
        const { autoHighlight, highlightedObjectIndex, highlightColor } = props;
        if (forceUpdate || oldProps.autoHighlight !== autoHighlight || oldProps.highlightedObjectIndex !== highlightedObjectIndex || oldProps.highlightColor !== highlightColor) {
            const picking = {};
            if (Array.isArray(highlightColor)) picking.highlightColor = highlightColor;
            // highlightedObjectIndex will overwrite any settings from auto highlighting.
            // Do not reset unless the value has changed.
            if (forceUpdate || oldProps.autoHighlight !== autoHighlight || highlightedObjectIndex !== oldProps.highlightedObjectIndex) picking.highlightedObjectColor = Number.isFinite(highlightedObjectIndex) && highlightedObjectIndex >= 0 ? this.encodePickingColor(highlightedObjectIndex) : null;
            this.setShaderModuleProps({
                picking
            });
        }
    }
    _getUpdateParams() {
        return {
            props: this.props,
            // @ts-ignore TS2531 this method can only be called internally with internalState assigned
            oldProps: this.internalState.getOldProps(),
            context: this.context,
            // @ts-ignore TS2531 this method can only be called internally with internalState assigned
            changeFlags: this.internalState.changeFlags
        };
    }
    /** Checks state of attributes and model */ _getNeedsRedraw(opts) {
        // this method may be called by the render loop as soon a the layer
        // has been created, so guard against uninitialized state
        if (!this.internalState) return false;
        let redraw = false;
        redraw = redraw || this.internalState.needsRedraw && this.id;
        // TODO - is attribute manager needed? - Model should be enough.
        const attributeManager = this.getAttributeManager();
        const attributeManagerNeedsRedraw = attributeManager ? attributeManager.getNeedsRedraw(opts) : false;
        redraw = redraw || attributeManagerNeedsRedraw;
        if (redraw) for (const extension of this.props.extensions)extension.onNeedsRedraw.call(this, extension);
        this.internalState.needsRedraw = this.internalState.needsRedraw && !opts.clearRedrawFlags;
        return redraw;
    }
    /** Callback when asyn prop is loaded */ _onAsyncPropUpdated() {
        // @ts-ignore TS2531 this method can only be called internally with internalState assigned
        this._diffProps(this.props, this.internalState.getOldProps());
        this.setNeedsUpdate();
    }
}
Layer.defaultProps = defaultProps;
Layer.layerName = 'Layer';
exports.default = Layer;

},{"@luma.gl/core":"7TxCR","@luma.gl/webgl":"9NtH7","./constants.js":"k6l9N","./attribute/attribute-manager.js":"8sB6D","./uniform-transition-manager.js":"fcBSA","../lifecycle/props.js":"iFg3N","../lifecycle/constants.js":"1XIxh","../utils/count.js":"lbOrq","../utils/log.js":"9S0lD","../debug/index.js":"7gIzA","../utils/assert.js":"3Sh37","../utils/memoize.js":"4XQCO","../utils/shader.js":"iZ4h8","../shaderlib/project/project-functions.js":"5L1Sq","../utils/typed-array-manager.js":"6eAB3","../lifecycle/component.js":"jQxsw","./layer-state.js":"ieNG7","@math.gl/web-mercator":"3nSdG","@loaders.gl/core":"30VLs","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fcBSA":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transitionSettingsJs = require("./attribute/transition-settings.js");
var _cpuInterpolationTransitionJs = require("../transitions/cpu-interpolation-transition.js");
var _cpuInterpolationTransitionJsDefault = parcelHelpers.interopDefault(_cpuInterpolationTransitionJs);
var _cpuSpringTransitionJs = require("../transitions/cpu-spring-transition.js");
var _cpuSpringTransitionJsDefault = parcelHelpers.interopDefault(_cpuSpringTransitionJs);
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
const TRANSITION_TYPES = {
    interpolation: (0, _cpuInterpolationTransitionJsDefault.default),
    spring: (0, _cpuSpringTransitionJsDefault.default)
};
class UniformTransitionManager {
    constructor(timeline){
        this.transitions = new Map();
        this.timeline = timeline;
    }
    get active() {
        return this.transitions.size > 0;
    }
    add(key, fromValue, toValue, settings) {
        const { transitions } = this;
        if (transitions.has(key)) {
            const transition = transitions.get(key);
            // value may not be available if `update()` has not been called. Fallback to `fromValue`
            const { value = transition.settings.fromValue } = transition;
            // start from interrupted position
            fromValue = value;
            this.remove(key);
        }
        settings = (0, _transitionSettingsJs.normalizeTransitionSettings)(settings);
        if (!settings) return;
        const TransitionType = TRANSITION_TYPES[settings.type];
        if (!TransitionType) {
            (0, _logJsDefault.default).error(`unsupported transition type '${settings.type}'`)();
            return;
        }
        const transition = new TransitionType(this.timeline);
        transition.start({
            ...settings,
            fromValue,
            toValue
        });
        transitions.set(key, transition);
    }
    remove(key) {
        const { transitions } = this;
        if (transitions.has(key)) {
            transitions.get(key).cancel();
            transitions.delete(key);
        }
    }
    update() {
        const propsInTransition = {};
        for (const [key, transition] of this.transitions){
            transition.update();
            propsInTransition[key] = transition.value;
            if (!transition.inProgress) // transition ended
            this.remove(key);
        }
        return propsInTransition;
    }
    clear() {
        for (const key of this.transitions.keys())this.remove(key);
    }
}
exports.default = UniformTransitionManager;

},{"./attribute/transition-settings.js":"fZusS","../transitions/cpu-interpolation-transition.js":"EXull","../transitions/cpu-spring-transition.js":"dOtvp","../utils/log.js":"9S0lD","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"EXull":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@math.gl/core");
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
class CPUInterpolationTransition extends (0, _transitionJsDefault.default) {
    get value() {
        return this._value;
    }
    _onUpdate() {
        const { time, settings: { fromValue, toValue, duration, easing } } = this;
        const t = easing(time / duration);
        this._value = (0, _core.lerp)(fromValue, toValue, t);
    }
}
exports.default = CPUInterpolationTransition;

},{"@math.gl/core":"6z0Tv","./transition.js":"gMqhw","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dOtvp":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
const EPSILON = 1e-5;
/*
 * Calculate the next value in the spring transition
 * @param prev {Number} - previous value
 * @param cur {Number} - current value
 * @param dest {Number} - destination value
 * @param damping {Number}
 * @param stiffness {Number}
 */ function updateSpringElement(prev, cur, dest, damping, stiffness) {
    const velocity = cur - prev;
    const delta = dest - cur;
    const spring = delta * stiffness;
    const damper = -velocity * damping;
    return spring + damper + velocity + cur;
}
function updateSpring(prev, cur, dest, damping, stiffness) {
    if (Array.isArray(dest)) {
        const next = [];
        for(let i = 0; i < dest.length; i++)next[i] = updateSpringElement(prev[i], cur[i], dest[i], damping, stiffness);
        return next;
    }
    return updateSpringElement(prev, cur, dest, damping, stiffness);
}
/*
 * Calculate the distance between two numbers or two vectors
 */ function distance(value1, value2) {
    if (Array.isArray(value1)) {
        let distanceSquare = 0;
        for(let i = 0; i < value1.length; i++){
            const d = value1[i] - value2[i];
            distanceSquare += d * d;
        }
        return Math.sqrt(distanceSquare);
    }
    return Math.abs(value1 - value2);
}
class CPUSpringTransition extends (0, _transitionJsDefault.default) {
    get value() {
        return this._currValue;
    }
    _onUpdate() {
        // TODO - use timeline
        // const {time} = this;
        const { fromValue, toValue, damping, stiffness } = this.settings;
        const { _prevValue = fromValue, _currValue = fromValue } = this;
        let nextValue = updateSpring(_prevValue, _currValue, toValue, damping, stiffness);
        const delta = distance(nextValue, toValue);
        const velocity = distance(nextValue, _currValue);
        if (delta < EPSILON && velocity < EPSILON) {
            nextValue = toValue;
            this.end();
        }
        this._prevValue = _currValue;
        this._currValue = nextValue;
    }
}
exports.default = CPUSpringTransition;

},{"./transition.js":"gMqhw","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iFg3N":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateProps", ()=>validateProps);
// Returns an object with "change flags", either false or strings indicating reason for change
parcelHelpers.export(exports, "diffProps", ()=>diffProps);
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * @param {Object} opt.oldProps - object with old key/value pairs
 * @param {Object} opt.newProps - object with new key/value pairs
 * @param {Object} opt.ignoreProps={} - object, keys that should not be compared
 * @returns {null|String} - null when values of all keys are strictly equal.
 *   if unequal, returns a string explaining what changed.
 */ /* eslint-disable max-statements, max-depth, complexity */ /*
 * Note: for better performance, this function assumes that both oldProps and newProps
   inherit the same prototype (defaultProps). That is, if neither object contains own
   property <key>, assume `oldProps.<key>` and `newProps.<key>` are equal.
 */ parcelHelpers.export(exports, "compareProps", ()=>compareProps);
var _constantsJs = require("./constants.js");
function validateProps(props) {
    const propTypes = props[0, _constantsJs.PROP_TYPES_SYMBOL];
    for(const propName in propTypes){
        const propType = propTypes[propName];
        const { validate } = propType;
        if (validate && !validate(props[propName], propType)) throw new Error(`Invalid prop ${propName}: ${props[propName]}`);
    }
}
function diffProps(props, oldProps) {
    // First check if any props have changed (ignore props that will be examined separately)
    const propsChangedReason = compareProps({
        newProps: props,
        oldProps,
        propTypes: props[0, _constantsJs.PROP_TYPES_SYMBOL],
        ignoreProps: {
            data: null,
            updateTriggers: null,
            extensions: null,
            transitions: null
        }
    });
    // Now check if any data related props have changed
    const dataChangedReason = diffDataProps(props, oldProps);
    // Check update triggers to determine if any attributes need regeneration
    // Note - if data has changed, all attributes will need regeneration, so skip this step
    let updateTriggersChangedReason = false;
    if (!dataChangedReason) updateTriggersChangedReason = diffUpdateTriggers(props, oldProps);
    return {
        dataChanged: dataChangedReason,
        propsChanged: propsChangedReason,
        updateTriggersChanged: updateTriggersChangedReason,
        extensionsChanged: diffExtensions(props, oldProps),
        transitionsChanged: diffTransitions(props, oldProps)
    };
}
function diffTransitions(props, oldProps) {
    if (!props.transitions) return false;
    const result = {};
    const propTypes = props[0, _constantsJs.PROP_TYPES_SYMBOL];
    let changed = false;
    for(const key in props.transitions){
        const propType = propTypes[key];
        const type = propType && propType.type;
        const isTransitionable = type === 'number' || type === 'color' || type === 'array';
        if (isTransitionable && comparePropValues(props[key], oldProps[key], propType)) {
            result[key] = true;
            changed = true;
        }
    }
    return changed ? result : false;
}
function compareProps({ newProps, oldProps, ignoreProps = {}, propTypes = {}, triggerName = 'props' }) {
    // shallow equality => deep equality
    if (oldProps === newProps) return false;
    // TODO - do we need these checks? Should never happen...
    if (typeof newProps !== 'object' || newProps === null) return `${triggerName} changed shallowly`;
    if (typeof oldProps !== 'object' || oldProps === null) return `${triggerName} changed shallowly`;
    // Compare explicitly defined new props against old/default values
    for (const key of Object.keys(newProps))if (!(key in ignoreProps)) {
        if (!(key in oldProps)) return `${triggerName}.${key} added`;
        const changed = comparePropValues(newProps[key], oldProps[key], propTypes[key]);
        if (changed) return `${triggerName}.${key} ${changed}`;
    }
    // Test if any old props have been dropped
    for (const key of Object.keys(oldProps))if (!(key in ignoreProps)) {
        if (!(key in newProps)) return `${triggerName}.${key} dropped`;
        if (!Object.hasOwnProperty.call(newProps, key)) {
            // Compare dropped old prop against default value
            const changed = comparePropValues(newProps[key], oldProps[key], propTypes[key]);
            if (changed) return `${triggerName}.${key} ${changed}`;
        }
    }
    return false;
}
/* eslint-enable max-statements, max-depth, complexity */ // HELPERS
function comparePropValues(newProp, oldProp, propType) {
    // If prop type has an equal function, invoke it
    let equal = propType && propType.equal;
    if (equal && !equal(newProp, oldProp, propType)) return 'changed deeply';
    if (!equal) {
        // If object has an equals function, invoke it
        equal = newProp && oldProp && newProp.equals;
        if (equal && !equal.call(newProp, oldProp)) return 'changed deeply';
    }
    if (!equal && oldProp !== newProp) return 'changed shallowly';
    return null;
}
// The comparison of the data prop requires special handling
// the dataComparator should be used if supplied
function diffDataProps(props, oldProps) {
    if (oldProps === null) return 'oldProps is null, initial diff';
    let dataChanged = false;
    // Support optional app defined comparison of data
    const { dataComparator, _dataDiff } = props;
    if (dataComparator) {
        if (!dataComparator(props.data, oldProps.data)) dataChanged = 'Data comparator detected a change';
    } else if (props.data !== oldProps.data) dataChanged = 'A new data container was supplied';
    if (dataChanged && _dataDiff) dataChanged = _dataDiff(props.data, oldProps.data) || dataChanged;
    return dataChanged;
}
// Checks if any update triggers have changed
// also calls callback to invalidate attributes accordingly.
function diffUpdateTriggers(props, oldProps) {
    if (oldProps === null) return {
        all: true
    };
    // If the 'all' updateTrigger fires, ignore testing others
    if ('all' in props.updateTriggers) {
        const diffReason = diffUpdateTrigger(props, oldProps, 'all');
        if (diffReason) return {
            all: true
        };
    }
    const reason = {};
    let changed = false;
    // If the 'all' updateTrigger didn't fire, need to check all others
    for(const triggerName in props.updateTriggers)if (triggerName !== 'all') {
        const diffReason = diffUpdateTrigger(props, oldProps, triggerName);
        if (diffReason) {
            reason[triggerName] = true;
            changed = true;
        }
    }
    return changed ? reason : false;
}
// Returns true if any extensions have changed
function diffExtensions(props, oldProps) {
    if (oldProps === null) return true;
    const oldExtensions = oldProps.extensions;
    const { extensions } = props;
    if (extensions === oldExtensions) return false;
    if (!oldExtensions || !extensions) return true;
    if (extensions.length !== oldExtensions.length) return true;
    for(let i = 0; i < extensions.length; i++){
        if (!extensions[i].equals(oldExtensions[i])) return true;
    }
    return false;
}
function diffUpdateTrigger(props, oldProps, triggerName) {
    let newTriggers = props.updateTriggers[triggerName];
    newTriggers = newTriggers === undefined || newTriggers === null ? {} : newTriggers;
    let oldTriggers = oldProps.updateTriggers[triggerName];
    oldTriggers = oldTriggers === undefined || oldTriggers === null ? {} : oldTriggers;
    const diffReason = compareProps({
        oldProps: oldTriggers,
        newProps: newTriggers,
        triggerName
    });
    return diffReason;
}

},{"./constants.js":"1XIxh","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lbOrq":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Deduces numer of elements in a JavaScript container.
 * - Auto-deduction for ES6 containers that define a count() method
 * - Auto-deduction for ES6 containers that define a size member
 * - Auto-deduction for Classic Arrays via the built-in length attribute
 * - Also handles objects, although note that this an O(N) operation
 */ parcelHelpers.export(exports, "count", ()=>count);
const ERR_NOT_OBJECT = 'count(): argument not an object';
const ERR_NOT_CONTAINER = 'count(): argument not a container';
function count(container) {
    if (!isObject(container)) throw new Error(ERR_NOT_OBJECT);
    // Check if ES6 collection "count" function is available
    if (typeof container.count === 'function') return container.count();
    // Check if ES6 collection "size" attribute is set
    if (Number.isFinite(container.size)) return container.size;
    // Check if array length attribute is set
    // Note: checking this last since some ES6 collections (Immutable.js)
    // emit profuse warnings when trying to access `length` attribute
    if (Number.isFinite(container.length)) return container.length;
    // Note that getting the count of an object is O(N)
    if (isPlainObject(container)) return Object.keys(container).length;
    throw new Error(ERR_NOT_CONTAINER);
}
/**
 * Checks if argument is a plain object (not a class or array etc)
 * @param {*} value - JavaScript value to be tested
 * @return {Boolean} - true if argument is a plain JavaScript object
 */ function isPlainObject(value) {
    return value !== null && typeof value === 'object' && value.constructor === Object;
}
/**
 * Checks if argument is an indexable object (not a primitive value, nor null)
 * @param {*} value - JavaScript value to be tested
 * @return {Boolean} - true if argument is a JavaScript object
 */ function isObject(value) {
    return value !== null && typeof value === 'object';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iZ4h8":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Merge two luma.gl shader descriptors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeShaders", ()=>mergeShaders);
function mergeShaders(target, source) {
    if (!source) return target;
    const result = {
        ...target,
        ...source
    };
    if ('defines' in source) result.defines = {
        ...target.defines,
        ...source.defines
    };
    if ('modules' in source) {
        result.modules = (target.modules || []).concat(source.modules);
        // Hack: prject32 and project64 cannot co-exist
        if (source.modules.some((module)=>module.name === 'project64')) {
            const index = result.modules.findIndex((module)=>module.name === 'project32');
            if (index >= 0) result.modules.splice(index, 1);
        }
    }
    if ('inject' in source) {
        if (!target.inject) result.inject = source.inject;
        else {
            const mergedInjection = {
                ...target.inject
            };
            for(const key in source.inject)mergedInjection[key] = (mergedInjection[key] || '') + source.inject[key];
            result.inject = mergedInjection;
        }
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5L1Sq":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/**
 * Projection utils
 * TODO: move to Viewport class?
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Get the common space position from world coordinates in the given coordinate system */ parcelHelpers.export(exports, "getWorldPosition", ()=>getWorldPosition);
/**
 * Equivalent to project_position in project.glsl
 * projects a user supplied position to world position directly with or without
 * a reference coordinate system
 */ parcelHelpers.export(exports, "projectPosition", ()=>projectPosition);
var _constantsJs = require("../../lib/constants.js");
var _viewportUniformsJs = require("./viewport-uniforms.js");
var _webMercatorViewportJs = require("../../viewports/web-mercator-viewport.js");
var _webMercatorViewportJsDefault = parcelHelpers.interopDefault(_webMercatorViewportJs);
var _core = require("@math.gl/core");
var _webMercator = require("@math.gl/web-mercator");
const DEFAULT_COORDINATE_ORIGIN = [
    0,
    0,
    0
];
// In project.glsl, offset modes calculate z differently from LNG_LAT mode.
// offset modes apply the y adjustment (unitsPerMeter2) when projecting z
// LNG_LAT mode only use the linear scale.
function lngLatZToWorldPosition(lngLatZ, viewport, offsetMode = false) {
    const p = viewport.projectPosition(lngLatZ);
    // TODO - avoid using instanceof
    if (offsetMode && viewport instanceof (0, _webMercatorViewportJsDefault.default)) {
        const [longitude, latitude, z = 0] = lngLatZ;
        const distanceScales = viewport.getDistanceScales([
            longitude,
            latitude
        ]);
        p[2] = z * distanceScales.unitsPerMeter[2];
    }
    return p;
}
function normalizeParameters(opts) {
    const { viewport, modelMatrix, coordinateOrigin } = opts;
    let { coordinateSystem, fromCoordinateSystem, fromCoordinateOrigin } = opts;
    if (coordinateSystem === (0, _constantsJs.COORDINATE_SYSTEM).DEFAULT) coordinateSystem = viewport.isGeospatial ? (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT : (0, _constantsJs.COORDINATE_SYSTEM).CARTESIAN;
    if (fromCoordinateSystem === undefined) fromCoordinateSystem = coordinateSystem;
    if (fromCoordinateOrigin === undefined) fromCoordinateOrigin = coordinateOrigin;
    return {
        viewport,
        coordinateSystem,
        coordinateOrigin,
        modelMatrix,
        fromCoordinateSystem,
        fromCoordinateOrigin
    };
}
function getWorldPosition(position, { viewport, modelMatrix, coordinateSystem, coordinateOrigin, offsetMode }) {
    let [x, y, z = 0] = position;
    if (modelMatrix) [x, y, z] = (0, _core.vec4).transformMat4([], [
        x,
        y,
        z,
        1.0
    ], modelMatrix);
    switch(coordinateSystem){
        case (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT:
            return lngLatZToWorldPosition([
                x,
                y,
                z
            ], viewport, offsetMode);
        case (0, _constantsJs.COORDINATE_SYSTEM).LNGLAT_OFFSETS:
            return lngLatZToWorldPosition([
                x + coordinateOrigin[0],
                y + coordinateOrigin[1],
                z + (coordinateOrigin[2] || 0)
            ], viewport, offsetMode);
        case (0, _constantsJs.COORDINATE_SYSTEM).METER_OFFSETS:
            return lngLatZToWorldPosition((0, _webMercator.addMetersToLngLat)(coordinateOrigin, [
                x,
                y,
                z
            ]), viewport, offsetMode);
        case (0, _constantsJs.COORDINATE_SYSTEM).CARTESIAN:
        default:
            return viewport.isGeospatial ? [
                x + coordinateOrigin[0],
                y + coordinateOrigin[1],
                z + coordinateOrigin[2]
            ] : viewport.projectPosition([
                x,
                y,
                z
            ]);
    }
}
function projectPosition(position, params) {
    const { viewport, coordinateSystem, coordinateOrigin, modelMatrix, fromCoordinateSystem, fromCoordinateOrigin } = normalizeParameters(params);
    const { autoOffset = true } = params;
    const { geospatialOrigin = DEFAULT_COORDINATE_ORIGIN, shaderCoordinateOrigin = DEFAULT_COORDINATE_ORIGIN, offsetMode = false } = autoOffset ? (0, _viewportUniformsJs.getOffsetOrigin)(viewport, coordinateSystem, coordinateOrigin) : {};
    const worldPosition = getWorldPosition(position, {
        viewport,
        modelMatrix,
        coordinateSystem: fromCoordinateSystem,
        coordinateOrigin: fromCoordinateOrigin,
        offsetMode
    });
    if (offsetMode) {
        const positionCommonSpace = viewport.projectPosition(geospatialOrigin || shaderCoordinateOrigin);
        (0, _core.vec3).sub(worldPosition, worldPosition, positionCommonSpace);
    }
    return worldPosition;
}

},{"../../lib/constants.js":"k6l9N","./viewport-uniforms.js":"8W447","../../viewports/web-mercator-viewport.js":"3azhZ","@math.gl/core":"6z0Tv","@math.gl/web-mercator":"3nSdG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jQxsw":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantsJs = require("./constants.js");
var _createPropsJs = require("./create-props.js");
let counter = 0;
class Component {
    constructor(...propObjects){
        // Merge supplied props with default props and freeze them.
        /* eslint-disable prefer-spread */ this.props = (0, _createPropsJs.createProps)(this, propObjects);
        /* eslint-enable prefer-spread */ this.id = this.props.id; // The layer's id, used for matching with layers from last render cycle
        this.count = counter++; // Keep track of how many layer instances you are generating
    }
    // clone this layer with modified props
    clone(newProps) {
        const { props } = this;
        // Async props cannot be copied with Object.assign, copy them separately
        const asyncProps = {};
        // See async props definition in create-props.js
        for(const key in props[0, _constantsJs.ASYNC_DEFAULTS_SYMBOL]){
            if (key in props[0, _constantsJs.ASYNC_RESOLVED_SYMBOL]) asyncProps[key] = props[0, _constantsJs.ASYNC_RESOLVED_SYMBOL][key];
            else if (key in props[0, _constantsJs.ASYNC_ORIGINAL_SYMBOL]) asyncProps[key] = props[0, _constantsJs.ASYNC_ORIGINAL_SYMBOL][key];
        }
        // Some custom layer implementation may not support multiple arguments in the constructor
        // @ts-ignore
        return new this.constructor({
            ...props,
            ...asyncProps,
            ...newProps
        });
    }
}
Component.componentName = 'Component';
Component.defaultProps = {};
exports.default = Component;

},{"./constants.js":"1XIxh","./create-props.js":"4XhMK","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4XhMK":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Create a property object
parcelHelpers.export(exports, "createProps", ()=>createProps);
var _logJs = require("../utils/log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _iterableUtilsJs = require("../utils/iterable-utils.js");
var _propTypesJs = require("./prop-types.js");
var _constantsJs = require("./constants.js");
var _componentJs = require("./component.js");
var _componentJsDefault = parcelHelpers.interopDefault(_componentJs);
function createProps(component, propObjects) {
    // Resolve extension value
    let extensions;
    for(let i = propObjects.length - 1; i >= 0; i--){
        const props = propObjects[i];
        if ('extensions' in props) // @ts-expect-error TS(2339) extensions not defined
        extensions = props.extensions;
    }
    // Create a new prop object with empty default props object
    const propsPrototype = getPropsPrototype(component.constructor, extensions);
    // The true default props object will be found later
    const propsInstance = Object.create(propsPrototype);
    // Props need a back pointer to the owning component
    propsInstance[0, _constantsJs.COMPONENT_SYMBOL] = component;
    // The supplied (original) values for those async props that are set to url strings or Promises.
    // In this case, the actual (i.e. resolved) values are looked up from component.internalState
    propsInstance[0, _constantsJs.ASYNC_ORIGINAL_SYMBOL] = {};
    // Note: the actual (resolved) values for props that are NOT set to urls or Promises.
    // in this case the values are served directly from this map
    propsInstance[0, _constantsJs.ASYNC_RESOLVED_SYMBOL] = {};
    // "Copy" all sync props
    for(let i = 0; i < propObjects.length; ++i){
        const props = propObjects[i];
        // Do not use Object.assign here to avoid Symbols in props overwriting our private fields
        // This might happen if one of the arguments is another props instance
        for(const key in props)propsInstance[key] = props[key];
    }
    // Props must be immutable
    Object.freeze(propsInstance);
    return propsInstance;
}
const MergedDefaultPropsCacheKey = '_mergedDefaultProps';
// Return precalculated defaultProps and propType objects if available
// build them if needed
function getPropsPrototype(componentClass, extensions) {
    // Bail out if we're not looking at a component - for two reasons:
    // 1. There's no reason for an ancestor of component to have props
    // 2. If we don't bail out, we'll follow the prototype chain all the way back to the global
    // function prototype and add _mergedDefaultProps to it, which may break other frameworks
    // (e.g. the react-three-fiber reconciler)
    if (!(componentClass instanceof (0, _componentJsDefault.default).constructor)) return {};
    // A string that uniquely identifies the extensions involved
    let cacheKey = MergedDefaultPropsCacheKey;
    if (extensions) for (const extension of extensions){
        const ExtensionClass = extension.constructor;
        if (ExtensionClass) cacheKey += `:${ExtensionClass.extensionName || ExtensionClass.name}`;
    }
    const defaultProps = getOwnProperty(componentClass, cacheKey);
    if (!defaultProps) return componentClass[cacheKey] = createPropsPrototypeAndTypes(componentClass, extensions || []);
    return defaultProps;
}
// Build defaultProps and propType objects by walking component prototype chain
function createPropsPrototypeAndTypes(componentClass, extensions) {
    const parent = componentClass.prototype;
    if (!parent) return null;
    const parentClass = Object.getPrototypeOf(componentClass);
    const parentDefaultProps = getPropsPrototype(parentClass);
    // Parse propTypes from Component.defaultProps
    const componentDefaultProps = getOwnProperty(componentClass, 'defaultProps') || {};
    const componentPropDefs = (0, _propTypesJs.parsePropTypes)(componentDefaultProps);
    // Merged default props object. Order: parent, self, extensions
    const defaultProps = Object.assign(Object.create(null), parentDefaultProps, componentPropDefs.defaultProps);
    // Merged prop type definitions. Order: parent, self, extensions
    const propTypes = Object.assign(Object.create(null), parentDefaultProps?.[0, _constantsJs.PROP_TYPES_SYMBOL], componentPropDefs.propTypes);
    // Merged deprecation list. Order: parent, self, extensions
    const deprecatedProps = Object.assign(Object.create(null), parentDefaultProps?.[0, _constantsJs.DEPRECATED_PROPS_SYMBOL], componentPropDefs.deprecatedProps);
    for (const extension of extensions){
        const extensionDefaultProps = getPropsPrototype(extension.constructor);
        if (extensionDefaultProps) {
            Object.assign(defaultProps, extensionDefaultProps);
            Object.assign(propTypes, extensionDefaultProps[0, _constantsJs.PROP_TYPES_SYMBOL]);
            Object.assign(deprecatedProps, extensionDefaultProps[0, _constantsJs.DEPRECATED_PROPS_SYMBOL]);
        }
    }
    // Create any necessary property descriptors and create the default prop object
    // Assign merged default props
    createPropsPrototype(defaultProps, componentClass);
    // Add getters/setters for async props
    addAsyncPropsToPropPrototype(defaultProps, propTypes);
    // Add setters for deprecated props
    addDeprecatedPropsToPropPrototype(defaultProps, deprecatedProps);
    // Store the precalculated props
    defaultProps[0, _constantsJs.PROP_TYPES_SYMBOL] = propTypes;
    defaultProps[0, _constantsJs.DEPRECATED_PROPS_SYMBOL] = deprecatedProps;
    // Backwards compatibility
    // TODO: remove access of hidden property from the rest of the code base
    if (extensions.length === 0 && !hasOwnProperty(componentClass, '_propTypes')) componentClass._propTypes = propTypes;
    return defaultProps;
}
// Builds a pre-merged default props object that component props can inherit from
function createPropsPrototype(defaultProps, componentClass) {
    // Avoid freezing `id` prop
    const id = getComponentName(componentClass);
    Object.defineProperties(defaultProps, {
        // `id` is treated specially because layer might need to override it
        id: {
            writable: true,
            value: id
        }
    });
}
function addDeprecatedPropsToPropPrototype(defaultProps, deprecatedProps) {
    for(const propName in deprecatedProps)/* eslint-disable accessor-pairs */ Object.defineProperty(defaultProps, propName, {
        enumerable: false,
        set (newValue) {
            const nameStr = `${this.id}: ${propName}`;
            for (const newPropName of deprecatedProps[propName])if (!hasOwnProperty(this, newPropName)) this[newPropName] = newValue;
            (0, _logJsDefault.default).deprecated(nameStr, deprecatedProps[propName].join('/'))();
        }
    });
}
// Create descriptors for overridable props
function addAsyncPropsToPropPrototype(defaultProps, propTypes) {
    const defaultValues = {};
    const descriptors = {};
    // Move async props into shadow values
    for(const propName in propTypes){
        const propType = propTypes[propName];
        const { name, value } = propType;
        // Note: async is ES7 keyword, can't destructure
        if (propType.async) {
            defaultValues[name] = value;
            descriptors[name] = getDescriptorForAsyncProp(name);
        }
    }
    // Default "resolved" values for async props, returned if value not yet resolved/set.
    defaultProps[0, _constantsJs.ASYNC_DEFAULTS_SYMBOL] = defaultValues;
    // Shadowed object, just to make sure "early indexing" into the instance does not fail
    defaultProps[0, _constantsJs.ASYNC_ORIGINAL_SYMBOL] = {};
    Object.defineProperties(defaultProps, descriptors);
}
// Helper: Configures getter and setter for one async prop
function getDescriptorForAsyncProp(name) {
    return {
        enumerable: true,
        // Save the provided value for async props in a special map
        set (newValue) {
            if (typeof newValue === 'string' || newValue instanceof Promise || (0, _iterableUtilsJs.isAsyncIterable)(newValue)) this[0, _constantsJs.ASYNC_ORIGINAL_SYMBOL][name] = newValue;
            else this[0, _constantsJs.ASYNC_RESOLVED_SYMBOL][name] = newValue;
        },
        // Only the component's state knows the true value of async prop
        get () {
            if (this[0, _constantsJs.ASYNC_RESOLVED_SYMBOL]) {
                // Prop value isn't async, so just return it
                if (name in this[0, _constantsJs.ASYNC_RESOLVED_SYMBOL]) {
                    const value = this[0, _constantsJs.ASYNC_RESOLVED_SYMBOL][name];
                    return value || this[0, _constantsJs.ASYNC_DEFAULTS_SYMBOL][name];
                }
                if (name in this[0, _constantsJs.ASYNC_ORIGINAL_SYMBOL]) {
                    // It's an async prop value: look into component state
                    const state = this[0, _constantsJs.COMPONENT_SYMBOL] && this[0, _constantsJs.COMPONENT_SYMBOL].internalState;
                    if (state && state.hasAsyncProp(name)) return state.getAsyncProp(name) || this[0, _constantsJs.ASYNC_DEFAULTS_SYMBOL][name];
                }
            }
            // the prop is not supplied, or
            // component not yet initialized/matched, return the component's default value for the prop
            return this[0, _constantsJs.ASYNC_DEFAULTS_SYMBOL][name];
        }
    };
}
// HELPER METHODS
function hasOwnProperty(object, prop) {
    return Object.prototype.hasOwnProperty.call(object, prop);
}
// Constructors have their super class constructors as prototypes
function getOwnProperty(object, prop) {
    return hasOwnProperty(object, prop) && object[prop];
}
function getComponentName(componentClass) {
    const componentName = componentClass.componentName;
    if (!componentName) (0, _logJsDefault.default).warn(`${componentClass.name}.componentName not specified`)();
    return componentName || componentClass.name;
}

},{"../utils/log.js":"9S0lD","../utils/iterable-utils.js":"akgls","./prop-types.js":"8v7nK","./constants.js":"1XIxh","./component.js":"jQxsw","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8v7nK":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsePropTypes", ()=>parsePropTypes);
var _textureJs = require("../utils/texture.js");
var _deepEqualJs = require("../utils/deep-equal.js");
const TYPE_DEFINITIONS = {
    boolean: {
        validate (value, propType) {
            return true;
        },
        equal (value1, value2, propType) {
            return Boolean(value1) === Boolean(value2);
        }
    },
    number: {
        validate (value, propType) {
            return Number.isFinite(value) && (!('max' in propType) || value <= propType.max) && (!('min' in propType) || value >= propType.min);
        }
    },
    color: {
        validate (value, propType) {
            return propType.optional && !value || isArray(value) && (value.length === 3 || value.length === 4);
        },
        equal (value1, value2, propType) {
            return (0, _deepEqualJs.deepEqual)(value1, value2, 1);
        }
    },
    accessor: {
        validate (value, propType) {
            const valueType = getTypeOf(value);
            return valueType === 'function' || valueType === getTypeOf(propType.value);
        },
        equal (value1, value2, propType) {
            if (typeof value2 === 'function') return true;
            return (0, _deepEqualJs.deepEqual)(value1, value2, 1);
        }
    },
    array: {
        validate (value, propType) {
            return propType.optional && !value || isArray(value);
        },
        equal (value1, value2, propType) {
            const { compare } = propType;
            const depth = Number.isInteger(compare) ? compare : compare ? 1 : 0;
            return compare ? (0, _deepEqualJs.deepEqual)(value1, value2, depth) : value1 === value2;
        }
    },
    object: {
        equal (value1, value2, propType) {
            if (propType.ignore) return true;
            const { compare } = propType;
            const depth = Number.isInteger(compare) ? compare : compare ? 1 : 0;
            return compare ? (0, _deepEqualJs.deepEqual)(value1, value2, depth) : value1 === value2;
        }
    },
    function: {
        validate (value, propType) {
            return propType.optional && !value || typeof value === 'function';
        },
        equal (value1, value2, propType) {
            // Backward compatibility - {compare: true} and {ignore: false} are equivalent
            const shouldIgnore = !propType.compare && propType.ignore !== false;
            return shouldIgnore || value1 === value2;
        }
    },
    data: {
        transform: (value, propType, component)=>{
            if (!value) return value;
            const { dataTransform } = component.props;
            if (dataTransform) return dataTransform(value);
            // Detect loaders.gl v4 table format
            if (typeof value.shape === 'string' && value.shape.endsWith('-table') && Array.isArray(value.data)) return value.data;
            return value;
        }
    },
    image: {
        transform: (value, propType, component)=>{
            const context = component.context;
            if (!context || !context.device) return null;
            return (0, _textureJs.createTexture)(component.id, context.device, value, {
                ...propType.parameters,
                ...component.props.textureParameters
            });
        },
        release: (value, propType, component)=>{
            (0, _textureJs.destroyTexture)(component.id, value);
        }
    }
};
function parsePropTypes(propDefs) {
    const propTypes = {};
    const defaultProps = {};
    const deprecatedProps = {};
    for (const [propName, propDef] of Object.entries(propDefs)){
        const deprecated = propDef?.deprecatedFor;
        if (deprecated) deprecatedProps[propName] = Array.isArray(deprecated) ? deprecated : [
            deprecated
        ];
        else {
            const propType = parsePropType(propName, propDef);
            propTypes[propName] = propType;
            defaultProps[propName] = propType.value;
        }
    }
    return {
        propTypes,
        defaultProps,
        deprecatedProps
    };
}
// Parses one property definition entry. Either contains:
// * a valid prop type object ({type, ...})
// * or just a default value, in which case type and name inference is used
function parsePropType(name, propDef) {
    switch(getTypeOf(propDef)){
        case 'object':
            return normalizePropDefinition(name, propDef);
        case 'array':
            return normalizePropDefinition(name, {
                type: 'array',
                value: propDef,
                compare: false
            });
        case 'boolean':
            return normalizePropDefinition(name, {
                type: 'boolean',
                value: propDef
            });
        case 'number':
            return normalizePropDefinition(name, {
                type: 'number',
                value: propDef
            });
        case 'function':
            // return guessFunctionType(name, propDef);
            return normalizePropDefinition(name, {
                type: 'function',
                value: propDef,
                compare: true
            });
        default:
            return {
                name,
                type: 'unknown',
                value: propDef
            };
    }
}
function normalizePropDefinition(name, propDef) {
    if (!('type' in propDef)) {
        if (!('value' in propDef)) // If no type and value this object is likely the value
        return {
            name,
            type: 'object',
            value: propDef
        };
        return {
            name,
            type: getTypeOf(propDef.value),
            ...propDef
        };
    }
    return {
        name,
        ...TYPE_DEFINITIONS[propDef.type],
        ...propDef
    };
}
function isArray(value) {
    return Array.isArray(value) || ArrayBuffer.isView(value);
}
// improved version of javascript typeof that can distinguish arrays and null values
function getTypeOf(value) {
    if (isArray(value)) return 'array';
    if (value === null) return 'null';
    return typeof value;
}

},{"../utils/texture.js":"ecpJX","../utils/deep-equal.js":"1MkgV","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ecpJX":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * @param owner
 * @param device
 * @param image could be one of:
 *   - Texture
 *   - Browser object: Image, ImageData, ImageData, HTMLCanvasElement, HTMLVideoElement, ImageBitmap
 *   - Plain object: {width: <number>, height: <number>, data: <Uint8Array>}
 * @param parameters
 * @returns
 */ parcelHelpers.export(exports, "createTexture", ()=>createTexture);
parcelHelpers.export(exports, "destroyTexture", ()=>destroyTexture);
var _core = require("@luma.gl/core");
const DEFAULT_TEXTURE_PARAMETERS = {
    minFilter: 'linear',
    mipmapFilter: 'linear',
    magFilter: 'linear',
    addressModeU: 'clamp-to-edge',
    addressModeV: 'clamp-to-edge'
};
// Track the textures that are created by us. They need to be released when they are no longer used.
const internalTextures = {};
function createTexture(owner, device, image, sampler) {
    if (image instanceof (0, _core.Texture)) return image;
    else if (image.constructor && image.constructor.name !== 'Object') // Browser object
    image = {
        data: image
    };
    let samplerParameters = null;
    if (image.compressed) samplerParameters = {
        minFilter: 'linear',
        mipmapFilter: image.data.length > 1 ? 'nearest' : 'linear'
    };
    const texture = device.createTexture({
        ...image,
        sampler: {
            ...DEFAULT_TEXTURE_PARAMETERS,
            ...samplerParameters,
            ...sampler
        },
        mipmaps: true
    });
    // Track this texture
    internalTextures[texture.id] = owner;
    return texture;
}
function destroyTexture(owner, texture) {
    if (!texture || !(texture instanceof (0, _core.Texture))) return;
    // Only delete the texture if requested by the same layer that created it
    if (internalTextures[texture.id] === owner) {
        texture.delete();
        delete internalTextures[texture.id];
    }
}

},{"@luma.gl/core":"7TxCR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ieNG7":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// deck.gl, MIT license
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _componentStateJs = require("../lifecycle/component-state.js");
var _componentStateJsDefault = parcelHelpers.interopDefault(_componentStateJs);
class LayerState extends (0, _componentStateJsDefault.default) {
    constructor({ attributeManager, layer }){
        super(layer);
        this.attributeManager = attributeManager;
        this.needsRedraw = true;
        this.needsUpdate = true;
        this.subLayers = null;
        this.usesPickingColorCache = false;
    }
    get layer() {
        return this.component;
    }
    /* Override base Component methods with Layer-specific handling */ _fetch(propName, url) {
        const layer = this.layer;
        const fetch = layer?.props.fetch;
        if (fetch) return fetch(url, {
            propName,
            layer
        });
        return super._fetch(propName, url);
    }
    _onResolve(propName, value) {
        const layer = this.layer;
        if (layer) {
            const onDataLoad = layer.props.onDataLoad;
            if (propName === 'data' && onDataLoad) onDataLoad(value, {
                propName,
                layer
            });
        }
    }
    _onError(propName, error) {
        const layer = this.layer;
        if (layer) layer.raiseError(error, `loading ${propName} of ${this.layer}`);
    }
}
exports.default = LayerState;

},{"../lifecycle/component-state.js":"aMUfY","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aMUfY":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iterableUtilsJs = require("../utils/iterable-utils.js");
var _constantsJs = require("./constants.js");
const EMPTY_PROPS = Object.freeze({});
class ComponentState {
    constructor(component){
        this.component = component;
        this.asyncProps = {}; // Prop values that the layer sees
        this.onAsyncPropUpdated = ()=>{};
        this.oldProps = null; // Last props before update
        this.oldAsyncProps = null; // Last props before update, with async values copied.
    }
    finalize() {
        for(const propName in this.asyncProps){
            const asyncProp = this.asyncProps[propName];
            if (asyncProp && asyncProp.type && asyncProp.type.release) // Release any resources created by transforms
            asyncProp.type.release(asyncProp.resolvedValue, asyncProp.type, this.component);
        }
        this.asyncProps = {};
        this.component = null;
        this.resetOldProps();
    }
    /* Layer-facing props API */ getOldProps() {
        return this.oldAsyncProps || this.oldProps || EMPTY_PROPS;
    }
    resetOldProps() {
        this.oldAsyncProps = null;
        this.oldProps = this.component ? this.component.props : null;
    }
    // Checks if a prop is overridden
    hasAsyncProp(propName) {
        return propName in this.asyncProps;
    }
    // Returns value of an overriden prop
    getAsyncProp(propName) {
        const asyncProp = this.asyncProps[propName];
        return asyncProp && asyncProp.resolvedValue;
    }
    isAsyncPropLoading(propName) {
        if (propName) {
            const asyncProp = this.asyncProps[propName];
            return Boolean(asyncProp && asyncProp.pendingLoadCount > 0 && asyncProp.pendingLoadCount !== asyncProp.resolvedLoadCount);
        }
        for(const key in this.asyncProps){
            if (this.isAsyncPropLoading(key)) return true;
        }
        return false;
    }
    // Without changing the original prop value, swap out the data resolution under the hood
    reloadAsyncProp(propName, value) {
        this._watchPromise(propName, Promise.resolve(value));
    }
    // Updates all async/overridden props (when new props come in)
    // Checks if urls have changed, starts loading, or removes override
    setAsyncProps(props) {
        this.component = props[0, _constantsJs.COMPONENT_SYMBOL] || this.component;
        // NOTE: prop param and default values are only support for testing
        const resolvedValues = props[0, _constantsJs.ASYNC_RESOLVED_SYMBOL] || {};
        const originalValues = props[0, _constantsJs.ASYNC_ORIGINAL_SYMBOL] || props;
        const defaultValues = props[0, _constantsJs.ASYNC_DEFAULTS_SYMBOL] || {};
        // TODO - use async props from the layer's prop types
        for(const propName in resolvedValues){
            const value = resolvedValues[propName];
            this._createAsyncPropData(propName, defaultValues[propName]);
            this._updateAsyncProp(propName, value);
            // Use transformed value
            resolvedValues[propName] = this.getAsyncProp(propName);
        }
        for(const propName in originalValues){
            const value = originalValues[propName];
            // Makes sure a record exists for this prop
            this._createAsyncPropData(propName, defaultValues[propName]);
            this._updateAsyncProp(propName, value);
        }
    }
    /* Placeholder methods for subclassing */ _fetch(propName, url) {
        return null;
    }
    _onResolve(propName, value) {}
    _onError(propName, error) {}
    // Intercept strings (URLs) and Promises and activates loading and prop rewriting
    _updateAsyncProp(propName, value) {
        if (!this._didAsyncInputValueChange(propName, value)) return;
        // interpret value string as url and start a new load tracked by a promise
        if (typeof value === 'string') value = this._fetch(propName, value);
        // interprets promise and track the "loading"
        if (value instanceof Promise) {
            this._watchPromise(propName, value);
            return;
        }
        if ((0, _iterableUtilsJs.isAsyncIterable)(value)) {
            this._resolveAsyncIterable(propName, value); // eslint-disable-line @typescript-eslint/no-floating-promises
            return;
        }
        // else, normal, non-async value. Just store value for now
        this._setPropValue(propName, value);
    }
    // Whenever async props are changing, we need to make a copy of oldProps
    // otherwise the prop rewriting will affect the value both in props and oldProps.
    // While the copy is relatively expensive, this only happens on load completion.
    _freezeAsyncOldProps() {
        if (!this.oldAsyncProps && this.oldProps) {
            // 1. inherit all synchronous props from oldProps
            // 2. reconfigure the async prop descriptors to fixed values
            this.oldAsyncProps = Object.create(this.oldProps);
            for(const propName in this.asyncProps)Object.defineProperty(this.oldAsyncProps, propName, {
                enumerable: true,
                value: this.oldProps[propName]
            });
        }
    }
    // Checks if an input value actually changed (to avoid reloading/rewatching promises/urls)
    _didAsyncInputValueChange(propName, value) {
        // @ts-ignore
        const asyncProp = this.asyncProps[propName];
        if (value === asyncProp.resolvedValue || value === asyncProp.lastValue) return false;
        asyncProp.lastValue = value;
        return true;
    }
    // Set normal, non-async value
    _setPropValue(propName, value) {
        // Save the current value before overwriting so that diffProps can access both
        this._freezeAsyncOldProps();
        const asyncProp = this.asyncProps[propName];
        if (asyncProp) {
            value = this._postProcessValue(asyncProp, value);
            asyncProp.resolvedValue = value;
            asyncProp.pendingLoadCount++;
            asyncProp.resolvedLoadCount = asyncProp.pendingLoadCount;
        }
    }
    // Set a just resolved async value, calling onAsyncPropUpdates if value changes asynchronously
    _setAsyncPropValue(propName, value, loadCount) {
        // Only update if loadCount is larger or equal to resolvedLoadCount
        // otherwise a more recent load has already completed
        const asyncProp = this.asyncProps[propName];
        if (asyncProp && loadCount >= asyncProp.resolvedLoadCount && value !== undefined) {
            // Save the current value before overwriting so that diffProps can access both
            this._freezeAsyncOldProps();
            asyncProp.resolvedValue = value;
            asyncProp.resolvedLoadCount = loadCount;
            // Call callback to inform listener
            this.onAsyncPropUpdated(propName, value);
        }
    }
    // Tracks a promise, sets the prop when loaded, handles load count
    _watchPromise(propName, promise) {
        const asyncProp = this.asyncProps[propName];
        if (asyncProp) {
            asyncProp.pendingLoadCount++;
            const loadCount = asyncProp.pendingLoadCount;
            promise.then((data)=>{
                if (!this.component) // This component state has been finalized
                return;
                data = this._postProcessValue(asyncProp, data);
                this._setAsyncPropValue(propName, data, loadCount);
                this._onResolve(propName, data);
            }).catch((error)=>{
                this._onError(propName, error);
            });
        }
    }
    async _resolveAsyncIterable(propName, iterable) {
        if (propName !== 'data') {
            // we only support data as async iterable
            this._setPropValue(propName, iterable);
            return;
        }
        const asyncProp = this.asyncProps[propName];
        if (!asyncProp) return;
        asyncProp.pendingLoadCount++;
        const loadCount = asyncProp.pendingLoadCount;
        let data = [];
        let count = 0;
        for await (const chunk of iterable){
            if (!this.component) // This component state has been finalized
            return;
            // @ts-expect-error (2339) dataTransform is not decared in base component props
            const { dataTransform } = this.component.props;
            if (dataTransform) data = dataTransform(chunk, data);
            else data = data.concat(chunk);
            // Used by the default _dataDiff function
            Object.defineProperty(data, '__diff', {
                enumerable: false,
                value: [
                    {
                        startRow: count,
                        endRow: data.length
                    }
                ]
            });
            count = data.length;
            this._setAsyncPropValue(propName, data, loadCount);
        }
        this._onResolve(propName, data);
    }
    // Give the app a chance to post process the loaded data
    _postProcessValue(asyncProp, value) {
        const propType = asyncProp.type;
        if (propType && this.component) {
            if (propType.release) propType.release(asyncProp.resolvedValue, propType, this.component);
            if (propType.transform) return propType.transform(value, propType, this.component);
        }
        return value;
    }
    // Creating an asyncProp record if needed
    _createAsyncPropData(propName, defaultValue) {
        const asyncProp = this.asyncProps[propName];
        if (!asyncProp) {
            const propTypes = this.component && this.component.props[0, _constantsJs.PROP_TYPES_SYMBOL];
            // assert(defaultValue !== undefined);
            this.asyncProps[propName] = {
                type: propTypes && propTypes[propName],
                lastValue: null,
                resolvedValue: defaultValue,
                pendingLoadCount: 0,
                resolvedLoadCount: 0
            };
        }
    }
}
exports.default = ComponentState;

},{"../utils/iterable-utils.js":"akgls","./constants.js":"1XIxh","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lQMDh":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@math.gl/core");
var _viewportJs = require("./viewport.js");
var _viewportJsDefault = parcelHelpers.interopDefault(_viewportJs);
var _constantsJs = require("../lib/constants.js");
var _webMercator = require("@math.gl/web-mercator");
const DEGREES_TO_RADIANS = Math.PI / 180;
const RADIANS_TO_DEGREES = 180 / Math.PI;
const EARTH_RADIUS = 6370972;
const GLOBE_RADIUS = 256;
function getDistanceScales() {
    const unitsPerMeter = GLOBE_RADIUS / EARTH_RADIUS;
    const unitsPerDegree = Math.PI / 180 * GLOBE_RADIUS;
    return {
        unitsPerMeter: [
            unitsPerMeter,
            unitsPerMeter,
            unitsPerMeter
        ],
        unitsPerMeter2: [
            0,
            0,
            0
        ],
        metersPerUnit: [
            1 / unitsPerMeter,
            1 / unitsPerMeter,
            1 / unitsPerMeter
        ],
        unitsPerDegree: [
            unitsPerDegree,
            unitsPerDegree,
            unitsPerMeter
        ],
        unitsPerDegree2: [
            0,
            0,
            0
        ],
        degreesPerUnit: [
            1 / unitsPerDegree,
            1 / unitsPerDegree,
            1 / unitsPerMeter
        ]
    };
}
class GlobeViewport extends (0, _viewportJsDefault.default) {
    constructor(opts = {}){
        const { longitude = 0, zoom = 0, // Matches Maplibre defaults
        // https://github.com/maplibre/maplibre-gl-js/blob/f8ab4b48d59ab8fe7b068b102538793bbdd4c848/src/geo/projection/globe_transform.ts#L632-L633
        nearZMultiplier = 0.5, farZMultiplier = 1, resolution = 10 } = opts;
        let { latitude = 0, height, altitude = 1.5, fovy } = opts;
        // Clamp to web mercator limit to prevent bad inputs
        latitude = Math.max(Math.min(latitude, (0, _webMercator.MAX_LATITUDE)), -(0, _webMercator.MAX_LATITUDE));
        height = height || 1;
        if (fovy) altitude = (0, _webMercator.fovyToAltitude)(fovy);
        else fovy = (0, _webMercator.altitudeToFovy)(altitude);
        // Exagerate distance by latitude to match the Web Mercator distortion
        // The goal is that globe and web mercator projection results converge at high zoom
        // https://github.com/maplibre/maplibre-gl-js/blob/f8ab4b48d59ab8fe7b068b102538793bbdd4c848/src/geo/projection/globe_transform.ts#L575-L577
        const scaleAdjust = 1 / Math.PI / Math.cos(latitude * Math.PI / 180);
        const scale = Math.pow(2, zoom) * scaleAdjust;
        const nearZ = opts.nearZ ?? nearZMultiplier;
        const farZ = opts.farZ ?? (altitude + GLOBE_RADIUS * 2 * scale / height) * farZMultiplier;
        // Calculate view matrix
        const viewMatrix = new (0, _core.Matrix4)().lookAt({
            eye: [
                0,
                -altitude,
                0
            ],
            up: [
                0,
                0,
                1
            ]
        });
        viewMatrix.rotateX(latitude * DEGREES_TO_RADIANS);
        viewMatrix.rotateZ(-longitude * DEGREES_TO_RADIANS);
        viewMatrix.scale(scale / height);
        super({
            ...opts,
            // x, y, width,
            height,
            // view matrix
            viewMatrix,
            longitude,
            latitude,
            zoom,
            // projection matrix parameters
            distanceScales: getDistanceScales(),
            fovy,
            focalDistance: altitude,
            near: nearZ,
            far: farZ
        });
        this.scale = scale;
        this.latitude = latitude;
        this.longitude = longitude;
        this.resolution = resolution;
    }
    get projectionMode() {
        return (0, _constantsJs.PROJECTION_MODE).GLOBE;
    }
    getDistanceScales() {
        return this.distanceScales;
    }
    getBounds(options = {}) {
        const unprojectOption = {
            targetZ: options.z || 0
        };
        const left = this.unproject([
            0,
            this.height / 2
        ], unprojectOption);
        const top = this.unproject([
            this.width / 2,
            0
        ], unprojectOption);
        const right = this.unproject([
            this.width,
            this.height / 2
        ], unprojectOption);
        const bottom = this.unproject([
            this.width / 2,
            this.height
        ], unprojectOption);
        if (right[0] < this.longitude) right[0] += 360;
        if (left[0] > this.longitude) left[0] -= 360;
        return [
            Math.min(left[0], right[0], top[0], bottom[0]),
            Math.min(left[1], right[1], top[1], bottom[1]),
            Math.max(left[0], right[0], top[0], bottom[0]),
            Math.max(left[1], right[1], top[1], bottom[1])
        ];
    }
    unproject(xyz, { topLeft = true, targetZ } = {}) {
        const [x, y, z] = xyz;
        const y2 = topLeft ? y : this.height - y;
        const { pixelUnprojectionMatrix } = this;
        let coord;
        if (Number.isFinite(z)) // Has depth component
        coord = transformVector(pixelUnprojectionMatrix, [
            x,
            y2,
            z,
            1
        ]);
        else {
            // since we don't know the correct projected z value for the point,
            // unproject two points to get a line and then find the point on that line that intersects with the sphere
            const coord0 = transformVector(pixelUnprojectionMatrix, [
                x,
                y2,
                -1,
                1
            ]);
            const coord1 = transformVector(pixelUnprojectionMatrix, [
                x,
                y2,
                1,
                1
            ]);
            const lt = ((targetZ || 0) / EARTH_RADIUS + 1) * GLOBE_RADIUS;
            const lSqr = (0, _core.vec3).sqrLen((0, _core.vec3).sub([], coord0, coord1));
            const l0Sqr = (0, _core.vec3).sqrLen(coord0);
            const l1Sqr = (0, _core.vec3).sqrLen(coord1);
            const sSqr = (4 * l0Sqr * l1Sqr - (lSqr - l0Sqr - l1Sqr) ** 2) / 16;
            const dSqr = 4 * sSqr / lSqr;
            const r0 = Math.sqrt(l0Sqr - dSqr);
            const dr = Math.sqrt(Math.max(0, lt * lt - dSqr));
            const t = (r0 - dr) / Math.sqrt(lSqr);
            coord = (0, _core.vec3).lerp([], coord0, coord1, t);
        }
        const [X, Y, Z] = this.unprojectPosition(coord);
        if (Number.isFinite(z)) return [
            X,
            Y,
            Z
        ];
        return Number.isFinite(targetZ) ? [
            X,
            Y,
            targetZ
        ] : [
            X,
            Y
        ];
    }
    projectPosition(xyz) {
        const [lng, lat, Z = 0] = xyz;
        const lambda = lng * DEGREES_TO_RADIANS;
        const phi = lat * DEGREES_TO_RADIANS;
        const cosPhi = Math.cos(phi);
        const D = (Z / EARTH_RADIUS + 1) * GLOBE_RADIUS;
        return [
            Math.sin(lambda) * cosPhi * D,
            -Math.cos(lambda) * cosPhi * D,
            Math.sin(phi) * D
        ];
    }
    unprojectPosition(xyz) {
        const [x, y, z] = xyz;
        const D = (0, _core.vec3).len(xyz);
        const phi = Math.asin(z / D);
        const lambda = Math.atan2(x, -y);
        const lng = lambda * RADIANS_TO_DEGREES;
        const lat = phi * RADIANS_TO_DEGREES;
        const Z = (D / GLOBE_RADIUS - 1) * EARTH_RADIUS;
        return [
            lng,
            lat,
            Z
        ];
    }
    projectFlat(xyz) {
        return xyz;
    }
    unprojectFlat(xyz) {
        return xyz;
    }
    panByPosition(coords, pixel) {
        const fromPosition = this.unproject(pixel);
        return {
            longitude: coords[0] - fromPosition[0] + this.longitude,
            latitude: coords[1] - fromPosition[1] + this.latitude
        };
    }
}
exports.default = GlobeViewport;
function transformVector(matrix, vector) {
    const result = (0, _core.vec4).transformMat4([], vector, matrix);
    (0, _core.vec4).scale(result, result, 1 / result[3]);
    return result;
}

},{"@math.gl/core":"6z0Tv","./viewport.js":"9yrml","../lib/constants.js":"k6l9N","@math.gl/web-mercator":"3nSdG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cbqTt":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _globeViewportJs = require("../viewports/globe-viewport.js");
var _globeViewportJsDefault = parcelHelpers.interopDefault(_globeViewportJs);
var _webMercatorViewportJs = require("../viewports/web-mercator-viewport.js");
var _webMercatorViewportJsDefault = parcelHelpers.interopDefault(_webMercatorViewportJs);
var _globeControllerJs = require("../controllers/globe-controller.js");
var _globeControllerJsDefault = parcelHelpers.interopDefault(_globeControllerJs);
class GlobeView extends (0, _viewJsDefault.default) {
    constructor(props = {}){
        super(props);
    }
    getViewportType(viewState) {
        return viewState.zoom > 12 ? (0, _webMercatorViewportJsDefault.default) : (0, _globeViewportJsDefault.default);
    }
    get ControllerType() {
        return 0, _globeControllerJsDefault.default;
    }
}
GlobeView.displayName = 'GlobeView';
exports.default = GlobeView;

},{"./view.js":"tjAv3","../viewports/globe-viewport.js":"lQMDh","../viewports/web-mercator-viewport.js":"3azhZ","../controllers/globe-controller.js":"k8oxA","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"k8oxA":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@math.gl/core");
var _controllerJs = require("./controller.js");
var _controllerJsDefault = parcelHelpers.interopDefault(_controllerJs);
var _mapControllerJs = require("./map-controller.js");
var _mathUtilsJs = require("../utils/math-utils.js");
var _linearInterpolatorJs = require("../transitions/linear-interpolator.js");
var _linearInterpolatorJsDefault = parcelHelpers.interopDefault(_linearInterpolatorJs);
var _webMercator = require("@math.gl/web-mercator");
class GlobeState extends (0, _mapControllerJs.MapState) {
    // Apply any constraints (mathematical or defined by _viewportProps) to map state
    applyConstraints(props) {
        // Ensure zoom is within specified range
        const { maxZoom, minZoom, zoom } = props;
        props.zoom = (0, _core.clamp)(zoom, minZoom, maxZoom);
        const { longitude, latitude } = props;
        if (longitude < -180 || longitude > 180) props.longitude = (0, _mathUtilsJs.mod)(longitude + 180, 360) - 180;
        props.latitude = (0, _core.clamp)(latitude, -(0, _webMercator.MAX_LATITUDE), (0, _webMercator.MAX_LATITUDE));
        return props;
    }
}
class GlobeController extends (0, _controllerJsDefault.default) {
    constructor(){
        super(...arguments);
        this.ControllerState = GlobeState;
        this.transition = {
            transitionDuration: 300,
            transitionInterpolator: new (0, _linearInterpolatorJsDefault.default)([
                'longitude',
                'latitude',
                'zoom'
            ])
        };
        this.dragMode = 'pan';
    }
    setProps(props) {
        super.setProps(props);
        // TODO - support pitching?
        this.dragRotate = false;
        this.touchRotate = false;
    }
}
exports.default = GlobeController;

},{"@math.gl/core":"6z0Tv","./controller.js":"ep4CT","./map-controller.js":"75nE6","../utils/math-utils.js":"kiHqg","../transitions/linear-interpolator.js":"1f6ng","@math.gl/web-mercator":"3nSdG","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2WEkC":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iterableUtilsJs = require("./iterable-utils.js");
var _typedArrayManagerJs = require("./typed-array-manager.js");
var _typedArrayManagerJsDefault = parcelHelpers.interopDefault(_typedArrayManagerJs);
var _assertJs = require("./assert.js");
var _assertJsDefault = parcelHelpers.interopDefault(_assertJs);
var _core = require("@luma.gl/core");
class Tesselator {
    constructor(opts){
        this.indexStarts = [
            0
        ];
        this.vertexStarts = [
            0
        ];
        this.vertexCount = 0;
        this.instanceCount = 0;
        const { attributes = {} } = opts;
        this.typedArrayManager = (0, _typedArrayManagerJsDefault.default);
        this.attributes = {};
        this._attributeDefs = attributes;
        this.opts = opts;
        this.updateGeometry(opts);
    }
    /* Public methods */ updateGeometry(opts) {
        Object.assign(this.opts, opts);
        const { data, buffers = {}, getGeometry, geometryBuffer, positionFormat, dataChanged, normalize = true } = this.opts;
        this.data = data;
        this.getGeometry = getGeometry;
        this.positionSize = // @ts-ignore (2339) when geometryBuffer is a luma Buffer, size falls back to positionFormat
        geometryBuffer && geometryBuffer.size || (positionFormat === 'XY' ? 2 : 3);
        this.buffers = buffers;
        this.normalize = normalize;
        // Handle external logical value
        if (geometryBuffer) {
            (0, _assertJsDefault.default)(data.startIndices); // binary data missing startIndices
            this.getGeometry = this.getGeometryFromBuffer(geometryBuffer);
            if (!normalize) // skip packing and set attribute value directly
            // TODO - avoid mutating user-provided object
            buffers.vertexPositions = geometryBuffer;
        }
        this.geometryBuffer = buffers.vertexPositions;
        if (Array.isArray(dataChanged)) // is partial update
        for (const dataRange of dataChanged)this._rebuildGeometry(dataRange);
        else this._rebuildGeometry();
    }
    updatePartialGeometry({ startRow, endRow }) {
        this._rebuildGeometry({
            startRow,
            endRow
        });
    }
    getGeometryFromBuffer(geometryBuffer) {
        const value = geometryBuffer.value || geometryBuffer;
        if (!ArrayBuffer.isView(value)) // Cannot read binary geometries
        return null;
        // @ts-ignore (2322) NumericArray not assignable to GeometryT
        return (0, _iterableUtilsJs.getAccessorFromBuffer)(value, {
            size: this.positionSize,
            offset: geometryBuffer.offset,
            stride: geometryBuffer.stride,
            startIndices: this.data.startIndices
        });
    }
    /* Private utility methods */ _allocate(instanceCount, copy) {
        // allocate attributes
        const { attributes, buffers, _attributeDefs, typedArrayManager } = this;
        for(const name in _attributeDefs)if (name in buffers) {
            // Use external buffer
            typedArrayManager.release(attributes[name]);
            attributes[name] = null;
        } else {
            const def = _attributeDefs[name];
            // If dataRange is supplied, this is a partial update.
            // In case we need to reallocate the typed array, it will need the old values copied
            // before performing partial update.
            def.copy = copy;
            attributes[name] = typedArrayManager.allocate(attributes[name], instanceCount, def);
        }
    }
    /**
     * Visit all objects
     * `data` is expected to be an iterable consistent with the base Layer expectation
     */ _forEachGeometry(visitor, startRow, endRow) {
        const { data, getGeometry } = this;
        const { iterable, objectInfo } = (0, _iterableUtilsJs.createIterable)(data, startRow, endRow);
        for (const object of iterable){
            objectInfo.index++;
            const geometry = getGeometry ? getGeometry(object, objectInfo) : null;
            visitor(geometry, objectInfo.index);
        }
    }
    /* eslint-disable complexity,max-statements */ _rebuildGeometry(dataRange) {
        if (!this.data) return;
        let { indexStarts, vertexStarts, instanceCount } = this;
        const { data, geometryBuffer } = this;
        const { startRow = 0, endRow = Infinity } = dataRange || {};
        const normalizedData = {};
        if (!dataRange) {
            // Full update - regenerate buffer layout from scratch
            indexStarts = [
                0
            ];
            vertexStarts = [
                0
            ];
        }
        if (this.normalize || !geometryBuffer) {
            this._forEachGeometry((geometry, dataIndex)=>{
                const normalizedGeometry = geometry && this.normalizeGeometry(geometry);
                normalizedData[dataIndex] = normalizedGeometry;
                vertexStarts[dataIndex + 1] = vertexStarts[dataIndex] + (normalizedGeometry ? this.getGeometrySize(normalizedGeometry) : 0);
            }, startRow, endRow);
            // count instances
            instanceCount = vertexStarts[vertexStarts.length - 1];
        } else {
            // assume user provided data is already normalized
            vertexStarts = data.startIndices;
            instanceCount = vertexStarts[data.length] || 0;
            if (ArrayBuffer.isView(geometryBuffer)) instanceCount = instanceCount || geometryBuffer.length / this.positionSize;
            else if (geometryBuffer instanceof (0, _core.Buffer)) {
                const byteStride = this.positionSize * 4;
                instanceCount = instanceCount || geometryBuffer.byteLength / byteStride;
            } else if (geometryBuffer.buffer) {
                const byteStride = geometryBuffer.stride || this.positionSize * 4;
                instanceCount = instanceCount || geometryBuffer.buffer.byteLength / byteStride;
            } else if (geometryBuffer.value) {
                const bufferValue = geometryBuffer.value;
                const elementStride = // @ts-ignore (2339) if stride is not specified, will fall through to positionSize
                geometryBuffer.stride / bufferValue.BYTES_PER_ELEMENT || this.positionSize;
                instanceCount = instanceCount || bufferValue.length / elementStride;
            }
        }
        // allocate attributes
        this._allocate(instanceCount, Boolean(dataRange));
        this.indexStarts = indexStarts;
        this.vertexStarts = vertexStarts;
        this.instanceCount = instanceCount;
        // @ts-ignore (2739) context will be populated in the loop
        const context = {};
        this._forEachGeometry((geometry, dataIndex)=>{
            const normalizedGeometry = normalizedData[dataIndex] || geometry;
            context.vertexStart = vertexStarts[dataIndex];
            context.indexStart = indexStarts[dataIndex];
            const vertexEnd = dataIndex < vertexStarts.length - 1 ? vertexStarts[dataIndex + 1] : instanceCount;
            context.geometrySize = vertexEnd - vertexStarts[dataIndex];
            context.geometryIndex = dataIndex;
            this.updateGeometryAttributes(normalizedGeometry, context);
        }, startRow, endRow);
        this.vertexCount = indexStarts[indexStarts.length - 1];
    }
}
exports.default = Tesselator;

},{"./iterable-utils.js":"akgls","./typed-array-manager.js":"6eAB3","./assert.js":"3Sh37","@luma.gl/core":"7TxCR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5WG87":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@deck.gl/core");
var _engine = require("@luma.gl/engine");
var _shadertools = require("@luma.gl/shadertools");
// Polygon geometry generation is managed by the polygon tesselator
var _polygonTesselatorJs = require("./polygon-tesselator.js");
var _polygonTesselatorJsDefault = parcelHelpers.interopDefault(_polygonTesselatorJs);
var _solidPolygonLayerUniformsJs = require("./solid-polygon-layer-uniforms.js");
var _solidPolygonLayerVertexTopGlslJs = require("./solid-polygon-layer-vertex-top.glsl.js");
var _solidPolygonLayerVertexTopGlslJsDefault = parcelHelpers.interopDefault(_solidPolygonLayerVertexTopGlslJs);
var _solidPolygonLayerVertexSideGlslJs = require("./solid-polygon-layer-vertex-side.glsl.js");
var _solidPolygonLayerVertexSideGlslJsDefault = parcelHelpers.interopDefault(_solidPolygonLayerVertexSideGlslJs);
var _solidPolygonLayerFragmentGlslJs = require("./solid-polygon-layer-fragment.glsl.js");
var _solidPolygonLayerFragmentGlslJsDefault = parcelHelpers.interopDefault(_solidPolygonLayerFragmentGlslJs);
const DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const defaultProps = {
    filled: true,
    extruded: false,
    wireframe: false,
    _normalize: true,
    _windingOrder: 'CW',
    _full3d: false,
    elevationScale: {
        type: 'number',
        min: 0,
        value: 1
    },
    getPolygon: {
        type: 'accessor',
        value: (f)=>f.polygon
    },
    getElevation: {
        type: 'accessor',
        value: 1000
    },
    getFillColor: {
        type: 'accessor',
        value: DEFAULT_COLOR
    },
    getLineColor: {
        type: 'accessor',
        value: DEFAULT_COLOR
    },
    material: true
};
const ATTRIBUTE_TRANSITION = {
    enter: (value, chunk)=>{
        return chunk.length ? chunk.subarray(chunk.length - value.length) : value;
    }
};
class SolidPolygonLayer extends (0, _core.Layer) {
    getShaders(type) {
        return super.getShaders({
            vs: type === 'top' ? (0, _solidPolygonLayerVertexTopGlslJsDefault.default) : (0, _solidPolygonLayerVertexSideGlslJsDefault.default),
            fs: (0, _solidPolygonLayerFragmentGlslJsDefault.default),
            defines: {
                RING_WINDING_ORDER_CW: !this.props._normalize && this.props._windingOrder === 'CCW' ? 0 : 1
            },
            modules: [
                (0, _core.project32),
                (0, _shadertools.gouraudMaterial),
                (0, _core.picking),
                (0, _solidPolygonLayerUniformsJs.solidPolygonUniforms)
            ]
        });
    }
    get wrapLongitude() {
        return false;
    }
    getBounds() {
        return this.getAttributeManager()?.getBounds([
            'vertexPositions'
        ]);
    }
    initializeState() {
        const { viewport } = this.context;
        let { coordinateSystem } = this.props;
        const { _full3d } = this.props;
        if (viewport.isGeospatial && coordinateSystem === (0, _core.COORDINATE_SYSTEM).DEFAULT) coordinateSystem = (0, _core.COORDINATE_SYSTEM).LNGLAT;
        let preproject;
        if (coordinateSystem === (0, _core.COORDINATE_SYSTEM).LNGLAT) {
            if (_full3d) preproject = viewport.projectPosition.bind(viewport);
            else preproject = viewport.projectFlat.bind(viewport);
        }
        this.setState({
            numInstances: 0,
            polygonTesselator: new (0, _polygonTesselatorJsDefault.default)({
                // Lnglat coordinates are usually projected non-linearly, which affects tesselation results
                // Provide a preproject function if the coordinates are in lnglat
                preproject,
                fp64: this.use64bitPositions(),
                IndexType: Uint32Array
            })
        });
        const attributeManager = this.getAttributeManager();
        const noAlloc = true;
        attributeManager.remove([
            'instancePickingColors'
        ]);
        /* eslint-disable max-len */ attributeManager.add({
            indices: {
                size: 1,
                isIndexed: true,
                // eslint-disable-next-line @typescript-eslint/unbound-method
                update: this.calculateIndices,
                noAlloc
            },
            vertexPositions: {
                size: 3,
                type: 'float64',
                stepMode: 'dynamic',
                fp64: this.use64bitPositions(),
                transition: ATTRIBUTE_TRANSITION,
                accessor: 'getPolygon',
                // eslint-disable-next-line @typescript-eslint/unbound-method
                update: this.calculatePositions,
                noAlloc,
                shaderAttributes: {
                    nextVertexPositions: {
                        vertexOffset: 1
                    }
                }
            },
            instanceVertexValid: {
                size: 1,
                type: 'uint16',
                stepMode: 'instance',
                // eslint-disable-next-line @typescript-eslint/unbound-method
                update: this.calculateVertexValid,
                noAlloc
            },
            elevations: {
                size: 1,
                stepMode: 'dynamic',
                transition: ATTRIBUTE_TRANSITION,
                accessor: 'getElevation'
            },
            fillColors: {
                size: this.props.colorFormat.length,
                type: 'unorm8',
                stepMode: 'dynamic',
                transition: ATTRIBUTE_TRANSITION,
                accessor: 'getFillColor',
                defaultValue: DEFAULT_COLOR
            },
            lineColors: {
                size: this.props.colorFormat.length,
                type: 'unorm8',
                stepMode: 'dynamic',
                transition: ATTRIBUTE_TRANSITION,
                accessor: 'getLineColor',
                defaultValue: DEFAULT_COLOR
            },
            pickingColors: {
                size: 4,
                type: 'uint8',
                stepMode: 'dynamic',
                accessor: (object, { index, target: value })=>this.encodePickingColor(object && object.__source ? object.__source.index : index, value)
            }
        });
    /* eslint-enable max-len */ }
    getPickingInfo(params) {
        const info = super.getPickingInfo(params);
        const { index } = info;
        const data = this.props.data;
        // Check if data comes from a composite layer, wrapped with getSubLayerRow
        if (data[0] && data[0].__source) // index decoded from picking color refers to the source index
        info.object = data.find((d)=>d.__source.index === index);
        return info;
    }
    disablePickingIndex(objectIndex) {
        const data = this.props.data;
        // Check if data comes from a composite layer, wrapped with getSubLayerRow
        if (data[0] && data[0].__source) {
            // index decoded from picking color refers to the source index
            for(let i = 0; i < data.length; i++)if (data[i].__source.index === objectIndex) this._disablePickingIndex(i);
        } else super.disablePickingIndex(objectIndex);
    }
    draw({ uniforms }) {
        const { extruded, filled, wireframe, elevationScale } = this.props;
        const { topModel, sideModel, wireframeModel, polygonTesselator } = this.state;
        const renderUniforms = {
            extruded: Boolean(extruded),
            elevationScale,
            isWireframe: false
        };
        // Note - the order is important
        if (wireframeModel && wireframe) {
            wireframeModel.setInstanceCount(polygonTesselator.instanceCount - 1);
            wireframeModel.shaderInputs.setProps({
                solidPolygon: {
                    ...renderUniforms,
                    isWireframe: true
                }
            });
            wireframeModel.draw(this.context.renderPass);
        }
        if (sideModel && filled) {
            sideModel.setInstanceCount(polygonTesselator.instanceCount - 1);
            sideModel.shaderInputs.setProps({
                solidPolygon: renderUniforms
            });
            sideModel.draw(this.context.renderPass);
        }
        if (topModel && filled) {
            topModel.setVertexCount(polygonTesselator.vertexCount);
            topModel.shaderInputs.setProps({
                solidPolygon: renderUniforms
            });
            topModel.draw(this.context.renderPass);
        }
    }
    updateState(updateParams) {
        super.updateState(updateParams);
        this.updateGeometry(updateParams);
        const { props, oldProps, changeFlags } = updateParams;
        const attributeManager = this.getAttributeManager();
        const regenerateModels = changeFlags.extensionsChanged || props.filled !== oldProps.filled || props.extruded !== oldProps.extruded;
        if (regenerateModels) {
            this.state.models?.forEach((model)=>model.destroy());
            this.setState(this._getModels());
            attributeManager.invalidateAll();
        }
    }
    updateGeometry({ props, oldProps, changeFlags }) {
        const geometryConfigChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPolygon);
        // When the geometry config  or the data is changed,
        // tessellator needs to be invoked
        if (geometryConfigChanged) {
            const { polygonTesselator } = this.state;
            const buffers = props.data.attributes || {};
            polygonTesselator.updateGeometry({
                data: props.data,
                normalize: props._normalize,
                geometryBuffer: buffers.getPolygon,
                buffers,
                getGeometry: props.getPolygon,
                positionFormat: props.positionFormat,
                wrapLongitude: props.wrapLongitude,
                // TODO - move the flag out of the viewport
                resolution: this.context.viewport.resolution,
                fp64: this.use64bitPositions(),
                dataChanged: changeFlags.dataChanged,
                full3d: props._full3d
            });
            this.setState({
                numInstances: polygonTesselator.instanceCount,
                startIndices: polygonTesselator.vertexStarts
            });
            if (!changeFlags.dataChanged) // Base `layer.updateState` only invalidates all attributes on data change
            // Cover the rest of the scenarios here
            this.getAttributeManager().invalidateAll();
        }
    }
    _getModels() {
        const { id, filled, extruded } = this.props;
        let topModel;
        let sideModel;
        let wireframeModel;
        if (filled) {
            const shaders = this.getShaders('top');
            shaders.defines.NON_INSTANCED_MODEL = 1;
            const bufferLayout = this.getAttributeManager().getBufferLayouts({
                isInstanced: false
            });
            topModel = new (0, _engine.Model)(this.context.device, {
                ...shaders,
                id: `${id}-top`,
                topology: 'triangle-list',
                bufferLayout,
                isIndexed: true,
                userData: {
                    excludeAttributes: {
                        instanceVertexValid: true
                    }
                }
            });
        }
        if (extruded) {
            const bufferLayout = this.getAttributeManager().getBufferLayouts({
                isInstanced: true
            });
            sideModel = new (0, _engine.Model)(this.context.device, {
                ...this.getShaders('side'),
                id: `${id}-side`,
                bufferLayout,
                geometry: new (0, _engine.Geometry)({
                    topology: 'triangle-strip',
                    attributes: {
                        // top right - top left - bottom right - bottom left
                        positions: {
                            size: 2,
                            value: new Float32Array([
                                1,
                                0,
                                0,
                                0,
                                1,
                                1,
                                0,
                                1
                            ])
                        }
                    }
                }),
                isInstanced: true,
                userData: {
                    excludeAttributes: {
                        indices: true
                    }
                }
            });
            wireframeModel = new (0, _engine.Model)(this.context.device, {
                ...this.getShaders('side'),
                id: `${id}-wireframe`,
                bufferLayout,
                geometry: new (0, _engine.Geometry)({
                    topology: 'line-strip',
                    attributes: {
                        // top right - top left - bottom left - bottom right
                        positions: {
                            size: 2,
                            value: new Float32Array([
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                1,
                                1
                            ])
                        }
                    }
                }),
                isInstanced: true,
                userData: {
                    excludeAttributes: {
                        indices: true
                    }
                }
            });
        }
        return {
            models: [
                sideModel,
                wireframeModel,
                topModel
            ].filter(Boolean),
            topModel,
            sideModel,
            wireframeModel
        };
    }
    calculateIndices(attribute) {
        const { polygonTesselator } = this.state;
        attribute.startIndices = polygonTesselator.indexStarts;
        attribute.value = polygonTesselator.get('indices');
    }
    calculatePositions(attribute) {
        const { polygonTesselator } = this.state;
        attribute.startIndices = polygonTesselator.vertexStarts;
        attribute.value = polygonTesselator.get('positions');
    }
    calculateVertexValid(attribute) {
        attribute.value = this.state.polygonTesselator.get('vertexValid');
    }
}
SolidPolygonLayer.defaultProps = defaultProps;
SolidPolygonLayer.layerName = 'SolidPolygonLayer';
exports.default = SolidPolygonLayer;

},{"@deck.gl/core":"grwzR","@luma.gl/engine":"joT4s","@luma.gl/shadertools":"iH5G2","./polygon-tesselator.js":"jXFxJ","./solid-polygon-layer-uniforms.js":"dK2uZ","./solid-polygon-layer-vertex-top.glsl.js":"5ONDQ","./solid-polygon-layer-vertex-side.glsl.js":"iuE2c","./solid-polygon-layer-fragment.glsl.js":"juvSW","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jXFxJ":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
// Handles tesselation of polygons with holes
// - 2D surfaces
// - 2D outlines
// - 3D surfaces (top and sides only)
// - 3D wireframes (not yet)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _polygonJs = require("./polygon.js");
var _core = require("@deck.gl/core");
var _polygon = require("@math.gl/polygon");
class PolygonTesselator extends (0, _core.Tesselator) {
    constructor(opts){
        const { fp64, IndexType = Uint32Array } = opts;
        super({
            ...opts,
            attributes: {
                positions: {
                    size: 3,
                    type: fp64 ? Float64Array : Float32Array
                },
                vertexValid: {
                    type: Uint16Array,
                    size: 1
                },
                indices: {
                    type: IndexType,
                    size: 1
                }
            }
        });
    }
    /** Get attribute by name */ get(attributeName) {
        const { attributes } = this;
        if (attributeName === 'indices') return attributes.indices && attributes.indices.subarray(0, this.vertexCount);
        return attributes[attributeName];
    }
    /** Override base Tesselator method */ updateGeometry(opts) {
        super.updateGeometry(opts);
        const externalIndices = this.buffers.indices;
        if (externalIndices) // @ts-ignore (2339) value is not defined on TypedArray (fall through)
        this.vertexCount = (externalIndices.value || externalIndices).length;
        else if (this.data && !this.getGeometry) throw new Error('missing indices buffer');
    }
    /** Implement base Tesselator interface */ normalizeGeometry(polygon) {
        if (this.normalize) {
            const normalizedPolygon = _polygonJs.normalize(polygon, this.positionSize);
            if (this.opts.resolution) return (0, _polygon.cutPolygonByGrid)(_polygonJs.getPositions(normalizedPolygon), _polygonJs.getHoleIndices(normalizedPolygon), {
                size: this.positionSize,
                gridResolution: this.opts.resolution,
                edgeTypes: true
            });
            if (this.opts.wrapLongitude) return (0, _polygon.cutPolygonByMercatorBounds)(_polygonJs.getPositions(normalizedPolygon), _polygonJs.getHoleIndices(normalizedPolygon), {
                size: this.positionSize,
                maxLatitude: 86,
                edgeTypes: true
            });
            return normalizedPolygon;
        }
        // normalize is explicitly set to false, assume that user passed in already normalized polygons
        return polygon;
    }
    /** Implement base Tesselator interface */ getGeometrySize(polygon) {
        if (isCut(polygon)) {
            let size = 0;
            for (const subPolygon of polygon)size += this.getGeometrySize(subPolygon);
            return size;
        }
        return _polygonJs.getPositions(polygon).length / this.positionSize;
    }
    /** Override base Tesselator method */ getGeometryFromBuffer(buffer) {
        if (this.normalize || !this.buffers.indices) return super.getGeometryFromBuffer(buffer);
        // we don't need to read the positions if no normalization/tesselation
        return null;
    }
    /** Implement base Tesselator interface */ updateGeometryAttributes(polygon, context) {
        if (polygon && isCut(polygon)) for (const subPolygon of polygon){
            const geometrySize = this.getGeometrySize(subPolygon);
            context.geometrySize = geometrySize;
            this.updateGeometryAttributes(subPolygon, context);
            context.vertexStart += geometrySize;
            context.indexStart = this.indexStarts[context.geometryIndex + 1];
        }
        else {
            const normalizedPolygon = polygon;
            this._updateIndices(normalizedPolygon, context);
            this._updatePositions(normalizedPolygon, context);
            this._updateVertexValid(normalizedPolygon, context);
        }
    }
    // Flatten the indices array
    _updateIndices(polygon, { geometryIndex, vertexStart: offset, indexStart }) {
        const { attributes, indexStarts, typedArrayManager } = this;
        let target = attributes.indices;
        if (!target || !polygon) return;
        let i = indexStart;
        // 1. get triangulated indices for the internal areas
        const indices = _polygonJs.getSurfaceIndices(polygon, this.positionSize, this.opts.preproject, this.opts.full3d);
        // make sure the buffer is large enough
        target = typedArrayManager.allocate(target, indexStart + indices.length, {
            copy: true
        });
        // 2. offset each index by the number of indices in previous polygons
        for(let j = 0; j < indices.length; j++)target[i++] = indices[j] + offset;
        indexStarts[geometryIndex + 1] = indexStart + indices.length;
        attributes.indices = target;
    }
    // Flatten out all the vertices of all the sub subPolygons
    _updatePositions(polygon, { vertexStart, geometrySize }) {
        const { attributes: { positions }, positionSize } = this;
        if (!positions || !polygon) return;
        const polygonPositions = _polygonJs.getPositions(polygon);
        for(let i = vertexStart, j = 0; j < geometrySize; i++, j++){
            const x = polygonPositions[j * positionSize];
            const y = polygonPositions[j * positionSize + 1];
            const z = positionSize > 2 ? polygonPositions[j * positionSize + 2] : 0;
            positions[i * 3] = x;
            positions[i * 3 + 1] = y;
            positions[i * 3 + 2] = z;
        }
    }
    _updateVertexValid(polygon, { vertexStart, geometrySize }) {
        const { positionSize } = this;
        const vertexValid = this.attributes.vertexValid;
        const holeIndices = polygon && _polygonJs.getHoleIndices(polygon);
        /* We are reusing the some buffer for `nextPositions` by offseting one vertex
         * to the left. As a result,
         * the last vertex of each ring overlaps with the first vertex of the next ring.
         * `vertexValid` is used to mark the end of each ring so we don't draw these
         * segments:
          positions      A0 A1 A2 A3 A4 B0 B1 B2 C0 ...
          nextPositions  A1 A2 A3 A4 B0 B1 B2 C0 C1 ...
          vertexValid    1  1  1  1  0  1  1  0  1 ...
         */ if (polygon && polygon.edgeTypes) vertexValid.set(polygon.edgeTypes, vertexStart);
        else vertexValid.fill(1, vertexStart, vertexStart + geometrySize);
        if (holeIndices) for(let j = 0; j < holeIndices.length; j++)vertexValid[vertexStart + holeIndices[j] / positionSize - 1] = 0;
        vertexValid[vertexStart + geometrySize - 1] = 0;
    }
}
exports.default = PolygonTesselator;
function isCut(polygon) {
    return Array.isArray(polygon) && polygon.length > 0 && !Number.isFinite(polygon[0]);
}

},{"./polygon.js":"61rwz","@deck.gl/core":"grwzR","@math.gl/polygon":"9Lj7P","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"61rwz":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable max-params */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Get the positions from a normalized polygon */ parcelHelpers.export(exports, "getPositions", ()=>getPositions);
/** Get the hole indices from a normalized polygon */ parcelHelpers.export(exports, "getHoleIndices", ()=>getHoleIndices);
/**
 * Normalize any polygon representation into the "complex flat" format
 */ /* eslint-disable max-statements */ parcelHelpers.export(exports, "normalize", ()=>normalize);
/**
 * Get vertex indices for drawing polygon mesh (triangulation)
 */ // eslint-disable-next-line complexity, max-statements
parcelHelpers.export(exports, "getSurfaceIndices", ()=>getSurfaceIndices);
var _earcut = require("earcut");
var _earcutDefault = parcelHelpers.interopDefault(_earcut);
var _polygon = require("@math.gl/polygon");
const OUTER_POLYGON_WINDING = (0, _polygon.WINDING).CLOCKWISE;
const HOLE_POLYGON_WINDING = (0, _polygon.WINDING).COUNTER_CLOCKWISE;
/** A scratch object for sending winding options */ const windingOptions = {
    isClosed: true
};
/**
 * Ensure a polygon is valid format
 */ function validate(polygon) {
    polygon = polygon && polygon.positions || polygon;
    if (!Array.isArray(polygon) && !ArrayBuffer.isView(polygon)) throw new Error('invalid polygon');
}
function getPositions(polygon) {
    return 'positions' in polygon ? polygon.positions : polygon;
}
function getHoleIndices(polygon) {
    return 'holeIndices' in polygon ? polygon.holeIndices : null;
}
/**
 * Check if a polygon is nested or flat
 * Returns true if the polygon is a flat polygon (i.e. not an array of polygons)
 */ function isNested(polygon) {
    return Array.isArray(polygon[0]);
}
/**
 * Check if a polygon is simple or complex
 * Returns true if the polygon is a simple polygon (i.e. not an array of polygons)
 */ function isSimple(polygon) {
    return polygon.length >= 1 && polygon[0].length >= 2 && Number.isFinite(polygon[0][0]);
}
/**
 * Check if a simple polygon is a closed ring
 * Returns true if the simple polygon is a closed ring
 */ function isNestedRingClosed(simplePolygon) {
    // check if first and last vertex are the same
    const p0 = simplePolygon[0];
    const p1 = simplePolygon[simplePolygon.length - 1];
    return p0[0] === p1[0] && p0[1] === p1[1] && p0[2] === p1[2];
}
/**
 * Check if a simple flat array is a closed ring
 * Returns true if the simple flat array is a closed ring
 */ function isFlatRingClosed(positions, /** size of a position, 2 (xy) or 3 (xyz) */ size, /** start index of the path in the positions array */ startIndex, /** end index of the path in the positions array */ endIndex) {
    for(let i = 0; i < size; i++){
        if (positions[startIndex + i] !== positions[endIndex - size + i]) return false;
    }
    return true;
}
/**
 * Copy a simple polygon coordinates into a flat array, closes the ring if needed.
 * Returns the index of the write head in the destination
 */ function copyNestedRing(/** destination */ target, /** index in the destination to start copying into */ targetStartIndex, /** the source polygon */ simplePolygon, /** size of a position, 2 (xy) or 3 (xyz) */ size, /** modify polygon to be of the specified winding direction */ windingDirection) {
    let targetIndex = targetStartIndex;
    const len = simplePolygon.length;
    for(let i = 0; i < len; i++)for(let j = 0; j < size; j++)target[targetIndex++] = simplePolygon[i][j] || 0;
    if (!isNestedRingClosed(simplePolygon)) for(let j = 0; j < size; j++)target[targetIndex++] = simplePolygon[0][j] || 0;
    windingOptions.start = targetStartIndex;
    windingOptions.end = targetIndex;
    windingOptions.size = size;
    (0, _polygon.modifyPolygonWindingDirection)(target, windingDirection, windingOptions);
    return targetIndex;
}
/**
 * Copy a simple flat array into another flat array, closes the ring if needed.
 * Returns the index of the write head in the destination
 */ function copyFlatRing(/** destination */ target, /** index in the destination to start copying into */ targetStartIndex, /** the source polygon */ positions, /** size of a position, 2 (xy) or 3 (xyz) */ size, /** start index of the path in the positions array */ srcStartIndex = 0, /** end index of the path in the positions array */ srcEndIndex, windingDirection) {
    srcEndIndex = srcEndIndex || positions.length;
    const srcLength = srcEndIndex - srcStartIndex;
    if (srcLength <= 0) return targetStartIndex;
    let targetIndex = targetStartIndex;
    for(let i = 0; i < srcLength; i++)target[targetIndex++] = positions[srcStartIndex + i];
    if (!isFlatRingClosed(positions, size, srcStartIndex, srcEndIndex)) for(let i = 0; i < size; i++)target[targetIndex++] = positions[srcStartIndex + i];
    windingOptions.start = targetStartIndex;
    windingOptions.end = targetIndex;
    windingOptions.size = size;
    (0, _polygon.modifyPolygonWindingDirection)(target, windingDirection, windingOptions);
    return targetIndex;
}
function normalize(polygon, positionSize) {
    validate(polygon);
    const positions = [];
    const holeIndices = [];
    if ('positions' in polygon) {
        // complex flat
        const { positions: srcPositions, holeIndices: srcHoleIndices } = polygon;
        if (srcHoleIndices) {
            let targetIndex = 0;
            // split the positions array into `holeIndices.length + 1` rings
            // holeIndices[-1] falls back to 0
            // holeIndices[holeIndices.length] falls back to positions.length
            for(let i = 0; i <= srcHoleIndices.length; i++){
                targetIndex = copyFlatRing(positions, targetIndex, srcPositions, positionSize, srcHoleIndices[i - 1], srcHoleIndices[i], i === 0 ? OUTER_POLYGON_WINDING : HOLE_POLYGON_WINDING);
                holeIndices.push(targetIndex);
            }
            // The last one is not a starting index of a hole, remove
            holeIndices.pop();
            return {
                positions,
                holeIndices
            };
        }
        polygon = srcPositions;
    }
    if (!isNested(polygon)) {
        // simple flat
        copyFlatRing(positions, 0, polygon, positionSize, 0, positions.length, OUTER_POLYGON_WINDING);
        return positions;
    }
    if (!isSimple(polygon)) {
        // complex polygon
        let targetIndex = 0;
        for (const [polygonIndex, simplePolygon] of polygon.entries()){
            targetIndex = copyNestedRing(positions, targetIndex, simplePolygon, positionSize, polygonIndex === 0 ? OUTER_POLYGON_WINDING : HOLE_POLYGON_WINDING);
            holeIndices.push(targetIndex);
        }
        // The last one is not a starting index of a hole, remove
        holeIndices.pop();
        // last index points to the end of the array, remove it
        return {
            positions,
            holeIndices
        };
    }
    // simple polygon
    copyNestedRing(positions, 0, polygon, positionSize, OUTER_POLYGON_WINDING);
    return positions;
}
/* eslint-enable max-statements */ /*
 * Calculate the area of a single plane of the polygon
 */ function getPlaneArea(positions, xIndex, yIndex) {
    const numVerts = positions.length / 3;
    let area = 0;
    for(let i = 0; i < numVerts; i++){
        const j = (i + 1) % numVerts;
        area += positions[i * 3 + xIndex] * positions[j * 3 + yIndex];
        area -= positions[j * 3 + xIndex] * positions[i * 3 + yIndex];
    }
    return Math.abs(area / 2);
}
function permutePositions(positions, xIndex, yIndex, zIndex) {
    const numVerts = positions.length / 3;
    for(let i = 0; i < numVerts; i++){
        const o = i * 3;
        const x = positions[o + 0];
        const y = positions[o + 1];
        const z = positions[o + 2];
        positions[o + xIndex] = x;
        positions[o + yIndex] = y;
        positions[o + zIndex] = z;
    }
}
function getSurfaceIndices(polygon, positionSize, preproject, full3d) {
    let holeIndices = getHoleIndices(polygon);
    if (holeIndices) holeIndices = holeIndices.map((positionIndex)=>positionIndex / positionSize);
    let positions = getPositions(polygon);
    const is3d = full3d && positionSize === 3;
    if (preproject) {
        // When tesselating lnglat coordinates, project them to the common space for accuracy
        const n = positions.length;
        // Clone the array
        positions = positions.slice();
        const p = [];
        for(let i = 0; i < n; i += positionSize){
            p[0] = positions[i];
            p[1] = positions[i + 1];
            if (is3d) p[2] = positions[i + 2];
            const xy = preproject(p);
            positions[i] = xy[0];
            positions[i + 1] = xy[1];
            if (is3d) positions[i + 2] = xy[2];
        }
    }
    if (is3d) {
        // calculate plane with largest area
        const xyArea = getPlaneArea(positions, 0, 1);
        const xzArea = getPlaneArea(positions, 0, 2);
        const yzArea = getPlaneArea(positions, 1, 2);
        if (!xyArea && !xzArea && !yzArea) return []; // no planes have area, nothing we can do
        // permute positions to make the largest plane xy for earcut
        if (xyArea > xzArea && xyArea > yzArea) ;
        else if (xzArea > yzArea) {
            // xz plane largest, permute to make xyz -> xzy
            if (!preproject) positions = positions.slice();
            permutePositions(positions, 0, 2, 1);
        } else {
            // yz plane largest, permute to make xyz -> yzx
            if (!preproject) positions = positions.slice();
            permutePositions(positions, 2, 0, 1);
        }
    }
    // Let earcut triangulate the polygon
    return (0, _earcutDefault.default)(positions, holeIndices, positionSize);
}

},{"earcut":"2qRC2","@math.gl/polygon":"9Lj7P","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2qRC2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = earcut;
module.exports.default = earcut;
function earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = insertNode(i, data[i], data[i + 1], last);
    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = zOrder(x0, y0, minX, minY, invSize), maxZ = zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = splitPolygon(a, b);
                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);
                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }
    queue.sort(compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = eliminateHole(queue[i], outerNode);
    return outerNode;
}
function compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    var bridge = findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
    (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
    (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
    equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    var o1 = sign(area(p1, q1, p2));
    var o2 = sign(area(p1, q1, q2));
    var o3 = sign(area(p2, q2, p1));
    var o4 = sign(area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs(signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

},{}],"9Lj7P":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Polygon", ()=>(0, _polygonJs.Polygon));
parcelHelpers.export(exports, "getPolygonSignedArea", ()=>(0, _polygonUtilsJs.getPolygonSignedArea));
parcelHelpers.export(exports, "getPolygonWindingDirection", ()=>(0, _polygonUtilsJs.getPolygonWindingDirection));
parcelHelpers.export(exports, "forEachSegmentInPolygon", ()=>(0, _polygonUtilsJs.forEachSegmentInPolygon));
parcelHelpers.export(exports, "modifyPolygonWindingDirection", ()=>(0, _polygonUtilsJs.modifyPolygonWindingDirection));
parcelHelpers.export(exports, "WINDING", ()=>(0, _polygonUtilsJs.WINDING));
parcelHelpers.export(exports, "earcut", ()=>(0, _earcutJs.earcut));
parcelHelpers.export(exports, "clipPolygon", ()=>(0, _lineclipJs.clipPolygon));
parcelHelpers.export(exports, "clipPolyline", ()=>(0, _lineclipJs.clipPolyline));
parcelHelpers.export(exports, "cutPolygonByGrid", ()=>(0, _cutByGridJs.cutPolygonByGrid));
parcelHelpers.export(exports, "cutPolylineByGrid", ()=>(0, _cutByGridJs.cutPolylineByGrid));
parcelHelpers.export(exports, "cutPolylineByMercatorBounds", ()=>(0, _cutByMercatorBoundsJs.cutPolylineByMercatorBounds));
parcelHelpers.export(exports, "cutPolygonByMercatorBounds", ()=>(0, _cutByMercatorBoundsJs.cutPolygonByMercatorBounds));
/** @deprecated */ parcelHelpers.export(exports, "_Polygon", ()=>(0, _polygonJs.Polygon));
var _polygonJs = require("./polygon.js");
var _polygonUtilsJs = require("./polygon-utils.js");
var _earcutJs = require("./earcut.js");
var _lineclipJs = require("./lineclip.js");
var _cutByGridJs = require("./cut-by-grid.js");
var _cutByMercatorBoundsJs = require("./cut-by-mercator-bounds.js");

},{"./polygon.js":"7qbIB","./polygon-utils.js":"hCbKZ","./earcut.js":"20OX8","./lineclip.js":"ghxic","./cut-by-grid.js":"2E3cW","./cut-by-mercator-bounds.js":"asuWN","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7qbIB":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable no-undef, no-console */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Polygon", ()=>Polygon);
var _core = require("@math.gl/core");
var _polygonUtilsJs = require("./polygon-utils.js");
class Polygon {
    constructor(points, options = {}){
        this.points = points;
        this.isFlatArray = !(0, _core.isArray)(points[0]);
        this.options = {
            start: options.start || 0,
            end: options.end || points.length,
            size: options.size || 2,
            isClosed: options.isClosed
        };
        Object.freeze(this);
    }
    /**
     * Returns signed area of the polygon.
     * @returns Signed area of the polygon.
     */ getSignedArea() {
        if (this.isFlatArray) return (0, _polygonUtilsJs.getPolygonSignedArea)(this.points, this.options);
        return (0, _polygonUtilsJs.getPolygonSignedAreaPoints)(this.points, this.options);
    }
    /**
     * Returns absolute area of the polygon.
     * @returns Absolute area of the polygon.
     */ getArea() {
        return Math.abs(this.getSignedArea());
    }
    /**
     * Returns winding direction of the polygon.
     * @returns Winding direction of the polygon. 1 is for clockwise, -1 for counterclockwise winding direction.
     */ getWindingDirection() {
        return Math.sign(this.getSignedArea());
    }
    /**
     * Calls the visitor callback for each segment in the polygon.
     * @param visitor A callback to call for each segment.
     */ forEachSegment(visitor) {
        if (this.isFlatArray) (0, _polygonUtilsJs.forEachSegmentInPolygon)(this.points, // eslint-disable-next-line max-params
        (x1, y1, x2, y2, i1, i2)=>{
            // TODO @igorDykhta original visitor uses arrays for each point, but with flat arrays performance degrades if we allocate points for each segment
            visitor([
                x1,
                y1
            ], [
                x2,
                y2
            ], i1, i2);
        }, this.options);
        else (0, _polygonUtilsJs.forEachSegmentInPolygonPoints)(this.points, visitor, this.options);
    }
    /**
     * Checks winding direction of the polygon and reverses the polygon in case of opposite winding direction.
     * @param direction Requested winding direction. 1 is for clockwise, -1 for counterclockwise winding direction.
     * @return Returns true if the winding direction was changed.
     */ modifyWindingDirection(direction) {
        if (this.isFlatArray) return (0, _polygonUtilsJs.modifyPolygonWindingDirection)(this.points, direction, this.options);
        return (0, _polygonUtilsJs.modifyPolygonWindingDirectionPoints)(this.points, direction, this.options);
    }
}

},{"@math.gl/core":"6z0Tv","./polygon-utils.js":"hCbKZ","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hCbKZ":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT and ISC
// Copyright (c) vis.gl contributors
/* eslint-disable max-statements, max-depth, complexity, no-unused-expressions */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WINDING", ()=>WINDING);
/**
 * Checks winding direction of the polygon and reverses the polygon in case of opposite winding direction.
 * Note: points are modified in-place.
 * @param points An array that represents points of the polygon.
 * @param direction Requested winding direction. 1 is for clockwise, -1 for counterclockwise winding direction.
 * @param options Parameters of the polygon.
 * @return Returns true if the winding direction was changed.
 */ parcelHelpers.export(exports, "modifyPolygonWindingDirection", ()=>modifyPolygonWindingDirection);
/**
 * Returns winding direction of the polygon.
 * @param points An array that represents points of the polygon.
 * @param options Parameters of the polygon.
 * @returns Winding direction of the polygon.
 */ parcelHelpers.export(exports, "getPolygonWindingDirection", ()=>getPolygonWindingDirection);
parcelHelpers.export(exports, "DimIndex", ()=>DimIndex);
/**
 * Returns signed area of the polygon.
 * @param points An array that represents points of the polygon.
 * @param options Parameters of the polygon.
 * @returns Signed area of the polygon.
 * https://en.wikipedia.org/wiki/Shoelace_formula
 */ parcelHelpers.export(exports, "getPolygonSignedArea", ()=>getPolygonSignedArea);
/**
 * Calls the visitor callback for each segment in the polygon.
 * @param points An array that represents points of the polygon
 * @param visitor A callback to call for each segment.
 * @param options Parameters of the polygon.
 */ parcelHelpers.export(exports, "forEachSegmentInPolygon", ()=>forEachSegmentInPolygon);
/**
 * Checks winding direction of the polygon and reverses the polygon in case of opposite winding direction.
 * Note: points are modified in-place.
 * @param points Array of points that represent the polygon.
 * @param direction Requested winding direction. 1 is for clockwise, -1 for counterclockwise winding direction.
 * @param options Parameters of the polygon.
 * @return Returns true if the winding direction was changed.
 */ parcelHelpers.export(exports, "modifyPolygonWindingDirectionPoints", ()=>modifyPolygonWindingDirectionPoints);
/**
 * Returns winding direction of the polygon.
 * @param points Array of points that represent the polygon.
 * @param options Parameters of the polygon.
 * @returns Winding direction of the polygon.
 */ parcelHelpers.export(exports, "getPolygonWindingDirectionPoints", ()=>getPolygonWindingDirectionPoints);
/**
 * Returns signed area of the polygon.
 * @param points Array of points that represent the polygon.
 * @param options Parameters of the polygon.
 * @returns Signed area of the polygon.
 */ parcelHelpers.export(exports, "getPolygonSignedAreaPoints", ()=>getPolygonSignedAreaPoints);
/**
 * Calls visitor callback for each segment in the polygon.
 * @param points Array of points that represent the polygon.
 * @param visitor A callback to call for each segment.
 * @param options Parameters of the polygon.
 */ parcelHelpers.export(exports, "forEachSegmentInPolygonPoints", ()=>forEachSegmentInPolygonPoints);
var _core = require("@math.gl/core");
const WINDING = {
    CLOCKWISE: 1,
    COUNTER_CLOCKWISE: -1
};
function modifyPolygonWindingDirection(points, direction, options = {}) {
    const windingDirection = getPolygonWindingDirection(points, options);
    if (windingDirection !== direction) {
        reversePolygon(points, options);
        return true;
    }
    return false;
}
function getPolygonWindingDirection(points, options = {}) {
    return Math.sign(getPolygonSignedArea(points, options));
}
const DimIndex = {
    x: 0,
    y: 1,
    z: 2
};
function getPolygonSignedArea(points, options = {}) {
    const { start = 0, end = points.length, plane = 'xy' } = options;
    const dim = options.size || 2;
    let area = 0;
    const i0 = DimIndex[plane[0]];
    const i1 = DimIndex[plane[1]];
    for(let i = start, j = end - dim; i < end; i += dim){
        area += (points[i + i0] - points[j + i0]) * (points[i + i1] + points[j + i1]);
        j = i;
    }
    return area / 2;
}
function forEachSegmentInPolygon(points, visitor, options = {}) {
    const { start = 0, end = points.length, size = 2, isClosed } = options;
    const numPoints = (end - start) / size;
    for(let i = 0; i < numPoints - 1; ++i)visitor(points[start + i * size], points[start + i * size + 1], points[start + (i + 1) * size], points[start + (i + 1) * size + 1], i, i + 1);
    const endPointIndex = start + (numPoints - 1) * size;
    const isClosedEx = isClosed || (0, _core.equals)(points[start], points[endPointIndex]) && (0, _core.equals)(points[start + 1], points[endPointIndex + 1]);
    if (!isClosedEx) visitor(points[endPointIndex], points[endPointIndex + 1], points[start], points[start + 1], numPoints - 1, 0);
}
function reversePolygon(points, options) {
    const { start = 0, end = points.length, size = 2 } = options;
    const numPoints = (end - start) / size;
    const numSwaps = Math.floor(numPoints / 2);
    for(let i = 0; i < numSwaps; ++i){
        const b1 = start + i * size;
        const b2 = start + (numPoints - 1 - i) * size;
        for(let j = 0; j < size; ++j){
            const tmp = points[b1 + j];
            points[b1 + j] = points[b2 + j];
            points[b2 + j] = tmp;
        }
    }
}
function modifyPolygonWindingDirectionPoints(points, direction, options = {}) {
    const currentDirection = getPolygonWindingDirectionPoints(points, options);
    if (currentDirection !== direction) {
        points.reverse();
        return true;
    }
    return false;
}
function getPolygonWindingDirectionPoints(points, options = {}) {
    return Math.sign(getPolygonSignedAreaPoints(points, options));
}
function getPolygonSignedAreaPoints(points, options = {}) {
    // https://en.wikipedia.org/wiki/Shoelace_formula
    const { start = 0, end = points.length, plane = 'xy' } = options;
    let area = 0;
    const i0 = DimIndex[plane[0]];
    const i1 = DimIndex[plane[1]];
    for(let i = start, j = end - 1; i < end; ++i){
        area += (points[i][i0] - points[j][i0]) * (points[i][i1] + points[j][i1]);
        j = i;
    }
    return area / 2;
}
function forEachSegmentInPolygonPoints(points, visitor, options = {}) {
    const { start = 0, end = points.length, isClosed } = options;
    for(let i = start; i < end - 1; ++i)visitor(points[i], points[i + 1], i, i + 1);
    const isClosedEx = isClosed || (0, _core.equals)(points[end - 1], points[0]);
    if (!isClosedEx) visitor(points[end - 1], points[0], end - 1, 0);
}

},{"@math.gl/core":"6z0Tv","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"20OX8":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT and ISC
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes a triangulation of a polygon
 * @param positions a flat array of the vertex positions that define the polygon.
 * @param holeIndices an array of hole indices if any (e.g. [5, 8] for a 12-vertex input would mean one hole with vertices 5–7 and another with 8–11).
 * @param dim the number of elements in each vertex. Size `2` will interpret `positions` as `[x0, y0, x1, y1, ...]` and size `3` will interpret `positions` as `[x0, y0, z0, x1, y1, z1, ...]`. Default `2`.
 * @param areas areas of outer polygon and holes as computed by `getPolygonSignedArea()`. Can be optionally supplied to speed up triangulation
 * @returns array of indices into the `positions` array that describes the triangulation of the polygon
 * Adapted from https://github.com/mapbox/earcut
 */ parcelHelpers.export(exports, "earcut", ()=>earcut);
var _polygonUtilsJs = require("./polygon-utils.js");
function earcut(positions, holeIndices, dim = 2, areas, plane = 'xy') {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : positions.length;
    let outerNode = linkedList(positions, 0, outerLen, dim, true, areas && areas[0], plane);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let invSize;
    let maxX;
    let maxY;
    let minX;
    let minY;
    let x;
    let y;
    if (hasHoles) outerNode = eliminateHoles(positions, holeIndices, outerNode, dim, areas, plane);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (positions.length > 80 * dim) {
        minX = maxX = positions[0];
        minY = maxY = positions[1];
        for(let i = dim; i < outerLen; i += dim){
            x = positions[i];
            y = positions[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise, area, plane) {
    let i;
    let last;
    if (area === undefined) area = (0, _polygonUtilsJs.getPolygonSignedArea)(data, {
        start,
        end,
        size: dim,
        plane
    });
    let i0 = (0, _polygonUtilsJs.DimIndex)[plane[0]];
    let i1 = (0, _polygonUtilsJs.DimIndex)[plane[1]];
    // Note that the signed area calculation in math.gl
    // has the opposite sign to that which was originally
    // present in earcut, thus the `< 0` is reversed
    if (clockwise === area < 0) for(i = start; i < end; i += dim)last = insertNode(i, data[i + i0], data[i + i1], last);
    else for(i = end - dim; i >= start; i -= dim)last = insertNode(i, data[i + i0], data[i + i1], last);
    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start;
    let again;
    do {
        again = false;
        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    let prev;
    let next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    const a = ear.prev;
    const b = ear;
    const c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x;
    const bx = b.x;
    const cx = c.x;
    const ay = a.y;
    const by = b.y;
    const cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx;
    const y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy;
    const x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx;
    const y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev;
    const b = ear;
    const c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x;
    const bx = b.x;
    const cx = c.x;
    const ay = a.y;
    const by = b.y;
    const cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx;
    const y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy;
    const x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx;
    const y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = zOrder(x0, y0, minX, minY, invSize);
    const maxZ = zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ;
    let n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev;
        const b = p.next.next;
        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = splitPolygon(a, b);
                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);
                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim, areas, plane) {
    const queue = [];
    let i;
    let len;
    let start;
    let end;
    let list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false, areas && areas[i + 1], plane);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }
    queue.sort(compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = eliminateHole(queue[i], outerNode);
    return outerNode;
}
function compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    const bridge = findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    let tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    let e;
    let i;
    let inSize = 1;
    let numMerges;
    let p;
    let pSize;
    let q;
    let qSize;
    let tail;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00ff00ff;
    x = (x | x << 4) & 0x0f0f0f0f;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00ff00ff;
    y = (y | y << 4) & 0x0f0f0f0f;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function getLeftmost(start) {
    let p = start;
    let leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
    (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
    (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
    equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    const o1 = sign(area(p1, q1, p2));
    const o2 = sign(area(p1, q1, q2));
    const o3 = sign(area(p2, q2, p1));
    const o4 = sign(area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    const a2 = new Vertex(a.i, a.x, a.y);
    const b2 = new Vertex(b.i, b.x, b.y);
    const an = a.next;
    const bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    const p = new Vertex(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
class Vertex {
    constructor(i, x, y){
        // previous and next vertex nodes in a polygon ring
        this.prev = null;
        this.next = null;
        // z-order curve value
        this.z = 0;
        // previous and next nodes in z-order
        this.prevZ = null;
        this.nextZ = null;
        // indicates whether this is a steiner point
        this.steiner = false;
        this.i = i;
        this.x = x;
        this.y = y;
    }
}

},{"./polygon-utils.js":"hCbKZ","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ghxic":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT and ISC
// Copyright (c) vis.gl contributors
/*
  Adapted from https://github.com/mapbox/lineclip to work with flat arrays
  and 3d positions

  ISC License

  Copyright (c) 2015, Mapbox

  Permission to use, copy, modify, and/or distribute this software for any purpose
  with or without fee is hereby granted, provided that the above copyright notice
  and this permission notice appear in all copies.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
  FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
  OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
  TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
  THIS SOFTWARE.

 */ /* eslint-disable max-statements, max-depth, complexity */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Cohen-Sutherland line clipping algorithm, adapted to efficiently
 * handle polylines rather than just segments
 */ parcelHelpers.export(exports, "clipPolyline", ()=>clipPolyline);
/**
 * Sutherland-Hodgeman polygon clipping algorithm
 * polygon must be closed (first vertex == last vertex)
 */ parcelHelpers.export(exports, "clipPolygon", ()=>clipPolygon);
/** intersect a segment against one of the 4 lines that make up the bbox */ parcelHelpers.export(exports, "intersect", ()=>intersect);
/**
 * bit code reflects the point position relative to the bbox:
 *         left  mid  right
 *    top  1001  1000  1010
 *    mid  0001  0000  0010
 * bottom  0101  0100  0110
 */ parcelHelpers.export(exports, "bitCode", ()=>bitCode);
var _utilsJs = require("./utils.js");
function clipPolyline(positions, bbox, options) {
    const { size = 2, startIndex = 0, endIndex = positions.length } = options || {};
    const numPoints = (endIndex - startIndex) / size;
    const result = [];
    let part = [];
    let a;
    let b;
    let codeA = -1;
    let codeB;
    let lastCode;
    for(let i = 1; i < numPoints; i++){
        a = (0, _utilsJs.getPointAtIndex)(positions, i - 1, size, startIndex, a);
        b = (0, _utilsJs.getPointAtIndex)(positions, i, size, startIndex, b);
        if (codeA < 0) codeA = bitCode(a, bbox);
        codeB = lastCode = bitCode(b, bbox);
        // eslint-disable-next-line no-constant-condition
        while(true){
            if (!(codeA | codeB)) {
                // accept
                (0, _utilsJs.push)(part, a);
                if (codeB !== lastCode) {
                    // segment went outside
                    (0, _utilsJs.push)(part, b);
                    if (i < numPoints - 1) {
                        // start a new line
                        result.push(part);
                        part = [];
                    }
                } else if (i === numPoints - 1) (0, _utilsJs.push)(part, b);
                break;
            } else if (codeA & codeB) break;
            else if (codeA) {
                // a outside, intersect with clip edge
                intersect(a, b, codeA, bbox, a);
                codeA = bitCode(a, bbox);
            } else {
                // b outside
                intersect(a, b, codeB, bbox, b);
                codeB = bitCode(b, bbox);
            }
        }
        codeA = lastCode;
    }
    if (part.length) result.push(part);
    return result;
}
function clipPolygon(positions, bbox, options) {
    const { size = 2, endIndex = positions.length } = options || {};
    let { startIndex = 0 } = options || {};
    let numPoints = (endIndex - startIndex) / size;
    let result;
    let p;
    let prev;
    let inside;
    let prevInside;
    // clip against each side of the clip rectangle
    for(let edge = 1; edge <= 8; edge *= 2){
        result = [];
        prev = (0, _utilsJs.getPointAtIndex)(positions, numPoints - 1, size, startIndex, prev);
        prevInside = !(bitCode(prev, bbox) & edge);
        for(let i = 0; i < numPoints; i++){
            p = (0, _utilsJs.getPointAtIndex)(positions, i, size, startIndex, p);
            inside = !(bitCode(p, bbox) & edge);
            // if segment goes through the clip window, add an intersection
            if (inside !== prevInside) (0, _utilsJs.push)(result, intersect(prev, p, edge, bbox));
            if (inside) (0, _utilsJs.push)(result, p); // add a point if it's inside
            (0, _utilsJs.copy)(prev, p);
            prevInside = inside;
        }
        // close loop
        positions = result;
        startIndex = 0;
        numPoints = result.length / size;
        if (!numPoints) break;
    }
    return result;
}
function intersect(a, b, edge, bbox, out = []) {
    let t;
    // Forces out[snapI] to be on the bbox edge
    // Interpolation introduces precision issue which may cause lineclip to be
    // stuck in an infinite loop
    let snap;
    if (edge & 8) {
        // top
        t = (bbox[3] - a[1]) / (b[1] - a[1]);
        snap = 3;
    } else if (edge & 4) {
        // bottom
        t = (bbox[1] - a[1]) / (b[1] - a[1]);
        snap = 1;
    } else if (edge & 2) {
        // right
        t = (bbox[2] - a[0]) / (b[0] - a[0]);
        snap = 2;
    } else if (edge & 1) {
        // left
        t = (bbox[0] - a[0]) / (b[0] - a[0]);
        snap = 0;
    } else return null;
    for(let i = 0; i < a.length; i++)out[i] = (snap & 1) === i ? bbox[snap] : t * (b[i] - a[i]) + a[i];
    return out;
}
function bitCode(p, bbox) {
    let code = 0;
    if (p[0] < bbox[0]) code |= 1;
    else if (p[0] > bbox[2]) code |= 2; // right
    if (p[1] < bbox[1]) code |= 4;
    else if (p[1] > bbox[3]) code |= 8; // top
    return code;
}

},{"./utils.js":"4xWUX","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4xWUX":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "push", ()=>push);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "getPointAtIndex", ()=>getPointAtIndex);
function push(target, source) {
    const size = source.length;
    const startIndex = target.length;
    // dedupe, if source is the same point as the last vertex
    if (startIndex > 0) {
        let isDuplicate = true;
        for(let i = 0; i < size; i++)if (target[startIndex - size + i] !== source[i]) {
            isDuplicate = false;
            break;
        }
        if (isDuplicate) return false;
    }
    for(let i = 0; i < size; i++)target[startIndex + i] = source[i];
    return true;
}
function copy(target, source) {
    const size = source.length;
    for(let i = 0; i < size; i++)target[i] = source[i];
}
function getPointAtIndex(positions, index, size, offset, out = []) {
    const startI = offset + index * size;
    for(let i = 0; i < size; i++)out[i] = positions[startI + i];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2E3cW":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/* eslint-disable max-statements, max-depth, complexity, no-unused-expressions */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cutPolylineByGrid", ()=>cutPolylineByGrid);
/**
 * Cuts a polygon by a pre-defined grid
 */ parcelHelpers.export(exports, "cutPolygonByGrid", ()=>cutPolygonByGrid);
var _lineclipJs = require("./lineclip.js");
var _utilsJs = require("./utils.js");
function cutPolylineByGrid(positions, options) {
    const { size = 2, broken = false, gridResolution = 10, gridOffset = [
        0,
        0
    ], startIndex = 0, endIndex = positions.length } = options || {};
    const numPoints = (endIndex - startIndex) / size;
    let part = [];
    const result = [
        part
    ];
    const a = (0, _utilsJs.getPointAtIndex)(positions, 0, size, startIndex);
    let b;
    let codeB;
    const cell = getGridCell(a, gridResolution, gridOffset, []);
    const scratchPoint = [];
    (0, _utilsJs.push)(part, a);
    for(let i = 1; i < numPoints; i++){
        b = (0, _utilsJs.getPointAtIndex)(positions, i, size, startIndex, b);
        codeB = (0, _lineclipJs.bitCode)(b, cell);
        while(codeB){
            // find the intersection with the current cell
            (0, _lineclipJs.intersect)(a, b, codeB, cell, scratchPoint);
            const codeAlt = (0, _lineclipJs.bitCode)(scratchPoint, cell);
            if (codeAlt) {
                (0, _lineclipJs.intersect)(a, scratchPoint, codeAlt, cell, scratchPoint);
                codeB = codeAlt;
            }
            (0, _utilsJs.push)(part, scratchPoint);
            // move to the next cell
            (0, _utilsJs.copy)(a, scratchPoint);
            moveToNeighborCell(cell, gridResolution, codeB);
            if (broken && part.length > size) {
                part = [];
                result.push(part);
                (0, _utilsJs.push)(part, a);
            }
            codeB = (0, _lineclipJs.bitCode)(b, cell);
        }
        (0, _utilsJs.push)(part, b);
        (0, _utilsJs.copy)(a, b);
    }
    return broken ? result : result[0];
}
const TYPE_INSIDE = 0;
const TYPE_BORDER = 1;
function cutPolygonByGrid(positions, holeIndices = null, options) {
    if (!positions.length) // input is empty
    return [];
    const { size = 2, gridResolution = 10, gridOffset = [
        0,
        0
    ], edgeTypes = false } = options || {};
    const result = [];
    const queue = [
        {
            pos: positions,
            types: edgeTypes ? new Array(positions.length / size).fill(TYPE_BORDER) : null,
            holes: holeIndices || []
        }
    ];
    const bbox = [
        [],
        []
    ];
    // @ts-ignore
    let cell = [];
    // Recursively bisect polygon until every part fit in a single grid cell
    while(queue.length){
        const { pos, types, holes } = queue.shift();
        // Get the bounding box of the outer polygon
        getBoundingBox(pos, size, holes[0] || pos.length, bbox);
        cell = getGridCell(bbox[0], gridResolution, gridOffset, cell);
        const code = (0, _lineclipJs.bitCode)(bbox[1], cell);
        if (code) {
            // Split the outer ring at the boundary
            let parts = bisectPolygon(pos, types, size, 0, holes[0] || pos.length, cell, code);
            const polygonLow = {
                pos: parts[0].pos,
                types: parts[0].types,
                holes: []
            };
            const polygonHigh = {
                pos: parts[1].pos,
                types: parts[1].types,
                holes: []
            };
            queue.push(polygonLow, polygonHigh);
            // Split each hole at the boundary
            for(let i = 0; i < holes.length; i++){
                parts = bisectPolygon(pos, types, size, holes[i], holes[i + 1] || pos.length, cell, code);
                if (parts[0]) {
                    polygonLow.holes.push(polygonLow.pos.length);
                    polygonLow.pos = concatInPlace(polygonLow.pos, parts[0].pos);
                    if (edgeTypes) polygonLow.types = concatInPlace(polygonLow.types, parts[0].types);
                }
                if (parts[1]) {
                    polygonHigh.holes.push(polygonHigh.pos.length);
                    polygonHigh.pos = concatInPlace(polygonHigh.pos, parts[1].pos);
                    if (edgeTypes) polygonHigh.types = concatInPlace(polygonHigh.types, parts[1].types);
                }
            }
        } else {
            // Polygon fits in a single cell, no more processing required
            const polygon = {
                positions: pos
            };
            if (edgeTypes) polygon.edgeTypes = types;
            if (holes.length) polygon.holeIndices = holes;
            result.push(polygon);
        }
    }
    return result;
}
// edgeTypes:
// TYPE_BORDER - edge from the original polygon
// TYPE_INSIDE - inside the original polygon
// eslint-disable-next-line max-params
function bisectPolygon(positions, edgeTypes, size, startIndex, endIndex, bbox, edge) {
    const numPoints = (endIndex - startIndex) / size;
    const resultLow = [];
    const resultHigh = [];
    const typesLow = [];
    const typesHigh = [];
    const scratchPoint = [];
    let p;
    let side;
    let type;
    const prev = (0, _utilsJs.getPointAtIndex)(positions, numPoints - 1, size, startIndex);
    let prevSide = Math.sign(edge & 8 ? prev[1] - bbox[3] : prev[0] - bbox[2]);
    let prevType = edgeTypes && edgeTypes[numPoints - 1];
    let lowPointCount = 0;
    let highPointCount = 0;
    for(let i = 0; i < numPoints; i++){
        p = (0, _utilsJs.getPointAtIndex)(positions, i, size, startIndex, p);
        side = Math.sign(edge & 8 ? p[1] - bbox[3] : p[0] - bbox[2]);
        type = edgeTypes && edgeTypes[startIndex / size + i];
        // if segment goes through the boundary, add an intersection
        if (side && prevSide && prevSide !== side) {
            (0, _lineclipJs.intersect)(prev, p, edge, bbox, scratchPoint);
            (0, _utilsJs.push)(resultLow, scratchPoint) && typesLow.push(prevType);
            (0, _utilsJs.push)(resultHigh, scratchPoint) && typesHigh.push(prevType);
        }
        if (side <= 0) {
            (0, _utilsJs.push)(resultLow, p) && typesLow.push(type);
            lowPointCount -= side;
        } else if (typesLow.length) typesLow[typesLow.length - 1] = TYPE_INSIDE;
        if (side >= 0) {
            (0, _utilsJs.push)(resultHigh, p) && typesHigh.push(type);
            highPointCount += side;
        } else if (typesHigh.length) typesHigh[typesHigh.length - 1] = TYPE_INSIDE;
        (0, _utilsJs.copy)(prev, p);
        prevSide = side;
        prevType = type;
    }
    return [
        lowPointCount ? {
            pos: resultLow,
            types: edgeTypes && typesLow
        } : null,
        highPointCount ? {
            pos: resultHigh,
            types: edgeTypes && typesHigh
        } : null
    ];
}
function getGridCell(p, gridResolution, gridOffset, out) {
    const left = Math.floor((p[0] - gridOffset[0]) / gridResolution) * gridResolution + gridOffset[0];
    const bottom = Math.floor((p[1] - gridOffset[1]) / gridResolution) * gridResolution + gridOffset[1];
    out[0] = left;
    out[1] = bottom;
    out[2] = left + gridResolution;
    out[3] = bottom + gridResolution;
    return out;
}
function moveToNeighborCell(cell, gridResolution, edge) {
    if (edge & 8) {
        // top
        cell[1] += gridResolution;
        cell[3] += gridResolution;
    } else if (edge & 4) {
        // bottom
        cell[1] -= gridResolution;
        cell[3] -= gridResolution;
    } else if (edge & 2) {
        // right
        cell[0] += gridResolution;
        cell[2] += gridResolution;
    } else if (edge & 1) {
        // left
        cell[0] -= gridResolution;
        cell[2] -= gridResolution;
    }
}
function getBoundingBox(positions, size, endIndex, out) {
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for(let i = 0; i < endIndex; i += size){
        const x = positions[i];
        const y = positions[i + 1];
        minX = x < minX ? x : minX;
        maxX = x > maxX ? x : maxX;
        minY = y < minY ? y : minY;
        maxY = y > maxY ? y : maxY;
    }
    out[0][0] = minX;
    out[0][1] = minY;
    out[1][0] = maxX;
    out[1][1] = maxY;
    return out;
}
function concatInPlace(arr1, arr2) {
    for(let i = 0; i < arr2.length; i++)arr1.push(arr2[i]);
    return arr1;
}

},{"./lineclip.js":"ghxic","./utils.js":"4xWUX","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"asuWN":[function(require,module,exports,__globalThis) {
// math.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** https://user-images.githubusercontent.com/2059298/78465769-938b7a00-76ae-11ea-9b95-1f4c26425ab9.png */ parcelHelpers.export(exports, "cutPolylineByMercatorBounds", ()=>cutPolylineByMercatorBounds);
/** https://user-images.githubusercontent.com/2059298/78465770-94241080-76ae-11ea-809a-6a8534dac1d9.png */ parcelHelpers.export(exports, "cutPolygonByMercatorBounds", ()=>cutPolygonByMercatorBounds);
var _cutByGridJs = require("./cut-by-grid.js");
var _utilsJs = require("./utils.js");
// https://en.wikipedia.org/wiki/Web_Mercator_projection
const DEFAULT_MAX_LATITUDE = 85.051129;
function cutPolylineByMercatorBounds(positions, options) {
    const { size = 2, startIndex = 0, endIndex = positions.length, normalize = true } = options || {};
    // Remap longitudes so that each segment takes the shorter path
    const newPositions = positions.slice(startIndex, endIndex);
    wrapLongitudesForShortestPath(newPositions, size, 0, endIndex - startIndex);
    const parts = (0, _cutByGridJs.cutPolylineByGrid)(newPositions, {
        size,
        broken: true,
        gridResolution: 360,
        gridOffset: [
            -180,
            -180
        ]
    });
    if (normalize) // Each part is guaranteed to be in a single copy of the world
    // Map longitudes back to [-180, 180]
    for (const part of parts)shiftLongitudesIntoRange(part, size);
    return parts;
}
function cutPolygonByMercatorBounds(positions, holeIndices = null, options) {
    const { size = 2, normalize = true, edgeTypes = false } = options || {};
    holeIndices = holeIndices || [];
    const newPositions = [];
    const newHoleIndices = [];
    let srcStartIndex = 0;
    let targetIndex = 0;
    for(let ringIndex = 0; ringIndex <= holeIndices.length; ringIndex++){
        // srcStartIndex/srcEndIndex define the ring in the original positions
        const srcEndIndex = holeIndices[ringIndex] || positions.length;
        // targetStartIndex/targetIndex define the ring in newPositions
        const targetStartIndex = targetIndex;
        // In case the ring contains a pole (e.g. Antarctica), we'll have to insert vertices
        // The insertion point is defined by the vertex closest to the pole
        // Split the the ring by the insertion point when copying to newPositions
        const splitIndex = findSplitIndex(positions, size, srcStartIndex, srcEndIndex);
        for(let i = splitIndex; i < srcEndIndex; i++)newPositions[targetIndex++] = positions[i];
        for(let i = srcStartIndex; i < splitIndex; i++)newPositions[targetIndex++] = positions[i];
        // Remap longitudes so that each segment takes the shorter path
        wrapLongitudesForShortestPath(newPositions, size, targetStartIndex, targetIndex);
        // Handle the case when the ring contains a pole
        insertPoleVertices(newPositions, size, targetStartIndex, targetIndex, options?.maxLatitude);
        srcStartIndex = srcEndIndex;
        newHoleIndices[ringIndex] = targetIndex;
    }
    newHoleIndices.pop();
    const parts = (0, _cutByGridJs.cutPolygonByGrid)(newPositions, newHoleIndices, {
        size,
        gridResolution: 360,
        gridOffset: [
            -180,
            -180
        ],
        edgeTypes
    });
    if (normalize) // Each part is guaranteed to be in a single copy of the world
    // Map longitudes back to [-180, 180]
    for (const part of parts)// @ts-expect-error (mutates readonly array) May mutate newPositions, which is created by us
    shiftLongitudesIntoRange(part.positions, size);
    return parts;
}
/* Helpers */ // See comments for insertPoleVertices
function findSplitIndex(positions, size, startIndex, endIndex) {
    let maxLat = -1;
    let pointIndex = -1;
    for(let i = startIndex + 1; i < endIndex; i += size){
        const lat = Math.abs(positions[i]);
        if (lat > maxLat) {
            maxLat = lat;
            pointIndex = i - 1;
        }
    }
    return pointIndex;
}
// https://user-images.githubusercontent.com/2059298/78857483-5987e400-79de-11ea-98fc-0631287a8431.png
//
// If the polygon contains a pole, to tesselate it correctly, we need to insert the edge
// of map into the polygon. This requires adding two vertices that represent the pole, by
// drawing a perpendicular line to the Mercator map edge from a selected vertex on the ring.
//
// We select the insertion position carefully so that the inserted line segments do not
// intersect with the ring itself. This is ensured by findSplitIndex, which returns the
// vertex closest to the pole.
function insertPoleVertices(positions, size, startIndex, endIndex, maxLatitude = DEFAULT_MAX_LATITUDE) {
    // Check if the ring contains a pole
    const firstLng = positions[startIndex];
    const lastLng = positions[endIndex - size];
    if (Math.abs(firstLng - lastLng) > 180) {
        // The ring does not make a round trip
        // Add the nearest pole to the vertices so that the polygon tesselates correctly
        const p = (0, _utilsJs.getPointAtIndex)(positions, 0, size, startIndex);
        // Copy the first vertex to the world of the last vertex
        p[0] += Math.round((lastLng - firstLng) / 360) * 360;
        (0, _utilsJs.push)(positions, p);
        // Project the copied vertex to the edge of the map
        p[1] = Math.sign(p[1]) * maxLatitude;
        (0, _utilsJs.push)(positions, p);
        // Project the first vertex to the edge of the map
        p[0] = firstLng;
        (0, _utilsJs.push)(positions, p);
    }
}
function wrapLongitudesForShortestPath(positions, size, startIndex, endIndex) {
    let prevLng = positions[0];
    let lng;
    for(let i = startIndex; i < endIndex; i += size){
        lng = positions[i];
        const delta = lng - prevLng;
        if (delta > 180 || delta < -180) lng -= Math.round(delta / 360) * 360;
        positions[i] = prevLng = lng;
    }
}
function shiftLongitudesIntoRange(positions, size) {
    let refLng;
    const pointCount = positions.length / size;
    // Find a longitude that is not on the edge of a world
    // Which we will use to determine which world copy it is
    for(let i = 0; i < pointCount; i++){
        refLng = positions[i * size];
        if ((refLng + 180) % 360 !== 0) break;
    }
    const delta = -Math.round(refLng / 360) * 360;
    if (delta === 0) return;
    for(let i = 0; i < pointCount; i++)positions[i * size] += delta;
}

},{"./cut-by-grid.js":"2E3cW","./utils.js":"4xWUX","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"dK2uZ":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "solidPolygonUniforms", ()=>solidPolygonUniforms);
const uniformBlock = `\
uniform solidPolygonUniforms {
  bool extruded;
  bool isWireframe;
  float elevationScale;
} solidPolygon;
`;
const solidPolygonUniforms = {
    name: 'solidPolygon',
    vs: uniformBlock,
    fs: uniformBlock,
    uniformTypes: {
        extruded: 'f32',
        isWireframe: 'f32',
        elevationScale: 'f32'
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5ONDQ":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _solidPolygonLayerVertexMainGlslJs = require("./solid-polygon-layer-vertex-main.glsl.js");
var _solidPolygonLayerVertexMainGlslJsDefault = parcelHelpers.interopDefault(_solidPolygonLayerVertexMainGlslJs);
exports.default = `\
#version 300 es
#define SHADER_NAME solid-polygon-layer-vertex-shader
in vec3 vertexPositions;
in vec3 vertexPositions64Low;
in float elevations;
${0, _solidPolygonLayerVertexMainGlslJsDefault.default}
void main(void) {
PolygonProps props;
props.positions = vertexPositions;
props.positions64Low = vertexPositions64Low;
props.elevations = elevations;
props.normal = vec3(0.0, 0.0, 1.0);
calculatePosition(props);
}
`;

},{"./solid-polygon-layer-vertex-main.glsl.js":"f8IPF","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"f8IPF":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = `\
in vec4 fillColors;
in vec4 lineColors;
in vec3 pickingColors;
out vec4 vColor;
struct PolygonProps {
vec3 positions;
vec3 positions64Low;
vec3 normal;
float elevations;
};
vec3 project_offset_normal(vec3 vector) {
if (project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT ||
project.coordinateSystem == COORDINATE_SYSTEM_LNGLAT_OFFSETS) {
return normalize(vector * project.commonUnitsPerWorldUnit);
}
return project_normal(vector);
}
void calculatePosition(PolygonProps props) {
vec3 pos = props.positions;
vec3 pos64Low = props.positions64Low;
vec3 normal = props.normal;
vec4 colors = solidPolygon.isWireframe ? lineColors : fillColors;
geometry.worldPosition = props.positions;
geometry.pickingColor = pickingColors;
if (solidPolygon.extruded) {
pos.z += props.elevations * solidPolygon.elevationScale;
}
gl_Position = project_position_to_clipspace(pos, pos64Low, vec3(0.), geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
if (solidPolygon.extruded) {
#ifdef IS_SIDE_VERTEX
normal = project_offset_normal(normal);
#else
normal = project_normal(normal);
#endif
geometry.normal = normal;
vec3 lightColor = lighting_getLightColor(colors.rgb, project.cameraPosition, geometry.position.xyz, geometry.normal);
vColor = vec4(lightColor, colors.a * layer.opacity);
} else {
vColor = vec4(colors.rgb, colors.a * layer.opacity);
}
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"iuE2c":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _solidPolygonLayerVertexMainGlslJs = require("./solid-polygon-layer-vertex-main.glsl.js");
var _solidPolygonLayerVertexMainGlslJsDefault = parcelHelpers.interopDefault(_solidPolygonLayerVertexMainGlslJs);
exports.default = `\
#version 300 es
#define SHADER_NAME solid-polygon-layer-vertex-shader-side
#define IS_SIDE_VERTEX
in vec2 positions;
in vec3 vertexPositions;
in vec3 nextVertexPositions;
in vec3 vertexPositions64Low;
in vec3 nextVertexPositions64Low;
in float elevations;
in float instanceVertexValid;
${0, _solidPolygonLayerVertexMainGlslJsDefault.default}
void main(void) {
if(instanceVertexValid < 0.5){
gl_Position = vec4(0.);
return;
}
PolygonProps props;
vec3 pos;
vec3 pos64Low;
vec3 nextPos;
vec3 nextPos64Low;
#if RING_WINDING_ORDER_CW == 1
pos = vertexPositions;
pos64Low = vertexPositions64Low;
nextPos = nextVertexPositions;
nextPos64Low = nextVertexPositions64Low;
#else
pos = nextVertexPositions;
pos64Low = nextVertexPositions64Low;
nextPos = vertexPositions;
nextPos64Low = vertexPositions64Low;
#endif
props.positions = mix(pos, nextPos, positions.x);
props.positions64Low = mix(pos64Low, nextPos64Low, positions.x);
props.normal = vec3(
pos.y - nextPos.y + (pos64Low.y - nextPos64Low.y),
nextPos.x - pos.x + (nextPos64Low.x - pos64Low.x),
0.0);
props.elevations = elevations * positions.y;
calculatePosition(props);
}
`;

},{"./solid-polygon-layer-vertex-main.glsl.js":"f8IPF","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"juvSW":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = `\
#version 300 es
#define SHADER_NAME solid-polygon-layer-fragment-shader
precision highp float;
in vec4 vColor;
out vec4 fragColor;
void main(void) {
fragColor = vColor;
geometry.uv = vec2(0.);
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ePgCZ":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@deck.gl/core");
var _engine = require("@luma.gl/engine");
var _pathTesselatorJs = require("./path-tesselator.js");
var _pathTesselatorJsDefault = parcelHelpers.interopDefault(_pathTesselatorJs);
var _pathLayerUniformsJs = require("./path-layer-uniforms.js");
var _pathLayerVertexGlslJs = require("./path-layer-vertex.glsl.js");
var _pathLayerVertexGlslJsDefault = parcelHelpers.interopDefault(_pathLayerVertexGlslJs);
var _pathLayerFragmentGlslJs = require("./path-layer-fragment.glsl.js");
var _pathLayerFragmentGlslJsDefault = parcelHelpers.interopDefault(_pathLayerFragmentGlslJs);
const DEFAULT_COLOR = [
    0,
    0,
    0,
    255
];
const defaultProps = {
    widthUnits: 'meters',
    widthScale: {
        type: 'number',
        min: 0,
        value: 1
    },
    widthMinPixels: {
        type: 'number',
        min: 0,
        value: 0
    },
    widthMaxPixels: {
        type: 'number',
        min: 0,
        value: Number.MAX_SAFE_INTEGER
    },
    jointRounded: false,
    capRounded: false,
    miterLimit: {
        type: 'number',
        min: 0,
        value: 4
    },
    billboard: false,
    _pathType: null,
    getPath: {
        type: 'accessor',
        value: (object)=>object.path
    },
    getColor: {
        type: 'accessor',
        value: DEFAULT_COLOR
    },
    getWidth: {
        type: 'accessor',
        value: 1
    },
    // deprecated props
    rounded: {
        deprecatedFor: [
            'jointRounded',
            'capRounded'
        ]
    }
};
const ATTRIBUTE_TRANSITION = {
    enter: (value, chunk)=>{
        return chunk.length ? chunk.subarray(chunk.length - value.length) : value;
    }
};
/** Render lists of coordinate points as extruded polylines with mitering. */ class PathLayer extends (0, _core.Layer) {
    getShaders() {
        return super.getShaders({
            vs: (0, _pathLayerVertexGlslJsDefault.default),
            fs: (0, _pathLayerFragmentGlslJsDefault.default),
            modules: [
                (0, _core.project32),
                (0, _core.picking),
                (0, _pathLayerUniformsJs.pathUniforms)
            ]
        }); // 'project' module added by default.
    }
    get wrapLongitude() {
        return false;
    }
    getBounds() {
        return this.getAttributeManager()?.getBounds([
            'vertexPositions'
        ]);
    }
    initializeState() {
        const noAlloc = true;
        const attributeManager = this.getAttributeManager();
        /* eslint-disable max-len */ attributeManager.addInstanced({
            vertexPositions: {
                size: 3,
                // Start filling buffer from 1 vertex in
                vertexOffset: 1,
                type: 'float64',
                fp64: this.use64bitPositions(),
                transition: ATTRIBUTE_TRANSITION,
                accessor: 'getPath',
                // eslint-disable-next-line @typescript-eslint/unbound-method
                update: this.calculatePositions,
                noAlloc,
                shaderAttributes: {
                    instanceLeftPositions: {
                        vertexOffset: 0
                    },
                    instanceStartPositions: {
                        vertexOffset: 1
                    },
                    instanceEndPositions: {
                        vertexOffset: 2
                    },
                    instanceRightPositions: {
                        vertexOffset: 3
                    }
                }
            },
            instanceTypes: {
                size: 1,
                type: 'uint8',
                // eslint-disable-next-line @typescript-eslint/unbound-method
                update: this.calculateSegmentTypes,
                noAlloc
            },
            instanceStrokeWidths: {
                size: 1,
                accessor: 'getWidth',
                transition: ATTRIBUTE_TRANSITION,
                defaultValue: 1
            },
            instanceColors: {
                size: this.props.colorFormat.length,
                type: 'unorm8',
                accessor: 'getColor',
                transition: ATTRIBUTE_TRANSITION,
                defaultValue: DEFAULT_COLOR
            },
            instancePickingColors: {
                size: 4,
                type: 'uint8',
                accessor: (object, { index, target: value })=>this.encodePickingColor(object && object.__source ? object.__source.index : index, value)
            }
        });
        /* eslint-enable max-len */ this.setState({
            pathTesselator: new (0, _pathTesselatorJsDefault.default)({
                fp64: this.use64bitPositions()
            })
        });
    }
    updateState(params) {
        super.updateState(params);
        const { props, changeFlags } = params;
        const attributeManager = this.getAttributeManager();
        const geometryChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPath);
        if (geometryChanged) {
            const { pathTesselator } = this.state;
            const buffers = props.data.attributes || {};
            pathTesselator.updateGeometry({
                data: props.data,
                geometryBuffer: buffers.getPath,
                buffers,
                normalize: !props._pathType,
                loop: props._pathType === 'loop',
                getGeometry: props.getPath,
                positionFormat: props.positionFormat,
                wrapLongitude: props.wrapLongitude,
                // TODO - move the flag out of the viewport
                resolution: this.context.viewport.resolution,
                dataChanged: changeFlags.dataChanged
            });
            this.setState({
                numInstances: pathTesselator.instanceCount,
                startIndices: pathTesselator.vertexStarts
            });
            if (!changeFlags.dataChanged) // Base `layer.updateState` only invalidates all attributes on data change
            // Cover the rest of the scenarios here
            attributeManager.invalidateAll();
        }
        if (changeFlags.extensionsChanged) {
            this.state.model?.destroy();
            this.state.model = this._getModel();
            attributeManager.invalidateAll();
        }
    }
    getPickingInfo(params) {
        const info = super.getPickingInfo(params);
        const { index } = info;
        const data = this.props.data;
        // Check if data comes from a composite layer, wrapped with getSubLayerRow
        if (data[0] && data[0].__source) // index decoded from picking color refers to the source index
        info.object = data.find((d)=>d.__source.index === index);
        return info;
    }
    /** Override base Layer method */ disablePickingIndex(objectIndex) {
        const data = this.props.data;
        // Check if data comes from a composite layer, wrapped with getSubLayerRow
        if (data[0] && data[0].__source) {
            // index decoded from picking color refers to the source index
            for(let i = 0; i < data.length; i++)if (data[i].__source.index === objectIndex) this._disablePickingIndex(i);
        } else super.disablePickingIndex(objectIndex);
    }
    draw({ uniforms }) {
        const { jointRounded, capRounded, billboard, miterLimit, widthUnits, widthScale, widthMinPixels, widthMaxPixels } = this.props;
        const model = this.state.model;
        const pathProps = {
            jointType: Number(jointRounded),
            capType: Number(capRounded),
            billboard,
            widthUnits: (0, _core.UNIT)[widthUnits],
            widthScale,
            miterLimit,
            widthMinPixels,
            widthMaxPixels
        };
        model.shaderInputs.setProps({
            path: pathProps
        });
        model.draw(this.context.renderPass);
    }
    _getModel() {
        /*
         *       _
         *        "-_ 1                   3                       5
         *     _     "o---------------------o-------------------_-o
         *       -   / ""--..__              '.             _.-' /
         *   _     "@- - - - - ""--..__- - - - x - - - -_.@'    /
         *    "-_  /                   ""--..__ '.  _,-` :     /
         *       "o----------------------------""-o'    :     /
         *      0,2                            4 / '.  :     /
         *                                      /   '.:     /
         *                                     /     :'.   /
         *                                    /     :  ', /
         *                                   /     :     o
         */ // prettier-ignore
        const SEGMENT_INDICES = [
            // start corner
            0,
            1,
            2,
            // body
            1,
            4,
            2,
            1,
            3,
            4,
            // end corner
            3,
            5,
            4
        ];
        // [0] position on segment - 0: start, 1: end
        // [1] side of path - -1: left, 0: center (joint), 1: right
        // prettier-ignore
        const SEGMENT_POSITIONS = [
            // bevel start corner
            0,
            0,
            // start inner corner
            0,
            -1,
            // start outer corner
            0,
            1,
            // end inner corner
            1,
            -1,
            // end outer corner
            1,
            1,
            // bevel end corner
            1,
            0
        ];
        return new (0, _engine.Model)(this.context.device, {
            ...this.getShaders(),
            id: this.props.id,
            bufferLayout: this.getAttributeManager().getBufferLayouts(),
            geometry: new (0, _engine.Geometry)({
                topology: 'triangle-list',
                attributes: {
                    indices: new Uint16Array(SEGMENT_INDICES),
                    positions: {
                        value: new Float32Array(SEGMENT_POSITIONS),
                        size: 2
                    }
                }
            }),
            isInstanced: true
        });
    }
    calculatePositions(attribute) {
        const { pathTesselator } = this.state;
        attribute.startIndices = pathTesselator.vertexStarts;
        attribute.value = pathTesselator.get('positions');
    }
    calculateSegmentTypes(attribute) {
        const { pathTesselator } = this.state;
        attribute.startIndices = pathTesselator.vertexStarts;
        attribute.value = pathTesselator.get('segmentTypes');
    }
}
PathLayer.defaultProps = defaultProps;
PathLayer.layerName = 'PathLayer';
exports.default = PathLayer;

},{"@deck.gl/core":"grwzR","@luma.gl/engine":"joT4s","./path-tesselator.js":"1o5bs","./path-layer-uniforms.js":"4azq4","./path-layer-vertex.glsl.js":"gIPko","./path-layer-fragment.glsl.js":"7g5ni","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1o5bs":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@deck.gl/core");
var _pathJs = require("./path.js");
const START_CAP = 1;
const END_CAP = 2;
const INVALID = 4;
class PathTesselator extends (0, _core.Tesselator) {
    constructor(opts){
        super({
            ...opts,
            attributes: {
                // Padding covers shaderAttributes for last segment in largest case fp64
                // additional vertex + hi & low parts, 3 * 6
                positions: {
                    size: 3,
                    padding: 18,
                    initialize: true,
                    type: opts.fp64 ? Float64Array : Float32Array
                },
                segmentTypes: {
                    size: 1,
                    type: Uint8ClampedArray
                }
            }
        });
    }
    /** Get packed attribute by name */ get(attributeName) {
        return this.attributes[attributeName];
    }
    /* Implement base Tesselator interface */ getGeometryFromBuffer(buffer) {
        if (this.normalize) return super.getGeometryFromBuffer(buffer);
        // we don't need to read the positions if no normalization
        return null;
    }
    /* Implement base Tesselator interface */ normalizeGeometry(path) {
        if (this.normalize) return (0, _pathJs.normalizePath)(path, this.positionSize, this.opts.resolution, this.opts.wrapLongitude);
        return path;
    }
    /* Implement base Tesselator interface */ getGeometrySize(path) {
        if (isCut(path)) {
            let size = 0;
            for (const subPath of path)size += this.getGeometrySize(subPath);
            return size;
        }
        const numPoints = this.getPathLength(path);
        if (numPoints < 2) // invalid path
        return 0;
        if (this.isClosed(path)) // minimum 3 vertices
        return numPoints < 3 ? 0 : numPoints + 2;
        return numPoints;
    }
    /* Implement base Tesselator interface */ updateGeometryAttributes(path, context) {
        if (context.geometrySize === 0) return;
        if (path && isCut(path)) for (const subPath of path){
            const geometrySize = this.getGeometrySize(subPath);
            context.geometrySize = geometrySize;
            this.updateGeometryAttributes(subPath, context);
            context.vertexStart += geometrySize;
        }
        else {
            this._updateSegmentTypes(path, context);
            this._updatePositions(path, context);
        }
    }
    _updateSegmentTypes(path, context) {
        const segmentTypes = this.attributes.segmentTypes;
        const isPathClosed = path ? this.isClosed(path) : false;
        const { vertexStart, geometrySize } = context;
        // positions   --  A0 A1 B0 B1 B2 B3 B0 B1 B2 --
        // segmentTypes     3  4  4  0  0  0  0  4  4
        segmentTypes.fill(0, vertexStart, vertexStart + geometrySize);
        if (isPathClosed) {
            segmentTypes[vertexStart] = INVALID;
            segmentTypes[vertexStart + geometrySize - 2] = INVALID;
        } else {
            segmentTypes[vertexStart] += START_CAP;
            segmentTypes[vertexStart + geometrySize - 2] += END_CAP;
        }
        segmentTypes[vertexStart + geometrySize - 1] = INVALID;
    }
    _updatePositions(path, context) {
        const { positions } = this.attributes;
        if (!positions || !path) return;
        const { vertexStart, geometrySize } = context;
        const p = new Array(3);
        // positions   --  A0 A1 B0 B1 B2 B3 B0 B1 B2 --
        // segmentTypes     3  4  4  0  0  0  0  4  4
        for(let i = vertexStart, ptIndex = 0; ptIndex < geometrySize; i++, ptIndex++){
            this.getPointOnPath(path, ptIndex, p);
            positions[i * 3] = p[0];
            positions[i * 3 + 1] = p[1];
            positions[i * 3 + 2] = p[2];
        }
    }
    // Utilities
    /** Returns the number of points in the path */ getPathLength(path) {
        return path.length / this.positionSize;
    }
    /** Returns a point on the path at the specified index */ getPointOnPath(path, index, target = []) {
        const { positionSize } = this;
        if (index * positionSize >= path.length) // loop
        index += 1 - path.length / positionSize;
        const i = index * positionSize;
        target[0] = path[i];
        target[1] = path[i + 1];
        target[2] = positionSize === 3 && path[i + 2] || 0;
        return target;
    }
    // Returns true if the first and last points are identical
    isClosed(path) {
        if (!this.normalize) return Boolean(this.opts.loop);
        const { positionSize } = this;
        const lastPointIndex = path.length - positionSize;
        return path[0] === path[lastPointIndex] && path[1] === path[lastPointIndex + 1] && (positionSize === 2 || path[2] === path[lastPointIndex + 2]);
    }
}
exports.default = PathTesselator;
function isCut(path) {
    return Array.isArray(path[0]);
}

},{"@deck.gl/core":"grwzR","./path.js":"9cNxm","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9cNxm":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Flattens a nested path object
 * Cut the feature if needed (globe projection, wrap longitude, etc.)
 * Returns a flat array of path positions, or a list of flat arrays representing multiple paths
 */ parcelHelpers.export(exports, "normalizePath", ()=>normalizePath);
var _polygon = require("@math.gl/polygon");
function normalizePath(path, size, gridResolution, wrapLongitude) {
    let flatPath;
    if (Array.isArray(path[0])) {
        const length = path.length * size;
        flatPath = new Array(length);
        for(let i = 0; i < path.length; i++)for(let j = 0; j < size; j++)flatPath[i * size + j] = path[i][j] || 0;
    } else flatPath = path;
    if (gridResolution) return (0, _polygon.cutPolylineByGrid)(flatPath, {
        size,
        gridResolution
    });
    if (wrapLongitude) return (0, _polygon.cutPolylineByMercatorBounds)(flatPath, {
        size
    });
    return flatPath;
}

},{"@math.gl/polygon":"9Lj7P","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4azq4":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pathUniforms", ()=>pathUniforms);
const uniformBlock = `\
uniform pathUniforms {
  float widthScale;
  float widthMinPixels;
  float widthMaxPixels;
  float jointType;
  float capType;
  float miterLimit;
  bool billboard;
  highp int widthUnits;
} path;
`;
const pathUniforms = {
    name: 'path',
    vs: uniformBlock,
    fs: uniformBlock,
    uniformTypes: {
        widthScale: 'f32',
        widthMinPixels: 'f32',
        widthMaxPixels: 'f32',
        jointType: 'f32',
        capType: 'f32',
        miterLimit: 'f32',
        billboard: 'f32',
        widthUnits: 'i32'
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"gIPko":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = `\
#version 300 es
#define SHADER_NAME path-layer-vertex-shader
in vec2 positions;
in float instanceTypes;
in vec3 instanceStartPositions;
in vec3 instanceEndPositions;
in vec3 instanceLeftPositions;
in vec3 instanceRightPositions;
in vec3 instanceLeftPositions64Low;
in vec3 instanceStartPositions64Low;
in vec3 instanceEndPositions64Low;
in vec3 instanceRightPositions64Low;
in float instanceStrokeWidths;
in vec4 instanceColors;
in vec3 instancePickingColors;
uniform float opacity;
out vec4 vColor;
out vec2 vCornerOffset;
out float vMiterLength;
out vec2 vPathPosition;
out float vPathLength;
out float vJointType;
const float EPSILON = 0.001;
const vec3 ZERO_OFFSET = vec3(0.0);
float flipIfTrue(bool flag) {
return -(float(flag) * 2. - 1.);
}
vec3 getLineJoinOffset(
vec3 prevPoint, vec3 currPoint, vec3 nextPoint,
vec2 width
) {
bool isEnd = positions.x > 0.0;
float sideOfPath = positions.y;
float isJoint = float(sideOfPath == 0.0);
vec3 deltaA3 = (currPoint - prevPoint);
vec3 deltaB3 = (nextPoint - currPoint);
mat3 rotationMatrix;
bool needsRotation = !path.billboard && project_needs_rotation(currPoint, rotationMatrix);
if (needsRotation) {
deltaA3 = deltaA3 * rotationMatrix;
deltaB3 = deltaB3 * rotationMatrix;
}
vec2 deltaA = deltaA3.xy / width;
vec2 deltaB = deltaB3.xy / width;
float lenA = length(deltaA);
float lenB = length(deltaB);
vec2 dirA = lenA > 0. ? normalize(deltaA) : vec2(0.0, 0.0);
vec2 dirB = lenB > 0. ? normalize(deltaB) : vec2(0.0, 0.0);
vec2 perpA = vec2(-dirA.y, dirA.x);
vec2 perpB = vec2(-dirB.y, dirB.x);
vec2 tangent = dirA + dirB;
tangent = length(tangent) > 0. ? normalize(tangent) : perpA;
vec2 miterVec = vec2(-tangent.y, tangent.x);
vec2 dir = isEnd ? dirA : dirB;
vec2 perp = isEnd ? perpA : perpB;
float L = isEnd ? lenA : lenB;
float sinHalfA = abs(dot(miterVec, perp));
float cosHalfA = abs(dot(dirA, miterVec));
float turnDirection = flipIfTrue(dirA.x * dirB.y >= dirA.y * dirB.x);
float cornerPosition = sideOfPath * turnDirection;
float miterSize = 1.0 / max(sinHalfA, EPSILON);
miterSize = mix(
min(miterSize, max(lenA, lenB) / max(cosHalfA, EPSILON)),
miterSize,
step(0.0, cornerPosition)
);
vec2 offsetVec = mix(miterVec * miterSize, perp, step(0.5, cornerPosition))
* (sideOfPath + isJoint * turnDirection);
bool isStartCap = lenA == 0.0 || (!isEnd && (instanceTypes == 1.0 || instanceTypes == 3.0));
bool isEndCap = lenB == 0.0 || (isEnd && (instanceTypes == 2.0 || instanceTypes == 3.0));
bool isCap = isStartCap || isEndCap;
if (isCap) {
offsetVec = mix(perp * sideOfPath, dir * path.capType * 4.0 * flipIfTrue(isStartCap), isJoint);
vJointType = path.capType;
} else {
vJointType = path.jointType;
}
vPathLength = L;
vCornerOffset = offsetVec;
vMiterLength = dot(vCornerOffset, miterVec * turnDirection);
vMiterLength = isCap ? isJoint : vMiterLength;
vec2 offsetFromStartOfPath = vCornerOffset + deltaA * float(isEnd);
vPathPosition = vec2(
dot(offsetFromStartOfPath, perp),
dot(offsetFromStartOfPath, dir)
);
geometry.uv = vPathPosition;
float isValid = step(instanceTypes, 3.5);
vec3 offset = vec3(offsetVec * width * isValid, 0.0);
if (needsRotation) {
offset = rotationMatrix * offset;
}
return offset;
}
void clipLine(inout vec4 position, vec4 refPosition) {
if (position.w < EPSILON) {
float r = (EPSILON - refPosition.w) / (position.w - refPosition.w);
position = refPosition + (position - refPosition) * r;
}
}
void main() {
geometry.pickingColor = instancePickingColors;
vColor = vec4(instanceColors.rgb, instanceColors.a * layer.opacity);
float isEnd = positions.x;
vec3 prevPosition = mix(instanceLeftPositions, instanceStartPositions, isEnd);
vec3 prevPosition64Low = mix(instanceLeftPositions64Low, instanceStartPositions64Low, isEnd);
vec3 currPosition = mix(instanceStartPositions, instanceEndPositions, isEnd);
vec3 currPosition64Low = mix(instanceStartPositions64Low, instanceEndPositions64Low, isEnd);
vec3 nextPosition = mix(instanceEndPositions, instanceRightPositions, isEnd);
vec3 nextPosition64Low = mix(instanceEndPositions64Low, instanceRightPositions64Low, isEnd);
geometry.worldPosition = currPosition;
vec2 widthPixels = vec2(clamp(
project_size_to_pixel(instanceStrokeWidths * path.widthScale, path.widthUnits),
path.widthMinPixels, path.widthMaxPixels) / 2.0);
vec3 width;
if (path.billboard) {
vec4 prevPositionScreen = project_position_to_clipspace(prevPosition, prevPosition64Low, ZERO_OFFSET);
vec4 currPositionScreen = project_position_to_clipspace(currPosition, currPosition64Low, ZERO_OFFSET, geometry.position);
vec4 nextPositionScreen = project_position_to_clipspace(nextPosition, nextPosition64Low, ZERO_OFFSET);
clipLine(prevPositionScreen, currPositionScreen);
clipLine(nextPositionScreen, currPositionScreen);
clipLine(currPositionScreen, mix(nextPositionScreen, prevPositionScreen, isEnd));
width = vec3(widthPixels, 0.0);
DECKGL_FILTER_SIZE(width, geometry);
vec3 offset = getLineJoinOffset(
prevPositionScreen.xyz / prevPositionScreen.w,
currPositionScreen.xyz / currPositionScreen.w,
nextPositionScreen.xyz / nextPositionScreen.w,
project_pixel_size_to_clipspace(width.xy)
);
DECKGL_FILTER_GL_POSITION(currPositionScreen, geometry);
gl_Position = vec4(currPositionScreen.xyz + offset * currPositionScreen.w, currPositionScreen.w);
} else {
prevPosition = project_position(prevPosition, prevPosition64Low);
currPosition = project_position(currPosition, currPosition64Low);
nextPosition = project_position(nextPosition, nextPosition64Low);
width = vec3(project_pixel_size(widthPixels), 0.0);
DECKGL_FILTER_SIZE(width, geometry);
vec3 offset = getLineJoinOffset(prevPosition, currPosition, nextPosition, width.xy);
geometry.position = vec4(currPosition + offset, 1.0);
gl_Position = project_common_position_to_clipspace(geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
}
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7g5ni":[function(require,module,exports,__globalThis) {
// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = `\
#version 300 es
#define SHADER_NAME path-layer-fragment-shader
precision highp float;
in vec4 vColor;
in vec2 vCornerOffset;
in float vMiterLength;
in vec2 vPathPosition;
in float vPathLength;
in float vJointType;
out vec4 fragColor;
void main(void) {
geometry.uv = vPathPosition;
if (vPathPosition.y < 0.0 || vPathPosition.y > vPathLength) {
if (vJointType > 0.5 && length(vCornerOffset) > 1.0) {
discard;
}
if (vJointType < 0.5 && vMiterLength > path.miterLimit + 1.0) {
discard;
}
}
fragColor = vColor;
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4E495":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDisplay", ()=>timeDisplay);
parcelHelpers.export(exports, "sortServices", ()=>sortServices);
parcelHelpers.export(exports, "sortServicesPinned", ()=>sortServicesPinned);
const timeDisplay = (ms)=>{
    if (ms === null) return;
    const mins = Math.floor(ms / 1000 / 60);
    return mins <= 0 ? 'Arr' : `${mins}m`;
};
const sortServices = (a, b)=>{
    const a0 = a.toString()[0];
    const b0 = b.toString()[0];
    if (isNaN(a0) && !isNaN(b0)) return 1;
    if (!isNaN(a0) && isNaN(b0)) return -1;
    const result = a0 - b0;
    if (result !== 0) return result;
    return parseInt(a, 10) - parseInt(b, 10);
};
const sortServicesPinned = (pinnedServices)=>(a, b)=>{
        const pinA = pinnedServices.includes(a.no);
        const pinB = pinnedServices.includes(b.no);
        if (pinA && !pinB) return -1;
        else if (pinB && !pinA) return 1;
        else return sortServices(a.no, b.no);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kNdlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lscache = require("lscache");
var _lscacheDefault = parcelHelpers.interopDefault(_lscache);
exports.default = (url, timeout)=>{
    const data = (0, _lscacheDefault.default).get(url);
    if (data) return Promise.resolve(data);
    else return fetch(url).then((r)=>r.json()).then((r)=>{
        (0, _lscacheDefault.default).set(url, r, timeout);
        return r;
    });
};

},{"lscache":"1Js1m","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1Js1m":[function(require,module,exports,__globalThis) {
/**
 * lscache library
 * Copyright (c) 2011, Pamela Fox
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* jshint undef:true, browser:true, node:true */ /* global define */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (module.exports) // CommonJS/Node module
    module.exports = factory();
    else // Browser globals
    root.lscache = factory();
})(this, function() {
    // Prefix for all lscache keys
    var CACHE_PREFIX = 'lscache-';
    // Suffix for the key name on the expiration items in localStorage
    var CACHE_SUFFIX = '-cacheexpiration';
    // expiration date radix (set to Base-36 for most space savings)
    var EXPIRY_RADIX = 10;
    // time resolution in milliseconds
    var expiryMilliseconds = 60000;
    // ECMAScript max Date (epoch + 1e8 days)
    var maxDate = calculateMaxDate(expiryMilliseconds);
    var cachedStorage;
    var cachedJSON;
    var cacheBucket = '';
    var warnings = false;
    // Determines if localStorage is supported in the browser;
    // result is cached for better performance instead of being run each time.
    // Feature detection is based on how Modernizr does it;
    // it's not straightforward due to FF4 issues.
    // It's not run at parse-time as it takes 200ms in Android.
    function supportsStorage() {
        var key = '__lscachetest__';
        var value = key;
        if (cachedStorage !== undefined) return cachedStorage;
        // some browsers will throw an error if you try to access local storage (e.g. brave browser)
        // hence check is inside a try/catch
        try {
            if (!localStorage) return false;
        } catch (ex) {
            return false;
        }
        try {
            setItem(key, value);
            removeItem(key);
            cachedStorage = true;
        } catch (e) {
            // If we hit the limit, and we don't have an empty localStorage then it means we have support
            if (isOutOfSpace(e) && localStorage.length) cachedStorage = true; // just maxed it out and even the set test failed.
            else cachedStorage = false;
        }
        return cachedStorage;
    }
    // Check to set if the error is us dealing with being out of space
    function isOutOfSpace(e) {
        return e && (e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.name === 'QuotaExceededError');
    }
    // Determines if native JSON (de-)serialization is supported in the browser.
    function supportsJSON() {
        /*jshint eqnull:true */ if (cachedJSON === undefined) cachedJSON = window.JSON != null;
        return cachedJSON;
    }
    /**
   * Returns a string where all RegExp special characters are escaped with a \.
   * @param {String} text
   * @return {string}
   */ function escapeRegExpSpecialCharacters(text) {
        return text.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&');
    }
    /**
   * Returns the full string for the localStorage expiration item.
   * @param {String} key
   * @return {string}
   */ function expirationKey(key) {
        return key + CACHE_SUFFIX;
    }
    /**
   * Returns the number of minutes since the epoch.
   * @return {number}
   */ function currentTime() {
        return Math.floor(new Date().getTime() / expiryMilliseconds);
    }
    /**
   * Wrapper functions for localStorage methods
   */ function getItem(key) {
        return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
    }
    function setItem(key, value) {
        // Fix for iPad issue - sometimes throws QUOTA_EXCEEDED_ERR on setItem.
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
        localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
    }
    function removeItem(key) {
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
    }
    function eachKey(fn) {
        var prefixRegExp = new RegExp('^' + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + '(.*)');
        // We first identify which keys to process
        var keysToProcess = [];
        var key, i;
        for(i = 0; i < localStorage.length; i++){
            key = localStorage.key(i);
            key = key && key.match(prefixRegExp);
            key = key && key[1];
            if (key && key.indexOf(CACHE_SUFFIX) < 0) keysToProcess.push(key);
        }
        // Then we apply the processing function to each key
        for(i = 0; i < keysToProcess.length; i++)fn(keysToProcess[i], expirationKey(keysToProcess[i]));
    }
    function flushItem(key) {
        var exprKey = expirationKey(key);
        removeItem(key);
        removeItem(exprKey);
    }
    function flushExpiredItem(key) {
        var exprKey = expirationKey(key);
        var expr = getItem(exprKey);
        if (expr) {
            var expirationTime = parseInt(expr, EXPIRY_RADIX);
            // Check if we should actually kick item out of storage
            if (currentTime() >= expirationTime) {
                removeItem(key);
                removeItem(exprKey);
                return true;
            }
        }
    }
    function warn(message, err) {
        if (!warnings) return;
        if (!('console' in window) || typeof window.console.warn !== 'function') return;
        window.console.warn("lscache - " + message);
        if (err) window.console.warn("lscache - The error was: " + err.message);
    }
    function calculateMaxDate(expiryMilliseconds) {
        return Math.floor(8.64e15 / expiryMilliseconds);
    }
    var lscache = {
        /**
     * Stores the value in localStorage. Expires after specified number of minutes.
     * @param {string} key
     * @param {Object|string} value
     * @param {number} time
     * @return {boolean} whether the value was inserted successfully
     */ set: function(key, value, time) {
            if (!supportsStorage()) return false;
            // If we don't get a string value, try to stringify
            // In future, localStorage may properly support storing non-strings
            // and this can be removed.
            if (!supportsJSON()) return false;
            try {
                value = JSON.stringify(value);
            } catch (e) {
                // Sometimes we can't stringify due to circular refs
                // in complex objects, so we won't bother storing then.
                return false;
            }
            try {
                setItem(key, value);
            } catch (e) {
                if (isOutOfSpace(e)) {
                    // If we exceeded the quota, then we will sort
                    // by the expire time, and then remove the N oldest
                    var storedKeys = [];
                    var storedKey;
                    eachKey(function(key, exprKey) {
                        var expiration = getItem(exprKey);
                        if (expiration) expiration = parseInt(expiration, EXPIRY_RADIX);
                        else // TODO: Store date added for non-expiring items for smarter removal
                        expiration = maxDate;
                        storedKeys.push({
                            key: key,
                            size: (getItem(key) || '').length,
                            expiration: expiration
                        });
                    });
                    // Sorts the keys with oldest expiration time last
                    storedKeys.sort(function(a, b) {
                        return b.expiration - a.expiration;
                    });
                    var targetSize = (value || '').length;
                    while(storedKeys.length && targetSize > 0){
                        storedKey = storedKeys.pop();
                        warn("Cache is full, removing item with key '" + storedKey.key + "'");
                        flushItem(storedKey.key);
                        targetSize -= storedKey.size;
                    }
                    try {
                        setItem(key, value);
                    } catch (e) {
                        // value may be larger than total quota
                        warn("Could not add item with key '" + key + "', perhaps it's too big?", e);
                        return false;
                    }
                } else {
                    // If it was some other error, just give up.
                    warn("Could not add item with key '" + key + "'", e);
                    return false;
                }
            }
            // If a time is specified, store expiration info in localStorage
            if (time) setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
            else // In case they previously set a time, remove that info from localStorage.
            removeItem(expirationKey(key));
            return true;
        },
        /**
     * Retrieves specified value from localStorage, if not expired.
     * @param {string} key
     * @return {string|Object}
     */ get: function(key) {
            if (!supportsStorage()) return null;
            // Return the de-serialized item if not expired
            if (flushExpiredItem(key)) return null;
            // Tries to de-serialize stored value if its an object, and returns the normal value otherwise.
            var value = getItem(key);
            if (!value || !supportsJSON()) return value;
            try {
                // We can't tell if its JSON or a string, so we try to parse
                return JSON.parse(value);
            } catch (e) {
                // If we can't parse, it's probably because it isn't an object
                return value;
            }
        },
        /**
     * Removes a value from localStorage.
     * Equivalent to 'delete' in memcache, but that's a keyword in JS.
     * @param {string} key
     */ remove: function(key) {
            if (!supportsStorage()) return;
            flushItem(key);
        },
        /**
     * Returns whether local storage is supported.
     * Currently exposed for testing purposes.
     * @return {boolean}
     */ supported: function() {
            return supportsStorage();
        },
        /**
     * Flushes all lscache items and expiry markers without affecting rest of localStorage
     */ flush: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushItem(key);
            });
        },
        /**
     * Flushes expired lscache items and expiry markers without affecting rest of localStorage
     */ flushExpired: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushExpiredItem(key);
            });
        },
        /**
     * Appends CACHE_PREFIX so lscache will partition data in to different buckets.
     * @param {string} bucket
     */ setBucket: function(bucket) {
            cacheBucket = bucket;
        },
        /**
     * Resets the string being appended to CACHE_PREFIX so lscache will use the default storage behavior.
     */ resetBucket: function() {
            cacheBucket = '';
        },
        /**
     * @returns {number} The currently set number of milliseconds each time unit represents in
     *   the set() function's "time" argument.
     */ getExpiryMilliseconds: function() {
            return expiryMilliseconds;
        },
        /**
     * Sets the number of milliseconds each time unit represents in the set() function's
     *   "time" argument.
     * Sample values:
     *  1: each time unit = 1 millisecond
     *  1000: each time unit = 1 second
     *  60000: each time unit = 1 minute (Default value)
     *  360000: each time unit = 1 hour
     * @param {number} milliseconds
     */ setExpiryMilliseconds: function(milliseconds) {
            expiryMilliseconds = milliseconds;
            maxDate = calculateMaxDate(expiryMilliseconds);
        },
        /**
     * Sets whether to display warnings when an item is removed from the cache or not.
     */ enableWarnings: function(enabled) {
            warnings = enabled;
        }
    };
    // Return the module
    return lscache;
});

},{}],"4wBi3":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("anDi6");

},{}],"0ghot":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3123e");

},{}],"3k5gl":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aU3FH");

},{}]},["20yW5","jIMFG"], "jIMFG", "parcelRequireda9d", {}, "./", "/")

//# sourceMappingURL=visualization.962e2b5a.js.map
